'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var $7SXl2$reactdom = require('react-dom');
var reactRouterDom = require('react-router-dom');
var reactToastify = require('react-toastify');
var ReactDatePicker = require('react-datepicker');
var dateFns = require('date-fns');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var $7SXl2$reactdom__namespace = /*#__PURE__*/_interopNamespace($7SXl2$reactdom);
var $7SXl2$reactdom__default = /*#__PURE__*/_interopDefaultLegacy($7SXl2$reactdom);
var ReactDatePicker__default = /*#__PURE__*/_interopDefaultLegacy(ReactDatePicker);

const secondaryColors = {
    black: 'rgba(21, 28, 43, 1)',
    offBlack: 'rgba(18, 18, 18, 1)',
    secondary: {
        main: 'rgba(28, 37, 56, 1)',
        darker: 'rgba(199, 199, 199, 1)',
        dark: 'rgba(44, 50, 62, 1)',
        light: 'rgba(33, 44, 66, 1)',
        lighter: 'rgba(62, 71, 90, 1)',
    },
    grey: {
        100: 'rgba(249, 249, 251, 1)',
        200: 'rgba(238, 239, 242, 1)',
        300: 'rgba(212, 216, 223, 1)',
        400: 'rgba(184, 190, 201, 1)',
        500: 'rgba(156, 164, 180, 1)',
        600: 'rgba(135, 143, 162, 1)',
        700: 'rgba(114, 124, 146, 1)',
        800: 'rgba(99, 110, 129, 1)',
        900: 'rgba(82, 90, 106, 1)',
    },
    white: 'rgba(255, 255, 255, 1)',
    icons: {
        twitter: 'rgba(30, 161, 242, 1)',
        linkedIn: 'rgba(7, 116, 179, 1)',
        facebook: 'rgba(1, 124, 255, 1)',
    },
};
const primaryColors = {
    main: 'rgba(163, 234, 42, 1)',
    dark: 'rgba(156, 223, 41, 1)',
    light: 'rgba(163, 234, 42, 0.5)',
    lighter: 'rgba(163, 234, 42, 0.3)',
};
const legacyColors = {
    grey: {
        1000: 'rgba(62, 71, 90, 1)',
        980: 'rgba(156, 164, 180, 0.8)',
    },
    notificationSuccess: {
        dark: 'rgba(23, 39, 40, 1)',
        light: 'rgba(233, 243, 231, 1)',
    },
    notificationBadge: 'rgba(244, 206, 215, 1)',
    buttonHover: 'rgba(20, 45, 98, 1)',
    roomProgressBar: {
        light: {
            first: 'rgba(34, 54, 84, 1)',
            second: 'rgba(24, 35, 55, 1)',
            third: 'rgba(21, 28, 43, 1)',
        },
        dark: {
            first: 'rgba(45, 72, 113, 1)',
            second: 'rgba(28, 43, 69, 1)',
            third: 'rgba(31, 49, 88, 1)',
        },
    },
    alpha: {
        50: 'rgba(255, 255, 255, 0.5)',
        75: 'rgba(255, 255, 255, 0.75)',
    },
    gradientDarkFlip: 'linear-gradient(0.8deg, #223654 72.84%, #182337 145.61%, #151c2b 188.82%)',
    gradientDark: 'linear-gradient(179.2deg, #223654 72.84%, #182337 145.61%, #151c2b 188.82%)',
    twitter: 'rgba(0, 172, 238, 1)',
    facebook: 'rgba(66, 103, 178, 1)',
    linkedIn: 'rgba(0, 119, 181, 1)',
    misc: {
        darkErrorLighter: 'rgba(42, 25, 44, 1)',
        darkInfoLighter: 'rgba(21, 33, 62, 1)',
        darkWarningLighter: 'rgba(44, 39, 39, 1)',
        lightErrorLighter: 'rgba(253, 229, 235, 1)',
        lightInfoLighter: 'rgba(231, 238, 252, 1)',
        lightWarningLighter: 'rgba(255, 243, 229, 1)',
        lightAddButtonHover: 'rgba(184, 204, 247, 1)',
        darkLoadingPrimary: 'rgba(38, 50, 77, 1)',
        darkLoadingSecondary: 'rgba(51, 64, 95, 1)',
    },
};
const accentColors = {
    info: {
        light: 'rgba(17, 83, 228, 1)',
        dark: 'rgba(113, 156, 249, 1)',
    },
    success: {
        light: 'rgba(38, 137, 12, 1)',
        dark: 'rgba(59, 200, 30, 1)',
    },
    error: {
        light: 'rgba(235, 0, 55, 1)',
        dark: 'rgba(255, 91, 103, 1)',
    },
    warning: {
        light: 'rgba(255, 138, 0, 1)',
        lighter: 'rgba(255, 141, 0, 1)',
        dark: 'rgba(255, 187, 69, 1)',
    },
};
const otherColors = {
    green1: {
        100: 'rgba(38, 137, 12, 1)',
        20: 'rgba(38, 137, 12, 0.2)',
        10: 'rgba(38, 137, 12, 0.1)',
    },
    green2: {
        100: 'rgba(59, 200, 30, 1)',
        20: 'rgba(59, 200, 30, 0.2)',
        10: 'rgba(59, 200, 30, 0.1)',
    },
    green3: {
        100: 'rgba(120, 252, 87, 1)',
        20: 'rgba(120, 252, 87, 0.2)',
        10: 'rgba(120, 252, 87, 0.1)',
    },
    orange1: {
        100: 'rgba(189, 88, 0, 1)',
        20: 'rgba(189, 88, 0, 0.2)',
        10: 'rgba(189, 88, 0, 0.1)',
    },
    orange2: {
        100: 'rgba(255, 138, 0, 1)',
        20: 'rgba(255, 138, 0, 0.2)',
        10: 'rgba(255, 138, 0, 0.1)',
    },
    orange3: {
        100: 'rgba(255, 187, 69, 1)',
        20: 'rgba(255, 187, 69, 0.2)',
        10: 'rgba(255, 187, 69, 0.1)',
    },
    red1: {
        100: 'rgba(195, 0, 22, 1)',
        20: 'rgba(195, 0, 22, 0.2)',
        10: 'rgba(195, 0, 22, 0.1)',
    },
    red2: {
        100: 'rgba(235, 0, 55, 1)',
        20: 'rgba(235, 0, 55, 0.2)',
        10: 'rgba(235, 0, 55, 0.1)',
    },
    red3: {
        100: 'rgba(255, 91, 103, 1)',
        80: 'rgba(255, 91, 103, 0.8)',
        20: 'rgba(255, 91, 103, 0.2)',
        10: 'rgba(255, 91, 103, 0.1)',
    },
    purple1: {
        100: 'rgba(102, 0, 202, 1)',
        20: 'rgba(102, 0, 202, 0.2)',
        10: 'rgba(102, 0, 202, 0.1)',
    },
    purple2: {
        100: 'rgba(159, 0, 255, 1)',
        20: 'rgba(159, 0, 255, 0.2)',
        10: 'rgba(159, 0, 255, 0.1)',
    },
    purple3: {
        100: 'rgba(215, 82, 255, 1)',
        20: 'rgba(215, 82, 255, 0.2)',
        10: 'rgba(215, 82, 255, 0.1)',
    },
    blue1: {
        100: 'rgba(17, 83, 228, 1)',
        30: 'rgba(17, 83, 228, 0.3)',
        10: 'rgba(17, 83, 228, 0.1)',
    },
    textL: 'rgba(21, 28, 43, 1)',
    gradientLevels: 'linear-gradient(171deg, rgb(236, 252, 45) 45%, rgb(53, 238, 23), rgb(81, 245, 24))',
};
const lighterVariations = {
    success: {
        light: 'rgba(212, 231, 206, 1)',
        dark: 'rgba(34, 70, 51, 1)',
        lighter: 'rgba(234, 244, 231, 1)',
    },
    warning: {
        light: 'rgba(255, 232, 204, 1)',
        dark: 'rgba(73, 67, 59, 1)',
        lighter: 'rgba(255, 244, 230, 1)',
    },
    error: {
        light: 'rgba(251, 204, 215, 1)',
        dark: 'rgba(73, 48, 66, 1)',
        lighter: 'rgba(253, 230, 235, 1)',
    },
    purple: {
        light: 'rgba(236, 204, 255, 1)',
        dark: 'rgba(65, 46, 96, 1)',
    },
    info: {
        light: 'rgba(207, 221, 250, 1)',
        dark: 'rgba(39, 54, 84, 1)',
    },
    blue: {
        light: 'rgba(231, 238, 252, 1)',
        dark: 'rgba(39, 54, 84, 1)',
        darker: 'rgba(45, 61, 95, 1)',
    },
    green: {
        light: 'rgba(235, 249, 208, 1)',
        dark: 'rgba(51, 74, 9, 1)',
    },
};

const darkColors = {
    ...secondaryColors,
    primary: primaryColors,
    background: {
        main: secondaryColors.secondary.main,
        secondary: otherColors.textL,
        secondaryLight: secondaryColors.secondary.main,
        secondaryLighter: secondaryColors.secondary.light,
        secondaryDark: secondaryColors.black,
        light: secondaryColors.secondary.main,
        lighter: secondaryColors.secondary.light,
        lightest: legacyColors.grey[1000],
        dark: otherColors.textL,
        darker: 'rgba(20, 30, 50, 1)',
        darkest: 'rgba(11, 12, 38, 1)',
        grey: secondaryColors.grey[900],
        greyLight: 'rgba(37, 47, 67, 1)',
        disabled: secondaryColors.grey[900],
        select: secondaryColors.secondary.light,
        selected: secondaryColors.grey[400],
        selectedHover: secondaryColors.grey[600],
        active: otherColors.green1[10],
        overlay: 'rgba(20, 22, 25, 0.5)',
        tableRowHover: legacyColors.grey[1000],
        tertiary: secondaryColors.offBlack,
        tooltipTitleBackground: secondaryColors.grey[900],
        tableEven: secondaryColors.secondary.main,
        tableOdd: secondaryColors.secondary.light,
        invert: lighterVariations.info.light,
    },
    border: {
        main: secondaryColors.secondary.light,
        dark: secondaryColors.secondary.light,
        light: legacyColors.grey[1000],
        dropdown: legacyColors.grey[1000],
        hover: secondaryColors.grey[600],
    },
    text: {
        main: secondaryColors.grey[100],
        secondary: secondaryColors.grey[500],
        tertiary: secondaryColors.grey[400],
        light: secondaryColors.grey[400],
        lighter: secondaryColors.grey[200],
        lightest: secondaryColors.grey[400],
        highlight: primaryColors.main,
        invert: otherColors.textL,
        button: primaryColors.main,
        placeholder: secondaryColors.grey[400],
        placeholderInvert: secondaryColors.grey[800],
        selectionBox: secondaryColors.grey[200],
    },
    paragraph: secondaryColors.grey[200],
    success: {
        main: otherColors.green2[100],
        secondary: primaryColors.main,
        light: lighterVariations.green.dark,
        lighter: legacyColors.notificationSuccess.dark,
        toggle: primaryColors.main,
        lightest: otherColors.green2[20],
        accent: 'rgba(72, 192, 10, 1)',
    },
    error: {
        main: otherColors.red3[100],
        light: otherColors.red3[20],
        lighter: legacyColors.misc.darkErrorLighter,
        lightest: otherColors.red3[10],
        soft: otherColors.red3[10],
    },
    info: {
        main: accentColors.info.dark,
        light: 'rgba(113, 156, 249, 0.2)',
        lighter: legacyColors.misc.darkInfoLighter,
        lightest: 'rgba(113, 156, 249, 0.2)',
        secondary: accentColors.info.light,
        soft: 'rgba(113, 156, 249, 0.1)',
    },
    warning: {
        main: accentColors.warning.dark,
        light: accentColors.warning.dark,
        lighter: legacyColors.misc.darkWarningLighter,
        lightest: 'rgba(255, 187, 69, 0.2)',
        secondary: 'rgba(255, 187, 69, 0.3)',
    },
    purple: {
        main: otherColors.purple3[100],
        dark: otherColors.purple1[100],
        light: otherColors.purple3[100],
        lighter: otherColors.purple3[20],
    },
    level: {
        main: otherColors.purple3[100],
    },
    scrollBar: {
        primary: secondaryColors.grey[900],
        secondary: secondaryColors.grey[700],
    },
    icon: {
        main: secondaryColors.grey[700],
        lighter: secondaryColors.grey[700],
        secondary: secondaryColors.grey[400],
    },
    checkIcon: {
        main: secondaryColors.grey[100],
        disabled: secondaryColors.grey[600],
    },
    twitter: {
        main: legacyColors.twitter,
        secondary: secondaryColors.icons.twitter,
    },
    facebook: {
        main: legacyColors.facebook,
        secondary: secondaryColors.icons.facebook,
    },
    linkedIn: {
        main: legacyColors.linkedIn,
        secondary: secondaryColors.icons.linkedIn,
    },
    loading: {
        primary: legacyColors.misc.darkLoadingPrimary,
        secondary: legacyColors.misc.darkLoadingSecondary,
    },
    placeholder: { light: lighterVariations.blue.darker, dark: secondaryColors.secondary.main },
    divider: legacyColors.grey[1000],
    button: {
        secondary: {
            border: legacyColors.grey[1000],
            hover: secondaryColors.grey[200],
        },
        error: {
            text: otherColors.textL,
            hover: otherColors.red3[80],
        },
        close: {
            background: otherColors.textL,
        },
    },
    addButton: {
        background: accentColors.info.light,
        color: secondaryColors.grey[100],
        border: accentColors.info.light,
        hover: legacyColors.buttonHover,
        textHover: secondaryColors.grey[100],
    },
    radio: {
        default: legacyColors.grey[1000],
        hover: secondaryColors.grey[400],
        focus: secondaryColors.secondary.light,
        selected: primaryColors.main,
        disabledBorder: legacyColors.grey[1000],
        disabledContent: secondaryColors.grey[900],
        disabledChecked: secondaryColors.grey[600],
    },
    selectionBox: {
        border: legacyColors.grey[1000],
        selectedBorder: otherColors.green2[100],
        hoverBorder: secondaryColors.grey[400],
        disabledText: secondaryColors.grey[600],
        disabledContent: secondaryColors.grey[900],
        disabledIcon: secondaryColors.grey[600],
    },
    codeTag: {
        text: accentColors.warning.dark,
        background: otherColors.orange2[10],
    },
    progressBar: secondaryColors.grey[900],
    toggle: secondaryColors.grey[600],
    sideNav: {
        text: secondaryColors.grey[200],
        sectionHeader: secondaryColors.grey[100],
    },
    overlay: secondaryColors.grey[800],
    roomProgressBar: legacyColors.roomProgressBar.dark,
    datePicker: {
        background: otherColors.textL,
        buttonHover: legacyColors.buttonHover,
        inRange: 'rgba(17, 83, 228, 0.60)',
    },
    notificationBadge: {
        main: legacyColors.notificationBadge,
    },
    gradientDark: legacyColors.gradientDark,
    gradientDarkFlip: legacyColors.gradientDarkFlip,
    alpha: legacyColors.alpha,
    formSelect: {
        optionHover: secondaryColors.secondary.lighter,
    },
    statusTag: {
        complete: lighterVariations.success.dark,
        inProgress: lighterVariations.info.dark,
        notStarted: lighterVariations.warning.dark,
        notStartedIcon: 'rgba(255, 141, 0, 1)',
        overDue: secondaryColors.secondary.main,
        overDueIcon: secondaryColors.grey[600],
        dueSoon: lighterVariations.error.dark,
        green: {
            background: lighterVariations.success.dark,
            accent: accentColors.success.dark,
        },
        blue: {
            background: lighterVariations.blue.darker,
            accent: accentColors.info.dark,
        },
        orange: {
            background: lighterVariations.warning.dark,
            accent: accentColors.warning.lighter,
        },
        grey: {
            background: secondaryColors.secondary.lighter,
            accent: secondaryColors.grey[600],
        },
        red: {
            background: lighterVariations.error.dark,
            accent: accentColors.error.dark,
        },
        purple: {
            background: lighterVariations.purple.dark,
            accent: otherColors.purple3[100],
        },
    },
    boxShadow: {
        hover: `0px 7.9px 26px 0px rgba(0, 0, 0, 0.60)`,
    },
    activityCalendar: {
        levelZero: secondaryColors.grey[900],
        levelOne: otherColors.orange3[100],
        levelTwo: primaryColors.main,
        levelThree: accentColors.success.light,
    },
    alertBanner: {
        success: lighterVariations.success.dark,
        warning: lighterVariations.warning.dark,
        warningIcon: otherColors.orange3[100],
        info: lighterVariations.blue.darker,
        error: lighterVariations.error.dark,
    },
    notifications: {
        likedBackground: lighterVariations.success.dark,
        likedColor: 'rgba(212, 231, 206, 1)',
        unlikedBackground: secondaryColors.black,
        unlikedColor: secondaryColors.grey[800],
        hoverColor: secondaryColors.grey[600],
        hoverBorder: 'rgba(10, 13, 21, 1)',
        hoverBorderLiked: lighterVariations.success.dark,
        hoverColorLiked: lighterVariations.success.lighter,
    },
};

const lightColors = {
    ...secondaryColors,
    primary: primaryColors,
    secondary: secondaryColors.secondary,
    background: {
        main: secondaryColors.white,
        secondary: secondaryColors.white,
        secondaryLight: secondaryColors.grey[200],
        secondaryLighter: secondaryColors.grey[200],
        secondaryDark: secondaryColors.white,
        light: secondaryColors.white,
        lighter: secondaryColors.white,
        lightest: secondaryColors.white,
        dark: secondaryColors.grey[100],
        darker: secondaryColors.grey[300],
        darkest: secondaryColors.grey[300],
        grey: secondaryColors.grey[300],
        greyLight: secondaryColors.grey[300],
        disabled: secondaryColors.grey[200],
        select: secondaryColors.white,
        selected: secondaryColors.secondary.light,
        selectedHover: secondaryColors.grey[900],
        overlay: legacyColors.grey[980],
        tableRowHover: secondaryColors.grey[200],
        tertiary: secondaryColors.white,
        tooltipTitleBackground: secondaryColors.grey[200],
        tableEven: secondaryColors.white,
        tableOdd: secondaryColors.grey[100],
        active: 'rgba(38, 137, 12, 0.1)',
        invert: lighterVariations.blue.darker,
    },
    border: {
        main: secondaryColors.grey[200],
        light: secondaryColors.grey[300],
        dark: secondaryColors.grey[300],
        dropdown: secondaryColors.grey[300],
        hover: secondaryColors.grey[400],
    },
    text: {
        main: otherColors.textL,
        secondary: secondaryColors.grey[900],
        tertiary: secondaryColors.grey[900],
        light: secondaryColors.secondary.main,
        lighter: secondaryColors.grey[900],
        lightest: secondaryColors.grey[600],
        highlight: otherColors.textL,
        invert: secondaryColors.grey[100],
        button: otherColors.green1[100],
        placeholder: secondaryColors.grey[800],
        placeholderInvert: secondaryColors.grey[400],
        selectionBox: secondaryColors.grey[900],
    },
    paragraph: secondaryColors.grey[900],
    success: {
        main: otherColors.green1[100],
        secondary: accentColors.success.light,
        light: lighterVariations.green.light,
        lighter: legacyColors.notificationSuccess.light,
        lightest: otherColors.green1[20],
        toggle: otherColors.green1[100],
        accent: 'rgba(101, 241, 23, 1)',
    },
    error: {
        main: accentColors.error.light,
        secondary: otherColors.red1[100],
        light: 'rgba(235, 0, 55, 0.3)',
        lighter: legacyColors.misc.lightErrorLighter,
        lightest: 'rgba(235, 0, 55, 0.02)',
        soft: lighterVariations.error.lighter,
    },
    info: {
        main: accentColors.info.light,
        light: 'rgba(113, 156, 249, 0.2)',
        lighter: legacyColors.misc.lightInfoLighter,
        lightest: 'rgba(17, 83, 228, 0.2)',
        secondary: accentColors.info.light,
        soft: otherColors.blue1[10],
    },
    warning: {
        main: otherColors.orange2[100],
        light: accentColors.warning.light,
        lighter: legacyColors.misc.lightWarningLighter,
        lightest: otherColors.orange2[20],
        secondary: 'rgba(255, 141, 0, 0.3)',
    },
    purple: {
        main: otherColors.purple2[100],
        dark: otherColors.purple1[100],
        light: otherColors.purple3[100],
        lighter: otherColors.purple2[20],
    },
    level: {
        main: otherColors.purple1[100],
    },
    scrollBar: {
        primary: secondaryColors.grey[100],
        secondary: secondaryColors.grey[300],
    },
    icon: {
        main: secondaryColors.grey[900],
        lighter: secondaryColors.grey[400],
        secondary: secondaryColors.grey[700],
    },
    checkIcon: {
        main: otherColors.textL,
        disabled: secondaryColors.grey[400],
    },
    twitter: {
        main: legacyColors.twitter,
        secondary: secondaryColors.icons.twitter,
    },
    facebook: {
        main: legacyColors.facebook,
        secondary: secondaryColors.icons.facebook,
    },
    linkedIn: {
        main: legacyColors.linkedIn,
        secondary: secondaryColors.icons.linkedIn,
    },
    loading: {
        primary: secondaryColors.grey[200],
        secondary: secondaryColors.grey[100],
    },
    placeholder: {
        light: secondaryColors.grey[300],
        dark: secondaryColors.grey[600],
    },
    divider: secondaryColors.grey[200],
    button: {
        secondary: {
            border: secondaryColors.grey[300],
            hover: secondaryColors.grey[200],
        },
        error: {
            text: secondaryColors.grey[100],
            hover: otherColors.red1[100],
        },
        close: {
            background: secondaryColors.white,
        },
    },
    addButton: {
        background: accentColors.info.light,
        color: secondaryColors.grey[100],
        border: accentColors.info.light,
        hover: legacyColors.misc.lightAddButtonHover,
        textHover: otherColors.textL,
    },
    sideNav: {
        text: secondaryColors.grey[900],
        sectionHeader: otherColors.textL,
    },
    radio: {
        default: secondaryColors.grey[300],
        hover: secondaryColors.grey[900],
        focus: secondaryColors.white,
        selected: otherColors.green1[100],
        disabledBorder: secondaryColors.grey[300],
        disabledContent: secondaryColors.grey[200],
        disabledChecked: secondaryColors.grey[400],
    },
    selectionBox: {
        border: secondaryColors.grey[300],
        selectedBorder: otherColors.green1[100],
        hoverBorder: secondaryColors.grey[900],
        disabledText: secondaryColors.grey[600],
        disabledContent: secondaryColors.grey[200],
        disabledIcon: secondaryColors.grey[600],
    },
    codeTag: {
        text: accentColors.error.light,
        background: secondaryColors.grey[200],
    },
    progressBar: secondaryColors.grey[400],
    toggle: secondaryColors.grey[400],
    overlay: secondaryColors.grey[400],
    roomProgressBar: legacyColors.roomProgressBar.light,
    datePicker: {
        background: secondaryColors.white,
        buttonHover: secondaryColors.grey[200],
        inRange: 'rgba(17, 83, 228, 0.60)',
    },
    notificationBadge: {
        main: legacyColors.notificationBadge,
    },
    gradientDark: legacyColors.gradientDark,
    gradientDarkFlip: legacyColors.gradientDarkFlip,
    alpha: legacyColors.alpha,
    formSelect: {
        optionHover: secondaryColors.grey[200],
    },
    statusTag: {
        complete: lighterVariations.success.light,
        inProgress: lighterVariations.info.light,
        notStarted: lighterVariations.warning.light,
        notStartedIcon: 'rgba(255, 141, 0, 1)',
        overDue: secondaryColors.grey[300],
        overDueIcon: secondaryColors.grey[600],
        dueSoon: lighterVariations.error.light,
        green: {
            background: lighterVariations.success.light,
            accent: accentColors.success.light,
        },
        blue: {
            background: lighterVariations.info.light,
            accent: accentColors.info.light,
        },
        orange: {
            background: lighterVariations.warning.light,
            accent: accentColors.warning.lighter,
        },
        grey: {
            background: secondaryColors.grey[300],
            accent: secondaryColors.grey[600],
        },
        red: {
            background: lighterVariations.error.light,
            accent: accentColors.error.light,
        },
        purple: {
            background: lighterVariations.purple.light,
            accent: otherColors.purple2[100],
        },
    },
    boxShadow: {
        hover: `0px 7.9px 26px 0px rgba(0, 0, 0, 0.15)`,
    },
    activityCalendar: {
        levelZero: secondaryColors.grey[300],
        levelOne: otherColors.orange3[100],
        levelTwo: primaryColors.main,
        levelThree: accentColors.success.light,
    },
    alertBanner: {
        success: lighterVariations.success.lighter,
        warning: lighterVariations.warning.lighter,
        warningIcon: accentColors.warning.lighter,
        info: lighterVariations.blue.light,
        error: lighterVariations.error.lighter,
    },
    notifications: {
        likedBackground: 'rgba(232, 245, 216, 1)',
        likedColor: 'rgba(90, 155, 15, 1)',
        unlikedBackground: secondaryColors.grey[200],
        unlikedColor: secondaryColors.grey[600],
        hoverColor: secondaryColors.grey[700],
        hoverBorder: secondaryColors.grey[300],
        hoverBorderLiked: 'rgba(186, 225, 138, 1)',
        hoverColorLiked: 'rgba(65, 112, 11, 1)',
    },
};

const theme = {
    colors: lightColors,
    fonts: {
        familyUbuntu: 'Ubuntu',
        familySansPro: 'Source Sans Pro, sans-serif',
        familyBungee: 'Bungee, sans-serif',
        sizes: {
            reset: '10px',
            title: '4rem',
            subTitle: '3.2rem',
            dashboardTitle: '2.2rem',
            large: '2.4rem',
            mediumLarge: '2.1rem',
            medium: '1.8rem',
            default: '1.6rem',
            small: '1.4rem',
            tiny: '1.2rem',
        },
        weight: {
            regular: '400',
            semiBold: '500',
            bold: '600',
            bolder: '700',
        },
        lineHeight: {
            default: '2.4rem',
        },
    },
    gutter: {
        small: '1.5rem',
        big: '3rem',
    },
    radius: {
        small: '.5rem',
        medium: '.6rem',
        big: '1rem',
        huge: '3rem',
    },
    sizes: {
        xs: '320px',
        sm: '360px',
        md: '768px',
        lg: '1024px',
        xl: '1440px',
        xxl: '1920px',
        xxxl: '2560px',
    },
    boxShadow: {
        main: `0 2px 8px 0 rgba(21, 28, 43,0.2)`,
        light: `0px 3px 13px 0 rgba(21, 28, 43, 0.07)`,
    },
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min () {
	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
	hasRequiredReactJsxRuntime_production_min = 1;
var f=React__default["default"],k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
	function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}reactJsxRuntime_production_min.Fragment=l;reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;
	return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	var React = React__default["default"];

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
	var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator';
	function getIteratorFn(maybeIterable) {
	  if (maybeIterable === null || typeof maybeIterable !== 'object') {
	    return null;
	  }

	  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

	  if (typeof maybeIterator === 'function') {
	    return maybeIterator;
	  }

	  return null;
	}

	var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

	function error(format) {
	  {
	    {
	      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }

	      printWarning('error', format, args);
	    }
	  }
	}

	function printWarning(level, format, args) {
	  // When changing this logic, you might want to also
	  // update consoleWithStackDev.www.js as well.
	  {
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    var stack = ReactDebugCurrentFrame.getStackAddendum();

	    if (stack !== '') {
	      format += '%s';
	      args = args.concat([stack]);
	    } // eslint-disable-next-line react-internal/safe-string-coercion


	    var argsWithFormat = args.map(function (item) {
	      return String(item);
	    }); // Careful: RN currently depends on this prefix

	    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	    // breaks IE9: https://github.com/facebook/react/issues/13610
	    // eslint-disable-next-line react-internal/no-production-logging

	    Function.prototype.apply.call(console[level], console, argsWithFormat);
	  }
	}

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function getWrappedName(outerType, innerType, wrapperName) {
	  var displayName = outerType.displayName;

	  if (displayName) {
	    return displayName;
	  }

	  var functionName = innerType.displayName || innerType.name || '';
	  return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
	} // Keep in sync with react-reconciler/getComponentNameFromFiber


	function getContextName(type) {
	  return type.displayName || 'Context';
	} // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.


	function getComponentNameFromType(type) {
	  if (type == null) {
	    // Host root, text node or just invalid type.
	    return null;
	  }

	  {
	    if (typeof type.tag === 'number') {
	      error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
	    }
	  }

	  if (typeof type === 'function') {
	    return type.displayName || type.name || null;
	  }

	  if (typeof type === 'string') {
	    return type;
	  }

	  switch (type) {
	    case REACT_FRAGMENT_TYPE:
	      return 'Fragment';

	    case REACT_PORTAL_TYPE:
	      return 'Portal';

	    case REACT_PROFILER_TYPE:
	      return 'Profiler';

	    case REACT_STRICT_MODE_TYPE:
	      return 'StrictMode';

	    case REACT_SUSPENSE_TYPE:
	      return 'Suspense';

	    case REACT_SUSPENSE_LIST_TYPE:
	      return 'SuspenseList';

	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_CONTEXT_TYPE:
	        var context = type;
	        return getContextName(context) + '.Consumer';

	      case REACT_PROVIDER_TYPE:
	        var provider = type;
	        return getContextName(provider._context) + '.Provider';

	      case REACT_FORWARD_REF_TYPE:
	        return getWrappedName(type, type.render, 'ForwardRef');

	      case REACT_MEMO_TYPE:
	        var outerName = type.displayName || null;

	        if (outerName !== null) {
	          return outerName;
	        }

	        return getComponentNameFromType(type.type) || 'Memo';

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            return getComponentNameFromType(init(payload));
	          } catch (x) {
	            return null;
	          }
	        }

	      // eslint-disable-next-line no-fallthrough
	    }
	  }

	  return null;
	}

	var assign = Object.assign;

	// Helpers to patch console.logs to avoid logging during side-effect free
	// replaying on render function. This currently only patches the object
	// lazily which won't cover if the log function was extracted eagerly.
	// We could also eagerly patch the method.
	var disabledDepth = 0;
	var prevLog;
	var prevInfo;
	var prevWarn;
	var prevError;
	var prevGroup;
	var prevGroupCollapsed;
	var prevGroupEnd;

	function disabledLog() {}

	disabledLog.__reactDisabledLog = true;
	function disableLogs() {
	  {
	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      prevLog = console.log;
	      prevInfo = console.info;
	      prevWarn = console.warn;
	      prevError = console.error;
	      prevGroup = console.group;
	      prevGroupCollapsed = console.groupCollapsed;
	      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

	      var props = {
	        configurable: true,
	        enumerable: true,
	        value: disabledLog,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        info: props,
	        log: props,
	        warn: props,
	        error: props,
	        group: props,
	        groupCollapsed: props,
	        groupEnd: props
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    disabledDepth++;
	  }
	}
	function reenableLogs() {
	  {
	    disabledDepth--;

	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      var props = {
	        configurable: true,
	        enumerable: true,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        log: assign({}, props, {
	          value: prevLog
	        }),
	        info: assign({}, props, {
	          value: prevInfo
	        }),
	        warn: assign({}, props, {
	          value: prevWarn
	        }),
	        error: assign({}, props, {
	          value: prevError
	        }),
	        group: assign({}, props, {
	          value: prevGroup
	        }),
	        groupCollapsed: assign({}, props, {
	          value: prevGroupCollapsed
	        }),
	        groupEnd: assign({}, props, {
	          value: prevGroupEnd
	        })
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    if (disabledDepth < 0) {
	      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
	    }
	  }
	}

	var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
	var prefix;
	function describeBuiltInComponentFrame(name, source, ownerFn) {
	  {
	    if (prefix === undefined) {
	      // Extract the VM specific prefix used by each line.
	      try {
	        throw Error();
	      } catch (x) {
	        var match = x.stack.trim().match(/\n( *(at )?)/);
	        prefix = match && match[1] || '';
	      }
	    } // We use the prefix to ensure our stacks line up with native stack frames.


	    return '\n' + prefix + name;
	  }
	}
	var reentry = false;
	var componentFrameCache;

	{
	  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
	  componentFrameCache = new PossiblyWeakMap();
	}

	function describeNativeComponentFrame(fn, construct) {
	  // If something asked for a stack inside a fake render, it should get ignored.
	  if ( !fn || reentry) {
	    return '';
	  }

	  {
	    var frame = componentFrameCache.get(fn);

	    if (frame !== undefined) {
	      return frame;
	    }
	  }

	  var control;
	  reentry = true;
	  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

	  Error.prepareStackTrace = undefined;
	  var previousDispatcher;

	  {
	    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
	    // for warnings.

	    ReactCurrentDispatcher.current = null;
	    disableLogs();
	  }

	  try {
	    // This should throw.
	    if (construct) {
	      // Something should be setting the props in the constructor.
	      var Fake = function () {
	        throw Error();
	      }; // $FlowFixMe


	      Object.defineProperty(Fake.prototype, 'props', {
	        set: function () {
	          // We use a throwing setter instead of frozen or non-writable props
	          // because that won't throw in a non-strict mode function.
	          throw Error();
	        }
	      });

	      if (typeof Reflect === 'object' && Reflect.construct) {
	        // We construct a different control for this case to include any extra
	        // frames added by the construct call.
	        try {
	          Reflect.construct(Fake, []);
	        } catch (x) {
	          control = x;
	        }

	        Reflect.construct(fn, [], Fake);
	      } else {
	        try {
	          Fake.call();
	        } catch (x) {
	          control = x;
	        }

	        fn.call(Fake.prototype);
	      }
	    } else {
	      try {
	        throw Error();
	      } catch (x) {
	        control = x;
	      }

	      fn();
	    }
	  } catch (sample) {
	    // This is inlined manually because closure doesn't do it for us.
	    if (sample && control && typeof sample.stack === 'string') {
	      // This extracts the first frame from the sample that isn't also in the control.
	      // Skipping one frame that we assume is the frame that calls the two.
	      var sampleLines = sample.stack.split('\n');
	      var controlLines = control.stack.split('\n');
	      var s = sampleLines.length - 1;
	      var c = controlLines.length - 1;

	      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
	        // We expect at least one stack frame to be shared.
	        // Typically this will be the root most one. However, stack frames may be
	        // cut off due to maximum stack limits. In this case, one maybe cut off
	        // earlier than the other. We assume that the sample is longer or the same
	        // and there for cut off earlier. So we should find the root most frame in
	        // the sample somewhere in the control.
	        c--;
	      }

	      for (; s >= 1 && c >= 0; s--, c--) {
	        // Next we find the first one that isn't the same which should be the
	        // frame that called our sample function and the control.
	        if (sampleLines[s] !== controlLines[c]) {
	          // In V8, the first line is describing the message but other VMs don't.
	          // If we're about to return the first line, and the control is also on the same
	          // line, that's a pretty good indicator that our sample threw at same line as
	          // the control. I.e. before we entered the sample frame. So we ignore this result.
	          // This can happen if you passed a class to function component, or non-function.
	          if (s !== 1 || c !== 1) {
	            do {
	              s--;
	              c--; // We may still have similar intermediate frames from the construct call.
	              // The next one that isn't the same should be our match though.

	              if (c < 0 || sampleLines[s] !== controlLines[c]) {
	                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
	                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
	                // but we have a user-provided "displayName"
	                // splice it in to make the stack more readable.


	                if (fn.displayName && _frame.includes('<anonymous>')) {
	                  _frame = _frame.replace('<anonymous>', fn.displayName);
	                }

	                {
	                  if (typeof fn === 'function') {
	                    componentFrameCache.set(fn, _frame);
	                  }
	                } // Return the line we found.


	                return _frame;
	              }
	            } while (s >= 1 && c >= 0);
	          }

	          break;
	        }
	      }
	    }
	  } finally {
	    reentry = false;

	    {
	      ReactCurrentDispatcher.current = previousDispatcher;
	      reenableLogs();
	    }

	    Error.prepareStackTrace = previousPrepareStackTrace;
	  } // Fallback to just using the name if we couldn't make it throw.


	  var name = fn ? fn.displayName || fn.name : '';
	  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

	  {
	    if (typeof fn === 'function') {
	      componentFrameCache.set(fn, syntheticFrame);
	    }
	  }

	  return syntheticFrame;
	}
	function describeFunctionComponentFrame(fn, source, ownerFn) {
	  {
	    return describeNativeComponentFrame(fn, false);
	  }
	}

	function shouldConstruct(Component) {
	  var prototype = Component.prototype;
	  return !!(prototype && prototype.isReactComponent);
	}

	function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

	  if (type == null) {
	    return '';
	  }

	  if (typeof type === 'function') {
	    {
	      return describeNativeComponentFrame(type, shouldConstruct(type));
	    }
	  }

	  if (typeof type === 'string') {
	    return describeBuiltInComponentFrame(type);
	  }

	  switch (type) {
	    case REACT_SUSPENSE_TYPE:
	      return describeBuiltInComponentFrame('Suspense');

	    case REACT_SUSPENSE_LIST_TYPE:
	      return describeBuiltInComponentFrame('SuspenseList');
	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_FORWARD_REF_TYPE:
	        return describeFunctionComponentFrame(type.render);

	      case REACT_MEMO_TYPE:
	        // Memo may contain any component type so we recursively resolve it.
	        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            // Lazy may contain any component type so we recursively resolve it.
	            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
	          } catch (x) {}
	        }
	    }
	  }

	  return '';
	}

	var hasOwnProperty = Object.prototype.hasOwnProperty;

	var loggedTypeFailures = {};
	var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame.setExtraStackFrame(null);
	    }
	  }
	}

	function checkPropTypes(typeSpecs, values, location, componentName, element) {
	  {
	    // $FlowFixMe This is okay but Flow doesn't know it.
	    var has = Function.call.bind(hasOwnProperty);

	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.

	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            // eslint-disable-next-line react-internal/prod-error-codes
	            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
	            err.name = 'Invariant Violation';
	            throw err;
	          }

	          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        } catch (ex) {
	          error$1 = ex;
	        }

	        if (error$1 && !(error$1 instanceof Error)) {
	          setCurrentlyValidatingElement(element);

	          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

	          setCurrentlyValidatingElement(null);
	        }

	        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error$1.message] = true;
	          setCurrentlyValidatingElement(element);

	          error('Failed %s type: %s', location, error$1.message);

	          setCurrentlyValidatingElement(null);
	        }
	      }
	    }
	  }
	}

	var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

	function isArray(a) {
	  return isArrayImpl(a);
	}

	/*
	 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
	 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
	 *
	 * The functions in this module will throw an easier-to-understand,
	 * easier-to-debug exception with a clear errors message message explaining the
	 * problem. (Instead of a confusing exception thrown inside the implementation
	 * of the `value` object).
	 */
	// $FlowFixMe only called in DEV, so void return is not possible.
	function typeName(value) {
	  {
	    // toStringTag is needed for namespaced types like Temporal.Instant
	    var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
	    var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
	    return type;
	  }
	} // $FlowFixMe only called in DEV, so void return is not possible.


	function willCoercionThrow(value) {
	  {
	    try {
	      testStringCoercion(value);
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	}

	function testStringCoercion(value) {
	  // If you ended up here by following an exception call stack, here's what's
	  // happened: you supplied an object or symbol value to React (as a prop, key,
	  // DOM attribute, CSS property, string ref, etc.) and when React tried to
	  // coerce it to a string using `'' + value`, an exception was thrown.
	  //
	  // The most common types that will cause this exception are `Symbol` instances
	  // and Temporal objects like `Temporal.Instant`. But any object that has a
	  // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
	  // exception. (Library authors do this to prevent users from using built-in
	  // numeric operators like `+` or comparison operators like `>=` because custom
	  // methods are needed to perform accurate arithmetic or comparison.)
	  //
	  // To fix the problem, coerce this object or symbol value to a string before
	  // passing it to React. The most reliable way is usually `String(value)`.
	  //
	  // To find which value is throwing, check the browser or debugger console.
	  // Before this exception was thrown, there should be `console.error` output
	  // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
	  // problem and how that type was used: key, atrribute, input value prop, etc.
	  // In most cases, this console output also shows the component and its
	  // ancestor components where the exception happened.
	  //
	  // eslint-disable-next-line react-internal/safe-string-coercion
	  return '' + value;
	}
	function checkKeyStringCoercion(value) {
	  {
	    if (willCoercionThrow(value)) {
	      error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));

	      return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
	    }
	  }
	}

	var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	var specialPropKeyWarningShown;
	var specialPropRefWarningShown;
	var didWarnAboutStringRefs;

	{
	  didWarnAboutStringRefs = {};
	}

	function hasValidRef(config) {
	  {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.ref !== undefined;
	}

	function hasValidKey(config) {
	  {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.key !== undefined;
	}

	function warnIfStringRefCannotBeAutoConverted(config, self) {
	  {
	    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
	      var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);

	      if (!didWarnAboutStringRefs[componentName]) {
	        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);

	        didWarnAboutStringRefs[componentName] = true;
	      }
	    }
	  }
	}

	function defineKeyPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingKey = function () {
	      if (!specialPropKeyWarningShown) {
	        specialPropKeyWarningShown = true;

	        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingKey.isReactWarning = true;
	    Object.defineProperty(props, 'key', {
	      get: warnAboutAccessingKey,
	      configurable: true
	    });
	  }
	}

	function defineRefPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingRef = function () {
	      if (!specialPropRefWarningShown) {
	        specialPropRefWarningShown = true;

	        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingRef.isReactWarning = true;
	    Object.defineProperty(props, 'ref', {
	      get: warnAboutAccessingRef,
	      configurable: true
	    });
	  }
	}
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, instanceof check
	 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} props
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} owner
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @internal
	 */


	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allows us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };

	  {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.

	    Object.defineProperty(element._store, 'validated', {
	      configurable: false,
	      enumerable: false,
	      writable: true,
	      value: false
	    }); // self and source are DEV only properties.

	    Object.defineProperty(element, '_self', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: self
	    }); // Two elements created in two different places should be considered
	    // equal for testing purposes and therefore we hide it from enumeration.

	    Object.defineProperty(element, '_source', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: source
	    });

	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }

	  return element;
	};
	/**
	 * https://github.com/reactjs/rfcs/pull/107
	 * @param {*} type
	 * @param {object} props
	 * @param {string} key
	 */

	function jsxDEV(type, config, maybeKey, source, self) {
	  {
	    var propName; // Reserved names are extracted

	    var props = {};
	    var key = null;
	    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
	    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
	    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
	    // but as an intermediary step, we will use jsxDEV for everything except
	    // <div {...props} key="Hi" />, because we aren't currently able to tell if
	    // key is explicitly declared to be undefined or not.

	    if (maybeKey !== undefined) {
	      {
	        checkKeyStringCoercion(maybeKey);
	      }

	      key = '' + maybeKey;
	    }

	    if (hasValidKey(config)) {
	      {
	        checkKeyStringCoercion(config.key);
	      }

	      key = '' + config.key;
	    }

	    if (hasValidRef(config)) {
	      ref = config.ref;
	      warnIfStringRefCannotBeAutoConverted(config, self);
	    } // Remaining properties are added to a new props object


	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    } // Resolve default props


	    if (type && type.defaultProps) {
	      var defaultProps = type.defaultProps;

	      for (propName in defaultProps) {
	        if (props[propName] === undefined) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    }

	    if (key || ref) {
	      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

	      if (key) {
	        defineKeyPropWarningGetter(props, displayName);
	      }

	      if (ref) {
	        defineRefPropWarningGetter(props, displayName);
	      }
	    }

	    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	  }
	}

	var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
	var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement$1(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
	    }
	  }
	}

	var propTypesMisspellWarningShown;

	{
	  propTypesMisspellWarningShown = false;
	}
	/**
	 * Verifies the object is a ReactElement.
	 * See https://reactjs.org/docs/react-api.html#isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a ReactElement.
	 * @final
	 */


	function isValidElement(object) {
	  {
	    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	  }
	}

	function getDeclarationErrorAddendum() {
	  {
	    if (ReactCurrentOwner$1.current) {
	      var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);

	      if (name) {
	        return '\n\nCheck the render method of `' + name + '`.';
	      }
	    }

	    return '';
	  }
	}

	function getSourceInfoErrorAddendum(source) {
	  {
	    if (source !== undefined) {
	      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
	      var lineNumber = source.lineNumber;
	      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
	    }

	    return '';
	  }
	}
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */


	var ownerHasKeyUseWarning = {};

	function getCurrentComponentErrorInfo(parentType) {
	  {
	    var info = getDeclarationErrorAddendum();

	    if (!info) {
	      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

	      if (parentName) {
	        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
	      }
	    }

	    return info;
	  }
	}
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it. Error statuses are cached so a warning
	 * will only be shown once.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */


	function validateExplicitKey(element, parentType) {
	  {
	    if (!element._store || element._store.validated || element.key != null) {
	      return;
	    }

	    element._store.validated = true;
	    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

	    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
	      return;
	    }

	    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
	    // property, it may be the creator of the child that's responsible for
	    // assigning it a key.

	    var childOwner = '';

	    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
	      // Give the component that originally created this child.
	      childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
	    }

	    setCurrentlyValidatingElement$1(element);

	    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

	    setCurrentlyValidatingElement$1(null);
	  }
	}
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */


	function validateChildKeys(node, parentType) {
	  {
	    if (typeof node !== 'object') {
	      return;
	    }

	    if (isArray(node)) {
	      for (var i = 0; i < node.length; i++) {
	        var child = node[i];

	        if (isValidElement(child)) {
	          validateExplicitKey(child, parentType);
	        }
	      }
	    } else if (isValidElement(node)) {
	      // This element was passed in a valid location.
	      if (node._store) {
	        node._store.validated = true;
	      }
	    } else if (node) {
	      var iteratorFn = getIteratorFn(node);

	      if (typeof iteratorFn === 'function') {
	        // Entry iterators used to provide implicit keys,
	        // but now we print a separate warning for them later.
	        if (iteratorFn !== node.entries) {
	          var iterator = iteratorFn.call(node);
	          var step;

	          while (!(step = iterator.next()).done) {
	            if (isValidElement(step.value)) {
	              validateExplicitKey(step.value, parentType);
	            }
	          }
	        }
	      }
	    }
	  }
	}
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */


	function validatePropTypes(element) {
	  {
	    var type = element.type;

	    if (type === null || type === undefined || typeof type === 'string') {
	      return;
	    }

	    var propTypes;

	    if (typeof type === 'function') {
	      propTypes = type.propTypes;
	    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
	    // Inner props are checked in the reconciler.
	    type.$$typeof === REACT_MEMO_TYPE)) {
	      propTypes = type.propTypes;
	    } else {
	      return;
	    }

	    if (propTypes) {
	      // Intentionally inside to avoid triggering lazy initializers:
	      var name = getComponentNameFromType(type);
	      checkPropTypes(propTypes, element.props, 'prop', name, element);
	    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
	      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

	      var _name = getComponentNameFromType(type);

	      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
	    }

	    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
	      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
	    }
	  }
	}
	/**
	 * Given a fragment, validate that it can only be provided with fragment props
	 * @param {ReactElement} fragment
	 */


	function validateFragmentProps(fragment) {
	  {
	    var keys = Object.keys(fragment.props);

	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];

	      if (key !== 'children' && key !== 'key') {
	        setCurrentlyValidatingElement$1(fragment);

	        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

	        setCurrentlyValidatingElement$1(null);
	        break;
	      }
	    }

	    if (fragment.ref !== null) {
	      setCurrentlyValidatingElement$1(fragment);

	      error('Invalid attribute `ref` supplied to `React.Fragment`.');

	      setCurrentlyValidatingElement$1(null);
	    }
	  }
	}

	var didWarnAboutKeySpread = {};
	function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
	  {
	    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.

	    if (!validType) {
	      var info = '';

	      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
	      }

	      var sourceInfo = getSourceInfoErrorAddendum(source);

	      if (sourceInfo) {
	        info += sourceInfo;
	      } else {
	        info += getDeclarationErrorAddendum();
	      }

	      var typeString;

	      if (type === null) {
	        typeString = 'null';
	      } else if (isArray(type)) {
	        typeString = 'array';
	      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
	        typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
	        info = ' Did you accidentally export a JSX literal instead of a component?';
	      } else {
	        typeString = typeof type;
	      }

	      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
	    }

	    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.

	    if (element == null) {
	      return element;
	    } // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)


	    if (validType) {
	      var children = props.children;

	      if (children !== undefined) {
	        if (isStaticChildren) {
	          if (isArray(children)) {
	            for (var i = 0; i < children.length; i++) {
	              validateChildKeys(children[i], type);
	            }

	            if (Object.freeze) {
	              Object.freeze(children);
	            }
	          } else {
	            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
	          }
	        } else {
	          validateChildKeys(children, type);
	        }
	      }
	    }

	    {
	      if (hasOwnProperty.call(props, 'key')) {
	        var componentName = getComponentNameFromType(type);
	        var keys = Object.keys(props).filter(function (k) {
	          return k !== 'key';
	        });
	        var beforeExample = keys.length > 0 ? '{key: someKey, ' + keys.join(': ..., ') + ': ...}' : '{key: someKey}';

	        if (!didWarnAboutKeySpread[componentName + beforeExample]) {
	          var afterExample = keys.length > 0 ? '{' + keys.join(': ..., ') + ': ...}' : '{}';

	          error('A props object containing a "key" prop is being spread into JSX:\n' + '  let props = %s;\n' + '  <%s {...props} />\n' + 'React keys must be passed directly to JSX without using spread:\n' + '  let props = %s;\n' + '  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);

	          didWarnAboutKeySpread[componentName + beforeExample] = true;
	        }
	      }
	    }

	    if (type === REACT_FRAGMENT_TYPE) {
	      validateFragmentProps(element);
	    } else {
	      validatePropTypes(element);
	    }

	    return element;
	  }
	} // These two functions exist to still get child warnings in dev
	// even with the prod transform. This means that jsxDEV is purely
	// opt-in behavior for better messages but that we won't stop
	// giving you warnings if you use production apis.

	function jsxWithValidationStatic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, true);
	  }
	}
	function jsxWithValidationDynamic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, false);
	  }
	}

	var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
	// for now we can ship identical prod functions

	var jsxs =  jsxWithValidationStatic ;

	reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
	reactJsxRuntime_development.jsx = jsx;
	reactJsxRuntime_development.jsxs = jsxs;
	  })();
	}
	return reactJsxRuntime_development;
}

(function (module) {

	if (process.env.NODE_ENV === 'production') {
	  module.exports = requireReactJsxRuntime_production_min();
	} else {
	  module.exports = requireReactJsxRuntime_development();
	}
} (jsxRuntime));

const StyledContainer$1 = styled__default["default"].div `
  margin: 0 auto;
  width: 100%;
  padding: 0 1.2rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    max-width: 720px;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    max-width: 1320px;
  }
`;

const Container$1 = ({ children, className }) => (jsxRuntime.exports.jsx(StyledContainer$1, { className: className, children: children }));

const StyledFlex = styled__default["default"].div `
  align-items: ${({ alignItems = 'center' }) => alignItems};
  align-content: ${({ alignContent = 'center' }) => alignContent};
  display: flex;
  flex-wrap: ${({ flexWrap = 'wrap' }) => flexWrap};
  flex-direction: ${({ flexDirection = 'row' }) => flexDirection};
  gap: ${({ gap = '2rem' }) => gap};
  height: ${({ height = 'auto' }) => height};
  justify-content: ${({ justifyContent = 'space-between' }) => justifyContent};
  width: ${({ width = '100%' }) => width};
`;

const StyledFluidContainer = styled__default["default"](Container$1) `
  ${({ isFullWidth }) => isFullWidth &&
    `
    max-width: 100%;
    margin: 0;
    padding: 0 3.8rem;
  `}
`;

const FluidContainer = ({ children, className, isFullWidth }) => (jsxRuntime.exports.jsx(StyledFluidContainer, { isFullWidth: isFullWidth, className: className, children: children }));

const StyledFormInputBase = styled.css `
  border: none;
  flex-grow: 1;
  background-color: transparent;
  font: inherit;
  color: inherit;

  /*
    Mitigates for an issue where the browser may fall back to the user agent stylesheet, causing right
    adornments to render outside the containing div
  */
  min-width: 4rem;

  :disabled {
    color: ${({ theme }) => theme.colors.grey[600]};
    ::placeholder {
      color: ${({ theme }) => theme.colors.grey[600]};
    }
  }
  ::placeholder {
    color: ${({ theme }) => theme.colors.grey[400]};
  }
  /*
    While not broadly recommended by a11y guidelines, this suppresses browser-native focus styling.
    This is mitigated by the :focus-within pseudo element in StyledFormFieldInputWrapper above
  */
  outline: 0;
`;
const StyledFormInputBaseWrapper = styled__default["default"].div `
  width: 100%;
  height: auto;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme, isDisabled, forceDarkMode }) => {
    if (isDisabled) {
        return theme.colors.grey[900];
    }
    if (forceDarkMode) {
        return darkColors.text.main;
    }
    return theme.colors.text.light;
}};
  border-radius: ${({ theme }) => theme.radius.small};
  background-color: ${({ isDisabled, isError, forceDarkMode, theme }) => {
    if (isDisabled) {
        return theme.colors.background.disabled;
    }
    if (isError) {
        return theme.colors.error.lightest;
    }
    if (forceDarkMode) {
        return darkColors.background.secondary;
    }
    return theme.colors.background.secondary;
}};
  outline: none;
  border: ${({ isError, theme, forceDarkMode }) => {
    const color = isError ? theme.colors.error.main : theme.colors.border.dropdown;
    return `0.1rem solid ${forceDarkMode ? theme.colors.secondary.lighter : color}`;
}};
  &:focus-within {
    border-color: ${({ theme }) => theme.colors.info.main};
  }
  /* // hide arrows on number input */
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield !important;
  display: flex;
`;

const GlobalStyles = styled.createGlobalStyle(({ theme }) => `
  @import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@300;400;500;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,300;0,400;0,600;0,700;1,400&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Bungee&display=swap');

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    font-size: ${theme.fonts.sizes.reset};
  }

  body {
    background-color: ${theme.colors.background.dark}
  }

  body,
  a,
  button {
    font-family: ${theme.fonts.familySansPro};
  }

  p {
    font-size: 1.6rem;
    margin-bottom: 0;
    line-height: 2.4rem;
  }

  ul {
    list-style: none;
  }

  small {
    font-size: 1.4rem;
  }

  a,
  button {
    cursor: pointer;
  }

  a {
    color: ${theme.colors.info.main};
  }

  button {
    border: none;
    background: transparent;
  }

  input::-webkit-input-placeholder   {
    font-family: ${theme.fonts.familySansPro};
  }

  input::-moz-placeholder{
    font-family: ${theme.fonts.familySansPro};
  }

  :is(h1, h2, h3, h4) {
    font-family: ${theme.fonts.familyUbuntu};
    font-weight: 500;
    margin-bottom: 2rem;
    color: ${theme.colors.text.main};
  }

  :is(h5, h6) {
    font-family: ${theme.fonts.familySansPro};
    font-weight: 400;
    margin-bottom: 2rem;
    color: ${theme.colors.paragraph};
  }

  h1 {
    font-size: 3.2rem;

    @media screen and (min-width: ${theme.sizes.md}) {
      font-size: 4.4rem;
    }

    @media screen and (min-width: ${theme.sizes.lg}) {
      font-size: 5.4rem;
    }   
  }

  h2 {
    font-size: 2.4rem;

    @media screen and (min-width: ${theme.sizes.md}) {
      font-size: 3.2rem;
    }   
  }

  h3 {
    font-size: 2rem;

     @media screen and (min-width: ${theme.sizes.lg}) {
      font-size: 2.4rem;
     }
  }

  h4 {
    font-size: 1.8rem;
  }

  h5 {
    font-size: 2rem;
    line-height: 3rem;
  
     @media screen and (min-width: ${theme.sizes.lg}) {
      font-size: 2.4rem;
      line-height: 3.5rem;
    }  
  }

  h6 {
    font-size: 2rem;

    @media screen and (min-width: ${theme.sizes.lg}) {
      font-size: 2.2rem;
    }  
  }

  .no-scroll {
    overflow: hidden;
    height: 100%;
  }

  .mobile-no-scroll {
    @media screen and (max-width: ${theme.sizes.md}) {
      overflow: hidden;
      height: 100%;
    }
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.scrollBar.primary};
    border-radius:  ${theme.radius.big};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.scrollBar.secondary};
    border-radius: ${theme.radius.big};
  }

  /* --- Global Override styles for popover arrows used by react-datepicker --- */

    /* These control the fill color of the popover arrow */
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after {
    border-bottom-color: ${theme.colors.datePicker.background};
  }
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::after {
    border-top-color: ${theme.colors.datePicker.background};
  }
  .react-datepicker-popper[data-placement^='left'] .react-datepicker__triangle::after {
    border-left-color: ${theme.colors.datePicker.background};
  }
  .react-datepicker-popper[data-placement^='right'] .react-datepicker__triangle::after {
    border-right-color: ${theme.colors.datePicker.background};
  }

  /* These control the border color of the popover arrow */
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {
    border-bottom-color: ${theme.colors.border.light};
  }
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before {
    border-top-color: ${theme.colors.border.light};
  }
  .react-datepicker-popper[data-placement^='left'] .react-datepicker__triangle::before {
    border-left-color: ${theme.colors.border.light};
  }
  .react-datepicker-popper[data-placement^='right'] .react-datepicker__triangle::before {
    border-right-color: ${theme.colors.border.light};
  }
`);

const StyledGrid = styled__default["default"].div `
  display: grid;
  align-items: ${({ alignItems = 'stretch' }) => alignItems};
  gap: ${({ gap = '2rem' }) => gap};

  grid-template-columns: ${({ gridTemplateColumns = 'auto-responsive', autoResponsiveWidth = '20rem' }) => {
    switch (gridTemplateColumns) {
        case 'col-2': {
            return 'repeat(2, 1fr)';
        }
        case 'col-3': {
            return 'repeat(3, 1fr)';
        }
        case 'col-4': {
            return 'repeat(4, 1fr)';
        }
        case 'auto-responsive': {
            return `repeat(auto-fit, minmax(${autoResponsiveWidth}, 1fr))`;
        }
        default: {
            return gridTemplateColumns;
        }
    }
}};

  justify-content: ${({ justifyContent = 'space-between' }) => justifyContent};
  width: ${({ width = '100%' }) => width};

  @media screen and (max-width: ${({ theme }) => theme.sizes?.lg}) {
    grid-template-columns: ${({ gridTemplateColumns }) => {
    if (gridTemplateColumns === 'col-3' || gridTemplateColumns === 'col-4') {
        return 'repeat(2, 1fr)';
    }
    if (gridTemplateColumns === 'auto-responsive') {
        return 'repeat(auto-fit, minmax(250px, 1fr))';
    }
    return gridTemplateColumns;
}};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes?.md}) {
    grid-template-columns: 1fr;
  }
`;

/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const faCalendarDays = {
  prefix: 'far',
  iconName: 'calendar-days',
  icon: [448, 512, ["calendar-alt"], "f073", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l80 0 0 56-80 0 0-56zm0 104l80 0 0 64-80 0 0-64zm128 0l96 0 0 64-96 0 0-64zm144 0l80 0 0 64-80 0 0-64zm80-48l-80 0 0-56 80 0 0 56zm0 160l0 40c0 8.8-7.2 16-16 16l-64 0 0-56 80 0zm-128 0l0 56-96 0 0-56 96 0zm-144 0l0 56-64 0c-8.8 0-16-7.2-16-16l0-40 80 0zM272 248l-96 0 0-56 96 0 0 56z"]
};
const faLightbulb = {
  prefix: 'far',
  iconName: 'lightbulb',
  icon: [384, 512, [128161], "f0eb", "M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7c0 0 0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5L109 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5l-48.6 0c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80l0-16 160 0 0 16c0 44.2-35.8 80-80 80z"]
};
const faFlag$1 = {
  prefix: 'far',
  iconName: 'flag',
  icon: [448, 512, [127988, 61725], "f024", "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24L0 64 0 350.5 0 400l0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-100 80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-279.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L48 52l0-28zm0 77.5l96.6-24.2c27-6.7 55.5-3.6 80.4 8.8c54.9 27.4 118.7 29.7 175 6.8l0 241.8-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4c-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5l0-237z"]
};
const faChevronUp = {
  prefix: 'far',
  iconName: 'chevron-up',
  icon: [512, 512, [], "f077", "M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z"]
};
const faSparkles = {
  prefix: 'far',
  iconName: 'sparkles',
  icon: [512, 512, [10024], "f890", "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5L26.3 277l8.1 3.7 .6 .3 88.3 40.8L164.1 410l.3 .6 3.7 8.1 7.9 17.1c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l7.9-17.1 3.7-8.1 .3-.6 40.8-88.3L346 281l.6-.3 8.1-3.7 17.1-7.9c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5l-17.1-7.9-8.1-3.7-.6-.3-88.3-40.8L217 99.1l-.3-.6L213 90.3l-7.9-17.1c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3l-7.9 17.1-3.7 8.1-.3 .6-40.8 88.3L35.1 228.1l-.6 .3-8.1 3.7L9.3 240zm83 14.5l51.2-23.6c10.4-4.8 18.7-13.1 23.5-23.5l23.6-51.2 23.6 51.2c4.8 10.4 13.1 18.7 23.5 23.5l51.2 23.6-51.2 23.6c-10.4 4.8-18.7 13.1-23.5 23.5l-23.6 51.2-23.6-51.2c-4.8-10.4-13.1-18.7-23.5-23.5L92.3 254.6zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"]
};
const faBookmark$1 = {
  prefix: 'far',
  iconName: 'bookmark',
  icon: [384, 512, [128278, 61591], "f02e", "M0 48C0 21.5 21.5 0 48 0l0 48 0 393.4 130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4 336 48 48 48 48 0 336 0c26.5 0 48 21.5 48 48l0 440c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488L0 48z"]
};
const faArrowUpFromBracket = {
  prefix: 'far',
  iconName: 'arrow-up-from-bracket',
  icon: [448, 512, [], "e09a", "M241 7c-9.4-9.4-24.6-9.4-33.9 0L79 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87L200 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-246.1 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zM48 344c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-80z"]
};
const faKey = {
  prefix: 'far',
  iconName: 'key',
  icon: [512, 512, [128273], "f084", "M208 176c0-70.7 57.3-128 128-128s128 57.3 128 128s-57.3 128-128 128c-10.4 0-20.5-1.2-30.1-3.6c-8.1-2-16.7 .4-22.6 6.4L254.1 336 200 336c-13.3 0-24 10.7-24 24l0 40-40 0c-13.3 0-24 10.7-24 24l0 40-64 0 0-78.1L205.2 228.7c5.9-5.9 8.3-14.5 6.4-22.6c-2.3-9.6-3.6-19.7-3.6-30.1zM336 0C238.8 0 160 78.8 160 176c0 9.5 .7 18.8 2.2 27.9L7 359c-4.5 4.5-7 10.6-7 17L0 488c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l27.2-27.2c9.1 1.4 18.4 2.2 27.9 2.2c97.2 0 176-78.8 176-176S433.2 0 336 0zm32 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faBan = {
  prefix: 'far',
  iconName: 'ban',
  icon: [512, 512, [128683, "cancel"], "f05e", "M385.1 419.1L92.9 126.9C64.8 162.3 48 207.2 48 256c0 114.9 93.1 208 208 208c48.8 0 93.7-16.8 129.1-44.9zm33.9-33.9C447.2 349.7 464 304.8 464 256c0-114.9-93.1-208-208-208c-48.8 0-93.7 16.8-129.1 44.9L419.1 385.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faSpellCheck = {
  prefix: 'far',
  iconName: 'spell-check',
  icon: [576, 512, [], "f891", "M134.1 14.6C130.3 5.8 121.6 0 112 0s-18.3 5.8-22.1 14.6l-88 208c-5.2 12.2 .5 26.3 12.8 31.5s26.3-.5 31.5-12.8L56.8 216l110.3 0 10.7 25.4c5.2 12.2 19.2 17.9 31.5 12.8s17.9-19.2 12.8-31.5l-88-208zM146.9 168l-69.7 0L112 85.6 146.9 168zM256 24l0 104 0 104c0 13.3 10.7 24 24 24l92 0c42 0 76-34 76-76c0-24.6-11.7-46.4-29.8-60.3C426.9 107.3 432 92.2 432 76c0-42-34-76-76-76L280 0c-13.3 0-24 10.7-24 24zm100 80l-52 0 0-56 52 0c15.5 0 28 12.5 28 28s-12.5 28-28 28zm-52 48l52 0 16 0c15.5 0 28 12.5 28 28s-12.5 28-28 28l-68 0 0-56zM568.6 313.3c9.6-9.2 9.9-24.4 .7-33.9s-24.4-9.9-33.9-.7l-183 175.7L265 367c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L335 505c9.2 9.2 24.2 9.4 33.6 .3l200-192z"]
};
const faArrowRightToBracket = {
  prefix: 'far',
  iconName: 'arrow-right-to-bracket',
  icon: [512, 512, ["sign-in"], "f090", "M217 401L345 273c9.4-9.4 9.4-24.6 0-33.9L217 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l246.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zM344 80l80 0c22.1 0 40 17.9 40 40l0 272c0 22.1-17.9 40-40 40l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c48.6 0 88-39.4 88-88l0-272c0-48.6-39.4-88-88-88l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24z"]
};
const faCrown = {
  prefix: 'far',
  iconName: 'crown',
  icon: [576, 512, [128081], "f521", "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34l-5.8 11.6L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7l-72-57.6L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0l4.4 23.9L86.4 427.4c5.5 30.4 32 52.6 63 52.6l277.2 0c30.9 0 57.4-22.1 63-52.6l41.4-227.5 4.4-23.9c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-17.1 13.7-72 57.6c-15.9 12.7-39.5 7.5-48.6-10.7L314.8 117.7 309 106zM133.7 418.9L102.2 245.6l28.9 23.1c39.8 31.8 98.8 18.9 121.5-26.7L288 171.3l35.4 70.7c22.8 45.6 81.8 58.5 121.5 26.7l28.9-23.1L442.3 418.9c-1.4 7.6-8 13.1-15.7 13.1l-277.2 0c-7.7 0-14.4-5.5-15.7-13.1z"]
};
const faFire$1 = {
  prefix: 'far',
  iconName: 'fire',
  icon: [448, 512, [128293], "f06d", "M89.3 156.3C113 115 143.2 77 170.5 50.4c18.7 18.7 40.9 47.2 60.1 71.7c3.8 4.8 7.4 9.5 10.9 13.9c4.6 5.8 11.7 9.2 19.1 9.1s14.4-3.6 18.9-9.5c3.3-4.3 7.7-10.8 12.3-17.4c2.6-3.8 5.3-7.6 7.8-11.2c5.6-7.9 10.5-14.5 14.4-19.1c20 20.8 41 53 57.4 88.4c17.7 38.2 28.6 77 28.6 106.3c0 103-78.8 181.4-176 181.4c-98.3 0-176-78.4-176-181.4c0-37.5 16.2-82.4 41.3-126.2zM199.5 11.6C183.3-3.8 158-3.9 141.8 11.5c-32 30.1-67 73.6-94.1 121C20.7 179.5 0 233 0 282.6C0 410.9 98.1 512 224 512c124.6 0 224-100.9 224-229.4c0-39.1-13.9-85.2-33.1-126.5C395.7 114.6 369.8 74.9 343 49c-16.3-15.8-42-15.8-58.3-.1c-7.9 7.6-17 20-24.3 30.3l-1.1 1.6C240.6 57 218.4 29.5 199.5 11.6zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"]
};
const faGift = {
  prefix: 'far',
  iconName: 'gift',
  icon: [512, 512, [127873], "f06b", "M231.9 44.4C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88c0 14.4 3.5 28 9.6 40L48 128c-26.5 0-48 21.5-48 48l0 64c0 20.9 13.4 38.7 32 45.3l0 2.7 0 160c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-160 0-2.7c18.6-6.6 32-24.4 32-45.3l0-64c0-26.5-21.5-48-48-48l-25.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41zM464 176l0 64-32 0-144 0 0-64 72 0 104 0zm-240 0l0 64L80 240l-32 0 0-64 104 0 72 0zm0 112l0 176L96 464c-8.8 0-16-7.2-16-16l0-160 144 0zm64 176l0-176 144 0 0 160c0 8.8-7.2 16-16 16l-128 0zm72-336l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40zm-136 0l-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8L225.3 128l-1.3 0z"]
};
const faGaugeCircleBolt = {
  prefix: 'far',
  iconName: 'gauge-circle-bolt',
  icon: [640, 512, [], "e496", "M256 464c29.4 0 57.3-6.1 82.6-17.1c7.4 14.7 16.7 28.2 27.7 40.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6L232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 181.4c18.9 9 32 28.3 32 50.6c0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.7 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"]
};
const faChartBar = {
  prefix: 'far',
  iconName: 'chart-bar',
  icon: [512, 512, ["bar-chart"], "f080", "M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faCircleCheck$2 = {
  prefix: 'far',
  iconName: 'circle-check',
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
};
const faCircleArrowDown = {
  prefix: 'far',
  iconName: 'circle-arrow-down',
  icon: [512, 512, ["arrow-circle-down"], "f0ab", "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM361 305l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faNewspaper = {
  prefix: 'far',
  iconName: 'newspaper',
  icon: [512, 512, [128240], "f1ea", "M168 80c-13.3 0-24 10.7-24 24l0 304c0 8.4-1.4 16.5-4.1 24L440 432c13.3 0 24-10.7 24-24l0-304c0-13.3-10.7-24-24-24L168 80zM72 480c-39.8 0-72-32.2-72-72L0 112C0 98.7 10.7 88 24 88s24 10.7 24 24l0 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-304c0-39.8 32.2-72 72-72l272 0c39.8 0 72 32.2 72 72l0 304c0 39.8-32.2 72-72 72L72 480zM176 136c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-80zm200-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM200 272l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faArrowUpRightFromSquare$1 = {
  prefix: 'far',
  iconName: 'arrow-up-right-from-square',
  icon: [512, 512, ["external-link"], "f08e", "M304 24c0 13.3 10.7 24 24 24l102.1 0L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223L464 184c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24L328 0c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"]
};
const faChartLine = {
  prefix: 'far',
  iconName: 'chart-line',
  icon: [512, 512, ["line-chart"], "f201", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zM473 169c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119-79-79c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l79-79 79 79c9.4 9.4 24.6 9.4 33.9 0L473 169z"]
};
const faArrowRight$1 = {
  prefix: 'far',
  iconName: 'arrow-right',
  icon: [448, 512, [8594], "f061", "M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z"]
};
const faMessageSmile = {
  prefix: 'far',
  iconName: 'message-smile',
  icon: [512, 512, ["comment-alt-smile"], "f4aa", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM150.5 238.1c-9.9 8.8-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z"]
};
const faCircle$1 = {
  prefix: 'far',
  iconName: 'circle',
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faVolumeHigh = {
  prefix: 'far',
  iconName: 'volume-high',
  icon: [640, 512, [128266, "volume-up"], "f028", "M533.6 32.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C557.5 113.8 592 180.8 592 256s-34.5 142.2-88.7 186.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C598.5 426.7 640 346.2 640 256s-41.5-170.8-106.4-223.5zM473.1 107c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C475.3 170.7 496 210.9 496 256s-20.7 85.3-53.2 111.8c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149zm-60.5 74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C393.1 227.6 400 241 400 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C434.1 312.9 448 286.1 448 256s-13.9-56.9-35.4-74.5zM159.9 201.9L272 102.3l0 307.3L159.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1l-88 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l88 0c5.9 0 11.6-2.2 15.9-6.1zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160 56 160c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l78.9 0L270.4 472.5c5.5 4.9 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-388.4C320 45.3 306.7 32 290.2 32z"]
};
const faCircleQuestion = {
  prefix: 'far',
  iconName: 'circle-question',
  icon: [512, 512, [62108, "question-circle"], "f059", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faQuestionCircle = faCircleQuestion;
const faRoute = {
  prefix: 'far',
  iconName: 'route',
  icon: [512, 512, [], "f4d7", "M438.6 155.7c-7.2 11.5-15 22.6-22.6 32.7c-7.5-10.1-15.4-21.2-22.6-32.7C375.7 127.3 368 106.3 368 96c0-26.5 21.5-48 48-48s48 21.5 48 48c0 10.3-7.7 31.3-25.4 59.7zM427.4 251C452.9 221.1 512 146.2 512 96c0-53-43-96-96-96s-96 43-96 96c0 33.3 25.9 77.3 50.8 112L328 208c-48.6 0-88 39.4-88 88s39.4 88 88 88l96 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-246.2 0c-2.7 3.8-5.5 7.6-8.2 11.2c-10.7 14.2-21.3 26.9-30 36.8L424 512c48.6 0 88-39.4 88-88s-39.4-88-88-88l-96 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l84.9 0c5.1 1.1 10.7-.6 14.5-5zM118.9 408.4c-7.3 11-15.3 21.7-22.9 31.2c-7.6-9.5-15.6-20.2-22.9-31.2C55.4 381.7 48 361.9 48 352c0-26.5 21.5-48 48-48s48 21.5 48 48c0 9.9-7.4 29.7-25.1 56.4zm19 55.6c25.9-33.1 54.1-77.3 54.1-112c0-53-43-96-96-96s-96 43-96 96c0 50.5 59.8 121 85 148.4c6 6.5 16 6.5 21.9 0c.1-.1 .2-.2 .3-.3c.3-.3 .6-.7 .9-1c2.8-3.1 6-6.7 9.5-10.7c.1-.1 .1-.1 .2-.2c6.1-7 13-15.2 20-24.2z"]
};
const faTerminal = {
  prefix: 'far',
  iconName: 'terminal',
  icon: [576, 512, [], "f120", "M6.3 72.2c-9-9.8-8.3-24.9 1.4-33.9s24.9-8.3 33.9 1.4l184 200c8.5 9.2 8.5 23.3 0 32.5l-184 200c-9 9.8-24.2 10.4-33.9 1.4s-10.4-24.2-1.4-33.9L175.4 256 6.3 72.2zM248 432l304 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-304 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faDoorClosed$1 = {
  prefix: 'far',
  iconName: 'door-closed',
  icon: [576, 512, [128682], "f52a", "M416 48c8.8 0 16 7.2 16 16l0 400-288 0 0-400c0-8.8 7.2-16 16-16l256 0zm64 416l0-400c0-35.3-28.7-64-64-64L160 0C124.7 0 96 28.7 96 64l0 400-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 48 0 288 0 48 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0zM368 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
const faHandsClapping$1 = {
  prefix: 'far',
  iconName: 'hands-clapping',
  icon: [512, 512, [], "e1a8", "M328 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM223.1 18.7c7.4-4.9 17.3-2.9 22.2 4.4l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2zM412 152c9.5-5.1 20.4-8 32-8c37.6 0 68 30.4 68 68l0 117.6c0 100.5-81.3 182-181.7 182.4c27.3-16.9 50.5-39.8 67.8-66.8c39.4-23.4 65.8-66.4 65.8-115.6L464 212c0-11-9-20-20-20c-5 0-9.6 1.9-13.1 4.9c-2.5-16.7-9.2-32-18.9-44.9zM410.7 23.1c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48zM320 208l0 40c0 3.3-.6 6.4-1.8 9.2s-2.9 5.5-5.2 7.8s-5 4-7.8 5.2s-5.9 1.8-9.2 1.8s-6.4-.6-9.2-1.8s-5.5-2.9-7.8-5.2L169 154.9c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7L233 247c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L121 202.9l-32-32c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7l24 24L185 295c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L65 242.9s0 0 0 0c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7l48 48s0 0 0 0L137 343c1.2 1.2 2.2 2.4 3.1 3.8c6.2 9.3 5.1 22-3.1 30.2c-9.4 9.4-24.6 9.4-33.9 0L65 338.9s0 0 0 0c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7l22 22s0 0 0 0l16 16s0 0 0 0l33.6 33.6c25.2 25.2 59.4 39.4 95 39.4C291.8 464 352 403.8 352 329.6L352 208c0-8.8-7.2-16-16-16s-16 7.2-16 16zM113.9 129.6c10.4-15.4 28.1-25.6 48.1-25.6c15.4 0 30.1 6.1 41 17L274 192.1c7.1-27.6 32.2-48.1 62-48.1c35.3 0 64 28.7 64 64l0 121.6C400 430.3 318.3 512 217.6 512c-48.4 0-94.8-19.2-129-53.4L55 425s0 0 0 0L39 409s0 0 0 0l-22-22C6.1 376 0 361.3 0 345.9c0-19.6 9.7-36.9 24.6-47.4L17 290.9C6.1 280 0 265.3 0 249.9c0-21.2 11.4-39.8 28.4-49.9c-2.9-7-4.4-14.5-4.4-22.1c0-32 25.9-57.9 57.9-57.9c11.4 0 22.5 3.4 31.9 9.6z"]
};
const faChartLineDown = {
  prefix: 'far',
  iconName: 'chart-line-down',
  icon: [512, 512, [128201], "f64d", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zM320 296c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 54.1L321 127c-9.4-9.4-24.6-9.4-33.9 0l-79 79-63-63c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l79-79L398.1 272 344 272c-13.3 0-24 10.7-24 24z"]
};
const faCrosshairs = {
  prefix: 'far',
  iconName: 'crosshairs',
  icon: [512, 512, [], "f05b", "M256 0c13.3 0 24 10.7 24 24l0 17.3C380.1 52.4 459.6 131.9 470.7 232l17.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-17.3 0C459.6 380.1 380.1 459.6 280 470.7l0 17.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-17.3C131.9 459.6 52.4 380.1 41.3 280L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l17.3 0C52.4 131.9 131.9 52.4 232 41.3L232 24c0-13.3 10.7-24 24-24zM89.7 280c10.5 73.6 68.7 131.8 142.3 142.3l0-30.3c0-13.3 10.7-24 24-24s24 10.7 24 24l0 30.3c73.6-10.5 131.8-68.7 142.3-142.3L392 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l30.3 0C411.8 158.4 353.6 100.2 280 89.7l0 30.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-30.3C158.4 100.2 100.2 158.4 89.7 232l30.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-30.3 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faGear = {
  prefix: 'far',
  iconName: 'gear',
  icon: [512, 512, [9881, "cog"], "f013", "M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3c-2.6-7.6-5.6-21.8 2.7-35.4c2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192z"]
};
const faClock$1 = {
  prefix: 'far',
  iconName: 'clock',
  icon: [512, 512, [128339, "clock-four"], "f017", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
const faUpload = {
  prefix: 'far',
  iconName: 'upload',
  icon: [512, 512, [], "f093", "M280 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-278.1-95 95c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 7c9.4-9.4 24.6-9.4 33.9 0L409 143c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-95-95L280 360zm32-8l0-48 136 0c35.3 0 64 28.7 64 64l0 80c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-80c0-35.3 28.7-64 64-64l136 0 0 48L64 352c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-80c0-8.8-7.2-16-16-16l-136 0zm72 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faAngleDown$1 = {
  prefix: 'far',
  iconName: 'angle-down',
  icon: [448, 512, [8964], "f107", "M241 369c-9.4 9.4-24.6 9.4-33.9 0L47 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 369z"]
};
const faXmarkLarge = {
  prefix: 'far',
  iconName: 'xmark-large',
  icon: [448, 512, [], "e59b", "M41 39C31.6 29.7 16.4 29.7 7 39S-2.3 63.6 7 73l183 183L7 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l183-183L407 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-183-183L441 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-183 183L41 39z"]
};
const faArrowDown$1 = {
  prefix: 'far',
  iconName: 'arrow-down',
  icon: [384, 512, [8595], "f063", "M174.6 472.6c4.5 4.7 10.8 7.4 17.4 7.4s12.8-2.7 17.4-7.4l168-176c9.2-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9 .8L216 396.1 216 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 340.1L41.4 263.4c-9.2-9.6-24.3-9.9-33.9-.8s-9.9 24.3-.8 33.9l168 176z"]
};
const faMagnifyingGlass$1 = {
  prefix: 'far',
  iconName: 'magnifying-glass',
  icon: [512, 512, [128269, "search"], "f002", "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"]
};
const faSearch$1 = faMagnifyingGlass$1;
const faChevronDown$2 = {
  prefix: 'far',
  iconName: 'chevron-down',
  icon: [512, 512, [], "f078", "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"]
};
const faCircleEllipsis = {
  prefix: 'far',
  iconName: 'circle-ellipsis',
  icon: [512, 512, [], "e10a", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm32 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
const faArrowUp$1 = {
  prefix: 'far',
  iconName: 'arrow-up',
  icon: [384, 512, [8593], "f062", "M209.4 39.4C204.8 34.7 198.6 32 192 32s-12.8 2.7-17.4 7.4l-168 176c-9.2 9.6-8.8 24.8 .8 33.9s24.8 8.8 33.9-.8L168 115.9 168 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-340.1L342.6 248.6c9.2 9.6 24.3 9.9 33.9 .8s9.9-24.3 .8-33.9l-168-176z"]
};
const faCircleUser = {
  prefix: 'far',
  iconName: 'circle-user',
  icon: [512, 512, [62142, "user-circle"], "f2bd", "M406.5 399.6C387.4 352.9 341.5 320 288 320l-64 0c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3l64 0c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"]
};
const faCopy$1 = {
  prefix: 'far',
  iconName: 'copy',
  icon: [448, 512, [], "f0c5", "M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z"]
};
const faXmark$2 = {
  prefix: 'far',
  iconName: 'xmark',
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"]
};
const faClose = faXmark$2;
const faChevronLeft$1 = {
  prefix: 'far',
  iconName: 'chevron-left',
  icon: [320, 512, [9001], "f053", "M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"]
};
const faChevronRight$1 = {
  prefix: 'far',
  iconName: 'chevron-right',
  icon: [320, 512, [9002], "f054", "M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"]
};
const faVideoSlash = {
  prefix: 'far',
  iconName: 'video-slash',
  icon: [640, 512, [], "f4e2", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L113.9 64 352 64c35.3 0 64 28.7 64 64l0 33 0 127 0 12.8L560 413.6l0-50.3 0-11.4 0-64 0-139.4L448 199l0-52.6L552.3 99.5c5.1-2.3 10.6-3.5 16.2-3.5c21.8 0 39.5 17.7 39.5 39.5L608 352l0 24.5 0 74.8 22.8 17.9c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM368 263.1L368 128c0-8.8-7.2-16-16-16l-176.8 0L368 263.1zM32 128c0-2.2 .1-4.4 .3-6.5L80 159l0 225c0 8.8 7.2 16 16 16l256 0c8.2 0 15-6.2 15.9-14.1L407 416.7c-11.2 18.7-31.6 31.3-55 31.3L96 448c-35.3 0-64-28.7-64-64l0-256z"]
};
const faAward = {
  prefix: 'far',
  iconName: 'award',
  icon: [384, 512, [], "f559", "M163.1 8.1c17.7-10.8 40-10.8 57.8 0l15.6 9.5c1.2 .7 2.7 1.1 4.1 1.1l18.3-.4c20.8-.5 40.1 10.7 50 28.9l8.8 16.1c.7 1.3 1.7 2.3 3 3L336.8 75c18.2 10 29.4 29.3 28.9 50l-.4 18.3c0 1.4 .3 2.9 1.1 4.1l9.5 15.6c10.8 17.7 10.8 40 0 57.8l-9.5 15.6c-.7 1.2-1.1 2.7-1.1 4.1l.4 18.3c.5 20.8-10.7 40.1-28.9 50l-16.1 8.8c-1.3 .7-2.3 1.7-3 3L309 336.8c-10 18.2-29.3 29.4-50 28.9l-18.3-.4c-1.4 0-2.9 .3-4.1 1.1l-15.6 9.5c-17.7 10.8-40 10.8-57.8 0l-15.6-9.5c-1.2-.7-2.7-1.1-4.1-1.1l-18.3 .4c-20.8 .5-40.1-10.7-50-28.9l-8.8-16.1c-.7-1.3-1.7-2.3-3-3L47.2 309c-18.2-10-29.4-29.3-28.9-50l.4-18.3c0-1.4-.3-2.9-1.1-4.1L8.1 220.9c-10.8-17.7-10.8-40 0-57.8l9.5-15.6c.7-1.2 1.1-2.7 1.1-4.1l-.4-18.3C17.8 104.3 29 85 47.2 75l16.1-8.8c1.3-.7 2.3-1.7 3-3L75 47.2c10-18.2 29.3-29.4 50-28.9l18.3 .4c1.4 0 2.9-.3 4.1-1.1l15.6-9.5zm32.8 41c-2.4-1.5-5.4-1.5-7.8 0l-15.6 9.5c-9.1 5.5-19.6 8.3-30.2 8.1l-18.3-.4c-2.8-.1-5.4 1.4-6.8 3.9l-8.8 16.1c-5.1 9.3-12.8 17-22.1 22.1l-16.1 8.8c-2.5 1.4-4 4-3.9 6.8l.4 18.3c.3 10.6-2.6 21.1-8.1 30.2l-9.5 15.6L28.6 175.6l20.5 12.5c-1.5 2.4-1.5 5.4 0 7.8l9.5 15.6c5.5 9.1 8.3 19.6 8.1 30.2l-.4 18.3c-.1 2.8 1.4 5.4 3.9 6.8l16.1 8.8c9.3 5.1 17 12.8 22.1 22.1l8.8 16.1c1.4 2.5 4 4 6.8 3.9l18.3-.4c10.6-.3 21.1 2.6 30.2 8.1l15.6 9.5c2.4 1.5 5.4 1.5 7.8 0l15.6-9.5c9.1-5.5 19.6-8.3 30.2-8.1l18.3 .4c2.8 .1 5.4-1.4 6.8-3.9l8.8-16.1c5.1-9.3 12.8-17 22.1-22.1l16.1-8.8c2.5-1.4 4-4 3.9-6.8l-.4-18.3c-.3-10.6 2.6-21.1 8.1-30.2l9.5-15.6c1.5-2.4 1.5-5.4 0-7.8l-9.5-15.6c-5.5-9.1-8.3-19.6-8.1-30.2l.4-18.3c.1-2.8-1.4-5.4-3.9-6.8l-16.1-8.8c-9.3-5.1-17-12.8-22.1-22.1l-8.8-16.1c-1.4-2.5-4-4-6.8-3.9l-18.3 .4c-10.6 .3-21.1-2.6-30.2-8.1l-15.6-9.5zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM1.3 441.8l41.2-97.9 4.5 8.2c15.7 28.7 46.1 46.3 78.9 45.5l11.1-.3 9.5 5.8c8 4.9 16.7 8.4 25.6 10.5l-37.3 88.5c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L212 413.7c8.9-2.1 17.5-5.6 25.5-10.5l9.5-5.8 11.1 .3c32.7 .8 63.2-16.8 78.9-45.5l4.5-8.2 41.2 97.9c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"]
};
const faShield = {
  prefix: 'far',
  iconName: 'shield',
  icon: [512, 512, [128737, "shield-blank"], "f132", "M256 49.4L73 127c-5.9 2.5-9.1 7.8-9 12.8c.5 91.4 38.4 249.3 186.4 320.1c3.6 1.7 7.8 1.7 11.3 0C409.7 389 447.6 231.2 448 139.7c0-5-3.1-10.2-9-12.8L256 49.4zM269.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0s9.2 1 13.4 2.9z"]
};
const faMoon = {
  prefix: 'far',
  iconName: 'moon',
  icon: [384, 512, [127769, 9214], "f186", "M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0l-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z"]
};
const faCheck$1 = {
  prefix: 'far',
  iconName: 'check',
  icon: [448, 512, [10003, 10004], "f00c", "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"]
};
const faBookOpen = {
  prefix: 'far',
  iconName: 'book-open',
  icon: [576, 512, [128214, 128366], "f518", "M156 32C100.6 32 48.8 46.6 27.1 53.6C10.3 59 0 74.5 0 91.1L0 403.5c0 26.1 24 44.2 48 40.2c19.8-3.3 54.8-7.7 100-7.7c54 0 97.5 25.5 112.5 35.6c7.5 5 16.8 8.4 27 8.4c11.5 0 21.6-4.2 29.3-9.9C330.2 460.3 369.1 436 428 436c47.7 0 80.5 4 99 7.2c23.9 4.1 49-13.8 49-40.6l0-311.5c0-16.5-10.3-32.1-27.1-37.5C527.2 46.6 475.4 32 420 32c-36.8 0-71.8 6.4-97.4 12.7c-12.8 3.2-23.5 6.3-30.9 8.7c-1.3 .4-2.6 .8-3.7 1.2c-1.1-.4-2.4-.8-3.7-1.2c-7.5-2.4-18.1-5.5-30.9-8.7C227.8 38.4 192.8 32 156 32zM264 97.3l0 320.6C238 404.2 196.8 388 148 388c-42.9 0-77.4 3.7-100 7.1L48 97.3C70.3 90.6 112.4 80 156 80c31.6 0 62.6 5.6 85.9 11.3c8.6 2.1 16.1 4.2 22.1 6zm48 319.2l0-319.2c6-1.8 13.5-3.9 22.1-6C357.4 85.6 388.4 80 420 80c43.6 0 85.7 10.6 108 17.3l0 297.4c-21.7-3.3-54.9-6.7-100-6.7c-51.4 0-90.8 15-116 28.6z"]
};
const faFileSpreadsheet = {
  prefix: 'far',
  iconName: 'file-spreadsheet',
  icon: [384, 512, [], "f65b", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM176 256l0 48-64 0 0-48 64 0zm-64 80l64 0 0 48-64 0 0-48zm96 0l64 0 0 48-64 0 0-48zm-16 80l16 0 64 0c17.7 0 32-14.3 32-32l0-48 0-16 0-16 0-48c0-17.7-14.3-32-32-32l-64 0-16 0-16 0-64 0c-17.7 0-32 14.3-32 32l0 48 0 16 0 16 0 48c0 17.7 14.3 32 32 32l64 0 16 0zm16-112l0-48 64 0 0 48-64 0z"]
};
const faThumbsUp$1 = {
  prefix: 'far',
  iconName: 'thumbs-up',
  icon: [512, 512, [128077, 61575], "f164", "M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.2s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16l-97.5 0c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8l97.5 0c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32L0 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-64 0z"]
};

function _extends$b() {
  return _extends$b = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$b.apply(null, arguments);
}

/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ React.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = React.useMemo(()=>context
            , Object.values(context));
            return /*#__PURE__*/ React.createElement(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = React.useContext(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + 'Provider';
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ React.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return React.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                })
            , [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            })
        );
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return React.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                })
            , [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}

/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React.useCallback($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = React.Children.toArray(children);
    const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if (React.Children.count(newElement) > 1) return React.Children.only(null);
                return /*#__PURE__*/ React.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ React.createElement($5e63c961fc1ce211$var$SlotClone, _extends$b({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ React.isValidElement(newElement) ? /*#__PURE__*/ React.cloneElement(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ React.createElement($5e63c961fc1ce211$var$SlotClone, _extends$b({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ React.isValidElement(children)) return /*#__PURE__*/ React.cloneElement(children, {
        ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref)
    });
    return React.Children.count(children) > 1 ? React.Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ React.isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}

// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + 'CollectionProvider';
    const [createCollectionContext, createCollectionScope] = $c512c27ab02ef895$export$50c7b4e9d9f19c1(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope , children: children  } = props;
        const ref = React__default["default"].useRef(null);
        const itemMap = React__default["default"].useRef(new Map()).current;
        return /*#__PURE__*/ React__default["default"].createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + 'CollectionSlot';
    const CollectionSlot = /*#__PURE__*/ React__default["default"].forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children  } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ React__default["default"].createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
            ref: composedRefs
        }, children);
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + 'CollectionItemSlot';
    const ITEM_DATA_ATTR = 'data-radix-collection-item';
    const CollectionItemSlot = /*#__PURE__*/ React__default["default"].forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children , ...itemData } = props;
        const ref = React__default["default"].useRef(null);
        const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        React__default["default"].useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref)
            ;
        });
        return /*#__PURE__*/ React__default["default"].createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
            [ITEM_DATA_ATTR]: '',
            ref: composedRefs
        }, children);
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + 'CollectionConsumer', scope);
        const getItems = React__default["default"].useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current)
            );
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}

function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}

/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
    const callbackRef = React.useRef(callback);
    React.useEffect(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return React.useMemo(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }
    , []);
}

function $71cd76cc60e0454e$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
    const setValue = React.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === 'function' ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = React.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = React.useRef(value);
    const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
    React.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}

const $8927f6f2acc4f386$var$NODES$1 = [
    'a',
    'button',
    'div',
    'h2',
    'h3',
    'img',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $8927f6f2acc4f386$export$250ffa63cdc0d034$1 = $8927f6f2acc4f386$var$NODES$1.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
        React.useEffect(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ React.createElement(Comp, _extends$b({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $8927f6f2acc4f386$export$6d1a0317bde7de7f$1(target, event) {
    if (target) $7SXl2$reactdom.flushSync(()=>target.dispatchEvent(event)
    );
}

/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? React.useLayoutEffect : ()=>{};

function $fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return React.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}


const $921a889cee6df7e8$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = $921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === 'function' ? children({
        present: presence.isPresent
    }) : React.Children.only(children);
    const ref = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(presence.ref, child.ref);
    const forceMount = typeof children === 'function';
    return forceMount || presence.isPresent ? /*#__PURE__*/ React.cloneElement(child, {
        ref: ref
    }) : null;
};
$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = 'Presence';
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = React.useState();
    const stylesRef = React.useRef({});
    const prevPresentRef = React.useRef(present);
    const prevAnimationNameRef = React.useRef('none');
    const initialState = present ? 'mounted' : 'unmounted';
    const [state, send] = $fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: 'unmounted',
            ANIMATION_OUT: 'unmountSuspended'
        },
        unmountSuspended: {
            MOUNT: 'mounted',
            ANIMATION_END: 'unmounted'
        },
        unmounted: {
            MOUNT: 'mounted'
        }
    });
    React.useEffect(()=>{
        const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === 'mounted' ? currentAnimationName : 'none';
    }, [
        state
    ]);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send('MOUNT');
            else if (currentAnimationName === 'none' || (styles === null || styles === void 0 ? void 0 : styles.display) === 'none') // If there is no exit animation or the element is hidden, animations won't run
            // so we unmount instantly
            send('UNMOUNT');
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send('ANIMATION_OUT');
                else send('UNMOUNT');
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // With React 18 concurrency this update is applied
                // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                $7SXl2$reactdom.flushSync(()=>send('ANIMATION_END')
                );
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) // if animation occurred, store its name as the previous animation.
                prevAnimationNameRef.current = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener('animationstart', handleAnimationStart);
            node1.addEventListener('animationcancel', handleAnimationEnd);
            node1.addEventListener('animationend', handleAnimationEnd);
            return ()=>{
                node1.removeEventListener('animationstart', handleAnimationStart);
                node1.removeEventListener('animationcancel', handleAnimationEnd);
                node1.removeEventListener('animationend', handleAnimationEnd);
            };
        } else // Transition to the unmounted state if the node is removed prematurely.
        // We avoid doing so during cleanup as the node may change but still exist.
        send('ANIMATION_END');
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            'mounted',
            'unmountSuspended'
        ].includes(state),
        ref: React.useCallback((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || 'none';
}

const $1746a345f3d73bb7$var$useReactId = React__namespace['useId'.toString()] || (()=>undefined
);
let $1746a345f3d73bb7$var$count = 0;
function $1746a345f3d73bb7$export$f680877a34711e37(deterministicId) {
    const [id, setId] = React__namespace.useState($1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count++)
        );
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : '');
}

/* -------------------------------------------------------------------------------------------------
 * Collapsible
 * -----------------------------------------------------------------------------------------------*/ const $409067139f391064$var$COLLAPSIBLE_NAME = 'Collapsible';
const [$409067139f391064$var$createCollapsibleContext, $409067139f391064$export$952b32dcbe73087a] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($409067139f391064$var$COLLAPSIBLE_NAME);
const [$409067139f391064$var$CollapsibleProvider, $409067139f391064$var$useCollapsibleContext] = $409067139f391064$var$createCollapsibleContext($409067139f391064$var$COLLAPSIBLE_NAME);
const $409067139f391064$export$6eb0f7ddcda6131f = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible , open: openProp , defaultOpen: defaultOpen , disabled: disabled , onOpenChange: onOpenChange , ...collapsibleProps } = props;
    const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ React.createElement($409067139f391064$var$CollapsibleProvider, {
        scope: __scopeCollapsible,
        disabled: disabled,
        contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
        open: open,
        onOpenToggle: React.useCallback(()=>setOpen((prevOpen)=>!prevOpen
            )
        , [
            setOpen
        ])
    }, /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({
        "data-state": $409067139f391064$var$getState(open),
        "data-disabled": disabled ? '' : undefined
    }, collapsibleProps, {
        ref: forwardedRef
    })));
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleTrigger
 * -----------------------------------------------------------------------------------------------*/ const $409067139f391064$var$TRIGGER_NAME = 'CollapsibleTrigger';
const $409067139f391064$export$c135dce7b15bbbdc = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible , ...triggerProps } = props;
    const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$TRIGGER_NAME, __scopeCollapsible);
    return /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$b({
        type: "button",
        "aria-controls": context.contentId,
        "aria-expanded": context.open || false,
        "data-state": $409067139f391064$var$getState(context.open),
        "data-disabled": context.disabled ? '' : undefined,
        disabled: context.disabled
    }, triggerProps, {
        ref: forwardedRef,
        onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onOpenToggle)
    }));
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleContent
 * -----------------------------------------------------------------------------------------------*/ const $409067139f391064$var$CONTENT_NAME = 'CollapsibleContent';
const $409067139f391064$export$aadde00976f34151 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount , ...contentProps } = props;
    const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, props.__scopeCollapsible);
    return /*#__PURE__*/ React.createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, ({ present: present  })=>/*#__PURE__*/ React.createElement($409067139f391064$var$CollapsibleContentImpl, _extends$b({}, contentProps, {
            ref: forwardedRef,
            present: present
        }))
    );
});
/* -----------------------------------------------------------------------------------------------*/ const $409067139f391064$var$CollapsibleContentImpl = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible , present: present , children: children , ...contentProps } = props;
    const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, __scopeCollapsible);
    const [isPresent, setIsPresent] = React.useState(present);
    const ref = React.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const heightRef = React.useRef(0);
    const height = heightRef.current;
    const widthRef = React.useRef(0);
    const width = widthRef.current; // when opening we want it to immediately open to retrieve dimensions
    // when closing we delay `present` to retrieve dimensions before closing
    const isOpen = context.open || isPresent;
    const isMountAnimationPreventedRef = React.useRef(isOpen);
    const originalStylesRef = React.useRef();
    React.useEffect(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false
        );
        return ()=>cancelAnimationFrame(rAF)
        ;
    }, []);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        const node = ref.current;
        if (node) {
            originalStylesRef.current = originalStylesRef.current || {
                transitionDuration: node.style.transitionDuration,
                animationName: node.style.animationName
            }; // block any animations/transitions so the element renders at its full dimensions
            node.style.transitionDuration = '0s';
            node.style.animationName = 'none'; // get width and height from full dimensions
            const rect = node.getBoundingClientRect();
            heightRef.current = rect.height;
            widthRef.current = rect.width; // kick off any animations/transitions that were originally set up if it isn't the initial mount
            if (!isMountAnimationPreventedRef.current) {
                node.style.transitionDuration = originalStylesRef.current.transitionDuration;
                node.style.animationName = originalStylesRef.current.animationName;
            }
            setIsPresent(present);
        }
    /**
     * depends on `context.open` because it will change to `false`
     * when a close is triggered but `present` will be `false` on
     * animation end (so when close finishes). This allows us to
     * retrieve the dimensions *before* closing.
     */ }, [
        context.open,
        present
    ]);
    return /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({
        "data-state": $409067139f391064$var$getState(context.open),
        "data-disabled": context.disabled ? '' : undefined,
        id: context.contentId,
        hidden: !isOpen
    }, contentProps, {
        ref: composedRefs,
        style: {
            [`--radix-collapsible-content-height`]: height ? `${height}px` : undefined,
            [`--radix-collapsible-content-width`]: width ? `${width}px` : undefined,
            ...props.style
        }
    }), isOpen && children);
});
/* -----------------------------------------------------------------------------------------------*/ function $409067139f391064$var$getState(open) {
    return open ? 'open' : 'closed';
}
const $409067139f391064$export$be92b6f5f03c0fe9 = $409067139f391064$export$6eb0f7ddcda6131f;
const $409067139f391064$export$41fb9f06171c75f4 = $409067139f391064$export$c135dce7b15bbbdc;
const $409067139f391064$export$7c6e2c02157bb7d2 = $409067139f391064$export$aadde00976f34151;

/* -------------------------------------------------------------------------------------------------
 * Accordion
 * -----------------------------------------------------------------------------------------------*/ const $1bf158f521e1b1b4$var$ACCORDION_NAME = 'Accordion';
const $1bf158f521e1b1b4$var$ACCORDION_KEYS = [
    'Home',
    'End',
    'ArrowDown',
    'ArrowUp'
];
const [$1bf158f521e1b1b4$var$Collection, $1bf158f521e1b1b4$var$useCollection, $1bf158f521e1b1b4$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($1bf158f521e1b1b4$var$ACCORDION_NAME);
const [$1bf158f521e1b1b4$var$createAccordionContext, $1bf158f521e1b1b4$export$9748edc328a73be1] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($1bf158f521e1b1b4$var$ACCORDION_NAME, [
    $1bf158f521e1b1b4$var$createCollectionScope,
    $409067139f391064$export$952b32dcbe73087a
]);
const $1bf158f521e1b1b4$var$useCollapsibleScope = $409067139f391064$export$952b32dcbe73087a();
const $1bf158f521e1b1b4$export$a766cd26d0d69044 = /*#__PURE__*/ React__default["default"].forwardRef((props, forwardedRef)=>{
    const { type: type , ...accordionProps } = props;
    const singleProps = accordionProps;
    const multipleProps = accordionProps;
    return /*#__PURE__*/ React__default["default"].createElement($1bf158f521e1b1b4$var$Collection.Provider, {
        scope: props.__scopeAccordion
    }, type === 'multiple' ? /*#__PURE__*/ React__default["default"].createElement($1bf158f521e1b1b4$var$AccordionImplMultiple, _extends$b({}, multipleProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ React__default["default"].createElement($1bf158f521e1b1b4$var$AccordionImplSingle, _extends$b({}, singleProps, {
        ref: forwardedRef
    })));
});
$1bf158f521e1b1b4$export$a766cd26d0d69044.propTypes = {
    type (props) {
        const value = props.value || props.defaultValue;
        if (props.type && ![
            'single',
            'multiple'
        ].includes(props.type)) return new Error('Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.');
        if (props.type === 'multiple' && typeof value === 'string') return new Error('Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.');
        if (props.type === 'single' && Array.isArray(value)) return new Error('Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.');
        return null;
    }
};
/* -----------------------------------------------------------------------------------------------*/ const [$1bf158f521e1b1b4$var$AccordionValueProvider, $1bf158f521e1b1b4$var$useAccordionValueContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME);
const [$1bf158f521e1b1b4$var$AccordionCollapsibleProvider, $1bf158f521e1b1b4$var$useAccordionCollapsibleContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME, {
    collapsible: false
});
const $1bf158f521e1b1b4$var$AccordionImplSingle = /*#__PURE__*/ React__default["default"].forwardRef((props, forwardedRef)=>{
    const { value: valueProp , defaultValue: defaultValue , onValueChange: onValueChange = ()=>{} , collapsible: collapsible = false , ...accordionSingleProps } = props;
    const [value, setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    return /*#__PURE__*/ React__default["default"].createElement($1bf158f521e1b1b4$var$AccordionValueProvider, {
        scope: props.__scopeAccordion,
        value: value ? [
            value
        ] : [],
        onItemOpen: setValue,
        onItemClose: React__default["default"].useCallback(()=>collapsible && setValue('')
        , [
            collapsible,
            setValue
        ])
    }, /*#__PURE__*/ React__default["default"].createElement($1bf158f521e1b1b4$var$AccordionCollapsibleProvider, {
        scope: props.__scopeAccordion,
        collapsible: collapsible
    }, /*#__PURE__*/ React__default["default"].createElement($1bf158f521e1b1b4$var$AccordionImpl, _extends$b({}, accordionSingleProps, {
        ref: forwardedRef
    }))));
});
/* -----------------------------------------------------------------------------------------------*/ const $1bf158f521e1b1b4$var$AccordionImplMultiple = /*#__PURE__*/ React__default["default"].forwardRef((props, forwardedRef)=>{
    const { value: valueProp , defaultValue: defaultValue , onValueChange: onValueChange = ()=>{} , ...accordionMultipleProps } = props;
    const [value1 = [], setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const handleItemOpen = React__default["default"].useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]
        )
    , [
        setValue
    ]);
    const handleItemClose = React__default["default"].useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value)=>value !== itemValue
            )
        )
    , [
        setValue
    ]);
    return /*#__PURE__*/ React__default["default"].createElement($1bf158f521e1b1b4$var$AccordionValueProvider, {
        scope: props.__scopeAccordion,
        value: value1,
        onItemOpen: handleItemOpen,
        onItemClose: handleItemClose
    }, /*#__PURE__*/ React__default["default"].createElement($1bf158f521e1b1b4$var$AccordionCollapsibleProvider, {
        scope: props.__scopeAccordion,
        collapsible: true
    }, /*#__PURE__*/ React__default["default"].createElement($1bf158f521e1b1b4$var$AccordionImpl, _extends$b({}, accordionMultipleProps, {
        ref: forwardedRef
    }))));
});
/* -----------------------------------------------------------------------------------------------*/ const [$1bf158f521e1b1b4$var$AccordionImplProvider, $1bf158f521e1b1b4$var$useAccordionContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME);
const $1bf158f521e1b1b4$var$AccordionImpl = /*#__PURE__*/ React__default["default"].forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , disabled: disabled , ...accordionProps } = props;
    const accordionRef = React__default["default"].useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(accordionRef, forwardedRef);
    const getItems = $1bf158f521e1b1b4$var$useCollection(__scopeAccordion);
    const handleKeyDown = $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event)=>{
        var _triggerCollection$cl;
        if (!$1bf158f521e1b1b4$var$ACCORDION_KEYS.includes(event.key)) return;
        const target = event.target;
        const triggerCollection = getItems().filter((item)=>{
            var _item$ref$current;
            return !((_item$ref$current = item.ref.current) !== null && _item$ref$current !== void 0 && _item$ref$current.disabled);
        });
        const triggerIndex = triggerCollection.findIndex((item)=>item.ref.current === target
        );
        const triggerCount = triggerCollection.length;
        if (triggerIndex === -1) return; // Prevents page scroll while user is navigating
        event.preventDefault();
        let nextIndex = triggerIndex;
        switch(event.key){
            case 'Home':
                nextIndex = 0;
                break;
            case 'End':
                nextIndex = triggerCount - 1;
                break;
            case 'ArrowDown':
                nextIndex = triggerIndex + 1;
                break;
            case 'ArrowUp':
                nextIndex = triggerIndex - 1;
                if (nextIndex < 0) nextIndex = triggerCount - 1;
                break;
        }
        const clampedIndex = nextIndex % triggerCount;
        (_triggerCollection$cl = triggerCollection[clampedIndex].ref.current) === null || _triggerCollection$cl === void 0 || _triggerCollection$cl.focus();
    });
    return /*#__PURE__*/ React__default["default"].createElement($1bf158f521e1b1b4$var$AccordionImplProvider, {
        scope: __scopeAccordion,
        disabled: disabled
    }, /*#__PURE__*/ React__default["default"].createElement($1bf158f521e1b1b4$var$Collection.Slot, {
        scope: __scopeAccordion
    }, /*#__PURE__*/ React__default["default"].createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({}, accordionProps, {
        ref: composedRefs,
        onKeyDown: disabled ? undefined : handleKeyDown
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * AccordionItem
 * -----------------------------------------------------------------------------------------------*/ const $1bf158f521e1b1b4$var$ITEM_NAME = 'AccordionItem';
const [$1bf158f521e1b1b4$var$AccordionItemProvider, $1bf158f521e1b1b4$var$useAccordionItemContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ITEM_NAME);
/**
 * `AccordionItem` contains all of the parts of a collapsible section inside of an `Accordion`.
 */ const $1bf158f521e1b1b4$export$d99097c13d4dac9f = /*#__PURE__*/ React__default["default"].forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , value: value , ...accordionItemProps } = props;
    const accordionContext = $1bf158f521e1b1b4$var$useAccordionContext($1bf158f521e1b1b4$var$ITEM_NAME, __scopeAccordion);
    const valueContext = $1bf158f521e1b1b4$var$useAccordionValueContext($1bf158f521e1b1b4$var$ITEM_NAME, __scopeAccordion);
    const collapsibleScope = $1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
    const triggerId = $1746a345f3d73bb7$export$f680877a34711e37();
    const open1 = value && valueContext.value.includes(value) || false;
    const disabled = accordionContext.disabled || props.disabled;
    return /*#__PURE__*/ React__default["default"].createElement($1bf158f521e1b1b4$var$AccordionItemProvider, {
        scope: __scopeAccordion,
        open: open1,
        disabled: disabled,
        triggerId: triggerId
    }, /*#__PURE__*/ React__default["default"].createElement($409067139f391064$export$be92b6f5f03c0fe9, _extends$b({
        "data-state": open1 ? 'open' : 'closed'
    }, collapsibleScope, accordionItemProps, {
        ref: forwardedRef,
        disabled: disabled,
        open: open1,
        onOpenChange: (open)=>{
            if (open) valueContext.onItemOpen(value);
            else valueContext.onItemClose(value);
        }
    })));
});
/* -------------------------------------------------------------------------------------------------
 * AccordionTrigger
 * -----------------------------------------------------------------------------------------------*/ const $1bf158f521e1b1b4$var$TRIGGER_NAME = 'AccordionTrigger';
/**
 * `AccordionTrigger` is the trigger that toggles the collapsed state of an `AccordionItem`. It
 * should always be nested inside of an `AccordionHeader`.
 */ const $1bf158f521e1b1b4$export$94e939b1f85bdd73 = /*#__PURE__*/ React__default["default"].forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , ...triggerProps } = props;
    const itemContext = $1bf158f521e1b1b4$var$useAccordionItemContext($1bf158f521e1b1b4$var$TRIGGER_NAME, __scopeAccordion);
    const collapsibleContext = $1bf158f521e1b1b4$var$useAccordionCollapsibleContext($1bf158f521e1b1b4$var$TRIGGER_NAME, __scopeAccordion);
    const collapsibleScope = $1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
    return /*#__PURE__*/ React__default["default"].createElement($1bf158f521e1b1b4$var$Collection.ItemSlot, {
        scope: __scopeAccordion
    }, /*#__PURE__*/ React__default["default"].createElement($409067139f391064$export$41fb9f06171c75f4, _extends$b({
        "aria-disabled": itemContext.open && !collapsibleContext.collapsible || undefined,
        id: itemContext.triggerId
    }, collapsibleScope, triggerProps, {
        ref: forwardedRef
    })));
});
/* -------------------------------------------------------------------------------------------------
 * AccordionContent
 * -----------------------------------------------------------------------------------------------*/ const $1bf158f521e1b1b4$var$CONTENT_NAME = 'AccordionContent';
/**
 * `AccordionContent` contains the collapsible content for an `AccordionItem`.
 */ const $1bf158f521e1b1b4$export$985b9a77379b54a0 = /*#__PURE__*/ React__default["default"].forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , ...contentProps } = props;
    const itemContext = $1bf158f521e1b1b4$var$useAccordionItemContext($1bf158f521e1b1b4$var$CONTENT_NAME, __scopeAccordion);
    const collapsibleScope = $1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
    return /*#__PURE__*/ React__default["default"].createElement($409067139f391064$export$7c6e2c02157bb7d2, _extends$b({
        role: "region",
        "aria-labelledby": itemContext.triggerId
    }, collapsibleScope, contentProps, {
        ref: forwardedRef,
        style: {
            ['--radix-accordion-content-height']: 'var(--radix-collapsible-content-height)',
            ['--radix-accordion-content-width']: 'var(--radix-collapsible-content-width)',
            ...props.style
        }
    }));
});
const $1bf158f521e1b1b4$export$be92b6f5f03c0fe9 = $1bf158f521e1b1b4$export$a766cd26d0d69044;
const $1bf158f521e1b1b4$export$6d08773d2e66f8f2 = $1bf158f521e1b1b4$export$d99097c13d4dac9f;
const $1bf158f521e1b1b4$export$41fb9f06171c75f4 = $1bf158f521e1b1b4$export$94e939b1f85bdd73;
const $1bf158f521e1b1b4$export$7c6e2c02157bb7d2 = $1bf158f521e1b1b4$export$985b9a77379b54a0;

/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function _defineProperty$2(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys$2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2$2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) {
      _defineProperty$2(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

const noop$1 = () => {};
let _WINDOW = {};
let _DOCUMENT = {};
let _MUTATION_OBSERVER = null;
let _PERFORMANCE = {
  mark: noop$1,
  measure: noop$1
};
try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}
const {
  userAgent = ''
} = _WINDOW.navigator || {};
const WINDOW = _WINDOW;
const DOCUMENT = _DOCUMENT;
const MUTATION_OBSERVER = _MUTATION_OBSERVER;
const PERFORMANCE = _PERFORMANCE;
!!WINDOW.document;
const IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
const IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var p = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/,
  g = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i;
var S = {
    classic: {
      fa: "solid",
      fas: "solid",
      "fa-solid": "solid",
      far: "regular",
      "fa-regular": "regular",
      fal: "light",
      "fa-light": "light",
      fat: "thin",
      "fa-thin": "thin",
      fab: "brands",
      "fa-brands": "brands"
    },
    duotone: {
      fa: "solid",
      fad: "solid",
      "fa-solid": "solid",
      "fa-duotone": "solid",
      fadr: "regular",
      "fa-regular": "regular",
      fadl: "light",
      "fa-light": "light",
      fadt: "thin",
      "fa-thin": "thin"
    },
    sharp: {
      fa: "solid",
      fass: "solid",
      "fa-solid": "solid",
      fasr: "regular",
      "fa-regular": "regular",
      fasl: "light",
      "fa-light": "light",
      fast: "thin",
      "fa-thin": "thin"
    },
    "sharp-duotone": {
      fa: "solid",
      fasds: "solid",
      "fa-solid": "solid",
      fasdr: "regular",
      "fa-regular": "regular",
      fasdl: "light",
      "fa-light": "light",
      fasdt: "thin",
      "fa-thin": "thin"
    }
  },
  A = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
  },
  P = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"];
var s = "classic",
  t$1 = "duotone",
  r = "sharp",
  o = "sharp-duotone",
  L = [s, t$1, r, o];
var G = {
    classic: {
      900: "fas",
      400: "far",
      normal: "far",
      300: "fal",
      100: "fat"
    },
    duotone: {
      900: "fad",
      400: "fadr",
      300: "fadl",
      100: "fadt"
    },
    sharp: {
      900: "fass",
      400: "fasr",
      300: "fasl",
      100: "fast"
    },
    "sharp-duotone": {
      900: "fasds",
      400: "fasdr",
      300: "fasdl",
      100: "fasdt"
    }
  };
var lt = {
    "Font Awesome 6 Free": {
      900: "fas",
      400: "far"
    },
    "Font Awesome 6 Pro": {
      900: "fas",
      400: "far",
      normal: "far",
      300: "fal",
      100: "fat"
    },
    "Font Awesome 6 Brands": {
      400: "fab",
      normal: "fab"
    },
    "Font Awesome 6 Duotone": {
      900: "fad",
      400: "fadr",
      normal: "fadr",
      300: "fadl",
      100: "fadt"
    },
    "Font Awesome 6 Sharp": {
      900: "fass",
      400: "fasr",
      normal: "fasr",
      300: "fasl",
      100: "fast"
    },
    "Font Awesome 6 Sharp Duotone": {
      900: "fasds",
      400: "fasdr",
      normal: "fasdr",
      300: "fasdl",
      100: "fasdt"
    }
  };
var pt = new Map([["classic", {
    defaultShortPrefixId: "fas",
    defaultStyleId: "solid",
    styleIds: ["solid", "regular", "light", "thin", "brands"],
    futureStyleIds: [],
    defaultFontWeight: 900
  }], ["sharp", {
    defaultShortPrefixId: "fass",
    defaultStyleId: "solid",
    styleIds: ["solid", "regular", "light", "thin"],
    futureStyleIds: [],
    defaultFontWeight: 900
  }], ["duotone", {
    defaultShortPrefixId: "fad",
    defaultStyleId: "solid",
    styleIds: ["solid", "regular", "light", "thin"],
    futureStyleIds: [],
    defaultFontWeight: 900
  }], ["sharp-duotone", {
    defaultShortPrefixId: "fasds",
    defaultStyleId: "solid",
    styleIds: ["solid", "regular", "light", "thin"],
    futureStyleIds: [],
    defaultFontWeight: 900
  }]]),
  xt = {
    classic: {
      solid: "fas",
      regular: "far",
      light: "fal",
      thin: "fat",
      brands: "fab"
    },
    duotone: {
      solid: "fad",
      regular: "fadr",
      light: "fadl",
      thin: "fadt"
    },
    sharp: {
      solid: "fass",
      regular: "fasr",
      light: "fasl",
      thin: "fast"
    },
    "sharp-duotone": {
      solid: "fasds",
      regular: "fasdr",
      light: "fasdl",
      thin: "fasdt"
    }
  };
var Ft = ["fak", "fa-kit", "fakd", "fa-kit-duotone"],
  St = {
    kit: {
      fak: "kit",
      "fa-kit": "kit"
    },
    "kit-duotone": {
      fakd: "kit-duotone",
      "fa-kit-duotone": "kit-duotone"
    }
  },
  At = ["kit"];
var Ct = {
  kit: {
    "fa-kit": "fak"
  },
  "kit-duotone": {
    "fa-kit-duotone": "fakd"
  }
};
var Lt = ["fak", "fakd"],
  Wt = {
    kit: {
      fak: "fa-kit"
    },
    "kit-duotone": {
      fakd: "fa-kit-duotone"
    }
  };
var Et = {
    kit: {
      kit: "fak"
    },
    "kit-duotone": {
      "kit-duotone": "fakd"
    }
  };

var t$1$1 = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
  },
  r$1 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"];
var bt$1 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"];
var Yt = {
    "Font Awesome Kit": {
      400: "fak",
      normal: "fak"
    },
    "Font Awesome Kit Duotone": {
      400: "fakd",
      normal: "fakd"
    }
  };
var ua = {
    classic: {
      "fa-brands": "fab",
      "fa-duotone": "fad",
      "fa-light": "fal",
      "fa-regular": "far",
      "fa-solid": "fas",
      "fa-thin": "fat"
    },
    duotone: {
      "fa-regular": "fadr",
      "fa-light": "fadl",
      "fa-thin": "fadt"
    },
    sharp: {
      "fa-solid": "fass",
      "fa-regular": "fasr",
      "fa-light": "fasl",
      "fa-thin": "fast"
    },
    "sharp-duotone": {
      "fa-solid": "fasds",
      "fa-regular": "fasdr",
      "fa-light": "fasdl",
      "fa-thin": "fasdt"
    }
  },
  I$1 = {
    classic: ["fas", "far", "fal", "fat", "fad"],
    duotone: ["fadr", "fadl", "fadt"],
    sharp: ["fass", "fasr", "fasl", "fast"],
    "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
  },
  ga = {
    classic: {
      fab: "fa-brands",
      fad: "fa-duotone",
      fal: "fa-light",
      far: "fa-regular",
      fas: "fa-solid",
      fat: "fa-thin"
    },
    duotone: {
      fadr: "fa-regular",
      fadl: "fa-light",
      fadt: "fa-thin"
    },
    sharp: {
      fass: "fa-solid",
      fasr: "fa-regular",
      fasl: "fa-light",
      fast: "fa-thin"
    },
    "sharp-duotone": {
      fasds: "fa-solid",
      fasdr: "fa-regular",
      fasdl: "fa-light",
      fasdt: "fa-thin"
    }
  },
  x = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"],
  Ia = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...r$1, ...x],
  m$1 = ["solid", "regular", "light", "thin", "duotone", "brands"],
  c$1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  F$1 = c$1.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]),
  ma = [...Object.keys(I$1), ...m$1, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", t$1$1.GROUP, t$1$1.SWAP_OPACITY, t$1$1.PRIMARY, t$1$1.SECONDARY].concat(c$1.map(a => "".concat(a, "x"))).concat(F$1.map(a => "w-".concat(a)));
var wa = {
    "Font Awesome 5 Free": {
      900: "fas",
      400: "far"
    },
    "Font Awesome 5 Pro": {
      900: "fas",
      400: "far",
      normal: "far",
      300: "fal"
    },
    "Font Awesome 5 Brands": {
      400: "fab",
      normal: "fab"
    },
    "Font Awesome 5 Duotone": {
      900: "fad"
    }
  };

const NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
const UNITS_IN_GRID = 16;
const DEFAULT_CSS_PREFIX = 'fa';
const DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
const DATA_FA_I2SVG = 'data-fa-i2svg';
const DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
const DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
const DATA_PREFIX = 'data-prefix';
const DATA_ICON = 'data-icon';
const HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
const MUTATION_APPROACH_ASYNC = 'async';
const TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
const PRODUCTION$1 = (() => {
  try {
    return process.env.NODE_ENV === 'production';
  } catch (e$$1) {
    return false;
  }
})();
function familyProxy(obj) {
  // Defaults to the classic family if family is not available
  return new Proxy(obj, {
    get(target, prop) {
      return prop in target ? target[prop] : target[s];
    }
  });
}
const _PREFIX_TO_STYLE = _objectSpread2$2({}, S);

// We changed FACSSClassesToStyleId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _PREFIX_TO_STYLE below, so we are manually adding
// {'fa-duotone': 'duotone'}
_PREFIX_TO_STYLE[s] = _objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, {
  'fa-duotone': 'duotone'
}), S[s]), St['kit']), St['kit-duotone']);
const PREFIX_TO_STYLE = familyProxy(_PREFIX_TO_STYLE);
const _STYLE_TO_PREFIX = _objectSpread2$2({}, xt);

// We changed FAStyleIdToShortPrefixId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _STYLE_TO_PREFIX below, so we are manually adding {duotone: 'fad'}
_STYLE_TO_PREFIX[s] = _objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, {
  duotone: 'fad'
}), _STYLE_TO_PREFIX[s]), Et['kit']), Et['kit-duotone']);
const STYLE_TO_PREFIX = familyProxy(_STYLE_TO_PREFIX);
const _PREFIX_TO_LONG_STYLE = _objectSpread2$2({}, ga);
_PREFIX_TO_LONG_STYLE[s] = _objectSpread2$2(_objectSpread2$2({}, _PREFIX_TO_LONG_STYLE[s]), Wt['kit']);
const PREFIX_TO_LONG_STYLE = familyProxy(_PREFIX_TO_LONG_STYLE);
const _LONG_STYLE_TO_PREFIX = _objectSpread2$2({}, ua);
_LONG_STYLE_TO_PREFIX[s] = _objectSpread2$2(_objectSpread2$2({}, _LONG_STYLE_TO_PREFIX[s]), Ct['kit']);
familyProxy(_LONG_STYLE_TO_PREFIX);
const ICON_SELECTION_SYNTAX_PATTERN = p; // eslint-disable-line no-useless-escape

const LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
const FONT_FAMILY_PATTERN = g;
const _FONT_WEIGHT_TO_PREFIX = _objectSpread2$2({}, G);
familyProxy(_FONT_WEIGHT_TO_PREFIX);
const ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
const DUOTONE_CLASSES = A;
const RESERVED_CLASSES = [...At, ...ma];

const initial = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');
  if (element) {
    return element.getAttribute(attr);
  }
}
function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}
if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  const attrs = [['data-family-prefix', 'familyPrefix'], ['data-css-prefix', 'cssPrefix'], ['data-family-default', 'familyDefault'], ['data-style-default', 'styleDefault'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(_ref => {
    let [attr, key] = _ref;
    const val = coerce(getAttrConfig(attr));
    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}
const _default = {
  styleDefault: 'solid',
  familyDefault: s,
  cssPrefix: DEFAULT_CSS_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};

// familyPrefix is deprecated but we must still support it if present
if (initial.familyPrefix) {
  initial.cssPrefix = initial.familyPrefix;
}
const _config = _objectSpread2$2(_objectSpread2$2({}, _default), initial);
if (!_config.autoReplaceSvg) _config.observeMutations = false;
const config = {};
Object.keys(_default).forEach(key => {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function (val) {
      _config[key] = val;
      _onChangeCb.forEach(cb => cb(config));
    },
    get: function () {
      return _config[key];
    }
  });
});

// familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty(config, 'familyPrefix', {
  enumerable: true,
  set: function (val) {
    _config.cssPrefix = val;
    _onChangeCb.forEach(cb => cb(config));
  },
  get: function () {
    return _config.cssPrefix;
  }
});
WINDOW.FontAwesomeConfig = config;
const _onChangeCb = [];
function onChange(cb) {
  _onChangeCb.push(cb);
  return () => {
    _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
  };
}

const d$2 = UNITS_IN_GRID;
const meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }
  const style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  const headChildren = DOCUMENT.head.childNodes;
  let beforeChild = null;
  for (let i = headChildren.length - 1; i > -1; i--) {
    const child = headChildren[i];
    const tagName = (child.tagName || '').toUpperCase();
    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }
  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
const idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  let size = 12;
  let id = '';
  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }
  return id;
}
function toArray(obj) {
  const array = [];
  for (let i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }
  return array;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(i => i);
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce((acc, attributeName) => {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce((acc, styleName) => {
    return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  let {
    transform,
    containerWidth,
    iconWidth
  } = _ref;
  const outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  const inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  const path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer,
    inner,
    path
  };
}
function transformForCss(_ref2) {
  let {
    transform,
    width = UNITS_IN_GRID,
    height = UNITS_IN_GRID,
    startCentered = false
  } = _ref2;
  let val = '';
  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d$2 - width / 2, "em, ").concat(transform.y / d$2 - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d$2, "em), calc(-50% + ").concat(transform.y / d$2, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d$2, "em, ").concat(transform.y / d$2, "em) ");
  }
  val += "scale(".concat(transform.size / d$2 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d$2 * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}

var baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Pro\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Pro\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-regular: normal 400 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-light: normal 300 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-thin: normal 100 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n  --fa-font-sharp-solid: normal 900 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-regular: normal 400 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-light: normal 300 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-thin: normal 100 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-regular: normal 400 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-light: normal 300 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-thin: normal 100 1em/1 \"Font Awesome 6 Sharp Duotone\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}";

function css$3() {
  const dcp = DEFAULT_CSS_PREFIX;
  const drc = DEFAULT_REPLACEMENT_CLASS;
  const fp = config.cssPrefix;
  const rc = config.replacementClass;
  let s = baseStyles;
  if (fp !== dcp || rc !== drc) {
    const dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
    const customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
    const rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }
  return s;
}
let _cssInserted = false;
function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css$3());
    _cssInserted = true;
  }
}
var InjectCSS = {
  mixout() {
    return {
      dom: {
        css: css$3,
        insertCss: ensureCss
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg() {
        ensureCss();
      }
    };
  }
};

const w$1 = WINDOW || {};
if (!w$1[NAMESPACE_IDENTIFIER]) w$1[NAMESPACE_IDENTIFIER] = {};
if (!w$1[NAMESPACE_IDENTIFIER].styles) w$1[NAMESPACE_IDENTIFIER].styles = {};
if (!w$1[NAMESPACE_IDENTIFIER].hooks) w$1[NAMESPACE_IDENTIFIER].hooks = {};
if (!w$1[NAMESPACE_IDENTIFIER].shims) w$1[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w$1[NAMESPACE_IDENTIFIER];

const functions = [];
const listener = function () {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(fn => fn());
};
let loaded = false;
if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}
function domready (fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}

function toHtml(abstractNodes) {
  const {
    tag,
    attributes = {},
    children = []
  } = abstractNodes;
  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix,
      iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */
var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */
var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
    length = keys.length,
    iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
    i,
    key,
    result;
  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }
  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }
  return result;
};

/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

function ucs2decode(string) {
  const output = [];
  let counter = 0;
  const length = string.length;
  while (counter < length) {
    const value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      const extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) {
        // eslint-disable-line eqeqeq
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
}
function toHex(unicode) {
  const decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index) {
  const size = string.length;
  let first = string.charCodeAt(index);
  let second;
  if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
    second = string.charCodeAt(index + 1);
    if (second >= 0xDC00 && second <= 0xDFFF) {
      return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
  }
  return first;
}

function normalizeIcons(icons) {
  return Object.keys(icons).reduce((acc, iconName) => {
    const icon = icons[iconName];
    const expanded = !!icon.icon;
    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }
    return acc;
  }, {});
}
function defineIcons(prefix, icons) {
  let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    skipHooks = false
  } = params;
  const normalized = normalizeIcons(icons);
  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalizeIcons(icons));
  } else {
    namespace.styles[prefix] = _objectSpread2$2(_objectSpread2$2({}, namespace.styles[prefix] || {}), normalized);
  }

  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */
  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

const {
  styles,
  shims
} = namespace;
const FAMILY_NAMES = Object.keys(PREFIX_TO_LONG_STYLE);
const PREFIXES_FOR_FAMILY = FAMILY_NAMES.reduce((acc, familyId) => {
  acc[familyId] = Object.keys(PREFIX_TO_LONG_STYLE[familyId]);
  return acc;
}, {});
let _defaultUsablePrefix = null;
let _byUnicode = {};
let _byLigature = {};
let _byOldName = {};
let _byOldUnicode = {};
let _byAlias = {};
function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}
function getIconName(cssPrefix, cls) {
  const parts = cls.split('-');
  const prefix = parts[0];
  const iconName = parts.slice(1).join('-');
  if (prefix === cssPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
const build = () => {
  const lookup = reducer => {
    return reduce(styles, (o$$1, style, prefix) => {
      o$$1[prefix] = reduce(style, reducer, {});
      return o$$1;
    }, {});
  };
  _byUnicode = lookup((acc, icon, iconName) => {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }
    if (icon[2]) {
      const aliases = icon[2].filter(a$$1 => {
        return typeof a$$1 === 'number';
      });
      aliases.forEach(alias => {
        acc[alias.toString(16)] = iconName;
      });
    }
    return acc;
  });
  _byLigature = lookup((acc, icon, iconName) => {
    acc[iconName] = iconName;
    if (icon[2]) {
      const aliases = icon[2].filter(a$$1 => {
        return typeof a$$1 === 'string';
      });
      aliases.forEach(alias => {
        acc[alias] = iconName;
      });
    }
    return acc;
  });
  _byAlias = lookup((acc, icon, iconName) => {
    const aliases = icon[2];
    acc[iconName] = iconName;
    aliases.forEach(alias => {
      acc[alias] = iconName;
    });
    return acc;
  });

  // If we have a Kit, we can't determine if regular is available since we
  // could be auto-fetching it. We'll have to assume that it is available.
  const hasRegular = 'far' in styles || config.autoFetchSvg;
  const shimLookups = reduce(shims, (acc, shim) => {
    const maybeNameMaybeUnicode = shim[0];
    let prefix = shim[1];
    const iconName = shim[2];
    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }
    if (typeof maybeNameMaybeUnicode === 'string') {
      acc.names[maybeNameMaybeUnicode] = {
        prefix,
        iconName
      };
    }
    if (typeof maybeNameMaybeUnicode === 'number') {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix,
        iconName
      };
    }
    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault, {
    family: config.familyDefault
  });
};
onChange(c$$1 => {
  _defaultUsablePrefix = getCanonicalPrefix(c$$1.styleDefault, {
    family: config.familyDefault
  });
});
build();
function byUnicode(prefix, unicode) {
  return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
  return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
  return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  const oldUnicode = _byOldUnicode[unicode];
  const newUnicode = byUnicode('fas', unicode);
  return oldUnicode || (newUnicode ? {
    prefix: 'fas',
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
const emptyCanonicalIcon = () => {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getFamilyId(values) {
  let family = s;
  const famProps = FAMILY_NAMES.reduce((acc, familyId) => {
    acc[familyId] = "".concat(config.cssPrefix, "-").concat(familyId);
    return acc;
  }, {});
  L.forEach(familyId => {
    if (values.includes(famProps[familyId]) || values.some(v$$1 => PREFIXES_FOR_FAMILY[familyId].includes(v$$1))) {
      family = familyId;
    }
  });
  return family;
}
function getCanonicalPrefix(styleOrPrefix) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    family = s
  } = params;
  const style = PREFIX_TO_STYLE[family][styleOrPrefix];

  // handles the exception of passing in only a family of 'duotone' with no style
  if (family === t$1 && !styleOrPrefix) {
    return 'fad';
  }
  const prefix = STYLE_TO_PREFIX[family][styleOrPrefix] || STYLE_TO_PREFIX[family][style];
  const defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  const result = prefix || defined || null;
  return result;
}
function moveNonFaClassesToRest(classNames) {
  let rest = [];
  let iconName = null;
  classNames.forEach(cls => {
    const result = getIconName(config.cssPrefix, cls);
    if (result) {
      iconName = result;
    } else if (cls) {
      rest.push(cls);
    }
  });
  return {
    iconName,
    rest
  };
}
function sortedUniqueValues(arr) {
  return arr.sort().filter((value, index, arr) => {
    return arr.indexOf(value) === index;
  });
}
function getCanonicalIcon(values) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    skipLookups = false
  } = params;
  let givenPrefix = null;
  const faCombinedClasses = Ia.concat(bt$1);
  const faStyleOrFamilyClasses = sortedUniqueValues(values.filter(cls => faCombinedClasses.includes(cls)));
  const nonStyleOrFamilyClasses = sortedUniqueValues(values.filter(cls => !Ia.includes(cls)));
  const faStyles = faStyleOrFamilyClasses.filter(cls => {
    givenPrefix = cls;
    return !P.includes(cls);
  });
  const [styleFromValues = null] = faStyles;
  const family = getFamilyId(faStyleOrFamilyClasses);
  const canonical = _objectSpread2$2(_objectSpread2$2({}, moveNonFaClassesToRest(nonStyleOrFamilyClasses)), {}, {
    prefix: getCanonicalPrefix(styleFromValues, {
      family
    })
  });
  return _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, canonical), getDefaultCanonicalPrefix({
    values,
    family,
    styles,
    config,
    canonical,
    givenPrefix
  })), applyShimAndAlias(skipLookups, givenPrefix, canonical));
}
function applyShimAndAlias(skipLookups, givenPrefix, canonical) {
  let {
    prefix,
    iconName
  } = canonical;
  if (skipLookups || !prefix || !iconName) {
    return {
      prefix,
      iconName
    };
  }
  const shim = givenPrefix === 'fa' ? byOldName(iconName) : {};
  const aliasIconName = byAlias(prefix, iconName);
  iconName = shim.iconName || aliasIconName || iconName;
  prefix = shim.prefix || prefix;
  if (prefix === 'far' && !styles['far'] && styles['fas'] && !config.autoFetchSvg) {
    // Allow a fallback from the regular style to solid if regular is not available
    // but only if we aren't auto-fetching SVGs
    prefix = 'fas';
  }
  return {
    prefix,
    iconName
  };
}
const newCanonicalFamilies = L.filter(familyId => {
  return familyId !== s || familyId !== t$1;
});
const newCanonicalStyles = Object.keys(ga).filter(key => key !== s).map(key => Object.keys(ga[key])).flat();
function getDefaultCanonicalPrefix(prefixOptions) {
  const {
    values,
    family,
    canonical,
    givenPrefix = '',
    styles = {},
    config: config$$1 = {}
  } = prefixOptions;
  const isDuotoneFamily = family === t$1;
  const valuesHasDuotone = values.includes('fa-duotone') || values.includes('fad');
  const defaultFamilyIsDuotone = config$$1.familyDefault === 'duotone';
  const canonicalPrefixIsDuotone = canonical.prefix === 'fad' || canonical.prefix === 'fa-duotone';
  if (!isDuotoneFamily && (valuesHasDuotone || defaultFamilyIsDuotone || canonicalPrefixIsDuotone)) {
    canonical.prefix = 'fad';
  }
  if (values.includes('fa-brands') || values.includes('fab')) {
    canonical.prefix = 'fab';
  }
  if (!canonical.prefix && newCanonicalFamilies.includes(family)) {
    const validPrefix = Object.keys(styles).find(key => newCanonicalStyles.includes(key));
    if (validPrefix || config$$1.autoFetchSvg) {
      const defaultPrefix = pt.get(family).defaultShortPrefixId;
      canonical.prefix = defaultPrefix;
      canonical.iconName = byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
  }
  if (canonical.prefix === 'fa' || givenPrefix === 'fa') {
    // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = getDefaultUsablePrefix() || 'fas';
  }
  return canonical;
}

class Library {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
      definitions[_key] = arguments[_key];
    }
    const additions = definitions.reduce(this._pullDefinitions, {});
    Object.keys(additions).forEach(key => {
      this.definitions[key] = _objectSpread2$2(_objectSpread2$2({}, this.definitions[key] || {}), additions[key]);
      defineIcons(key, additions[key]);

      // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
      const longPrefix = PREFIX_TO_LONG_STYLE[s][key];
      if (longPrefix) defineIcons(longPrefix, additions[key]);
      build();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(additions, definition) {
    const normalized = definition.prefix && definition.iconName && definition.icon ? {
      0: definition
    } : definition;
    Object.keys(normalized).map(key => {
      const {
        prefix,
        iconName,
        icon
      } = normalized[key];
      const aliases = icon[2];
      if (!additions[prefix]) additions[prefix] = {};
      if (aliases.length > 0) {
        aliases.forEach(alias => {
          if (typeof alias === 'string') {
            additions[prefix][alias] = icon;
          }
        });
      }
      additions[prefix][iconName] = icon;
    });
    return additions;
  }
}

let _plugins = [];
let _hooks = {};
const providers = {};
const defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref) {
  let {
    mixoutsTo: obj
  } = _ref;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(k => {
    if (defaultProviderKeys.indexOf(k) === -1) {
      delete providers[k];
    }
  });
  _plugins.forEach(plugin => {
    const mixout = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout).forEach(tk => {
      if (typeof mixout[tk] === 'function') {
        obj[tk] = mixout[tk];
      }
      if (typeof mixout[tk] === 'object') {
        Object.keys(mixout[tk]).forEach(sk => {
          if (!obj[tk]) {
            obj[tk] = {};
          }
          obj[tk][sk] = mixout[tk][sk];
        });
      }
    });
    if (plugin.hooks) {
      const hooks = plugin.hooks();
      Object.keys(hooks).forEach(hook => {
        if (!_hooks[hook]) {
          _hooks[hook] = [];
        }
        _hooks[hook].push(hooks[hook]);
      });
    }
    if (plugin.provides) {
      plugin.provides(providers);
    }
  });
  return obj;
}
function chainHooks(hook, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  const hookFns = _hooks[hook] || [];
  hookFns.forEach(hookFn => {
    accumulator = hookFn.apply(null, [accumulator, ...args]); // eslint-disable-line no-useless-call
  });
  return accumulator;
}
function callHooks(hook) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  const hookFns = _hooks[hook] || [];
  hookFns.forEach(hookFn => {
    hookFn.apply(null, args);
  });
  return undefined;
}
function callProvided() {
  const hook = arguments[0];
  const args = Array.prototype.slice.call(arguments, 1);
  return providers[hook] ? providers[hook].apply(null, args) : undefined;
}

function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === 'fa') {
    iconLookup.prefix = 'fas';
  }
  let {
    iconName
  } = iconLookup;
  const prefix = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName) return;
  iconName = byAlias(prefix, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
const library = new Library();
const noAuto = () => {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks('noAuto');
};
const dom = {
  i2svg: function () {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (IS_DOM) {
      callHooks('beforeI2svg', params);
      callProvided('pseudoElements2svg', params);
      return callProvided('i2svg', params);
    } else {
      return Promise.reject(new Error('Operation requires a DOM of some kind.'));
    }
  },
  watch: function () {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      autoReplaceSvgRoot
    } = params;
    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }
    config.observeMutations = true;
    domready(() => {
      autoReplace({
        autoReplaceSvgRoot
      });
      callHooks('watch', params);
    });
  }
};
const parse$3 = {
  icon: icon => {
    if (icon === null) {
      return null;
    }
    if (typeof icon === 'object' && icon.prefix && icon.iconName) {
      return {
        prefix: icon.prefix,
        iconName: byAlias(icon.prefix, icon.iconName) || icon.iconName
      };
    }
    if (Array.isArray(icon) && icon.length === 2) {
      const iconName = icon[1].indexOf('fa-') === 0 ? icon[1].slice(3) : icon[1];
      const prefix = getCanonicalPrefix(icon[0]);
      return {
        prefix,
        iconName: byAlias(prefix, iconName) || iconName
      };
    }
    if (typeof icon === 'string' && (icon.indexOf("".concat(config.cssPrefix, "-")) > -1 || icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      const canonicalIcon = getCanonicalIcon(icon.split(' '), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }
    if (typeof icon === 'string') {
      const prefix = getDefaultUsablePrefix();
      return {
        prefix,
        iconName: byAlias(prefix, icon) || icon
      };
    }
  }
};
const api = {
  noAuto,
  config,
  dom,
  parse: parse$3,
  library,
  findIconDefinition,
  toHtml
};
const autoReplace = function () {
  let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    autoReplaceSvgRoot = DOCUMENT
  } = params;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};

function domVariants(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function () {
      return val.abstract.map(a => toHtml(a));
    }
  });
  Object.defineProperty(val, 'node', {
    get: function () {
      if (!IS_DOM) return;
      const container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function asIcon (_ref) {
  let {
    children,
    main,
    mask,
    attributes,
    styles,
    transform
  } = _ref;
  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    const {
      width,
      height
    } = main;
    const offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread2$2(_objectSpread2$2({}, styles), {}, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }
  return [{
    tag: 'svg',
    attributes,
    children
  }];
}

function asSymbol (_ref) {
  let {
    prefix,
    iconName,
    children,
    attributes,
    symbol
  } = _ref;
  const id = symbol === true ? "".concat(prefix, "-").concat(config.cssPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread2$2(_objectSpread2$2({}, attributes), {}, {
        id
      }),
      children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  const {
    icons: {
      main,
      mask
    },
    prefix,
    iconName,
    transform,
    symbol,
    title,
    maskId,
    titleId,
    extra,
    watchable = false
  } = params;
  const {
    width,
    height
  } = mask.found ? mask : main;
  const isUploadedIcon = Lt.includes(prefix);
  const attrClass = [config.replacementClass, iconName ? "".concat(config.cssPrefix, "-").concat(iconName) : ''].filter(c$$1 => extra.classes.indexOf(c$$1) === -1).filter(c$$1 => c$$1 !== '' || !!c$$1).concat(extra.classes).join(' ');
  let content = {
    children: [],
    attributes: _objectSpread2$2(_objectSpread2$2({}, extra.attributes), {}, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  const uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};
  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }
  if (title) {
    content.children.push({
      tag: 'title',
      attributes: {
        id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });
    delete content.attributes.title;
  }
  const args = _objectSpread2$2(_objectSpread2$2({}, content), {}, {
    prefix,
    iconName,
    main,
    mask,
    maskId,
    transform,
    symbol,
    styles: _objectSpread2$2(_objectSpread2$2({}, uploadedIconWidthStyle), extra.styles)
  });
  const {
    children,
    attributes
  } = mask.found && main.found ? callProvided('generateAbstractMask', args) || {
    children: [],
    attributes: {}
  } : callProvided('generateAbstractIcon', args) || {
    children: [],
    attributes: {}
  };
  args.children = children;
  args.attributes = attributes;
  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  const {
    content,
    width,
    height,
    transform,
    title,
    extra,
    watchable = false
  } = params;
  const attributes = _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });
  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }
  const styles = _objectSpread2$2({}, extra.styles);
  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({
      transform,
      startCentered: true,
      width,
      height
    });
    styles['-webkit-transform'] = styles['transform'];
  }
  const styleString = joinStyles(styles);
  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }
  const val = [];
  val.push({
    tag: 'span',
    attributes,
    children: [content]
  });
  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }
  return val;
}
function makeLayersCounterAbstract(params) {
  const {
    content,
    title,
    extra
  } = params;
  const attributes = _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });
  const styleString = joinStyles(extra.styles);
  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }
  const val = [];
  val.push({
    tag: 'span',
    attributes,
    children: [content]
  });
  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }
  return val;
}

const {
  styles: styles$1
} = namespace;
function asFoundIcon(icon) {
  const width = icon[0];
  const height = icon[1];
  const [vectorData] = icon.slice(4);
  let element = null;
  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }
  return {
    found: true,
    width,
    height,
    icon: element
  };
}
const missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};
function maybeNotifyMissing(iconName, prefix) {
  if (!PRODUCTION$1 && !config.showMissingIcons && iconName) {
    console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
  }
}
function findIcon(iconName, prefix) {
  let givenPrefix = prefix;
  if (prefix === 'fa' && config.styleDefault !== null) {
    prefix = getDefaultUsablePrefix();
  }
  return new Promise((resolve, reject) => {
    if (givenPrefix === 'fa') {
      const shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix = shim.prefix || prefix;
    }
    if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
      const icon = styles$1[prefix][iconName];
      return resolve(asFoundIcon(icon));
    }
    maybeNotifyMissing(iconName, prefix);
    resolve(_objectSpread2$2(_objectSpread2$2({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided('missingIconAbstract') || {} : {}
    }));
  });
}

const noop$1$1 = () => {};
const p$2 = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1$1,
  measure: noop$1$1
};
const preamble = "FA \"6.7.2\"";
const begin = name => {
  p$2.mark("".concat(preamble, " ").concat(name, " begins"));
  return () => end(name);
};
const end = name => {
  p$2.mark("".concat(preamble, " ").concat(name, " ends"));
  p$2.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};
var perf = {
  begin,
  end
};

const noop$2 = () => {};
function isWatched(node) {
  const i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg === 'string';
}
function hasPrefixAndIcon(node) {
  const prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
  const icon = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
  return prefix && icon;
}
function hasBeenReplaced(node) {
  return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}
function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }
  const mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}
function createElementNS(tag) {
  return DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}
function createElement(tag) {
  return DOCUMENT.createElement(tag);
}
function convertSVG(abstractObj) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    ceFn = abstractObj.tag === 'svg' ? createElementNS : createElement
  } = params;
  if (typeof abstractObj === 'string') {
    return DOCUMENT.createTextNode(abstractObj);
  }
  const tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function (key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  const children = abstractObj.children || [];
  children.forEach(function (child) {
    tag.appendChild(convertSVG(child, {
      ceFn
    }));
  });
  return tag;
}
function nodeAsComment(node) {
  let comment = " ".concat(node.outerHTML, " ");
  /* BEGIN.ATTRIBUTION */
  comment = "".concat(comment, "Font Awesome fontawesome.com ");
  /* END.ATTRIBUTION */
  return comment;
}
const mutators = {
  replace: function (mutation) {
    const node = mutation[0];
    if (node.parentNode) {
      mutation[1].forEach(abstract => {
        node.parentNode.insertBefore(convertSVG(abstract), node);
      });
      if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        let comment = DOCUMENT.createComment(nodeAsComment(node));
        node.parentNode.replaceChild(comment, node);
      } else {
        node.remove();
      }
    }
  },
  nest: function (mutation) {
    const node = mutation[0];
    const abstract = mutation[1];

    // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement
    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }
    const forSvg = new RegExp("".concat(config.cssPrefix, "-.*"));
    delete abstract[0].attributes.id;
    if (abstract[0].attributes.class) {
      const splitClasses = abstract[0].attributes.class.split(' ').reduce((acc, cls) => {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }
        return acc;
      }, {
        toNode: [],
        toSvg: []
      });
      abstract[0].attributes.class = splitClasses.toSvg.join(' ');
      if (splitClasses.toNode.length === 0) {
        node.removeAttribute('class');
      } else {
        node.setAttribute('class', splitClasses.toNode.join(' '));
      }
    }
    const newInnerHTML = abstract.map(a => toHtml(a)).join('\n');
    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};
function performOperationSync(op) {
  op();
}
function perform(mutations, callback) {
  const callbackFunction = typeof callback === 'function' ? callback : noop$2;
  if (mutations.length === 0) {
    callbackFunction();
  } else {
    let frame = performOperationSync;
    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }
    frame(() => {
      const mutator = getMutator();
      const mark = perf.begin('mutate');
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
let disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
let mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }
  if (!config.observeMutations) {
    return;
  }
  const {
    treeCallback = noop$2,
    nodeCallback = noop$2,
    pseudoElementsCallback = noop$2,
    observeMutationsRoot = DOCUMENT
  } = options;
  mo = new MUTATION_OBSERVER(objects => {
    if (disabled) return;
    const defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(mutationRecord => {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }
        treeCallback(mutationRecord.target);
      }
      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }
      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class' && hasPrefixAndIcon(mutationRecord.target)) {
          const {
            prefix,
            iconName
          } = getCanonicalIcon(classArray(mutationRecord.target));
          mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
          if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}

function styleParser (node) {
  const style = node.getAttribute('style');
  let val = [];
  if (style) {
    val = style.split(';').reduce((acc, style) => {
      const styles = style.split(':');
      const prop = styles[0];
      const value = styles.slice(1);
      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }
      return acc;
    }, {});
  }
  return val;
}

function classParser (node) {
  const existingPrefix = node.getAttribute('data-prefix');
  const existingIconName = node.getAttribute('data-icon');
  const innerText = node.innerText !== undefined ? node.innerText.trim() : '';
  let val = getCanonicalIcon(classArray(node));
  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }
  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }
  if (val.iconName && val.prefix) {
    return val;
  }
  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
  }
  if (!val.iconName && config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) {
    val.iconName = node.firstChild.data;
  }
  return val;
}

function attributesParser (node) {
  const extraAttributes = toArray(node.attributes).reduce((acc, attr) => {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }
    return acc;
  }, {});
  const title = node.getAttribute('title');
  const titleId = node.getAttribute('data-fa-title-id');
  if (config.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes['aria-hidden'] = 'true';
      extraAttributes['focusable'] = 'false';
    }
  }
  return extraAttributes;
}

function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  let parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    styleParser: true
  };
  const {
    iconName,
    prefix,
    rest: extraClasses
  } = classParser(node);
  const extraAttributes = attributesParser(node);
  const pluginMeta = chainHooks('parseNodeAttributes', {}, node);
  let extraStyles = parser.styleParser ? styleParser(node) : [];
  return _objectSpread2$2({
    iconName,
    title: node.getAttribute('title'),
    titleId: node.getAttribute('data-fa-title-id'),
    prefix,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}

const {
  styles: styles$2
} = namespace;
function generateMutation(node) {
  const nodeMeta = config.autoReplaceSvg === 'nest' ? parseMeta(node, {
    styleParser: false
  }) : parseMeta(node);
  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided('generateLayersText', node, nodeMeta);
  } else {
    return callProvided('generateSvgReplacementMutation', node, nodeMeta);
  }
}
function getKnownPrefixes() {
  return [...Ft, ...Ia];
}
function onTree(root) {
  let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  const htmlClassList = DOCUMENT.documentElement.classList;
  const hclAdd = suffix => htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  const hclRemove = suffix => htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  const prefixes = config.autoFetchSvg ? getKnownPrefixes() : P.concat(Object.keys(styles$2));
  if (!prefixes.includes('fa')) {
    prefixes.push('fa');
  }
  const prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(p$$1 => ".".concat(p$$1, ":not([").concat(DATA_FA_I2SVG, "])"))).join(', ');
  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }
  let candidates = [];
  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e$$1) {
    // noop
  }
  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return Promise.resolve();
  }
  const mark = perf.begin('onTree');
  const mutations = candidates.reduce((acc, node) => {
    try {
      const mutation = generateMutation(node);
      if (mutation) {
        acc.push(mutation);
      }
    } catch (e$$1) {
      if (!PRODUCTION$1) {
        if (e$$1.name === 'MissingIcon') {
          console.error(e$$1);
        }
      }
    }
    return acc;
  }, []);
  return new Promise((resolve, reject) => {
    Promise.all(mutations).then(resolvedMutations => {
      perform(resolvedMutations, () => {
        hclAdd('active');
        hclAdd('complete');
        hclRemove('pending');
        if (typeof callback === 'function') callback();
        mark();
        resolve();
      });
    }).catch(e$$1 => {
      mark();
      reject(e$$1);
    });
  });
}
function onNode(node) {
  let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  generateMutation(node).then(mutation => {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}
function resolveIcons(next) {
  return function (maybeIconDefinition) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    let {
      mask
    } = params;
    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }
    return next(iconDefinition, _objectSpread2$2(_objectSpread2$2({}, params), {}, {
      mask
    }));
  };
}
const render = function (iconDefinition) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    transform = meaninglessTransform,
    symbol = false,
    mask = null,
    maskId = null,
    title = null,
    titleId = null,
    classes = [],
    attributes = {},
    styles = {}
  } = params;
  if (!iconDefinition) return;
  const {
    prefix,
    iconName,
    icon
  } = iconDefinition;
  return domVariants(_objectSpread2$2({
    type: 'icon'
  }, iconDefinition), () => {
    callHooks('beforeDOMElementCreation', {
      iconDefinition,
      params
    });
    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }
    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix,
      iconName,
      transform: _objectSpread2$2(_objectSpread2$2({}, meaninglessTransform), transform),
      symbol,
      title,
      maskId,
      titleId,
      extra: {
        attributes,
        styles,
        classes
      }
    });
  });
};
var ReplaceElements = {
  mixout() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides(providers$$1) {
    providers$$1.i2svg = function (params) {
      const {
        node = DOCUMENT,
        callback = () => {}
      } = params;
      return onTree(node, callback);
    };
    providers$$1.generateSvgReplacementMutation = function (node, nodeMeta) {
      const {
        iconName,
        title,
        titleId,
        prefix,
        transform,
        symbol,
        mask,
        maskId,
        extra
      } = nodeMeta;
      return new Promise((resolve, reject) => {
        Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(_ref => {
          let [main, mask] = _ref;
          resolve([node, makeInlineSvgAbstract({
            icons: {
              main,
              mask
            },
            prefix,
            iconName,
            transform,
            symbol,
            maskId,
            title,
            titleId,
            extra,
            watchable: true
          })]);
        }).catch(reject);
      });
    };
    providers$$1.generateAbstractIcon = function (_ref2) {
      let {
        children,
        attributes,
        main,
        transform,
        styles
      } = _ref2;
      const styleString = joinStyles(styles);
      if (styleString.length > 0) {
        attributes['style'] = styleString;
      }
      let nextChild;
      if (transformIsMeaningful(transform)) {
        nextChild = callProvided('generateAbstractTransformGrouping', {
          main,
          transform,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }
      children.push(nextChild || main.icon);
      return {
        children,
        attributes
      };
    };
  }
};

var Layers = {
  mixout() {
    return {
      layer(assembler) {
        let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const {
          classes = []
        } = params;
        return domVariants({
          type: 'layer'
        }, () => {
          callHooks('beforeDOMElementCreation', {
            assembler,
            params
          });
          let children = [];
          assembler(args => {
            Array.isArray(args) ? args.map(a => {
              children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: 'span',
            attributes: {
              class: ["".concat(config.cssPrefix, "-layers"), ...classes].join(' ')
            },
            children
          }];
        });
      }
    };
  }
};

var LayersCounter = {
  mixout() {
    return {
      counter(content) {
        let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const {
          title = null,
          classes = [],
          attributes = {},
          styles = {}
        } = params;
        return domVariants({
          type: 'counter',
          content
        }, () => {
          callHooks('beforeDOMElementCreation', {
            content,
            params
          });
          return makeLayersCounterAbstract({
            content: content.toString(),
            title,
            extra: {
              attributes,
              styles,
              classes: ["".concat(config.cssPrefix, "-layers-counter"), ...classes]
            }
          });
        });
      }
    };
  }
};

var LayersText = {
  mixout() {
    return {
      text(content) {
        let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const {
          transform = meaninglessTransform,
          title = null,
          classes = [],
          attributes = {},
          styles = {}
        } = params;
        return domVariants({
          type: 'text',
          content
        }, () => {
          callHooks('beforeDOMElementCreation', {
            content,
            params
          });
          return makeLayersTextAbstract({
            content,
            transform: _objectSpread2$2(_objectSpread2$2({}, meaninglessTransform), transform),
            title,
            extra: {
              attributes,
              styles,
              classes: ["".concat(config.cssPrefix, "-layers-text"), ...classes]
            }
          });
        });
      }
    };
  },
  provides(providers$$1) {
    providers$$1.generateLayersText = function (node, nodeMeta) {
      const {
        title,
        transform,
        extra
      } = nodeMeta;
      let width = null;
      let height = null;
      if (IS_IE) {
        const computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        const boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
      }
      if (config.autoA11y && !title) {
        extra.attributes['aria-hidden'] = 'true';
      }
      return Promise.resolve([node, makeLayersTextAbstract({
        content: node.innerHTML,
        width,
        height,
        transform,
        title,
        extra,
        watchable: true
      })]);
    };
  }
};

const CLEAN_CONTENT_PATTERN = new RegExp('\u{22}', 'ug');
const SECONDARY_UNICODE_RANGE = [1105920, 1112319];
const _FONT_FAMILY_WEIGHT_TO_PREFIX = _objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, {
  FontAwesome: {
    normal: 'fas',
    400: 'fas'
  }
}), lt), wa), Yt);
const FONT_FAMILY_WEIGHT_TO_PREFIX = Object.keys(_FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, key) => {
  acc[key.toLowerCase()] = _FONT_FAMILY_WEIGHT_TO_PREFIX[key];
  return acc;
}, {});
const FONT_FAMILY_WEIGHT_FALLBACK = Object.keys(FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, fontFamily) => {
  const weights = FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamily];
  acc[fontFamily] = weights[900] || [...Object.entries(weights)][0][1];
  return acc;
}, {});
function hexValueFromContent(content) {
  const cleaned = content.replace(CLEAN_CONTENT_PATTERN, '');
  const codePoint = codePointAt(cleaned, 0);
  const isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  const isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}
function getPrefix(fontFamily, fontWeight) {
  const fontFamilySanitized = fontFamily.replace(/^['"]|['"]$/g, '').toLowerCase();
  const fontWeightInteger = parseInt(fontWeight);
  const fontWeightSanitized = isNaN(fontWeightInteger) ? 'normal' : fontWeightInteger;
  return (FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamilySanitized] || {})[fontWeightSanitized] || FONT_FAMILY_WEIGHT_FALLBACK[fontFamilySanitized];
}
function replaceForPosition(node, position) {
  const pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
  return new Promise((resolve, reject) => {
    if (node.getAttribute(pendingAttribute) !== null) {
      // This node is already being processed
      return resolve();
    }
    const children = toArray(node.children);
    const alreadyProcessedPseudoElement = children.filter(c$$1 => c$$1.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position)[0];
    const styles = WINDOW.getComputedStyle(node, position);
    const fontFamily = styles.getPropertyValue('font-family');
    const fontFamilyMatch = fontFamily.match(FONT_FAMILY_PATTERN);
    const fontWeight = styles.getPropertyValue('font-weight');
    const content = styles.getPropertyValue('content');
    if (alreadyProcessedPseudoElement && !fontFamilyMatch) {
      // If we've already processed it but the current computed style does not result in a font-family,
      // that probably means that a class name that was previously present to make the icon has been
      // removed. So we now should delete the icon.
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamilyMatch && content !== 'none' && content !== '') {
      const content = styles.getPropertyValue('content');
      let prefix = getPrefix(fontFamily, fontWeight);
      const {
        value: hexValue,
        isSecondary
      } = hexValueFromContent(content);
      const isV4 = fontFamilyMatch[0].startsWith('FontAwesome');
      let iconName = byUnicode(prefix, hexValue);
      let iconIdentifier = iconName;
      if (isV4) {
        const iconName4 = byOldUnicode(hexValue);
        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix = iconName4.prefix;
        }
      }

      // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
      // already done so with the same prefix and iconName
      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node.setAttribute(pendingAttribute, iconIdentifier);
        if (alreadyProcessedPseudoElement) {
          // Delete the old one, since we're replacing it with a new one
          node.removeChild(alreadyProcessedPseudoElement);
        }
        const meta = blankMeta();
        const {
          extra
        } = meta;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
        findIcon(iconName, prefix).then(main => {
          const abstract = makeInlineSvgAbstract(_objectSpread2$2(_objectSpread2$2({}, meta), {}, {
            icons: {
              main,
              mask: emptyCanonicalIcon()
            },
            prefix,
            iconName: iconIdentifier,
            extra,
            watchable: true
          }));
          const element = DOCUMENT.createElementNS('http://www.w3.org/2000/svg', 'svg');
          if (position === '::before') {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }
          element.outerHTML = abstract.map(a$$1 => toHtml(a$$1)).join('\n');
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}
function replace$1(node) {
  return Promise.all([replaceForPosition(node, '::before'), replaceForPosition(node, '::after')]);
}
function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
function searchPseudoElements(root) {
  if (!IS_DOM) return;
  return new Promise((resolve, reject) => {
    const operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace$1);
    const end = perf.begin('searchPseudoElements');
    disableObservation();
    Promise.all(operations).then(() => {
      end();
      enableObservation();
      resolve();
    }).catch(() => {
      end();
      enableObservation();
      reject();
    });
  });
}
var PseudoElements = {
  hooks() {
    return {
      mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides(providers) {
    providers.pseudoElements2svg = function (params) {
      const {
        node = DOCUMENT
      } = params;
      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }
    };
  }
};

let _unwatched = false;
var MutationObserver$1 = {
  mixout() {
    return {
      dom: {
        unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        observe(chainHooks('mutationObserverCallbacks', {}));
      },
      noAuto() {
        disconnect();
      },
      watch(params) {
        const {
          observeMutationsRoot
        } = params;
        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks('mutationObserverCallbacks', {
            observeMutationsRoot
          }));
        }
      }
    };
  }
};

const parseTransformString = transformString => {
  let transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(' ').reduce((acc, n) => {
    const parts = n.toLowerCase().split('-');
    const first = parts[0];
    let rest = parts.slice(1).join('-');
    if (first && rest === 'h') {
      acc.flipX = true;
      return acc;
    }
    if (first && rest === 'v') {
      acc.flipY = true;
      return acc;
    }
    rest = parseFloat(rest);
    if (isNaN(rest)) {
      return acc;
    }
    switch (first) {
      case 'grow':
        acc.size = acc.size + rest;
        break;
      case 'shrink':
        acc.size = acc.size - rest;
        break;
      case 'left':
        acc.x = acc.x - rest;
        break;
      case 'right':
        acc.x = acc.x + rest;
        break;
      case 'up':
        acc.y = acc.y - rest;
        break;
      case 'down':
        acc.y = acc.y + rest;
        break;
      case 'rotate':
        acc.rotate = acc.rotate + rest;
        break;
    }
    return acc;
  }, transform);
};
var PowerTransforms = {
  mixout() {
    return {
      parse: {
        transform: transformString => {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(accumulator, node) {
        const transformString = node.getAttribute('data-fa-transform');
        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }
        return accumulator;
      }
    };
  },
  provides(providers) {
    providers.generateAbstractTransformGrouping = function (_ref) {
      let {
        main,
        transform,
        containerWidth,
        iconWidth
      } = _ref;
      const outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
      const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
      const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
      const inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      const path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      const operations = {
        outer,
        inner,
        path
      };
      return {
        tag: 'g',
        attributes: _objectSpread2$2({}, operations.outer),
        children: [{
          tag: 'g',
          attributes: _objectSpread2$2({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2$2(_objectSpread2$2({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};

const ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};
function fillBlack(abstract) {
  let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = 'black';
  }
  return abstract;
}
function deGroup(abstract) {
  if (abstract.tag === 'g') {
    return abstract.children;
  } else {
    return [abstract];
  }
}
var Masks = {
  hooks() {
    return {
      parseNodeAttributes(accumulator, node) {
        const maskData = node.getAttribute('data-fa-mask');
        const mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(' ').map(i => i.trim()));
        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }
        accumulator.mask = mask;
        accumulator.maskId = node.getAttribute('data-fa-mask-id');
        return accumulator;
      }
    };
  },
  provides(providers) {
    providers.generateAbstractMask = function (_ref) {
      let {
        children,
        attributes,
        main,
        mask,
        maskId: explicitMaskId,
        transform
      } = _ref;
      const {
        width: mainWidth,
        icon: mainPath
      } = main;
      const {
        width: maskWidth,
        icon: maskPath
      } = mask;
      const trans = transformForSvg({
        transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      const maskRect = {
        tag: 'rect',
        attributes: _objectSpread2$2(_objectSpread2$2({}, ALL_SPACE), {}, {
          fill: 'white'
        })
      };
      const maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      const maskInnerGroup = {
        tag: 'g',
        attributes: _objectSpread2$2({}, trans.inner),
        children: [fillBlack(_objectSpread2$2({
          tag: mainPath.tag,
          attributes: _objectSpread2$2(_objectSpread2$2({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      const maskOuterGroup = {
        tag: 'g',
        attributes: _objectSpread2$2({}, trans.outer),
        children: [maskInnerGroup]
      };
      const maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      const clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      const maskTag = {
        tag: 'mask',
        attributes: _objectSpread2$2(_objectSpread2$2({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: 'userSpaceOnUse',
          maskContentUnits: 'userSpaceOnUse'
        }),
        children: [maskRect, maskOuterGroup]
      };
      const defs = {
        tag: 'defs',
        children: [{
          tag: 'clipPath',
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: 'rect',
        attributes: _objectSpread2$2({
          fill: 'currentColor',
          'clip-path': "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children,
        attributes
      };
    };
  }
};

var MissingIconIndicator = {
  provides(providers) {
    let reduceMotion = false;
    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    providers.missingIconAbstract = function () {
      const gChildren = [];
      const FILL = {
        fill: 'currentColor'
      };
      const ANIMATION_BASE = {
        attributeType: 'XML',
        repeatCount: 'indefinite',
        dur: '2s'
      };

      // Ring
      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2$2(_objectSpread2$2({}, FILL), {}, {
          d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
        })
      });
      const OPACITY_ANIMATE = _objectSpread2$2(_objectSpread2$2({}, ANIMATION_BASE), {}, {
        attributeName: 'opacity'
      });
      const dot = {
        tag: 'circle',
        attributes: _objectSpread2$2(_objectSpread2$2({}, FILL), {}, {
          cx: '256',
          cy: '364',
          r: '28'
        }),
        children: []
      };
      if (!reduceMotion) {
        dot.children.push({
          tag: 'animate',
          attributes: _objectSpread2$2(_objectSpread2$2({}, ANIMATION_BASE), {}, {
            attributeName: 'r',
            values: '28;14;28;28;14;28;'
          })
        }, {
          tag: 'animate',
          attributes: _objectSpread2$2(_objectSpread2$2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;1;1;0;1;'
          })
        });
      }
      gChildren.push(dot);
      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2$2(_objectSpread2$2({}, FILL), {}, {
          opacity: '1',
          d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
        }),
        children: reduceMotion ? [] : [{
          tag: 'animate',
          attributes: _objectSpread2$2(_objectSpread2$2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;0;0;0;1;'
          })
        }]
      });
      if (!reduceMotion) {
        // Exclamation
        gChildren.push({
          tag: 'path',
          attributes: _objectSpread2$2(_objectSpread2$2({}, FILL), {}, {
            opacity: '0',
            d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
          }),
          children: [{
            tag: 'animate',
            attributes: _objectSpread2$2(_objectSpread2$2({}, OPACITY_ANIMATE), {}, {
              values: '0;0;1;1;0;0;'
            })
          }]
        });
      }
      return {
        tag: 'g',
        attributes: {
          'class': 'missing'
        },
        children: gChildren
      };
    };
  }
};

var SvgSymbols = {
  hooks() {
    return {
      parseNodeAttributes(accumulator, node) {
        const symbolData = node.getAttribute('data-fa-symbol');
        const symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
        accumulator['symbol'] = symbol;
        return accumulator;
      }
    };
  }
};

var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];

registerPlugins(plugins, {
  mixoutsTo: api
});
api.noAuto;
api.config;
api.library;
api.dom;
const parse$1$1 = api.parse;
api.findIconDefinition;
api.toHtml;
const icon = api.icon;
api.layer;
api.text;
api.counter;

var propTypes = {exports: {}};

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs$1.exports;
	hasRequiredReactIs = 1;
	(function (module) {

		if (process.env.NODE_ENV === 'production') {
		  module.exports = requireReactIs_production_min();
		} else {
		  module.exports = requireReactIs_development();
		}
} (reactIs$1));
	return reactIs$1.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$1(obj);
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}

function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// Get CSS class list from a props object
function classList(props) {
  var _classes;

  var beat = props.beat,
      fade = props.fade,
      beatFade = props.beatFade,
      bounce = props.bounce,
      shake = props.shake,
      flash = props.flash,
      spin = props.spin,
      spinPulse = props.spinPulse,
      spinReverse = props.spinReverse,
      pulse = props.pulse,
      fixedWidth = props.fixedWidth,
      inverse = props.inverse,
      border = props.border,
      listItem = props.listItem,
      flip = props.flip,
      size = props.size,
      rotation = props.rotation,
      pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-beat': beat,
    'fa-fade': fade,
    'fa-beat-fade': beatFade,
    'fa-bounce': bounce,
    'fa-shake': shake,
    'fa-flash': flash,
    'fa-spin': spin,
    'fa-spin-reverse': spinReverse,
    'fa-spin-pulse': spinPulse,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip': flip === true,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, _defineProperty$1(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty$1(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), _defineProperty$1(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty$1(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}

function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape


  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}

var _excluded$6 = ["style"];

function capitalize$1(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize$1(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert$1(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert$1(createElement, child);
  });
  /* eslint-disable dot-notation */

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties$1(extraProps, _excluded$6);

  mixins.attrs['style'] = _objectSpread2$1(_objectSpread2$1({}, mixins.attrs['style']), existingStyle);
  /* eslint-enable */

  return createElement.apply(void 0, [element.tag, _objectSpread2$1(_objectSpread2$1({}, mixins.attrs), remaining)].concat(_toConsumableArray$1(children)));
}

var PRODUCTION = false;

try {
  PRODUCTION = process.env.NODE_ENV === 'production';
} catch (e) {}

function log () {
  if (!PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function normalizeIconArgs(icon) {
  // this has everything that it needs to be rendered which means it was probably imported
  // directly from an icon svg package
  if (icon && _typeof$1(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) {
    return icon;
  }

  if (parse$1$1.icon) {
    return parse$1$1.icon(icon);
  } // if the icon is null, there's nothing to do


  if (icon === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it


  if (icon && _typeof$1(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  } // if it's an array with length of two


  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if it's a string, use it as the icon name


  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
}

// creates an object with a key of key
// and a value of value
// if certain conditions are met
function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty$1({}, key, value) : {};
}

var defaultProps$2 = {
  border: false,
  className: '',
  mask: null,
  maskId: null,
  fixedWidth: false,
  inverse: false,
  flip: false,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  spinPulse: false,
  spinReverse: false,
  beat: false,
  fade: false,
  beatFade: false,
  bounce: false,
  shake: false,
  symbol: false,
  title: '',
  titleId: null,
  transform: null,
  swapOpacity: false
};
var FontAwesomeIcon = /*#__PURE__*/React__default["default"].forwardRef(function (props, ref) {
  var allProps = _objectSpread2$1(_objectSpread2$1({}, defaultProps$2), props);

  var iconArgs = allProps.icon,
      maskArgs = allProps.mask,
      symbol = allProps.symbol,
      className = allProps.className,
      title = allProps.title,
      titleId = allProps.titleId,
      maskId = allProps.maskId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(_toConsumableArray$1(classList(allProps)), _toConsumableArray$1((className || '').split(' '))));
  var transform = objectWithKey('transform', typeof allProps.transform === 'string' ? parse$1$1.transform(allProps.transform) : allProps.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = icon(iconLookup, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, classes), transform), mask), {}, {
    symbol: symbol,
    title: title,
    titleId: titleId,
    maskId: maskId
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: ref
  };
  Object.keys(allProps).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!defaultProps$2.hasOwnProperty(key)) {
      extraProps[key] = allProps[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
});
FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  beat: propTypes.exports.bool,
  border: propTypes.exports.bool,
  beatFade: propTypes.exports.bool,
  bounce: propTypes.exports.bool,
  className: propTypes.exports.string,
  fade: propTypes.exports.bool,
  flash: propTypes.exports.bool,
  mask: propTypes.exports.oneOfType([propTypes.exports.object, propTypes.exports.array, propTypes.exports.string]),
  maskId: propTypes.exports.string,
  fixedWidth: propTypes.exports.bool,
  inverse: propTypes.exports.bool,
  flip: propTypes.exports.oneOf([true, false, 'horizontal', 'vertical', 'both']),
  icon: propTypes.exports.oneOfType([propTypes.exports.object, propTypes.exports.array, propTypes.exports.string]),
  listItem: propTypes.exports.bool,
  pull: propTypes.exports.oneOf(['right', 'left']),
  pulse: propTypes.exports.bool,
  rotation: propTypes.exports.oneOf([0, 90, 180, 270]),
  shake: propTypes.exports.bool,
  size: propTypes.exports.oneOf(['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: propTypes.exports.bool,
  spinPulse: propTypes.exports.bool,
  spinReverse: propTypes.exports.bool,
  symbol: propTypes.exports.oneOfType([propTypes.exports.bool, propTypes.exports.string]),
  title: propTypes.exports.string,
  titleId: propTypes.exports.string,
  transform: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.object]),
  swapOpacity: propTypes.exports.bool
};
var convertCurry = convert$1.bind(null, React__default["default"].createElement);

const StyledAccordionWrapper = styled__default["default"]($1bf158f521e1b1b4$export$a766cd26d0d69044) `
  display: flex;
  flex-direction: column;
  width: 100%;
  border: ${({ theme }) => `1px solid ${theme.colors.border.light}`};
  border-radius: ${({ theme }) => theme.radius.small};
  color: ${({ theme }) => theme.colors.text.main};
`;
const StyledAccordionGroupWrapper = styled__default["default"](StyledAccordionWrapper) `
  display: flex;
  flex-direction: column;
  width: 100%;
  border: ${({ theme }) => `1px solid ${theme.colors.border.light}`};
  border-radius: ${({ theme }) => theme.radius.small};
  color: ${({ theme }) => theme.colors.text.main};

  > div {
    border-bottom: ${({ theme }) => `1px solid ${theme.colors.border.light}`};

    &:hover {
      background-color: ${({ theme }) => theme.colors.background.tableRowHover};
    }
  }

  > div:first-child {
    border-radius: ${({ theme }) => theme.radius.small} ${({ theme }) => theme.radius.small} 0 0;
  }

  > div:last-child {
    border: 0;
    border-radius: 0 0 ${({ theme }) => theme.radius.small} ${({ theme }) => theme.radius.small};
  }
`;
const StyledAccordionSummary = styled__default["default"]($1bf158f521e1b1b4$export$94e939b1f85bdd73) `
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 1.2rem;
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  cursor: pointer;
  line-height: 2rem;
  background-color: ${({ theme }) => theme.colors.background.dark};
  color: ${({ theme }) => theme.colors.text.main};
  padding: 1.4rem 1.8rem;
  border-radius: ${({ theme }) => `${theme.radius.small}`};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};

  /* Add class for external styling */
  &.accordion-trigger {
    /* This allows external styles to override */
  }

  &[data-state='open'] {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};

    > svg {
      transform: rotate(180deg);
      color: ${({ theme }) => theme.colors.info.main};
    }
  }

  &:hover {
    border-radius: ${({ theme }) => `${theme.radius.small} ${theme.radius.small} 0 0`};
    background-color: ${({ theme }) => theme.colors.background.tableRowHover};
  }
`;
const StyledAccordionTrigger$1 = styled__default["default"]($1bf158f521e1b1b4$export$94e939b1f85bdd73) `
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 1.2rem;
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  cursor: pointer;
  line-height: 2rem;
  background-color: ${({ theme }) => theme.colors.background.dark};
  color: ${({ theme }) => theme.colors.text.main};
  padding: 1.4rem 1.8rem;
  border-radius: ${({ theme }) => `${theme.radius.small}`};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};

  &[data-state='open'] {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};

    > svg {
      transform: rotate(180deg);
      color: ${({ theme }) => theme.colors.info.main};
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.tableRowHover};
  }
`;
const StyledChevron = styled__default["default"](FontAwesomeIcon) `
  font-size: 1.8rem;
  line-height: 1.8rem;
  color: ${({ theme }) => theme.colors.text.light};
`;
const StyledAccordionContent$1 = styled__default["default"]($1bf158f521e1b1b4$export$985b9a77379b54a0) `
  display: flex;
  border-radius: ${({ theme }) => `0 0 ${theme.radius.small} ${theme.radius.small}`};
  background-color: ${({ theme }) => theme.colors.background.light};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: 2.1rem;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};

  /* Add class for external styling */
  &.accordion-content {
    /* This allows external styles to override */
  }

  &[data-state='open'] {
    padding: 1.6rem 3rem;
  }
`;
const StyledLeftContent = styled__default["default"].div `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
`;

const Accordion = ({ title, content, icon, className }) => (jsxRuntime.exports.jsx(StyledAccordionWrapper, { type: "single", collapsible: true, className: className, children: jsxRuntime.exports.jsxs($1bf158f521e1b1b4$export$d99097c13d4dac9f, { value: title, children: [jsxRuntime.exports.jsxs(StyledAccordionSummary, { className: "accordion-trigger", children: [jsxRuntime.exports.jsxs(StyledLeftContent, { children: [icon, title] }), jsxRuntime.exports.jsx(StyledChevron, { icon: faAngleDown$1 })] }), jsxRuntime.exports.jsx(StyledAccordionContent$1, { className: "accordion-content", children: content })] }) }));
const AccordionGroup = ({ items, className }) => (jsxRuntime.exports.jsx(StyledAccordionGroupWrapper, { type: "multiple", className: className, children: items.map((item) => (jsxRuntime.exports.jsxs($1bf158f521e1b1b4$export$d99097c13d4dac9f, { value: item.id, children: [jsxRuntime.exports.jsxs(StyledAccordionTrigger$1, { className: "accordion-trigger", children: [jsxRuntime.exports.jsx(StyledLeftContent, { children: item.title }), jsxRuntime.exports.jsx(StyledChevron, { icon: faAngleDown$1 })] }), jsxRuntime.exports.jsx(StyledAccordionContent$1, { className: "accordion-content", children: item.content })] }, item.id))) }));

var LoadingPhotoIcon = "data:image/svg+xml,%3Csvg%20width%3D%223069%22%20height%3D%221971%22%20viewBox%3D%220%200%203069%201971%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%223069%22%20height%3D%221971%22%20fill%3D%22%23B8BEC9%22%2F%3E%3Cpath%20d%3D%22M1516.5%20519C1525.34%20519%201533.81%20522.511%201540.06%20528.76C1546.31%20535.009%201549.82%20543.484%201549.82%20552.321V752.25C1549.82%20761.087%201546.31%20769.563%201540.06%20775.812C1533.81%20782.061%201525.34%20785.571%201516.5%20785.571C1507.66%20785.571%201499.19%20782.061%201492.94%20775.812C1486.69%20769.563%201483.18%20761.087%201483.18%20752.25V552.321C1483.18%20543.484%201486.69%20535.009%201492.94%20528.76C1499.19%20522.511%201507.66%20519%201516.5%20519ZM1516.5%201185.43C1525.34%201185.43%201533.81%201188.94%201540.06%201195.19C1546.31%201201.44%201549.82%201209.91%201549.82%201218.75V1418.68C1549.82%201427.52%201546.31%201435.99%201540.06%201442.24C1533.81%201448.49%201525.34%201452%201516.5%201452C1507.66%201452%201499.19%201448.49%201492.94%201442.24C1486.69%201435.99%201483.18%201427.52%201483.18%201418.68V1218.75C1483.18%201209.91%201486.69%201201.44%201492.94%201195.19C1499.19%201188.94%201507.66%201185.43%201516.5%201185.43ZM1983%20985.5C1983%20994.337%201979.49%201002.81%201973.24%201009.06C1966.99%201015.31%201958.52%201018.82%201949.68%201018.82H1749.75C1740.91%201018.82%201732.44%201015.31%201726.19%201009.06C1719.94%201002.81%201716.43%20994.337%201716.43%20985.5C1716.43%20976.663%201719.94%20968.187%201726.19%20961.938C1732.44%20955.689%201740.91%20952.179%201749.75%20952.179H1949.68C1958.52%20952.179%201966.99%20955.689%201973.24%20961.938C1979.49%20968.187%201983%20976.663%201983%20985.5ZM1316.57%20985.5C1316.57%20994.337%201313.06%201002.81%201306.81%201009.06C1300.56%201015.31%201292.09%201018.82%201283.25%201018.82H1083.32C1074.48%201018.82%201066.01%201015.31%201059.76%201009.06C1053.51%201002.81%201050%20994.337%201050%20985.5C1050%20976.663%201053.51%20968.187%201059.76%20961.938C1066.01%20955.689%201074.48%20952.179%201083.32%20952.179H1283.25C1292.09%20952.179%201300.56%20955.689%201306.81%20961.938C1313.06%20968.187%201316.57%20976.663%201316.57%20985.5ZM1186.62%20655.618C1192.87%20649.371%201201.34%20645.862%201210.18%20645.862C1219.01%20645.862%201227.49%20649.371%201233.73%20655.618L1375.22%20797.034C1381.29%20803.319%201384.65%20811.736%201384.57%20820.472C1384.49%20829.209%201380.99%20837.567%201374.81%20843.745C1368.63%20849.923%201360.28%20853.427%201351.54%20853.503C1342.8%20853.579%201334.39%20850.22%201328.1%20844.151L1186.62%20702.734C1180.37%20696.486%201176.86%20688.012%201176.86%20679.176C1176.86%20670.34%201180.37%20661.867%201186.62%20655.618ZM1657.85%201126.85C1664.1%201120.6%201672.57%201117.09%201681.41%201117.09C1690.24%201117.09%201698.72%201120.6%201704.97%201126.85L1846.38%201268.27C1852.45%201274.55%201855.81%201282.97%201855.73%201291.7C1855.66%201300.44%201852.15%201308.8%201845.98%201314.98C1839.8%201321.15%201831.44%201324.66%201822.7%201324.73C1813.97%201324.81%201805.55%201321.45%201799.27%201315.38L1657.85%201173.97C1651.6%201167.72%201648.09%201159.24%201648.09%201150.41C1648.09%201141.57%201651.6%201133.1%201657.85%201126.85ZM1846.38%20655.685C1852.61%20661.93%201856.1%20670.39%201856.1%20679.209C1856.1%20688.029%201852.61%20696.488%201846.38%20702.734L1704.97%20844.217C1698.68%20850.287%201690.26%20853.646%201681.53%20853.57C1672.79%20853.494%201664.43%20849.989%201658.26%20843.811C1652.08%20837.633%201648.57%20829.276%201648.5%20820.539C1648.42%20811.802%201651.78%20803.385%201657.85%20797.101L1799.27%20655.685C1805.51%20649.438%201813.99%20645.928%201822.82%20645.928C1831.66%20645.928%201840.13%20649.438%201846.38%20655.685ZM1375.15%201126.85C1381.4%201133.1%201384.91%201141.57%201384.91%201150.41C1384.91%201159.24%201381.4%201167.72%201375.15%201173.97L1233.73%201315.38C1227.45%201321.45%201219.03%201324.81%201210.3%201324.73C1201.56%201324.66%201193.2%201321.15%201187.02%201314.98C1180.85%201308.8%201177.34%201300.44%201177.27%201291.7C1177.19%201282.97%201180.55%201274.55%201186.62%201268.27L1328.03%201126.85C1334.28%201120.6%201342.76%201117.09%201351.59%201117.09C1360.43%201117.09%201368.9%201120.6%201375.15%201126.85Z%22%20fill%3D%22%23727C92%22%2F%3E%3C%2Fsvg%3E";

var NoPhotoIcon = "data:image/svg+xml,%3Csvg%20width%3D%223069%22%20height%3D%221971%22%20viewBox%3D%220%200%203069%201971%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%223069%22%20height%3D%221971%22%20fill%3D%22%23B8BEC9%22%2F%3E%3Cpath%20d%3D%22M1857.37%20503.003C1845.08%20502.839%201833.5%20508.773%201826.46%20518.847L1183.51%201409.07C1175.72%201419.84%201174.25%201433.95%201179.68%201446.09C1185.1%201458.23%201196.59%201466.55%201209.82%201467.92C1223.04%201469.29%201235.99%201463.5%201243.79%201452.73L1304.07%201369.28H2079.15C2088.99%201369.27%202098.43%201365.36%202105.38%201358.41C2112.34%201351.45%202116.25%201342.02%202116.25%201332.18V639.787C2116.25%20629.955%202112.34%20620.519%202105.38%20613.559C2098.43%20606.608%202089%20602.701%202079.15%20602.692H1857.77L1886.75%20562.51C1892.32%20555.154%201894.96%20545.985%201894.13%20536.793C1893.3%20527.599%201889.08%20519.043%201882.29%20512.799C1875.49%20506.547%201866.61%20503.062%201857.38%20503.01L1857.37%20503.003ZM987.232%20602.686C978.073%20603.652%20969.603%20607.973%20963.462%20614.829C957.321%20621.686%20953.949%20630.578%20954.001%20639.781V1332.18C954.001%201342.01%20957.907%201351.45%20964.868%201358.41C971.819%201365.36%20981.255%201369.27%20991.095%201369.27H1102.76C1112.68%201369.41%201122.26%201365.57%201129.32%201358.6C1136.39%201351.62%201140.38%201342.11%201140.38%201332.18C1140.38%201322.25%201136.39%201312.73%201129.32%201305.76C1122.26%201298.79%201112.68%201294.95%201102.76%201295.08H1028.18V1211.62L1275.47%201043.16L1300.2%201060.17C1311.17%201067.56%201325.26%201068.55%201337.16%201062.78C1349.07%201057%201356.99%201045.32%201357.98%201032.13C1358.96%201018.92%201352.85%201006.2%201341.93%20998.723L1296.34%20967.433C1289.08%20962.517%201280.32%20960.326%201271.6%20961.249C1265.51%20961.87%201259.68%20964%201254.6%20967.433L1028.18%201121.99V676.873H1598.49C1608.41%20677.011%201617.99%20673.164%201625.06%20666.196C1632.13%20659.227%201636.11%20649.705%201636.11%20639.778C1636.11%20629.851%201632.13%20620.338%201625.06%20613.361C1617.98%20606.392%201608.41%20602.546%201598.49%20602.684H991.091C989.797%20602.623%20988.512%20602.623%20987.227%20602.684L987.232%20602.686ZM1804.05%20676.876H2042.06V1039.68L1843.45%20870.833C1835.82%20864.425%201825.93%20861.363%201816.02%20862.329C1808.49%20863.011%201801.34%20865.977%201795.54%20870.833L1508.07%201112.33L1495.7%201103.83L1804.05%20676.876ZM1287.84%20713.971C1233.65%20713.971%201188.92%20758.698%201188.92%20812.887C1188.92%20867.075%201233.65%20911.794%201287.84%20911.794C1342.03%20911.794%201386.75%20867.075%201386.75%20812.887C1386.75%20758.698%201342.03%20713.971%201287.84%20713.971ZM1287.84%20788.152C1301.93%20788.152%201312.56%20798.786%201312.56%20812.887C1312.56%20826.98%201301.93%20837.613%201287.84%20837.613C1273.75%20837.613%201263.11%20826.979%201263.11%20812.887C1263.11%20798.786%201273.75%20788.152%201287.84%20788.152ZM1819.5%20947.732L2042.06%201137.06V1295.09H1357.76L1452.43%201164.11L1489.52%201189.61C1496.21%201194.17%201504.23%201196.42%201512.32%201195.99C1520.41%201195.58%201528.14%201192.52%201534.33%201187.29L1819.5%20947.732Z%22%20fill%3D%22%23727C92%22%2F%3E%3C%2Fsvg%3E";

const Image = ({ alt, src, loadSrc = LoadingPhotoIcon, errorSrc = NoPhotoIcon, title, showLoadingImage = true, ...nativeImageProps }) => {
    const [isLoad, setIsLoad] = React.useState(false);
    const [hasError, setHasError] = React.useState(false);
    const imageSrc = showLoadingImage ? (isLoad ? src : loadSrc) : src;
    const finalSrc = hasError ? errorSrc : imageSrc;
    const isNotPhoto = !finalSrc || finalSrc === errorSrc;
    const credit = isNotPhoto ? 'Credit: icon broken image by scarlett mckay from  from thenounproject.com' : 'TryHackMe';
    const titleText = title ?? credit;
    const shouldHide = !showLoadingImage && !isLoad && !hasError;
    return (jsxRuntime.exports.jsx("img", { src: finalSrc || errorSrc, alt: alt, onLoad: () => setIsLoad(true), onError: () => setHasError(true), title: titleText, style: {
            ...(nativeImageProps.style || {}),
            ...(shouldHide ? { opacity: 0, visibility: 'hidden' } : {}),
        }, ...nativeImageProps }));
};

const StyledAvatar$2 = styled__default["default"].div `
  border-radius: ${({ theme, isSquare }) => (isSquare ? theme.radius.small : '100%')};
  ${({ hasBorder, theme, borderColor, borderWidth }) => hasBorder && `border: solid ${borderWidth ?? '0.3rem'} ${borderColor ?? theme.colors.grey[900]}`};
  cursor: ${({ isCursorPointer }) => (isCursorPointer ? 'pointer' : 'default')};
  display: flex;
  height: ${({ size = '5.6rem' }) => size};
  transition: all 250ms ease-in-out;
  overflow: hidden;
  position: relative;
  width: ${({ size = '5.6rem' }) => size};
  flex-shrink: 0;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: ${({ mobileSize = '5.2rem' }) => mobileSize};
    height: ${({ mobileSize = '5.2rem' }) => mobileSize};
  }

  ${({ hasHover, theme }) => hasHover &&
    `&:hover {
    border-color: ${theme.colors.primary.main};
  }`}

  img {
    background-color: ${({ theme, hasBackground = true }) => (hasBackground ? theme.colors.secondary.dark : 'transparent')};
    border-radius: ${({ isSquare }) => (isSquare ? 0 : '100%')};
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;
const StyledAvatarButtonWrapper = styled__default["default"].button `
  &:focus {
    outline: 0;
    ${StyledAvatar$2} {
      border-color: ${({ theme }) => theme.colors.primary.main};
    }
  }
`;

const Avatar = ({ avatarSrc, size = '5.6rem', mobileSize, hasBorder = true, isCursorPointer = true, borderColor, borderWidth, isSquare = false, hasHover = true, hasBackground = true, title, href = '', target = '_blank', showLoadingImage = true, }) => {
    const rel = target === '_blank' ? 'noopener' : undefined;
    return (jsxRuntime.exports.jsx(StyledAvatar$2, { hasBorder: hasBorder, size: size, mobileSize: mobileSize, isCursorPointer: isCursorPointer, borderColor: borderColor, borderWidth: borderWidth, isSquare: isSquare, hasHover: hasHover, hasBackground: hasBackground, "data-testid": "avatar", children: href ? (jsxRuntime.exports.jsx("a", { href: href, target: target, ...(rel ? { rel } : {}), children: jsxRuntime.exports.jsx(Image, { src: avatarSrc, alt: "User avatar", width: size, height: size, "aria-label": "User avatar", loading: "lazy", title: title, showLoadingImage: showLoadingImage }) })) : (jsxRuntime.exports.jsx(Image, { src: avatarSrc, alt: "User avatar", width: size, height: size, "aria-label": "User avatar", loading: "lazy", title: title, showLoadingImage: showLoadingImage })) }));
};

const StyledSpinner$1 = styled__default["default"].span `
  border: 2px solid;
  border-color: ${({ color }) => color};
  border-radius: 50%;
  border-top-color: transparent;
  display: inline-block;
  width: ${({ size = '1.4rem' }) => size};
  height: ${({ size = '1.4rem' }) => size};
  animation: loading 1s linear infinite;

  @keyframes loading {
    to {
      transform: rotate(1turn);
    }
  }
`;

const determineTextButtonColor = (color, theme) => {
    switch (color) {
        case 'primary': {
            return theme.colors.text.button;
        }
        case 'secondary': {
            return theme.colors.text.main;
        }
        case 'info': {
            return theme.colors.info.main;
        }
        case 'error': {
            return theme.colors.error.main;
        }
        case 'hint': {
            return theme.colors.warning.main;
        }
        default: {
            return theme.colors.text.button;
        }
    }
};

const getButtonSolidColors = {
    primary: styled.css `
    ${({ theme, isDarkVersion, onDarkBg }) => `
       background-color: ${theme.colors.primary.main};
       color: ${theme.colors.black};
       border-color: ${theme.colors.primary.main};
       
      &:hover:not(:disabled) {
         background-color: ${theme.colors.primary.lighter};
         color: ${onDarkBg || isDarkVersion ? theme.colors.white : theme.colors.text.main};
       }
    `}
  `,
    secondary: styled.css `
    ${({ theme }) => `
    background-color: ${theme.colors.button.secondary.border};
    border-color: ${theme.colors.button.secondary.border};
    color: ${theme.colors.text.main};
    &:hover:not(:disabled) {
      background-color: ${theme.colors.button.secondary.hover};
      color: ${theme.colors.black};
    }
  `}
  `,
    secondaryDark: styled.css `
   ${({ theme }) => `
   background-color: ${theme.colors.background.secondaryDark};
   border-color: ${theme.colors.button.secondary.border};
   color: ${theme.colors.text.main};
   &:hover:not(:disabled) {
     background-color: ${theme.colors.button.secondary.hover};
     color: ${theme.colors.black};
   }
 `}
 `,
    info: styled.css `
    ${({ theme }) => `
      background-color: ${theme.colors.info.light};
      color: ${theme.colors.text.main};
      border-color: ${theme.colors.info.light};
      &:hover:not(:disabled) {
        background-color: ${theme.colors.info.light};
      }
    `}
  `,
    error: styled.css `
    ${({ theme }) => `
      background-color: ${theme.colors.error.main};
      border-color: ${theme.colors.error.main};
      color: ${theme.colors.button.error.text};
      &:hover:not(:disabled) {
        background-color: ${theme.colors.button.error.hover};
        border-color: ${theme.colors.button.error.hover};
        color: ${theme.colors.button.error.text};
      }
    `}
  `,
    hint: styled.css `
    ${({ theme }) => `
       background-color: ${theme.colors.warning.main};
       color: ${theme.colors.black};
       border-color: ${theme.colors.warning.main};
       &:hover:not(:disabled) {
         background-color: ${theme.colors.warning.secondary};
         color: ${theme.colors.text.main};
       }
    `}
  `,
    add: styled.css `
    ${({ theme }) => `
       background-color: ${theme.colors.addButton.background};
       color: ${theme.colors.addButton.color};
       border-color: ${theme.colors.addButton.border};
       &:hover:not(:disabled) {
         background-color: ${theme.colors.addButton.hover};
         color: ${theme.colors.addButton.textHover};
       }
    `}
  `,
};
const getButtonOutlinedColors = {
    primary: styled.css `
    ${({ theme }) => `
      background-color: transparent;
      color: ${theme.colors.text.main};
      border-color: ${theme.colors.primary.main};
      &:hover:not(:disabled) {
        background-color: ${theme.colors.primary.main};
        color: ${theme.colors.black};
      }
    `}
  `,
    secondary: styled.css `
    ${({ theme }) => `
      background-color: transparent;
      border-color: ${theme.colors.button.secondary.border};
      color: ${theme.colors.text.main};
      &:hover:not(:disabled) {
        background-color: ${theme.colors.button.secondary.hover};
        color: ${theme.colors.black};
      }
  `}
  `,
    info: styled.css `
    ${({ theme }) => `
       background-color: transparent;
       color: ${theme.colors.text.main};
       border-color: ${theme.colors.info.light};
       &:hover:not(:disabled) {
         background-color: ${theme.colors.info.light};
       }
    `}
  `,
    error: styled.css `
    ${({ theme }) => `
       background-color: transparent;
       border-color: ${theme.colors.error.main};
       color: ${theme.colors.text.main};
       &:hover:not(:disabled) {
         background-color: ${theme.colors.button.error.hover};
         border-color: ${theme.colors.button.error.hover};
         color: ${theme.colors.button.error.text};
       }
    `}
  `,
    hint: styled.css `
    ${({ theme }) => `
    background-color: transparent;
    color: ${theme.colors.text.main};
    border-color: ${theme.colors.warning.main};
    &:hover:not(:disabled) {
      background-color: ${theme.colors.warning.secondary};
      color: ${theme.colors.text.main};
    }
  `}
  `,
    add: styled.css `
    ${({ theme }) => `
       background-color: transparent;
       color: ${theme.colors.text.light};
       border-color: ${theme.colors.info.main};
       &:hover:not(:disabled) {
         background-color: ${theme.colors.info.main};
         color: ${theme.colors.text.invert};
       }
    `}
  `,
};
const StyledButton$3 = styled__default["default"].button `
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.radius.small};
  color: ${({ theme }) => theme.colors.black};
  display: ${({ hidden }) => (hidden ? 'none' : 'inline-flex')};
  max-width: 100%;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  gap: 0.6rem;
  height: 3.6rem;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  padding: 0.9rem 1.6rem;
  pointer-events: initial;
  border-width: 0.1rem;
  border-style: solid;

  & > div {
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }

  svg {
    height: 1.2rem;
    margin: 0 0.1rem;
    width: 1.2rem;
  }


  &:disabled {
    background-color: ${({ theme }) => theme.colors.grey[400]};
    border-color: ${({ theme }) => theme.colors.grey[400]};
    color: ${({ theme }) => theme.colors.grey[600]};
    cursor: not-allowed;

    svg {
      color: ${({ theme }) => theme.colors.grey[600]};
    }
  }
  
  ${({ size, theme }) => {
    if (size === 'large') {
        return `
        font-size: 2.4rem;
        height: 4.8rem;
        padding: 1rem 3.6rem;

        svg {
          height: 2rem;
          width: 2rem;
        }
      `;
    }
    if (size === 'small') {
        return `
        font-size: ${theme.fonts.sizes.small};
        height: 2.8rem;
        padding: 0.6rem 1rem;

        svg {
          width: 1rem;
          height: 1rem;
        }
      `;
    }
    return '';
}}

  ${({ theme, color, variant }) => {
    if (variant === 'solid') {
        return getButtonSolidColors[color];
    }
    if (variant === 'outlined') {
        return getButtonOutlinedColors[color];
    }
    if (variant === 'text') {
        return styled.css `
        background-color: transparent;
        border: none;
        color: ${() => determineTextButtonColor(color, theme)};
        padding: 0;
        height: auto;

        &:disabled {
          background-color: transparent;
        }

        &:hover:not(:disabled) {
          text-decoration: underline;
        }
      `;
    }
    return '';
}}
`;

const Button$1 = React__default["default"].forwardRef(({ variant = 'solid', size = 'default', color = 'primary', children, isDisabled, type = 'button', isLoading, loadingMsg = 'Loading...', isDarkVersion, onDarkBg = false, ...nativeButtonAttributes }, ref) => {
    const themeContext = styled.useTheme();
    let spinnerColor = themeContext.colors.black || themeContext.colors.secondary.main;
    if (variant === 'text') {
        spinnerColor = determineTextButtonColor(color, themeContext);
    }
    if (variant === 'outlined') {
        spinnerColor = themeContext.colors.text.main;
    }
    return (jsxRuntime.exports.jsx(StyledButton$3, { ref: ref, color: color, variant: variant, size: size, type: type, disabled: isDisabled, isLoading: isLoading, isDarkVersion: isDarkVersion, onDarkBg: onDarkBg, role: "button", ...nativeButtonAttributes, children: isLoading ? (jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx(StyledSpinner$1, { "data-testid": "spinner", color: spinnerColor }), loadingMsg] })) : (children) }));
});
Button$1.displayName = 'Button';

const StyledCard$1 = styled__default["default"].div `
  width: 100%;
  height: fit-content;
  background: ${({ theme }) => theme.colors.background.main};
  border-radius: ${({ theme }) => `${theme.radius.small}`};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  padding: ${({ padding }) => padding ?? '3.2rem'};
`;

const Card = ({ children, padding }) => (jsxRuntime.exports.jsx(StyledCard$1, { padding: padding, children: children }));

const StyledCardOverlay = styled__default["default"].div `
  align-items: center;
  background-color: rgba(0, 0, 0, 0.65);
  border-radius: ${({ theme }) => theme.radius.small};
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  width: 100%;
  z-index: 1;
  backdrop-filter: blur(1px);
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
`;
const StyledCardActionButton = styled__default["default"](Button$1) `
  color: ${({ variant, theme }) => (variant === 'outlined' ? theme.colors.white : '')};
  width: ${({ $width }) => $width ?? '13.2rem'};

  :hover:not(:disabled) {
    color: ${({ variant, theme }) => (variant === 'solid' ? theme.colors.white : '')};
  }
`;

const CardOverlay = ({ onFirstBtnClick, onSecondBtnClick, firstBtnText, secondBtnText, isVisible, btnsWidth, }) => (jsxRuntime.exports.jsxs(StyledCardOverlay, { "$isVisible": isVisible, children: [jsxRuntime.exports.jsx(StyledCardActionButton, { variant: "solid", "$width": btnsWidth, onClick: onFirstBtnClick, children: firstBtnText }), secondBtnText && (jsxRuntime.exports.jsx(StyledCardActionButton, { "$width": btnsWidth, variant: "outlined", onClick: onSecondBtnClick, children: secondBtnText }))] }));

const StyledCircularLink = styled__default["default"](reactRouterDom.Link) `
  border-radius: 100%;
  height: ${({ $sizes }) => $sizes ?? '4.1rem'};
  width: ${({ $sizes }) => $sizes ?? '4.1rem'};
  background-color: ${({ theme }) => theme.colors.primary.main};
  border: 1px solid ${({ theme }) => theme.colors.primary.main};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: ${({ theme }) => theme.colors.secondary.main};
    font-size: 2.1rem;
  }

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.primary.lighter};
    svg {
      color: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? theme.colors.white : theme.colors.text.main)};
    }
  }
`;

const StyledCircularProgress$1 = styled__default["default"].svg `
  transform: rotate(-90deg);
  shape-rendering: geometricPrecision;
  position: relative;
`;
const StyledCircleBackground$1 = styled__default["default"].circle `
  fill: none;
  stroke: ${({ theme, $strokeBackgroundColor }) => $strokeBackgroundColor || theme.colors.grey[400]};
  stroke-width: strokeWidth;
`;
const StyledCircleProgress$1 = styled__default["default"].circle `
  fill: none;
  stroke: ${({ $strokeColor }) => $strokeColor || lightColors.info.main};
  stroke-width: strokeProgressWidth;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.5s linear;
`;
const StyledProgressText = styled__default["default"].div `
  color: ${({ $isDarkVersion, theme, $textColor }) => {
    if ($textColor) {
        return $textColor;
    }
    if ($isDarkVersion) {
        return theme.colors.grey[200];
    }
    return theme.colors.text.lighter;
}};
  position: absolute;
  z-index: 1;
  line-height: 0;
  top: 48%;
  right: 50%;
  transform: translate(50%, 50%);
  font-size: ${({ $fontSize }) => $fontSize || '1rem'};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ $fontWeight = '400' }) => $fontWeight};
`;
const StyledCircularProgressWrapper$1 = styled__default["default"].div `
  position: relative;
  display: inline-block;
`;

const CircularProgress = ({ isDarkVersion = false, progressValue, size = 34, strokeWidth = 2, fontSize = '1rem', strokeColor, strokeBackgroundColor, textColor, customStrokeProgressWidth, fontWeight, children, }) => {
    const radius = size / 2 - strokeWidth;
    const circumference = 2 * Math.PI * radius;
    const offset = ((100 - progressValue) / 100) * circumference;
    const strokeProgressWidth = customStrokeProgressWidth || strokeWidth * 2;
    return (jsxRuntime.exports.jsxs(StyledCircularProgressWrapper$1, { "data-testid": "circular-progress", children: [jsxRuntime.exports.jsxs(StyledCircularProgress$1, { width: size, viewBox: `0 0 ${size} ${size}`, "shape-rendering": "geometricPrecision", children: [jsxRuntime.exports.jsx(StyledCircleBackground$1, { cx: size / 2, cy: size / 2, r: radius, strokeWidth: strokeWidth, "shape-rendering": "geometricPrecision", "$strokeBackgroundColor": strokeBackgroundColor }), jsxRuntime.exports.jsx(StyledCircleProgress$1, { cx: size / 2, cy: size / 2, r: radius, strokeWidth: strokeProgressWidth, strokeDasharray: circumference, strokeDashoffset: offset, "shape-rendering": "geometricPrecision", "$strokeColor": strokeColor })] }), jsxRuntime.exports.jsx(StyledProgressText, { "$fontSize": fontSize, "$isDarkVersion": isDarkVersion, "$textColor": textColor, "$fontWeight": fontWeight, children: jsxRuntime.exports.jsx("span", { children: children || `${progressValue}%` }) })] }));
};

const getIconButtonHoverColors = {
    edit: styled.css `
    ${({ theme }) => `color: ${theme.colors.text.main};`}
  `,
    add: styled.css `
    ${({ theme }) => `color: ${theme.colors.info.main};`}
  `,
    delete: styled.css `
    ${({ theme }) => `color: ${theme.colors.error.main}`}
  `,
    copy: styled.css `
    ${({ theme }) => `color: ${theme.colors.grey[600]}`}
  `,
    navigate: styled.css `
    ${({ theme }) => `color: ${theme.colors.grey[600]}`}
  `,
    'navigate-round': styled.css `
    ${({ theme }) => `color: ${theme.colors.grey[600]}`}
  `,
};
const StyledIconButton = styled__default["default"].button `
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme, variant }) => (variant === 'navigate-round' ? '100px' : theme.radius.small)};
  display: ${({ hidden }) => (hidden ? 'none' : 'inline-flex')};
  max-width: 100%;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  pointer-events: initial;
  border-width: 0.1rem;
  border-style: solid;
  width: ${({ width }) => width || '2.4rem'};
  height: ${({ height }) => height || '2.4rem'};
  min-width: ${({ width, variant }) => (variant === 'copy' ? width || '2.4rem' : 'unset')};
  min-height: ${({ height, variant }) => (variant === 'copy' ? height || '2.4rem' : 'unset')};
  background-color: transparent;
  border-color: transparent;
  color: ${({ theme }) => theme.colors.text.lighter};
  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.border.light};
    background-color: ${({ theme }) => theme.colors.white};
    ${({ variant }) => getIconButtonHoverColors[variant]}
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.grey[400]};
    border-color: ${({ theme }) => theme.colors.grey[400]};
    color: ${({ theme }) => theme.colors.grey[600]};
    cursor: not-allowed;
  }
  svg {
    ${({ variant }) => (variant === 'navigate-round' ? 'height: 1.9rem;' : '')};
  }
`;

const IconButton = React__default["default"].forwardRef(({ variant, width, height, children, isDisabled, type = 'button', ...nativeButtonAttributes }, ref) => (jsxRuntime.exports.jsx(StyledIconButton, { ref: ref, variant: variant, width: width, height: height, type: type, disabled: isDisabled, role: "button", ...nativeButtonAttributes, children: children })));
IconButton.displayName = 'IconButton';

const StyledCardCommon = styled.css `
  background: ${({ theme }) => theme.colors.background.light};
  border-radius: ${({ theme }) => theme.radius.medium};
  height: auto;
  border: ${({ theme }) => `1px solid ${theme.colors.border.main}`};
`;
const StyledCardBoxShadowCommon = styled.css `
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  cursor: pointer;
  transition: box-shadow 0.3s ease-in-out;

  &:hover {
    box-shadow: ${({ theme }) => theme.colors.boxShadow.hover};
  }
`;
const StyledBox = styled__default["default"].div `
  ${StyledCardCommon};
  width: max-content;
`;
const StyledBoxShadowedBox = styled__default["default"](StyledBox) `
  ${StyledCardCommon};
  border: none;
  box-shadow: ${({ theme }) => theme.boxShadow.light} 
`;

const StyledArrowTop = styled.css `
  border-top-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  bottom: 100%;
`;
const StyledArrowBottom = styled.css `
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  top: 100%;
`;
const StyledArrowSides = styled.css `
  border-top-color: transparent;
  border-bottom-color: transparent;
  top: 49%;
  transform: translateY(-50%);
`;
const StyledTooltip = styled__default["default"](StyledBoxShadowedBox) `
  display: inline-block;
  max-width: ${({ tooltipMaxWidth }) => tooltipMaxWidth || 40}rem;
  position: relative;
  width: ${({ tooltipTitle }) => (tooltipTitle ? '31.2rem' : 'inherit')};
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  background: ${({ theme }) => theme.colors.background.tertiary};
  color: ${({ theme }) => theme.colors.text.main};

  &::before {
    border-color: ${({ theme }) => theme.colors.background.tertiary};
    border-width: 0.8rem;
    border-style: solid;
    content: '';
    height: 0;
    position: absolute;
    width: 0;

    ${({ arrowPosition, tooltipTitle, theme }) => {
    switch (arrowPosition) {
        case 'top-center': {
            return `
            ${StyledArrowTop.toString()};
            left: 51%;
            transform: translateX(-50%);
            border-bottom-color: ${tooltipTitle ? theme.colors.background.tooltipTitleBackground : theme.colors.background.tertiary}
          `;
        }
        case 'top-right': {
            return `
            ${StyledArrowTop.toString()};
            right: 2rem;
            border-bottom-color: ${tooltipTitle ? theme.colors.background.tooltipTitleBackground : theme.colors.background.tertiary}
          `;
        }
        case 'top-left': {
            return `
            ${StyledArrowTop.toString()};
            left: 2rem;
            border-bottom-color: ${tooltipTitle ? theme.colors.background.tooltipTitleBackground : theme.colors.background.tertiary}
          `;
        }
        case 'bottom-center': {
            return `
            ${StyledArrowBottom.toString()};
            left: 51%;
            transform: translateX(-50%);
        `;
        }
        case 'bottom-right': {
            return `
          ${StyledArrowBottom.toString()};
            right: 2rem;
            
          `;
        }
        case 'bottom-left': {
            return `
            ${StyledArrowBottom.toString()};
            left: 2rem;
          `;
        }
        case 'left': {
            return `
            ${StyledArrowSides.toString()};
            border-left-color: transparent;
            right: 100%;
          `;
        }
        case 'right': {
            return `
            ${StyledArrowSides.toString()};
            border-right-color: transparent;
            left: 100%;
          `;
        }
        case 'no-arrow': {
            return '';
        }
        default: {
            return `
            ${StyledArrowTop.toString()};
            left: 51%;
            transform: translateX(-50%);
            border-bottom-color: ${tooltipTitle ? theme.colors.background.tooltipTitleBackground : theme.colors.background.tertiary}
          `;
        }
    }
}};
  }
`;
const StyledTooltipTitle = styled__default["default"].div `
  border-radius: 0.5rem 0.5rem 0 0;
  padding: 1.2rem;
  padding-bottom: 1rem;
  background: ${({ theme }) => theme.colors.background.tooltipTitleBackground};
`;
const StyledBodyContainer = styled__default["default"].div `
  padding: 1.2rem;
`;

const Tooltip = ({ children, tooltipTitle, arrowPosition = 'top-center', tooltipMaxWidth }) => (jsxRuntime.exports.jsxs(StyledTooltip, { arrowPosition: arrowPosition, tooltipTitle: tooltipTitle, role: "tooltip", tooltipMaxWidth: tooltipMaxWidth, children: [tooltipTitle ? (jsxRuntime.exports.jsx(StyledTooltipTitle, { children: jsxRuntime.exports.jsx("p", { children: tooltipTitle }) })) : null, jsxRuntime.exports.jsx(StyledBodyContainer, { children: children })] }));

const StyledDescriptionListItemContainer = styled__default["default"].div `
  padding: 1.6rem 0 1.5rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  display: flex;
  flex-direction: column;
`;
const StyledContent$9 = styled__default["default"].div `
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0.2rem 0;
  gap: 0.2rem;
  min-height: 3.2rem;
`;
const StyledContentLeft = styled__default["default"].div `
  display: flex;
  align-items: flex-end;
  gap: 0.3rem;
`;
const StyledLabel = styled__default["default"].p `
  font-size: 1.6rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.paragraph};
`;
const StyledValue = styled__default["default"].div `
  font-size: 1.6rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.text.main};
  line-break: anywhere;
`;
const StyledTooltipWrapper$4 = styled__default["default"].div `
  display: flex;
  position: relative;

  & > div {
    position: absolute;
    top: -3rem;
    left: 1rem;
  }
`;
const StyledTooltipContent$2 = styled__default["default"].div `
  display: flex;
  gap: 0.3rem;
  align-items: center;
  min-width: 2.8rem;
`;
const StyledIconButtonWrapper = styled__default["default"].div `
  width: 2.8rem;
  height: 2.8rem;
`;

const DescriptionListItem = ({ label, value, hasCopyButton, buttonChildren, buttonOnClick, buttonSize = 'small', buttonVariant, buttonColor, buttonIsDisabled, }) => {
    const [tooltipVisible, setTooltipVisible] = React.useState(false);
    React.useEffect(() => {
        if (tooltipVisible) {
            setTimeout(() => {
                setTooltipVisible(false);
            }, 1600);
        }
    }, [tooltipVisible]);
    return (jsxRuntime.exports.jsxs(StyledDescriptionListItemContainer, { children: [jsxRuntime.exports.jsx(StyledLabel, { children: label }), jsxRuntime.exports.jsxs(StyledContent$9, { children: [jsxRuntime.exports.jsxs(StyledContentLeft, { children: [jsxRuntime.exports.jsx(StyledValue, { children: value }), hasCopyButton && typeof value === 'string' && (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(StyledIconButtonWrapper, { children: jsxRuntime.exports.jsx(IconButton, { "data-testid": "copy-icon", onClick: async () => {
                                                setTooltipVisible(true);
                                                await navigator.clipboard.writeText(value);
                                            }, variant: "copy", width: "2.8rem", height: "2.8rem", "aria-label": "copy", children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCopy$1 }) }) }), tooltipVisible && (jsxRuntime.exports.jsx(StyledTooltipWrapper$4, { children: jsxRuntime.exports.jsx(Tooltip, { arrowPosition: "left", children: jsxRuntime.exports.jsxs(StyledTooltipContent$2, { children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCheck$1 }), "Copied"] }) }) }))] }))] }), buttonChildren && (jsxRuntime.exports.jsx(Button$1, { size: buttonSize, onClick: buttonOnClick, "data-testid": "button", variant: buttonVariant, color: buttonColor, isDisabled: buttonIsDisabled, children: buttonChildren }))] })] }));
};

const $f631663db3294ace$var$DirectionContext = /*#__PURE__*/ React.createContext(undefined);
/* -----------------------------------------------------------------------------------------------*/ function $f631663db3294ace$export$b39126d51d94e6f3(localDir) {
    const globalDir = React.useContext($f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || 'ltr';
}

/**
 * Listens for when the escape key is down
 */ function $addc16e1bbe58fd0$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onEscapeKeyDownProp);
    React.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener('keydown', handleKeyDown);
        return ()=>ownerDocument.removeEventListener('keydown', handleKeyDown)
        ;
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}

const $5cb92bef7577960e$var$CONTEXT_UPDATE$1 = 'dismissableLayer.update';
const $5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE$1 = 'dismissableLayer.pointerDownOutside';
const $5cb92bef7577960e$var$FOCUS_OUTSIDE$1 = 'dismissableLayer.focusOutside';
let $5cb92bef7577960e$var$originalBodyPointerEvents$1;
const $5cb92bef7577960e$var$DismissableLayerContext$1 = /*#__PURE__*/ React.createContext({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $5cb92bef7577960e$export$177fb62ff3ec1f22$1 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = React.useContext($5cb92bef7577960e$var$DismissableLayerContext$1);
    const [node1, setNode] = React.useState(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = React.useState({});
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setNode(node)
    );
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $5cb92bef7577960e$var$usePointerDownOutside$1((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $5cb92bef7577960e$var$useFocusOutside$1((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    $addc16e1bbe58fd0$export$3a72a57244d6e765((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    React.useEffect(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $5cb92bef7577960e$var$originalBodyPointerEvents$1 = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = 'none';
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $5cb92bef7577960e$var$dispatchUpdate$1();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $5cb92bef7577960e$var$originalBodyPointerEvents$1;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ React.useEffect(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $5cb92bef7577960e$var$dispatchUpdate$1();
        };
    }, [
        node1,
        context
    ]);
    React.useEffect(()=>{
        const handleUpdate = ()=>force({})
        ;
        document.addEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE$1, handleUpdate);
        return ()=>document.removeEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE$1, handleUpdate)
        ;
    }, []);
    return /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? 'auto' : 'none' : undefined,
            ...props.style
        },
        onFocusCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $5cb92bef7577960e$var$usePointerDownOutside$1(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onPointerDownOutside);
    const isPointerInsideReactTreeRef = React.useRef(false);
    const handleClickRef = React.useRef(()=>{});
    React.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $5cb92bef7577960e$var$handleAndDispatchCustomEvent$1($5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE$1, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === 'touch') {
                    ownerDocument.removeEventListener('click', handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener('click', handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener('pointerdown', handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener('pointerdown', handlePointerDown);
            ownerDocument.removeEventListener('click', handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $5cb92bef7577960e$var$useFocusOutside$1(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onFocusOutside);
    const isFocusInsideReactTreeRef = React.useRef(false);
    React.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $5cb92bef7577960e$var$handleAndDispatchCustomEvent$1($5cb92bef7577960e$var$FOCUS_OUTSIDE$1, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener('focusin', handleFocus);
        return ()=>ownerDocument.removeEventListener('focusin', handleFocus)
        ;
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true
        ,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $5cb92bef7577960e$var$dispatchUpdate$1() {
    const event = new CustomEvent($5cb92bef7577960e$var$CONTEXT_UPDATE$1);
    document.dispatchEvent(event);
}
function $5cb92bef7577960e$var$handleAndDispatchCustomEvent$1(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) $8927f6f2acc4f386$export$6d1a0317bde7de7f$1(target, event);
    else target.dispatchEvent(event);
}

/** Number of components which have requested interest to have focus guards */ let $3db38b7d1fb3fe6a$var$count = 0;
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c() {
    React.useEffect(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll('[data-radix-focus-guard]');
        document.body.insertAdjacentElement('afterbegin', (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement('beforeend', (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $3db38b7d1fb3fe6a$var$createFocusGuard());
        $3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll('[data-radix-focus-guard]').forEach((node)=>node.remove()
            );
            $3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement('span');
    element.setAttribute('data-radix-focus-guard', '');
    element.tabIndex = 0;
    element.style.cssText = 'outline: none; opacity: 0; position: fixed; pointer-events: none';
    return element;
}

const $d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = 'focusScope.autoFocusOnMount';
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = 'focusScope.autoFocusOnUnmount';
const $d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
const $d3863c46a17e8a28$export$20e40289641fbbb6 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false , trapped: trapped = false , onMountAutoFocus: onMountAutoFocusProp , onUnmountAutoFocus: onUnmountAutoFocusProp , ...scopeProps } = props;
    const [container1, setContainer] = React.useState(null);
    const onMountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onMountAutoFocusProp);
    const onUnmountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onUnmountAutoFocusProp);
    const lastFocusedElementRef = React.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setContainer(node)
    );
    const focusScope = React.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    React.useEffect(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                if (!container1.contains(event.relatedTarget)) $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            document.addEventListener('focusin', handleFocusIn);
            document.addEventListener('focusout', handleFocusOut);
            return ()=>{
                document.removeEventListener('focusin', handleFocusIn);
                document.removeEventListener('focusout', handleFocusOut);
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    React.useEffect(()=>{
        if (container1) {
            $d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $d3863c46a17e8a28$var$focusFirst($d3863c46a17e8a28$var$removeLinks($d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                     // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = React.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === 'Tab' && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false  } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === 'INPUT' && node.type === 'hidden';
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $d3863c46a17e8a28$var$isHidden(node, { upTo: upTo  }) {
    if (getComputedStyle(node).visibility === 'hidden') return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === 'none') return true;
        node = node.parentElement;
    }
    return false;
}
function $d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && 'select' in element;
}
function $d3863c46a17e8a28$var$focus(element, { select: select = false  } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $d3863c46a17e8a28$var$focusScopesStack = $d3863c46a17e8a28$var$createFocusScopesStack();
function $d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
             // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== 'A'
    );
}

function getSide$1(placement) {
  return placement.split('-')[0];
}

function getAlignment$1(placement) {
  return placement.split('-')[1];
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].includes(getSide$1(placement)) ? 'x' : 'y';
}

function getLengthFromAxis(axis) {
  return axis === 'y' ? 'height' : 'width';
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const mainAxis = getMainAxisFromPlacement(placement);
  const length = getLengthFromAxis(mainAxis);
  const commonAlign = reference[length] / 2 - floating[length] / 2;
  const side = getSide$1(placement);
  const isVertical = mainAxis === 'x';
  let coords;

  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;

    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;

    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }

  switch (getAlignment$1(placement)) {
    case 'start':
      coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;

    case 'end':
      coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }

  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */

const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));

  if (process.env.NODE_ENV !== "production") {
    if (platform == null) {
      console.error(['Floating UI: `platform` property was not passed to config. If you', 'want to use Floating UI on the web, install @floating-ui/dom', 'instead of the /core package. Otherwise, you can create your own', '`platform`: https://floating-ui.com/docs/platform'].join(' '));
    }

    if (middleware.filter(_ref => {
      let {
        name
      } = _ref;
      return name === 'autoPlacement' || name === 'flip';
    }).length > 1) {
      throw new Error(['Floating UI: duplicate `flip` and/or `autoPlacement`', 'middleware detected. This will lead to an infinite loop. Ensure only', 'one of either has been passed to the `middleware` array.'].join(' '));
    }
  }

  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;

  for (let i = 0; i < middleware.length; i++) {
    const {
      name,
      fn
    } = middleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = { ...middlewareData,
      [name]: { ...middlewareData[name],
        ...data
      }
    };

    if (process.env.NODE_ENV !== "production") {
      if (resetCount > 50) {
        console.warn(['Floating UI: The middleware lifecycle appears to be running in an', 'infinite loop. This is usually caused by a `reset` continually', 'being returned without a break condition.'].join(' '));
      }
    }

    if (reset && resetCount <= 50) {
      resetCount++;

      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }

        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }

        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }

      i = -1;
      continue;
    }
  }

  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

function expandPaddingObject$1(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}

function getSideObjectFromPadding(padding) {
  return typeof padding !== 'number' ? expandPaddingObject$1(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}

function rectToClientRect$1(rect) {
  return { ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow$1(middlewareArguments, options) {
  var _await$platform$isEle;

  if (options === void 0) {
    options = {};
  }

  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = middlewareArguments;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = options;
  const paddingObject = getSideObjectFromPadding(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect$1(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const elementClientRect = rectToClientRect$1(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: elementContext === 'floating' ? { ...rects.floating,
      x,
      y
    } : rects.reference,
    offsetParent: await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)),
    strategy
  }) : rects[elementContext]);
  return {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
}

const min$2 = Math.min;
const max$2 = Math.max;

function within(min$1, value, max$1) {
  return max$2(min$1, min$2(value, max$1));
}

/**
 * Positions an inner element of the floating element such that it is centered
 * to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$2 = options => ({
  name: 'arrow',
  options,

  async fn(middlewareArguments) {
    // Since `element` is required, we don't Partial<> the type
    const {
      element,
      padding = 0
    } = options != null ? options : {};
    const {
      x,
      y,
      placement,
      rects,
      platform
    } = middlewareArguments;

    if (element == null) {
      if (process.env.NODE_ENV !== "production") {
        console.warn('Floating UI: No `element` was passed to the `arrow` middleware.');
      }

      return {};
    }

    const paddingObject = getSideObjectFromPadding(padding);
    const coords = {
      x,
      y
    };
    const axis = getMainAxisFromPlacement(placement);
    const alignment = getAlignment$1(placement);
    const length = getLengthFromAxis(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const minProp = axis === 'y' ? 'top' : 'left';
    const maxProp = axis === 'y' ? 'bottom' : 'right';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;

    if (clientSize === 0) {
      clientSize = rects.floating[length];
    }

    const centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds

    const min = paddingObject[minProp];
    const max = clientSize - arrowDimensions[length] - paddingObject[maxProp];
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = within(min, center, max); // Make sure that arrow points at the reference

    const alignmentPadding = alignment === 'start' ? paddingObject[minProp] : paddingObject[maxProp];
    const shouldAddOffset = alignmentPadding > 0 && center !== offset && rects.reference[length] <= rects.floating[length];
    const alignmentOffset = shouldAddOffset ? center < min ? min - center : max - center : 0;
    return {
      [axis]: coords[axis] - alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset
      }
    };
  }

});

const hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement$1(placement) {
  return placement.replace(/left|right|bottom|top/g, matched => hash$1[matched]);
}

function getAlignmentSides$1(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }

  const alignment = getAlignment$1(placement);
  const mainAxis = getMainAxisFromPlacement(placement);
  const length = getLengthFromAxis(mainAxis);
  let mainAlignmentSide = mainAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';

  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement$1(mainAlignmentSide);
  }

  return {
    main: mainAlignmentSide,
    cross: getOppositePlacement$1(mainAlignmentSide)
  };
}

const hash$2 = {
  start: 'end',
  end: 'start'
};
function getOppositeAlignmentPlacement$1(placement) {
  return placement.replace(/start|end/g, matched => hash$2[matched]);
}

const sides$1 = ['top', 'right', 'bottom', 'left'];

function getExpandedPlacements$1(placement) {
  const oppositePlacement = getOppositePlacement$1(placement);
  return [getOppositeAlignmentPlacement$1(placement), oppositePlacement, getOppositeAlignmentPlacement$1(oppositePlacement)];
}

/**
 * Changes the placement of the floating element to one that will fit if the
 * initially specified `placement` does not.
 * @see https://floating-ui.com/docs/flip
 */
const flip$1 = function (options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'flip',
    options,

    async fn(middlewareArguments) {
      var _middlewareData$flip;

      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = middlewareArguments;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        flipAlignment = true,
        ...detectOverflowOptions
      } = options;
      const side = getSide$1(placement);
      const isBasePlacement = side === initialPlacement;
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement$1(initialPlacement)] : getExpandedPlacements$1(initialPlacement));
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow$1(middlewareArguments, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];

      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }

      if (checkCrossAxis) {
        const {
          main,
          cross
        } = getAlignmentSides$1(placement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
        overflows.push(overflow[main], overflow[cross]);
      }

      overflowsData = [...overflowsData, {
        placement,
        overflows
      }]; // One or more sides is overflowing

      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip$, _middlewareData$flip2;

        const nextIndex = ((_middlewareData$flip$ = (_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) != null ? _middlewareData$flip$ : 0) + 1;
        const nextPlacement = placements[nextIndex];

        if (nextPlacement) {
          // Try next placement and re-run the lifecycle
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        let resetPlacement = 'bottom';

        switch (fallbackStrategy) {
          case 'bestFit':
            {
              var _overflowsData$map$so;

              const placement = (_overflowsData$map$so = overflowsData.map(d => [d, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0].placement;

              if (placement) {
                resetPlacement = placement;
              }

              break;
            }

          case 'initialPlacement':
            resetPlacement = initialPlacement;
            break;
        }

        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }

      return {};
    }

  };
};

function getSideOffsets$1(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}

function isAnySideFullyClipped$1(overflow) {
  return sides$1.some(side => overflow[side] >= 0);
}

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide$1 = function (_temp) {
  let {
    strategy = 'referenceHidden',
    ...detectOverflowOptions
  } = _temp === void 0 ? {} : _temp;
  return {
    name: 'hide',

    async fn(middlewareArguments) {
      const {
        rects
      } = middlewareArguments;

      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await detectOverflow$1(middlewareArguments, { ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets$1(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped$1(offsets)
              }
            };
          }

        case 'escaped':
          {
            const overflow = await detectOverflow$1(middlewareArguments, { ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets$1(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped$1(offsets)
              }
            };
          }

        default:
          {
            return {};
          }
      }
    }

  };
};

async function convertValueToCoords$1(middlewareArguments, value) {
  const {
    placement,
    platform,
    elements
  } = middlewareArguments;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = getSide$1(placement);
  const alignment = getAlignment$1(placement);
  const isVertical = getMainAxisFromPlacement(placement) === 'x';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = typeof value === 'function' ? value(middlewareArguments) : value; // eslint-disable-next-line prefer-const

  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };

  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }

  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
/**
 * Displaces the floating element from its reference element.
 * @see https://floating-ui.com/docs/offset
 */

const offset$1 = function (value) {
  if (value === void 0) {
    value = 0;
  }

  return {
    name: 'offset',
    options: value,

    async fn(middlewareArguments) {
      const {
        x,
        y
      } = middlewareArguments;
      const diffCoords = await convertValueToCoords$1(middlewareArguments, value);
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: diffCoords
      };
    }

  };
};

function getCrossAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

/**
 * Shifts the floating element in order to keep it in view when it will overflow
 * a clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift$1 = function (options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'shift',
    options,

    async fn(middlewareArguments) {
      const {
        x,
        y,
        placement
      } = middlewareArguments;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = options;
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow$1(middlewareArguments, detectOverflowOptions);
      const mainAxis = getMainAxisFromPlacement(getSide$1(placement));
      const crossAxis = getCrossAxis(mainAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];

      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = within(min, mainAxisCoord, max);
      }

      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = within(min, crossAxisCoord, max);
      }

      const limitedCoords = limiter.fn({ ...middlewareArguments,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return { ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }

  };
};

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift$1 = function (options) {
  if (options === void 0) {
    options = {};
  }

  return {
    options,

    fn(middlewareArguments) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = middlewareArguments;
      const {
        offset = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = options;
      const coords = {
        x,
        y
      };
      const mainAxis = getMainAxisFromPlacement(placement);
      const crossAxis = getCrossAxis(mainAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = typeof offset === 'function' ? offset({ ...rects,
        placement
      }) : offset;
      const computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };

      if (checkMainAxis) {
        const len = mainAxis === 'y' ? 'height' : 'width';
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;

        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }

      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2, _middlewareData$offse3, _middlewareData$offse4;

        const len = mainAxis === 'y' ? 'width' : 'height';
        const isOriginSide = ['top', 'left'].includes(getSide$1(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? (_middlewareData$offse = (_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) != null ? _middlewareData$offse : 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : (_middlewareData$offse3 = (_middlewareData$offse4 = middlewareData.offset) == null ? void 0 : _middlewareData$offse4[crossAxis]) != null ? _middlewareData$offse3 : 0) - (isOriginSide ? computedOffset.crossAxis : 0);

        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }

      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }

  };
};

/**
 * Provides data to change the size of the floating element. For instance,
 * prevent it from overflowing its clipping boundary or match the width of the
 * reference element.
 * @see https://floating-ui.com/docs/size
 */
const size$1 = function (options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'size',
    options,

    async fn(middlewareArguments) {
      const {
        placement,
        rects,
        platform,
        elements
      } = middlewareArguments;
      const {
        apply,
        ...detectOverflowOptions
      } = options;
      const overflow = await detectOverflow$1(middlewareArguments, detectOverflowOptions);
      const side = getSide$1(placement);
      const alignment = getAlignment$1(placement);
      let heightSide;
      let widthSide;

      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }

      const xMin = max$2(overflow.left, 0);
      const xMax = max$2(overflow.right, 0);
      const yMin = max$2(overflow.top, 0);
      const yMax = max$2(overflow.bottom, 0);
      const dimensions = {
        availableHeight: rects.floating.height - (['left', 'right'].includes(placement) ? 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max$2(overflow.top, overflow.bottom)) : overflow[heightSide]),
        availableWidth: rects.floating.width - (['top', 'bottom'].includes(placement) ? 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max$2(overflow.left, overflow.right)) : overflow[widthSide])
      };
      const prevDimensions = await platform.getDimensions(elements.floating);
      apply == null ? void 0 : apply({ ...middlewareArguments,
        ...dimensions
      });
      const nextDimensions = await platform.getDimensions(elements.floating);

      if (prevDimensions.width !== nextDimensions.width || prevDimensions.height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }

      return {};
    }

  };
};

function isWindow(value) {
  return value && value.document && value.location && value.alert && value.setInterval;
}
function getWindow$1(node) {
  if (node == null) {
    return window;
  }

  if (!isWindow(node)) {
    const ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function getComputedStyle$1$1(element) {
  return getWindow$1(element).getComputedStyle(element);
}

function getNodeName$1(node) {
  return isWindow(node) ? '' : node ? (node.nodeName || '').toLowerCase() : '';
}

function getUAString() {
  const uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands) {
    return uaData.brands.map(item => item.brand + "/" + item.version).join(' ');
  }

  return navigator.userAgent;
}

function isHTMLElement$1(value) {
  return value instanceof getWindow$1(value).HTMLElement;
}
function isElement$1(value) {
  return value instanceof getWindow$1(value).Element;
}
function isNode$1(value) {
  return value instanceof getWindow$1(value).Node;
}
function isShadowRoot$1(node) {
  // Browsers without `ShadowRoot` support
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  const OwnElement = getWindow$1(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}
function isOverflowElement$1(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  const {
    overflow,
    overflowX,
    overflowY
  } = getComputedStyle$1$1(element);
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName$1(element));
}
function isContainingBlock(element) {
  // TODO: Try and use feature detection here instead
  const isFirefox = /firefox/i.test(getUAString());
  const css = getComputedStyle$1$1(element); // This is non-exhaustive but covers the most common CSS properties that
  // create a containing block.
  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

  return css.transform !== 'none' || css.perspective !== 'none' || // @ts-ignore (TS 4.1 compat)
  css.contain === 'paint' || ['transform', 'perspective'].includes(css.willChange) || isFirefox && css.willChange === 'filter' || isFirefox && (css.filter ? css.filter !== 'none' : false);
}
function isLayoutViewport() {
  // Not Safari
  return !/^((?!chrome|android).)*safari/i.test(getUAString()); // Feature detection for this fails in various ways
  // • Always-visible scrollbar or not
  // • Width of <html>, etc.
  // const vV = win.visualViewport;
  // return vV ? Math.abs(win.innerWidth / vV.scale - vV.width) < 0.5 : true;
}

const min$1 = Math.min;
const max$1 = Math.max;
const round$1 = Math.round;

function getBoundingClientRect$1(element, includeScale, isFixedStrategy) {
  var _win$visualViewport$o, _win$visualViewport, _win$visualViewport$o2, _win$visualViewport2;

  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  const clientRect = element.getBoundingClientRect();
  let scaleX = 1;
  let scaleY = 1;

  if (includeScale && isHTMLElement$1(element)) {
    scaleX = element.offsetWidth > 0 ? round$1(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$1(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  const win = isElement$1(element) ? getWindow$1(element) : window;
  const addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  const x = (clientRect.left + (addVisualOffsets ? (_win$visualViewport$o = (_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) != null ? _win$visualViewport$o : 0 : 0)) / scaleX;
  const y = (clientRect.top + (addVisualOffsets ? (_win$visualViewport$o2 = (_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) != null ? _win$visualViewport$o2 : 0 : 0)) / scaleY;
  const width = clientRect.width / scaleX;
  const height = clientRect.height / scaleY;
  return {
    width,
    height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x,
    y
  };
}

function getDocumentElement$1(node) {
  return ((isNode$1(node) ? node.ownerDocument : node.document) || window.document).documentElement;
}

function getNodeScroll(element) {
  if (isElement$1(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }

  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  return getBoundingClientRect$1(getDocumentElement$1(element)).left + getNodeScroll(element).scrollLeft;
}

function isScaled(element) {
  const rect = getBoundingClientRect$1(element);
  return round$1(rect.width) !== element.offsetWidth || round$1(rect.height) !== element.offsetHeight;
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  const documentElement = getDocumentElement$1(offsetParent);
  const rect = getBoundingClientRect$1(element, // @ts-ignore - checked above (TS 4.1 compat)
  isOffsetParentAnElement && isScaled(offsetParent), strategy === 'fixed');
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
    if (getNodeName$1(offsetParent) !== 'body' || isOverflowElement$1(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement$1(offsetParent)) {
      const offsetRect = getBoundingClientRect$1(offsetParent, true);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function getParentNode$1(node) {
  if (getNodeName$1(node) === 'html') {
    return node;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // @ts-ignore
    node.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    node.parentNode || ( // DOM Element detected
    isShadowRoot$1(node) ? node.host : null) || // ShadowRoot detected
    getDocumentElement$1(node) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement$1(element) || getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
}

function getContainingBlock(element) {
  let currentNode = getParentNode$1(element);

  if (isShadowRoot$1(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement$1(currentNode) && !['html', 'body'].includes(getNodeName$1(currentNode))) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  const window = getWindow$1(element);
  let offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName$1(offsetParent) === 'html' || getNodeName$1(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static' && !isContainingBlock(offsetParent))) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getDimensions(element) {
  if (isHTMLElement$1(element)) {
    return {
      width: element.offsetWidth,
      height: element.offsetHeight
    };
  }

  const rect = getBoundingClientRect$1(element);
  return {
    width: rect.width,
    height: rect.height
  };
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  const documentElement = getDocumentElement$1(offsetParent);

  if (offsetParent === documentElement) {
    return rect;
  }

  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
    if (getNodeName$1(offsetParent) !== 'body' || isOverflowElement$1(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement$1(offsetParent)) {
      const offsetRect = getBoundingClientRect$1(offsetParent, true);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } // This doesn't appear to be need to be negated.
    // else if (documentElement) {
    //   offsets.x = getWindowScrollBarX(documentElement);
    // }

  }

  return { ...rect,
    x: rect.x - scroll.scrollLeft + offsets.x,
    y: rect.y - scroll.scrollTop + offsets.y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow$1(element);
  const html = getDocumentElement$1(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width,
    height,
    x,
    y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  const html = getDocumentElement$1(element);
  const scroll = getNodeScroll(element);
  const body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  const width = max$1(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  const height = max$1(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;

  if (getComputedStyle$1$1(body || html).direction === 'rtl') {
    x += max$1(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width,
    height,
    x,
    y
  };
}

function getNearestOverflowAncestor$1(node) {
  const parentNode = getParentNode$1(node);

  if (['html', 'body', '#document'].includes(getNodeName$1(parentNode))) {
    // @ts-ignore assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement$1(parentNode) && isOverflowElement$1(parentNode)) {
    return parentNode;
  }

  return getNearestOverflowAncestor$1(parentNode);
}

function getOverflowAncestors$1(node, list) {
  var _node$ownerDocument;

  if (list === void 0) {
    list = [];
  }

  const scrollableAncestor = getNearestOverflowAncestor$1(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
  const win = getWindow$1(scrollableAncestor);
  const target = isBody ? [win].concat(win.visualViewport || [], isOverflowElement$1(scrollableAncestor) ? scrollableAncestor : []) : scrollableAncestor;
  const updatedList = list.concat(target);
  return isBody ? updatedList : // @ts-ignore: isBody tells us target will be an HTMLElement here
  updatedList.concat(getOverflowAncestors$1(target));
}

function contains(parent, child) {
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot$1(rootNode)) {
    let next = child;

    do {
      // use `===` replace node.isSameNode()
      if (next && parent === next) {
        return true;
      } // @ts-ignore: need a better way to handle this...


      next = next.parentNode || next.host;
    } while (next);
  }

  return false;
}

function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect$1(element, false, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  return {
    top,
    left,
    x: left,
    y: top,
    right: left + element.clientWidth,
    bottom: top + element.clientHeight,
    width: element.clientWidth,
    height: element.clientHeight
  };
}

function getClientRectFromClippingAncestor(element, clippingParent, strategy) {
  if (clippingParent === 'viewport') {
    return rectToClientRect$1(getViewportRect(element, strategy));
  }

  if (isElement$1(clippingParent)) {
    return getInnerBoundingClientRect(clippingParent, strategy);
  }

  return rectToClientRect$1(getDocumentRect(getDocumentElement$1(element)));
} // A "clipping ancestor" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingAncestors(element) {
  const clippingAncestors = getOverflowAncestors$1(element);
  const canEscapeClipping = ['absolute', 'fixed'].includes(getComputedStyle$1$1(element).position);
  const clipperElement = canEscapeClipping && isHTMLElement$1(element) ? getOffsetParent(element) : element;

  if (!isElement$1(clipperElement)) {
    return [];
  } // @ts-ignore isElement check ensures we return Array<Element>


  return clippingAncestors.filter(clippingAncestors => isElement$1(clippingAncestors) && contains(clippingAncestors, clipperElement) && getNodeName$1(clippingAncestors) !== 'body');
} // Gets the maximum area that the element is visible in due to any number of
// clipping ancestors


function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const mainClippingAncestors = boundary === 'clippingAncestors' ? getClippingAncestors(element) : [].concat(boundary);
  const clippingAncestors = [...mainClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max$1(rect.top, accRect.top);
    accRect.right = min$1(rect.right, accRect.right);
    accRect.bottom = min$1(rect.bottom, accRect.bottom);
    accRect.left = max$1(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

const platform = {
  getClippingRect,
  convertOffsetParentRelativeRectToViewportRelativeRect,
  isElement: isElement$1,
  getDimensions,
  getOffsetParent,
  getDocumentElement: getDocumentElement$1,
  getElementRects: _ref => {
    let {
      reference,
      floating,
      strategy
    } = _ref;
    return {
      reference: getRectRelativeToOffsetParent(reference, getOffsetParent(floating), strategy),
      floating: { ...getDimensions(floating),
        x: 0,
        y: 0
      }
    };
  },
  getClientRects: element => Array.from(element.getClientRects()),
  isRTL: element => getComputedStyle$1$1(element).direction === 'rtl'
};

/**
 * Automatically updates the position of the floating element when necessary.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate$1(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }

  const {
    ancestorScroll: _ancestorScroll = true,
    ancestorResize: _ancestorResize = true,
    elementResize = true,
    animationFrame = false
  } = options;
  const ancestorScroll = _ancestorScroll && !animationFrame;
  const ancestorResize = _ancestorResize && !animationFrame;
  const ancestors = ancestorScroll || ancestorResize ? [...(isElement$1(reference) ? getOverflowAncestors$1(reference) : []), ...getOverflowAncestors$1(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  let observer = null;

  if (elementResize) {
    let initialUpdate = true;
    observer = new ResizeObserver(() => {
      if (!initialUpdate) {
        update();
      }

      initialUpdate = false;
    });
    isElement$1(reference) && !animationFrame && observer.observe(reference);
    observer.observe(floating);
  }

  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect$1(reference) : null;

  if (animationFrame) {
    frameLoop();
  }

  function frameLoop() {
    const nextRefRect = getBoundingClientRect$1(reference);

    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }

    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }

  update();
  return () => {
    var _observer;

    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    (_observer = observer) == null ? void 0 : _observer.disconnect();
    observer = null;

    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */

const computePosition = (reference, floating, options) => computePosition$1(reference, floating, {
  platform,
  ...options
});

var index$2 = typeof document !== 'undefined' ? React.useLayoutEffect : React.useEffect;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }

  let length, i, keys;

  if (a && b && typeof a == 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }

      return true;
    }

    keys = Object.keys(a);
    length = keys.length;

    if (length !== Object.keys(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }

    for (i = length; i-- !== 0;) {
      const key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        continue;
      }

      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }

    return true;
  }

  return a !== a && b !== b;
}

function useLatestRef(value) {
  const ref = React__namespace.useRef(value);
  index$2(() => {
    ref.current = value;
  });
  return ref;
}

function useFloating(_temp) {
  let {
    middleware,
    placement = 'bottom',
    strategy = 'absolute',
    whileElementsMounted
  } = _temp === void 0 ? {} : _temp;
  const reference = React__namespace.useRef(null);
  const floating = React__namespace.useRef(null);
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const cleanupRef = React__namespace.useRef(null);
  const [data, setData] = React__namespace.useState({
    // Setting these to `null` will allow the consumer to determine if
    // `computePosition()` has run yet
    x: null,
    y: null,
    strategy,
    placement,
    middlewareData: {}
  });
  const [latestMiddleware, setLatestMiddleware] = React__namespace.useState(middleware);

  if (!deepEqual(latestMiddleware == null ? void 0 : latestMiddleware.map(_ref => {
    let {
      options
    } = _ref;
    return options;
  }), middleware == null ? void 0 : middleware.map(_ref2 => {
    let {
      options
    } = _ref2;
    return options;
  }))) {
    setLatestMiddleware(middleware);
  }

  const update = React__namespace.useCallback(() => {
    if (!reference.current || !floating.current) {
      return;
    }

    computePosition(reference.current, floating.current, {
      middleware: latestMiddleware,
      placement,
      strategy
    }).then(data => {
      if (isMountedRef.current) {
        $7SXl2$reactdom__namespace.flushSync(() => {
          setData(data);
        });
      }
    });
  }, [latestMiddleware, placement, strategy]);
  index$2(() => {
    // Skip first update
    if (isMountedRef.current) {
      update();
    }
  }, [update]);
  const isMountedRef = React__namespace.useRef(false);
  index$2(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const runElementMountCallback = React__namespace.useCallback(() => {
    if (typeof cleanupRef.current === 'function') {
      cleanupRef.current();
      cleanupRef.current = null;
    }

    if (reference.current && floating.current) {
      if (whileElementsMountedRef.current) {
        const cleanupFn = whileElementsMountedRef.current(reference.current, floating.current, update);
        cleanupRef.current = cleanupFn;
      } else {
        update();
      }
    }
  }, [update, whileElementsMountedRef]);
  const setReference = React__namespace.useCallback(node => {
    reference.current = node;
    runElementMountCallback();
  }, [runElementMountCallback]);
  const setFloating = React__namespace.useCallback(node => {
    floating.current = node;
    runElementMountCallback();
  }, [runElementMountCallback]);
  const refs = React__namespace.useMemo(() => ({
    reference,
    floating
  }), []);
  return React__namespace.useMemo(() => ({ ...data,
    update,
    refs,
    reference: setReference,
    floating: setFloating
  }), [data, update, refs, setReference, setFloating]);
}

/**
 * Positions an inner element of the floating element such that it is centered
 * to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */

const arrow$1 = options => {
  const {
    element,
    padding
  } = options;

  function isRef(value) {
    return Object.prototype.hasOwnProperty.call(value, 'current');
  }

  return {
    name: 'arrow',
    options,

    fn(args) {
      if (isRef(element)) {
        if (element.current != null) {
          return arrow$2({
            element: element.current,
            padding
          }).fn(args);
        }

        return {};
      } else if (element) {
        return arrow$2({
          element,
          padding
        }).fn(args);
      }

      return {};
    }

  };
};

function $db6c3485150b8e66$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = React.useState(undefined);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                 // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ('borderBoxSize' in entry) {
                    const borderSizeEntry = entry['borderBoxSize']; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize['inlineSize'];
                    height = borderSize['blockSize'];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: 'border-box'
            });
            return ()=>resizeObserver.unobserve(element)
            ;
        } else // We only want to reset to `undefined` when the element becomes `null`,
        // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}

/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$POPPER_NAME$1 = 'Popper';
const [$cf1ac5d9fe0e8206$var$createPopperContext$1, $cf1ac5d9fe0e8206$export$722aac194ae923$1] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cf1ac5d9fe0e8206$var$POPPER_NAME$1);
const [$cf1ac5d9fe0e8206$var$PopperProvider$1, $cf1ac5d9fe0e8206$var$usePopperContext$1] = $cf1ac5d9fe0e8206$var$createPopperContext$1($cf1ac5d9fe0e8206$var$POPPER_NAME$1);
const $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9$1 = (props)=>{
    const { __scopePopper: __scopePopper , children: children  } = props;
    const [anchor, setAnchor] = React.useState(null);
    return /*#__PURE__*/ React.createElement($cf1ac5d9fe0e8206$var$PopperProvider$1, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$ANCHOR_NAME$1 = 'PopperAnchor';
const $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d$1 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper , virtualRef: virtualRef , ...anchorProps } = props;
    const context = $cf1ac5d9fe0e8206$var$usePopperContext$1($cf1ac5d9fe0e8206$var$ANCHOR_NAME$1, __scopePopper);
    const ref = React.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    React.useEffect(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({}, anchorProps, {
        ref: composedRefs
    }));
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$CONTENT_NAME$1 = 'PopperContent';
const [$cf1ac5d9fe0e8206$var$PopperContentProvider$1, $cf1ac5d9fe0e8206$var$useContentContext$1] = $cf1ac5d9fe0e8206$var$createPopperContext$1($cf1ac5d9fe0e8206$var$CONTENT_NAME$1);
const [$cf1ac5d9fe0e8206$var$PositionContextProvider$1, $cf1ac5d9fe0e8206$var$usePositionContext$1] = $cf1ac5d9fe0e8206$var$createPopperContext$1($cf1ac5d9fe0e8206$var$CONTENT_NAME$1, {
    hasParent: false,
    positionUpdateFns: new Set()
});
const $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc$1 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$hide, _middlewareData$trans, _middlewareData$trans2;
    const { __scopePopper: __scopePopper , side: side = 'bottom' , sideOffset: sideOffset = 0 , align: align = 'center' , alignOffset: alignOffset = 0 , arrowPadding: arrowPadding = 0 , collisionBoundary: collisionBoundary = [] , collisionPadding: collisionPaddingProp = 0 , sticky: sticky = 'partial' , hideWhenDetached: hideWhenDetached = false , avoidCollisions: avoidCollisions = true , ...contentProps } = props;
    const context = $cf1ac5d9fe0e8206$var$usePopperContext$1($cf1ac5d9fe0e8206$var$CONTENT_NAME$1, __scopePopper);
    const [content, setContent] = React.useState(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setContent(node)
    );
    const [arrow, setArrow] = React.useState(null);
    const arrowSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== 'center' ? '-' + align : '');
    const collisionPadding = typeof collisionPaddingProp === 'number' ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($cf1ac5d9fe0e8206$var$isNotNull$1),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { reference: reference , floating: floating , strategy: strategy , x: x , y: y , placement: placement , middlewareData: middlewareData , update: update  } = useFloating({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: 'fixed',
        placement: desiredPlacement,
        whileElementsMounted: autoUpdate$1,
        middleware: [
            offset$1({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions ? shift$1({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === 'partial' ? limitShift$1() : undefined,
                ...detectOverflowOptions
            }) : undefined,
            arrow ? arrow$1({
                element: arrow,
                padding: arrowPadding
            }) : undefined,
            avoidCollisions ? flip$1({
                ...detectOverflowOptions
            }) : undefined,
            $cf1ac5d9fe0e8206$var$transformOrigin$1({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached ? hide$1({
                strategy: 'referenceHidden'
            }) : undefined
        ].filter($cf1ac5d9fe0e8206$var$isDefined$1)
    }); // assign the reference dynamically once `Content` has mounted so we can collocate the logic
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        reference(context.anchor);
    }, [
        reference,
        context.anchor
    ]);
    const isPlaced = x !== null && y !== null;
    const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement$1(placement);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = React.useState();
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    const { hasParent: hasParent , positionUpdateFns: positionUpdateFns  } = $cf1ac5d9fe0e8206$var$usePositionContext$1($cf1ac5d9fe0e8206$var$CONTENT_NAME$1, __scopePopper);
    const isRoot = !hasParent;
    React.useLayoutEffect(()=>{
        if (!isRoot) {
            positionUpdateFns.add(update);
            return ()=>{
                positionUpdateFns.delete(update);
            };
        }
    }, [
        isRoot,
        positionUpdateFns,
        update
    ]); // when nested contents are rendered in portals, they are appended out of order causing
    // children to be positioned incorrectly if initially open.
    // we need to re-compute the positioning once the parent has finally been placed.
    // https://github.com/floating-ui/floating-ui/issues/1531
    React.useLayoutEffect(()=>{
        if (isRoot && isPlaced) Array.from(positionUpdateFns).reverse().forEach((fn)=>requestAnimationFrame(fn)
        );
    }, [
        isRoot,
        isPlaced,
        positionUpdateFns
    ]);
    const commonProps = {
        'data-side': placedSide,
        'data-align': placedAlign,
        ...contentProps,
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPlaced ? 'none' : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        ref: floating,
        "data-radix-popper-content-wrapper": "",
        style: {
            position: strategy,
            left: 0,
            top: 0,
            transform: isPlaced ? `translate3d(${Math.round(x)}px, ${Math.round(y)}px, 0)` : 'translate3d(0, -200%, 0)',
            // keep off the page when measuring
            minWidth: 'max-content',
            zIndex: contentZIndex,
            ['--radix-popper-transform-origin']: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(' ')
        }
    }, /*#__PURE__*/ React.createElement($cf1ac5d9fe0e8206$var$PopperContentProvider$1, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, isRoot ? /*#__PURE__*/ React.createElement($cf1ac5d9fe0e8206$var$PositionContextProvider$1, {
        scope: __scopePopper,
        hasParent: true,
        positionUpdateFns: positionUpdateFns
    }, /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, commonProps)) : /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, commonProps)));
});
/* -----------------------------------------------------------------------------------------------*/ function $cf1ac5d9fe0e8206$var$isDefined$1(value) {
    return value !== undefined;
}
function $cf1ac5d9fe0e8206$var$isNotNull$1(value) {
    return value !== null;
}
const $cf1ac5d9fe0e8206$var$transformOrigin$1 = (options)=>({
        name: 'transformOrigin',
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement , rects: rects , middlewareData: middlewareData  } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement$1(placement);
            const noArrowAlign = {
                start: '0%',
                center: '50%',
                end: '100%'
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = '';
            let y = '';
            if (placedSide === 'bottom') {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === 'top') {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === 'right') {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === 'left') {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    })
;
function $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement$1(placement) {
    const [side, align = 'center'] = placement.split('-');
    return [
        side,
        align
    ];
}
const $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9$1 = $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9$1;
const $cf1ac5d9fe0e8206$export$b688253958b8dfe7$1 = $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d$1;
const $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2$1 = $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc$1;

const $f1701beae083dbae$export$602eac185826482c$1 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body , ...portalProps } = props;
    return container ? /*#__PURE__*/ $7SXl2$reactdom__default["default"].createPortal(/*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});

const $d7bdfb9eb0fdf311$var$ENTRY_FOCUS$1 = 'rovingFocusGroup.onEntryFocus';
const $d7bdfb9eb0fdf311$var$EVENT_OPTIONS$1 = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$GROUP_NAME$1 = 'RovingFocusGroup';
const [$d7bdfb9eb0fdf311$var$Collection$1, $d7bdfb9eb0fdf311$var$useCollection$1, $d7bdfb9eb0fdf311$var$createCollectionScope$1] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($d7bdfb9eb0fdf311$var$GROUP_NAME$1);
const [$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext$1, $d7bdfb9eb0fdf311$export$c7109489551a4f4$1] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($d7bdfb9eb0fdf311$var$GROUP_NAME$1, [
    $d7bdfb9eb0fdf311$var$createCollectionScope$1
]);
const [$d7bdfb9eb0fdf311$var$RovingFocusProvider$1, $d7bdfb9eb0fdf311$var$useRovingFocusContext$1] = $d7bdfb9eb0fdf311$var$createRovingFocusGroupContext$1($d7bdfb9eb0fdf311$var$GROUP_NAME$1);
const $d7bdfb9eb0fdf311$export$8699f7c8af148338$1 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    return /*#__PURE__*/ React.createElement($d7bdfb9eb0fdf311$var$Collection$1.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ React.createElement($d7bdfb9eb0fdf311$var$Collection$1.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ React.createElement($d7bdfb9eb0fdf311$var$RovingFocusGroupImpl$1, _extends$b({}, props, {
        ref: forwardedRef
    }))));
});
/* -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$RovingFocusGroupImpl$1 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , orientation: orientation , loop: loop = false , dir: dir , currentTabStopId: currentTabStopIdProp , defaultCurrentTabStopId: defaultCurrentTabStopId , onCurrentTabStopIdChange: onCurrentTabStopIdChange , onEntryFocus: onEntryFocus , ...groupProps } = props;
    const ref = React.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = React.useState(false);
    const handleEntryFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onEntryFocus);
    const getItems = $d7bdfb9eb0fdf311$var$useCollection$1(__scopeRovingFocusGroup);
    const isClickFocusRef = React.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = React.useState(0);
    React.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS$1, handleEntryFocus);
            return ()=>node.removeEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS$1, handleEntryFocus)
            ;
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ React.createElement($d7bdfb9eb0fdf311$var$RovingFocusProvider$1, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: React.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId)
        , [
            setCurrentTabStopId
        ]),
        onItemShiftTab: React.useCallback(()=>setIsTabbingBackOut(true)
        , []),
        onFocusableItemAdd: React.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1
            )
        , []),
        onFocusableItemRemove: React.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1
            )
        , [])
    }, /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: 'none',
            ...props.style
        },
        onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($d7bdfb9eb0fdf311$var$ENTRY_FOCUS$1, $d7bdfb9eb0fdf311$var$EVENT_OPTIONS$1);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable
                    );
                    const activeItem = items.find((item)=>item.active
                    );
                    const currentItem = items.find((item)=>item.id === currentTabStopId
                    );
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current
                    );
                    $d7bdfb9eb0fdf311$var$focusFirst$1(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, ()=>setIsTabbingBackOut(false)
        )
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$ITEM_NAME$1 = 'RovingFocusGroupItem';
const $d7bdfb9eb0fdf311$export$ab9df7c53fe8454$1 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , focusable: focusable = true , active: active = false , ...itemProps } = props;
    const id = $1746a345f3d73bb7$export$f680877a34711e37();
    const context = $d7bdfb9eb0fdf311$var$useRovingFocusContext$1($d7bdfb9eb0fdf311$var$ITEM_NAME$1, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $d7bdfb9eb0fdf311$var$useCollection$1(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd , onFocusableItemRemove: onFocusableItemRemove  } = context;
    React.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove()
            ;
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ React.createElement($d7bdfb9eb0fdf311$var$Collection$1.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.span, _extends$b({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, ()=>context.onItemFocus(id)
        ),
        onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event)=>{
            if (event.key === 'Tab' && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $d7bdfb9eb0fdf311$var$getFocusIntent$1(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable
                );
                let candidateNodes = items.map((item)=>item.ref.current
                );
                if (focusIntent === 'last') candidateNodes.reverse();
                else if (focusIntent === 'prev' || focusIntent === 'next') {
                    if (focusIntent === 'prev') candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $d7bdfb9eb0fdf311$var$wrapArray$1(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$d7bdfb9eb0fdf311$var$focusFirst$1(candidateNodes)
                );
            }
        })
    })));
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT$1 = {
    ArrowLeft: 'prev',
    ArrowUp: 'prev',
    ArrowRight: 'next',
    ArrowDown: 'next',
    PageUp: 'first',
    Home: 'first',
    PageDown: 'last',
    End: 'last'
};
function $d7bdfb9eb0fdf311$var$getDirectionAwareKey$1(key, dir) {
    if (dir !== 'rtl') return key;
    return key === 'ArrowLeft' ? 'ArrowRight' : key === 'ArrowRight' ? 'ArrowLeft' : key;
}
function $d7bdfb9eb0fdf311$var$getFocusIntent$1(event, orientation, dir) {
    const key = $d7bdfb9eb0fdf311$var$getDirectionAwareKey$1(event.key, dir);
    if (orientation === 'vertical' && [
        'ArrowLeft',
        'ArrowRight'
    ].includes(key)) return undefined;
    if (orientation === 'horizontal' && [
        'ArrowUp',
        'ArrowDown'
    ].includes(key)) return undefined;
    return $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT$1[key];
}
function $d7bdfb9eb0fdf311$var$focusFirst$1(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $d7bdfb9eb0fdf311$var$wrapArray$1(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]
    );
}
const $d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9$1 = $d7bdfb9eb0fdf311$export$8699f7c8af148338$1;
const $d7bdfb9eb0fdf311$export$6d08773d2e66f8f2$1 = $d7bdfb9eb0fdf311$export$ab9df7c53fe8454$1;

var getDefaultParent = function (originalTarget) {
    if (typeof document === 'undefined') {
        return null;
    }
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function (node) {
    return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function (parent, targets) {
    return targets
        .map(function (target) {
        if (parent.contains(target)) {
            return target;
        }
        var correctedTarget = unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) {
            return correctedTarget;
        }
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    })
        .filter(function (x) { return Boolean(x); });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */
var applyAttributeToOthers = function (originalTarget, parentNode, markerName, controlAttribute) {
    var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    if (!markerMap[markerName]) {
        markerMap[markerName] = new WeakMap();
    }
    var markerCounter = markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function (el) {
        if (!el || elementsToKeep.has(el)) {
            return;
        }
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function (parent) {
        if (!parent || elementsToStop.has(parent)) {
            return;
        }
        Array.prototype.forEach.call(parent.children, function (node) {
            if (elementsToKeep.has(node)) {
                deep(node);
            }
            else {
                try {
                    var attr = node.getAttribute(controlAttribute);
                    var alreadyHidden = attr !== null && attr !== 'false';
                    var counterValue = (counterMap.get(node) || 0) + 1;
                    var markerValue = (markerCounter.get(node) || 0) + 1;
                    counterMap.set(node, counterValue);
                    markerCounter.set(node, markerValue);
                    hiddenNodes.push(node);
                    if (counterValue === 1 && alreadyHidden) {
                        uncontrolledNodes.set(node, true);
                    }
                    if (markerValue === 1) {
                        node.setAttribute(markerName, 'true');
                    }
                    if (!alreadyHidden) {
                        node.setAttribute(controlAttribute, 'true');
                    }
                }
                catch (e) {
                    console.error('aria-hidden: cannot operate on ', node, e);
                }
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    lockCount++;
    return function () {
        hiddenNodes.forEach(function (node) {
            var counterValue = counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!uncontrolledNodes.has(node)) {
                    node.removeAttribute(controlAttribute);
                }
                uncontrolledNodes.delete(node);
            }
            if (!markerValue) {
                node.removeAttribute(markerName);
            }
        });
        lockCount--;
        if (!lockCount) {
            // clear
            counterMap = new WeakMap();
            counterMap = new WeakMap();
            uncontrolledNodes = new WeakMap();
            markerMap = {};
        }
    };
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var hideOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-aria-hidden'; }
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
/**
 * Name of a CSS variable containing the amount of "hidden" scrollbar
 * ! might be undefined ! use will fallback!
 */
var removedBarSizeVariable = '--removed-body-scroll-bar-size';

/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = React.useState(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            },
        },
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' ? React__namespace.useLayoutEffect : React__namespace.useEffect;
var currentValues = new WeakMap();
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    var callbackRef = useCallbackRef(defaultValue || null, function (newValue) {
        return refs.forEach(function (ref) { return assignRef(ref, newValue); });
    });
    // handle refs changes - added or removed
    useIsomorphicLayoutEffect$1(function () {
        var oldValue = currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function (ref) {
                if (!nextRefs_1.has(ref)) {
                    assignRef(ref, null);
                }
            });
            nextRefs_1.forEach(function (ref) {
                if (!prevRefs_1.has(ref)) {
                    assignRef(ref, current_1);
                }
            });
        }
        currentValues.set(callbackRef, refs);
    }, [refs]);
    return callbackRef;
}

// Only Node.JS has a process variable that is of [[Class]] process
Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = __assign({ async: true, ssr: false }, options);
    return medium;
}

var SideCar$1 = function (_a) {
    var sideCar = _a.sideCar, rest = __rest(_a, ["sideCar"]);
    if (!sideCar) {
        throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    }
    var Target = sideCar.read();
    if (!Target) {
        throw new Error('Sidecar medium not found');
    }
    return React__namespace.createElement(Target, __assign({}, rest));
};
SideCar$1.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar$1;
}

var effectCar = createSidecarMedium();

var nothing = function () {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */
var RemoveScroll = React__namespace.forwardRef(function (props, parentRef) {
    var ref = React__namespace.useRef(null);
    var _a = React__namespace.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing,
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
    var SideCar = sideCar;
    var containerRef = useMergeRefs([ref, parentRef]);
    var containerProps = __assign(__assign({}, rest), callbacks);
    return (React__namespace.createElement(React__namespace.Fragment, null,
        enabled && (React__namespace.createElement(SideCar, { sideCar: effectCar, removeScrollBar: removeScrollBar, shards: shards, noIsolation: noIsolation, inert: inert, setCallbacks: setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref })),
        forwardProps ? (React__namespace.cloneElement(React__namespace.Children.only(children), __assign(__assign({}, containerProps), { ref: containerRef }))) : (React__namespace.createElement(Container, __assign({}, containerProps, { className: className, ref: containerRef }), children))));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false,
};
RemoveScroll.classNames = {
    fullWidth: fullWidthClassName,
    zeroRight: zeroRightClassName,
};

var getNonce = function () {
    if (typeof __webpack_nonce__ !== 'undefined') {
        return __webpack_nonce__;
    }
    return undefined;
};

function makeStyleTag() {
    if (!document)
        return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = getNonce();
    if (nonce) {
        tag.setAttribute('nonce', nonce);
    }
    return tag;
}
function injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) {
        // @ts-ignore
        tag.styleSheet.cssText = css;
    }
    else {
        tag.appendChild(document.createTextNode(css));
    }
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function () {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function (style) {
            if (counter == 0) {
                if ((stylesheet = makeStyleTag())) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function () {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        },
    };
};

/**
 * creates a hook to control style singleton
 * @see {@link styleSingleton} for a safer component version
 * @example
 * ```tsx
 * const useStyle = styleHookSingleton();
 * ///
 * useStyle('body { overflow: hidden}');
 */
var styleHookSingleton = function () {
    var sheet = stylesheetSingleton();
    return function (styles, isDynamic) {
        React__namespace.useEffect(function () {
            sheet.add(styles);
            return function () {
                sheet.remove();
            };
        }, [styles && isDynamic]);
    };
};

/**
 * create a Component to add styles on demand
 * - styles are added when first instance is mounted
 * - styles are removed when the last instance is unmounted
 * - changing styles in runtime does nothing unless dynamic is set. But with multiple components that can lead to the undefined behavior
 */
var styleSingleton = function () {
    var useStyle = styleHookSingleton();
    var Sheet = function (_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0,
};
var parse$2 = function (x) { return parseInt(x || '', 10) || 0; };
var getOffset = function (gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [parse$2(left), parse$2(top), parse$2(right)];
};
var getGapWidth = function (gapMode) {
    if (gapMode === void 0) { gapMode = 'margin'; }
    if (typeof window === 'undefined') {
        return zeroGap;
    }
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0]),
    };
};

var Style = styleSingleton();
var lockAttribute = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function (_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) { gapMode = 'margin'; }
    return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' &&
            "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";"),
    ]
        .filter(Boolean)
        .join(''), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function () {
    var counter = parseInt(document.body.getAttribute(lockAttribute) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function () {
    React__namespace.useEffect(function () {
        document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
        return function () {
            var newCounter = getCurrentUseCounter() - 1;
            if (newCounter <= 0) {
                document.body.removeAttribute(lockAttribute);
            }
            else {
                document.body.setAttribute(lockAttribute, newCounter.toString());
            }
        };
    }, []);
};
/**
 * Removes page scrollbar and blocks page scroll when mounted
 */
var RemoveScrollBar = function (_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    useLockAttribute();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */
    var gap = React__namespace.useMemo(function () { return getGapWidth(gapMode); }, [gapMode]);
    return React__namespace.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '') });
};

var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options$1 = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
                return true;
            },
        });
        // @ts-ignore
        window.addEventListener('test', options$1, options$1);
        // @ts-ignore
        window.removeEventListener('test', options$1, options$1);
    }
    catch (err) {
        passiveSupported = false;
    }
}
var nonPassive = passiveSupported ? { passive: false } : false;

var alwaysContainsScroll = function (node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function (node, overflow) {
    var styles = window.getComputedStyle(node);
    return (
    // not-not-scrollable
    styles[overflow] !== 'hidden' &&
        // contains scroll inside self
        !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var elementCouldBeVScrolled = function (node) { return elementCanBeScrolled(node, 'overflowY'); };
var elementCouldBeHScrolled = function (node) { return elementCanBeScrolled(node, 'overflowX'); };
var locationCouldBeScrolled = function (axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) {
            current = current.host;
        }
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) {
                return true;
            }
        }
        current = current.parentNode;
    } while (current && current !== document.body);
    return false;
};
var getVScrollVariables = function (_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight,
    ];
};
var getHScrollVariables = function (_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth,
    ];
};
var elementCouldBeScrolled = function (axis, node) {
    return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function (axis, node) {
    return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function (axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */
    return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    } while (
    // portaled content
    (!targetInLock && target !== document.body) ||
        // self content
        (targetInLock && (endTarget.contains(target) || endTarget === target)));
    if (isDeltaPositive && ((noOverscroll && availableScroll === 0) || (!noOverscroll && delta > availableScroll))) {
        shouldCancelScroll = true;
    }
    else if (!isDeltaPositive &&
        ((noOverscroll && availableScrollTop === 0) || (!noOverscroll && -delta > availableScrollTop))) {
        shouldCancelScroll = true;
    }
    return shouldCancelScroll;
};

var getTouchXY = function (event) {
    return 'changedTouches' in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function (event) { return [event.deltaX, event.deltaY]; };
var extractRef = function (ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function (x, y) { return x[0] === y[0] && x[1] === y[1]; };
var generateStyle = function (id) { return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n"); };
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = React__namespace.useRef([]);
    var touchStartRef = React__namespace.useRef([0, 0]);
    var activeAxis = React__namespace.useRef();
    var id = React__namespace.useState(idCounter++)[0];
    var Style = React__namespace.useState(function () { return styleSingleton(); })[0];
    var lastProps = React__namespace.useRef(props);
    React__namespace.useEffect(function () {
        lastProps.current = props;
    }, [props]);
    React__namespace.useEffect(function () {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
            allow_1.forEach(function (el) { return el.classList.add("allow-interactivity-".concat(id)); });
            return function () {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function (el) { return el.classList.remove("allow-interactivity-".concat(id)); });
            };
        }
        return;
    }, [props.inert, props.lockRef.current, props.shards]);
    var shouldCancelEvent = React__namespace.useCallback(function (event, parent) {
        if ('touches' in event && event.touches.length === 2) {
            return !lastProps.current.allowPinchZoom;
        }
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') {
            return false;
        }
        var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
        if (!canBeScrolledInMainDirection) {
            return true;
        }
        if (canBeScrolledInMainDirection) {
            currentAxis = moveDirection;
        }
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
            // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) {
            return false;
        }
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) {
            activeAxis.current = currentAxis;
        }
        if (!currentAxis) {
            return true;
        }
        var cancelingAxis = activeAxis.current || currentAxis;
        return handleScroll(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = React__namespace.useCallback(function (_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) {
            // not the last active
            return;
        }
        var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function (e) { return e.name === event.type && e.target === event.target && deltaCompare(e.delta, delta); })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) {
                event.preventDefault();
            }
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || [])
                .map(extractRef)
                .filter(Boolean)
                .filter(function (node) { return node.contains(event.target); });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) {
                    event.preventDefault();
                }
            }
        }
    }, []);
    var shouldCancel = React__namespace.useCallback(function (name, delta, target, should) {
        var event = { name: name, delta: delta, target: target, should: should };
        shouldPreventQueue.current.push(event);
        setTimeout(function () {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) { return e !== event; });
        }, 1);
    }, []);
    var scrollTouchStart = React__namespace.useCallback(function (event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = React__namespace.useCallback(function (event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = React__namespace.useCallback(function (event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    React__namespace.useEffect(function () {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove,
        });
        document.addEventListener('wheel', shouldPrevent, nonPassive);
        document.addEventListener('touchmove', shouldPrevent, nonPassive);
        document.addEventListener('touchstart', scrollTouchStart, nonPassive);
        return function () {
            lockStack = lockStack.filter(function (inst) { return inst !== Style; });
            document.removeEventListener('wheel', shouldPrevent, nonPassive);
            document.removeEventListener('touchmove', shouldPrevent, nonPassive);
            document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        inert ? React__namespace.createElement(Style, { styles: generateStyle(id) }) : null,
        removeScrollBar ? React__namespace.createElement(RemoveScrollBar, { gapMode: "margin" }) : null));
}

var SideCar = exportSidecar(effectCar, RemoveScrollSideCar);

var ReactRemoveScroll = React__namespace.forwardRef(function (props, ref) { return (React__namespace.createElement(RemoveScroll, __assign({}, props, { ref: ref, sideCar: SideCar }))); });
ReactRemoveScroll.classNames = RemoveScroll.classNames;

const $6cc32821e9371a1c$var$SELECTION_KEYS = [
    'Enter',
    ' '
];
const $6cc32821e9371a1c$var$FIRST_KEYS = [
    'ArrowDown',
    'PageUp',
    'Home'
];
const $6cc32821e9371a1c$var$LAST_KEYS = [
    'ArrowUp',
    'PageDown',
    'End'
];
const $6cc32821e9371a1c$var$FIRST_LAST_KEYS = [
    ...$6cc32821e9371a1c$var$FIRST_KEYS,
    ...$6cc32821e9371a1c$var$LAST_KEYS
];
const $6cc32821e9371a1c$var$SUB_OPEN_KEYS = {
    ltr: [
        ...$6cc32821e9371a1c$var$SELECTION_KEYS,
        'ArrowRight'
    ],
    rtl: [
        ...$6cc32821e9371a1c$var$SELECTION_KEYS,
        'ArrowLeft'
    ]
};
const $6cc32821e9371a1c$var$SUB_CLOSE_KEYS = {
    ltr: [
        'ArrowLeft'
    ],
    rtl: [
        'ArrowRight'
    ]
};
/* -------------------------------------------------------------------------------------------------
 * Menu
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$MENU_NAME = 'Menu';
const [$6cc32821e9371a1c$var$Collection, $6cc32821e9371a1c$var$useCollection, $6cc32821e9371a1c$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($6cc32821e9371a1c$var$MENU_NAME);
const [$6cc32821e9371a1c$var$createMenuContext, $6cc32821e9371a1c$export$4027731b685e72eb] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($6cc32821e9371a1c$var$MENU_NAME, [
    $6cc32821e9371a1c$var$createCollectionScope,
    $cf1ac5d9fe0e8206$export$722aac194ae923$1,
    $d7bdfb9eb0fdf311$export$c7109489551a4f4$1
]);
const $6cc32821e9371a1c$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923$1();
const $6cc32821e9371a1c$var$useRovingFocusGroupScope = $d7bdfb9eb0fdf311$export$c7109489551a4f4$1();
const [$6cc32821e9371a1c$var$MenuProvider, $6cc32821e9371a1c$var$useMenuContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$MENU_NAME);
const [$6cc32821e9371a1c$var$MenuRootProvider, $6cc32821e9371a1c$var$useMenuRootContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$MENU_NAME);
const $6cc32821e9371a1c$export$d9b273488cd8ce6f = (props)=>{
    const { __scopeMenu: __scopeMenu , open: open = false , children: children , dir: dir , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const [content, setContent] = React.useState(null);
    const isUsingKeyboardRef = React.useRef(false);
    const handleOpenChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onOpenChange);
    const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
    React.useEffect(()=>{
        // Capture phase ensures we set the boolean before any side effects execute
        // in response to the key or pointer event as they might depend on this value.
        const handleKeyDown = ()=>{
            isUsingKeyboardRef.current = true;
            document.addEventListener('pointerdown', handlePointer, {
                capture: true,
                once: true
            });
            document.addEventListener('pointermove', handlePointer, {
                capture: true,
                once: true
            });
        };
        const handlePointer = ()=>isUsingKeyboardRef.current = false
        ;
        document.addEventListener('keydown', handleKeyDown, {
            capture: true
        });
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown, {
                capture: true
            });
            document.removeEventListener('pointerdown', handlePointer, {
                capture: true
            });
            document.removeEventListener('pointermove', handlePointer, {
                capture: true
            });
        };
    }, []);
    return /*#__PURE__*/ React.createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9$1, popperScope, /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$MenuProvider, {
        scope: __scopeMenu,
        open: open,
        onOpenChange: handleOpenChange,
        content: content,
        onContentChange: setContent
    }, /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$MenuRootProvider, {
        scope: __scopeMenu,
        onClose: React.useCallback(()=>handleOpenChange(false)
        , [
            handleOpenChange
        ]),
        isUsingKeyboardRef: isUsingKeyboardRef,
        dir: direction,
        modal: modal
    }, children)));
};
const $6cc32821e9371a1c$export$9fa5ebd18bee4d43 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , ...anchorProps } = props;
    const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    return /*#__PURE__*/ React.createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe7$1, _extends$b({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/* -------------------------------------------------------------------------------------------------
 * MenuPortal
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$PORTAL_NAME = 'MenuPortal';
const [$6cc32821e9371a1c$var$PortalProvider, $6cc32821e9371a1c$var$usePortalContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$PORTAL_NAME, {
    forceMount: undefined
});
const $6cc32821e9371a1c$export$793392f970497feb = (props)=>{
    const { __scopeMenu: __scopeMenu , forceMount: forceMount , children: children , container: container  } = props;
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$PORTAL_NAME, __scopeMenu);
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$PortalProvider, {
        scope: __scopeMenu,
        forceMount: forceMount
    }, /*#__PURE__*/ React.createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, /*#__PURE__*/ React.createElement($f1701beae083dbae$export$602eac185826482c$1, {
        asChild: true,
        container: container
    }, children)));
};
/* -------------------------------------------------------------------------------------------------
 * MenuContent
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$CONTENT_NAME = 'MenuContent';
const [$6cc32821e9371a1c$var$MenuContentProvider, $6cc32821e9371a1c$var$useMenuContentContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$CONTENT_NAME);
const $6cc32821e9371a1c$export$479f0f2f71193efe = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const portalContext = $6cc32821e9371a1c$var$usePortalContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$Collection.Provider, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ React.createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$Collection.Slot, {
        scope: props.__scopeMenu
    }, rootContext.modal ? /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$MenuRootContentModal, _extends$b({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$MenuRootContentNonModal, _extends$b({}, contentProps, {
        ref: forwardedRef
    })))));
});
/* ---------------------------------------------------------------------------------------------- */ const $6cc32821e9371a1c$var$MenuRootContentModal = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const ref = React.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref); // Hide everything from ARIA except the `MenuContent`
    React.useEffect(()=>{
        const content = ref.current;
        if (content) return hideOthers(content);
    }, []);
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$MenuContentImpl, _extends$b({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open // make sure to only disable pointer events when open
        ,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusOutside, (event)=>event.preventDefault()
        , {
            checkForDefaultPrevented: false
        }),
        onDismiss: ()=>context.onOpenChange(false)
    }));
});
const $6cc32821e9371a1c$var$MenuRootContentNonModal = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$MenuContentImpl, _extends$b({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        onDismiss: ()=>context.onOpenChange(false)
    }));
});
/* ---------------------------------------------------------------------------------------------- */ const $6cc32821e9371a1c$var$MenuContentImpl = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , loop: loop = false , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , disableOutsidePointerEvents: disableOutsidePointerEvents , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , disableOutsideScroll: disableOutsideScroll , ...contentProps } = props;
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
    const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
    const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const rovingFocusGroupScope = $6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
    const getItems = $6cc32821e9371a1c$var$useCollection(__scopeMenu);
    const [currentItemId, setCurrentItemId] = React.useState(null);
    const contentRef = React.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, contentRef, context.onContentChange);
    const timerRef = React.useRef(0);
    const searchRef = React.useRef('');
    const pointerGraceTimerRef = React.useRef(0);
    const pointerGraceIntentRef = React.useRef(null);
    const pointerDirRef = React.useRef('right');
    const lastPointerXRef = React.useRef(0);
    const ScrollLockWrapper = disableOutsideScroll ? ReactRemoveScroll : React.Fragment;
    const scrollLockWrapperProps = disableOutsideScroll ? {
        as: $5e63c961fc1ce211$export$8c6ed5c666ac1360,
        allowPinchZoom: true
    } : undefined;
    const handleTypeaheadSearch = (key)=>{
        var _items$find, _items$find2;
        const search = searchRef.current + key;
        const items = getItems().filter((item)=>!item.disabled
        );
        const currentItem = document.activeElement;
        const currentMatch = (_items$find = items.find((item)=>item.ref.current === currentItem
        )) === null || _items$find === void 0 ? void 0 : _items$find.textValue;
        const values = items.map((item)=>item.textValue
        );
        const nextMatch = $6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch);
        const newItem = (_items$find2 = items.find((item)=>item.textValue === nextMatch
        )) === null || _items$find2 === void 0 ? void 0 : _items$find2.ref.current; // Reset `searchRef` 1 second after it was last updated
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== '') timerRef.current = window.setTimeout(()=>updateSearch('')
            , 1000);
        })(search);
        if (newItem) /**
       * Imperative focus during keydown is risky so we prevent React's batching updates
       * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
       */ setTimeout(()=>newItem.focus()
        );
    };
    React.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current)
        ;
    }, []); // Make sure the whole tree has focus guards as our `MenuContent` may be
    // the last element in the DOM (beacuse of the `Portal`)
    $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
    const isPointerMovingToSubmenu = React.useCallback((event)=>{
        var _pointerGraceIntentRe, _pointerGraceIntentRe2;
        const isMovingTowards = pointerDirRef.current === ((_pointerGraceIntentRe = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe === void 0 ? void 0 : _pointerGraceIntentRe.side);
        return isMovingTowards && $6cc32821e9371a1c$var$isPointerInGraceArea(event, (_pointerGraceIntentRe2 = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe2 === void 0 ? void 0 : _pointerGraceIntentRe2.area);
    }, []);
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$MenuContentProvider, {
        scope: __scopeMenu,
        searchRef: searchRef,
        onItemEnter: React.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        onItemLeave: React.useCallback((event)=>{
            var _contentRef$current;
            if (isPointerMovingToSubmenu(event)) return;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
            setCurrentItemId(null);
        }, [
            isPointerMovingToSubmenu
        ]),
        onTriggerLeave: React.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        pointerGraceTimerRef: pointerGraceTimerRef,
        onPointerGraceIntentChange: React.useCallback((intent)=>{
            pointerGraceIntentRef.current = intent;
        }, [])
    }, /*#__PURE__*/ React.createElement(ScrollLockWrapper, scrollLockWrapperProps, /*#__PURE__*/ React.createElement($d3863c46a17e8a28$export$20e40289641fbbb6, {
        asChild: true,
        trapped: trapFocus,
        onMountAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(onOpenAutoFocus, (event)=>{
            var _contentRef$current2;
            // when opening, explicitly focus the content area only and leave
            // `onEntryFocus` in  control of focusing first item
            event.preventDefault();
            (_contentRef$current2 = contentRef.current) === null || _contentRef$current2 === void 0 || _contentRef$current2.focus();
        }),
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ React.createElement($5cb92bef7577960e$export$177fb62ff3ec1f22$1, {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onInteractOutside: onInteractOutside,
        onDismiss: onDismiss
    }, /*#__PURE__*/ React.createElement($d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9$1, _extends$b({
        asChild: true
    }, rovingFocusGroupScope, {
        dir: rootContext.dir,
        orientation: "vertical",
        loop: loop,
        currentTabStopId: currentItemId,
        onCurrentTabStopIdChange: setCurrentItemId,
        onEntryFocus: (event)=>{
            // only focus first item when using keyboard
            if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
        }
    }), /*#__PURE__*/ React.createElement($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2$1, _extends$b({
        role: "menu",
        "aria-orientation": "vertical",
        "data-state": $6cc32821e9371a1c$var$getOpenState(context.open),
        "data-radix-menu-content": "",
        dir: rootContext.dir
    }, popperScope, contentProps, {
        ref: composedRefs,
        style: {
            outline: 'none',
            ...contentProps.style
        },
        onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(contentProps.onKeyDown, (event)=>{
            // submenu key events bubble through portals. We only care about keys in this menu.
            const target = event.target;
            const isKeyDownInside = target.closest('[data-radix-menu-content]') === event.currentTarget;
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
            const isCharacterKey = event.key.length === 1;
            if (isKeyDownInside) {
                // menus should not be navigated using tab key so we prevent it
                if (event.key === 'Tab') event.preventDefault();
                if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
            } // focus first/last item based on key pressed
            const content = contentRef.current;
            if (event.target !== content) return;
            if (!$6cc32821e9371a1c$var$FIRST_LAST_KEYS.includes(event.key)) return;
            event.preventDefault();
            const items = getItems().filter((item)=>!item.disabled
            );
            const candidateNodes = items.map((item)=>item.ref.current
            );
            if ($6cc32821e9371a1c$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
            $6cc32821e9371a1c$var$focusFirst(candidateNodes);
        }),
        onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, (event)=>{
            // clear search buffer when leaving the menu
            if (!event.currentTarget.contains(event.target)) {
                window.clearTimeout(timerRef.current);
                searchRef.current = '';
            }
        }),
        onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, $6cc32821e9371a1c$var$whenMouse((event)=>{
            const target = event.target;
            const pointerXHasChanged = lastPointerXRef.current !== event.clientX; // We don't use `event.movementX` for this check because Safari will
            // always return `0` on a pointer event.
            if (event.currentTarget.contains(target) && pointerXHasChanged) {
                const newDir = event.clientX > lastPointerXRef.current ? 'right' : 'left';
                pointerDirRef.current = newDir;
                lastPointerXRef.current = event.clientX;
            }
        }))
    })))))));
});
/* -------------------------------------------------------------------------------------------------
 * MenuItem
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$ITEM_NAME = 'MenuItem';
const $6cc32821e9371a1c$var$ITEM_SELECT = 'menu.itemSelect';
const $6cc32821e9371a1c$export$2ce376c2cc3355c8 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { disabled: disabled = false , onSelect: onSelect , ...itemProps } = props;
    const ref = React.useRef(null);
    const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
    const contentContext = $6cc32821e9371a1c$var$useMenuContentContext($6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const isPointerDownRef = React.useRef(false);
    const handleSelect = ()=>{
        const menuItem = ref.current;
        if (!disabled && menuItem) {
            const itemSelectEvent = new CustomEvent($6cc32821e9371a1c$var$ITEM_SELECT, {
                bubbles: true,
                cancelable: true
            });
            menuItem.addEventListener($6cc32821e9371a1c$var$ITEM_SELECT, (event)=>onSelect === null || onSelect === void 0 ? void 0 : onSelect(event)
            , {
                once: true
            });
            $8927f6f2acc4f386$export$6d1a0317bde7de7f$1(menuItem, itemSelectEvent);
            if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
            else rootContext.onClose();
        }
    };
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$MenuItemImpl, _extends$b({}, itemProps, {
        ref: composedRefs,
        disabled: disabled,
        onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, handleSelect),
        onPointerDown: (event)=>{
            var _props$onPointerDown;
            (_props$onPointerDown = props.onPointerDown) === null || _props$onPointerDown === void 0 || _props$onPointerDown.call(props, event);
            isPointerDownRef.current = true;
        },
        onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerUp, (event)=>{
            var _event$currentTarget;
            // Pointer down can move to a different menu item which should activate it on pointer up.
            // We dispatch a click for selection to allow composition with click based triggers and to
            // prevent Firefox from getting stuck in text selection mode when the menu closes.
            if (!isPointerDownRef.current) (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || _event$currentTarget.click();
        }),
        onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== '';
            if (disabled || isTypingAhead && event.key === ' ') return;
            if ($6cc32821e9371a1c$var$SELECTION_KEYS.includes(event.key)) {
                event.currentTarget.click();
                /**
         * We prevent default browser behaviour for selection keys as they should trigger
         * a selection only:
         * - prevents space from scrolling the page.
         * - if keydown causes focus to move, prevents keydown from firing on the new target.
         */ event.preventDefault();
            }
        })
    }));
});
/* ---------------------------------------------------------------------------------------------- */ const $6cc32821e9371a1c$var$MenuItemImpl = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , disabled: disabled = false , textValue: textValue , ...itemProps } = props;
    const contentContext = $6cc32821e9371a1c$var$useMenuContentContext($6cc32821e9371a1c$var$ITEM_NAME, __scopeMenu);
    const rovingFocusGroupScope = $6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
    const ref = React.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const [isFocused, setIsFocused] = React.useState(false); // get the item's `.textContent` as default strategy for typeahead `textValue`
    const [textContent, setTextContent] = React.useState('');
    React.useEffect(()=>{
        const menuItem = ref.current;
        if (menuItem) {
            var _menuItem$textContent;
            setTextContent(((_menuItem$textContent = menuItem.textContent) !== null && _menuItem$textContent !== void 0 ? _menuItem$textContent : '').trim());
        }
    }, [
        itemProps.children
    ]);
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$Collection.ItemSlot, {
        scope: __scopeMenu,
        disabled: disabled,
        textValue: textValue !== null && textValue !== void 0 ? textValue : textContent
    }, /*#__PURE__*/ React.createElement($d7bdfb9eb0fdf311$export$6d08773d2e66f8f2$1, _extends$b({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled
    }), /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({
        role: "menuitem",
        "data-highlighted": isFocused ? '' : undefined,
        "aria-disabled": disabled || undefined,
        "data-disabled": disabled ? '' : undefined
    }, itemProps, {
        ref: composedRefs,
        onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, $6cc32821e9371a1c$var$whenMouse((event)=>{
            if (disabled) contentContext.onItemLeave(event);
            else {
                contentContext.onItemEnter(event);
                if (!event.defaultPrevented) {
                    const item = event.currentTarget;
                    item.focus();
                }
            }
        })),
        onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerLeave, $6cc32821e9371a1c$var$whenMouse((event)=>contentContext.onItemLeave(event)
        )),
        onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, ()=>setIsFocused(true)
        ),
        onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, ()=>setIsFocused(false)
        )
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * MenuRadioGroup
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$RADIO_GROUP_NAME = 'MenuRadioGroup';
$6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$RADIO_GROUP_NAME, {
    value: undefined,
    onValueChange: ()=>{}
});
/* -------------------------------------------------------------------------------------------------
 * MenuItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$ITEM_INDICATOR_NAME = 'MenuItemIndicator';
$6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, {
    checked: false
});
const $6cc32821e9371a1c$export$1cec7dcdd713e220 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , ...separatorProps } = props;
    return /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({
        role: "separator",
        "aria-orientation": "horizontal"
    }, separatorProps, {
        ref: forwardedRef
    }));
});
/* -------------------------------------------------------------------------------------------------
 * MenuSub
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$SUB_NAME = 'MenuSub';
const [$6cc32821e9371a1c$var$MenuSubProvider, $6cc32821e9371a1c$var$useMenuSubContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$SUB_NAME);
const $6cc32821e9371a1c$export$71bdb9d1e2909932 = (props)=>{
    const { __scopeMenu: __scopeMenu , children: children , open: open = false , onOpenChange: onOpenChange  } = props;
    const parentMenuContext = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$SUB_NAME, __scopeMenu);
    const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const [trigger, setTrigger] = React.useState(null);
    const [content, setContent] = React.useState(null);
    const handleOpenChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onOpenChange); // Prevent the parent menu from reopening with open submenus.
    React.useEffect(()=>{
        if (parentMenuContext.open === false) handleOpenChange(false);
        return ()=>handleOpenChange(false)
        ;
    }, [
        parentMenuContext.open,
        handleOpenChange
    ]);
    return /*#__PURE__*/ React.createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9$1, popperScope, /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$MenuProvider, {
        scope: __scopeMenu,
        open: open,
        onOpenChange: handleOpenChange,
        content: content,
        onContentChange: setContent
    }, /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$MenuSubProvider, {
        scope: __scopeMenu,
        contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
        triggerId: $1746a345f3d73bb7$export$f680877a34711e37(),
        trigger: trigger,
        onTriggerChange: setTrigger
    }, children)));
};
/* -------------------------------------------------------------------------------------------------
 * MenuSubTrigger
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$SUB_TRIGGER_NAME = 'MenuSubTrigger';
const $6cc32821e9371a1c$export$5fbbb3ba7297405f = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const subContext = $6cc32821e9371a1c$var$useMenuSubContext($6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const contentContext = $6cc32821e9371a1c$var$useMenuContentContext($6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const openTimerRef = React.useRef(null);
    const { pointerGraceTimerRef: pointerGraceTimerRef , onPointerGraceIntentChange: onPointerGraceIntentChange  } = contentContext;
    const scope = {
        __scopeMenu: props.__scopeMenu
    };
    const clearOpenTimer = React.useCallback(()=>{
        if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
    }, []);
    React.useEffect(()=>clearOpenTimer
    , [
        clearOpenTimer
    ]);
    React.useEffect(()=>{
        const pointerGraceTimer = pointerGraceTimerRef.current;
        return ()=>{
            window.clearTimeout(pointerGraceTimer);
            onPointerGraceIntentChange(null);
        };
    }, [
        pointerGraceTimerRef,
        onPointerGraceIntentChange
    ]);
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$export$9fa5ebd18bee4d43, _extends$b({
        asChild: true
    }, scope), /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$MenuItemImpl, _extends$b({
        id: subContext.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": subContext.contentId,
        "data-state": $6cc32821e9371a1c$var$getOpenState(context.open)
    }, props, {
        ref: $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, subContext.onTriggerChange) // This is redundant for mouse users but we cannot determine pointer type from
        ,
        onClick: (event)=>{
            var _props$onClick;
            (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, event);
            if (props.disabled || event.defaultPrevented) return;
            /**
       * We manually focus because iOS Safari doesn't always focus on click (e.g. buttons)
       * and we rely heavily on `onFocusOutside` for submenus to close when switching
       * between separate submenus.
       */ event.currentTarget.focus();
            if (!context.open) context.onOpenChange(true);
        },
        onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, $6cc32821e9371a1c$var$whenMouse((event)=>{
            contentContext.onItemEnter(event);
            if (event.defaultPrevented) return;
            if (!props.disabled && !context.open && !openTimerRef.current) {
                contentContext.onPointerGraceIntentChange(null);
                openTimerRef.current = window.setTimeout(()=>{
                    context.onOpenChange(true);
                    clearOpenTimer();
                }, 100);
            }
        })),
        onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerLeave, $6cc32821e9371a1c$var$whenMouse((event)=>{
            var _context$content;
            clearOpenTimer();
            const contentRect = (_context$content = context.content) === null || _context$content === void 0 ? void 0 : _context$content.getBoundingClientRect();
            if (contentRect) {
                var _context$content2;
                // TODO: make sure to update this when we change positioning logic
                const side = (_context$content2 = context.content) === null || _context$content2 === void 0 ? void 0 : _context$content2.dataset.side;
                const rightSide = side === 'right';
                const bleed = rightSide ? -5 : 5;
                const contentNearEdge = contentRect[rightSide ? 'left' : 'right'];
                const contentFarEdge = contentRect[rightSide ? 'right' : 'left'];
                contentContext.onPointerGraceIntentChange({
                    area: [
                        // consistently within polygon bounds
                        {
                            x: event.clientX + bleed,
                            y: event.clientY
                        },
                        {
                            x: contentNearEdge,
                            y: contentRect.top
                        },
                        {
                            x: contentFarEdge,
                            y: contentRect.top
                        },
                        {
                            x: contentFarEdge,
                            y: contentRect.bottom
                        },
                        {
                            x: contentNearEdge,
                            y: contentRect.bottom
                        }
                    ],
                    side: side
                });
                window.clearTimeout(pointerGraceTimerRef.current);
                pointerGraceTimerRef.current = window.setTimeout(()=>contentContext.onPointerGraceIntentChange(null)
                , 300);
            } else {
                contentContext.onTriggerLeave(event);
                if (event.defaultPrevented) return; // There's 100ms where the user may leave an item before the submenu was opened.
                contentContext.onPointerGraceIntentChange(null);
            }
        })),
        onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== '';
            if (props.disabled || isTypingAhead && event.key === ' ') return;
            if ($6cc32821e9371a1c$var$SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
                var _context$content3;
                context.onOpenChange(true); // The trigger may hold focus if opened via pointer interaction
                // so we ensure content is given focus again when switching to keyboard.
                (_context$content3 = context.content) === null || _context$content3 === void 0 || _context$content3.focus(); // prevent window from scrolling
                event.preventDefault();
            }
        })
    })));
});
/* -------------------------------------------------------------------------------------------------
 * MenuSubContent
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$SUB_CONTENT_NAME = 'MenuSubContent';
const $6cc32821e9371a1c$export$e7142ab31822bde6 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const portalContext = $6cc32821e9371a1c$var$usePortalContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount , ...subContentProps } = props;
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const subContext = $6cc32821e9371a1c$var$useMenuSubContext($6cc32821e9371a1c$var$SUB_CONTENT_NAME, props.__scopeMenu);
    const ref = React.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$Collection.Provider, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ React.createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$Collection.Slot, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ React.createElement($6cc32821e9371a1c$var$MenuContentImpl, _extends$b({
        id: subContext.contentId,
        "aria-labelledby": subContext.triggerId
    }, subContentProps, {
        ref: composedRefs,
        align: "start",
        side: rootContext.dir === 'rtl' ? 'left' : 'right',
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        trapFocus: false,
        onOpenAutoFocus: (event)=>{
            var _ref$current;
            // when opening a submenu, focus content for keyboard users only
            if (rootContext.isUsingKeyboardRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
            event.preventDefault();
        } // The menu might close because of focusing another menu item in the parent menu. We
        ,
        onCloseAutoFocus: (event)=>event.preventDefault()
        ,
        onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusOutside, (event)=>{
            // We prevent closing when the trigger is focused to avoid triggering a re-open animation
            // on pointer interaction.
            if (event.target !== subContext.trigger) context.onOpenChange(false);
        }),
        onEscapeKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onEscapeKeyDown, rootContext.onClose),
        onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event)=>{
            // Submenu key events bubble through portals. We only care about keys in this menu.
            const isKeyDownInside = event.currentTarget.contains(event.target);
            const isCloseKey = $6cc32821e9371a1c$var$SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
            if (isKeyDownInside && isCloseKey) {
                var _subContext$trigger;
                context.onOpenChange(false); // We focus manually because we prevented it in `onCloseAutoFocus`
                (_subContext$trigger = subContext.trigger) === null || _subContext$trigger === void 0 || _subContext$trigger.focus(); // prevent window from scrolling
                event.preventDefault();
            }
        })
    })))));
});
/* -----------------------------------------------------------------------------------------------*/ function $6cc32821e9371a1c$var$getOpenState(open) {
    return open ? 'open' : 'closed';
}
function $6cc32821e9371a1c$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $6cc32821e9371a1c$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]
    );
}
/**
 * This is the "meat" of the typeahead matching logic. It takes in all the values,
 * the search and the current match, and returns the next match (or `undefined`).
 *
 * We normalize the search because if a user has repeatedly pressed a character,
 * we want the exact same behavior as if we only had that one character
 * (ie. cycle through options starting with that character)
 *
 * We also reorder the values by wrapping the array around the current match.
 * This is so we always look forward from the current match, and picking the first
 * match will always be the correct one.
 *
 * Finally, if the normalized search is exactly one character, we exclude the
 * current match from the values because otherwise it would be the first to match always
 * and focus would never move. This is as opposed to the regular case, where we
 * don't want focus to move if the current match still matches.
 */ function $6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]
    );
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
    let wrappedValues = $6cc32821e9371a1c$var$wrapArray(values, Math.max(currentMatchIndex, 0));
    const excludeCurrentMatch = normalizedSearch.length === 1;
    if (excludeCurrentMatch) wrappedValues = wrappedValues.filter((v)=>v !== currentMatch
    );
    const nextMatch = wrappedValues.find((value)=>value.toLowerCase().startsWith(normalizedSearch.toLowerCase())
    );
    return nextMatch !== currentMatch ? nextMatch : undefined;
}
// Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $6cc32821e9371a1c$var$isPointInPolygon(point, polygon) {
    const { x: x , y: y  } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y; // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $6cc32821e9371a1c$var$isPointerInGraceArea(event, area) {
    if (!area) return false;
    const cursorPos = {
        x: event.clientX,
        y: event.clientY
    };
    return $6cc32821e9371a1c$var$isPointInPolygon(cursorPos, area);
}
function $6cc32821e9371a1c$var$whenMouse(handler) {
    return (event)=>event.pointerType === 'mouse' ? handler(event) : undefined
    ;
}
const $6cc32821e9371a1c$export$be92b6f5f03c0fe9 = $6cc32821e9371a1c$export$d9b273488cd8ce6f;
const $6cc32821e9371a1c$export$b688253958b8dfe7 = $6cc32821e9371a1c$export$9fa5ebd18bee4d43;
const $6cc32821e9371a1c$export$602eac185826482c = $6cc32821e9371a1c$export$793392f970497feb;
const $6cc32821e9371a1c$export$7c6e2c02157bb7d2 = $6cc32821e9371a1c$export$479f0f2f71193efe;
const $6cc32821e9371a1c$export$6d08773d2e66f8f2 = $6cc32821e9371a1c$export$2ce376c2cc3355c8;
const $6cc32821e9371a1c$export$1ff3c3f08ae963c0 = $6cc32821e9371a1c$export$1cec7dcdd713e220;
const $6cc32821e9371a1c$export$d7a01e11500dfb6f = $6cc32821e9371a1c$export$71bdb9d1e2909932;
const $6cc32821e9371a1c$export$2ea8a7a591ac5eac = $6cc32821e9371a1c$export$5fbbb3ba7297405f;
const $6cc32821e9371a1c$export$6d4de93b380beddf = $6cc32821e9371a1c$export$e7142ab31822bde6;

/* -------------------------------------------------------------------------------------------------
 * DropdownMenu
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$DROPDOWN_MENU_NAME = 'DropdownMenu';
const [$d08ef79370b62062$var$createDropdownMenuContext, $d08ef79370b62062$export$c0623cd925aeb687] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($d08ef79370b62062$var$DROPDOWN_MENU_NAME, [
    $6cc32821e9371a1c$export$4027731b685e72eb
]);
const $d08ef79370b62062$var$useMenuScope = $6cc32821e9371a1c$export$4027731b685e72eb();
const [$d08ef79370b62062$var$DropdownMenuProvider, $d08ef79370b62062$var$useDropdownMenuContext] = $d08ef79370b62062$var$createDropdownMenuContext($d08ef79370b62062$var$DROPDOWN_MENU_NAME);
const $d08ef79370b62062$export$e44a253a59704894 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , children: children , dir: dir , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const triggerRef = React.useRef(null);
    const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ React.createElement($d08ef79370b62062$var$DropdownMenuProvider, {
        scope: __scopeDropdownMenu,
        triggerId: $1746a345f3d73bb7$export$f680877a34711e37(),
        triggerRef: triggerRef,
        contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: React.useCallback(()=>setOpen((prevOpen)=>!prevOpen
            )
        , [
            setOpen
        ]),
        modal: modal
    }, /*#__PURE__*/ React.createElement($6cc32821e9371a1c$export$be92b6f5f03c0fe9, _extends$b({}, menuScope, {
        open: open,
        onOpenChange: setOpen,
        dir: dir,
        modal: modal
    }), children));
};
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuTrigger
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$TRIGGER_NAME = 'DropdownMenuTrigger';
const $d08ef79370b62062$export$d2469213b3befba9 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , disabled: disabled = false , ...triggerProps } = props;
    const context = $d08ef79370b62062$var$useDropdownMenuContext($d08ef79370b62062$var$TRIGGER_NAME, __scopeDropdownMenu);
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$export$b688253958b8dfe7, _extends$b({
        asChild: true
    }, menuScope), /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$b({
        type: "button",
        id: context.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : undefined,
        "data-state": context.open ? 'open' : 'closed',
        "data-disabled": disabled ? '' : undefined,
        disabled: disabled
    }, triggerProps, {
        ref: $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, context.triggerRef),
        onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) {
                context.onOpenToggle(); // prevent trigger focusing when opening
                // this allows the content to be given focus without competition
                if (!context.open) event.preventDefault();
            }
        }),
        onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event)=>{
            if (disabled) return;
            if ([
                'Enter',
                ' '
            ].includes(event.key)) context.onOpenToggle();
            if (event.key === 'ArrowDown') context.onOpenChange(true); // prevent keydown from scrolling window / first focused item to execute
            // that keydown (inadvertently closing the menu)
            if ([
                'Enter',
                ' ',
                'ArrowDown'
            ].includes(event.key)) event.preventDefault();
        })
    })));
});
const $d08ef79370b62062$export$cd369b4d4d54efc9 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...portalProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$export$602eac185826482c, _extends$b({}, menuScope, portalProps));
};
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuContent
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$CONTENT_NAME = 'DropdownMenuContent';
const $d08ef79370b62062$export$6e76d93a37c01248 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...contentProps } = props;
    const context = $d08ef79370b62062$var$useDropdownMenuContext($d08ef79370b62062$var$CONTENT_NAME, __scopeDropdownMenu);
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const hasInteractedOutsideRef = React.useRef(false);
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$export$7c6e2c02157bb7d2, _extends$b({
        id: context.contentId,
        "aria-labelledby": context.triggerId
    }, menuScope, contentProps, {
        ref: forwardedRef,
        onCloseAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            if (!hasInteractedOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
            hasInteractedOutsideRef.current = false; // Always prevent auto focus because we either focus manually or want user agent focus
            event.preventDefault();
        }),
        onInteractOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onInteractOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: {
            ...props.style,
            // re-namespace exposed content custom property
            ['--radix-dropdown-menu-content-transform-origin']: 'var(--radix-popper-transform-origin)'
        }
    }));
});
const $d08ef79370b62062$export$ed97964d1871885d = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...itemProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$export$6d08773d2e66f8f2, _extends$b({}, menuScope, itemProps, {
        ref: forwardedRef
    }));
});
const $d08ef79370b62062$export$da160178fd3bc7e9 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...separatorProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$export$1ff3c3f08ae963c0, _extends$b({}, menuScope, separatorProps, {
        ref: forwardedRef
    }));
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSub
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$export$2f307d81a64f5442 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , children: children , open: openProp , onOpenChange: onOpenChange , defaultOpen: defaultOpen  } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$export$d7a01e11500dfb6f, _extends$b({}, menuScope, {
        open: open,
        onOpenChange: setOpen
    }), children);
};
const $d08ef79370b62062$export$21dcb7ec56f874cf = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...subTriggerProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$export$2ea8a7a591ac5eac, _extends$b({}, menuScope, subTriggerProps, {
        ref: forwardedRef
    }));
});
const $d08ef79370b62062$export$f34ec8bc2482cc5f = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...subContentProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ React.createElement($6cc32821e9371a1c$export$6d4de93b380beddf, _extends$b({}, menuScope, subContentProps, {
        ref: forwardedRef,
        style: {
            ...props.style,
            // re-namespace exposed content custom property
            ['--radix-dropdown-menu-content-transform-origin']: 'var(--radix-popper-transform-origin)'
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$export$be92b6f5f03c0fe9 = $d08ef79370b62062$export$e44a253a59704894;
const $d08ef79370b62062$export$41fb9f06171c75f4 = $d08ef79370b62062$export$d2469213b3befba9;
const $d08ef79370b62062$export$602eac185826482c = $d08ef79370b62062$export$cd369b4d4d54efc9;
const $d08ef79370b62062$export$7c6e2c02157bb7d2 = $d08ef79370b62062$export$6e76d93a37c01248;
const $d08ef79370b62062$export$6d08773d2e66f8f2 = $d08ef79370b62062$export$ed97964d1871885d;
const $d08ef79370b62062$export$1ff3c3f08ae963c0 = $d08ef79370b62062$export$da160178fd3bc7e9;
const $d08ef79370b62062$export$d7a01e11500dfb6f = $d08ef79370b62062$export$2f307d81a64f5442;
const $d08ef79370b62062$export$2ea8a7a591ac5eac = $d08ef79370b62062$export$21dcb7ec56f874cf;
const $d08ef79370b62062$export$6d4de93b380beddf = $d08ef79370b62062$export$f34ec8bc2482cc5f;

const useOnClickOutside = ({ ref, handler }) => {
    React.useEffect(() => {
        const listener = (event) => {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
};

const useContentDropCountdown = (contentDropTimeRemaining) => {
    const displayRef = React.useRef(null);
    React.useEffect(() => {
        if (!contentDropTimeRemaining || contentDropTimeRemaining <= 0) {
            if (displayRef.current) {
                displayRef.current.textContent = '';
            }
            return;
        }
        const nowUtc = Date.now();
        const endTimeUtc = nowUtc + contentDropTimeRemaining;
        const updateDisplay = () => {
            const currentUtc = Date.now();
            const remaining = endTimeUtc - currentUtc;
            if (remaining <= 0) {
                if (displayRef.current) {
                    displayRef.current.textContent = '';
                }
                return;
            }
            const totalSeconds = Math.floor(remaining / 1000);
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            if (displayRef.current) {
                displayRef.current.textContent = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            }
        };
        updateDisplay();
        const interval = setInterval(updateDisplay, 1000);
        return () => clearInterval(interval);
    }, [contentDropTimeRemaining]);
    return displayRef;
};

const useViewport = () => {
    const [width, setWidth] = React.useState(window.innerWidth);
    const [height, setHeight] = React.useState(window.innerHeight);
    React.useEffect(() => {
        const handleWindowResize = () => {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, []);
    return { width, height };
};

const useItemsPerSlide = () => {
    const { width } = useViewport();
    const theme = styled.useTheme();
    if (width >= Number.parseInt(theme.sizes.lg, 10))
        return 3;
    if (width >= Number.parseInt(theme.sizes.md, 10))
        return 2;
    return 1;
};

/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
const faBars = {
  prefix: 'fas',
  iconName: 'bars',
  icon: [448, 512, ["navicon"], "f0c9", "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"]
};
const faCircleExclamation = {
  prefix: 'fas',
  iconName: 'circle-exclamation',
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faExclamationCircle = faCircleExclamation;
const faEyeSlash = {
  prefix: 'fas',
  iconName: 'eye-slash',
  icon: [640, 512, [], "f070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"]
};
const faFire = {
  prefix: 'fas',
  iconName: 'fire',
  icon: [448, 512, [128293], "f06d", "M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"]
};
const faCircleCheck$1 = {
  prefix: 'fas',
  iconName: 'circle-check',
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faCheckCircle$1 = faCircleCheck$1;
const faSnowflake = {
  prefix: 'fas',
  iconName: 'snowflake',
  icon: [448, 512, [10052, 10054], "f2dc", "M224 0c17.7 0 32 14.3 32 32l0 30.1 15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49 0 70.3 61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7l0 70.3 49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15 0 30.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-30.1-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49 0-70.3-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3l0-70.3L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15L192 32c0-17.7 14.3-32 32-32z"]
};
const faArrowUpRightFromSquare = {
  prefix: 'fas',
  iconName: 'arrow-up-right-from-square',
  icon: [512, 512, ["external-link"], "f08e", "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"]
};
const faArrowRight = {
  prefix: 'fas',
  iconName: 'arrow-right',
  icon: [448, 512, [8594], "f061", "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"]
};
const faWrench = {
  prefix: 'fas',
  iconName: 'wrench',
  icon: [512, 512, [128295], "f0ad", "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7L336 192c-8.8 0-16-7.2-16-16l0-57.4c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faEye = {
  prefix: 'fas',
  iconName: 'eye',
  icon: [576, 512, [128065], "f06e", "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"]
};
const faDoorClosed = {
  prefix: 'fas',
  iconName: 'door-closed',
  icon: [576, 512, [128682], "f52a", "M96 64c0-35.3 28.7-64 64-64L416 0c35.3 0 64 28.7 64 64l0 384 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-112 0-288 0L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0L96 64zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faArrowLeft = {
  prefix: 'fas',
  iconName: 'arrow-left',
  icon: [448, 512, [8592], "f060", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]
};
const faCircleInfo = {
  prefix: 'fas',
  iconName: 'circle-info',
  icon: [512, 512, ["info-circle"], "f05a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faInfoCircle = faCircleInfo;
const faMinus = {
  prefix: 'fas',
  iconName: 'minus',
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"]
};
const faCaretDown = {
  prefix: 'fas',
  iconName: 'caret-down',
  icon: [320, 512, [], "f0d7", "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
};
const faAngleDown = {
  prefix: 'fas',
  iconName: 'angle-down',
  icon: [448, 512, [8964], "f107", "M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"]
};
const faChevronDown$1 = {
  prefix: 'fas',
  iconName: 'chevron-down',
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
};
const faXmark$1 = {
  prefix: 'fas',
  iconName: 'xmark',
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
};
const faChevronLeft = {
  prefix: 'fas',
  iconName: 'chevron-left',
  icon: [320, 512, [9001], "f053", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
};
const faChevronRight = {
  prefix: 'fas',
  iconName: 'chevron-right',
  icon: [320, 512, [9002], "f054", "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
};
const faCheck = {
  prefix: 'fas',
  iconName: 'check',
  icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
};
const faTriangleExclamation = {
  prefix: 'fas',
  iconName: 'triangle-exclamation',
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faExclamationTriangle = faTriangleExclamation;
const faShare = {
  prefix: 'fas',
  iconName: 'share',
  icon: [512, 512, ["mail-forward"], "f064", "M307 34.8c-11.5 5.1-19 16.6-19 29.2l0 64-112 0C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96l96 0 0 64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"]
};
const faCircleXmark = {
  prefix: 'fas',
  iconName: 'circle-xmark',
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};

const usePasswordVisibility = (initialVisible = false) => {
    const [isVisible, setIsVisible] = React.useState(initialVisible);
    const toggle = React.useCallback(() => {
        setIsVisible((prev) => !prev);
    }, []);
    const show = React.useCallback(() => {
        setIsVisible(true);
    }, []);
    const hide = React.useCallback(() => {
        setIsVisible(false);
    }, []);
    return {
        isVisible,
        toggle,
        show,
        hide,
        set: setIsVisible,
        inputType: isVisible ? 'text' : 'password',
        icon: isVisible ? faEyeSlash : faEye,
        ariaLabel: isVisible ? 'Hide password' : 'Show password',
    };
};

const initialValue = {
    theme: 'light',
};

const SwitchThemeContext = React.createContext(initialValue);
const useSwitchTheme = () => {
    const [currentTheme, setCurrentTheme] = React.useState(initialValue.theme);
    const colors = currentTheme === 'dark' ? darkColors : lightColors;
    const themeWithDynamicColors = { ...theme, colors };
    return { themeWithDynamicColors, currentTheme, setCurrentTheme };
};

const slideUpAndFade = styled.keyframes `
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
const slideRightAndFade = styled.keyframes `
 from {
    opacity: 0;
    transform: translateX(-15px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;
const slideDownAndFade = styled.keyframes `
  from {
    opacity: 0;
    transform: translateY(-15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
const slideLeftAndFade = styled.keyframes `
 from {
    opacity: 0;
    transform: translateX(15px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;
const fadeOut$2 = styled.keyframes `
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
const StyledDropdownMenuContent = styled__default["default"]($d08ef79370b62062$export$7c6e2c02157bb7d2) `
  background: ${({ theme, $type }) => ($type === 'streak' ? 'transparent' : theme.colors.background.lighter)};
  border-radius: ${({ theme }) => theme.radius.small};
  ${({ $isDarkMode, $type, theme }) => $isDarkMode && $type === 'notification' ? `border: 1px solid ${theme.colors.background.lightest};` : ''}
  box-shadow: ${({ theme, $type }) => ($type === 'streak' ? 'none' : theme.boxShadow.light)};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  padding: ${({ $type }) => {
    switch ($type) {
        case 'other': {
            return '1.1rem 1rem 0.9rem 1rem';
        }
        case 'notification': {
            return '0';
        }
        case 'avatar': {
            return '1.4rem 1rem 1.4rem 1rem';
        }
        case 'tutor': {
            return '0.8rem 1rem';
        }
        case 'streak': {
            return '0';
        }
        default: {
            return '1.1rem 1rem 1.3rem 1rem';
        }
    }
}};
  margin-left: ${({ $type }) => ($type === 'tutor' ? '-6rem' : '0')};

  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    max-width: 100vw;
  }
  overflow-y: hidden;
  width: ${({ $type }) => {
    switch ($type) {
        case 'other': {
            return '17rem';
        }
        case 'notification': {
            return '48.8rem';
        }
        case 'button': {
            return 'auto';
        }
        case 'streak': {
            return '41.2rem';
        }
        case 'tutor': {
            return '22rem';
        }
        default: {
            return '26.9rem';
        }
    }
}};
  animation-duration: 200ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  z-index: 1000;
  
  ${({ $isAnimated }) => $isAnimated
    ? styled.css `
          &[data-side='top'] {
            animation-name: ${slideUpAndFade};
          }
          &[data-side='right'] {
            animation-name: ${slideLeftAndFade};
          }
          &[data-side='bottom'] {
            animation-name: ${slideDownAndFade};
          }
          &[data-side='left'] {
            animation-name: ${slideRightAndFade};
          }
          &[data-state='closed'] {
            animation-name: ${fadeOut$2};
          }
        `
    : ''}
`;
const StyledDropdownMenuItem = styled__default["default"]($d08ef79370b62062$export$6d08773d2e66f8f2) `
  cursor: pointer;
  display: block;
  border-radius: ${({ theme }) => theme.radius.small};
  transition: all 100ms ease-in-out;
  color: ${({ theme }) => theme.colors.text.main};
  text-decoration: none;
  svg {
    transition: all 100ms ease-in-out;
    path {
      fill: ${({ theme }) => theme.colors.text.main};
    }
  }

  /* Highlight on hover/focus for all dropdown items, including parents with submenus */
  &[data-highlighted],
  &:hover {
    background-color: ${({ theme }) => theme.colors.formSelect.optionHover};
    outline: none;
  }

  ${({ theme, $isSelected }) => $isSelected &&
    styled.css `
      background-color: ${lightColors.info.main};
      color: ${theme.colors.white};

      a {
        color: ${theme.colors.white};
      }

      &:hover {
        background-color: ${lightColors.info.main};
        color: ${theme.colors.white};
      }
      svg path {
        fill: ${theme.colors.white};
      }
    `}
`;
const StyledDropdownMenuItemContent = styled__default["default"].div `
  display: flex;
  width: 100%;
  align-items: center;
  padding: ${({ type, isExtraPadding }) => {
    switch (type) {
        case 'other': {
            return isExtraPadding ? '0.6rem 0 0.6rem 1.6rem' : '0.6rem 0 0.6rem 0.6rem';
        }
        case 'avatar':
        case 'tutor': {
            return '0.5rem 0 0.5rem 1.7rem';
        }
        case 'button': {
            return '0.6rem 1.6rem';
        }
        default: {
            return '1.1rem 1.8rem 1.3rem 1.8rem';
        }
    }
}};
  gap: ${({ type, isNew }) => {
    if (isNew)
        return '1rem';
    if (type === 'main')
        return '1.6rem';
    return '1rem';
}};
  ${({ type }) => type === 'avatar' &&
    styled.css `
      > div {
        display: flex;
        align-items: center;
        svg {
          margin-left: 1rem;
          width: 0.8rem;
          height: 0.8rem;
          path {
            fill: ${({ theme }) => theme.colors.error.main};
            color: ${({ theme }) => theme.colors.error.main};
          }
        }
      }
    `}
  svg {
    fill: ${({ theme }) => theme.colors.text.main};
    color: ${({ theme }) => theme.colors.text.main};
    height: ${({ type }) => (type === 'avatar' ? '1.6rem' : '2rem')};
    width: ${({ type }) => (type === 'main' ? '2.5rem' : '1.8rem')};

    ${({ type, theme }) => type === 'main' &&
    styled.css `
        @media screen and (max-width: ${theme.sizes.md}) {
          width: 2rem;
        }
      `}
  }
`;
const StyledStatusIcon$1 = styled__default["default"](FontAwesomeIcon) ``;
const StyledNewTabLinkIcon = styled__default["default"](FontAwesomeIcon) `
  margin-left: auto;
`;
const StyledDropdownMenuItemTitle = styled__default["default"].p `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: 2rem;
  ${({ type }) => type === 'main'
    ? styled.css `
          line-height: 2rem;
        `
    : ''}
`;
const StyledDropdownMenuItemSubTitle = styled__default["default"].small `
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  line-height: 1.5rem;
  margin-top: 0.4rem;
  display: block;
  text-align: start;
`;
const StyledDropdownMenuSeparator = styled__default["default"]($d08ef79370b62062$export$1ff3c3f08ae963c0) `
  height: 0.1rem;
  background-color: ${({ theme }) => theme.colors.divider};
  margin: 0.9rem 0;
`;
const StyledDropdownMenuItemTitleWrapper = styled__default["default"].div `
  display: flex;
  gap: 0.6rem;
  align-items: center;
`;
const StyledNewFeatureTag$1 = styled__default["default"].span `
  display: flex;
  align-items: center;
  background-color: ${lighterVariations.error.light};
  color: ${accentColors.error.light};
  padding: 0 1rem;
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  border-radius: ${({ theme }) => theme.radius.huge};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  line-height: 1.379rem;
  height: 2rem;
`;
const StyledDropdownMenuSubItemsWrapper = styled__default["default"].div `
  position: relative;
  width: 100%;
`;
const StyledDropdownMenuSubItemsIndicator = styled__default["default"].span `
  display: flex;
  align-items: center;
  margin-left: 1rem;
  color: ${({ theme }) => theme.colors.text.main};
  font-size: 1.2rem;
  opacity: 0.7;
  transition: color 0.2s;

  /* stylelint-disable */
  ${StyledDropdownMenuItem}:hover &,
  ${StyledDropdownMenuItem}[data-highlighted] & {
    color: ${({ theme }) => theme.colors.primary.main};
    opacity: 1;
  }
`;
const StyledDropdownMenuSubMenuContent = styled__default["default"].div `
  position: absolute;
  top: 0;
  left: 100%;
  min-width: 220px;
  background: ${({ theme }) => theme.colors.background.lighter};
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: ${({ theme }) => theme.boxShadow.main};
  padding: 1.6rem 1.2rem;
  z-index: 50;
  margin-left: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;
const StyledDropdownMenuSubMenuTitle = styled__default["default"].h4 `
  font-size: ${({ theme }) => theme.fonts.sizes.title};
  font-weight: bold;
  margin: 0 0 0.2rem 0;
`;
const StyledDropdownMenuSubMenuDescription = styled__default["default"].p `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0 0 0.8rem 0;
`;
const StyledDropdownMenuSubMenuList = styled__default["default"].ul `
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;
const StyledDropdownMenuSubMenuListItem = styled__default["default"].li `
  display: flex;
  align-items: center;
  padding: 0.6rem 0.8rem;
  border-radius: ${({ theme }) => theme.radius.small};
  cursor: pointer;
  transition: background 0.15s;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.main};

  &:hover {
    background: ${({ theme }) => theme.colors.formSelect.optionHover};
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;
const StyledRadixSubContent = styled__default["default"]($d08ef79370b62062$export$6d4de93b380beddf) `
  margin-left: 0.5rem;
  background: ${({ theme }) => theme.colors.background.lighter};
  color: ${({ theme }) => theme.colors.text.main};
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: ${({ theme }) => theme.boxShadow.main};
  padding: 1.1rem;
`;
const StyledSubMenuTriggerButton = styled__default["default"].button `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  color: inherit;
  font: inherit;

  /* Highlight on hover/focus for all dropdown items, including parents with submenus */
  &[data-highlighted],
  &:hover {
    background-color: ${({ theme }) => theme.colors.formSelect.optionHover};
    outline: none;
    border-radius: ${({ theme }) => theme.radius.small};
  }
  /* Re-enable a clear focus ring for keyboard navigation */
  &:focus-visible {
    outline: 0.1px solid ${({ theme }) => theme.colors.formSelect.optionHover};
    outline-offset: 0.1px;
  }
`;
const StyledVerticalContent = styled__default["default"].div `
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
  background: ${({ theme }) => theme.colors.background.lighter};
  padding: 0.7rem 0.7rem 0.7rem 3rem;
  width: 100%;
  transition: display 0.2s ease;
`;
const StyledChevronIcon$1 = styled__default["default"](FontAwesomeIcon) `
  height: 1.3rem;
  opacity: 0.7;
  padding-right: 1.8rem;
  transition: opacity 0.2s ease;
`;

const DropdownMenu = ({ triggerBtn, alignContent = 'center', sideOffset = 25, children, usePortal = true, isAnimated = false, type = 'other', ...radixProps }) => {
    const PortalOrFragment = usePortal ? $d08ef79370b62062$export$602eac185826482c : React.Fragment;
    const { theme } = React.useContext(SwitchThemeContext);
    const isDark = theme === 'dark';
    return (jsxRuntime.exports.jsxs($d08ef79370b62062$export$be92b6f5f03c0fe9, { modal: false, ...radixProps, children: [jsxRuntime.exports.jsx($d08ef79370b62062$export$41fb9f06171c75f4, { asChild: true, children: triggerBtn }), jsxRuntime.exports.jsx(PortalOrFragment, { children: jsxRuntime.exports.jsx(StyledDropdownMenuContent, { "$isAnimated": isAnimated, align: alignContent, sideOffset: sideOffset, "$type": type, "$isDarkMode": isDark, children: children }) })] }));
};

const DropdownMenuItem = ({ children, isSelected = false, shouldCloseOnSelect = true, ...nativeDivAttributesAndRadixItemProps }) => (jsxRuntime.exports.jsx(StyledDropdownMenuItem, { ...nativeDivAttributesAndRadixItemProps, "$isSelected": isSelected, onSelect: (event) => {
        nativeDivAttributesAndRadixItemProps.onSelect(event);
        if (!shouldCloseOnSelect) {
            event.preventDefault();
        }
    }, children: children }));
const DropdownMenuItemAsLink = ({ href, children, isLinkOpenedInNewTab, ...nativeDivAttributesAndRadixItemProps }) => (jsxRuntime.exports.jsx(StyledDropdownMenuItem, { asChild: true, ...nativeDivAttributesAndRadixItemProps, children: jsxRuntime.exports.jsx(reactRouterDom.NavLink, { to: href, state: { pageReferrer: 'navbar' }, ...(isLinkOpenedInNewTab && {
            target: '_blank',
            rel: 'noopener noreferrer',
        }), children: children }) }));

/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const faCaretRight = {
  prefix: 'fas',
  iconName: 'caret-right',
  icon: [256, 512, [], "f0da", "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"]
};
const faRadar = {
  prefix: 'fas',
  iconName: 'radar',
  icon: [512, 512, [], "e024", "M304.8 173.3c-14.3-8.4-31-13.3-48.8-13.3c-53 0-96 43-96 96s43 96 96 96s96-43 96-96l64 0c0 73.5-49.6 135.5-117.2 154.2C290.8 394.7 274.7 384 256 384s-34.8 10.7-42.8 26.2c-51.7-14.3-92.8-53.9-109.4-104.6c14.4-8.3 24.1-23.8 24.1-41.7c0-19.4-11.5-36.1-28-43.7C116.2 149.1 179.9 96 256 96c35.5 0 68.3 11.6 94.9 31.2l22.8-22.8C341.2 79 300.4 64 256 64C163.1 64 85.7 129.9 67.9 217.6C47.2 222.9 32 241.7 32 264c0 23.8 17.3 43.6 40.1 47.4c19.3 64.3 71.5 114.4 137 130.9C213.8 463.8 233 480 256 480s42.2-16.2 46.9-37.8C386.3 421.3 448 345.9 448 256l64 0c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c62.1 0 118.9 22.1 163.3 58.8L463 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-182 182c3.3 7.7 5.1 16.1 5.1 25c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c8.9 0 17.3 1.8 25 5.1l23.8-23.8z"]
};
const faFlag = {
  prefix: 'fas',
  iconName: 'flag',
  icon: [448, 512, [127988, 61725], "f024", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 64 0 368 0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-247.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48l0-16z"]
};
const faBookmark = {
  prefix: 'fas',
  iconName: 'bookmark',
  icon: [384, 512, [128278, 61591], "f02e", "M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"]
};
const faPaperPlaneTop = {
  prefix: 'fas',
  iconName: 'paper-plane-top',
  icon: [512, 512, ["paper-plane-alt", "send"], "e20a", "M57.6 35.8C23.1 20.6-11.3 57.4 6.1 90.9l63 121.2c4.4 8.4 12.6 14.1 22 15.3c0 0 0 0 0 0L266 249.3c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7L91.1 284.6s0 0 0 0c-9.4 1.2-17.6 6.9-22 15.3L6.1 421.1c-17.4 33.5 17 70.2 51.6 55.1L492.9 285.3c25.5-11.2 25.5-47.4 0-58.6L57.6 35.8z"]
};
const faCircleCheck = {
  prefix: 'fas',
  iconName: 'circle-check',
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faCheckCircle = faCircleCheck;
const faCircle = {
  prefix: 'fas',
  iconName: 'circle',
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
const faSpinnerThird = {
  prefix: 'fas',
  iconName: 'spinner-third',
  icon: [512, 512, [], "f3f4", "M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256c0 46.6-12.5 90.4-34.3 128c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96c0-106-86-192-192-192c-17.7 0-32-14.3-32-32z"]
};
const faHandsClapping = {
  prefix: 'fas',
  iconName: 'hands-clapping',
  icon: [512, 512, [], "e1a8", "M336 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm-98.7 7.1l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4zM135 119c9.4-9.4 24.6-9.4 33.9 0L292.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3l0-39.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 153.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L23 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zM433.1 484.9c-24.2 14.5-50.9 22.1-77.7 23.1c48.1-39.6 76.6-99 76.6-162.4l0-98.1c8.2-.1 16-6.4 16-16l0-39.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 153.6c0 57.1-30 110-78.9 139.4zM424.9 18.7c7.4 4.9 9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48c4.9-7.4 14.8-9.3 22.2-4.4z"]
};
const faCircleSmall = {
  prefix: 'fas',
  iconName: 'circle-small',
  icon: [320, 512, [], "e122", "M0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z"]
};
const faThumbsDown = {
  prefix: 'fas',
  iconName: 'thumbs-down',
  icon: [512, 512, [128078, 61576], "f165", "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2l144 0c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48l-97.5 0c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7l0 38.3 0 48 0 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384l64 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32L32 96C14.3 96 0 110.3 0 128L0 352c0 17.7 14.3 32 32 32z"]
};
const faArrowDown = {
  prefix: 'fas',
  iconName: 'arrow-down',
  icon: [384, 512, [8595], "f063", "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"]
};
const faChevronDown = {
  prefix: 'fas',
  iconName: 'chevron-down',
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
};
const faArrowUp = {
  prefix: 'fas',
  iconName: 'arrow-up',
  icon: [384, 512, [8593], "f062", "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"]
};
const faStarSharp = {
  prefix: 'fas',
  iconName: 'star-sharp',
  icon: [576, 512, [], "e28b", "M310.9 16.7C307.7 6.8 298.5 0 288 0s-19.7 6.8-22.9 16.7L214.5 176 56 176c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L172.1 320.7 121.1 480.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7L288 406.4 417.3 506.9c8.3 6.5 19.8 6.8 28.5 .7s12.3-16.9 9.1-27L403.9 320.7 534.7 218.9c8.1-6.3 11.3-17 8-26.7s-12.4-16.2-22.7-16.2l-158.5 0L310.9 16.7z"]
};
const faCircleHalfStroke = {
  prefix: 'fas',
  iconName: 'circle-half-stroke',
  icon: [512, 512, [9680, "adjust"], "f042", "M448 256c0-106-86-192-192-192l0 384c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faCopy = {
  prefix: 'fas',
  iconName: 'copy',
  icon: [448, 512, [], "f0c5", "M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z"]
};
const faXmark = {
  prefix: 'fas',
  iconName: 'xmark',
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
};
const faTrophy = {
  prefix: 'fas',
  iconName: 'trophy',
  icon: [576, 512, [127942], "f091", "M400 0L176 0c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8L24 64C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9L192 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-26.1 0C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24L446.4 64c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112l84.4 0c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6l84.4 0c-5.1 66.3-31.1 111.2-63 142.3z"]
};
const faThumbsUp = {
  prefix: 'fas',
  iconName: 'thumbs-up',
  icon: [512, 512, [128077, 61575], "f164", "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2l144 0c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48l-97.5 0c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3l0-38.3 0-48 0-24.9c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32L0 224c0-17.7 14.3-32 32-32z"]
};

const DropdownMenuItemContent = ({ icon, title, subTitle, type = 'other', urgencyIndicator, isNew, isLinkOpenedInNewTab, isExtraPadding = true, toggle, }) => (jsxRuntime.exports.jsxs(StyledDropdownMenuItemContent, { type: type, isNew: isNew, isExtraPadding: isExtraPadding, children: [icon, jsxRuntime.exports.jsxs("div", { children: [title && (jsxRuntime.exports.jsxs(StyledDropdownMenuItemTitleWrapper, { children: [jsxRuntime.exports.jsx(StyledDropdownMenuItemTitle, { type: type, children: title }), isNew && jsxRuntime.exports.jsx(StyledNewFeatureTag$1, { children: "NEW" })] })), subTitle && jsxRuntime.exports.jsx(StyledDropdownMenuItemSubTitle, { children: subTitle }), urgencyIndicator && jsxRuntime.exports.jsx(StyledStatusIcon$1, { icon: faCircle })] }), toggle, isLinkOpenedInNewTab && jsxRuntime.exports.jsx(StyledNewTabLinkIcon, { icon: faArrowUpRightFromSquare$1 })] }));

const DropdownMenuSeparator = () => jsxRuntime.exports.jsx(StyledDropdownMenuSeparator, {});

const SubMenuContent = ({ subMenuItems }) => (jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, { children: subMenuItems?.map((subMenuItem) => (jsxRuntime.exports.jsx(DropdownMenuItemAsLink, { href: subMenuItem.href || '#', children: jsxRuntime.exports.jsx(DropdownMenuItemContent, { icon: subMenuItem.icon, title: subMenuItem.name, subTitle: subMenuItem.description, type: "other", isNew: subMenuItem.isNew }) }, subMenuItem.name))) }));
const DropdownSubMenuItemAsLink = ({ href, children, subMenuItems, openSubMenu, onOpenChange, layout = 'vertical', }) => {
    if (layout === 'vertical') {
        return (jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx($d08ef79370b62062$export$6d08773d2e66f8f2, { asChild: true, onSelect: (e) => {
                        e.preventDefault();
                    }, children: jsxRuntime.exports.jsxs(StyledSubMenuTriggerButton, { type: "button", onClick: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onOpenChange(openSubMenu === href ? null : href);
                        }, onKeyDown: (e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                e.stopPropagation();
                                onOpenChange(openSubMenu === href ? null : href);
                            }
                        }, role: "button", "aria-haspopup": "menu", "aria-expanded": openSubMenu === href, children: [children, jsxRuntime.exports.jsx(StyledChevronIcon$1, { icon: openSubMenu === href ? faChevronUp : faChevronDown$2 })] }) }), jsxRuntime.exports.jsx(StyledVerticalContent, { "$isOpen": openSubMenu === href, children: jsxRuntime.exports.jsx(SubMenuContent, { subMenuItems: subMenuItems }) })] }));
    }
    return (jsxRuntime.exports.jsxs($d08ef79370b62062$export$d7a01e11500dfb6f, { open: openSubMenu === href, onOpenChange: (open) => onOpenChange(open ? href : null), children: [jsxRuntime.exports.jsx($d08ef79370b62062$export$2ea8a7a591ac5eac, { asChild: true, children: jsxRuntime.exports.jsxs(StyledSubMenuTriggerButton, { type: "button", onClick: (e) => {
                        e.stopPropagation();
                        onOpenChange(openSubMenu === href ? null : href);
                    }, "aria-haspopup": "menu", "aria-expanded": openSubMenu === href, children: [children, jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faChevronRight$1, style: { height: '1.3rem', opacity: 0.7, paddingRight: '1.8rem' } })] }) }), jsxRuntime.exports.jsx(StyledRadixSubContent, { sideOffset: 8, alignOffset: -4, children: jsxRuntime.exports.jsx(SubMenuContent, { subMenuItems: subMenuItems }) })] }));
};

const StyledHeader$1 = styled__default["default"].header `
  width: 100%;
  background: ${({ isTransparent, theme }) => (isTransparent ? 'transparent' : theme.colors.secondary.light)};
  display: flex;
  min-height: ${({ isSplitScreenOpen }) => !isSplitScreenOpen && '9rem'};
  padding: 1rem 0;
  padding: 0.8rem 0;
  ${({ isSticky, isTransparent }) => {
    if (isSticky) {
        return 'position: sticky;';
    }
    if (isTransparent) {
        return 'position: absolute;';
    }
    return 'position: relative;';
}}
  top: 0;
  z-index: 4;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    min-height: 8rem;
  }

  & > div {
    align-items: center;
    display: grid;
    grid-template-columns: auto 1fr;

    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      position: relative;
    }
  }

  div[role='menu'] {
    width: 100%;
  }

  div[type='other'] {
    padding: 0.6rem 1.6rem;
  }
`;
const StyledLogo = styled__default["default"](reactRouterDom.Link) `
  &:focus {
    outline: none;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: none;
  }
`;
const StyledNavButton = styled__default["default"].button `
  display: none;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    background: transparent;
    border: none;
    display: inline-block;
    height: 3rem;
    width: 3rem;

    & > span {
      background-color: white;
      display: flex;
      height: 0.2rem;
      position: relative;
      transition: 0.5s;
      width: 2.5rem;

      &:before,
      &:after {
        background: white;
        content: '';
        height: 0.2rem;
        position: absolute;
        transition: all 0.2s ease-in-out;
        width: 2.5rem;
      }
      &:before {
        bottom: 0.8rem;
      }
      &:after {
        top: 0.8rem;
      }
    }
  }
`;
const StyledHeaderActions = styled__default["default"].div `
  a[data-premium]:hover,
  a[data-paused]:hover {
    color: ${({ theme }) => theme.colors.grey[100]};
  }
`;
const StyledButtonsWrapper$1 = styled__default["default"].div `
  display: flex;
  gap: 2rem;
  justify-content: flex-end;
  align-items: center;

  a[data-link='signin'],
  a[data-link='join']:hover {
    color: ${({ theme }) => theme.colors.grey[100]};
  }

  button[data-link='join']:hover {
    color: ${({ theme }) => theme.colors.grey[100]};
  }

  & > a {
    white-space: nowrap;
  }
`;
const StyledGoPremiumWrapper = styled__default["default"].div `
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    display: block;
  }
`;
const DropdownMenuItemAsLinkGoPremiumCTA = styled__default["default"](DropdownMenuItemAsLink) `
  div {
    width: 100%;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    display: none;
  }
  margin-top: 0.3rem;
`;
const StyledAuthHeaderActionsWrapper = styled__default["default"].div `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.6rem;
  justify-content: flex-end;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    gap: 2.6rem;
  }
`;
const StyledAccessMachine = styled__default["default"].button `
  padding: 1rem 1.6rem;
  color: ${({ theme }) => theme.colors.grey[100]};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  line-height: 1.6rem;
  display: flex;
  align-items: center;
  background-color: ${({ connected, theme }) => (connected ? theme.colors.primary.lighter : lightColors.error.light)};
  border-radius: 3rem;

  &::before {
    content: '';
    display: inline-block;
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 50%;
    background-color: ${({ connected, theme }) => (connected ? theme.colors.primary.main : darkColors.error.main)};
    margin-right: 0.6rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: none;
  }
`;
const StyledSearchWrapper = styled__default["default"].div `
  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    position: relative;
  }
`;
const StyledSearch = styled__default["default"].button `
  padding: 0.8rem 0.6rem;

  svg {
    height: 2rem;
    width: 2rem;

    path {
      fill: ${({ theme }) => theme.colors.alpha[50]};
    }
  }

  &:hover {
    svg path {
      fill: ${({ theme }) => theme.colors.alpha[75]};
    }
  }

  &:active {
    svg path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }

  &:focus,
  &:focus-within,
  &:active {
    border: 1px solid ${darkColors.info.main};
    border-radius: ${({ theme }) => theme.radius.small};
  }
`;
const StyledGoBusinessWrapper = styled__default["default"].div `
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    display: block;
  }
`;

const hoveredItem = styled.css `
  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.alpha[75]};
    & > svg {
      fill: ${({ theme }) => theme.colors.alpha[75]};
      color: ${({ theme }) => theme.colors.alpha[75]};
    }
  }
`;
const StyledItem = styled.css `
  display: block;
  color: ${({ theme }) => theme.colors.alpha[50]};
  text-align: center;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding: 0.8rem;
  }

  &.active {
    color: ${({ theme }) => theme.colors.white};

    & > svg {
      color: ${({ theme }) => theme.colors.primary.main};
      fill: ${({ theme }) => theme.colors.primary.main};
    }
  }

  &:focus {
    outline: none;
  }

  svg {
    fill: ${({ theme }) => theme.colors.alpha[50]};
    color: ${({ theme }) => theme.colors.alpha[50]};
    height: 2.2rem;
    width: auto;
    display: block;
    margin: 0 auto;
  }
`;
const StyledItemLink = styled__default["default"](reactRouterDom.NavLink) `
  ${hoveredItem}
  ${StyledItem}
  text-decoration: none;
`;
const StyledItemButton = styled__default["default"].button `
  ${StyledItem}
  background: none;
  border: none;
  color: ${({ isActive, theme }) => isActive && theme.colors.white};
  & > svg {
    color: ${({ isActive, theme }) => isActive && theme.colors.primary.main};
    fill: ${({ isActive, theme }) => isActive && theme.colors.primary.main};
  }
  ${({ isActive }) => !isActive &&
    styled.css `
      ${hoveredItem};
      &[data-state='open'] {
        color: ${({ theme }) => theme.colors.white};
        & > svg {
          fill: ${({ theme }) => theme.colors.white};
          color: ${({ theme }) => theme.colors.white};
        }
      }
    `}
`;
const StyledNavItemName = styled__default["default"].p `
  margin-top: 0.8rem;
  display: none;

  // on legacy app the text isn't displayed at less than 1100px, in theme we have 1024px

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    display: block;
  }
`;

const NavItem = ({ item, splitScreenMode, isNavItemActive, onMenuOpenChange }) => {
    const type = item.name === 'Other' ? 'other' : 'main';
    const [openSubMenu, setOpenSubMenu] = React.useState(null);
    const shouldShowAsActive = isNavItemActive(item);
    return (jsxRuntime.exports.jsx("li", { children: item.href ? (jsxRuntime.exports.jsxs(StyledItemLink, { "aria-label": `Navigate to ${item.name} page`, to: item.href, state: { pageReferrer: 'navbar' }, className: shouldShowAsActive ? 'active' : '', children: [item.icon, !splitScreenMode && jsxRuntime.exports.jsx(StyledNavItemName, { children: item.name })] })) : (jsxRuntime.exports.jsx(DropdownMenu, { sideOffset: 2, alignContent: "start", usePortal: false, type: type, onOpenChange: onMenuOpenChange, triggerBtn: jsxRuntime.exports.jsxs(StyledItemButton, { "aria-label": `Toggle dropdown for ${item.name}`, isActive: shouldShowAsActive, children: [item.icon, !splitScreenMode && jsxRuntime.exports.jsx(StyledNavItemName, { children: item.name })] }), children: item.subItems?.map((subItem) => subItem.subMenuItems && subItem.subMenuItems.length > 0 ? (jsxRuntime.exports.jsx(DropdownSubMenuItemAsLink, { href: subItem.href, openSubMenu: openSubMenu, onOpenChange: setOpenSubMenu, subMenuItems: subItem.subMenuItems, type: type, children: jsxRuntime.exports.jsx(DropdownMenuItemContent, { icon: subItem.icon, title: subItem.name, subTitle: subItem.description, type: type, isNew: subItem.isNew }) }, subItem.name)) : (jsxRuntime.exports.jsx(DropdownMenuItemAsLink, { href: subItem.href || '#', children: jsxRuntime.exports.jsx(DropdownMenuItemContent, { icon: subItem.icon, title: subItem.name, subTitle: subItem.description, type: type, isNew: subItem.isNew }) }, subItem.name))) })) }, item.name));
};

const StyledNav = styled__default["default"].nav `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: none;
  }
`;
const StyledItems = styled__default["default"].ul `
  align-items: center;
  display: flex;
  gap: 1rem;
`;
styled__default["default"].div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 2rem;
  position: sticky;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.black};

  a {
    justify-content: center;
  }

  a:first-of-type,
  a:last-of-type:hover {
    color: ${({ theme }) => theme.colors.grey[100]};
  }
`;

const DesktopNav = ({ navItems, splitScreenMode, isNavItemActive, isAuth, isChristmas, onLogoHoverChange, onMenuOpenChange, }) => {
    const tryHackmeLogo = 'https://assets.tryhackme.com/img/logo/tryhackme_logo_full.svg';
    const tryHackmeChristmasLogo = 'https://assets.tryhackme.com/img/logo/thm_christmas_logo.svg';
    return (jsxRuntime.exports.jsxs(StyledNav, { "aria-label": "Main", children: [!splitScreenMode && (jsxRuntime.exports.jsx(StyledLogo, { to: isAuth ? '/dashboard' : '/', onMouseEnter: () => onLogoHoverChange?.(true), onMouseLeave: () => onLogoHoverChange?.(false), children: jsxRuntime.exports.jsx("img", { height: isChristmas ? '81px' : '64px', src: isChristmas ? tryHackmeChristmasLogo : tryHackmeLogo, srcSet: isChristmas ? tryHackmeChristmasLogo : tryHackmeLogo, alt: "TryHackMe" }) })), jsxRuntime.exports.jsx(StyledItems, { children: navItems.map((item) => (jsxRuntime.exports.jsx(NavItem, { splitScreenMode: splitScreenMode, item: item, isNavItemActive: isNavItemActive, onMenuOpenChange: onMenuOpenChange }, item.name))) })] }));
};

const StyledDifficulty = styled__default["default"].div `
  display: flex;
  align-items: center;
  gap: ${({ $isExpanded }) => ($isExpanded ? '0.6rem' : '0rem')};
  transition: gap 0.3s ease-out;

  p {
    text-transform: capitalize;
    color: ${({ theme, isDisabled }) => isDisabled && theme.colors.grey[600]};
    font-size: ${({ theme, isSmall, fontSize }) => fontSize || (isSmall ? theme.fonts.sizes.small : theme.fonts.sizes.default)};
    line-height: 1.8rem;
  }

  svg {
    font-size: ${({ theme, isSmall }) => (isSmall ? theme.fonts.sizes.small : theme.fonts.sizes.default)};

    path:first-of-type {
      fill: ${({ theme, isDisabled }) => isDisabled && theme.colors.grey[600]};
      opacity: 0.4;
    }

    path:last-of-type {
      fill: ${({ theme, isDisabled }) => isDisabled && theme.colors.grey[600]};
    }
  }

  &[data-difficulty='info'] {
    svg path {
      fill: ${({ theme, isDisabled }) => isDisabled && theme.colors.grey[600]};
      opacity: 1;
    }
  }

  ${({ theme, isDisabled, isDarkVersion }) => !isDisabled &&
    styled.css `
      &[data-difficulty='info'] {
        p {
          color: ${isDarkVersion ? darkColors.info.main : theme.colors.info.main};
        }

        svg path {
          fill: ${isDarkVersion ? darkColors.info.main : theme.colors.info.main};
        }
      }

      &[data-difficulty='easy'],
      &[data-difficulty='novice'] {
        p {
          color: ${isDarkVersion ? darkColors.success.main : theme.colors.success.main};
        }
        svg path {
          fill: ${isDarkVersion ? darkColors.success.main : theme.colors.success.main};
        }
      }

      &[data-difficulty='medium'],
      &[data-difficulty='intermediate'] {
        p {
          color: ${isDarkVersion ? darkColors.warning.light : theme.colors.warning.light};
        }
        svg path {
          fill: ${isDarkVersion ? darkColors.warning.light : theme.colors.warning.light};
        }
      }

      &[data-difficulty='hard'] {
        p {
          color: ${isDarkVersion ? darkColors.error.main : theme.colors.error.main};
        }
        svg path {
          fill: ${isDarkVersion ? darkColors.error.main : theme.colors.error.main};
        }
      }

      &[data-difficulty='insane'] {
        p {
          color: ${isDarkVersion ? darkColors.level.main : theme.colors.level.main};
        }
        svg path {
          fill: ${isDarkVersion ? darkColors.level.main : theme.colors.level.main};
        }
      }
    `}
`;
const StyledXAxisExpand = styled__default["default"].div `
  white-space: nowrap;
  overflow: hidden;

  max-width: ${({ $isExpanded }) => ($isExpanded ? '200px' : '0px')};
  opacity: ${({ $isExpanded }) => ($isExpanded ? 1 : 0)};
  transition: max-width 0.3s ease-out, opacity 0.3s ease-out;
  will-change: max-width, opacity;
  pointer-events: ${({ $isExpanded }) => ($isExpanded ? 'auto' : 'none')};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const faSignalBars = {
  prefix: 'fad',
  iconName: 'signal-bars',
  icon: [640, 512, ["signal-alt", "signal-alt-4", "signal-bars-strong"], "f690", ["", "M560 0c-26.5 0-48 21.5-48 48l0 416c0 26.5 21.5 48 48 48s48-21.5 48-48l0-416c0-26.5-21.5-48-48-48zM352 176l0 288c0 26.5 21.5 48 48 48s48-21.5 48-48l0-288c0-26.5-21.5-48-48-48s-48 21.5-48 48zM240 256c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48zM80 384c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48z"]]
};
const faSignalBarsStrong = faSignalBars;
const faSignalBarsGood = {
  prefix: 'fad',
  iconName: 'signal-bars-good',
  icon: [640, 512, ["signal-alt-3"], "f693", ["M512 48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 416c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-416z", "M400 128c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48s48-21.5 48-48l0-288c0-26.5-21.5-48-48-48zM192 304l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48s-48 21.5-48 48zM32 432l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]]
};
const faSignalBarsWeak = {
  prefix: 'fad',
  iconName: 'signal-bars-weak',
  icon: [640, 512, ["signal-alt-1"], "f691", ["M192 304l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48s-48 21.5-48 48zM352 176l0 288c0 26.5 21.5 48 48 48s48-21.5 48-48l0-288c0-26.5-21.5-48-48-48s-48 21.5-48 48zM512 48l0 416c0 26.5 21.5 48 48 48s48-21.5 48-48l0-416c0-26.5-21.5-48-48-48s-48 21.5-48 48z", "M32 432c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V432z"]]
};
const faSignalBarsFair = {
  prefix: 'fad',
  iconName: 'signal-bars-fair',
  icon: [640, 512, ["signal-alt-2"], "f692", ["M352 176l0 288c0 26.5 21.5 48 48 48s48-21.5 48-48l0-288c0-26.5-21.5-48-48-48s-48 21.5-48 48zM512 48l0 416c0 26.5 21.5 48 48 48s48-21.5 48-48l0-416c0-26.5-21.5-48-48-48s-48 21.5-48 48z", "M240 256c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48zM80 384c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48z"]]
};

const getDifficultyIcon = (type) => {
    switch (type) {
        case 'info': {
            return faBookOpen;
        }
        case 'easy': {
            return faSignalBarsWeak;
        }
        case 'medium': {
            return faSignalBarsFair;
        }
        case 'intermediate': {
            return faSignalBarsFair;
        }
        case 'hard': {
            return faSignalBarsGood;
        }
        case 'insane': {
            return faSignalBars;
        }
        case 'novice': {
            return faSignalBarsWeak;
        }
        default: {
            return faSignalBarsWeak;
        }
    }
};

const Difficulty = ({ difficulty, isSmall, hasIcon, isDisabled, isDarkVersion, fontSize, $isExpanded = true, }) => {
    const isEasy = difficulty === 'easy' || 'novice';
    return (jsxRuntime.exports.jsxs(StyledDifficulty, { hasIcon: hasIcon, isSmall: isSmall, isDisabled: isDisabled, "$isExpanded": $isExpanded, "data-difficulty": difficulty, isDarkVersion: isDarkVersion, "data-testid": "difficulty", fontSize: fontSize, children: [hasIcon && jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: getDifficultyIcon(difficulty) }), jsxRuntime.exports.jsx(StyledXAxisExpand, { "data-testid": "difficulty-label", "data-expanded": $isExpanded, "$isExpanded": $isExpanded, children: jsxRuntime.exports.jsx("p", { children: difficulty === isEasy ? 'easy' : difficulty }) })] }));
};

exports.DifficultyEnum = void 0;
(function (DifficultyEnum) {
    DifficultyEnum["Medium"] = "medium";
    DifficultyEnum["Info"] = "info";
    DifficultyEnum["Easy"] = "easy";
    DifficultyEnum["Hard"] = "hard";
    DifficultyEnum["Insane"] = "insane";
})(exports.DifficultyEnum || (exports.DifficultyEnum = {}));

const StyledTime$1 = styled__default["default"].div `
  align-items: center;
  display: flex;
  gap: 0.6rem;

  p {
    font-size: 1.4rem;
    line-height: 2rem;
  }

  svg {
    height: 1.4rem;
    width: 1.4rem;
    color: ${({ theme }) => theme.colors.grey[600]};
  }
`;

const Duration = ({ duration }) => (jsxRuntime.exports.jsxs(StyledTime$1, { children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faClock$1 }), jsxRuntime.exports.jsx("p", { "data-text": "duration", children: duration })] }));

function $010c2913dbd2fe3d$export$5cae361ad82dce8b(value) {
    const ref = React.useRef({
        value: value,
        previous: value
    }); // We compare values before making an update to ensure that
    // a change has been made. This ensures the previous value is
    // persisted correctly between renders.
    return React.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}

/* -------------------------------------------------------------------------------------------------
 * Checkbox
 * -----------------------------------------------------------------------------------------------*/ const $e698a72e93240346$var$CHECKBOX_NAME = 'Checkbox';
const [$e698a72e93240346$var$createCheckboxContext, $e698a72e93240346$export$b566c4ff5488ea01] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($e698a72e93240346$var$CHECKBOX_NAME);
const [$e698a72e93240346$var$CheckboxProvider, $e698a72e93240346$var$useCheckboxContext] = $e698a72e93240346$var$createCheckboxContext($e698a72e93240346$var$CHECKBOX_NAME);
const $e698a72e93240346$export$48513f6b9f8ce62d = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox , name: name , checked: checkedProp , defaultChecked: defaultChecked , required: required , disabled: disabled , value: value = 'on' , onCheckedChange: onCheckedChange , ...checkboxProps } = props;
    const [button, setButton] = React.useState(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setButton(node)
    );
    const hasConsumerStoppedPropagationRef = React.useRef(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest('form')) : true;
    const [checked = false, setChecked] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    return /*#__PURE__*/ React.createElement($e698a72e93240346$var$CheckboxProvider, {
        scope: __scopeCheckbox,
        state: checked,
        disabled: disabled
    }, /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$b({
        type: "button",
        role: "checkbox",
        "aria-checked": $e698a72e93240346$var$isIndeterminate(checked) ? 'mixed' : checked,
        "aria-required": required,
        "data-state": $e698a72e93240346$var$getState(checked),
        "data-disabled": disabled ? '' : undefined,
        disabled: disabled,
        value: value
    }, checkboxProps, {
        ref: composedRefs,
        onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event)=>{
            // According to WAI ARIA, Checkboxes don't activate on enter keypress
            if (event.key === 'Enter') event.preventDefault();
        }),
        onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, (event)=>{
            setChecked((prevChecked)=>$e698a72e93240346$var$isIndeterminate(prevChecked) ? true : !prevChecked
            );
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if checkbox is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect checkbox updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ React.createElement($e698a72e93240346$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: 'translateX(-100%)'
        }
    }));
});
/* -------------------------------------------------------------------------------------------------
 * CheckboxIndicator
 * -----------------------------------------------------------------------------------------------*/ const $e698a72e93240346$var$INDICATOR_NAME = 'CheckboxIndicator';
const $e698a72e93240346$export$59aad738f51d1c05 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox , forceMount: forceMount , ...indicatorProps } = props;
    const context = $e698a72e93240346$var$useCheckboxContext($e698a72e93240346$var$INDICATOR_NAME, __scopeCheckbox);
    return /*#__PURE__*/ React.createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || $e698a72e93240346$var$isIndeterminate(context.state) || context.state === true
    }, /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.span, _extends$b({
        "data-state": $e698a72e93240346$var$getState(context.state),
        "data-disabled": context.disabled ? '' : undefined
    }, indicatorProps, {
        ref: forwardedRef,
        style: {
            pointerEvents: 'none',
            ...props.style
        }
    })));
});
/* ---------------------------------------------------------------------------------------------- */ const $e698a72e93240346$var$BubbleInput = (props)=>{
    const { control: control , checked: checked , bubbles: bubbles = true , ...inputProps } = props;
    const ref = React.useRef(null);
    const prevChecked = $010c2913dbd2fe3d$export$5cae361ad82dce8b(checked);
    const controlSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(control); // Bubble checked change to parents (e.g form change event)
    React.useEffect(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, 'checked');
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event('click', {
                bubbles: bubbles
            });
            input.indeterminate = $e698a72e93240346$var$isIndeterminate(checked);
            setChecked.call(input, $e698a72e93240346$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ React.createElement("input", _extends$b({
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: $e698a72e93240346$var$isIndeterminate(checked) ? false : checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: 'absolute',
            pointerEvents: 'none',
            opacity: 0,
            margin: 0
        }
    }));
};
function $e698a72e93240346$var$isIndeterminate(checked) {
    return checked === 'indeterminate';
}
function $e698a72e93240346$var$getState(checked) {
    return $e698a72e93240346$var$isIndeterminate(checked) ? 'indeterminate' : checked ? 'checked' : 'unchecked';
}
const $e698a72e93240346$export$be92b6f5f03c0fe9 = $e698a72e93240346$export$48513f6b9f8ce62d;
const $e698a72e93240346$export$adb584737d712b70 = $e698a72e93240346$export$59aad738f51d1c05;

const StyledCheckboxRoot = styled__default["default"]($e698a72e93240346$export$be92b6f5f03c0fe9) `
  button {
    all: unset;
  }
  background-color: ${({ $isError, theme }) => $isError ? theme.colors.error.lightest : theme.colors.background.secondary};
  border-radius: 0.2rem;
  border: 1px solid ${({ $isError, theme }) => ($isError ? theme.colors.error.main : theme.colors.border.dropdown)};
  height: 2rem;
  width: 2rem;
  transition: border-color 100ms, background-color 100ms;

  &:hover {
    border-color: ${({ theme }) => theme.colors.border.hover};
  }
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.info.main};
  }
  &[data-state='checked'] {
    background-color: ${({ theme }) => theme.colors.success.toggle};
    border-color: ${({ $isError, theme }) => ($isError ? theme.colors.error.main : theme.colors.success.toggle)};
    &:hover {
      border-color: ${({ theme }) => theme.colors.border.hover};
    }
    &:focus {
      border-color: ${({ theme }) => theme.colors.info.main};
    }
  }
  &[data-state='indeterminate'] {
    background-color: ${({ theme }) => theme.colors.success.toggle};
    border-color: ${({ $isError, theme }) => ($isError ? theme.colors.error.main : theme.colors.success.toggle)};
    &:hover {
      border-color: ${({ theme }) => theme.colors.border.hover};
    }
    &:focus {
      border-color: ${({ theme }) => theme.colors.info.main};
    }
  }
  &[data-disabled] {
    pointer-events: none;
    background-color: ${({ theme }) => theme.colors.background.disabled};
    &[data-state='checked'] {
      background-color: ${({ theme }) => theme.colors.background.disabled};
      border-color: ${({ theme }) => theme.colors.border.dropdown};
    }
    &[data-state='indeterminate'] {
      background-color: ${({ theme }) => theme.colors.background.disabled};
      border-color: ${({ theme }) => theme.colors.border.dropdown};
    }
  }
`;
const StyledCheckboxIndicator = styled__default["default"]($e698a72e93240346$export$adb584737d712b70) `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledCheckIcon$4 = styled__default["default"](FontAwesomeIcon) `
  color: ${({ disabled, theme }) => (disabled ? theme.colors.toggle : theme.colors.background.main)};
  width: 1.4rem;
`;
const StyledMinusIcon = styled__default["default"](FontAwesomeIcon) `
  color: ${({ disabled, theme }) => (disabled ? theme.colors.toggle : theme.colors.background.main)};
  width: 1.2rem;
`;

const FormCheckbox = ({ checkboxIndicatorProps, isError, innerRef, ...checkboxRootProps }) => {
    const { disabled, checked } = checkboxRootProps;
    return (jsxRuntime.exports.jsx(StyledCheckboxRoot, { ref: innerRef, ...checkboxRootProps, "$isError": isError, children: jsxRuntime.exports.jsx(StyledCheckboxIndicator, { ...checkboxIndicatorProps, children: checked === 'indeterminate' ? (jsxRuntime.exports.jsx(StyledMinusIcon, { icon: faMinus, disabled: disabled })) : (jsxRuntime.exports.jsx(StyledCheckIcon$4, { icon: faCheck, disabled: disabled })) }) }));
};

const StyledFormErrorMessage = styled__default["default"].p `
  margin-top: 0.6rem;
  margin-bottom: 0;
  font-size: 1.2rem;
  line-height: 1.6rem;
  letter-spacing: 0.04rem;
  color: ${({ theme }) => theme.colors.error.main};
`;

const FormErrorMessage = ({ children, ...nativeParagraphAttributes }) => (jsxRuntime.exports.jsx(StyledFormErrorMessage, { role: "alert", ...nativeParagraphAttributes, children: children }));

const StyledFormInput = styled__default["default"].input `
  ${StyledFormInputBase};
  height: 2rem;
`;
const StyledAdornmentWrapper = styled__default["default"].div `
  align-items: center;
  display: flex;
`;
const StyledAdornmentWrapperLeft = styled__default["default"](StyledAdornmentWrapper) `
  margin-right: 1rem;
`;
const StyledAdornmentWrapperRight = styled__default["default"](StyledAdornmentWrapper) `
  margin-left: 1rem;
`;
const StyledFormInputWrapper = styled__default["default"](StyledFormInputBaseWrapper) `
  padding: 0.7rem 1.2rem 0.7rem 1.6rem;
`;

const FormInput = React.forwardRef(({ isDisabled, isError, leftAdornment, rightAdornment, forceDarkMode = false, ...nativeInputAttributes }, ref) => (jsxRuntime.exports.jsxs(StyledFormInputWrapper, { isDisabled, isError, forceDarkMode, children: [leftAdornment && jsxRuntime.exports.jsx(StyledAdornmentWrapperLeft, { children: leftAdornment }), jsxRuntime.exports.jsx(StyledFormInput, { disabled: isDisabled, ref: ref, ...nativeInputAttributes }), rightAdornment && jsxRuntime.exports.jsx(StyledAdornmentWrapperRight, { children: rightAdornment })] })));

const StyledFormLabel = styled__default["default"].label `
  color: ${({ variant, theme, isDisabled }) => {
    if (isDisabled) {
        return variant === 'toggle' ? theme.colors.grey[600] : theme.colors.text.light;
    }
    return theme.colors.text.main;
}};
  font-size: ${({ variant, theme }) => (variant === 'toggle' ? theme.fonts.sizes.default : theme.fonts.sizes.small)};
  line-height: 1.6rem;
  ${({ variant, labelPosition, customlabelMargin }) => {
    switch (labelPosition) {
        case 'left': {
            return `
            margin-right: ${variant === 'toggle' ? '1rem' : '1.6rem'};
            white-space: nowrap;`;
        }
        case 'right': {
            return `
            margin-left: ${variant === 'toggle' ? '1rem' : '1.6rem'};
            white-space: nowrap;`;
        }
        case 'top': {
            return `margin-bottom: ${customlabelMargin || '0.9rem'}`;
        }
        default: {
            return '';
        }
    }
}}
`;
const RequiredAsterisk = styled__default["default"].span `
  color: ${({ theme }) => theme.colors.error.main};
`;
const StyledOptionalLabel = styled__default["default"].small `
  color: ${({ theme }) => theme.colors.grey[600]};
  margin-left: 0.5rem;
`;

const FormLabel = ({ isDisabled, labelPosition, customlabelMargin, children, isRequired, isOptionalLabel, ...nativeLabelAttributes }) => (jsxRuntime.exports.jsxs(StyledFormLabel, { isDisabled,
    labelPosition,
    customlabelMargin, ...nativeLabelAttributes, children: [children, isRequired && jsxRuntime.exports.jsx(RequiredAsterisk, { children: "*" }), isOptionalLabel && jsxRuntime.exports.jsx(StyledOptionalLabel, { children: "(Optional)" })] }));

const StyledFormTextArea$1 = styled__default["default"].textarea `
  ${StyledFormInputBase};
  padding: 1rem 1.2rem 1rem 1.6rem;
  resize: vertical;
`;
const StyledFormTextAreaWrapper$1 = styled__default["default"](StyledFormInputBaseWrapper) ``;

const FormTextArea = React.forwardRef(({ isDisabled, isError, ...nativeTextAreaAttributes }, ref) => (jsxRuntime.exports.jsx(StyledFormTextAreaWrapper$1, { isDisabled, isError, children: jsxRuntime.exports.jsx(StyledFormTextArea$1, { disabled: isDisabled, ref: ref, ...nativeTextAreaAttributes }) })));

const StyledRadioLabelText = styled__default["default"].span `
  font-weight: 400;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme, disabled, isDark }) => {
    if (disabled) {
        return theme.colors.grey[600];
    }
    if (isDark) {
        return secondaryColors.grey[100];
    }
    return theme.colors.text.main;
}};
`;
const StyledFormRadioLabelWrapper = styled__default["default"].label `
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  align-items: center;
  width: min-content;
  white-space: nowrap;
`;
const StyledRadio = styled__default["default"].input `
  -webkit-appearance: button;
  appearance: none;
  border: 1px solid
    ${({ isError, isDark, theme }) => {
    if (isError) {
        return theme.colors.error.main;
    }
    if (isDark) {
        return theme.colors.radio.hover;
    }
    return theme.colors.radio.default;
}};
  background-color: ${({ isError, isDark, theme }) => {
    if (isError) {
        return theme.colors.error.lightest;
    }
    if (isDark) {
        return secondaryColors.secondary.light;
    }
    return theme.colors.background.secondary;
}};
  height: 2rem;
  width: 2rem;
  font-style: normal;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  ::after {
    content: '';
    display: block;
    border-radius: 50%;
    width: 1rem;
    height: 1rem;
    margin: 0.4rem;
  }
  :checked {
    ::after {
      background-color: ${({ theme, isDark }) => (isDark ? primaryColors.main : theme.colors.radio.selected)};
    }
    border: 1px solid ${({ theme, isDark }) => (isDark ? primaryColors.main : theme.colors.radio.selected)};
  }
  :hover {
    border: 1px solid ${({ theme }) => theme.colors.radio.hover};
  }
  :focus {
    border: 1px solid ${({ theme }) => theme.colors.info.main};
    background-color: ${({ theme, isDark }) => (isDark ? secondaryColors.secondary.light : theme.colors.radio.focus)};
  }
  :disabled {
    cursor: not-allowed;
    border: 1px solid ${({ theme }) => theme.colors.radio.disabledBorder};
    background-color: ${({ theme }) => theme.colors.radio.disabledContent};
    :checked {
      ::after {
        background-color: ${({ theme }) => theme.colors.radio.disabledChecked};
      }
    }
  }
`;
const StyledRadioWrapper = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;
const StyledFormTextAreaWrapper = styled__default["default"].div `
  flex-direction: column;
`;
const StyledFormTextArea = styled__default["default"].div `
  margin-top: 0.625rem;
  width: 18rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.sm}) {
    width: 20rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 44rem;
  }
`;

const FormRadio = React.forwardRef(({ label, disabled, isError, isFreeText, onChangeInput, placeholder, isDark = false, ...rest }, ref) => (jsxRuntime.exports.jsx(StyledFormRadioLabelWrapper, { disabled: disabled, children: jsxRuntime.exports.jsxs(StyledRadioWrapper, { children: [jsxRuntime.exports.jsx(StyledRadio, { "data-testid": `${label}-radio-button`, ref: ref, type: "radio", disabled: disabled, isError: isError, isDark: isDark, ...rest }), jsxRuntime.exports.jsxs(StyledFormTextAreaWrapper, { children: [jsxRuntime.exports.jsx(StyledRadioLabelText, { disabled: disabled, isDark: isDark, children: label }), isFreeText && (jsxRuntime.exports.jsx(StyledFormTextArea, { children: jsxRuntime.exports.jsx(FormTextArea, { placeholder: placeholder, rows: 1, onChange: onChangeInput, isError: isError }) }))] })] }) })));

function memo(getDeps, fn, opts) {
  let deps = opts.initialDeps ?? [];
  let result;
  function memoizedFunction() {
    var _a, _b, _c, _d;
    let depTime;
    if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
    const newDeps = getDeps();
    const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index) => deps[index] !== dep);
    if (!depsChanged) {
      return result;
    }
    deps = newDeps;
    let resultTime;
    if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
    result = fn(...newDeps);
    if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
      const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
      const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
      const resultFpsPercentage = resultEndTime / 16;
      const pad = (str, num) => {
        str = String(str);
        while (str.length < num) {
          str = " " + str;
        }
        return str;
      };
      console.info(
        `%c⏱ ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * resultFpsPercentage, 120)
        )}deg 100% 31%);`,
        opts == null ? void 0 : opts.key
      );
    }
    (_d = opts == null ? void 0 : opts.onChange) == null ? void 0 : _d.call(opts, result);
    return result;
  }
  memoizedFunction.updateDeps = (newDeps) => {
    deps = newDeps;
  };
  return memoizedFunction;
}
function notUndefined(value, msg) {
  if (value === void 0) {
    throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
  } else {
    return value;
  }
}
const approxEqual = (a, b) => Math.abs(a - b) < 1;
const debounce = (targetWindow, fn, ms) => {
  let timeoutId;
  return function(...args) {
    targetWindow.clearTimeout(timeoutId);
    timeoutId = targetWindow.setTimeout(() => fn.apply(this, args), ms);
  };
};

const defaultKeyExtractor = (index) => index;
const defaultRangeExtractor = (range) => {
  const start = Math.max(range.startIndex - range.overscan, 0);
  const end = Math.min(range.endIndex + range.overscan, range.count - 1);
  const arr = [];
  for (let i = start; i <= end; i++) {
    arr.push(i);
  }
  return arr;
};
const observeElementRect = (instance, cb) => {
  const element = instance.scrollElement;
  if (!element) {
    return;
  }
  const targetWindow = instance.targetWindow;
  if (!targetWindow) {
    return;
  }
  const handler = (rect) => {
    const { width, height } = rect;
    cb({ width: Math.round(width), height: Math.round(height) });
  };
  handler(element.getBoundingClientRect());
  if (!targetWindow.ResizeObserver) {
    return () => {
    };
  }
  const observer = new targetWindow.ResizeObserver((entries) => {
    const run = () => {
      const entry = entries[0];
      if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
          handler({ width: box.inlineSize, height: box.blockSize });
          return;
        }
      }
      handler(element.getBoundingClientRect());
    };
    instance.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
  });
  observer.observe(element, { box: "border-box" });
  return () => {
    observer.unobserve(element);
  };
};
const addEventListenerOptions = {
  passive: true
};
const supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const observeElementOffset = (instance, cb) => {
  const element = instance.scrollElement;
  if (!element) {
    return;
  }
  const targetWindow = instance.targetWindow;
  if (!targetWindow) {
    return;
  }
  let offset = 0;
  const fallback = instance.options.useScrollendEvent && supportsScrollend ? () => void 0 : debounce(
    targetWindow,
    () => {
      cb(offset, false);
    },
    instance.options.isScrollingResetDelay
  );
  const createHandler = (isScrolling) => () => {
    const { horizontal, isRtl } = instance.options;
    offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
    fallback();
    cb(offset, isScrolling);
  };
  const handler = createHandler(true);
  const endHandler = createHandler(false);
  endHandler();
  element.addEventListener("scroll", handler, addEventListenerOptions);
  const registerScrollendEvent = instance.options.useScrollendEvent && supportsScrollend;
  if (registerScrollendEvent) {
    element.addEventListener("scrollend", endHandler, addEventListenerOptions);
  }
  return () => {
    element.removeEventListener("scroll", handler);
    if (registerScrollendEvent) {
      element.removeEventListener("scrollend", endHandler);
    }
  };
};
const measureElement = (element, entry, instance) => {
  if (entry == null ? void 0 : entry.borderBoxSize) {
    const box = entry.borderBoxSize[0];
    if (box) {
      const size = Math.round(
        box[instance.options.horizontal ? "inlineSize" : "blockSize"]
      );
      return size;
    }
  }
  return Math.round(
    element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]
  );
};
const elementScroll = (offset, {
  adjustments = 0,
  behavior
}, instance) => {
  var _a, _b;
  const toOffset = offset + adjustments;
  (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null ? void 0 : _b.call(_a, {
    [instance.options.horizontal ? "left" : "top"]: toOffset,
    behavior
  });
};
class Virtualizer {
  constructor(opts) {
    this.unsubs = [];
    this.scrollElement = null;
    this.targetWindow = null;
    this.isScrolling = false;
    this.scrollToIndexTimeoutId = null;
    this.measurementsCache = [];
    this.itemSizeCache = /* @__PURE__ */ new Map();
    this.pendingMeasuredCacheIndexes = [];
    this.scrollRect = null;
    this.scrollOffset = null;
    this.scrollDirection = null;
    this.scrollAdjustments = 0;
    this.elementsCache = /* @__PURE__ */ new Map();
    this.observer = /* @__PURE__ */ (() => {
      let _ro = null;
      const get = () => {
        if (_ro) {
          return _ro;
        }
        if (!this.targetWindow || !this.targetWindow.ResizeObserver) {
          return null;
        }
        return _ro = new this.targetWindow.ResizeObserver((entries) => {
          entries.forEach((entry) => {
            const run = () => {
              this._measureElement(entry.target, entry);
            };
            this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
          });
        });
      };
      return {
        disconnect: () => {
          var _a;
          (_a = get()) == null ? void 0 : _a.disconnect();
          _ro = null;
        },
        observe: (target) => {
          var _a;
          return (_a = get()) == null ? void 0 : _a.observe(target, { box: "border-box" });
        },
        unobserve: (target) => {
          var _a;
          return (_a = get()) == null ? void 0 : _a.unobserve(target);
        }
      };
    })();
    this.range = null;
    this.setOptions = (opts2) => {
      Object.entries(opts2).forEach(([key, value]) => {
        if (typeof value === "undefined") delete opts2[key];
      });
      this.options = {
        debug: false,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: false,
        getItemKey: defaultKeyExtractor,
        rangeExtractor: defaultRangeExtractor,
        onChange: () => {
        },
        measureElement,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: true,
        isRtl: false,
        useScrollendEvent: false,
        useAnimationFrameWithResizeObserver: false,
        ...opts2
      };
    };
    this.notify = (sync) => {
      var _a, _b;
      (_b = (_a = this.options).onChange) == null ? void 0 : _b.call(_a, this, sync);
    };
    this.maybeNotify = memo(
      () => {
        this.calculateRange();
        return [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ];
      },
      (isScrolling) => {
        this.notify(isScrolling);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    );
    this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((d) => d());
      this.unsubs = [];
      this.observer.disconnect();
      this.scrollElement = null;
      this.targetWindow = null;
    };
    this._didMount = () => {
      return () => {
        this.cleanup();
      };
    };
    this._willUpdate = () => {
      var _a;
      const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== scrollElement) {
        this.cleanup();
        if (!scrollElement) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = scrollElement;
        if (this.scrollElement && "ownerDocument" in this.scrollElement) {
          this.targetWindow = this.scrollElement.ownerDocument.defaultView;
        } else {
          this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
        }
        this.elementsCache.forEach((cached) => {
          this.observer.observe(cached);
        });
        this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        });
        this.unsubs.push(
          this.options.observeElementRect(this, (rect) => {
            this.scrollRect = rect;
            this.maybeNotify();
          })
        );
        this.unsubs.push(
          this.options.observeElementOffset(this, (offset, isScrolling) => {
            this.scrollAdjustments = 0;
            this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
            this.scrollOffset = offset;
            this.isScrolling = isScrolling;
            this.maybeNotify();
          })
        );
      }
    };
    this.getSize = () => {
      if (!this.options.enabled) {
        this.scrollRect = null;
        return 0;
      }
      this.scrollRect = this.scrollRect ?? this.options.initialRect;
      return this.scrollRect[this.options.horizontal ? "width" : "height"];
    };
    this.getScrollOffset = () => {
      if (!this.options.enabled) {
        this.scrollOffset = null;
        return 0;
      }
      this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
      return this.scrollOffset;
    };
    this.getFurthestMeasurement = (measurements, index) => {
      const furthestMeasurementsFound = /* @__PURE__ */ new Map();
      const furthestMeasurements = /* @__PURE__ */ new Map();
      for (let m = index - 1; m >= 0; m--) {
        const measurement = measurements[m];
        if (furthestMeasurementsFound.has(measurement.lane)) {
          continue;
        }
        const previousFurthestMeasurement = furthestMeasurements.get(
          measurement.lane
        );
        if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) {
          furthestMeasurements.set(measurement.lane, measurement);
        } else if (measurement.end < previousFurthestMeasurement.end) {
          furthestMeasurementsFound.set(measurement.lane, true);
        }
        if (furthestMeasurementsFound.size === this.options.lanes) {
          break;
        }
      }
      return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b) => {
        if (a.end === b.end) {
          return a.index - b.index;
        }
        return a.end - b.end;
      })[0] : void 0;
    };
    this.getMeasurementOptions = memo(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (count, paddingStart, scrollMargin, getItemKey, enabled) => {
        this.pendingMeasuredCacheIndexes = [];
        return {
          count,
          paddingStart,
          scrollMargin,
          getItemKey,
          enabled
        };
      },
      {
        key: false
      }
    );
    this.getMeasurements = memo(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count, paddingStart, scrollMargin, getItemKey, enabled }, itemSizeCache) => {
        if (!enabled) {
          this.measurementsCache = [];
          this.itemSizeCache.clear();
          return [];
        }
        if (this.measurementsCache.length === 0) {
          this.measurementsCache = this.options.initialMeasurementsCache;
          this.measurementsCache.forEach((item) => {
            this.itemSizeCache.set(item.key, item.size);
          });
        }
        const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const measurements = this.measurementsCache.slice(0, min);
        for (let i = min; i < count; i++) {
          const key = getItemKey(i);
          const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
          const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
          const measuredSize = itemSizeCache.get(key);
          const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
          const end = start + size;
          const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
          measurements[i] = {
            index: i,
            start,
            size,
            end,
            key,
            lane
          };
        }
        this.measurementsCache = measurements;
        return measurements;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    );
    this.calculateRange = memo(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (measurements, outerSize, scrollOffset, lanes) => {
        return this.range = measurements.length > 0 && outerSize > 0 ? calculateRange({
          measurements,
          outerSize,
          scrollOffset,
          lanes
        }) : null;
      },
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    );
    this.getVirtualIndexes = memo(
      () => {
        let startIndex = null;
        let endIndex = null;
        const range = this.calculateRange();
        if (range) {
          startIndex = range.startIndex;
          endIndex = range.endIndex;
        }
        this.maybeNotify.updateDeps([this.isScrolling, startIndex, endIndex]);
        return [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          startIndex,
          endIndex
        ];
      },
      (rangeExtractor, overscan, count, startIndex, endIndex) => {
        return startIndex === null || endIndex === null ? [] : rangeExtractor({
          startIndex,
          endIndex,
          overscan,
          count
        });
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    );
    this.indexFromElement = (node) => {
      const attributeName = this.options.indexAttribute;
      const indexStr = node.getAttribute(attributeName);
      if (!indexStr) {
        console.warn(
          `Missing attribute name '${attributeName}={index}' on measured element.`
        );
        return -1;
      }
      return parseInt(indexStr, 10);
    };
    this._measureElement = (node, entry) => {
      const index = this.indexFromElement(node);
      const item = this.measurementsCache[index];
      if (!item) {
        return;
      }
      const key = item.key;
      const prevNode = this.elementsCache.get(key);
      if (prevNode !== node) {
        if (prevNode) {
          this.observer.unobserve(prevNode);
        }
        this.observer.observe(node);
        this.elementsCache.set(key, node);
      }
      if (node.isConnected) {
        this.resizeItem(index, this.options.measureElement(node, entry, this));
      }
    };
    this.resizeItem = (index, size) => {
      const item = this.measurementsCache[index];
      if (!item) {
        return;
      }
      const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
      const delta = size - itemSize;
      if (delta !== 0) {
        if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) {
          if (process.env.NODE_ENV !== "production" && this.options.debug) {
            console.info("correction", delta);
          }
          this._scrollToOffset(this.getScrollOffset(), {
            adjustments: this.scrollAdjustments += delta,
            behavior: void 0
          });
        }
        this.pendingMeasuredCacheIndexes.push(item.index);
        this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
        this.notify(false);
      }
    };
    this.measureElement = (node) => {
      if (!node) {
        this.elementsCache.forEach((cached, key) => {
          if (!cached.isConnected) {
            this.observer.unobserve(cached);
            this.elementsCache.delete(key);
          }
        });
        return;
      }
      this._measureElement(node, void 0);
    };
    this.getVirtualItems = memo(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (indexes, measurements) => {
        const virtualItems = [];
        for (let k = 0, len = indexes.length; k < len; k++) {
          const i = indexes[k];
          const measurement = measurements[i];
          virtualItems.push(measurement);
        }
        return virtualItems;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    );
    this.getVirtualItemForOffset = (offset) => {
      const measurements = this.getMeasurements();
      if (measurements.length === 0) {
        return void 0;
      }
      return notUndefined(
        measurements[findNearestBinarySearch(
          0,
          measurements.length - 1,
          (index) => notUndefined(measurements[index]).start,
          offset
        )]
      );
    };
    this.getOffsetForAlignment = (toOffset, align, itemSize = 0) => {
      const size = this.getSize();
      const scrollOffset = this.getScrollOffset();
      if (align === "auto") {
        align = toOffset >= scrollOffset + size ? "end" : "start";
      }
      if (align === "center") {
        toOffset += (itemSize - size) / 2;
      } else if (align === "end") {
        toOffset -= size;
      }
      const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
      const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
      const maxOffset = scrollSize - size;
      return Math.max(Math.min(maxOffset, toOffset), 0);
    };
    this.getOffsetForIndex = (index, align = "auto") => {
      index = Math.max(0, Math.min(index, this.options.count - 1));
      const item = this.measurementsCache[index];
      if (!item) {
        return void 0;
      }
      const size = this.getSize();
      const scrollOffset = this.getScrollOffset();
      if (align === "auto") {
        if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) {
          align = "end";
        } else if (item.start <= scrollOffset + this.options.scrollPaddingStart) {
          align = "start";
        } else {
          return [scrollOffset, align];
        }
      }
      const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(toOffset, align, item.size),
        align
      ];
    };
    this.isDynamicMode = () => this.elementsCache.size > 0;
    this.cancelScrollToIndex = () => {
      if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
        this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
        this.scrollToIndexTimeoutId = null;
      }
    };
    this.scrollToOffset = (toOffset, { align = "start", behavior } = {}) => {
      this.cancelScrollToIndex();
      if (behavior === "smooth" && this.isDynamicMode()) {
        console.warn(
          "The `smooth` scroll behavior is not fully supported with dynamic size."
        );
      }
      this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
        adjustments: void 0,
        behavior
      });
    };
    this.scrollToIndex = (index, { align: initialAlign = "auto", behavior } = {}) => {
      index = Math.max(0, Math.min(index, this.options.count - 1));
      this.cancelScrollToIndex();
      if (behavior === "smooth" && this.isDynamicMode()) {
        console.warn(
          "The `smooth` scroll behavior is not fully supported with dynamic size."
        );
      }
      const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
      if (!offsetAndAlign) return;
      const [offset, align] = offsetAndAlign;
      this._scrollToOffset(offset, { adjustments: void 0, behavior });
      if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) {
        this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
          this.scrollToIndexTimeoutId = null;
          const elementInDOM = this.elementsCache.has(
            this.options.getItemKey(index)
          );
          if (elementInDOM) {
            const [latestOffset] = notUndefined(
              this.getOffsetForIndex(index, align)
            );
            if (!approxEqual(latestOffset, this.getScrollOffset())) {
              this.scrollToIndex(index, { align, behavior });
            }
          } else {
            this.scrollToIndex(index, { align, behavior });
          }
        });
      }
    };
    this.scrollBy = (delta, { behavior } = {}) => {
      this.cancelScrollToIndex();
      if (behavior === "smooth" && this.isDynamicMode()) {
        console.warn(
          "The `smooth` scroll behavior is not fully supported with dynamic size."
        );
      }
      this._scrollToOffset(this.getScrollOffset() + delta, {
        adjustments: void 0,
        behavior
      });
    };
    this.getTotalSize = () => {
      var _a;
      const measurements = this.getMeasurements();
      let end;
      if (measurements.length === 0) {
        end = this.options.paddingStart;
      } else if (this.options.lanes === 1) {
        end = ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0;
      } else {
        const endByLane = Array(this.options.lanes).fill(null);
        let endIndex = measurements.length - 1;
        while (endIndex >= 0 && endByLane.some((val) => val === null)) {
          const item = measurements[endIndex];
          if (endByLane[item.lane] === null) {
            endByLane[item.lane] = item.end;
          }
          endIndex--;
        }
        end = Math.max(...endByLane.filter((val) => val !== null));
      }
      return Math.max(
        end - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    };
    this._scrollToOffset = (offset, {
      adjustments,
      behavior
    }) => {
      this.options.scrollToFn(offset, { behavior, adjustments }, this);
    };
    this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map();
      this.notify(false);
    };
    this.setOptions(opts);
  }
}
const findNearestBinarySearch = (low, high, getCurrentValue, value) => {
  while (low <= high) {
    const middle = (low + high) / 2 | 0;
    const currentValue = getCurrentValue(middle);
    if (currentValue < value) {
      low = middle + 1;
    } else if (currentValue > value) {
      high = middle - 1;
    } else {
      return middle;
    }
  }
  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};
function calculateRange({
  measurements,
  outerSize,
  scrollOffset,
  lanes
}) {
  const lastIndex = measurements.length - 1;
  const getOffset = (index) => measurements[index].start;
  if (measurements.length <= lanes) {
    return {
      startIndex: 0,
      endIndex: lastIndex
    };
  }
  let startIndex = findNearestBinarySearch(
    0,
    lastIndex,
    getOffset,
    scrollOffset
  );
  let endIndex = startIndex;
  if (lanes === 1) {
    while (endIndex < lastIndex && measurements[endIndex].end < scrollOffset + outerSize) {
      endIndex++;
    }
  } else if (lanes > 1) {
    const endPerLane = Array(lanes).fill(0);
    while (endIndex < lastIndex && endPerLane.some((pos) => pos < scrollOffset + outerSize)) {
      const item = measurements[endIndex];
      endPerLane[item.lane] = item.end;
      endIndex++;
    }
    const startPerLane = Array(lanes).fill(scrollOffset + outerSize);
    while (startIndex >= 0 && startPerLane.some((pos) => pos >= scrollOffset)) {
      const item = measurements[startIndex];
      startPerLane[item.lane] = item.start;
      startIndex--;
    }
    startIndex = Math.max(0, startIndex - startIndex % lanes);
    endIndex = Math.min(lastIndex, endIndex + (lanes - 1 - endIndex % lanes));
  }
  return { startIndex, endIndex };
}

const useIsomorphicLayoutEffect = typeof document !== "undefined" ? React__namespace.useLayoutEffect : React__namespace.useEffect;
function useVirtualizerBase(options) {
  const rerender = React__namespace.useReducer(() => ({}), {})[1];
  const resolvedOptions = {
    ...options,
    onChange: (instance2, sync) => {
      var _a;
      if (sync) {
        $7SXl2$reactdom.flushSync(rerender);
      } else {
        rerender();
      }
      (_a = options.onChange) == null ? void 0 : _a.call(options, instance2, sync);
    }
  };
  const [instance] = React__namespace.useState(
    () => new Virtualizer(resolvedOptions)
  );
  instance.setOptions(resolvedOptions);
  useIsomorphicLayoutEffect(() => {
    return instance._didMount();
  }, []);
  useIsomorphicLayoutEffect(() => {
    return instance._willUpdate();
  });
  return instance;
}
function useVirtualizer(options) {
  return useVirtualizerBase({
    observeElementRect,
    observeElementOffset,
    scrollToFn: elementScroll,
    ...options
  });
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

var _excluded$5 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref) {
  var _ref$defaultInputValu = _ref.defaultInputValue,
    defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu,
    _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen,
    defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
    propsInputValue = _ref.inputValue,
    propsMenuIsOpen = _ref.menuIsOpen,
    propsOnChange = _ref.onChange,
    propsOnInputChange = _ref.onInputChange,
    propsOnMenuClose = _ref.onMenuClose,
    propsOnMenuOpen = _ref.onMenuOpen,
    propsValue = _ref.value,
    restSelectProps = _objectWithoutProperties(_ref, _excluded$5);
  var _useState = React.useState(propsInputValue !== undefined ? propsInputValue : defaultInputValue),
    _useState2 = _slicedToArray(_useState, 2),
    stateInputValue = _useState2[0],
    setStateInputValue = _useState2[1];
  var _useState3 = React.useState(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen),
    _useState4 = _slicedToArray(_useState3, 2),
    stateMenuIsOpen = _useState4[0],
    setStateMenuIsOpen = _useState4[1];
  var _useState5 = React.useState(propsValue !== undefined ? propsValue : defaultValue),
    _useState6 = _slicedToArray(_useState5, 2),
    stateValue = _useState6[0],
    setStateValue = _useState6[1];
  var onChange = React.useCallback(function (value, actionMeta) {
    if (typeof propsOnChange === 'function') {
      propsOnChange(value, actionMeta);
    }
    setStateValue(value);
  }, [propsOnChange]);
  var onInputChange = React.useCallback(function (value, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === 'function') {
      newValue = propsOnInputChange(value, actionMeta);
    }
    setStateInputValue(newValue !== undefined ? newValue : value);
  }, [propsOnInputChange]);
  var onMenuOpen = React.useCallback(function () {
    if (typeof propsOnMenuOpen === 'function') {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = React.useCallback(function () {
    if (typeof propsOnMenuClose === 'function') {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== undefined ? propsValue : stateValue;
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen,
    onChange: onChange,
    onInputChange: onInputChange,
    onMenuClose: onMenuClose,
    onMenuOpen: onMenuOpen,
    value: value
  });
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

var isDevelopment$2 = false;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  } // this function should always return with a value
  // TS can't understand it though so we make it stop complaining here


  return undefined;
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? !isDevelopment$2 : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      var _tag$parentNode;

      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim$1 (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match$1 (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position$2 = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node$1 (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign(node$1('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position$2 > 0 ? charat(characters, --position$2) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position$2 < length ? charat(characters, position$2++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position$2)
}

/**
 * @return {number}
 */
function caret () {
	return position$2
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position$2 = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim$1(slice(position$2 - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace$1 (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position$2
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position$2
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position$2 - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position$2)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse$1('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse$1 (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace$1(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace(characters, /\f/g, '');
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse$1(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse$1(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse$1(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim$1(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node$1(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node$1(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node$1(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize$1 (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify$2 (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize$1(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize$1(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

var weakMemoize = function weakMemoize(func) {
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // Use non-null assertion because we just checked that the cache `has` it
      // This allows us to remove `undefined` from the return value
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var isBrowser$3 = typeof document !== 'undefined';

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position$2);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position$2 - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value;
  var parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return WEBKIT + value + MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case KEYFRAMES:
      return serialize$1([copy(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);

    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match$1(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize$1([copy(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize$1([copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var getServerStylisCache = isBrowser$3 ? undefined : weakMemoize(function () {
  return memoize(function () {
    return {};
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (isBrowser$3 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }

      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser$3) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' ');

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (!getServerStylisCache) {
    var currentSheet;
    var finalizingPlugins = [stringify$2, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize$1(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify$2];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize$1(compile(styles), _serializer);
    };

    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var reactIs = requireReactIs();
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

var isBrowser$2 = typeof document !== 'undefined';

function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$2 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$2 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$2 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var isDevelopment$1 = false;

var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  var componentSelector = interpolation;

  if (componentSelector.__emotion_styles !== undefined) {

    return componentSelector;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        var keyframes = interpolation;

        if (keyframes.anim === 1) {
          cursor = {
            name: keyframes.name,
            styles: keyframes.styles,
            next: cursor
          };
          return keyframes.name;
        }

        var serializedStyles = interpolation;

        if (serializedStyles.styles !== undefined) {
          var next = serializedStyles.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = serializedStyles.styles + ";";
          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }

        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  var asString = interpolation;

  if (registered == null) {
    return asString;
  }

  var cached = registered[asString];
  return cached !== undefined ? cached : asString;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];

      if (typeof value !== 'object') {
        var asString = value;

        if (registered != null && registered[asString] !== undefined) {
          string += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment$1) {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(key) + ":" + interpolated + ";";
                break;
              }

            default:
              {

                string += key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;

    styles += asTemplateStringsArr[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      var templateStringsArr = strings;

      styles += templateStringsArr[i];
    }
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + match[1];
  }

  var name = murmur2(styles) + identifierName;

  return {
    name: name,
    styles: styles,
    next: cursor
  };
}

var isBrowser$1 = typeof document !== 'undefined';

var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = React__namespace['useInsertion' + 'Effect'] ? React__namespace['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser$1 ? syncFallback : useInsertionEffect || syncFallback;

var isDevelopment = false;

var isBrowser = typeof document !== 'undefined';

var EmotionCacheContext = /* #__PURE__ */React__namespace.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  return /*#__PURE__*/React.forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = React.useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = React.useContext(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/React__namespace.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /* #__PURE__ */React__namespace.createContext({});

var hasOwn$1 = {}.hasOwnProperty;

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {

  var newProps = {};

  for (var _key in props) {
    if (hasOwn$1.call(props, _key)) {
      newProps[_key] = props[_key];
    }
  }

  newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:

  return newProps;
};

var Insertion$1 = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/React__namespace.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, React__namespace.useContext(ThemeContext));

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var _key2 in props) {
    if (hasOwn$1.call(props, _key2) && _key2 !== 'css' && _key2 !== typePropName && (!isDevelopment )) {
      newProps[_key2] = props[_key2];
    }
  }

  newProps.className = className;

  if (ref) {
    newProps.ref = ref;
  }

  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement(Insertion$1, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/React__namespace.createElement(WrappedComponent, newProps));
});

var Emotion$1 = Emotion;

var jsx = function jsx(type, props) {
  // eslint-disable-next-line prefer-rest-params
  var args = arguments;

  if (props == null || !hasOwn$1.call(props, 'css')) {
    return React__namespace.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }

  return React__namespace.createElement.apply(null, createElementArgArray);
};

(function (_jsx) {
  var JSX;

  (function (_JSX) {})(JSX || (JSX = _jsx.JSX || (_jsx.JSX = {})));
})(jsx || (jsx = {}));

function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

function keyframes() {
  var insertable = css$2.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge$1(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    var rules = '';

    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);

      if (!isBrowser && res !== undefined) {
        rules += res;
      }
    }

    if (!isBrowser) {
      return rules;
    }
  });

  if (!isBrowser && rules.length !== 0) {
    var _ref2;

    return /*#__PURE__*/React__namespace.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function (serialized) {
      return serialized.name;
    }).join(' '), _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var ClassNames = /* #__PURE__ */withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && isDevelopment) {
      throw new Error('css can only be used during render');
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && isDevelopment) {
      throw new Error('cx can only be used during render');
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge$1(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: React__namespace.useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
});

function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const sides = ['top', 'right', 'bottom', 'left'];
const alignments = ['start', 'end'];
const placements = /*#__PURE__*/sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter(placement => getAlignment(placement) === alignment), ...allowedPlacements.filter(placement => getAlignment(placement) !== alignment)] : allowedPlacements.filter(placement => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter(placement => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'autoPlacement',
    options,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform,
        elements
      } = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const placements$1 = alignment !== undefined || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));

      // Make `computeCoords` start from the right place.
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []), {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];

      // There are more placements to check.
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map(d => {
        const alignment = getAlignment(d.placement);
        return [d.placement, alignment && crossAxis ?
        // Check along the mainAxis and main crossAxis side.
        d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0) :
        // Check only the mainAxis.
        d.overflows[0], d.overflows];
      }).sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(d => d[2].slice(0,
      // Aligned placements should not check their opposite crossAxis
      // side.
      getAlignment(d[0]) ? 2 : 3).every(v => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$filter2;
                const placement = (_overflowsData$filter2 = overflowsData.filter(d => {
                  if (hasFallbackAxisSideDirection) {
                    const currentSideAxis = getSideAxis(d.placement);
                    return currentSideAxis === initialSideAxis ||
                    // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    currentSideAxis === 'y';
                  }
                  return true;
                }).map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some(side => overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = 'referenceHidden',
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case 'escaped':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};

function getBoundingRect(rects) {
  const minX = min(...rects.map(rect => rect.left));
  const minY = min(...rects.map(rect => rect.top));
  const maxX = max(...rects.map(rect => rect.right));
  const maxY = max(...rects.map(rect => rect.bottom));
  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
function getRectsByLine(rects) {
  const sortedRects = rects.slice().sort((a, b) => a.y - b.y);
  const groups = [];
  let prevRect = null;
  for (let i = 0; i < sortedRects.length; i++) {
    const rect = sortedRects[i];
    if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) {
      groups.push([rect]);
    } else {
      groups[groups.length - 1].push(rect);
    }
    prevRect = rect;
  }
  return groups.map(rect => rectToClientRect(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'inline',
    options,
    async fn(state) {
      const {
        placement,
        elements,
        rects,
        platform,
        strategy
      } = state;
      // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
      // ClientRect's bounds, despite the event listener being triggered. A
      // padding of 2 seems to handle this issue.
      const {
        padding = 2,
        x,
        y
      } = evaluate(options, state);
      const nativeClientRects = Array.from((await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference))) || []);
      const clientRects = getRectsByLine(nativeClientRects);
      const fallback = rectToClientRect(getBoundingRect(nativeClientRects));
      const paddingObject = getPaddingObject(padding);
      function getBoundingClientRect() {
        // There are two rects and they are disjoined.
        if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
          // Find the first rect in which the point is fully inside.
          return clientRects.find(rect => x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
        }

        // There are 2 or more connected rects.
        if (clientRects.length >= 2) {
          if (getSideAxis(placement) === 'y') {
            const firstRect = clientRects[0];
            const lastRect = clientRects[clientRects.length - 1];
            const isTop = getSide(placement) === 'top';
            const top = firstRect.top;
            const bottom = lastRect.bottom;
            const left = isTop ? firstRect.left : lastRect.left;
            const right = isTop ? firstRect.right : lastRect.right;
            const width = right - left;
            const height = bottom - top;
            return {
              top,
              bottom,
              left,
              right,
              width,
              height,
              x: left,
              y: top
            };
          }
          const isLeftSide = getSide(placement) === 'left';
          const maxRight = max(...clientRects.map(rect => rect.right));
          const minLeft = min(...clientRects.map(rect => rect.left));
          const measureRects = clientRects.filter(rect => isLeftSide ? rect.left === minLeft : rect.right === maxRight);
          const top = measureRects[0].top;
          const bottom = measureRects[measureRects.length - 1].bottom;
          const left = minLeft;
          const right = maxRight;
          const width = right - left;
          const height = bottom - top;
          return {
            top,
            bottom,
            left,
            right,
            width,
            height,
            x: left,
            y: top
          };
        }
        return fallback;
      }
      const resetRects = await platform.getElementRects({
        reference: {
          getBoundingClientRect
        },
        floating: elements.floating,
        strategy
      });
      if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) {
        return {
          reset: {
            rects: resetRects
          }
        };
      }
      return {};
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset, state);
      const computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === 'y' ? 'height' : 'width';
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === 'y' ? 'width' : 'height';
        const isOriginSide = ['top', 'left'].includes(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};

function hasWindow() {
  return typeof window !== 'undefined';
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          // If the reference is clipped, the ratio is 0. Throttle the refresh
          // to prevent an infinite loop of updates.
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1000);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
offset;

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
autoPlacement;

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
shift;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
flip;

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
size;

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
hide;

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
arrow;

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
inline;

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
limitShift;

var isClient = typeof document !== 'undefined';

var index$1 = isClient ? React.useLayoutEffect : React.useEffect;

var _excluded$3 = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
// ==============================
// NO OP
// ==============================

var noop = function noop() {};

// ==============================
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/
function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}
function classNames(prefix, state, className) {
  var arr = [className];
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }
  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
}
// ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (isArray$1(value)) return value.filter(Boolean);
  if (_typeof(value) === 'object' && value !== null) return [value];
  return [];
};

// ==============================
// Clean Common Props
// ==============================

var cleanCommonProps = function cleanCommonProps(props) {
  //className
  props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = _objectWithoutProperties(props, _excluded$3);
  return _objectSpread2({}, innerProps);
};

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

// Normalized Scroll Top
// ------------------------------

function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }
  return el.clientHeight;
}

// Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }
  el.scrollTop = top;
}

// Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  if (style.position === 'fixed') return document.documentElement;
  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
}

// Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}

// Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

// ==============================
// Get bounding client object
// ==============================

// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}

// ==============================
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

// ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

// ==============================
// Passive Event Detector
// ==============================

// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
// check for SSR
var w = typeof window !== 'undefined' ? window : {};
if (w.addEventListener && w.removeEventListener) {
  w.addEventListener('p', noop, options);
  w.removeEventListener('p', noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray$1(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps(propsObj) {
  for (var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    properties[_key - 1] = arguments[_key];
  }
  var propsMap = Object.entries(propsObj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return !properties.includes(key);
  });
  return propsMap.reduce(function (newProps, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      val = _ref4[1];
    newProps[key] = val;
    return newProps;
  }, {});
};

function getMenuPlacement(_ref) {
  var preferredMaxHeight = _ref.maxHeight,
    menuEl = _ref.menuEl,
    minHeight = _ref.minHeight,
    preferredPlacement = _ref.placement,
    shouldScroll = _ref.shouldScroll,
    isFixedPosition = _ref.isFixedPosition,
    theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: preferredMaxHeight
  };

  // something went wrong, return default state
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
    scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
    menuBottom = _menuEl$getBoundingCl.bottom,
    menuHeight = _menuEl$getBoundingCl.height,
    menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
    containerTop = _menuEl$offsetParent$.top;
  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (preferredPlacement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      }

      // 4. Forked beviour when there isn't enough space below

      // AUTO: flip the menu, render above
      if (preferredPlacement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = preferredMaxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, preferredMaxHeight);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      }

      // BOTTOM: allow browser to increase scrollable area and immediately set scroll
      if (preferredPlacement === 'bottom') {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = preferredMaxHeight;

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      }

      // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below
      return {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
      };
    default:
      throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
  }
  return defaultState;
}

// Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};
var menuCSS = function menuCSS(_ref2) {
  var _ref3;
  var placement = _ref2.placement,
    _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    spacing = _ref2$theme.spacing,
    colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, _defineProperty(_ref3, alignToControl(placement), '100%'), _defineProperty(_ref3, "backgroundColor", colors.neutral0), _defineProperty(_ref3, "borderRadius", borderRadius), _defineProperty(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty(_ref3, "marginBottom", spacing.menuGutter), _defineProperty(_ref3, "marginTop", spacing.menuGutter), _defineProperty(_ref3, "position", 'absolute'), _defineProperty(_ref3, "width", '100%'), _defineProperty(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /*#__PURE__*/React.createContext(null);

// NOTE: internal only
var MenuPlacer = function MenuPlacer(props) {
  var children = props.children,
    minMenuHeight = props.minMenuHeight,
    maxMenuHeight = props.maxMenuHeight,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition,
    menuShouldScrollIntoView = props.menuShouldScrollIntoView,
    theme = props.theme;
  var _ref4 = React.useContext(PortalPlacementContext) || {},
    setPortalPlacement = _ref4.setPortalPlacement;
  var ref = React.useRef(null);
  var _useState = React.useState(maxMenuHeight),
    _useState2 = _slicedToArray(_useState, 2),
    maxHeight = _useState2[0],
    setMaxHeight = _useState2[1];
  var _useState3 = React.useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    placement = _useState4[0],
    setPlacement = _useState4[1];
  index$1(function () {
    var menuEl = ref.current;
    if (!menuEl) return;

    // DO NOT scroll if position is fixed
    var isFixedPosition = menuPosition === 'fixed';
    var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
    var state = getMenuPlacement({
      maxHeight: maxMenuHeight,
      menuEl: menuEl,
      minHeight: minMenuHeight,
      placement: menuPlacement,
      shouldScroll: shouldScroll,
      isFixedPosition: isFixedPosition,
      theme: theme
    });
    setMaxHeight(state.maxHeight);
    setPlacement(state.placement);
    setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
  }, [maxMenuHeight, menuPlacement, menuPosition, menuShouldScrollIntoView, minMenuHeight, setPortalPlacement, theme]);
  return children({
    ref: ref,
    placerProps: _objectSpread2(_objectSpread2({}, props), {}, {
      placement: placement || coercePlacement(menuPlacement),
      maxHeight: maxHeight
    })
  });
};
var Menu = function Menu(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('menu', props),
    className: cx({
      menu: true
    }, className),
    ref: innerRef
  }, innerProps), children);
};

// ==============================
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref5) {
  var maxHeight = _ref5.maxHeight,
    baseUnit = _ref5.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps,
    innerRef = props.innerRef,
    isMulti = props.isMulti;
  return jsx("div", _extends$b({
    css: getStyles('menuList', props),
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, innerProps), children);
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref6) {
  var _ref6$theme = _ref6.theme,
    baseUnit = _ref6$theme.spacing.baseUnit,
    colors = _ref6$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('noOptionsMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('loadingMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
};

// ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref7) {
  var rect = _ref7.rect,
    offset = _ref7.offset,
    position = _ref7.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = function MenuPortal(_ref8) {
  var appendTo = _ref8.appendTo,
    children = _ref8.children,
    className = _ref8.className,
    controlElement = _ref8.controlElement,
    cx = _ref8.cx,
    innerProps = _ref8.innerProps,
    menuPlacement = _ref8.menuPlacement,
    menuPosition = _ref8.menuPosition,
    getStyles = _ref8.getStyles;
  var menuPortalRef = React.useRef(null);
  var cleanupRef = React.useRef(null);
  var _useState5 = React.useState(coercePlacement(menuPlacement)),
    _useState6 = _slicedToArray(_useState5, 2),
    placement = _useState6[0],
    setPortalPlacement = _useState6[1];
  var portalPlacementContext = React.useMemo(function () {
    return {
      setPortalPlacement: setPortalPlacement
    };
  }, []);
  var _useState7 = React.useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    computedPosition = _useState8[0],
    setComputedPosition = _useState8[1];
  var updateComputedPosition = React.useCallback(function () {
    if (!controlElement) return;
    var rect = getBoundingClientObj(controlElement);
    var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
    var offset = rect[placement] + scrollDistance;
    if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) {
      setComputedPosition({
        offset: offset,
        rect: rect
      });
    }
  }, [controlElement, menuPosition, placement, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width]);
  index$1(function () {
    updateComputedPosition();
  }, [updateComputedPosition]);
  var runAutoUpdate = React.useCallback(function () {
    if (typeof cleanupRef.current === 'function') {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (controlElement && menuPortalRef.current) {
      cleanupRef.current = autoUpdate(controlElement, menuPortalRef.current, updateComputedPosition, {
        elementResize: 'ResizeObserver' in window
      });
    }
  }, [controlElement, updateComputedPosition]);
  index$1(function () {
    runAutoUpdate();
  }, [runAutoUpdate]);
  var setMenuPortalElement = React.useCallback(function (menuPortalElement) {
    menuPortalRef.current = menuPortalElement;
    runAutoUpdate();
  }, [runAutoUpdate]);

  // bail early if required elements aren't present
  if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;

  // same wrapper element whether fixed or portalled
  var menuWrapper = jsx("div", _extends$b({
    ref: setMenuPortalElement,
    css: getStyles('menuPortal', {
      offset: computedPosition.offset,
      position: menuPosition,
      rect: computedPosition.rect
    }),
    className: cx({
      'menu-portal': true
    }, className)
  }, innerProps), children);
  return jsx(PortalPlacementContext.Provider, {
    value: portalPlacementContext
  }, appendTo ? /*#__PURE__*/$7SXl2$reactdom.createPortal(menuWrapper, appendTo) : menuWrapper);
};

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
    isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : undefined,
    pointerEvents: isDisabled ? 'none' : undefined,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    isRtl = props.isRtl;
  return jsx("div", _extends$b({
    css: getStyles('container', props),
    className: cx({
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
};

// ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing,
    isMulti = _ref2.isMulti,
    hasValue = _ref2.hasValue,
    controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
  return {
    alignItems: 'center',
    display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    innerProps = props.innerProps,
    isMulti = props.isMulti,
    getStyles = props.getStyles,
    hasValue = props.hasValue;
  return jsx("div", _extends$b({
    css: getStyles('valueContainer', props),
    className: cx({
      'value-container': true,
      'value-container--is-multi': isMulti,
      'value-container--has-value': hasValue
    }, className)
  }, innerProps), children);
};

// ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    innerProps = props.innerProps,
    getStyles = props.getStyles;
  return jsx("div", _extends$b({
    css: getStyles('indicatorsContainer', props),
    className: cx({
      indicators: true
    }, className)
  }, innerProps), children);
};

var _templateObject;
var _excluded$2 = ["size"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$2 = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};
// ==============================
// Dropdown & Clear Icons
// ==============================

var Svg = function Svg(_ref) {
  var size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return jsx("svg", _extends$b({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$2
  }, props));
};
var CrossIcon = function CrossIcon(props) {
  return jsx(Svg, _extends$b({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return jsx(Svg, _extends$b({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};

// ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3) {
  var isFocused = _ref3.isFocused,
    _ref3$theme = _ref3.theme,
    baseUnit = _ref3$theme.spacing.baseUnit,
    colors = _ref3$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator$1 = function DropdownIndicator(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('dropdownIndicator', props),
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className)
  }, innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }, innerProps), children || jsx(CrossIcon, null));
};

// ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
  var isDisabled = _ref4.isDisabled,
    _ref4$theme = _ref4.theme,
    baseUnit = _ref4$theme.spacing.baseUnit,
    colors = _ref4$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps;
  return jsx("span", _extends$b({}, innerProps, {
    css: getStyles('indicatorSeparator', props),
    className: cx({
      'indicator-separator': true
    }, className)
  }));
};

// ==============================
// Loading
// ==============================

var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
  var isFocused = _ref5.isFocused,
    size = _ref5.size,
    _ref5$theme = _ref5.theme,
    colors = _ref5$theme.colors,
    baseUnit = _ref5$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};
var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
    offset = _ref6.offset;
  return jsx("span", {
    css: /*#__PURE__*/css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : undefined,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};
var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps,
    isRtl = props.isRtl;
  return jsx("div", _extends$b({
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }, innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    _ref$theme = _ref.theme,
    colors = _ref$theme.colors,
    borderRadius = _ref$theme.borderRadius,
    spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};
var Control = function Control(props) {
  var children = props.children,
    cx = props.cx,
    getStyles = props.getStyles,
    className = props.className,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    innerRef = props.innerRef,
    innerProps = props.innerProps,
    menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends$b({
    ref: innerRef,
    css: getStyles('control', props),
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

var _excluded$1 = ["data"];
var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};
var Group = function Group(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    Heading = props.Heading,
    headingProps = props.headingProps,
    innerProps = props.innerProps,
    label = props.label,
    theme = props.theme,
    selectProps = props.selectProps;
  return jsx("div", _extends$b({
    css: getStyles('group', props),
    className: cx({
      group: true
    }, className)
  }, innerProps), jsx(Heading, _extends$b({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), jsx("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: 500,
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var getStyles = props.getStyles,
    cx = props.cx,
    className = props.className;
  var _cleanCommonProps = cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$1);
  return jsx("div", _extends$b({
    css: getStyles('groupHeading', props),
    className: cx({
      'group-heading': true
    }, className)
  }, innerProps));
};

var _excluded$4 = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
    value = _ref.value,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return _objectSpread2({
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80,
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? 'translateZ(0)' : ''
  }, containerStyle);
};
var spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: '1 1 auto',
  display: 'inline-grid',
  gridArea: '1 / 1 / 2 / 3',
  gridTemplateColumns: '0 min-content',
  '&:after': _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre'
  }, spacingStyle)
};
var inputStyle = function inputStyle(isHidden) {
  return _objectSpread2({
    label: 'input',
    color: 'inherit',
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: '100%'
  }, spacingStyle);
};
var Input = function Input(props) {
  var className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    value = props.value;
  var _cleanCommonProps = cleanCommonProps(props),
    innerRef = _cleanCommonProps.innerRef,
    isDisabled = _cleanCommonProps.isDisabled,
    isHidden = _cleanCommonProps.isHidden,
    inputClassName = _cleanCommonProps.inputClassName,
    innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$4);
  return jsx("div", {
    className: cx({
      'input-container': true
    }, className),
    css: getStyles('input', props),
    "data-value": value || ''
  }, jsx("input", _extends$b({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    borderRadius = _ref$theme.borderRadius,
    colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug
  };
};

var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    colors = _ref2$theme.colors,
    cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
    spacing = _ref3$theme.spacing,
    borderRadius = _ref3$theme.borderRadius,
    colors = _ref3$theme.colors,
    isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused ? colors.dangerLight : undefined,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
    innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
    innerProps = _ref5.innerProps;
  return jsx("div", _extends$b({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue(props) {
  var children = props.children,
    className = props.className,
    components = props.components,
    cx = props.cx,
    data = props.data,
    getStyles = props.getStyles,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    removeProps = props.removeProps,
    selectProps = props.selectProps;
  var Container = components.Container,
    Label = components.Label,
    Remove = components.Remove;
  return jsx(ClassNames, null, function (_ref6) {
    var css = _ref6.css,
      emotionCx = _ref6.cx;
    return jsx(Container, {
      data: data,
      innerProps: _objectSpread2({
        className: emotionCx(css(getStyles('multiValue', props)), cx({
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className))
      }, innerProps),
      selectProps: selectProps
    }, jsx(Label, {
      data: data,
      innerProps: {
        className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
          'multi-value__label': true
        }, className))
      },
      selectProps: selectProps
    }, children), jsx(Remove, {
      data: data,
      innerProps: _objectSpread2({
        className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
          'multi-value__remove': true
        }, className)),
        'aria-label': "Remove ".concat(children || 'option')
      }, removeProps),
      selectProps: selectProps
    }));
  });
};

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    isSelected = _ref.isSelected,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
    }
  };
};
var Option$1 = function Option(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    isSelected = props.isSelected,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('option', props),
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    gridArea: '1 / 1 / 2 / 3',
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  };
};
var Placeholder = function Placeholder(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('placeholder', props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};

var css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    gridArea: '1 / 1 / 2 / 3',
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
};
var SingleValue = function SingleValue(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    isDisabled = props.isDisabled,
    innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('singleValue', props),
    className: cx({
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator$1,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option$1,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _objectSpread2(_objectSpread2({}, components), props.components);
};

var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var cache = null;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) {
            return cache.lastResult;
        }
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this,
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// Assistive text to describe visual elements. Hidden for sighted users.
var _ref = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};
var A11yText = function A11yText(props) {
  return jsx("span", _extends$b({
    css: _ref
  }, props));
};

var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable,
      isMulti = props.isMulti,
      isDisabled = props.isDisabled,
      tabSelectsValue = props.tabSelectsValue,
      context = props.context;
    switch (context) {
      case 'menu':
        return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
      case 'input':
        return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
      default:
        return '';
    }
  },
  onChange: function onChange(props) {
    var action = props.action,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      labels = props.labels,
      isDisabled = props.isDisabled;
    switch (action) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option ".concat(label, ", deselected.");
      case 'clear':
        return 'All selected options have been cleared.';
      case 'initial-input-focus':
        return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
      case 'select-option':
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
      default:
        return '';
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context,
      focused = props.focused,
      options = props.options,
      _props$label2 = props.label,
      label = _props$label2 === void 0 ? '' : _props$label2,
      selectValue = props.selectValue,
      isDisabled = props.isDisabled,
      isSelected = props.isSelected;
    var getArrayIndex = function getArrayIndex(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
    };
    if (context === 'value' && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === 'menu') {
      var disabled = isDisabled ? ' disabled' : '';
      var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
      return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
    }
    return '';
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
      resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
  }
};

var LiveRegion = function LiveRegion(props) {
  var ariaSelection = props.ariaSelection,
    focusedOption = props.focusedOption,
    focusedValue = props.focusedValue,
    focusableOptions = props.focusableOptions,
    isFocused = props.isFocused,
    selectValue = props.selectValue,
    selectProps = props.selectProps,
    id = props.id;
  var ariaLiveMessages = selectProps.ariaLiveMessages,
    getOptionLabel = selectProps.getOptionLabel,
    inputValue = selectProps.inputValue,
    isMulti = selectProps.isMulti,
    isOptionDisabled = selectProps.isOptionDisabled,
    isSearchable = selectProps.isSearchable,
    menuIsOpen = selectProps.menuIsOpen,
    options = selectProps.options,
    screenReaderStatus = selectProps.screenReaderStatus,
    tabSelectsValue = selectProps.tabSelectsValue;
  var ariaLabel = selectProps['aria-label'];
  var ariaLive = selectProps['aria-live'];

  // Update aria live message configuration when prop changes
  var messages = React.useMemo(function () {
    return _objectSpread2(_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);

  // Update aria live selected option when prop changes
  var ariaSelected = React.useMemo(function () {
    var message = '';
    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option,
        selectedOptions = ariaSelection.options,
        removedValue = ariaSelection.removedValue,
        removedValues = ariaSelection.removedValues,
        value = ariaSelection.value;
      // select-option when !isMulti does not return option so we assume selected option is value
      var asOption = function asOption(val) {
        return !Array.isArray(val) ? val : null;
      };

      // If there is just one item from the action then get its label
      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel(selected) : '';

      // If there are multiple items from the action then return an array of labels
      var multiSelected = selectedOptions || removedValues || undefined;
      var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
      var onChangeProps = _objectSpread2({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: selected && isOptionDisabled(selected, selectValue),
        label: label,
        labels: labels
      }, ariaSelection);
      message = messages.onChange(onChangeProps);
    }
    return message;
  }, [ariaSelection, messages, isOptionDisabled, selectValue, getOptionLabel]);
  var ariaFocused = React.useMemo(function () {
    var focusMsg = '';
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused: focused,
        label: getOptionLabel(focused),
        isDisabled: isOptionDisabled(focused, selectValue),
        isSelected: isSelected,
        options: focusableOptions,
        context: focused === focusedOption ? 'menu' : 'value',
        selectValue: selectValue
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel, isOptionDisabled, messages, focusableOptions, selectValue]);
  var ariaResults = React.useMemo(function () {
    var resultsMsg = '';
    if (menuIsOpen && options.length && messages.onFilter) {
      var resultsMessage = screenReaderStatus({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue: inputValue,
        resultsMessage: resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus]);
  var ariaGuidance = React.useMemo(function () {
    var guidanceMsg = '';
    if (messages.guidance) {
      var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
      guidanceMsg = messages.guidance({
        'aria-label': ariaLabel,
        context: context,
        isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
        isMulti: isMulti,
        isSearchable: isSearchable,
        tabSelectsValue: tabSelectsValue
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue]);
  var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
  var ScreenReaderText = jsx(React.Fragment, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-context"
  }, ariaContext));
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
  return jsx(React.Fragment, null, jsx(A11yText, {
    id: id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};

var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};
for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};

var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);
var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    // eslint-disable-next-line no-underscore-dangle
    if (option.data.__isNew__) return true;
    var _ignoreCase$ignoreAcc = _objectSpread2({
        ignoreCase: true,
        ignoreAccents: true,
        stringify: defaultStringify,
        trim: true,
        matchFrom: 'any'
      }, config),
      ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
      ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
      stringify = _ignoreCase$ignoreAcc.stringify,
      trim = _ignoreCase$ignoreAcc.trim,
      matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var _excluded = ["innerRef"];
function DummyInput(_ref) {
  var innerRef = _ref.innerRef,
    props = _objectWithoutProperties(_ref, _excluded);
  // Remove animation props not meant for HTML elements
  var filteredProps = removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
  return jsx("input", _extends$b({
    ref: innerRef
  }, filteredProps, {
    css: /*#__PURE__*/css$2({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: 'transparent',
      fontSize: 'inherit',
      gridArea: '1 / 1 / 2 / 3',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(.01)'
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}

var cancelScroll = function cancelScroll(event) {
  event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref) {
  var isEnabled = _ref.isEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var isBottom = React.useRef(false);
  var isTop = React.useRef(false);
  var touchStart = React.useRef(0);
  var scrollTarget = React.useRef(null);
  var handleEventDelta = React.useCallback(function (event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current,
      scrollTop = _scrollTarget$current.scrollTop,
      scrollHeight = _scrollTarget$current.scrollHeight,
      clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;

    // reset bottom/top flags
    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    }

    // bottom limit
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;

      // top limit
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }

    // cancel scroll
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = React.useCallback(function (event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = React.useCallback(function (event) {
    // set touch start so we can calculate touchmove delta
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = React.useCallback(function (event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = React.useCallback(function (el) {
    // bail early if no element is available to attach to
    if (!el) return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener('wheel', onWheel, notPassive);
    el.addEventListener('touchstart', onTouchStart, notPassive);
    el.addEventListener('touchmove', onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = React.useCallback(function (el) {
    // bail early if no element is available to detach from
    if (!el) return;
    el.removeEventListener('wheel', onWheel, false);
    el.removeEventListener('touchstart', onTouchStart, false);
    el.removeEventListener('touchmove', onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  React.useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function () {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function (element) {
    scrollTarget.current = element;
  };
}

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};
function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;
  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref) {
  var isEnabled = _ref.isEnabled,
    _ref$accountForScroll = _ref.accountForScrollbars,
    accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = React.useRef({});
  var scrollTarget = React.useRef(null);
  var addScrollLock = React.useCallback(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      // store any styles already applied to the body
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }

    // apply the lock styles and padding if this is the first scroll lock
    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }

    // account for touch devices
    if (target && isTouchDevice()) {
      // Mobile Safari ignores { overflow: hidden } declaration on the body.
      target.addEventListener('touchmove', preventTouchMove, listenerOptions);

      // Allow scroll on provided target
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }

    // increment active scroll locks
    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = React.useCallback(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;

    // safely decrement active scroll locks
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);

    // reapply original body styles, if any
    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }

    // remove touch listeners
    if (target && isTouchDevice()) {
      target.removeEventListener('touchmove', preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  React.useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function () {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function (element) {
    scrollTarget.current = element;
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var blurSelectInput = function blurSelectInput() {
  return document.activeElement && document.activeElement.blur();
};
var _ref2$1 = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNjcm9sbE1hbmFnZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQStDVSIsImZpbGUiOiJTY3JvbGxNYW5hZ2VyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgRnJhZ21lbnQsIFJlYWN0RWxlbWVudCwgUmVmQ2FsbGJhY2sgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgdXNlU2Nyb2xsQ2FwdHVyZSBmcm9tICcuL3VzZVNjcm9sbENhcHR1cmUnO1xuaW1wb3J0IHVzZVNjcm9sbExvY2sgZnJvbSAnLi91c2VTY3JvbGxMb2NrJztcblxuaW50ZXJmYWNlIFByb3BzIHtcbiAgcmVhZG9ubHkgY2hpbGRyZW46IChyZWY6IFJlZkNhbGxiYWNrPEhUTUxFbGVtZW50PikgPT4gUmVhY3RFbGVtZW50O1xuICByZWFkb25seSBsb2NrRW5hYmxlZDogYm9vbGVhbjtcbiAgcmVhZG9ubHkgY2FwdHVyZUVuYWJsZWQ6IGJvb2xlYW47XG4gIHJlYWRvbmx5IG9uQm90dG9tQXJyaXZlPzogKGV2ZW50OiBXaGVlbEV2ZW50IHwgVG91Y2hFdmVudCkgPT4gdm9pZDtcbiAgcmVhZG9ubHkgb25Cb3R0b21MZWF2ZT86IChldmVudDogV2hlZWxFdmVudCB8IFRvdWNoRXZlbnQpID0+IHZvaWQ7XG4gIHJlYWRvbmx5IG9uVG9wQXJyaXZlPzogKGV2ZW50OiBXaGVlbEV2ZW50IHwgVG91Y2hFdmVudCkgPT4gdm9pZDtcbiAgcmVhZG9ubHkgb25Ub3BMZWF2ZT86IChldmVudDogV2hlZWxFdmVudCB8IFRvdWNoRXZlbnQpID0+IHZvaWQ7XG59XG5cbmNvbnN0IGJsdXJTZWxlY3RJbnB1dCA9ICgpID0+XG4gIGRvY3VtZW50LmFjdGl2ZUVsZW1lbnQgJiYgKGRvY3VtZW50LmFjdGl2ZUVsZW1lbnQgYXMgSFRNTEVsZW1lbnQpLmJsdXIoKTtcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gU2Nyb2xsTWFuYWdlcih7XG4gIGNoaWxkcmVuLFxuICBsb2NrRW5hYmxlZCxcbiAgY2FwdHVyZUVuYWJsZWQgPSB0cnVlLFxuICBvbkJvdHRvbUFycml2ZSxcbiAgb25Cb3R0b21MZWF2ZSxcbiAgb25Ub3BBcnJpdmUsXG4gIG9uVG9wTGVhdmUsXG59OiBQcm9wcykge1xuICBjb25zdCBzZXRTY3JvbGxDYXB0dXJlVGFyZ2V0ID0gdXNlU2Nyb2xsQ2FwdHVyZSh7XG4gICAgaXNFbmFibGVkOiBjYXB0dXJlRW5hYmxlZCxcbiAgICBvbkJvdHRvbUFycml2ZSxcbiAgICBvbkJvdHRvbUxlYXZlLFxuICAgIG9uVG9wQXJyaXZlLFxuICAgIG9uVG9wTGVhdmUsXG4gIH0pO1xuICBjb25zdCBzZXRTY3JvbGxMb2NrVGFyZ2V0ID0gdXNlU2Nyb2xsTG9jayh7IGlzRW5hYmxlZDogbG9ja0VuYWJsZWQgfSk7XG5cbiAgY29uc3QgdGFyZ2V0UmVmOiBSZWZDYWxsYmFjazxIVE1MRWxlbWVudD4gPSAoZWxlbWVudCkgPT4ge1xuICAgIHNldFNjcm9sbENhcHR1cmVUYXJnZXQoZWxlbWVudCk7XG4gICAgc2V0U2Nyb2xsTG9ja1RhcmdldChlbGVtZW50KTtcbiAgfTtcblxuICByZXR1cm4gKFxuICAgIDxGcmFnbWVudD5cbiAgICAgIHtsb2NrRW5hYmxlZCAmJiAoXG4gICAgICAgIDxkaXZcbiAgICAgICAgICBvbkNsaWNrPXtibHVyU2VsZWN0SW5wdXR9XG4gICAgICAgICAgY3NzPXt7IHBvc2l0aW9uOiAnZml4ZWQnLCBsZWZ0OiAwLCBib3R0b206IDAsIHJpZ2h0OiAwLCB0b3A6IDAgfX1cbiAgICAgICAgLz5cbiAgICAgICl9XG4gICAgICB7Y2hpbGRyZW4odGFyZ2V0UmVmKX1cbiAgICA8L0ZyYWdtZW50PlxuICApO1xufVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};
function ScrollManager(_ref) {
  var children = _ref.children,
    lockEnabled = _ref.lockEnabled,
    _ref$captureEnabled = _ref.captureEnabled,
    captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive: onBottomArrive,
    onBottomLeave: onBottomLeave,
    onTopArrive: onTopArrive,
    onTopLeave: onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return jsx(React.Fragment, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2$1
  }), children(targetRef));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWFJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZTogc3RyaW5nO1xuICByZWFkb25seSBvbkZvY3VzOiBGb2N1c0V2ZW50SGFuZGxlcjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0+ID0gKHsgbmFtZSwgb25Gb2N1cyB9KSA9PiAoXG4gIDxpbnB1dFxuICAgIHJlcXVpcmVkXG4gICAgbmFtZT17bmFtZX1cbiAgICB0YWJJbmRleD17LTF9XG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var RequiredInput = function RequiredInput(_ref) {
  var name = _ref.name,
    onFocus = _ref.onFocus;
  return jsx("input", {
    required: true,
    name: name,
    tabIndex: -1,
    onFocus: onFocus,
    css: _ref2
    // Prevent `Switching from uncontrolled to controlled` error
    ,
    value: "",
    onChange: function onChange() {}
  });
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css,
  valueContainer: valueContainerCSS
};

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var baseUnit = 4;
// The minimum height of the control
var controlHeight = 38;
// The amount of space between the control and menu */
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps$1 = {
  'aria-live': 'polite',
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true
};
function toCategorizedOption(props, option, selectValue, index) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);
  var isSelected = _isOptionSelected(props, option, selectValue);
  var label = getOptionLabel(props, option);
  var value = getOptionValue(props, option);
  return {
    type: 'option',
    data: option,
    isDisabled: isDisabled,
    isSelected: isSelected,
    label: label,
    value: value,
    index: index
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function (groupOrOption, groupOrOptionIndex) {
    if ('options' in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function (categorizedOption) {
        return isFocusable(props, categorizedOption);
      });
      return categorizedOptions.length > 0 ? {
        type: 'group',
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : undefined;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function (option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue,
    inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
  var data = categorizedOption.data,
    isSelected = categorizedOption.isSelected,
    label = categorizedOption.label,
    value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label: label,
    value: value,
    data: data
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue,
    lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      // the focused value is still in the selectValue, return it
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      // the focusedValue is not present in the next selectValue array by
      // reference, so return the new value at the same index
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getOptionLabel = function getOptionLabel(props, data) {
  return props.getOptionLabel(data);
};
var getOptionValue = function getOptionValue(props, data) {
  return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;
  if (typeof props.isOptionSelected === 'function') {
    return props.isOptionSelected(option, selectValue);
  }
  var candidate = getOptionValue(props, option);
  return selectValue.some(function (i) {
    return getOptionValue(props, i) === candidate;
  });
}
function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
  var hideSelectedOptions = props.hideSelectedOptions,
    isMulti = props.isMulti;
  if (hideSelectedOptions === undefined) return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);
  var _super = _createSuper(Select);
  // Misc. Instance Properties
  // ------------------------------

  // TODO

  // Refs
  // ------------------------------

  // Lifecycle
  // ------------------------------

  function Select(_props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: undefined,
      prevProps: undefined
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.instancePrefix = '';
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;
    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };
    _this.inputRef = null;
    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        name = _this$props.name;
      actionMeta.name = name;
      _this.ariaOnChange(newValue, actionMeta);
      onChange(newValue, actionMeta);
    };
    _this.setValue = function (newValue, action, option) {
      var _this$props2 = _this.props,
        closeMenuOnSelect = _this$props2.closeMenuOnSelect,
        isMulti = _this$props2.isMulti,
        inputValue = _this$props2.inputValue;
      _this.onInputChange('', {
        action: 'set-value',
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      }
      // when the select value should change, we should reset focusedValue
      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };
    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
        blurInputOnSelect = _this$props3.blurInputOnSelect,
        isMulti = _this$props3.isMulti,
        name = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue(multiValueAsValue(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        })), 'deselect-option', newValue);
      } else if (!isDisabled) {
        // Select option if option is not disabled
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), 'select-option', newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), 'select-option');
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: 'select-option',
          option: newValue,
          name: name
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function (removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: 'remove-value',
        removedValue: removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function () {
      var selectValue = _this.state.selectValue;
      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: 'clear',
        removedValues: selectValue
      });
    };
    _this.popValue = function () {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    };
    _this.getValue = function () {
      return _this.state.selectValue;
    };
    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function (data) {
      return getOptionLabel(_this.props, data);
    };
    _this.getOptionValue = function (data) {
      return getOptionValue(_this.props, data);
    };
    _this.getStyles = function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getElementId = function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function () {
      return defaultComponents(_this.props);
    };
    _this.buildCategorizedOptions = function () {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function () {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function () {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function () {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function (value, actionMeta) {
      _this.setState({
        ariaSelection: _objectSpread2({
          value: value
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function (event) {
      // Event captured by dropdown indicator
      if (event.defaultPrevented) {
        return;
      }
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
        isMulti = _this$props4.isMulti,
        menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }
      event.preventDefault();
    };
    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      _this.openAfterFocus = false;
      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };
    _this.onTouchStart = function (_ref2) {
      var touches = _ref2.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }

      // reset move vars
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function (event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: 'input-change',
        prevInputValue: prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function (event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange('', {
        action: 'input-blur',
        prevInputValue: prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      _this.setState({
        focusedOption: focusedOption
      });
    };
    _this.shouldHideSelectedOptions = function () {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onValueInputFocus = function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.focus();
    };
    _this.onKeyDown = function (event) {
      var _this$props5 = _this.props,
        isMulti = _this$props5.isMulti,
        backspaceRemovesValue = _this$props5.backspaceRemovesValue,
        escapeClearsValue = _this$props5.escapeClearsValue,
        inputValue = _this$props5.inputValue,
        isClearable = _this$props5.isClearable,
        isDisabled = _this$props5.isDisabled,
        menuIsOpen = _this$props5.menuIsOpen,
        onKeyDown = _this$props5.onKeyDown,
        tabSelectsValue = _this$props5.tabSelectsValue,
        openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state,
        focusedOption = _this$state.focusedOption,
        focusedValue = _this$state.focusedValue,
        selectValue = _this$state.selectValue;
      if (isDisabled) return;
      if (typeof onKeyDown === 'function') {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }

      // Block option hover events when the user has just pressed a key
      _this.blockOptionHover = true;
      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;
          _this.focusValue('previous');
          break;
        case 'ArrowRight':
          if (!isMulti || inputValue) return;
          _this.focusValue('next');
          break;
        case 'Delete':
        case 'Backspace':
          if (inputValue) return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case 'Tab':
          if (_this.isComposing) return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
          // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case 'Escape':
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange('', {
              action: 'menu-close',
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case ' ':
          // space
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu('first');
            break;
          }
          if (!focusedOption) return;
          _this.selectOption(focusedOption);
          break;
        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }
          break;
        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }
          break;
        case 'PageUp':
          if (!menuIsOpen) return;
          _this.focusOption('pageup');
          break;
        case 'PageDown':
          if (!menuIsOpen) return;
          _this.focusOption('pagedown');
          break;
        case 'Home':
          if (!menuIsOpen) return;
          _this.focusOption('first');
          break;
        case 'End':
          if (!menuIsOpen) return;
          _this.focusOption('last');
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);

    // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
    if (_props.menuIsOpen && _this.state.selectValue.length) {
      var focusableOptions = _this.buildFocusableOptions();
      var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
      _this.state.focusedOption = focusableOptions[optionIndex];
    }
    return _this;
  }
  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }

      // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
      if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
        isDisabled = _this$props6.isDisabled,
        menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (
      // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled ||
      // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) {
        // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: true
        });
      }

      // scroll the focused option into view if necessary
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }

    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange('', {
        action: 'menu-close',
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }

    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }

    // aliased for consumers
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state,
        selectValue = _this$state2.selectValue,
        isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }

      // only scroll if the menu isn't already open
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex]
      }, function () {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state,
        selectValue = _this$state3.selectValue,
        focusedValue = _this$state3.focusedValue;

      // Only multiselects support value focusing
      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;
      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options = this.getFocusableOptions();
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
      }
      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    value:
    // ==============================
    // Getters
    // ==============================

    function getTheme() {
      // Use the default theme if there are no customisations.
      if (!this.props.theme) {
        return defaultTheme;
      }
      // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.
      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      }
      // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.
      return _objectSpread2(_objectSpread2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
        cx = this.cx,
        getStyles = this.getStyles,
        getValue = this.getValue,
        selectOption = this.selectOption,
        setValue = this.setValue,
        props = this.props;
      var isMulti = props.isMulti,
        isRtl = props.isRtl,
        options = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue: clearValue,
        cx: cx,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        selectProps: props,
        setValue: setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props,
        isClearable = _this$props7.isClearable,
        isMulti = _this$props7.isMulti;

      // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable
      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    }

    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value:
    // ==============================
    // Composition Handlers
    // ==============================

    function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value:
    // ==============================
    // Touch Handlers
    // ==============================

    function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value:
    // ==============================
    // Renderers
    // ==============================
    function renderInput() {
      var _this$props8 = this.props,
        isDisabled = _this$props8.isDisabled,
        isSearchable = _this$props8.isSearchable,
        inputId = _this$props8.inputId,
        inputValue = _this$props8.inputValue,
        tabIndex = _this$props8.tabIndex,
        form = _this$props8.form,
        menuIsOpen = _this$props8.menuIsOpen,
        required = _this$props8.required;
      var _this$getComponents = this.getComponents(),
        Input = _this$getComponents.Input;
      var _this$state4 = this.state,
        inputIsHidden = _this$state4.inputIsHidden,
        ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId('input');

      // aria attributes makes the JSX "noisy", separated for clarity
      var ariaAttributes = _objectSpread2(_objectSpread2(_objectSpread2({
        'aria-autocomplete': 'list',
        'aria-expanded': menuIsOpen,
        'aria-haspopup': true,
        'aria-errormessage': this.props['aria-errormessage'],
        'aria-invalid': this.props['aria-invalid'],
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby'],
        'aria-required': required,
        role: 'combobox'
      }, menuIsOpen && {
        'aria-controls': this.getElementId('listbox'),
        'aria-owns': this.getElementId('listbox')
      }), !isSearchable && {
        'aria-readonly': true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
        'aria-describedby': this.getElementId('live-region')
      } : {
        'aria-describedby': this.getElementId('placeholder')
      });
      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/React__namespace.createElement(DummyInput, _extends$b({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex: tabIndex,
          inputMode: "none",
          form: form,
          value: ""
        }, ariaAttributes));
      }
      return /*#__PURE__*/React__namespace.createElement(Input, _extends$b({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(),
        MultiValue = _this$getComponents2.MultiValue,
        MultiValueContainer = _this$getComponents2.MultiValueContainer,
        MultiValueLabel = _this$getComponents2.MultiValueLabel,
        MultiValueRemove = _this$getComponents2.MultiValueRemove,
        SingleValue = _this$getComponents2.SingleValue,
        Placeholder = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props,
        controlShouldRenderValue = _this$props9.controlShouldRenderValue,
        isDisabled = _this$props9.isDisabled,
        isMulti = _this$props9.isMulti,
        inputValue = _this$props9.inputValue,
        placeholder = _this$props9.placeholder;
      var _this$state5 = this.state,
        selectValue = _this$state5.selectValue,
        focusedValue = _this$state5.focusedValue,
        isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/React__namespace.createElement(Placeholder, _extends$b({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused,
          innerProps: {
            id: this.getElementId('placeholder')
          }
        }), placeholder);
      }
      if (isMulti) {
        return selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /*#__PURE__*/React__namespace.createElement(MultiValue, _extends$b({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: key,
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, 'value'));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /*#__PURE__*/React__namespace.createElement(SingleValue, _extends$b({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(),
        ClearIndicator = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props,
        isDisabled = _this$props10.isDisabled,
        isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React__namespace.createElement(ClearIndicator, _extends$b({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(),
        LoadingIndicator = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props,
        isDisabled = _this$props11.isDisabled,
        isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React__namespace.createElement(LoadingIndicator, _extends$b({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(),
        DropdownIndicator = _this$getComponents5.DropdownIndicator,
        IndicatorSeparator = _this$getComponents5.IndicatorSeparator;

      // separator doesn't make sense without the dropdown indicator
      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/React__namespace.createElement(IndicatorSeparator, _extends$b({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(),
        DropdownIndicator = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React__namespace.createElement(DropdownIndicator, _extends$b({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(),
        Group = _this$getComponents7.Group,
        GroupHeading = _this$getComponents7.GroupHeading,
        Menu = _this$getComponents7.Menu,
        MenuList = _this$getComponents7.MenuList,
        MenuPortal = _this$getComponents7.MenuPortal,
        LoadingMessage = _this$getComponents7.LoadingMessage,
        NoOptionsMessage = _this$getComponents7.NoOptionsMessage,
        Option = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props,
        captureMenuScroll = _this$props12.captureMenuScroll,
        inputValue = _this$props12.inputValue,
        isLoading = _this$props12.isLoading,
        loadingMessage = _this$props12.loadingMessage,
        minMenuHeight = _this$props12.minMenuHeight,
        maxMenuHeight = _this$props12.maxMenuHeight,
        menuIsOpen = _this$props12.menuIsOpen,
        menuPlacement = _this$props12.menuPlacement,
        menuPosition = _this$props12.menuPosition,
        menuPortalTarget = _this$props12.menuPortalTarget,
        menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
        menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
        noOptionsMessage = _this$props12.noOptionsMessage,
        onMenuScrollToTop = _this$props12.onMenuScrollToTop,
        onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null;

      // TODO: Internal Option Type here
      var render = function render(props, id) {
        var type = props.type,
          data = props.data,
          isDisabled = props.isDisabled,
          isSelected = props.isSelected,
          label = props.label,
          value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? undefined : function () {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1
        };
        return /*#__PURE__*/React__namespace.createElement(Option, _extends$b({}, commonProps, {
          innerProps: innerProps,
          data: data,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: type,
          value: value,
          isFocused: isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
        }), _this4.formatOptionLabel(props.data, 'menu'));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function (item) {
          if (item.type === 'group') {
            var _data = item.data,
              options = item.options,
              groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /*#__PURE__*/React__namespace.createElement(Group, _extends$b({}, commonProps, {
              key: groupId,
              data: _data,
              options: options,
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === 'option') {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/React__namespace.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });
        if (_message === null) return null;
        menuUI = /*#__PURE__*/React__namespace.createElement(NoOptionsMessage, commonProps, _message);
      }
      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/React__namespace.createElement(MenuPlacer, _extends$b({}, commonProps, menuPlacementProps), function (_ref4) {
        var ref = _ref4.ref,
          _ref4$placerProps = _ref4.placerProps,
          placement = _ref4$placerProps.placement,
          maxHeight = _ref4$placerProps.maxHeight;
        return /*#__PURE__*/React__namespace.createElement(Menu, _extends$b({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove,
            id: _this4.getElementId('listbox')
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/React__namespace.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function (scrollTargetRef) {
          return /*#__PURE__*/React__namespace.createElement(MenuList, _extends$b({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);
              scrollTargetRef(instance);
            },
            isLoading: isLoading,
            maxHeight: maxHeight,
            focusedOption: focusedOption
          }), menuUI);
        }));
      });

      // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`
      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/React__namespace.createElement(MenuPortal, _extends$b({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props,
        delimiter = _this$props13.delimiter,
        isDisabled = _this$props13.isDisabled,
        isMulti = _this$props13.isMulti,
        name = _this$props13.name,
        required = _this$props13.required;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;
      if (required && !this.hasValue()) {
        return /*#__PURE__*/React__namespace.createElement(RequiredInput, {
          name: name,
          onFocus: this.onValueInputFocus
        });
      }
      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/React__namespace.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/React__namespace.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /*#__PURE__*/React__namespace.createElement("input", {
            name: name,
            type: "hidden",
            value: ""
          });
          return /*#__PURE__*/React__namespace.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
        return /*#__PURE__*/React__namespace.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state,
        ariaSelection = _this$state6.ariaSelection,
        focusedOption = _this$state6.focusedOption,
        focusedValue = _this$state6.focusedValue,
        isFocused = _this$state6.isFocused,
        selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /*#__PURE__*/React__namespace.createElement(LiveRegion, _extends$b({}, commonProps, {
        id: this.getElementId('live-region'),
        ariaSelection: ariaSelection,
        focusedOption: focusedOption,
        focusedValue: focusedValue,
        isFocused: isFocused,
        selectValue: selectValue,
        focusableOptions: focusableOptions
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(),
        Control = _this$getComponents8.Control,
        IndicatorsContainer = _this$getComponents8.IndicatorsContainer,
        SelectContainer = _this$getComponents8.SelectContainer,
        ValueContainer = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props,
        className = _this$props14.className,
        id = _this$props14.id,
        isDisabled = _this$props14.isDisabled,
        menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/React__namespace.createElement(SelectContainer, _extends$b({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/React__namespace.createElement(Control, _extends$b({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/React__namespace.createElement(ValueContainer, _extends$b({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/React__namespace.createElement(IndicatorsContainer, _extends$b({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
        clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
        inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate,
        ariaSelection = state.ariaSelection,
        isFocused = state.isFocused,
        prevWasFocused = state.prevWasFocused;
      var options = props.options,
        value = props.value,
        menuIsOpen = props.menuIsOpen,
        inputValue = props.inputValue,
        isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};
      if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        newMenuOptionsState = {
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue,
          clearFocusValueOnUpdate: false
        };
      }
      // some updates should toggle the state of the input visibility
      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: undefined
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        // If `value` or `defaultValue` props are not empty then announce them
        // when the Select is initially focused
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: 'initial-input-focus'
        };
        hasKeptFocus = !prevWasFocused;
      }

      // If the 'initial-input-focus' action has been set already
      // then reset the ariaSelection to null
      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') {
        newAriaSelection = null;
      }
      return _objectSpread2(_objectSpread2(_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select;
}(React.Component);
Select.defaultProps = defaultProps$1;

var StateManagedSelect = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var baseSelectProps = useStateManager(props);
  return /*#__PURE__*/React__namespace.createElement(Select, _extends$b({
    ref: ref
  }, baseSelectProps));
});

const resourcesPageResponse = {
    posts: [
        {
            id: '63d138ca0181dc0001fa76d3',
            uuid: '8c857f95-2d97-41f7-a7cb-696087ac7470',
            title: "Collaborative Hacking for Your Team's Development",
            slug: 'collaborative-hacking-koth',
            html: '<p>Collaboration and competition within the workplace are great ways to harness the power of motivating your staff and encourage teamwork, enabling your team to make better contributions to their day-to-day work and realize what they can accomplish if they focus their efforts!</p><p>Take team building to the next level with <a href="https://blog.tryhackme.com/hack-with-your-friends-to-become-king-of-the-hill/">King of the Hill</a> - a fantastic training tool used by businesses across the globe, allowing teams to cooperate and upskill, in a collaborative and engaging hacking game that combines offensive and defensive security skills.</p><h2 id="team-collaboration">Team Collaboration</h2><p><strong>Why is collaboration important in the workplace?</strong> Collaborative learning is key to progression within the industry, with problem-solving a combined effort. Solving problems through collaboration is a great way to learn while promoting creativity, productivity, and a sense of community, with <a href="https://online.queens.edu/resources/infographic/communicating-in-the-workplace/">75%</a> of employers rating teamwork and collaboration as “very important”.</p><p>For wider teams, teams are often unaware of how to engage with cyber security, therefore, strengthening collaboration adds a sense of accountability. Where security teams work independently, collaboration in the workplace allows for inclusiveness by bringing teams together with a shared focus.</p><p>Collaboration keeps teams on track and enables individuals who may otherwise be struggling on their own. Most importantly, businesses can use collaboration to drive workforce participation and buy-in.</p><h2 id="king-of-the-hill">King of the Hill</h2><p><a href="https://blog.tryhackme.com/hack-with-your-friends-to-become-king-of-the-hill/">King of the Hill</a> is a competitive hacking game for intermediate and advanced users. Play against ten other hackers to compromise a machine and patch its vulnerabilities to prevent other players from gaining access. </p><p>Through gamification, King of the Hill covers defensive and offensive security topics transferable to job responsibilities. Best of all, you can choose to host your own private King of the Hill, allowing your team to compete against each other, collaborate, and learn together in your very own workspace.</p><p>Using both red and blue team tactics, workforces are able to better recognise how other teams work, with a shared understanding of their roles and responsibilities.</p><p>First, your team will hack their way to compromise a vulnerable machine using offensive tactics, collecting flags in the process to gain more points. They must then work together using blue-team tactics to retain their presence and defend their position against the competition. The longer they maintain access, the more points your team gets.</p><p>Your team can then keep track of performance through a competitive leaderboard - an awesome way to ignite competition, display results, and foster a thriving culture!</p><figure class="kg-card kg-image-card"><img src="https://lh6.googleusercontent.com/VY8usebo38L5PVe_EjHibN_-pYGnQ0Ut7XNTbgLlrgNJAo7ms12t3eytnIB-_m1hQJp4-GzGNoFqB4w8By3g_g-va-qAN2pmX83wHFEjz1_5A9yTFah_K6OE1uXJM7yz1EJ3aDrUedUzcRJlltejuBebVu9B7boiNKtT15vPl5fJSvP7ZGcEF2dGErlG7A" class="kg-image" alt loading="lazy"></figure><p><br>All tactics are taught through TryHackMe’s pathways and rooms to arm the workforce with the knowledge and skills to prevent threats and reduce negative implications. King of the Hill is perfect for putting your team’s skills to the test!</p><!--kg-card-begin: html--><center><a href="https://tryhackme.com/games/koth"><button style=\'background-color: #222c42; color: white; padding: 15px 20px; border-radius: 10px; font-size: 25px;\'>Launch King of the Hill!</button></a></center><!--kg-card-end: html--><h2 id="collaborative-workspaces">Collaborative Workspaces</h2><p>A <a href="https://tryhackme.com/workspace">workspace</a> is a way for the workforce to collaborate in a fun, competitive environment. Your team can upskill, complete challenges, and work towards the top of your collaborative online workspace leaderboard!</p><p>From a management perspective, workspaces provide insights into how your team are working towards their goals, with an overview of their activity on TryHackMe and hacking streaks. The leaderboard displays a rank of all team members in your workspace, ordered by the number of points each user has collected from completing rooms, labs, and pathways. </p><p>Leaderboards within TryHackMe workspaces drive competition throughout your team. ​​ Additionally, you can choose to incentivise by internally creating your own prizes to recognise and reward those at the top of the workspace leaderboard!</p><!--kg-card-begin: html--><center><a href="https://tryhackme.com/workspace"><button style=\'background-color: #222c42; color: white; padding: 15px 20px; border-radius: 10px; font-size: 25px;\'>Launch a TryHackMe Workspace</button></a></center><!--kg-card-end: html--><h2 id="tryhackmetraining">TryHackMeTraining</h2><p>Alongside collaborative workspaces and King of the Hill, we have hundreds of training labs to upskill and arm your team with the knowledge of tools and practices to mitigate cyber attacks. Our business package promotes workplace collaboration and allows you to access all rooms and pathways to present the most relevant training to your team - assigning tasks to complete purely through the browser. </p><p>Learning through collaboration and using competition to test your workforce helps to amplify knowledge retention and engagement - forming a strong baseline for your cyber security standing. </p><!--kg-card-begin: html--><center><a href="https://tryhackme.com/business"><button style=\'background-color: #222c42; color: white; padding: 15px 20px; border-radius: 10px; font-size: 25px;\'>TryHackMe for Business</button></a></center><!--kg-card-end: html-->',
            comment_id: '63d138ca0181dc0001fa76d3',
            feature_image: 'https://blog.tryhackme.com/content/images/2023/01/Banner--6-.png',
            featured: false,
            visibility: 'public',
            created_at: '2023-01-25T14:12:26.000+00:00',
            updated_at: '2023-01-26T09:00:10.000+00:00',
            published_at: '2023-01-26T09:00:06.000+00:00',
            custom_excerpt: 'Take team building to the next level with King of the Hill. Teams can cooperate and upskill in a collaborative and engaging hacking game, combining offensive and defensive security skills.',
            codeinjection_head: null,
            codeinjection_foot: null,
            custom_template: null,
            canonical_url: null,
            tags: [
                {
                    id: '618021e4e085210001ec1aed',
                    name: 'Business',
                    slug: 'business',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/business/',
                },
                {
                    id: '628014d5e085210001ec24d4',
                    name: 'business-resource',
                    slug: 'business-resource',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/business-resource/',
                },
                {
                    id: '618cfabfe085210001ec1da2',
                    name: 'Platform',
                    slug: 'platform',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/platform/',
                },
            ],
            authors: [
                {
                    id: '62eaaa040181dc0001fa6403',
                    name: 'Ellie Gillard',
                    slug: 'ellie',
                    profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                    cover_image: null,
                    bio: null,
                    website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                    location: 'United Kingdom',
                    facebook: null,
                    twitter: '@EllieGillardTHM',
                    meta_title: null,
                    meta_description: null,
                    url: 'https://blog.tryhackme.com/author/ellie/',
                },
            ],
            primary_author: {
                id: '62eaaa040181dc0001fa6403',
                name: 'Ellie Gillard',
                slug: 'ellie',
                profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                cover_image: null,
                bio: null,
                website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                location: 'United Kingdom',
                facebook: null,
                twitter: '@EllieGillardTHM',
                meta_title: null,
                meta_description: null,
                url: 'https://blog.tryhackme.com/author/ellie/',
            },
            primary_tag: {
                id: '618021e4e085210001ec1aed',
                name: 'Business',
                slug: 'business',
                description: null,
                feature_image: null,
                visibility: 'public',
                og_image: null,
                og_title: null,
                og_description: null,
                twitter_image: null,
                twitter_title: null,
                twitter_description: null,
                meta_title: null,
                meta_description: null,
                codeinjection_head: null,
                codeinjection_foot: null,
                canonical_url: null,
                accent_color: null,
                url: 'https://blog.tryhackme.com/tag/business/',
            },
            url: 'https://blog.tryhackme.com/collaborative-hacking-koth/',
            excerpt: 'Take team building to the next level with King of the Hill. Teams can cooperate and upskill in a collaborative and engaging hacking game, combining offensive and defensive security skills.',
            reading_time: 3,
            access: true,
            og_image: null,
            og_title: null,
            og_description: null,
            twitter_image: null,
            twitter_title: null,
            twitter_description: null,
            meta_title: "Collaborative Hacking for Your Team's Development",
            meta_description: 'Take business team building to the next level with King of the Hill - an engaging hacking game combining offensive and defensive security skills.',
            email_subject: null,
            frontmatter: null,
            feature_image_alt: null,
            feature_image_caption: null,
        },
        {
            id: '63c574480181dc0001fa7690',
            uuid: 'a57bc2af-00cf-47be-9c4e-68b3072a4940',
            title: 'The Importance of eCommerce Cyber Security',
            slug: 'ecommerce-cyber-security',
            html: '<p>The rise of eCommerce over the last three years has opened a lucrative avenue for cyber crime, with cyber criminals increasingly targeting eCommerce businesses in a constant game of cat and mouse.</p><p>Ecommerce cyber crime can affect businesses of all sizes, despite <a href="https://www.insurancebee.com/blog/smb-owners-unprepared-for-cybercrime">54%</a> assuming they are too small to become victims of an attack.</p><p>Higher volumes of attempted fraud and cyber crime are anticipated during events with increased online shopping volume; such as Black Friday, Cyber Monday, Christmas, Valentine\'s Day, and sale seasons. Businesses must wise up to the latest methods of attack and strengthen their eCommerce cyber defence, with hackers targeting store admins, users, and employees through various malicious techniques.</p><p>Defensive and offensive security are two of the most critical lines of protecting against eCommerce cyber attacks. What are the major security threats to an eCommerce website, and how can you best protect your business?</p><h2 id="why-is-security-important-in-ecommerce">Why is Security Important in eCommerce?</h2><p>Cyber crime is at its peak - global losses have increased by <a href="https://www.raconteur.net/technology/cybersecurity/cybercriminals-ecommerce-online-retail/#:~:text=According%20to%20Statista%2C%20global%20ecommerce,than%2014%25%20compared%20with%202020.">14%</a> in the last year alone - with no signs of slowing down any time soon.</p><p>eCommerce sites are treasure troves of personal and financial data, resulting in these devastating global eCommerce losses. Security threats to eCommerce cause havoc in online trading, with the industry experiencing up to <a href="https://www.getastra.com/blog/knowledge-base/ecommerce-security-threats/">32.4%</a> of all successful threats annually. Fraudulent chargebacks also cost businesses worldwide approximately <a href="https://chargebacks.com/true-cost-chargebacks/#:~:text=Chargebacks%20are%20a%20%2440%20billion,losses%20of%20goods%20and%20services.">$40</a> billion every year.</p><!--kg-card-begin: html--><table style="border:none;border-collapse:collapse;"><colgroup><col width="601"></colgroup><tbody><tr style="height:0pt"><td style="border-left:solid #000000 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt;overflow:hidden;overflow-wrap:break-word;"><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">“Online shopping already accounts for 10% of retail sales and is expected to grow at a year-on-year rate of 15%.”</span></p><br><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#93c47d;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">Kinsta</span></p></td></tr></tbody></table><!--kg-card-end: html--><p>One of the most dangerous eCommerce security threats is a sensitive data leak, resulting in severe financial and reputational harm. The cost of a breach can be hugely devastating for businesses of all sizes, with <a href="https://www.denverpost.com/2016/10/23/small-companies-cyber-attack-out-of-business/">60%</a> of small businesses forced to shut down within half a year following cyber attacks.</p><p>With eCommerce organisations acquiring an ever-increasing quantity of data than ever before, including credit card information, consumers\' addresses and email addresses, businesses are at an increased risk of attacks. Data protection in eCommerce is one of the biggest concerns for digital consumers. Building trust with customers can take ​​years, but one negative experience can be a massive blow to your business.</p><h2 id="ecommerce-security-risks">eCommerce Security Risks</h2><p>The best way to stay ahead of eCommerce cyber crime is to be aware of the risks involved and the security best practices to be on the lookout for.</p><p>The security threats to eCommerce are often intentional, with fraud, data misuse, security breach and disruption to business in mind. In contrast, many eCommerce threats are accidental or a result of <a href="https://tryhackme.com/resources/blog/cyber-security-the-cost-of-human-error">human error</a>.<br></p><figure class="kg-card kg-image-card"><img src="https://lh6.googleusercontent.com/8xFf9ou1INzEVjCL-bxq7QqmnU6MrYskJ7-LWW-l_xFN_ukN0GzGZVgkfds_3d4xn785IxN1icdNcQ2QzFP62JsyfCNtEh4__5LJ6jbd8dDzTJBCeiUIStaI6B21v3bcX4VGXqMenyrpjNL8OP5EUhV6XgyHLsffbCyMeQEmWxkkBrbM6EpGDlCeY7sOcA" class="kg-image" alt loading="lazy"></figure><p>Data privacy is the number one risk for eCommerce businesses, with DDoS attacks and financial fraud the two most frequent threats. The most common cyber threats to eCommerce businesses include:</p><ul><li>Financial fraud (eCommerce fraud risks include including credit card fraud and fake return/refund fraud)</li><li>DoS &amp; DDoS Attacks</li><li>Bots</li><li>Malware</li><li>Spamming</li><li>Phishing</li><li>Smishing (SMS phishing)</li><li>Brute force</li><li>SQL injection</li><li>Cross-site scripting (XSS)</li><li>E-skimming</li><li>The exploitation of known vulnerabilities</li></ul><p>eCommerce malware attacks are a particularly great concern for retail businesses, since most small online businesses fail to securely back up their data and are especially vulnerable to this attack.</p><h2 id="ecommerce-cyber-security-trends">eCommerce Cyber Security Trends</h2><p>Changing customer behaviour, new technological trends, and complicated attack vectors will continue transforming how eCommerce businesses operate from a cyber security standpoint.</p><h3 id="payment-innovations">Payment Innovations</h3><p>As the number of consumers using online retail increases, so will the development of modern banking transactions. The progression of artificial intelligence and data analytics is expected to contribute heavily towards introducing new payment innovations, intending to make payments more secure than ever.</p><h3 id="adoption-of-ai-for-fraud-detection">Adoption of AI for Fraud Detection</h3><p>AI has and will become increasingly vital in developing new behavioural biometrics solutions to develop authentication methods within eCommerce and the <a href="https://tryhackme.com/resources/blog/cyber-security-trends-financial-services">financial services sector</a>.</p><p>Artificial intelligence can boost eCommerce security by analysing vast volumes of data much more quickly while detecting unauthorised and suspicious activity. Visa and MasterCard continue to develop learning technologies to predict financial fraud and, most importantly, prevent it from occurring.</p><h3 id="e-skimming">E-skimming</h3><p>E-skimming is the practice of hackers gaining access to online stores by injecting malicious skimming code into payment processing segments of the website - extracting data. These attacks are often launched to steal customer information and have multiplied in recent years.</p><p>Hackers can insert a skimming code in your eCommerce site, including payment processing pages where confidential information passes through. eCommerce businesses are advised to comply fully with the Payment Card Industry Data Security Standard (<a href="https://www.pcisecuritystandards.org/about_us/">PCI DSS</a>).</p><p>The Payment Card Industry Data Security Standard is a set of security standards designed to ensure all companies are accepting, processing, storing or transmitting credit card information and maintaining a secure environment.</p><h3 id="strengthening-defences">Strengthening Defences</h3><p>While your eCommerce business will always be vulnerable to cyber threats, taking precautionary measures is vital by performing an in-depth cyber security analysis of your business and strengthening your eCommerce website security.</p><p>eCommerce shopping is on the rise, and with that in mind, so are cyber attacks on eCommerce. There is no specified timing for a cyber attack, and no one can anticipate them, highlighting the importance of remaining up to date on industry security trends to give an edge over threat actors.</p><p>TryHackMe consists of over 560 real-world training labs to teach offensive and defensive topics in action, arming your team with the knowledge needed to protect against eCommerce cyber threats.</p><p>Our training pathways explore high-level offensive and defensive cyber security for eCommerce, allowing security teams to stay on top of new threats and advances in the eCommerce industry.</p><p><a href="https://tryhackme.com/business"><strong>Launch defensive cyber security training</strong></a><strong> for your team.</strong></p><!--kg-card-begin: html--><center><a href="https://tryhackme.com/business"><button style=\'background-color: #222c42; color: white; padding: 15px 20px; border-radius: 10px; font-size: 25px;\'>Launch TryHackMe</button></a></center><!--kg-card-end: html-->',
            comment_id: '63c574480181dc0001fa7690',
            feature_image: 'https://blog.tryhackme.com/content/images/2023/01/Banner--4-.png',
            featured: false,
            visibility: 'public',
            created_at: '2023-01-16T15:59:04.000+00:00',
            updated_at: '2023-01-24T09:00:32.000+00:00',
            published_at: '2023-01-24T09:00:32.000+00:00',
            custom_excerpt: 'Ecommerce cyber crime can affect businesses of all sizes, despite 54% assuming they are too small to become victims of an attack.',
            codeinjection_head: null,
            codeinjection_foot: null,
            custom_template: null,
            canonical_url: null,
            tags: [
                {
                    id: '62977ecde085210001ec2640',
                    name: 'Blog',
                    slug: 'blog',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/blog/',
                },
                {
                    id: '618021e4e085210001ec1aed',
                    name: 'Business',
                    slug: 'business',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/business/',
                },
            ],
            authors: [
                {
                    id: '62eaaa040181dc0001fa6403',
                    name: 'Ellie Gillard',
                    slug: 'ellie',
                    profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                    cover_image: null,
                    bio: null,
                    website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                    location: 'United Kingdom',
                    facebook: null,
                    twitter: '@EllieGillardTHM',
                    meta_title: null,
                    meta_description: null,
                    url: 'https://blog.tryhackme.com/author/ellie/',
                },
            ],
            primary_author: {
                id: '62eaaa040181dc0001fa6403',
                name: 'Ellie Gillard',
                slug: 'ellie',
                profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                cover_image: null,
                bio: null,
                website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                location: 'United Kingdom',
                facebook: null,
                twitter: '@EllieGillardTHM',
                meta_title: null,
                meta_description: null,
                url: 'https://blog.tryhackme.com/author/ellie/',
            },
            primary_tag: {
                id: '62977ecde085210001ec2640',
                name: 'Blog',
                slug: 'blog',
                description: null,
                feature_image: null,
                visibility: 'public',
                og_image: null,
                og_title: null,
                og_description: null,
                twitter_image: null,
                twitter_title: null,
                twitter_description: null,
                meta_title: null,
                meta_description: null,
                codeinjection_head: null,
                codeinjection_foot: null,
                canonical_url: null,
                accent_color: null,
                url: 'https://blog.tryhackme.com/tag/blog/',
            },
            url: 'https://blog.tryhackme.com/ecommerce-cyber-security/',
            excerpt: 'Ecommerce cyber crime can affect businesses of all sizes, despite 54% assuming they are too small to become victims of an attack.',
            reading_time: 4,
            access: true,
            og_image: null,
            og_title: null,
            og_description: null,
            twitter_image: null,
            twitter_title: null,
            twitter_description: null,
            meta_title: 'The Importance of eCommerce Cyber Security',
            meta_description: 'The rise of eCommerce has opened a lucrative avenue for cyber crime, with criminals increasingly targeting eCommerce businesses of all sizes.',
            email_subject: null,
            frontmatter: null,
            feature_image_alt: null,
            feature_image_caption: null,
        },
        {
            id: '63c573080181dc0001fa7661',
            uuid: '475fb562-766d-425f-843a-dcecb11ed62d',
            title: 'How to Become a Penetration Tester',
            slug: 'how-to-become-a-penetration-tester',
            html: '<p>As an area where skills gaps are most prominent and demand is at its highest, penetration testing is promised to be a secure, rewarding career with a wealth of learning capabilities and a highly competitive salary.</p><p>No matter how long you have been working, there\'s something new to be learnt in penetration testing every day, making it full of consistently evolving challenges!</p><p>Are you interested in <a href="https://tryhackme.com/resources/blog/becoming-a-penetration-tester">becoming a penetration tester</a>? Learn the ins and outs of the job role, discover the best way to learn penetration testing, and understand how to gain the expertise and skills to achieve your dream career in penetration testing!</p><h2 id="what-is-a-penetration-tester">What is a Penetration Tester?</h2><p>Penetration testers are ethical hackers that scale simulated cyber attacks to proactively search for vulnerabilities in the network infrastructure and web applications. Most importantly, these operations allow for security vulnerabilities to be patched up.</p><p>Penetration Tester job responsibilities include:</p><ul><li>Perform penetration tests on networks, applications and computer systems</li><li>Perform physical security assessments to identify vulnerabilities</li><li>Identify attacker entry points used to exploit vulnerabilities and weaknesses</li><li>Identify areas needed for improved awareness and education</li><li>Identify improvements for existing security solutions (policies, hardware, software, etc.)</li><li>Research, document and discuss findings</li><li>Review and provide feedback for security fixes</li><li>Create new testing methods to identify vulnerabilities</li><li>Keep updated on the latest malware and security threats</li></ul><h2 id="penetration-testing-salary">Penetration Testing Salary</h2><p>Depending on experience, you can earn between £31,595 for entry-level Penetration Tester positions, to over £110,000 as you progress. The average Penetration Tester salary is around £70,000 (approximately $80,000).</p><p>As a critical skill in high demand, <a href="https://dera.ioe.ac.uk/39218/1/Cyber_security_skills_in_the_UK_labour_market_2022_-_findings_report.pdf">20%</a> of employers report penetration testing roles as ‘hard to fill’. The most common shortage in a specialist role has been found in penetration testing, which has led to sharp salary increases over the last 12 months.</p><h2 id="penetration-testing-job-requirements">Penetration Testing Job Requirements</h2><p>Some pentesting positions seek candidates with relevant degrees, while others require only a demonstration of relevant skills and an appropriate level of cyber security experience and knowledge.</p><p>Initial training will always serve as a foundation for any pentesting career. However, keeping up with the latest exploits, alongside <a href="https://tryhackme.com/module/recent-threats">recent threats</a> and techniques, is a must!</p><p>Employers search for exceptional problem-solving skills, dedication to detail, and a desire to remain continually educated on the latest trends in the field.</p><h2 id="learn-penetration-testing">Learn Penetration Testing</h2><p>Become equipped for a career in penetration testing through our learning pathways, designed to train you with the advanced skills needed to pursue new career opportunities in penetration testing. Prepare for real-world penetration testing with training content tailored to all skill levels, meaning that you won\'t even need prior knowledge to kickstart your pentester learning with TryHackMe!</p><p>You’ll learn the basics of ethical hacking and penetration testing in the four pathways listed below:</p><h4 id="comptia-pentest-pathway-easy"><a href="https://tryhackme.com/path-action/pentestplus/join"><strong>CompTIA Pentest+ Pathway</strong></a> (Easy)</h4><p>Gain hands-on exercises and practical exam preparation to prepare you for the CompTIA PenTest+ exam. Once you complete this pathway, we’ll give you an exclusive 10% discount on the exam!</p><h4 id="jr-penetration-tester-pathway-intermediate"><a href="https://tryhackme.com/path-action/jrpenetrationtester/join"><strong>Jr Penetration Tester Pathway</strong></a> (Intermediate)</h4><p>Explore the fundamental pentesting methodologies to become a Junior Penetration Tester. We\'ll introduce you to web application hacking and privilege escalation, equipping you with the practical skills to perform security assessments against web applications and enterprise infrastructure.</p><h4 id="offensive-pentesting-pathway-intermediate"><a href="https://tryhackme.com/path-action/pentesting/join"><strong>Offensive Pentesting Pathway</strong></a> (Intermediate)</h4><p>Prepare for real-world penetration testing as you master the industry-standard tools to find vulnerabilities in machines in realistic attack scenarios. From then onwards, you can continue to gain pentesting certifications from well-known certifiers in the security industry.</p><h4 id="red-teaming-intermediate"><a href="https://tryhackme.com/path/outline/redteaming"><strong>Red Teaming</strong></a> (Intermediate)</h4><p>Level up with more advanced topics and understand how to execute adversary attack emulations as a Red Team Operator.</p><p>Want to progress and gain a penetration tester certification? Check out our <a href="https://tryhackme.com/resources/blog/certifications-in-cyber-security">cyber security certifications</a> guide to read more.</p><h2 id="get-started">Get Started!</h2><p>TryHackMe courses are suited to all - from the complete beginner to the seasoned hacker - making learning engaging, entertaining, accessible, and affordable.</p><p>Our training labs grow with you, so you can launch into the industry and continually upskill based on new threats and trends. Our real-world training allows you to prepare for work responsibilities in penetration testing, achieving sought-after skills.</p><!--kg-card-begin: html--><center><a href="https://tryhackme.com/hacktivities"><button style=\'background-color: #222c42; color: white; padding: 15px 20px; border-radius: 10px; font-size: 25px;\'>Start Learning!</button></a></center><!--kg-card-end: html--><p>For inspiration on breaking into a pentester career, check out <a href="https://tryhackme.com/resources/blog/olufelas-success-story">Olufela’s success story</a>!</p>',
            comment_id: '63c573080181dc0001fa7661',
            feature_image: 'https://blog.tryhackme.com/content/images/2023/01/How-to-Become-a-Penetration-Tester---banner.png',
            featured: false,
            visibility: 'public',
            created_at: '2023-01-16T15:53:44.000+00:00',
            updated_at: '2023-01-19T10:00:59.000+00:00',
            published_at: '2023-01-19T10:00:59.000+00:00',
            custom_excerpt: 'Prepare for real-world penetration testing with training content tailored to all skill levels!',
            codeinjection_head: null,
            codeinjection_foot: null,
            custom_template: null,
            canonical_url: null,
            tags: [
                {
                    id: '62977ecde085210001ec2640',
                    name: 'Blog',
                    slug: 'blog',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/blog/',
                },
                {
                    id: '626b14c1e085210001ec24b1',
                    name: 'Careers',
                    slug: 'careers',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/careers/',
                },
            ],
            authors: [
                {
                    id: '62eaaa040181dc0001fa6403',
                    name: 'Ellie Gillard',
                    slug: 'ellie',
                    profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                    cover_image: null,
                    bio: null,
                    website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                    location: 'United Kingdom',
                    facebook: null,
                    twitter: '@EllieGillardTHM',
                    meta_title: null,
                    meta_description: null,
                    url: 'https://blog.tryhackme.com/author/ellie/',
                },
            ],
            primary_author: {
                id: '62eaaa040181dc0001fa6403',
                name: 'Ellie Gillard',
                slug: 'ellie',
                profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                cover_image: null,
                bio: null,
                website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                location: 'United Kingdom',
                facebook: null,
                twitter: '@EllieGillardTHM',
                meta_title: null,
                meta_description: null,
                url: 'https://blog.tryhackme.com/author/ellie/',
            },
            primary_tag: {
                id: '62977ecde085210001ec2640',
                name: 'Blog',
                slug: 'blog',
                description: null,
                feature_image: null,
                visibility: 'public',
                og_image: null,
                og_title: null,
                og_description: null,
                twitter_image: null,
                twitter_title: null,
                twitter_description: null,
                meta_title: null,
                meta_description: null,
                codeinjection_head: null,
                codeinjection_foot: null,
                canonical_url: null,
                accent_color: null,
                url: 'https://blog.tryhackme.com/tag/blog/',
            },
            url: 'https://blog.tryhackme.com/how-to-become-a-penetration-tester/',
            excerpt: 'Prepare for real-world penetration testing with training content tailored to all skill levels!',
            reading_time: 3,
            access: true,
            og_image: null,
            og_title: null,
            og_description: null,
            twitter_image: null,
            twitter_title: null,
            twitter_description: null,
            meta_title: 'How to Become a Penetration Tester',
            meta_description: 'Interested in becoming a penetration tester? With TryHackMe, gain the expertise and skills to achieve your dream career in penetration testing.',
            email_subject: null,
            frontmatter: null,
            feature_image_alt: null,
            feature_image_caption: null,
        },
        {
            id: '63c570f50181dc0001fa7637',
            uuid: 'b028f88f-c672-4669-b4a2-784b28d15d39',
            title: 'Preparing the Insurance Sector for Cyber Attacks',
            slug: 'insurance-sector-cyber-attacks',
            html: '<p>In recent weeks, an Australian health insurer, Medibank, made global headlines after falling victim to a cyber breach. The attack resulted in the names, addresses, dates of birth, phone numbers, email addresses, and health records published on a dark web forum. Almost 10 million customers, including the Australian prime minister, were impacted by the Medibank privacy breach after the firm refused to pay a ransom.</p><p>Cyber attacks against insurance companies are considered a top global risk for the financial sector and a continuing risk for the economy. <a href="https://blog.tryhackme.com/recurrent-cyber-threats-financial-services/">Cyber threats within the financial sector</a> mostly affect insurers, payment institutions, and credit unions.</p><p>As other financial sectors become more secure, attackers are well aware of insurance lagging behind other financial services sectors, with cyber attacks on insurance companies beginning to grow in frequency and severity.</p><h2 id="why-are-insurers-vulnerable-to-cyber-attacks">Why Are Insurers Vulnerable to Cyber Attacks?</h2><p>Financial institutions are more heavily relying on digital and remote solutions to perform daily operations. While this has brought along benefits, the increasing reliance on digital solutions has also heightened the risk of cyber attacks.</p><p>While the insurance sector is best placed to understand risk better than any other industry, insurance groups are a natural target for cyber attacks due to the substantial confidential policyholder data they hold. In contrast to other sectors, insurers typically collect considerable amounts of protected personal sensitive information that attackers can exploit for financial gain.</p><p>Besides immediate financial loss, consequences suffered by insurers following insurance-sector cyber attacks include the disruption to business, policyholders and third parties. Cyber incidents can also result in severe and long-lasting operational issues, alongside having a direct impact on all policyholders.</p><h2 id="cyber-threats-to-the-insurance-industry">Cyber Threats to the Insurance Industry</h2><p>Insurers are seeing an alarming spike in malware and attempted attacks, with cyber security risks considered the main trigger of other threats.</p><p>A key trend we have seen is attackers threatening to share compromised files across the web for further misuse by other criminals unless a ransom is paid. This has proven to increase pressure on victims to pay a ransom, given the potential risks of losing customer confidence and the legal/regulatory implications of exposing data.</p><p>In particular, those providing cyber insurance coverage have proved to be prime targets of ransomware, with attackers able to obtain policy details and the security standards of their customers. Companies with cyber insurance coverage are often identified by attackers as more attractive targets due to the perception that policyholders are more likely to pay ransom amounts if their insurer covers them.</p><p>The maximum ransomware amount that a cyber insurance policy covers is another crucial detail of insurance policies, with attackers taking this into consideration when calculating a ransom figure.</p><h2 id="preparing-the-insurance-sector-against-attacks">Preparing the Insurance Sector Against Attacks</h2><p>Insurers are facing a spate of attacks from individuals testing their security measures for vulnerabilities to exploit. Having individually tailored security policies in place should be a business priority for insurers, alongside appropriately managing cyber and IT risk with active risk management to reduce the likelihood of attacks.</p><p>Ongoing training, upskilling, and keeping pace with new developments and threats to insurance companies will enable security teams to take action and mitigate the risk to insurers. </p><p>Our training pathways explore high-level offensive and defensive security content, allowing security teams to stay on top of emerging threats and advances in the industry, and are perfect for the entirety of insurance teams.</p><p>TryHackMe consists of over 560 real-world training labs to teach these topics in-action, arming your team with the knowledge needed for defensive security operations.</p><!--kg-card-begin: html--><center><a href="https://tryhackme.com/business"><button style=\'background-color: #222c42; color: white; padding: 15px 20px; border-radius: 10px; font-size: 25px;\'>TryHackMe for Business</button></a></center><!--kg-card-end: html-->',
            comment_id: '63c570f50181dc0001fa7637',
            feature_image: 'https://blog.tryhackme.com/content/images/2023/01/Cyber-insurance-blog---banner.png',
            featured: false,
            visibility: 'public',
            created_at: '2023-01-16T15:44:53.000+00:00',
            updated_at: '2023-01-17T10:17:00.000+00:00',
            published_at: '2023-01-17T10:00:37.000+00:00',
            custom_excerpt: 'Insurers are seeing an alarming spike in malware and attempted attacks, with cyber security risks considered the main trigger of other threats.',
            codeinjection_head: null,
            codeinjection_foot: null,
            custom_template: null,
            canonical_url: null,
            tags: [
                {
                    id: '62977ecde085210001ec2640',
                    name: 'Blog',
                    slug: 'blog',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/blog/',
                },
                {
                    id: '618021e4e085210001ec1aed',
                    name: 'Business',
                    slug: 'business',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/business/',
                },
            ],
            authors: [
                {
                    id: '62eaaa040181dc0001fa6403',
                    name: 'Ellie Gillard',
                    slug: 'ellie',
                    profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                    cover_image: null,
                    bio: null,
                    website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                    location: 'United Kingdom',
                    facebook: null,
                    twitter: '@EllieGillardTHM',
                    meta_title: null,
                    meta_description: null,
                    url: 'https://blog.tryhackme.com/author/ellie/',
                },
            ],
            primary_author: {
                id: '62eaaa040181dc0001fa6403',
                name: 'Ellie Gillard',
                slug: 'ellie',
                profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                cover_image: null,
                bio: null,
                website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                location: 'United Kingdom',
                facebook: null,
                twitter: '@EllieGillardTHM',
                meta_title: null,
                meta_description: null,
                url: 'https://blog.tryhackme.com/author/ellie/',
            },
            primary_tag: {
                id: '62977ecde085210001ec2640',
                name: 'Blog',
                slug: 'blog',
                description: null,
                feature_image: null,
                visibility: 'public',
                og_image: null,
                og_title: null,
                og_description: null,
                twitter_image: null,
                twitter_title: null,
                twitter_description: null,
                meta_title: null,
                meta_description: null,
                codeinjection_head: null,
                codeinjection_foot: null,
                canonical_url: null,
                accent_color: null,
                url: 'https://blog.tryhackme.com/tag/blog/',
            },
            url: 'https://blog.tryhackme.com/insurance-sector-cyber-attacks/',
            excerpt: 'Insurers are seeing an alarming spike in malware and attempted attacks, with cyber security risks considered the main trigger of other threats.',
            reading_time: 2,
            access: true,
            og_image: null,
            og_title: null,
            og_description: null,
            twitter_image: null,
            twitter_title: null,
            twitter_description: null,
            meta_title: 'Preparing the Insurance Sector for Cyber Attacks',
            meta_description: 'Cyber attacks against insurance companies are considered a top global risk for the financial sector and a continuing risk for the economy.',
            email_subject: null,
            frontmatter: null,
            feature_image_alt: null,
            feature_image_caption: null,
        },
        {
            id: '63b6e7810181dc0001fa75a1',
            uuid: '8d510069-a861-4eb8-a84f-0a003e3e9cd5',
            title: 'Solving the Cyber Security Skill Gap',
            slug: 'solving-the-cyber-skills-gap',
            html: '<p>Cyber security continues to face two significant, intertwined challenges: an increased global threat and an alarming shortage of professionals to fill millions of open positions. </p><p>Demand for trained security professionals remains at an all-time high as the cyber security industry is inevitably facing a major shortage of cyber security skills. This global shortage is estimated to be 3.5 million, with the workforce required to grow <a href="https://www.isc2.org/Research/Workforce-Study">65%</a> to defend organisations’ critical assets effectively. </p><p>In a cyber security study, <a href="https://www.packetlabs.net/posts/cybersecurity-skills-shortage/">41%</a> of respondents claimed the cyber security skills shortage has led to recruiting junior employees (instead of hiring experienced cyber security professionals) which has left businesses needing to invest in areas they may not have previously.</p><p>The cyber skill gap has left businesses across the globe ​​"inundated" by an endless stream of cyber attacks.</p><h2 id="what-cyber-security-skills-are-in-demand">What Cyber Security Skills Are in Demand?</h2><p>Highly trained cyber security professionals are becoming more critical than ever before. Knowing what skills are needed for cyber security is crucial.</p><figure class="kg-card kg-image-card"><img src="https://lh6.googleusercontent.com/CyYzrEwUHLL5WewZp3BGq5ooi5wo_S1XQtKnKgp2IyA9yybeTjsHKo_F3YjasrRnPKKHJNi66glQSUkTaBg4NVRVZMEn3mobT0W7LhavB-cypM0HsreAQ7D94w4e8mu1R074TRROU0NJDEBDKoNJqwl1ilmhAXg1vak0xnIdrCOnsgJ4-4sg0e4yu7XrSg" class="kg-image" alt loading="lazy"></figure><h3 id="penetration-testing">Penetration Testing</h3><p>Any individual, business, or government is at risk of being hacked, and ethical hacking can protect you from real-world malicious attacks. Penetration testers use hacking techniques to test an organisation’s security systems for weaknesses lawfully and are crucial in enabling an organisation to fix vulnerabilities before hackers can exploit them.</p><p>Penetration testing is a critical skill in high demand for businesses of all sizes, with <a href="https://dera.ioe.ac.uk/39218/1/Cyber_security_skills_in_the_UK_labour_market_2022_-_findings_report.pdf">20%</a> of employers reporting this area as ‘hard to fill’. The most common shortage in a specialist role is in penetration testing.</p><h3 id="cloud-security">Cloud Security</h3><p>Cloud-based services and storage are becoming increasingly popular among businesses today. However, using cloud services also introduces serious security risks, highlighting the vital need for cloud security professionals to protect data and applications in the cloud. </p><p>The demand for cloud security roles has substantially increased due to more organisations taking advantage of cloud apps, multi-cloud, and hybrid cloud strategies. Cloud skills are exceptionally scarce, with <a href="https://go.451research.com/2020-mi-access-to-talent-driving-managed-service-opportunity.html">86%</a> of companies reporting a skills gap for implementing cloud.</p><h3 id="programming-skills">Programming Skills</h3><p>Professionals in the field of cyber security must be fluent in at least one programming language, with a basic understanding of Java, C, or C++ advised. This knowledge will allow your team to detect code flaws and, therefore, increasing abilities to solve complicated software-related problems. </p><p>As programming skills are vital in ethical hacking, it’s among one of the most in-demand skills within cyber security. It is considered one of the most valuable essential skills for cyber security.</p><h3 id="computer-forensics">Computer Forensics</h3><p>With a great understanding of computer forensics, cyber security professionals can more effectively protect against data breaches and cope with the aftermath of attacks by identifying, preserving, recovering, analysing and presenting.</p><p>Computer forensic skills are a crucial aspect of every business in the internet age, despite only <a href="https://go.451research.com/2020-mi-access-to-talent-driving-managed-service-opportunity.html">33%</a> of companies reporting they felt confident in their forensic analysis operations. The lack of skilled professionals is one of the major causes of restraining market growth, with computer forensics recorded as one of the top three areas with a technical skills gap.</p><h3 id="application-security">Application Security</h3><p>Application Security Engineers are responsible for developing and maintaining software application security policies and procedures. As smartphone and tablet usage continues to soar, the need for improved application security will also rise. Demand for developers and engineers to design and build secure applications is predicted to grow by <a href="https://www.burning-glass.com/wp-content/uploads/2020/10/Fastest_Growing_Cybersecurity_Skills_Report.pdf">164%</a> in the next five years.</p><p>Locating qualified professionals with experience in application security is proving to be an obstacle, with organisations across the globe seeking experts to protect their applications from hackers.</p><h3 id="artificial-intelligence">Artificial Intelligence</h3><p>Artificial intelligence will become increasingly crucial in analysing vast volumes of data while detecting unauthorised and suspicious activity. Currently, an estimated <a href="https://www.statista.com/topics/8131/cyber-crime-and-companies-in-the-uk/#dossierKeyfigures">72% of organisations</a> rely on AI to expose cyber attacks.</p><!--kg-card-begin: html--><table style="border:none;border-collapse:collapse;"><colgroup><col width="601"></colgroup><tbody><tr style="height:0pt"><td style="border-left:solid #000000 1pt;border-right:solid #fafafa 1pt;border-bottom:solid #fafafa 1pt;border-top:solid #ffffff 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt;overflow:hidden;overflow-wrap:break-word;"><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">“Given that AI skillsets are not yet widespread, embedding AI into existing toolsets that security teams are already using in their daily processes will be key to overcoming this barrier.”</span></p><br><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#93c47d;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">IBM</span></p></td></tr></tbody></table><!--kg-card-end: html--><p>Businesses across the globe are struggling to source employees with the skills necessary to create, train and work alongside intelligent machines. Experts predict that <a href="https://www.forbes.com/sites/bernardmarr/2022/06/13/what-are-the-most-in-demand-ai-skills/">97 million</a> jobs involving artificial intelligence (AI) will be created between 2022 and 2025.</p><h2 id="addressing-the-cyber-skills-gap">Addressing the Cyber Skills Gap</h2><p>Industries cannot protect themselves against cyber threats if the cyber skills gap isn’t addressed globally. Alongside international collaboration, societal awareness, cooperation between public and private sectors, and high-level commitment from businesses and governments, preparing a new generation of cyber professionals is crucial in combatting cyber security risks. </p><p>Gender is another hurdle in the cyber skills shortage, with women accounting for just 25% of the global cyber security workforce. On a positive note, experts predict that women will represent <a href="https://cybercrimemag.wpenginepowered.com/wp-content/uploads/2022/09/Women-In-Cybersecurity-2022-Report-Final.pdf">30 per cent</a> of the global cyber security workforce by 2025.</p><p>Empowering women in cyber and diversifying cyber teams should be a global interest, with women considerably underrepresented in the sector. Common predictions behind the cyber gender gap include the notion that roles are specifically geared towards males, alongside the lack of targeting from educational bodies.</p><p>Efforts should be shifted into exposing teenage or younger women to cyber security as a viable career option, therefore welcoming underrepresented groups into the field.  It’s important for the cyber security industry to represent and open opportunities to all. Here at TryHackMe, accessibility is a core pillar of our ethos. Whoever you are, wherever you are in the world, you should have the opportunity to learn cyber. We will continue to support this movement alongside accessibility drivers as a whole.</p><p>Employers and organisations across the globe are advised to minimise employee turnover where possible, with a strong emphasis on <strong>training</strong> and <strong>upskilling</strong>. Without training and hiring cyber talent, the skills shortage will only deepen.</p><h2 id="cyber-security-upskilling">Cyber Security Upskilling</h2><p>The cyber security environment changes rapidly; therefore, searching for qualified individuals to enter the job market can be a long waiting game. Identifying existing staff to develop, adapt, and learn new skills creates a solution to the cyber security skills gap.</p><p>Therefore, there has never been a better time to <a href="https://tryhackme.com/business?utm_source=cyber-security-around-the-world&amp;utm_medium=ebook&amp;utm_campaign=ebook">upskill your team</a> through short, gamified, real-world labs alongside various learning resources. </p><p>Our training pathways explore high-level offensive and defensive security content, allowing your team to stay on top of new threats and advances in the industry, and are perfect for strengthening the skills needed for cyber security demand.</p><p>Cyber security is an ever-evolving field, and so the need in different cyber niches will fluctuate, relative to external factors. The sheer need for skilled professionals in volume remains to be strong, and continues to grow with the increased sophistication and risk of attack. </p><p>TryHackMe enables businesses to train teams of all levels in cyber, from the complete beginner, through to the seasoned professional upskilling on the latest threats. We also enable individuals to learn cyber security and achieve lucrative jobs, as well as working with schools and universities around the globe to get the next generation passionate about our industry.</p><!--kg-card-begin: html--><center><a href="https://tryhackme.com/business"><button style=\'background-color: #222c42; color: white; padding: 15px 20px; border-radius: 10px; font-size: 25px;\'>Launch TryHackMe today</button></a></center><!--kg-card-end: html-->',
            comment_id: '63b6e7810181dc0001fa75a1',
            feature_image: 'https://blog.tryhackme.com/content/images/2023/01/Solving-the-Cyber-Skills-Gap-03.png',
            featured: false,
            visibility: 'public',
            created_at: '2023-01-05T15:06:41.000+00:00',
            updated_at: '2023-01-17T16:49:03.000+00:00',
            published_at: '2023-01-12T09:00:15.000+00:00',
            custom_excerpt: 'Demand for trained security professionals remains at an all-time high. Without training and hiring cyber talent, the skills shortage will only deepen.',
            codeinjection_head: null,
            codeinjection_foot: null,
            custom_template: null,
            canonical_url: null,
            tags: [
                {
                    id: '62977ecde085210001ec2640',
                    name: 'Blog',
                    slug: 'blog',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/blog/',
                },
                {
                    id: '618021e4e085210001ec1aed',
                    name: 'Business',
                    slug: 'business',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/business/',
                },
            ],
            authors: [
                {
                    id: '62eaaa040181dc0001fa6403',
                    name: 'Ellie Gillard',
                    slug: 'ellie',
                    profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                    cover_image: null,
                    bio: null,
                    website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                    location: 'United Kingdom',
                    facebook: null,
                    twitter: '@EllieGillardTHM',
                    meta_title: null,
                    meta_description: null,
                    url: 'https://blog.tryhackme.com/author/ellie/',
                },
            ],
            primary_author: {
                id: '62eaaa040181dc0001fa6403',
                name: 'Ellie Gillard',
                slug: 'ellie',
                profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                cover_image: null,
                bio: null,
                website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                location: 'United Kingdom',
                facebook: null,
                twitter: '@EllieGillardTHM',
                meta_title: null,
                meta_description: null,
                url: 'https://blog.tryhackme.com/author/ellie/',
            },
            primary_tag: {
                id: '62977ecde085210001ec2640',
                name: 'Blog',
                slug: 'blog',
                description: null,
                feature_image: null,
                visibility: 'public',
                og_image: null,
                og_title: null,
                og_description: null,
                twitter_image: null,
                twitter_title: null,
                twitter_description: null,
                meta_title: null,
                meta_description: null,
                codeinjection_head: null,
                codeinjection_foot: null,
                canonical_url: null,
                accent_color: null,
                url: 'https://blog.tryhackme.com/tag/blog/',
            },
            url: 'https://blog.tryhackme.com/solving-the-cyber-skills-gap/',
            excerpt: 'Demand for trained security professionals remains at an all-time high. Without training and hiring cyber talent, the skills shortage will only deepen.',
            reading_time: 5,
            access: true,
            og_image: null,
            og_title: null,
            og_description: null,
            twitter_image: null,
            twitter_title: null,
            twitter_description: null,
            meta_title: 'Solving the Cyber Security Skill Gap',
            meta_description: 'Demand for cyber security professionals remains at an all-time high. Without training and hiring cyber talent, this shortage will only deepen.',
            email_subject: null,
            frontmatter: null,
            feature_image_alt: null,
            feature_image_caption: null,
        },
        {
            id: '63b6d0460181dc0001fa7576',
            uuid: '3f7b07cb-75e1-4012-b8f2-c8adb51f81da',
            title: 'Mitigating Cyber Security Risks in the Remote Working World',
            slug: 'cyber-risks-of-remote-working',
            html: '<p>Remote work has introduced a myriad of benefits, from increased productivity, time saved during commuting, and better work-life balance. Today’s world requires us to be connected everywhere. As a result, remote working has paved the way for cyber criminals to target a new wave of home workers, with <a href="https://blog.malwarebytes.com/reports/2020/08/20-percent-of-organizations-experienced-breach-due-to-remote-worker-labs-report-reveals/">20%</a> of organisations experiencing a breach because of a remote worker. </p><p>More security challenges are to be expected, with hackers exploiting vulnerabilities in the infrastructure that enables remote work. Furthermore, organisations with a remote workforce take, on average, <a href="https://blog.knowbe4.com/data-breach-costs-increase-by-1-million-when-remote-workers-are-involved">58</a> days longer to identify and contain the breach compared to office-based organisations. This amount of time can lead to significantly increased damage to businesses, so must be a focus for all remote-first companies.</p><p>Attackers are coming down on home workers lacking the protection their organisations have built up over the years. As a result, remote working has become a new gateway for attacks, meaning that remote working teams will continue to be a target for cyber criminals. Organisations should focus efforts on managing risks for those working from home and tackle remote working safety.</p><h2 id="cyber-security-risks-of-remote-working">Cyber Security Risks of Remote Working</h2><p>With distributed workforces working remotely, businesses and members of staff must be aware of the cyber security risks of working from home, and take appropriate security measures.</p><h3 id="use-of-personal-devices">Use of Personal Devices</h3><p>With remote employees using work equipment from home, a staggering <a href="https://www.checkpoint.com/press/2022/check-point-softwares-assessment-reveals-how-remote-work-has-created-a-gap-in-organizations-security-practices/">70%</a> of organisations allow (or have previously allowed) access to corporate assets from personal laptops and mobile devices. As soon as employees start using their personal devices, oversight ends. </p><p>Workers across the globe have taken to using personal devices, regardless of whether their home routers, laptops and smartphones were properly updated and adequately secured. In addition, one in three (<a href="https://www.tessian.com/resources/security-cultures-report-2022/">29%</a> of) employees admit to taking data with them after leaving a company.</p><p>Storing internal company data clearly demonstrates how crucial it is for businesses to take action in preventing the loss of corporate data, intellectual property, and tackle the risk of corporate fraud.</p><h3 id="unsecure-internet-connections">Unsecure Internet Connections</h3><p>Where employees work where they choose, there is a much higher risk of accessing unsecured internet connections that can be intercepted by attackers, whether that be public internet connection or a home Wi-Fi connection.</p><p>Public and at-home internet connections are rarely secured with the latest encryption and authentication methods. Employees may be sharing sensitive company data over unsecured channels, without realising the threats involved.</p><h3 id="outdated-updates">Outdated Updates</h3><p>Software updates contain new features, performance improvements, bug fixes and vital security patches that prevent vulnerabilities from being exploited. If employees are using outdated software versions, which is more likely in remote working scenarios, they will be more vulnerable to attacks.</p><p>Delaying software updates can leave remote employees open to malware and vulnerabilities. A simple step to limit remote working cyber security risks is to make sure employees are regularly updating software.</p><h3 id="human-error">Human Error</h3><p>One of the most common cyber security risks of working from home is human error. Reduced oversight of employees has resulted in cyber security teams losing sight of what’s happening on home and public networks. Even if your company has taken the time to educate staff on cyber security work from home threats, a busy work schedule can lead to security measures falling down on the priority list. Without close supervision, employees are less likely to take security protocols seriously, with <a href="https://tryhackme.com/resources/blog/cyber-security-the-cost-of-human-error">human error</a> to be expected.</p><p>Employees play an essential role in maintaining the company’s cyber security, despite <a href="https://tryhackme.com/resources/blog/employees-ignore-security-guidelines">58% of employees ignoring cyber security guidelines</a> and only <a href="https://www.lastpass.com/solutions/authentication/two-factor-authentication">26%</a> of companies using multi-factor authentication to secure their accounts. In addition, with only <a href="https://blog.checkpoint.com/2022/02/02/the-2022-workforce-security-report/">20%</a> of organisations failing to implement methods to protect remote users who are browsing the internet, the risks of remote working becomes dangerously high.</p><h3 id="use-of-remote-working-tools">Use of Remote Working Tools</h3><p>Remote working has led to an increased reliance on third-party communicative technology and online tools, such as Teams, Zoom, Google Hangouts, and Asana, to name just a few. The use of third-party tools has opened up more avenues for cyber criminals to infiltrate remote workers with malicious intent.</p><p>Cyber criminals can use third-party tools to disrupt online conferences and obtain confidential commercial data to use to their advantage.</p><h3 id="sophisticated-attacks">Sophisticated Attacks</h3><p>Attacks are becoming increasingly more sophisticated in the shift to remote work environments. Phishing continues to be a persistent threat, with the heightened risk of remote workers relying on emails and clicking something they shouldn\'t. The risk is heightened remotely since workers have a greater dependence on email and become less suspicious of a well-engineered phishing email attack disguised as a legitimate business request.</p><h2 id="keeping-remote-workers-safe">Keeping Remote Workers Safe</h2><p>Remote adaptations are necessary to cyber strategy and building a cyber culture. If remote employee’s equipment is not secured properly, they can provide entry points for malicious threats, highlighting the necessity of ensuring cyber security for remote workers. There are various ways that employees and organisations can reduce risks associated with working from home and remain safe in a remote working environment:</p><h3 id="creating-equipment-policies">Creating Equipment Policies</h3><p>Where at all possible, remote machines should strictly be used for professional use, with personal devices kept separate from work. Restrictions should also be placed on how professional devices are used, for example, the prohibited use of social media, and introducing use of work equipment regulations.</p><p>Remote workers should also keep family members away from work devices, with company property exposed to those outside of the organisation. It’s vital to remind staff to keep devices safe and not allow other household members to access their work computers, mobiles, and other forms of hardware. Devices should be password protected to prevent third parties from gaining access.</p><h3 id="virtual-private-networks">Virtual Private Networks</h3><p>Remote workers should be using safe, trusted networks to protect their work and corporate data. Virtual private networks (VPN) use an encryption tunnel to protect the connection and keep information safe.</p><p>As home Wi-Fi networks are more vulnerable to attacks, those working remotely should be encouraged to always use a VPN, which will bring firewall protection and align with the company security policy.</p><h3 id="passwords-and-two-factor-authentication">Passwords and Two-Factor Authentication</h3><p>Alongside strong, unique passwords that are regularly updated, multi-factor authentication (MFA or 2FA) is critical for remote employees. Multi-factor authentication adds additional layers of security by requiring the user to validate that they are, in fact, who they say they are. This can include one-time codes, access via a dedicated app on a mobile device, or even biometrics. MFA should be enabled wherever possible. </p><p>Updating passwords should include not only on devices and accounts, but also changing router passwords to reduce the threat of hackers accessing wireless home networks.</p><h3 id="anti-malware-software">Anti-Malware Software</h3><p>Though it may seem straightforward to deploy anti-malware software on business devices, many remote businesses fail to equip employees with basic protection. One of the most effective methods of protection is to invest in a comprehensive antivirus suite.</p><p>Ensure that all remote workers have sufficient and up-to-date antivirus software, anti-malware and firewalls installed on all devices. This software will run discreetly in the background, so employees won’t even notice the hard work it’s doing.</p><h3 id="regular-updates">Regular Updates</h3><p>A basic requirement for remote workers should be to ensure that all hardware and software are both configured correctly and have the latest patches and updates from the manufacturer. This should include keeping router software up to date.</p><p>Rather than delaying updates, remote employees should periodically check for updates and install them when available. Patches and software updates often address potential security concerns.</p><h2 id="managing-remote-teams">Managing Remote Teams</h2><p>Even while employees are working remotely, having an understanding of how to protect themselves and the company is crucial, as well as establishing security for remote employees. Adopting security measures for remote working helps to amp up business defences, while keeping remote employees safe and protected. </p><p>Our cyber training for remote employees upskills and arms teams with knowledge of tools and practices to mitigate cyber attacks, and can be a pillar to <a href="https://tryhackme.com/resources/blog/how-to-build-a-cyber-culture-in-your-workforce">building cyber culture</a>, alongside introductory training modules teaching users how the web works, common threats, and what to look out for.</p><p>Strengthen your cyber security standing today by training and upskilling remote teams.</p><!--kg-card-begin: html--><center><a href="https://tryhackme.com/business"><button style=\'background-color: #222c42; color: white; padding: 15px 20px; border-radius: 10px; font-size: 25px;\'>TryHackMe for Business</button></a></center><!--kg-card-end: html-->',
            comment_id: '63b6d0460181dc0001fa7576',
            feature_image: 'https://blog.tryhackme.com/content/images/2023/01/Cyber-Security-in-the-Remote-Working-World---Banner--1-.png',
            featured: false,
            visibility: 'public',
            created_at: '2023-01-05T13:27:34.000+00:00',
            updated_at: '2023-01-10T10:00:15.000+00:00',
            published_at: '2023-01-10T10:00:15.000+00:00',
            custom_excerpt: 'With distributed workforces working remotely, cyber criminals continue to target remote workers.',
            codeinjection_head: null,
            codeinjection_foot: null,
            custom_template: null,
            canonical_url: null,
            tags: [
                {
                    id: '62977ecde085210001ec2640',
                    name: 'Blog',
                    slug: 'blog',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/blog/',
                },
                {
                    id: '618021e4e085210001ec1aed',
                    name: 'Business',
                    slug: 'business',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/business/',
                },
            ],
            authors: [
                {
                    id: '62eaaa040181dc0001fa6403',
                    name: 'Ellie Gillard',
                    slug: 'ellie',
                    profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                    cover_image: null,
                    bio: null,
                    website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                    location: 'United Kingdom',
                    facebook: null,
                    twitter: '@EllieGillardTHM',
                    meta_title: null,
                    meta_description: null,
                    url: 'https://blog.tryhackme.com/author/ellie/',
                },
            ],
            primary_author: {
                id: '62eaaa040181dc0001fa6403',
                name: 'Ellie Gillard',
                slug: 'ellie',
                profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                cover_image: null,
                bio: null,
                website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                location: 'United Kingdom',
                facebook: null,
                twitter: '@EllieGillardTHM',
                meta_title: null,
                meta_description: null,
                url: 'https://blog.tryhackme.com/author/ellie/',
            },
            primary_tag: {
                id: '62977ecde085210001ec2640',
                name: 'Blog',
                slug: 'blog',
                description: null,
                feature_image: null,
                visibility: 'public',
                og_image: null,
                og_title: null,
                og_description: null,
                twitter_image: null,
                twitter_title: null,
                twitter_description: null,
                meta_title: null,
                meta_description: null,
                codeinjection_head: null,
                codeinjection_foot: null,
                canonical_url: null,
                accent_color: null,
                url: 'https://blog.tryhackme.com/tag/blog/',
            },
            url: 'https://blog.tryhackme.com/cyber-risks-of-remote-working/',
            excerpt: 'With distributed workforces working remotely, cyber criminals continue to target remote workers.',
            reading_time: 5,
            access: true,
            og_image: null,
            og_title: null,
            og_description: null,
            twitter_image: null,
            twitter_title: null,
            twitter_description: null,
            meta_title: 'Mitigating Cyber Security Risks in the Remote Working World',
            meta_description: 'With distributed workforces working remotely, cyber criminals continue to target remote workers.',
            email_subject: null,
            frontmatter: null,
            feature_image_alt: null,
            feature_image_caption: null,
        },
        {
            id: '63b594840181dc0001fa7543',
            uuid: '1553b5ec-cac8-4aa3-bb7e-758af86342a2',
            title: 'Cyber Security Predictions for 2023',
            slug: '2023-cyber-predictions',
            html: '<p>This year has seen some unforgettable changes to the world of cyber security. As we step into 2023, we are taking a step back and showcasing predictions for what the industry could face in the year ahead; compiled by our experts with hundreds of years of combined cyber security experience.</p><p>Let’s explore cyber security predictions for 2023!</p><h2 id="a-rise-in-mobile-specific-cyber-threats">A Rise in Mobile-Specific Cyber Threats</h2><p>With greater reliance on smartphones in the workplace, remote working, and an increase in mobile device threats, cyber crimes involving mobile devices are likely to soar in 2023, meaning experts will have to quickly monitor and mitigate the influx of the latest mobile threats.</p><p>A whopping <a href="https://community.rsa.com/yfcdo34327/attachments/yfcdo34327/fraud-risk-intelligence-blog/18/1/RSA-CurrentStateofCybercrime-2019.pdf">70%</a> of online fraud is accomplished through mobile platforms, with a 680% increase in fraudulent transactions originating from mobile apps. In addition, US cyber crime statistics show that <a href="https://ctmfile.com/story/beware-one-in-36-mobile-devices-has-high-risk-apps-installed">1 in 36</a> mobile devices have high-risk apps installed.</p><p>Mobile device cyber crime statistics show no signs of slowing down in the year ahead. SMS-based authentication has inevitably become less secure, with experts calling for businesses to move over to multi-factor authentication due to the increased risk of SMS-based authentication. Multi-factor authentication can feature an authenticator app using time-sensitive tokens or more direct hardware or device-based authenticators.</p><h2 id="demand-for-security-talent">Demand for Security Talent</h2><p>All industries are battling a continuous cyber skill shortage of professionals, with an estimated shortage of <a href="https://www.computerweekly.com/news/252526318/Cyber-professional-shortfall-hits-34-million">3.4 million</a> cyber security professionals worldwide. The global cyber security workforce must grow by 65% to defend organisations’ critical assets effectively. </p><p>With governments beginning to issue hefty fines to organisations suffering from data breaches, this security shortage will only continue to amplify in 2023 and cause havoc in all industries. The gender skill cap in cyber security is another predominant issue, with women accounting for just 25% of the global cyber security workforce. </p><p>From 2023 onwards, we expect to see organisations fostering career development and progression for those within junior cyber security roles. Experts also predict that women will represent <a href="https://cybercrimemag.wpenginepowered.com/wp-content/uploads/2022/09/Women-In-Cybersecurity-2022-Report-Final.pdf">30%</a> of the global cyber security workforce over the next three years.</p><h2 id="artificial-intelligence-ai">Artificial Intelligence (AI)</h2><p>With its ability to analyse vast volumes of data instantly, an estimated <a href="https://www.statista.com/topics/8131/cyber-crime-and-companies-in-the-uk/#dossierKeyfigures">72% of organisations</a> rely on AI to expose cyber attacks. AI adoption is anticipated to accelerate next year, allowing security, compliance and privacy teams to maximise productivity during great business transformation. </p><p>Artificial intelligence will become increasingly crucial as the data we utilise continues to grow, which we have seen in light of OpenAI’s recent launch of <a href="https://tryhackme.com/resources/blog/chatgpt-our-expert-review">ChatGPT</a>.</p><p>In fraud detection, artificial intelligence can help boost security by analysing vast volumes of data much more quickly while detecting unauthorised and suspicious activity. For fintechs, AI can also strengthen the security of existing systems and fintech transactions.</p><h2 id="ransomware-attacks">Ransomware Attacks</h2><p>Every 14 seconds, a new organisation is hit by ransomware, and this will only continue to accelerate with ransomware attacks on the rise. In 2023, we expect to see cyber criminals increasing ransomware attacks on vulnerable SMBs. Healthcare will remain a prime target, with the rise of patients turning to telehealth to access healthcare services remotely.</p><p>We may expect governments to address ransomware in the next couple of months, with legislation criminalising making ransomware payments. Ultimately, paying ransomware accelerates the drive to conduct ransomware attacks, therefore eradicating ransomware payments may discourage attackers.</p><h2 id="changes-in-laws-and-regulations">Changes in Laws and Regulations</h2><p>The last 12 months have seen a dramatic increase in the frequency and severity of cyber attacks, so it may be unsurprising to know that new regulations will emerge around the subject of ransomware attacks. </p><p>New data privacy laws are also set to go into effect in the United States, meaning that now is the time to assess your current procedures and systems to ensure they comply. At the time of  writing, five states have comprehensive data privacy laws passed and set to take effect in the coming months – California, Colorado, Connecticut, Utah and Virginia.</p><p>The California Consumer Privacy Act (CCPA) is considered the strictest privacy regulation in the U.S., expanding consumer privacy rights, including the right to delete, opt out and request access to information on file. We expect state privacy regulations to heighten in 2023 and beyond.</p><p>Companies must comply with data privacy laws by adapting how data is stored and processed.</p><h2 id="industry-collaboration">Industry Collaboration</h2><p>With the threat landscape expanding in volume and sophistication, we see the industry come together and unify with shared learnings, intelligence, and resources. Progress and development in cyber security require collaboration and knowledge sharing; therefore, industries need to counter the continuous advance of cyber-enabled crime.</p><!--kg-card-begin: html--><table style="border:none;border-collapse:collapse;"><colgroup><col width="601"></colgroup><tbody><tr style="height:0pt"><td style="border-left:solid #000000 1pt;border-right:solid #fafafa 1pt;border-bottom:solid #fafafa 1pt;border-top:solid #ffffff 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt;overflow:hidden;overflow-wrap:break-word;"><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">“In 2023, I think we will see even more collaboration and partnership amongst the good guys as we work together to make the world safer for everyone. No one company can do it alone, and we already see the industry come together.”</span></p><br><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#93c47d;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">Vasu Jakkal,</span><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;"> CVP Security at Microsoft</span></p></td></tr></tbody></table><!--kg-card-end: html--><p>While technological advances make knowledge available to everyone, collaboration and knowledge exchange allow all industries to evolve and stay ahead of cyber threats. We expect to see security vendors and professionals step up and collaborate to fill the void in 2023 while organisations continue to prioritise cyber security.</p><p>Those prioritising cyber security will continue to reduce their risk of business disruption and reputational loss from major breaches.</p><p>As an ever-evolving field, TryHackMe will continue to lead training on new threats and evolving tools and mitigation techniques. We have some brilliant things in store for 2023 and we can\'t wait to join you on your cyber learning journey.</p><!--kg-card-begin: html--><center><a href="https://tryhackme.com/resources/blog/cyber-security-news-2022"><button style=\'background-color: #222c42; color: white; padding: 15px 20px; border-radius: 10px; font-size: 25px;\'>Read our cyber security news for 2022!</button></a></center><!--kg-card-end: html-->',
            comment_id: '63b594840181dc0001fa7543',
            feature_image: 'https://blog.tryhackme.com/content/images/2023/01/Banner--3-.png',
            featured: false,
            visibility: 'public',
            created_at: '2023-01-04T15:00:20.000+00:00',
            updated_at: '2023-01-05T09:00:29.000+00:00',
            published_at: '2023-01-05T09:00:29.000+00:00',
            custom_excerpt: "We've seen some unforgettable changes to the world of cyber security in the last year, but what can we expect to see in 2023?",
            codeinjection_head: null,
            codeinjection_foot: null,
            custom_template: null,
            canonical_url: null,
            tags: [
                {
                    id: '62977ecde085210001ec2640',
                    name: 'Blog',
                    slug: 'blog',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/blog/',
                },
            ],
            authors: [
                {
                    id: '62eaaa040181dc0001fa6403',
                    name: 'Ellie Gillard',
                    slug: 'ellie',
                    profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                    cover_image: null,
                    bio: null,
                    website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                    location: 'United Kingdom',
                    facebook: null,
                    twitter: '@EllieGillardTHM',
                    meta_title: null,
                    meta_description: null,
                    url: 'https://blog.tryhackme.com/author/ellie/',
                },
            ],
            primary_author: {
                id: '62eaaa040181dc0001fa6403',
                name: 'Ellie Gillard',
                slug: 'ellie',
                profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                cover_image: null,
                bio: null,
                website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                location: 'United Kingdom',
                facebook: null,
                twitter: '@EllieGillardTHM',
                meta_title: null,
                meta_description: null,
                url: 'https://blog.tryhackme.com/author/ellie/',
            },
            primary_tag: {
                id: '62977ecde085210001ec2640',
                name: 'Blog',
                slug: 'blog',
                description: null,
                feature_image: null,
                visibility: 'public',
                og_image: null,
                og_title: null,
                og_description: null,
                twitter_image: null,
                twitter_title: null,
                twitter_description: null,
                meta_title: null,
                meta_description: null,
                codeinjection_head: null,
                codeinjection_foot: null,
                canonical_url: null,
                accent_color: null,
                url: 'https://blog.tryhackme.com/tag/blog/',
            },
            url: 'https://blog.tryhackme.com/2023-cyber-predictions/',
            excerpt: "We've seen some unforgettable changes to the world of cyber security in the last year, but what can we expect to see in 2023?",
            reading_time: 4,
            access: true,
            og_image: null,
            og_title: null,
            og_description: null,
            twitter_image: null,
            twitter_title: null,
            twitter_description: null,
            meta_title: 'Cyber Security Predictions for 2023',
            meta_description: "We've seen some unforgettable changes to the world of cyber security in the last year, but what can we expect to see in 2023?",
            email_subject: null,
            frontmatter: null,
            feature_image_alt: null,
            feature_image_caption: null,
        },
        {
            id: '63ac6e950181dc0001fa74a4',
            uuid: '2ca962f9-119a-4cfd-bbae-4ee452bef851',
            title: 'Advent of Cyber Prize Winners!',
            slug: 'advent-of-cyber-winners',
            html: '<p>In this year’s Advent of Cyber, the elf McSkidy needed your help investigating a serious breach, with daily challenges covering red teaming, digital investigations, web vulnerabilities, IoT Hacking, and Cyber Defence. </p><p>Featuring 24 cyber security tasks leading up to Christmas, our fourth consecutive Advent of Cyber was comprised of daily tasks with the purpose of helping you break into cyber. Best of all, you had the chance to win epic prizes with a value of over $40,000!</p><p>All you had to do was participate in the daily tasks to be automatically entered in the draw. For each question you answered correctly, you bagged an extra raffle ticket to our ultimate prize draw! Winners for all prizes have been calculated at random using the pool of raffle tickets.</p><p>Before we get to the exciting bit, let’s remind ourselves of the <em>epic</em> prizes up for grab:</p><ul><li><strong>Offensive Security Learn One subscription</strong></li><li><strong>Raspberry Pi 400</strong></li><li><strong>Airpods 2nd Gen Pro</strong></li><li><strong>DJI Drone</strong></li><li><strong>GoPro</strong></li><li><strong>CompTIA Security+ Vouchers</strong></li><li><strong>Remarkable 2</strong></li><li><strong>Flipper Zero</strong></li><li><strong>ASUS ZenBook 14 8GB RAM, 512GB SSD Intel i5</strong></li><li><strong>Hak5 WiFi Pineapple</strong></li><li><strong>Hak5 Rubber Ducky</strong></li><li><strong>TryHackMe Monthly Subscriptions</strong></li><li><strong>$20 TryHackMe Swag Vouchers</strong></li><li><strong>$2000 donation to a charity of your choice</strong></li></ul><figure class="kg-card kg-image-card"><img src="https://blog.tryhackme.com/content/images/2022/12/prizes-woohoo-03.png" class="kg-image" alt loading="lazy" width="1081" height="500" srcset="https://blog.tryhackme.com/content/images/size/w600/2022/12/prizes-woohoo-03.png 600w, https://blog.tryhackme.com/content/images/size/w1000/2022/12/prizes-woohoo-03.png 1000w, https://blog.tryhackme.com/content/images/2022/12/prizes-woohoo-03.png 1081w" sizes="(min-width: 720px) 720px"></figure><p>It’s finally time to announce our Advent of Cyber 2022 prize winners - woohoo! Drumroll, please...</p><h3 id="offensive-security-learn-one-subscription">Offensive Security Learn One Subscription</h3><p>jrog | s.soni | rattis | cichydawid | Logixmaster | Jaayseme</p><h3 id="raspberry-pi-400">Raspberry Pi 400</h3><p>alpaka007 | NyGmember | sribalaji | mahesh452 | DarknightR3n</p><h3 id="airpods-2-gen-pro">Airpods 2 Gen Pro</h3><p>rockcreeper | Mr.Charlie | rachcrow | 5ku110x539 | CompilerTries | rajesh558888 | Code.Monger | Didacus | ksimha | MeGGu</p><h3 id="dji-drone">DJI Drone</h3><p>schettlerc | Nicfelmen | avaxxx | simplepad | katliana | xebex</p><h3 id="gopro">GoPro</h3><p>Vkingwarrior19 | Orby | GODmak | dithomas1 | cyberdnz | cho44 | Spanska | GacekKosmatek | mooncakeza | samuelajala01</p><h3 id="comptia-security-voucher">CompTia Security+ Voucher</h3><p>hookerfeline54 | Mgriff | tmanso | ckinfi | agendproton | CylentKnight | Rb291 | anonymouslij | overhead | nesnaj</p><h3 id="remarkable-2">Remarkable 2</h3><p>Binary10 | hardhell | admin-ch | magbenyo</p><h3 id="flipper-zero">Flipper Zero</h3><p>ryanramadhanip | MoojPanie | zuggylabs | piratemoo | MateuszB | Madmax3650 | Shatt3r | xoliswa | cyclone8 | teoleo777</p><h3 id="asus-zenbook">ASUS ZenBook</h3><p>Fatkane | Gabbar1990 | sidz | Tophatman | Reyben.Cortes | mikkel | alexandraibutnar | akkabai | beepdisastrous77 | thunder963 | Nester | freeeekon</p><h3 id="hak5-wifi-pineapple">Hak5 WiFi Pineapple</h3><p>TortugaEpica | nortonpt | siph3r | AnuragVerma | randhana | AcidPhreak | leekarop | al.gar | moredolphin | NKxTHM</p><h3 id="hak5-rubber-ducky">Hak5 Rubber Ducky</h3><p>cl4t3 | Brucealmightyman | exploitron | contestantinnova | Ananananananana | ItzikNakav | mikejkelley | DrFalken | Scandium | 0xD4rk</p><h3 id="tryhackme-monthly-subscription">TryHackMe Monthly Subscription</h3><p>Vyper864 | 0tt3rNuggz | Eagles | ycsua | Inimys | scarlet23 | winson | KhaliRou | jahmaal | SoftDevHalp | alexrengel | AeBiCe | thesriidhar | Kakarot | DeepanshHooda</p><h3 id="tryhackme-swag-voucher">TryHackMe Swag Voucher</h3><p>Souvlakia | adicpnn | renatadzembatyi | prof1t | Dexo224</p><h3 id="2000-charity-donation-to-your-chosen-charity">$2000 Charity Donation (to your chosen charity!)</h3><p>SaiNiveditha</p><p><br><strong>Congratulations to our fantastic winners!</strong> </p><p>If you see your username listed above, you’ll be contacted by the email address you signed up to TryHackMe with - make sure you reply to us by the 30th of December. After this date, the prize value will be donated to a charity chosen by TryHackMe.</p><p>Once again, we would like to thank each and every one of you for helping McSkidy save Christmas and for getting involved with this year’s hacking festivities. We’re excited to see what’s in store for next year’s Advent of Cyber.</p><p>The TryHackMe team is creating some <strong>epic </strong>training content for 2023, watch this space to smash your goals! </p><p>See you next time!</p><p><br></p>',
            comment_id: '63ac6e950181dc0001fa74a4',
            feature_image: 'https://blog.tryhackme.com/content/images/2023/01/AoC-winners---blog-header-11-11.png',
            featured: false,
            visibility: 'public',
            created_at: '2022-12-28T16:28:05.000+00:00',
            updated_at: '2023-01-03T08:58:53.000+00:00',
            published_at: '2022-12-28T17:03:32.000+00:00',
            custom_excerpt: 'It’s finally time to announce our Advent of Cyber 2022 prize winners. Drumroll, please!',
            codeinjection_head: null,
            codeinjection_foot: null,
            custom_template: null,
            canonical_url: null,
            tags: [
                {
                    id: '62977ecde085210001ec2640',
                    name: 'Blog',
                    slug: 'blog',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/blog/',
                },
                {
                    id: '616da14ee085210001ec1740',
                    name: 'Newsroom',
                    slug: 'newsroom',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/newsroom/',
                },
            ],
            authors: [
                {
                    id: '62eaaa040181dc0001fa6403',
                    name: 'Ellie Gillard',
                    slug: 'ellie',
                    profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                    cover_image: null,
                    bio: null,
                    website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                    location: 'United Kingdom',
                    facebook: null,
                    twitter: '@EllieGillardTHM',
                    meta_title: null,
                    meta_description: null,
                    url: 'https://blog.tryhackme.com/author/ellie/',
                },
            ],
            primary_author: {
                id: '62eaaa040181dc0001fa6403',
                name: 'Ellie Gillard',
                slug: 'ellie',
                profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                cover_image: null,
                bio: null,
                website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                location: 'United Kingdom',
                facebook: null,
                twitter: '@EllieGillardTHM',
                meta_title: null,
                meta_description: null,
                url: 'https://blog.tryhackme.com/author/ellie/',
            },
            primary_tag: {
                id: '62977ecde085210001ec2640',
                name: 'Blog',
                slug: 'blog',
                description: null,
                feature_image: null,
                visibility: 'public',
                og_image: null,
                og_title: null,
                og_description: null,
                twitter_image: null,
                twitter_title: null,
                twitter_description: null,
                meta_title: null,
                meta_description: null,
                codeinjection_head: null,
                codeinjection_foot: null,
                canonical_url: null,
                accent_color: null,
                url: 'https://blog.tryhackme.com/tag/blog/',
            },
            url: 'https://blog.tryhackme.com/advent-of-cyber-winners/',
            excerpt: 'It’s finally time to announce our Advent of Cyber 2022 prize winners. Drumroll, please!',
            reading_time: 2,
            access: true,
            og_image: null,
            og_title: null,
            og_description: null,
            twitter_image: null,
            twitter_title: null,
            twitter_description: null,
            meta_title: 'Advent of Cyber Prize Winners!',
            meta_description: 'It’s finally time to announce our Advent of Cyber 2022 prize winners. Drumroll, please!',
            email_subject: null,
            frontmatter: null,
            feature_image_alt: null,
            feature_image_caption: null,
        },
        {
            id: '63a189070181dc0001fa7466',
            uuid: 'b5f5ccf6-df23-4d26-af86-2b76dd017502',
            title: 'The Top Cyber Security News From 2022',
            slug: 'cyber-security-news-2022',
            html: '<p>What a year it’s been! The last 12 months have seen a dramatic increase in the frequency and severity of cyber attacks and some unforgettable updates to the world of cyber security.</p><p>We’re looking back at some key developments and highlights from 2022. From the largest DDoS attack in history and millions of users affected by breaches across the globe, all the way through to reaching one million TryHackMe users - we have a lot to share!</p><p>Let’s dive straight in…</p><h2 id="you%E2%80%99re-one-in-a-million">You’re One in a Million!</h2><p>At the beginning of the year, we officially surpassed <a href="https://tryhackme.com/resources/blog/one-million-users">one million users on TryHackMe</a>! To celebrate this momentous milestone, we released batches of brand-new content, gave away a bunch of year-long subscriptions (plus epic limited edition swag!), and even dived into a live Q&amp;A featuring some of the faces behind TryHackMe. We have a team of over 50 experts with combined hundreds of years experience in cyber security; we love to share what we’re all about!</p><h2 id="kaspersky-antivirus-considered-a-security-risk">Kaspersky Antivirus Considered a Security Risk</h2><p>Previously named by Gartner as the third-largest provider of consumer-level IT products, Kaspersky, the digital cyber security and anti-virus company used across the globe, has since been identified as a risk to national security. On the 25th of March, the US Federal Communications Commission (FCC) and the Department of Homeland Security (DHS) added Kaspersky to the list of foreign IT vendors that “pose an unacceptable risk to national security or the security and safety of United States persons”.</p><p>While we’re yet to see public evidence of wrongdoing, companies in the US are forbidden from using FCC funds to purchase Kaspersky products.</p><h2 id="google-hit-by-%E2%80%9Clargest-ever%E2%80%9D-web-ddos-attack">Google Hit by “Largest Ever” Web DDoS Attack</h2><p>On the 1st of June, Google reported that it had blocked the “largest” distributed denial of service (DDoS) attack on record, targetting a Google Cloud Armor user with HTTPS for over an hour. The peak of the attack reached 46 million requests per second.</p><p>At 9:45 AM (PT), an attack of more than 10,000 requests per second (rps) targeted Google’s customer’s HTTP/S Load Balancer. Eight minutes later, the attack grew to 100,000 requests per second. Google announced the DDoS attack was 76% larger than the previous record, highlighting the severity of the attack.</p><!--kg-card-begin: html--><table style="border:none;border-collapse:collapse;"><colgroup><col width="601"></colgroup><tbody><tr style="height:0pt"><td style="border-left:solid #000000 1pt;border-right:solid #fafafa 1pt;border-bottom:solid #ffffff 1pt;border-top:solid #ffffff 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt;overflow:hidden;overflow-wrap:break-word;"><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">“To give a sense of the scale of the attack, that is like receiving all the daily requests to Wikipedia (one of the top 10 trafficked websites in the world) in just 10 seconds.”</span></p><br><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#93c47d;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">Emil Kiner,</span><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;"> Senior Product Manager at Cloud Armor</span></p></td></tr></tbody></table><!--kg-card-end: html--><p>DDoS (distributed denial-of-service) attacks are designed to exceed a website’s capacity to handle multiple requests, preventing the website from functioning as it should. DDoS attacks are increasing in frequency and growing in size at an alarming rate, often used to blackmail businesses into paying a ransom, disrupt service, distract an incident response team and even inflict long-term brand damage.</p><h2 id="twitter%E2%80%99s-data-breach-affects-54-million-users">Twitter’s Data Breach Affects 5.4 Million Users</h2><p>Towards the end of July, a hacker claimed to have possession of 5.4 million Twitter accounts for sale. As a result of the attack, the hacker was able to link email addresses and phone numbers to user accounts, compiling a list of 5.4 million Twitter user profiles.</p><p>The hacker (going by the alias “devil”) revealed they harvested the data using a vulnerability initially flagged to Twitter six months prior. Twitter confirmed the breach on the 5th of August, advising users to secure their accounts with multi-factor authentication. The social giant reassured users that no passwords were compromised in the breach.</p><h2 id="uber-systems-breach">Uber Systems Breach</h2><p>September brought us the news of a significant Uber systems breach that sent shockwaves throughout the ride-hailing company.</p><p>Uber employees initially received a message that read, “I announce I am a hacker, and Uber has suffered a data breach”, before listing several internal databases that had supposedly been compromised. It’s thought that the breach took place after an Uber employee fell victim to social engineering targeting and mistakenly handed over login credentials to the hacker.</p><p>Uber’s system breach left internal systems inaccessible, with the hacker gaining access to the organisation’s email dashboard, endpoints, Windows domain and Amazon Web Services console.</p><h2 id="over-12-million-credit-card-numbers-leaked-on-forum">Over 1.2 Million Credit Card Numbers Leaked on Forum</h2><p>On the 12th of October, BidenCash, a carding marketplace that promotes the trafficking and unauthorised use of credit cards, released the details of 1,221,551 credit cards of individuals from the United Kingdom and United States.</p><p>A file posted on the site contained the card numbers, expiration dates and CVV numbers of cards expiring between 2023 and 2026, meaning that fraudsters could use these details to make online transactions.</p><p>BidenCash hit the news earlier in June 2022 after previously leaking thousands of credit card information to promote the carding website. Cyber security experts believe the latest October release of credit card information could be another attempt at advertising.</p><h2 id="the-launch-of-hackerween">The Launch of Hackerween</h2><p>For the very first year, we released TryHackMe’s Hackerween - a spooky five-day affair running over Halloween week packed full to the brim of juicy content! </p><p>Hackerween brought us new daily challenges, created by our team of experts to exercise your skills on different topics. Daily challenges alternated between blue teams and red teams, with a difficulty rating of easy to medium to test your skills in offensive and defensive topics. <a href="https://tryhackme.com/resources/blog/happy-hackerween">You can still access all the Hackerween challenges</a>, totally free. We’re excited to launch more challenge events in 2023 - watch this space!</p><h2 id="denmark-ranked-as-the-most-cyber-secure-country-in-the-world">Denmark Ranked As the Most Cyber-Secure Country in the World</h2><p>According to the <a href="https://www.visionofhumanity.org/maps/#/">Global Peace Index 2022</a>, Denmark is the fourth safest country in the world, with considerably low crime rates and a fantastic economy and welfare system. And, on the 26th of September 2022, Denmark was announced as the most cyber-secure country in the world! </p><p>In the report of <a href="https://www.comparitech.com/blog/vpn-privacy/cybersecurity-by-country/">cyber secure countries</a>, Denmark was closely followed by Germany, the United States, Norway, the UK, Canada, Sweden, and Australia. Named as the least cyber-secure countries in the world were Tajikistan, Bangladesh, and China.</p><p>While countries across the globe are facing increasingly sophisticated cyber attacks, Denmark consistently leads the global race in cyber security for their widespread implementation of two-factor authentication, strict legislation, cyber security laws, the wide-ranging digitisation of public services, a technologically proficient population, and Danish businesses keeping up with technological advances. These initiatives have contributed to Denmark\'s becoming more robust and digitally secure.</p><h2 id="dozens-of-meta-employees-fired-for-alleged-hacking">Dozens of Meta Employees Fired for Alleged Hacking</h2><p>On the 17th of November, global outlets were flooded by the news that dozens of Meta employees were disciplined or fired for breaking Facebook’s terms of service by allegedly compromising and taking over user accounts.</p><p>The employees, - some of whom were contractors employed as security guards - were investigated for abusing internal tools to bribe users into paying a fee to recover their locked social media accounts. According to the social network\'s terms of service, the buying or selling of accounts or paying for account recovery is a violation.</p><p>One employee was dismissed following accusations that they allowed hackers to fraudulently access multiple Facebook accounts in exchange for thousands of dollars worth of Bitcoin.</p><h2 id="log4j">Log4j</h2><p>In December of 2021, a newly-discovered zero-day vulnerability, Log4j, hit the cyber news with the highest possible CVSS score of 10. The vulnerability enabled attackers to remotely gain access to and take control of machines and servers. It was (and still is) embedded in many apps, services and enterprise software tools written in Java.</p><p>Within hours of its discovery, cyber criminals began exploiting the vulnerability globally. Log4j was claimed to be one of the most severe exploits worldwide.</p><p>One year on, customers are still hit by an average of <a href="https://www.imperva.com/blog/log4j-one-year-later/">500,000</a> attack requests daily, with around 7% of those requests successful. On the 3rd of December, 2022, attack requests skyrocketed higher than had been seen when the vulnerability was first released. </p><p>As a reactive platform closely monitoring recent threats, TryHackMe launched a training lab within 24 hours of log4j’s launch. You can still access our free interactive training lab, allowing you to find out more about how you can <a href="https://tryhackme.com/room/solar">exploit, detect and mitigate Log4j</a>!</p><h2 id="the-return-of-the-bandit-yeti">The Return of the Bandit Yeti</h2><p>Ho ho hackety ho! <a href="https://tryhackme.com/room/adventofcyber4">Advent of Cyber</a> returned to our screens on the 1st of December, and this time round, all users were in with the chance of winning epic prizes worth over $40,000!</p><p>We needed your help investigating a serious breach and testing all remaining systems for security flaws.<strong> </strong>Thanks to all of you, we managed to help McSkidy and the team identify their mysterious adversary, investigate the incident and secure their systems once again throughout each of the daily exercises!</p><p>We also gave away some fantastic prizes, subscription vouchers and free swag to our awesome users - to thank you for joining in on the hacking festivities!</p><p>Don’t panic if you missed out! All <a href="https://tryhackme.com/room/adventofcyber4">Advent of Cyber</a> tasks from 2022 will be available until November 2023.</p><p><strong>We’re excited and intrigued to see what 2023 has in store for the wonderful world of cyber security; the good, the bad, and the ugly. We’ll be here with you throughout your learning journey! Here’s to 2023!</strong></p>',
            comment_id: '63a189070181dc0001fa7466',
            feature_image: 'https://blog.tryhackme.com/content/images/2022/12/A-year-in-cyber-security-01--1-.png',
            featured: false,
            visibility: 'public',
            created_at: '2022-12-20T10:05:59.000+00:00',
            updated_at: '2022-12-22T09:00:01.000+00:00',
            published_at: '2022-12-22T09:00:01.000+00:00',
            custom_excerpt: 'This year has seen some unforgettable changes to the world of cyber security. Join us as we reflect on the key developments and highlights from 2022!',
            codeinjection_head: null,
            codeinjection_foot: null,
            custom_template: null,
            canonical_url: null,
            tags: [
                {
                    id: '62977ecde085210001ec2640',
                    name: 'Blog',
                    slug: 'blog',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/blog/',
                },
                {
                    id: '616da14ee085210001ec1740',
                    name: 'Newsroom',
                    slug: 'newsroom',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/newsroom/',
                },
            ],
            authors: [
                {
                    id: '62eaaa040181dc0001fa6403',
                    name: 'Ellie Gillard',
                    slug: 'ellie',
                    profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                    cover_image: null,
                    bio: null,
                    website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                    location: 'United Kingdom',
                    facebook: null,
                    twitter: '@EllieGillardTHM',
                    meta_title: null,
                    meta_description: null,
                    url: 'https://blog.tryhackme.com/author/ellie/',
                },
            ],
            primary_author: {
                id: '62eaaa040181dc0001fa6403',
                name: 'Ellie Gillard',
                slug: 'ellie',
                profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                cover_image: null,
                bio: null,
                website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                location: 'United Kingdom',
                facebook: null,
                twitter: '@EllieGillardTHM',
                meta_title: null,
                meta_description: null,
                url: 'https://blog.tryhackme.com/author/ellie/',
            },
            primary_tag: {
                id: '62977ecde085210001ec2640',
                name: 'Blog',
                slug: 'blog',
                description: null,
                feature_image: null,
                visibility: 'public',
                og_image: null,
                og_title: null,
                og_description: null,
                twitter_image: null,
                twitter_title: null,
                twitter_description: null,
                meta_title: null,
                meta_description: null,
                codeinjection_head: null,
                codeinjection_foot: null,
                canonical_url: null,
                accent_color: null,
                url: 'https://blog.tryhackme.com/tag/blog/',
            },
            url: 'https://blog.tryhackme.com/cyber-security-news-2022/',
            excerpt: 'This year has seen some unforgettable changes to the world of cyber security. Join us as we reflect on the key developments and highlights from 2022!',
            reading_time: 6,
            access: true,
            og_image: null,
            og_title: null,
            og_description: null,
            twitter_image: null,
            twitter_title: null,
            twitter_description: null,
            meta_title: 'The Top Cyber Security News From 2022',
            meta_description: 'This year has seen unforgettable changes to the world of cyber security. Join us as we reflect on some key developments and highlights from 2022!',
            email_subject: null,
            frontmatter: null,
            feature_image_alt: null,
            feature_image_caption: null,
        },
        {
            id: '639c831a0181dc0001fa73dd',
            uuid: 'f5805434-9f64-4d71-ba16-3bf3625f4c02',
            title: 'TryHackMe in Review - 2022',
            slug: '2022-review',
            html: '<p>Looking back on 2022, we welcomed 752,000 new platform users (bringing the total TryHackMe user count to 1.6 million,) saw hundreds of organisations launch TryHackMe with thousands of employees to upskill and progress in cyber, and released 627 labs and five new pathways. To keep bringing you this epic content, we even expanded our internal team with 30 new staff members!</p><p>Let’s have a look back at some of our highlights from 2022…</p><h2 id="tryhackme-in-2022">TryHackMe in 2022</h2><p>At the beginning of the year, we surpassed an astonishing <a href="https://tryhackme.com/resources/blog/one-million-users">one million users</a>. Now, at the end of 2022, we are delighted to have reached a staggering 1.6 million users!</p><figure class="kg-card kg-image-card"><img src="https://blog.tryhackme.com/content/images/2022/12/image--4-.png" class="kg-image" alt loading="lazy" width="1486" height="836" srcset="https://blog.tryhackme.com/content/images/size/w600/2022/12/image--4-.png 600w, https://blog.tryhackme.com/content/images/size/w1000/2022/12/image--4-.png 1000w, https://blog.tryhackme.com/content/images/2022/12/image--4-.png 1486w" sizes="(min-width: 720px) 720px"></figure><p>To give some insight into a handful of those users, this year, TryHackMe helped:</p><ul><li><a href="https://tryhackme.com/resources/blog/charlie-success-story">Charlie upskill within cyber security</a></li><li><a href="https://tryhackme.com/resources/blog/tepis-success-story">Tepi launch into cyber</a></li><li><a href="https://tryhackme.com/resources/blog/michaels-success-story">Michael transition from Music Teacher to Security Engineer</a></li><li><a href="https://tryhackme.com/resources/blog/olufelas-success-story">Olufela secure a Junior Penetration Tester role</a></li><li><a href="https://tryhackme.com/resources/blog/angus-success-story">Angus upskill as a Cyber Security Analyst</a></li><li><a href="https://tryhackme.com/resources/blog/irenes-success-story">Irene provide Cardiff University students with a hands-on, interactive understanding of cyber security</a></li></ul><p>TryHackMe users have excelled in careers, turned their lives around on a new path, and hit some truly astonishing goals. We will always be here to support you in your journey, and we’re <strong>so </strong>excited to hear more about your successes. Here’s to you!</p><p>We worked with initiatives and charities supporting underrepresented groups with training and guidance to continue making training and cyber careers achievable to all. Here are just some of these initiatives:</p><ul><li><a href="https://tryhackme.com/resources/blog/techvets-initiative">TechVets X TryHackMe</a>: Helping Underrepresented Groups Bridge Into Cyber</li><li><a href="https://tryhackme.com/resources/blog/cybergirls-fellowship">CyberGirls x TryHackMe</a>: Supporting Girls Across Africa Enter the World of Cyber Security</li><li><a href="https://tryhackme.com/resources/blog/cyberscotland-ctf">CyberScotland x TryHackMe</a>: First CTF Used by 1400 Students</li><li><a href="https://tryhackme.com/resources/blog/education-scotland">Education Scotland x TryHackMe</a>: Creating a Skilled, Cyber Aware Generation</li></ul><p>A huge catalyst for what we do is to drive innovation behind learning. With a considerable proportion of breaches preventable with the correct training measures, ensuring businesses have a fundamental understanding of cyber security helps to amp up defences. That’s why, at the beginning of 2022, we launched <a href="https://tryhackme.com/resources/blog/cyber-awareness-training">cyber security awareness training</a> featuring a series of interactive tasks designed to give a baseline understanding of cyber security and common attacks. In turn, we have enabled hundreds of businesses to revolutionise their training and onboarding, nurturing teams of developing, evolving, and thriving individuals.</p><p>In June 2022, we were crowned the <a href="https://tryhackme.com/resources/blog/most-innovative-cyber-sme">UK\'s Most Innovative Cyber SME</a> by DCMS and Infosecurity Europe! TryHackMe was cited as the most innovative for reasons including accessibility - allowing cyber security professions to be achievable without boundaries and contributing vital skills to the market. </p><p><strong>We are incredibly delighted, humbled, and proud of our team and community!</strong></p><h2 id="here%E2%80%99s-to-2023">Here’s to 2023!</h2><p>We can’t wait to see what’s to come in 2023. We’ll be pushing content out across all niches of cyber security, with a significant focus on actively reacting to the ever-increasing threats and advances in the field. We can’t wait to continue making a world-class interactive platform that makes a difference for all TryHackMe users across the globe!</p><p><strong>Once again, we’d like to thank all TryHackMe users for being a part of this journey, and we’d like to extend this gratitide to our incredible team working behind the scenes to bring you epic content. </strong></p><p>2022 has undoubtedly been a tremendous year for achievements and is a testament to the community and the incredible opportunities our users obtain. Whether you’ve used TryHackMe as a hobby, to upskill, develop a career in cyber security, or even prepare for the latest threats, we are honoured to have you. </p><p>Here’s to 2023 - it’s going to be a great one!<br></p>',
            comment_id: '639c831a0181dc0001fa73dd',
            feature_image: 'https://blog.tryhackme.com/content/images/2022/12/THM-Year-in-Review-2022-03.png',
            featured: false,
            visibility: 'public',
            created_at: '2022-12-16T14:39:22.000+00:00',
            updated_at: '2022-12-20T09:21:53.000+00:00',
            published_at: '2022-12-20T09:00:33.000+00:00',
            custom_excerpt: '2022 has undoubtedly been a tremendous year for achievements and is a testament to the community and the incredible opportunities our users obtain. Take a look at some of our highlights!',
            codeinjection_head: null,
            codeinjection_foot: null,
            custom_template: null,
            canonical_url: null,
            tags: [
                {
                    id: '616da14ee085210001ec1740',
                    name: 'Newsroom',
                    slug: 'newsroom',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/newsroom/',
                },
                {
                    id: '62977ecde085210001ec2640',
                    name: 'Blog',
                    slug: 'blog',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/blog/',
                },
            ],
            authors: [
                {
                    id: '62eaaa040181dc0001fa6403',
                    name: 'Ellie Gillard',
                    slug: 'ellie',
                    profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                    cover_image: null,
                    bio: null,
                    website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                    location: 'United Kingdom',
                    facebook: null,
                    twitter: '@EllieGillardTHM',
                    meta_title: null,
                    meta_description: null,
                    url: 'https://blog.tryhackme.com/author/ellie/',
                },
            ],
            primary_author: {
                id: '62eaaa040181dc0001fa6403',
                name: 'Ellie Gillard',
                slug: 'ellie',
                profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                cover_image: null,
                bio: null,
                website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                location: 'United Kingdom',
                facebook: null,
                twitter: '@EllieGillardTHM',
                meta_title: null,
                meta_description: null,
                url: 'https://blog.tryhackme.com/author/ellie/',
            },
            primary_tag: {
                id: '616da14ee085210001ec1740',
                name: 'Newsroom',
                slug: 'newsroom',
                description: null,
                feature_image: null,
                visibility: 'public',
                og_image: null,
                og_title: null,
                og_description: null,
                twitter_image: null,
                twitter_title: null,
                twitter_description: null,
                meta_title: null,
                meta_description: null,
                codeinjection_head: null,
                codeinjection_foot: null,
                canonical_url: null,
                accent_color: null,
                url: 'https://blog.tryhackme.com/tag/newsroom/',
            },
            url: 'https://blog.tryhackme.com/2022-review/',
            excerpt: '2022 has undoubtedly been a tremendous year for achievements and is a testament to the community and the incredible opportunities our users obtain. Take a look at some of our highlights!',
            reading_time: 3,
            access: true,
            og_image: null,
            og_title: null,
            og_description: null,
            twitter_image: null,
            twitter_title: null,
            twitter_description: null,
            meta_title: 'TryHackMe in Review - 2022',
            meta_description: 'Looking back on 2022, TryHackMe has had a tremendous year for achievements, progression, and expansion. Join us in reminiscing on our highlights!',
            email_subject: null,
            frontmatter: null,
            feature_image_alt: null,
            feature_image_caption: null,
        },
        {
            id: '639c98d40181dc0001fa740e',
            uuid: '5a24b318-c580-4277-b48b-98e65421ba1d',
            title: 'ChatGPT: Here’s What the Experts Say!',
            slug: 'chatgpt-our-expert-review',
            html: '<p>Described as the latest revolutionary development in the world of generative AI, ChatGPT has quickly turned into a viral sensation since the text-based artificial intelligence tool was released in recent weeks. The new AI is the latest chatbot from independent research body, OpenAI foundation, founded by Elon Musk.</p><p>After launching in late November of 2022, ChatGPT has reached over one million users and has since taken the tech industry and the internet by storm.</p><h2 id="what-is-chatgpt">What is ChatGPT?</h2><p>As a variant of OpenAI’s popular GPT-3.5 language-generation software, ChatGPT has been designed to carry conversations with users, answer questions, and even write essays. </p><p>In as little as a nano-second, OpenAI takes your question, scans the internet for answers and compiles a response out of data fragments. Trained by AI and machine learning, the chatbot is designed to provide information and answer questions through a conversational interface.</p><p>One of the most significant benefits of ChatGPT is its ability to learn and adapt quickly to new information and topics. </p><p>The AI tool remembers what users said in an earlier conversation and is trained to decline inappropriate or harmful requests. There are, however, situations where ChatGPT may unintentionally produce incorrect or inappropriate information.</p><h2 id="a-%E2%80%98game-changer%E2%80%99-for-businesses">A ‘Game-Changer’ for Businesses</h2><p>So far, the response to the artificial intelligence chatbot has been overwhelmingly positive after creating a major buzz on social media. ChatGPT is already being hailed as a game-changer for businesses that rely on natural language processing, showing the potential to revolutionise how we interact with technology.</p><p>For businesses, using ChatGPT creates an opportunity for a natural and human-like conversational experience for users while freeing time for human customer service agents to focus on more complex and high-value interactions. </p><p>The concept of ChatGPT serves as a reminder that innovation is ongoing. ​​If ChatGPT’s popularity continues to soar, we may expect to see search engines updating their core search technology to incorporate chat functionality.</p><h2 id="public-concerns">Public Concerns</h2><p>As you may have anticipated, many headlines hit the news arguing against using ChatGPT, with speculation that professions dependent upon content production could be rendered obsolete.</p><p>Questioning whether robots are set to replace skilled jobs, Paul Krugman of The New York Times\', says: “<em>ChatGPT is only the latest example of technology that seems to be able to carry out tasks that not long ago seemed to require the services not just of human beings but of humans with substantial formal education.</em>”</p><p>It is possible OpenAI’s chatbot could cause job losses through automation. As the model can generate large amounts of text quickly and at a low cost, it could be used to automate some tasks currently performed by humans. Meanwhile, others have argued that OpenAI’s Chat GPT-3 lacks interpretability and creativity, with limits on the potential uses and capabilities of the model.</p><h2 id="the-cyber-risks-of-chatgpt">The Cyber Risks of ChatGPT</h2><p>Artificial intelligence <em>could</em> be a catalyst for cyber crime when in the wrong hands. Researchers have already shared concerns that any user can generate malware and ransomware on-demand without technical expertise or coding knowledge. Cyber criminals can use AI to increase the volume of phishing threats, challenging security teams that are already overwhelmed. </p><p>While security teams can leverage ChatGPT for defensive security, the solution has also significantly complicated the threat landscape. Security researchers have already begun testing ChatGPT’s capacity to generate malicious code. </p><p>On the other hand, security analysts can use the tool to review open-source code for vulnerabilities before deployment.</p><h2 id="our-final-thoughts">Our Final Thoughts</h2><p>ChatGPT has certainly stirred excitement in the community! With some of the chatbot’s limitations, it’s unclear if and when ChatGPT can be used commercially. While it’s still early days, ​​it has the potential to be used in a wide range of applications and is already having a major impact on the field of artificial intelligence. </p><p>As ChatGPT continues to evolve, it will undoubtedly play an increasingly important role in shaping the future of human-computer interaction. We’re excited to see how ChatGPT develops and would recommend trying it out for yourself to see just what the tool is capable of. </p><p>Keep an eye out, as we’ll be reporting on any key updates in the future in our monthly round-up posts!</p>',
            comment_id: '639c98d40181dc0001fa740e',
            feature_image: 'https://blog.tryhackme.com/content/images/2022/12/ChatGPT-banner.png',
            featured: false,
            visibility: 'public',
            created_at: '2022-12-16T16:12:04.000+00:00',
            updated_at: '2022-12-19T11:43:10.000+00:00',
            published_at: '2022-12-19T09:00:32.000+00:00',
            custom_excerpt: 'ChatGPT has reached over one million users and has taken the tech industry and the internet by storm. Take a read of our expert views!',
            codeinjection_head: null,
            codeinjection_foot: null,
            custom_template: null,
            canonical_url: null,
            tags: [
                {
                    id: '62977ecde085210001ec2640',
                    name: 'Blog',
                    slug: 'blog',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/blog/',
                },
                {
                    id: '616da14ee085210001ec1740',
                    name: 'Newsroom',
                    slug: 'newsroom',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/newsroom/',
                },
            ],
            authors: [
                {
                    id: '62eaaa040181dc0001fa6403',
                    name: 'Ellie Gillard',
                    slug: 'ellie',
                    profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                    cover_image: null,
                    bio: null,
                    website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                    location: 'United Kingdom',
                    facebook: null,
                    twitter: '@EllieGillardTHM',
                    meta_title: null,
                    meta_description: null,
                    url: 'https://blog.tryhackme.com/author/ellie/',
                },
            ],
            primary_author: {
                id: '62eaaa040181dc0001fa6403',
                name: 'Ellie Gillard',
                slug: 'ellie',
                profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                cover_image: null,
                bio: null,
                website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                location: 'United Kingdom',
                facebook: null,
                twitter: '@EllieGillardTHM',
                meta_title: null,
                meta_description: null,
                url: 'https://blog.tryhackme.com/author/ellie/',
            },
            primary_tag: {
                id: '62977ecde085210001ec2640',
                name: 'Blog',
                slug: 'blog',
                description: null,
                feature_image: null,
                visibility: 'public',
                og_image: null,
                og_title: null,
                og_description: null,
                twitter_image: null,
                twitter_title: null,
                twitter_description: null,
                meta_title: null,
                meta_description: null,
                codeinjection_head: null,
                codeinjection_foot: null,
                canonical_url: null,
                accent_color: null,
                url: 'https://blog.tryhackme.com/tag/blog/',
            },
            url: 'https://blog.tryhackme.com/chatgpt-our-expert-review/',
            excerpt: 'ChatGPT has reached over one million users and has taken the tech industry and the internet by storm. Take a read of our expert views!',
            reading_time: 3,
            access: true,
            og_image: null,
            og_title: null,
            og_description: null,
            twitter_image: null,
            twitter_title: null,
            twitter_description: null,
            meta_title: 'ChatGPT: Here’s What the Experts Say!',
            meta_description: 'ChatGPT has reached over one million users and has taken the tech industry and the internet by storm. Take a read of our expert views!',
            email_subject: null,
            frontmatter: null,
            feature_image_alt: 'Robot typing on a laptop',
            feature_image_caption: null,
        },
        {
            id: '637be3770181dc0001fa72aa',
            uuid: 'c09b6ad2-8009-4a1d-8884-b59ea5f3473f',
            title: 'Advent of Cyber 2022',
            slug: 'advent-of-cyber-2022',
            html: '<p><strong>Ho ho hackety ho! </strong></p><p>It’s our favourite time of the year - Advent of Cyber - woohoo! This year’s event features 24 cyber security tasks leading up to Christmas. Our fourth consecutive Advent of Cyber is comprised of daily tasks with the purpose of helping you break into cyber. You can also win <strong>epic </strong>prizes with a value of over $40,000! </p><!--kg-card-begin: html--><center><a href="https://tryhackme.com/room/adventofcyber4"><button style=\'background-color: #222c42; color: white; padding: 15px 20px; border-radius: 10px; font-size: 25px;\'>Join Advent of Cyber!</button></a></center><!--kg-card-end: html--><p><em>It’s an advent calendar but with security challenges instead of chocolate! (And a bucket load of prizes!)</em></p><h2 id="what-you-will-learn">What You Will Learn</h2><p>Advent of Cyber aims to give a baseline understanding and introduction to cyber security, covering red, blue, and purple team topics. This year, topics include red teaming, digital investigations, web vulnerabilities, IoT Hacking, and Cyber Defence. </p><p>TryHackMe learning features gamified labs, where you will be guided through topics in a thorough, absorbable learning guide composed by our team of experts. You will use this theory to actively hack and defend vulnerable virtual machines to learn in action, transferable to job roles. Every daily task features a walkthrough video created by some of the key content creators in our field. Expect to see juicy content from people such as John Hammond, Cybersecurity Meg, Husky Hacks, SecurityNinja, Neal Bridges, InsiderPHD, and more! </p><p>All you have to do is participate in the daily tasks to be automatically entered in the prize draw. We will contact you by the email address you signed up to TryHackMe with.</p><figure class="kg-card kg-image-card"><img src="https://lh4.googleusercontent.com/eHPUpLHncMQSeVAJd5KdUe4B4v1Q4lTzwCV4wahrCM04rIJdEEn7lw6epHbwXJszB5MmmY7SB8Y_Zd7N-xKOp6lTDnZbhMwVNEEw1R9sBDEbtbhtqYBhBm2W_ipdC2vNPXPfKQf4g6vnqAXdjR783OzeI_OcPX6ARFpYywiO4yDcyrK1217YolUXjAhu6Q" class="kg-image" alt loading="lazy"></figure><p>Spread the word and share Advent of Cyber!</p><h2 id="win-over-40000-worth-of-prizes">Win Over $40,000 Worth of Prizes!</h2><p>Let’s talk about the GOODS. In this event, points don’t matter, but the number of questions you answer does! For each question you get correct, you get a raffle ticket. We will randomly choose the winners on the 28th of December using everyone’s raffle tickets. The more questions you answer, the more chances you have of winning. You can win: </p><ul><li>Offensive Security Learn One subscription</li><li>$2000 donation to a charity of your choice</li><li>Raspberry Pi 400</li><li>Airpods 2nd Gen Pro</li><li>DJI Drone</li><li>GoPro</li><li>CompTIA Security+ Vouchers</li><li>Remarkable 2</li><li>Flipper Zero</li><li>ASUS ZenBook 14 8GB RAM, 512GB SSD Intel i5</li><li>Hak5 WiFi Pineapple</li><li>Hak5 Rubber Ducky</li><li>TryHackMe Monthly Subscriptions</li><li>$20 TryHackMe Swag Vouchers</li></ul><p>All you have to do is take part in the daily tasks to be entered. We will contact you by the email address you signed up to TryHackMe with. </p><p>On top of this, you can win <strong>daily prizes</strong>. Every day you complete a question, you will be entered into a separate prize draw for the chance to win a mini-prize. You can win one of two prizes every day; a one-month TryHackMe subscription voucher or a £15 swag voucher. Prize winners will be announced every Monday of the event on Twitter, and winners will be contacted via email.</p><h2 id="certification">Certification</h2><p>You will get a certificate for completing Advent of Cyber, a testament to your participation and hard work! Many companies across the cyber security field seek TryHackMe experience as desired when hiring new employees, so getting started with TryHackMe training can help you excel in achieving your goals.</p><h2 id="celebrate-in-style">Celebrate in Style</h2><p>We’ve launched a limited edition Christmas T-shirt to celebrate this year’s advent of cyber, which you can get your hands on in our <a href="https://store.tryhackme.com/">swag store</a>. You can also win exclusive Christmas swag throughout December by following us on social media: <a href="https://twitter.com/RealTryHackMe">Twitter</a>, <a href="https://www.linkedin.com/company/tryhackme/">LinkedIn</a>, <a href="https://www.facebook.com/people/Tryhackme/100069557747714/">Facebook</a>, <a href="https://www.instagram.com/realtryhackme/">Instagram</a>, <a href="https://discord.com/invite/tryhackme">Discord</a>, and <a href="https://www.pinterest.co.uk/RealTryHackMe/">Pinterest</a>.</p><h2 id="advent-of-cyber-for-businesses">Advent of Cyber for Businesses</h2><p>Advent of Cyber is for everyone. After seeing the value of challenge events across our clients, we’re adding an extra focus to business benefits this year. Get your team and wider company involved in Advent of Cyber to benefit from collaborative hacking, broader team engagement, and strengthen your cyber security standing. </p><p><a href="https://tryhackme.com/resources/blog/advent-of-cyber-for-business">Check out how to get involved in Advent of Cyber with your company here.</a></p><hr><p>However you choose to get involved, step into Christmas with us, amp up your cyber security skills, and learn about the Nightmare before Elfmas…</p><!--kg-card-begin: html--><center><a href="https://tryhackme.com/christmas"><button style=\'background-color: #222c42; color: white; padding: 15px 20px; border-radius: 10px; font-size: 25px;\'>Get Started!</button></a></center><!--kg-card-end: html--><figure class="kg-card kg-image-card"><img src="https://blog.tryhackme.com/content/images/2022/11/AdventOfCyber-scroll2.jpeg" class="kg-image" alt loading="lazy" width="612" height="2727" srcset="https://blog.tryhackme.com/content/images/size/w600/2022/11/AdventOfCyber-scroll2.jpeg 600w, https://blog.tryhackme.com/content/images/2022/11/AdventOfCyber-scroll2.jpeg 612w"></figure>',
            comment_id: '637be3770181dc0001fa72aa',
            feature_image: 'https://blog.tryhackme.com/content/images/2022/11/AoC-Launch-Image-03.png',
            featured: false,
            visibility: 'public',
            created_at: '2022-11-21T20:45:43.000+00:00',
            updated_at: '2022-12-30T14:36:21.000+00:00',
            published_at: '2022-12-01T09:00:52.000+00:00',
            custom_excerpt: 'Get started in cyber security for free with Advent of Cyber: 24 unique daily challenges and $40,000 worth of prizes!',
            codeinjection_head: null,
            codeinjection_foot: null,
            custom_template: null,
            canonical_url: null,
            tags: [
                {
                    id: '62977ecde085210001ec2640',
                    name: 'Blog',
                    slug: 'blog',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/blog/',
                },
            ],
            authors: [
                {
                    id: '6162059ee085210001ec16bd',
                    name: 'Emma Sivess',
                    slug: 'emma',
                    profile_image: 'https://blog.tryhackme.com/content/images/2021/10/Emma-Sivess.png',
                    cover_image: null,
                    bio: null,
                    website: 'https://www.linkedin.com/in/emma-sivess-7b1431b4/',
                    location: 'Brighton',
                    facebook: null,
                    twitter: null,
                    meta_title: null,
                    meta_description: null,
                    url: 'https://blog.tryhackme.com/author/emma/',
                },
            ],
            primary_author: {
                id: '6162059ee085210001ec16bd',
                name: 'Emma Sivess',
                slug: 'emma',
                profile_image: 'https://blog.tryhackme.com/content/images/2021/10/Emma-Sivess.png',
                cover_image: null,
                bio: null,
                website: 'https://www.linkedin.com/in/emma-sivess-7b1431b4/',
                location: 'Brighton',
                facebook: null,
                twitter: null,
                meta_title: null,
                meta_description: null,
                url: 'https://blog.tryhackme.com/author/emma/',
            },
            primary_tag: {
                id: '62977ecde085210001ec2640',
                name: 'Blog',
                slug: 'blog',
                description: null,
                feature_image: null,
                visibility: 'public',
                og_image: null,
                og_title: null,
                og_description: null,
                twitter_image: null,
                twitter_title: null,
                twitter_description: null,
                meta_title: null,
                meta_description: null,
                codeinjection_head: null,
                codeinjection_foot: null,
                canonical_url: null,
                accent_color: null,
                url: 'https://blog.tryhackme.com/tag/blog/',
            },
            url: 'https://blog.tryhackme.com/advent-of-cyber-2022/',
            excerpt: 'Get started in cyber security for free with Advent of Cyber: 24 unique daily challenges and $40,000 worth of prizes!',
            reading_time: 3,
            access: true,
            og_image: null,
            og_title: null,
            og_description: null,
            twitter_image: null,
            twitter_title: null,
            twitter_description: null,
            meta_title: 'TryHackMe Advent of Cyber 2022',
            meta_description: 'Get started in cyber security for free with Advent of Cyber 2022: 24 unique daily challenges and $40,000 worth of prizes!',
            email_subject: null,
            frontmatter: null,
            feature_image_alt: null,
            feature_image_caption: null,
        },
        {
            id: '637f4bb80181dc0001fa739d',
            uuid: 'c10cab54-c5f8-4913-a13e-32130a39aa4f',
            title: 'Training, Retaining & Upskilling SOC Teams',
            slug: 'training-retaining-upskilling-soc-teams',
            html: '<p>SOC (Security Operations Centre) professionals are at the core of your organisation’s security team, with a responsibility to monitor, prevent, detect, investigate, and respond to cyber threats around the clock.</p><p>With the cyber security threat landscape rapidly evolving and attacks becoming more sophisticated, there is never a better reason to invest in the upskilling and development of your SOC team. Upskilling your security team should form a pillar of your security plan, and is key to future-proofing your cyber security operations team.</p><p>Keep reading to discover how to continuously upskill your SOC team, the benefits of doing so,  and how <a href="https://tryhackme.com/module/security-operations-and-monitoring">Security Operations &amp; Monitoring</a> and ongoing TryHackMe training can strengthen your SOC team.</p><h2 id="knowledge-of-the-latest-threats">Knowledge of the Latest Threats</h2><p>New vulnerabilities surface every day. To ensure SOC teams are up to speed and prepared in all scenarios, it’s crucial to keep your team aware of recent threats with hands-on cyber security training, arming them with the knowledge needed to mitigate negative implications of emerging and evolving tactics.</p><p>Giving the confidence to deal with all types of threats will allow security teams to better interpret analytics, giving them greater visibility to threats and the early warning signs to look out for. This also includes maintaining and updating existing systems, reviewing all network activities, and patching vulnerabilities, alongside other core SOC team responsibilities.</p><p>Outdated security operations training loses relevancy quickly - as tools, tactics, and threats change consistently in our industry. It’s all too common for SOC teams to be given training that has been developed and marginally adapted (if at all,) years ago. Your team should be up to date with all the latest security developments to be as prepared as possible.</p><h2 id="proactive-defence">Proactive Defence</h2><p>Attackers work hard to avoid detection, which is why SOC Analysts proactively search for and investigate evidence of anomalies that may indicate an attack. </p><p>SOC teams must possess an in-depth knowledge of threat intelligence, incident response, digital forensics, vulnerability management, and endpoint analysis. If you\'re not upskilling your SOC team, the skill gaps will only widen.</p><p>SOC Analysts deal with a growing number of alerts on a day-to-day basis. While common causes often include phishing attacks, social engineering attempts, stolen passwords, and other forms of <a href="https://tryhackme.com/resources/blog/cyber-security-the-cost-of-human-error#:~:text=What%20is%20human%20error%3F,and%20falling%20victim%20to%20scams.">human error</a>, training professionals outside of the SOC team is equally as important. Adopting <a href="https://tryhackme.com/resources/blog/non-technical-cyber-security-training">cyber security training for non-technical teams</a> can aid in building a cyber-savvy team capable of helping to prevent breaches.</p><h2 id="quick-response-times">Quick Response Times</h2><p>With the rise of complex attacks, SOC teams must respond quickly with accuracy. This is where the 1/10/60 challenge comes in, whereby analysts have an average of one minute to detect an attack, 10 minutes to understand it and 60 minutes to contain it. </p><p>Threat hunting and intelligence monitoring are vital in detecting and preventing the early stages of an attack, and a key understanding of these tools will help to improve the average response time to threats.</p><h2 id="employee-retention">Employee Retention</h2><p>A challenge faced by many SOC teams around the globe is the lack of automation and ongoing training and development, resulting in the difficulty of retaining talent - contributing towards the cyber skills shortage.</p><p>SOC analysts are the first line of defence. Therefore, investing time, resources and ongoing training will allow your security operations team to further their education, putting them in a more advanced position to monitor and analyse the organisation’s security posture.</p><p>With talented cyber security individuals in short supply, training, upskilling and investing in your SOC team members is pivotal.</p><h2 id="tryhackme-for-soc-teams">TryHackMe for SOC Teams</h2><p>TryHackMe consists of over 560 real-world training labs to teach these topics in-action, arming your team with the knowledge needed for defensive security operations. </p><p>Our training pathways explore high-level offensive and defensive security content, allowing security teams to stay on top of new threats and advances in the industry, and are perfect for SOC teams alongside the entirety of your team to build foundations for a cyber culture.</p><!--kg-card-begin: html--><center><a href="https://tryhackme.com/business"><button style=\'background-color: #222c42; color: white; padding: 15px 20px; border-radius: 10px; font-size: 25px;\'>TryHackMe for Business</button></a></center><!--kg-card-end: html-->',
            comment_id: '637f4bb80181dc0001fa739d',
            feature_image: 'https://blog.tryhackme.com/content/images/2022/11/Training--Retaining---Upskilling-SOC-Teams---banner.png',
            featured: false,
            visibility: 'public',
            created_at: '2022-11-24T10:47:20.000+00:00',
            updated_at: '2022-12-01T09:00:02.000+00:00',
            published_at: '2022-12-01T09:00:02.000+00:00',
            custom_excerpt: 'To ensure SOC teams are up to speed and prepared in all scenarios, it’s crucial to arm your team with the knowledge needed to mitigate negative implications of emerging and evolving tactics.',
            codeinjection_head: null,
            codeinjection_foot: null,
            custom_template: null,
            canonical_url: null,
            tags: [
                {
                    id: '618021e4e085210001ec1aed',
                    name: 'Business',
                    slug: 'business',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/business/',
                },
                {
                    id: '62977ecde085210001ec2640',
                    name: 'Blog',
                    slug: 'blog',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/blog/',
                },
            ],
            authors: [
                {
                    id: '62eaaa040181dc0001fa6403',
                    name: 'Ellie Gillard',
                    slug: 'ellie',
                    profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                    cover_image: null,
                    bio: null,
                    website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                    location: 'United Kingdom',
                    facebook: null,
                    twitter: '@EllieGillardTHM',
                    meta_title: null,
                    meta_description: null,
                    url: 'https://blog.tryhackme.com/author/ellie/',
                },
            ],
            primary_author: {
                id: '62eaaa040181dc0001fa6403',
                name: 'Ellie Gillard',
                slug: 'ellie',
                profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                cover_image: null,
                bio: null,
                website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                location: 'United Kingdom',
                facebook: null,
                twitter: '@EllieGillardTHM',
                meta_title: null,
                meta_description: null,
                url: 'https://blog.tryhackme.com/author/ellie/',
            },
            primary_tag: {
                id: '618021e4e085210001ec1aed',
                name: 'Business',
                slug: 'business',
                description: null,
                feature_image: null,
                visibility: 'public',
                og_image: null,
                og_title: null,
                og_description: null,
                twitter_image: null,
                twitter_title: null,
                twitter_description: null,
                meta_title: null,
                meta_description: null,
                codeinjection_head: null,
                codeinjection_foot: null,
                canonical_url: null,
                accent_color: null,
                url: 'https://blog.tryhackme.com/tag/business/',
            },
            url: 'https://blog.tryhackme.com/training-retaining-upskilling-soc-teams/',
            excerpt: 'To ensure SOC teams are up to speed and prepared in all scenarios, it’s crucial to arm your team with the knowledge needed to mitigate negative implications of emerging and evolving tactics.',
            reading_time: 3,
            access: true,
            og_image: null,
            og_title: null,
            og_description: null,
            twitter_image: null,
            twitter_title: null,
            twitter_description: null,
            meta_title: 'Training, Retaining & Upskilling SOC Teams',
            meta_description: 'It’s crucial to arm your SOC team with the knowledge needed to mitigate negative implications of emerging and evolving tactics - and we can help!',
            email_subject: null,
            frontmatter: null,
            feature_image_alt: null,
            feature_image_caption: null,
        },
        {
            id: '637f3a6e0181dc0001fa7373',
            uuid: '13b2e532-c8fc-443d-a6fa-ba2fe2904777',
            title: 'This Month in Cyber Security: November 2022',
            slug: 'november-cyber-security-roundup',
            html: '<p>Another month has passed in the world of cyber security, and November has been nothing short of newsworthy - with dozens of Meta staff fired in a catastrophic Facebook-Instagram hijack, Google fined $391 million for misleading users, the NCSC adopting advanced methods of identifying UK vulnerabilities, and an all-new SOC Analyst pathway to get your teeth into. </p><p>Plus, the annual launch of Advent of Cyber - full of hacker festivities and over $40,000 of epic prizes to win!</p><p>Keep reading to deep dive into our November roundup for your monthly dose of cyber security updates!</p><h2 id="dozens-of-meta-employees-fired-in-facebook-instagram-hijack">Dozens of Meta Employees Fired in Facebook-Instagram Hijack</h2><p>Meta Platforms is said to have fired dozens of employees and contractors (who worked as security guards for Meta) over the past year for allegedly compromising and taking over user accounts.</p><p>Those accused of hijacking were initially given access to an internal system called ‘Oops’, used for restoring access to Facebook and Instagram accounts. Dozens of Meta employees were found abusing internal tools to bribe Facebook and Instagram users into paying a fee to recover their locked social media accounts.</p><p>Meta security guidelines state that buying or selling accounts or paying for an account recovery service is a violation of the social network\'s terms of service.</p><!--kg-card-begin: html--><table style="border:none;border-collapse:collapse;"><colgroup><col width="601"></colgroup><tbody><tr style="height:0pt"><td style="border-left:solid #000000 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt;overflow:hidden;overflow-wrap:break-word;"><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">"Meta will keep taking appropriate action against those involved in these kinds of schemes. Individuals selling fraudulent services are always targeting online platforms, including ours, and adapting their tactics in response to the detection methods that are commonly used across the industry.”</span></p><br><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#93c47d;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">Andy Stone</span><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">, Spokesperson for Meta</span></p></td></tr></tbody></table><!--kg-card-end: html--><p>With individuals, businesses and organisations across the globe depending on social media, gaining illicit control of an account can be lucrative and detrimental. </p><p>The incident has taken the internet by storm, with global news outlets criticising the social media giant and Google searches for ‘Meta hijack’ soaring throughout November.</p><h2 id="google-fined-391m-for-location-tracking">Google Fined $391M for Location Tracking</h2><p>Google has been ordered to pay a record $391.5 million fine over charges that the internet giant has prioritised profits over user privacy, with Google collecting user location information without the user’s acknowledgement.</p><p>The collection of personal location data has been referred to as ‘deceptive’, after leading users to believe they had turned off location tracking in their account settings. Despite users switching off their Location History settings, Web &amp; App Activity was automatically enabled when users set up their Google accounts. </p><p>By misleading consumers with location tracking practices, Google is found to have broken state consumer protection laws. The $391.5 million fine will be divided among 40 affected states in the United States, with Google ordered to be “more transparent” with their practices. Users are advised to check their Google location tracking settings.</p><h2 id="discord-users-hit-by-ransomware">Discord Users Hit by Ransomware</h2><p>On the 20th November, it was announced that Discord was hit by the new \'AXLocker\' ransomware family that not only encrypts victims\' files and demands a ransom payment, but also steals the Discord accounts of infected users.</p><p>When users logged into Discord, the platform then sent the user an authentication token which hackers used to log in as the user or issue API requests that retrieve information about the associated account. The Discord ransomware attack targeted consumers, with ransomware victims were then displayed a pop-up window containing a message that their data was encrypted and how they can purchase a decryptor. Victims were given just 48 hours to contact attackers.</p><p>If you notice that AXLocker has encrypted your computer, you are advised to immediately update your login credentials to prevent further compromisation of your accounts and data.</p><h2 id="hive-ransomware-receive-100m-in-ransom-payments">Hive Ransomware Receive $100M in Ransom Payments</h2><p>Hive ransomware operators struck over 1,300 global businesses between June 2021 and November 2022, attacking vulnerabilities in Microsoft Exchange Server and Fortinet VPNsa.</p><p>Collecting an estimated $100 million in ransom payments, the Hive ransomware group used the ransomware-as-a-service (RaaS) model to conduct and distribute the ransomware attacks, targeting a number of businesses and critical infrastructure sectors.</p><p>In some reported cases, Hive actors were able to bypass multi-factor authentication (MFA) and gain access to FortiOS servers by exploiting Common Vulnerabilities and Exposures (CVE) CVE-2020-12812. </p><p>Initial access was also gained to victim networks through the distribution of phishing emails containing malicious attachments. Around half of cyber attacks in the UK involve phishing (a third in the US), with phishing attempts found in one in every 3,722 emails. </p><p><strong>TryHackMe has training catered to a plethora of cyber threats and patterns, with over 560 training labs. Learn how to analyse and defend against phishing emails, and investigate real-world phishing attempts using a variety of techniques with our </strong><a href="https://tryhackme.com/module/phishing"><strong>phishing module.</strong></a></p><h2 id="new-scanning-capability-to-identify-uk-vulnerabilities">New Scanning Capability to Identify UK Vulnerabilities</h2><p>In other cyber security news, the National Cyber Security Centre (NCSC) has launched a new data-driven scanning capability identifying cyber vulnerabilities in the UK, in a bid to make the UK the safest place to live and work.</p><p>The scanning capability service intends to enhance the understanding of the UK\'s security standing, as a whole, and improve responses to shocks, such as widely exploited zero-day vulnerabilities. From this information, the NCSC hopes to identify the common issues for businesses and, in turn, better explain those issues to organisations.</p><!--kg-card-begin: html--><table style="border:none;border-collapse:collapse;"><colgroup><col width="601"></colgroup><tbody><tr style="height:0pt"><td style="border-left:solid #000000 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt;overflow:hidden;overflow-wrap:break-word;"><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">"We\'re not trying to find vulnerabilities in the UK for some other, nefarious purpose. We\'re beginning with simple scans, and will slowly increase the complexity of the scans, explaining what we\'re doing (and why we\'re doing it)."</span></p><br><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#93c47d;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">National Cyber Security Centre (NCSC)</span></p></td></tr></tbody></table><!--kg-card-end: html--><p>The vulnerability scanning program will review all connected internet devices in the country for software versions, looking for outdated installations that have known vulnerabilities.</p><h2 id="soc-analyst-pathway-release">SOC Analyst Pathway Release</h2><p>Earlier this month, we finally released our brand-new <a href="https://tryhackme.com/path/outline/soclevel1">SOC Level 1 pathway</a>, with over 21,000 TryHackMe users already enrolled!</p><p>Covering the many tools and real-life analysis scenarios, the pathway equips you with the knowledge and skills to break into the field of defensive security operations, through a day in the life of a Junior Security Analyst.</p><p>Get started with our <a href="https://tryhackme.com/path/outline/introtocyber">Introduction to Cyber Security</a> and <a href="https://tryhackme.com/path/outline/presecurity">Pre-Security</a> pathways, and upskill with our brand new <a href="https://tryhackme.com/path/outline/soclevel1">SOC Level 1 pathway</a>!</p><h2 id="advent-of-cyber-2022">Advent of Cyber: 2022</h2><p>Ho ho hackety ho! The TryHackMe elves have been busy working behind the scenes to bring you yet another epic <a href="https://tryhackme.com/room/adventofcyber4">Advent of Cyber</a> - sleigh, what?!</p><p>This year, topics include red teaming, digital investigations, web vulnerabilities, IoT Hacking, and Cyber Defence. Of course, it wouldn’t be Christmas without some exciting prizes up for grabs, and this year, we’re giving away over $40,000 worth of epic prizes!</p><p>Throughout the month, expect to see juicy content from people such as John Hammond, Cybersecurity Meg, Husky Hacks, SecurityNinja, Neal Bridges, InsiderPHD, and more! </p><p>However you choose to get involved, step into Christmas with us, amp up your cyber security skills, and learn about the Nightmare before Elfmas…</p><!--kg-card-begin: html--><center><a href="https://tryhackme.com/christmas"><button style=\'background-color: #222c42; color: white; padding: 15px 20px; border-radius: 10px; font-size: 25px;\'>Launch Advent of Cyber!</button></a></center><!--kg-card-end: html-->',
            comment_id: '637f3a6e0181dc0001fa7373',
            feature_image: 'https://blog.tryhackme.com/content/images/2022/11/Monthly-roundup---November-01.png',
            featured: false,
            visibility: 'public',
            created_at: '2022-11-24T09:33:34.000+00:00',
            updated_at: '2022-11-29T09:00:44.000+00:00',
            published_at: '2022-11-29T09:00:44.000+00:00',
            custom_excerpt: "Dive into our monthly dose of cyber security updates from November. We're exploring some of the in-depth research, trending threats and attacks, and the juicy new releases from TryHackMe!",
            codeinjection_head: null,
            codeinjection_foot: null,
            custom_template: null,
            canonical_url: null,
            tags: [
                {
                    id: '616da14ee085210001ec1740',
                    name: 'Newsroom',
                    slug: 'newsroom',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/newsroom/',
                },
            ],
            authors: [
                {
                    id: '62eaaa040181dc0001fa6403',
                    name: 'Ellie Gillard',
                    slug: 'ellie',
                    profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                    cover_image: null,
                    bio: null,
                    website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                    location: 'United Kingdom',
                    facebook: null,
                    twitter: '@EllieGillardTHM',
                    meta_title: null,
                    meta_description: null,
                    url: 'https://blog.tryhackme.com/author/ellie/',
                },
            ],
            primary_author: {
                id: '62eaaa040181dc0001fa6403',
                name: 'Ellie Gillard',
                slug: 'ellie',
                profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                cover_image: null,
                bio: null,
                website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                location: 'United Kingdom',
                facebook: null,
                twitter: '@EllieGillardTHM',
                meta_title: null,
                meta_description: null,
                url: 'https://blog.tryhackme.com/author/ellie/',
            },
            primary_tag: {
                id: '616da14ee085210001ec1740',
                name: 'Newsroom',
                slug: 'newsroom',
                description: null,
                feature_image: null,
                visibility: 'public',
                og_image: null,
                og_title: null,
                og_description: null,
                twitter_image: null,
                twitter_title: null,
                twitter_description: null,
                meta_title: null,
                meta_description: null,
                codeinjection_head: null,
                codeinjection_foot: null,
                canonical_url: null,
                accent_color: null,
                url: 'https://blog.tryhackme.com/tag/newsroom/',
            },
            url: 'https://blog.tryhackme.com/november-cyber-security-roundup/',
            excerpt: "Dive into our monthly dose of cyber security updates from November. We're exploring some of the in-depth research, trending threats and attacks, and the juicy new releases from TryHackMe!",
            reading_time: 4,
            access: true,
            og_image: null,
            og_title: null,
            og_description: null,
            twitter_image: null,
            twitter_title: null,
            twitter_description: null,
            meta_title: 'This Month in Cyber Security: November 2022',
            meta_description: 'November brings us data breaches, trending threats, vulnerabilities and attacks, with some exciting new festive releases from TryHackMe!',
            email_subject: null,
            frontmatter: null,
            feature_image_alt: null,
            feature_image_caption: null,
        },
        {
            id: '637ccd100181dc0001fa7324',
            uuid: '582afc69-4f9d-479f-9307-de6d966a23e0',
            title: 'The High Risk of Cyber Crime in UK Universities',
            slug: 'cyber-crime-in-uk-universities',
            html: '<p>Universities are at a high risk of cyber crime, with student data, personal information, and extremely valuable research causing education institutions to be prime targets of attack. </p><p>Universities often lack the resources to secure their data adequately, which poses another motivation behind attack. A recent study showed education and research were found to be the most attacked industry sector, seeing a <a href="https://pages.checkpoint.com/cyber-attack-2022-trends.html">114%</a> increase in the past two years.</p><p>75% of data breaches in the education sector occur at universities alone, while a third of UK universities have been hit with ransomware attacks over the past <a href="https://www.urbannetwork.co.uk/a-third-of-uk-unis-hit-by-ransomware-in-last-10-years/#:~:text=Around%20a%20third%20(33%25),were%20sent%20to%2C%20105%20responded.">decade</a>. Whilst most attacks were isolated incidents, Sheffield Hallam University reported 42 ransomware attacks since 2013.</p><p>The National Cyber Security Centre continuously warns of the rising cyber security threats to universities in the education sector, highlighting the importance of cyber security in universities and all higher education institutions.</p><h2 id="consequences-of-cyber-attacks-on-universities">Consequences of Cyber Attacks on Universities</h2><p>87% of universities have experienced at least one successful cyber attack, while <a href="https://www.nextgensecurityforeducation.com/wp-content/uploads/VMWare-UK-University-Challenge-Cyber-Security.pdf">43%</a> have had student data attacked, including dissertation materials and exam results. Consequences may range from threats to students’ personal information, to IP loss and anti-competitive behaviour.</p><h3 id="reputational-damage">Reputational Damage</h3><p>Reputational damage can be an irreversible consequence of attacks, or can lead to long-term repercussions which can be costly and resource-consuming to rectify - for instance, inevitable headlines flooding news outlets when attacks take place.</p><p>University league tables rank the best universities in the UK and act as a potentially crucial deciding factor for prospective students evaluating their available options. League tables monitor opinions of students in the course of study among other factors, and are therefore vital in universities upholding a positive reputation. </p><p>In the league tables following cyber attacks, it isn’t uncommon for universities to drop in the rankings. Of course, there are many factors for movements in university league table rankings, however, patterns in dropping after an attack showcase a negative effect that universities should avoid.</p><h3 id="financial-losses">Financial Losses</h3><p>Universities estimate that cyber attacks (over the last 12 months) cost them upwards of £50,000 in financial losses. One university cyber attack led to a response team deployed for six weeks, equating to £65,000 worth of resources plus significant legal costs.</p><p>Other detrimental consequences include hefty fines from the Information Commissioner’s Office, alongside universities dropping in league tables and students claiming tuition fees back in the event of missed teaching.</p><h3 id="further-threats">Further Threats</h3><p>In the event that university data does fall into the wrong hands as a result of a cyber attack, the consequences can be serious, including threats to national security, identity fraud, and financial crime.<br></p><!--kg-card-begin: html--><table style="border:none;border-collapse:collapse;"><colgroup><col width="601"></colgroup><tbody><tr style="height:0pt"><td style="border-left:solid #000000 1pt;border-right:solid #fafafa 1pt;border-bottom:solid #fafafa 1pt;border-top:solid #ffffff 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt;overflow:hidden;overflow-wrap:break-word;"><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">“Protecting our higher education institutions from cyber crime is vital if the UK is to remain one of the world’s top research and innovation destinations; it has to be a board-level issue both in the commercial and public sector world. If UK universities are to continue attracting the best students from both home and abroad, damage to reputation through cyber attacks and associated data breaches can create a serious threat to their ability to compete for applications and</span></p><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">associated funding.”</span></p><br><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#93c47d;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">Tim Hearn</span><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">, Director, UK Government and Public Services, of VMware</span></p></td></tr></tbody></table><!--kg-card-end: html--><p>The Organisation for Economic Co-operation and Development (OECD) said that <a href="https://www.oecd.org/education/education-at-a-glance/">online-only lessons</a> would mark a failure by universities to offer value for money to students and could encourage more students to take less costly higher education courses such as the open university. In addition, this would risk affected universities being overtaken by more competitive digital providers.</p><h2 id="why-cyber-criminals-attack-education">Why Cyber Criminals Attack Education</h2><p>Universities have always been at a higher risk of cyber crime, with personal information, student data and valuable research making them a prime target for cyber criminals. Higher education institutions are at heightened risk due to increased network activity and the general complexity of enabling hybrid learning. </p><p>Alongside this and the transition to digital learning in recent years, universities have become an ‘easy target’ as reported by the National Cyber Security Centre. </p><!--kg-card-begin: html--><table style="border:none;border-collapse:collapse;"><colgroup><col width="601"></colgroup><tbody><tr style="height:0pt"><td style="border-left:solid #000000 1pt;border-right:solid #fafafa 1pt;border-bottom:solid #fafafa 1pt;border-top:solid #ffffff 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt;overflow:hidden;overflow-wrap:break-word;"><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">“Any targeting of the education sector by cyber criminals is completely unacceptable. We strongly encourage schools, colleges, and universities to act on our guidance and help ensure their students can continue their education uninterrupted. We are committed to ensuring the UK education sector is resilient against cyber threats.”</span></p><br><p dir="ltr" style="line-height:1.38;margin-left: 36pt;margin-top:0pt;margin-bottom:0pt;"><span style="font-size:11pt;font-family:Arial;color:#93c47d;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">Paul Chichester,</span><span style="font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;"> Director of Operations at the NCSC</span></p></td></tr></tbody></table><!--kg-card-end: html--><p>Considered an under-resourced sector, universities and higher education institutions are greatly vulnerable and must remain highly vigilant, ensuring cyber security practices are in place. </p><p><a href="https://tryhackme.com/resources/blog/cyber-security-the-cost-of-human-error">Human error</a> is the biggest cause of security incidents, and tackling this is key to reducing attacks within the education sector. With students and university staff accessing websites with minimal restrictions, malware can easily find its way into university devices.</p><p>The lack of cyber awareness is another factor in educational cyber attacks, with only <a href="https://wonkhe.com/blogs/universities-may-underestimate-the-impact-of-cyber-attacks/#:~:text=cyber%20security%20posture%20survey">80%</a> of universities providing mandatory security awareness training for staff and only 8% of university students taking up basic cyber security awareness training.</p><h2 id="recent-cyber-attacks-on-universities">Recent Cyber Attacks on Universities</h2><p>In recent years, many universities across the UK have faced ransomware and cyber attacks, resulting in the cancellation of classes and students being unable to submit assignments and access their course materials. Universities affected by cyber attacks continuously work alongside local police and the NCSC (<a href="https://www.ncsc.gov.uk/">National Cyber Security Centre</a>) to support investigations. </p><p>The NCSC recognises and supports the best in cyber security education for students and universities, by providing guidance to all educational bodies and through their <a href="https://www.ncsc.gov.uk/information/early-warning-service">NCSC Early Warning service</a> that notifies organisations of malicious activity on submitted domains and IPs. When an educational institution is hit by a cyber attack, the NCSC work collaboratively with law enforcement, defence, the UK’s intelligence and security agencies and international partners.</p><h3 id="university-of-portsmouth-cyber-attack">University of Portsmouth Cyber Attack</h3><p>In April of last year, Portsmouth University faced a ransom attack delaying the start of the new term. The Portsmouth University cyber attack saw several IT systems out of action for almost a month. As a result of the attack, the University of Portsmouth were forced to shut down the campus.</p><p>A notice on the Portsmouth University website read: “<em>An ongoing technical disruption has affected some of our IT systems, which remain offline whilst we work with expert support to investigate the issue and securely restore these systems. We have taken the decision to close down many of our services in order to best protect our systems and information while the investigation is underway.</em>”</p><p>Although it was never confirmed how the ransomware attack occurred, Portsmouth University is unaware of data being stolen. The university was closed for a total of 12 days.</p><p>In addition, the University of Portsmouth dropped 45 spaces on the university league table, in the same year the attack took place - dropping from position 21 in 2020, to 66 in 2021. The University of Portsmouth’s reputation continued into 2022, dropping into 75th position two years after the ransom attack. In 2022’s league table, the university has been ranked in 69th place.</p><h3 id="university-of-sunderland-cyber-attack">University of Sunderland Cyber Attack</h3><p>Shortly after the start of the first term in September 2021, the University of Sunderland fell victim to a suspected cyber attack causing significant IT issues.</p><p>As a result of the Sunderland University cyber attack, IT systems and services experienced extensive interruption, with the university website and telephone lines kept offline for several days. The disturbance also caused the cancellation of classes, with staff unable to access their emails. Consequences of the attack include the disruption of teaching efforts and difficulty accessing study resources. </p><p>Hackers could have gained access as the university dealt with the influx of new students during the busiest time of the year, paired with the university migrating to the cloud environment.</p><p>The University of Sunderland faced immense criticism from students that claimed paying £9,000 per year in tuition fees for online classes was a “waste” of money.</p><h3 id="university-of-hertfordshire-cyber-attack">University of Hertfordshire Cyber Attack</h3><p>The University of Hertfordshire experienced a cyber attack impacting all systems and blocking access to its cloud-based services, including MS Teams, Zoom and Canvas.</p><p>As a result of the Hertfordshire University cyber attack, all online classes were cancelled, with students and staff unable to use onsite or remote access to computer facilities. Students were also unable to submit assignments.</p><p>While there was no evidence to suggest that any data had been taken, the University of Hertfordshire dropped 13 places in the league tables in the year following the attack.</p><h3 id="university-of-northampton-cyber-attack">University of Northampton Cyber Attack</h3><p>In March 2021, the University of Northampton was severely impacted after being hit by a cyber attack that interrupted services to its IT and telephone systems and servers. </p><p>The Northampton university cyber attack left students and staff unable to access the university’s internal systems, with the cancellation of online lessons and students given extensions for assignments.</p><p>The University of Northampton said those who carried out the attack had "no regard to the disruption to teaching and learning such attacks cause". It’s thought that the cyber attack was identified as a ransomware variant. However, this hasn’t been formally confirmed.</p><p>The University of Northampton dropped 11 spaces in league tables following the attack, showcasing the damages of the year after the attack unfolded. The university continued to drop a further eight places in the 2023 university league tables.</p><h2 id="building-security-layers-in-universities">Building Security Layers in Universities</h2><p>Educational institutions should adopt a \'defence-in-depth\' approach, as advised by the NCSC, alongside an incident response plan to limit the consequences of malicious university cyber attacks and reduce downtime.</p><p>Training university staff and students with the information required to recognise (and react to) cyber threats will decrease the highest risk in causing breaches, with security awareness being the first line of defence. Knowing the financial and reputational risks of attacks proves the need to arm defences. Whilst awareness across the board should be a focus, building your cyber security team is vital to avert the risk of attack. </p><p>Whatever the case, university employees should be armed with <a href="https://tryhackme.com/module/cyber-security-awareness">cyber security awareness</a> knowledge in order to prevent threats and reduce the implications in the educational sector. </p><p>As a common method of attack, universities have become a hunting ground for phishing scams. With over 560 training labs, TryHackMe has training catered to a plethora of cyber threats and patterns. Show your team how to analyse and defend against phishing emails through real-world phishing attempts using a variety of techniques with our <a href="https://tryhackme.com/module/phishing">phishing module</a>, which covers the components of phshing, indictors of phishing scams, analysis, and defence.</p><p>Defensive teams should be able to monitor and investigate alerts around the clock and escalate security incidents when necessary, which our brand new <a href="https://tryhackme.com/path/outline/soclevel1">SOC Level 1</a> Pathway guides your security team through. As <a href="https://tryhackme.com/resources/blog/offence-is-the-best-defence">offence is argued to be the best defence</a>, offensive cyber security is invaluable for the cyber security positioning of educational institutions. </p><p>With red team exercises vital to detecting, preventing and remediating cyber threats, our <a href="https://tryhackme.com/path/outline/redteaming">Red Teaming Pathway</a> upskills your team in challenging the defence capabilities, strengthening your cyber security standing.</p><p>Launch TryHackMe to help omit risk and the repercussions of breaches through bite-sized guided training.</p><!--kg-card-begin: html--><center><a href="https://tryhackme.com/business"><button style=\'background-color: #222c42; color: white; padding: 15px 20px; border-radius: 10px; font-size: 25px;\'>Get Started with TryHackMe!</button></a></center><!--kg-card-end: html-->',
            comment_id: '637ccd100181dc0001fa7324',
            feature_image: 'https://blog.tryhackme.com/content/images/2022/11/The-High-Risks-of-Cyber-Crime-in-Universities--Banner.png',
            featured: false,
            visibility: 'public',
            created_at: '2022-11-22T13:22:24.000+00:00',
            updated_at: '2022-11-24T09:29:56.000+00:00',
            published_at: '2022-11-24T09:00:22.000+00:00',
            custom_excerpt: 'Universities are at a high risk of cyber crime, with personal information, student data and valuable research making them a prime target for cyber criminals. ',
            codeinjection_head: null,
            codeinjection_foot: null,
            custom_template: null,
            canonical_url: null,
            tags: [
                {
                    id: '617fedc0e085210001ec1aa8',
                    name: 'Education',
                    slug: 'education',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/education/',
                },
                {
                    id: '616da14ee085210001ec1740',
                    name: 'Newsroom',
                    slug: 'newsroom',
                    description: null,
                    feature_image: null,
                    visibility: 'public',
                    og_image: null,
                    og_title: null,
                    og_description: null,
                    twitter_image: null,
                    twitter_title: null,
                    twitter_description: null,
                    meta_title: null,
                    meta_description: null,
                    codeinjection_head: null,
                    codeinjection_foot: null,
                    canonical_url: null,
                    accent_color: null,
                    url: 'https://blog.tryhackme.com/tag/newsroom/',
                },
            ],
            authors: [
                {
                    id: '62eaaa040181dc0001fa6403',
                    name: 'Ellie Gillard',
                    slug: 'ellie',
                    profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                    cover_image: null,
                    bio: null,
                    website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                    location: 'United Kingdom',
                    facebook: null,
                    twitter: '@EllieGillardTHM',
                    meta_title: null,
                    meta_description: null,
                    url: 'https://blog.tryhackme.com/author/ellie/',
                },
            ],
            primary_author: {
                id: '62eaaa040181dc0001fa6403',
                name: 'Ellie Gillard',
                slug: 'ellie',
                profile_image: 'https://blog.tryhackme.com/content/images/2022/11/Untitled-design-1.jpg',
                cover_image: null,
                bio: null,
                website: 'https://www.linkedin.com/in/ellie-gillard-307b41124/',
                location: 'United Kingdom',
                facebook: null,
                twitter: '@EllieGillardTHM',
                meta_title: null,
                meta_description: null,
                url: 'https://blog.tryhackme.com/author/ellie/',
            },
            primary_tag: {
                id: '617fedc0e085210001ec1aa8',
                name: 'Education',
                slug: 'education',
                description: null,
                feature_image: null,
                visibility: 'public',
                og_image: null,
                og_title: null,
                og_description: null,
                twitter_image: null,
                twitter_title: null,
                twitter_description: null,
                meta_title: null,
                meta_description: null,
                codeinjection_head: null,
                codeinjection_foot: null,
                canonical_url: null,
                accent_color: null,
                url: 'https://blog.tryhackme.com/tag/education/',
            },
            url: 'https://blog.tryhackme.com/cyber-crime-in-uk-universities/',
            excerpt: 'Universities are at a high risk of cyber crime, with personal information, student data and valuable research making them a prime target for cyber criminals. ',
            reading_time: 7,
            access: true,
            og_image: null,
            og_title: null,
            og_description: null,
            twitter_image: null,
            twitter_title: null,
            twitter_description: null,
            meta_title: 'The High Risk of Cyber Crime in UK Universities',
            meta_description: 'Universities are at a high risk of cyber crime, with personal information, student data and valuable research making them a prime target.',
            email_subject: null,
            frontmatter: null,
            feature_image_alt: null,
            feature_image_caption: null,
        },
    ],
    meta: { pagination: { page: 1, limit: 15, pages: 9, total: 127, next: 2, prev: null } },
};

const BREAKPOINT_MOBILE = 768;

const dailyBugleData = [
    {
        score: 30,
        tasks: {
            '1': [
                {
                    questionNo: 1,
                    correct: true,
                    score: 30,
                    attempts: 0,
                    _id: '65041e1ced5ea4c1f8e3bc74',
                    timeCorrect: '2023-09-26T06:15:42.325Z',
                },
            ],
            '2': [
                {
                    questionNo: 1,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '65041e1ced5ea4c1f8e3bc76',
                },
                {
                    questionNo: 2,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '65041e1ced5ea4c1f8e3bc77',
                },
                {
                    questionNo: 3,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '65041e1ced5ea4c1f8e3bc78',
                },
                {
                    questionNo: 4,
                    correct: true,
                    score: 0,
                    attempts: 0,
                    _id: '65041e1ced5ea4c1f8e3bc79',
                },
            ],
            '3': [
                {
                    questionNo: 1,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '65041e1ced5ea4c1f8e3bc7b',
                },
            ],
        },
        level: 6,
        avatar: 'https://secure.gravatar.com/avatar/81dd38e0e4f5a58588da6634674d40c6.jpg?s=200&d=robohash&r=x',
        username: 'amin1235',
        rank: 2,
    },
    {
        score: 200,
        tasks: {
            '1': [
                {
                    questionNo: 1,
                    correct: true,
                    score: 30,
                    attempts: 0,
                    _id: '65041e1ced5ea4c1f8e3bc74',
                    timeCorrect: '2023-09-26T06:15:42.325Z',
                },
            ],
            '2': [
                {
                    questionNo: 1,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '65041e1ced5ea4c1f8e3bc76',
                },
                {
                    questionNo: 2,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '65041e1ced5ea4c1f8e3bc77',
                },
                {
                    questionNo: 3,
                    correct: true,
                    score: 0,
                    attempts: 0,
                    _id: '65041e1ced5ea4c1f8e3bc78',
                },
                {
                    questionNo: 4,
                    correct: true,
                    score: 0,
                    attempts: 0,
                    _id: '65041e1ced5ea4c1f8e3bc79',
                },
            ],
            '3': [
                {
                    questionNo: 1,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '65041e1ced5ea4c1f8e3bc7b',
                },
            ],
        },
        level: 6,
        avatar: 'https://secure.gravatar.com/avatar/81dd38e0e4f5a58588da6634674d40c6.jpg?s=200&d=robohash&r=x',
        username: 'amin1235',
        rank: 1,
    },
];
const ctfCollectionVol2Data = [
    {
        score: 60,
        tasks: {
            '1': [
                {
                    questionNo: 1,
                    correct: true,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b61f',
                    timeCorrect: '2023-09-15T07:46:48.572Z',
                },
            ],
            '2': [
                {
                    questionNo: 1,
                    correct: true,
                    score: 30,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b621',
                    timeCorrect: '2023-09-25T04:57:53.796Z',
                },
                {
                    questionNo: 2,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b622',
                },
                {
                    questionNo: 3,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b623',
                },
                {
                    questionNo: 4,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b624',
                },
                {
                    questionNo: 5,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b625',
                },
                {
                    questionNo: 6,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b626',
                },
                {
                    questionNo: 7,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b627',
                },
                {
                    questionNo: 8,
                    correct: true,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b628',
                },
                {
                    questionNo: 9,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b629',
                },
                {
                    questionNo: 10,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b62a',
                },
                {
                    questionNo: 11,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b62b',
                },
                {
                    questionNo: 12,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b62c',
                },
                {
                    questionNo: 13,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b62d',
                },
                {
                    questionNo: 14,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b62e',
                },
                {
                    questionNo: 15,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b62f',
                },
                {
                    questionNo: 16,
                    correct: true,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b630',
                },
                {
                    questionNo: 17,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b631',
                },
                {
                    questionNo: 18,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b632',
                },
                {
                    questionNo: 19,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b633',
                },
                {
                    questionNo: 20,
                    correct: true,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b634',
                },
            ],
        },
        level: 6,
        avatar: 'https://secure.gravatar.com/avatar/81dd38e0e4f5a58588da6634674d40c6.jpg?s=200&d=robohash&r=x',
        username: '6504067bed5ea4c1f8e3b633',
        rank: 2,
    },
    {
        score: 340,
        tasks: {
            '1': [
                {
                    questionNo: 1,
                    correct: true,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b61f',
                    timeCorrect: '2023-09-15T07:46:48.572Z',
                },
            ],
            '2': [
                {
                    questionNo: 1,
                    correct: true,
                    score: 30,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b621',
                    timeCorrect: '2023-09-25T04:57:53.796Z',
                },
                {
                    questionNo: 2,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b622',
                },
                {
                    questionNo: 3,
                    correct: true,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b623',
                },
                {
                    questionNo: 4,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b624',
                },
                {
                    questionNo: 5,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b625',
                },
                {
                    questionNo: 6,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b626',
                },
                {
                    questionNo: 7,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b627',
                },
                {
                    questionNo: 8,
                    correct: true,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b628',
                },
                {
                    questionNo: 9,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b629',
                },
                {
                    questionNo: 10,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b62a',
                },
                {
                    questionNo: 11,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b62b',
                },
                {
                    questionNo: 12,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b62c',
                },
                {
                    questionNo: 13,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b62d',
                },
                {
                    questionNo: 14,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b62e',
                },
                {
                    questionNo: 15,
                    correct: true,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b62f',
                },
                {
                    questionNo: 16,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b630',
                },
                {
                    questionNo: 17,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b631',
                },
                {
                    questionNo: 18,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b632',
                },
                {
                    questionNo: 19,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b633',
                },
                {
                    questionNo: 20,
                    correct: false,
                    score: 0,
                    attempts: 0,
                    _id: '6504067bed5ea4c1f8e3b634',
                },
            ],
        },
        level: 6,
        avatar: 'https://secure.gravatar.com/avatar/81dd38e0e4f5a58588da6634674d40c6.jpg?s=200&d=robohash&r=x',
        username: 'amin1235',
        rank: 1,
    },
];

const SELECT_ALL_OPTION_VALUE = 'select-all';

const StyledDropdownButton$1 = styled__default["default"].button `
  position: relative;
  display: flex;
  height: 36px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.2rem 1rem 1.5rem;
  border-radius: ${({ theme }) => theme.radius.small};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  background-color: ${({ isDisabled, theme, isError, forceDarkMode }) => {
    if (isDisabled) {
        return theme.colors.background.disabled;
    }
    if (isError) {
        return theme.colors.error.lightest;
    }
    if (forceDarkMode) {
        return darkColors.background.secondary;
    }
    return theme.colors.background.main;
}};
  border: ${({ theme, isError }) => `0.1rem solid ${isError ? theme.colors.error.main : theme.colors.border.dropdown}`};
  border-color: ${({ theme, isMenuOpen, isMenuOpenAndForceDarkMode }) => {
    if (isMenuOpenAndForceDarkMode) {
        return darkColors.info.main;
    }
    if (isMenuOpen) {
        return theme.colors.info.main;
    }
    return '';
}};
  color: ${({ theme, isSelected, forceDarkMode }) => {
    if (isSelected) {
        return theme.colors.text.main;
    }
    if (forceDarkMode) {
        return theme.colors.grey[400];
    }
    return theme.colors.text.placeholder;
}};
`;
const StyledSearchIcon = styled__default["default"](FontAwesomeIcon) `
  color: ${({ theme }) => theme.colors.grey[500]};
  height: 2rem;
  width: 2rem;
`;
const StyledMenu = styled__default["default"].div `
  width: ${({ $menuWidth }) => $menuWidth ?? '100%'};
  background-color: transparent;
  ${({ $isVirtualized, theme }) => $isVirtualized && {
    backgroundColor: theme.colors.background.select,
}};
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  margin-top: 0.8rem;
  position: absolute;
  z-index: 2;
`;
const StyledBlanket = styled__default["default"].div `
  width: 100%;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  position: fixed;
  z-index: 1;
  color: white;
`;
const StyledDropdownWrapper = styled__default["default"].div `
  position: relative;
  width: 100%;
`;
const StyledArrowIcon$3 = styled__default["default"](FontAwesomeIcon) `
  font-size: 1rem;
  color: ${({ theme, color }) => color ?? theme.colors.grey[800]};
  transition: transform 0.2s ease-in-out;
  margin-top: 0.3rem;
  ${({ $isOpen }) => $isOpen &&
    `
	    transform: rotate(-180deg);
    `};
`;
const StyledSelected = styled__default["default"].span `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme, forceDarkMode }) => (forceDarkMode ? theme.colors.grey[100] : theme.colors.text.main)};
`;
const resolveCustomReactSelectStyles = ({ theme, usesCheckboxItemWrapper, }) => ({
    control: () => ({
        backgroundColor: theme.colors.background.select,
        border: 0,
        outline: 0,
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'flex-start',
        borderTop: 0,
        borderLeft: 0,
        borderRight: 0,
        borderBottom: `1px solid ${theme.colors.divider}`,
        padding: '1rem 0 1rem 1.5rem',
        borderTopLeftRadius: theme.radius.small,
        borderTopRightRadius: theme.radius.small,
    }),
    input: (baseStyles) => ({
        ...baseStyles,
        '[type="text"]': {
            color: `${theme.colors.text.main} !important`,
        },
    }),
    container: (baseStyles) => ({
        ...baseStyles,
        textAlign: 'left',
        fontSize: theme.fonts.sizes.default,
        transition: 'none',
    }),
    indicatorsContainer: (baseStyles) => ({
        ...baseStyles,
        transition: 'none',
        '> div': {
            padding: '0 8px',
            transition: 'none',
        },
    }),
    valueContainer: (baseStyles) => ({
        ...baseStyles,
        cursor: 'text',
        flex: 'auto',
        maxHeight: '15rem',
        overflowY: 'scroll',
    }),
    menu: () => ({ boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)' }),
    menuList: (baseStyles) => ({
        ...baseStyles,
        padding: usesCheckboxItemWrapper ? '0.7rem 1rem 1rem 1rem' : '1rem',
        backgroundColor: theme.colors.background.select,
        borderBottomLeftRadius: theme.radius.small,
        borderBottomRightRadius: theme.radius.small,
    }),
    option: (_baseStyles, { isDisabled, isSelected, isFocused, data: { value } }) => {
        let backgroundColor;
        if (!usesCheckboxItemWrapper && isSelected) {
            backgroundColor = theme.colors.info.main;
        }
        else if (isFocused) {
            backgroundColor = theme.colors.formSelect.optionHover;
        }
        const color = !usesCheckboxItemWrapper && isSelected ? theme.colors.text.invert : theme.colors.text.main;
        const selectedColor = isSelected ? theme.colors.text.main : undefined;
        return {
            color: isDisabled ? theme.colors.icon.lighter : color,
            padding: usesCheckboxItemWrapper ? '0.7rem 0 0.7rem 0.7rem' : '1rem 0 1rem 1rem',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            borderRadius: theme.radius.small,
            backgroundColor,
            transition: 'background-color 0.2s linear',
            ...(value === SELECT_ALL_OPTION_VALUE && {
                margin: '-0.7rem -1rem 0.5rem -1rem',
                padding: '1rem 1rem 1rem 1.7rem',
                borderRadius: 0,
                borderBottom: `1px solid ${theme.colors.grey[200]}`,
            }),
            '&:hover': {
                backgroundColor: isDisabled ? undefined : theme.colors.formSelect.optionHover,
                color: isDisabled ? theme.colors.icon.lighter : selectedColor,
            },
        };
    },
});

const DropdownWrapper = ({ children, isOpen, target, onClose, menuWidth, isVirtualized, }) => (jsxRuntime.exports.jsxs(StyledDropdownWrapper, { children: [target, isOpen ? (jsxRuntime.exports.jsx(StyledMenu, { "$isVirtualized": isVirtualized, "$menuWidth": menuWidth, children: children })) : null, isOpen ? jsxRuntime.exports.jsx(StyledBlanket, { onClick: onClose }) : null] }));
const DropdownIndicator = () => jsxRuntime.exports.jsx(StyledSearchIcon, { icon: faSearch$1 });

exports.StatusTagEnum = void 0;
(function (StatusTagEnum) {
    StatusTagEnum["RED"] = "Red";
    StatusTagEnum["BLUE"] = "Blue";
    StatusTagEnum["ORANGE"] = "Orange";
    StatusTagEnum["GREY"] = "Grey";
    StatusTagEnum["GREEN"] = "Green";
    StatusTagEnum["PURPLE"] = "Purple";
})(exports.StatusTagEnum || (exports.StatusTagEnum = {}));

const baseTagStyles = styled.css `
  ${({ theme, size, textColor, type }) => {
    if (size === 'small') {
        return styled.css `
        color: ${() => {
            switch (textColor) {
                case undefined: {
                    return theme.colors.grey[200];
                }
                case 'white': {
                    return theme.colors.white;
                }
                case 'black': {
                    return theme.colors.black;
                }
                default: {
                    return theme.colors.text[textColor];
                }
            }
        }};
        font-size: ${theme.fonts.sizes.tiny};
        padding: ${() => (type === 'dismissable' ? '0.4rem 1.2rem' : '0.2rem 1rem')};
      `;
    }
    return styled.css `
      color: ${theme.colors.grey[100]};
      border: 1px solid ${theme.colors.secondary.lighter};
      font-size: ${theme.fonts.sizes.small};
      padding: 0.7rem 1.6rem;
    `;
}};
  border-radius: ${({ theme }) => theme.radius.huge};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  width: max-content;
`;
const StyledColorTag = styled__default["default"].span `
  ${baseTagStyles};
  background-color: ${({ theme, color = 'success', variation = 'main' }) => {
    const colors = theme.colors[color];
    return colors[variation] || colors.main;
}};
`;
const StyledGreyTag = styled__default["default"].span `
  ${baseTagStyles};
  background-color: ${({ theme, color, variation }) => theme.colors[color][variation]};
`;
const StyledStatusTag$1 = styled__default["default"].span `
  ${baseTagStyles};
  color: ${({ theme }) => theme.colors.addButton.textHover};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row-reverse;
  gap: 0.4rem;
  background-color: ${({ theme, status }) => {
    const statusTagColors = {
        [exports.StatusTagEnum.GREEN]: theme.colors.statusTag.green.background,
        [exports.StatusTagEnum.PURPLE]: theme.colors.statusTag.purple.background,
        [exports.StatusTagEnum.BLUE]: theme.colors.statusTag.blue.background,
        [exports.StatusTagEnum.ORANGE]: theme.colors.statusTag.orange.background,
        [exports.StatusTagEnum.GREY]: theme.colors.statusTag.grey.background,
        [exports.StatusTagEnum.RED]: theme.colors.statusTag.red.background,
    };
    return statusTagColors[status];
}};
`;
const StyledStatusIcon = styled__default["default"](FontAwesomeIcon) `
  color: ${({ theme, status }) => {
    const statusTagColors = {
        [exports.StatusTagEnum.GREEN]: theme.colors.statusTag.green.accent,
        [exports.StatusTagEnum.PURPLE]: theme.colors.statusTag.purple.accent,
        [exports.StatusTagEnum.BLUE]: theme.colors.statusTag.blue.accent,
        [exports.StatusTagEnum.ORANGE]: theme.colors.statusTag.orange.accent,
        [exports.StatusTagEnum.GREY]: theme.colors.statusTag.grey.accent,
        [exports.StatusTagEnum.RED]: theme.colors.statusTag.red.accent,
    };
    return statusTagColors[status];
}};
`;
const StyledRemoveTagButton = styled__default["default"].button `
  margin-left: 0.6rem;
  vertical-align: middle;
`;
const StyledTagIcon = styled__default["default"](FontAwesomeIcon) `
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.text.lighter};
`;
const StyledCodeTag = styled__default["default"].span `
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: 1.6rem;
  color: ${({ theme, twoFA }) => (twoFA ? theme.colors.info.secondary : theme.colors.codeTag.text)};
  background: ${({ theme, twoFA }) => (twoFA ? theme.colors.grey[200] : theme.colors.codeTag.background)};
  font-weight: ${({ theme, twoFA }) => (twoFA ? theme.fonts.weight.bolder : theme.fonts.weight.regular)};
  padding: ${({ twoFA }) => (twoFA ? '0.3rem 0.8rem' : '0.1rem 0.8rem')};
  border-radius: 0.3rem;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  line-height: ${({ twoFA }) => (twoFA ? `2.8rem` : `2.4rem`)};
`;
const StyledIconTag = styled__default["default"].span `
  color: ${({ theme }) => theme.colors.text.main};
  background-color: ${({ theme, type = 'neutral' }) => {
    switch (type) {
        case 'info': {
            return theme.colors.info.lightest;
        }
        case 'success': {
            return theme.colors.success.lightest;
        }
        case 'warning': {
            return theme.colors.warning.secondary;
        }
        case 'error': {
            return theme.colors.error.light;
        }
        case 'neutral': {
            return theme.colors.background.disabled;
        }
        default: {
            return theme.colors.info.lightest;
        }
    }
}};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  border-radius: ${({ theme }) => theme.radius.huge};
  padding: 0.6rem 1.6rem;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'max-content')};
  display: flex;
  gap: 0.4rem;
  align-items: center;
  justify-content: center;
`;

const RemoveTagButton = (props) => (jsxRuntime.exports.jsx(StyledRemoveTagButton, { ...props, "aria-label": "dismiss", "data-testid": "dismiss-tag", children: jsxRuntime.exports.jsx(StyledTagIcon, { icon: faXmark }) }));
const Tag = (props) => {
    const { id, color, children, type, handleDismissTag, status } = props;
    if (color === 'grey')
        return (jsxRuntime.exports.jsxs(StyledGreyTag, { ...props, children: [children, type === 'dismissable' && jsxRuntime.exports.jsx(RemoveTagButton, { onClick: () => handleDismissTag?.(id) })] }));
    if (status) {
        const hideIcon = props.hideIcon ?? false;
        return (jsxRuntime.exports.jsxs(StyledStatusTag$1, { ...props, status: status, children: [children, hideIcon || jsxRuntime.exports.jsx(StyledStatusIcon, { status: status, icon: faCircleSmall, "data-testid": "status-icon" })] }));
    }
    return (jsxRuntime.exports.jsxs(StyledColorTag, { ...props, children: [children, type === 'dismissable' && jsxRuntime.exports.jsx(RemoveTagButton, { onClick: () => handleDismissTag?.(id) })] }));
};
const CodeTag = (props) => jsxRuntime.exports.jsx(StyledCodeTag, { ...props });
const IconTag = (props) => jsxRuntime.exports.jsx(StyledIconTag, { ...props });

const StyledCustomTag = styled__default["default"](Tag) `
  color: ${({ theme }) => theme.colors.grey[200]};
  background-color: ${({ theme }) => theme.colors.text.lighter};
`;
const selectExampleOptions = (isWithCustomContent = false) => [
    {
        id: '1',
        label: 'Display Value 1',
        value: 'DV-1',
        iconSrc: 'https://upload.wikimedia.org/wikipedia/commons/0/03/Flag_of_Italy.svg',
        ...(isWithCustomContent && {
            additionalOptionContent: [
                jsxRuntime.exports.jsx(StyledCustomTag, { size: "small", children: "Cloned room" }, "8f8f9511"),
                jsxRuntime.exports.jsx(StyledCustomTag, { size: "small", children: "Challenge" }, "8f8f9512"),
            ],
        }),
        isDisabled: true,
    },
    {
        id: '2',
        label: 'Display Value 2',
        value: 'DV-2',
        icon: faChartLine,
    },
    {
        id: '3',
        label: 'Display Value 3',
        value: 'DV-3',
        icon: faChartLineDown,
        ...(isWithCustomContent && {
            additionalOptionContent: [
                jsxRuntime.exports.jsx(StyledCustomTag, { size: "small", children: "Walkthrough" }, "8f8f9513"),
            ],
        }),
    },
    {
        id: '4',
        label: 'Display Value 4',
        value: 'DV-4',
        icon: faChartBar,
        ...(isWithCustomContent && {
            additionalOptionContent: [
                jsxRuntime.exports.jsx(StyledCustomTag, { size: "small", children: "Cloned room" }, "8f8f9514"),
                jsxRuntime.exports.jsx(StyledCustomTag, { size: "small", children: "Challenge" }, "8f8f9515"),
                jsxRuntime.exports.jsx(StyledCustomTag, { size: "small", children: "Easy" }, "8f8f9516"),
            ],
        }),
    },
    {
        id: '5',
        label: 'Display Value 5',
        value: 'DV-5',
        icon: faChartLineDown,
        ...(isWithCustomContent && {
            additionalOptionContent: [
                jsxRuntime.exports.jsx(StyledCustomTag, { size: "small", children: "Walkthrough" }, "8f8f9517"),
                jsxRuntime.exports.jsx(StyledCustomTag, { size: "small", children: "Medium" }, "8f8f9518"),
            ],
        }),
    },
    {
        id: '6',
        label: 'Display Value 6',
        value: 'DV-6',
        iconSrc: 'https://upload.wikimedia.org/wikipedia/commons/0/03/Flag_of_Italy.svg',
        ...(isWithCustomContent && {
            additionalOptionContent: [
                jsxRuntime.exports.jsx(StyledCustomTag, { size: "small", children: "Cloned room" }, "8f8f9519"),
            ],
        }),
    },
    {
        id: '7',
        label: 'Display Value 7',
        value: 'DV-7',
        iconSrc: 'https://upload.wikimedia.org/wikipedia/commons/0/03/Flag_of_Italy.svg',
        ...(isWithCustomContent && {
            additionalOptionContent: [
                jsxRuntime.exports.jsx(StyledCustomTag, { size: "small", children: "Cloned room" }, "8f8f95110"),
                jsxRuntime.exports.jsx(StyledCustomTag, { size: "small", children: "Walkthrough" }, "8f8f95111"),
                jsxRuntime.exports.jsx(StyledCustomTag, { size: "small", children: "Insane" }, "8f8f95112"),
            ],
        }),
    },
    {
        id: '8',
        label: 'Display Value 8',
        value: 'DV-8',
        iconSrc: 'https://upload.wikimedia.org/wikipedia/commons/0/03/Flag_of_Italy.svg',
    },
    {
        id: '9',
        label: 'Display Value 9',
        value: 'DV-9',
        iconSrc: 'https://upload.wikimedia.org/wikipedia/commons/0/03/Flag_of_Italy.svg',
    },
    {
        id: '10',
        label: 'Display Value 10',
        value: 'DV-10',
        iconSrc: 'https://upload.wikimedia.org/wikipedia/commons/0/03/Flag_of_Italy.svg',
    },
];

const formatNumberWithSuffix = (num, decimalPlaces = 1) => {
    if (num >= 1_000_000_000) {
        return `${(num / 1_000_000_000).toFixed(decimalPlaces).replace(/\.0$/, '')}B`;
    }
    if (num >= 1_000_000) {
        return `${(num / 1_000_000).toFixed(decimalPlaces).replace(/\.0$/, '')}M`;
    }
    if (num >= 1_000) {
        return `${(num / 1_000).toFixed(decimalPlaces).replace(/\.0$/, '')}K`;
    }
    return num.toString();
};

const OptionWrapper = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 0.4rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    align-items: center;
    flex-direction: row;
  }
`;
const ContentWrapper$1 = styled__default["default"].div `
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-right: 1rem;
  flex-shrink: 1;
`;
const StyledCheckboxItem$1 = styled__default["default"].div `
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
  > p {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    line-height: 2rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.text.main};
  }
  > button {
    flex-shrink: 0;
    background-color: transparent;
  }
`;

const CustomOption = (props) => {
    const { data, label, showCheckboxes } = props;
    const { additionalOptionContent } = data;
    return additionalOptionContent?.length || showCheckboxes ? (jsxRuntime.exports.jsx(components.Option, { ...props, children: jsxRuntime.exports.jsxs(OptionWrapper, { children: [showCheckboxes ? jsxRuntime.exports.jsx(CheckboxItemWrapper$1, { ...props }) : label, jsxRuntime.exports.jsx(ContentWrapper$1, { children: additionalOptionContent?.map((additionalContent) => additionalContent) })] }) })) : (jsxRuntime.exports.jsx(components.Option, { ...props }));
};
const CheckboxItemWrapper$1 = (props) => {
    const { label, isSelected, innerProps: { onClick: nativeOnClick }, } = props;
    const checkboxId = React.useId();
    return (jsxRuntime.exports.jsxs(StyledCheckboxItem$1, { onClick: (event) => {
            if (event.target instanceof HTMLInputElement) {
                event.stopPropagation();
            }
        }, children: [jsxRuntime.exports.jsx(FormCheckbox, { checked: isSelected, "aria-labelledby": checkboxId, onClick: nativeOnClick }), jsxRuntime.exports.jsx("p", { id: checkboxId, children: label })] }));
};

const StyledFormSelectIcon = styled__default["default"](FontAwesomeIcon) `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  padding-right: 0.4rem;
`;
const StyledIconImage = styled__default["default"].img `
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  object-fit: cover;
`;
const StyledCustomFormatOptionLabel = styled__default["default"].div `
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
const StyledVirtualizedMenuList = styled__default["default"].div `
  max-height: ${({ $height }) => $height};
  overflow: auto;
  padding: 1rem;
`;
const StyledVirtualizedMenuListContent = styled__default["default"].div `
  height: ${({ $height }) => $height};
  position: relative;
`;
const StyledVirtualizedMenuListItem = styled__default["default"].div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transform: translateY(${({ $translateY }) => $translateY});
`;

const CustomOptionInitializer = (showCheckboxes) => (props) => (jsxRuntime.exports.jsx(CustomOption, { ...props, showCheckboxes: showCheckboxes }));
const customFormatOptionLabelDisplay = (selected, _meta, title = 'select-icon') => {
    if (selected instanceof Array) {
        if (selected.length === 1)
            return selected[0]?.label;
        if (selected.length === 2)
            return `${selected[0]?.label ?? 'Unknown'}, ${selected[1]?.label ?? 'Unknown'}`;
        return `${selected[0]?.label ?? 'Unknown'} and ${selected.length - 1} more`;
    }
    const { label, icon, iconSrc } = selected;
    const hasIcon = !!icon || iconSrc;
    if (hasIcon) {
        const renderIcon = () => {
            if (!icon) {
                return jsxRuntime.exports.jsx(StyledIconImage, { src: iconSrc, alt: `${label}-icon`, "data-testid": "img-src" });
            }
            if (typeof icon === 'object' && 'type' in icon) {
                return icon;
            }
            return jsxRuntime.exports.jsx(StyledFormSelectIcon, { icon: icon, title: title });
        };
        return (jsxRuntime.exports.jsxs(StyledCustomFormatOptionLabel, { children: [renderIcon(), label] }));
    }
    return label;
};
const VirtualizedMenuList = ({ children }) => {
    const parentRef = React.useRef(null);
    const items = (Array.isArray(children) ? children : [children]);
    const estimatedItemHeight = 40;
    const maxHeight = 300;
    const rowVirtualizer = useVirtualizer({
        count: items.length,
        getScrollElement: () => parentRef.current,
        estimateSize: () => estimatedItemHeight,
        overscan: 5,
    });
    const totalSize = rowVirtualizer.getTotalSize();
    const height = Math.min(totalSize, maxHeight);
    return (jsxRuntime.exports.jsx(StyledVirtualizedMenuList, { "$height": `${height}px`, ref: parentRef, children: jsxRuntime.exports.jsx(StyledVirtualizedMenuListContent, { "$height": `${totalSize}px`, children: rowVirtualizer.getVirtualItems().map((virtualRow) => {
                const child = items[virtualRow.index];
                return (jsxRuntime.exports.jsx(StyledVirtualizedMenuListItem, { "data-index": virtualRow.index, ref: rowVirtualizer.measureElement, "$translateY": `${virtualRow.start}px`, children: child }, virtualRow.key.toString() ?? virtualRow.index));
            }) }) }));
};
const FormSelect = ({ handleSelection, id, selected, isDisabled = false, isError = false, placeholder = '', backspaceRemovesValue = false, controlShouldRenderValue = false, hideSelectedOptions = false, isVirtualized = false, isSearchable = true, tabSelectsValue = false, menuIsOpen = true, forceDarkMode = false, showCheckboxes = false, icon, ...reactSelectAttributes }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [searchText, setSearchText] = React.useState('');
    const isMenuOpenAndForceDarkMode = isOpen && forceDarkMode;
    const theme = styled.useTheme();
    const customStyles = React.useMemo(() => resolveCustomReactSelectStyles({
        theme: forceDarkMode ? { ...theme, colors: darkColors } : theme,
        usesCheckboxItemWrapper: showCheckboxes,
    }), [forceDarkMode, theme, showCheckboxes]);
    const hasAtLeastOneOptionSelected = selected && (selected instanceof Array ? selected.length > 0 : true);
    const renderSelectedContent = () => {
        if (!icon) {
            return hasAtLeastOneOptionSelected
                ? customFormatOptionLabelDisplay(selected, null, 'select-icon-selected')
                : placeholder;
        }
        return (jsxRuntime.exports.jsx(StyledCustomFormatOptionLabel, { children: jsxRuntime.exports.jsxs("span", { children: [icon, hasAtLeastOneOptionSelected
                        ? customFormatOptionLabelDisplay(selected, null, 'select-icon-selected')
                        : placeholder] }) }));
    };
    return (jsxRuntime.exports.jsx(DropdownWrapper, { isOpen: isOpen, onClose: () => {
            setIsOpen(false);
            setSearchText('');
        }, isVirtualized: isVirtualized, target: jsxRuntime.exports.jsxs(StyledDropdownButton$1, { type: "button", name: id, isDisabled: isDisabled, disabled: isDisabled, isMenuOpen: isOpen, isError: isError, isSelected: !!selected, forceDarkMode: forceDarkMode, isMenuOpenAndForceDarkMode: isMenuOpenAndForceDarkMode, onClick: () => !isDisabled && setIsOpen((prev) => !prev), "aria-label": "click here to choose an option", children: [jsxRuntime.exports.jsx(StyledSelected, { forceDarkMode: forceDarkMode, children: renderSelectedContent() }), jsxRuntime.exports.jsx(StyledArrowIcon$3, { icon: faChevronDown$1, "$isOpen": isOpen })] }), children: jsxRuntime.exports.jsx(StateManagedSelect, { backspaceRemovesValue,
            controlShouldRenderValue,
            hideSelectedOptions,
            isSearchable,
            tabSelectsValue,
            isDisabled,
            menuIsOpen,
            placeholder,
            forceDarkMode,
            ...reactSelectAttributes, autoFocus: true, formatOptionLabel: customFormatOptionLabelDisplay, components: {
                Option: CustomOptionInitializer(showCheckboxes),
                DropdownIndicator,
                IndicatorSeparator: null,
                ...(isVirtualized ? { MenuList: VirtualizedMenuList } : {}),
                ...(isSearchable ? {} : { Control: () => null }),
            }, name: id, onChange: (newValue) => {
                if (!isDisabled) {
                    if (newValue == null)
                        return;
                    handleSelection(newValue);
                }
                if (reactSelectAttributes.closeMenuOnSelect !== false)
                    setIsOpen(false);
            }, styles: customStyles, value: selected, ...(isSearchable && {
                onInputChange: (value, actionMeta) => {
                    if (actionMeta.action === 'input-change') {
                        setSearchText(value);
                    }
                    if (reactSelectAttributes.onInputChange)
                        reactSelectAttributes.onInputChange(value, actionMeta);
                },
                inputValue: searchText,
            }) }) }));
};

const StyledSliderWrapper = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  gap: 1.6rem;
  align-items: center;
  width: 100%;
`;
const StyledSliderValueIndicator = styled__default["default"].div `
  flex-shrink: 1;
  min-width: 5.4rem;
  text-align: center;
  font-size: 1.6rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.main};
  background-color: ${({ theme }) => theme.colors.background.active};
  padding: 00.6rem 1.6rem;
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
`;
const StyledSliderTrackContainer = styled__default["default"].div `
  flex-grow: 1;
  position: relative;
  width: 100%;
  padding: 8px 0;
  touch-action: none;
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
`;
const StyledSliderTrack = styled__default["default"].div `
  height: 1rem;
  width: 100%;
  background: ${({ theme }) => theme.colors.background.greyLight};
  border-radius: 2rem;
`;
const StyledSliderProgress = styled__default["default"](StyledSliderTrack) `
  position: absolute;
  background: ${({ theme }) => theme.colors.primary.main};
  width: ${(props) => props.$percentage}%;
  box-shadow: 4px 0 4px 0 rgba(0, 0, 0, 0.15) inset, 0 4px 4px 0 rgba(0, 0, 0, 0.15) inset;
`;
const StyledSliderHandle = styled__default["default"].div `
  position: absolute;
  left: ${(props) => props.$percentage}%;
  top: 50%;
  transform: translate(-50%, -50%) ${(props) => (props.$isDragging ? 'scale(1.1)' : 'scale(1)')};
  width: 1.6rem;
  height: 1.6rem;
  background: ${({ theme }) => theme.colors.success.main};
  border: 2px solid ${({ theme }) => theme.colors.success.main};
  border-radius: 50%;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'grab')};
  transition: transform 0.2s;
  -webkit-tap-highlight-color: transparent;

  &:active {
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'grabbing')};
  }
`;

const FormSlider = ({ isDisabled, isError, min = 0, max = 100, step = 1, name, value: controlledValue, onChange, onBlur, }) => {
    const [internalValue, setInternalValue] = React.useState(min);
    const value = controlledValue ?? internalValue;
    const [isDragging, setIsDragging] = React.useState(false);
    const sliderRef = React.useRef(null);
    const calculatePercentage = React.useCallback(() => {
        const numValue = Number(value) || min;
        return ((numValue - min) / (max - min)) * 100;
    }, [value, min, max]);
    const getValueFromPosition = React.useCallback((clientX) => {
        if (!sliderRef.current)
            return Number(value) || min;
        const rect = sliderRef.current.getBoundingClientRect();
        const percentage = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
        return Math.round((percentage * (max - min) + min) / step) * step;
    }, [max, min, step, value]);
    const updateValue = React.useCallback((clientX) => {
        if (isDisabled)
            return;
        const newValue = getValueFromPosition(clientX);
        setInternalValue(newValue);
        if (onChange) {
            const event = {
                target: {
                    value: newValue,
                    valueAsNumber: newValue,
                    name,
                },
            };
            onChange(event);
        }
    }, [isDisabled, name, getValueFromPosition, onChange]);
    const handleMouseDown = React.useCallback((e) => {
        if (isDisabled)
            return;
        e.preventDefault();
        setIsDragging(true);
        updateValue(e.clientX);
    }, [isDisabled, updateValue]);
    const handleMouseMove = React.useCallback((e) => {
        if (isDragging) {
            e.preventDefault();
            updateValue(e.clientX);
        }
    }, [isDragging, updateValue]);
    const handleMouseUp = React.useCallback(() => {
        setIsDragging(false);
        if (onBlur) {
            onBlur({
                target: {
                    value,
                    valueAsNumber: value,
                    name,
                },
                type: 'blur',
            });
        }
    }, [onBlur, value, name]);
    const handleTouchStart = React.useCallback((e) => {
        if (isDisabled || !e.touches[0])
            return;
        e.preventDefault();
        setIsDragging(true);
        updateValue(e.touches[0].clientX);
    }, [isDisabled, updateValue]);
    const handleTouchMove = React.useCallback((e) => {
        if (isDragging && e.touches[0]) {
            e.preventDefault();
            updateValue(e.touches[0].clientX);
        }
    }, [isDragging, updateValue]);
    const handleTouchEnd = React.useCallback(() => {
        setIsDragging(false);
        if (onBlur) {
            onBlur({
                target: { value: String(value), name },
                type: 'blur',
            });
        }
    }, [onBlur, value, name]);
    React.useEffect(() => {
        if (!isDragging)
            return undefined;
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
        window.addEventListener('touchmove', handleTouchMove, { passive: false });
        window.addEventListener('touchend', handleTouchEnd);
        window.addEventListener('touchcancel', handleTouchEnd);
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
            window.removeEventListener('touchmove', handleTouchMove);
            window.removeEventListener('touchend', handleTouchEnd);
            window.removeEventListener('touchcancel', handleTouchEnd);
        };
    }, [isDragging, handleMouseMove, handleMouseUp, handleTouchMove, handleTouchEnd]);
    const percentage = calculatePercentage();
    return (jsxRuntime.exports.jsxs(StyledSliderWrapper, { children: [jsxRuntime.exports.jsx(StyledSliderTrackContainer, { isDisabled: isDisabled, isError: isError, children: jsxRuntime.exports.jsxs(StyledSliderTrack, { role: "presentation", ref: sliderRef, onMouseDown: handleMouseDown, onTouchStart: handleTouchStart, isDisabled: isDisabled, isError: isError, children: [jsxRuntime.exports.jsx(StyledSliderProgress, { "$percentage": percentage, isDisabled: isDisabled, isError: isError }), jsxRuntime.exports.jsx(StyledSliderHandle, { role: "slider", "$percentage": percentage, "$isDragging": isDragging, isDisabled: isDisabled, isError: isError, onMouseDown: handleMouseDown, onTouchStart: handleTouchStart })] }) }), jsxRuntime.exports.jsx(StyledSliderValueIndicator, { isDisabled: isDisabled, children: value })] }));
};
FormSlider.displayName = 'FormSlider';

exports.FormToggleSize = void 0;
(function (FormToggleSize) {
    FormToggleSize["SMALL"] = "small";
    FormToggleSize["MEDIUM"] = "medium";
    FormToggleSize["LARGE"] = "large";
})(exports.FormToggleSize || (exports.FormToggleSize = {}));

/* -------------------------------------------------------------------------------------------------
 * Switch
 * -----------------------------------------------------------------------------------------------*/ const $6be4966fd9bbc698$var$SWITCH_NAME = 'Switch';
const [$6be4966fd9bbc698$var$createSwitchContext, $6be4966fd9bbc698$export$cf7f5f17f69cbd43] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($6be4966fd9bbc698$var$SWITCH_NAME);
const [$6be4966fd9bbc698$var$SwitchProvider, $6be4966fd9bbc698$var$useSwitchContext] = $6be4966fd9bbc698$var$createSwitchContext($6be4966fd9bbc698$var$SWITCH_NAME);
const $6be4966fd9bbc698$export$b5d5cf8927ab7262 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch , name: name , checked: checkedProp , defaultChecked: defaultChecked , required: required , disabled: disabled , value: value = 'on' , onCheckedChange: onCheckedChange , ...switchProps } = props;
    const [button, setButton] = React.useState(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setButton(node)
    );
    const hasConsumerStoppedPropagationRef = React.useRef(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest('form')) : true;
    const [checked = false, setChecked] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    return /*#__PURE__*/ React.createElement($6be4966fd9bbc698$var$SwitchProvider, {
        scope: __scopeSwitch,
        checked: checked,
        disabled: disabled
    }, /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$b({
        type: "button",
        role: "switch",
        "aria-checked": checked,
        "aria-required": required,
        "data-state": $6be4966fd9bbc698$var$getState(checked),
        "data-disabled": disabled ? '' : undefined,
        disabled: disabled,
        value: value
    }, switchProps, {
        ref: composedRefs,
        onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, (event)=>{
            setChecked((prevChecked)=>!prevChecked
            );
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if switch is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect switch updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ React.createElement($6be4966fd9bbc698$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: 'translateX(-100%)'
        }
    }));
});
/* -------------------------------------------------------------------------------------------------
 * SwitchThumb
 * -----------------------------------------------------------------------------------------------*/ const $6be4966fd9bbc698$var$THUMB_NAME = 'SwitchThumb';
const $6be4966fd9bbc698$export$4d07bf653ea69106 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch , ...thumbProps } = props;
    const context = $6be4966fd9bbc698$var$useSwitchContext($6be4966fd9bbc698$var$THUMB_NAME, __scopeSwitch);
    return /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.span, _extends$b({
        "data-state": $6be4966fd9bbc698$var$getState(context.checked),
        "data-disabled": context.disabled ? '' : undefined
    }, thumbProps, {
        ref: forwardedRef
    }));
});
/* ---------------------------------------------------------------------------------------------- */ const $6be4966fd9bbc698$var$BubbleInput = (props)=>{
    const { control: control , checked: checked , bubbles: bubbles = true , ...inputProps } = props;
    const ref = React.useRef(null);
    const prevChecked = $010c2913dbd2fe3d$export$5cae361ad82dce8b(checked);
    const controlSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(control); // Bubble checked change to parents (e.g form change event)
    React.useEffect(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, 'checked');
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event('click', {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ React.createElement("input", _extends$b({
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: 'absolute',
            pointerEvents: 'none',
            opacity: 0,
            margin: 0
        }
    }));
};
function $6be4966fd9bbc698$var$getState(checked) {
    return checked ? 'checked' : 'unchecked';
}
const $6be4966fd9bbc698$export$be92b6f5f03c0fe9 = $6be4966fd9bbc698$export$b5d5cf8927ab7262;

const StyledSwitchThumb = styled__default["default"]($6be4966fd9bbc698$export$4d07bf653ea69106) `
  display: block;
  background-color: ${({ theme }) => theme.colors.toggle};
  border-radius: 5rem;
  transition: all 100ms;
  transform: translateX(0.3rem);
  will-change: transform;
  &[data-state='checked'] {
    background-color: ${({ theme }) => theme.colors.success.toggle};
    &[data-disabled] {
      background-color: ${({ theme }) => theme.colors.toggle};
    }
  }
`;
const rulesPerSize = {
    [exports.FormToggleSize.SMALL]: styled.css `
    width: 3.2rem;
    height: 1.8rem;

    ${StyledSwitchThumb} {
      width: 1.2rem;
      height: 1.2rem;

      &[data-state='checked'] {
        transform: translateX(1.6rem);
      }
    }
  `,
    [exports.FormToggleSize.MEDIUM]: styled.css `
    width: 3.5rem;
    height: 2rem;

    ${StyledSwitchThumb} {
      width: 1.4rem;
      height: 1.4rem;

      &[data-state='checked'] {
        transform: translateX(1.7rem);
      }
    }
  `,
    [exports.FormToggleSize.LARGE]: styled.css `
    width: 4.9rem;
    height: 2.8rem;

    ${StyledSwitchThumb} {
      width: 2rem;
      height: 2rem;

      &[data-state='checked'] {
        transform: translateX(2.4rem);
      }
    }
  `,
};
const StyledSwitchRoot = styled__default["default"]($6be4966fd9bbc698$export$be92b6f5f03c0fe9) `
  background-color: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.dropdown};
  border-radius: 10rem;
  position: relative;
  transition: border-color 100ms, background-color 100ms;

  :focus {
    border-color: ${({ theme }) => theme.colors.info.main};
    outline: none;
  }

  :hover {
    border-color: ${({ theme }) => theme.colors.border.hover};
  }

  &[data-disabled] {
    pointer-events: none;
    background-color: ${({ theme }) => theme.colors.background.disabled};
  }

  &[data-state='checked'] {
    border-color: ${({ theme }) => theme.colors.success.toggle};
    :focus {
      border-color: ${({ theme }) => theme.colors.info.main};
    }
    :hover {
      border-color: ${({ theme }) => theme.colors.border.hover};
    }
    &[data-disabled] {
      border-color: ${({ theme }) => theme.colors.border.dropdown};
    }
  }

  button {
    all: unset;
  }

  ${({ $size }) => rulesPerSize[$size]};
`;

const FormToggle = ({ id, switchThumbProps, innerRef, size = exports.FormToggleSize.MEDIUM, ...switchRootProps }) => (jsxRuntime.exports.jsx(StyledSwitchRoot, { ref: innerRef, id: id, "$size": size, ...switchRootProps, children: jsxRuntime.exports.jsx(StyledSwitchThumb, { ...switchThumbProps }) }));

const $d7bdfb9eb0fdf311$var$ENTRY_FOCUS = 'rovingFocusGroup.onEntryFocus';
const $d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$GROUP_NAME = 'RovingFocusGroup';
const [$d7bdfb9eb0fdf311$var$Collection, $d7bdfb9eb0fdf311$var$useCollection, $d7bdfb9eb0fdf311$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $d7bdfb9eb0fdf311$export$c7109489551a4f4] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$d7bdfb9eb0fdf311$var$RovingFocusProvider, $d7bdfb9eb0fdf311$var$useRovingFocusContext] = $d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($d7bdfb9eb0fdf311$var$GROUP_NAME);
const $d7bdfb9eb0fdf311$export$8699f7c8af148338 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    return /*#__PURE__*/ React.createElement($d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ React.createElement($d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ React.createElement($d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, _extends$b({}, props, {
        ref: forwardedRef
    }))));
});
/* -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , orientation: orientation , loop: loop = false , dir: dir , currentTabStopId: currentTabStopIdProp , defaultCurrentTabStopId: defaultCurrentTabStopId , onCurrentTabStopIdChange: onCurrentTabStopIdChange , onEntryFocus: onEntryFocus , ...groupProps } = props;
    const ref = React.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = React.useState(false);
    const handleEntryFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onEntryFocus);
    const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = React.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = React.useState(0);
    React.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus)
            ;
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ React.createElement($d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: React.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId)
        , [
            setCurrentTabStopId
        ]),
        onItemShiftTab: React.useCallback(()=>setIsTabbingBackOut(true)
        , []),
        onFocusableItemAdd: React.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1
            )
        , []),
        onFocusableItemRemove: React.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1
            )
        , [])
    }, /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: 'none',
            ...props.style
        },
        onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable
                    );
                    const activeItem = items.find((item)=>item.active
                    );
                    const currentItem = items.find((item)=>item.id === currentTabStopId
                    );
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current
                    );
                    $d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, ()=>setIsTabbingBackOut(false)
        )
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$ITEM_NAME = 'RovingFocusGroupItem';
const $d7bdfb9eb0fdf311$export$ab9df7c53fe8454 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , focusable: focusable = true , active: active = false , tabStopId: tabStopId , ...itemProps } = props;
    const autoId = $1746a345f3d73bb7$export$f680877a34711e37();
    const id = tabStopId || autoId;
    const context = $d7bdfb9eb0fdf311$var$useRovingFocusContext($d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd , onFocusableItemRemove: onFocusableItemRemove  } = context;
    React.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove()
            ;
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ React.createElement($d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.span, _extends$b({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, ()=>context.onItemFocus(id)
        ),
        onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event)=>{
            if (event.key === 'Tab' && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable
                );
                let candidateNodes = items.map((item)=>item.ref.current
                );
                if (focusIntent === 'last') candidateNodes.reverse();
                else if (focusIntent === 'prev' || focusIntent === 'next') {
                    if (focusIntent === 'prev') candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes)
                );
            }
        })
    })));
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: 'prev',
    ArrowUp: 'prev',
    ArrowRight: 'next',
    ArrowDown: 'next',
    PageUp: 'first',
    Home: 'first',
    PageDown: 'last',
    End: 'last'
};
function $d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== 'rtl') return key;
    return key === 'ArrowLeft' ? 'ArrowRight' : key === 'ArrowRight' ? 'ArrowLeft' : key;
}
function $d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === 'vertical' && [
        'ArrowLeft',
        'ArrowRight'
    ].includes(key)) return undefined;
    if (orientation === 'horizontal' && [
        'ArrowUp',
        'ArrowDown'
    ].includes(key)) return undefined;
    return $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]
    );
}
const $d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9 = $d7bdfb9eb0fdf311$export$8699f7c8af148338;
const $d7bdfb9eb0fdf311$export$6d08773d2e66f8f2 = $d7bdfb9eb0fdf311$export$ab9df7c53fe8454;

/* -------------------------------------------------------------------------------------------------
 * Tabs
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$TABS_NAME = 'Tabs';
const [$69cb30bb0017df05$var$createTabsContext, $69cb30bb0017df05$export$355f5bd209d7b13a] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($69cb30bb0017df05$var$TABS_NAME, [
    $d7bdfb9eb0fdf311$export$c7109489551a4f4
]);
const $69cb30bb0017df05$var$useRovingFocusGroupScope = $d7bdfb9eb0fdf311$export$c7109489551a4f4();
const [$69cb30bb0017df05$var$TabsProvider, $69cb30bb0017df05$var$useTabsContext] = $69cb30bb0017df05$var$createTabsContext($69cb30bb0017df05$var$TABS_NAME);
const $69cb30bb0017df05$export$b2539bed5023c21c = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: valueProp , onValueChange: onValueChange , defaultValue: defaultValue , orientation: orientation = 'horizontal' , dir: dir , activationMode: activationMode = 'automatic' , ...tabsProps } = props;
    const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
    const [value, setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /*#__PURE__*/ React.createElement($69cb30bb0017df05$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: $1746a345f3d73bb7$export$f680877a34711e37(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode
    }, /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({
        dir: direction,
        "data-orientation": orientation
    }, tabsProps, {
        ref: forwardedRef
    })));
});
/* -------------------------------------------------------------------------------------------------
 * TabsList
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$TAB_LIST_NAME = 'TabsList';
const $69cb30bb0017df05$export$9712d22edc0d78c1 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , loop: loop = true , ...listProps } = props;
    const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    return /*#__PURE__*/ React.createElement($d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9, _extends$b({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: context.orientation,
        dir: context.dir,
        loop: loop
    }), /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({
        role: "tablist",
        "aria-orientation": context.orientation
    }, listProps, {
        ref: forwardedRef
    })));
});
/* -------------------------------------------------------------------------------------------------
 * TabsTrigger
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$TRIGGER_NAME = 'TabsTrigger';
const $69cb30bb0017df05$export$8114b9fdfdf9f3ba = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , disabled: disabled = false , ...triggerProps } = props;
    const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /*#__PURE__*/ React.createElement($d7bdfb9eb0fdf311$export$6d08773d2e66f8f2, _extends$b({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled,
        active: isSelected
    }), /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$b({
        type: "button",
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": contentId,
        "data-state": isSelected ? 'active' : 'inactive',
        "data-disabled": disabled ? '' : undefined,
        disabled: disabled,
        id: triggerId
    }, triggerProps, {
        ref: forwardedRef,
        onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onMouseDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
            else // prevent focus to avoid accidental activation
            event.preventDefault();
        }),
        onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event)=>{
            if ([
                ' ',
                'Enter'
            ].includes(event.key)) context.onValueChange(value);
        }),
        onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, ()=>{
            // handle "automatic" activation if necessary
            // ie. activate tab following focus
            const isAutomaticActivation = context.activationMode !== 'manual';
            if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
        })
    })));
});
/* -------------------------------------------------------------------------------------------------
 * TabsContent
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$CONTENT_NAME = 'TabsContent';
const $69cb30bb0017df05$export$bd905d70e8fd2ebb = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , forceMount: forceMount , children: children , ...contentProps } = props;
    const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = React.useRef(isSelected);
    React.useEffect(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false
        );
        return ()=>cancelAnimationFrame(rAF)
        ;
    }, []);
    return /*#__PURE__*/ React.createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || isSelected
    }, ({ present: present  })=>/*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({
            "data-state": isSelected ? 'active' : 'inactive',
            "data-orientation": context.orientation,
            role: "tabpanel",
            "aria-labelledby": triggerId,
            hidden: !present,
            id: contentId,
            tabIndex: 0
        }, contentProps, {
            ref: forwardedRef,
            style: {
                ...props.style,
                animationDuration: isMountAnimationPreventedRef.current ? '0s' : undefined
            }
        }), present && children)
    );
});
/* ---------------------------------------------------------------------------------------------- */ function $69cb30bb0017df05$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $69cb30bb0017df05$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
const $69cb30bb0017df05$export$be92b6f5f03c0fe9 = $69cb30bb0017df05$export$b2539bed5023c21c;
const $69cb30bb0017df05$export$54c2e3dc7acea9f5 = $69cb30bb0017df05$export$9712d22edc0d78c1;
const $69cb30bb0017df05$export$41fb9f06171c75f4 = $69cb30bb0017df05$export$8114b9fdfdf9f3ba;
const $69cb30bb0017df05$export$7c6e2c02157bb7d2 = $69cb30bb0017df05$export$bd905d70e8fd2ebb;

const StyledRadixTabTrigger = styled__default["default"]($69cb30bb0017df05$export$41fb9f06171c75f4) `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.lighter};
  padding: 1.6rem;
  transition: all 150ms ease-in-out;
  position: relative;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.disabled};
  }

  &::before {
    position: absolute;
    content: '';
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0;
    background-color: ${({ theme, borderbottom }) => (borderbottom ? null : theme.colors.primary.main)};
    border-bottom: ${({ borderbottom }) => (borderbottom ? `3px solid ${borderbottom}` : null)};
  }

  &[data-state='active'] {
    outline: 0;
    font-weight: ${({ theme }) => theme.fonts.weight.bolder};
    color: ${({ theme }) => theme.colors.text.main};
    &::before {
      border-bottom: ${({ theme, borderbottom }) => (borderbottom ? `3px solid ${theme.colors.primary.main}` : null)};
      height: 0.3rem;
    }
  }

  &[data-variant='secondary'] {  
    color: ${({ theme }) => theme.colors.text.lightest};
    font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
    &:before {
      background-color: ${({ theme }) => theme.colors.border.main};
      height: 0.2rem;
    }

    &[data-state="active"] {
      font-weight: ${({ theme }) => theme.fonts.weight.bolder};
      color: ${({ theme }) => theme.colors.text.main};
      &:before {
        background-color: ${({ theme }) => theme.colors.text.main};
        height: 0.2rem;
      }
    }
  }
`;
const StyledRadixTabList = styled__default["default"]($69cb30bb0017df05$export$54c2e3dc7acea9f5) `
  white-space: unset;
  text-align: ${({ alignment }) => alignment || 'left'};

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;
const StyledTabBadge = styled__default["default"](Tag) `
  position: absolute;
  top: -1.1rem;
  right: 0.8rem;
`;

const Tab = ({ children, borderbottom, variant = 'default', ...props }) => (jsxRuntime.exports.jsx(StyledRadixTabTrigger, { borderbottom: borderbottom, ...props, "data-variant": variant, children: children }));

const TabList = ({ className, alignment = 'left', children }) => (jsxRuntime.exports.jsx(StyledRadixTabList, { alignment: alignment, className: className, children: children }));

const TabPanel = ({ ...props }) => jsxRuntime.exports.jsx($69cb30bb0017df05$export$7c6e2c02157bb7d2, { ...props });

const StyledFontAwesomeIcon$2 = styled__default["default"](FontAwesomeIcon) `
  margin-left: 1rem;
  height: 1.6rem;
  width: 1.6rem;
`;
const StyledIconGroupWrapper = styled__default["default"]('div') `
  align-items: center;
  display: flex;
  margin: 0;
`;
const StyledErrorIcon$1 = styled__default["default"](StyledFontAwesomeIcon$2) `
  color: ${({ theme }) => theme.colors.error.main};
`;
const StyledValidatedIcon = styled__default["default"](StyledFontAwesomeIcon$2) `
  color: ${({ theme }) => theme.colors.success.main};
`;
styled__default["default"](StyledFontAwesomeIcon$2) `
  color: ${({ theme }) => theme.colors.grey[400]};
`;
styled__default["default"].button `
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  gap: 0.6rem;
  padding: 0;
  height: auto;

  svg {
    color: ${({ theme }) => theme.colors.grey[400]};
    transition: color 0.2s ease-in-out;
  }

  &:hover:not(:disabled) {
    svg {
      transition: color 0.2s ease-in-out;
      color: ${({ theme }) => theme.colors.grey[600]};
    }
  }
`;
const resolveFlexDirection = (position) => {
    switch (position) {
        case 'top': {
            return 'column';
        }
        case 'right':
        case 'left': {
            return 'row';
        }
        default: {
            throw new Error(`Invalid label position: ${position}`);
        }
    }
};
const StyledTextFieldWithLabelWrapper = styled__default["default"].div `
  position: relative;
  display: flex;
  flex-direction: ${({ labelPosition }) => resolveFlexDirection(labelPosition)};
  align-items: ${({ labelPosition }) => (['left', 'right'].includes(labelPosition) ? 'center' : 'flex-start')};
`;
const StyledLabelWrapper = styled__default["default"].div `
  display: flex;
  gap: 1rem;
  align-items: center;
`;

const Tabs = ({ ...props }) => jsxRuntime.exports.jsx($69cb30bb0017df05$export$be92b6f5f03c0fe9, { ...props });

const StyledTabs = styled__default["default"](Tabs) `
  margin: 0 1.2rem 1.2rem 1.2rem;
  width: 28.8rem;
`;
const StyledGlossaryTooltipIcon = styled__default["default"](StyledFontAwesomeIcon$2) `
  margin: 0;
  height: 1.4rem;
`;
const StyledTablist = styled__default["default"](TabList) `
  margin-top: 0.6rem;
  margin-bottom: 1.6rem;
`;
const StyledSpellCheckContent = styled__default["default"].div `
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  color: ${({ theme }) => theme.colors.text.lighter};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
`;
const StyledLinkContent = styled__default["default"](StyledSpellCheckContent) `
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
`;
const StyledLink$5 = styled__default["default"].a `
  color: ${({ theme }) => theme.colors.info.main};
  text-decoration: none;
  display: block;
  overflow-wrap: break-word;
  word-wrap: break-word;
  font-size: ${({ theme }) => theme.fonts.sizes.small};
`;
const StyledContainer = styled__default["default"].div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
`;
const StyledAvatar$1 = styled__default["default"].img `
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 1rem;
  margin-right: 1rem;
`;
const StyledGlossaryTooltipTitle = styled__default["default"](StyledTooltipTitle) `
  padding: 0.9rem 0 0.6rem 1.2rem;
  height: 3.5rem;
`;

const displayLinks = (linksArray) => linksArray.map((href) => (jsxRuntime.exports.jsx(StyledLink$5, { href: href, target: "_blank", rel: "noreferrer", children: href }, `${Math.floor(1000 * Math.random())}-${href}`)));
const displayRoomContent = (roomContentArray) => roomContentArray.map((room) => {
    const { href, code, imageURL, description } = room;
    return (jsxRuntime.exports.jsxs(StyledContainer, { children: [imageURL ? jsxRuntime.exports.jsx(StyledAvatar$1, { src: imageURL, alt: description, loading: "lazy" }) : null, jsxRuntime.exports.jsx(StyledLink$5, { href: href, target: "_blank", rel: "noreferrer", children: code })] }, `${Math.floor(1000 * Math.random())}-${code}`));
});
const GlossaryTooltip = ({ tooltipTitle, textContent, videoContent, articleContent, roomContent, arrowPosition = 'top-center', }) => {
    const theme = styled.useTheme();
    const defaultValue = (textContent && 'text-content') ||
        (videoContent?.length && 'video-content') ||
        (roomContent?.length && 'room-content') ||
        (articleContent?.length && 'article-content') ||
        '';
    return (jsxRuntime.exports.jsxs(StyledTooltip, { arrowPosition: arrowPosition, tooltipTitle: tooltipTitle, role: "tooltip", children: [jsxRuntime.exports.jsx(StyledGlossaryTooltipTitle, { children: jsxRuntime.exports.jsx("p", { children: tooltipTitle }) }), jsxRuntime.exports.jsxs(StyledTabs, { defaultValue: defaultValue, children: [jsxRuntime.exports.jsxs(StyledTablist, { children: [textContent && (jsxRuntime.exports.jsx(Tab, { value: "text-content", borderbottom: theme.colors.border.light, children: jsxRuntime.exports.jsx(StyledGlossaryTooltipIcon, { icon: faSpellCheck }) })), videoContent?.length && (jsxRuntime.exports.jsx(Tab, { value: "video-content", borderbottom: theme.colors.border.light, children: jsxRuntime.exports.jsx(StyledGlossaryTooltipIcon, { icon: faVideoSlash }) })), roomContent?.length && (jsxRuntime.exports.jsx(Tab, { value: "room-content", borderbottom: theme.colors.border.light, children: jsxRuntime.exports.jsx(StyledGlossaryTooltipIcon, { icon: faBookOpen }) })), articleContent?.length && (jsxRuntime.exports.jsx(Tab, { value: "article-content", borderbottom: theme.colors.border.light, children: jsxRuntime.exports.jsx(StyledGlossaryTooltipIcon, { icon: faNewspaper }) }))] }), jsxRuntime.exports.jsx(TabPanel, { value: "text-content", children: jsxRuntime.exports.jsx(StyledSpellCheckContent, { children: textContent }) }), jsxRuntime.exports.jsx(TabPanel, { value: "video-content", children: jsxRuntime.exports.jsx(StyledLinkContent, { children: videoContent?.length ? displayLinks(videoContent) : null }) }), jsxRuntime.exports.jsx(TabPanel, { value: "room-content", children: roomContent?.length ? displayRoomContent(roomContent) : null }), jsxRuntime.exports.jsx(TabPanel, { value: "article-content", children: jsxRuntime.exports.jsx(StyledLinkContent, { children: articleContent?.length ? displayLinks(articleContent) : null }) })] })] }));
};

const StyledInfoBoxWithCopy = styled__default["default"].div `
  position: relative;
  display: flex;
  gap: 1.6rem;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  white-space: pre-wrap;
  border-radius: 0.5rem;
  padding: 1.8rem;
  background-color: ${({ theme }) => theme.colors.info.light};
  color: ${({ theme }) => theme.colors.text.main};
`;
const StyledInfoBox = styled__default["default"].div `
  border-radius: 0.5rem;
  padding: 1.8rem;
  background-color: ${({ theme }) => theme.colors.info.light};
  color: ${({ theme }) => theme.colors.text.main};
`;
const StyledCopyTextButtonContainer = styled__default["default"].div `
  display: flex;
  background: ${({ theme }) => theme.colors.button.close.background};
  padding: 0.8rem 1.6rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.border.light};
  border-radius: 0.4rem;
  gap: 0.5rem;
  cursor: pointer;
`;
const StyledCopyTextIcon = styled__default["default"](FontAwesomeIcon) `
  color: ${({ $isButton, theme }) => ($isButton ? theme.colors.text.light : theme.colors.text.lightest)};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: 1.9rem;
  align-items: center;
`;
const StyledCopyText = styled__default["default"].span `
  color: ${({ theme }) => theme.colors.text.light};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: 1.6rem;
  align-self: center;
  width: max-content;
`;

const $8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'form',
    'h2',
    'h3',
    'img',
    'input',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
        React.useEffect(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ React.createElement(Comp, _extends$b({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
    if (target) $7SXl2$reactdom.flushSync(()=>target.dispatchEvent(event)
    );
}

const $5cb92bef7577960e$var$CONTEXT_UPDATE = 'dismissableLayer.update';
const $5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = 'dismissableLayer.pointerDownOutside';
const $5cb92bef7577960e$var$FOCUS_OUTSIDE = 'dismissableLayer.focusOutside';
let $5cb92bef7577960e$var$originalBodyPointerEvents;
const $5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ React.createContext({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $5cb92bef7577960e$export$177fb62ff3ec1f22 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = React.useContext($5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = React.useState(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = React.useState({});
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setNode(node)
    );
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    $addc16e1bbe58fd0$export$3a72a57244d6e765((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    React.useEffect(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = 'none';
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ React.useEffect(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    React.useEffect(()=>{
        const handleUpdate = ()=>force({})
        ;
        document.addEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate)
        ;
    }, []);
    return /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$b({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? 'auto' : 'none' : undefined,
            ...props.style
        },
        onFocusCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onPointerDownOutside);
    const isPointerInsideReactTreeRef = React.useRef(false);
    const handleClickRef = React.useRef(()=>{});
    React.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === 'touch') {
                    ownerDocument.removeEventListener('click', handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener('click', handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener('pointerdown', handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener('pointerdown', handlePointerDown);
            ownerDocument.removeEventListener('click', handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onFocusOutside);
    const isFocusInsideReactTreeRef = React.useRef(false);
    React.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener('focusin', handleFocus);
        return ()=>ownerDocument.removeEventListener('focusin', handleFocus)
        ;
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true
        ,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event);
    else target.dispatchEvent(event);
}

const $7e8f5cd07187803e$export$21b07c8f274aebd5 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { children: children , width: width = 10 , height: height = 5 , ...arrowProps } = props;
    return /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.svg, _extends$b({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ React.createElement("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $7e8f5cd07187803e$export$be92b6f5f03c0fe9 = $7e8f5cd07187803e$export$21b07c8f274aebd5;

/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$POPPER_NAME = 'Popper';
const [$cf1ac5d9fe0e8206$var$createPopperContext, $cf1ac5d9fe0e8206$export$722aac194ae923] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$cf1ac5d9fe0e8206$var$PopperProvider, $cf1ac5d9fe0e8206$var$usePopperContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$POPPER_NAME);
const $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper , children: children  } = props;
    const [anchor, setAnchor] = React.useState(null);
    return /*#__PURE__*/ React.createElement($cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$ANCHOR_NAME = 'PopperAnchor';
const $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper , virtualRef: virtualRef , ...anchorProps } = props;
    const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = React.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    React.useEffect(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$b({}, anchorProps, {
        ref: composedRefs
    }));
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$CONTENT_NAME = 'PopperContent';
const [$cf1ac5d9fe0e8206$var$PopperContentProvider, $cf1ac5d9fe0e8206$var$useContentContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME);
const [$cf1ac5d9fe0e8206$var$PositionContextProvider, $cf1ac5d9fe0e8206$var$usePositionContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, {
    hasParent: false,
    positionUpdateFns: new Set()
});
const $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$hide, _middlewareData$trans, _middlewareData$trans2;
    const { __scopePopper: __scopePopper , side: side = 'bottom' , sideOffset: sideOffset = 0 , align: align = 'center' , alignOffset: alignOffset = 0 , arrowPadding: arrowPadding = 0 , collisionBoundary: collisionBoundary = [] , collisionPadding: collisionPaddingProp = 0 , sticky: sticky = 'partial' , hideWhenDetached: hideWhenDetached = false , avoidCollisions: avoidCollisions = true , onPlaced: onPlaced , ...contentProps } = props;
    const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = React.useState(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setContent(node)
    );
    const [arrow, setArrow] = React.useState(null);
    const arrowSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== 'center' ? '-' + align : '');
    const collisionPadding = typeof collisionPaddingProp === 'number' ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { reference: reference , floating: floating , strategy: strategy , x: x , y: y , placement: placement , middlewareData: middlewareData , update: update  } = useFloating({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: 'fixed',
        placement: desiredPlacement,
        whileElementsMounted: autoUpdate$1,
        middleware: [
            $cf1ac5d9fe0e8206$var$anchorCssProperties(),
            offset$1({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions ? shift$1({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === 'partial' ? limitShift$1() : undefined,
                ...detectOverflowOptions
            }) : undefined,
            arrow ? arrow$1({
                element: arrow,
                padding: arrowPadding
            }) : undefined,
            avoidCollisions ? flip$1({
                ...detectOverflowOptions
            }) : undefined,
            size$1({
                ...detectOverflowOptions,
                apply: ({ elements: elements , availableWidth: width , availableHeight: height  })=>{
                    elements.floating.style.setProperty('--radix-popper-available-width', `${width}px`);
                    elements.floating.style.setProperty('--radix-popper-available-height', `${height}px`);
                }
            }),
            $cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached ? hide$1({
                strategy: 'referenceHidden'
            }) : undefined
        ].filter($cf1ac5d9fe0e8206$var$isDefined)
    }); // assign the reference dynamically once `Content` has mounted so we can collocate the logic
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        reference(context.anchor);
    }, [
        reference,
        context.anchor
    ]);
    const isPlaced = x !== null && y !== null;
    const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onPlaced);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (isPlaced) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPlaced,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = React.useState();
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    const { hasParent: hasParent , positionUpdateFns: positionUpdateFns  } = $cf1ac5d9fe0e8206$var$usePositionContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const isRoot = !hasParent;
    React.useLayoutEffect(()=>{
        if (!isRoot) {
            positionUpdateFns.add(update);
            return ()=>{
                positionUpdateFns.delete(update);
            };
        }
    }, [
        isRoot,
        positionUpdateFns,
        update
    ]); // when nested contents are rendered in portals, they are appended out of order causing
    // children to be positioned incorrectly if initially open.
    // we need to re-compute the positioning once the parent has finally been placed.
    // https://github.com/floating-ui/floating-ui/issues/1531
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (isRoot && isPlaced) Array.from(positionUpdateFns).reverse().forEach((fn)=>requestAnimationFrame(fn)
        );
    }, [
        isRoot,
        isPlaced,
        positionUpdateFns
    ]);
    const commonProps = {
        'data-side': placedSide,
        'data-align': placedAlign,
        ...contentProps,
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPlaced ? 'none' : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        ref: floating,
        "data-radix-popper-content-wrapper": "",
        style: {
            position: strategy,
            left: 0,
            top: 0,
            transform: isPlaced ? `translate3d(${Math.round(x)}px, ${Math.round(y)}px, 0)` : 'translate3d(0, -200%, 0)',
            // keep off the page when measuring
            minWidth: 'max-content',
            zIndex: contentZIndex,
            ['--radix-popper-transform-origin']: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(' ')
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ React.createElement($cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, isRoot ? /*#__PURE__*/ React.createElement($cf1ac5d9fe0e8206$var$PositionContextProvider, {
        scope: __scopePopper,
        hasParent: true,
        positionUpdateFns: positionUpdateFns
    }, /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, commonProps)) : /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, commonProps)));
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$ARROW_NAME = 'PopperArrow';
const $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right'
};
const $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0 = /*#__PURE__*/ React.forwardRef(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper , ...arrowProps } = props;
    const contentContext = $cf1ac5d9fe0e8206$var$useContentContext($cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    React.createElement("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: 'absolute',
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: '',
                right: '0 0',
                bottom: 'center 0',
                left: '100% 0'
            }[contentContext.placedSide],
            transform: {
                top: 'translateY(100%)',
                right: 'translateY(50%) rotate(90deg) translateX(-50%)',
                bottom: `rotate(180deg)`,
                left: 'translateY(50%) rotate(-90deg) translateX(50%)'
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? 'hidden' : undefined
        }
    }, /*#__PURE__*/ React.createElement($7e8f5cd07187803e$export$be92b6f5f03c0fe9, _extends$b({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: 'block'
        }
    }))));
});
/* -----------------------------------------------------------------------------------------------*/ function $cf1ac5d9fe0e8206$var$isDefined(value) {
    return value !== undefined;
}
function $cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $cf1ac5d9fe0e8206$var$anchorCssProperties = ()=>({
        name: 'anchorCssProperties',
        fn (data) {
            const { rects: rects , elements: elements  } = data;
            const { width: width , height: height  } = rects.reference;
            elements.floating.style.setProperty('--radix-popper-anchor-width', `${width}px`);
            elements.floating.style.setProperty('--radix-popper-anchor-height', `${height}px`);
            return {};
        }
    })
;
const $cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: 'transformOrigin',
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement , rects: rects , middlewareData: middlewareData  } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: '0%',
                center: '50%',
                end: '100%'
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = '';
            let y = '';
            if (placedSide === 'bottom') {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === 'top') {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === 'right') {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === 'left') {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    })
;
function $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = 'center'] = placement.split('-');
    return [
        side,
        align
    ];
}
const $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9 = $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9;
const $cf1ac5d9fe0e8206$export$b688253958b8dfe7 = $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d;
const $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2 = $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc;
const $cf1ac5d9fe0e8206$export$21b07c8f274aebd5 = $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0;

const $f1701beae083dbae$export$602eac185826482c = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body , ...portalProps } = props;
    return container ? /*#__PURE__*/ $7SXl2$reactdom__default["default"].createPortal(/*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$b({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});

const $ea1ef594cf570d83$export$439d29a4e110a164 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    return /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends$b({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: 'absolute',
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            ...props.style
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $ea1ef594cf570d83$export$be92b6f5f03c0fe9 = $ea1ef594cf570d83$export$439d29a4e110a164;

const [$a093c7e1ec25a057$var$createTooltipContext, $a093c7e1ec25a057$export$1c540a2224f0d865] = $c512c27ab02ef895$export$50c7b4e9d9f19c1('Tooltip', [
    $cf1ac5d9fe0e8206$export$722aac194ae923
]);
const $a093c7e1ec25a057$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923();
/* -------------------------------------------------------------------------------------------------
 * TooltipProvider
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$PROVIDER_NAME = 'TooltipProvider';
const $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION = 700;
const $a093c7e1ec25a057$var$TOOLTIP_OPEN = 'tooltip.open';
const [$a093c7e1ec25a057$var$TooltipProviderContextProvider, $a093c7e1ec25a057$var$useTooltipProviderContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PROVIDER_NAME);
const $a093c7e1ec25a057$export$f78649fb9ca566b8 = (props)=>{
    const { __scopeTooltip: __scopeTooltip , delayDuration: delayDuration = $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION , skipDelayDuration: skipDelayDuration = 300 , disableHoverableContent: disableHoverableContent = false , children: children  } = props;
    const [isOpenDelayed, setIsOpenDelayed] = React.useState(true);
    const isPointerInTransitRef = React.useRef(false);
    const skipDelayTimerRef = React.useRef(0);
    React.useEffect(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer)
        ;
    }, []);
    return /*#__PURE__*/ React.createElement($a093c7e1ec25a057$var$TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayed: isOpenDelayed,
        delayDuration: delayDuration,
        onOpen: React.useCallback(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            setIsOpenDelayed(false);
        }, []),
        onClose: React.useCallback(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>setIsOpenDelayed(true)
            , skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef: isPointerInTransitRef,
        onPointerInTransitChange: React.useCallback((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent: disableHoverableContent
    }, children);
};
/* -------------------------------------------------------------------------------------------------
 * Tooltip
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$TOOLTIP_NAME = 'Tooltip';
const [$a093c7e1ec25a057$var$TooltipContextProvider, $a093c7e1ec25a057$var$useTooltipContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME);
const $a093c7e1ec25a057$export$28c660c63b792dea = (props)=>{
    const { __scopeTooltip: __scopeTooltip , children: children , open: openProp , defaultOpen: defaultOpen = false , onOpenChange: onOpenChange , disableHoverableContent: disableHoverableContentProp , delayDuration: delayDurationProp  } = props;
    const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = React.useState(null);
    const contentId = $1746a345f3d73bb7$export$f680877a34711e37();
    const openTimerRef = React.useRef(0);
    const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
    const wasOpenDelayedRef = React.useRef(false);
    const [open1 = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: (open)=>{
            if (open) {
                providerContext.onOpen(); // as `onChange` is called within a lifecycle method we
                // avoid dispatching via `dispatchDiscreteCustomEvent`.
                document.dispatchEvent(new CustomEvent($a093c7e1ec25a057$var$TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(open);
        }
    });
    const stateAttribute = React.useMemo(()=>{
        return open1 ? wasOpenDelayedRef.current ? 'delayed-open' : 'instant-open' : 'closed';
    }, [
        open1
    ]);
    const handleOpen = React.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = React.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = React.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    React.useEffect(()=>{
        return ()=>window.clearTimeout(openTimerRef.current)
        ;
    }, []);
    return /*#__PURE__*/ React.createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, /*#__PURE__*/ React.createElement($a093c7e1ec25a057$var$TooltipContextProvider, {
        scope: __scopeTooltip,
        contentId: contentId,
        open: open1,
        stateAttribute: stateAttribute,
        trigger: trigger,
        onTriggerChange: setTrigger,
        onTriggerEnter: React.useCallback(()=>{
            if (providerContext.isOpenDelayed) handleDelayedOpen();
            else handleOpen();
        }, [
            providerContext.isOpenDelayed,
            handleDelayedOpen,
            handleOpen
        ]),
        onTriggerLeave: React.useCallback(()=>{
            if (disableHoverableContent) handleClose();
            else // Clear the timer in case the pointer leaves the trigger before the tooltip is opened.
            window.clearTimeout(openTimerRef.current);
        }, [
            handleClose,
            disableHoverableContent
        ]),
        onOpen: handleOpen,
        onClose: handleClose,
        disableHoverableContent: disableHoverableContent
    }, children));
};
/* -------------------------------------------------------------------------------------------------
 * TooltipTrigger
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$TRIGGER_NAME = 'TooltipTrigger';
const $a093c7e1ec25a057$export$8c610744efcf8a1d = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip , ...triggerProps } = props;
    const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const ref = React.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = React.useRef(false);
    const hasPointerMoveOpenedRef = React.useRef(false);
    const handlePointerUp = React.useCallback(()=>isPointerDownRef.current = false
    , []);
    React.useEffect(()=>{
        return ()=>document.removeEventListener('pointerup', handlePointerUp)
        ;
    }, [
        handlePointerUp
    ]);
    return /*#__PURE__*/ React.createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends$b({
        asChild: true
    }, popperScope), /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends$b({
        // We purposefully avoid adding `type=button` here because tooltip triggers are also
        // commonly anchors and the anchor `type` attribute signifies MIME type.
        "aria-describedby": context.open ? context.contentId : undefined,
        "data-state": context.stateAttribute
    }, triggerProps, {
        ref: composedRefs,
        onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, (event)=>{
            if (event.pointerType === 'touch') return;
            if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                context.onTriggerEnter();
                hasPointerMoveOpenedRef.current = true;
            }
        }),
        onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerLeave, ()=>{
            context.onTriggerLeave();
            hasPointerMoveOpenedRef.current = false;
        }),
        onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, ()=>{
            isPointerDownRef.current = true;
            document.addEventListener('pointerup', handlePointerUp, {
                once: true
            });
        }),
        onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, ()=>{
            if (!isPointerDownRef.current) context.onOpen();
        }),
        onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, context.onClose),
        onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onClose)
    })));
});
/* -------------------------------------------------------------------------------------------------
 * TooltipPortal
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$PORTAL_NAME = 'TooltipPortal';
const [$a093c7e1ec25a057$var$PortalProvider, $a093c7e1ec25a057$var$usePortalContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PORTAL_NAME, {
    forceMount: undefined
});
const $a093c7e1ec25a057$export$7b36b8f925ab7497 = (props)=>{
    const { __scopeTooltip: __scopeTooltip , forceMount: forceMount , children: children , container: container  } = props;
    const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$PORTAL_NAME, __scopeTooltip);
    return /*#__PURE__*/ React.createElement($a093c7e1ec25a057$var$PortalProvider, {
        scope: __scopeTooltip,
        forceMount: forceMount
    }, /*#__PURE__*/ React.createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, /*#__PURE__*/ React.createElement($f1701beae083dbae$export$602eac185826482c, {
        asChild: true,
        container: container
    }, children)));
};
/* -------------------------------------------------------------------------------------------------
 * TooltipContent
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$CONTENT_NAME = 'TooltipContent';
const $a093c7e1ec25a057$export$e9003e2be37ec060 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const portalContext = $a093c7e1ec25a057$var$usePortalContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const { forceMount: forceMount = portalContext.forceMount , side: side = 'top' , ...contentProps } = props;
    const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    return /*#__PURE__*/ React.createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, context.disableHoverableContent ? /*#__PURE__*/ React.createElement($a093c7e1ec25a057$var$TooltipContentImpl, _extends$b({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ React.createElement($a093c7e1ec25a057$var$TooltipContentHoverable, _extends$b({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })));
});
const $a093c7e1ec25a057$var$TooltipContentHoverable = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const ref = React.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = React.useState(null);
    const { trigger: trigger , onClose: onClose  } = context;
    const content = ref.current;
    const { onPointerInTransitChange: onPointerInTransitChange  } = providerContext;
    const handleRemoveGraceArea = React.useCallback(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = React.useCallback((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = $a093c7e1ec25a057$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const bleed = exitSide === 'right' || exitSide === 'bottom' ? -5 : 5;
        const isXAxis = exitSide === 'right' || exitSide === 'left';
        const startPoint = isXAxis ? {
            x: event.clientX + bleed,
            y: event.clientY
        } : {
            x: event.clientX,
            y: event.clientY + bleed
        };
        const hoverTargetPoints = $a093c7e1ec25a057$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = $a093c7e1ec25a057$var$getHull([
            startPoint,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    React.useEffect(()=>{
        return ()=>handleRemoveGraceArea()
        ;
    }, [
        handleRemoveGraceArea
    ]);
    React.useEffect(()=>{
        if (trigger && content) {
            const handleTriggerLeave = (event)=>handleCreateGraceArea(event, content)
            ;
            const handleContentLeave = (event)=>handleCreateGraceArea(event, trigger)
            ;
            trigger.addEventListener('pointerleave', handleTriggerLeave);
            content.addEventListener('pointerleave', handleContentLeave);
            return ()=>{
                trigger.removeEventListener('pointerleave', handleTriggerLeave);
                content.removeEventListener('pointerleave', handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    React.useEffect(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = (event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
                const isPointerOutsideGraceArea = !$a093c7e1ec25a057$var$isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            };
            document.addEventListener('pointermove', handleTrackPointerGrace);
            return ()=>document.removeEventListener('pointermove', handleTrackPointerGrace)
            ;
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /*#__PURE__*/ React.createElement($a093c7e1ec25a057$var$TooltipContentImpl, _extends$b({}, props, {
        ref: composedRefs
    }));
});
const [$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, $a093c7e1ec25a057$var$useVisuallyHiddenContentContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME, {
    isInside: false
});
const $a093c7e1ec25a057$var$TooltipContentImpl = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip , children: children , 'aria-label': ariaLabel , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , ...contentProps } = props;
    const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, __scopeTooltip);
    const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const { onClose: onClose  } = context; // Close this tooltip if another one opens
    React.useEffect(()=>{
        document.addEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose)
        ;
    }, [
        onClose
    ]); // Close the tooltip if the trigger is scrolled
    React.useEffect(()=>{
        if (context.trigger) {
            const handleScroll = (event)=>{
                const target = event.target;
                if (target !== null && target !== void 0 && target.contains(context.trigger)) onClose();
            };
            window.addEventListener('scroll', handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener('scroll', handleScroll, {
                    capture: true
                })
            ;
        }
    }, [
        context.trigger,
        onClose
    ]);
    return /*#__PURE__*/ React.createElement($5cb92bef7577960e$export$177fb62ff3ec1f22, {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault()
        ,
        onDismiss: onClose
    }, /*#__PURE__*/ React.createElement($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, _extends$b({
        "data-state": context.stateAttribute
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            '--radix-tooltip-content-transform-origin': 'var(--radix-popper-transform-origin)',
            '--radix-tooltip-content-available-width': 'var(--radix-popper-available-width)',
            '--radix-tooltip-content-available-height': 'var(--radix-popper-available-height)',
            '--radix-tooltip-trigger-width': 'var(--radix-popper-anchor-width)',
            '--radix-tooltip-trigger-height': 'var(--radix-popper-anchor-height)'
        }
    }), /*#__PURE__*/ React.createElement($5e63c961fc1ce211$export$d9f1ccf0bdb05d45, null, children), /*#__PURE__*/ React.createElement($a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, {
        scope: __scopeTooltip,
        isInside: true
    }, /*#__PURE__*/ React.createElement($ea1ef594cf570d83$export$be92b6f5f03c0fe9, {
        id: context.contentId,
        role: "tooltip"
    }, ariaLabel || children))));
});
/* -------------------------------------------------------------------------------------------------
 * TooltipArrow
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$ARROW_NAME = 'TooltipArrow';
const $a093c7e1ec25a057$export$c27ee0ad710f7559 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip , ...arrowProps } = props;
    const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const visuallyHiddenContentContext = $a093c7e1ec25a057$var$useVisuallyHiddenContentContext($a093c7e1ec25a057$var$ARROW_NAME, __scopeTooltip); // if the arrow is inside the `VisuallyHidden`, we don't want to render it all to
    // prevent issues in positioning the arrow due to the duplicate
    return visuallyHiddenContentContext.isInside ? null : /*#__PURE__*/ React.createElement($cf1ac5d9fe0e8206$export$21b07c8f274aebd5, _extends$b({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/* -----------------------------------------------------------------------------------------------*/ function $a093c7e1ec25a057$var$getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return 'left';
        case right:
            return 'right';
        case top:
            return 'top';
        case bottom:
            return 'bottom';
        default:
            return null;
    }
}
function $a093c7e1ec25a057$var$getPointsFromRect(rect) {
    const { top: top , right: right , bottom: bottom , left: left  } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
} // Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $a093c7e1ec25a057$var$isPointInPolygon(point, polygon) {
    const { x: x , y: y  } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y; // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
} // Returns a new array of points representing the convex hull of the given set of points.
// https://www.nayuki.io/page/convex-hull-algorithm
function $a093c7e1ec25a057$var$getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return $a093c7e1ec25a057$var$getHullPresorted(newPoints);
} // Returns the convex hull, assuming that each points[i] <= points[i + 1]. Runs in O(n) time.
function $a093c7e1ec25a057$var$getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i1 = points.length - 1; i1 >= 0; i1--){
        const p = points[i1];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
const $a093c7e1ec25a057$export$2881499e37b75b9a = $a093c7e1ec25a057$export$f78649fb9ca566b8;
const $a093c7e1ec25a057$export$be92b6f5f03c0fe9 = $a093c7e1ec25a057$export$28c660c63b792dea;
const $a093c7e1ec25a057$export$41fb9f06171c75f4 = $a093c7e1ec25a057$export$8c610744efcf8a1d;
const $a093c7e1ec25a057$export$602eac185826482c = $a093c7e1ec25a057$export$7b36b8f925ab7497;
const $a093c7e1ec25a057$export$7c6e2c02157bb7d2 = $a093c7e1ec25a057$export$e9003e2be37ec060;
const $a093c7e1ec25a057$export$21b07c8f274aebd5 = $a093c7e1ec25a057$export$c27ee0ad710f7559;

const StyledTooltipContent$1 = styled__default["default"]($a093c7e1ec25a057$export$e9003e2be37ec060) `
  display: flex;
  gap: 0.3rem;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  opacity: 1;
  z-index: 1001;
  padding: 1.2rem;
`;
const StyledTooltipArrow = styled__default["default"]($a093c7e1ec25a057$export$c27ee0ad710f7559) `
  fill: ${({ theme }) => theme.colors.background.tertiary};
`;
const StyledTooltipText$1 = styled__default["default"].p `
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  line-height: 1.5rem;
  color: ${({ theme }) => theme.colors.text.main};
`;
const StyledCheckIcon$3 = styled__default["default"](FontAwesomeIcon) `
  && {
    color: ${({ theme }) => theme.colors.text.main};
  }
`;

const InfoBoxTooltip = ({ children, open, setIsOpen }) => {
    React.useEffect(() => {
        if (open) {
            setTimeout(() => {
                setIsOpen(false);
            }, 1600);
        }
    }, [setIsOpen, open]);
    return (jsxRuntime.exports.jsx($a093c7e1ec25a057$export$2881499e37b75b9a, { children: jsxRuntime.exports.jsxs($a093c7e1ec25a057$export$be92b6f5f03c0fe9, { open: open, delayDuration: 0, children: [jsxRuntime.exports.jsx($a093c7e1ec25a057$export$41fb9f06171c75f4, { asChild: true, onClick: () => setIsOpen(true), children: children }), jsxRuntime.exports.jsx($a093c7e1ec25a057$export$602eac185826482c, { children: jsxRuntime.exports.jsxs(StyledTooltipContent$1, { sideOffset: 1, side: "right", children: [jsxRuntime.exports.jsx(StyledCheckIcon$3, { icon: faCheck$1 }), jsxRuntime.exports.jsx(StyledTooltipText$1, { children: "Copied" }), jsxRuntime.exports.jsx(StyledTooltipArrow, {})] }) })] }) }));
};

const InfoBox = ({ children, textToCopy, linkButtonType, handleAfterCopy, ...nativeDivAttributes }) => {
    const [tooltipVisible, setTooltipVisible] = React.useState(false);
    if (textToCopy && linkButtonType) {
        return (jsxRuntime.exports.jsxs(StyledInfoBoxWithCopy, { ...nativeDivAttributes, children: [children, linkButtonType === 'button' && (jsxRuntime.exports.jsx(InfoBoxTooltip, { open: tooltipVisible, setIsOpen: setTooltipVisible, children: jsxRuntime.exports.jsxs(StyledCopyTextButtonContainer, { onClick: async () => {
                            setTooltipVisible(true);
                            await navigator.clipboard.writeText(textToCopy);
                            handleAfterCopy?.();
                        }, "aria-label": "copy-button", children: [jsxRuntime.exports.jsx(StyledCopyTextIcon, { "$isButton": true, icon: faCopy$1 }), jsxRuntime.exports.jsx(StyledCopyText, { children: "Copy link" })] }) })), linkButtonType === 'icon' && (jsxRuntime.exports.jsx(InfoBoxTooltip, { open: tooltipVisible, setIsOpen: setTooltipVisible, children: jsxRuntime.exports.jsx(IconButton, { variant: "copy", width: "3.6rem", height: "3.6rem", onClick: async () => {
                            setTooltipVisible(true);
                            await navigator.clipboard.writeText(textToCopy);
                            handleAfterCopy?.();
                        }, "aria-label": "copy-icon-button", children: jsxRuntime.exports.jsx(StyledCopyTextIcon, { icon: faCopy$1 }) }) }))] }));
    }
    return jsxRuntime.exports.jsx(StyledInfoBox, { ...nativeDivAttributes, children: children });
};

const StyledLoginButton = styled__default["default"].div `
  ${({ $fillSpace }) => ($fillSpace ? 'width: 100%' : '')};

  button[data-link='text'] {
    display: inline-block;
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.info.main};
    font-family: ${({ theme }) => theme.fonts.familySansPro};
  }

  button[data-link='outlined'] {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
  }

  & > button {
    white-space: nowrap;
    ${({ $fillSpace }) => ($fillSpace ? 'width: 100%' : '')};
  }
`;

const LoginButton = ({ variant = 'outlined', children = 'Log In', className, forceDarkMode = false, fillSpace = false, onNavigate = () => { }, }) => {
    const navigate = reactRouterDom.useNavigate();
    const location = reactRouterDom.useLocation();
    const navigateToLogin = () => {
        window.sessionStorage.setItem('login_referrer', location.pathname);
        navigate('/login');
        onNavigate();
    };
    return (jsxRuntime.exports.jsx(styled.ThemeProvider, { theme: { ...theme, colors: forceDarkMode ? darkColors : lightColors }, children: jsxRuntime.exports.jsx(StyledLoginButton, { className: className, "$fillSpace": fillSpace, children: jsxRuntime.exports.jsx(StyledButton$3, { onClick: navigateToLogin, size: "default", variant: variant, color: "primary", "data-link": variant, children: children }) }) }));
};

const PaginationContainer = styled__default["default"].div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;
const StyledCommon$1 = styled.css `
  padding: 1rem 1.6rem;
  height: 3.6rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.border.light};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: 1.6rem;
  background: ${({ theme }) => theme.colors.background.secondary};
  color: ${({ theme }) => theme.colors.text.main};

  :hover {
    background: ${({ theme }) => theme.colors.background.disabled};
  }
`;
const StyledNavigationButton = styled__default["default"].button `
  ${StyledCommon$1}

  ${({ disabled }) => {
    if (disabled) {
        return styled.css `
        color: ${({ theme }) => (disabled ? theme.colors.text.lightest : theme.colors.text.main)};
        :hover {
          background: ${({ theme }) => theme.colors.background.secondary};
        }
      `;
    }
    return '';
}}

  &:first-child {
    border-radius: 0.5rem 0 0 0.5rem;
    border-right: none;
  }

  &:last-child {
    border-radius: 0 0.5rem 0.5rem 0;
  }
`;
const StyledPaginateButton = styled__default["default"].button `
  ${StyledCommon$1}
  border-right: none;

  ${({ background }) => {
    if (background) {
        return styled.css `
        :hover {
          background: ${({ theme }) => theme.colors.background.secondary};
        }
      `;
    }
    return '';
}}

  &[aria-pressed='true'] {
    color: ${({ theme }) => theme.colors.text.invert};
    background: ${({ theme }) => theme.colors.background.selected};
    :hover {
      background: ${({ theme }) => theme.colors.background.selectedHover};
    }
  }
  &[data-cursor='not-clickable'] {
    cursor: initial;
  }
`;
const StyledAvailablePages = styled__default["default"].p `
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  line-height: 2.2rem;
  color: ${({ theme }) => theme.colors.text.lighter};
  margin-top: 1.4rem;
`;

const getPageId = (page, index) => `page-${page}-${index}`;
const Pagination = ({ totalPages, selectedPage, onChange, hideAvailablePageText = false }) => {
    const pageNumbers = [];
    const showFirstSevenPages = selectedPage <= 5;
    const showLastSevenPages = selectedPage >= totalPages - 4;
    for (let i = 1; i <= totalPages; i++) {
        if (i === 1 ||
            i === totalPages ||
            i === selectedPage ||
            (showFirstSevenPages && i <= 7) ||
            (showLastSevenPages && i >= totalPages - 6) ||
            (!showFirstSevenPages && !showLastSevenPages && i >= selectedPage - 2 && i <= selectedPage + 2)) {
            pageNumbers.push(i);
        }
        else if (pageNumbers[pageNumbers.length - 1] !== '...') {
            pageNumbers.push('...');
        }
    }
    const handlePreviousPage = () => {
        const prevPage = selectedPage - 1;
        onChange(prevPage);
        onChange(prevPage);
    };
    const handlePageChange = (page) => {
        onChange(page);
        if (page !== selectedPage) {
            onChange(page);
        }
    };
    const handleNextPage = () => {
        const nextPage = selectedPage + 1;
        onChange(nextPage);
        onChange(nextPage);
    };
    return (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsxs(PaginationContainer, { role: "navigation", children: [jsxRuntime.exports.jsx(StyledNavigationButton, { onClick: handlePreviousPage, disabled: selectedPage === 1, "data-testid": "previous", children: "Previous" }), pageNumbers.map((page, index) => (jsxRuntime.exports.jsx(React.Fragment, { children: typeof page === 'number' ? (jsxRuntime.exports.jsx(StyledPaginateButton, { "aria-pressed": page === selectedPage, onClick: () => handlePageChange(page), disabled: selectedPage === page, children: page }, page)) : (jsxRuntime.exports.jsx(StyledPaginateButton, { background: true, disabled: true, "data-cursor": "not-clickable", children: page }, page)) }, getPageId(page, index)))), jsxRuntime.exports.jsx(StyledNavigationButton, { onClick: handleNextPage, disabled: selectedPage === totalPages, "data-testid": "next", children: "Next" })] }), !hideAvailablePageText && (jsxRuntime.exports.jsx(PaginationContainer, { children: jsxRuntime.exports.jsxs(StyledAvailablePages, { children: [selectedPage, " of ", totalPages, " available pages"] }) }))] }));
};

/* -------------------------------------------------------------------------------------------------
 * Progress
 * -----------------------------------------------------------------------------------------------*/ const $67824d98245208a0$var$PROGRESS_NAME = 'Progress';
const $67824d98245208a0$var$DEFAULT_MAX = 100;
const [$67824d98245208a0$var$createProgressContext, $67824d98245208a0$export$388eb2d8f6d3261f] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($67824d98245208a0$var$PROGRESS_NAME);
const [$67824d98245208a0$var$ProgressProvider, $67824d98245208a0$var$useProgressContext] = $67824d98245208a0$var$createProgressContext($67824d98245208a0$var$PROGRESS_NAME);
const $67824d98245208a0$export$b25a304ec7d746bb = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeProgress: __scopeProgress , value: valueProp , max: maxProp , getValueLabel: getValueLabel = $67824d98245208a0$var$defaultGetValueLabel , ...progressProps } = props;
    const max = $67824d98245208a0$var$isValidMaxNumber(maxProp) ? maxProp : $67824d98245208a0$var$DEFAULT_MAX;
    const value = $67824d98245208a0$var$isValidValueNumber(valueProp, max) ? valueProp : null;
    const valueLabel = $67824d98245208a0$var$isNumber(value) ? getValueLabel(value, max) : undefined;
    return /*#__PURE__*/ React.createElement($67824d98245208a0$var$ProgressProvider, {
        scope: __scopeProgress,
        value: value,
        max: max
    }, /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({
        "aria-valuemax": max,
        "aria-valuemin": 0,
        "aria-valuenow": $67824d98245208a0$var$isNumber(value) ? value : undefined,
        "aria-valuetext": valueLabel,
        role: "progressbar",
        "data-state": $67824d98245208a0$var$getProgressState(value, max),
        "data-value": value !== null && value !== void 0 ? value : undefined,
        "data-max": max
    }, progressProps, {
        ref: forwardedRef
    })));
});
$67824d98245208a0$export$b25a304ec7d746bb.propTypes = {
    max (props, propName, componentName) {
        const propValue = props[propName];
        const strVal = String(propValue);
        if (propValue && !$67824d98245208a0$var$isValidMaxNumber(propValue)) return new Error($67824d98245208a0$var$getInvalidMaxError(strVal, componentName));
        return null;
    },
    value (props, propName, componentName) {
        const valueProp = props[propName];
        const strVal = String(valueProp);
        const max = $67824d98245208a0$var$isValidMaxNumber(props.max) ? props.max : $67824d98245208a0$var$DEFAULT_MAX;
        if (valueProp != null && !$67824d98245208a0$var$isValidValueNumber(valueProp, max)) return new Error($67824d98245208a0$var$getInvalidValueError(strVal, componentName));
        return null;
    }
};
/* -------------------------------------------------------------------------------------------------
 * ProgressIndicator
 * -----------------------------------------------------------------------------------------------*/ const $67824d98245208a0$var$INDICATOR_NAME = 'ProgressIndicator';
const $67824d98245208a0$export$2b776f7e7ee60dbd = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    var _context$value;
    const { __scopeProgress: __scopeProgress , ...indicatorProps } = props;
    const context = $67824d98245208a0$var$useProgressContext($67824d98245208a0$var$INDICATOR_NAME, __scopeProgress);
    return /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({
        "data-state": $67824d98245208a0$var$getProgressState(context.value, context.max),
        "data-value": (_context$value = context.value) !== null && _context$value !== void 0 ? _context$value : undefined,
        "data-max": context.max
    }, indicatorProps, {
        ref: forwardedRef
    }));
});
/* ---------------------------------------------------------------------------------------------- */ function $67824d98245208a0$var$defaultGetValueLabel(value, max) {
    return `${Math.round(value / max * 100)}%`;
}
function $67824d98245208a0$var$getProgressState(value, maxValue) {
    return value == null ? 'indeterminate' : value === maxValue ? 'complete' : 'loading';
}
function $67824d98245208a0$var$isNumber(value) {
    return typeof value === 'number';
}
function $67824d98245208a0$var$isValidMaxNumber(max) {
    // prettier-ignore
    return $67824d98245208a0$var$isNumber(max) && !isNaN(max) && max > 0;
}
function $67824d98245208a0$var$isValidValueNumber(value, max) {
    // prettier-ignore
    return $67824d98245208a0$var$isNumber(value) && !isNaN(value) && value <= max && value >= 0;
} // Split this out for clearer readability of the error message.
function $67824d98245208a0$var$getInvalidMaxError(propValue, componentName) {
    return `Invalid prop \`max\` of value \`${propValue}\` supplied to \`${componentName}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${$67824d98245208a0$var$DEFAULT_MAX}\`.`;
}
function $67824d98245208a0$var$getInvalidValueError(propValue, componentName) {
    return `Invalid prop \`value\` of value \`${propValue}\` supplied to \`${componentName}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${$67824d98245208a0$var$DEFAULT_MAX} if no \`max\` prop is set)
  - \`null\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
const $67824d98245208a0$export$be92b6f5f03c0fe9 = $67824d98245208a0$export$b25a304ec7d746bb;
const $67824d98245208a0$export$adb584737d712b70 = $67824d98245208a0$export$2b776f7e7ee60dbd;

exports.StatusEnum = void 0;
(function (StatusEnum) {
    StatusEnum["DUE_SOON"] = "Due Soon";
    StatusEnum["IN_PROGRESS"] = "In Progress";
    StatusEnum["NOT_STARTED"] = "Not Started";
    StatusEnum["OVER_DUE"] = "Overdue";
    StatusEnum["COMPLETE"] = "Complete";
})(exports.StatusEnum || (exports.StatusEnum = {}));

const StyledProgressBar$1 = styled__default["default"]($67824d98245208a0$export$be92b6f5f03c0fe9) `
  position: relative;
  overflow: ${({ threshold }) => (threshold ? 'visible' : 'hidden')};
  background-color: ${({ theme, backgroundColor }) => backgroundColor || theme.colors.progressBar};
  width: 100%;
  height: ${({ height }) => `${height}px`};
  border-radius: ${({ radius }) => `${radius}rem`};
  ${({ threshold, max }) => threshold !== undefined &&
    `
    &::before {
      content: '';
      position: absolute;
      top: -0.3rem;
      bottom: -0.3rem;
      width: 0.2rem;
      background-color: #636e81;
      left: ${(100 / max) * threshold}%;
      z-index: 1;
      border-radius: 0.4rem;
    }
  `}
  /* Fix overflow clipping in Safari */
  /* https://gist.github.com/domske/b66047671c780a238b51c51ffde8d3a0 */
  transform: translateZ(0);
`;
const StyledIndicator = styled__default["default"]($67824d98245208a0$export$adb584737d712b70) `
  width: 100%;
  height: 100%;
  transition: transform 500ms cubic-bezier(0.65, 0, 0.35, 1);
  transform: ${({ value, max }) => `translateX(-${100 - (100 / max) * value}%)`};
  background: ${({ theme, value, status, progressColor }) => {
    if (progressColor) {
        return progressColor;
    }
    if (status && value > 0 && value < 100) {
        if (status === exports.StatusEnum.OVER_DUE) {
            return theme.colors.selectionBox.disabledText;
        }
        return theme.colors.info.main;
    }
    if (status && value === 100) {
        if (status === exports.StatusEnum.OVER_DUE) {
            return theme.colors.selectionBox.disabledText;
        }
        return theme.colors.success.main;
    }
    return theme.colors.info.main;
}};
`;
const StyledProgressBarThresholdText = styled__default["default"].div `
  position: absolute;
  left: ${({ threshold, max }) => (threshold ? `${(100 / max) * threshold}%` : 'auto')};
  top: 100%;
  transform: translateX(-50%);
  margin-top: 0.5rem;
  z-index: 2;
  white-space: nowrap;
  color: #9ca4b4;
  font-size: 1.4rem;
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: 400;
`;

const ProgressBar = ({ title = 'Progress Bar', value, height = 5, radius = 0, max = 100, status, threshold, thresholdText = '', progressColor, backgroundColor, }) => {
    const { theme } = React.useContext(SwitchThemeContext);
    const isDark = theme === 'dark';
    return (jsxRuntime.exports.jsxs(StyledProgressBar$1, { isDark: isDark, title: title, value: value, radius: radius, max: max, height: height, threshold: threshold, backgroundColor: backgroundColor, children: [jsxRuntime.exports.jsx(StyledIndicator, { value: value, max: max, status: status, progressColor: progressColor }), threshold ? (jsxRuntime.exports.jsx(StyledProgressBarThresholdText, { threshold: threshold, max: max, children: thresholdText })) : null] }));
};

const getProgressWidth = (steps, currentStep) => {
    if (currentStep > steps)
        return '100%';
    return `${(100 / (steps - 1)) * (currentStep - 1)}%`;
};
const getVariant = (step, currentStep) => {
    let variant = 'current';
    if (currentStep > step)
        variant = 'completed';
    if (currentStep < step)
        variant = 'incomplete';
    return variant;
};

const StepContainer = styled__default["default"].div `
  align-items: center;
  background: ${({ theme }) => theme.colors.background.grey};
  display: flex;
  height: 0.4rem;
  justify-content: space-between;
  position: relative;
  margin: 1rem 0;

  :before {
    content: '';
    background-color: ${({ theme }) => theme.colors.success.main};
    height: inherit;
    left: 0;
    position: absolute;
    width: ${({ progressWidth }) => progressWidth};
    z-index: 1;
  }
`;
const StyledStep = styled__default["default"].div `
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background.grey};
  border-radius: 10rem;
  color: ${({ theme }) => theme.colors.paragraph};
  display: flex;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  height: 2rem;
  justify-content: center;
  line-height: ${({ theme }) => theme.fonts.sizes.small};
  position: relative;
  transition: all 0.4s linear;
  width: 2rem;
  z-index: 2;

  &[data-variant='current'] {
    background-color: ${({ theme }) => theme.colors.info.main};
    color: ${({ theme }) => theme.colors.text.invert};
  }

  &[data-variant='completed'] {
    background-color: ${({ theme }) => theme.colors.success.main};
    color: ${({ theme }) => theme.colors.white};

    svg {
      color: ${({ theme }) => theme.colors.text.invert};
      height: 1.2rem;
      width: 1.2rem;
    }
  }
`;

const ProgressBarSteps = ({ steps, currentStep }) => {
    const stepsList = steps > 0 ? [...Array.from({ length: steps }).keys()] : [];
    const progressWidth = getProgressWidth(steps, currentStep);
    return (jsxRuntime.exports.jsx(StepContainer, { progressWidth: progressWidth, role: "progressbar", title: "progressbar", children: stepsList.map((index) => {
            const step = index + 1;
            const variant = getVariant(step, currentStep);
            return (jsxRuntime.exports.jsx(StyledStep, { "aria-label": "step", "data-variant": variant, children: currentStep > step ? jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCheck }) : step }, index));
        }) }));
};

const StyledRating = styled__default["default"].div `
  display: flex;
`;
const StyledRate = styled__default["default"].button `
  padding-right: 1.7rem;

  &:last-child {
    padding-right: 0;
  }

  &:hover:not([disabled]) {
    svg {
      transform: scale(1.2);
      path {
        fill: ${({ theme }) => theme.colors.warning.light};
        stroke: ${({ theme }) => theme.colors.warning.light};
      }
    }
  }

  &:disabled {
    cursor: not-allowed;
  }

  ${({ isDisabled }) => isDisabled &&
    `
    opacity: 0.5;
  `}

  svg {
    height: 3.4rem;
    stroke-width: 3rem;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    width: 3.4rem;
  }

  svg[data-icon='empty'] {
    path {
      fill: transparent;
      stroke: ${({ theme }) => theme.colors.text.lighter};
    }
  }

  svg[data-icon='filled'] {
    path {
      fill: ${({ theme }) => theme.colors.warning.light};
      stroke: ${({ theme }) => theme.colors.warning.light};
    }
  }
`;

const Rating = ({ rateName = 'rate-platform', max = 5, rate = 0, setRate, isReadOnly = false, isDisabled = false, }) => {
    const totalRating = [...Array.from({ length: max }).keys()];
    const [temporaryRate, setTemporaryRate] = React.useState(0);
    return (jsxRuntime.exports.jsxs(StyledRating, { children: [jsxRuntime.exports.jsx("input", { type: "hidden", name: rateName, value: rate }), totalRating.map((item) => {
                const newRate = item + 1;
                return (jsxRuntime.exports.jsx(StyledRate, { isDisabled: isDisabled, id: `${item}`, onClick: () => setRate(newRate), title: `Rate ${newRate} out of ${max}`, disabled: isReadOnly || isDisabled, onMouseEnter: () => setTemporaryRate(newRate), onMouseLeave: () => setTemporaryRate(0), children: temporaryRate > 0 ? (jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faStarSharp, "data-icon": temporaryRate >= newRate ? 'filled' : 'empty', "data-testid": "icon-rate" })) : (jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faStarSharp, "data-icon": rate >= newRate ? 'filled' : 'empty', "data-testid": "icon-rate" })) }, item));
            })] }));
};

const StyledCloseButton$4 = styled__default["default"].button `
  align-self: center;
  height: 1.3rem;
  flex-shrink: 0;
  position: relative;
  z-index: 1;

  svg {
    color: ${({ theme }) => theme.colors.text.main};
    height: 1.3rem;
    width: 1.3rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    align-self: start;
    padding-top: 0.5rem;
  }
`;

const CloseButton$1 = ({ closeToast }) => (jsxRuntime.exports.jsx(StyledCloseButton$4, { onClick: closeToast, "aria-label": "close-notification", children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faXmark$2 }) }));

const missionGradientOverlay = styled.css `
  &::after {
    content: '';
    background: linear-gradient(90deg, rgba(0, 255, 21, 0.1) 0%, rgba(0, 255, 21, 0.1) 5%, transparent 40%);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 0.5rem;
    z-index: -1;
  }
`;
const StyledAnimation = styled.css `
  .enter-animation {
    animation: fadeInUp 0.5s ease-in-out both;
  }

  .exit-animation {
    animation: slide-right 0.5s ease-out both;
  }

  @keyframes fadeInUp {
    0% {
      opacity: 0;
      transform: translateY(8rem);
    }

    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slide-right {
    0% {
      transform: translateX(0);
    }

    30% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateX(30rem);
    }
  }
`;
const StyledToastContainer = styled__default["default"](reactToastify.ToastContainer) `
  z-index: 2147483002;

  &&&.Toastify__toast-container {
    top: 1rem;
    right: 2rem;
    width: 48rem;

    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      width: auto;
      left: 1rem;
    }
  }
 

  .Toastify__toast {
    border: 1px solid ${({ theme }) => theme.colors.border.main};
    box-shadow: none;
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    min-height: 50px;
    margin: 1rem 0;
    padding: 1.6rem;
    line-height: 2rem;
    color: ${({ theme }) => theme.colors.text.main};
    width: inherit;
    display: flex;
    align-items: center;
    gap: 1.4rem;


    a {
      text-decoration: none;
      font-size: inherit;
      font-family: inherit;
      font-weight: inherit;
      line-height: inherit;
      vertical-align: baseline;
      display: inline;
    }

    > *:not(button):not(.Toastify__toast-icon):not(.Toastify__progress-bar--wrp) {
      flex: 1;
      min-width: 0;
    }
   h2, h3, h4 {
      font-size: ${({ theme }) => theme.fonts.sizes.default};
      align-self: self-start;
      margin: 0;
    }

    p {
      font-size: ${({ theme }) => theme.fonts.sizes.default};
      align-self: self-start;
      margin: 0;
    }
  }

  .Toastify__toast {
    background-color: ${({ theme }) => theme.colors.background.main};
    border: 1px solid ${({ theme }) => theme.colors.border.main};
    position: relative;
    z-index: 1;
    button {
      margin-left: auto;
      flex-shrink: 0;
      
      svg {
        color: ${({ theme }) => theme.colors.text.main};
      }
    }

    &-icon {
      margin-inline-end: 0;
      width: auto;

      @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
        align-self: start;
      }
    }

    &--success {
      background-color: ${({ theme }) => theme.colors.success.lighter};
      border: 1px solid ${({ theme }) => theme.colors.success.main};

      svg {
        color: ${({ theme }) => theme.colors.success.main};
      }
    }

    &--error {
      background-color: ${({ theme }) => theme.colors.error.lighter};
      border: 1px solid ${({ theme }) => theme.colors.error.main};

      svg {
        color: ${({ theme }) => theme.colors.error.main};
      }
    }

    &--info {
      background-color: ${({ theme }) => theme.colors.info.lighter};
      border: 1px solid ${({ theme }) => theme.colors.info.main};

      svg {
        color: ${({ theme }) => theme.colors.info.main};
      }
    }

    &--warning {
      background-color: ${({ theme }) => theme.colors.warning.lighter};
      border: 1px solid ${({ theme }) => theme.colors.warning.main};

      svg {
        color: ${({ theme }) => theme.colors.warning.main};
      }
    }
  
  }

 .weekly-mission-toast {
    background-color: ${({ theme }) => theme.colors.background.main};
    border: 1px solid ${({ theme }) => theme.colors.border.dark};
    position: relative;
    z-index: 1;
    h3 {
      font-size: ${({ theme }) => theme.fonts.sizes.default};
      margin-bottom: 0.5rem;
    }
    
    img {
      width: 6.8rem;
      height: 6.8rem;
    }
   
    ${missionGradientOverlay}
  }

  .mission-progress-toast,
  .mission-completed-toast {
    background-color: ${({ theme }) => theme.colors.background.main};
    border: 1px solid ${({ theme }) => theme.colors.border.dark};
    position: relative;
    z-index: 1;
    
    h3 {
      font-size: ${({ theme }) => theme.fonts.sizes.default};
      margin-bottom: 0.5rem;
    }
    
    .Toastify__toast-icon {
      width: 10rem;
    }
    
    img {
      width: 100%;
      height: auto;
    }
    
    ${missionGradientOverlay}
  }

  ${StyledAnimation}
`;
const StyledNotificationContent = styled__default["default"].div `
  align-items: center;
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 1.5rem;

  p,
  span {
    line-height: 2rem;
  }

  button {
    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      margin-top: 1rem;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: inline-block;
  }
`;

const StyledStreakNotification = styled__default["default"].article `
  display: flex;
  flex: 1;
  justify-content: flex-start;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.secondary.main};
`;
const StyledStreakContainer = styled__default["default"].div `
  display: flex;
  width: auto;
  height: 2.9rem;
  align-items: flex-end;
  margin-right: 0.4rem;
  color: ${({ theme }) => theme.colors.primary.main};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  line-height: 2.8rem;
  font-size: 2.4rem;
  white-space: nowrap;
`;
const StyledStreakIconContainer = styled__default["default"].div `
  display: flex;
  width: 2.1rem;
  height: 2.4rem;
  justify-content: flex-start;
  align-items: flex-end;
  margin-right: 1.6rem;
`;
const StyledStreakIcon = styled__default["default"](FontAwesomeIcon) `
  width: 2.1rem;
  height: 2.4rem;
  align-items: flex-end;
`;
const StyledMessageContainer = styled__default["default"].div `
  display: flex;
  width: auto;
  max-width: 19.8rem;
  justify-content: flex-start;
  margin: 1.2rem 0;
  color: ${({ theme }) => theme.colors.grey[100]};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 1.8rem;
`;
const ToastMessage = styled.css `
  position: fixed;
  right: 1rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: auto;
    max-width: 33rem;
    left: 1rem;
    margin: 0 auto;
  }
`;
const StyledStreakToastContainer = styled__default["default"](reactToastify.ToastContainer) `
  z-index: 2147483002;

  .Toastify__toast {
    margin-bottom: 1rem;
    background-color: ${({ theme }) => theme.colors.secondary.main};
    box-shadow: none;
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    padding: 0 1.2rem 0 1.6rem;
    color: ${({ theme }) => theme.colors.text.main};

    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      margin-bottom: 0;
    }
  }

  .Toastify__toast {
    button {
      opacity: 1;
      align-self: start;
    }

    button svg {
      color: ${({ theme }) => theme.colors.grey[200]};
      margin-top: 1.1rem;
      margin-left: 1.1rem;
    }

    &--success {
      background-color: ${({ theme }) => theme.colors.secondary.main};

      svg {
        color: ${({ theme }) => theme.colors.primary.main};
      }
    }
  }

  .toast-message-bottom-right {
    bottom: 0;
    ${ToastMessage}
  }

  .toast-message-top-right {
    top: 0;
    margin-top: 1rem;
    ${ToastMessage}
  }

  ${StyledAnimation}
`;

const StyledCloseButton$3 = styled__default["default"].button `
  align-self: start;
  height: 1.6rem;

  svg {
    color: ${({ theme }) => theme.colors.text.main};
    height: 1.6rem;
    width: 1.6rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    align-self: start;
    padding-top: 0.5rem;
  }
`;
const StyledThreatHuntingNotificationContainer = styled__default["default"](reactToastify.ToastContainer) `
  .Toastify__toast {
    padding: 1.8rem;
    display: flex;
    border-radius: ${({ theme }) => theme.radius.small};
    flex-direction: row;
    background: linear-gradient(350deg, rgb(28, 37, 56) 3.07%, rgb(28, 42, 48) 59.5%, rgb(36, 61, 51) 99%);
    width: 100%;
    margin-right: 1.8rem;
  }

  &.Toastify__toast-container {
    width: 41.4rem;
  }

  &.Toastify__toast-container--bottom-right {
    bottom: 4rem;
    right: 4rem;
  }

  ${StyledAnimation}
`;

const EaseInSlideOut = reactToastify.cssTransition({
    enter: 'enter-animation',
    exit: 'exit-animation',
});
const ToastNotificationContainer = () => (jsxRuntime.exports.jsx(StyledToastContainer, { containerId: "toast", rtl: false, hideProgressBar: true, pauseOnFocusLoss: true, autoClose: 6000, position: "top-right", closeOnClick: false, closeButton: CloseButton$1, transition: EaseInSlideOut, "aria-label": "Main notifications" }));
const StreakNotificationContainer = () => (jsxRuntime.exports.jsx(StyledStreakToastContainer, { containerId: "streak", rtl: false, hideProgressBar: true, pauseOnFocusLoss: true, autoClose: 6000, position: "bottom-right", closeOnClick: false, transition: EaseInSlideOut, icon: false, closeButton: CloseButton$1, "aria-label": "Streak notifications" }));
const CustomizedNotificationContainer = () => (jsxRuntime.exports.jsx(StyledThreatHuntingNotificationContainer, { containerId: "thsim", rtl: false, hideProgressBar: true, pauseOnFocusLoss: true, autoClose: 6000, position: "bottom-right", closeOnClick: false, closeButton: CloseButton$1, transition: EaseInSlideOut, "aria-label": "Threat hunting notifications" }));
const NotificationContainer = () => (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(ToastNotificationContainer, {}), jsxRuntime.exports.jsx(StreakNotificationContainer, {}), jsxRuntime.exports.jsx(CustomizedNotificationContainer, {})] }));

const NotificationDispatch = (type, children, icon) => {
    switch (type) {
        case 'success': {
            return reactToastify.toast.success(children, {
                icon: icon ? icon : jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCircleCheck$1, title: "success-icon" }),
                containerId: 'toast',
            });
        }
        case 'error': {
            return reactToastify.toast.error(children, {
                icon: icon ? icon : jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCircleExclamation, title: "error-icon" }),
                containerId: 'toast',
            });
        }
        case 'info': {
            return reactToastify.toast.info(children, {
                icon: icon ? icon : jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCircleInfo, title: "info-icon" }),
                containerId: 'toast',
            });
        }
        case 'warning': {
            return reactToastify.toast.warn(children, {
                icon: icon ? icon : jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faTriangleExclamation, title: "warning-icon" }),
                containerId: 'toast',
            });
        }
        default: {
            return reactToastify.toast.success(children, {
                icon: icon ? icon : jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCircleCheck$1, title: "success-icon" }),
                containerId: 'toast',
            });
        }
    }
};
const TempCustomNotificationDispatch = ({ options, children }) => {
    return reactToastify.toast(children, { ...options, containerId: 'toast' });
};

const StreakNotificationComponent = ({ streak, message }) => (jsxRuntime.exports.jsxs(StyledStreakNotification, { children: [streak && jsxRuntime.exports.jsx(StyledStreakContainer, { children: streak }), jsxRuntime.exports.jsx(StyledStreakIconContainer, { children: jsxRuntime.exports.jsx(StyledStreakIcon, { icon: faFire, title: "streak-icon" }) }), jsxRuntime.exports.jsx(StyledMessageContainer, { children: message })] }));
const StreakNotificationDispatch = (type, children, position = 'bottom-right') => {
    switch (type) {
        case 'success': {
            return reactToastify.toast.success(children, {
                icon: false,
                closeButton: CloseButton$1,
                containerId: 'streak',
                className: `toast-message-${position}`,
                position,
            });
        }
        default: {
            return reactToastify.toast(children, {
                icon: false,
                closeButton: CloseButton$1,
                containerId: 'streak',
                className: `toast-message-${position}`,
                position,
            });
        }
    }
};

const toasts = new Set();
const dismiss = () => {
    for (const alertToast of toasts) {
        toasts.delete(alertToast);
        reactToastify.toast.dismiss(alertToast.id);
        clearTimeout(alertToast.timeoutId);
    }
};
const AlertNotificationDispatch = (type, content) => {
    dismiss();
    const id = NotificationDispatch(type, content);
    const timeoutId = setTimeout(() => {
        dismiss();
    }, 2000);
    toasts.add({ id, timeoutId });
    return id;
};

const CloseButton = ({ closeToast }) => (jsxRuntime.exports.jsx(StyledCloseButton$3, { onClick: closeToast, "aria-label": "close-notification", children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faXmark$2 }) }));
const ThreatHuntingNotificationDispatch = (children, options) => {
    const { position = 'bottom-right' } = options || {};
    return reactToastify.toast(children, {
        ...options,
        hideProgressBar: true,
        className: `${position}`,
        autoClose: 4000,
        closeButton: CloseButton,
        containerId: 'thsim',
    });
};

const StyledThreatHuntingNotification = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  gap: 1.8rem;
  background: none;
  align-items: center;
`;
const StyledThreatHuntingNotificationLeft = styled__default["default"].div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledThreatHuntingNotificationRight = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  flex-grow: 1;
`;
const StyledThreatHuntingNotificationTitle = styled__default["default"].div `
  font-size: 1.6rem;
  line-height: 1.8rem;
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
`;
const StyledThreatHuntingNotificationDescription = styled__default["default"].div `
  font-size: 1.4rem;
  line-height: 1.6rem;
  color: ${({ theme }) => theme.colors.grey[400]};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
`;

const ThreatHuntingNotificationComponent = ({ icon, title, description, }) => (jsxRuntime.exports.jsxs(StyledThreatHuntingNotification, { children: [jsxRuntime.exports.jsx(StyledThreatHuntingNotificationLeft, { children: icon }), jsxRuntime.exports.jsxs(StyledThreatHuntingNotificationRight, { children: [jsxRuntime.exports.jsx(StyledThreatHuntingNotificationTitle, { children: title }), jsxRuntime.exports.jsx(StyledThreatHuntingNotificationDescription, { children: description })] })] }));

const ThNotificationIconCircles = (jsxRuntime.exports.jsxs("svg", { width: "86", height: "86", viewBox: "0 0 356 357", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntime.exports.jsx("rect", { x: "1.50958", y: "1.5086", width: "352.981", height: "353.013", rx: "176.491", stroke: "url(#paint0_linear_6940_17279)", strokeOpacity: "0.7", strokeWidth: "3.0172" }), jsxRuntime.exports.jsx("circle", { cx: "178", cy: "178.015", r: "107.849", stroke: "url(#paint1_linear_6940_17279)", strokeOpacity: "0.7", strokeWidth: "4.5258" }), jsxRuntime.exports.jsx("circle", { cx: "177.783", cy: "178.015", r: "54.0503", fill: "#A3EA2A", fillOpacity: "0.1", stroke: "url(#paint2_linear_6940_17279)", strokeWidth: "4.5258" }), jsxRuntime.exports.jsx("path", { d: "M198.733 162.789C199.671 163.727 199.671 165.134 198.733 165.978L173.972 190.738C173.128 191.676 171.721 191.676 170.877 190.738L158.122 177.983C157.184 177.139 157.184 175.732 158.122 174.794C158.966 173.95 160.373 173.95 161.217 174.794L172.472 186.049L195.638 162.789C196.482 161.945 197.889 161.945 198.733 162.789Z", fill: "#A3EA2A" }), jsxRuntime.exports.jsxs("defs", { children: [jsxRuntime.exports.jsxs("linearGradient", { id: "paint0_linear_6940_17279", x1: "178.016", y1: "-16.5946", x2: "178.016", y2: "356.03", gradientUnits: "userSpaceOnUse", children: [jsxRuntime.exports.jsx("stop", { stopColor: "#C2F270" }), jsxRuntime.exports.jsx("stop", { offset: "0.15", stopColor: "#A3EA2A" }), jsxRuntime.exports.jsx("stop", { offset: "0.842487", stopColor: "#5B8223", stopOpacity: "0" })] }), jsxRuntime.exports.jsxs("linearGradient", { id: "paint1_linear_6940_17279", x1: "178.016", y1: "57.3268", x2: "178.016", y2: "293.423", gradientUnits: "userSpaceOnUse", children: [jsxRuntime.exports.jsx("stop", { stopColor: "#A3EA2A" }), jsxRuntime.exports.jsx("stop", { offset: "0.922355", stopColor: "#5B8223", stopOpacity: "0" })] }), jsxRuntime.exports.jsxs("linearGradient", { id: "paint2_linear_6940_17279", x1: "177.783", y1: "126.916", x2: "177.783", y2: "234.328", gradientUnits: "userSpaceOnUse", children: [jsxRuntime.exports.jsx("stop", { stopColor: "#A3EA2A" }), jsxRuntime.exports.jsx("stop", { offset: "1", stopColor: "#5B8223" })] })] })] }));

const StyledVoteButton = styled__default["default"](Button$1) `
  svg {
    height: 1.6rem;
    width: 1.6rem;
  }
  svg[data-icon='empty'] {
    path {
      fill: ${darkColors.grey[400]};
    }
  }
  svg[data-icon='filled'] {
    path {
      fill: ${darkColors.primary.main};
    }
  }
  span {
    color: ${darkColors.text.main};
  }
  &:hover {
    span {
      color: ${darkColors.black};
    }
    svg[data-icon='empty'] {
      path {
        fill: ${darkColors.black};
      }
    }
  }
  &:disabled {
    background-color: ${darkColors.grey[400]};
    border-color: ${darkColors.grey[400]};
    span {
      color: ${darkColors.grey[600]};
    }
    svg {
      path {
        color: ${darkColors.grey[600]};
      }
    }
    svg[data-icon='filled'] {
      path {
        fill: ${darkColors.grey[600]};
      }
  }
  }
  border-color: ${darkColors.border.light};
`;
const StyledVoteCounter = styled__default["default"].span `
  margin: 0.8rem 0;
  line-height: 2rem;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
`;

const RecommendButton = ({ onChange, votesCount = 0, userVote = 0, isAuth }) => {
    const [isRecommendedByUser, setIsRecommendedByUser] = React.useState(userVote);
    React.useEffect(() => {
        setIsRecommendedByUser(userVote);
    }, [userVote]);
    const toggleRecommend = () => {
        if (isAuth === false) {
            NotificationDispatch('error', 'Uh-oh! Please log in');
            return;
        }
        setIsRecommendedByUser(isRecommendedByUser === 1 ? 0 : 1);
        onChange(isRecommendedByUser !== 1);
    };
    return (jsxRuntime.exports.jsxs(StyledVoteButton, { "data-testid": "recommend-button", variant: "outlined", color: "secondary", onClick: () => toggleRecommend(), "aria-label": "vote-up", children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: isRecommendedByUser === 1 ? faThumbsUp : faThumbsUp$1, "data-icon": isRecommendedByUser === 1 ? 'filled' : 'empty', "data-testid": "vote-up" }), jsxRuntime.exports.jsxs(StyledVoteCounter, { children: [votesCount > 0 ? votesCount : '', " Recommend"] })] }));
};

const StyledRedeemTicketButtonWrapper = styled__default["default"].div `
  display: flex;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 0.5rem;
  width: 90%;
  align-items: center;
  justify-content: center;
`;
const StyledRedeemTicketButton = styled__default["default"](Button$1) `
  border: 0.2rem solid;
  width: 100%;

  &[data-ticket='cybercrusader-title'] {
    border-color: ${lightColors.warning.main};
    background-color: ${lightColors.warning.main.replace('1)', '0.2)')};

    &:hover {
      background-color: ${lightColors.warning.main.replace('1)', '0.2)')};
    }
  }

  &[data-ticket='streak-freeze-1'] {
    border-color: ${darkColors.info.main};
    background-color: ${darkColors.info.main.replace('1)', '0.2)')};

    &:hover {
      background-color: ${darkColors.info.main.replace('1)', '0.2)')};
    }
  }

  &[data-ticket='20-swag-voucher'] {
    border-color: ${darkColors.success.main};
    background-color: ${darkColors.success.main.replace('1)', '0.2)')};

    &:hover {
      background-color: ${darkColors.success.main.replace('1)', '0.2)')};
    }
  }

  &[data-ticket='tryhackme-tshirt'] {
    border-color: ${lightColors.success.main};
    background-color: ${lightColors.success.main.replace('1)', '0.2)')};

    &:hover {
      background-color: ${lightColors.success.main.replace('1)', '0.2)')};
    }
  }

  &[data-ticket='tryhackme-hat'] {
    border-color: ${lightColors.info.main};
    background-color: ${lightColors.info.main.replace('1)', '0.2)')};

    &:hover {
      background-color: ${lightColors.info.main.replace('1)', '0.2)')};
    }
  }

  &[data-ticket='streak-freeze-7'] {
    border-color: ${lightColors.error.main};
    background-color: ${lightColors.error.main.replace('1)', '0.2)')};

    &:hover {
      background-color: ${lightColors.error.main.replace('1)', '0.2)')};
    }
  }

  &[data-ticket='1-month-premium-voucher'] {
    border-color: ${darkColors.error.main};
    background-color: ${darkColors.error.main.replace('1)', '0.2)')};

    &:hover {
      background-color: ${darkColors.error.main.replace('1)', '0.2)')};
    }
  }

  &[data-ticket='10-swag-voucher'] {
    border-color: ${darkColors.warning.main};
    background-color: ${darkColors.warning.main.replace('1)', '0.2)')};

    &:hover {
      background-color: ${darkColors.warning.main.replace('1)', '0.2)')};
    }
  }

  &[data-ticket='50-amazon-voucher'] {
    border-color: ${lightColors.purple.light};
    background-color: ${lightColors.purple.light.replace('1)', '0.2)')};

    &:hover {
      background-color: ${lightColors.purple.light.replace('1)', '0.2)')};
    }
  }

  &[data-ticket='12-month-premium-voucher'] {
    border-color: ${lightColors.purple.main};
    background-color: ${lightColors.purple.main.replace('1)', '0.2)')};

    &:hover {
      background-color: ${lightColors.purple.main.replace('1)', '0.2)')};
    }
  }

  &[data-ticket='laptop'] {
    border-color: ${({ theme }) => theme.colors.grey[400]};
    background-color: ${({ theme }) => theme.colors.grey[400].replace('1)', '0.2)')};

    &:hover {
      background-color: ${({ theme }) => theme.colors.grey[400].replace('1)', '0.2)')};
    }
  }

  &[data-ticket='defcon'] {
    border-color: ${({ theme }) => theme.colors.grey[800]};
    background-color: ${({ theme }) => theme.colors.grey[800].replace('1)', '0.2)')};

    &:hover {
      background-color: ${({ theme }) => theme.colors.grey[800].replace('1)', '0.2)')};
    }
  }

  &[data-ticket='redeem'] {
    border-color: ${({ theme }) => theme.colors.info.main};
    background-color: ${({ theme }) => theme.colors.info.main};
    color: ${({ theme }) => theme.colors.white};

    &:hover {
      background-color: ${({ theme }) => theme.colors.info.main};
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;

const RedeemTicketButton = ({ name, isRedeemed, onClick }) => (jsxRuntime.exports.jsx(StyledRedeemTicketButtonWrapper, { children: jsxRuntime.exports.jsx(StyledRedeemTicketButton, { onClick: onClick, "data-ticket": isRedeemed ? name : 'redeem', children: isRedeemed ? 'Prize redeemed' : 'Redeem prize' }) }));

const StyledRoomProgressBarContainer = styled__default["default"].div `
  position: sticky;
  top: 0;
  z-index: 2;
  background: linear-gradient(
    271.24deg,
    ${({ theme }) => theme.colors.roomProgressBar.first} 36.75%,
    ${({ theme }) => theme.colors.roomProgressBar.second} 69.21%,
    ${({ theme }) => theme.colors.roomProgressBar.third} 93.01%
  );
`;
const StyledRoomProgressBar = styled__default["default"]($67824d98245208a0$export$be92b6f5f03c0fe9) `
  height: 1.6rem;
  background-color: ${({ theme, value }) => (value === 100 ? theme.colors.primary.main : theme.colors.info.secondary)};
  width: ${(props) => props.value}%;
`;
const StyledRoomProgressBarValue = styled__default["default"]($67824d98245208a0$export$adb584737d712b70) `
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -55%);
  color: ${({ theme, value }) => (value === 100 ? theme.colors.black : theme.colors.grey[100])};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  line-height: 1.5rem;
`;

const RoomProgressBar = ({ value }) => {
    const percentage = `Room ${value === 100 ? 'completed' : 'progress'} ( ${value}% )`;
    return (jsxRuntime.exports.jsx(StyledRoomProgressBarContainer, { children: jsxRuntime.exports.jsx(StyledRoomProgressBar, { "aria-label": percentage, width: percentage, value: value, children: jsxRuntime.exports.jsx(StyledRoomProgressBarValue, { value: value, children: percentage }) }) }));
};

const SelectWrapper = styled__default["default"].div `
  position: relative;
  width: fit-content;
`;
const SelectButton = styled__default["default"](Button$1) `
  width: 3.2rem;
  height: 2.8rem;
  border-color: ${({ $isDarkVersion }) => $isDarkVersion && darkColors.button.secondary.border};

  ${({ $isOpen, theme, $isDarkVersion }) => $isOpen &&
    `
    background-color: ${$isDarkVersion ? darkColors.button.secondary.hover : theme.colors.button.secondary.hover};
    color: ${theme.colors.black};
  `}

  &:focus {
    outline: none;
    background-color: ${({ theme, $isDarkVersion }) => $isDarkVersion ? darkColors.button.secondary.hover : theme.colors.button.secondary.hover};
    color: ${({ theme }) => theme.colors.black};
    ${({ $isOpen, theme, $isDarkVersion }) => $isOpen &&
    `
    background-color: ${$isDarkVersion ? darkColors.button.secondary.hover : theme.colors.button.secondary.hover};
    color: ${theme.colors.black};
  `}
  }
  &:hover svg,
  &:focus svg {
    color: ${({ theme }) => theme.colors.black};
  }
`;
const StyledSelectDropdown = styled__default["default"].div `
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
  position: absolute;
  top: calc(100% + 0.5rem);
  ${({ $position }) => ($position === 'right' ? 'right: 0;' : 'left: 0;')}
  width: max-content;
  max-height: 30rem;
  overflow-y: auto;
  background-color: ${({ theme, $isDarkVersion }) => $isDarkVersion ? darkColors.background.select : theme.colors.background.select};
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: ${({ theme, $isDarkVersion }) => $isDarkVersion ? '0 2px 10px 2px rgba(21, 28, 43,0.6)' : theme.boxShadow.main};
  z-index: 10;
`;
const StyledOptionsList = styled__default["default"].ul `
  list-style-type: none;
  padding: 0.8rem 1rem;
  margin: 0;
`;
const StyledOptionItem = styled__default["default"].li `
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 2rem 0.5rem 1rem;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? darkColors.text.main : theme.colors.text.main)};
  border-radius: ${({ theme }) => theme.radius.small};
  line-height: 2.4rem;

  &:hover {
    background-color: ${({ theme, $isDarkVersion }) => $isDarkVersion ? darkColors.formSelect.optionHover : theme.colors.formSelect.optionHover};
  }
`;
const StyledOptionIcon = styled__default["default"].span `
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  width: 1.6rem;
  color: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? darkColors.text.main : theme.colors.text.main)};
`;
const StyledCheckIcon$2 = styled__default["default"](FontAwesomeIcon) `
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.primary.main};
  width: 1.6rem;
`;

const SimpleSelect = ({ options, value, onChange, isDisabled = false, className, icon, position = 'right', isDarkVersion, }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const wrapperRef = React.useRef(null);
    const selectedValue = value || options[0];
    const handleClose = React.useCallback(() => {
        setIsOpen(false);
    }, []);
    useOnClickOutside({ ref: wrapperRef, handler: handleClose });
    React.useEffect(() => {
        const closeOnEscapeKey = (e) => {
            if (e.key === 'Escape') {
                handleClose();
            }
        };
        document.body.addEventListener('keydown', closeOnEscapeKey);
        return () => {
            document.body.removeEventListener('keydown', closeOnEscapeKey);
        };
    }, [handleClose]);
    const handleToggle = () => {
        if (!isDisabled) {
            setIsOpen(!isOpen);
        }
    };
    const handleSelect = (option) => {
        onChange(option);
        setIsOpen(false);
    };
    return (jsxRuntime.exports.jsxs(SelectWrapper, { ref: wrapperRef, className: className, "data-testid": "simple-select", children: [jsxRuntime.exports.jsx(SelectButton, { onClick: handleToggle, "$isOpen": isOpen, "$isDisabled": isDisabled, disabled: isDisabled, "aria-haspopup": "listbox", "aria-expanded": isOpen, color: "secondary", variant: "outlined", "$isDarkVersion": isDarkVersion, children: jsxRuntime.exports.jsx(StyledOptionIcon, { "data-testid": "simple-select-icon", "$isDarkVersion": isDarkVersion, children: icon ?? jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faBars }) }) }), jsxRuntime.exports.jsx(StyledSelectDropdown, { "$isOpen": isOpen, "$position": position, "$isDarkVersion": isDarkVersion, "data-testid": "select-options", children: jsxRuntime.exports.jsx(StyledOptionsList, { children: options.map((option) => (jsxRuntime.exports.jsxs(StyledOptionItem, { onClick: () => handleSelect(option), "$isSelected": selectedValue?.value === option.value, "aria-selected": selectedValue?.value === option.value, "$isDarkVersion": isDarkVersion, children: [selectedValue?.value === option.value ? jsxRuntime.exports.jsx(StyledCheckIcon$2, { icon: faCheck }) : jsxRuntime.exports.jsx(StyledOptionIcon, {}), option.label] }, option.value))) }) })] }));
};

var MitreStatusEnum;
(function (MitreStatusEnum) {
    MitreStatusEnum["ALL_COMPLETED"] = "All completed";
    MitreStatusEnum["HIGH_COMPLETION"] = "High completion";
    MitreStatusEnum["LOW_COMPLETION"] = "Low completion";
    MitreStatusEnum["NOT_STARTED"] = "Not started";
    MitreStatusEnum["NOT_TAGGED"] = "Not tagged";
})(MitreStatusEnum || (MitreStatusEnum = {}));

const getMitreStatusDetails = ({ percentage, isNotTagged, }) => {
    if (isNotTagged) {
        return { status: MitreStatusEnum.NOT_TAGGED, icon: faBan, text: MitreStatusEnum.NOT_TAGGED };
    }
    if (percentage === 100) {
        return { status: MitreStatusEnum.ALL_COMPLETED, icon: faCheckCircle, text: `${percentage.toString()}%` };
    }
    if (percentage >= 40) {
        return { status: MitreStatusEnum.HIGH_COMPLETION, icon: faCircleHalfStroke, text: `${percentage.toString()}%` };
    }
    if (percentage > 0) {
        return { status: MitreStatusEnum.LOW_COMPLETION, icon: faCircleHalfStroke, text: `${percentage.toString()}%` };
    }
    if (percentage <= 0) {
        return { status: MitreStatusEnum.NOT_STARTED, icon: faCircle$1, text: MitreStatusEnum.NOT_STARTED };
    }
    return { status: MitreStatusEnum.NOT_TAGGED, icon: faCircleSmall, text: MitreStatusEnum.NOT_TAGGED };
};
const getMitreStatusCardColor = ($status, $isDark) => {
    const lightStatusTagColors = {
        [MitreStatusEnum.ALL_COMPLETED]: lighterVariations.success.lighter,
        [MitreStatusEnum.HIGH_COMPLETION]: lighterVariations.blue.light,
        [MitreStatusEnum.LOW_COMPLETION]: lighterVariations.warning.lighter,
        [MitreStatusEnum.NOT_STARTED]: secondaryColors.white,
        [MitreStatusEnum.NOT_TAGGED]: secondaryColors.grey[300],
    };
    const darkStatusTagColors = {
        [MitreStatusEnum.ALL_COMPLETED]: lighterVariations.success.dark,
        [MitreStatusEnum.HIGH_COMPLETION]: lighterVariations.blue.darker,
        [MitreStatusEnum.LOW_COMPLETION]: lighterVariations.warning.dark,
        [MitreStatusEnum.NOT_STARTED]: secondaryColors.secondary.main,
        [MitreStatusEnum.NOT_TAGGED]: secondaryColors.secondary.lighter,
    };
    return $isDark ? darkStatusTagColors[$status] : lightStatusTagColors[$status];
};
const getMitreStatusTagColor = ($status, $isDark) => {
    const lightStatusTagColors = {
        [MitreStatusEnum.ALL_COMPLETED]: secondaryColors.grey[100],
        [MitreStatusEnum.HIGH_COMPLETION]: secondaryColors.grey[100],
        [MitreStatusEnum.LOW_COMPLETION]: secondaryColors.grey[100],
        [MitreStatusEnum.NOT_STARTED]: secondaryColors.black,
        [MitreStatusEnum.NOT_TAGGED]: secondaryColors.black,
    };
    const darkStatusTagColors = {
        [MitreStatusEnum.ALL_COMPLETED]: secondaryColors.black,
        [MitreStatusEnum.HIGH_COMPLETION]: secondaryColors.black,
        [MitreStatusEnum.LOW_COMPLETION]: secondaryColors.black,
        [MitreStatusEnum.NOT_STARTED]: secondaryColors.grey[100],
        [MitreStatusEnum.NOT_TAGGED]: secondaryColors.grey[100],
    };
    return $isDark ? darkStatusTagColors[$status] : lightStatusTagColors[$status];
};
const getMitreStatusTagBackground = ($status, $isDark) => {
    const lightStatusTagColors = {
        [MitreStatusEnum.ALL_COMPLETED]: accentColors.success.light,
        [MitreStatusEnum.HIGH_COMPLETION]: accentColors.info.light,
        [MitreStatusEnum.LOW_COMPLETION]: accentColors.warning.lighter,
        [MitreStatusEnum.NOT_STARTED]: secondaryColors.grey[200],
        [MitreStatusEnum.NOT_TAGGED]: secondaryColors.grey[400],
    };
    const darkStatusTagColors = {
        [MitreStatusEnum.ALL_COMPLETED]: accentColors.success.dark,
        [MitreStatusEnum.HIGH_COMPLETION]: accentColors.info.dark,
        [MitreStatusEnum.LOW_COMPLETION]: accentColors.warning.dark,
        [MitreStatusEnum.NOT_STARTED]: secondaryColors.grey[900],
        [MitreStatusEnum.NOT_TAGGED]: secondaryColors.grey[900],
    };
    return $isDark ? darkStatusTagColors[$status] : lightStatusTagColors[$status];
};
const getMitreStatusItemColor = ($status, $isDark) => {
    const lightStatusTagColors = {
        [MitreStatusEnum.ALL_COMPLETED]: accentColors.success.light,
        [MitreStatusEnum.HIGH_COMPLETION]: accentColors.info.light,
        [MitreStatusEnum.LOW_COMPLETION]: accentColors.warning.lighter,
        [MitreStatusEnum.NOT_STARTED]: secondaryColors.grey[600],
        [MitreStatusEnum.NOT_TAGGED]: secondaryColors.grey[800],
    };
    const darkStatusTagColors = {
        [MitreStatusEnum.ALL_COMPLETED]: accentColors.success.dark,
        [MitreStatusEnum.HIGH_COMPLETION]: accentColors.info.dark,
        [MitreStatusEnum.LOW_COMPLETION]: accentColors.warning.dark,
        [MitreStatusEnum.NOT_STARTED]: secondaryColors.grey[400],
        [MitreStatusEnum.NOT_TAGGED]: secondaryColors.grey[600],
    };
    return $isDark ? darkStatusTagColors[$status] : lightStatusTagColors[$status];
};

const StyledHiddenParagraph = styled__default["default"].p `
  display: none;
`;

const StyledAppearAnimation$1 = styled.css `
  @keyframes appear {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const StyledLoadingPlaceholder = styled.css `
  animation: placeHolder 4s linear infinite;
  background: linear-gradient(
    to right,
    ${({ theme }) => theme.colors.loading.primary},
    ${({ theme }) => theme.colors.loading.secondary},
    ${({ theme }) => theme.colors.loading.primary}
  );
  border-radius: ${({ theme }) => theme.radius.small};

  @keyframes placeHolder {
    0% {
      background-position: -1000px 0;
    }
    100% {
      background-position: 0 0;
    }
  }
`;

const StyledTopToDown = styled.css `
  animation: ease-in-down 0.2s ease-in-out;

  @keyframes ease-in-down {
    0% {
      transform: translateY(-30px);
    }
    90% {
      transform: translateY(10px);
    }
    100% {
      transform: translateY(0);
    }
  }
`;

const fadeIn$1 = styled.keyframes `
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const fadeOut$1 = styled.keyframes `
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
const StyledDialogOver = styled.css `
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background.overlay};
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
`;
const StyledDialogAnimation = styled.css `
  &[data-state='open'] {
    animation: ${fadeIn$1} 150ms ease-out;
  }

  &[data-state='closed'] {
    animation: ${fadeOut$1} 150ms ease-out;
  }
`;
const StyledCloseButton$2 = styled.css `
  svg {
    color: ${({ theme }) => theme.colors.text.lighter};
    display: block;
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.info.main};
  }
`;
const contentShow = styled.keyframes `
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

exports.CardTypeEnum = void 0;
(function (CardTypeEnum) {
    CardTypeEnum["ROOM"] = "room";
    CardTypeEnum["MODULE"] = "module";
    CardTypeEnum["NETWORK"] = "network";
    CardTypeEnum["PATH"] = "path";
    CardTypeEnum["SOC_SIM"] = "soc-sim";
    CardTypeEnum["THREAT_HUNTING"] = "threat-hunting";
})(exports.CardTypeEnum || (exports.CardTypeEnum = {}));

const StyledCheckIcon$1 = styled__default["default"](FontAwesomeIcon) `
  color: ${({ $cardType, theme }) => $cardType === exports.CardTypeEnum.MODULE || exports.CardTypeEnum.PATH ? darkColors.success.main : theme.colors.success.main};
  height: ${({ $size }) => ($size ? `${$size}px` : '2.4rem')};
  width: ${({ $size }) => ($size ? `${$size}px` : '2.4rem')};
`;
const StyledNewTag = styled__default["default"].span `
  align-items: center;
  background-color: ${lightColors.error.lighter};
  border-radius: ${({ theme }) => theme.radius.big};
  color: ${({ theme }) => theme.colors.error.main};
  display: flex;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: 1.2rem;
  height: 1.8rem;
  line-height: 1.2rem;
  padding: 0 1rem;
  text-transform: uppercase;
`;
const StyledTime = styled__default["default"].div `
  align-items: center;
  display: flex;
  gap: 0.6rem;

  p {
    font-size: 1.4rem;
    line-height: 2rem;
  }

  svg {
    height: 1.4rem;
    width: 1.4rem;
  }
`;

exports.RoomType = void 0;
(function (RoomType) {
    RoomType["Challenge"] = "challenge";
    RoomType["Walkthrough"] = "walkthrough";
    RoomType["Network"] = "network";
})(exports.RoomType || (exports.RoomType = {}));

exports.Sender = void 0;
(function (Sender) {
    Sender["USER"] = "user";
    Sender["SYSTEM"] = "system";
    Sender["LLM"] = "llm";
    Sender["NUDGE"] = "nudge";
})(exports.Sender || (exports.Sender = {}));

const StyledFlexColumnCenter = styled.css `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const StyledWrapper$6 = styled__default["default"].div `
  ${StyledFlexColumnCenter};
  gap: 0.4rem;
  width: 17.5rem;
`;
const StyledTimelineContainerCommons = styled.css `
  overflow-y: scroll;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
`;
const StyledImageWrapper$3 = styled__default["default"].div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ isSelected }) => (isSelected ? '12.9rem' : '9rem')};
  height: ${({ isSelected }) => (isSelected ? '12.9rem' : '9rem')};
  border-radius: 50%;
  border: 0.3rem solid ${({ theme, isSelected }) => (isSelected ? theme.colors.primary.main : theme.colors.border.main)};
`;

const useTimeline = ({ timelineData, onChange, containerRef }) => {
    const [selectedItemIndex, setSelectedItemIndex] = React.useState(0);
    const scrollToSelectedElement = (index) => {
        if (containerRef.current) {
            const selectedElement = containerRef.current.children[index];
            if (selectedElement) {
                const containerRect = containerRef.current.getBoundingClientRect();
                const selectedElementRect = selectedElement.getBoundingClientRect();
                let offset = selectedElementRect.top - containerRect.top;
                if (offset > 0) {
                    offset -= 30;
                }
                containerRef.current.scrollTo({ top: containerRef.current.scrollTop + offset, behavior: 'smooth' });
            }
        }
    };
    const handleOnElementClick = (index) => {
        setSelectedItemIndex(index);
        scrollToSelectedElement(index);
        if (onChange) {
            onChange(index);
        }
    };
    const handleNavigationButtonClick = (indexChange) => {
        const newIndex = selectedItemIndex + indexChange;
        if (newIndex >= 0 && newIndex < timelineData.length) {
            setSelectedItemIndex(newIndex);
            scrollToSelectedElement(newIndex);
        }
        if (onChange) {
            onChange(newIndex);
        }
    };
    return {
        selectedItemIndex,
        handleOnElementClick,
        handleNavigationButtonClick,
    };
};

const StyledCardTitle = styled.css `
  color: ${({ theme }) => theme.colors.text.main};
  display: -webkit-box;
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  line-height: 2.3rem;
`;
const StyledCardDescription = styled.css `
  color: ${({ theme }) => theme.colors.paragraph};
  display: -webkit-box;
  line-height: 2rem;
  overflow: hidden;
  -webkit-box-orient: vertical;
`;

const commonMitreCardStyles = styled.css `
  width: 100%;
  min-width: calc(25% - 12px);
  border-radius: ${({ theme }) => `${theme.radius.small}`};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
`;
const StyledMitreCard = styled__default["default"].div `
  ${commonMitreCardStyles};
  display: flex;
  flex-direction: column;
  min-height: 10.6rem;
  overflow: hidden;
  color: ${({ $isDark }) => ($isDark ? secondaryColors.grey[100] : secondaryColors.black)};
  background: ${({ $status, $isDark }) => getMitreStatusCardColor($status, $isDark)};
`;
const StyledMitreCardLoader = styled__default["default"].div `
  ${StyledLoadingPlaceholder};
  ${commonMitreCardStyles};
  height: 10.6rem;
`;
const StyledMitreContentContainer = styled__default["default"].div `
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.6rem;
`;
const StyledMitreStatusIcon = styled__default["default"](FontAwesomeIcon) `
  flex-shrink: 0;
  width: 1.6rem;
  height: 1.6rem;
  margin-top: 0.2rem;
  color: ${({ $status, $isDark }) => getMitreStatusItemColor($status, $isDark)};
`;
const StyledMitreName = styled__default["default"].p `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: normal;
  flex-grow: 1;
  word-break: break-word;
`;
const StyledMitreTag = styled__default["default"].div `
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  flex-shrink: 0;
  height: 1.9rem;
  margin-top: 0.1rem;
  margin-left: auto;
  padding: 0 0.6rem;
  color: ${({ $status, $isDark }) => getMitreStatusTagColor($status, $isDark)};
  background: ${({ $status, $isDark }) => getMitreStatusTagBackground($status, $isDark)};
  border-radius: 0.2rem;
`;
const StyledViewDetailsButton = styled__default["default"](Button$1) `
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  gap: 0.2rem;
  width: fit-content;
  color: ${({ $isDark }) => ($isDark ? accentColors.info.dark : accentColors.info.light)};
  margin-top: 0.6rem;
`;

const StyledStatusTag = styled__default["default"].span `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: fit-content;
  height: 3rem;
  padding: 1rem;
  border-radius: ${({ theme }) => theme.radius.huge};
  color: ${({ $isDark }) => ($isDark ? secondaryColors.grey[100] : secondaryColors.black)};
  background-color: ${({ $status, $isDark }) => {
    const lightStatusTagColors = {
        [MitreStatusEnum.ALL_COMPLETED]: lighterVariations.success.lighter,
        [MitreStatusEnum.HIGH_COMPLETION]: lighterVariations.blue.light,
        [MitreStatusEnum.LOW_COMPLETION]: lighterVariations.warning.lighter,
        [MitreStatusEnum.NOT_STARTED]: secondaryColors.grey[200],
        [MitreStatusEnum.NOT_TAGGED]: secondaryColors.grey[400],
    };
    const darkStatusTagColors = {
        [MitreStatusEnum.ALL_COMPLETED]: lighterVariations.success.dark,
        [MitreStatusEnum.HIGH_COMPLETION]: lighterVariations.blue.darker,
        [MitreStatusEnum.LOW_COMPLETION]: lighterVariations.warning.dark,
        [MitreStatusEnum.NOT_STARTED]: secondaryColors.grey[800],
        [MitreStatusEnum.NOT_TAGGED]: secondaryColors.secondary.lighter,
    };
    return $isDark ? darkStatusTagColors[$status] : lightStatusTagColors[$status];
}};
`;

const StatusTag = ({ percentage = 0, isNotTagged = false }) => {
    const { theme } = React.useContext(SwitchThemeContext);
    const isDark = theme === 'dark';
    const { status, icon, text } = getMitreStatusDetails({ percentage, isNotTagged });
    return (jsxRuntime.exports.jsxs(StyledStatusTag, { "$status": status, "$isDark": isDark, children: [jsxRuntime.exports.jsx(StyledMitreStatusIcon, { "$status": status, "$isDark": isDark, icon: icon, "data-testid": "status-icon" }), jsxRuntime.exports.jsx("span", { children: text })] }));
};

const StyledSwitchGroup = styled__default["default"].div `
  border-radius: ${({ theme }) => theme.radius.small};
  display: inline-flex;
`;
const StyledSwitchButton = styled__default["default"](StyledButton$3) `
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  background: ${({ theme }) => theme.colors.background.light};
  border: 1px solid ${({ theme, color = 'primary' }) => color === 'info' ? theme.colors.statusTag.grey.background : theme.colors.primary.main};
  border-radius: 0;
  color: ${({ theme }) => theme.colors.text.main};
  margin-left: -1px;

  &[aria-pressed='true'],
  &:hover&[aria-pressed='true'] {
    background: ${({ theme, color = 'primary' }) => color === 'info' ? lightColors.info.main : theme.colors.primary.main};
    color: ${({ theme, color = 'primary' }) => (color === 'info' ? theme.colors.white : theme.colors.secondary.main)};
  }   

  &:hover&[aria-pressed='true'] {
    cursor: not-allowed;
  }

  &:last-child {
    border-radius: 0 ${({ theme }) => theme.radius.small} ${({ theme }) => theme.radius.small} 0;
  }
  &:first-child {
    border-radius: ${({ theme }) => theme.radius.small} 0 0 ${({ theme }) => theme.radius.small};
    margin-left: 0;
  }

  &:hover:not(:disabled),
  &:focus-visible {
    background-color: ${({ theme, color = 'primary' }) => color === 'info' ? theme.colors.info.lighter : theme.colors.primary.lighter};
    color: ${({ theme }) => theme.colors.text.main};
  }
`;
const StyledArrow$1 = styled__default["default"](FontAwesomeIcon) `
  margin: 0;
  width: 0.6rem;
  transform: scale(1.5);
`;

const Switch = ({ options, onClick, currentOption, maxOptions = 0, color = 'primary', }) => {
    const [offset, setOffset] = React.useState(0);
    const arrowsVisisble = Boolean(maxOptions && options.length > maxOptions);
    return (jsxRuntime.exports.jsxs(StyledSwitchGroup, { children: [arrowsVisisble && (jsxRuntime.exports.jsx(StyledSwitchButton, { "aria-pressed": false, size: "default", variant: "solid", color: color, onClick: () => {
                    setOffset((p) => {
                        if (p < maxOptions) {
                            return 0;
                        }
                        return p - maxOptions;
                    });
                }, disabled: !offset, "aria-label": "prev", children: jsxRuntime.exports.jsx(StyledArrow$1, { icon: faChevronLeft$1 }) }, "prev")), options.slice(offset, offset + maxOptions || options.length).map((option) => (jsxRuntime.exports.jsx(StyledSwitchButton, { "aria-pressed": option.id === currentOption, size: "default", variant: "solid", color: color, onClick: () => onClick(option.id), children: option.value }, option.id))), arrowsVisisble && (jsxRuntime.exports.jsx(StyledSwitchButton, { "aria-label": "next", "aria-pressed": false, size: "default", variant: "solid", color: color, onClick: () => {
                    setOffset((p) => {
                        if (options.length - (offset + maxOptions) < maxOptions) {
                            return options.length - maxOptions;
                        }
                        return p + maxOptions;
                    });
                }, disabled: offset + maxOptions === options.length, children: jsxRuntime.exports.jsx(StyledArrow$1, { icon: faChevronRight$1 }) }, "next"))] }));
};

const StyledTicket = styled__default["default"].div `
  background-color: ${({ theme }) => theme.colors.background.main};
  border-radius: ${({ theme }) => theme.radius.small};
  border: ${({ $isCollected }) => ($isCollected ? '0.2rem solid' : '0.2rem dashed')};
  border-color: ${({ theme }) => theme.colors.grey[400]};
  color: ${({ theme }) => theme.colors.text.main};
  display: grid;
  align-items: start;
  height: 15.2rem;
  text-align: center;
  width: 13rem;
  box-shadow: ${({ theme, $isCollected }) => ($isCollected ? theme.boxShadow.light : 'none')};
  animation: shaking 1s ease-in-out;

  p {
    padding: 0 1rem;
  }

  span {
    display: block;
  }

  @keyframes shaking {
    0% {
      transform: scaleX(1);
    }
    10%,
    20% {
      transform: scale3d(0.9, 0.9, 0.9) rotate(-3deg);
    }
    30%,
    50%,
    70%,
    90% {
      transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
    }
    40%,
    60%,
    80% {
      transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
    }
    100% {
      transform: scaleX(1);
    }
  }

  &[data-ticket='redeem-prompt'],
  &[data-ticket='click-reveal'] {
    align-items: center;
    border: 0.2rem dashed ${({ theme }) => theme.colors.info.main};
    background-color: ${lightColors.info.main.replace('1)', '0.1)')};
    box-shadow: none;
    animation: none;
  }

  &[data-ticket='click-reveal'] {
    cursor: pointer;
  }

  &[data-ticket='cybercrusader-title'] {
    border-color: ${({ $isCollected }) => $isCollected ? lightColors.warning.main : lightColors.warning.main.replace('1)', '0.2)')};
  }

  &[data-ticket='streak-freeze-1'] {
    border-color: ${({ $isCollected }) => $isCollected ? darkColors.info.main : darkColors.info.main.replace('1)', '0.2)')};
  }

  &[data-ticket='20-swag-voucher'] {
    border-color: ${({ $isCollected }) => $isCollected ? darkColors.success.main : darkColors.success.main.replace('1)', '0.2)')};
  }

  &[data-ticket='tryhackme-tshirt'] {
    border-color: ${({ $isCollected }) => $isCollected ? lightColors.success.main : lightColors.success.main.replace('1)', '0.2)')};
  }

  &[data-ticket='tryhackme-hat'] {
    border-color: ${({ $isCollected }) => $isCollected ? lightColors.info.main : lightColors.info.main.replace('1)', '0.2)')};
  }

  &[data-ticket='streak-freeze-7'] {
    border-color: ${({ $isCollected }) => $isCollected ? lightColors.error.main : lightColors.error.main.replace('1)', '0.2)')};
  }

  &[data-ticket='1-month-premium-voucher'] {
    border-color: ${({ $isCollected }) => $isCollected ? darkColors.error.main : darkColors.error.main.replace('1)', '0.2)')};
  }

  &[data-ticket='10-swag-voucher'] {
    border-color: ${({ $isCollected }) => $isCollected ? darkColors.warning.main : darkColors.warning.main.replace('1)', '0.2)')};
  }

  &[data-ticket='50-amazon-voucher'] {
    border-color: ${({ $isCollected }) => $isCollected ? lightColors.purple.light : lightColors.purple.light.replace('1)', '0.2)')};
  }

  &[data-ticket='12-month-premium-voucher'] {
    border-color: ${({ $isCollected }) => $isCollected ? lightColors.purple.main : lightColors.purple.main.replace('1)', '0.2)')};
  }

  &[data-ticket='laptop'] {
    border-color: ${({ theme, $isCollected }) => $isCollected ? theme.colors.grey[400] : theme.colors.grey[400].replace('1)', '0.2)')};
  }

  &[data-ticket='defcon'] {
    border-color: ${({ theme }) => theme.colors.grey[800]};
    border-color: ${({ theme, $isCollected }) => $isCollected ? theme.colors.grey[800] : theme.colors.grey[800].replace('1)', '0.2)')};
  }
`;
const StyledTicketHeader = styled__default["default"].span `
  align-self: flex-start;
  border-top: 1.8rem solid;
  border-top-color: inherit;
  border-radius: 0.2rem 0.2rem 0 0;
  width: 100%;

  &[data-ticket='redeem-prompt'],
  &[data-ticket='click-reveal'] {
    display: none;
  }
`;
const SpinnerWrapper = styled__default["default"].div `
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TICKETS = {
    'cybercrusader-title': {
        text: 'Cyber Crusader',
    },
    'streak-freeze-1': {
        text: '1 Day',
        secondLine: 'Streak Freeze',
    },
    'streak-freeze-7': {
        text: '7 Day',
        secondLine: 'Streak Freeze',
    },
    '10-swag-voucher': {
        text: '£10 Swag',
        secondLine: 'Voucher',
    },
    'tryhackme-tshirt': {
        text: 'TryHackMe',
        secondLine: 'T-Shirt',
    },
    'tryhackme-hat': {
        text: 'TryHackMe',
        secondLine: 'Baseball Cap',
    },
    '1-month-premium-voucher': {
        text: '1 Month',
        secondLine: 'Premium Voucher',
    },
    '20-swag-voucher': {
        text: '£20 Swag',
        secondLine: 'Voucher',
    },
    '50-amazon-voucher': {
        text: '$50 Amazon',
        secondLine: 'Voucher',
    },
    '12-month-premium-voucher': {
        text: '12 Month',
        secondLine: 'Premium Voucher',
    },
    laptop: {
        text: 'Laptop',
    },
    defcon: {
        text: 'DEFCON33',
        secondLine: 'Ticket',
    },
    'redeem-prompt': {
        text: 'Subscribe to redeem 2 tickets',
    },
    'click-reveal': {
        text: 'Click to reveal',
    },
};

const Ticket = ({ name, isCollected, isLoading = false, spinnerColor = 'black' }) => {
    const ticket = TICKETS[name];
    return (jsxRuntime.exports.jsxs(StyledTicket, { "data-ticket": name, "$isCollected": isCollected, "data-testid": "ticket", children: [jsxRuntime.exports.jsx(StyledTicketHeader, { "data-ticket": name }), isLoading ? (jsxRuntime.exports.jsx(SpinnerWrapper, { children: jsxRuntime.exports.jsx(StyledSpinner$1, { "data-testid": "spinner", color: spinnerColor }) })) : (jsxRuntime.exports.jsxs("p", { children: [ticket?.text, " ", ticket?.secondLine && jsxRuntime.exports.jsx("span", { children: ticket?.secondLine })] }))] }));
};

const StyledTimelineWrapper = styled__default["default"](StyledWrapper$6) `
  > button {
    border: 0.1rem solid ${({ theme }) => theme.colors.primary.main};
    width: 3.6rem;
    height: 3.6rem;

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.colors.primary.light};
      border: 0.1rem solid ${({ theme }) => theme.colors.primary.main};
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;
const StyledTimelineContainer$1 = styled__default["default"].div `
  ${StyledTimelineContainerCommons};
  height: 20.9rem;
  gap: 0.4rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    height: 61.1rem;
  }
`;
const StyledTimelineItemWrapper$1 = styled__default["default"].div `
  ${StyledFlexColumnCenter};
  gap: 0.4rem;
`;
const StyledTimelineItem$1 = styled__default["default"].div `
  ${StyledFlexColumnCenter};
  opacity: ${({ isSelected }) => !isSelected && '0.56'};
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`;
const StyledItemImage = styled__default["default"].img `
  width: ${({ isSelected }) => (isSelected ? '12.3rem' : '8.4rem')};
  height: ${({ isSelected }) => (isSelected ? '12.3rem' : '8.4rem')};
  border-radius: 50%;
  object-fit: contain;
`;
const StyledItemTitle$1 = styled__default["default"].div `
  font-family: ${({ theme }) => theme.fonts.familyBungee};
  font-size: ${({ isSelected, theme }) => (isSelected ? '1.8rem' : theme.fonts.sizes.default)};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  margin-block: 1.6rem 0.8rem;
  color: ${({ theme }) => theme.colors.text.main};
`;
const StyledItemDescription = styled__default["default"].div `
  font-size: ${({ isSelected, theme }) => (isSelected ? theme.fonts.sizes.small : theme.fonts.sizes.tiny)};
  padding: ${({ isSelected }) => (isSelected ? '0.6rem 1.2rem' : '0.2rem 1rem')};
  border-radius: 10rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme, color = 'info' }) => {
    switch (color) {
        case 'red': {
            return theme.colors.error.main;
        }
        case 'blue': {
            return theme.colors.info.main;
        }
        default: {
            return theme.colors[color].main;
        }
    }
}};
  background-color: ${({ theme, color = 'info' }) => {
    switch (color) {
        case 'purple': {
            return theme.colors.purple.lighter;
        }
        case 'warning': {
            return theme.colors.warning.lightest;
        }
        case 'red': {
            return theme.colors.error.light;
        }
        case 'blue': {
            return theme.colors.info.light;
        }
        default: {
            return theme.colors.info.light;
        }
    }
}};
`;
const StyledVerticalLine$1 = styled__default["default"].div `
  width: 0.2rem;
  height: 3.6rem;
  background-color: ${({ theme }) => theme.colors.border.light};
`;

const Timeline = ({ timelineData, onChange }) => {
    const containerRef = React.useRef(null);
    const { selectedItemIndex, handleOnElementClick, handleNavigationButtonClick } = useTimeline({
        timelineData,
        containerRef,
        onChange,
    });
    return (jsxRuntime.exports.jsxs(StyledTimelineWrapper, { children: [jsxRuntime.exports.jsx(IconButton, { variant: "navigate", onClick: () => handleNavigationButtonClick(-1), "aria-label": "Previous", disabled: selectedItemIndex === 0, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faArrowUp$1 }) }), jsxRuntime.exports.jsx(StyledVerticalLine$1, {}), jsxRuntime.exports.jsx(StyledTimelineContainer$1, { ref: containerRef, children: timelineData.map(({ image, title, subtitle, color }, index) => (jsxRuntime.exports.jsxs(StyledTimelineItemWrapper$1, { children: [jsxRuntime.exports.jsxs(StyledTimelineItem$1, { onClick: () => handleOnElementClick(index), isSelected: index === selectedItemIndex, children: [jsxRuntime.exports.jsx(StyledImageWrapper$3, { isSelected: index === selectedItemIndex, children: jsxRuntime.exports.jsx(StyledItemImage, { src: image, alt: title, isSelected: index === selectedItemIndex }) }), jsxRuntime.exports.jsx(StyledItemTitle$1, { isSelected: index === selectedItemIndex, children: title }), jsxRuntime.exports.jsx(StyledItemDescription, { color: color, isSelected: index === selectedItemIndex, children: subtitle })] }), index !== timelineData.length - 1 && jsxRuntime.exports.jsx(StyledVerticalLine$1, {})] }, title))) }), jsxRuntime.exports.jsx(StyledVerticalLine$1, {}), jsxRuntime.exports.jsx(IconButton, { variant: "navigate", onClick: () => handleNavigationButtonClick(1), "aria-label": "Next", disabled: selectedItemIndex === timelineData.length - 1, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faArrowDown$1 }) })] }));
};

const StyledTooltipText = styled__default["default"].div `
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.offBlack};
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  padding: 1rem;
  border-radius: ${({ theme }) => theme.radius.small};
`;
const StyledAction = styled__default["default"].div `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.grey[600]};

  :hover {
    color: ${({ theme }) => theme.colors.grey[300]};
  }
`;

const SmallTooltipWrapper = ({ id, children, tooltipText, position = 'bottom', onClick = () => { }, visible = true, styles = {}, contentStyles = {}, tooltipContent, useOwnProvider = true, }) => visible ? (useOwnProvider ? (jsxRuntime.exports.jsx($a093c7e1ec25a057$export$2881499e37b75b9a, { children: jsxRuntime.exports.jsxs($a093c7e1ec25a057$export$be92b6f5f03c0fe9, { children: [jsxRuntime.exports.jsx($a093c7e1ec25a057$export$41fb9f06171c75f4, { asChild: true, children: jsxRuntime.exports.jsx(StyledAction, { id: id, "data-testid": id, onClick: onClick, style: { ...styles }, children: children }, id) }), jsxRuntime.exports.jsx($a093c7e1ec25a057$export$602eac185826482c, { children: jsxRuntime.exports.jsxs($a093c7e1ec25a057$export$7c6e2c02157bb7d2, { side: position, style: { zIndex: 2_147_483_002, ...contentStyles }, children: [jsxRuntime.exports.jsx($a093c7e1ec25a057$export$21b07c8f274aebd5, {}), jsxRuntime.exports.jsx(StyledTooltipText, { children: tooltipContent ?? tooltipText })] }) })] }) })) : (jsxRuntime.exports.jsxs($a093c7e1ec25a057$export$be92b6f5f03c0fe9, { children: [jsxRuntime.exports.jsx($a093c7e1ec25a057$export$41fb9f06171c75f4, { asChild: true, children: jsxRuntime.exports.jsx(StyledAction, { id: id, "data-testid": id, onClick: onClick, style: { ...styles }, children: children }, id) }), jsxRuntime.exports.jsx($a093c7e1ec25a057$export$602eac185826482c, { children: jsxRuntime.exports.jsxs($a093c7e1ec25a057$export$7c6e2c02157bb7d2, { side: position, style: { zIndex: 2_147_483_002, ...contentStyles }, children: [jsxRuntime.exports.jsx($a093c7e1ec25a057$export$21b07c8f274aebd5, {}), jsxRuntime.exports.jsx(StyledTooltipText, { children: tooltipContent ?? tooltipText })] }) })] }))) : (children);

function ok$1() {}

function unreachable() {}

/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */

/**
 * Serialize an array of strings or numbers to comma-separated tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @param {Options} [options]
 *   Configuration for `stringify` (optional).
 * @returns {string}
 *   Comma-separated tokens.
 */
function stringify$1(values, options) {
  const settings = options || {};

  // Ensure the last empty entry is seen.
  const input = values[values.length - 1] === '' ? [...values, ''] : values;

  return input
    .join(
      (settings.padRight ? ' ' : '') +
        ',' +
        (settings.padLeft === false ? '' : ' ')
    )
    .trim()
}

/**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [jsx=false]
 *   Support JSX identifiers (default: `false`).
 */
const nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
const nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;

/** @type {Options} */
const emptyOptions$2 = {};

/**
 * Checks if the given value is a valid identifier name.
 *
 * @param {string} name
 *   Identifier to check.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {boolean}
 *   Whether `name` can be an identifier.
 */
function name(name, options) {
  const settings = options || emptyOptions$2;
  const re = settings.jsx ? nameReJsx : nameRe;
  return re.test(name)
}

/**
 * @typedef {import('hast').Nodes} Nodes
 */

// HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const re = /[ \t\n\f\r]/g;

/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {Nodes | string} thing
 *   Thing to check (`Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`); if a node is passed it must be a `Text` node,
 *   whose `value` field is checked.
 */
function whitespace(thing) {
  return typeof thing === 'object'
    ? thing.type === 'text'
      ? empty$1(thing.value)
      : false
    : empty$1(thing)
}

/**
 * @param {string} value
 * @returns {boolean}
 */
function empty$1(value) {
  return value.replace(re, '') === ''
}

/**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */

/** @type {SchemaType} */
class Schema {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(property, normal, space) {
    this.normal = normal;
    this.property = property;

    if (space) {
      this.space = space;
    }
  }
}

Schema.prototype.normal = {};
Schema.prototype.property = {};
Schema.prototype.space = undefined;

/**
 * @import {Info, Space} from 'property-information'
 */

/**
 * @param {ReadonlyArray<Schema>} definitions
 *   Definitions.
 * @param {Space | undefined} [space]
 *   Space.
 * @returns {Schema}
 *   Schema.
 */
function merge(definitions, space) {
  /** @type {Record<string, Info>} */
  const property = {};
  /** @type {Record<string, string>} */
  const normal = {};

  for (const definition of definitions) {
    Object.assign(property, definition.property);
    Object.assign(normal, definition.normal);
  }

  return new Schema(property, normal, space)
}

/**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */
function normalize$1(value) {
  return value.toLowerCase()
}

/**
 * @import {Info as InfoType} from 'property-information'
 */

/** @type {InfoType} */
class Info {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(property, attribute) {
    this.attribute = attribute;
    this.property = property;
  }
}

Info.prototype.attribute = '';
Info.prototype.booleanish = false;
Info.prototype.boolean = false;
Info.prototype.commaOrSpaceSeparated = false;
Info.prototype.commaSeparated = false;
Info.prototype.defined = false;
Info.prototype.mustUseProperty = false;
Info.prototype.number = false;
Info.prototype.overloadedBoolean = false;
Info.prototype.property = '';
Info.prototype.spaceSeparated = false;
Info.prototype.space = undefined;

let powers = 0;

const boolean = increment();
const booleanish = increment();
const overloadedBoolean = increment();
const number = increment();
const spaceSeparated = increment();
const commaSeparated = increment();
const commaOrSpaceSeparated = increment();

function increment() {
  return 2 ** ++powers
}

var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  boolean: boolean,
  booleanish: booleanish,
  overloadedBoolean: overloadedBoolean,
  number: number,
  spaceSeparated: spaceSeparated,
  commaSeparated: commaSeparated,
  commaOrSpaceSeparated: commaOrSpaceSeparated
});

/**
 * @import {Space} from 'property-information'
 */

const checks = /** @type {ReadonlyArray<keyof typeof types>} */ (
  Object.keys(types)
);

class DefinedInfo extends Info {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(property, attribute, mask, space) {
    let index = -1;

    super(property, attribute);

    mark(this, 'space', space);

    if (typeof mask === 'number') {
      while (++index < checks.length) {
        const check = checks[index];
        mark(this, checks[index], (mask & types[check]) === types[check]);
      }
    }
  }
}

DefinedInfo.prototype.defined = true;

/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */
function mark(values, key, value) {
  if (value) {
    values[key] = value;
  }
}

/**
 * @import {Info, Space} from 'property-information'
 */

/**
 * @param {Definition} definition
 *   Definition.
 * @returns {Schema}
 *   Schema.
 */
function create(definition) {
  /** @type {Record<string, Info>} */
  const properties = {};
  /** @type {Record<string, string>} */
  const normals = {};

  for (const [property, value] of Object.entries(definition.properties)) {
    const info = new DefinedInfo(
      property,
      definition.transform(definition.attributes || {}, property),
      value,
      definition.space
    );

    if (
      definition.mustUseProperty &&
      definition.mustUseProperty.includes(property)
    ) {
      info.mustUseProperty = true;
    }

    properties[property] = info;

    normals[normalize$1(property)] = property;
    normals[normalize$1(info.attribute)] = property;
  }

  return new Schema(properties, normals, definition.space)
}

const aria = create({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  },
  transform(_, property) {
    return property === 'role'
      ? property
      : 'aria-' + property.slice(4).toLowerCase()
  }
});

/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */
function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}

/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Transformed property.
 */
function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}

const html$2 = create({
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    blocking: spaceSeparated,
    capture: null,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: overloadedBoolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: boolean,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shadowRootClonable: boolean,
    shadowRootDelegatesFocus: boolean,
    shadowRootMode: null,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,
    writingSuggestions: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: number, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: boolean, // Lists. Use CSS to reduce space between items instead
    declare: boolean, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: number, // `<img>` and `<object>`
    leftMargin: number, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: number, // `<body>`
    marginWidth: number, // `<body>`
    noResize: boolean, // `<frame>`
    noHref: boolean, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean, // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: number, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: booleanish, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: number, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean,
    disableRemotePlayback: boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  },
  space: 'html',
  transform: caseInsensitiveTransform
});

const svg$1 = create({
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    transformOrigin: 'transform-origin',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null, // SEMI_COLON_SEPARATED
    keySplines: null, // SEMI_COLON_SEPARATED
    keyTimes: null, // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: 'svg',
  transform: caseSensitiveTransform
});

const xlink = create({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: 'xlink',
  transform(_, property) {
    return 'xlink:' + property.slice(5).toLowerCase()
  }
});

const xmlns = create({
  attributes: {xmlnsxlink: 'xmlns:xlink'},
  properties: {xmlnsXLink: null, xmlns: null},
  space: 'xmlns',
  transform: caseInsensitiveTransform
});

const xml = create({
  properties: {xmlBase: null, xmlLang: null, xmlSpace: null},
  space: 'xml',
  transform(_, property) {
    return 'xml:' + property.slice(3).toLowerCase()
  }
});

/**
 * Special cases for React (`Record<string, string>`).
 *
 * `hast` is close to `React` but differs in a couple of cases.
 * To get a React property from a hast property,
 * check if it is in `hastToReact`.
 * If it is, use the corresponding value;
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */
const hastToReact = {
  classId: 'classID',
  dataType: 'datatype',
  itemId: 'itemID',
  strokeDashArray: 'strokeDasharray',
  strokeDashOffset: 'strokeDashoffset',
  strokeLineCap: 'strokeLinecap',
  strokeLineJoin: 'strokeLinejoin',
  strokeMiterLimit: 'strokeMiterlimit',
  typeOf: 'typeof',
  xLinkActuate: 'xlinkActuate',
  xLinkArcRole: 'xlinkArcrole',
  xLinkHref: 'xlinkHref',
  xLinkRole: 'xlinkRole',
  xLinkShow: 'xlinkShow',
  xLinkTitle: 'xlinkTitle',
  xLinkType: 'xlinkType',
  xmlnsXLink: 'xmlnsXlink'
};

/**
 * @import {Schema} from 'property-information'
 */

const cap$1 = /[A-Z]/g;
const dash = /-[a-z]/g;
const valid = /^data[-\w.:]+$/i;

/**
 * Look up info on a property.
 *
 * In most cases the given `schema` contains info on the property.
 * All standard,
 * most legacy,
 * and some non-standard properties are supported.
 * For these cases,
 * the returned `Info` has hints about the value of the property.
 *
 * `name` can also be a valid data attribute or property,
 * in which case an `Info` object with the correctly cased `attribute` and
 * `property` is returned.
 *
 * `name` can be an unknown attribute,
 * in which case an `Info` object with `attribute` and `property` set to the
 * given name is returned.
 * It is not recommended to provide unsupported legacy or recently specced
 * properties.
 *
 *
 * @param {Schema} schema
 *   Schema;
 *   either the `html` or `svg` export.
 * @param {string} value
 *   An attribute-like or property-like name;
 *   it will be passed through `normalize` to hopefully find the correct info.
 * @returns {Info}
 *   Info.
 */
function find(schema, value) {
  const normal = normalize$1(value);
  let property = value;
  let Type = Info;

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === 'data' && valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      const rest = value.slice(5).replace(dash, camelcase);
      property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
    } else {
      // Turn it into an attribute.
      const rest = value.slice(4);

      if (!dash.test(rest)) {
        let dashes = rest.replace(cap$1, kebab);

        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes;
        }

        value = 'data' + dashes;
      }
    }

    Type = DefinedInfo;
  }

  return new Type(property, value)
}

/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */
function kebab($0) {
  return '-' + $0.toLowerCase()
}

/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */
function camelcase($0) {
  return $0.charAt(1).toUpperCase()
}

// Note: types exposed from `index.d.ts`.

const html$1 = merge([aria, html$2, xlink, xmlns, xml], 'html');

const svg = merge([aria, svg$1, xlink, xmlns, xml], 'svg');

/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */

/**
 * Serialize an array of strings as space separated-tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @returns {string}
 *   Space-separated tokens.
 */
function stringify(values) {
  return values.join(' ').trim()
}

var cjs$1 = {};

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
var inlineStyleParser = function (style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function (node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) ; else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}

var __importDefault$1 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(cjs$1, "__esModule", { value: true });
cjs$1.default = StyleToObject;
var inline_style_parser_1 = __importDefault$1(inlineStyleParser);
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */
function StyleToObject(style, iterator) {
    var styleObject = null;
    if (!style || typeof style !== 'string') {
        return styleObject;
    }
    var declarations = (0, inline_style_parser_1.default)(style);
    var hasIterator = typeof iterator === 'function';
    declarations.forEach(function (declaration) {
        if (declaration.type !== 'declaration') {
            return;
        }
        var property = declaration.property, value = declaration.value;
        if (hasIterator) {
            iterator(property, value, declaration);
        }
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}

var utilities = {};

Object.defineProperty(utilities, "__esModule", { value: true });
utilities.camelCase = void 0;
var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
var HYPHEN_REGEX = /-([a-z])/g;
var NO_HYPHEN_REGEX = /^[^-]+$/;
var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
/**
 * Checks whether to skip camelCase.
 */
var skipCamelCase = function (property) {
    return !property ||
        NO_HYPHEN_REGEX.test(property) ||
        CUSTOM_PROPERTY_REGEX.test(property);
};
/**
 * Replacer that capitalizes first character.
 */
var capitalize = function (match, character) {
    return character.toUpperCase();
};
/**
 * Replacer that removes beginning hyphen of vendor prefix property.
 */
var trimHyphen = function (match, prefix) { return "".concat(prefix, "-"); };
/**
 * CamelCases a CSS property.
 */
var camelCase = function (property, options) {
    if (options === void 0) { options = {}; }
    if (skipCamelCase(property)) {
        return property;
    }
    property = property.toLowerCase();
    if (options.reactCompat) {
        // `-ms` vendor prefix should not be capitalized
        property = property.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen);
    }
    else {
        // for non-React, remove first hyphen so vendor prefix is not capitalized
        property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
    }
    return property.replace(HYPHEN_REGEX, capitalize);
};
utilities.camelCase = camelCase;

var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var style_to_object_1 = __importDefault(cjs$1);
var utilities_1 = utilities;
/**
 * Parses CSS inline style to JavaScript object (camelCased).
 */
function StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') {
        return output;
    }
    (0, style_to_object_1.default)(style, function (property, value) {
        // skip CSS comment
        if (property && value) {
            output[(0, utilities_1.camelCase)(property, options)] = value;
        }
    });
    return output;
}
StyleToJS.default = StyleToJS;
var cjs = StyleToJS;

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */

/**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */

/**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */
const pointEnd = point$2('end');

/**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */
const pointStart = point$2('start');

/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */
function point$2(type) {
  return point

  /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */
  function point(node) {
    const point = (node && node.position && node.position[type]) || {};

    if (
      typeof point.line === 'number' &&
      point.line > 0 &&
      typeof point.column === 'number' &&
      point.column > 0
    ) {
      return {
        line: point.line,
        column: point.column,
        offset:
          typeof point.offset === 'number' && point.offset > -1
            ? point.offset
            : undefined
      }
    }
  }
}

/**
 * Get the positional info of `node`.
 *
 * @param {Node | NodeLike | null | undefined} [node]
 *   Node.
 * @returns {Position | undefined}
 *   Position.
 */
function position$1(node) {
  const start = pointStart(node);
  const end = pointEnd(node);

  if (start && end) {
    return {start, end}
  }
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */

/**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */

/**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */
function stringifyPosition(value) {
  // Nothing.
  if (!value || typeof value !== 'object') {
    return ''
  }

  // Node.
  if ('position' in value || 'type' in value) {
    return position(value.position)
  }

  // Position.
  if ('start' in value || 'end' in value) {
    return position(value)
  }

  // Point.
  if ('line' in value || 'column' in value) {
    return point$1(value)
  }

  // ?
  return ''
}

/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */
function point$1(point) {
  return index(point && point.line) + ':' + index(point && point.column)
}

/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */
function position(pos) {
  return point$1(pos && pos.start) + '-' + point$1(pos && pos.end)
}

/**
 * @param {number | null | undefined} value
 * @returns {number}
 */
function index(value) {
  return value && typeof value === 'number' ? value : 1
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */

/**
 * Message.
 */
class VFileMessage extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(causeOrReason, optionsOrParentOrPlace, origin) {
    super();

    if (typeof optionsOrParentOrPlace === 'string') {
      origin = optionsOrParentOrPlace;
      optionsOrParentOrPlace = undefined;
    }

    /** @type {string} */
    let reason = '';
    /** @type {Options} */
    let options = {};
    let legacyCause = false;

    if (optionsOrParentOrPlace) {
      // Point.
      if (
        'line' in optionsOrParentOrPlace &&
        'column' in optionsOrParentOrPlace
      ) {
        options = {place: optionsOrParentOrPlace};
      }
      // Position.
      else if (
        'start' in optionsOrParentOrPlace &&
        'end' in optionsOrParentOrPlace
      ) {
        options = {place: optionsOrParentOrPlace};
      }
      // Node.
      else if ('type' in optionsOrParentOrPlace) {
        options = {
          ancestors: [optionsOrParentOrPlace],
          place: optionsOrParentOrPlace.position
        };
      }
      // Options.
      else {
        options = {...optionsOrParentOrPlace};
      }
    }

    if (typeof causeOrReason === 'string') {
      reason = causeOrReason;
    }
    // Error.
    else if (!options.cause && causeOrReason) {
      legacyCause = true;
      reason = causeOrReason.message;
      options.cause = causeOrReason;
    }

    if (!options.ruleId && !options.source && typeof origin === 'string') {
      const index = origin.indexOf(':');

      if (index === -1) {
        options.ruleId = origin;
      } else {
        options.source = origin.slice(0, index);
        options.ruleId = origin.slice(index + 1);
      }
    }

    if (!options.place && options.ancestors && options.ancestors) {
      const parent = options.ancestors[options.ancestors.length - 1];

      if (parent) {
        options.place = parent.position;
      }
    }

    const start =
      options.place && 'start' in options.place
        ? options.place.start
        : options.place;

    /* eslint-disable no-unused-expressions */
    /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */
    this.ancestors = options.ancestors || undefined;

    /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */
    this.cause = options.cause || undefined;

    /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */
    this.column = start ? start.column : undefined;

    /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */
    this.fatal = undefined;

    /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */
    this.file;

    // Field from `Error`.
    /**
     * Reason for message.
     *
     * @type {string}
     */
    this.message = reason;

    /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */
    this.line = start ? start.line : undefined;

    // Field from `Error`.
    /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */
    this.name = stringifyPosition(options.place) || '1:1';

    /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */
    this.place = options.place || undefined;

    /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */
    this.reason = this.message;

    /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */
    this.ruleId = options.ruleId || undefined;

    /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */
    this.source = options.source || undefined;

    // Field from `Error`.
    /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */
    this.stack =
      legacyCause && options.cause && typeof options.cause.stack === 'string'
        ? options.cause.stack
        : '';

    // The following fields are “well known”.
    // Not standard.
    // Feel free to add other non-standard fields to your messages.

    /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */
    this.actual;

    /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */
    this.expected;

    /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */
    this.note;

    /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */
    this.url;
    /* eslint-enable no-unused-expressions */
  }
}

VFileMessage.prototype.file = '';
VFileMessage.prototype.name = '';
VFileMessage.prototype.reason = '';
VFileMessage.prototype.message = '';
VFileMessage.prototype.stack = '';
VFileMessage.prototype.column = undefined;
VFileMessage.prototype.line = undefined;
VFileMessage.prototype.ancestors = undefined;
VFileMessage.prototype.cause = undefined;
VFileMessage.prototype.fatal = undefined;
VFileMessage.prototype.place = undefined;
VFileMessage.prototype.ruleId = undefined;
VFileMessage.prototype.source = undefined;

/**
 * @import {Identifier, Literal, MemberExpression} from 'estree'
 * @import {Jsx, JsxDev, Options, Props} from 'hast-util-to-jsx-runtime'
 * @import {Element, Nodes, Parents, Root, Text} from 'hast'
 * @import {MdxFlowExpressionHast, MdxTextExpressionHast} from 'mdast-util-mdx-expression'
 * @import {MdxJsxFlowElementHast, MdxJsxTextElementHast} from 'mdast-util-mdx-jsx'
 * @import {MdxjsEsmHast} from 'mdast-util-mdxjs-esm'
 * @import {Position} from 'unist'
 * @import {Child, Create, Field, JsxElement, State, Style} from './types.js'
 */

// To do: next major: `Object.hasOwn`.
const own$4 = {}.hasOwnProperty;

/** @type {Map<string, number>} */
const emptyMap = new Map();

const cap = /[A-Z]/g;

// `react-dom` triggers a warning for *any* white space in tables.
// To follow GFM, `mdast-util-to-hast` injects line endings between elements.
// Other tools might do so too, but they don’t do here, so we remove all of
// that.

// See: <https://github.com/facebook/react/pull/7081>.
// See: <https://github.com/facebook/react/pull/7515>.
// See: <https://github.com/remarkjs/remark-react/issues/64>.
// See: <https://github.com/rehypejs/rehype-react/pull/29>.
// See: <https://github.com/rehypejs/rehype-react/pull/32>.
// See: <https://github.com/rehypejs/rehype-react/pull/45>.
const tableElements = new Set(['table', 'tbody', 'thead', 'tfoot', 'tr']);

const tableCellElement = new Set(['td', 'th']);

const docs = 'https://github.com/syntax-tree/hast-util-to-jsx-runtime';

/**
 * Transform a hast tree to preact, react, solid, svelte, vue, etc.,
 * with an automatic JSX runtime.
 *
 * @param {Nodes} tree
 *   Tree to transform.
 * @param {Options} options
 *   Configuration (required).
 * @returns {JsxElement}
 *   JSX element.
 */

function toJsxRuntime(tree, options) {
  if (!options || options.Fragment === undefined) {
    throw new TypeError('Expected `Fragment` in options')
  }

  const filePath = options.filePath || undefined;
  /** @type {Create} */
  let create;

  if (options.development) {
    if (typeof options.jsxDEV !== 'function') {
      throw new TypeError(
        'Expected `jsxDEV` in options when `development: true`'
      )
    }

    create = developmentCreate(filePath, options.jsxDEV);
  } else {
    if (typeof options.jsx !== 'function') {
      throw new TypeError('Expected `jsx` in production options')
    }

    if (typeof options.jsxs !== 'function') {
      throw new TypeError('Expected `jsxs` in production options')
    }

    create = productionCreate(filePath, options.jsx, options.jsxs);
  }

  /** @type {State} */
  const state = {
    Fragment: options.Fragment,
    ancestors: [],
    components: options.components || {},
    create,
    elementAttributeNameCase: options.elementAttributeNameCase || 'react',
    evaluater: options.createEvaluater ? options.createEvaluater() : undefined,
    filePath,
    ignoreInvalidStyle: options.ignoreInvalidStyle || false,
    passKeys: options.passKeys !== false,
    passNode: options.passNode || false,
    schema: options.space === 'svg' ? svg : html$1,
    stylePropertyNameCase: options.stylePropertyNameCase || 'dom',
    tableCellAlignToStyle: options.tableCellAlignToStyle !== false
  };

  const result = one$1(state, tree, undefined);

  // JSX element.
  if (result && typeof result !== 'string') {
    return result
  }

  // Text node or something that turned into nothing.
  return state.create(
    tree,
    state.Fragment,
    {children: result || undefined},
    undefined
  )
}

/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Nodes} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function one$1(state, node, key) {
  if (node.type === 'element') {
    return element(state, node, key)
  }

  if (node.type === 'mdxFlowExpression' || node.type === 'mdxTextExpression') {
    return mdxExpression(state, node)
  }

  if (node.type === 'mdxJsxFlowElement' || node.type === 'mdxJsxTextElement') {
    return mdxJsxElement(state, node, key)
  }

  if (node.type === 'mdxjsEsm') {
    return mdxEsm(state, node)
  }

  if (node.type === 'root') {
    return root$1(state, node, key)
  }

  if (node.type === 'text') {
    return text$3(state, node)
  }
}

/**
 * Handle element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function element(state, node, key) {
  const parentSchema = state.schema;
  let schema = parentSchema;

  if (node.tagName.toLowerCase() === 'svg' && parentSchema.space === 'html') {
    schema = svg;
    state.schema = schema;
  }

  state.ancestors.push(node);

  const type = findComponentFromName(state, node.tagName, false);
  const props = createElementProps(state, node);
  let children = createChildren(state, node);

  if (tableElements.has(node.tagName)) {
    children = children.filter(function (child) {
      return typeof child === 'string' ? !whitespace(child) : true
    });
  }

  addNode(state, props, type, node);
  addChildren(props, children);

  // Restore.
  state.ancestors.pop();
  state.schema = parentSchema;

  return state.create(node, type, props, key)
}

/**
 * Handle MDX expression.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxFlowExpressionHast | MdxTextExpressionHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function mdxExpression(state, node) {
  if (node.data && node.data.estree && state.evaluater) {
    const program = node.data.estree;
    const expression = program.body[0];
    ok$1(expression.type === 'ExpressionStatement');

    // Assume result is a child.
    return /** @type {Child | undefined} */ (
      state.evaluater.evaluateExpression(expression.expression)
    )
  }

  crashEstree(state, node.position);
}

/**
 * Handle MDX ESM.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxjsEsmHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function mdxEsm(state, node) {
  if (node.data && node.data.estree && state.evaluater) {
    // Assume result is a child.
    return /** @type {Child | undefined} */ (
      state.evaluater.evaluateProgram(node.data.estree)
    )
  }

  crashEstree(state, node.position);
}

/**
 * Handle MDX JSX.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function mdxJsxElement(state, node, key) {
  const parentSchema = state.schema;
  let schema = parentSchema;

  if (node.name === 'svg' && parentSchema.space === 'html') {
    schema = svg;
    state.schema = schema;
  }

  state.ancestors.push(node);

  const type =
    node.name === null
      ? state.Fragment
      : findComponentFromName(state, node.name, true);
  const props = createJsxElementProps(state, node);
  const children = createChildren(state, node);

  addNode(state, props, type, node);
  addChildren(props, children);

  // Restore.
  state.ancestors.pop();
  state.schema = parentSchema;

  return state.create(node, type, props, key)
}

/**
 * Handle root.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Root} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function root$1(state, node, key) {
  /** @type {Props} */
  const props = {};

  addChildren(props, createChildren(state, node));

  return state.create(node, state.Fragment, props, key)
}

/**
 * Handle text.
 *
 * @param {State} _
 *   Info passed around.
 * @param {Text} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function text$3(_, node) {
  return node.value
}

/**
 * Add `node` to props.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Props} props
 *   Props.
 * @param {unknown} type
 *   Type.
 * @param {Element | MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Node.
 * @returns {undefined}
 *   Nothing.
 */
function addNode(state, props, type, node) {
  // If this is swapped out for a component:
  if (typeof type !== 'string' && type !== state.Fragment && state.passNode) {
    props.node = node;
  }
}

/**
 * Add children to props.
 *
 * @param {Props} props
 *   Props.
 * @param {Array<Child>} children
 *   Children.
 * @returns {undefined}
 *   Nothing.
 */
function addChildren(props, children) {
  if (children.length > 0) {
    const value = children.length > 1 ? children : children[0];

    if (value) {
      props.children = value;
    }
  }
}

/**
 * @param {string | undefined} _
 *   Path to file.
 * @param {Jsx} jsx
 *   Dynamic.
 * @param {Jsx} jsxs
 *   Static.
 * @returns {Create}
 *   Create a production element.
 */
function productionCreate(_, jsx, jsxs) {
  return create
  /** @type {Create} */
  function create(_, type, props, key) {
    // Only an array when there are 2 or more children.
    const isStaticChildren = Array.isArray(props.children);
    const fn = isStaticChildren ? jsxs : jsx;
    return key ? fn(type, props, key) : fn(type, props)
  }
}

/**
 * @param {string | undefined} filePath
 *   Path to file.
 * @param {JsxDev} jsxDEV
 *   Development.
 * @returns {Create}
 *   Create a development element.
 */
function developmentCreate(filePath, jsxDEV) {
  return create
  /** @type {Create} */
  function create(node, type, props, key) {
    // Only an array when there are 2 or more children.
    const isStaticChildren = Array.isArray(props.children);
    const point = pointStart(node);
    return jsxDEV(
      type,
      props,
      key,
      isStaticChildren,
      {
        columnNumber: point ? point.column - 1 : undefined,
        fileName: filePath,
        lineNumber: point ? point.line : undefined
      },
      undefined
    )
  }
}

/**
 * Create props from an element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current element.
 * @returns {Props}
 *   Props.
 */
function createElementProps(state, node) {
  /** @type {Props} */
  const props = {};
  /** @type {string | undefined} */
  let alignValue;
  /** @type {string} */
  let prop;

  for (prop in node.properties) {
    if (prop !== 'children' && own$4.call(node.properties, prop)) {
      const result = createProperty(state, prop, node.properties[prop]);

      if (result) {
        const [key, value] = result;

        if (
          state.tableCellAlignToStyle &&
          key === 'align' &&
          typeof value === 'string' &&
          tableCellElement.has(node.tagName)
        ) {
          alignValue = value;
        } else {
          props[key] = value;
        }
      }
    }
  }

  if (alignValue) {
    // Assume style is an object.
    const style = /** @type {Style} */ (props.style || (props.style = {}));
    style[state.stylePropertyNameCase === 'css' ? 'text-align' : 'textAlign'] =
      alignValue;
  }

  return props
}

/**
 * Create props from a JSX element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current JSX element.
 * @returns {Props}
 *   Props.
 */
function createJsxElementProps(state, node) {
  /** @type {Props} */
  const props = {};

  for (const attribute of node.attributes) {
    if (attribute.type === 'mdxJsxExpressionAttribute') {
      if (attribute.data && attribute.data.estree && state.evaluater) {
        const program = attribute.data.estree;
        const expression = program.body[0];
        ok$1(expression.type === 'ExpressionStatement');
        const objectExpression = expression.expression;
        ok$1(objectExpression.type === 'ObjectExpression');
        const property = objectExpression.properties[0];
        ok$1(property.type === 'SpreadElement');

        Object.assign(
          props,
          state.evaluater.evaluateExpression(property.argument)
        );
      } else {
        crashEstree(state, node.position);
      }
    } else {
      // For JSX, the author is responsible of passing in the correct values.
      const name = attribute.name;
      /** @type {unknown} */
      let value;

      if (attribute.value && typeof attribute.value === 'object') {
        if (
          attribute.value.data &&
          attribute.value.data.estree &&
          state.evaluater
        ) {
          const program = attribute.value.data.estree;
          const expression = program.body[0];
          ok$1(expression.type === 'ExpressionStatement');
          value = state.evaluater.evaluateExpression(expression.expression);
        } else {
          crashEstree(state, node.position);
        }
      } else {
        value = attribute.value === null ? true : attribute.value;
      }

      // Assume a prop.
      props[name] = /** @type {Props[keyof Props]} */ (value);
    }
  }

  return props
}

/**
 * Create children.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Parents} node
 *   Current element.
 * @returns {Array<Child>}
 *   Children.
 */
function createChildren(state, node) {
  /** @type {Array<Child>} */
  const children = [];
  let index = -1;
  /** @type {Map<string, number>} */
  // Note: test this when Solid doesn’t want to merge my upcoming PR.
  /* c8 ignore next */
  const countsByName = state.passKeys ? new Map() : emptyMap;

  while (++index < node.children.length) {
    const child = node.children[index];
    /** @type {string | undefined} */
    let key;

    if (state.passKeys) {
      const name =
        child.type === 'element'
          ? child.tagName
          : child.type === 'mdxJsxFlowElement' ||
              child.type === 'mdxJsxTextElement'
            ? child.name
            : undefined;

      if (name) {
        const count = countsByName.get(name) || 0;
        key = name + '-' + count;
        countsByName.set(name, count + 1);
      }
    }

    const result = one$1(state, child, key);
    if (result !== undefined) children.push(result);
  }

  return children
}

/**
 * Handle a property.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Field | undefined}
 *   Field for runtime, optional.
 */
function createProperty(state, prop, value) {
  const info = find(state.schema, prop);

  // Ignore nullish and `NaN` values.
  if (
    value === null ||
    value === undefined ||
    (typeof value === 'number' && Number.isNaN(value))
  ) {
    return
  }

  if (Array.isArray(value)) {
    // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? stringify$1(value) : stringify(value);
  }

  // React only accepts `style` as object.
  if (info.property === 'style') {
    let styleObject =
      typeof value === 'object' ? value : parseStyle(state, String(value));

    if (state.stylePropertyNameCase === 'css') {
      styleObject = transformStylesToCssCasing(styleObject);
    }

    return ['style', styleObject]
  }

  return [
    state.elementAttributeNameCase === 'react' && info.space
      ? hastToReact[info.property] || info.property
      : info.attribute,
    value
  ]
}

/**
 * Parse a CSS declaration to an object.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} value
 *   CSS declarations.
 * @returns {Style}
 *   Properties.
 * @throws
 *   Throws `VFileMessage` when CSS cannot be parsed.
 */
function parseStyle(state, value) {
  try {
    return cjs(value, {reactCompat: true})
  } catch (error) {
    if (state.ignoreInvalidStyle) {
      return {}
    }

    const cause = /** @type {Error} */ (error);
    const message = new VFileMessage('Cannot parse `style` attribute', {
      ancestors: state.ancestors,
      cause,
      ruleId: 'style',
      source: 'hast-util-to-jsx-runtime'
    });
    message.file = state.filePath || undefined;
    message.url = docs + '#cannot-parse-style-attribute';

    throw message
  }
}

/**
 * Create a JSX name from a string.
 *
 * @param {State} state
 *   To do.
 * @param {string} name
 *   Name.
 * @param {boolean} allowExpression
 *   Allow member expressions and identifiers.
 * @returns {unknown}
 *   To do.
 */
function findComponentFromName(state, name$1, allowExpression) {
  /** @type {Identifier | Literal | MemberExpression} */
  let result;

  if (!allowExpression) {
    result = {type: 'Literal', value: name$1};
  } else if (name$1.includes('.')) {
    const identifiers = name$1.split('.');
    let index = -1;
    /** @type {Identifier | Literal | MemberExpression | undefined} */
    let node;

    while (++index < identifiers.length) {
      /** @type {Identifier | Literal} */
      const prop = name(identifiers[index])
        ? {type: 'Identifier', name: identifiers[index]}
        : {type: 'Literal', value: identifiers[index]};
      node = node
        ? {
            type: 'MemberExpression',
            object: node,
            property: prop,
            computed: Boolean(index && prop.type === 'Literal'),
            optional: false
          }
        : prop;
    }
    result = node;
  } else {
    result =
      name(name$1) && !/^[a-z]/.test(name$1)
        ? {type: 'Identifier', name: name$1}
        : {type: 'Literal', value: name$1};
  }

  // Only literals can be passed in `components` currently.
  // No identifiers / member expressions.
  if (result.type === 'Literal') {
    const name = /** @type {string | number} */ (result.value);
    return own$4.call(state.components, name) ? state.components[name] : name
  }

  // Assume component.
  if (state.evaluater) {
    return state.evaluater.evaluateExpression(result)
  }

  crashEstree(state);
}

/**
 * @param {State} state
 * @param {Position | undefined} [place]
 * @returns {never}
 */
function crashEstree(state, place) {
  const message = new VFileMessage(
    'Cannot handle MDX estrees without `createEvaluater`',
    {
      ancestors: state.ancestors,
      place,
      ruleId: 'mdx-estree',
      source: 'hast-util-to-jsx-runtime'
    }
  );
  message.file = state.filePath || undefined;
  message.url = docs + '#cannot-handle-mdx-estrees-without-createevaluater';

  throw message
}

/**
 * Transform a DOM casing style object to a CSS casing style object.
 *
 * @param {Style} domCasing
 * @returns {Style}
 */
function transformStylesToCssCasing(domCasing) {
  /** @type {Style} */
  const cssCasing = {};
  /** @type {string} */
  let from;

  for (from in domCasing) {
    if (own$4.call(domCasing, from)) {
      cssCasing[transformStyleToCssCasing(from)] = domCasing[from];
    }
  }

  return cssCasing
}

/**
 * Transform a DOM casing style field to a CSS casing style field.
 *
 * @param {string} from
 * @returns {string}
 */
function transformStyleToCssCasing(from) {
  let to = from.replace(cap, toDash);
  // Handle `ms-xxx` -> `-ms-xxx`.
  if (to.slice(0, 3) === 'ms-') to = '-' + to;
  return to
}

/**
 * Make `$0` dash cased.
 *
 * @param {string} $0
 *   Capitalized ASCII leter.
 * @returns {string}
 *   Dash and lower letter.
 */
function toDash($0) {
  return '-' + $0.toLowerCase()
}

/**
 * HTML URL properties.
 *
 * Each key is a property name and each value is a list of tag names it applies
 * to or `null` if it applies to all elements.
 *
 * @type {Record<string, Array<string> | null>}
 */
const urlAttributes = {
  action: ['form'],
  cite: ['blockquote', 'del', 'ins', 'q'],
  data: ['object'],
  formAction: ['button', 'input'],
  href: ['a', 'area', 'base', 'link'],
  icon: ['menuitem'],
  itemId: null,
  manifest: ['html'],
  ping: ['a', 'area'],
  poster: ['video'],
  src: [
    'audio',
    'embed',
    'iframe',
    'img',
    'input',
    'script',
    'source',
    'track',
    'video'
  ]
};

/**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */

/** @type {Options} */
const emptyOptions$1 = {};

/**
 * Get the text content of a node or list of nodes.
 *
 * Prefers the node’s plain-text fields, otherwise serializes its children,
 * and if the given value is an array, serialize the nodes in it.
 *
 * @param {unknown} [value]
 *   Thing to serialize, typically `Node`.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {string}
 *   Serialized `value`.
 */
function toString$1(value, options) {
  const settings = options || emptyOptions$1;
  const includeImageAlt =
    typeof settings.includeImageAlt === 'boolean'
      ? settings.includeImageAlt
      : true;
  const includeHtml =
    typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;

  return one(value, includeImageAlt, includeHtml)
}

/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */
function one(value, includeImageAlt, includeHtml) {
  if (node(value)) {
    if ('value' in value) {
      return value.type === 'html' && !includeHtml ? '' : value.value
    }

    if (includeImageAlt && 'alt' in value && value.alt) {
      return value.alt
    }

    if ('children' in value) {
      return all(value.children, includeImageAlt, includeHtml)
    }
  }

  if (Array.isArray(value)) {
    return all(value, includeImageAlt, includeHtml)
  }

  return ''
}

/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */
function all(values, includeImageAlt, includeHtml) {
  /** @type {Array<string>} */
  const result = [];
  let index = -1;

  while (++index < values.length) {
    result[index] = one(values[index], includeImageAlt, includeHtml);
  }

  return result.join('')
}

/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */
function node(value) {
  return Boolean(value && typeof value === 'object')
}

/**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */
const characterEntities = {
  AElig: 'Æ',
  AMP: '&',
  Aacute: 'Á',
  Abreve: 'Ă',
  Acirc: 'Â',
  Acy: 'А',
  Afr: '𝔄',
  Agrave: 'À',
  Alpha: 'Α',
  Amacr: 'Ā',
  And: '⩓',
  Aogon: 'Ą',
  Aopf: '𝔸',
  ApplyFunction: '⁡',
  Aring: 'Å',
  Ascr: '𝒜',
  Assign: '≔',
  Atilde: 'Ã',
  Auml: 'Ä',
  Backslash: '∖',
  Barv: '⫧',
  Barwed: '⌆',
  Bcy: 'Б',
  Because: '∵',
  Bernoullis: 'ℬ',
  Beta: 'Β',
  Bfr: '𝔅',
  Bopf: '𝔹',
  Breve: '˘',
  Bscr: 'ℬ',
  Bumpeq: '≎',
  CHcy: 'Ч',
  COPY: '©',
  Cacute: 'Ć',
  Cap: '⋒',
  CapitalDifferentialD: 'ⅅ',
  Cayleys: 'ℭ',
  Ccaron: 'Č',
  Ccedil: 'Ç',
  Ccirc: 'Ĉ',
  Cconint: '∰',
  Cdot: 'Ċ',
  Cedilla: '¸',
  CenterDot: '·',
  Cfr: 'ℭ',
  Chi: 'Χ',
  CircleDot: '⊙',
  CircleMinus: '⊖',
  CirclePlus: '⊕',
  CircleTimes: '⊗',
  ClockwiseContourIntegral: '∲',
  CloseCurlyDoubleQuote: '”',
  CloseCurlyQuote: '’',
  Colon: '∷',
  Colone: '⩴',
  Congruent: '≡',
  Conint: '∯',
  ContourIntegral: '∮',
  Copf: 'ℂ',
  Coproduct: '∐',
  CounterClockwiseContourIntegral: '∳',
  Cross: '⨯',
  Cscr: '𝒞',
  Cup: '⋓',
  CupCap: '≍',
  DD: 'ⅅ',
  DDotrahd: '⤑',
  DJcy: 'Ђ',
  DScy: 'Ѕ',
  DZcy: 'Џ',
  Dagger: '‡',
  Darr: '↡',
  Dashv: '⫤',
  Dcaron: 'Ď',
  Dcy: 'Д',
  Del: '∇',
  Delta: 'Δ',
  Dfr: '𝔇',
  DiacriticalAcute: '´',
  DiacriticalDot: '˙',
  DiacriticalDoubleAcute: '˝',
  DiacriticalGrave: '`',
  DiacriticalTilde: '˜',
  Diamond: '⋄',
  DifferentialD: 'ⅆ',
  Dopf: '𝔻',
  Dot: '¨',
  DotDot: '⃜',
  DotEqual: '≐',
  DoubleContourIntegral: '∯',
  DoubleDot: '¨',
  DoubleDownArrow: '⇓',
  DoubleLeftArrow: '⇐',
  DoubleLeftRightArrow: '⇔',
  DoubleLeftTee: '⫤',
  DoubleLongLeftArrow: '⟸',
  DoubleLongLeftRightArrow: '⟺',
  DoubleLongRightArrow: '⟹',
  DoubleRightArrow: '⇒',
  DoubleRightTee: '⊨',
  DoubleUpArrow: '⇑',
  DoubleUpDownArrow: '⇕',
  DoubleVerticalBar: '∥',
  DownArrow: '↓',
  DownArrowBar: '⤓',
  DownArrowUpArrow: '⇵',
  DownBreve: '̑',
  DownLeftRightVector: '⥐',
  DownLeftTeeVector: '⥞',
  DownLeftVector: '↽',
  DownLeftVectorBar: '⥖',
  DownRightTeeVector: '⥟',
  DownRightVector: '⇁',
  DownRightVectorBar: '⥗',
  DownTee: '⊤',
  DownTeeArrow: '↧',
  Downarrow: '⇓',
  Dscr: '𝒟',
  Dstrok: 'Đ',
  ENG: 'Ŋ',
  ETH: 'Ð',
  Eacute: 'É',
  Ecaron: 'Ě',
  Ecirc: 'Ê',
  Ecy: 'Э',
  Edot: 'Ė',
  Efr: '𝔈',
  Egrave: 'È',
  Element: '∈',
  Emacr: 'Ē',
  EmptySmallSquare: '◻',
  EmptyVerySmallSquare: '▫',
  Eogon: 'Ę',
  Eopf: '𝔼',
  Epsilon: 'Ε',
  Equal: '⩵',
  EqualTilde: '≂',
  Equilibrium: '⇌',
  Escr: 'ℰ',
  Esim: '⩳',
  Eta: 'Η',
  Euml: 'Ë',
  Exists: '∃',
  ExponentialE: 'ⅇ',
  Fcy: 'Ф',
  Ffr: '𝔉',
  FilledSmallSquare: '◼',
  FilledVerySmallSquare: '▪',
  Fopf: '𝔽',
  ForAll: '∀',
  Fouriertrf: 'ℱ',
  Fscr: 'ℱ',
  GJcy: 'Ѓ',
  GT: '>',
  Gamma: 'Γ',
  Gammad: 'Ϝ',
  Gbreve: 'Ğ',
  Gcedil: 'Ģ',
  Gcirc: 'Ĝ',
  Gcy: 'Г',
  Gdot: 'Ġ',
  Gfr: '𝔊',
  Gg: '⋙',
  Gopf: '𝔾',
  GreaterEqual: '≥',
  GreaterEqualLess: '⋛',
  GreaterFullEqual: '≧',
  GreaterGreater: '⪢',
  GreaterLess: '≷',
  GreaterSlantEqual: '⩾',
  GreaterTilde: '≳',
  Gscr: '𝒢',
  Gt: '≫',
  HARDcy: 'Ъ',
  Hacek: 'ˇ',
  Hat: '^',
  Hcirc: 'Ĥ',
  Hfr: 'ℌ',
  HilbertSpace: 'ℋ',
  Hopf: 'ℍ',
  HorizontalLine: '─',
  Hscr: 'ℋ',
  Hstrok: 'Ħ',
  HumpDownHump: '≎',
  HumpEqual: '≏',
  IEcy: 'Е',
  IJlig: 'Ĳ',
  IOcy: 'Ё',
  Iacute: 'Í',
  Icirc: 'Î',
  Icy: 'И',
  Idot: 'İ',
  Ifr: 'ℑ',
  Igrave: 'Ì',
  Im: 'ℑ',
  Imacr: 'Ī',
  ImaginaryI: 'ⅈ',
  Implies: '⇒',
  Int: '∬',
  Integral: '∫',
  Intersection: '⋂',
  InvisibleComma: '⁣',
  InvisibleTimes: '⁢',
  Iogon: 'Į',
  Iopf: '𝕀',
  Iota: 'Ι',
  Iscr: 'ℐ',
  Itilde: 'Ĩ',
  Iukcy: 'І',
  Iuml: 'Ï',
  Jcirc: 'Ĵ',
  Jcy: 'Й',
  Jfr: '𝔍',
  Jopf: '𝕁',
  Jscr: '𝒥',
  Jsercy: 'Ј',
  Jukcy: 'Є',
  KHcy: 'Х',
  KJcy: 'Ќ',
  Kappa: 'Κ',
  Kcedil: 'Ķ',
  Kcy: 'К',
  Kfr: '𝔎',
  Kopf: '𝕂',
  Kscr: '𝒦',
  LJcy: 'Љ',
  LT: '<',
  Lacute: 'Ĺ',
  Lambda: 'Λ',
  Lang: '⟪',
  Laplacetrf: 'ℒ',
  Larr: '↞',
  Lcaron: 'Ľ',
  Lcedil: 'Ļ',
  Lcy: 'Л',
  LeftAngleBracket: '⟨',
  LeftArrow: '←',
  LeftArrowBar: '⇤',
  LeftArrowRightArrow: '⇆',
  LeftCeiling: '⌈',
  LeftDoubleBracket: '⟦',
  LeftDownTeeVector: '⥡',
  LeftDownVector: '⇃',
  LeftDownVectorBar: '⥙',
  LeftFloor: '⌊',
  LeftRightArrow: '↔',
  LeftRightVector: '⥎',
  LeftTee: '⊣',
  LeftTeeArrow: '↤',
  LeftTeeVector: '⥚',
  LeftTriangle: '⊲',
  LeftTriangleBar: '⧏',
  LeftTriangleEqual: '⊴',
  LeftUpDownVector: '⥑',
  LeftUpTeeVector: '⥠',
  LeftUpVector: '↿',
  LeftUpVectorBar: '⥘',
  LeftVector: '↼',
  LeftVectorBar: '⥒',
  Leftarrow: '⇐',
  Leftrightarrow: '⇔',
  LessEqualGreater: '⋚',
  LessFullEqual: '≦',
  LessGreater: '≶',
  LessLess: '⪡',
  LessSlantEqual: '⩽',
  LessTilde: '≲',
  Lfr: '𝔏',
  Ll: '⋘',
  Lleftarrow: '⇚',
  Lmidot: 'Ŀ',
  LongLeftArrow: '⟵',
  LongLeftRightArrow: '⟷',
  LongRightArrow: '⟶',
  Longleftarrow: '⟸',
  Longleftrightarrow: '⟺',
  Longrightarrow: '⟹',
  Lopf: '𝕃',
  LowerLeftArrow: '↙',
  LowerRightArrow: '↘',
  Lscr: 'ℒ',
  Lsh: '↰',
  Lstrok: 'Ł',
  Lt: '≪',
  Map: '⤅',
  Mcy: 'М',
  MediumSpace: ' ',
  Mellintrf: 'ℳ',
  Mfr: '𝔐',
  MinusPlus: '∓',
  Mopf: '𝕄',
  Mscr: 'ℳ',
  Mu: 'Μ',
  NJcy: 'Њ',
  Nacute: 'Ń',
  Ncaron: 'Ň',
  Ncedil: 'Ņ',
  Ncy: 'Н',
  NegativeMediumSpace: '​',
  NegativeThickSpace: '​',
  NegativeThinSpace: '​',
  NegativeVeryThinSpace: '​',
  NestedGreaterGreater: '≫',
  NestedLessLess: '≪',
  NewLine: '\n',
  Nfr: '𝔑',
  NoBreak: '⁠',
  NonBreakingSpace: ' ',
  Nopf: 'ℕ',
  Not: '⫬',
  NotCongruent: '≢',
  NotCupCap: '≭',
  NotDoubleVerticalBar: '∦',
  NotElement: '∉',
  NotEqual: '≠',
  NotEqualTilde: '≂̸',
  NotExists: '∄',
  NotGreater: '≯',
  NotGreaterEqual: '≱',
  NotGreaterFullEqual: '≧̸',
  NotGreaterGreater: '≫̸',
  NotGreaterLess: '≹',
  NotGreaterSlantEqual: '⩾̸',
  NotGreaterTilde: '≵',
  NotHumpDownHump: '≎̸',
  NotHumpEqual: '≏̸',
  NotLeftTriangle: '⋪',
  NotLeftTriangleBar: '⧏̸',
  NotLeftTriangleEqual: '⋬',
  NotLess: '≮',
  NotLessEqual: '≰',
  NotLessGreater: '≸',
  NotLessLess: '≪̸',
  NotLessSlantEqual: '⩽̸',
  NotLessTilde: '≴',
  NotNestedGreaterGreater: '⪢̸',
  NotNestedLessLess: '⪡̸',
  NotPrecedes: '⊀',
  NotPrecedesEqual: '⪯̸',
  NotPrecedesSlantEqual: '⋠',
  NotReverseElement: '∌',
  NotRightTriangle: '⋫',
  NotRightTriangleBar: '⧐̸',
  NotRightTriangleEqual: '⋭',
  NotSquareSubset: '⊏̸',
  NotSquareSubsetEqual: '⋢',
  NotSquareSuperset: '⊐̸',
  NotSquareSupersetEqual: '⋣',
  NotSubset: '⊂⃒',
  NotSubsetEqual: '⊈',
  NotSucceeds: '⊁',
  NotSucceedsEqual: '⪰̸',
  NotSucceedsSlantEqual: '⋡',
  NotSucceedsTilde: '≿̸',
  NotSuperset: '⊃⃒',
  NotSupersetEqual: '⊉',
  NotTilde: '≁',
  NotTildeEqual: '≄',
  NotTildeFullEqual: '≇',
  NotTildeTilde: '≉',
  NotVerticalBar: '∤',
  Nscr: '𝒩',
  Ntilde: 'Ñ',
  Nu: 'Ν',
  OElig: 'Œ',
  Oacute: 'Ó',
  Ocirc: 'Ô',
  Ocy: 'О',
  Odblac: 'Ő',
  Ofr: '𝔒',
  Ograve: 'Ò',
  Omacr: 'Ō',
  Omega: 'Ω',
  Omicron: 'Ο',
  Oopf: '𝕆',
  OpenCurlyDoubleQuote: '“',
  OpenCurlyQuote: '‘',
  Or: '⩔',
  Oscr: '𝒪',
  Oslash: 'Ø',
  Otilde: 'Õ',
  Otimes: '⨷',
  Ouml: 'Ö',
  OverBar: '‾',
  OverBrace: '⏞',
  OverBracket: '⎴',
  OverParenthesis: '⏜',
  PartialD: '∂',
  Pcy: 'П',
  Pfr: '𝔓',
  Phi: 'Φ',
  Pi: 'Π',
  PlusMinus: '±',
  Poincareplane: 'ℌ',
  Popf: 'ℙ',
  Pr: '⪻',
  Precedes: '≺',
  PrecedesEqual: '⪯',
  PrecedesSlantEqual: '≼',
  PrecedesTilde: '≾',
  Prime: '″',
  Product: '∏',
  Proportion: '∷',
  Proportional: '∝',
  Pscr: '𝒫',
  Psi: 'Ψ',
  QUOT: '"',
  Qfr: '𝔔',
  Qopf: 'ℚ',
  Qscr: '𝒬',
  RBarr: '⤐',
  REG: '®',
  Racute: 'Ŕ',
  Rang: '⟫',
  Rarr: '↠',
  Rarrtl: '⤖',
  Rcaron: 'Ř',
  Rcedil: 'Ŗ',
  Rcy: 'Р',
  Re: 'ℜ',
  ReverseElement: '∋',
  ReverseEquilibrium: '⇋',
  ReverseUpEquilibrium: '⥯',
  Rfr: 'ℜ',
  Rho: 'Ρ',
  RightAngleBracket: '⟩',
  RightArrow: '→',
  RightArrowBar: '⇥',
  RightArrowLeftArrow: '⇄',
  RightCeiling: '⌉',
  RightDoubleBracket: '⟧',
  RightDownTeeVector: '⥝',
  RightDownVector: '⇂',
  RightDownVectorBar: '⥕',
  RightFloor: '⌋',
  RightTee: '⊢',
  RightTeeArrow: '↦',
  RightTeeVector: '⥛',
  RightTriangle: '⊳',
  RightTriangleBar: '⧐',
  RightTriangleEqual: '⊵',
  RightUpDownVector: '⥏',
  RightUpTeeVector: '⥜',
  RightUpVector: '↾',
  RightUpVectorBar: '⥔',
  RightVector: '⇀',
  RightVectorBar: '⥓',
  Rightarrow: '⇒',
  Ropf: 'ℝ',
  RoundImplies: '⥰',
  Rrightarrow: '⇛',
  Rscr: 'ℛ',
  Rsh: '↱',
  RuleDelayed: '⧴',
  SHCHcy: 'Щ',
  SHcy: 'Ш',
  SOFTcy: 'Ь',
  Sacute: 'Ś',
  Sc: '⪼',
  Scaron: 'Š',
  Scedil: 'Ş',
  Scirc: 'Ŝ',
  Scy: 'С',
  Sfr: '𝔖',
  ShortDownArrow: '↓',
  ShortLeftArrow: '←',
  ShortRightArrow: '→',
  ShortUpArrow: '↑',
  Sigma: 'Σ',
  SmallCircle: '∘',
  Sopf: '𝕊',
  Sqrt: '√',
  Square: '□',
  SquareIntersection: '⊓',
  SquareSubset: '⊏',
  SquareSubsetEqual: '⊑',
  SquareSuperset: '⊐',
  SquareSupersetEqual: '⊒',
  SquareUnion: '⊔',
  Sscr: '𝒮',
  Star: '⋆',
  Sub: '⋐',
  Subset: '⋐',
  SubsetEqual: '⊆',
  Succeeds: '≻',
  SucceedsEqual: '⪰',
  SucceedsSlantEqual: '≽',
  SucceedsTilde: '≿',
  SuchThat: '∋',
  Sum: '∑',
  Sup: '⋑',
  Superset: '⊃',
  SupersetEqual: '⊇',
  Supset: '⋑',
  THORN: 'Þ',
  TRADE: '™',
  TSHcy: 'Ћ',
  TScy: 'Ц',
  Tab: '\t',
  Tau: 'Τ',
  Tcaron: 'Ť',
  Tcedil: 'Ţ',
  Tcy: 'Т',
  Tfr: '𝔗',
  Therefore: '∴',
  Theta: 'Θ',
  ThickSpace: '  ',
  ThinSpace: ' ',
  Tilde: '∼',
  TildeEqual: '≃',
  TildeFullEqual: '≅',
  TildeTilde: '≈',
  Topf: '𝕋',
  TripleDot: '⃛',
  Tscr: '𝒯',
  Tstrok: 'Ŧ',
  Uacute: 'Ú',
  Uarr: '↟',
  Uarrocir: '⥉',
  Ubrcy: 'Ў',
  Ubreve: 'Ŭ',
  Ucirc: 'Û',
  Ucy: 'У',
  Udblac: 'Ű',
  Ufr: '𝔘',
  Ugrave: 'Ù',
  Umacr: 'Ū',
  UnderBar: '_',
  UnderBrace: '⏟',
  UnderBracket: '⎵',
  UnderParenthesis: '⏝',
  Union: '⋃',
  UnionPlus: '⊎',
  Uogon: 'Ų',
  Uopf: '𝕌',
  UpArrow: '↑',
  UpArrowBar: '⤒',
  UpArrowDownArrow: '⇅',
  UpDownArrow: '↕',
  UpEquilibrium: '⥮',
  UpTee: '⊥',
  UpTeeArrow: '↥',
  Uparrow: '⇑',
  Updownarrow: '⇕',
  UpperLeftArrow: '↖',
  UpperRightArrow: '↗',
  Upsi: 'ϒ',
  Upsilon: 'Υ',
  Uring: 'Ů',
  Uscr: '𝒰',
  Utilde: 'Ũ',
  Uuml: 'Ü',
  VDash: '⊫',
  Vbar: '⫫',
  Vcy: 'В',
  Vdash: '⊩',
  Vdashl: '⫦',
  Vee: '⋁',
  Verbar: '‖',
  Vert: '‖',
  VerticalBar: '∣',
  VerticalLine: '|',
  VerticalSeparator: '❘',
  VerticalTilde: '≀',
  VeryThinSpace: ' ',
  Vfr: '𝔙',
  Vopf: '𝕍',
  Vscr: '𝒱',
  Vvdash: '⊪',
  Wcirc: 'Ŵ',
  Wedge: '⋀',
  Wfr: '𝔚',
  Wopf: '𝕎',
  Wscr: '𝒲',
  Xfr: '𝔛',
  Xi: 'Ξ',
  Xopf: '𝕏',
  Xscr: '𝒳',
  YAcy: 'Я',
  YIcy: 'Ї',
  YUcy: 'Ю',
  Yacute: 'Ý',
  Ycirc: 'Ŷ',
  Ycy: 'Ы',
  Yfr: '𝔜',
  Yopf: '𝕐',
  Yscr: '𝒴',
  Yuml: 'Ÿ',
  ZHcy: 'Ж',
  Zacute: 'Ź',
  Zcaron: 'Ž',
  Zcy: 'З',
  Zdot: 'Ż',
  ZeroWidthSpace: '​',
  Zeta: 'Ζ',
  Zfr: 'ℨ',
  Zopf: 'ℤ',
  Zscr: '𝒵',
  aacute: 'á',
  abreve: 'ă',
  ac: '∾',
  acE: '∾̳',
  acd: '∿',
  acirc: 'â',
  acute: '´',
  acy: 'а',
  aelig: 'æ',
  af: '⁡',
  afr: '𝔞',
  agrave: 'à',
  alefsym: 'ℵ',
  aleph: 'ℵ',
  alpha: 'α',
  amacr: 'ā',
  amalg: '⨿',
  amp: '&',
  and: '∧',
  andand: '⩕',
  andd: '⩜',
  andslope: '⩘',
  andv: '⩚',
  ang: '∠',
  ange: '⦤',
  angle: '∠',
  angmsd: '∡',
  angmsdaa: '⦨',
  angmsdab: '⦩',
  angmsdac: '⦪',
  angmsdad: '⦫',
  angmsdae: '⦬',
  angmsdaf: '⦭',
  angmsdag: '⦮',
  angmsdah: '⦯',
  angrt: '∟',
  angrtvb: '⊾',
  angrtvbd: '⦝',
  angsph: '∢',
  angst: 'Å',
  angzarr: '⍼',
  aogon: 'ą',
  aopf: '𝕒',
  ap: '≈',
  apE: '⩰',
  apacir: '⩯',
  ape: '≊',
  apid: '≋',
  apos: "'",
  approx: '≈',
  approxeq: '≊',
  aring: 'å',
  ascr: '𝒶',
  ast: '*',
  asymp: '≈',
  asympeq: '≍',
  atilde: 'ã',
  auml: 'ä',
  awconint: '∳',
  awint: '⨑',
  bNot: '⫭',
  backcong: '≌',
  backepsilon: '϶',
  backprime: '‵',
  backsim: '∽',
  backsimeq: '⋍',
  barvee: '⊽',
  barwed: '⌅',
  barwedge: '⌅',
  bbrk: '⎵',
  bbrktbrk: '⎶',
  bcong: '≌',
  bcy: 'б',
  bdquo: '„',
  becaus: '∵',
  because: '∵',
  bemptyv: '⦰',
  bepsi: '϶',
  bernou: 'ℬ',
  beta: 'β',
  beth: 'ℶ',
  between: '≬',
  bfr: '𝔟',
  bigcap: '⋂',
  bigcirc: '◯',
  bigcup: '⋃',
  bigodot: '⨀',
  bigoplus: '⨁',
  bigotimes: '⨂',
  bigsqcup: '⨆',
  bigstar: '★',
  bigtriangledown: '▽',
  bigtriangleup: '△',
  biguplus: '⨄',
  bigvee: '⋁',
  bigwedge: '⋀',
  bkarow: '⤍',
  blacklozenge: '⧫',
  blacksquare: '▪',
  blacktriangle: '▴',
  blacktriangledown: '▾',
  blacktriangleleft: '◂',
  blacktriangleright: '▸',
  blank: '␣',
  blk12: '▒',
  blk14: '░',
  blk34: '▓',
  block: '█',
  bne: '=⃥',
  bnequiv: '≡⃥',
  bnot: '⌐',
  bopf: '𝕓',
  bot: '⊥',
  bottom: '⊥',
  bowtie: '⋈',
  boxDL: '╗',
  boxDR: '╔',
  boxDl: '╖',
  boxDr: '╓',
  boxH: '═',
  boxHD: '╦',
  boxHU: '╩',
  boxHd: '╤',
  boxHu: '╧',
  boxUL: '╝',
  boxUR: '╚',
  boxUl: '╜',
  boxUr: '╙',
  boxV: '║',
  boxVH: '╬',
  boxVL: '╣',
  boxVR: '╠',
  boxVh: '╫',
  boxVl: '╢',
  boxVr: '╟',
  boxbox: '⧉',
  boxdL: '╕',
  boxdR: '╒',
  boxdl: '┐',
  boxdr: '┌',
  boxh: '─',
  boxhD: '╥',
  boxhU: '╨',
  boxhd: '┬',
  boxhu: '┴',
  boxminus: '⊟',
  boxplus: '⊞',
  boxtimes: '⊠',
  boxuL: '╛',
  boxuR: '╘',
  boxul: '┘',
  boxur: '└',
  boxv: '│',
  boxvH: '╪',
  boxvL: '╡',
  boxvR: '╞',
  boxvh: '┼',
  boxvl: '┤',
  boxvr: '├',
  bprime: '‵',
  breve: '˘',
  brvbar: '¦',
  bscr: '𝒷',
  bsemi: '⁏',
  bsim: '∽',
  bsime: '⋍',
  bsol: '\\',
  bsolb: '⧅',
  bsolhsub: '⟈',
  bull: '•',
  bullet: '•',
  bump: '≎',
  bumpE: '⪮',
  bumpe: '≏',
  bumpeq: '≏',
  cacute: 'ć',
  cap: '∩',
  capand: '⩄',
  capbrcup: '⩉',
  capcap: '⩋',
  capcup: '⩇',
  capdot: '⩀',
  caps: '∩︀',
  caret: '⁁',
  caron: 'ˇ',
  ccaps: '⩍',
  ccaron: 'č',
  ccedil: 'ç',
  ccirc: 'ĉ',
  ccups: '⩌',
  ccupssm: '⩐',
  cdot: 'ċ',
  cedil: '¸',
  cemptyv: '⦲',
  cent: '¢',
  centerdot: '·',
  cfr: '𝔠',
  chcy: 'ч',
  check: '✓',
  checkmark: '✓',
  chi: 'χ',
  cir: '○',
  cirE: '⧃',
  circ: 'ˆ',
  circeq: '≗',
  circlearrowleft: '↺',
  circlearrowright: '↻',
  circledR: '®',
  circledS: 'Ⓢ',
  circledast: '⊛',
  circledcirc: '⊚',
  circleddash: '⊝',
  cire: '≗',
  cirfnint: '⨐',
  cirmid: '⫯',
  cirscir: '⧂',
  clubs: '♣',
  clubsuit: '♣',
  colon: ':',
  colone: '≔',
  coloneq: '≔',
  comma: ',',
  commat: '@',
  comp: '∁',
  compfn: '∘',
  complement: '∁',
  complexes: 'ℂ',
  cong: '≅',
  congdot: '⩭',
  conint: '∮',
  copf: '𝕔',
  coprod: '∐',
  copy: '©',
  copysr: '℗',
  crarr: '↵',
  cross: '✗',
  cscr: '𝒸',
  csub: '⫏',
  csube: '⫑',
  csup: '⫐',
  csupe: '⫒',
  ctdot: '⋯',
  cudarrl: '⤸',
  cudarrr: '⤵',
  cuepr: '⋞',
  cuesc: '⋟',
  cularr: '↶',
  cularrp: '⤽',
  cup: '∪',
  cupbrcap: '⩈',
  cupcap: '⩆',
  cupcup: '⩊',
  cupdot: '⊍',
  cupor: '⩅',
  cups: '∪︀',
  curarr: '↷',
  curarrm: '⤼',
  curlyeqprec: '⋞',
  curlyeqsucc: '⋟',
  curlyvee: '⋎',
  curlywedge: '⋏',
  curren: '¤',
  curvearrowleft: '↶',
  curvearrowright: '↷',
  cuvee: '⋎',
  cuwed: '⋏',
  cwconint: '∲',
  cwint: '∱',
  cylcty: '⌭',
  dArr: '⇓',
  dHar: '⥥',
  dagger: '†',
  daleth: 'ℸ',
  darr: '↓',
  dash: '‐',
  dashv: '⊣',
  dbkarow: '⤏',
  dblac: '˝',
  dcaron: 'ď',
  dcy: 'д',
  dd: 'ⅆ',
  ddagger: '‡',
  ddarr: '⇊',
  ddotseq: '⩷',
  deg: '°',
  delta: 'δ',
  demptyv: '⦱',
  dfisht: '⥿',
  dfr: '𝔡',
  dharl: '⇃',
  dharr: '⇂',
  diam: '⋄',
  diamond: '⋄',
  diamondsuit: '♦',
  diams: '♦',
  die: '¨',
  digamma: 'ϝ',
  disin: '⋲',
  div: '÷',
  divide: '÷',
  divideontimes: '⋇',
  divonx: '⋇',
  djcy: 'ђ',
  dlcorn: '⌞',
  dlcrop: '⌍',
  dollar: '$',
  dopf: '𝕕',
  dot: '˙',
  doteq: '≐',
  doteqdot: '≑',
  dotminus: '∸',
  dotplus: '∔',
  dotsquare: '⊡',
  doublebarwedge: '⌆',
  downarrow: '↓',
  downdownarrows: '⇊',
  downharpoonleft: '⇃',
  downharpoonright: '⇂',
  drbkarow: '⤐',
  drcorn: '⌟',
  drcrop: '⌌',
  dscr: '𝒹',
  dscy: 'ѕ',
  dsol: '⧶',
  dstrok: 'đ',
  dtdot: '⋱',
  dtri: '▿',
  dtrif: '▾',
  duarr: '⇵',
  duhar: '⥯',
  dwangle: '⦦',
  dzcy: 'џ',
  dzigrarr: '⟿',
  eDDot: '⩷',
  eDot: '≑',
  eacute: 'é',
  easter: '⩮',
  ecaron: 'ě',
  ecir: '≖',
  ecirc: 'ê',
  ecolon: '≕',
  ecy: 'э',
  edot: 'ė',
  ee: 'ⅇ',
  efDot: '≒',
  efr: '𝔢',
  eg: '⪚',
  egrave: 'è',
  egs: '⪖',
  egsdot: '⪘',
  el: '⪙',
  elinters: '⏧',
  ell: 'ℓ',
  els: '⪕',
  elsdot: '⪗',
  emacr: 'ē',
  empty: '∅',
  emptyset: '∅',
  emptyv: '∅',
  emsp13: ' ',
  emsp14: ' ',
  emsp: ' ',
  eng: 'ŋ',
  ensp: ' ',
  eogon: 'ę',
  eopf: '𝕖',
  epar: '⋕',
  eparsl: '⧣',
  eplus: '⩱',
  epsi: 'ε',
  epsilon: 'ε',
  epsiv: 'ϵ',
  eqcirc: '≖',
  eqcolon: '≕',
  eqsim: '≂',
  eqslantgtr: '⪖',
  eqslantless: '⪕',
  equals: '=',
  equest: '≟',
  equiv: '≡',
  equivDD: '⩸',
  eqvparsl: '⧥',
  erDot: '≓',
  erarr: '⥱',
  escr: 'ℯ',
  esdot: '≐',
  esim: '≂',
  eta: 'η',
  eth: 'ð',
  euml: 'ë',
  euro: '€',
  excl: '!',
  exist: '∃',
  expectation: 'ℰ',
  exponentiale: 'ⅇ',
  fallingdotseq: '≒',
  fcy: 'ф',
  female: '♀',
  ffilig: 'ﬃ',
  fflig: 'ﬀ',
  ffllig: 'ﬄ',
  ffr: '𝔣',
  filig: 'ﬁ',
  fjlig: 'fj',
  flat: '♭',
  fllig: 'ﬂ',
  fltns: '▱',
  fnof: 'ƒ',
  fopf: '𝕗',
  forall: '∀',
  fork: '⋔',
  forkv: '⫙',
  fpartint: '⨍',
  frac12: '½',
  frac13: '⅓',
  frac14: '¼',
  frac15: '⅕',
  frac16: '⅙',
  frac18: '⅛',
  frac23: '⅔',
  frac25: '⅖',
  frac34: '¾',
  frac35: '⅗',
  frac38: '⅜',
  frac45: '⅘',
  frac56: '⅚',
  frac58: '⅝',
  frac78: '⅞',
  frasl: '⁄',
  frown: '⌢',
  fscr: '𝒻',
  gE: '≧',
  gEl: '⪌',
  gacute: 'ǵ',
  gamma: 'γ',
  gammad: 'ϝ',
  gap: '⪆',
  gbreve: 'ğ',
  gcirc: 'ĝ',
  gcy: 'г',
  gdot: 'ġ',
  ge: '≥',
  gel: '⋛',
  geq: '≥',
  geqq: '≧',
  geqslant: '⩾',
  ges: '⩾',
  gescc: '⪩',
  gesdot: '⪀',
  gesdoto: '⪂',
  gesdotol: '⪄',
  gesl: '⋛︀',
  gesles: '⪔',
  gfr: '𝔤',
  gg: '≫',
  ggg: '⋙',
  gimel: 'ℷ',
  gjcy: 'ѓ',
  gl: '≷',
  glE: '⪒',
  gla: '⪥',
  glj: '⪤',
  gnE: '≩',
  gnap: '⪊',
  gnapprox: '⪊',
  gne: '⪈',
  gneq: '⪈',
  gneqq: '≩',
  gnsim: '⋧',
  gopf: '𝕘',
  grave: '`',
  gscr: 'ℊ',
  gsim: '≳',
  gsime: '⪎',
  gsiml: '⪐',
  gt: '>',
  gtcc: '⪧',
  gtcir: '⩺',
  gtdot: '⋗',
  gtlPar: '⦕',
  gtquest: '⩼',
  gtrapprox: '⪆',
  gtrarr: '⥸',
  gtrdot: '⋗',
  gtreqless: '⋛',
  gtreqqless: '⪌',
  gtrless: '≷',
  gtrsim: '≳',
  gvertneqq: '≩︀',
  gvnE: '≩︀',
  hArr: '⇔',
  hairsp: ' ',
  half: '½',
  hamilt: 'ℋ',
  hardcy: 'ъ',
  harr: '↔',
  harrcir: '⥈',
  harrw: '↭',
  hbar: 'ℏ',
  hcirc: 'ĥ',
  hearts: '♥',
  heartsuit: '♥',
  hellip: '…',
  hercon: '⊹',
  hfr: '𝔥',
  hksearow: '⤥',
  hkswarow: '⤦',
  hoarr: '⇿',
  homtht: '∻',
  hookleftarrow: '↩',
  hookrightarrow: '↪',
  hopf: '𝕙',
  horbar: '―',
  hscr: '𝒽',
  hslash: 'ℏ',
  hstrok: 'ħ',
  hybull: '⁃',
  hyphen: '‐',
  iacute: 'í',
  ic: '⁣',
  icirc: 'î',
  icy: 'и',
  iecy: 'е',
  iexcl: '¡',
  iff: '⇔',
  ifr: '𝔦',
  igrave: 'ì',
  ii: 'ⅈ',
  iiiint: '⨌',
  iiint: '∭',
  iinfin: '⧜',
  iiota: '℩',
  ijlig: 'ĳ',
  imacr: 'ī',
  image: 'ℑ',
  imagline: 'ℐ',
  imagpart: 'ℑ',
  imath: 'ı',
  imof: '⊷',
  imped: 'Ƶ',
  in: '∈',
  incare: '℅',
  infin: '∞',
  infintie: '⧝',
  inodot: 'ı',
  int: '∫',
  intcal: '⊺',
  integers: 'ℤ',
  intercal: '⊺',
  intlarhk: '⨗',
  intprod: '⨼',
  iocy: 'ё',
  iogon: 'į',
  iopf: '𝕚',
  iota: 'ι',
  iprod: '⨼',
  iquest: '¿',
  iscr: '𝒾',
  isin: '∈',
  isinE: '⋹',
  isindot: '⋵',
  isins: '⋴',
  isinsv: '⋳',
  isinv: '∈',
  it: '⁢',
  itilde: 'ĩ',
  iukcy: 'і',
  iuml: 'ï',
  jcirc: 'ĵ',
  jcy: 'й',
  jfr: '𝔧',
  jmath: 'ȷ',
  jopf: '𝕛',
  jscr: '𝒿',
  jsercy: 'ј',
  jukcy: 'є',
  kappa: 'κ',
  kappav: 'ϰ',
  kcedil: 'ķ',
  kcy: 'к',
  kfr: '𝔨',
  kgreen: 'ĸ',
  khcy: 'х',
  kjcy: 'ќ',
  kopf: '𝕜',
  kscr: '𝓀',
  lAarr: '⇚',
  lArr: '⇐',
  lAtail: '⤛',
  lBarr: '⤎',
  lE: '≦',
  lEg: '⪋',
  lHar: '⥢',
  lacute: 'ĺ',
  laemptyv: '⦴',
  lagran: 'ℒ',
  lambda: 'λ',
  lang: '⟨',
  langd: '⦑',
  langle: '⟨',
  lap: '⪅',
  laquo: '«',
  larr: '←',
  larrb: '⇤',
  larrbfs: '⤟',
  larrfs: '⤝',
  larrhk: '↩',
  larrlp: '↫',
  larrpl: '⤹',
  larrsim: '⥳',
  larrtl: '↢',
  lat: '⪫',
  latail: '⤙',
  late: '⪭',
  lates: '⪭︀',
  lbarr: '⤌',
  lbbrk: '❲',
  lbrace: '{',
  lbrack: '[',
  lbrke: '⦋',
  lbrksld: '⦏',
  lbrkslu: '⦍',
  lcaron: 'ľ',
  lcedil: 'ļ',
  lceil: '⌈',
  lcub: '{',
  lcy: 'л',
  ldca: '⤶',
  ldquo: '“',
  ldquor: '„',
  ldrdhar: '⥧',
  ldrushar: '⥋',
  ldsh: '↲',
  le: '≤',
  leftarrow: '←',
  leftarrowtail: '↢',
  leftharpoondown: '↽',
  leftharpoonup: '↼',
  leftleftarrows: '⇇',
  leftrightarrow: '↔',
  leftrightarrows: '⇆',
  leftrightharpoons: '⇋',
  leftrightsquigarrow: '↭',
  leftthreetimes: '⋋',
  leg: '⋚',
  leq: '≤',
  leqq: '≦',
  leqslant: '⩽',
  les: '⩽',
  lescc: '⪨',
  lesdot: '⩿',
  lesdoto: '⪁',
  lesdotor: '⪃',
  lesg: '⋚︀',
  lesges: '⪓',
  lessapprox: '⪅',
  lessdot: '⋖',
  lesseqgtr: '⋚',
  lesseqqgtr: '⪋',
  lessgtr: '≶',
  lesssim: '≲',
  lfisht: '⥼',
  lfloor: '⌊',
  lfr: '𝔩',
  lg: '≶',
  lgE: '⪑',
  lhard: '↽',
  lharu: '↼',
  lharul: '⥪',
  lhblk: '▄',
  ljcy: 'љ',
  ll: '≪',
  llarr: '⇇',
  llcorner: '⌞',
  llhard: '⥫',
  lltri: '◺',
  lmidot: 'ŀ',
  lmoust: '⎰',
  lmoustache: '⎰',
  lnE: '≨',
  lnap: '⪉',
  lnapprox: '⪉',
  lne: '⪇',
  lneq: '⪇',
  lneqq: '≨',
  lnsim: '⋦',
  loang: '⟬',
  loarr: '⇽',
  lobrk: '⟦',
  longleftarrow: '⟵',
  longleftrightarrow: '⟷',
  longmapsto: '⟼',
  longrightarrow: '⟶',
  looparrowleft: '↫',
  looparrowright: '↬',
  lopar: '⦅',
  lopf: '𝕝',
  loplus: '⨭',
  lotimes: '⨴',
  lowast: '∗',
  lowbar: '_',
  loz: '◊',
  lozenge: '◊',
  lozf: '⧫',
  lpar: '(',
  lparlt: '⦓',
  lrarr: '⇆',
  lrcorner: '⌟',
  lrhar: '⇋',
  lrhard: '⥭',
  lrm: '‎',
  lrtri: '⊿',
  lsaquo: '‹',
  lscr: '𝓁',
  lsh: '↰',
  lsim: '≲',
  lsime: '⪍',
  lsimg: '⪏',
  lsqb: '[',
  lsquo: '‘',
  lsquor: '‚',
  lstrok: 'ł',
  lt: '<',
  ltcc: '⪦',
  ltcir: '⩹',
  ltdot: '⋖',
  lthree: '⋋',
  ltimes: '⋉',
  ltlarr: '⥶',
  ltquest: '⩻',
  ltrPar: '⦖',
  ltri: '◃',
  ltrie: '⊴',
  ltrif: '◂',
  lurdshar: '⥊',
  luruhar: '⥦',
  lvertneqq: '≨︀',
  lvnE: '≨︀',
  mDDot: '∺',
  macr: '¯',
  male: '♂',
  malt: '✠',
  maltese: '✠',
  map: '↦',
  mapsto: '↦',
  mapstodown: '↧',
  mapstoleft: '↤',
  mapstoup: '↥',
  marker: '▮',
  mcomma: '⨩',
  mcy: 'м',
  mdash: '—',
  measuredangle: '∡',
  mfr: '𝔪',
  mho: '℧',
  micro: 'µ',
  mid: '∣',
  midast: '*',
  midcir: '⫰',
  middot: '·',
  minus: '−',
  minusb: '⊟',
  minusd: '∸',
  minusdu: '⨪',
  mlcp: '⫛',
  mldr: '…',
  mnplus: '∓',
  models: '⊧',
  mopf: '𝕞',
  mp: '∓',
  mscr: '𝓂',
  mstpos: '∾',
  mu: 'μ',
  multimap: '⊸',
  mumap: '⊸',
  nGg: '⋙̸',
  nGt: '≫⃒',
  nGtv: '≫̸',
  nLeftarrow: '⇍',
  nLeftrightarrow: '⇎',
  nLl: '⋘̸',
  nLt: '≪⃒',
  nLtv: '≪̸',
  nRightarrow: '⇏',
  nVDash: '⊯',
  nVdash: '⊮',
  nabla: '∇',
  nacute: 'ń',
  nang: '∠⃒',
  nap: '≉',
  napE: '⩰̸',
  napid: '≋̸',
  napos: 'ŉ',
  napprox: '≉',
  natur: '♮',
  natural: '♮',
  naturals: 'ℕ',
  nbsp: ' ',
  nbump: '≎̸',
  nbumpe: '≏̸',
  ncap: '⩃',
  ncaron: 'ň',
  ncedil: 'ņ',
  ncong: '≇',
  ncongdot: '⩭̸',
  ncup: '⩂',
  ncy: 'н',
  ndash: '–',
  ne: '≠',
  neArr: '⇗',
  nearhk: '⤤',
  nearr: '↗',
  nearrow: '↗',
  nedot: '≐̸',
  nequiv: '≢',
  nesear: '⤨',
  nesim: '≂̸',
  nexist: '∄',
  nexists: '∄',
  nfr: '𝔫',
  ngE: '≧̸',
  nge: '≱',
  ngeq: '≱',
  ngeqq: '≧̸',
  ngeqslant: '⩾̸',
  nges: '⩾̸',
  ngsim: '≵',
  ngt: '≯',
  ngtr: '≯',
  nhArr: '⇎',
  nharr: '↮',
  nhpar: '⫲',
  ni: '∋',
  nis: '⋼',
  nisd: '⋺',
  niv: '∋',
  njcy: 'њ',
  nlArr: '⇍',
  nlE: '≦̸',
  nlarr: '↚',
  nldr: '‥',
  nle: '≰',
  nleftarrow: '↚',
  nleftrightarrow: '↮',
  nleq: '≰',
  nleqq: '≦̸',
  nleqslant: '⩽̸',
  nles: '⩽̸',
  nless: '≮',
  nlsim: '≴',
  nlt: '≮',
  nltri: '⋪',
  nltrie: '⋬',
  nmid: '∤',
  nopf: '𝕟',
  not: '¬',
  notin: '∉',
  notinE: '⋹̸',
  notindot: '⋵̸',
  notinva: '∉',
  notinvb: '⋷',
  notinvc: '⋶',
  notni: '∌',
  notniva: '∌',
  notnivb: '⋾',
  notnivc: '⋽',
  npar: '∦',
  nparallel: '∦',
  nparsl: '⫽⃥',
  npart: '∂̸',
  npolint: '⨔',
  npr: '⊀',
  nprcue: '⋠',
  npre: '⪯̸',
  nprec: '⊀',
  npreceq: '⪯̸',
  nrArr: '⇏',
  nrarr: '↛',
  nrarrc: '⤳̸',
  nrarrw: '↝̸',
  nrightarrow: '↛',
  nrtri: '⋫',
  nrtrie: '⋭',
  nsc: '⊁',
  nsccue: '⋡',
  nsce: '⪰̸',
  nscr: '𝓃',
  nshortmid: '∤',
  nshortparallel: '∦',
  nsim: '≁',
  nsime: '≄',
  nsimeq: '≄',
  nsmid: '∤',
  nspar: '∦',
  nsqsube: '⋢',
  nsqsupe: '⋣',
  nsub: '⊄',
  nsubE: '⫅̸',
  nsube: '⊈',
  nsubset: '⊂⃒',
  nsubseteq: '⊈',
  nsubseteqq: '⫅̸',
  nsucc: '⊁',
  nsucceq: '⪰̸',
  nsup: '⊅',
  nsupE: '⫆̸',
  nsupe: '⊉',
  nsupset: '⊃⃒',
  nsupseteq: '⊉',
  nsupseteqq: '⫆̸',
  ntgl: '≹',
  ntilde: 'ñ',
  ntlg: '≸',
  ntriangleleft: '⋪',
  ntrianglelefteq: '⋬',
  ntriangleright: '⋫',
  ntrianglerighteq: '⋭',
  nu: 'ν',
  num: '#',
  numero: '№',
  numsp: ' ',
  nvDash: '⊭',
  nvHarr: '⤄',
  nvap: '≍⃒',
  nvdash: '⊬',
  nvge: '≥⃒',
  nvgt: '>⃒',
  nvinfin: '⧞',
  nvlArr: '⤂',
  nvle: '≤⃒',
  nvlt: '<⃒',
  nvltrie: '⊴⃒',
  nvrArr: '⤃',
  nvrtrie: '⊵⃒',
  nvsim: '∼⃒',
  nwArr: '⇖',
  nwarhk: '⤣',
  nwarr: '↖',
  nwarrow: '↖',
  nwnear: '⤧',
  oS: 'Ⓢ',
  oacute: 'ó',
  oast: '⊛',
  ocir: '⊚',
  ocirc: 'ô',
  ocy: 'о',
  odash: '⊝',
  odblac: 'ő',
  odiv: '⨸',
  odot: '⊙',
  odsold: '⦼',
  oelig: 'œ',
  ofcir: '⦿',
  ofr: '𝔬',
  ogon: '˛',
  ograve: 'ò',
  ogt: '⧁',
  ohbar: '⦵',
  ohm: 'Ω',
  oint: '∮',
  olarr: '↺',
  olcir: '⦾',
  olcross: '⦻',
  oline: '‾',
  olt: '⧀',
  omacr: 'ō',
  omega: 'ω',
  omicron: 'ο',
  omid: '⦶',
  ominus: '⊖',
  oopf: '𝕠',
  opar: '⦷',
  operp: '⦹',
  oplus: '⊕',
  or: '∨',
  orarr: '↻',
  ord: '⩝',
  order: 'ℴ',
  orderof: 'ℴ',
  ordf: 'ª',
  ordm: 'º',
  origof: '⊶',
  oror: '⩖',
  orslope: '⩗',
  orv: '⩛',
  oscr: 'ℴ',
  oslash: 'ø',
  osol: '⊘',
  otilde: 'õ',
  otimes: '⊗',
  otimesas: '⨶',
  ouml: 'ö',
  ovbar: '⌽',
  par: '∥',
  para: '¶',
  parallel: '∥',
  parsim: '⫳',
  parsl: '⫽',
  part: '∂',
  pcy: 'п',
  percnt: '%',
  period: '.',
  permil: '‰',
  perp: '⊥',
  pertenk: '‱',
  pfr: '𝔭',
  phi: 'φ',
  phiv: 'ϕ',
  phmmat: 'ℳ',
  phone: '☎',
  pi: 'π',
  pitchfork: '⋔',
  piv: 'ϖ',
  planck: 'ℏ',
  planckh: 'ℎ',
  plankv: 'ℏ',
  plus: '+',
  plusacir: '⨣',
  plusb: '⊞',
  pluscir: '⨢',
  plusdo: '∔',
  plusdu: '⨥',
  pluse: '⩲',
  plusmn: '±',
  plussim: '⨦',
  plustwo: '⨧',
  pm: '±',
  pointint: '⨕',
  popf: '𝕡',
  pound: '£',
  pr: '≺',
  prE: '⪳',
  prap: '⪷',
  prcue: '≼',
  pre: '⪯',
  prec: '≺',
  precapprox: '⪷',
  preccurlyeq: '≼',
  preceq: '⪯',
  precnapprox: '⪹',
  precneqq: '⪵',
  precnsim: '⋨',
  precsim: '≾',
  prime: '′',
  primes: 'ℙ',
  prnE: '⪵',
  prnap: '⪹',
  prnsim: '⋨',
  prod: '∏',
  profalar: '⌮',
  profline: '⌒',
  profsurf: '⌓',
  prop: '∝',
  propto: '∝',
  prsim: '≾',
  prurel: '⊰',
  pscr: '𝓅',
  psi: 'ψ',
  puncsp: ' ',
  qfr: '𝔮',
  qint: '⨌',
  qopf: '𝕢',
  qprime: '⁗',
  qscr: '𝓆',
  quaternions: 'ℍ',
  quatint: '⨖',
  quest: '?',
  questeq: '≟',
  quot: '"',
  rAarr: '⇛',
  rArr: '⇒',
  rAtail: '⤜',
  rBarr: '⤏',
  rHar: '⥤',
  race: '∽̱',
  racute: 'ŕ',
  radic: '√',
  raemptyv: '⦳',
  rang: '⟩',
  rangd: '⦒',
  range: '⦥',
  rangle: '⟩',
  raquo: '»',
  rarr: '→',
  rarrap: '⥵',
  rarrb: '⇥',
  rarrbfs: '⤠',
  rarrc: '⤳',
  rarrfs: '⤞',
  rarrhk: '↪',
  rarrlp: '↬',
  rarrpl: '⥅',
  rarrsim: '⥴',
  rarrtl: '↣',
  rarrw: '↝',
  ratail: '⤚',
  ratio: '∶',
  rationals: 'ℚ',
  rbarr: '⤍',
  rbbrk: '❳',
  rbrace: '}',
  rbrack: ']',
  rbrke: '⦌',
  rbrksld: '⦎',
  rbrkslu: '⦐',
  rcaron: 'ř',
  rcedil: 'ŗ',
  rceil: '⌉',
  rcub: '}',
  rcy: 'р',
  rdca: '⤷',
  rdldhar: '⥩',
  rdquo: '”',
  rdquor: '”',
  rdsh: '↳',
  real: 'ℜ',
  realine: 'ℛ',
  realpart: 'ℜ',
  reals: 'ℝ',
  rect: '▭',
  reg: '®',
  rfisht: '⥽',
  rfloor: '⌋',
  rfr: '𝔯',
  rhard: '⇁',
  rharu: '⇀',
  rharul: '⥬',
  rho: 'ρ',
  rhov: 'ϱ',
  rightarrow: '→',
  rightarrowtail: '↣',
  rightharpoondown: '⇁',
  rightharpoonup: '⇀',
  rightleftarrows: '⇄',
  rightleftharpoons: '⇌',
  rightrightarrows: '⇉',
  rightsquigarrow: '↝',
  rightthreetimes: '⋌',
  ring: '˚',
  risingdotseq: '≓',
  rlarr: '⇄',
  rlhar: '⇌',
  rlm: '‏',
  rmoust: '⎱',
  rmoustache: '⎱',
  rnmid: '⫮',
  roang: '⟭',
  roarr: '⇾',
  robrk: '⟧',
  ropar: '⦆',
  ropf: '𝕣',
  roplus: '⨮',
  rotimes: '⨵',
  rpar: ')',
  rpargt: '⦔',
  rppolint: '⨒',
  rrarr: '⇉',
  rsaquo: '›',
  rscr: '𝓇',
  rsh: '↱',
  rsqb: ']',
  rsquo: '’',
  rsquor: '’',
  rthree: '⋌',
  rtimes: '⋊',
  rtri: '▹',
  rtrie: '⊵',
  rtrif: '▸',
  rtriltri: '⧎',
  ruluhar: '⥨',
  rx: '℞',
  sacute: 'ś',
  sbquo: '‚',
  sc: '≻',
  scE: '⪴',
  scap: '⪸',
  scaron: 'š',
  sccue: '≽',
  sce: '⪰',
  scedil: 'ş',
  scirc: 'ŝ',
  scnE: '⪶',
  scnap: '⪺',
  scnsim: '⋩',
  scpolint: '⨓',
  scsim: '≿',
  scy: 'с',
  sdot: '⋅',
  sdotb: '⊡',
  sdote: '⩦',
  seArr: '⇘',
  searhk: '⤥',
  searr: '↘',
  searrow: '↘',
  sect: '§',
  semi: ';',
  seswar: '⤩',
  setminus: '∖',
  setmn: '∖',
  sext: '✶',
  sfr: '𝔰',
  sfrown: '⌢',
  sharp: '♯',
  shchcy: 'щ',
  shcy: 'ш',
  shortmid: '∣',
  shortparallel: '∥',
  shy: '­',
  sigma: 'σ',
  sigmaf: 'ς',
  sigmav: 'ς',
  sim: '∼',
  simdot: '⩪',
  sime: '≃',
  simeq: '≃',
  simg: '⪞',
  simgE: '⪠',
  siml: '⪝',
  simlE: '⪟',
  simne: '≆',
  simplus: '⨤',
  simrarr: '⥲',
  slarr: '←',
  smallsetminus: '∖',
  smashp: '⨳',
  smeparsl: '⧤',
  smid: '∣',
  smile: '⌣',
  smt: '⪪',
  smte: '⪬',
  smtes: '⪬︀',
  softcy: 'ь',
  sol: '/',
  solb: '⧄',
  solbar: '⌿',
  sopf: '𝕤',
  spades: '♠',
  spadesuit: '♠',
  spar: '∥',
  sqcap: '⊓',
  sqcaps: '⊓︀',
  sqcup: '⊔',
  sqcups: '⊔︀',
  sqsub: '⊏',
  sqsube: '⊑',
  sqsubset: '⊏',
  sqsubseteq: '⊑',
  sqsup: '⊐',
  sqsupe: '⊒',
  sqsupset: '⊐',
  sqsupseteq: '⊒',
  squ: '□',
  square: '□',
  squarf: '▪',
  squf: '▪',
  srarr: '→',
  sscr: '𝓈',
  ssetmn: '∖',
  ssmile: '⌣',
  sstarf: '⋆',
  star: '☆',
  starf: '★',
  straightepsilon: 'ϵ',
  straightphi: 'ϕ',
  strns: '¯',
  sub: '⊂',
  subE: '⫅',
  subdot: '⪽',
  sube: '⊆',
  subedot: '⫃',
  submult: '⫁',
  subnE: '⫋',
  subne: '⊊',
  subplus: '⪿',
  subrarr: '⥹',
  subset: '⊂',
  subseteq: '⊆',
  subseteqq: '⫅',
  subsetneq: '⊊',
  subsetneqq: '⫋',
  subsim: '⫇',
  subsub: '⫕',
  subsup: '⫓',
  succ: '≻',
  succapprox: '⪸',
  succcurlyeq: '≽',
  succeq: '⪰',
  succnapprox: '⪺',
  succneqq: '⪶',
  succnsim: '⋩',
  succsim: '≿',
  sum: '∑',
  sung: '♪',
  sup1: '¹',
  sup2: '²',
  sup3: '³',
  sup: '⊃',
  supE: '⫆',
  supdot: '⪾',
  supdsub: '⫘',
  supe: '⊇',
  supedot: '⫄',
  suphsol: '⟉',
  suphsub: '⫗',
  suplarr: '⥻',
  supmult: '⫂',
  supnE: '⫌',
  supne: '⊋',
  supplus: '⫀',
  supset: '⊃',
  supseteq: '⊇',
  supseteqq: '⫆',
  supsetneq: '⊋',
  supsetneqq: '⫌',
  supsim: '⫈',
  supsub: '⫔',
  supsup: '⫖',
  swArr: '⇙',
  swarhk: '⤦',
  swarr: '↙',
  swarrow: '↙',
  swnwar: '⤪',
  szlig: 'ß',
  target: '⌖',
  tau: 'τ',
  tbrk: '⎴',
  tcaron: 'ť',
  tcedil: 'ţ',
  tcy: 'т',
  tdot: '⃛',
  telrec: '⌕',
  tfr: '𝔱',
  there4: '∴',
  therefore: '∴',
  theta: 'θ',
  thetasym: 'ϑ',
  thetav: 'ϑ',
  thickapprox: '≈',
  thicksim: '∼',
  thinsp: ' ',
  thkap: '≈',
  thksim: '∼',
  thorn: 'þ',
  tilde: '˜',
  times: '×',
  timesb: '⊠',
  timesbar: '⨱',
  timesd: '⨰',
  tint: '∭',
  toea: '⤨',
  top: '⊤',
  topbot: '⌶',
  topcir: '⫱',
  topf: '𝕥',
  topfork: '⫚',
  tosa: '⤩',
  tprime: '‴',
  trade: '™',
  triangle: '▵',
  triangledown: '▿',
  triangleleft: '◃',
  trianglelefteq: '⊴',
  triangleq: '≜',
  triangleright: '▹',
  trianglerighteq: '⊵',
  tridot: '◬',
  trie: '≜',
  triminus: '⨺',
  triplus: '⨹',
  trisb: '⧍',
  tritime: '⨻',
  trpezium: '⏢',
  tscr: '𝓉',
  tscy: 'ц',
  tshcy: 'ћ',
  tstrok: 'ŧ',
  twixt: '≬',
  twoheadleftarrow: '↞',
  twoheadrightarrow: '↠',
  uArr: '⇑',
  uHar: '⥣',
  uacute: 'ú',
  uarr: '↑',
  ubrcy: 'ў',
  ubreve: 'ŭ',
  ucirc: 'û',
  ucy: 'у',
  udarr: '⇅',
  udblac: 'ű',
  udhar: '⥮',
  ufisht: '⥾',
  ufr: '𝔲',
  ugrave: 'ù',
  uharl: '↿',
  uharr: '↾',
  uhblk: '▀',
  ulcorn: '⌜',
  ulcorner: '⌜',
  ulcrop: '⌏',
  ultri: '◸',
  umacr: 'ū',
  uml: '¨',
  uogon: 'ų',
  uopf: '𝕦',
  uparrow: '↑',
  updownarrow: '↕',
  upharpoonleft: '↿',
  upharpoonright: '↾',
  uplus: '⊎',
  upsi: 'υ',
  upsih: 'ϒ',
  upsilon: 'υ',
  upuparrows: '⇈',
  urcorn: '⌝',
  urcorner: '⌝',
  urcrop: '⌎',
  uring: 'ů',
  urtri: '◹',
  uscr: '𝓊',
  utdot: '⋰',
  utilde: 'ũ',
  utri: '▵',
  utrif: '▴',
  uuarr: '⇈',
  uuml: 'ü',
  uwangle: '⦧',
  vArr: '⇕',
  vBar: '⫨',
  vBarv: '⫩',
  vDash: '⊨',
  vangrt: '⦜',
  varepsilon: 'ϵ',
  varkappa: 'ϰ',
  varnothing: '∅',
  varphi: 'ϕ',
  varpi: 'ϖ',
  varpropto: '∝',
  varr: '↕',
  varrho: 'ϱ',
  varsigma: 'ς',
  varsubsetneq: '⊊︀',
  varsubsetneqq: '⫋︀',
  varsupsetneq: '⊋︀',
  varsupsetneqq: '⫌︀',
  vartheta: 'ϑ',
  vartriangleleft: '⊲',
  vartriangleright: '⊳',
  vcy: 'в',
  vdash: '⊢',
  vee: '∨',
  veebar: '⊻',
  veeeq: '≚',
  vellip: '⋮',
  verbar: '|',
  vert: '|',
  vfr: '𝔳',
  vltri: '⊲',
  vnsub: '⊂⃒',
  vnsup: '⊃⃒',
  vopf: '𝕧',
  vprop: '∝',
  vrtri: '⊳',
  vscr: '𝓋',
  vsubnE: '⫋︀',
  vsubne: '⊊︀',
  vsupnE: '⫌︀',
  vsupne: '⊋︀',
  vzigzag: '⦚',
  wcirc: 'ŵ',
  wedbar: '⩟',
  wedge: '∧',
  wedgeq: '≙',
  weierp: '℘',
  wfr: '𝔴',
  wopf: '𝕨',
  wp: '℘',
  wr: '≀',
  wreath: '≀',
  wscr: '𝓌',
  xcap: '⋂',
  xcirc: '◯',
  xcup: '⋃',
  xdtri: '▽',
  xfr: '𝔵',
  xhArr: '⟺',
  xharr: '⟷',
  xi: 'ξ',
  xlArr: '⟸',
  xlarr: '⟵',
  xmap: '⟼',
  xnis: '⋻',
  xodot: '⨀',
  xopf: '𝕩',
  xoplus: '⨁',
  xotime: '⨂',
  xrArr: '⟹',
  xrarr: '⟶',
  xscr: '𝓍',
  xsqcup: '⨆',
  xuplus: '⨄',
  xutri: '△',
  xvee: '⋁',
  xwedge: '⋀',
  yacute: 'ý',
  yacy: 'я',
  ycirc: 'ŷ',
  ycy: 'ы',
  yen: '¥',
  yfr: '𝔶',
  yicy: 'ї',
  yopf: '𝕪',
  yscr: '𝓎',
  yucy: 'ю',
  yuml: 'ÿ',
  zacute: 'ź',
  zcaron: 'ž',
  zcy: 'з',
  zdot: 'ż',
  zeetrf: 'ℨ',
  zeta: 'ζ',
  zfr: '𝔷',
  zhcy: 'ж',
  zigrarr: '⇝',
  zopf: '𝕫',
  zscr: '𝓏',
  zwj: '‍',
  zwnj: '‌'
};

// To do: next major: use `Object.hasOwn`.
const own$3 = {}.hasOwnProperty;

/**
 * Decode a single character reference (without the `&` or `;`).
 * You probably only need this when you’re building parsers yourself that follow
 * different rules compared to HTML.
 * This is optimized to be tiny in browsers.
 *
 * @param {string} value
 *   `notin` (named), `#123` (deci), `#x123` (hexa).
 * @returns {string|false}
 *   Decoded reference.
 */
function decodeNamedCharacterReference(value) {
  return own$3.call(characterEntities, value) ? characterEntities[value] : false
}

/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */
function splice(list, start, remove, items) {
  const end = list.length;
  let chunkStart = 0;
  /** @type {Array<unknown>} */
  let parameters;

  // Make start between zero and `end` (included).
  if (start < 0) {
    start = -start > end ? 0 : end + start;
  } else {
    start = start > end ? end : start;
  }
  remove = remove > 0 ? remove : 0;

  // No need to chunk the items if there’s only a couple (10k) items.
  if (items.length < 10000) {
    parameters = Array.from(items);
    parameters.unshift(start, remove);
    // @ts-expect-error Hush, it’s fine.
    list.splice(...parameters);
  } else {
    // Delete `remove` items starting from `start`
    if (remove) list.splice(start, remove);

    // Insert the items in chunks to not cause stack overflows.
    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 10000);
      parameters.unshift(start, 0);
      // @ts-expect-error Hush, it’s fine.
      list.splice(...parameters);
      chunkStart += 10000;
      start += 10000;
    }
  }
}

/**
 * Append `items` (an array) at the end of `list` (another array).
 * When `list` was empty, returns `items` instead.
 *
 * This prevents a potentially expensive operation when `list` is empty,
 * and adds items in batches to prevent V8 from hanging.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {Array<T>} items
 *   Items to add to `list`.
 * @returns {Array<T>}
 *   Either `list` or `items`.
 */
function push(list, items) {
  if (list.length > 0) {
    splice(list, list.length, 0, items);
    return list;
  }
  return items;
}

/**
 * @import {
 *   Extension,
 *   Handles,
 *   HtmlExtension,
 *   NormalizedExtension
 * } from 'micromark-util-types'
 */

const hasOwnProperty = {}.hasOwnProperty;

/**
 * Combine multiple syntax extensions into one.
 *
 * @param {ReadonlyArray<Extension>} extensions
 *   List of syntax extensions.
 * @returns {NormalizedExtension}
 *   A single combined extension.
 */
function combineExtensions(extensions) {
  /** @type {NormalizedExtension} */
  const all = {};
  let index = -1;

  while (++index < extensions.length) {
    syntaxExtension(all, extensions[index]);
  }

  return all
}

/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */
function syntaxExtension(all, extension) {
  /** @type {keyof Extension} */
  let hook;

  for (hook in extension) {
    const maybe = hasOwnProperty.call(all, hook) ? all[hook] : undefined;
    /** @type {Record<string, unknown>} */
    const left = maybe || (all[hook] = {});
    /** @type {Record<string, unknown> | undefined} */
    const right = extension[hook];
    /** @type {string} */
    let code;

    if (right) {
      for (code in right) {
        if (!hasOwnProperty.call(left, code)) left[code] = [];
        const value = right[code];
        constructs(
          // @ts-expect-error Looks like a list.
          left[code],
          Array.isArray(value) ? value : value ? [value] : []
        );
      }
    }
  }
}

/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 *   List of constructs to merge into.
 * @param {Array<unknown>} list
 *   List of constructs to merge.
 * @returns {undefined}
 *   Nothing.
 */
function constructs(existing, list) {
  let index = -1;
  /** @type {Array<unknown>} */
  const before = [];

  while (++index < list.length) {
(list[index].add === 'after' ? existing : before).push(list[index]);
  }

  splice(existing, 0, 0, before);
}

/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */
function decodeNumericCharacterReference(value, base) {
  const code = Number.parseInt(value, base);
  if (
  // C0 except for HT, LF, FF, CR, space.
  code < 9 || code === 11 || code > 13 && code < 32 ||
  // Control character (DEL) of C0, and C1 controls.
  code > 126 && code < 160 ||
  // Lone high surrogates and low surrogates.
  code > 55_295 && code < 57_344 ||
  // Noncharacters.
  code > 64_975 && code < 65_008 || /* eslint-disable no-bitwise */
  (code & 65_535) === 65_535 || (code & 65_535) === 65_534 || /* eslint-enable no-bitwise */
  // Out of range
  code > 1_114_111) {
    return "\uFFFD";
  }
  return String.fromCodePoint(code);
}

/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */
function normalizeIdentifier(value) {
  return value
  // Collapse markdown whitespace.
  .replace(/[\t\n\r ]+/g, " ")
  // Trim.
  .replace(/^ | $/g, '')
  // Some characters are considered “uppercase”, but if their lowercase
  // counterpart is uppercased will result in a different uppercase
  // character.
  // Hence, to get that form, we perform both lower- and uppercase.
  // Upper case makes sure keys will not interact with default prototypal
  // methods: no method is uppercase.
  .toLowerCase().toUpperCase();
}

/**
 * @import {Code} from 'micromark-util-types'
 */

/**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiAlpha = regexCheck(/[A-Za-z]/);

/**
 * Check whether the character code represents an ASCII alphanumeric (`a`
 * through `z`, case insensitive, or `0` through `9`).
 *
 * An **ASCII alphanumeric** is an ASCII digit (see `asciiDigit`) or ASCII alpha
 * (see `asciiAlpha`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiAlphanumeric = regexCheck(/[\dA-Za-z]/);

/**
 * Check whether the character code represents an ASCII atext.
 *
 * atext is an ASCII alphanumeric (see `asciiAlphanumeric`), or a character in
 * the inclusive ranges U+0023 NUMBER SIGN (`#`) to U+0027 APOSTROPHE (`'`),
 * U+002A ASTERISK (`*`), U+002B PLUS SIGN (`+`), U+002D DASH (`-`), U+002F
 * SLASH (`/`), U+003D EQUALS TO (`=`), U+003F QUESTION MARK (`?`), U+005E
 * CARET (`^`) to U+0060 GRAVE ACCENT (`` ` ``), or U+007B LEFT CURLY BRACE
 * (`{`) to U+007E TILDE (`~`).
 *
 * See:
 * **\[RFC5322]**:
 * [Internet Message Format](https://tools.ietf.org/html/rfc5322).
 * P. Resnick.
 * IETF.
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);

/**
 * Check whether a character code is an ASCII control character.
 *
 * An **ASCII control** is a character in the inclusive range U+0000 NULL (NUL)
 * to U+001F (US), or U+007F (DEL).
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function asciiControl(code) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127)
  );
}

/**
 * Check whether the character code represents an ASCII digit (`0` through `9`).
 *
 * An **ASCII digit** is a character in the inclusive range U+0030 (`0`) to
 * U+0039 (`9`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiDigit = regexCheck(/\d/);

/**
 * Check whether the character code represents an ASCII hex digit (`a` through
 * `f`, case insensitive, or `0` through `9`).
 *
 * An **ASCII hex digit** is an ASCII digit (see `asciiDigit`), ASCII upper hex
 * digit, or an ASCII lower hex digit.
 *
 * An **ASCII upper hex digit** is a character in the inclusive range U+0041
 * (`A`) to U+0046 (`F`).
 *
 * An **ASCII lower hex digit** is a character in the inclusive range U+0061
 * (`a`) to U+0066 (`f`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiHexDigit = regexCheck(/[\dA-Fa-f]/);

/**
 * Check whether the character code represents ASCII punctuation.
 *
 * An **ASCII punctuation** is a character in the inclusive ranges U+0021
 * EXCLAMATION MARK (`!`) to U+002F SLASH (`/`), U+003A COLON (`:`) to U+0040 AT
 * SIGN (`@`), U+005B LEFT SQUARE BRACKET (`[`) to U+0060 GRAVE ACCENT
 * (`` ` ``), or U+007B LEFT CURLY BRACE (`{`) to U+007E TILDE (`~`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);

/**
 * Check whether a character code is a markdown line ending.
 *
 * A **markdown line ending** is the virtual characters M-0003 CARRIAGE RETURN
 * LINE FEED (CRLF), M-0004 LINE FEED (LF) and M-0005 CARRIAGE RETURN (CR).
 *
 * In micromark, the actual character U+000A LINE FEED (LF) and U+000D CARRIAGE
 * RETURN (CR) are replaced by these virtual characters depending on whether
 * they occurred together.
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function markdownLineEnding(code) {
  return code !== null && code < -2;
}

/**
 * Check whether a character code is a markdown line ending (see
 * `markdownLineEnding`) or markdown space (see `markdownSpace`).
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function markdownLineEndingOrSpace(code) {
  return code !== null && (code < 0 || code === 32);
}

/**
 * Check whether a character code is a markdown space.
 *
 * A **markdown space** is the concrete character U+0020 SPACE (SP) and the
 * virtual characters M-0001 VIRTUAL SPACE (VS) and M-0002 HORIZONTAL TAB (HT).
 *
 * In micromark, the actual character U+0009 CHARACTER TABULATION (HT) is
 * replaced by one M-0002 HORIZONTAL TAB (HT) and between 0 and 3 M-0001 VIRTUAL
 * SPACE (VS) characters, depending on the column at which the tab occurred.
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function markdownSpace(code) {
  return code === -2 || code === -1 || code === 32;
}

// Size note: removing ASCII from the regex and using `asciiPunctuation` here
// In fact adds to the bundle size.
/**
 * Check whether the character code represents Unicode punctuation.
 *
 * A **Unicode punctuation** is a character in the Unicode `Pc` (Punctuation,
 * Connector), `Pd` (Punctuation, Dash), `Pe` (Punctuation, Close), `Pf`
 * (Punctuation, Final quote), `Pi` (Punctuation, Initial quote), `Po`
 * (Punctuation, Other), or `Ps` (Punctuation, Open) categories, or an ASCII
 * punctuation (see `asciiPunctuation`).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 *
 * @param code
 *   Code.
 * @returns
 *   Whether it matches.
 */
const unicodePunctuation = regexCheck(/\p{P}|\p{S}/u);

/**
 * Check whether the character code represents Unicode whitespace.
 *
 * Note that this does handle micromark specific markdown whitespace characters.
 * See `markdownLineEndingOrSpace` to check that.
 *
 * A **Unicode whitespace** is a character in the Unicode `Zs` (Separator,
 * Space) category, or U+0009 CHARACTER TABULATION (HT), U+000A LINE FEED (LF),
 * U+000C (FF), or U+000D CARRIAGE RETURN (CR) (**\[UNICODE]**).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 *
 * @param code
 *   Code.
 * @returns
 *   Whether it matches.
 */
const unicodeWhitespace = regexCheck(/\s/);

/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 *   Expression.
 * @returns {(code: Code) => boolean}
 *   Check.
 */
function regexCheck(regex) {
  return check;

  /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */
  function check(code) {
    return code !== null && code > -1 && regex.test(String.fromCharCode(code));
  }
}

/**
 * Normalize a URL.
 *
 * Encode unsafe characters with percent-encoding, skipping already encoded
 * sequences.
 *
 * @param {string} value
 *   URI to normalize.
 * @returns {string}
 *   Normalized URI.
 */
function normalizeUri(value) {
  /** @type {Array<string>} */
  const result = [];
  let index = -1;
  let start = 0;
  let skip = 0;
  while (++index < value.length) {
    const code = value.charCodeAt(index);
    /** @type {string} */
    let replace = '';

    // A correct percent encoded value.
    if (code === 37 && asciiAlphanumeric(value.charCodeAt(index + 1)) && asciiAlphanumeric(value.charCodeAt(index + 2))) {
      skip = 2;
    }
    // ASCII.
    else if (code < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) {
        replace = String.fromCharCode(code);
      }
    }
    // Astral.
    else if (code > 55_295 && code < 57_344) {
      const next = value.charCodeAt(index + 1);

      // A correct surrogate pair.
      if (code < 56_320 && next > 56_319 && next < 57_344) {
        replace = String.fromCharCode(code, next);
        skip = 1;
      }
      // Lone surrogate.
      else {
        replace = "\uFFFD";
      }
    }
    // Unicode.
    else {
      replace = String.fromCharCode(code);
    }
    if (replace) {
      result.push(value.slice(start, index), encodeURIComponent(replace));
      start = index + skip + 1;
      replace = '';
    }
    if (skip) {
      index += skip;
      skip = 0;
    }
  }
  return result.join('') + value.slice(start);
}

/**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */

// To do: implement `spaceOrTab`, `spaceOrTabMinMax`, `spaceOrTabWithOptions`.

/**
 * Parse spaces and tabs.
 *
 * There is no `nok` parameter:
 *
 * *   spaces in markdown are often optional, in which case this factory can be
 *     used and `ok` will be switched to whether spaces were found or not
 * *   one line ending or space can be detected with `markdownSpace(code)` right
 *     before using `factorySpace`
 *
 * ###### Examples
 *
 * Where `␉` represents a tab (plus how much it expands) and `␠` represents a
 * single space.
 *
 * ```markdown
 * ␉
 * ␠␠␠␠
 * ␉␠
 * ```
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {TokenType} type
 *   Type (`' \t'`).
 * @param {number | undefined} [max=Infinity]
 *   Max (exclusive).
 * @returns {State}
 *   Start state.
 */
function factorySpace(effects, ok, type, max) {
  const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
  let size = 0;
  return start;

  /** @type {State} */
  function start(code) {
    if (markdownSpace(code)) {
      effects.enter(type);
      return prefix(code);
    }
    return ok(code);
  }

  /** @type {State} */
  function prefix(code) {
    if (markdownSpace(code) && size++ < limit) {
      effects.consume(code);
      return prefix;
    }
    effects.exit(type);
    return ok(code);
  }
}

/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */
/** @type {InitialConstruct} */
const content$1 = {
  tokenize: initializeContent
};

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Initializer}
 *   Content.
 */
function initializeContent(effects) {
  const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
  /** @type {Token} */
  let previous;
  return contentStart;

  /** @type {State} */
  function afterContentStartConstruct(code) {
    if (code === null) {
      effects.consume(code);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return factorySpace(effects, contentStart, "linePrefix");
  }

  /** @type {State} */
  function paragraphInitial(code) {
    effects.enter("paragraph");
    return lineStart(code);
  }

  /** @type {State} */
  function lineStart(code) {
    const token = effects.enter("chunkText", {
      contentType: "text",
      previous
    });
    if (previous) {
      previous.next = token;
    }
    previous = token;
    return data(code);
  }

  /** @type {State} */
  function data(code) {
    if (code === null) {
      effects.exit("chunkText");
      effects.exit("paragraph");
      effects.consume(code);
      return;
    }
    if (markdownLineEnding(code)) {
      effects.consume(code);
      effects.exit("chunkText");
      return lineStart;
    }

    // Data.
    effects.consume(code);
    return data;
  }
}

/**
 * @import {
 *   Construct,
 *   ContainerState,
 *   InitialConstruct,
 *   Initializer,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */
/** @type {InitialConstruct} */
const document$2 = {
  tokenize: initializeDocument
};

/** @type {Construct} */
const containerConstruct = {
  tokenize: tokenizeContainer
};

/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */
function initializeDocument(effects) {
  const self = this;
  /** @type {Array<StackItem>} */
  const stack = [];
  let continued = 0;
  /** @type {TokenizeContext | undefined} */
  let childFlow;
  /** @type {Token | undefined} */
  let childToken;
  /** @type {number} */
  let lineStartOffset;
  return start;

  /** @type {State} */
  function start(code) {
    // First we iterate through the open blocks, starting with the root
    // document, and descending through last children down to the last open
    // block.
    // Each block imposes a condition that the line must satisfy if the block is
    // to remain open.
    // For example, a block quote requires a `>` character.
    // A paragraph requires a non-blank line.
    // In this phase we may match all or just some of the open blocks.
    // But we cannot close unmatched blocks yet, because we may have a lazy
    // continuation line.
    if (continued < stack.length) {
      const item = stack[continued];
      self.containerState = item[1];
      return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
    }

    // Done.
    return checkNewContainers(code);
  }

  /** @type {State} */
  function documentContinue(code) {
    continued++;

    // Note: this field is called `_closeFlow` but it also closes containers.
    // Perhaps a good idea to rename it but it’s already used in the wild by
    // extensions.
    if (self.containerState._closeFlow) {
      self.containerState._closeFlow = undefined;
      if (childFlow) {
        closeFlow();
      }

      // Note: this algorithm for moving events around is similar to the
      // algorithm when dealing with lazy lines in `writeToChild`.
      const indexBeforeExits = self.events.length;
      let indexBeforeFlow = indexBeforeExits;
      /** @type {Point | undefined} */
      let point;

      // Find the flow chunk.
      while (indexBeforeFlow--) {
        if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
          point = self.events[indexBeforeFlow][1].end;
          break;
        }
      }
      exitContainers(continued);

      // Fix positions.
      let index = indexBeforeExits;
      while (index < self.events.length) {
        self.events[index][1].end = {
          ...point
        };
        index++;
      }

      // Inject the exits earlier (they’re still also at the end).
      splice(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));

      // Discard the duplicate exits.
      self.events.length = index;
      return checkNewContainers(code);
    }
    return start(code);
  }

  /** @type {State} */
  function checkNewContainers(code) {
    // Next, after consuming the continuation markers for existing blocks, we
    // look for new block starts (e.g. `>` for a block quote).
    // If we encounter a new block start, we close any blocks unmatched in
    // step 1 before creating the new block as a child of the last matched
    // block.
    if (continued === stack.length) {
      // No need to `check` whether there’s a container, of `exitContainers`
      // would be moot.
      // We can instead immediately `attempt` to parse one.
      if (!childFlow) {
        return documentContinued(code);
      }

      // If we have concrete content, such as block HTML or fenced code,
      // we can’t have containers “pierce” into them, so we can immediately
      // start.
      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        return flowStart(code);
      }

      // If we do have flow, it could still be a blank line,
      // but we’d be interrupting it w/ a new container if there’s a current
      // construct.
      // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
      // needed in micromark-extension-gfm-table@1.0.6).
      self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
    }

    // Check if there is a new container.
    self.containerState = {};
    return effects.check(containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
  }

  /** @type {State} */
  function thereIsANewContainer(code) {
    if (childFlow) closeFlow();
    exitContainers(continued);
    return documentContinued(code);
  }

  /** @type {State} */
  function thereIsNoNewContainer(code) {
    self.parser.lazy[self.now().line] = continued !== stack.length;
    lineStartOffset = self.now().offset;
    return flowStart(code);
  }

  /** @type {State} */
  function documentContinued(code) {
    // Try new containers.
    self.containerState = {};
    return effects.attempt(containerConstruct, containerContinue, flowStart)(code);
  }

  /** @type {State} */
  function containerContinue(code) {
    continued++;
    stack.push([self.currentConstruct, self.containerState]);
    // Try another.
    return documentContinued(code);
  }

  /** @type {State} */
  function flowStart(code) {
    if (code === null) {
      if (childFlow) closeFlow();
      exitContainers(0);
      effects.consume(code);
      return;
    }
    childFlow = childFlow || self.parser.flow(self.now());
    effects.enter("chunkFlow", {
      _tokenizer: childFlow,
      contentType: "flow",
      previous: childToken
    });
    return flowContinue(code);
  }

  /** @type {State} */
  function flowContinue(code) {
    if (code === null) {
      writeToChild(effects.exit("chunkFlow"), true);
      exitContainers(0);
      effects.consume(code);
      return;
    }
    if (markdownLineEnding(code)) {
      effects.consume(code);
      writeToChild(effects.exit("chunkFlow"));
      // Get ready for the next line.
      continued = 0;
      self.interrupt = undefined;
      return start;
    }
    effects.consume(code);
    return flowContinue;
  }

  /**
   * @param {Token} token
   *   Token.
   * @param {boolean | undefined} [endOfFile]
   *   Whether the token is at the end of the file (default: `false`).
   * @returns {undefined}
   *   Nothing.
   */
  function writeToChild(token, endOfFile) {
    const stream = self.sliceStream(token);
    if (endOfFile) stream.push(null);
    token.previous = childToken;
    if (childToken) childToken.next = token;
    childToken = token;
    childFlow.defineSkip(token.start);
    childFlow.write(stream);

    // Alright, so we just added a lazy line:
    //
    // ```markdown
    // > a
    // b.
    //
    // Or:
    //
    // > ~~~c
    // d
    //
    // Or:
    //
    // > | e |
    // f
    // ```
    //
    // The construct in the second example (fenced code) does not accept lazy
    // lines, so it marked itself as done at the end of its first line, and
    // then the content construct parses `d`.
    // Most constructs in markdown match on the first line: if the first line
    // forms a construct, a non-lazy line can’t “unmake” it.
    //
    // The construct in the third example is potentially a GFM table, and
    // those are *weird*.
    // It *could* be a table, from the first line, if the following line
    // matches a condition.
    // In this case, that second line is lazy, which “unmakes” the first line
    // and turns the whole into one content block.
    //
    // We’ve now parsed the non-lazy and the lazy line, and can figure out
    // whether the lazy line started a new flow block.
    // If it did, we exit the current containers between the two flow blocks.
    if (self.parser.lazy[token.start.line]) {
      let index = childFlow.events.length;
      while (index--) {
        if (
        // The token starts before the line ending…
        childFlow.events[index][1].start.offset < lineStartOffset && (
        // …and either is not ended yet…
        !childFlow.events[index][1].end ||
        // …or ends after it.
        childFlow.events[index][1].end.offset > lineStartOffset)) {
          // Exit: there’s still something open, which means it’s a lazy line
          // part of something.
          return;
        }
      }

      // Note: this algorithm for moving events around is similar to the
      // algorithm when closing flow in `documentContinue`.
      const indexBeforeExits = self.events.length;
      let indexBeforeFlow = indexBeforeExits;
      /** @type {boolean | undefined} */
      let seen;
      /** @type {Point | undefined} */
      let point;

      // Find the previous chunk (the one before the lazy line).
      while (indexBeforeFlow--) {
        if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
          if (seen) {
            point = self.events[indexBeforeFlow][1].end;
            break;
          }
          seen = true;
        }
      }
      exitContainers(continued);

      // Fix positions.
      index = indexBeforeExits;
      while (index < self.events.length) {
        self.events[index][1].end = {
          ...point
        };
        index++;
      }

      // Inject the exits earlier (they’re still also at the end).
      splice(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));

      // Discard the duplicate exits.
      self.events.length = index;
    }
  }

  /**
   * @param {number} size
   *   Size.
   * @returns {undefined}
   *   Nothing.
   */
  function exitContainers(size) {
    let index = stack.length;

    // Exit open containers.
    while (index-- > size) {
      const entry = stack[index];
      self.containerState = entry[1];
      entry[0].exit.call(self, effects);
    }
    stack.length = size;
  }
  function closeFlow() {
    childFlow.write([null]);
    childToken = undefined;
    childFlow = undefined;
    self.containerState._closeFlow = undefined;
  }
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 *   Tokenizer.
 */
function tokenizeContainer(effects, ok, nok) {
  // Always populated by defaults.

  return factorySpace(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}

/**
 * @import {Code} from 'micromark-util-types'
 */
/**
 * Classify whether a code represents whitespace, punctuation, or something
 * else.
 *
 * Used for attention (emphasis, strong), whose sequences can open or close
 * based on the class of surrounding characters.
 *
 * > 👉 **Note**: eof (`null`) is seen as whitespace.
 *
 * @param {Code} code
 *   Code.
 * @returns {typeof constants.characterGroupWhitespace | typeof constants.characterGroupPunctuation | undefined}
 *   Group.
 */
function classifyCharacter(code) {
  if (code === null || markdownLineEndingOrSpace(code) || unicodeWhitespace(code)) {
    return 1;
  }
  if (unicodePunctuation(code)) {
    return 2;
  }
}

/**
 * @import {Event, Resolver, TokenizeContext} from 'micromark-util-types'
 */

/**
 * Call all `resolveAll`s.
 *
 * @param {ReadonlyArray<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */
function resolveAll(constructs, events, context) {
  /** @type {Array<Resolver>} */
  const called = [];
  let index = -1;

  while (++index < constructs.length) {
    const resolve = constructs[index].resolveAll;

    if (resolve && !called.includes(resolve)) {
      events = resolve(events, context);
      called.push(resolve);
    }
  }

  return events
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Event,
 *   Point,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const attention = {
  name: 'attention',
  resolveAll: resolveAllAttention,
  tokenize: tokenizeAttention
};

/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */
// eslint-disable-next-line complexity
function resolveAllAttention(events, context) {
  let index = -1;
  /** @type {number} */
  let open;
  /** @type {Token} */
  let group;
  /** @type {Token} */
  let text;
  /** @type {Token} */
  let openingSequence;
  /** @type {Token} */
  let closingSequence;
  /** @type {number} */
  let use;
  /** @type {Array<Event>} */
  let nextEvents;
  /** @type {number} */
  let offset;

  // Walk through all events.
  //
  // Note: performance of this is fine on an mb of normal markdown, but it’s
  // a bottleneck for malicious stuff.
  while (++index < events.length) {
    // Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
      open = index;

      // Now walk back to find an opener.
      while (open--) {
        // Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open &&
        // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
          // If the opening can close or the closing can open,
          // and the close size *is not* a multiple of three,
          // but the sum of the opening and closing size *is* multiple of three,
          // then don’t match.
          if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) {
            continue;
          }

          // Number of markers to use from the sequence.
          use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
          const start = {
            ...events[open][1].end
          };
          const end = {
            ...events[index][1].start
          };
          movePoint(start, -use);
          movePoint(end, use);
          openingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start,
            end: {
              ...events[open][1].end
            }
          };
          closingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...events[index][1].start
            },
            end
          };
          text = {
            type: use > 1 ? "strongText" : "emphasisText",
            start: {
              ...events[open][1].end
            },
            end: {
              ...events[index][1].start
            }
          };
          group = {
            type: use > 1 ? "strong" : "emphasis",
            start: {
              ...openingSequence.start
            },
            end: {
              ...closingSequence.end
            }
          };
          events[open][1].end = {
            ...openingSequence.start
          };
          events[index][1].start = {
            ...closingSequence.end
          };
          nextEvents = [];

          // If there are more markers in the opening, add them before.
          if (events[open][1].end.offset - events[open][1].start.offset) {
            nextEvents = push(nextEvents, [['enter', events[open][1], context], ['exit', events[open][1], context]]);
          }

          // Opening.
          nextEvents = push(nextEvents, [['enter', group, context], ['enter', openingSequence, context], ['exit', openingSequence, context], ['enter', text, context]]);

          // Always populated by defaults.

          // Between.
          nextEvents = push(nextEvents, resolveAll(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));

          // Closing.
          nextEvents = push(nextEvents, [['exit', text, context], ['enter', closingSequence, context], ['exit', closingSequence, context], ['exit', group, context]]);

          // If there are more markers in the closing, add them after.
          if (events[index][1].end.offset - events[index][1].start.offset) {
            offset = 2;
            nextEvents = push(nextEvents, [['enter', events[index][1], context], ['exit', events[index][1], context]]);
          } else {
            offset = 0;
          }
          splice(events, open - 1, index - open + 3, nextEvents);
          index = open + nextEvents.length - offset - 2;
          break;
        }
      }
    }
  }

  // Remove remaining sequences.
  index = -1;
  while (++index < events.length) {
    if (events[index][1].type === 'attentionSequence') {
      events[index][1].type = 'data';
    }
  }
  return events;
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeAttention(effects, ok) {
  const attentionMarkers = this.parser.constructs.attentionMarkers.null;
  const previous = this.previous;
  const before = classifyCharacter(previous);

  /** @type {NonNullable<Code>} */
  let marker;
  return start;

  /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    marker = code;
    effects.enter('attentionSequence');
    return inside(code);
  }

  /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    if (code === marker) {
      effects.consume(code);
      return inside;
    }
    const token = effects.exit('attentionSequence');

    // To do: next major: move this to resolver, just like `markdown-rs`.
    const after = classifyCharacter(code);

    // Always populated by defaults.

    const open = !after || after === 2 && before || attentionMarkers.includes(code);
    const close = !before || before === 2 && after || attentionMarkers.includes(previous);
    token._open = Boolean(marker === 42 ? open : open && (before || !close));
    token._close = Boolean(marker === 42 ? close : close && (after || !open));
    return ok(code);
  }
}

/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 *   Point.
 * @param {number} offset
 *   Amount to move.
 * @returns {undefined}
 *   Nothing.
 */
function movePoint(point, offset) {
  point.column += offset;
  point.offset += offset;
  point._bufferIndex += offset;
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const autolink = {
  name: 'autolink',
  tokenize: tokenizeAutolink
};

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeAutolink(effects, ok, nok) {
  let size = 0;
  return start;

  /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("autolink");
    effects.enter("autolinkMarker");
    effects.consume(code);
    effects.exit("autolinkMarker");
    effects.enter("autolinkProtocol");
    return open;
  }

  /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (asciiAlpha(code)) {
      effects.consume(code);
      return schemeOrEmailAtext;
    }
    if (code === 64) {
      return nok(code);
    }
    return emailAtext(code);
  }

  /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */
  function schemeOrEmailAtext(code) {
    // ASCII alphanumeric and `+`, `-`, and `.`.
    if (code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)) {
      // Count the previous alphabetical from `open` too.
      size = 1;
      return schemeInsideOrEmailAtext(code);
    }
    return emailAtext(code);
  }

  /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */
  function schemeInsideOrEmailAtext(code) {
    if (code === 58) {
      effects.consume(code);
      size = 0;
      return urlInside;
    }

    // ASCII alphanumeric and `+`, `-`, and `.`.
    if ((code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)) && size++ < 32) {
      effects.consume(code);
      return schemeInsideOrEmailAtext;
    }
    size = 0;
    return emailAtext(code);
  }

  /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */
  function urlInside(code) {
    if (code === 62) {
      effects.exit("autolinkProtocol");
      effects.enter("autolinkMarker");
      effects.consume(code);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok;
    }

    // ASCII control, space, or `<`.
    if (code === null || code === 32 || code === 60 || asciiControl(code)) {
      return nok(code);
    }
    effects.consume(code);
    return urlInside;
  }

  /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */
  function emailAtext(code) {
    if (code === 64) {
      effects.consume(code);
      return emailAtSignOrDot;
    }
    if (asciiAtext(code)) {
      effects.consume(code);
      return emailAtext;
    }
    return nok(code);
  }

  /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */
  function emailAtSignOrDot(code) {
    return asciiAlphanumeric(code) ? emailLabel(code) : nok(code);
  }

  /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */
  function emailLabel(code) {
    if (code === 46) {
      effects.consume(code);
      size = 0;
      return emailAtSignOrDot;
    }
    if (code === 62) {
      // Exit, then change the token type.
      effects.exit("autolinkProtocol").type = "autolinkEmail";
      effects.enter("autolinkMarker");
      effects.consume(code);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok;
    }
    return emailValue(code);
  }

  /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */
  function emailValue(code) {
    // ASCII alphanumeric or `-`.
    if ((code === 45 || asciiAlphanumeric(code)) && size++ < 63) {
      const next = code === 45 ? emailValue : emailLabel;
      effects.consume(code);
      return next;
    }
    return nok(code);
  }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const blankLine = {
  partial: true,
  tokenize: tokenizeBlankLine
};

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeBlankLine(effects, ok, nok) {
  return start;

  /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    return markdownSpace(code) ? factorySpace(effects, after, "linePrefix")(code) : after(code);
  }

  /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code);
  }
}

/**
 * @import {
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const blockQuote = {
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit,
  name: 'blockQuote',
  tokenize: tokenizeBlockQuoteStart
};

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeBlockQuoteStart(effects, ok, nok) {
  const self = this;
  return start;

  /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (code === 62) {
      const state = self.containerState;
      if (!state.open) {
        effects.enter("blockQuote", {
          _container: true
        });
        state.open = true;
      }
      effects.enter("blockQuotePrefix");
      effects.enter("blockQuoteMarker");
      effects.consume(code);
      effects.exit("blockQuoteMarker");
      return after;
    }
    return nok(code);
  }

  /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    if (markdownSpace(code)) {
      effects.enter("blockQuotePrefixWhitespace");
      effects.consume(code);
      effects.exit("blockQuotePrefixWhitespace");
      effects.exit("blockQuotePrefix");
      return ok;
    }
    effects.exit("blockQuotePrefix");
    return ok(code);
  }
}

/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeBlockQuoteContinuation(effects, ok, nok) {
  const self = this;
  return contStart;

  /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */
  function contStart(code) {
    if (markdownSpace(code)) {
      // Always populated by defaults.

      return factorySpace(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
    return contBefore(code);
  }

  /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */
  function contBefore(code) {
    return effects.attempt(blockQuote, ok, nok)(code);
  }
}

/** @type {Exiter} */
function exit(effects) {
  effects.exit("blockQuote");
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const characterEscape = {
  name: 'characterEscape',
  tokenize: tokenizeCharacterEscape
};

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeCharacterEscape(effects, ok, nok) {
  return start;

  /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("characterEscape");
    effects.enter("escapeMarker");
    effects.consume(code);
    effects.exit("escapeMarker");
    return inside;
  }

  /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    // ASCII punctuation.
    if (asciiPunctuation(code)) {
      effects.enter("characterEscapeValue");
      effects.consume(code);
      effects.exit("characterEscapeValue");
      effects.exit("characterEscape");
      return ok;
    }
    return nok(code);
  }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const characterReference = {
  name: 'characterReference',
  tokenize: tokenizeCharacterReference
};

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeCharacterReference(effects, ok, nok) {
  const self = this;
  let size = 0;
  /** @type {number} */
  let max;
  /** @type {(code: Code) => boolean} */
  let test;
  return start;

  /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("characterReference");
    effects.enter("characterReferenceMarker");
    effects.consume(code);
    effects.exit("characterReferenceMarker");
    return open;
  }

  /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 35) {
      effects.enter("characterReferenceMarkerNumeric");
      effects.consume(code);
      effects.exit("characterReferenceMarkerNumeric");
      return numeric;
    }
    effects.enter("characterReferenceValue");
    max = 31;
    test = asciiAlphanumeric;
    return value(code);
  }

  /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */
  function numeric(code) {
    if (code === 88 || code === 120) {
      effects.enter("characterReferenceMarkerHexadecimal");
      effects.consume(code);
      effects.exit("characterReferenceMarkerHexadecimal");
      effects.enter("characterReferenceValue");
      max = 6;
      test = asciiHexDigit;
      return value;
    }
    effects.enter("characterReferenceValue");
    max = 7;
    test = asciiDigit;
    return value(code);
  }

  /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */
  function value(code) {
    if (code === 59 && size) {
      const token = effects.exit("characterReferenceValue");
      if (test === asciiAlphanumeric && !decodeNamedCharacterReference(self.sliceSerialize(token))) {
        return nok(code);
      }

      // To do: `markdown-rs` uses a different name:
      // `CharacterReferenceMarkerSemi`.
      effects.enter("characterReferenceMarker");
      effects.consume(code);
      effects.exit("characterReferenceMarker");
      effects.exit("characterReference");
      return ok;
    }
    if (test(code) && size++ < max) {
      effects.consume(code);
      return value;
    }
    return nok(code);
  }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const nonLazyContinuation = {
  partial: true,
  tokenize: tokenizeNonLazyContinuation
};

/** @type {Construct} */
const codeFenced = {
  concrete: true,
  name: 'codeFenced',
  tokenize: tokenizeCodeFenced
};

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeCodeFenced(effects, ok, nok) {
  const self = this;
  /** @type {Construct} */
  const closeStart = {
    partial: true,
    tokenize: tokenizeCloseStart
  };
  let initialPrefix = 0;
  let sizeOpen = 0;
  /** @type {NonNullable<Code>} */
  let marker;
  return start;

  /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: parse whitespace like `markdown-rs`.
    return beforeSequenceOpen(code);
  }

  /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function beforeSequenceOpen(code) {
    const tail = self.events[self.events.length - 1];
    initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    marker = code;
    effects.enter("codeFenced");
    effects.enter("codeFencedFence");
    effects.enter("codeFencedFenceSequence");
    return sequenceOpen(code);
  }

  /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function sequenceOpen(code) {
    if (code === marker) {
      sizeOpen++;
      effects.consume(code);
      return sequenceOpen;
    }
    if (sizeOpen < 3) {
      return nok(code);
    }
    effects.exit("codeFencedFenceSequence");
    return markdownSpace(code) ? factorySpace(effects, infoBefore, "whitespace")(code) : infoBefore(code);
  }

  /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function infoBefore(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("codeFencedFence");
      return self.interrupt ? ok(code) : effects.check(nonLazyContinuation, atNonLazyBreak, after)(code);
    }
    effects.enter("codeFencedFenceInfo");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return info(code);
  }

  /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function info(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return infoBefore(code);
    }
    if (markdownSpace(code)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return factorySpace(effects, metaBefore, "whitespace")(code);
    }
    if (code === 96 && code === marker) {
      return nok(code);
    }
    effects.consume(code);
    return info;
  }

  /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function metaBefore(code) {
    if (code === null || markdownLineEnding(code)) {
      return infoBefore(code);
    }
    effects.enter("codeFencedFenceMeta");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return meta(code);
  }

  /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function meta(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceMeta");
      return infoBefore(code);
    }
    if (code === 96 && code === marker) {
      return nok(code);
    }
    effects.consume(code);
    return meta;
  }

  /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function atNonLazyBreak(code) {
    return effects.attempt(closeStart, after, contentBefore)(code);
  }

  /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function contentBefore(code) {
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return contentStart;
  }

  /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function contentStart(code) {
    return initialPrefix > 0 && markdownSpace(code) ? factorySpace(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
  }

  /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function beforeContentChunk(code) {
    if (code === null || markdownLineEnding(code)) {
      return effects.check(nonLazyContinuation, atNonLazyBreak, after)(code);
    }
    effects.enter("codeFlowValue");
    return contentChunk(code);
  }

  /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function contentChunk(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("codeFlowValue");
      return beforeContentChunk(code);
    }
    effects.consume(code);
    return contentChunk;
  }

  /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    effects.exit("codeFenced");
    return ok(code);
  }

  /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Tokenizer}
   */
  function tokenizeCloseStart(effects, ok, nok) {
    let size = 0;
    return startBefore;

    /**
     *
     *
     * @type {State}
     */
    function startBefore(code) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      return start;
    }

    /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */
    function start(code) {
      // Always populated by defaults.

      // To do: `enter` here or in next state?
      effects.enter("codeFencedFence");
      return markdownSpace(code) ? factorySpace(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
    }

    /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */
    function beforeSequenceClose(code) {
      if (code === marker) {
        effects.enter("codeFencedFenceSequence");
        return sequenceClose(code);
      }
      return nok(code);
    }

    /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */
    function sequenceClose(code) {
      if (code === marker) {
        size++;
        effects.consume(code);
        return sequenceClose;
      }
      if (size >= sizeOpen) {
        effects.exit("codeFencedFenceSequence");
        return markdownSpace(code) ? factorySpace(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
      }
      return nok(code);
    }

    /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */
    function sequenceCloseAfter(code) {
      if (code === null || markdownLineEnding(code)) {
        effects.exit("codeFencedFence");
        return ok(code);
      }
      return nok(code);
    }
  }
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeNonLazyContinuation(effects, ok, nok) {
  const self = this;
  return start;

  /**
   *
   *
   * @type {State}
   */
  function start(code) {
    if (code === null) {
      return nok(code);
    }
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return lineStart;
  }

  /**
   *
   *
   * @type {State}
   */
  function lineStart(code) {
    return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
  }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const codeIndented = {
  name: 'codeIndented',
  tokenize: tokenizeCodeIndented
};

/** @type {Construct} */
const furtherStart = {
  partial: true,
  tokenize: tokenizeFurtherStart
};

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeCodeIndented(effects, ok, nok) {
  const self = this;
  return start;

  /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: manually check if interrupting like `markdown-rs`.

    effects.enter("codeIndented");
    // To do: use an improved `space_or_tab` function like `markdown-rs`,
    // so that we can drop the next state.
    return factorySpace(effects, afterPrefix, "linePrefix", 4 + 1)(code);
  }

  /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
  }

  /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === null) {
      return after(code);
    }
    if (markdownLineEnding(code)) {
      return effects.attempt(furtherStart, atBreak, after)(code);
    }
    effects.enter("codeFlowValue");
    return inside(code);
  }

  /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("codeFlowValue");
      return atBreak(code);
    }
    effects.consume(code);
    return inside;
  }

  /** @type {State} */
  function after(code) {
    effects.exit("codeIndented");
    // To do: allow interrupting like `markdown-rs`.
    // Feel free to interrupt.
    // tokenizer.interrupt = false
    return ok(code);
  }
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeFurtherStart(effects, ok, nok) {
  const self = this;
  return furtherStart;

  /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */
  function furtherStart(code) {
    // To do: improve `lazy` / `pierce` handling.
    // If this is a lazy line, it can’t be code.
    if (self.parser.lazy[self.now().line]) {
      return nok(code);
    }
    if (markdownLineEnding(code)) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      return furtherStart;
    }

    // To do: the code here in `micromark-js` is a bit different from
    // `markdown-rs` because there it can attempt spaces.
    // We can’t yet.
    //
    // To do: use an improved `space_or_tab` function like `markdown-rs`,
    // so that we can drop the next state.
    return factorySpace(effects, afterPrefix, "linePrefix", 4 + 1)(code);
  }

  /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : markdownLineEnding(code) ? furtherStart(code) : nok(code);
  }
}

/**
 * @import {
 *   Construct,
 *   Previous,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const codeText = {
  name: 'codeText',
  previous,
  resolve: resolveCodeText,
  tokenize: tokenizeCodeText
};

// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */
function resolveCodeText(events) {
  let tailExitIndex = events.length - 4;
  let headEnterIndex = 3;
  /** @type {number} */
  let index;
  /** @type {number | undefined} */
  let enter;

  // If we start and end with an EOL or a space.
  if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
    index = headEnterIndex;

    // And we have data.
    while (++index < tailExitIndex) {
      if (events[index][1].type === "codeTextData") {
        // Then we have padding.
        events[headEnterIndex][1].type = "codeTextPadding";
        events[tailExitIndex][1].type = "codeTextPadding";
        headEnterIndex += 2;
        tailExitIndex -= 2;
        break;
      }
    }
  }

  // Merge adjacent spaces and data.
  index = headEnterIndex - 1;
  tailExitIndex++;
  while (++index <= tailExitIndex) {
    if (enter === undefined) {
      if (index !== tailExitIndex && events[index][1].type !== "lineEnding") {
        enter = index;
      }
    } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
      events[enter][1].type = "codeTextData";
      if (index !== enter + 2) {
        events[enter][1].end = events[index - 1][1].end;
        events.splice(enter + 2, index - enter - 2);
        tailExitIndex -= index - enter - 2;
        index = enter + 2;
      }
      enter = undefined;
    }
  }
  return events;
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Previous}
 */
function previous(code) {
  // If there is a previous code, there will always be a tail.
  return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeCodeText(effects, ok, nok) {
  let sizeOpen = 0;
  /** @type {number} */
  let size;
  /** @type {Token} */
  let token;
  return start;

  /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("codeText");
    effects.enter("codeTextSequence");
    return sequenceOpen(code);
  }

  /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */
  function sequenceOpen(code) {
    if (code === 96) {
      effects.consume(code);
      sizeOpen++;
      return sequenceOpen;
    }
    effects.exit("codeTextSequence");
    return between(code);
  }

  /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */
  function between(code) {
    // EOF.
    if (code === null) {
      return nok(code);
    }

    // To do: next major: don’t do spaces in resolve, but when compiling,
    // like `markdown-rs`.
    // Tabs don’t work, and virtual spaces don’t make sense.
    if (code === 32) {
      effects.enter('space');
      effects.consume(code);
      effects.exit('space');
      return between;
    }

    // Closing fence? Could also be data.
    if (code === 96) {
      token = effects.enter("codeTextSequence");
      size = 0;
      return sequenceClose(code);
    }
    if (markdownLineEnding(code)) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      return between;
    }

    // Data.
    effects.enter("codeTextData");
    return data(code);
  }

  /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */
  function data(code) {
    if (code === null || code === 32 || code === 96 || markdownLineEnding(code)) {
      effects.exit("codeTextData");
      return between(code);
    }
    effects.consume(code);
    return data;
  }

  /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */
  function sequenceClose(code) {
    // More.
    if (code === 96) {
      effects.consume(code);
      size++;
      return sequenceClose;
    }

    // Done!
    if (size === sizeOpen) {
      effects.exit("codeTextSequence");
      effects.exit("codeText");
      return ok(code);
    }

    // More or less accents: mark as data.
    token.type = "codeTextData";
    return data(code);
  }
}

/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push(...newElements)` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */
class SpliceBuffer {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(initial) {
    /** @type {Array<T>} */
    this.left = initial ? [...initial] : [];
    /** @type {Array<T>} */
    this.right = [];
  }

  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(index) {
    if (index < 0 || index >= this.left.length + this.right.length) {
      throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
    }
    if (index < this.left.length) return this.left[index];
    return this.right[this.right.length - index + this.left.length - 1];
  }

  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }

  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    this.setCursor(0);
    return this.right.pop();
  }

  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(start, end) {
    /** @type {number} */
    const stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
    if (stop < this.left.length) {
      return this.left.slice(start, stop);
    }
    if (start > this.left.length) {
      return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
    }
    return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
  }

  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(start, deleteCount, items) {
    /** @type {number} */
    const count = deleteCount || 0;
    this.setCursor(Math.trunc(start));
    const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
    if (items) chunkedPush(this.left, items);
    return removed.reverse();
  }

  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    this.setCursor(Number.POSITIVE_INFINITY);
    return this.left.pop();
  }

  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(item) {
    this.setCursor(Number.POSITIVE_INFINITY);
    this.left.push(item);
  }

  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(items) {
    this.setCursor(Number.POSITIVE_INFINITY);
    chunkedPush(this.left, items);
  }

  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(item) {
    this.setCursor(0);
    this.right.push(item);
  }

  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(items) {
    this.setCursor(0);
    chunkedPush(this.right, items.reverse());
  }

  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
    if (n < this.left.length) {
      // Move cursor to the this.left
      const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
      chunkedPush(this.right, removed.reverse());
    } else {
      // Move cursor to the this.right
      const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
      chunkedPush(this.left, removed.reverse());
    }
  }
}

/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */
function chunkedPush(list, right) {
  /** @type {number} */
  let chunkStart = 0;
  if (right.length < 10000) {
    list.push(...right);
  } else {
    while (chunkStart < right.length) {
      list.push(...right.slice(chunkStart, chunkStart + 10000));
      chunkStart += 10000;
    }
  }
}

/**
 * @import {Chunk, Event, Token} from 'micromark-util-types'
 */

/**
 * Tokenize subcontent.
 *
 * @param {Array<Event>} eventsArray
 *   List of events.
 * @returns {boolean}
 *   Whether subtokens were found.
 */
// eslint-disable-next-line complexity
function subtokenize(eventsArray) {
  /** @type {Record<string, number>} */
  const jumps = {};
  let index = -1;
  /** @type {Event} */
  let event;
  /** @type {number | undefined} */
  let lineIndex;
  /** @type {number} */
  let otherIndex;
  /** @type {Event} */
  let otherEvent;
  /** @type {Array<Event>} */
  let parameters;
  /** @type {Array<Event>} */
  let subevents;
  /** @type {boolean | undefined} */
  let more;
  const events = new SpliceBuffer(eventsArray);
  while (++index < events.length) {
    while (index in jumps) {
      index = jumps[index];
    }
    event = events.get(index);

    // Add a hook for the GFM tasklist extension, which needs to know if text
    // is in the first content of a list item.
    if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
      subevents = event[1]._tokenizer.events;
      otherIndex = 0;
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") {
        otherIndex += 2;
      }
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === "content") {
            break;
          }
          if (subevents[otherIndex][1].type === "chunkText") {
            subevents[otherIndex][1]._isInFirstContentOfListItem = true;
            otherIndex++;
          }
        }
      }
    }

    // Enter.
    if (event[0] === 'enter') {
      if (event[1].contentType) {
        Object.assign(jumps, subcontent(events, index));
        index = jumps[index];
        more = true;
      }
    }
    // Exit.
    else if (event[1]._container) {
      otherIndex = index;
      lineIndex = undefined;
      while (otherIndex--) {
        otherEvent = events.get(otherIndex);
        if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
          if (otherEvent[0] === 'enter') {
            if (lineIndex) {
              events.get(lineIndex)[1].type = "lineEndingBlank";
            }
            otherEvent[1].type = "lineEnding";
            lineIndex = otherIndex;
          }
        } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ; else {
          break;
        }
      }
      if (lineIndex) {
        // Fix position.
        event[1].end = {
          ...events.get(lineIndex)[1].start
        };

        // Switch container exit w/ line endings.
        parameters = events.slice(lineIndex, index);
        parameters.unshift(event);
        events.splice(lineIndex, index - lineIndex + 1, parameters);
      }
    }
  }

  // The changes to the `events` buffer must be copied back into the eventsArray
  splice(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
  return !more;
}

/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 *   Events.
 * @param {number} eventIndex
 *   Index.
 * @returns {Record<string, number>}
 *   Gaps.
 */
function subcontent(events, eventIndex) {
  const token = events.get(eventIndex)[1];
  const context = events.get(eventIndex)[2];
  let startPosition = eventIndex - 1;
  /** @type {Array<number>} */
  const startPositions = [];
  let tokenizer = token._tokenizer;
  if (!tokenizer) {
    tokenizer = context.parser[token.contentType](token.start);
    if (token._contentTypeTextTrailing) {
      tokenizer._contentTypeTextTrailing = true;
    }
  }
  const childEvents = tokenizer.events;
  /** @type {Array<[number, number]>} */
  const jumps = [];
  /** @type {Record<string, number>} */
  const gaps = {};
  /** @type {Array<Chunk>} */
  let stream;
  /** @type {Token | undefined} */
  let previous;
  let index = -1;
  /** @type {Token | undefined} */
  let current = token;
  let adjust = 0;
  let start = 0;
  const breaks = [start];

  // Loop forward through the linked tokens to pass them in order to the
  // subtokenizer.
  while (current) {
    // Find the position of the event for this token.
    while (events.get(++startPosition)[1] !== current) {
      // Empty.
    }
    startPositions.push(startPosition);
    if (!current._tokenizer) {
      stream = context.sliceStream(current);
      if (!current.next) {
        stream.push(null);
      }
      if (previous) {
        tokenizer.defineSkip(current.start);
      }
      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true;
      }
      tokenizer.write(stream);
      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = undefined;
      }
    }

    // Unravel the next token.
    previous = current;
    current = current.next;
  }

  // Now, loop back through all events (and linked tokens), to figure out which
  // parts belong where.
  current = token;
  while (++index < childEvents.length) {
    if (
    // Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
      start = index + 1;
      breaks.push(start);
      // Help GC.
      current._tokenizer = undefined;
      current.previous = undefined;
      current = current.next;
    }
  }

  // Help GC.
  tokenizer.events = [];

  // If there’s one more token (which is the cases for lines that end in an
  // EOF), that’s perfect: the last point we found starts it.
  // If there isn’t then make sure any remaining content is added to it.
  if (current) {
    // Help GC.
    current._tokenizer = undefined;
    current.previous = undefined;
  } else {
    breaks.pop();
  }

  // Now splice the events from the subtokenizer into the current events,
  // moving back to front so that splice indices aren’t affected.
  index = breaks.length;
  while (index--) {
    const slice = childEvents.slice(breaks[index], breaks[index + 1]);
    const start = startPositions.pop();
    jumps.push([start, start + slice.length - 1]);
    events.splice(start, 2, slice);
  }
  jumps.reverse();
  index = -1;
  while (++index < jumps.length) {
    gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
    adjust += jumps[index][1] - jumps[index][0] - 1;
  }
  return gaps;
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */
/**
 * No name because it must not be turned off.
 * @type {Construct}
 */
const content = {
  resolve: resolveContent,
  tokenize: tokenizeContent
};

/** @type {Construct} */
const continuationConstruct = {
  partial: true,
  tokenize: tokenizeContinuation
};

/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */
function resolveContent(events) {
  subtokenize(events);
  return events;
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeContent(effects, ok) {
  /** @type {Token | undefined} */
  let previous;
  return chunkStart;

  /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */
  function chunkStart(code) {
    effects.enter("content");
    previous = effects.enter("chunkContent", {
      contentType: "content"
    });
    return chunkInside(code);
  }

  /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */
  function chunkInside(code) {
    if (code === null) {
      return contentEnd(code);
    }

    // To do: in `markdown-rs`, each line is parsed on its own, and everything
    // is stitched together resolving.
    if (markdownLineEnding(code)) {
      return effects.check(continuationConstruct, contentContinue, contentEnd)(code);
    }

    // Data.
    effects.consume(code);
    return chunkInside;
  }

  /**
   *
   *
   * @type {State}
   */
  function contentEnd(code) {
    effects.exit("chunkContent");
    effects.exit("content");
    return ok(code);
  }

  /**
   *
   *
   * @type {State}
   */
  function contentContinue(code) {
    effects.consume(code);
    effects.exit("chunkContent");
    previous.next = effects.enter("chunkContent", {
      contentType: "content",
      previous
    });
    previous = previous.next;
    return chunkInside;
  }
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeContinuation(effects, ok, nok) {
  const self = this;
  return startLookahead;

  /**
   *
   *
   * @type {State}
   */
  function startLookahead(code) {
    effects.exit("chunkContent");
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return factorySpace(effects, prefixed, "linePrefix");
  }

  /**
   *
   *
   * @type {State}
   */
  function prefixed(code) {
    if (code === null || markdownLineEnding(code)) {
      return nok(code);
    }

    // Always populated by defaults.

    const tail = self.events[self.events.length - 1];
    if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) {
      return ok(code);
    }
    return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
  }
}

/**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */
/**
 * Parse destinations.
 *
 * ###### Examples
 *
 * ```markdown
 * <a>
 * <a\>b>
 * <a b>
 * <a)>
 * a
 * a\)b
 * a(b)c
 * a(b)
 * ```
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {State} nok
 *   State switched to when unsuccessful.
 * @param {TokenType} type
 *   Type for whole (`<a>` or `b`).
 * @param {TokenType} literalType
 *   Type when enclosed (`<a>`).
 * @param {TokenType} literalMarkerType
 *   Type for enclosing (`<` and `>`).
 * @param {TokenType} rawType
 *   Type when not enclosed (`b`).
 * @param {TokenType} stringType
 *   Type for the value (`a` or `b`).
 * @param {number | undefined} [max=Infinity]
 *   Depth of nested parens (inclusive).
 * @returns {State}
 *   Start state.
 */
function factoryDestination(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
  const limit = max || Number.POSITIVE_INFINITY;
  let balance = 0;
  return start;

  /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (code === 60) {
      effects.enter(type);
      effects.enter(literalType);
      effects.enter(literalMarkerType);
      effects.consume(code);
      effects.exit(literalMarkerType);
      return enclosedBefore;
    }

    // ASCII control, space, closing paren.
    if (code === null || code === 32 || code === 41 || asciiControl(code)) {
      return nok(code);
    }
    effects.enter(type);
    effects.enter(rawType);
    effects.enter(stringType);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return raw(code);
  }

  /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */
  function enclosedBefore(code) {
    if (code === 62) {
      effects.enter(literalMarkerType);
      effects.consume(code);
      effects.exit(literalMarkerType);
      effects.exit(literalType);
      effects.exit(type);
      return ok;
    }
    effects.enter(stringType);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return enclosed(code);
  }

  /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */
  function enclosed(code) {
    if (code === 62) {
      effects.exit("chunkString");
      effects.exit(stringType);
      return enclosedBefore(code);
    }
    if (code === null || code === 60 || markdownLineEnding(code)) {
      return nok(code);
    }
    effects.consume(code);
    return code === 92 ? enclosedEscape : enclosed;
  }

  /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */
  function enclosedEscape(code) {
    if (code === 60 || code === 62 || code === 92) {
      effects.consume(code);
      return enclosed;
    }
    return enclosed(code);
  }

  /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function raw(code) {
    if (!balance && (code === null || code === 41 || markdownLineEndingOrSpace(code))) {
      effects.exit("chunkString");
      effects.exit(stringType);
      effects.exit(rawType);
      effects.exit(type);
      return ok(code);
    }
    if (balance < limit && code === 40) {
      effects.consume(code);
      balance++;
      return raw;
    }
    if (code === 41) {
      effects.consume(code);
      balance--;
      return raw;
    }

    // ASCII control (but *not* `\0`) and space and `(`.
    // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
    // doesn’t.
    if (code === null || code === 32 || code === 40 || asciiControl(code)) {
      return nok(code);
    }
    effects.consume(code);
    return code === 92 ? rawEscape : raw;
  }

  /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */
  function rawEscape(code) {
    if (code === 40 || code === 41 || code === 92) {
      effects.consume(code);
      return raw;
    }
    return raw(code);
  }
}

/**
 * @import {
 *   Effects,
 *   State,
 *   TokenizeContext,
 *   TokenType
 * } from 'micromark-util-types'
 */
/**
 * Parse labels.
 *
 * > 👉 **Note**: labels in markdown are capped at 999 characters in the string.
 *
 * ###### Examples
 *
 * ```markdown
 * [a]
 * [a
 * b]
 * [a\]b]
 * ```
 *
 * @this {TokenizeContext}
 *   Tokenize context.
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {State} nok
 *   State switched to when unsuccessful.
 * @param {TokenType} type
 *   Type of the whole label (`[a]`).
 * @param {TokenType} markerType
 *   Type for the markers (`[` and `]`).
 * @param {TokenType} stringType
 *   Type for the identifier (`a`).
 * @returns {State}
 *   Start state.
 */
function factoryLabel(effects, ok, nok, type, markerType, stringType) {
  const self = this;
  let size = 0;
  /** @type {boolean} */
  let seen;
  return start;

  /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code);
    effects.exit(markerType);
    effects.enter(stringType);
    return atBreak;
  }

  /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (size > 999 || code === null || code === 91 || code === 93 && !seen ||
    // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) {
      return nok(code);
    }
    if (code === 93) {
      effects.exit(stringType);
      effects.enter(markerType);
      effects.consume(code);
      effects.exit(markerType);
      effects.exit(type);
      return ok;
    }

    // To do: indent? Link chunks and EOLs together?
    if (markdownLineEnding(code)) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      return atBreak;
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return labelInside(code);
  }

  /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */
  function labelInside(code) {
    if (code === null || code === 91 || code === 93 || markdownLineEnding(code) || size++ > 999) {
      effects.exit("chunkString");
      return atBreak(code);
    }
    effects.consume(code);
    if (!seen) seen = !markdownSpace(code);
    return code === 92 ? labelEscape : labelInside;
  }

  /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code);
      size++;
      return labelInside;
    }
    return labelInside(code);
  }
}

/**
 * @import {
 *   Code,
 *   Effects,
 *   State,
 *   TokenType
 * } from 'micromark-util-types'
 */
/**
 * Parse titles.
 *
 * ###### Examples
 *
 * ```markdown
 * "a"
 * 'b'
 * (c)
 * "a
 * b"
 * 'a
 *     b'
 * (a\)b)
 * ```
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {State} nok
 *   State switched to when unsuccessful.
 * @param {TokenType} type
 *   Type of the whole title (`"a"`, `'b'`, `(c)`).
 * @param {TokenType} markerType
 *   Type for the markers (`"`, `'`, `(`, and `)`).
 * @param {TokenType} stringType
 *   Type for the value (`a`).
 * @returns {State}
 *   Start state.
 */
function factoryTitle(effects, ok, nok, type, markerType, stringType) {
  /** @type {NonNullable<Code>} */
  let marker;
  return start;

  /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (code === 34 || code === 39 || code === 40) {
      effects.enter(type);
      effects.enter(markerType);
      effects.consume(code);
      effects.exit(markerType);
      marker = code === 40 ? 41 : code;
      return begin;
    }
    return nok(code);
  }

  /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */
  function begin(code) {
    if (code === marker) {
      effects.enter(markerType);
      effects.consume(code);
      effects.exit(markerType);
      effects.exit(type);
      return ok;
    }
    effects.enter(stringType);
    return atBreak(code);
  }

  /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === marker) {
      effects.exit(stringType);
      return begin(marker);
    }
    if (code === null) {
      return nok(code);
    }

    // Note: blank lines can’t exist in content.
    if (markdownLineEnding(code)) {
      // To do: use `space_or_tab_eol_with_options`, connect.
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      return factorySpace(effects, atBreak, "linePrefix");
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return inside(code);
  }

  /**
   *
   *
   * @type {State}
   */
  function inside(code) {
    if (code === marker || code === null || markdownLineEnding(code)) {
      effects.exit("chunkString");
      return atBreak(code);
    }
    effects.consume(code);
    return code === 92 ? escape : inside;
  }

  /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */
  function escape(code) {
    if (code === marker || code === 92) {
      effects.consume(code);
      return inside;
    }
    return inside(code);
  }
}

/**
 * @import {Effects, State} from 'micromark-util-types'
 */
/**
 * Parse spaces and tabs.
 *
 * There is no `nok` parameter:
 *
 * *   line endings or spaces in markdown are often optional, in which case this
 *     factory can be used and `ok` will be switched to whether spaces were found
 *     or not
 * *   one line ending or space can be detected with
 *     `markdownLineEndingOrSpace(code)` right before using `factoryWhitespace`
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @returns {State}
 *   Start state.
 */
function factoryWhitespace(effects, ok) {
  /** @type {boolean} */
  let seen;
  return start;

  /** @type {State} */
  function start(code) {
    if (markdownLineEnding(code)) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      seen = true;
      return start;
    }
    if (markdownSpace(code)) {
      return factorySpace(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
    }
    return ok(code);
  }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const definition = {
  name: 'definition',
  tokenize: tokenizeDefinition
};

/** @type {Construct} */
const titleBefore = {
  partial: true,
  tokenize: tokenizeTitleBefore
};

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeDefinition(effects, ok, nok) {
  const self = this;
  /** @type {string} */
  let identifier;
  return start;

  /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // Do not interrupt paragraphs (but do follow definitions).
    // To do: do `interrupt` the way `markdown-rs` does.
    // To do: parse whitespace the way `markdown-rs` does.
    effects.enter("definition");
    return before(code);
  }

  /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    // To do: parse whitespace the way `markdown-rs` does.

    return factoryLabel.call(self, effects, labelAfter,
    // Note: we don’t need to reset the way `markdown-rs` does.
    nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
  }

  /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelAfter(code) {
    identifier = normalizeIdentifier(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
    if (code === 58) {
      effects.enter("definitionMarker");
      effects.consume(code);
      effects.exit("definitionMarker");
      return markerAfter;
    }
    return nok(code);
  }

  /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */
  function markerAfter(code) {
    // Note: whitespace is optional.
    return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, destinationBefore)(code) : destinationBefore(code);
  }

  /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */
  function destinationBefore(code) {
    return factoryDestination(effects, destinationAfter,
    // Note: we don’t need to reset the way `markdown-rs` does.
    nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
  }

  /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */
  function destinationAfter(code) {
    return effects.attempt(titleBefore, after, after)(code);
  }

  /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    return markdownSpace(code) ? factorySpace(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
  }

  /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function afterWhitespace(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("definition");

      // Note: we don’t care about uniqueness.
      // It’s likely that that doesn’t happen very frequently.
      // It is more likely that it wastes precious time.
      self.parser.defined.push(identifier);

      // To do: `markdown-rs` interrupt.
      // // You’d be interrupting.
      // tokenizer.interrupt = true
      return ok(code);
    }
    return nok(code);
  }
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeTitleBefore(effects, ok, nok) {
  return titleBefore;

  /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */
  function titleBefore(code) {
    return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, beforeMarker)(code) : nok(code);
  }

  /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */
  function beforeMarker(code) {
    return factoryTitle(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
  }

  /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function titleAfter(code) {
    return markdownSpace(code) ? factorySpace(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
  }

  /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function titleAfterOptionalWhitespace(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code);
  }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const hardBreakEscape = {
  name: 'hardBreakEscape',
  tokenize: tokenizeHardBreakEscape
};

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeHardBreakEscape(effects, ok, nok) {
  return start;

  /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("hardBreakEscape");
    effects.consume(code);
    return after;
  }

  /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */
  function after(code) {
    if (markdownLineEnding(code)) {
      effects.exit("hardBreakEscape");
      return ok(code);
    }
    return nok(code);
  }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const headingAtx = {
  name: 'headingAtx',
  resolve: resolveHeadingAtx,
  tokenize: tokenizeHeadingAtx
};

/** @type {Resolver} */
function resolveHeadingAtx(events, context) {
  let contentEnd = events.length - 2;
  let contentStart = 3;
  /** @type {Token} */
  let content;
  /** @type {Token} */
  let text;

  // Prefix whitespace, part of the opening.
  if (events[contentStart][1].type === "whitespace") {
    contentStart += 2;
  }

  // Suffix whitespace, part of the closing.
  if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") {
    contentEnd -= 2;
  }
  if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
  }
  if (contentEnd > contentStart) {
    content = {
      type: "atxHeadingText",
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end
    };
    text = {
      type: "chunkText",
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end,
      contentType: "text"
    };
    splice(events, contentStart, contentEnd - contentStart + 1, [['enter', content, context], ['enter', text, context], ['exit', text, context], ['exit', content, context]]);
  }
  return events;
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeHeadingAtx(effects, ok, nok) {
  let size = 0;
  return start;

  /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: parse indent like `markdown-rs`.
    effects.enter("atxHeading");
    return before(code);
  }

  /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    effects.enter("atxHeadingSequence");
    return sequenceOpen(code);
  }

  /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function sequenceOpen(code) {
    if (code === 35 && size++ < 6) {
      effects.consume(code);
      return sequenceOpen;
    }

    // Always at least one `#`.
    if (code === null || markdownLineEndingOrSpace(code)) {
      effects.exit("atxHeadingSequence");
      return atBreak(code);
    }
    return nok(code);
  }

  /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === 35) {
      effects.enter("atxHeadingSequence");
      return sequenceFurther(code);
    }
    if (code === null || markdownLineEnding(code)) {
      effects.exit("atxHeading");
      // To do: interrupt like `markdown-rs`.
      // // Feel free to interrupt.
      // tokenizer.interrupt = false
      return ok(code);
    }
    if (markdownSpace(code)) {
      return factorySpace(effects, atBreak, "whitespace")(code);
    }

    // To do: generate `data` tokens, add the `text` token later.
    // Needs edit map, see: `markdown.rs`.
    effects.enter("atxHeadingText");
    return data(code);
  }

  /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */
  function sequenceFurther(code) {
    if (code === 35) {
      effects.consume(code);
      return sequenceFurther;
    }
    effects.exit("atxHeadingSequence");
    return atBreak(code);
  }

  /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */
  function data(code) {
    if (code === null || code === 35 || markdownLineEndingOrSpace(code)) {
      effects.exit("atxHeadingText");
      return atBreak(code);
    }
    effects.consume(code);
    return data;
  }
}

/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */
const htmlBlockNames = [
  'address',
  'article',
  'aside',
  'base',
  'basefont',
  'blockquote',
  'body',
  'caption',
  'center',
  'col',
  'colgroup',
  'dd',
  'details',
  'dialog',
  'dir',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'frame',
  'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hr',
  'html',
  'iframe',
  'legend',
  'li',
  'link',
  'main',
  'menu',
  'menuitem',
  'nav',
  'noframes',
  'ol',
  'optgroup',
  'option',
  'p',
  'param',
  'search',
  'section',
  'summary',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'track',
  'ul'
];

/**
 * List of lowercase HTML “raw” tag names.
 *
 * The list, when parsing HTML (flow), results in HTML that can include lines
 * without exiting, until a closing tag also in this list is found (condition
 * 1).
 *
 * This module is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `textarea` was added in `CommonMark@0.30`.
 */
const htmlRawNames = ['pre', 'script', 'style', 'textarea'];

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */

/** @type {Construct} */
const htmlFlow = {
  concrete: true,
  name: 'htmlFlow',
  resolveTo: resolveToHtmlFlow,
  tokenize: tokenizeHtmlFlow
};

/** @type {Construct} */
const blankLineBefore = {
  partial: true,
  tokenize: tokenizeBlankLineBefore
};
const nonLazyContinuationStart = {
  partial: true,
  tokenize: tokenizeNonLazyContinuationStart
};

/** @type {Resolver} */
function resolveToHtmlFlow(events) {
  let index = events.length;
  while (index--) {
    if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") {
      break;
    }
  }
  if (index > 1 && events[index - 2][1].type === "linePrefix") {
    // Add the prefix start to the HTML token.
    events[index][1].start = events[index - 2][1].start;
    // Add the prefix start to the HTML line token.
    events[index + 1][1].start = events[index - 2][1].start;
    // Remove the line prefix.
    events.splice(index - 2, 2);
  }
  return events;
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeHtmlFlow(effects, ok, nok) {
  const self = this;
  /** @type {number} */
  let marker;
  /** @type {boolean} */
  let closingTag;
  /** @type {string} */
  let buffer;
  /** @type {number} */
  let index;
  /** @type {Code} */
  let markerB;
  return start;

  /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: parse indent like `markdown-rs`.
    return before(code);
  }

  /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    effects.enter("htmlFlow");
    effects.enter("htmlFlowData");
    effects.consume(code);
    return open;
  }

  /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 33) {
      effects.consume(code);
      return declarationOpen;
    }
    if (code === 47) {
      effects.consume(code);
      closingTag = true;
      return tagCloseStart;
    }
    if (code === 63) {
      effects.consume(code);
      marker = 3;
      // To do:
      // tokenizer.concrete = true
      // To do: use `markdown-rs` style interrupt.
      // While we’re in an instruction instead of a declaration, we’re on a `?`
      // right now, so we do need to search for `>`, similar to declarations.
      return self.interrupt ? ok : continuationDeclarationInside;
    }

    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      // Always the case.
      effects.consume(code);
      buffer = String.fromCharCode(code);
      return tagName;
    }
    return nok(code);
  }

  /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */
  function declarationOpen(code) {
    if (code === 45) {
      effects.consume(code);
      marker = 2;
      return commentOpenInside;
    }
    if (code === 91) {
      effects.consume(code);
      marker = 5;
      index = 0;
      return cdataOpenInside;
    }

    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      effects.consume(code);
      marker = 4;
      // // Do not form containers.
      // tokenizer.concrete = true
      return self.interrupt ? ok : continuationDeclarationInside;
    }
    return nok(code);
  }

  /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */
  function commentOpenInside(code) {
    if (code === 45) {
      effects.consume(code);
      // // Do not form containers.
      // tokenizer.concrete = true
      return self.interrupt ? ok : continuationDeclarationInside;
    }
    return nok(code);
  }

  /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */
  function cdataOpenInside(code) {
    const value = "CDATA[";
    if (code === value.charCodeAt(index++)) {
      effects.consume(code);
      if (index === value.length) {
        // // Do not form containers.
        // tokenizer.concrete = true
        return self.interrupt ? ok : continuation;
      }
      return cdataOpenInside;
    }
    return nok(code);
  }

  /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */
  function tagCloseStart(code) {
    if (asciiAlpha(code)) {
      // Always the case.
      effects.consume(code);
      buffer = String.fromCharCode(code);
      return tagName;
    }
    return nok(code);
  }

  /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */
  function tagName(code) {
    if (code === null || code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      const slash = code === 47;
      const name = buffer.toLowerCase();
      if (!slash && !closingTag && htmlRawNames.includes(name)) {
        marker = 1;
        // // Do not form containers.
        // tokenizer.concrete = true
        return self.interrupt ? ok(code) : continuation(code);
      }
      if (htmlBlockNames.includes(buffer.toLowerCase())) {
        marker = 6;
        if (slash) {
          effects.consume(code);
          return basicSelfClosing;
        }

        // // Do not form containers.
        // tokenizer.concrete = true
        return self.interrupt ? ok(code) : continuation(code);
      }
      marker = 7;
      // Do not support complete HTML when interrupting.
      return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
    }

    // ASCII alphanumerical and `-`.
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code);
      buffer += String.fromCharCode(code);
      return tagName;
    }
    return nok(code);
  }

  /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */
  function basicSelfClosing(code) {
    if (code === 62) {
      effects.consume(code);
      // // Do not form containers.
      // tokenizer.concrete = true
      return self.interrupt ? ok : continuation;
    }
    return nok(code);
  }

  /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */
  function completeClosingTagAfter(code) {
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeClosingTagAfter;
    }
    return completeEnd(code);
  }

  /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeNameBefore(code) {
    if (code === 47) {
      effects.consume(code);
      return completeEnd;
    }

    // ASCII alphanumerical and `:` and `_`.
    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code);
      return completeAttributeName;
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAttributeNameBefore;
    }
    return completeEnd(code);
  }

  /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeName(code) {
    // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
    if (code === 45 || code === 46 || code === 58 || code === 95 || asciiAlphanumeric(code)) {
      effects.consume(code);
      return completeAttributeName;
    }
    return completeAttributeNameAfter(code);
  }

  /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code);
      return completeAttributeValueBefore;
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAttributeNameAfter;
    }
    return completeAttributeNameBefore(code);
  }

  /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueBefore(code) {
    if (code === null || code === 60 || code === 61 || code === 62 || code === 96) {
      return nok(code);
    }
    if (code === 34 || code === 39) {
      effects.consume(code);
      markerB = code;
      return completeAttributeValueQuoted;
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAttributeValueBefore;
    }
    return completeAttributeValueUnquoted(code);
  }

  /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueQuoted(code) {
    if (code === markerB) {
      effects.consume(code);
      markerB = null;
      return completeAttributeValueQuotedAfter;
    }
    if (code === null || markdownLineEnding(code)) {
      return nok(code);
    }
    effects.consume(code);
    return completeAttributeValueQuoted;
  }

  /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueUnquoted(code) {
    if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || markdownLineEndingOrSpace(code)) {
      return completeAttributeNameAfter(code);
    }
    effects.consume(code);
    return completeAttributeValueUnquoted;
  }

  /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueQuotedAfter(code) {
    if (code === 47 || code === 62 || markdownSpace(code)) {
      return completeAttributeNameBefore(code);
    }
    return nok(code);
  }

  /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */
  function completeEnd(code) {
    if (code === 62) {
      effects.consume(code);
      return completeAfter;
    }
    return nok(code);
  }

  /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */
  function completeAfter(code) {
    if (code === null || markdownLineEnding(code)) {
      // // Do not form containers.
      // tokenizer.concrete = true
      return continuation(code);
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAfter;
    }
    return nok(code);
  }

  /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */
  function continuation(code) {
    if (code === 45 && marker === 2) {
      effects.consume(code);
      return continuationCommentInside;
    }
    if (code === 60 && marker === 1) {
      effects.consume(code);
      return continuationRawTagOpen;
    }
    if (code === 62 && marker === 4) {
      effects.consume(code);
      return continuationClose;
    }
    if (code === 63 && marker === 3) {
      effects.consume(code);
      return continuationDeclarationInside;
    }
    if (code === 93 && marker === 5) {
      effects.consume(code);
      return continuationCdataInside;
    }
    if (markdownLineEnding(code) && (marker === 6 || marker === 7)) {
      effects.exit("htmlFlowData");
      return effects.check(blankLineBefore, continuationAfter, continuationStart)(code);
    }
    if (code === null || markdownLineEnding(code)) {
      effects.exit("htmlFlowData");
      return continuationStart(code);
    }
    effects.consume(code);
    return continuation;
  }

  /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */
  function continuationStart(code) {
    return effects.check(nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
  }

  /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */
  function continuationStartNonLazy(code) {
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return continuationBefore;
  }

  /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */
  function continuationBefore(code) {
    if (code === null || markdownLineEnding(code)) {
      return continuationStart(code);
    }
    effects.enter("htmlFlowData");
    return continuation(code);
  }

  /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */
  function continuationCommentInside(code) {
    if (code === 45) {
      effects.consume(code);
      return continuationDeclarationInside;
    }
    return continuation(code);
  }

  /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */
  function continuationRawTagOpen(code) {
    if (code === 47) {
      effects.consume(code);
      buffer = '';
      return continuationRawEndTag;
    }
    return continuation(code);
  }

  /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */
  function continuationRawEndTag(code) {
    if (code === 62) {
      const name = buffer.toLowerCase();
      if (htmlRawNames.includes(name)) {
        effects.consume(code);
        return continuationClose;
      }
      return continuation(code);
    }
    if (asciiAlpha(code) && buffer.length < 8) {
      // Always the case.
      effects.consume(code);
      buffer += String.fromCharCode(code);
      return continuationRawEndTag;
    }
    return continuation(code);
  }

  /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */
  function continuationCdataInside(code) {
    if (code === 93) {
      effects.consume(code);
      return continuationDeclarationInside;
    }
    return continuation(code);
  }

  /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */
  function continuationDeclarationInside(code) {
    if (code === 62) {
      effects.consume(code);
      return continuationClose;
    }

    // More dashes.
    if (code === 45 && marker === 2) {
      effects.consume(code);
      return continuationDeclarationInside;
    }
    return continuation(code);
  }

  /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */
  function continuationClose(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("htmlFlowData");
      return continuationAfter(code);
    }
    effects.consume(code);
    return continuationClose;
  }

  /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */
  function continuationAfter(code) {
    effects.exit("htmlFlow");
    // // Feel free to interrupt.
    // tokenizer.interrupt = false
    // // No longer concrete.
    // tokenizer.concrete = false
    return ok(code);
  }
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeNonLazyContinuationStart(effects, ok, nok) {
  const self = this;
  return start;

  /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (markdownLineEnding(code)) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      return after;
    }
    return nok(code);
  }

  /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
  }
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeBlankLineBefore(effects, ok, nok) {
  return start;

  /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return effects.attempt(blankLine, ok, nok);
  }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const htmlText = {
  name: 'htmlText',
  tokenize: tokenizeHtmlText
};

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeHtmlText(effects, ok, nok) {
  const self = this;
  /** @type {NonNullable<Code> | undefined} */
  let marker;
  /** @type {number} */
  let index;
  /** @type {State} */
  let returnState;
  return start;

  /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("htmlText");
    effects.enter("htmlTextData");
    effects.consume(code);
    return open;
  }

  /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 33) {
      effects.consume(code);
      return declarationOpen;
    }
    if (code === 47) {
      effects.consume(code);
      return tagCloseStart;
    }
    if (code === 63) {
      effects.consume(code);
      return instruction;
    }

    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      effects.consume(code);
      return tagOpen;
    }
    return nok(code);
  }

  /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function declarationOpen(code) {
    if (code === 45) {
      effects.consume(code);
      return commentOpenInside;
    }
    if (code === 91) {
      effects.consume(code);
      index = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha(code)) {
      effects.consume(code);
      return declaration;
    }
    return nok(code);
  }

  /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function commentOpenInside(code) {
    if (code === 45) {
      effects.consume(code);
      return commentEnd;
    }
    return nok(code);
  }

  /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */
  function comment(code) {
    if (code === null) {
      return nok(code);
    }
    if (code === 45) {
      effects.consume(code);
      return commentClose;
    }
    if (markdownLineEnding(code)) {
      returnState = comment;
      return lineEndingBefore(code);
    }
    effects.consume(code);
    return comment;
  }

  /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */
  function commentClose(code) {
    if (code === 45) {
      effects.consume(code);
      return commentEnd;
    }
    return comment(code);
  }

  /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */
  function commentEnd(code) {
    return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
  }

  /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */
  function cdataOpenInside(code) {
    const value = "CDATA[";
    if (code === value.charCodeAt(index++)) {
      effects.consume(code);
      return index === value.length ? cdata : cdataOpenInside;
    }
    return nok(code);
  }

  /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */
  function cdata(code) {
    if (code === null) {
      return nok(code);
    }
    if (code === 93) {
      effects.consume(code);
      return cdataClose;
    }
    if (markdownLineEnding(code)) {
      returnState = cdata;
      return lineEndingBefore(code);
    }
    effects.consume(code);
    return cdata;
  }

  /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */
  function cdataClose(code) {
    if (code === 93) {
      effects.consume(code);
      return cdataEnd;
    }
    return cdata(code);
  }

  /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */
  function cdataEnd(code) {
    if (code === 62) {
      return end(code);
    }
    if (code === 93) {
      effects.consume(code);
      return cdataEnd;
    }
    return cdata(code);
  }

  /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function declaration(code) {
    if (code === null || code === 62) {
      return end(code);
    }
    if (markdownLineEnding(code)) {
      returnState = declaration;
      return lineEndingBefore(code);
    }
    effects.consume(code);
    return declaration;
  }

  /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function instruction(code) {
    if (code === null) {
      return nok(code);
    }
    if (code === 63) {
      effects.consume(code);
      return instructionClose;
    }
    if (markdownLineEnding(code)) {
      returnState = instruction;
      return lineEndingBefore(code);
    }
    effects.consume(code);
    return instruction;
  }

  /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */
  function instructionClose(code) {
    return code === 62 ? end(code) : instruction(code);
  }

  /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function tagCloseStart(code) {
    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      effects.consume(code);
      return tagClose;
    }
    return nok(code);
  }

  /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function tagClose(code) {
    // ASCII alphanumerical and `-`.
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code);
      return tagClose;
    }
    return tagCloseBetween(code);
  }

  /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function tagCloseBetween(code) {
    if (markdownLineEnding(code)) {
      returnState = tagCloseBetween;
      return lineEndingBefore(code);
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return tagCloseBetween;
    }
    return end(code);
  }

  /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function tagOpen(code) {
    // ASCII alphanumerical and `-`.
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code);
      return tagOpen;
    }
    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code);
    }
    return nok(code);
  }

  /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function tagOpenBetween(code) {
    if (code === 47) {
      effects.consume(code);
      return end;
    }

    // ASCII alphabetical and `:` and `_`.
    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code);
      return tagOpenAttributeName;
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenBetween;
      return lineEndingBefore(code);
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return tagOpenBetween;
    }
    return end(code);
  }

  /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeName(code) {
    // ASCII alphabetical and `-`, `.`, `:`, and `_`.
    if (code === 45 || code === 46 || code === 58 || code === 95 || asciiAlphanumeric(code)) {
      effects.consume(code);
      return tagOpenAttributeName;
    }
    return tagOpenAttributeNameAfter(code);
  }

  /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code);
      return tagOpenAttributeValueBefore;
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeNameAfter;
      return lineEndingBefore(code);
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return tagOpenAttributeNameAfter;
    }
    return tagOpenBetween(code);
  }

  /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueBefore(code) {
    if (code === null || code === 60 || code === 61 || code === 62 || code === 96) {
      return nok(code);
    }
    if (code === 34 || code === 39) {
      effects.consume(code);
      marker = code;
      return tagOpenAttributeValueQuoted;
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueBefore;
      return lineEndingBefore(code);
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return tagOpenAttributeValueBefore;
    }
    effects.consume(code);
    return tagOpenAttributeValueUnquoted;
  }

  /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueQuoted(code) {
    if (code === marker) {
      effects.consume(code);
      marker = undefined;
      return tagOpenAttributeValueQuotedAfter;
    }
    if (code === null) {
      return nok(code);
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueQuoted;
      return lineEndingBefore(code);
    }
    effects.consume(code);
    return tagOpenAttributeValueQuoted;
  }

  /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueUnquoted(code) {
    if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) {
      return nok(code);
    }
    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code);
    }
    effects.consume(code);
    return tagOpenAttributeValueUnquoted;
  }

  /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueQuotedAfter(code) {
    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code);
    }
    return nok(code);
  }

  /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */
  function end(code) {
    if (code === 62) {
      effects.consume(code);
      effects.exit("htmlTextData");
      effects.exit("htmlText");
      return ok;
    }
    return nok(code);
  }

  /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */
  function lineEndingBefore(code) {
    effects.exit("htmlTextData");
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return lineEndingAfter;
  }

  /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */
  function lineEndingAfter(code) {
    // Always populated by defaults.

    return markdownSpace(code) ? factorySpace(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
  }

  /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */
  function lineEndingAfterPrefix(code) {
    effects.enter("htmlTextData");
    return returnState(code);
  }
}

/**
 * @import {
 *   Construct,
 *   Event,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const labelEnd = {
  name: 'labelEnd',
  resolveAll: resolveAllLabelEnd,
  resolveTo: resolveToLabelEnd,
  tokenize: tokenizeLabelEnd
};

/** @type {Construct} */
const resourceConstruct = {
  tokenize: tokenizeResource
};
/** @type {Construct} */
const referenceFullConstruct = {
  tokenize: tokenizeReferenceFull
};
/** @type {Construct} */
const referenceCollapsedConstruct = {
  tokenize: tokenizeReferenceCollapsed
};

/** @type {Resolver} */
function resolveAllLabelEnd(events) {
  let index = -1;
  /** @type {Array<Event>} */
  const newEvents = [];
  while (++index < events.length) {
    const token = events[index][1];
    newEvents.push(events[index]);
    if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
      // Remove the marker.
      const offset = token.type === "labelImage" ? 4 : 2;
      token.type = "data";
      index += offset;
    }
  }

  // If the events are equal, we don't have to copy newEvents to events
  if (events.length !== newEvents.length) {
    splice(events, 0, events.length, newEvents);
  }
  return events;
}

/** @type {Resolver} */
function resolveToLabelEnd(events, context) {
  let index = events.length;
  let offset = 0;
  /** @type {Token} */
  let token;
  /** @type {number | undefined} */
  let open;
  /** @type {number | undefined} */
  let close;
  /** @type {Array<Event>} */
  let media;

  // Find an opening.
  while (index--) {
    token = events[index][1];
    if (open) {
      // If we see another link, or inactive link label, we’ve been here before.
      if (token.type === "link" || token.type === "labelLink" && token._inactive) {
        break;
      }

      // Mark other link openings as inactive, as we can’t have links in
      // links.
      if (events[index][0] === 'enter' && token.type === "labelLink") {
        token._inactive = true;
      }
    } else if (close) {
      if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
        open = index;
        if (token.type !== "labelLink") {
          offset = 2;
          break;
        }
      }
    } else if (token.type === "labelEnd") {
      close = index;
    }
  }
  const group = {
    type: events[open][1].type === "labelLink" ? "link" : "image",
    start: {
      ...events[open][1].start
    },
    end: {
      ...events[events.length - 1][1].end
    }
  };
  const label = {
    type: "label",
    start: {
      ...events[open][1].start
    },
    end: {
      ...events[close][1].end
    }
  };
  const text = {
    type: "labelText",
    start: {
      ...events[open + offset + 2][1].end
    },
    end: {
      ...events[close - 2][1].start
    }
  };
  media = [['enter', group, context], ['enter', label, context]];

  // Opening marker.
  media = push(media, events.slice(open + 1, open + offset + 3));

  // Text open.
  media = push(media, [['enter', text, context]]);

  // Always populated by defaults.

  // Between.
  media = push(media, resolveAll(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));

  // Text close, marker close, label close.
  media = push(media, [['exit', text, context], events[close - 2], events[close - 1], ['exit', label, context]]);

  // Reference, resource, or so.
  media = push(media, events.slice(close + 1));

  // Media close.
  media = push(media, [['exit', group, context]]);
  splice(events, open, events.length, media);
  return events;
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeLabelEnd(effects, ok, nok) {
  const self = this;
  let index = self.events.length;
  /** @type {Token} */
  let labelStart;
  /** @type {boolean} */
  let defined;

  // Find an opening.
  while (index--) {
    if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
      labelStart = self.events[index][1];
      break;
    }
  }
  return start;

  /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // If there is not an okay opening.
    if (!labelStart) {
      return nok(code);
    }

    // If the corresponding label (link) start is marked as inactive,
    // it means we’d be wrapping a link, like this:
    //
    // ```markdown
    // > | a [b [c](d) e](f) g.
    //                  ^
    // ```
    //
    // We can’t have that, so it’s just balanced brackets.
    if (labelStart._inactive) {
      return labelEndNok(code);
    }
    defined = self.parser.defined.includes(normalizeIdentifier(self.sliceSerialize({
      start: labelStart.end,
      end: self.now()
    })));
    effects.enter("labelEnd");
    effects.enter("labelMarker");
    effects.consume(code);
    effects.exit("labelMarker");
    effects.exit("labelEnd");
    return after;
  }

  /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
    // an extension.

    // Resource (`[asd](fgh)`)?
    if (code === 40) {
      return effects.attempt(resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
    }

    // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
    if (code === 91) {
      return effects.attempt(referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
    }

    // Shortcut (`[asd]`) reference?
    return defined ? labelEndOk(code) : labelEndNok(code);
  }

  /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceNotFull(code) {
    return effects.attempt(referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
  }

  /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelEndOk(code) {
    // Note: `markdown-rs` does a bunch of stuff here.
    return ok(code);
  }

  /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelEndNok(code) {
    labelStart._balanced = true;
    return nok(code);
  }
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeResource(effects, ok, nok) {
  return resourceStart;

  /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */
  function resourceStart(code) {
    effects.enter("resource");
    effects.enter("resourceMarker");
    effects.consume(code);
    effects.exit("resourceMarker");
    return resourceBefore;
  }

  /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */
  function resourceBefore(code) {
    return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, resourceOpen)(code) : resourceOpen(code);
  }

  /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */
  function resourceOpen(code) {
    if (code === 41) {
      return resourceEnd(code);
    }
    return factoryDestination(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
  }

  /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */
  function resourceDestinationAfter(code) {
    return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, resourceBetween)(code) : resourceEnd(code);
  }

  /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */
  function resourceDestinationMissing(code) {
    return nok(code);
  }

  /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */
  function resourceBetween(code) {
    if (code === 34 || code === 39 || code === 40) {
      return factoryTitle(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
    }
    return resourceEnd(code);
  }

  /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */
  function resourceTitleAfter(code) {
    return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, resourceEnd)(code) : resourceEnd(code);
  }

  /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */
  function resourceEnd(code) {
    if (code === 41) {
      effects.enter("resourceMarker");
      effects.consume(code);
      effects.exit("resourceMarker");
      effects.exit("resource");
      return ok;
    }
    return nok(code);
  }
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeReferenceFull(effects, ok, nok) {
  const self = this;
  return referenceFull;

  /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceFull(code) {
    return factoryLabel.call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
  }

  /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */
  function referenceFullAfter(code) {
    return self.parser.defined.includes(normalizeIdentifier(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
  }

  /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceFullMissing(code) {
    return nok(code);
  }
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeReferenceCollapsed(effects, ok, nok) {
  return referenceCollapsedStart;

  /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceCollapsedStart(code) {
    // We only attempt a collapsed label if there’s a `[`.

    effects.enter("reference");
    effects.enter("referenceMarker");
    effects.consume(code);
    effects.exit("referenceMarker");
    return referenceCollapsedOpen;
  }

  /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */
  function referenceCollapsedOpen(code) {
    if (code === 93) {
      effects.enter("referenceMarker");
      effects.consume(code);
      effects.exit("referenceMarker");
      effects.exit("reference");
      return ok;
    }
    return nok(code);
  }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */

/** @type {Construct} */
const labelStartImage = {
  name: 'labelStartImage',
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartImage
};

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeLabelStartImage(effects, ok, nok) {
  const self = this;
  return start;

  /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("labelImage");
    effects.enter("labelImageMarker");
    effects.consume(code);
    effects.exit("labelImageMarker");
    return open;
  }

  /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 91) {
      effects.enter("labelMarker");
      effects.consume(code);
      effects.exit("labelMarker");
      effects.exit("labelImage");
      return after;
    }
    return nok(code);
  }

  /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // To do: use a new field to do this, this is still needed for
    // `micromark-extension-gfm-footnote`, but the `label-start-link`
    // behavior isn’t.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
  }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */

/** @type {Construct} */
const labelStartLink = {
  name: 'labelStartLink',
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartLink
};

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeLabelStartLink(effects, ok, nok) {
  const self = this;
  return start;

  /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("labelLink");
    effects.enter("labelMarker");
    effects.consume(code);
    effects.exit("labelMarker");
    effects.exit("labelLink");
    return after;
  }

  /** @type {State} */
  function after(code) {
    // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
    // remove.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
  }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const lineEnding = {
  name: 'lineEnding',
  tokenize: tokenizeLineEnding
};

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeLineEnding(effects, ok) {
  return start;

  /** @type {State} */
  function start(code) {
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return factorySpace(effects, ok, "linePrefix");
  }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const thematicBreak$1 = {
  name: 'thematicBreak',
  tokenize: tokenizeThematicBreak
};

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeThematicBreak(effects, ok, nok) {
  let size = 0;
  /** @type {NonNullable<Code>} */
  let marker;
  return start;

  /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("thematicBreak");
    // To do: parse indent like `markdown-rs`.
    return before(code);
  }

  /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    marker = code;
    return atBreak(code);
  }

  /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === marker) {
      effects.enter("thematicBreakSequence");
      return sequence(code);
    }
    if (size >= 3 && (code === null || markdownLineEnding(code))) {
      effects.exit("thematicBreak");
      return ok(code);
    }
    return nok(code);
  }

  /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function sequence(code) {
    if (code === marker) {
      effects.consume(code);
      size++;
      return sequence;
    }
    effects.exit("thematicBreakSequence");
    return markdownSpace(code) ? factorySpace(effects, atBreak, "whitespace")(code) : atBreak(code);
  }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */

/** @type {Construct} */
const list$1 = {
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd,
  name: 'list',
  tokenize: tokenizeListStart
};

/** @type {Construct} */
const listItemPrefixWhitespaceConstruct = {
  partial: true,
  tokenize: tokenizeListItemPrefixWhitespace
};

/** @type {Construct} */
const indentConstruct = {
  partial: true,
  tokenize: tokenizeIndent
};

// To do: `markdown-rs` parses list items on their own and later stitches them
// together.

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeListStart(effects, ok, nok) {
  const self = this;
  const tail = self.events[self.events.length - 1];
  let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
  let size = 0;
  return start;

  /** @type {State} */
  function start(code) {
    const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
    if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : asciiDigit(code)) {
      if (!self.containerState.type) {
        self.containerState.type = kind;
        effects.enter(kind, {
          _container: true
        });
      }
      if (kind === "listUnordered") {
        effects.enter("listItemPrefix");
        return code === 42 || code === 45 ? effects.check(thematicBreak$1, nok, atMarker)(code) : atMarker(code);
      }
      if (!self.interrupt || code === 49) {
        effects.enter("listItemPrefix");
        effects.enter("listItemValue");
        return inside(code);
      }
    }
    return nok(code);
  }

  /** @type {State} */
  function inside(code) {
    if (asciiDigit(code) && ++size < 10) {
      effects.consume(code);
      return inside;
    }
    if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
      effects.exit("listItemValue");
      return atMarker(code);
    }
    return nok(code);
  }

  /**
   * @type {State}
   **/
  function atMarker(code) {
    effects.enter("listItemMarker");
    effects.consume(code);
    effects.exit("listItemMarker");
    self.containerState.marker = self.containerState.marker || code;
    return effects.check(blankLine,
    // Can’t be empty when interrupting.
    self.interrupt ? nok : onBlank, effects.attempt(listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
  }

  /** @type {State} */
  function onBlank(code) {
    self.containerState.initialBlankLine = true;
    initialSize++;
    return endOfPrefix(code);
  }

  /** @type {State} */
  function otherPrefix(code) {
    if (markdownSpace(code)) {
      effects.enter("listItemPrefixWhitespace");
      effects.consume(code);
      effects.exit("listItemPrefixWhitespace");
      return endOfPrefix;
    }
    return nok(code);
  }

  /** @type {State} */
  function endOfPrefix(code) {
    self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
    return ok(code);
  }
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeListContinuation(effects, ok, nok) {
  const self = this;
  self.containerState._closeFlow = undefined;
  return effects.check(blankLine, onBlank, notBlank);

  /** @type {State} */
  function onBlank(code) {
    self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;

    // We have a blank line.
    // Still, try to consume at most the items size.
    return factorySpace(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
  }

  /** @type {State} */
  function notBlank(code) {
    if (self.containerState.furtherBlankLines || !markdownSpace(code)) {
      self.containerState.furtherBlankLines = undefined;
      self.containerState.initialBlankLine = undefined;
      return notInCurrentItem(code);
    }
    self.containerState.furtherBlankLines = undefined;
    self.containerState.initialBlankLine = undefined;
    return effects.attempt(indentConstruct, ok, notInCurrentItem)(code);
  }

  /** @type {State} */
  function notInCurrentItem(code) {
    // While we do continue, we signal that the flow should be closed.
    self.containerState._closeFlow = true;
    // As we’re closing flow, we’re no longer interrupting.
    self.interrupt = undefined;
    // Always populated by defaults.

    return factorySpace(effects, effects.attempt(list$1, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
  }
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeIndent(effects, ok, nok) {
  const self = this;
  return factorySpace(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);

  /** @type {State} */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1];
    return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
  }
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Exiter}
 */
function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type);
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeListItemPrefixWhitespace(effects, ok, nok) {
  const self = this;

  // Always populated by defaults.

  return factorySpace(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4 + 1);

  /** @type {State} */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1];
    return !markdownSpace(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
  }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */
/** @type {Construct} */
const setextUnderline = {
  name: 'setextUnderline',
  resolveTo: resolveToSetextUnderline,
  tokenize: tokenizeSetextUnderline
};

/** @type {Resolver} */
function resolveToSetextUnderline(events, context) {
  // To do: resolve like `markdown-rs`.
  let index = events.length;
  /** @type {number | undefined} */
  let content;
  /** @type {number | undefined} */
  let text;
  /** @type {number | undefined} */
  let definition;

  // Find the opening of the content.
  // It’ll always exist: we don’t tokenize if it isn’t there.
  while (index--) {
    if (events[index][0] === 'enter') {
      if (events[index][1].type === "content") {
        content = index;
        break;
      }
      if (events[index][1].type === "paragraph") {
        text = index;
      }
    }
    // Exit
    else {
      if (events[index][1].type === "content") {
        // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
      }
      if (!definition && events[index][1].type === "definition") {
        definition = index;
      }
    }
  }
  const heading = {
    type: "setextHeading",
    start: {
      ...events[content][1].start
    },
    end: {
      ...events[events.length - 1][1].end
    }
  };

  // Change the paragraph to setext heading text.
  events[text][1].type = "setextHeadingText";

  // If we have definitions in the content, we’ll keep on having content,
  // but we need move it.
  if (definition) {
    events.splice(text, 0, ['enter', heading, context]);
    events.splice(definition + 1, 0, ['exit', events[content][1], context]);
    events[content][1].end = {
      ...events[definition][1].end
    };
  } else {
    events[content][1] = heading;
  }

  // Add the heading exit at the end.
  events.push(['exit', heading, context]);
  return events;
}

/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */
function tokenizeSetextUnderline(effects, ok, nok) {
  const self = this;
  /** @type {NonNullable<Code>} */
  let marker;
  return start;

  /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    let index = self.events.length;
    /** @type {boolean | undefined} */
    let paragraph;
    // Find an opening.
    while (index--) {
      // Skip enter/exit of line ending, line prefix, and content.
      // We can now either have a definition or a paragraph.
      if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
        paragraph = self.events[index][1].type === "paragraph";
        break;
      }
    }

    // To do: handle lazy/pierce like `markdown-rs`.
    // To do: parse indent like `markdown-rs`.
    if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
      effects.enter("setextHeadingLine");
      marker = code;
      return before(code);
    }
    return nok(code);
  }

  /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    effects.enter("setextHeadingLineSequence");
    return inside(code);
  }

  /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    if (code === marker) {
      effects.consume(code);
      return inside;
    }
    effects.exit("setextHeadingLineSequence");
    return markdownSpace(code) ? factorySpace(effects, after, "lineSuffix")(code) : after(code);
  }

  /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("setextHeadingLine");
      return ok(code);
    }
    return nok(code);
  }
}

/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */
/** @type {InitialConstruct} */
const flow$1 = {
  tokenize: initializeFlow
};

/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */
function initializeFlow(effects) {
  const self = this;
  const initial = effects.attempt(
  // Try to parse a blank line.
  blankLine, atBlankEnding,
  // Try to parse initial flow (essentially, only code).
  effects.attempt(this.parser.constructs.flowInitial, afterConstruct, factorySpace(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt(content, afterConstruct)), "linePrefix")));
  return initial;

  /** @type {State} */
  function atBlankEnding(code) {
    if (code === null) {
      effects.consume(code);
      return;
    }
    effects.enter("lineEndingBlank");
    effects.consume(code);
    effects.exit("lineEndingBlank");
    self.currentConstruct = undefined;
    return initial;
  }

  /** @type {State} */
  function afterConstruct(code) {
    if (code === null) {
      effects.consume(code);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    self.currentConstruct = undefined;
    return initial;
  }
}

/**
 * @import {
 *   Code,
 *   InitialConstruct,
 *   Initializer,
 *   Resolver,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */

const resolver = {
  resolveAll: createResolver()
};
const string$1 = initializeFactory('string');
const text$2 = initializeFactory('text');

/**
 * @param {'string' | 'text'} field
 *   Field.
 * @returns {InitialConstruct}
 *   Construct.
 */
function initializeFactory(field) {
  return {
    resolveAll: createResolver(field === 'text' ? resolveAllLineSuffixes : undefined),
    tokenize: initializeText
  };

  /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Initializer}
   */
  function initializeText(effects) {
    const self = this;
    const constructs = this.parser.constructs[field];
    const text = effects.attempt(constructs, start, notText);
    return start;

    /** @type {State} */
    function start(code) {
      return atBreak(code) ? text(code) : notText(code);
    }

    /** @type {State} */
    function notText(code) {
      if (code === null) {
        effects.consume(code);
        return;
      }
      effects.enter("data");
      effects.consume(code);
      return data;
    }

    /** @type {State} */
    function data(code) {
      if (atBreak(code)) {
        effects.exit("data");
        return text(code);
      }

      // Data.
      effects.consume(code);
      return data;
    }

    /**
     * @param {Code} code
     *   Code.
     * @returns {boolean}
     *   Whether the code is a break.
     */
    function atBreak(code) {
      if (code === null) {
        return true;
      }
      const list = constructs[code];
      let index = -1;
      if (list) {
        // Always populated by defaults.

        while (++index < list.length) {
          const item = list[index];
          if (!item.previous || item.previous.call(self, self.previous)) {
            return true;
          }
        }
      }
      return false;
    }
  }
}

/**
 * @param {Resolver | undefined} [extraResolver]
 *   Resolver.
 * @returns {Resolver}
 *   Resolver.
 */
function createResolver(extraResolver) {
  return resolveAllText;

  /** @type {Resolver} */
  function resolveAllText(events, context) {
    let index = -1;
    /** @type {number | undefined} */
    let enter;

    // A rather boring computation (to merge adjacent `data` events) which
    // improves mm performance by 29%.
    while (++index <= events.length) {
      if (enter === undefined) {
        if (events[index] && events[index][1].type === "data") {
          enter = index;
          index++;
        }
      } else if (!events[index] || events[index][1].type !== "data") {
        // Don’t do anything if there is one data token.
        if (index !== enter + 2) {
          events[enter][1].end = events[index - 1][1].end;
          events.splice(enter + 2, index - enter - 2);
          index = enter + 2;
        }
        enter = undefined;
      }
    }
    return extraResolver ? extraResolver(events, context) : events;
  }
}

/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */
function resolveAllLineSuffixes(events, context) {
  let eventIndex = 0; // Skip first.

  while (++eventIndex <= events.length) {
    if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
      const data = events[eventIndex - 1][1];
      const chunks = context.sliceStream(data);
      let index = chunks.length;
      let bufferIndex = -1;
      let size = 0;
      /** @type {boolean | undefined} */
      let tabs;
      while (index--) {
        const chunk = chunks[index];
        if (typeof chunk === 'string') {
          bufferIndex = chunk.length;
          while (chunk.charCodeAt(bufferIndex - 1) === 32) {
            size++;
            bufferIndex--;
          }
          if (bufferIndex) break;
          bufferIndex = -1;
        }
        // Number
        else if (chunk === -2) {
          tabs = true;
          size++;
        } else if (chunk === -1) ; else {
          // Replacement character, exit.
          index++;
          break;
        }
      }

      // Allow final trailing whitespace.
      if (context._contentTypeTextTrailing && eventIndex === events.length) {
        size = 0;
      }
      if (size) {
        const token = {
          type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex,
            _index: data.start._index + index,
            line: data.end.line,
            column: data.end.column - size,
            offset: data.end.offset - size
          },
          end: {
            ...data.end
          }
        };
        data.end = {
          ...token.start
        };
        if (data.start.offset === data.end.offset) {
          Object.assign(data, token);
        } else {
          events.splice(eventIndex, 0, ['enter', token, context], ['exit', token, context]);
          eventIndex += 2;
        }
      }
      eventIndex++;
    }
  }
  return events;
}

/**
 * @import {Extension} from 'micromark-util-types'
 */

/** @satisfies {Extension['document']} */
const document$1 = {
  [42]: list$1,
  [43]: list$1,
  [45]: list$1,
  [48]: list$1,
  [49]: list$1,
  [50]: list$1,
  [51]: list$1,
  [52]: list$1,
  [53]: list$1,
  [54]: list$1,
  [55]: list$1,
  [56]: list$1,
  [57]: list$1,
  [62]: blockQuote
};

/** @satisfies {Extension['contentInitial']} */
const contentInitial = {
  [91]: definition
};

/** @satisfies {Extension['flowInitial']} */
const flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  [32]: codeIndented
};

/** @satisfies {Extension['flow']} */
const flow = {
  [35]: headingAtx,
  [42]: thematicBreak$1,
  [45]: [setextUnderline, thematicBreak$1],
  [60]: htmlFlow,
  [61]: setextUnderline,
  [95]: thematicBreak$1,
  [96]: codeFenced,
  [126]: codeFenced
};

/** @satisfies {Extension['string']} */
const string = {
  [38]: characterReference,
  [92]: characterEscape
};

/** @satisfies {Extension['text']} */
const text$1 = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  [33]: labelStartImage,
  [38]: characterReference,
  [42]: attention,
  [60]: [autolink, htmlText],
  [91]: labelStartLink,
  [92]: [hardBreakEscape, characterEscape],
  [93]: labelEnd,
  [95]: attention,
  [96]: codeText
};

/** @satisfies {Extension['insideSpan']} */
const insideSpan = {
  null: [attention, resolver]
};

/** @satisfies {Extension['attentionMarkers']} */
const attentionMarkers = {
  null: [42, 95]
};

/** @satisfies {Extension['disable']} */
const disable = {
  null: []
};

var defaultConstructs = /*#__PURE__*/Object.freeze({
  __proto__: null,
  document: document$1,
  contentInitial: contentInitial,
  flowInitial: flowInitial,
  flow: flow,
  string: string,
  text: text$1,
  insideSpan: insideSpan,
  attentionMarkers: attentionMarkers,
  disable: disable
});

/**
 * @import {
 *   Chunk,
 *   Code,
 *   ConstructRecord,
 *   Construct,
 *   Effects,
 *   InitialConstruct,
 *   ParseContext,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */
/**
 * Create a tokenizer.
 * Tokenizers deal with one type of data (e.g., containers, flow, text).
 * The parser is the object dealing with it all.
 * `initialize` works like other constructs, except that only its `tokenize`
 * function is used, in which case it doesn’t receive an `ok` or `nok`.
 * `from` can be given to set the point before the first character, although
 * when further lines are indented, they must be set with `defineSkip`.
 *
 * @param {ParseContext} parser
 *   Parser.
 * @param {InitialConstruct} initialize
 *   Construct.
 * @param {Omit<Point, '_bufferIndex' | '_index'> | undefined} [from]
 *   Point (optional).
 * @returns {TokenizeContext}
 *   Context.
 */
function createTokenizer(parser, initialize, from) {
  /** @type {Point} */
  let point = {
    _bufferIndex: -1,
    _index: 0,
    line: from && from.line || 1,
    column: from && from.column || 1,
    offset: from && from.offset || 0
  };
  /** @type {Record<string, number>} */
  const columnStart = {};
  /** @type {Array<Construct>} */
  const resolveAllConstructs = [];
  /** @type {Array<Chunk>} */
  let chunks = [];
  /** @type {Array<Token>} */
  let stack = [];

  /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */
  const effects = {
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    consume,
    enter,
    exit,
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    })
  };

  /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */
  const context = {
    code: null,
    containerState: {},
    defineSkip,
    events: [],
    now,
    parser,
    previous: null,
    sliceSerialize,
    sliceStream,
    write
  };

  /**
   * The state function.
   *
   * @type {State | undefined}
   */
  let state = initialize.tokenize.call(context, effects);
  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize);
  }
  return context;

  /** @type {TokenizeContext['write']} */
  function write(slice) {
    chunks = push(chunks, slice);
    main();

    // Exit if we’re not done, resolve might change stuff.
    if (chunks[chunks.length - 1] !== null) {
      return [];
    }
    addResult(initialize, 0);

    // Otherwise, resolve, and exit.
    context.events = resolveAll(resolveAllConstructs, context.events, context);
    return context.events;
  }

  //
  // Tools.
  //

  /** @type {TokenizeContext['sliceSerialize']} */
  function sliceSerialize(token, expandTabs) {
    return serializeChunks(sliceStream(token), expandTabs);
  }

  /** @type {TokenizeContext['sliceStream']} */
  function sliceStream(token) {
    return sliceChunks(chunks, token);
  }

  /** @type {TokenizeContext['now']} */
  function now() {
    // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
    const {
      _bufferIndex,
      _index,
      line,
      column,
      offset
    } = point;
    return {
      _bufferIndex,
      _index,
      line,
      column,
      offset
    };
  }

  /** @type {TokenizeContext['defineSkip']} */
  function defineSkip(value) {
    columnStart[value.line] = value.column;
    accountForPotentialSkip();
  }

  //
  // State management.
  //

  /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   *   Nothing.
   */
  function main() {
    /** @type {number} */
    let chunkIndex;
    while (point._index < chunks.length) {
      const chunk = chunks[point._index];

      // If we’re in a buffer chunk, loop through it.
      if (typeof chunk === 'string') {
        chunkIndex = point._index;
        if (point._bufferIndex < 0) {
          point._bufferIndex = 0;
        }
        while (point._index === chunkIndex && point._bufferIndex < chunk.length) {
          go(chunk.charCodeAt(point._bufferIndex));
        }
      } else {
        go(chunk);
      }
    }
  }

  /**
   * Deal with one code.
   *
   * @param {Code} code
   *   Code.
   * @returns {undefined}
   *   Nothing.
   */
  function go(code) {
    state = state(code);
  }

  /** @type {Effects['consume']} */
  function consume(code) {
    if (markdownLineEnding(code)) {
      point.line++;
      point.column = 1;
      point.offset += code === -3 ? 2 : 1;
      accountForPotentialSkip();
    } else if (code !== -1) {
      point.column++;
      point.offset++;
    }

    // Not in a string chunk.
    if (point._bufferIndex < 0) {
      point._index++;
    } else {
      point._bufferIndex++;

      // At end of string chunk.
      if (point._bufferIndex ===
      // Points w/ non-negative `_bufferIndex` reference
      // strings.
      /** @type {string} */
      chunks[point._index].length) {
        point._bufferIndex = -1;
        point._index++;
      }
    }

    // Expose the previous character.
    context.previous = code;
  }

  /** @type {Effects['enter']} */
  function enter(type, fields) {
    /** @type {Token} */
    // @ts-expect-error Patch instead of assign required fields to help GC.
    const token = fields || {};
    token.type = type;
    token.start = now();
    context.events.push(['enter', token, context]);
    stack.push(token);
    return token;
  }

  /** @type {Effects['exit']} */
  function exit(type) {
    const token = stack.pop();
    token.end = now();
    context.events.push(['exit', token, context]);
    return token;
  }

  /**
   * Use results.
   *
   * @type {ReturnHandle}
   */
  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from);
  }

  /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */
  function onsuccessfulcheck(_, info) {
    info.restore();
  }

  /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   *   Callback.
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   *   Fields.
   */
  function constructFactory(onreturn, fields) {
    return hook;

    /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | ConstructRecord | Construct} constructs
     *   Constructs.
     * @param {State} returnState
     *   State.
     * @param {State | undefined} [bogusState]
     *   State.
     * @returns {State}
     *   State.
     */
    function hook(constructs, returnState, bogusState) {
      /** @type {ReadonlyArray<Construct>} */
      let listOfConstructs;
      /** @type {number} */
      let constructIndex;
      /** @type {Construct} */
      let currentConstruct;
      /** @type {Info} */
      let info;
      return Array.isArray(constructs) ? /* c8 ignore next 1 */
      handleListOfConstructs(constructs) : 'tokenize' in constructs ?
      // Looks like a construct.
      handleListOfConstructs([(/** @type {Construct} */constructs)]) : handleMapOfConstructs(constructs);

      /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       *   Constructs.
       * @returns {State}
       *   State.
       */
      function handleMapOfConstructs(map) {
        return start;

        /** @type {State} */
        function start(code) {
          const left = code !== null && map[code];
          const all = code !== null && map.null;
          const list = [
          // To do: add more extension tests.
          /* c8 ignore next 2 */
          ...(Array.isArray(left) ? left : left ? [left] : []), ...(Array.isArray(all) ? all : all ? [all] : [])];
          return handleListOfConstructs(list)(code);
        }
      }

      /**
       * Handle a list of construct.
       *
       * @param {ReadonlyArray<Construct>} list
       *   Constructs.
       * @returns {State}
       *   State.
       */
      function handleListOfConstructs(list) {
        listOfConstructs = list;
        constructIndex = 0;
        if (list.length === 0) {
          return bogusState;
        }
        return handleConstruct(list[constructIndex]);
      }

      /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       *   Construct.
       * @returns {State}
       *   State.
       */
      function handleConstruct(construct) {
        return start;

        /** @type {State} */
        function start(code) {
          // To do: not needed to store if there is no bogus state, probably?
          // Currently doesn’t work because `inspect` in document does a check
          // w/o a bogus, which doesn’t make sense. But it does seem to help perf
          // by not storing.
          info = store();
          currentConstruct = construct;
          if (!construct.partial) {
            context.currentConstruct = construct;
          }

          // Always populated by defaults.

          if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) {
            return nok();
          }
          return construct.tokenize.call(
          // If we do have fields, create an object w/ `context` as its
          // prototype.
          // This allows a “live binding”, which is needed for `interrupt`.
          fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
        }
      }

      /** @type {State} */
      function ok(code) {
        onreturn(currentConstruct, info);
        return returnState;
      }

      /** @type {State} */
      function nok(code) {
        info.restore();
        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex]);
        }
        return bogusState;
      }
    }
  }

  /**
   * @param {Construct} construct
   *   Construct.
   * @param {number} from
   *   From.
   * @returns {undefined}
   *   Nothing.
   */
  function addResult(construct, from) {
    if (construct.resolveAll && !resolveAllConstructs.includes(construct)) {
      resolveAllConstructs.push(construct);
    }
    if (construct.resolve) {
      splice(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
    }
    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context);
    }
  }

  /**
   * Store state.
   *
   * @returns {Info}
   *   Info.
   */
  function store() {
    const startPoint = now();
    const startPrevious = context.previous;
    const startCurrentConstruct = context.currentConstruct;
    const startEventsIndex = context.events.length;
    const startStack = Array.from(stack);
    return {
      from: startEventsIndex,
      restore
    };

    /**
     * Restore state.
     *
     * @returns {undefined}
     *   Nothing.
     */
    function restore() {
      point = startPoint;
      context.previous = startPrevious;
      context.currentConstruct = startCurrentConstruct;
      context.events.length = startEventsIndex;
      stack = startStack;
      accountForPotentialSkip();
    }
  }

  /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   *   Nothing.
   */
  function accountForPotentialSkip() {
    if (point.line in columnStart && point.column < 2) {
      point.column = columnStart[point.line];
      point.offset += columnStart[point.line] - 1;
    }
  }
}

/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {Pick<Token, 'end' | 'start'>} token
 *   Token.
 * @returns {Array<Chunk>}
 *   Chunks.
 */
function sliceChunks(chunks, token) {
  const startIndex = token.start._index;
  const startBufferIndex = token.start._bufferIndex;
  const endIndex = token.end._index;
  const endBufferIndex = token.end._bufferIndex;
  /** @type {Array<Chunk>} */
  let view;
  if (startIndex === endIndex) {
    // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)];
  } else {
    view = chunks.slice(startIndex, endIndex);
    if (startBufferIndex > -1) {
      const head = view[0];
      if (typeof head === 'string') {
        view[0] = head.slice(startBufferIndex);
        /* c8 ignore next 4 -- used to be used, no longer */
      } else {
        view.shift();
      }
    }
    if (endBufferIndex > 0) {
      // @ts-expect-error `_bufferIndex` is used on string chunks.
      view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
  }
  return view;
}

/**
 * Get the string value of a slice of chunks.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {boolean | undefined} [expandTabs=false]
 *   Whether to expand tabs (default: `false`).
 * @returns {string}
 *   Result.
 */
function serializeChunks(chunks, expandTabs) {
  let index = -1;
  /** @type {Array<string>} */
  const result = [];
  /** @type {boolean | undefined} */
  let atTab;
  while (++index < chunks.length) {
    const chunk = chunks[index];
    /** @type {string} */
    let value;
    if (typeof chunk === 'string') {
      value = chunk;
    } else switch (chunk) {
      case -5:
        {
          value = "\r";
          break;
        }
      case -4:
        {
          value = "\n";
          break;
        }
      case -3:
        {
          value = "\r" + "\n";
          break;
        }
      case -2:
        {
          value = expandTabs ? " " : "\t";
          break;
        }
      case -1:
        {
          if (!expandTabs && atTab) continue;
          value = " ";
          break;
        }
      default:
        {
          // Currently only replacement character.
          value = String.fromCharCode(chunk);
        }
    }
    atTab = chunk === -2;
    result.push(value);
  }
  return result.join('');
}

/**
 * @import {
 *   Create,
 *   FullNormalizedExtension,
 *   InitialConstruct,
 *   ParseContext,
 *   ParseOptions
 * } from 'micromark-util-types'
 */

/**
 * @param {ParseOptions | null | undefined} [options]
 *   Configuration (optional).
 * @returns {ParseContext}
 *   Parser.
 */
function parse(options) {
  const settings = options || {};
  const constructs = /** @type {FullNormalizedExtension} */
  combineExtensions([defaultConstructs, ...(settings.extensions || [])]);

  /** @type {ParseContext} */
  const parser = {
    constructs,
    content: create(content$1),
    defined: [],
    document: create(document$2),
    flow: create(flow$1),
    lazy: {},
    string: create(string$1),
    text: create(text$2)
  };
  return parser;

  /**
   * @param {InitialConstruct} initial
   *   Construct to start with.
   * @returns {Create}
   *   Create a tokenizer.
   */
  function create(initial) {
    return creator;
    /** @type {Create} */
    function creator(from) {
      return createTokenizer(parser, initial, from);
    }
  }
}

/**
 * @import {Event} from 'micromark-util-types'
 */

/**
 * @param {Array<Event>} events
 *   Events.
 * @returns {Array<Event>}
 *   Events.
 */
function postprocess(events) {
  while (!subtokenize(events)) {
    // Empty
  }
  return events;
}

/**
 * @import {Chunk, Code, Encoding, Value} from 'micromark-util-types'
 */

/**
 * @callback Preprocessor
 *   Preprocess a value.
 * @param {Value} value
 *   Value.
 * @param {Encoding | null | undefined} [encoding]
 *   Encoding when `value` is a typed array (optional).
 * @param {boolean | null | undefined} [end=false]
 *   Whether this is the last chunk (default: `false`).
 * @returns {Array<Chunk>}
 *   Chunks.
 */

const search = /[\0\t\n\r]/g;

/**
 * @returns {Preprocessor}
 *   Preprocess a value.
 */
function preprocess() {
  let column = 1;
  let buffer = '';
  /** @type {boolean | undefined} */
  let start = true;
  /** @type {boolean | undefined} */
  let atCarriageReturn;
  return preprocessor;

  /** @type {Preprocessor} */
  // eslint-disable-next-line complexity
  function preprocessor(value, encoding, end) {
    /** @type {Array<Chunk>} */
    const chunks = [];
    /** @type {RegExpMatchArray | null} */
    let match;
    /** @type {number} */
    let next;
    /** @type {number} */
    let startPosition;
    /** @type {number} */
    let endPosition;
    /** @type {Code} */
    let code;
    value = buffer + (typeof value === 'string' ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
    startPosition = 0;
    buffer = '';
    if (start) {
      // To do: `markdown-rs` actually parses BOMs (byte order mark).
      if (value.charCodeAt(0) === 65279) {
        startPosition++;
      }
      start = undefined;
    }
    while (startPosition < value.length) {
      search.lastIndex = startPosition;
      match = search.exec(value);
      endPosition = match && match.index !== undefined ? match.index : value.length;
      code = value.charCodeAt(endPosition);
      if (!match) {
        buffer = value.slice(startPosition);
        break;
      }
      if (code === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3);
        atCarriageReturn = undefined;
      } else {
        if (atCarriageReturn) {
          chunks.push(-5);
          atCarriageReturn = undefined;
        }
        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition));
          column += endPosition - startPosition;
        }
        switch (code) {
          case 0:
            {
              chunks.push(65533);
              column++;
              break;
            }
          case 9:
            {
              next = Math.ceil(column / 4) * 4;
              chunks.push(-2);
              while (column++ < next) chunks.push(-1);
              break;
            }
          case 10:
            {
              chunks.push(-4);
              column = 1;
              break;
            }
          default:
            {
              atCarriageReturn = true;
              column = 1;
            }
        }
      }
      startPosition = endPosition + 1;
    }
    if (end) {
      if (atCarriageReturn) chunks.push(-5);
      if (buffer) chunks.push(buffer);
      chunks.push(null);
    }
    return chunks;
  }
}

const characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;

/**
 * Decode markdown strings (which occur in places such as fenced code info
 * strings, destinations, labels, and titles).
 *
 * The “string” content type allows character escapes and -references.
 * This decodes those.
 *
 * @param {string} value
 *   Value to decode.
 * @returns {string}
 *   Decoded value.
 */
function decodeString(value) {
  return value.replace(characterEscapeOrReference, decode);
}

/**
 * @param {string} $0
 *   Match.
 * @param {string} $1
 *   Character escape.
 * @param {string} $2
 *   Character reference.
 * @returns {string}
 *   Decoded value
 */
function decode($0, $1, $2) {
  if ($1) {
    // Escape.
    return $1;
  }

  // Reference.
  const head = $2.charCodeAt(0);
  if (head === 35) {
    const head = $2.charCodeAt(1);
    const hex = head === 120 || head === 88;
    return decodeNumericCharacterReference($2.slice(hex ? 2 : 1), hex ? 16 : 10);
  }
  return decodeNamedCharacterReference($2) || $0;
}

/**
 * @import {
 *   Break,
 *   Blockquote,
 *   Code,
 *   Definition,
 *   Emphasis,
 *   Heading,
 *   Html,
 *   Image,
 *   InlineCode,
 *   Link,
 *   ListItem,
 *   List,
 *   Nodes,
 *   Paragraph,
 *   PhrasingContent,
 *   ReferenceType,
 *   Root,
 *   Strong,
 *   Text,
 *   ThematicBreak
 * } from 'mdast'
 * @import {
 *   Encoding,
 *   Event,
 *   Token,
 *   Value
 * } from 'micromark-util-types'
 * @import {Point} from 'unist'
 * @import {
 *   CompileContext,
 *   CompileData,
 *   Config,
 *   Extension,
 *   Handle,
 *   OnEnterError,
 *   Options
 * } from './types.js'
 */
const own$2 = {}.hasOwnProperty;

/**
 * Turn markdown into a syntax tree.
 *
 * @overload
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {Options | null | undefined} [options]
 * @returns {Root}
 *
 * @overload
 * @param {Value} value
 * @param {Options | null | undefined} [options]
 * @returns {Root}
 *
 * @param {Value} value
 *   Markdown to parse.
 * @param {Encoding | Options | null | undefined} [encoding]
 *   Character encoding for when `value` is `Buffer`.
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {Root}
 *   mdast tree.
 */
function fromMarkdown(value, encoding, options) {
  if (typeof encoding !== 'string') {
    options = encoding;
    encoding = undefined;
  }
  return compiler(options)(postprocess(parse(options).document().write(preprocess()(value, encoding, true))));
}

/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */
function compiler(options) {
  /** @type {Config} */
  const config = {
    transforms: [],
    canContainEols: ['emphasis', 'fragment', 'heading', 'paragraph', 'strong'],
    enter: {
      autolink: opener(link),
      autolinkProtocol: onenterdata,
      autolinkEmail: onenterdata,
      atxHeading: opener(heading),
      blockQuote: opener(blockQuote),
      characterEscape: onenterdata,
      characterReference: onenterdata,
      codeFenced: opener(codeFlow),
      codeFencedFenceInfo: buffer,
      codeFencedFenceMeta: buffer,
      codeIndented: opener(codeFlow, buffer),
      codeText: opener(codeText, buffer),
      codeTextData: onenterdata,
      data: onenterdata,
      codeFlowValue: onenterdata,
      definition: opener(definition),
      definitionDestinationString: buffer,
      definitionLabelString: buffer,
      definitionTitleString: buffer,
      emphasis: opener(emphasis),
      hardBreakEscape: opener(hardBreak),
      hardBreakTrailing: opener(hardBreak),
      htmlFlow: opener(html, buffer),
      htmlFlowData: onenterdata,
      htmlText: opener(html, buffer),
      htmlTextData: onenterdata,
      image: opener(image),
      label: buffer,
      link: opener(link),
      listItem: opener(listItem),
      listItemValue: onenterlistitemvalue,
      listOrdered: opener(list, onenterlistordered),
      listUnordered: opener(list),
      paragraph: opener(paragraph),
      reference: onenterreference,
      referenceString: buffer,
      resourceDestinationString: buffer,
      resourceTitleString: buffer,
      setextHeading: opener(heading),
      strong: opener(strong),
      thematicBreak: opener(thematicBreak)
    },
    exit: {
      atxHeading: closer(),
      atxHeadingSequence: onexitatxheadingsequence,
      autolink: closer(),
      autolinkEmail: onexitautolinkemail,
      autolinkProtocol: onexitautolinkprotocol,
      blockQuote: closer(),
      characterEscapeValue: onexitdata,
      characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
      characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
      characterReferenceValue: onexitcharacterreferencevalue,
      characterReference: onexitcharacterreference,
      codeFenced: closer(onexitcodefenced),
      codeFencedFence: onexitcodefencedfence,
      codeFencedFenceInfo: onexitcodefencedfenceinfo,
      codeFencedFenceMeta: onexitcodefencedfencemeta,
      codeFlowValue: onexitdata,
      codeIndented: closer(onexitcodeindented),
      codeText: closer(onexitcodetext),
      codeTextData: onexitdata,
      data: onexitdata,
      definition: closer(),
      definitionDestinationString: onexitdefinitiondestinationstring,
      definitionLabelString: onexitdefinitionlabelstring,
      definitionTitleString: onexitdefinitiontitlestring,
      emphasis: closer(),
      hardBreakEscape: closer(onexithardbreak),
      hardBreakTrailing: closer(onexithardbreak),
      htmlFlow: closer(onexithtmlflow),
      htmlFlowData: onexitdata,
      htmlText: closer(onexithtmltext),
      htmlTextData: onexitdata,
      image: closer(onexitimage),
      label: onexitlabel,
      labelText: onexitlabeltext,
      lineEnding: onexitlineending,
      link: closer(onexitlink),
      listItem: closer(),
      listOrdered: closer(),
      listUnordered: closer(),
      paragraph: closer(),
      referenceString: onexitreferencestring,
      resourceDestinationString: onexitresourcedestinationstring,
      resourceTitleString: onexitresourcetitlestring,
      resource: onexitresource,
      setextHeading: closer(onexitsetextheading),
      setextHeadingLineSequence: onexitsetextheadinglinesequence,
      setextHeadingText: onexitsetextheadingtext,
      strong: closer(),
      thematicBreak: closer()
    }
  };
  configure(config, (options || {}).mdastExtensions || []);

  /** @type {CompileData} */
  const data = {};
  return compile;

  /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */
  function compile(events) {
    /** @type {Root} */
    let tree = {
      type: 'root',
      children: []
    };
    /** @type {Omit<CompileContext, 'sliceSerialize'>} */
    const context = {
      stack: [tree],
      tokenStack: [],
      config,
      enter,
      exit,
      buffer,
      resume,
      data
    };
    /** @type {Array<number>} */
    const listStack = [];
    let index = -1;
    while (++index < events.length) {
      // We preprocess lists to add `listItem` tokens, and to infer whether
      // items the list itself are spread out.
      if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
        if (events[index][0] === 'enter') {
          listStack.push(index);
        } else {
          const tail = listStack.pop();
          index = prepareList(events, tail, index);
        }
      }
    }
    index = -1;
    while (++index < events.length) {
      const handler = config[events[index][0]];
      if (own$2.call(handler, events[index][1].type)) {
        handler[events[index][1].type].call(Object.assign({
          sliceSerialize: events[index][2].sliceSerialize
        }, context), events[index][1]);
      }
    }

    // Handle tokens still being open.
    if (context.tokenStack.length > 0) {
      const tail = context.tokenStack[context.tokenStack.length - 1];
      const handler = tail[1] || defaultOnError;
      handler.call(context, undefined, tail[0]);
    }

    // Figure out `root` position.
    tree.position = {
      start: point(events.length > 0 ? events[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: point(events.length > 0 ? events[events.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    };

    // Call transforms.
    index = -1;
    while (++index < config.transforms.length) {
      tree = config.transforms[index](tree) || tree;
    }
    return tree;
  }

  /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */
  function prepareList(events, start, length) {
    let index = start - 1;
    let containerBalance = -1;
    let listSpread = false;
    /** @type {Token | undefined} */
    let listItem;
    /** @type {number | undefined} */
    let lineIndex;
    /** @type {number | undefined} */
    let firstBlankLineIndex;
    /** @type {boolean | undefined} */
    let atMarker;
    while (++index <= length) {
      const event = events[index];
      switch (event[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote":
          {
            if (event[0] === 'enter') {
              containerBalance++;
            } else {
              containerBalance--;
            }
            atMarker = undefined;
            break;
          }
        case "lineEndingBlank":
          {
            if (event[0] === 'enter') {
              if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) {
                firstBlankLineIndex = index;
              }
              atMarker = undefined;
            }
            break;
          }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          {
            // Empty.

            break;
          }
        default:
          {
            atMarker = undefined;
          }
      }
      if (!containerBalance && event[0] === 'enter' && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === 'exit' && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
        if (listItem) {
          let tailIndex = index;
          lineIndex = undefined;
          while (tailIndex--) {
            const tailEvent = events[tailIndex];
            if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
              if (tailEvent[0] === 'exit') continue;
              if (lineIndex) {
                events[lineIndex][1].type = "lineEndingBlank";
                listSpread = true;
              }
              tailEvent[1].type = "lineEnding";
              lineIndex = tailIndex;
            } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ; else {
              break;
            }
          }
          if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) {
            listItem._spread = true;
          }

          // Fix position.
          listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
          events.splice(lineIndex || index, 0, ['exit', listItem, event[2]]);
          index++;
          length++;
        }

        // Create a new list item.
        if (event[1].type === "listItemPrefix") {
          /** @type {Token} */
          const item = {
            type: 'listItem',
            _spread: false,
            start: Object.assign({}, event[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: undefined
          };
          listItem = item;
          events.splice(index, 0, ['enter', item, event[2]]);
          index++;
          length++;
          firstBlankLineIndex = undefined;
          atMarker = true;
        }
      }
    }
    events[start][1]._spread = listSpread;
    return length;
  }

  /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */
  function opener(create, and) {
    return open;

    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */
    function open(token) {
      enter.call(this, create(token), token);
      if (and) and.call(this, token);
    }
  }

  /**
   * @type {CompileContext['buffer']}
   */
  function buffer() {
    this.stack.push({
      type: 'fragment',
      children: []
    });
  }

  /**
   * @type {CompileContext['enter']}
   */
  function enter(node, token, errorHandler) {
    const parent = this.stack[this.stack.length - 1];
    /** @type {Array<Nodes>} */
    const siblings = parent.children;
    siblings.push(node);
    this.stack.push(node);
    this.tokenStack.push([token, errorHandler || undefined]);
    node.position = {
      start: point(token.start),
      // @ts-expect-error: `end` will be patched later.
      end: undefined
    };
  }

  /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */
  function closer(and) {
    return close;

    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */
    function close(token) {
      if (and) and.call(this, token);
      exit.call(this, token);
    }
  }

  /**
   * @type {CompileContext['exit']}
   */
  function exit(token, onExitError) {
    const node = this.stack.pop();
    const open = this.tokenStack.pop();
    if (!open) {
      throw new Error('Cannot close `' + token.type + '` (' + stringifyPosition({
        start: token.start,
        end: token.end
      }) + '): it’s not open');
    } else if (open[0].type !== token.type) {
      if (onExitError) {
        onExitError.call(this, token, open[0]);
      } else {
        const handler = open[1] || defaultOnError;
        handler.call(this, token, open[0]);
      }
    }
    node.position.end = point(token.end);
  }

  /**
   * @type {CompileContext['resume']}
   */
  function resume() {
    return toString$1(this.stack.pop());
  }

  //
  // Handlers.
  //

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onenterlistordered() {
    this.data.expectingFirstListItemValue = true;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onenterlistitemvalue(token) {
    if (this.data.expectingFirstListItemValue) {
      const ancestor = this.stack[this.stack.length - 2];
      ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
      this.data.expectingFirstListItemValue = undefined;
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefencedfenceinfo() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.lang = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefencedfencemeta() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.meta = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefencedfence() {
    // Exit if this is the closing fence.
    if (this.data.flowCodeInside) return;
    this.buffer();
    this.data.flowCodeInside = true;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefenced() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
    this.data.flowCodeInside = undefined;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodeindented() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.value = data.replace(/(\r?\n|\r)$/g, '');
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitdefinitionlabelstring(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = normalizeIdentifier(this.sliceSerialize(token)).toLowerCase();
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitdefinitiontitlestring() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.title = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitdefinitiondestinationstring() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.url = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitatxheadingsequence(token) {
    const node = this.stack[this.stack.length - 1];
    if (!node.depth) {
      const depth = this.sliceSerialize(token).length;
      node.depth = depth;
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitsetextheadingtext() {
    this.data.setextHeadingSlurpLineEnding = true;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitsetextheadinglinesequence(token) {
    const node = this.stack[this.stack.length - 1];
    node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitsetextheading() {
    this.data.setextHeadingSlurpLineEnding = undefined;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onenterdata(token) {
    const node = this.stack[this.stack.length - 1];
    /** @type {Array<Nodes>} */
    const siblings = node.children;
    let tail = siblings[siblings.length - 1];
    if (!tail || tail.type !== 'text') {
      // Add a new text node.
      tail = text();
      tail.position = {
        start: point(token.start),
        // @ts-expect-error: we’ll add `end` later.
        end: undefined
      };
      siblings.push(tail);
    }
    this.stack.push(tail);
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitdata(token) {
    const tail = this.stack.pop();
    tail.value += this.sliceSerialize(token);
    tail.position.end = point(token.end);
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlineending(token) {
    const context = this.stack[this.stack.length - 1];
    // If we’re at a hard break, include the line ending in there.
    if (this.data.atHardBreak) {
      const tail = context.children[context.children.length - 1];
      tail.position.end = point(token.end);
      this.data.atHardBreak = undefined;
      return;
    }
    if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
      onenterdata.call(this, token);
      onexitdata.call(this, token);
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexithardbreak() {
    this.data.atHardBreak = true;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexithtmlflow() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.value = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexithtmltext() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.value = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitcodetext() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.value = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlink() {
    const node = this.stack[this.stack.length - 1];
    // Note: there are also `identifier` and `label` fields on this link node!
    // These are used / cleaned here.

    // To do: clean.
    if (this.data.inReference) {
      /** @type {ReferenceType} */
      const referenceType = this.data.referenceType || 'shortcut';
      node.type += 'Reference';
      // @ts-expect-error: mutate.
      node.referenceType = referenceType;
      // @ts-expect-error: mutate.
      delete node.url;
      delete node.title;
    } else {
      // @ts-expect-error: mutate.
      delete node.identifier;
      // @ts-expect-error: mutate.
      delete node.label;
    }
    this.data.referenceType = undefined;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitimage() {
    const node = this.stack[this.stack.length - 1];
    // Note: there are also `identifier` and `label` fields on this link node!
    // These are used / cleaned here.

    // To do: clean.
    if (this.data.inReference) {
      /** @type {ReferenceType} */
      const referenceType = this.data.referenceType || 'shortcut';
      node.type += 'Reference';
      // @ts-expect-error: mutate.
      node.referenceType = referenceType;
      // @ts-expect-error: mutate.
      delete node.url;
      delete node.title;
    } else {
      // @ts-expect-error: mutate.
      delete node.identifier;
      // @ts-expect-error: mutate.
      delete node.label;
    }
    this.data.referenceType = undefined;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlabeltext(token) {
    const string = this.sliceSerialize(token);
    const ancestor = this.stack[this.stack.length - 2];
    // @ts-expect-error: stash this on the node, as it might become a reference
    // later.
    ancestor.label = decodeString(string);
    // @ts-expect-error: same as above.
    ancestor.identifier = normalizeIdentifier(string).toLowerCase();
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlabel() {
    const fragment = this.stack[this.stack.length - 1];
    const value = this.resume();
    const node = this.stack[this.stack.length - 1];
    // Assume a reference.
    this.data.inReference = true;
    if (node.type === 'link') {
      /** @type {Array<PhrasingContent>} */
      const children = fragment.children;
      node.children = children;
    } else {
      node.alt = value;
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitresourcedestinationstring() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.url = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitresourcetitlestring() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.title = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitresource() {
    this.data.inReference = undefined;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onenterreference() {
    this.data.referenceType = 'collapsed';
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitreferencestring(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    // @ts-expect-error: stash this on the node, as it might become a reference
    // later.
    node.label = label;
    // @ts-expect-error: same as above.
    node.identifier = normalizeIdentifier(this.sliceSerialize(token)).toLowerCase();
    this.data.referenceType = 'full';
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitcharacterreferencemarker(token) {
    this.data.characterReferenceType = token.type;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcharacterreferencevalue(token) {
    const data = this.sliceSerialize(token);
    const type = this.data.characterReferenceType;
    /** @type {string} */
    let value;
    if (type) {
      value = decodeNumericCharacterReference(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
      this.data.characterReferenceType = undefined;
    } else {
      const result = decodeNamedCharacterReference(data);
      value = result;
    }
    const tail = this.stack[this.stack.length - 1];
    tail.value += value;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcharacterreference(token) {
    const tail = this.stack.pop();
    tail.position.end = point(token.end);
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitautolinkprotocol(token) {
    onexitdata.call(this, token);
    const node = this.stack[this.stack.length - 1];
    node.url = this.sliceSerialize(token);
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitautolinkemail(token) {
    onexitdata.call(this, token);
    const node = this.stack[this.stack.length - 1];
    node.url = 'mailto:' + this.sliceSerialize(token);
  }

  //
  // Creaters.
  //

  /** @returns {Blockquote} */
  function blockQuote() {
    return {
      type: 'blockquote',
      children: []
    };
  }

  /** @returns {Code} */
  function codeFlow() {
    return {
      type: 'code',
      lang: null,
      meta: null,
      value: ''
    };
  }

  /** @returns {InlineCode} */
  function codeText() {
    return {
      type: 'inlineCode',
      value: ''
    };
  }

  /** @returns {Definition} */
  function definition() {
    return {
      type: 'definition',
      identifier: '',
      label: null,
      title: null,
      url: ''
    };
  }

  /** @returns {Emphasis} */
  function emphasis() {
    return {
      type: 'emphasis',
      children: []
    };
  }

  /** @returns {Heading} */
  function heading() {
    return {
      type: 'heading',
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }

  /** @returns {Break} */
  function hardBreak() {
    return {
      type: 'break'
    };
  }

  /** @returns {Html} */
  function html() {
    return {
      type: 'html',
      value: ''
    };
  }

  /** @returns {Image} */
  function image() {
    return {
      type: 'image',
      title: null,
      url: '',
      alt: null
    };
  }

  /** @returns {Link} */
  function link() {
    return {
      type: 'link',
      title: null,
      url: '',
      children: []
    };
  }

  /**
   * @param {Token} token
   * @returns {List}
   */
  function list(token) {
    return {
      type: 'list',
      ordered: token.type === 'listOrdered',
      start: null,
      spread: token._spread,
      children: []
    };
  }

  /**
   * @param {Token} token
   * @returns {ListItem}
   */
  function listItem(token) {
    return {
      type: 'listItem',
      spread: token._spread,
      checked: null,
      children: []
    };
  }

  /** @returns {Paragraph} */
  function paragraph() {
    return {
      type: 'paragraph',
      children: []
    };
  }

  /** @returns {Strong} */
  function strong() {
    return {
      type: 'strong',
      children: []
    };
  }

  /** @returns {Text} */
  function text() {
    return {
      type: 'text',
      value: ''
    };
  }

  /** @returns {ThematicBreak} */
  function thematicBreak() {
    return {
      type: 'thematicBreak'
    };
  }
}

/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */
function point(d) {
  return {
    line: d.line,
    column: d.column,
    offset: d.offset
  };
}

/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */
function configure(combined, extensions) {
  let index = -1;
  while (++index < extensions.length) {
    const value = extensions[index];
    if (Array.isArray(value)) {
      configure(combined, value);
    } else {
      extension(combined, value);
    }
  }
}

/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */
function extension(combined, extension) {
  /** @type {keyof Extension} */
  let key;
  for (key in extension) {
    if (own$2.call(extension, key)) {
      switch (key) {
        case 'canContainEols':
          {
            const right = extension[key];
            if (right) {
              combined[key].push(...right);
            }
            break;
          }
        case 'transforms':
          {
            const right = extension[key];
            if (right) {
              combined[key].push(...right);
            }
            break;
          }
        case 'enter':
        case 'exit':
          {
            const right = extension[key];
            if (right) {
              Object.assign(combined[key], right);
            }
            break;
          }
        // No default
      }
    }
  }
}

/** @type {OnEnterError} */
function defaultOnError(left, right) {
  if (left) {
    throw new Error('Cannot close `' + left.type + '` (' + stringifyPosition({
      start: left.start,
      end: left.end
    }) + '): a different token (`' + right.type + '`, ' + stringifyPosition({
      start: right.start,
      end: right.end
    }) + ') is open');
  } else {
    throw new Error('Cannot close document, a token (`' + right.type + '`, ' + stringifyPosition({
      start: right.start,
      end: right.end
    }) + ') is still open');
  }
}

/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} FromMarkdownOptions
 * @typedef {import('unified').Parser<Root>} Parser
 * @typedef {import('unified').Processor<Root>} Processor
 */

/**
 * Aadd support for parsing from markdown.
 *
 * @param {Readonly<Options> | null | undefined} [options]
 *   Configuration (optional).
 * @returns {undefined}
 *   Nothing.
 */
function remarkParse(options) {
  /** @type {Processor} */
  // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
  const self = this;

  self.parser = parser;

  /**
   * @type {Parser}
   */
  function parser(doc) {
    return fromMarkdown(doc, {
      ...self.data('settings'),
      ...options,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: self.data('micromarkExtensions') || [],
      mdastExtensions: self.data('fromMarkdownExtensions') || []
    })
  }
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function blockquote(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'blockquote',
    properties: {},
    children: state.wrap(state.all(node), true)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */
function hardBreak(state, node) {
  /** @type {Element} */
  const result = {type: 'element', tagName: 'br', properties: {}, children: []};
  state.patch(node, result);
  return [state.applyData(node, result), {type: 'text', value: '\n'}]
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function code(state, node) {
  const value = node.value ? node.value + '\n' : '';
  /** @type {Properties} */
  const properties = {};

  if (node.lang) {
    properties.className = ['language-' + node.lang];
  }

  // Create `<code>`.
  /** @type {Element} */
  let result = {
    type: 'element',
    tagName: 'code',
    properties,
    children: [{type: 'text', value}]
  };

  if (node.meta) {
    result.data = {meta: node.meta};
  }

  state.patch(node, result);
  result = state.applyData(node, result);

  // Create `<pre>`.
  result = {type: 'element', tagName: 'pre', properties: {}, children: [result]};
  state.patch(node, result);
  return result
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function strikethrough(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'del',
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function emphasis(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'em',
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `footnoteReference` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {FootnoteReference} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function footnoteReference(state, node) {
  const clobberPrefix =
    typeof state.options.clobberPrefix === 'string'
      ? state.options.clobberPrefix
      : 'user-content-';
  const id = String(node.identifier).toUpperCase();
  const safeId = normalizeUri(id.toLowerCase());
  const index = state.footnoteOrder.indexOf(id);
  /** @type {number} */
  let counter;

  let reuseCounter = state.footnoteCounts.get(id);

  if (reuseCounter === undefined) {
    reuseCounter = 0;
    state.footnoteOrder.push(id);
    counter = state.footnoteOrder.length;
  } else {
    counter = index + 1;
  }

  reuseCounter += 1;
  state.footnoteCounts.set(id, reuseCounter);

  /** @type {Element} */
  const link = {
    type: 'element',
    tagName: 'a',
    properties: {
      href: '#' + clobberPrefix + 'fn-' + safeId,
      id:
        clobberPrefix +
        'fnref-' +
        safeId +
        (reuseCounter > 1 ? '-' + reuseCounter : ''),
      dataFootnoteRef: true,
      ariaDescribedBy: ['footnote-label']
    },
    children: [{type: 'text', value: String(counter)}]
  };
  state.patch(node, link);

  /** @type {Element} */
  const sup = {
    type: 'element',
    tagName: 'sup',
    properties: {},
    children: [link]
  };
  state.patch(node, sup);
  return state.applyData(node, sup)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function heading(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'h' + node.depth,
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Html} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */

/**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Element | Raw | undefined}
 *   hast node.
 */
function html(state, node) {
  if (state.options.allowDangerousHtml) {
    /** @type {Raw} */
    const result = {type: 'raw', value: node.value};
    state.patch(node, result);
    return state.applyData(node, result)
  }

  return undefined
}

/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Reference} Reference
 *
 * @typedef {import('./state.js').State} State
 */

/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Extract<Nodes, Reference>} node
 *   Reference node (image, link).
 * @returns {Array<ElementContent>}
 *   hast content.
 */
function revert(state, node) {
  const subtype = node.referenceType;
  let suffix = ']';

  if (subtype === 'collapsed') {
    suffix += '[]';
  } else if (subtype === 'full') {
    suffix += '[' + (node.label || node.identifier) + ']';
  }

  if (node.type === 'imageReference') {
    return [{type: 'text', value: '![' + node.alt + suffix}]
  }

  const contents = state.all(node);
  const head = contents[0];

  if (head && head.type === 'text') {
    head.value = '[' + head.value;
  } else {
    contents.unshift({type: 'text', value: '['});
  }

  const tail = contents[contents.length - 1];

  if (tail && tail.type === 'text') {
    tail.value += suffix;
  } else {
    contents.push({type: 'text', value: suffix});
  }

  return contents
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `imageReference` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ImageReference} node
 *   mdast node.
 * @returns {Array<ElementContent> | ElementContent}
 *   hast node.
 */
function imageReference(state, node) {
  const id = String(node.identifier).toUpperCase();
  const definition = state.definitionById.get(id);

  if (!definition) {
    return revert(state, node)
  }

  /** @type {Properties} */
  const properties = {src: normalizeUri(definition.url || ''), alt: node.alt};

  if (definition.title !== null && definition.title !== undefined) {
    properties.title = definition.title;
  }

  /** @type {Element} */
  const result = {type: 'element', tagName: 'img', properties, children: []};
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `image` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Image} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function image(state, node) {
  /** @type {Properties} */
  const properties = {src: normalizeUri(node.url)};

  if (node.alt !== null && node.alt !== undefined) {
    properties.alt = node.alt;
  }

  if (node.title !== null && node.title !== undefined) {
    properties.title = node.title;
  }

  /** @type {Element} */
  const result = {type: 'element', tagName: 'img', properties, children: []};
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function inlineCode(state, node) {
  /** @type {Text} */
  const text = {type: 'text', value: node.value.replace(/\r?\n|\r/g, ' ')};
  state.patch(node, text);

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'code',
    properties: {},
    children: [text]
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `linkReference` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {LinkReference} node
 *   mdast node.
 * @returns {Array<ElementContent> | ElementContent}
 *   hast node.
 */
function linkReference(state, node) {
  const id = String(node.identifier).toUpperCase();
  const definition = state.definitionById.get(id);

  if (!definition) {
    return revert(state, node)
  }

  /** @type {Properties} */
  const properties = {href: normalizeUri(definition.url || '')};

  if (definition.title !== null && definition.title !== undefined) {
    properties.title = definition.title;
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'a',
    properties,
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `link` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Link} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function link(state, node) {
  /** @type {Properties} */
  const properties = {href: normalizeUri(node.url)};

  if (node.title !== null && node.title !== undefined) {
    properties.title = node.title;
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'a',
    properties,
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */
function listItem(state, node, parent) {
  const results = state.all(node);
  const loose = parent ? listLoose(parent) : listItemLoose(node);
  /** @type {Properties} */
  const properties = {};
  /** @type {Array<ElementContent>} */
  const children = [];

  if (typeof node.checked === 'boolean') {
    const head = results[0];
    /** @type {Element} */
    let paragraph;

    if (head && head.type === 'element' && head.tagName === 'p') {
      paragraph = head;
    } else {
      paragraph = {type: 'element', tagName: 'p', properties: {}, children: []};
      results.unshift(paragraph);
    }

    if (paragraph.children.length > 0) {
      paragraph.children.unshift({type: 'text', value: ' '});
    }

    paragraph.children.unshift({
      type: 'element',
      tagName: 'input',
      properties: {type: 'checkbox', checked: node.checked, disabled: true},
      children: []
    });

    // According to github-markdown-css, this class hides bullet.
    // See: <https://github.com/sindresorhus/github-markdown-css>.
    properties.className = ['task-list-item'];
  }

  let index = -1;

  while (++index < results.length) {
    const child = results[index];

    // Add eols before nodes, except if this is a loose, first paragraph.
    if (
      loose ||
      index !== 0 ||
      child.type !== 'element' ||
      child.tagName !== 'p'
    ) {
      children.push({type: 'text', value: '\n'});
    }

    if (child.type === 'element' && child.tagName === 'p' && !loose) {
      children.push(...child.children);
    } else {
      children.push(child);
    }
  }

  const tail = results[results.length - 1];

  // Add a final eol.
  if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) {
    children.push({type: 'text', value: '\n'});
  }

  /** @type {Element} */
  const result = {type: 'element', tagName: 'li', properties, children};
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @param {Parents} node
 * @return {Boolean}
 */
function listLoose(node) {
  let loose = false;
  if (node.type === 'list') {
    loose = node.spread || false;
    const children = node.children;
    let index = -1;

    while (!loose && ++index < children.length) {
      loose = listItemLoose(children[index]);
    }
  }

  return loose
}

/**
 * @param {ListItem} node
 * @return {Boolean}
 */
function listItemLoose(node) {
  const spread = node.spread;

  return spread === null || spread === undefined
    ? node.children.length > 1
    : spread
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function list(state, node) {
  /** @type {Properties} */
  const properties = {};
  const results = state.all(node);
  let index = -1;

  if (typeof node.start === 'number' && node.start !== 1) {
    properties.start = node.start;
  }

  // Like GitHub, add a class for custom styling.
  while (++index < results.length) {
    const child = results[index];

    if (
      child.type === 'element' &&
      child.tagName === 'li' &&
      child.properties &&
      Array.isArray(child.properties.className) &&
      child.properties.className.includes('task-list-item')
    ) {
      properties.className = ['contains-task-list'];
      break
    }
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: node.ordered ? 'ol' : 'ul',
    properties,
    children: state.wrap(results, true)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function paragraph(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'p',
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Parents} HastParents
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastParents}
 *   hast node.
 */
function root(state, node) {
  /** @type {HastRoot} */
  const result = {type: 'root', children: state.wrap(state.all(node))};
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function strong(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'strong',
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `table` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Table} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function table(state, node) {
  const rows = state.all(node);
  const firstRow = rows.shift();
  /** @type {Array<Element>} */
  const tableContent = [];

  if (firstRow) {
    /** @type {Element} */
    const head = {
      type: 'element',
      tagName: 'thead',
      properties: {},
      children: state.wrap([firstRow], true)
    };
    state.patch(node.children[0], head);
    tableContent.push(head);
  }

  if (rows.length > 0) {
    /** @type {Element} */
    const body = {
      type: 'element',
      tagName: 'tbody',
      properties: {},
      children: state.wrap(rows, true)
    };

    const start = pointStart(node.children[1]);
    const end = pointEnd(node.children[node.children.length - 1]);
    if (start && end) body.position = {start, end};
    tableContent.push(body);
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'table',
    properties: {},
    children: state.wrap(tableContent, true)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */
function tableRow(state, node, parent) {
  const siblings = parent ? parent.children : undefined;
  // Generate a body row when without parent.
  const rowIndex = siblings ? siblings.indexOf(node) : 1;
  const tagName = rowIndex === 0 ? 'th' : 'td';
  // To do: option to use `style`?
  const align = parent && parent.type === 'table' ? parent.align : undefined;
  const length = align ? align.length : node.children.length;
  let cellIndex = -1;
  /** @type {Array<ElementContent>} */
  const cells = [];

  while (++cellIndex < length) {
    // Note: can also be undefined.
    const cell = node.children[cellIndex];
    /** @type {Properties} */
    const properties = {};
    const alignValue = align ? align[cellIndex] : undefined;

    if (alignValue) {
      properties.align = alignValue;
    }

    /** @type {Element} */
    let result = {type: 'element', tagName, properties, children: []};

    if (cell) {
      result.children = state.all(cell);
      state.patch(cell, result);
      result = state.applyData(cell, result);
    }

    cells.push(result);
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'tr',
    properties: {},
    children: state.wrap(cells, true)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function tableCell(state, node) {
  // Note: this function is normally not called: see `table-row` for how rows
  // and their cells are compiled.
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'td', // Assume body cell.
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

const tab = 9; /* `\t` */
const space = 32; /* ` ` */

/**
 * Remove initial and final spaces and tabs at the line breaks in `value`.
 * Does not trim initial and final spaces and tabs of the value itself.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Trimmed value.
 */
function trimLines(value) {
  const source = String(value);
  const search = /\r?\n|\r/g;
  let match = search.exec(source);
  let last = 0;
  /** @type {Array<string>} */
  const lines = [];

  while (match) {
    lines.push(
      trimLine(source.slice(last, match.index), last > 0, true),
      match[0]
    );

    last = match.index + match[0].length;
    match = search.exec(source);
  }

  lines.push(trimLine(source.slice(last), last > 0, false));

  return lines.join('')
}

/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */
function trimLine(value, start, end) {
  let startIndex = 0;
  let endIndex = value.length;

  if (start) {
    let code = value.codePointAt(startIndex);

    while (code === tab || code === space) {
      startIndex++;
      code = value.codePointAt(startIndex);
    }
  }

  if (end) {
    let code = value.codePointAt(endIndex - 1);

    while (code === tab || code === space) {
      endIndex--;
      code = value.codePointAt(endIndex - 1);
    }
  }

  return endIndex > startIndex ? value.slice(startIndex, endIndex) : ''
}

/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `text` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastText} node
 *   mdast node.
 * @returns {HastElement | HastText}
 *   hast node.
 */
function text(state, node) {
  /** @type {HastText} */
  const result = {type: 'text', value: trimLines(String(node.value))};
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function thematicBreak(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'hr',
    properties: {},
    children: []
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * Default handlers for nodes.
 *
 * @satisfies {import('../state.js').Handlers}
 */
const handlers = {
  blockquote,
  break: hardBreak,
  code,
  delete: strikethrough,
  emphasis,
  footnoteReference,
  heading,
  html,
  imageReference,
  image,
  inlineCode,
  linkReference,
  link,
  listItem,
  list,
  paragraph,
  // @ts-expect-error: root is different, but hard to type.
  root,
  strong,
  table,
  tableCell,
  tableRow,
  text,
  thematicBreak,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
};

// Return nothing for nodes that are ignored.
function ignore() {
  return undefined
}

const VOID       = -1;
const PRIMITIVE  = 0;
const ARRAY      = 1;
const OBJECT     = 2;
const DATE       = 3;
const REGEXP     = 4;
const MAP        = 5;
const SET        = 6;
const ERROR      = 7;
const BIGINT     = 8;
// export const SYMBOL = 9;

const env = typeof self === 'object' ? self : globalThis;

const deserializer = ($, _) => {
  const as = (out, index) => {
    $.set(index, out);
    return out;
  };

  const unpair = index => {
    if ($.has(index))
      return $.get(index);

    const [type, value] = _[index];
    switch (type) {
      case PRIMITIVE:
      case VOID:
        return as(value, index);
      case ARRAY: {
        const arr = as([], index);
        for (const index of value)
          arr.push(unpair(index));
        return arr;
      }
      case OBJECT: {
        const object = as({}, index);
        for (const [key, index] of value)
          object[unpair(key)] = unpair(index);
        return object;
      }
      case DATE:
        return as(new Date(value), index);
      case REGEXP: {
        const {source, flags} = value;
        return as(new RegExp(source, flags), index);
      }
      case MAP: {
        const map = as(new Map, index);
        for (const [key, index] of value)
          map.set(unpair(key), unpair(index));
        return map;
      }
      case SET: {
        const set = as(new Set, index);
        for (const index of value)
          set.add(unpair(index));
        return set;
      }
      case ERROR: {
        const {name, message} = value;
        return as(new env[name](message), index);
      }
      case BIGINT:
        return as(BigInt(value), index);
      case 'BigInt':
        return as(Object(BigInt(value)), index);
      case 'ArrayBuffer':
        return as(new Uint8Array(value).buffer, value);
      case 'DataView': {
        const { buffer } = new Uint8Array(value);
        return as(new DataView(buffer), value);
      }
    }
    return as(new env[type](value), index);
  };

  return unpair;
};

/**
 * @typedef {Array<string,any>} Record a type representation
 */

/**
 * Returns a deserialized value from a serialized array of Records.
 * @param {Record[]} serialized a previously serialized value.
 * @returns {any}
 */
const deserialize = serialized => deserializer(new Map, serialized)(0);

const EMPTY = '';

const {toString} = {};
const {keys} = Object;

const typeOf = value => {
  const type = typeof value;
  if (type !== 'object' || !value)
    return [PRIMITIVE, type];

  const asString = toString.call(value).slice(8, -1);
  switch (asString) {
    case 'Array':
      return [ARRAY, EMPTY];
    case 'Object':
      return [OBJECT, EMPTY];
    case 'Date':
      return [DATE, EMPTY];
    case 'RegExp':
      return [REGEXP, EMPTY];
    case 'Map':
      return [MAP, EMPTY];
    case 'Set':
      return [SET, EMPTY];
    case 'DataView':
      return [ARRAY, asString];
  }

  if (asString.includes('Array'))
    return [ARRAY, asString];

  if (asString.includes('Error'))
    return [ERROR, asString];

  return [OBJECT, asString];
};

const shouldSkip = ([TYPE, type]) => (
  TYPE === PRIMITIVE &&
  (type === 'function' || type === 'symbol')
);

const serializer = (strict, json, $, _) => {

  const as = (out, value) => {
    const index = _.push(out) - 1;
    $.set(value, index);
    return index;
  };

  const pair = value => {
    if ($.has(value))
      return $.get(value);

    let [TYPE, type] = typeOf(value);
    switch (TYPE) {
      case PRIMITIVE: {
        let entry = value;
        switch (type) {
          case 'bigint':
            TYPE = BIGINT;
            entry = value.toString();
            break;
          case 'function':
          case 'symbol':
            if (strict)
              throw new TypeError('unable to serialize ' + type);
            entry = null;
            break;
          case 'undefined':
            return as([VOID], value);
        }
        return as([TYPE, entry], value);
      }
      case ARRAY: {
        if (type) {
          let spread = value;
          if (type === 'DataView') {
            spread = new Uint8Array(value.buffer);
          }
          else if (type === 'ArrayBuffer') {
            spread = new Uint8Array(value);
          }
          return as([type, [...spread]], value);
        }

        const arr = [];
        const index = as([TYPE, arr], value);
        for (const entry of value)
          arr.push(pair(entry));
        return index;
      }
      case OBJECT: {
        if (type) {
          switch (type) {
            case 'BigInt':
              return as([type, value.toString()], value);
            case 'Boolean':
            case 'Number':
            case 'String':
              return as([type, value.valueOf()], value);
          }
        }

        if (json && ('toJSON' in value))
          return pair(value.toJSON());

        const entries = [];
        const index = as([TYPE, entries], value);
        for (const key of keys(value)) {
          if (strict || !shouldSkip(typeOf(value[key])))
            entries.push([pair(key), pair(value[key])]);
        }
        return index;
      }
      case DATE:
        return as([TYPE, value.toISOString()], value);
      case REGEXP: {
        const {source, flags} = value;
        return as([TYPE, {source, flags}], value);
      }
      case MAP: {
        const entries = [];
        const index = as([TYPE, entries], value);
        for (const [key, entry] of value) {
          if (strict || !(shouldSkip(typeOf(key)) || shouldSkip(typeOf(entry))))
            entries.push([pair(key), pair(entry)]);
        }
        return index;
      }
      case SET: {
        const entries = [];
        const index = as([TYPE, entries], value);
        for (const entry of value) {
          if (strict || !shouldSkip(typeOf(entry)))
            entries.push(pair(entry));
        }
        return index;
      }
    }

    const {message} = value;
    return as([TYPE, {name: type, message}], value);
  };

  return pair;
};

/**
 * @typedef {Array<string,any>} Record a type representation
 */

/**
 * Returns an array of serialized Records.
 * @param {any} value a serializable value.
 * @param {{json?: boolean, lossy?: boolean}?} options an object with a `lossy` or `json` property that,
 *  if `true`, will not throw errors on incompatible types, and behave more
 *  like JSON stringify would behave. Symbol and Function will be discarded.
 * @returns {Record[]}
 */
 const serialize = (value, {json, lossy} = {}) => {
  const _ = [];
  return serializer(!(json || lossy), !!json, new Map, _)(value), _;
};

/**
 * @typedef {Array<string,any>} Record a type representation
 */

/**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */
var structuredClone$1 = typeof structuredClone === "function" ?
  /* c8 ignore start */
  (any, options) => (
    options && ('json' in options || 'lossy' in options) ?
      deserialize(serialize(any, options)) : structuredClone(any)
  ) :
  (any, options) => deserialize(serialize(any, options));

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */

/**
 * Generate the default content that GitHub uses on backreferences.
 *
 * @param {number} _
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {Array<ElementContent>}
 *   Content.
 */
function defaultFootnoteBackContent(_, rereferenceIndex) {
  /** @type {Array<ElementContent>} */
  const result = [{type: 'text', value: '↩'}];

  if (rereferenceIndex > 1) {
    result.push({
      type: 'element',
      tagName: 'sup',
      properties: {},
      children: [{type: 'text', value: String(rereferenceIndex)}]
    });
  }

  return result
}

/**
 * Generate the default label that GitHub uses on backreferences.
 *
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Label.
 */
function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
  return (
    'Back to reference ' +
    (referenceIndex + 1) +
    (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
  )
}

/**
 * Generate a hast footer for called footnote definitions.
 *
 * @param {State} state
 *   Info passed around.
 * @returns {Element | undefined}
 *   `section` element or `undefined`.
 */
// eslint-disable-next-line complexity
function footer(state) {
  const clobberPrefix =
    typeof state.options.clobberPrefix === 'string'
      ? state.options.clobberPrefix
      : 'user-content-';
  const footnoteBackContent =
    state.options.footnoteBackContent || defaultFootnoteBackContent;
  const footnoteBackLabel =
    state.options.footnoteBackLabel || defaultFootnoteBackLabel;
  const footnoteLabel = state.options.footnoteLabel || 'Footnotes';
  const footnoteLabelTagName = state.options.footnoteLabelTagName || 'h2';
  const footnoteLabelProperties = state.options.footnoteLabelProperties || {
    className: ['sr-only']
  };
  /** @type {Array<ElementContent>} */
  const listItems = [];
  let referenceIndex = -1;

  while (++referenceIndex < state.footnoteOrder.length) {
    const definition = state.footnoteById.get(
      state.footnoteOrder[referenceIndex]
    );

    if (!definition) {
      continue
    }

    const content = state.all(definition);
    const id = String(definition.identifier).toUpperCase();
    const safeId = normalizeUri(id.toLowerCase());
    let rereferenceIndex = 0;
    /** @type {Array<ElementContent>} */
    const backReferences = [];
    const counts = state.footnoteCounts.get(id);

    // eslint-disable-next-line no-unmodified-loop-condition
    while (counts !== undefined && ++rereferenceIndex <= counts) {
      if (backReferences.length > 0) {
        backReferences.push({type: 'text', value: ' '});
      }

      let children =
        typeof footnoteBackContent === 'string'
          ? footnoteBackContent
          : footnoteBackContent(referenceIndex, rereferenceIndex);

      if (typeof children === 'string') {
        children = {type: 'text', value: children};
      }

      backReferences.push({
        type: 'element',
        tagName: 'a',
        properties: {
          href:
            '#' +
            clobberPrefix +
            'fnref-' +
            safeId +
            (rereferenceIndex > 1 ? '-' + rereferenceIndex : ''),
          dataFootnoteBackref: '',
          ariaLabel:
            typeof footnoteBackLabel === 'string'
              ? footnoteBackLabel
              : footnoteBackLabel(referenceIndex, rereferenceIndex),
          className: ['data-footnote-backref']
        },
        children: Array.isArray(children) ? children : [children]
      });
    }

    const tail = content[content.length - 1];

    if (tail && tail.type === 'element' && tail.tagName === 'p') {
      const tailTail = tail.children[tail.children.length - 1];
      if (tailTail && tailTail.type === 'text') {
        tailTail.value += ' ';
      } else {
        tail.children.push({type: 'text', value: ' '});
      }

      tail.children.push(...backReferences);
    } else {
      content.push(...backReferences);
    }

    /** @type {Element} */
    const listItem = {
      type: 'element',
      tagName: 'li',
      properties: {id: clobberPrefix + 'fn-' + safeId},
      children: state.wrap(content, true)
    };

    state.patch(definition, listItem);

    listItems.push(listItem);
  }

  if (listItems.length === 0) {
    return
  }

  return {
    type: 'element',
    tagName: 'section',
    properties: {dataFootnotes: true, className: ['footnotes']},
    children: [
      {
        type: 'element',
        tagName: footnoteLabelTagName,
        properties: {
          ...structuredClone$1(footnoteLabelProperties),
          id: 'footnote-label'
        },
        children: [{type: 'text', value: footnoteLabel}]
      },
      {type: 'text', value: '\n'},
      {
        type: 'element',
        tagName: 'ol',
        properties: {},
        children: state.wrap(listItems, true)
      },
      {type: 'text', value: '\n'}
    ]
  }
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */

/**
 * Generate an assertion from a test.
 *
 * Useful if you’re going to test many nodes, for example when creating a
 * utility where something else passes a compatible test.
 *
 * The created function is a bit faster because it expects valid input only:
 * a `node`, `index`, and `parent`.
 *
 * @param {Test} test
 *   *   when nullish, checks if `node` is a `Node`.
 *   *   when `string`, works like passing `(node) => node.type === test`.
 *   *   when `function` checks if function passed the node is true.
 *   *   when `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
 *   *   when `array`, checks if any one of the subtests pass.
 * @returns {Check}
 *   An assertion.
 */
const convert =
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  (
    /**
     * @param {Test} [test]
     * @returns {Check}
     */
    function (test) {
      if (test === null || test === undefined) {
        return ok
      }

      if (typeof test === 'function') {
        return castFactory(test)
      }

      if (typeof test === 'object') {
        return Array.isArray(test) ? anyFactory(test) : propsFactory(test)
      }

      if (typeof test === 'string') {
        return typeFactory(test)
      }

      throw new Error('Expected function, string, or object as test')
    }
  );

/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */
function anyFactory(tests) {
  /** @type {Array<Check>} */
  const checks = [];
  let index = -1;

  while (++index < tests.length) {
    checks[index] = convert(tests[index]);
  }

  return castFactory(any)

  /**
   * @this {unknown}
   * @type {TestFunction}
   */
  function any(...parameters) {
    let index = -1;

    while (++index < checks.length) {
      if (checks[index].apply(this, parameters)) return true
    }

    return false
  }
}

/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */
function propsFactory(check) {
  const checkAsRecord = /** @type {Record<string, unknown>} */ (check);

  return castFactory(all)

  /**
   * @param {Node} node
   * @returns {boolean}
   */
  function all(node) {
    const nodeAsRecord = /** @type {Record<string, unknown>} */ (
      /** @type {unknown} */ (node)
    );

    /** @type {string} */
    let key;

    for (key in check) {
      if (nodeAsRecord[key] !== checkAsRecord[key]) return false
    }

    return true
  }
}

/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */
function typeFactory(check) {
  return castFactory(type)

  /**
   * @param {Node} node
   */
  function type(node) {
    return node && node.type === check
  }
}

/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */
function castFactory(testFunction) {
  return check

  /**
   * @this {unknown}
   * @type {Check}
   */
  function check(value, index, parent) {
    return Boolean(
      looksLikeANode(value) &&
        testFunction.call(
          this,
          value,
          typeof index === 'number' ? index : undefined,
          parent || undefined
        )
    )
  }
}

function ok() {
  return true
}

/**
 * @param {unknown} value
 * @returns {value is Node}
 */
function looksLikeANode(value) {
  return value !== null && typeof value === 'object' && 'type' in value
}

/**
 * @param {string} d
 * @returns {string}
 */
function color(d) {
  return d
}

/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 */

/** @type {Readonly<ActionTuple>} */
const empty = [];

/**
 * Continue traversing as normal.
 */
const CONTINUE = true;

/**
 * Stop traversing immediately.
 */
const EXIT = false;

/**
 * Do not traverse this node’s children.
 */
const SKIP = 'skip';

/**
 * Visit nodes, with ancestral information.
 *
 * This algorithm performs *depth-first* *tree traversal* in *preorder*
 * (**NLR**) or if `reverse` is given, in *reverse preorder* (**NRL**).
 *
 * You can choose for which nodes `visitor` is called by passing a `test`.
 * For complex tests, you should test yourself in `visitor`, as it will be
 * faster and will have improved type information.
 *
 * Walking the tree is an intensive task.
 * Make use of the return values of the visitor when possible.
 * Instead of walking a tree multiple times, walk it once, use `unist-util-is`
 * to check if a node matches, and then perform different operations.
 *
 * You can change the tree.
 * See `Visitor` for more info.
 *
 * @overload
 * @param {Tree} tree
 * @param {Check} check
 * @param {BuildVisitor<Tree, Check>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @overload
 * @param {Tree} tree
 * @param {BuildVisitor<Tree>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @param {UnistNode} tree
 *   Tree to traverse.
 * @param {Visitor | Test} test
 *   `unist-util-is`-compatible test
 * @param {Visitor | boolean | null | undefined} [visitor]
 *   Handle each node.
 * @param {boolean | null | undefined} [reverse]
 *   Traverse in reverse preorder (NRL) instead of the default preorder (NLR).
 * @returns {undefined}
 *   Nothing.
 *
 * @template {UnistNode} Tree
 *   Node type.
 * @template {Test} Check
 *   `unist-util-is`-compatible test.
 */
function visitParents(tree, test, visitor, reverse) {
  /** @type {Test} */
  let check;

  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor;
    // @ts-expect-error no visitor given, so `visitor` is test.
    visitor = test;
  } else {
    // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
  }

  const is = convert(check);
  const step = reverse ? -1 : 1;

  factory(tree, undefined, [])();

  /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */
  function factory(node, index, parents) {
    const value = /** @type {Record<string, unknown>} */ (
      node && typeof node === 'object' ? node : {}
    );

    if (typeof value.type === 'string') {
      const name =
        // `hast`
        typeof value.tagName === 'string'
          ? value.tagName
          : // `xast`
          typeof value.name === 'string'
          ? value.name
          : undefined;

      Object.defineProperty(visit, 'name', {
        value:
          'node (' + color(node.type + (name ? '<' + name + '>' : '')) + ')'
      });
    }

    return visit

    function visit() {
      /** @type {Readonly<ActionTuple>} */
      let result = empty;
      /** @type {Readonly<ActionTuple>} */
      let subresult;
      /** @type {number} */
      let offset;
      /** @type {Array<UnistParent>} */
      let grandparents;

      if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
        // @ts-expect-error: `visitor` is now a visitor.
        result = toResult(visitor(node, parents));

        if (result[0] === EXIT) {
          return result
        }
      }

      if ('children' in node && node.children) {
        const nodeAsParent = /** @type {UnistParent} */ (node);

        if (nodeAsParent.children && result[0] !== SKIP) {
          offset = (reverse ? nodeAsParent.children.length : -1) + step;
          grandparents = parents.concat(nodeAsParent);

          while (offset > -1 && offset < nodeAsParent.children.length) {
            const child = nodeAsParent.children[offset];

            subresult = factory(child, offset, grandparents)();

            if (subresult[0] === EXIT) {
              return subresult
            }

            offset =
              typeof subresult[1] === 'number' ? subresult[1] : offset + step;
          }
        }
      }

      return result
    }
  }
}

/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */
function toResult(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE, value]
  }

  return value === null || value === undefined ? empty : [value]
}

/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */

/**
 * Visit nodes.
 *
 * This algorithm performs *depth-first* *tree traversal* in *preorder*
 * (**NLR**) or if `reverse` is given, in *reverse preorder* (**NRL**).
 *
 * You can choose for which nodes `visitor` is called by passing a `test`.
 * For complex tests, you should test yourself in `visitor`, as it will be
 * faster and will have improved type information.
 *
 * Walking the tree is an intensive task.
 * Make use of the return values of the visitor when possible.
 * Instead of walking a tree multiple times, walk it once, use `unist-util-is`
 * to check if a node matches, and then perform different operations.
 *
 * You can change the tree.
 * See `Visitor` for more info.
 *
 * @overload
 * @param {Tree} tree
 * @param {Check} check
 * @param {BuildVisitor<Tree, Check>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @overload
 * @param {Tree} tree
 * @param {BuildVisitor<Tree>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @param {UnistNode} tree
 *   Tree to traverse.
 * @param {Visitor | Test} testOrVisitor
 *   `unist-util-is`-compatible test (optional, omit to pass a visitor).
 * @param {Visitor | boolean | null | undefined} [visitorOrReverse]
 *   Handle each node (when test is omitted, pass `reverse`).
 * @param {boolean | null | undefined} [maybeReverse=false]
 *   Traverse in reverse preorder (NRL) instead of the default preorder (NLR).
 * @returns {undefined}
 *   Nothing.
 *
 * @template {UnistNode} Tree
 *   Node type.
 * @template {Test} Check
 *   `unist-util-is`-compatible test.
 */
function visit(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
  /** @type {boolean | null | undefined} */
  let reverse;
  /** @type {Test} */
  let test;
  /** @type {Visitor} */
  let visitor;

  if (
    typeof testOrVisitor === 'function' &&
    typeof visitorOrReverse !== 'function'
  ) {
    test = undefined;
    visitor = testOrVisitor;
    reverse = visitorOrReverse;
  } else {
    // @ts-expect-error: assume the overload with test was given.
    test = testOrVisitor;
    // @ts-expect-error: assume the overload with test was given.
    visitor = visitorOrReverse;
    reverse = maybeReverse;
  }

  visitParents(tree, test, overload, reverse);

  /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */
  function overload(node, parents) {
    const parent = parents[parents.length - 1];
    const index = parent ? parent.children.indexOf(node) : undefined;
    return visitor(node, index, parent)
  }
}

/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').RootContent} HastRootContent
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('mdast').Parents} MdastParents
 *
 * @typedef {import('vfile').VFile} VFile
 *
 * @typedef {import('./footer.js').FootnoteBackContentTemplate} FootnoteBackContentTemplate
 * @typedef {import('./footer.js').FootnoteBackLabelTemplate} FootnoteBackLabelTemplate
 */

const own$1 = {}.hasOwnProperty;

/** @type {Options} */
const emptyOptions = {};

/**
 * Create `state` from an mdast tree.
 *
 * @param {MdastNodes} tree
 *   mdast node to transform.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {State}
 *   `state` function.
 */
function createState(tree, options) {
  const settings = options || emptyOptions;
  /** @type {Map<string, MdastDefinition>} */
  const definitionById = new Map();
  /** @type {Map<string, MdastFootnoteDefinition>} */
  const footnoteById = new Map();
  /** @type {Map<string, number>} */
  const footnoteCounts = new Map();
  /** @type {Handlers} */
  // @ts-expect-error: the root handler returns a root.
  // Hard to type.
  const handlers$1 = {...handlers, ...settings.handlers};

  /** @type {State} */
  const state = {
    all,
    applyData,
    definitionById,
    footnoteById,
    footnoteCounts,
    footnoteOrder: [],
    handlers: handlers$1,
    one,
    options: settings,
    patch,
    wrap: wrap$1
  };

  visit(tree, function (node) {
    if (node.type === 'definition' || node.type === 'footnoteDefinition') {
      const map = node.type === 'definition' ? definitionById : footnoteById;
      const id = String(node.identifier).toUpperCase();

      // Mimick CM behavior of link definitions.
      // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/9032189/lib/index.js#L20-L21>.
      if (!map.has(id)) {
        // @ts-expect-error: node type matches map.
        map.set(id, node);
      }
    }
  });

  return state

  /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | undefined} [parent]
   *   Parent of `node`.
   * @returns {Array<HastElementContent> | HastElementContent | undefined}
   *   Resulting hast node.
   */
  function one(node, parent) {
    const type = node.type;
    const handle = state.handlers[type];

    if (own$1.call(state.handlers, type) && handle) {
      return handle(state, node, parent)
    }

    if (state.options.passThrough && state.options.passThrough.includes(type)) {
      if ('children' in node) {
        const {children, ...shallow} = node;
        const result = structuredClone$1(shallow);
        // @ts-expect-error: TS doesn’t understand…
        result.children = state.all(node);
        // @ts-expect-error: TS doesn’t understand…
        return result
      }

      // @ts-expect-error: it’s custom.
      return structuredClone$1(node)
    }

    const unknown = state.options.unknownHandler || defaultUnknownHandler;

    return unknown(state, node, parent)
  }

  /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */
  function all(parent) {
    /** @type {Array<HastElementContent>} */
    const values = [];

    if ('children' in parent) {
      const nodes = parent.children;
      let index = -1;
      while (++index < nodes.length) {
        const result = state.one(nodes[index], parent);

        // To do: see if we van clean this? Can we merge texts?
        if (result) {
          if (index && nodes[index - 1].type === 'break') {
            if (!Array.isArray(result) && result.type === 'text') {
              result.value = trimMarkdownSpaceStart(result.value);
            }

            if (!Array.isArray(result) && result.type === 'element') {
              const head = result.children[0];

              if (head && head.type === 'text') {
                head.value = trimMarkdownSpaceStart(head.value);
              }
            }
          }

          if (Array.isArray(result)) {
            values.push(...result);
          } else {
            values.push(result);
          }
        }
      }
    }

    return values
  }
}

/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {undefined}
 *   Nothing.
 */
function patch(from, to) {
  if (from.position) to.position = position$1(from);
}

/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {HastElement | Type}
 *   Nothing.
 */
function applyData(from, to) {
  /** @type {HastElement | Type} */
  let result = to;

  // Handle `data.hName`, `data.hProperties, `data.hChildren`.
  if (from && from.data) {
    const hName = from.data.hName;
    const hChildren = from.data.hChildren;
    const hProperties = from.data.hProperties;

    if (typeof hName === 'string') {
      // Transforming the node resulted in an element with a different name
      // than wanted:
      if (result.type === 'element') {
        result.tagName = hName;
      }
      // Transforming the node resulted in a non-element, which happens for
      // raw, text, and root nodes (unless custom handlers are passed).
      // The intent of `hName` is to create an element, but likely also to keep
      // the content around (otherwise: pass `hChildren`).
      else {
        /** @type {Array<HastElementContent>} */
        // @ts-expect-error: assume no doctypes in `root`.
        const children = 'children' in result ? result.children : [result];
        result = {type: 'element', tagName: hName, properties: {}, children};
      }
    }

    if (result.type === 'element' && hProperties) {
      Object.assign(result.properties, structuredClone$1(hProperties));
    }

    if (
      'children' in result &&
      result.children &&
      hChildren !== null &&
      hChildren !== undefined
    ) {
      result.children = hChildren;
    }
  }

  return result
}

/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastElement | HastText}
 *   Resulting hast node.
 */
function defaultUnknownHandler(state, node) {
  const data = node.data || {};
  /** @type {HastElement | HastText} */
  const result =
    'value' in node &&
    !(own$1.call(data, 'hProperties') || own$1.call(data, 'hChildren'))
      ? {type: 'text', value: node.value}
      : {
          type: 'element',
          tagName: 'div',
          properties: {},
          children: state.all(node)
        };

  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * Wrap `nodes` with line endings between each node.
 *
 * @template {HastRootContent} Type
 *   Node type.
 * @param {Array<Type>} nodes
 *   List of nodes to wrap.
 * @param {boolean | undefined} [loose=false]
 *   Whether to add line endings at start and end (default: `false`).
 * @returns {Array<HastText | Type>}
 *   Wrapped nodes.
 */
function wrap$1(nodes, loose) {
  /** @type {Array<HastText | Type>} */
  const result = [];
  let index = -1;

  if (loose) {
    result.push({type: 'text', value: '\n'});
  }

  while (++index < nodes.length) {
    if (index) result.push({type: 'text', value: '\n'});
    result.push(nodes[index]);
  }

  if (loose && nodes.length > 0) {
    result.push({type: 'text', value: '\n'});
  }

  return result
}

/**
 * Trim spaces and tabs at the start of `value`.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Result.
 */
function trimMarkdownSpaceStart(value) {
  let index = 0;
  let code = value.charCodeAt(index);

  while (code === 9 || code === 32) {
    index++;
    code = value.charCodeAt(index);
  }

  return value.slice(index)
}

/**
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('./state.js').Options} Options
 */

/**
 * Transform mdast to hast.
 *
 * ##### Notes
 *
 * ###### HTML
 *
 * Raw HTML is available in mdast as `html` nodes and can be embedded in hast
 * as semistandard `raw` nodes.
 * Most utilities ignore `raw` nodes but two notable ones don’t:
 *
 * *   `hast-util-to-html` also has an option `allowDangerousHtml` which will
 *     output the raw HTML.
 *     This is typically discouraged as noted by the option name but is useful
 *     if you completely trust authors
 * *   `hast-util-raw` can handle the raw embedded HTML strings by parsing them
 *     into standard hast nodes (`element`, `text`, etc).
 *     This is a heavy task as it needs a full HTML parser, but it is the only
 *     way to support untrusted content
 *
 * ###### Footnotes
 *
 * Many options supported here relate to footnotes.
 * Footnotes are not specified by CommonMark, which we follow by default.
 * They are supported by GitHub, so footnotes can be enabled in markdown with
 * `mdast-util-gfm`.
 *
 * The options `footnoteBackLabel` and `footnoteLabel` define natural language
 * that explains footnotes, which is hidden for sighted users but shown to
 * assistive technology.
 * When your page is not in English, you must define translated values.
 *
 * Back references use ARIA attributes, but the section label itself uses a
 * heading that is hidden with an `sr-only` class.
 * To show it to sighted users, define different attributes in
 * `footnoteLabelProperties`.
 *
 * ###### Clobbering
 *
 * Footnotes introduces a problem, as it links footnote calls to footnote
 * definitions on the page through `id` attributes generated from user content,
 * which results in DOM clobbering.
 *
 * DOM clobbering is this:
 *
 * ```html
 * <p id=x></p>
 * <script>alert(x) // `x` now refers to the DOM `p#x` element</script>
 * ```
 *
 * Elements by their ID are made available by browsers on the `window` object,
 * which is a security risk.
 * Using a prefix solves this problem.
 *
 * More information on how to handle clobbering and the prefix is explained in
 * Example: headings (DOM clobbering) in `rehype-sanitize`.
 *
 * ###### Unknown nodes
 *
 * Unknown nodes are nodes with a type that isn’t in `handlers` or `passThrough`.
 * The default behavior for unknown nodes is:
 *
 * *   when the node has a `value` (and doesn’t have `data.hName`,
 *     `data.hProperties`, or `data.hChildren`, see later), create a hast `text`
 *     node
 * *   otherwise, create a `<div>` element (which could be changed with
 *     `data.hName`), with its children mapped from mdast to hast as well
 *
 * This behavior can be changed by passing an `unknownHandler`.
 *
 * @param {MdastNodes} tree
 *   mdast tree.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {HastNodes}
 *   hast tree.
 */
function toHast(tree, options) {
  const state = createState(tree, options);
  const node = state.one(tree, undefined);
  const foot = footer(state);
  /** @type {HastNodes} */
  const result = Array.isArray(node)
    ? {type: 'root', children: node}
    : node || {type: 'root', children: []};

  if (foot) {
    result.children.push({type: 'text', value: '\n'}, foot);
  }

  return result
}

/**
 * @import {Root as HastRoot} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {Options as ToHastOptions} from 'mdast-util-to-hast'
 * @import {Processor} from 'unified'
 * @import {VFile} from 'vfile'
 */

/**
 * Turn markdown into HTML.
 *
 * ##### Notes
 *
 * ###### Signature
 *
 * * if a processor is given,
 *   runs the (rehype) plugins used on it with a hast tree,
 *   then discards the result (*bridge mode*)
 * * otherwise,
 *   returns a hast tree,
 *   the plugins used after `remarkRehype` are rehype plugins (*mutate mode*)
 *
 * > 👉 **Note**:
 * > It’s highly unlikely that you want to pass a `processor`.
 *
 * ###### HTML
 *
 * Raw HTML is available in mdast as `html` nodes and can be embedded in hast
 * as semistandard `raw` nodes.
 * Most plugins ignore `raw` nodes but two notable ones don’t:
 *
 * * `rehype-stringify` also has an option `allowDangerousHtml` which will
 *   output the raw HTML.
 *   This is typically discouraged as noted by the option name but is useful if
 *   you completely trust authors
 * * `rehype-raw` can handle the raw embedded HTML strings by parsing them
 *   into standard hast nodes (`element`, `text`, etc);
 *   this is a heavy task as it needs a full HTML parser,
 *   but it is the only way to support untrusted content
 *
 * ###### Footnotes
 *
 * Many options supported here relate to footnotes.
 * Footnotes are not specified by CommonMark,
 * which we follow by default.
 * They are supported by GitHub,
 * so footnotes can be enabled in markdown with `remark-gfm`.
 *
 * The options `footnoteBackLabel` and `footnoteLabel` define natural language
 * that explains footnotes,
 * which is hidden for sighted users but shown to assistive technology.
 * When your page is not in English,
 * you must define translated values.
 *
 * Back references use ARIA attributes,
 * but the section label itself uses a heading that is hidden with an
 * `sr-only` class.
 * To show it to sighted users,
 * define different attributes in `footnoteLabelProperties`.
 *
 * ###### Clobbering
 *
 * Footnotes introduces a problem,
 * as it links footnote calls to footnote definitions on the page through `id`
 * attributes generated from user content,
 * which results in DOM clobbering.
 *
 * DOM clobbering is this:
 *
 * ```html
 * <p id=x></p>
 * <script>alert(x) // `x` now refers to the DOM `p#x` element</script>
 * ```
 *
 * Elements by their ID are made available by browsers on the `window` object,
 * which is a security risk.
 * Using a prefix solves this problem.
 *
 * More information on how to handle clobbering and the prefix is explained in
 * *Example: headings (DOM clobbering)* in `rehype-sanitize`.
 *
 * ###### Unknown nodes
 *
 * Unknown nodes are nodes with a type that isn’t in `handlers` or `passThrough`.
 * The default behavior for unknown nodes is:
 *
 * * when the node has a `value`
 *   (and doesn’t have `data.hName`, `data.hProperties`, or `data.hChildren`,
 *   see later),
 *   create a hast `text` node
 * * otherwise,
 *   create a `<div>` element (which could be changed with `data.hName`),
 *   with its children mapped from mdast to hast as well
 *
 * This behavior can be changed by passing an `unknownHandler`.
 *
 * @overload
 * @param {Processor} processor
 * @param {Readonly<Options> | null | undefined} [options]
 * @returns {TransformBridge}
 *
 * @overload
 * @param {Readonly<Options> | null | undefined} [options]
 * @returns {TransformMutate}
 *
 * @overload
 * @param {Readonly<Options> | Processor | null | undefined} [destination]
 * @param {Readonly<Options> | null | undefined} [options]
 * @returns {TransformBridge | TransformMutate}
 *
 * @param {Readonly<Options> | Processor | null | undefined} [destination]
 *   Processor or configuration (optional).
 * @param {Readonly<Options> | null | undefined} [options]
 *   When a processor was given,
 *   configuration (optional).
 * @returns {TransformBridge | TransformMutate}
 *   Transform.
 */
function remarkRehype(destination, options) {
  if (destination && 'run' in destination) {
    /**
     * @type {TransformBridge}
     */
    return async function (tree, file) {
      // Cast because root in -> root out.
      const hastTree = /** @type {HastRoot} */ (
        toHast(tree, {file, ...options})
      );
      await destination.run(hastTree, file);
    }
  }

  /**
   * @type {TransformMutate}
   */
  return function (tree, file) {
    // Cast because root in -> root out.
    // To do: in the future, disallow ` || options` fallback.
    // With `unified-engine`, `destination` can be `undefined` but
    // `options` will be the file set.
    // We should not pass that as `options`.
    return /** @type {HastRoot} */ (
      toHast(tree, {file, ...(destination || options)})
    )
  }
}

/**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */
function bail(error) {
  if (error) {
    throw error
  }
}

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject$1 = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

var extend = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject$1(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject$1(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};

function isPlainObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}

	const prototype = Object.getPrototypeOf(value);
	return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}

// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.

/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */

/**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */
function trough() {
  /** @type {Array<Middleware>} */
  const fns = [];
  /** @type {Pipeline} */
  const pipeline = {run, use};

  return pipeline

  /** @type {Run} */
  function run(...values) {
    let middlewareIndex = -1;
    /** @type {Callback} */
    const callback = values.pop();

    if (typeof callback !== 'function') {
      throw new TypeError('Expected function as last argument, not ' + callback)
    }

    next(null, ...values);

    /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */
    function next(error, ...output) {
      const fn = fns[++middlewareIndex];
      let index = -1;

      if (error) {
        callback(error);
        return
      }

      // Copy non-nullish input into values.
      while (++index < values.length) {
        if (output[index] === null || output[index] === undefined) {
          output[index] = values[index];
        }
      }

      // Save the newly created `output` for the next call.
      values = output;

      // Next or done.
      if (fn) {
        wrap(fn, next)(...output);
      } else {
        callback(null, ...output);
      }
    }
  }

  /** @type {Use} */
  function use(middelware) {
    if (typeof middelware !== 'function') {
      throw new TypeError(
        'Expected `middelware` to be a function, not ' + middelware
      )
    }

    fns.push(middelware);
    return pipeline
  }
}

/**
 * Wrap `middleware` into a uniform interface.
 *
 * You can pass all input to the resulting function.
 * `callback` is then called with the output of `middleware`.
 *
 * If `middleware` accepts more arguments than the later given in input,
 * an extra `done` function is passed to it after that input,
 * which must be called by `middleware`.
 *
 * The first value in `input` is the main input value.
 * All other input values are the rest input values.
 * The values given to `callback` are the input values,
 * merged with every non-nullish output value.
 *
 * * if `middleware` throws an error,
 *   returns a promise that is rejected,
 *   or calls the given `done` function with an error,
 *   `callback` is called with that error
 * * if `middleware` returns a value or returns a promise that is resolved,
 *   that value is the main output value
 * * if `middleware` calls `done`,
 *   all non-nullish values except for the first one (the error) overwrite the
 *   output values
 *
 * @param {Middleware} middleware
 *   Function to wrap.
 * @param {Callback} callback
 *   Callback called with the output of `middleware`.
 * @returns {Run}
 *   Wrapped middleware.
 */
function wrap(middleware, callback) {
  /** @type {boolean} */
  let called;

  return wrapped

  /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware.length > parameters.length;
    /** @type {any} */
    let result;

    if (fnExpectsCallback) {
      parameters.push(done);
    }

    try {
      result = middleware.apply(this, parameters);
    } catch (error) {
      const exception = /** @type {Error} */ (error);

      // Well, this is quite the pickle.
      // `middleware` received a callback and called it synchronously, but that
      // threw an error.
      // The only thing left to do is to throw the thing instead.
      if (fnExpectsCallback && called) {
        throw exception
      }

      return done(exception)
    }

    if (!fnExpectsCallback) {
      if (result && result.then && typeof result.then === 'function') {
        result.then(then, done);
      } else if (result instanceof Error) {
        done(result);
      } else {
        then(result);
      }
    }
  }

  /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */
  function done(error, ...output) {
    if (!called) {
      called = true;
      callback(error, ...output);
    }
  }

  /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */
  function then(value) {
    done(null, value);
  }
}

// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

const minpath = {basename, dirname, extname, join, sep: '/'};

/* eslint-disable max-depth, complexity */

/**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | null | undefined} [extname]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */
function basename(path, extname) {
  if (extname !== undefined && typeof extname !== 'string') {
    throw new TypeError('"ext" argument must be a string')
  }

  assertPath$1(path);
  let start = 0;
  let end = -1;
  let index = path.length;
  /** @type {boolean | undefined} */
  let seenNonSlash;

  if (
    extname === undefined ||
    extname.length === 0 ||
    extname.length > path.length
  ) {
    while (index--) {
      if (path.codePointAt(index) === 47 /* `/` */) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        if (seenNonSlash) {
          start = index + 1;
          break
        }
      } else if (end < 0) {
        // We saw the first non-path separator, mark this as the end of our
        // path component.
        seenNonSlash = true;
        end = index + 1;
      }
    }

    return end < 0 ? '' : path.slice(start, end)
  }

  if (extname === path) {
    return ''
  }

  let firstNonSlashEnd = -1;
  let extnameIndex = extname.length - 1;

  while (index--) {
    if (path.codePointAt(index) === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (seenNonSlash) {
        start = index + 1;
        break
      }
    } else {
      if (firstNonSlashEnd < 0) {
        // We saw the first non-path separator, remember this index in case
        // we need it if the extension ends up not matching.
        seenNonSlash = true;
        firstNonSlashEnd = index + 1;
      }

      if (extnameIndex > -1) {
        // Try to match the explicit extension.
        if (path.codePointAt(index) === extname.codePointAt(extnameIndex--)) {
          if (extnameIndex < 0) {
            // We matched the extension, so mark this as the end of our path
            // component
            end = index;
          }
        } else {
          // Extension does not match, so our result is the entire path
          // component
          extnameIndex = -1;
          end = firstNonSlashEnd;
        }
      }
    }
  }

  if (start === end) {
    end = firstNonSlashEnd;
  } else if (end < 0) {
    end = path.length;
  }

  return path.slice(start, end)
}

/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */
function dirname(path) {
  assertPath$1(path);

  if (path.length === 0) {
    return '.'
  }

  let end = -1;
  let index = path.length;
  /** @type {boolean | undefined} */
  let unmatchedSlash;

  // Prefix `--` is important to not run on `0`.
  while (--index) {
    if (path.codePointAt(index) === 47 /* `/` */) {
      if (unmatchedSlash) {
        end = index;
        break
      }
    } else if (!unmatchedSlash) {
      // We saw the first non-path separator
      unmatchedSlash = true;
    }
  }

  return end < 0
    ? path.codePointAt(0) === 47 /* `/` */
      ? '/'
      : '.'
    : end === 1 && path.codePointAt(0) === 47 /* `/` */
      ? '//'
      : path.slice(0, end)
}

/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */
function extname(path) {
  assertPath$1(path);

  let index = path.length;

  let end = -1;
  let startPart = 0;
  let startDot = -1;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find.
  let preDotState = 0;
  /** @type {boolean | undefined} */
  let unmatchedSlash;

  while (index--) {
    const code = path.codePointAt(index);

    if (code === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (unmatchedSlash) {
        startPart = index + 1;
        break
      }

      continue
    }

    if (end < 0) {
      // We saw the first non-path separator, mark this as the end of our
      // extension.
      unmatchedSlash = true;
      end = index + 1;
    }

    if (code === 46 /* `.` */) {
      // If this is our first dot, mark it as the start of our extension.
      if (startDot < 0) {
        startDot = index;
      } else if (preDotState !== 1) {
        preDotState = 1;
      }
    } else if (startDot > -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension.
      preDotState = -1;
    }
  }

  if (
    startDot < 0 ||
    end < 0 ||
    // We saw a non-dot character immediately before the dot.
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly `..`.
    (preDotState === 1 && startDot === end - 1 && startDot === startPart + 1)
  ) {
    return ''
  }

  return path.slice(startDot, end)
}

/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */
function join(...segments) {
  let index = -1;
  /** @type {string | undefined} */
  let joined;

  while (++index < segments.length) {
    assertPath$1(segments[index]);

    if (segments[index]) {
      joined =
        joined === undefined ? segments[index] : joined + '/' + segments[index];
    }
  }

  return joined === undefined ? '.' : normalize(joined)
}

/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */
// Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function normalize(path) {
  assertPath$1(path);

  const absolute = path.codePointAt(0) === 47; /* `/` */

  // Normalize the path according to POSIX rules.
  let value = normalizeString(path, !absolute);

  if (value.length === 0 && !absolute) {
    value = '.';
  }

  if (value.length > 0 && path.codePointAt(path.length - 1) === 47 /* / */) {
    value += '/';
  }

  return absolute ? '/' + value : value
}

/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */
function normalizeString(path, allowAboveRoot) {
  let result = '';
  let lastSegmentLength = 0;
  let lastSlash = -1;
  let dots = 0;
  let index = -1;
  /** @type {number | undefined} */
  let code;
  /** @type {number} */
  let lastSlashIndex;

  while (++index <= path.length) {
    if (index < path.length) {
      code = path.codePointAt(index);
    } else if (code === 47 /* `/` */) {
      break
    } else {
      code = 47; /* `/` */
    }

    if (code === 47 /* `/` */) {
      if (lastSlash === index - 1 || dots === 1) ; else if (lastSlash !== index - 1 && dots === 2) {
        if (
          result.length < 2 ||
          lastSegmentLength !== 2 ||
          result.codePointAt(result.length - 1) !== 46 /* `.` */ ||
          result.codePointAt(result.length - 2) !== 46 /* `.` */
        ) {
          if (result.length > 2) {
            lastSlashIndex = result.lastIndexOf('/');

            if (lastSlashIndex !== result.length - 1) {
              if (lastSlashIndex < 0) {
                result = '';
                lastSegmentLength = 0;
              } else {
                result = result.slice(0, lastSlashIndex);
                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
              }

              lastSlash = index;
              dots = 0;
              continue
            }
          } else if (result.length > 0) {
            result = '';
            lastSegmentLength = 0;
            lastSlash = index;
            dots = 0;
            continue
          }
        }

        if (allowAboveRoot) {
          result = result.length > 0 ? result + '/..' : '..';
          lastSegmentLength = 2;
        }
      } else {
        if (result.length > 0) {
          result += '/' + path.slice(lastSlash + 1, index);
        } else {
          result = path.slice(lastSlash + 1, index);
        }

        lastSegmentLength = index - lastSlash - 1;
      }

      lastSlash = index;
      dots = 0;
    } else if (code === 46 /* `.` */ && dots > -1) {
      dots++;
    } else {
      dots = -1;
    }
  }

  return result
}

/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */
function assertPath$1(path) {
  if (typeof path !== 'string') {
    throw new TypeError(
      'Path must be a string. Received ' + JSON.stringify(path)
    )
  }
}

/* eslint-enable max-depth, complexity */

// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const minproc = {cwd};

function cwd() {
  return '/'
}

/**
 * Checks if a value has the shape of a WHATWG URL object.
 *
 * Using a symbol or instanceof would not be able to recognize URL objects
 * coming from other implementations (e.g. in Electron), so instead we are
 * checking some well known properties for a lack of a better test.
 *
 * We use `href` and `protocol` as they are the only properties that are
 * easy to retrieve and calculate due to the lazy nature of the getters.
 *
 * We check for auth attribute to distinguish legacy url instance with
 * WHATWG URL instance.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */
// From: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js#L720>
function isUrl(fileUrlOrPath) {
  return Boolean(
    fileUrlOrPath !== null &&
      typeof fileUrlOrPath === 'object' &&
      'href' in fileUrlOrPath &&
      fileUrlOrPath.href &&
      'protocol' in fileUrlOrPath &&
      fileUrlOrPath.protocol &&
      // @ts-expect-error: indexing is fine.
      fileUrlOrPath.auth === undefined
  )
}

// See: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js>

/**
 * @param {URL | string} path
 *   File URL.
 * @returns {string}
 *   File URL.
 */
function urlToPath(path) {
  if (typeof path === 'string') {
    path = new URL(path);
  } else if (!isUrl(path)) {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' +
        path +
        '`'
    );
    error.code = 'ERR_INVALID_ARG_TYPE';
    throw error
  }

  if (path.protocol !== 'file:') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError('The URL must be of scheme file');
    error.code = 'ERR_INVALID_URL_SCHEME';
    throw error
  }

  return getPathFromURLPosix(path)
}

/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */
function getPathFromURLPosix(url) {
  if (url.hostname !== '') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    error.code = 'ERR_INVALID_FILE_URL_HOST';
    throw error
  }

  const pathname = url.pathname;
  let index = -1;

  while (++index < pathname.length) {
    if (
      pathname.codePointAt(index) === 37 /* `%` */ &&
      pathname.codePointAt(index + 1) === 50 /* `2` */
    ) {
      const third = pathname.codePointAt(index + 2);
      if (third === 70 /* `F` */ || third === 102 /* `f` */) {
        /** @type {NodeJS.ErrnoException} */
        const error = new TypeError(
          'File URL path must not include encoded / characters'
        );
        error.code = 'ERR_INVALID_FILE_URL_PATH';
        throw error
      }
    }
  }

  return decodeURIComponent(pathname)
}

/**
 * @import {Node, Point, Position} from 'unist'
 * @import {Options as MessageOptions} from 'vfile-message'
 * @import {Compatible, Data, Map, Options, Value} from 'vfile'
 */

/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 */
const order = /** @type {const} */ ([
  'history',
  'path',
  'basename',
  'stem',
  'extname',
  'dirname'
]);

class VFile {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(value) {
    /** @type {Options | VFile} */
    let options;

    if (!value) {
      options = {};
    } else if (isUrl(value)) {
      options = {path: value};
    } else if (typeof value === 'string' || isUint8Array$1(value)) {
      options = {value};
    } else {
      options = value;
    }

    /* eslint-disable no-unused-expressions */

    /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */
    // Prevent calling `cwd` (which could be expensive) if it’s not needed;
    // the empty string will be overridden in the next block.
    this.cwd = 'cwd' in options ? '' : minproc.cwd();

    /**
     * Place to store custom info (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */
    this.data = {};

    /**
     * List of file paths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */
    this.history = [];

    /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */
    this.messages = [];

    /**
     * Raw value.
     *
     * @type {Value}
     */
    this.value;

    // The below are non-standard, they are “well-known”.
    // As in, used in several tools.
    /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */
    this.map;

    /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */
    this.result;

    /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */
    this.stored;
    /* eslint-enable no-unused-expressions */

    // Set path related properties in the correct order.
    let index = -1;

    while (++index < order.length) {
      const field = order[index];

      // Note: we specifically use `in` instead of `hasOwnProperty` to accept
      // `vfile`s too.
      if (
        field in options &&
        options[field] !== undefined &&
        options[field] !== null
      ) {
        // @ts-expect-error: TS doesn’t understand basic reality.
        this[field] = field === 'history' ? [...options[field]] : options[field];
      }
    }

    /** @type {string} */
    let field;

    // Set non-path related properties.
    for (field in options) {
      // @ts-expect-error: fine to set other things.
      if (!order.includes(field)) {
        // @ts-expect-error: fine to set other things.
        this[field] = options[field];
      }
    }
  }

  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path === 'string'
      ? minpath.basename(this.path)
      : undefined
  }

  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(basename) {
    assertNonEmpty(basename, 'basename');
    assertPart(basename, 'basename');
    this.path = minpath.join(this.dirname || '', basename);
  }

  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path === 'string'
      ? minpath.dirname(this.path)
      : undefined
  }

  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(dirname) {
    assertPath(this.basename, 'dirname');
    this.path = minpath.join(dirname || '', this.basename);
  }

  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path === 'string'
      ? minpath.extname(this.path)
      : undefined
  }

  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(extname) {
    assertPart(extname, 'extname');
    assertPath(this.dirname, 'extname');

    if (extname) {
      if (extname.codePointAt(0) !== 46 /* `.` */) {
        throw new Error('`extname` must start with `.`')
      }

      if (extname.includes('.', 1)) {
        throw new Error('`extname` cannot contain multiple dots')
      }
    }

    this.path = minpath.join(this.dirname, this.stem + (extname || ''));
  }

  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1]
  }

  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(path) {
    if (isUrl(path)) {
      path = urlToPath(path);
    }

    assertNonEmpty(path, 'path');

    if (this.path !== path) {
      this.history.push(path);
    }
  }

  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path === 'string'
      ? minpath.basename(this.path, this.extname)
      : undefined
  }

  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(stem) {
    assertNonEmpty(stem, 'stem');
    assertPart(stem, 'stem');
    this.path = minpath.join(this.dirname || '', stem + (this.extname || ''));
  }

  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(causeOrReason, optionsOrParentOrPlace, origin) {
    // @ts-expect-error: the overloads are fine.
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);

    message.fatal = true;

    throw message
  }

  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(causeOrReason, optionsOrParentOrPlace, origin) {
    // @ts-expect-error: the overloads are fine.
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);

    message.fatal = undefined;

    return message
  }

  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = new VFileMessage(
      // @ts-expect-error: the overloads are fine.
      causeOrReason,
      optionsOrParentOrPlace,
      origin
    );

    if (this.path) {
      message.name = this.path + ':' + message.name;
      message.file = this.path;
    }

    message.fatal = false;

    this.messages.push(message);

    return message
  }

  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    if (this.value === undefined) {
      return ''
    }

    if (typeof this.value === 'string') {
      return this.value
    }

    const decoder = new TextDecoder(encoding || undefined);
    return decoder.decode(this.value)
  }
}

/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {undefined}
 *   Nothing.
 */
function assertPart(part, name) {
  if (part && part.includes(minpath.sep)) {
    throw new Error(
      '`' + name + '` cannot be a path: did not expect `' + minpath.sep + '`'
    )
  }
}

/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */
function assertNonEmpty(part, name) {
  if (!part) {
    throw new Error('`' + name + '` cannot be empty')
  }
}

/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */
function assertPath(path, name) {
  if (!path) {
    throw new Error('Setting `' + name + '` requires `path` to be set too')
  }
}

/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */
function isUint8Array$1(value) {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'byteLength' in value &&
      'byteOffset' in value
  )
}

const CallableInstance =
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  (
    /** @type {unknown} */
    (
      /**
       * @this {Function}
       * @param {string | symbol} property
       * @returns {(...parameters: Array<unknown>) => unknown}
       */
      function (property) {
        const self = this;
        const constr = self.constructor;
        const proto = /** @type {Record<string | symbol, Function>} */ (
          // Prototypes do exist.
          // type-coverage:ignore-next-line
          constr.prototype
        );
        const value = proto[property];
        /** @type {(...parameters: Array<unknown>) => unknown} */
        const apply = function () {
          return value.apply(apply, arguments)
        };

        Object.setPrototypeOf(apply, proto);

        // Not needed for us in `unified`: we only call this on the `copy`
        // function,
        // and we don't need to add its fields (`length`, `name`)
        // over.
        // See also: GH-246.
        // const names = Object.getOwnPropertyNames(value)
        //
        // for (const p of names) {
        //   const descriptor = Object.getOwnPropertyDescriptor(value, p)
        //   if (descriptor) Object.defineProperty(apply, p, descriptor)
        // }

        return apply
      }
    )
  );

/**
 * @typedef {import('trough').Pipeline} Pipeline
 *
 * @typedef {import('unist').Node} Node
 *
 * @typedef {import('vfile').Compatible} Compatible
 * @typedef {import('vfile').Value} Value
 *
 * @typedef {import('../index.js').CompileResultMap} CompileResultMap
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Settings} Settings
 */

// To do: next major: drop `Compiler`, `Parser`: prefer lowercase.

// To do: we could start yielding `never` in TS when a parser is missing and
// `parse` is called.
// Currently, we allow directly setting `processor.parser`, which is untyped.

const own = {}.hasOwnProperty;

/**
 * @template {Node | undefined} [ParseTree=undefined]
 *   Output of `parse` (optional).
 * @template {Node | undefined} [HeadTree=undefined]
 *   Input for `run` (optional).
 * @template {Node | undefined} [TailTree=undefined]
 *   Output for `run` (optional).
 * @template {Node | undefined} [CompileTree=undefined]
 *   Input of `stringify` (optional).
 * @template {CompileResults | undefined} [CompileResult=undefined]
 *   Output of `stringify` (optional).
 * @extends {CallableInstance<[], Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>>}
 */
class Processor extends CallableInstance {
  /**
   * Create a processor.
   */
  constructor() {
    // If `Processor()` is called (w/o new), `copy` is called instead.
    super('copy');

    /**
     * Compiler to use (deprecated).
     *
     * @deprecated
     *   Use `compiler` instead.
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */
    this.Compiler = undefined;

    /**
     * Parser to use (deprecated).
     *
     * @deprecated
     *   Use `parser` instead.
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */
    this.Parser = undefined;

    // Note: the following fields are considered private.
    // However, they are needed for tests, and TSC generates an untyped
    // `private freezeIndex` field for, which trips `type-coverage` up.
    // Instead, we use `@deprecated` to visualize that they shouldn’t be used.
    /**
     * Internal list of configured plugins.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Array<PluginTuple<Array<unknown>>>}
     */
    this.attachers = [];

    /**
     * Compiler to use.
     *
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */
    this.compiler = undefined;

    /**
     * Internal state to track where we are while freezing.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {number}
     */
    this.freezeIndex = -1;

    /**
     * Internal state to track whether we’re frozen.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {boolean | undefined}
     */
    this.frozen = undefined;

    /**
     * Internal state.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Data}
     */
    this.namespace = {};

    /**
     * Parser to use.
     *
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */
    this.parser = undefined;

    /**
     * Internal list of configured transformers.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Pipeline}
     */
    this.transformers = trough();
  }

  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    // Cast as the type parameters will be the same after attaching.
    const destination =
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */ (
        new Processor()
      );
    let index = -1;

    while (++index < this.attachers.length) {
      const attacher = this.attachers[index];
      destination.use(...attacher);
    }

    destination.data(extend(true, {}, this.namespace));

    return destination
  }

  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(key, value) {
    if (typeof key === 'string') {
      // Set `key`.
      if (arguments.length === 2) {
        assertUnfrozen('data', this.frozen);
        this.namespace[key] = value;
        return this
      }

      // Get `key`.
      return (own.call(this.namespace, key) && this.namespace[key]) || undefined
    }

    // Set space.
    if (key) {
      assertUnfrozen('data', this.frozen);
      this.namespace = key;
      return this
    }

    // Get space.
    return this.namespace
  }

  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen) {
      return this
    }

    // Cast so that we can type plugins easier.
    // Plugins are supposed to be usable on different processors, not just on
    // this exact processor.
    const self = /** @type {Processor} */ (/** @type {unknown} */ (this));

    while (++this.freezeIndex < this.attachers.length) {
      const [attacher, ...options] = this.attachers[this.freezeIndex];

      if (options[0] === false) {
        continue
      }

      if (options[0] === true) {
        options[0] = undefined;
      }

      const transformer = attacher.call(self, ...options);

      if (typeof transformer === 'function') {
        this.transformers.use(transformer);
      }
    }

    this.frozen = true;
    this.freezeIndex = Number.POSITIVE_INFINITY;

    return this
  }

  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(file) {
    this.freeze();
    const realFile = vfile(file);
    const parser = this.parser || this.Parser;
    assertParser('parse', parser);
    return parser(String(realFile), realFile)
  }

  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(file, done) {
    const self = this;

    this.freeze();
    assertParser('process', this.parser || this.Parser);
    assertCompiler('process', this.compiler || this.Compiler);

    return done ? executor(undefined, done) : new Promise(executor)

    // Note: `void`s needed for TS.
    /**
     * @param {((file: VFileWithOutput<CompileResult>) => undefined | void) | undefined} resolve
     * @param {(error: Error | undefined) => undefined | void} reject
     * @returns {undefined}
     */
    function executor(resolve, reject) {
      const realFile = vfile(file);
      // Assume `ParseTree` (the result of the parser) matches `HeadTree` (the
      // input of the first transform).
      const parseTree =
        /** @type {HeadTree extends undefined ? Node : HeadTree} */ (
          /** @type {unknown} */ (self.parse(realFile))
        );

      self.run(parseTree, realFile, function (error, tree, file) {
        if (error || !tree || !file) {
          return realDone(error)
        }

        // Assume `TailTree` (the output of the last transform) matches
        // `CompileTree` (the input of the compiler).
        const compileTree =
          /** @type {CompileTree extends undefined ? Node : CompileTree} */ (
            /** @type {unknown} */ (tree)
          );

        const compileResult = self.stringify(compileTree, file);

        if (looksLikeAValue(compileResult)) {
          file.value = compileResult;
        } else {
          file.result = compileResult;
        }

        realDone(error, /** @type {VFileWithOutput<CompileResult>} */ (file));
      });

      /**
       * @param {Error | undefined} error
       * @param {VFileWithOutput<CompileResult> | undefined} [file]
       * @returns {undefined}
       */
      function realDone(error, file) {
        if (error || !file) {
          reject(error);
        } else if (resolve) {
          resolve(file);
        } else {
          done(undefined, file);
        }
      }
    }
  }

  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(file) {
    /** @type {boolean} */
    let complete = false;
    /** @type {VFileWithOutput<CompileResult> | undefined} */
    let result;

    this.freeze();
    assertParser('processSync', this.parser || this.Parser);
    assertCompiler('processSync', this.compiler || this.Compiler);

    this.process(file, realDone);
    assertDone('processSync', 'process', complete);

    return result

    /**
     * @type {ProcessCallback<VFileWithOutput<CompileResult>>}
     */
    function realDone(error, file) {
      complete = true;
      bail(error);
      result = file;
    }
  }

  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(tree, file, done) {
    assertNode(tree);
    this.freeze();

    const transformers = this.transformers;

    if (!done && typeof file === 'function') {
      done = file;
      file = undefined;
    }

    return done ? executor(undefined, done) : new Promise(executor)

    // Note: `void`s needed for TS.
    /**
     * @param {(
     *   ((tree: TailTree extends undefined ? Node : TailTree) => undefined | void) |
     *   undefined
     * )} resolve
     * @param {(error: Error) => undefined | void} reject
     * @returns {undefined}
     */
    function executor(resolve, reject) {
      const realFile = vfile(file);
      transformers.run(tree, realFile, realDone);

      /**
       * @param {Error | undefined} error
       * @param {Node} outputTree
       * @param {VFile} file
       * @returns {undefined}
       */
      function realDone(error, outputTree, file) {
        const resultingTree =
          /** @type {TailTree extends undefined ? Node : TailTree} */ (
            outputTree || tree
          );

        if (error) {
          reject(error);
        } else if (resolve) {
          resolve(resultingTree);
        } else {
          done(undefined, resultingTree, file);
        }
      }
    }
  }

  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(tree, file) {
    /** @type {boolean} */
    let complete = false;
    /** @type {(TailTree extends undefined ? Node : TailTree) | undefined} */
    let result;

    this.run(tree, file, realDone);

    assertDone('runSync', 'run', complete);
    return result

    /**
     * @type {RunCallback<TailTree extends undefined ? Node : TailTree>}
     */
    function realDone(error, tree) {
      bail(error);
      result = tree;
      complete = true;
    }
  }

  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(tree, file) {
    this.freeze();
    const realFile = vfile(file);
    const compiler = this.compiler || this.Compiler;
    assertCompiler('stringify', compiler);
    assertNode(tree);

    return compiler(tree, realFile)
  }

  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(value, ...parameters) {
    const attachers = this.attachers;
    const namespace = this.namespace;

    assertUnfrozen('use', this.frozen);

    if (value === null || value === undefined) ; else if (typeof value === 'function') {
      addPlugin(value, parameters);
    } else if (typeof value === 'object') {
      if (Array.isArray(value)) {
        addList(value);
      } else {
        addPreset(value);
      }
    } else {
      throw new TypeError('Expected usable value, not `' + value + '`')
    }

    return this

    /**
     * @param {Pluggable} value
     * @returns {undefined}
     */
    function add(value) {
      if (typeof value === 'function') {
        addPlugin(value, []);
      } else if (typeof value === 'object') {
        if (Array.isArray(value)) {
          const [plugin, ...parameters] =
            /** @type {PluginTuple<Array<unknown>>} */ (value);
          addPlugin(plugin, parameters);
        } else {
          addPreset(value);
        }
      } else {
        throw new TypeError('Expected usable value, not `' + value + '`')
      }
    }

    /**
     * @param {Preset} result
     * @returns {undefined}
     */
    function addPreset(result) {
      if (!('plugins' in result) && !('settings' in result)) {
        throw new Error(
          'Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither'
        )
      }

      addList(result.plugins);

      if (result.settings) {
        namespace.settings = extend(true, namespace.settings, result.settings);
      }
    }

    /**
     * @param {PluggableList | null | undefined} plugins
     * @returns {undefined}
     */
    function addList(plugins) {
      let index = -1;

      if (plugins === null || plugins === undefined) ; else if (Array.isArray(plugins)) {
        while (++index < plugins.length) {
          const thing = plugins[index];
          add(thing);
        }
      } else {
        throw new TypeError('Expected a list of plugins, not `' + plugins + '`')
      }
    }

    /**
     * @param {Plugin} plugin
     * @param {Array<unknown>} parameters
     * @returns {undefined}
     */
    function addPlugin(plugin, parameters) {
      let index = -1;
      let entryIndex = -1;

      while (++index < attachers.length) {
        if (attachers[index][0] === plugin) {
          entryIndex = index;
          break
        }
      }

      if (entryIndex === -1) {
        attachers.push([plugin, ...parameters]);
      }
      // Only set if there was at least a `primary` value, otherwise we’d change
      // `arguments.length`.
      else if (parameters.length > 0) {
        let [primary, ...rest] = parameters;
        const currentPrimary = attachers[entryIndex][1];
        if (isPlainObject(currentPrimary) && isPlainObject(primary)) {
          primary = extend(true, currentPrimary, primary);
        }

        attachers[entryIndex] = [plugin, primary, ...rest];
      }
    }
  }
}

// Note: this returns a *callable* instance.
// That’s why it’s documented as a function.
/**
 * Create a new processor.
 *
 * @example
 *   This example shows how a new processor can be created (from `remark`) and linked
 *   to **stdin**(4) and **stdout**(4).
 *
 *   ```js
 *   import process from 'node:process'
 *   import concatStream from 'concat-stream'
 *   import {remark} from 'remark'
 *
 *   process.stdin.pipe(
 *     concatStream(function (buf) {
 *       process.stdout.write(String(remark().processSync(buf)))
 *     })
 *   )
 *   ```
 *
 * @returns
 *   New *unfrozen* processor (`processor`).
 *
 *   This processor is configured to work the same as its ancestor.
 *   When the descendant processor is configured in the future it does not
 *   affect the ancestral processor.
 */
const unified = new Processor().freeze();

/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */
function assertParser(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `parser`')
  }
}

/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */
function assertCompiler(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `compiler`')
  }
}

/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */
function assertUnfrozen(name, frozen) {
  if (frozen) {
    throw new Error(
      'Cannot call `' +
        name +
        '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.'
    )
  }
}

/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */
function assertNode(node) {
  // `isPlainObj` unfortunately uses `any` instead of `unknown`.
  // type-coverage:ignore-next-line
  if (!isPlainObject(node) || typeof node.type !== 'string') {
    throw new TypeError('Expected node, got `' + node + '`')
    // Fine.
  }
}

/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */
function assertDone(name, asyncName, complete) {
  if (!complete) {
    throw new Error(
      '`' + name + '` finished async. Use `' + asyncName + '` instead'
    )
  }
}

/**
 * @param {Compatible | undefined} [value]
 * @returns {VFile}
 */
function vfile(value) {
  return looksLikeAVFile(value) ? value : new VFile(value)
}

/**
 * @param {Compatible | undefined} [value]
 * @returns {value is VFile}
 */
function looksLikeAVFile(value) {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'message' in value &&
      'messages' in value
  )
}

/**
 * @param {unknown} [value]
 * @returns {value is Value}
 */
function looksLikeAValue(value) {
  return typeof value === 'string' || isUint8Array(value)
}

/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */
function isUint8Array(value) {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'byteLength' in value &&
      'byteOffset' in value
  )
}

// Register `Raw` in tree:

const changelog =
  'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';

/** @type {PluggableList} */
const emptyPlugins = [];
/** @type {Readonly<RemarkRehypeOptions>} */
const emptyRemarkRehypeOptions = {allowDangerousHtml: true};
const safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;

// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */
const deprecations = [
  {from: 'astPlugins', id: 'remove-buggy-html-in-markdown-parser'},
  {from: 'allowDangerousHtml', id: 'remove-buggy-html-in-markdown-parser'},
  {
    from: 'allowNode',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes',
    to: 'allowElement'
  },
  {
    from: 'allowedTypes',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes',
    to: 'allowedElements'
  },
  {
    from: 'disallowedTypes',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes',
    to: 'disallowedElements'
  },
  {from: 'escapeHtml', id: 'remove-buggy-html-in-markdown-parser'},
  {from: 'includeElementIndex', id: '#remove-includeelementindex'},
  {
    from: 'includeNodeIndex',
    id: 'change-includenodeindex-to-includeelementindex'
  },
  {from: 'linkTarget', id: 'remove-linktarget'},
  {from: 'plugins', id: 'change-plugins-to-remarkplugins', to: 'remarkPlugins'},
  {from: 'rawSourcePos', id: '#remove-rawsourcepos'},
  {from: 'renderers', id: 'change-renderers-to-components', to: 'components'},
  {from: 'source', id: 'change-source-to-children', to: 'children'},
  {from: 'sourcePos', id: '#remove-sourcepos'},
  {from: 'transformImageUri', id: '#add-urltransform', to: 'urlTransform'},
  {from: 'transformLinkUri', id: '#add-urltransform', to: 'urlTransform'}
];

/**
 * Component to render markdown.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {JSX.Element}
 *   React element.
 */
function Markdown(options) {
  const allowedElements = options.allowedElements;
  const allowElement = options.allowElement;
  const children = options.children || '';
  const className = options.className;
  const components = options.components;
  const disallowedElements = options.disallowedElements;
  const rehypePlugins = options.rehypePlugins || emptyPlugins;
  const remarkPlugins = options.remarkPlugins || emptyPlugins;
  const remarkRehypeOptions = options.remarkRehypeOptions
    ? {...options.remarkRehypeOptions, ...emptyRemarkRehypeOptions}
    : emptyRemarkRehypeOptions;
  const skipHtml = options.skipHtml;
  const unwrapDisallowed = options.unwrapDisallowed;
  const urlTransform = options.urlTransform || defaultUrlTransform;

  const processor = unified()
    .use(remarkParse)
    .use(remarkPlugins)
    .use(remarkRehype, remarkRehypeOptions)
    .use(rehypePlugins);

  const file = new VFile();

  if (typeof children === 'string') {
    file.value = children;
  }

  for (const deprecation of deprecations) {
    if (Object.hasOwn(options, deprecation.from)) {
      unreachable(
        'Unexpected `' +
          deprecation.from +
          '` prop, ' +
          (deprecation.to
            ? 'use `' + deprecation.to + '` instead'
            : 'remove it') +
          ' (see <' +
          changelog +
          '#' +
          deprecation.id +
          '> for more info)'
      );
    }
  }

  const mdastTree = processor.parse(file);
  /** @type {Nodes} */
  let hastTree = processor.runSync(mdastTree, file);

  // Wrap in `div` if there’s a class name.
  if (className) {
    hastTree = {
      type: 'element',
      tagName: 'div',
      properties: {className},
      // Assume no doctypes.
      children: /** @type {Array<ElementContent>} */ (
        hastTree.type === 'root' ? hastTree.children : [hastTree]
      )
    };
  }

  visit(hastTree, transform);

  return toJsxRuntime(hastTree, {
    Fragment: jsxRuntime.exports.Fragment,
    components,
    ignoreInvalidStyle: true,
    jsx: jsxRuntime.exports.jsx,
    jsxs: jsxRuntime.exports.jsxs,
    passKeys: true,
    passNode: true
  })

  /** @type {Visitor} */
  function transform(node, index, parent) {
    if (node.type === 'raw' && parent && typeof index === 'number') {
      if (skipHtml) {
        parent.children.splice(index, 1);
      } else {
        parent.children[index] = {type: 'text', value: node.value};
      }

      return index
    }

    if (node.type === 'element') {
      /** @type {string} */
      let key;

      for (key in urlAttributes) {
        if (
          Object.hasOwn(urlAttributes, key) &&
          Object.hasOwn(node.properties, key)
        ) {
          const value = node.properties[key];
          const test = urlAttributes[key];
          if (test === null || test.includes(node.tagName)) {
            node.properties[key] = urlTransform(String(value || ''), key, node);
          }
        }
      }
    }

    if (node.type === 'element') {
      let remove = allowedElements
        ? !allowedElements.includes(node.tagName)
        : disallowedElements
        ? disallowedElements.includes(node.tagName)
        : false;

      if (!remove && allowElement && typeof index === 'number') {
        remove = !allowElement(node, index, parent);
      }

      if (remove && parent && typeof index === 'number') {
        if (unwrapDisallowed && node.children) {
          parent.children.splice(index, 1, ...node.children);
        } else {
          parent.children.splice(index, 1);
        }

        return index
      }
    }
  }
}

/**
 * Make a URL safe.
 *
 * @satisfies {UrlTransform}
 * @param {string} value
 *   URL.
 * @returns {string}
 *   Safe URL.
 */
function defaultUrlTransform(value) {
  // Same as:
  // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
  // But without the `encode` part.
  const colon = value.indexOf(':');
  const questionMark = value.indexOf('?');
  const numberSign = value.indexOf('#');
  const slash = value.indexOf('/');

  if (
    // If there is no protocol, it’s relative.
    colon < 0 ||
    // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    (slash > -1 && colon > slash) ||
    (questionMark > -1 && colon > questionMark) ||
    (numberSign > -1 && colon > numberSign) ||
    // It is a protocol, it should be allowed.
    safeProtocol.test(value.slice(0, colon))
  ) {
    return value
  }

  return ''
}

const TRANSITION_DURATION$1 = 0.3;
const StyledChatBubble = styled__default["default"].div `
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: ${({ $isUsersMessage }) => ($isUsersMessage ? 'flex-end' : 'flex-start')};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.grey[100]};

  h1,
  h2,
  h3 {
    margin-bottom: 0;
    color: ${({ theme }) => theme.colors.grey[100]};
  }

  ol,
  ul {
    padding: 0 0 0 2rem;
    line-height: 1.6;
    margin-left: 1rem;
  }

  ul {
    list-style: disc;
  }

  p > a {
    cursor: pointer;
    color: ${accentColors.info.dark};
  }

  code {
    background-color: #212c42;
    color: ${({ theme }) => theme.colors.primary.main};
    padding: 0.2rem 0.5rem;
    display: ruby;
    white-space: normal;
    border-radius: 0.3rem;
    border: solid 1px rgba(62, 71, 90, 1);
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace !important;
    font-size: ${({ theme }) => theme.fonts.sizes.small};
  }
`;
const StyledCodeBox = styled__default["default"].div `
  background-color: rgba(28, 37, 56, 1);
  position: relative;
  border-radius: 0.6rem;

  pre > code {
    background-color: rgba(28, 37, 56, 1);
    display: block;
    white-space: nowrap;
    overflow-x: auto;
    border: unset;
    padding-left: 16px;
    padding-right: 38px;
    font-size: ${({ theme }) => theme.fonts.sizes.default};

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.colors.secondary.light};
      margin: 10px 0 10px 0;
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.colors.grey[700]};
      border-radius: 8px;
      width: 8px;

      :hover {
        background-color: ${({ theme }) => theme.colors.grey[500]};
      }
    }
  }
`;
const StyledCodeCopy = styled__default["default"].div `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.grey[600]};
  padding: 0.2rem 0.8rem;
  position: absolute;
  right: 0;
  top: 0;
  background-color: rgba(28, 37, 56, 1);
  border-bottom-left-radius: 0.6rem;
  border-top-right-radius: 0.6rem;

  :hover {
    cursor: pointer;
    background-color: rgba(45, 61, 95, 1);
    color: ${({ theme }) => theme.colors.grey[300]};
  }
`;
const StyledChatTextRow = styled__default["default"].div `
  display: flex;
  flex-direction: ${({ $isUsersMessage }) => ($isUsersMessage ? 'row' : 'column')};
  gap: 2.5rem;
  justify-content: ${({ $isUsersMessage }) => ($isUsersMessage ? 'flex-end' : 'flex-start')};
`;
const userMessageAnimation = styled.keyframes `
    0% {
        animation-timing-function: ease-in;
        opacity: 0;
        transform: translateX(40px) scale(0);
    }

    50% {
        animation-timing-function: ease-out;
        opacity: 1;
        transform: translateX(0) scale(1);
      }
      
      100% {
        animation-timing-function: ease-out;
        opacity: 1;
        transform: translateX(0) scale(1);
    }
`;
const StyledUserMessage = styled__default["default"].p `
  padding: ${({ $isUsersMessage }) => ($isUsersMessage ? '1rem 2.4rem' : '0')};
  border-radius: 1.2rem 1.2rem 0.3rem 1.2rem;
  background-color: ${({ $isUsersMessage }) => ($isUsersMessage ? 'rgba(28, 37, 56, 1)' : 'inherit')};
  width: fit-content;
  max-width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
  transform-origin: bottom right;
  ${({ $isUsersMessage, $shouldAnimate }) => $isUsersMessage &&
    $shouldAnimate &&
    styled.css `
      opacity: 0;
      animation: ${userMessageAnimation} ${TRANSITION_DURATION$1}s ease 0s 1 normal forwards;
    `};

  ${({ $isAskEcho }) => $isAskEcho &&
    styled.css `
      span {
        color: rgba(215, 82, 255, 1);
      }
    `};
`;
const personaAnimation = styled.keyframes `
    0% {
        opacity: 0;
        transform: translateX(-40px);
    }
    40% {
        opacity: 0;
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
`;
const StyledPersona = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  margin-bottom: 0.4rem;
  ${({ $shouldAnimate }) => $shouldAnimate &&
    styled.css `
      animation: ${personaAnimation} ${TRANSITION_DURATION$1}s ease 0s 1 normal forwards;
    `};
`;
styled__default["default"].div `
  display: inline-block;
`;
const StyledPill$1 = styled__default["default"].div `
  padding: 2px 10px 2px 10px;
  border-radius: 1rem 1rem 1rem 1rem;
  background-color: ${lighterVariations.purple.dark};
  color: ${otherColors.purple3[100]};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  line-height: 1.4rem;
  cursor: pointer;
`;
const systemMessageAnimation = styled.keyframes `
    0% {
        opacity: 0;
        transform: translateY(80%);
    }
    20% {
        opacity: 0;
    }
    50% {
        opacity: 1;
        transform: translateY(0%);
    }
    100% {
        opacity: 1;
        transform: translateY(0%);
    }
`;
const StyledSystemMessage = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: hidden;

  ${({ $shouldAnimate }) => $shouldAnimate &&
    styled.css `
      animation: ${systemMessageAnimation} ${TRANSITION_DURATION$1}s ease-out 0s 1 normal forwards;
    `};
`;
const StyleVotingRow = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 0;
  opacity: ${({ $shouldAnimate }) => ($shouldAnimate ? 1 : 0)};
  transition: opacity 0.5s;
  transition-delay: 0.25s;
`;
const StyledVotingOptions = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  gap: 0.2rem;
  padding: 0.2rem;
  border-radius: 0.6rem;
  background-color: rgba(28, 37, 56, 1);
  height: fit-content;
  position: relative;
  bottom: 20px;
`;
const StyledUpVoteIcon = styled__default["default"](FontAwesomeIcon) `
  padding: 0.4rem;
  border-radius: 0.6rem;

  color: ${({ $vote, theme }) => ($vote === 1 ? theme.colors.primary.main : theme.colors.primary.lightest)};
  background-color: ${({ $vote }) => ($vote === 1 ? 'rgba(33, 44, 66, 1)' : 'rgba(28, 37, 56, 1)')};

  cursor: ${({ $shouldAnimate }) => ($shouldAnimate ? 'pointer' : 'default')};
  transition: cursor 1s;
  transition-delay: 0.5s;

  :hover {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;
const StyledDownVoteIcon = styled__default["default"](FontAwesomeIcon) `
  padding: 0.4rem;
  border-radius: 0.6rem;

  color: ${({ $vote, theme }) => ($vote === -1 ? theme.colors.error.main : theme.colors.primary.lightest)};
  background-color: ${({ $vote }) => ($vote === -1 ? 'rgba(33, 44, 66, 1)' : 'rgba(28, 37, 56, 1)')};

  cursor: ${({ $shouldAnimate }) => ($shouldAnimate ? 'pointer' : 'default')};
  transition: cursor 1s;
  transition-delay: 0.5s;

  :hover {
    color: ${({ theme }) => theme.colors.error.main};
  }
`;
const suggestionAnimation = styled.keyframes `
    0% {
        opacity: 0;
        transform: scale(0);
    }
    30% {
        opacity: 0;
        transform: scale(0.5);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
`;
const selectedAnimation = styled.keyframes `
    0% {
        opacity: 1;
        transform: scale(1);
    }
    30% {
        opacity: 1;
        transform: scale(0.5);
    }
    100% {
        opacity: 0;
        transform: scale(0);
    }
`;
const unselectedAnimation = styled.keyframes `
    0% {
        opacity: 1;
        transform: translateX(0);
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 0;
        transform: translateX(-50px);
    }
`;
const StyledUserActionsWrapper = styled__default["default"].div `
  height: ${({ $actionSelected }) => ($actionSelected ? 0 : 'unset')};
`;
const StyledUserActions = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.8rem;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.grey[100]};
  opacity: 1;
  padding-top: 0.8rem;
  padding-bottom: 1.6rem;
`;
const StyledUserAction = styled__default["default"].div `
  opacity: 0;
  border: solid 1px ${({ theme }) => theme.colors.primary.main};
  border-radius: ${({ theme }) => theme.radius.huge};
  padding: 0.7rem 1.6rem;
  cursor: pointer;

  :hover {
    background-color: ${({ theme }) => theme.colors.primary.main};
    color: rgba(21, 28, 43, 1);
  }

  ${({ suggestionIndex, actionTaken }) => {
    const delay = suggestionIndex * 0.2;
    if (actionTaken === 'selected') {
        return styled.css `
        cursor: default;
        animation: ${selectedAnimation} ${TRANSITION_DURATION$1}s ease-out 0s 1 normal forwards;
      `;
    }
    if (actionTaken === 'unselected') {
        return styled.css `
        cursor: default;
        animation: ${unselectedAnimation} ${TRANSITION_DURATION$1}s ease-out 0s 1 normal forwards;
      `;
    }
    return styled.css `
      animation: ${suggestionAnimation} ${TRANSITION_DURATION$1}s ease-out ${delay}s 1 normal forwards;
    `;
}}
`;

const PreCodeBlock = ({ children }) => {
    const [isCopied, setIsCopied] = React.useState(false);
    const copyToClipboard = async () => {
        const codeText = children.props.children;
        const trimmedCode = codeText
            .split('\n')
            .map((line) => line.trimEnd())
            .join('\n')
            .trim();
        await navigator.clipboard.writeText(trimmedCode);
        window.dispatchEvent(new Event('copy'));
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 500);
    };
    return (jsxRuntime.exports.jsxs(StyledCodeBox, { children: [jsxRuntime.exports.jsx("pre", { style: { whiteSpace: 'pre-wrap', wordBreak: 'break-word' }, children: children }), jsxRuntime.exports.jsx(StyledCodeCopy, { onClick: () => {
                    copyToClipboard().catch(console.error);
                }, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: isCopied ? faCopy : faCopy$1, "data-testid": "copy-to-clipboard-icon" }) })] }));
};
const markdownComponents = {
    a: (props) => (jsxRuntime.exports.jsx("a", { href: props.href, target: "_blank", rel: "noreferrer", children: props.children })),
    pre(props) {
        return jsxRuntime.exports.jsx(PreCodeBlock, { children: props.children });
    },
    code(props) {
        return jsxRuntime.exports.jsx("code", { style: { whiteSpace: 'pre-wrap', wordBreak: 'break-word' }, children: props.children });
    },
};
const ChatBubble = ({ chatMessage, persona, handleMessageVoting, onSuggestionClick, shouldAnimate, isMostRecentSystemMessage, areActionsDisabled, askEchoPrompt, isVotingDisabled, }) => {
    const isUsersMessage = chatMessage.sender === exports.Sender.USER;
    const [isHovering, setIsHovering] = React.useState(false);
    const [userActions, setUserActions] = React.useState([]);
    const [actionSelected, setActionSelected] = React.useState(false);
    const areSuggestionsValid = !chatMessage.suggestions || !('valid' in chatMessage.suggestions) || chatMessage.suggestions.valid;
    React.useEffect(() => {
        const { suggestions } = chatMessage;
        if (!suggestions) {
            setUserActions([]);
            return;
        }
        let suggestionList = [];
        if ('list' in suggestions) {
            suggestionList = suggestions.list || [];
        }
        else if (Array.isArray(suggestions)) {
            suggestionList = suggestions;
        }
        setUserActions(suggestionList.map((s) => ({ suggestion: s })));
    }, [chatMessage]);
    const handleSuggestionClick = (suggestion) => {
        setUserActions((prevState) => {
            const newState = [...prevState];
            return newState.map((p) => {
                if (p.suggestion === suggestion) {
                    return { ...p, actionTaken: 'selected' };
                }
                return { ...p, actionTaken: 'unselected' };
            });
        });
        setActionSelected(true);
        onSuggestionClick(suggestion);
    };
    if (isUsersMessage) {
        return (jsxRuntime.exports.jsx(StyledChatBubble, { "$isUsersMessage": isUsersMessage, "data-testid": `message-${chatMessage.id}`, children: jsxRuntime.exports.jsx(StyledChatTextRow, { "$isUsersMessage": isUsersMessage, children: jsxRuntime.exports.jsx(StyledUserMessage, { "$isUsersMessage": isUsersMessage, "$shouldAnimate": shouldAnimate, "$isAskEcho": chatMessage.type === 'ask-echo', children: chatMessage.type === 'ask-echo' && askEchoPrompt ? (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [askEchoPrompt, jsxRuntime.exports.jsx("span", { "data-testid": `ask-echo-message-${chatMessage.id}`, children: chatMessage.message })] })) : (chatMessage.message) }) }) }));
    }
    return (jsxRuntime.exports.jsxs(StyledChatBubble, { "$isUsersMessage": isUsersMessage, "data-testid": `message-${chatMessage.id}`, children: [persona && (jsxRuntime.exports.jsxs(StyledPersona, { "$shouldAnimate": shouldAnimate, children: [jsxRuntime.exports.jsx(Avatar, { avatarSrc: persona?.imgUrl, size: "2.4rem", hasBorder: false, isCursorPointer: false, hasBackground: false, isSquare: true }), persona?.name, chatMessage.sender === exports.Sender.NUDGE && (jsxRuntime.exports.jsx(SmallTooltipWrapper, { id: "nudge-message-label", tooltipText: "This message was generated based on your behaviour in the room.", position: "top", children: jsxRuntime.exports.jsx(StyledPill$1, { children: "Smart suggestion" }) })), chatMessage.sender === exports.Sender.SYSTEM && chatMessage.type === 'hint' && (jsxRuntime.exports.jsx(SmallTooltipWrapper, { id: "hint-message-label", tooltipText: "This message is a hint to help you solve the question.", position: "top", children: jsxRuntime.exports.jsx(StyledPill$1, { children: "Hint" }) }))] })), jsxRuntime.exports.jsxs(StyledChatTextRow, { "$isUsersMessage": isUsersMessage, onMouseEnter: () => setIsHovering(true), onMouseLeave: () => setIsHovering(false), children: [jsxRuntime.exports.jsx(StyledSystemMessage, { "$shouldAnimate": shouldAnimate, children: jsxRuntime.exports.jsx(Markdown, { components: markdownComponents, children: chatMessage.message }) }), !isVotingDisabled && (jsxRuntime.exports.jsx(StyleVotingRow, { "$shouldAnimate": isHovering, onMouseEnter: () => setIsHovering(true), onMouseLeave: () => setIsHovering(false), children: jsxRuntime.exports.jsxs(StyledVotingOptions, { children: [jsxRuntime.exports.jsx(StyledUpVoteIcon, { "data-testid": "message-up-vote", onClick: () => handleMessageVoting(1, chatMessage.id), icon: faThumbsUp, "$vote": chatMessage.vote, "$shouldAnimate": isHovering }), jsxRuntime.exports.jsx(StyledDownVoteIcon, { "data-testid": "message-down-vote", onClick: () => handleMessageVoting(-1, chatMessage.id), icon: faThumbsDown, "$vote": chatMessage.vote, "$shouldAnimate": isHovering })] }) }))] }), isMostRecentSystemMessage && !areActionsDisabled && areSuggestionsValid && userActions.length > 0 && (jsxRuntime.exports.jsx(StyledUserActionsWrapper, { "$actionSelected": actionSelected, children: jsxRuntime.exports.jsx(StyledUserActions, { children: userActions?.map((btn, index) => (jsxRuntime.exports.jsx(StyledUserAction, { "data-testid": "suggestion", onClick: () => !btn.actionTaken && handleSuggestionClick(btn.suggestion), suggestionIndex: index, actionTaken: btn.actionTaken, children: btn.suggestion }, `suggestion-${btn.suggestion.toLowerCase()}`))) }) }))] }));
};

const DEFAULT_TUTOR_LANDING_PAGE_URL = `/r/echo`;

const StyledChatHeader = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  gap: 1.2rem;
  background-color: ${({ theme }) => theme.colors.secondary.main};
  border-radius: ${({ $isEmbedded }) => ($isEmbedded ? '0' : '0.6rem 0.6rem 0 0')};
  color: ${({ theme }) => theme.colors.text.invert};
  padding: 1.6rem;
  justify-content: space-between;
  align-items: center;
`;
const StyledHeaderContent = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
`;
const StyledHeaderText = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;
const StyledNameRow = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
`;
const StyledHeaderName = styled__default["default"].div `
  font-weight: 700;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.white};
  line-height: 1.8rem;
`;
const StyledPill = styled__default["default"].div `
  padding: 2px 10px 2px 10px;
  border-radius: 1rem 1rem 1rem 1rem;
  background-color: rgba(45, 61, 95, 1);
  color: rgba(113, 156, 249, 1);
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  line-height: 1.4rem;
  cursor: pointer;
`;
const StyledStrapLine = styled__default["default"].div `
  line-height: ${({ $isEmbedded }) => ($isEmbedded ? '1.8rem' : '2rem')};
  font-size: ${({ theme, $isEmbedded }) => ($isEmbedded ? theme.fonts.sizes.tiny : theme.fonts.sizes.small)};
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
`;
const StyledActions = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: flex-end;
`;
const StyledLink$4 = styled__default["default"].a `
  cursor: pointer;
`;

const ChatHeader = ({ persona, options, landingPageUrl = DEFAULT_TUTOR_LANDING_PAGE_URL, isBeta, handleHover, isEmbedded = false, }) => {
    const headerRef = React.useRef(null);
    React.useLayoutEffect(() => {
        const updateHeaderHeight = () => {
            if (headerRef.current) {
                const height = headerRef.current.offsetHeight;
                document.documentElement.style.setProperty('--chat-header-height', `${height}px`);
            }
        };
        updateHeaderHeight();
        const resizeObserver = new ResizeObserver(updateHeaderHeight);
        if (headerRef.current) {
            resizeObserver.observe(headerRef.current);
        }
        return () => {
            resizeObserver.disconnect();
        };
    }, []);
    return (jsxRuntime.exports.jsxs(StyledChatHeader, { ref: headerRef, "data-testid": "chat-header-container", className: "tutor-drag-handle", onMouseEnter: () => handleHover('enter'), onMouseLeave: () => handleHover('leave'), "$isEmbedded": isEmbedded, children: [jsxRuntime.exports.jsxs(StyledHeaderContent, { children: [jsxRuntime.exports.jsx(StyledLink$4, { href: landingPageUrl, target: "_blank", rel: "noreferrer", "data-testid": "chat-header-avatar-container", onMouseEnter: () => handleHover('leave'), onMouseLeave: () => handleHover('enter'), children: jsxRuntime.exports.jsx(Avatar, { avatarSrc: persona.imgUrl, size: "4rem", isCursorPointer: true, isSquare: true, hasBorder: false, hasBackground: false, title: persona?.name ?? 'Echo' }) }), jsxRuntime.exports.jsxs(StyledHeaderText, { children: [jsxRuntime.exports.jsxs(StyledNameRow, { children: [jsxRuntime.exports.jsx(StyledHeaderName, { children: persona.name }), isBeta && (jsxRuntime.exports.jsx(SmallTooltipWrapper, { id: "beta-pill", tooltipText: "This feature is free to use while we are in beta.", position: "top", children: jsxRuntime.exports.jsx(StyledPill, { children: "Beta" }) }))] }), jsxRuntime.exports.jsx(StyledStrapLine, { "$isEmbedded": isEmbedded, children: "Powered by AI" })] })] }), jsxRuntime.exports.jsx(StyledActions, { children: options &&
                    options.map((option) => option.subOptions && option.subOptions.length > 0 ? (jsxRuntime.exports.jsx(DropdownMenu, { triggerBtn: jsxRuntime.exports.jsx("button", { type: "button", onMouseEnter: () => handleHover('leave'), onMouseLeave: () => handleHover('enter'), children: jsxRuntime.exports.jsx(SmallTooltipWrapper, { id: option.id, tooltipText: option.label, onClick: option.onClick, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: option.icon.name, rotation: option.icon.rotation }) }) }), sideOffset: 12, alignContent: "center", type: "tutor", children: React.Children.toArray(option.subOptions.map((subOption) => (jsxRuntime.exports.jsx(DropdownMenuItem, { onSelect: () => {
                                subOption.onClick();
                            }, "data-testid": subOption.id, onMouseEnter: () => handleHover('leave'), onMouseLeave: () => handleHover('enter'), children: jsxRuntime.exports.jsx(DropdownMenuItemContent, { icon: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: subOption.icon.name, rotation: subOption.icon.rotation }), title: subOption.label, type: "tutor" }) }, subOption.id)))) }, option.id)) : (jsxRuntime.exports.jsx(SmallTooltipWrapper, { id: option.id, tooltipText: option.label, onClick: option.onClick, styles: { cursor: 'pointer' }, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: option.icon.name, rotation: option.icon.rotation, onMouseEnter: () => handleHover('leave'), onMouseLeave: () => handleHover('enter') }) }, option.id))) })] }));
};

const defaultAnimation = styled.keyframes `
    25% {
        transform: translate(0, -10px);
    }
    75% {
        transform: translate(0, 10px);
    }
`;
const bounceAnimation = styled.keyframes `
    0% {
        transform: translateY(-15px);
    }
    25% {
        opacity: 1;
        transform: translateY(10px);
    }
    40% {
        transform: translateY(0);
    }
    55% {
        transform: translateY(10px);
    }
    65% {
        transform: translateY(6px);
    }
    75% {
        transform: translateY(10px);
    }
    82% {
        transform: translateY(8px);
    }
    87% {
        transform: translateY(10px);
    }
    93% {
        opacity: 1;
        transform: translateY(10px);
    }
    100% {
        opacity: 0;
        transform: translateY(10px);
    }
`;
const waveAnimation = styled.keyframes `
    0% {
        transform: translateY(0);
    }
    15% {
        transform: translateY(-8px);
    }
    20% {
        transform: translateY(-9px);
    }
    25% {
        transform: translateY(-10px);
    }
    30% {
        transform: translateY(-9px);
    }
    35% {
        transform: translateY(-8px);
    }
    65% {
        transform: translateY(8px);
    }
    70% {
        transform: translateY(9px);
    }
    75% {
        transform: translateY(10px);
    }
    80% {
        transform: translateY(9px);
    }
    85% {
        transform: translateY(8px);
    }
    100% {
        transform: translateY(0);
    }
`;
const pulseAnimation = styled.keyframes `
    0% {
        height: 1rem;
    }
    4% {
        height: 0.9rem;
    }
    8% {
        height: 0.8rem;
    }
    42% {
        height: 0.2rem;
    }
    48% {
        height: 0.1rem;
        opacity: 1;
    }
    50% {
        height: 0;
        opacity: 0;
    }
    54% {
        opacity: 1;
        height: 0.1rem;
    }
    58% {
        height: 0.2rem;
    }
    90% {
        height: 0.8rem;
    }
    95% {
        height: 0.9rem;
    }
    100% {
        height: 1rem;
    }
`;
const Circle = styled__default["default"].div `
  height: 1rem;
  width: 1rem;
  border-radius: 50%;
  background-color: rgba(82, 90, 106, 1);
  ${({ $type }) => {
    switch ($type) {
        case 'bounce': {
            return styled.css `
          opacity: 0;
          animation-name: ${bounceAnimation};
        `;
        }
        case 'wave': {
            return styled.css `
          animation-name: ${waveAnimation};
        `;
        }
        case 'pulse': {
            return styled.css `
          animation-name: ${pulseAnimation};
        `;
        }
        default: {
            return styled.css `
          animation-name: ${defaultAnimation};
        `;
        }
    }
}}

  animation-duration: ${({ $duration }) => $duration}s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-direction: forwards;
`;
const Container = styled__default["default"].div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 0.4rem;
  min-height: 4rem;
  height: 4rem;
  border-radius: 100px;
  padding-left: 1.6rem;
  padding-right: 1.6rem;
  background-color: rgba(33, 44, 66, 1);
  width: fit-content;

  div:nth-child(1) {
    ${({ $type }) => {
    switch ($type) {
        case 'bounce': {
            return styled.css `
            animation-delay: 0s;
          `;
        }
        case 'wave': {
            return styled.css `
            animation-delay: 0s;
          `;
        }
        default: {
            return styled.css `
            animation-delay: -1.5s;
          `;
        }
    }
}}
  }

  div:nth-child(2) {
    ${({ $type }) => {
    switch ($type) {
        case 'bounce': {
            return styled.css `
            animation-delay: 0.66s;
          `;
        }
        case 'wave': {
            return styled.css `
            animation-delay: 0.2s;
          `;
        }
        default: {
            return styled.css `
            animation-delay: -1.2s;
          `;
        }
    }
}}
  }

  div:nth-child(3) {
    ${({ $type }) => {
    switch ($type) {
        case 'bounce': {
            return styled.css `
            animation-delay: 1.32s;
          `;
        }
        case 'wave': {
            return styled.css `
            animation-delay: 0.4s;
          `;
        }
        default: {
            return styled.css `
            animation-delay: -0.9s;
          `;
        }
    }
}}
  }
`;

const ChatLoader = ({ $type, $duration = 2 }) => (jsxRuntime.exports.jsxs(Container, { "$type": $type, "data-testid": "chat-loader", children: [jsxRuntime.exports.jsx(Circle, { "$type": $type, "$duration": $duration }), jsxRuntime.exports.jsx(Circle, { "$type": $type, "$duration": $duration }), jsxRuntime.exports.jsx(Circle, { "$type": $type, "$duration": $duration })] }));

const REM_BASE = 10;
const remToPx = (rem) => {
    return Number.parseFloat(rem) * REM_BASE;
};
const pxToRem = (px) => {
    return `${px / REM_BASE}rem`;
};
const CHAT_BUTTON_SIZE = '6.4rem';
const CHAT_BUTTON_FONT_SIZE = '2.3rem';
const DESCRIPTION_WIDTH = '42rem';
const DESCRIPTION_MAX_WIDTH = '44rem';
const DESCRIPTION_PADDING = '1.6rem';
const DESCRIPTION_BORDER_RADIUS_EXPANDED = '0.5rem';
const DESCRIPTION_CIRCLE_SIZE = '3.6rem';
const DESCRIPTION_CIRCLE_RADIUS = '50%';
const DESCRIPTION_MIN_HEIGHT = '7.4rem';
const DESCRIPTION_MAX_HEIGHT = '15rem';
const DESCRIPTION_DEFAULT_HEIGHT = '7.4rem';
const DESCRIPTION_MIN_HEIGHT_PX = remToPx(DESCRIPTION_MIN_HEIGHT);
const DESCRIPTION_MAX_HEIGHT_PX = remToPx(DESCRIPTION_MAX_HEIGHT);
const DESCRIPTION_BOTTOM_POSITION = '8rem';
const DESCRIPTION_HIDDEN_BOTTOM = '3.2rem';
const RIPPLE_SIZE = '6rem';
const RIPPLE_OPACITY = 0.4;
const ANIMATION_DURATION_FAST = '0.06s';
const ANIMATION_DURATION_NORMAL = '0.15s';
const ANIMATION_DURATION_SLOW = '0.22s';
const ANIMATION_DELAY = '0.25s';
const ANIMATION_EASING_SMOOTH = 'cubic-bezier(0.175, 0.885, 0.32, 1)';
const ANIMATION_EASING_DEFAULT = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
const TEXT_HEIGHT_BUFFER = 4;

const StyledBackGround = styled__default["default"].div `
  position: relative;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;

    ${({ $hasInactiveNudge, $hasEngagementPrompt, $hasActiveNudge }) => $hasInactiveNudge &&
    !$hasEngagementPrompt &&
    !$hasActiveNudge &&
    styled.css `
      &::after {
        content: '';
        width: ${RIPPLE_SIZE};
        height: ${RIPPLE_SIZE};
        position: absolute;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.colors.primary.main};
        opacity: ${RIPPLE_OPACITY};
        animation: ripple 2s infinite ease-in-out;
        z-index: -1;
      }
    `}

  @keyframes ripple {
    0%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.3);
    }
  }
`;
const StyledChatButton = styled__default["default"].button `
  position: relative;
  width: ${CHAT_BUTTON_SIZE};
  height: ${CHAT_BUTTON_SIZE};
  font-size: ${CHAT_BUTTON_FONT_SIZE};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
  transition: all 0.3s ease;
`;
const getEnhancedStyledChatDescriptionStyles = ($animationPhase, $isDarkMode, $targetHeight) => styled.css `
    ${$animationPhase === 'hidden' &&
    styled.css `
      width: 0;
      height: 0;
      opacity: 0;
      z-index: 1;
      bottom: ${DESCRIPTION_HIDDEN_BOTTOM};
      left: 50%;
      transform: translateX(-50%);
      transition: all ${ANIMATION_DURATION_FAST} ${ANIMATION_EASING_DEFAULT};
      padding: 0;
    `}
    
    ${($animationPhase === 'rising' || $animationPhase === 'shrinking') &&
    styled.css `
      width: ${DESCRIPTION_CIRCLE_SIZE};
      height: ${DESCRIPTION_CIRCLE_SIZE};
      border-radius: ${DESCRIPTION_CIRCLE_RADIUS};
      bottom: ${DESCRIPTION_BOTTOM_POSITION};
      left: calc(50% - calc(${DESCRIPTION_CIRCLE_SIZE} / 2));
      opacity: 1;
      z-index: 20;
      transition: all ${ANIMATION_DURATION_NORMAL} ${ANIMATION_EASING_DEFAULT};
      padding: 0;
      overflow: hidden;
    `}
    
    ${$animationPhase === 'expanded' &&
    styled.css `
      width: ${DESCRIPTION_WIDTH};
      max-width: ${DESCRIPTION_MAX_WIDTH};
      height: ${$targetHeight || DESCRIPTION_DEFAULT_HEIGHT};
      border-radius: ${DESCRIPTION_BORDER_RADIUS_EXPANDED};
      bottom: ${DESCRIPTION_BOTTOM_POSITION};
      left: 0;
      opacity: 1;
      z-index: 20;
      padding: ${DESCRIPTION_PADDING};
      transition: 
        width ${ANIMATION_DURATION_SLOW} ${ANIMATION_EASING_SMOOTH},
        left ${ANIMATION_DURATION_SLOW} ${ANIMATION_EASING_SMOOTH},
        height ${ANIMATION_DURATION_SLOW} ${ANIMATION_EASING_SMOOTH},
        border-radius ${ANIMATION_DURATION_NORMAL} ${ANIMATION_EASING_SMOOTH};
      box-shadow: ${$isDarkMode ? '0 0.3rem 1.3rem 0 rgba(21, 28, 43, 0.6)' : '0 0.3rem 1.3rem 0 rgba(21, 28, 43, 0.07)'};
      word-wrap: break-word;
      white-space: normal;
      font-size: ${({ theme }) => theme.fonts.sizes.small};
      overflow-y: auto;
      overflow-x: hidden;
      
      scrollbar-width: thin;
      scrollbar-color: rgba(155, 155, 155, 0.5) transparent;
      
      &::-webkit-scrollbar {
        width: 4px;
      }
      
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      
      &::-webkit-scrollbar-thumb {
        background-color: rgba(155, 155, 155, 0.5);
        border-radius: 2px;
        border: none;
      }
      
      &::-webkit-scrollbar-thumb:hover {
        background-color: rgba(155, 155, 155, 0.8);
      }
    `}
  `;
const StyledChatDescription = styled__default["default"].div `
  position: absolute;
  background-color: ${({ theme }) => theme.colors.secondary.light};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: -1;

   ${({ $animationPhase, $isDarkMode, $targetHeight }) => getEnhancedStyledChatDescriptionStyles($animationPhase, $isDarkMode, $targetHeight)}

  `;
const StyledMessage$1 = styled__default["default"].span `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  opacity: ${({ $animationPhase }) => ($animationPhase === 'expanded' ? 1 : 0)};
  visibility: ${({ $animationPhase }) => ($animationPhase === 'expanded' ? 'visible' : 'hidden')};
  transition: ${({ $animationPhase }) => ($animationPhase === 'expanded' ? `all ${ANIMATION_DURATION_NORMAL} ease ${ANIMATION_DELAY}` : 'opacity 0.05s ease, transform 0.05s ease')};
  transform: ${({ $animationPhase }) => ($animationPhase === 'expanded' ? 'translateY(0)' : 'translateY(1rem)')};
`;
const StyledCloseIcon$2 = styled__default["default"].button `
  position: absolute;
  top: 0.4rem;
  right: 0.4rem;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0.4rem;
  border: none;
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ $animationPhase }) => ($animationPhase === 'expanded' ? 1 : 0)};
  visibility: ${({ $animationPhase }) => ($animationPhase === 'expanded' ? 'visible' : 'hidden')};
  transition: ${({ $animationPhase }) => ($animationPhase === 'expanded' ? `all ${ANIMATION_DURATION_NORMAL} ease ${ANIMATION_DELAY}` : 'opacity 0.05s ease')};
  z-index: 10;

  &:hover {
    background-color: ${({ $isDarkMode }) => ($isDarkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)')};
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }

`;

const calculateTextHeight = (text) => {
    const textElement = document.createElement('div');
    textElement.style.fontSize = '1.4rem';
    textElement.style.fontWeight = '400';
    textElement.style.lineHeight = '1.5';
    textElement.style.whiteSpace = 'normal';
    textElement.style.wordWrap = 'break-word';
    textElement.style.width = DESCRIPTION_WIDTH;
    textElement.style.maxWidth = DESCRIPTION_MAX_WIDTH;
    textElement.style.padding = DESCRIPTION_PADDING;
    textElement.style.position = 'absolute';
    textElement.style.visibility = 'hidden';
    textElement.style.top = '-9999px';
    textElement.innerHTML = text;
    document.body.appendChild(textElement);
    const height = textElement.offsetHeight;
    document.body.removeChild(textElement);
    return height + TEXT_HEIGHT_BUFFER;
};
const ChatButton = ({ className, onClick, onHover, onCloseNudge, hasActiveNudge, hasInactiveNudge, nudgeMessage, hasEngagementPrompt = false, engagementPromptMessage, persona = {
    name: 'Hackassist',
    imgUrl: 'https://assets.tryhackme.com/img/logo/tryhackme_logo_full.svg',
}, isDarkMode = true, avatarComponent, }) => {
    const [isHovering, setIsHovering] = React.useState(false);
    const [animationPhase, setAnimationPhase] = React.useState('hidden');
    const timeoutRef = React.useRef(null);
    const containerRef = React.useRef(null);
    const showEngagementPrompt = !hasActiveNudge && (hasEngagementPrompt || isHovering);
    React.useEffect(() => {
        if (timeoutRef.current)
            clearTimeout(timeoutRef.current);
        if (showEngagementPrompt || hasActiveNudge) {
            setAnimationPhase('rising');
            timeoutRef.current = setTimeout(() => {
                setAnimationPhase('expanded');
            }, 220);
        }
        else {
            setAnimationPhase((prevPhase) => {
                if (prevPhase === 'expanded' || prevPhase === 'rising') {
                    timeoutRef.current = setTimeout(() => {
                        setAnimationPhase('hidden');
                    }, 220);
                    return 'shrinking';
                }
                return 'hidden';
            });
        }
        return () => {
            if (timeoutRef.current)
                clearTimeout(timeoutRef.current);
        };
    }, [showEngagementPrompt, hasActiveNudge]);
    const handleHover = () => {
        setIsHovering(true);
        onHover?.();
    };
    const handleLeave = () => {
        setIsHovering(false);
    };
    const handleCloseClick = React.useCallback((e) => {
        e.stopPropagation();
        onCloseNudge?.();
    }, [onCloseNudge]);
    React.useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current &&
                !containerRef.current.contains(event.target) &&
                (hasActiveNudge || showEngagementPrompt)) {
                onCloseNudge?.();
            }
        };
        if (hasActiveNudge || showEngagementPrompt) {
            const timeoutId = setTimeout(() => {
                document.addEventListener('mousedown', handleClickOutside);
            }, 100);
            return () => {
                clearTimeout(timeoutId);
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }
        return undefined;
    }, [hasActiveNudge, showEngagementPrompt, onCloseNudge]);
    const [targetHeight, setTargetHeight] = React.useState(pxToRem(DESCRIPTION_MIN_HEIGHT_PX));
    React.useEffect(() => {
        const textContent = hasActiveNudge ? nudgeMessage : engagementPromptMessage;
        if (textContent) {
            const estimatedHeightPx = calculateTextHeight(textContent);
            const clampedHeightPx = Math.min(Math.max(estimatedHeightPx, DESCRIPTION_MIN_HEIGHT_PX), DESCRIPTION_MAX_HEIGHT_PX);
            const newTargetHeight = pxToRem(clampedHeightPx);
            setTargetHeight(newTargetHeight);
        }
        else {
            setTargetHeight(pxToRem(DESCRIPTION_MIN_HEIGHT_PX));
        }
    }, [nudgeMessage, engagementPromptMessage, hasActiveNudge]);
    return (jsxRuntime.exports.jsxs(StyledBackGround, { ref: containerRef, className: className, "data-testid": "chat-button-background", "$hasInactiveNudge": hasInactiveNudge, "$hasActiveNudge": hasActiveNudge, "$hasEngagementPrompt": showEngagementPrompt, children: [jsxRuntime.exports.jsx(StyledChatButton, { onClick: onClick, onMouseEnter: handleHover, onMouseLeave: handleLeave, "$hasActiveNudge": hasActiveNudge, "$hasInactiveNudge": hasInactiveNudge, "$hasEngagementPrompt": showEngagementPrompt, "$isDarkMode": isDarkMode, "data-testid": "chat-button-icon", children: avatarComponent ?? (jsxRuntime.exports.jsx(Avatar, { avatarSrc: persona?.imgUrl, hasBorder: false, title: persona?.name ?? 'Echo', size: CHAT_BUTTON_SIZE, mobileSize: CHAT_BUTTON_SIZE, isSquare: true, hasBackground: false, showLoadingImage: false })) }), jsxRuntime.exports.jsxs(StyledChatDescription, { "$animationPhase": animationPhase, "$isDarkMode": isDarkMode, "data-testid": "chat-button-description", onClick: onClick, "$targetHeight": targetHeight, children: [jsxRuntime.exports.jsx(StyledMessage$1, { "$animationPhase": animationPhase, children: hasActiveNudge ? nudgeMessage : engagementPromptMessage }), (hasActiveNudge || showEngagementPrompt) && onCloseNudge && (jsxRuntime.exports.jsx(StyledCloseIcon$2, { "$animationPhase": animationPhase, "$isDarkMode": isDarkMode, onClick: handleCloseClick, "data-testid": "chat-button-close", "aria-label": "Close message", children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faXmark$2 }) }))] })] }));
};

var e,t=(e=React__default["default"])&&"object"==typeof e&&"default"in e?e.default:e;var reactCountdownHook=function(e,r){void 0===e&&(e=6e4),void 0===r&&(r=1e3);var n=t.useState(0),u=n[0],c=n[1],a=t.useRef({}),i=function e(t){a.current.started||(a.current.started=t,a.current.lastInterval=t);var n=Math.min(r,a.current.timeLeft||Infinity);t-a.current.lastInterval>=n&&(a.current.lastInterval+=n,c(function(e){return a.current.timeLeft=e-n,a.current.timeLeft})),t-a.current.started<a.current.timeToCount?a.current.requestId=window.requestAnimationFrame(e):(a.current={},c(0));},o=t.useCallback(function(t){window.cancelAnimationFrame(a.current.requestId);var r=void 0!==t?t:e;a.current.started=null,a.current.lastInterval=null,a.current.timeToCount=r,a.current.requestId=window.requestAnimationFrame(i),c(r);},[]),s=t.useCallback(function(){window.cancelAnimationFrame(a.current.requestId),a.current.started=null,a.current.lastInterval=null,a.current.timeToCount=a.current.timeLeft;},[]),l=t.useCallback(function(){!a.current.started&&a.current.timeLeft>0&&(window.cancelAnimationFrame(a.current.requestId),a.current.requestId=window.requestAnimationFrame(i));},[]),m=t.useCallback(function(){a.current.timeLeft&&(window.cancelAnimationFrame(a.current.requestId),a.current={},c(0));},[]),d=t.useMemo(function(){return {start:o,pause:s,resume:l,reset:m}},[]);return t.useEffect(function(){return function(){return window.cancelAnimationFrame(a.current.requestId)}},[]),[u,d]};

const StyledErrorWrapper = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
const StyledErrorMessage = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.2rem;
  padding: 1.2rem 1.6rem;
  background-color: ${otherColors.red2['10']};
  border: solid 1px ${accentColors.error.dark};
  border-radius: ${({ theme }) => theme.radius.small};
`;
const StyledErrorIcon = styled__default["default"].div `
  font-size: 2rem;
  color: ${accentColors.error.dark};
`;
const StyledErrorText$1 = styled__default["default"].div `
  display: inline-block;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.grey['100']};
`;
const StyledErrorAction = styled__default["default"](Button$1) `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.grey['100']};
  width: fit-content;
`;

const ChatError = ({ message, disableAction, onActionClick, actionText, actionIcon, enableActionAfterNSeconds, }) => {
    const [disabled, setDisabled] = React.useState(disableAction ?? false);
    const [countdown, { start: startCountdown, reset: resetCountdown }] = reactCountdownHook(0, 1000);
    const [countdownText, setCountdownText] = React.useState('');
    React.useEffect(() => {
        if (enableActionAfterNSeconds && enableActionAfterNSeconds > 0) {
            startCountdown(enableActionAfterNSeconds * 1000);
        }
    }, [enableActionAfterNSeconds, startCountdown]);
    React.useEffect(() => {
        if (enableActionAfterNSeconds) {
            if (countdown === 0) {
                setCountdownText('');
                setDisabled(false);
                resetCountdown();
            }
            else {
                setCountdownText(` in ${countdown / 1000}s`);
                setDisabled(true);
            }
        }
    }, [countdown, enableActionAfterNSeconds, resetCountdown]);
    return (jsxRuntime.exports.jsxs(StyledErrorWrapper, { children: [jsxRuntime.exports.jsxs(StyledErrorMessage, { children: [jsxRuntime.exports.jsx(StyledErrorIcon, { children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCircleExclamation }) }), jsxRuntime.exports.jsx(StyledErrorText$1, { "data-testid": "chat-error-message", children: message })] }), jsxRuntime.exports.jsxs(StyledErrorAction, { isDisabled: disabled, onClick: onActionClick, variant: "outlined", color: "secondary", size: "default", "data-testid": "chat-error-action", children: [actionIcon && jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: actionIcon, "data-testid": "action-icon" }), actionText, enableActionAfterNSeconds && countdownText] })] }));
};

const LEFT = "Left";
const RIGHT = "Right";
const UP = "Up";
const DOWN = "Down";

/* global document */
const defaultProps = {
    delta: 10,
    preventScrollOnSwipe: false,
    rotationAngle: 0,
    trackMouse: false,
    trackTouch: true,
    swipeDuration: Infinity,
    touchEventOptions: { passive: true },
};
const initialState = {
    first: true,
    initial: [0, 0],
    start: 0,
    swiping: false,
    xy: [0, 0],
};
const mouseMove = "mousemove";
const mouseUp = "mouseup";
const touchEnd = "touchend";
const touchMove = "touchmove";
const touchStart = "touchstart";
function getDirection(absX, absY, deltaX, deltaY) {
    if (absX > absY) {
        if (deltaX > 0) {
            return RIGHT;
        }
        return LEFT;
    }
    else if (deltaY > 0) {
        return DOWN;
    }
    return UP;
}
function rotateXYByAngle(pos, angle) {
    if (angle === 0)
        return pos;
    const angleInRadians = (Math.PI / 180) * angle;
    const x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
    const y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
    return [x, y];
}
function getHandlers(set, handlerProps) {
    const onStart = (event) => {
        const isTouch = "touches" in event;
        // if more than a single touch don't track, for now...
        if (isTouch && event.touches.length > 1)
            return;
        set((state, props) => {
            // setup mouse listeners on document to track swipe since swipe can leave container
            if (props.trackMouse && !isTouch) {
                document.addEventListener(mouseMove, onMove);
                document.addEventListener(mouseUp, onUp);
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            props.onTouchStartOrOnMouseDown &&
                props.onTouchStartOrOnMouseDown({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { initial: xy.slice(), xy, start: event.timeStamp || 0 });
        });
    };
    const onMove = (event) => {
        set((state, props) => {
            const isTouch = "touches" in event;
            // Discount a swipe if additional touches are present after
            // a swipe has started.
            if (isTouch && event.touches.length > 1) {
                return state;
            }
            // if swipe has exceeded duration stop tracking
            if (event.timeStamp - state.start > props.swipeDuration) {
                return state.swiping ? Object.assign(Object.assign({}, state), { swiping: false }) : state;
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const [x, y] = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            const deltaX = x - state.xy[0];
            const deltaY = y - state.xy[1];
            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);
            const time = (event.timeStamp || 0) - state.start;
            const velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
            const vxvy = [deltaX / (time || 1), deltaY / (time || 1)];
            const dir = getDirection(absX, absY, deltaX, deltaY);
            // if swipe is under delta and we have not started to track a swipe: skip update
            const delta = typeof props.delta === "number"
                ? props.delta
                : props.delta[dir.toLowerCase()] ||
                    defaultProps.delta;
            if (absX < delta && absY < delta && !state.swiping)
                return state;
            const eventData = {
                absX,
                absY,
                deltaX,
                deltaY,
                dir,
                event,
                first: state.first,
                initial: state.initial,
                velocity,
                vxvy,
            };
            // call onSwipeStart if present and is first swipe event
            eventData.first && props.onSwipeStart && props.onSwipeStart(eventData);
            // call onSwiping if present
            props.onSwiping && props.onSwiping(eventData);
            // track if a swipe is cancelable (handler for swiping or swiped(dir) exists)
            // so we can call preventDefault if needed
            let cancelablePageSwipe = false;
            if (props.onSwiping ||
                props.onSwiped ||
                props[`onSwiped${dir}`]) {
                cancelablePageSwipe = true;
            }
            if (cancelablePageSwipe &&
                props.preventScrollOnSwipe &&
                props.trackTouch &&
                event.cancelable) {
                event.preventDefault();
            }
            return Object.assign(Object.assign({}, state), { 
                // first is now always false
                first: false, eventData, swiping: true });
        });
    };
    const onEnd = (event) => {
        set((state, props) => {
            let eventData;
            if (state.swiping && state.eventData) {
                // if swipe is less than duration fire swiped callbacks
                if (event.timeStamp - state.start < props.swipeDuration) {
                    eventData = Object.assign(Object.assign({}, state.eventData), { event });
                    props.onSwiped && props.onSwiped(eventData);
                    const onSwipedDir = props[`onSwiped${eventData.dir}`];
                    onSwipedDir && onSwipedDir(eventData);
                }
            }
            else {
                props.onTap && props.onTap({ event });
            }
            props.onTouchEndOrOnMouseUp && props.onTouchEndOrOnMouseUp({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { eventData });
        });
    };
    const cleanUpMouse = () => {
        // safe to just call removeEventListener
        document.removeEventListener(mouseMove, onMove);
        document.removeEventListener(mouseUp, onUp);
    };
    const onUp = (e) => {
        cleanUpMouse();
        onEnd(e);
    };
    /**
     * The value of passive on touchMove depends on `preventScrollOnSwipe`:
     * - true => { passive: false }
     * - false => { passive: true } // Default
     *
     * NOTE: When preventScrollOnSwipe is true, we attempt to call preventDefault to prevent scroll.
     *
     * props.touchEventOptions can also be set for all touch event listeners,
     * but for `touchmove` specifically when `preventScrollOnSwipe` it will
     * supersede and force passive to false.
     *
     */
    const attachTouch = (el, props) => {
        let cleanup = () => { };
        if (el && el.addEventListener) {
            const baseOptions = Object.assign(Object.assign({}, defaultProps.touchEventOptions), props.touchEventOptions);
            // attach touch event listeners and handlers
            const tls = [
                [touchStart, onStart, baseOptions],
                // preventScrollOnSwipe option supersedes touchEventOptions.passive
                [
                    touchMove,
                    onMove,
                    Object.assign(Object.assign({}, baseOptions), (props.preventScrollOnSwipe ? { passive: false } : {})),
                ],
                [touchEnd, onEnd, baseOptions],
            ];
            tls.forEach(([e, h, o]) => el.addEventListener(e, h, o));
            // return properly scoped cleanup method for removing listeners, options not required
            cleanup = () => tls.forEach(([e, h]) => el.removeEventListener(e, h));
        }
        return cleanup;
    };
    const onRef = (el) => {
        // "inline" ref functions are called twice on render, once with null then again with DOM element
        // ignore null here
        if (el === null)
            return;
        set((state, props) => {
            // if the same DOM el as previous just return state
            if (state.el === el)
                return state;
            const addState = {};
            // if new DOM el clean up old DOM and reset cleanUpTouch
            if (state.el && state.el !== el && state.cleanUpTouch) {
                state.cleanUpTouch();
                addState.cleanUpTouch = void 0;
            }
            // only attach if we want to track touch
            if (props.trackTouch && el) {
                addState.cleanUpTouch = attachTouch(el, props);
            }
            // store event attached DOM el for comparison, clean up, and re-attachment
            return Object.assign(Object.assign(Object.assign({}, state), { el }), addState);
        });
    };
    // set ref callback to attach touch event listeners
    const output = {
        ref: onRef,
    };
    // if track mouse attach mouse down listener
    if (handlerProps.trackMouse) {
        output.onMouseDown = onStart;
    }
    return [output, attachTouch];
}
function updateTransientState(state, props, previousProps, attachTouch) {
    // if trackTouch is off or there is no el, then remove handlers if necessary and exit
    if (!props.trackTouch || !state.el) {
        if (state.cleanUpTouch) {
            state.cleanUpTouch();
        }
        return Object.assign(Object.assign({}, state), { cleanUpTouch: undefined });
    }
    // trackTouch is on, so if there are no handlers attached, attach them and exit
    if (!state.cleanUpTouch) {
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    // trackTouch is on and handlers are already attached, so if preventScrollOnSwipe changes value,
    // remove and reattach handlers (this is required to update the passive option when attaching
    // the handlers)
    if (props.preventScrollOnSwipe !== previousProps.preventScrollOnSwipe ||
        props.touchEventOptions.passive !== previousProps.touchEventOptions.passive) {
        state.cleanUpTouch();
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    return state;
}
function useSwipeable(options) {
    const { trackMouse } = options;
    const transientState = React__namespace.useRef(Object.assign({}, initialState));
    const transientProps = React__namespace.useRef(Object.assign({}, defaultProps));
    // track previous rendered props
    const previousProps = React__namespace.useRef(Object.assign({}, transientProps.current));
    previousProps.current = Object.assign({}, transientProps.current);
    // update current render props & defaults
    transientProps.current = Object.assign(Object.assign({}, defaultProps), options);
    // Force defaults for config properties
    let defaultKey;
    for (defaultKey in defaultProps) {
        if (transientProps.current[defaultKey] === void 0) {
            transientProps.current[defaultKey] = defaultProps[defaultKey];
        }
    }
    const [handlers, attachTouch] = React__namespace.useMemo(() => getHandlers((stateSetter) => (transientState.current = stateSetter(transientState.current, transientProps.current)), { trackMouse }), [trackMouse]);
    transientState.current = updateTransientState(transientState.current, transientProps.current, previousProps.current, attachTouch);
    return handlers;
}

const Dot$1 = styled__default["default"].div `
  cursor: pointer;
  height: 0.8rem;
  border-radius: 10rem;
  flex: 1;
  ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth}` : '')};
  ${({ isActive, color, theme, isHighlighted }) => {
    if (isActive) {
        if (color === 'secondary') {
            return styled.css `
          background-color: ${darkColors.secondary.main};
        `;
        }
        return color === 'primary'
            ? styled.css `
            background-color: ${theme.colors.primary.main};
            ${isHighlighted ? 'box-shadow: 0 0 15px 0 rgba(177, 250, 51, 1);' : ''}
          `
            : styled.css `
            background-color: ${theme.colors.info.main};
          `;
    }
    return styled.css `
      background-color: ${isHighlighted ? darkColors.statusTag.grey.background : theme.colors.grey[300]};
    `;
}}
`;
const DotsWrapper = styled__default["default"].div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28.9rem;
  gap: 0.8rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    width: 34.5rem;
  }
`;

const CarouselDots = ({ itemsLength, itemsPerSlide, currentIndex, color = 'default', onDotClick, maxWidth, isHighlighted, }) => (jsxRuntime.exports.jsx(DotsWrapper, { "data-testid": "dots", children: Array.from({ length: Math.ceil(itemsLength / itemsPerSlide) }).map((_, index) => (jsxRuntime.exports.jsx(Dot$1, { "data-testid": `dot-${index}`, isActive: index === Math.ceil(currentIndex / itemsPerSlide), onClick: () => onDotClick(index * itemsPerSlide), color: color, maxWidth: maxWidth, isHighlighted: isHighlighted }, `dot-${index}`))) }));

const slideRight = styled.keyframes `
 from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
`;
const slideLeft = styled.keyframes `
 from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;
const CarouselWrapper = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.4rem;
  overflow: hidden;
  position: relative;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    gap: 4.8rem;
  }
`;
const SlidesWrapper = styled__default["default"].div `
  display: grid;
  align-items: flex-start;
  justify-content: center;
  gap: 2rem;
  width: 100%;
  height: 100%;
  grid-template-columns: ${({ itemsPerSlide }) => `repeat(${itemsPerSlide}, minmax(100px,1fr))`};
`;
const ButtonWrapper = styled__default["default"].div `
  display: none;
  align-items: center;
  justify-content: ${({ type }) => (type === 'back' ? 'flex-end' : 'flex-start')};
  width: auto;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    display: flex;
    padding: 1.9rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    display: flex;
    width: 11.25rem;
  }

  > button {
    ${({ color, theme }) => {
    if (color === 'primary') {
        return styled.css `
          border: 0.1rem solid ${theme.colors.primary.main};

          &:hover:not(:disabled) {
            border: 0.1rem solid ${theme.colors.primary.main};
            background-color: ${theme.colors.primary.light};

            > svg {
              color: ${theme.colors.text.main};
            }
          }
        `;
    }
    if (color === 'secondary') {
        return styled.css `
          border: 0.1rem solid ${darkColors.secondary.main};

          &:hover:not(:disabled) {
            border: 0.1rem solid ${darkColors.secondary.main};
            background-color: ${darkColors.secondary.light};

            > svg {
              color: ${darkColors.text.main};
            }
          }
        `;
    }
    return null;
}}
  }
`;
const Slide = styled__default["default"].div `
  display: flex;
  animation-duration: 1000ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  animation-name: ${({ isLeftToRight }) => (isLeftToRight ? slideRight : slideLeft)};
  width: 100%;
  justify-content: center;
`;
const ContentWrapper = styled__default["default"].div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
const QuoteCarousal = styled__default["default"].div `
  display: grid;
  gap: 2rem;
`;

let intervalId;
let resumeTimer;
const Carousel = ({ items, showBackButton, showNextButton, showDots, itemsPerSlide = 1, color = 'default', buttonSize, isQuoteCarousel = false, loop = false, autoSwipe = false, autoSwipeInterval = 5000, className, isRoundIconButton = false, isHighlighted = false, }) => {
    const [currentIndex, setCurrentIndex] = React.useState(0);
    const [previousIndex, setPreviousIndex] = React.useState(0);
    const [isAutoSwipePaused, setIsAutoSwipePaused] = React.useState(false);
    React.useEffect(() => {
        setCurrentIndex(0);
    }, [showNextButton, showDots, showBackButton, itemsPerSlide, items]);
    const handleSwipe = (delta) => {
        setPreviousIndex(currentIndex);
        const newIndex = currentIndex + delta * itemsPerSlide;
        if (newIndex >= 0 && newIndex <= items.length - itemsPerSlide) {
            setCurrentIndex(newIndex);
        }
        if (newIndex >= 0 && newIndex > items.length - itemsPerSlide) {
            if (loop && currentIndex >= items.length - itemsPerSlide)
                setCurrentIndex(0);
            else
                setCurrentIndex(Math.max(items.length - itemsPerSlide, 0));
        }
        if (newIndex < 0) {
            if (loop && currentIndex === 0)
                setCurrentIndex(items.length - itemsPerSlide);
            else
                setCurrentIndex(0);
        }
    };
    React.useEffect(() => {
        if (intervalId)
            clearInterval(intervalId);
        if (autoSwipe && loop && !isAutoSwipePaused) {
            intervalId = setInterval(() => {
                handleSwipe(1);
            }, autoSwipeInterval);
        }
        return () => {
            if (intervalId)
                clearInterval(intervalId);
        };
    }, [autoSwipe, autoSwipeInterval, items.length, itemsPerSlide, loop, handleSwipe, isAutoSwipePaused]);
    React.useEffect(() => {
        if (resumeTimer)
            clearTimeout(resumeTimer);
        if (autoSwipe && loop && isAutoSwipePaused) {
            resumeTimer = setTimeout(() => {
                setIsAutoSwipePaused(false);
            }, 10_000);
        }
        return () => {
            if (resumeTimer)
                clearTimeout(resumeTimer);
        };
    }, [autoSwipe, isAutoSwipePaused, loop]);
    const handlers = useSwipeable({
        onSwipedLeft: () => handleSwipe(1),
        onSwipedRight: () => handleSwipe(-1),
        delta: 10,
        preventScrollOnSwipe: false,
        trackTouch: true,
        trackMouse: false,
        rotationAngle: 0,
        swipeDuration: Number.POSITIVE_INFINITY,
        touchEventOptions: { passive: true },
    });
    const renderSlides = () => {
        const slides = [];
        for (let i = currentIndex; i < currentIndex + itemsPerSlide; i++) {
            if (items[i]) {
                slides.push(jsxRuntime.exports.jsx(Slide, { isLeftToRight: previousIndex > currentIndex, children: items[i] }, i));
            }
        }
        return slides;
    };
    const renderQuoteSlides = () => {
        const slides = [];
        for (let i = currentIndex; i < currentIndex + itemsPerSlide; i++) {
            if (items?.[i]) {
                const firstElement = items[i];
                const secondElement = items[i];
                slides.push(jsxRuntime.exports.jsx(Slide, { isLeftToRight: previousIndex > currentIndex, children: jsxRuntime.exports.jsxs(QuoteCarousal, { children: [firstElement?.[0], secondElement?.[1]] }) }, i));
            }
        }
        return slides;
    };
    return (jsxRuntime.exports.jsxs(CarouselWrapper, { className: className, children: [jsxRuntime.exports.jsxs(ContentWrapper, { children: [showBackButton && (jsxRuntime.exports.jsx(ButtonWrapper, { type: "back", "data-testid": "back-button-wrapper", color: color, children: jsxRuntime.exports.jsx(IconButton, { "data-testid": "back-button", "aria-label": "back", variant: isRoundIconButton ? 'navigate-round' : 'navigate', onClick: () => {
                                setIsAutoSwipePaused(true);
                                handleSwipe(-1);
                            }, width: buttonSize ?? '4.6rem', height: buttonSize ?? '4.6rem', disabled: !loop && currentIndex === 0, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: isRoundIconButton ? faArrowLeft : faChevronLeft }) }) })), isQuoteCarousel ? (jsxRuntime.exports.jsx(SlidesWrapper, { itemsPerSlide: itemsPerSlide, ...handlers, children: renderQuoteSlides() })) : (jsxRuntime.exports.jsx(SlidesWrapper, { itemsPerSlide: itemsPerSlide, ...handlers, children: renderSlides() })), showNextButton && (jsxRuntime.exports.jsx(ButtonWrapper, { type: "next", "data-testid": "next-button-wrapper", color: color, children: jsxRuntime.exports.jsx(IconButton, { "data-testid": "next-button", "aria-label": "next", variant: isRoundIconButton ? 'navigate-round' : 'navigate', onClick: () => {
                                setIsAutoSwipePaused(true);
                                handleSwipe(1);
                            }, width: buttonSize ?? '4.6rem', height: buttonSize ?? '4.6rem', disabled: !loop && currentIndex >= items.length - itemsPerSlide, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: isRoundIconButton ? faArrowRight : faChevronRight }) }) }))] }), showDots && (jsxRuntime.exports.jsx(CarouselDots, { isHighlighted: isHighlighted, itemsLength: items.length, itemsPerSlide: itemsPerSlide, currentIndex: currentIndex, color: color, onDotClick: (index) => {
                    setIsAutoSwipePaused(true);
                    setCurrentIndex(index);
                }, maxWidth: isRoundIconButton ? '8rem' : undefined }))] }));
};

const CarouselContainer = styled__default["default"].div `
  width: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
`;
const PagesWrapper = styled__default["default"].div `
  display: flex;
  transform: translateX(-${({ currentPage }) => currentPage * 100}%);
  transition: transform 1s ease-in-out;
  will-change: transform;
`;
const PageContainer = styled__default["default"].div `
  width: 100%;
  flex-shrink: 0;
`;
const ItemsContainer = styled__default["default"].div `
  display: flex;
  justify-content: center;
  gap: ${({ gap }) => gap}rem;
`;
const DotsContainer = styled__default["default"].div `
  display: flex;
  justify-content: center;
  gap: 0.6rem;
`;
const Dot = styled__default["default"].button `
  position: relative;
  width: ${({ dotSize }) => dotSize}rem;
  height: ${({ dotSize }) => dotSize}rem;
  border: none;
  border-radius: 50%;
  background: ${({ isActive, theme }) => (isActive ? theme.colors.primary.main : theme.colors.secondary.lighter)};
  cursor: pointer;
  padding: 0;

  // Increase clickable area
  &::before {
    content: '';
    position: absolute;
    transform: translate(-50%, -50%);
    width: calc(100% + 0.6rem);
    height: calc(100% + 0.6rem);
  }
`;

function CarouselFlex({ items, renderItem, getItemKey, itemsPerPage = 1, itemsGap = 1.6, autoPlay = false, autoPlayInterval = 5_000, dotSize = 0.6, }) {
    const [currentPageIndex, setCurrentPageIndex] = React.useState(0);
    const [isAutoPlayPaused, setIsAutoPlayPaused] = React.useState(false);
    const totalPages = Math.ceil(items.length / itemsPerPage);
    const goToPageManually = (pageIndex) => {
        setCurrentPageIndex(Math.max(0, Math.min(pageIndex, totalPages - 1)));
        setIsAutoPlayPaused(true);
    };
    React.useEffect(() => {
        if (!autoPlay || isAutoPlayPaused || totalPages <= 1)
            return;
        const intervalId = setInterval(() => {
            setCurrentPageIndex((prevPage) => (prevPage >= totalPages - 1 ? 0 : prevPage + 1));
        }, autoPlayInterval);
        return () => clearInterval(intervalId);
    }, [autoPlay, autoPlayInterval, isAutoPlayPaused, totalPages]);
    React.useEffect(() => {
        if (currentPageIndex > totalPages - 1) {
            setCurrentPageIndex(Math.max(0, totalPages - 1));
        }
    }, [totalPages, currentPageIndex]);
    const extractKey = (item) => {
        if (getItemKey)
            return getItemKey(item);
        return item._id;
    };
    const pages = [];
    for (let i = 0; i < items.length; i += itemsPerPage) {
        pages.push(items.slice(i, i + itemsPerPage));
    }
    return (jsxRuntime.exports.jsxs(CarouselContainer, { children: [jsxRuntime.exports.jsx(PagesWrapper, { currentPage: currentPageIndex, children: pages.map((pageItems) => {
                    const pageKey = pageItems.map((item) => extractKey(item)).join('-');
                    return (jsxRuntime.exports.jsx(PageContainer, { children: jsxRuntime.exports.jsx(ItemsContainer, { gap: itemsGap, children: pageItems.map((item) => (jsxRuntime.exports.jsx("div", { children: renderItem(item) }, extractKey(item)))) }) }, pageKey));
                }) }), totalPages > 1 && (jsxRuntime.exports.jsx(DotsContainer, { children: pages
                    .map((_, i) => i)
                    .map((pageIndex) => (jsxRuntime.exports.jsx(Dot, { onClick: () => goToPageManually(pageIndex), "aria-label": `Go to page ${pageIndex + 1}`, isActive: pageIndex === currentPageIndex, dotSize: dotSize }, `dot-${pageIndex}`))) }))] }));
}

const StyledWrapper$5 = styled__default["default"].div `
  position: relative;
  height: 3rem;
  display: flex;
  align-items: center;
`;
const StyledImage$2 = styled__default["default"].img `
  height: 100%;
`;
const StyledTooltipWrapper$3 = styled__default["default"].div `
  position: absolute;
  top: -6rem;
  left: 50%;
  transform: translateX(-51%);
  white-space: nowrap;
`;
const StyledTooltipContent = styled__default["default"].div `
  & p,
  & span {
    color: ${({ theme }) => theme.colors.text.main};
  }
`;
const StyledName = styled__default["default"].span `
  text-transform: capitalize;
`;
styled__default["default"].p `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

const CollaboratorWithTooltip = ({ collaborator, isDarkImg = false, }) => {
    const { name, imageLight, imageDark } = collaborator;
    const [isHover, setIsHover] = React.useState(false);
    const { theme } = React.useContext(SwitchThemeContext);
    const isDarkMode = theme === 'dark';
    const image = isDarkImg || isDarkMode ? imageDark : imageLight;
    const handleMouseEnter = React.useCallback(() => setIsHover(true), []);
    const handleMouseLeave = React.useCallback(() => setIsHover(false), []);
    return (jsxRuntime.exports.jsxs(StyledWrapper$5, { "data-testid": "collaborator-wrapper", onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: [jsxRuntime.exports.jsx(StyledImage$2, { "data-testid": "collaborator-image", src: image, alt: `Logo for collaborator ${name ?? ''}` }), isHover && (jsxRuntime.exports.jsx(StyledTooltipWrapper$3, { children: jsxRuntime.exports.jsx(Tooltip, { arrowPosition: "bottom-center", children: jsxRuntime.exports.jsx(StyledTooltipContent, { children: jsxRuntime.exports.jsxs("p", { children: ["Developed in partnership", ' ', name && (jsxRuntime.exports.jsxs("span", { children: ["with ", jsxRuntime.exports.jsx(StyledName, { children: name })] }))] }) }) }) }))] }));
};

const StyledWrapper$4 = styled__default["default"].div `
  height: 3rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`;
styled__default["default"].p `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

const CollaboratorWithTooltipGroup = ({ collaborators, isDarkImg = false, }) => {
    if (collaborators?.length === 0)
        return null;
    return (jsxRuntime.exports.jsx(StyledWrapper$4, { children: collaborators.map((collaborator) => (jsxRuntime.exports.jsx(CollaboratorWithTooltip, { collaborator: collaborator, isDarkImg: isDarkImg }, collaborator._id ?? collaborator.name))) }));
};

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd/MM/yyyy'
};
var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */
var locale = {
  code: 'en-GB',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4
  }
};

const StyledDateTimePickerWrapper$1 = styled__default["default"].div `
  width: ${({ $width }) => $width ?? '100%'};
  display: flex;
  flex-direction: column;
`;
const StyledRightAdornmentIcon$1 = styled__default["default"](FontAwesomeIcon) `
  color: ${({ theme }) => theme.colors.grey[500]};
`;
const StyledCalendarContainer$1 = styled__default["default"](ReactDatePicker.CalendarContainer) `
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  color: ${({ theme }) => theme.colors.text.main};
  border-radius: 0.8rem;
  border-color: ${({ theme }) => theme.colors.border.light};
  background-color: ${({ theme }) => theme.colors.datePicker.background};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item {
    margin-right: 0.4rem;
    border-radius: 0.4rem;
    transition: background-color 0.2s linear, color 0.2s linear;
    padding: 0.8rem 1rem;
    font-size: ${({ theme }) => theme.fonts.sizes.small};
    font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
    line-height: normal;
    width: 9.9rem;
    height: 3.2rem;
    :hover {
      color: ${({ theme }) => theme.colors.text.main};
      background-color: ${({ theme }) => theme.colors.datePicker.buttonHover};
    }

    &--selected {
      background-color: ${({ theme }) => theme.colors.info.main};
      color: ${({ theme }) => theme.colors.text.invert};
    }
  }
  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
    width: 100%;
  }
  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
    /* Has to be !important to override inline style injected by the library 😢 */
    height: 22.4rem !important;
  }
  .react-datepicker {
    &__time {
      background: transparent;
      &-container {
        ${({ $isTimeOnly }) => $isTimeOnly
    ? styled.css `
                margin-left: 0.5rem;
                border-left: none;
                border-radius: ${({ theme }) => theme.radius.small};
              `
    : styled.css `
                border-left: 1px solid ${({ theme }) => theme.colors.border.light};
              `}
        padding: 1rem 0.4rem 1rem 1rem;
        margin-right: 0.5rem;
        background-color: ${({ theme }) => theme.colors.datePicker.background};
        width: auto;
      }
    }
    &__month {
      margin: 0;
      &-container {
        padding: 1rem;
      }
    }
    &-time__header {
      font-size: ${({ theme }) => theme.fonts.sizes.small};
      color: ${({ theme }) => theme.colors.text.main};
      padding: 0.6rem;
      margin-bottom: 0.4rem;
    }
    &__current-month {
      font-size: ${({ theme }) => theme.fonts.sizes.small};
    }
    &__day-names {
      margin-bottom: 0;
    }
    &__day-name {
      padding: 0.8rem 0;
      width: 3.2rem;
      height: 3.2rem;
      text-align: center;
      color: ${({ theme }) => theme.colors.grey[600]};
      margin: 0;
    }
    &__header {
      padding: 0;
      background-color: transparent;
      border: none;
    }
    &__month-text {
      padding: 0.8rem 1rem;
      text-align: center;
      width: auto;
    }
    &__day {
      padding: 0.8rem 0;
      width: 3.2rem;
      height: 3.2rem;
    }
    &__day,
    &__month-text {
      border-radius: 0.4rem;
      margin: 0;
      transition: background-color 0.2s linear, color 0.2s linear, border-radius 0.2s linear;
      line-height: normal;
      color: ${({ theme }) => theme.colors.text.main};
      :hover:not(.react-datepicker__day--selecting-range-start):not(.react-datepicker__day--selecting-range-end) {
        color: ${({ theme }) => theme.colors.text.main};
        background-color: ${({ theme }) => theme.colors.datePicker.buttonHover};
      }

      &--today {
        font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
        color: ${({ theme }) => theme.colors.info.main};
        background-color: ${({ theme }) => theme.colors.info.light};
      }
      &--in-range {
        background-color: ${({ theme }) => theme.colors.datePicker.inRange};
        color: ${({ theme }) => theme.colors.grey[100]};
        :not(.react-datepicker__day--selecting-range-start):not(.react-datepicker__day--selecting-range-end):not(
            .react-datepicker__day--range-start
          ):not(.react-datepicker__day--range-end) {
          border-radius: 0;
        }
      }
      &--in-selecting-range {
        :not(.react-datepicker__day--in-range):not(.react-datepicker__day--selecting-range-start) {
          background-color: ${({ theme }) => theme.colors.grey[200]};
          color: ${({ theme }) => theme.colors.black};
        }
        :not(.react-datepicker__day--selecting-range-start):not(.react-datepicker__day--selecting-range-end) {
          border-radius: 0;
        }
      }
      &--range {
        background-color: ${({ theme }) => theme.colors.info.main};
        color: ${({ theme }) => theme.colors.grey[100]};
        &-start {
          background-color: ${({ theme }) => theme.colors.info.main};
          color: ${({ theme }) => theme.colors.grey[100]};
          :not(.react-datepicker__day--range-end):not(.react-datepicker__day--selecting-range-end) {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
        }
        &-end {
          background-color: ${({ theme }) => theme.colors.info.main};
          color: ${({ theme }) => theme.colors.grey[100]};
          :not(.react-datepicker__day--range-start):not(.react-datepicker__day--selecting-range-start) {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
      }
      &--selecting-range {
        background-color: ${({ theme }) => theme.colors.grey[200]};
        &-start {
          background-color: ${({ theme }) => theme.colors.info.main};
          color: ${({ theme }) => theme.colors.grey[100]};
          :not(.react-datepicker__day--selecting-range-end) {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
        }
        &-end {
          :not(.react-datepicker__day--selecting-range-start) {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
      }
      &--selected {
        :not(.react-datepicker__day--selecting-range-start) {
          color: ${({ theme }) => theme.colors.text.invert};
          background-color: ${({ theme }) => theme.colors.info.main};
        }
      }
      &--outside-month,
      &--disabled,
      &--excluded {
        :not(.react-datepicker__day--in-selecting-range):not(.react-datepicker__day--in-range) {
          color: ${({ theme }) => theme.colors.grey[500]};
        }
      }
    }
  }
`;
const StyledCustomHeader$1 = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const StyledCurrentMonthLabel$1 = styled__default["default"].strong `
  margin: 0 auto;
`;
const StyledMonthNavigationButton$1 = styled__default["default"].button `
  color: ${({ theme }) => theme.colors.text.main};
  border: 1px solid transparent;
  width: 3.2rem;
  height: 3.2rem;
  transition: all 0.2s linear;
  font-size: 1.8rem;
  border-radius: ${({ theme }) => theme.radius.small};
  :hover {
    background-color: ${({ theme }) => theme.colors.white};
    border-color: ${({ theme }) => theme.colors.border.light};
  }
  &:disabled {
    color: ${({ theme }) => theme.colors.grey[600]};
    cursor: not-allowed;
  }
`;

ReactDatePicker.registerLocale('en-GB', locale);
const customHeader$1 = ({ date, decreaseMonth, decreaseYear, increaseMonth, increaseYear, monthDate, nextMonthButtonDisabled, nextYearButtonDisabled, prevMonthButtonDisabled, prevYearButtonDisabled, isMonthView, }) => (jsxRuntime.exports.jsxs(StyledCustomHeader$1, { children: [jsxRuntime.exports.jsx(StyledMonthNavigationButton$1, { type: "button", ...(isMonthView
                ? { onClick: decreaseYear, disabled: prevYearButtonDisabled }
                : { onClick: decreaseMonth, disabled: prevMonthButtonDisabled }), "aria-label": `Previous ${isMonthView ? 'Year' : 'Month'}`, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faChevronLeft$1 }) }), jsxRuntime.exports.jsx(StyledCurrentMonthLabel$1, { children: isMonthView ? dateFns.format(monthDate, 'yyyy') : dateFns.format(date, 'MMMM yyyy') }), jsxRuntime.exports.jsx(StyledMonthNavigationButton$1, { type: "button", ...(isMonthView
                ? { onClick: increaseYear, disabled: nextYearButtonDisabled }
                : { onClick: increaseMonth, disabled: nextMonthButtonDisabled }), "aria-label": `Next ${isMonthView ? 'Year' : 'Month'}`, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faChevronRight$1 }) })] }));
const customInput$1 = ({ onChange, isClearable, selected, rightIcon = faCalendarDays, }) => (jsxRuntime.exports.jsx(FormInput, { autoComplete: "off", rightAdornment: isClearable && selected ? (jsxRuntime.exports.jsx(Button$1, { variant: "text", onClick: (event) => onChange(null, event), "aria-label": "Clear selection", children: jsxRuntime.exports.jsx(StyledRightAdornmentIcon$1, { icon: faCircleXmark }) })) : (jsxRuntime.exports.jsx(StyledRightAdornmentIcon$1, { icon: rightIcon })) }));
const calendarContainer = ({ $isTimeOnly, ...rest }) => (jsxRuntime.exports.jsx(StyledCalendarContainer$1, { ...rest, "$isTimeOnly": $isTimeOnly }));
const DateTimePicker = ({ width, isClearable, label, rightIcon, customPopperModifiers, ...props }) => {
    const id = React.useId();
    return (jsxRuntime.exports.jsxs(StyledDateTimePickerWrapper$1, { "$width": width, children: [label && jsxRuntime.exports.jsx(FormLabel, { htmlFor: id, children: label }), jsxRuntime.exports.jsx(ReactDatePicker__default["default"], { dateFormat: "dd/MM/yyyy", locale: "en-GB", customInput: customInput$1({
                    isClearable,
                    onChange: (date, event) => props.selectsRange ? props.onChange([date, date], event) : props.onChange(null, event),
                    selected: props.selected,
                    rightIcon,
                }), renderCustomHeader: (args) => customHeader$1({ ...args, isMonthView: !!props.showMonthYearPicker }), calendarContainer: (calendarContainerProps) => calendarContainer({ ...calendarContainerProps, $isTimeOnly: props.showTimeSelectOnly }), popperModifiers: customPopperModifiers || [
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: [],
                        },
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: 'clippingParents',
                        },
                    },
                ], ...props, id: id })] }));
};

const StyledDateTimePickerWrapper = styled__default["default"].div `
  width: ${({ $width }) => $width ?? '100%'};
  display: flex;
  flex-direction: column;
`;
const StyledRightAdornmentIcon = styled__default["default"](FontAwesomeIcon) `
  color: ${({ theme }) => theme.colors.grey[500]};
`;
const StyledCalendarContainer = styled__default["default"](ReactDatePicker.CalendarContainer) `
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  color: ${({ theme }) => theme.colors.text.main};
  border-radius: 0.8rem;
  border-color: ${({ theme }) => theme.colors.border.light};
  background-color: ${({ theme }) => theme.colors.datePicker.background};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item {
    margin-right: 0.4rem;
    border-radius: 0.4rem;
    transition: background-color 0.2s linear, color 0.2s linear;
    padding: 0.8rem 1rem;
    font-size: ${({ theme }) => theme.fonts.sizes.small};
    font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
    line-height: normal;
    width: 9.9rem;
    height: 3.2rem;
    :hover {
      color: ${({ theme }) => theme.colors.text.main};
      background-color: ${({ theme }) => theme.colors.datePicker.buttonHover};
    }

    &--selected {
      background-color: ${({ theme }) => theme.colors.info.main};
      color: ${({ theme }) => theme.colors.text.invert};
    }
  }
  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
    width: 100%;
  }
  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
    /* Has to be !important to override inline style injected by the library */
    height: 22.4rem !important;
  }
  /* Ensure width for time items with seconds */
  .react-datepicker__time-container.react-datepicker__time-container--with-seconds
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item {
    width: 12.5rem;
  }
  .react-datepicker {
    &__time {
      background: transparent;
      &-container {
        ${({ $isTimeOnly }) => $isTimeOnly
    ? styled.css `
                margin-left: 0.5rem;
                border-left: none;
                border-radius: ${({ theme }) => theme.radius.small};
              `
    : styled.css `
                border-left: 1px solid ${({ theme }) => theme.colors.border.light};
              `}
        padding: 1rem 0.4rem 1rem 1rem;
        margin-right: 0.5rem;
        background-color: ${({ theme }) => theme.colors.datePicker.background};
        width: auto;
        /* Adjust width for seconds */
        &--with-seconds {
          .react-datepicker__time-box {
            width: 13.5rem;
          }
        }
      }
    }
    &__month {
      margin: 0;
      &-container {
        padding: 1rem;
      }
    }
    &-time__header {
      font-size: ${({ theme }) => theme.fonts.sizes.small};
      color: ${({ theme }) => theme.colors.text.main};
      padding: 0.6rem;
      margin-bottom: 0.4rem;
    }
    &__current-month {
      font-size: ${({ theme }) => theme.fonts.sizes.small};
    }
    &__day-names {
      margin-bottom: 0;
    }
    &__day-name {
      padding: 0.8rem 0;
      width: 3.2rem;
      height: 3.2rem;
      text-align: center;
      color: ${({ theme }) => theme.colors.grey[600]};
      margin: 0;
    }
    &__header {
      padding: 0;
      background-color: transparent;
      border: none;
    }
    &__month-text {
      padding: 0.8rem 1rem;
      text-align: center;
      width: auto;
    }
    &__day {
      padding: 0.8rem 0;
      width: 3.2rem;
      height: 3.2rem;
    }
    &__day,
    &__month-text {
      border-radius: 0.4rem;
      margin: 0;
      transition: background-color 0.2s linear, color 0.2s linear, border-radius 0.2s linear;
      line-height: normal;
      color: ${({ theme }) => theme.colors.text.main};
      :hover:not(.react-datepicker__day--selecting-range-start):not(.react-datepicker__day--selecting-range-end) {
        color: ${({ theme }) => theme.colors.text.main};
        background-color: ${({ theme }) => theme.colors.datePicker.buttonHover};
      }

      &--today {
        font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
        color: ${({ theme }) => theme.colors.info.main};
        background-color: ${({ theme }) => theme.colors.info.light};
      }
      &--in-range {
        background-color: ${({ theme }) => theme.colors.datePicker.inRange};
        color: ${({ theme }) => theme.colors.grey[100]};
        :not(.react-datepicker__day--selecting-range-start):not(.react-datepicker__day--selecting-range-end):not(
            .react-datepicker__day--range-start
          ):not(.react-datepicker__day--range-end) {
          border-radius: 0;
        }
      }
      &--in-selecting-range {
        :not(.react-datepicker__day--in-range):not(.react-datepicker__day--selecting-range-start) {
          background-color: ${({ theme }) => theme.colors.grey[200]};
          color: ${({ theme }) => theme.colors.black};
        }
        :not(.react-datepicker__day--selecting-range-start):not(.react-datepicker__day--selecting-range-end) {
          border-radius: 0;
        }
      }
      &--range {
        background-color: ${({ theme }) => theme.colors.info.main};
        color: ${({ theme }) => theme.colors.grey[100]};
        &-start {
          background-color: ${({ theme }) => theme.colors.info.main};
          color: ${({ theme }) => theme.colors.grey[100]};
          :not(.react-datepicker__day--range-end):not(.react-datepicker__day--selecting-range-end) {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
        }
        &-end {
          background-color: ${({ theme }) => theme.colors.info.main};
          color: ${({ theme }) => theme.colors.grey[100]};
          :not(.react-datepicker__day--range-start):not(.react-datepicker__day--selecting-range-start) {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
      }
      &--selecting-range {
        background-color: ${({ theme }) => theme.colors.grey[200]};
        &-start {
          background-color: ${({ theme }) => theme.colors.info.main};
          color: ${({ theme }) => theme.colors.grey[100]};
          :not(.react-datepicker__day--selecting-range-end) {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
        }
        &-end {
          :not(.react-datepicker__day--selecting-range-start) {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
      }
      &--selected {
        :not(.react-datepicker__day--selecting-range-start) {
          color: ${({ theme }) => theme.colors.text.invert};
          background-color: ${({ theme }) => theme.colors.info.main};
        }
      }
      &--outside-month,
      &--disabled,
      &--excluded {
        :not(.react-datepicker__day--in-selecting-range):not(.react-datepicker__day--in-range) {
          color: ${({ theme }) => theme.colors.grey[500]};
        }
      }
    }
  }
`;
const StyledCustomHeader = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const StyledCurrentMonthLabel = styled__default["default"].strong `
  margin: 0 auto;
`;
const StyledMonthNavigationButton = styled__default["default"].button `
  color: ${({ theme }) => theme.colors.text.main};
  border: 1px solid transparent;
  width: 3.2rem;
  height: 3.2rem;
  transition: all 0.2s linear;
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  border-radius: ${({ theme }) => theme.radius.small};
  :hover {
    background-color: ${({ theme }) => theme.colors.white};
    border-color: ${({ theme }) => theme.colors.border.light};
  }
  &:disabled {
    color: ${({ theme }) => theme.colors.grey[600]};
    cursor: not-allowed;
  }
`;
const StyledTimeMenuWrapper = styled__default["default"].div `
  border-left: 1px solid ${({ theme }) => theme.colors.border.light};
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.datePicker.background};
  border-radius: 0 1rem 1rem 0;
`;
const StyledTimeMenuHeader = styled__default["default"].div `
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  color: ${({ theme }) => theme.colors.text.main};
  padding: 1rem 0.6rem 0.6rem 0.6rem;
  margin-bottom: 0.9rem;
  text-align: center;
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
`;
const TimeMenuContainer = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;
const TimeMenuColumn = styled__default["default"].div ``;
const TimeMenuLabel = styled__default["default"].div `
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  color: ${({ theme }) => theme.colors.grey[600]};
  margin-bottom: 1.4rem;
`;
const TimeMenuList = styled__default["default"].div `
  /* Height calculation: (3.2rem height + 0.2rem total margin) * 6 elements */
  height: 17.7rem;
  width: 5rem;
  overflow-y: auto;
  scroll-behavior: smooth;
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: inset 0 0 0.4rem ${({ $isDark }) => ($isDark ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.1)')};

  /* Hide scrollbar */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
const TimeMenuItem = styled__default["default"].div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3.2rem;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  color: ${({ theme, $isSelected }) => ($isSelected ? theme.colors.text.invert : theme.colors.text.main)};
  background-color: ${({ theme, $isSelected }) => ($isSelected ? theme.colors.info.main : 'transparent')};
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: ${({ theme }) => theme.radius.small};
  margin: 0.1rem 0.4rem;
  transform: translateY(${({ $isSelected }) => ($isSelected ? '0.4rem' : 0)});

  &:hover {
    background-color: ${({ theme, $isSelected }) => $isSelected ? theme.colors.info.main : theme.colors.datePicker.buttonHover};
  }
`;

ReactDatePicker.registerLocale('en-GB', locale);
const getCurrentValue = (type, hours, minutes, seconds) => {
    if (type === 'hours')
        return hours;
    if (type === 'minutes')
        return minutes;
    return seconds;
};
const MenuContainer = ({ children, className, selected, onChange, includeSeconds = true, ...rest }) => {
    const [hours, setHours] = React.useState(() => selected?.getHours() ?? 0);
    const [minutes, setMinutes] = React.useState(() => selected?.getMinutes() ?? 0);
    const [seconds, setSeconds] = React.useState(() => selected?.getSeconds() ?? 0);
    const { theme } = React.useContext(SwitchThemeContext);
    const isDark = theme === 'dark';
    React.useEffect(() => {
        if (selected) {
            setHours(selected.getHours());
            setMinutes(selected.getMinutes());
            setSeconds(selected.getSeconds());
        }
    }, [selected]);
    const handleTimeChange = React.useCallback((type, value, event) => {
        const newDate = new Date(selected || new Date());
        switch (type) {
            case 'hours': {
                newDate.setHours(value);
                setHours(value);
                break;
            }
            case 'minutes': {
                newDate.setMinutes(value);
                setMinutes(value);
                break;
            }
            case 'seconds': {
                newDate.setSeconds(value);
                setSeconds(value);
                break;
            }
        }
        onChange(newDate, event);
    }, [selected, onChange]);
    const getTimeOptions = React.useCallback((type) => {
        const max = type === 'hours' ? 24 : 60;
        const currentValue = getCurrentValue(type, hours, minutes, seconds);
        const options = Array.from({ length: max }, (_, i) => ({
            value: i,
            label: i.toString().padStart(2, '0'),
        }));
        const before = options.slice(0, currentValue);
        const after = options.slice(currentValue);
        return [...after, ...before];
    }, [hours, minutes, seconds]);
    return (jsxRuntime.exports.jsx(StyledCalendarContainer, { className: className, ...rest, children: jsxRuntime.exports.jsxs("div", { style: { display: 'flex', flexDirection: 'row' }, children: [children, jsxRuntime.exports.jsxs(StyledTimeMenuWrapper, { children: [jsxRuntime.exports.jsx(StyledTimeMenuHeader, { children: "Time" }), jsxRuntime.exports.jsxs(TimeMenuContainer, { children: [jsxRuntime.exports.jsxs(TimeMenuColumn, { "data-testid": "hours-column", children: [jsxRuntime.exports.jsx(TimeMenuLabel, { children: "Hours" }), jsxRuntime.exports.jsx(TimeMenuList, { "$isDark": isDark, children: getTimeOptions('hours').map((option) => (jsxRuntime.exports.jsx(TimeMenuItem, { "$isSelected": option.value === hours, onClick: (e) => handleTimeChange('hours', option.value, e), children: option.label }, option.value))) })] }), jsxRuntime.exports.jsxs(TimeMenuColumn, { "data-testid": "minutes-column", children: [jsxRuntime.exports.jsx(TimeMenuLabel, { children: "Minutes" }), jsxRuntime.exports.jsx(TimeMenuList, { "$isDark": isDark, children: getTimeOptions('minutes').map((option) => (jsxRuntime.exports.jsx(TimeMenuItem, { "$isSelected": option.value === minutes, onClick: (e) => handleTimeChange('minutes', option.value, e), children: option.label }, option.value))) })] }), includeSeconds && (jsxRuntime.exports.jsxs(TimeMenuColumn, { "data-testid": "seconds-column", children: [jsxRuntime.exports.jsx(TimeMenuLabel, { children: "Seconds" }), jsxRuntime.exports.jsx(TimeMenuList, { "$isDark": isDark, children: getTimeOptions('seconds').map((option) => (jsxRuntime.exports.jsx(TimeMenuItem, { "$isSelected": option.value === seconds, onClick: (e) => handleTimeChange('seconds', option.value, e), children: option.label }, option.value))) })] }))] })] })] }) }));
};
const customHeader = ({ date, decreaseMonth, decreaseYear, increaseMonth, increaseYear, monthDate, nextMonthButtonDisabled, nextYearButtonDisabled, prevMonthButtonDisabled, prevYearButtonDisabled, isMonthView, }) => (jsxRuntime.exports.jsxs(StyledCustomHeader, { children: [jsxRuntime.exports.jsx(StyledMonthNavigationButton, { type: "button", ...(isMonthView
                ? { onClick: decreaseYear, disabled: prevYearButtonDisabled }
                : { onClick: decreaseMonth, disabled: prevMonthButtonDisabled }), "aria-label": `Previous ${isMonthView ? 'Year' : 'Month'}`, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faChevronLeft$1 }) }), jsxRuntime.exports.jsx(StyledCurrentMonthLabel, { children: isMonthView ? dateFns.format(monthDate, 'yyyy') : dateFns.format(date, 'MMMM yyyy') }), jsxRuntime.exports.jsx(StyledMonthNavigationButton, { type: "button", ...(isMonthView
                ? { onClick: increaseYear, disabled: nextYearButtonDisabled }
                : { onClick: increaseMonth, disabled: nextMonthButtonDisabled }), "aria-label": `Next ${isMonthView ? 'Year' : 'Month'}`, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faChevronRight$1 }) })] }));
const customInput = ({ onChange, isClearable, selected, rightIcon = faCalendarDays, }) => (jsxRuntime.exports.jsx(FormInput, { autoComplete: "off", rightAdornment: isClearable && selected ? (jsxRuntime.exports.jsx(Button$1, { variant: "text", onClick: (event) => onChange(null, event), "aria-label": "Clear selection", children: jsxRuntime.exports.jsx(StyledRightAdornmentIcon, { icon: faCircleXmark }) })) : (jsxRuntime.exports.jsx(StyledRightAdornmentIcon, { icon: rightIcon })) }));
const DateTimeWheelPickerCalendarContainer = ({ children, includeSeconds, ...props }) => (jsxRuntime.exports.jsx(MenuContainer, { ...props, includeSeconds: includeSeconds, "$isTimeOnly": false, children: children }));
const DateTimeWheelPicker = ({ width, isClearable, label, rightIcon, onChange, includeSeconds = true, customPopperModifiers, ...props }) => {
    const id = React.useId();
    const [selectedDate, setSelectedDate] = React.useState(props.selected || null);
    const handleDateChange = React.useCallback((date, event) => {
        setSelectedDate(date);
        if (onChange) {
            onChange(date, event);
        }
    }, [onChange]);
    return (jsxRuntime.exports.jsxs(StyledDateTimePickerWrapper, { "$width": width, children: [label && jsxRuntime.exports.jsx(FormLabel, { htmlFor: id, children: label }), jsxRuntime.exports.jsx(ReactDatePicker__default["default"], { dateFormat: includeSeconds ? 'dd/MM/yyyy HH:mm:ss' : 'dd/MM/yyyy HH:mm', locale: "en-GB", selected: selectedDate, onChange: handleDateChange, customInput: customInput({
                    isClearable,
                    onChange: handleDateChange,
                    selected: selectedDate,
                    rightIcon,
                }), renderCustomHeader: customHeader, calendarContainer: (containerProps) => DateTimeWheelPickerCalendarContainer({
                    ...containerProps,
                    selected: selectedDate,
                    onChange: handleDateChange,
                    includeSeconds,
                }), popperModifiers: customPopperModifiers || [
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: [],
                        },
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: 'clippingParents',
                        },
                    },
                ], ...props, id: id })] }));
};

const StyledFooterLinks = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  gap: 3rem;
  margin: 0 6rem;

  * {
    color: ${({ theme }) => theme.colors.grey[100]};
  }

  li {
    margin-bottom: 1.2rem;
  }

  a {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    text-decoration: none;
    :hover {
      text-decoration: underline;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    margin: 0;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 10rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    gap: 6rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    gap: 8rem;
  }
`;

const footerLinksSections = [
    {
        title: 'Learning',
        links: [
            {
                href: '/hacktivities',
                name: 'Hands-on labs',
            },
            {
                href: '/business',
                name: 'For Business',
            },
            {
                href: '/classrooms',
                name: 'For Education',
            },
            {
                href: '/games/koth',
                name: 'Competitive Hacking',
            },
            {
                href: '/certification/security-analyst-level-1',
                name: 'Defensive Certifications',
            },
        ],
    },
    {
        title: 'Resources',
        links: [
            {
                href: '/about',
                name: 'About Us',
            },
            {
                href: '/resources/newsroom',
                name: 'Newsroom',
            },
            {
                href: '/resources/blog',
                name: 'Blog',
            },
            {
                href: '/glossary',
                name: 'Glossary',
            },
            {
                href: 'https://careers.tryhackme.com',
                name: 'Work at TryHackMe',
            },
            {
                href: '/careers',
                name: 'Careers in Cyber',
            },
        ],
    },
    {
        title: 'Shop',
        links: [
            {
                href: '/subscriptions',
                name: 'Buy Vouchers',
            },
            {
                href: 'https://store.tryhackme.com',
                name: 'Swag Shop',
            },
        ],
    },
    {
        title: 'Get in touch',
        links: [
            {
                href: '/contact',
                name: 'Contact Us',
                description: 'contact us',
            },
            {
                href: '/forum',
                name: 'Forum',
            },
        ],
    },
];
const FooterLinks = () => (jsxRuntime.exports.jsx(StyledFooterLinks, { children: footerLinksSections.map((linkSection) => (jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx("h3", { children: linkSection.title }), jsxRuntime.exports.jsx("ul", { children: linkSection.links.map((link) => (jsxRuntime.exports.jsx("li", { children: jsxRuntime.exports.jsx(reactRouterDom.Link, { to: link.href, "aria-label": link.description, children: link.name }) }, link.href))) })] }, linkSection.title))) }));

var _path$6, _defs$2;
function _extends$a() { return _extends$a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a.apply(null, arguments); }
const SvgLogoWithText = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$a({
  width: 136,
  height: 77,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _path$6 || (_path$6 = /*#__PURE__*/React__namespace.createElement("path", {
  fill: "url(#logo-with-text_svg__a)",
  d: "M0 0h136v77H0z"
})), _defs$2 || (_defs$2 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("pattern", {
  id: "logo-with-text_svg__a",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React__namespace.createElement("use", {
  xlinkHref: "#logo-with-text_svg__b",
  transform: "matrix(.0023 0 0 .00405 -.003 0)"
})), /*#__PURE__*/React__namespace.createElement("image", {
  id: "logo-with-text_svg__b",
  width: 439,
  height: 247,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAbcAAAD3CAYAAACeuBozAAAgAElEQVR4Ae19CxB/R1VeRFSQhwkqthgwVHkYZIS2YJUCAVS0MAaow8tC4mPCVA2JRcLDQhB5qNVJECFF0MRBLKA1qVRrW8YElJdQEgZpcQqGh+EpJPJ0rPJ1zu9/9vffu/fs3t17976/38xv7r1795495zt797v7PuUU/kZHAMAdAZwF4EcBPB/AawG8EcB1AN4H4KMAPoPm77MAPgbg/QDeBeBPALwawNMA/CsA3zi64kyACBABIkAEiIBDAMA3APhhAK8BcGOTs6pe3QTgfwK4GMB3A7il04FHIkAEiAARIAKDEQBwP62VXVuVvsqFvR3AfwBw/8FGUQARIAJEgAjsCwEAXwPgsQBeCeCvyzlokic+DOCXAPzzfXmH1hIBIkAEiEARAgC+BcCvT0JNdRORvrufAXD7IoMZmQgQASJABLaLgDTzAfh9AF+qyzmTS/s7HdDy4O16i5YRASJABIhAEgEADwDwpskpaJoE3wvgcUkAeJMIEAEiQAS2gwCAbwPwB9NwzOypvBPA927He7SECBABIkAEGggAOB3Aq2anm3kUuBrAvRuA8IIIEAEiQATWiwCAmwF4CoDPzcMri0n17wE8D8BXrNeb1JwIEAEiQAROkdqKrgKyGIZZgCJ/DuBMZg8iQASIABFYIQI64XkBXLJYFZ65QrdSZSJABIjAPhEAcAcAsprHlD8ZuCHrSv4ygAsAPArAd+nglTvJxHDxBoDbytqRAL4VwH1lsIeuSynLbL0cwB8C+PSEissSX6ftM6fQaiJABIjAShDQ4f2fnIAcZLFjWSj5oQBuUxseAN8B4NkA/nQCWz7EwSa1PUh5RIAIEIFKCOigkbG44AsArgLwQ1PXdADcDsB5ExDduZVcQTFEgAgQASJQAwFdZ3EMYpMh9E9cyqr8usXO0wF8cAxjAfz7Gv6gDCJABIgAERiIAIAXVy7oPw/ghQC+aaBqoz4O4F/rtjiVzccLRlWcwokAESACRCCNAICXVi7Zf2VtCxADuDuA36uMwy+nkeddIkAEiAARGAUBHV1Yq0z/XQBnjKLoREJ1U9P31AIEwIsmUp3JEAEiQASIgCAA4CWVCvG/AvDwLaEK4HwAX6yED/vgtpQ5aAsRIALLRQDAcysV3NJXd+vlWtpfMwB3BiDTFWr8nthfEz5JBIgAESACnQgA+IkKpbXMgzurM7GVRwDwZQB+qkItTtakfMjK4aD6RIAIEIFlIgDgsRWI7Y2ygskyLRxHK10l5fqB2H0WwD3H0ZBSiQARIAI7RQDA3Sqs6n/JTuGTPsrTALx+IMG9b4zVWPbqE9pNBIjAzhGQCdQAho4CfPLOYTyYX2Ex6d8hjkSACBABIlABAQC/MaDG8bcAfqCCGpsRoQs7D4AUP7EZMGgIESACRGAOBAA8ekgpLHO/5tB76WkC+LGBuHJX76U7mfoRASKwTAQAfO3A7V82NX+ttpcGDtB5b219KI8IEAEisAsEAPxWz9qFDF0/excgDTRy4E4KzxqYPB8nAkSACOwLAV1Kqie34fx9oTXMWgBX9ARa+jNXvWTZMOT4NBEgAkSgAAEAtwAgy2L1+V1RkBSjnljK7OYA3tYHbABXE0QiQASIABHIQADAz/YsaN+SIZ5RDARkJwQAH+2J++MNkQwiAkSACBABhwCAfwxAdr0u/X1GnnVyeCxHAMCDS0HX+H9ZnhqfIAJEgAjsCAEAr+hZwLL2UCGfAPi5nvifVyF5iiACRIAIbA8BAPfoWbBeuT005rMIgKy/Wfq7YT6NmTIRIAJEYMEIAPgvpSUqgE+tbefsBbvgoNqAj4yfXLpt1I8IEAEiMCkCAL65B7HJI1wKagRPAbishz9YexvBFxRJBIjAihHouaDv/wVwsxWbvVjVAZwK4G96ENwjF2sUFSMCRIAITImAzmu7sUdBygWRR3QUgIt6+OSPRlSJookAESAC60EAwLk9ClHOaRvZxbrVkOxaXvq788iqUTwRIAJEYPkIAHhraekJ4PuWb9n6NQTwzB6++fn1W04LiAARIAIDEADwTT0Kz2sHJMlHCxCQnbcB3FToo48XJMGoRIAIEIHtIQDgpwsLTon+mO0hsVyLADyvh4/uv1yLqBkRIAJEYGQEejRJfnhklSg+QADAHXuQ2yWBGF4SASJABPaBAIDTexSav7gPdJZlJYA3FPrqI8uygNoQASJABCZCAMCTCwtMiX7PidRjMh4CAH6kh6/u44ngKREgAkRgHwgA+E+FBea794HM8qwEcNtCX0n0n12eJdSICBABIjAyAgDeV1hgXjyyShSfQADAfy30FzcyTeDJW0SACGwQAR1iXlhW4iEbhGI1JgH4d4UO+yKAL1+NgVSUCBABIjAUAZmEXVhQ/gOArxqaLp/vjwCAby/0mUT/rv4p8kkiQASIwIoQAPBPALyksKB8+4pM3KyqAD5R6LeLLDAAnKYT+L9NCBDAvwBwN25fZKHFMCJABBaFAIBbAXgogBfqUPK/KiwY/ejvUFm3WZSRO1MGwGt8p2ScyxQCWTv0F7TP7i8znpEoHwPwpwBeCeBiAA8D8PU7g5vmEgEisBQEANwJwFMBvDmzEOsT7Z0AXgTgwUuxey96qG/7+KzWMx/WUbY/TLLbS66jnURgJgS0hibLaL29VglWIEcKuxcAuOtM5u8qWQBnFfhmiqh/BuBJu3ICjSUCRGBcBADcTuYyAfjUFKVYRhpvBHD2uFbvW3rPUa4ZrhscRbbm+TkAX7dvD9F6IkAEeiMA4GsB/BKAzw8uksYR8H4A5/c2kA8mEQDw3nHcVkXqZwE8W1oTkkbwJhEgAkTAIaA1NWkC/FyVYmh8IR8E8CinP4/DEdDBQeN7bngKUpNjc+Vwl1MCEdg2AgB+sMe+XsOLqDoS/ptMP9i2h8a1DsBDAOSOdKzjtTpSpJb5veOiQ+lEgAisDgEApwJ4VZ1yZlYpXwDwA6tzwMwKax/br8/quTqJ/2cAXzMznEyeCBCBJSAgK/ADGDI3rU6xVFfKvZaA7Rp00H3c/qIu/LNKk5rnvdeAPXUkAkRgJAQA/MsVN0OmStA3jATZ5sQCuC4F5Irv/ZvNOYsGEQEi0I0AgEesuODKUf3O3SjsOwaAc3KAXHGcC/ftYVpPBHaGAIDHTFxgfRTAuwHIHLVrAcgwfhnpNubv+3fm1mJzAbx+TAd4ssX/Mvn/Gv3Lcl03ePfHPH1BMTB8gAgQgfUhAOAJI5YksuDuawFcCOB7ZJmuLoRkEV0Aj9R1CaXQky1Uavw4eq4DfAAyjaLm7626ZNoTAdwHwDemVNCBTN+ty33JgCYhwTF+L0zpsYZ7AO6uK8fI6jGL+68BQ+q4YQRGaoZ6G4CnADizFnQApHB808BS7o619NmqHACyfueQ36cBvFhW+6+FkTaXy7SO2r+fqqXjHHIAXFEbkMryuOD1HBmDaZ5yiswDqpiZZYL3pQC+eUxsdSRn6bY5YuYbx9RrK7IBvKJnnvgjAI8eEwfdKuf5AD7eU0frsdUOMiG5jZnbKHu1CEitquIyWrLs0W2nBAPAHQpf7odOqd9a09J8YZFALEz6Tf/Z1PZqi8O7YkoVht9/av1rpFeY/wshqRKdNbcajqaMfAR0jcgPVci+stfa3fNTrh9Td4n+4w5bLq6f8nYlApDaUc5vdlwBPCNH0Y44sgD4GWvzKMltbR6jvqMjAOD3O172nNvPGl3RggQAPADA7wYDIv4H934rANGLCuCCxEAe2bPvHl70WU8ByK7eQ2tx7wFwy1kNKUyc5FYIGKNvGwEAP5bDXIk4MpruO7eNEq0TBHTB7PMB/DaA1+mOEIttwtNRmYms23nrV9bkeZLbmrxFXUdFAMCdB67sL/OSThtVSQonAgMQACA7df9DJ43FIzxoQPKTPkpymxRuJrZkBAB09U3FX/kTX+63WLJ91I0ICAKyUHYqI3fck77oVeRzkhvzOxE48cI/ruOlTt2WOUY3I5BEYC0IAPihVIbuuLeo/uQY5iS3GDIM3w0Cun3JRzpe6NhtmZC9ii/Z3TiUhmYhAOCiWKbuCJed5r8hK5EZIwF4urd8mVvGLOcoq/7k/mRHhRyZVhxuNTRj/thF0gCem5uTg3gfkEEFuwCJRm4SAQC/GeTp3MuXbhKQE604X5ELAoBnbhUH2rUBBADIPJ7Sn6zneM8NmE8Tdo4AAJmP2ee3yUnIAEhuO38nNmE+gPP6vNUAVrss0SYcRyOqIdBj1RX3yqyi760UKJJbKWKMv0gEAPwf96YWHLkO4yK9SaX6IgDgZwryv4v68b7pLfk5ktuSvUPdshAAcH/3lhYe75WVACMRgRUhAKDPoKofXJGJWapuhdx0e6QHArg4+K9uKbUsxzHSSQQAvLSQ1CT6K09K4BkR2A4CAJ7U4324cjsInLBkbnLT0ZeWK67pwlrWANWl4a63BGjYWRlyZHRn569LTs59AM/pTOhEhE69c9LbRRwAf50Jqh/trrsAh0buEoFg7VE/36fOT90SWGskNyW1y1NO8u51kkSCYD0xQA2/k9xqoOjJAPD9DS/lXbzWE8FTIrA5BHrW3n50S0AsmNxMMtGa2o15RdghFsltSxk2tAXAJQWZwUW9XyiH10RgawgA+KTL8JnHq7aEwZLJTfrRfKwB5NbWfFeS3HwQt3YO4H/53s44/8DWMKA9RMBCAMDLMt4HP4rsMv/llqw1hi2c3I7E1JPYxG9HGTH/sFkyhszCwwHc2n8zM88vWrhZVI8IVEEAwPdkvhN+tM20aiyc3B4hTi7op/J95M5JblXelAUKAfBQ5+WC45kLNIUqEYFREABQ0ocjr9GzR1FkBqELJzcZWXhWQbllRSW5zZCvJkkSwFMtjyfCPjmJYkyECCwEAd2ANfFKtG69bCGqD1Zj4eR2KYDUMP+WY4wAktvgXLJQAQB+zXB4Kui3F2oK1SICoyAA4NGpF8K495RRFJlB6MLJzYA+GXSTsWtB5yIU7HObIePVSBJAyZYWknOeXiNdyiACa0FAtnEqbJq871ps69Jz5eQmO5VcCKCTwFI4kNxS6Cz4HoAbkt867ZuPWrA5VI0IjIIAAGkCy/m9bhQFZhK6UnKTGtqFtSAjudVCcmI5AD6T88Z6ce4xsYpMjgjMjgCArwbwZ957YJ2+B8DpsytbUYEVkpsQ26CaWggfyS1EZCXXAL5gvaWJsE3uW7USd1HNGRGQzXgTG5q+XHaxn1G9UZJeIbl1DhApBYrkVorYQuInSCx2a3Mv8EJcQTVWggCAbwXwBNl5WleYv9tKVC9Wc2XkdmmxgRkPkNwyQFpilBiDxcKXaAN1IgJEYBwEVkZujeW4aiFCcquF5MRyYiQWC59YPSZHBIjAjAisiNyuGAsmkttYyI4st3CIs3De7UZWieKJABFYCAIrIrdzx4KM5DYWsiPLBfDhWC0tEn6nkVWieCJABBaCwIrIbbQdtUluC8mMpWoAkOHLJb97lqbB+ESACKwTgbWQ25joktzGRHdE2QDeWsJsAB45ojoUTQSIwIIQILkddh24KqeMrOG2XCLN2aqnhj6rlgHgNTmO8+I8c9UGU3kiQASyEVgJuV2TbVCPiAVb6gxuGiW59XBQ7JECxzl+e1VMFsOJABHYFgIkt6L94g77yw3JAa6QzThWn6w+RO9FPgvg8RlA+lE+ukhDqBQRIALVESC5FZHbc4Y4AMAj/IK245zk1gU2gH/aAaJ1+y5dcnl/fwjoxpEXA7gEwNV6lOuqa/0tDVkAZwC4QFcrEbsv1/Ozl6ZrqT4ktwO55W6Ien0pvn58AFl9e1ogk9x88GLnAL5oMVgi7N/GZDF8fQgI+QC41vJ3jjX6xdm1aaTIXxTJAThVicgyvbPwUFITMkv9ZBfvC3JwXGIcktuB3CSf5P56zbfrsaN4Z/5cYn6aXCf9ys51nsQbtQN3cgB2nKDudyUFsPnrgqZgKxgnv9fL36VH6X0l9BQhJwsPJfQobs5Y73hlqY5LiE9yO+EFANd5vkydSp4oGliiH1mpvGill8yfS8g7i9BBm1AsAGNhXwJw+0UoTyV6IaAv1JUxB7vwlPAeg5Gc2MEd7ym9uu4poTtdYsdo4aHEWEJsLo3Lu3Rb2n2S2wmPALjCOTHjKHkjq5VCa2x98lI0fy4tD82qD4AHZDgsjHLRrEoz8d4IZNRajr6OJdKjGeUoU5d8G2WR25i+Ep5L6KpotPAAIDs89/0touaawsm/R3I7gYa+M6U+lybrs8OanDZnn9OjxcxPP5o/ff/x/MSLL5v8lfxuIHDrQ6C0thWzMDEf57ALspLfcxIZatDIsphesfAeX8hm4QHg3IRN8nUvgw8kTowABw06iNk3VjjJ7SSyiTyfyBKj3TLz50lteXZEAMCv9XDDk44CeLJoBLTW0jX4oZUFLKP0y7MVVwMaL12iCfBGS/YYYaWEbtnh9Er0vTT2ElOMYh+MszbLOltyjiS3kygVDtWPvR+1whvv2UktedZCAMD9e6D+QQC3bAljwOIQUHKL1SakEDbvWYYkCMvcdiQmW2o5lvzaYR2DXky7Ld0SpC74tZpZE6TaIMLa9taUR3Jrolk4XL9HkZr9yCTvTtP6FV/12CFAPPGLKzZ5V6pH+g1kFJjM07rGeq0sgGJx5cs2Ej/WPDlJ06QSezjaTQhJJs3GdGsVHj1IXaZYWL9rLZyWGEZya3pF81KsRm75eqywVv5sasqrBgIAntHTE9/eEMSLxSIQFNDHmlaMsCxDAMRe7lbtRZ7Xfigra002pUSJ3el9IHTVrYTcLrWMkD42CyeVbz4Si7+0cJJb2yOan11eMv07QSDJre2aeAiAWwH4bA/H/AWAr4pL5p0lIaBNK40CuZDcrCxyU8zGRHPepDUYHeghgz6OJFxYczNrt1YTpsMihquQrYuz5CPJzfZO8LFkvQ99wuSjK/YBFco75mFbQ4a2EADw3BDFzOtfbQljwGoQiBXCoQEJokrWwmJ5KJQ/9XUlcosSVQzXFCFOjUEqPZJbHB0luLC5O5bVu8JFjqyEEmtJaDwf14p3oggAuB2AzzWQzL94TFQwbywagVghHCrdt4kxloVC+VNfJwqTVrNPLka+DbFnSG4+SvHzBH5+lkp+WMWl17mjLQJ9mynluWMrSm7NrY7mO5QC4Gl+zik4/38AHrRDyFZvcqwQCQ3bObmZX+khRv51DFeSm49S/DyBn18szUpuTnsdoCTN3rERuL7OskjyhX4TucjJtPc6lyaPPRAA8B7fEwXnnwdw3x5J8pEZEYi9VKFKOye3WJ9bdC3BGK4ktzBn2dcJ/PwiaRHk5lugzfcyoV/+QmIysf9w7ccLz2MLmPvGSp95+ByvCxAA8J0BoCWXssvAQwqSY9SZEYgVIpZakYyQXHkj8kx0EIqV7hhhNZolU0QVwzX1zBh2UubyEUj0Z4evz4XLt2bhGgJ4SYhq4fWPL9xEqqcIxAphC6BYHrDiSph+sVqPzf7FXUhuscVzzfl9anusiYqj3WIZZqfhibwYvjvRAUw7ha7cbABfCeBdIbKF17Ly/G3LU+cTUyJQSG6x5jnzpdMmGSvbzL5SR6JAsQaUxEaymZPRdfSbZffsNdYp89ZW0wr7y4bYqSMvrbwShjHvDAHaf1aryn1HAjnHyDJdrcLCT4fn8yJQSG6xuTixQj5W4zmOEpvL+kJykz4T62fO10uQOvtM5nJ4pXT1w0U24JV92M4ZIlaJLXfbG/MdG5L+rp8F8HDrje4R9iIAt9g1mAs1vpDcZNkq6ycveqO5raMfoRF3DmhKyE30S6zO0vp4i2HqD/2ew2amOQwBj9j8d0DI6fKSj3iVc7EvpONcKhmzvzPD0Fvg0wCe2gF87u2PAHg6myqX5eRYQRzTMlHIy84DhxdQiU2+bq3f7P1tYlsPcovVQhsbVCY2t5QCKjq6MoY3w5eBQITYrPwt74EQl/wfGPwlrHOjYEPo7M34y/DCCFoAeLkBeN8gmSgu2+w8eARVKbIQgR7kltrXTPJEjNRcfmnVdApVrhK9B7nJItOpn9ReUz82K1Xx3DxCMvJ1yvdD7rHWNrbLAfz3IR6KPHsDgFcAeAKA08e2gfLbCJSSm0hI7G0WcfMx+Lhgc1uTaUNKyU3tjg0sORoYOZGRk2xWmtbF1VLTZseIa0cPXsTHYDUwlyhI+swA/MHIrvwEgDcAuEwLHylM+D+JgezeUPUjoCe5yVp4pYONDmvoLSVv9yE30T3R7Bh7NQQnczTpUrCgHnEEEvkk5u+a4ZzXFndN/Tszf8XUzDhrliW13a+u4d0+5Cbpah9EbGpAiK30Vy2q5pIotDq/lBPPhnYLoZPYamTUmWRoPo/1t4b+rnnNZuw5fD5gB4Gazt+7rDfX8L0OW2/VjnNl6/OyXp71k0Khkyxy06oZTyeYt+zOHfShw7jFPqsGK6QmfZOLIvSa+O1Nlq4fGZuYb+X9IWGzT5XZm38b9gJ4GIBPD/Egnx2MwDMaTpn5Qr9yF0lmY0OjZEcyGxvoGeVr/pYPIuuDZvDLrK0orOnP6ONj0gDuCOAtNbxKGb0Q+JujM3hCBIjAJAgoycmiyLVqciKHtbVJvFeYCIBn9Sqa+VANBDilojC/MjoRqIWA1tilNpfb/+zeeSE0WfEnuj5pLR0pZyACAO7Sw8HO0Tz2R2DQEkAD3c7HV4gAgJ/WQTFWn6Mf9rDa5gE4LzPtx9VOewp52pcry7X5OLpzt/3NZibzexPW3cR167iNrgpZbw3A+/uX1XyyEIGHT/HSMo3tIADgY5l57LLaVgN4R2bar6udNuXVRyDTl9sa+Qng0QDemWk8o/VDQDaIvXX9LEuJW0aA5LZl705rW2axtS1ycxBrNf23AMhGpvzVReDZDmceiUAuAiS3XKQYrwuBzOJsm+TmwAFwGwA/AuCPMwFhtDQCb3LY8kgEShAguZWgxbgpBNJF1PHutsktBAjAAwA8U9eszO0DOKK18xNZeLrKCiWhX3i9fQRIbtv38VQWZpbD+yK3EHwApwF4EIAnR0YauRFHez4+DcAdQux4TQRKECC5laDFuCkESG4pdHiPCBCBSREguU0K96YTI7lt2r00jgisCwGS27r8tWRtSW5L9g51IwI7Q4DktjOHj2guyW1EcCm6PwK6Rt4DAYT/3iso6HJEobwH9tVSVuk39BP52YsUq50XALgagL9jtlxfLjr31W+Nz5Hc1ui1ZepMclumX3atlZLQtZHM2Wt0k66VZ4rsA7ZuM3KjKTBzKx0AssBtzu/KEsLsY89SniG5LcUT69cj58WSAYLrt5QWrAIB3WssRhqSX4syo9auYkR5yP+lwKSIUl+ozvXqeuyaLbW67BphqU1LiU9yW4on1q8HyW39PtyEBdo8JzWUrl82uXXUro7p5AKYQ5QqNEluBTW2o456cm2urmuNR3Jbq+eWp3f48kSus8uT5VlIjRaPgDZD+v1NkXx4CO7MjEqU0l+V9csBKKNG6acVJTclSD9u6fmFOfquNQ7Jba2eW57emS9WZ3myPMuo0SoQ6FGLSWbGjv46M7+ngColSk0gRW5XmEqc2EH58JymeVUk3o0pfdd+j+R2woOaB872tm2RVg0ZZCT/SwDIIKTOwUaJQU+9B1KV5DG1QwZZue1m5KNTbHHXYmOnHSVpuriR9ycMTpYnTlbsGBlQ1hq0NpaNMb0YPjMCGX1XYUaU62hm1IWwU/11ljykYABwnflQOjBFbjdFHm08o4VCbDflzW4iuWdyU5/Ltlw5zfMuG0l+F7IzRxHrikoubuOYyvdD7imhCvkm+7obypwYKVx1dHAgP3YZLU+6MEhhayTWeL+7ZPP+yhFQMjLyAYQAZCdg65fMjAkykhqTSVQpGBMZWGTFaldmRtY+QMum6ywdErXaK6z4WwjbK7npXpPFH2ZBZhJyaAw6SuTR5Eddn7ykpJbdHRDo7l9K7dR8h0r08gUmzpPlSSw9bSFKiG3cujQmh+EbRsAgDyGNeyWIL5kZ9QULa0eHfqrYbuxd8BrPCamdaujucrT5YibimzYlXqDNDizZG7mpj0tqOC6PxY5CkMf8Z+Td43Nd+b7kvjYzDiXno256IjXYBlkX6hTKs67Nd68rHW0etuSFYdL60tuGLj14f+EIeC+g1K4OGaEvuYmpXg1JSO7Ynu+l08iAXfAokTnCPA7oSJDVsXDxZSe+os34aktDV3fhy93S+Z7IrXCQknN97vFczT9R4qyRb/TdkJrWWL8GWZfonKlQMbklWlSsJKPvdoktjLtSBLS2dSQNMWMIuenzskND44upL7l5+jQyag9yu8bK/T4Bhy6M6Zx6JpSxpuu9kJsSWyQ7VAs+NyVpaL7QWmfuKOeUKjn3DmRdonOOUHmHC2XKqkS5NVQ2R5aAu5e4Q8nNwilGFFbcnLAe5GYOEEmlFdPZb3pKPb+2e3sgt4mIrbNsH5I3lNhyC/lOXTIjFBFcpsxScsutpbI5ckgG2/KzGyU3831L+ZHkZkI2d+DrUj5L3ZuJFEy8Unqm7mlTZLS500ysTqB0DTRaYzr0zEk1m9zYHJlCm/eyESC5nYCK5JZTPk0epxe5zUgKJkDZL2MQsXCqgpl2j8BG/3mgknmZmUYWuWnXSW5Nlc2RpkcYeEBgo+TWZypCrJ+u0f+3lWxT0CyZWXaNEq0vuUk/cN+f5B3JC+7vBjj1lddrKoA3WKtPun1tKCY2eR8yFcwlNzZHbqWQmduOjZJbMVHF5ubJl+TcPhoj/a2Sm9bacr/8Xbks/TYyKMRsitMmztiKN05G9Fjqv4E2mPlVbZDdMcz+aFX+OOK5ROeo4c0bneTG5sgS1Bm3E4GNklusIIquONJ8D09edQK40ggbJrfSWlt205YSRIocTmYc76w0i/QYCNNJHL4OSiJhjbRoEEkgz7M2eprUkc2RPqI8r4LARsktVlyGyUUAABanSURBVMCZBZkWWtZbeU0VkBcoZMPkVjJkvrhA11qV2extZSAJK3V/sJluTKwLL7ZB9NE87+zoJcPZ5RTpOEbJTTHNHTjD0ZEOeB7TCGyU3GTlFet3vYVGYgkykwwtGWsL2yK5JT5SrLwQLWy7fKmFcVjzsdI4hHXJ8+8n3kdL/lBSktV/oq0Zvl6pc0sxI8zEW2tsucQmYjfZB57Cl/d6IpB4mczMmJNMbORhzrNWnNJ5biIDJ1b/N94xhJPYU5NFe/VBWDYsLWyj5Ja74/oHhvqjpOmwJK3Eh1aYlxfTqhAqFrmWtTDdKv6yaLXsVlCycLWI3ezHZkkeYdxMBDZMbrGmSXlJZCX1swDINiCxr8bBBWCmC2aJtlFyiw0kCsvbQTUe57DEIKRGei5+zjGRHxsyl1SDCRUb6VqaUM0BPzm4Ms4OEdgwuUmTS3bTkfFCVikAl5qlNkpuWaMka/kkd3RfSXpGPrSCFvXhZSlYOUzeY3MUaAm2jLszBLZKbuLGAXOFNrvVjcveBeR2mXum1hHAOzILv6J5bpkyqzXn5fbx5eKWKw/AovJnJu59owmxbbZ7IDdvMF4PBLZMbgJHSd+Ivn27aP7YMbn17ku2Xq+cEtt6zgpLvIthMlVtsHQpCQuVq3gtzcwkthJnMO5JBBIvVO8XaAkDSk5aeCA46V/LmZ+0mw7rrZFbIh+HZW3vfO3nKXceCreuXdyuY4ENjUFRXXLHvm/ZXCnsnLF1p/wNI6DDmqXwD/+927i1eSWU13sIrw4Xbskr7WDWZkqZ4O2WVnJHGWW3q87qDZKbjHrN+W2B3KraMLR4ywF9QBwZ8LWrd3OoP/g8Edg1AlsjN3FmZgFatb8qJ83cjFZQc9sTuQnEJLjcTMR4RGDvCOyY3K6t5fvcAUu56WkrSg5fXpUrc4p4OQpXiFPNb1NgwjSIABGYCYGNkltOv6qUs72b3H135U649p/pOs8lgS45U97P1blCvN30iU/pP6ZFBDaFwEbJLbZgdliuDm7W01pW9Xl1AK4KlY1cL2ZQSUS/MLiFufbNXxpG7Lju3Xe/qReYxhABImAjsFFyk21rcn5CSoNqb4kl4Vrp2x6wQ3MnhgMQGxYx0KJlsB3QIjeHgJJc7oILsjD2Iux2+vNIBIjAghDYKLnJqjS5v96DFErnTpa4XUcG59pwdYnsMK4OYBkkQ2RmKhslN5Uhi53nEhybJ0Nn8poIEIETCGyR3MSy2BzLSAEsuz4X1QKU2LKaI12apXmu0AZZkLjIBsVJ1ld1v8tLdfTjOyEdxyS5qU65C19LUmye9J3AcyJABE4gsGFyk/mQJT9p5urc9kUIBIAQSfGvNM8VTAlwukgtNKuwd7U196B37E1wnozUaSe5CU4FxM7mydKMteX4+oK67SZkywn5ehvU95CDl7apS3ruf3bOc0uKo81FgtdqbfDx3Cq5iY0FBaRfGAtBiG9lW5bDO6Hn8r4IqRXV1nzBPu655wNskDwa2iDXYpvYmPr1IriUQO9eLrnJZHw2T+ZmFMY7vPCpUUmX5DRtKEmFL0h0IVolBGn6sX5SWHR+MYvvIp33WV+qQ32vHwQpGy7ISSMyUGASGyz9Nk5upbU3K39WC7Pw7wrTd6eaDgWCikdhZsrOIjfBJfKuxJKZ7R3q8iHvT4BA5ldgcpJkoq/BJDclwpyv3ejWMh3EMnqm1vRzbIi+uCojtinj6DbEsteWyU1slpXzY6Xh1OExH3SFFxbyNc2KvpOWzpkJR9+RiMzcvfmut55n2A4QiNR6YvmxlQG1cE71NcTITVbXz/21Cnld/SFFLK1narsz86PA2djSR/s3ZrUhhsnWyU3szt1M1DlwrGPMBznhM5F00X5xmbi1ypaU/fpxnCkaRbJT6fLeShCI1DyEdKRdW/7h15EUxMeRV5rBpOM29WuRW2SotDSLSqe8NBmFbeqN5YQyV35okUlNt6ieod1SG4jZ0BhSnflRMaoNKTx2Qm4l/Tehr0uukx9yKT/k3JuY4OTdLNpmJhOoYgLKfIdc8kU65+DOOAtGIEIyxwEkkXb9Y5NE5Ms3JCaL3MJVFhpxIs0tB1KN6BymKRl6VGIwCpTG12xETzcQwerzmdyGVNbcA7mJ/ZrHk+TjSseexwMZGB9sR3EpP+TeM/LjUX7Fk8OHb65OLl5m+sXkJvIjZZCVZLJbxenK40YQMF6IBslo5gmJ6FiLMpoGZAWI5wQ5y5IZRMGRMDVNa7LtkayCJYikdpmMP4a7jMKq9XKGRgrhOV2C2qerLYePHG12z0113Au5CZ6af8YguCMZGK0gR1/X8mnko/CYzsATKQeOrTYlOmem23p/ctIwyqBUcr3SyNGDcRaGgPHCtZzfRVb6QsmCtIdqf0Z8WWkg/LUKcWPz0KNuWhhJmseVCEKBE9TcwiQtG8Jm3dAGKfyOW6yEAse2IZUd90RuDgfNy1YN2nBNZ9ChidqTHeaFowAXp8Yx0p1wTKvHibxnWaOWY/pnpnl8N2JyYuHBh2JXcmyejAG5pXAjF7QymEFWCDHwv+iM+I2am9VXFcqT6y7i9dPU+KE5LbKx0ukTZtlgEZFhQ4hF40s4NMCS2UffPs/skdwEJ/1wkv7fviQnJNbKe0YrydHdffzT9Yzm0SihHhOPnwipFQ/7t/SKJ9G40yp7LFlWmPex2xAYuWDzpAXi1sIM5x+bzZyt+pI0orp71nFEcjvWcCLpNnS0ChjruT5huZgYBVqD3MK0QwPGtCFMO7wG8HtKzlJApv5VCkA/fQAv60jT6fN8/7na5zoiV2pgXUQnNXBpjj/2V4e6aB+s07txDOPWvNaanCxbJWl2/cQOIfaqtZtMX7bKnhIc9J1s4JpId1BNtEQvxp0JASOntwoqfcEbUVPqjkhuyS+7hoInLlpfzym9S+5Z5BbWJEVe0DcoWq2G3Erw2EtcJQoZDOT+VUlgChwNG8SW1dkxBVZMY8UIGF+kLQIxyOqmlMlG/EaBXkAM4ZdmSzdfj4nJLbffMLThOBjH192dT2mDS5NHIkAEiMDmEDCaKo4DNJyxRmdtg6xcPHfMILeskY0G8bZqlS5NOU5NDEZ6raYOY5jyYgjax47nRIAIEIFNIWAQV2upGqOAbhGgD0oXuUlcYyRkQ6Y2nYT8kWw6CSNLDdHXq/Z5Fy7ayR2q1SJAX68w8tg2+GnznAgQASKwGQQiTYTHArjrvgVEJrmF6/o1tqcwBmIkm0JFj6mJwfgwCFdvCef7iYqN0ZEhflPbEKbPayJABIjAZhAwalFSSMsuALIFRrjuYWMVDguETHKzVuhwW4pY61Qmm/NEj6mJIVK7FJIW3AS/8Jcc7TmHDZb/GEYEiAAR2AQC1mjIsFT2ro+1upjxOeQmzxo1Hy+ZxqkMw07WeFRe46EpmvQKbYgOE3dYhgZMYYNLm0ciQASIwOYQiKyDGJa1yQEdDpQCcpOBJeFowjBNIbZkX5uXbvjsqH1uXrphE2uoh9iQpUv4YO5zTpdaRwBnStrG/8xaaYwlRzfitHS//VhpUi4RIAILRkALMotsZGJnZ43NmWZMVm0MFnHx3FHJUFZDCH9CGp21HU+O6O7/s0jRPT/kqDZbNsh6fNl6BPqLLdnPDtE/fBbA74TO0Ou/nUunUEfrGsCzI3pL8OOtZxhGBIjAThDQUX7uy7ezObAWLN7k0lkK9Bp2eDZk1dRqpDmGjAS5CUl8BMBpY6Q7RCaA7wPwJZLbEBT5LBEgAkRgwwh0kJvwx58AuNlSIABwVwCfTRCb3GLNbSkOox5EgAhMh4A0twG4QEc7yojH0WuQWks+20tTzierLcfQzSA3IYsXx56fMhzArQC8v4PYSG5TOoVpEQEiMD8CSmpXRwpHGdqf1cRojZxMWWfF93S4JPXs2PcyyU3UffTYunTJB/CHHm6pU9bcusDkfSJABLaBgBJbOJfPKiCjK5ZrP5vM0Wv9YihljBIVWVfHnh87vIDcZh1gAuB5LdDjASS3sTMO5RMBIjA/AtokmENsUlxKvNbITZ0jGJVhWWlMlYgXx0Dn5HUrjaFhBeQmussAk68bmmbp8wCkCbfkR3IrBZnxiQARWB8CuutyWDjKvlcy/+7c8EawY7bEsVZSaTwWohIhVJlqIf198pdz/yfEOXkfXCG5ib5vm3KAiQ4g+YIPVMY5yS3MkLwmAntCwKqhbNF+g0ga29EYNawbHQ4RYmxtaOniu2OENI81Qm3iDMvpaJOok1v72IPcROeX1NbDkgfgtpkDSEIcSW4WoAwjAltGQGsUYU1E+pHMEYMaX9ZPlIEY8p+8AB7iD9U/LPwaE9W1JhXGOQ4uCchRJms/Iowc6pizeanRH9e5JmWYztDrnuQm5j9xaNqp5wF8GYDXhzhnXpPcUuDyHhHYIgJBQe2XFdIs1iA4LfTDARSz9A319YWuxuLbKeet5r8wgk/iWsuS2trBdktmqJ9BXC3cjBpjcv+8MI0a1wPI7e/C/FJDHycDwC8YPskNIrk5IHkkAntAIGgqk8Ja+pukJuJ+x1F72hxnDaBoFdJLxi6HiER/g/QbdvqEmCPTAeodG/I0zdZWOVNjOYDcxLRRBpj0GEDiwXw4JblNnZGYHhGYE4GgAD82zQU7YZ+hTXl+v5I/+KFVSM9pU1faRu0I1jM5NS33XE9yOzZzenJag1ncvamOA8lNmEQGmNy8lr4A7gGgdAAJya2WAyiHCKwRAb8E8PUPNgw99Klpv5IQnKw96dcw1kZuMiqy8fNtd+cTkNvxY8JLM0s3F3+MYwVyE2xfWkM3WccSwIcazup3wZpbDYdQBhFYAwLB6LzGRqQx8nJNcbH7K7FbyLnxs/Q2NnKNknhmzc2v+Ur6LXkBrhKncxdyS/chYZXITXQfNMBEphfoOpYNX/W8mIzcdNudB3rLqrnNf2VZN/nLvVYf7xCf8VkiQAQ8BIICuTFwIShkuwrh1n0vmcWdBna7svI4JN8p7G54x1Yzohe3kzCNmmBrOyBjWa6GX1x6Yx4rktugASaRHc09dxSdjkZu2mR/js59tPqkY4rK8m5CfI1BW2P6lrKJwG4Q8N664zwuMX7L5Kb2eaYfThvTGayh/ak5gBZhhpnIIK5rjTh+X6Yo1iLA8Jna1xXJTfTvNcBE1q0MHTTwehRy05pYCaHFzJApNa0PrNq+pTwisBsEgjft2FQS1DJaNZYu8ls6gMGIUIHhel9n4/51/v3wPJPcWnPh5Dkny5Lh33fxxj5WJjfBtmiAiU43kXUra/6qkpt+/EjNq/bv4rH9S/lEYBcIBIX4hWJ00BcnL++R9BwoGyC3VjOiTkiXbW+uNEqsAzbO/vBoEVMYR66Nfjz56pd+GEk3rAE0+kEteWOEjUBuAud/zNFV1qnU2p7hgkFB1citcnOpZZTMI229czn4MQ4RIAKKgFEoS/OI/0VqrpCxdnIT84PaqVXIuLBkrU1ltcjSymSR5k6XTnhsjaa0ZNYOA/DaUJHI9f8G8IbIPSv4nC5dtZZnPWuFXWYFRsIe15V2zv2cNUUj6ZcGk+ByHMI4RCCFQDDs338Jpf/H/ILcCLnJAshhH5dvv5zLCMfODn/jI8GcOyd+iKxNGaabrCmm/Dn0XgG5vVuH6t8QKh+5lgEm94npJ+tTRp6zgl8N4C7WjUjYYHKL1OgjyVUJbvXJxrBjOBEgAhEEtEYhK5Nco3+Zx2YSm4jQwlziyP/YbxQRv9hgsVFtCIfpy/UVKQx8o7SfyGF3OPr3w3PF2yJWCZulxuZ0LCE3eQbAvQHk9pF9wtoiR6YNFNCBkOpX6u4AuY8NapbM/CDJ1aUk3uQDilw+4JEIEIGNIKAEJc2Lk5G19m8e0lzKaLmCPrc/d64H8LiCErsxwERqcwCkVpfz+xSA0yXdqchN80WObmPFmSw/On/ySASIABHYHAJ9yE1AAPCrBaX7oS9XB5BIbS7n9/cA7ucAn5DcwoXCc3SVVhBZbcZ9uMhRWjmkNaD0d1zf1dnOIxEgAitGQJsMZTUHrugwoR8BSH9Wzu9Yc3PqFQ4w+UkAb85JSOM82aUjRwDfUvDsY/1nc8+VnAqSOSw6npyv5jWFl8htzMPM1Z/xiAARWBgCxoTnw5D5mJrBAJfJV/WI6bXG8L41N7EVwNcDyB1gUlK4vzrEcoqam04PydWziICUOMO+3lhajc10Qyx4TQSIwAoQ6Gi6aXSwa59V2GxEchvg5yHkJsnqAJPcPrRYYe6Hv1MGkIQmjU1uhX1tvUa3lkwNCe3nNREgAitCIChQ5KtWVvUIt4E5NPvovXDisxSKJLcBPh9KbpK04TOfrErOZQDJP7LMmYDcpI8s5zcovwULKaTS48ASKyMwjAisAYGgOfJYSwtqc24lFX9TVX9Y/aDCZg04jaljDXIT/WTbm1RJnXGvMYAktHkCcpMpHTm/QVM3jBWBYmmuaoHy0F+8JgK7RiBYNeT4pRo03xz6H7RjXkhNanYyGs39SG4DclFFcrs5gLc4p/Q4np8yY0xy07yVpXJKx9x7xrJsVtokt1xAGY8ILA2BgNyOK4N0kVfX/aXZuWR9apGb2DhggElrAEmI2cjk5n8sWUTjwtzaoG6vtr5Hf8k7Jzs88qMtzAS8JgJrQSD4gj0Oqe4ir677a7F/CXrWJDexp8cAE3MASYjNQsgtJKAxr0luYSbgNRFYCwJBzc1vlvS/pFsvOcmtnodrk5toVjDARCZ0mwNIQgtHJrdwENOYpJUru5XvQ0x4TQSIwEIRCEaOHecNBfPYWn0PJLd6Dh2D3EQ72famoxSXASTRhZVDC0cmt9yRkh0mVb3dyvchJrwmAkRgoQgEX/iHVdG1c9/vk2iNTiO51XPoiOTWNcDkx0usILmVoMW4RIAIzI5A0O8mpOYTm7m3GsmtntvGIjfRUAeYfNyoz5j7BqasGpncrF3TDbUnDTo206dw4T0iQAQWioBO5LaWJZKw4whKX32Sm4/GsPMxyU00A/AdwS4AMoDk5qVaj0xufh9visFkLpw0YY7+L8WH8YkAEVggAjqx9VIdYOIKkNT+cmd4Bcyxr26Bpi1epbHJTQAAcJ4yRvYAkhC4hZAb+8FCx/CaCBABIrBEBKYgN7EbwMsA3LcvBmOSm+qXqrG5exzB2NeBfI4IEAEiMCUCU5HbUJsmIDd/eTdHZtYx2qIw1EY+TwSIABEgApUQILmdAFI3G7XILAxj02SlvEcxRIAIEIHRECC5nYC2YEFjITtzoNNoTqJgIkAEiAARKEOA5HYSr2A3irDG5l/LGpOt+ZcnJXWf6YjfKwHI/oRs6uyGjDGIABEgAvkIkNxOYlVYexOyE3LKno8G4GwAlwRzOUUOCe6kG3hGBIgAERiOAMmtiWFB7c2vycnCA0J01i4BVxtk5j/rzq9uasIrIkAEiAAR6I0Aya0JnS7/Zi0q4EhozOPlTW14RQSIABEgAr0QILm1YdNVc8YksZRsElzbJQwhAkSACJQhQHKz8QoW9U6R0Rj3svvxbO0ZSgSIABHYOQIkt3gGmIHgruM0g7g/eIcIEAEikI0AyS0NlTZRjt0HJ/IvTGvCu0SACBABIpCNAMmtGyodZHLFCO2PQmqywwDnuXW7gTGIABEgAvkIkNyKsJLdKGqQnDQ/XkhSy8eeMYkAESACRQiQ3IrgOkTWmty5AGSx5dwmS9nKSQiNS3eVQ84niAARIAJEYGoElOxkw1P5C+nJ312fMbU+TK+JwP8H+Y5KMqGpC4kAAAAASUVORK5CYII="
}))));

const StyledFooterLogoSection = styled__default["default"].div `
  margin-top: 3rem;
  text-align: center;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.sizes.sm}) {
    margin-top: 5rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    margin-top: 0;
    text-align: right;
    width: auto;
  }

  p {
    color: ${({ theme }) => theme.colors.grey[100]};
    font-size: ${({ theme }) => theme.fonts.sizes.small};
    max-width: 36rem;
    margin: 2.4rem auto 0.7rem;

    @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
      max-width: 32rem;
    }
  }

  address {
    color: ${({ theme }) => theme.colors.grey[700]};
    font-size: ${({ theme }) => theme.fonts.sizes.small};
    font-style: normal;
  }
`;

const FooterLogoSection = () => (jsxRuntime.exports.jsxs(StyledFooterLogoSection, { children: [jsxRuntime.exports.jsx("div", { children: jsxRuntime.exports.jsx(SvgLogoWithText, {}) }), jsxRuntime.exports.jsx("p", { children: "We're a gamified, hands-on cyber security training platform that you can access through your browser." }), jsxRuntime.exports.jsx("address", { children: "128 City Road, London, United Kingdom, EC1V 2NX" })] }));

var _path$5;
function _extends$9() { return _extends$9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9.apply(null, arguments); }
const SvgDiscord = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$9({
  viewBox: "0 0 30 30",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path$5 || (_path$5 = /*#__PURE__*/React__namespace.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Zm6.831-21.29a.05.05 0 0 1 .026.023c2.248 3.182 3.359 6.77 2.944 10.903a.06.06 0 0 1-.026.044 16.712 16.712 0 0 1-4.98 2.417.066.066 0 0 1-.039 0 .063.063 0 0 1-.03-.023 12.678 12.678 0 0 1-1.017-1.59.06.06 0 0 1 .012-.072.064.064 0 0 1 .022-.014 10.392 10.392 0 0 0 1.554-.71.064.064 0 0 0 .022-.022.06.06 0 0 0 .003-.058.063.063 0 0 0-.02-.023 7.857 7.857 0 0 1-.309-.233.063.063 0 0 0-.065-.008c-3.22 1.431-6.747 1.431-10.005 0a.064.064 0 0 0-.065.009c-.1.079-.204.157-.308.232a.062.062 0 0 0-.025.053c0 .01.004.02.009.028a.063.063 0 0 0 .022.021c.498.277 1.017.515 1.553.712a.063.063 0 0 1 .037.035.058.058 0 0 1-.002.05 11.286 11.286 0 0 1-1.017 1.591.066.066 0 0 1-.07.022 16.766 16.766 0 0 1-4.972-2.417.066.066 0 0 1-.025-.045C4.713 16.06 5.42 12.442 8 8.732a.057.057 0 0 1 .027-.022c1.291-.57 2.653-.977 4.053-1.209a.066.066 0 0 1 .037.005.063.063 0 0 1 .028.025c.19.323.361.656.513.997 1.508-.22 3.043-.22 4.551 0 .15-.34.32-.673.505-.997a.06.06 0 0 1 .027-.025.063.063 0 0 1 .038-.005c1.4.233 2.761.64 4.052 1.21Zm-11.99 6.818c0 1.064.808 1.93 1.79 1.93.996 0 1.788-.866 1.788-1.93.016-1.056-.784-1.93-1.789-1.93-.996 0-1.789.866-1.789 1.93Zm6.615 0c0 1.064.809 1.93 1.79 1.93 1.004 0 1.789-.866 1.789-1.93.016-1.056-.785-1.93-1.79-1.93-.996 0-1.789.866-1.789 1.93Z"
})));

var _path$4;
function _extends$8() { return _extends$8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8.apply(null, arguments); }
const SvgFacebook = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$8({
  viewBox: "0 0 31 30",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path$4 || (_path$4 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M30.183 15.091C30.183 6.755 23.428 0 15.09 0 6.755 0 0 6.755 0 15.091 0 22.624 5.519 28.867 12.733 30V19.454H8.9V15.09h3.833v-3.325c0-3.782 2.252-5.87 5.7-5.87 1.652 0 3.379.294 3.379.294v3.712h-1.904c-1.874 0-2.459 1.163-2.459 2.357v2.832h4.186l-.67 4.363H17.45V30c7.215-1.133 12.734-7.377 12.734-14.909Z"
})));

var _path$3;
function _extends$7() { return _extends$7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7.apply(null, arguments); }
const SvgInstagram = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$7({
  viewBox: "0 0 30 30",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path$3 || (_path$3 = /*#__PURE__*/React__namespace.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Zm-4.612-15a4.607 4.607 0 0 1 4.614-4.615A4.607 4.607 0 0 1 19.616 15a4.607 4.607 0 0 1-4.614 4.615A4.607 4.607 0 0 1 10.388 15Zm1.614 0c0 1.655 1.35 3 3 3s3-1.345 3-3-1.346-3-3-3-3 1.345-3 3Zm7.803-3.727a1.076 1.076 0 1 0 0-2.153 1.076 1.076 0 0 0 0 2.153Zm2.678-3.756c1.056 1.053 1.386 2.33 1.454 3.772.084 1.486.084 5.936 0 7.422-.073 1.442-.402 2.72-1.454 3.772-1.052 1.056-2.329 1.386-3.77 1.454-1.486.084-5.94.084-7.425 0-1.442-.073-2.715-.402-3.771-1.454-1.056-1.053-1.385-2.33-1.454-3.772-.084-1.486-.084-5.94 0-7.426.073-1.442.398-2.72 1.454-3.772 1.056-1.052 2.333-1.381 3.77-1.45 1.486-.084 5.94-.084 7.425 0 1.442.073 2.719.402 3.771 1.454Zm-2.176 14.5a3.037 3.037 0 0 0 1.71-1.711c.403-1.013.38-3.229.366-4.665-.002-.238-.004-.455-.004-.641s.002-.403.004-.641c.015-1.436.037-3.649-.366-4.665a3.037 3.037 0 0 0-1.71-1.71c-1.016-.402-3.242-.38-4.677-.367-.233.003-.445.005-.628.005-.186 0-.403-.003-.641-.005-1.435-.014-3.648-.037-4.664.366a3.037 3.037 0 0 0-1.71 1.711c-.401 1.016-.38 3.242-.366 4.678.002.233.004.445.004.628 0 .186-.002.403-.004.641-.015 1.436-.037 3.649.366 4.665a3.037 3.037 0 0 0 1.71 1.71c1.016.402 3.242.38 4.677.367.233-.003.445-.005.628-.005.186 0 .403.003.641.005 1.435.015 3.648.037 4.664-.366Z"
})));

var _path$2;
function _extends$6() { return _extends$6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6.apply(null, arguments); }
const SvgLinkedin = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$6({
  viewBox: "0 0 30 30",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path$2 || (_path$2 = /*#__PURE__*/React__namespace.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Zm-7.227-7.5h3.42V11.484h-3.42V22.5ZM7.5 7.981c0 1.094.887 2 1.981 2s1.981-.906 1.981-2a1.981 1.981 0 1 0-3.962 0ZM20.583 22.5H24v-6.051c0-2.962-.636-5.241-4.099-5.241-1.664 0-2.78.913-3.236 1.778h-.048v-1.502h-3.28V22.5h3.416v-5.455c0-1.436.273-2.825 2.051-2.825 1.753 0 1.779 1.64 1.779 2.917V22.5Z"
})));

var _path$1;
function _extends$5() { return _extends$5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5.apply(null, arguments); }
const SvgPinterest = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$5({
  viewBox: "0 0 30 30",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path$1 || (_path$1 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M30 15c0 8.286-6.714 15-15 15a14.94 14.94 0 0 1-4.44-.671c.611-.998 1.525-2.631 1.863-3.932.182-.701.932-3.568.932-3.568.49.931 1.917 1.723 3.435 1.723 4.524 0 7.785-4.16 7.785-9.332 0-4.954-4.047-8.662-9.248-8.662-6.472 0-9.914 4.343-9.914 9.08 0 2.2 1.174 4.94 3.043 5.812.284.133.435.072.502-.2.048-.206.302-1.228.417-1.7a.449.449 0 0 0-.103-.429c-.61-.756-1.107-2.135-1.107-3.423 0-3.309 2.504-6.508 6.775-6.508 3.683 0 6.266 2.51 6.266 6.102 0 4.059-2.05 6.871-4.718 6.871-1.47 0-2.577-1.215-2.22-2.71.423-1.784 1.24-3.707 1.24-4.995 0-1.15-.617-2.111-1.9-2.111-1.505 0-2.715 1.554-2.715 3.64 0 1.332.448 2.227.448 2.227s-1.482 6.278-1.754 7.451c-.303 1.295-.182 3.121-.055 4.307C3.956 26.788 0 21.357 0 15 0 6.714 6.714 0 15 0s15 6.714 15 15Z"
})));

var _g$3;
function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4.apply(null, arguments); }
const SvgXIcon = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$4({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}, props), _g$3 || (_g$3 = /*#__PURE__*/React__namespace.createElement("g", {
  "data-name": "Layer 1",
  imageRendering: "optimizeQuality",
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision"
}, /*#__PURE__*/React__namespace.createElement("path", {
  d: "m8.61 7.73 11.04 14.44h1.7L10.42 7.73H8.61z"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M15 0C6.72 0 0 6.72 0 15s6.72 15 15 15 15-6.72 15-15S23.28 0 15 0Zm3.81 24L14 17.71 8.49 24H5.43l7.14-8.16L5.04 6h6.3l4.35 5.75L20.72 6h3.05l-6.67 7.62L24.95 24H18.8Z"
}))));

var _path;
function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3.apply(null, arguments); }
const SvgYoutube = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$3({
  viewBox: "0 0 30 30",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Zm8.205-22.051a2.66 2.66 0 0 1 1.856 1.898c.439 1.675.439 5.168.439 5.168s0 3.494-.439 5.168a2.62 2.62 0 0 1-1.856 1.868C21.567 22.5 15 22.5 15 22.5s-6.567 0-8.205-.449a2.62 2.62 0 0 1-1.856-1.868C4.5 18.51 4.5 15.015 4.5 15.015s0-3.494.439-5.168a2.66 2.66 0 0 1 1.856-1.898C8.433 7.5 15 7.5 15 7.5s6.567 0 8.205.449Zm-10.353 3.894v6.344l5.489-3.172-5.489-3.172Z"
})));

const StyledFooterSocialLink = styled__default["default"].a `
  height: 2.4rem;
  width: 2.4rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    height: 3rem;
    width: 3rem;
  }

  svg {
    height: 100%;
    width: 100%;
  }
`;

const socialIconLinks = [
    {
        href: 'https://twitter.com/tryhackme',
        icon: SvgXIcon,
        description: 'Follow us on X',
    },
    {
        href: 'https://www.linkedin.com/company/tryhackme/',
        icon: SvgLinkedin,
        description: 'Follow us on Linkedin',
    },
    {
        href: 'https://discord.com/invite/tryhackme',
        icon: SvgDiscord,
        description: 'Join Discord',
    },
    {
        href: 'https://www.facebook.com/people/Tryhackme/100069557747714/',
        icon: SvgFacebook,
        description: 'Follow us on Facebook',
    },
    {
        href: 'https://www.youtube.com/channel/UCRnWD3BsY5Co2MMETB7lHQw',
        icon: SvgYoutube,
        description: 'Follow us on our Youtube channel',
    },
    {
        href: 'https://instagram.com/realtryhackme',
        icon: SvgInstagram,
        description: 'Follow us on Instagram',
    },
    {
        href: 'https://www.pinterest.co.uk/RealTryHackMe/',
        icon: SvgPinterest,
        description: 'Follow us on Pinterest',
    },
];
const FooterSocialIconLinks = () => (jsxRuntime.exports.jsx(StyledFlex, { width: "auto", alignItems: "center", justifyContent: "flex-end", gap: "1.4rem", children: socialIconLinks.map((link) => (jsxRuntime.exports.jsx(StyledFooterSocialLink, { href: link.href, target: "_blank", rel: "noreferrer", "aria-label": link.description, children: jsxRuntime.exports.jsx(link.icon, {}) }, link.href))) }));

const StyledFooterBottom = styled__default["default"].div `
  border-top: 0.2rem solid ${({ theme, isAuth }) => (isAuth ? theme.colors.border.main : darkColors.secondary.lighter)};
  gap: 1rem;
  padding-top: 2.2rem;
  padding-bottom: ${({ isAuth }) => (isAuth ? '2.2rem' : '0')};

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }

  p,
  a {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
  }

  svg {
    fill: ${({ theme, isAuth }) => (isAuth ? theme.colors.icon.main : theme.colors.grey[700])};
    transition: all 150ms ease-in-out;
    width: 3rem;

    &:hover {
      transform: scale(1.1);
      fill: ${({ theme, isAuth }) => (isAuth ? theme.colors.text.main : theme.colors.grey[200])};
    }
  }

  & > div:last-child {
    @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
      justify-content: center;
      margin-top: 2.4rem;
    }
  }

  ${({ theme, isAuth }) => `
    p {
      color: ${isAuth ? theme.colors.paragraph : theme.colors.grey[700]}
    };
  `}
`;
const StyledFooterTop = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4.2rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    flex-direction: row;
  }
`;
const StyledBackgroundColorWrapper = styled__default["default"].footer `
  ${({ isAuth }) => !isAuth &&
    `
    background-color: ${lightColors.secondary.light};
    padding-top: 6rem;
    padding-bottom: 2.2rem;
  `}
`;
const StyledLegalLinks = styled__default["default"].div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: column;
  gap: 1.5rem;
  justify-content: center;

  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    gap: 1.8rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    justify-content: start;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: row;
    gap: 2rem;
  }

  a {
    color: ${({ theme }) => theme.colors.grey[700]};
    text-decoration: none;
    transition: color 0.2s ease-in-out;

    &:hover {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;

const Footer$1 = ({ isAuth }) => {
    const currentYear = new Date().getFullYear();
    return (jsxRuntime.exports.jsx(StyledBackgroundColorWrapper, { isAuth: isAuth, children: jsxRuntime.exports.jsxs(Container$1, { children: [!isAuth && (jsxRuntime.exports.jsxs(StyledFooterTop, { "data-testid": "top-footer", children: [jsxRuntime.exports.jsx(FooterLinks, {}), jsxRuntime.exports.jsx(FooterLogoSection, {})] })), jsxRuntime.exports.jsxs(StyledFooterBottom, { "data-testid": "bottom-footer", isAuth: isAuth, children: [jsxRuntime.exports.jsxs(StyledLegalLinks, { children: [jsxRuntime.exports.jsxs("p", { children: ["Copyright TryHackMe 2018-", currentYear] }), !isAuth && (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(reactRouterDom.Link, { to: "/legal/privacy-policy", children: "Privacy Policy" }), jsxRuntime.exports.jsx(reactRouterDom.Link, { to: "/legal/terms-of-use", children: "Terms of Use" }), jsxRuntime.exports.jsx(reactRouterDom.Link, { to: "/legal/ai-terms-of-use", children: "AI Terms of Use" }), jsxRuntime.exports.jsx(reactRouterDom.Link, { to: "/legal/acceptable-use-policy", children: "Acceptable Use Policy" }), jsxRuntime.exports.jsx(reactRouterDom.Link, { to: "/legal/cookie-policy", children: "Cookie Policy" })] }))] }), jsxRuntime.exports.jsx(FooterSocialIconLinks, {})] })] }) }));
};

var _g$2, _defs$1;
function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2.apply(null, arguments); }
const SvgStreakBroken = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$2({
  width: 20,
  height: 23,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g$2 || (_g$2 = /*#__PURE__*/React__namespace.createElement("g", {
  clipPath: "url(#streak-broken_svg__a)"
}, /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.442 2.302a26.876 26.876 0 0 0-2.505 2.689C10.72 3.307 9.206 1.595 7.5 0 3.114 4.093 0 9.434 0 12.65 0 18.369 4.473 23 10 23s10-4.631 10-10.35c0-2.39-2.321-7.327-5.558-10.348Zm-.866 15.303a5.988 5.988 0 0 1-3.447 1.082c-3.22 0-5.843-2.144-5.843-5.624 0-1.735 1.082-3.263 3.247-5.876.313.36 4.414 5.634 4.414 5.634l2.618-3.005c.184.304.35.608.502.894 1.223 2.344.71 5.345-1.491 6.895Z",
  fill: "#B8BEC9"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "m1 6 17 16",
  stroke: "#B8BEC9",
  strokeWidth: 2,
  strokeLinecap: "round"
}))), _defs$1 || (_defs$1 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
  id: "streak-broken_svg__a"
}, /*#__PURE__*/React__namespace.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v23H0z"
})))));

var _g$1;
function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
const SvgStreakCracked = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
  width: 30,
  height: 31,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g$1 || (_g$1 = /*#__PURE__*/React__namespace.createElement("g", {
  fill: "#FFBB45"
}, /*#__PURE__*/React__namespace.createElement("path", {
  d: "M18.594 21.804a5.939 5.939 0 0 1-3.469 1.117c-2.23 0-4.175-1.052-5.168-2.88l-2.025 1.104-1.238 1.57c1.813 2.816 4.85 4.663 8.306 4.663 4.5 0 8.307-3.14 9.588-7.466l-3.944-1.408c-.244 1.298-.925 2.493-2.05 3.307v-.007ZM9.256 17.114c0-1.79 1.088-3.371 3.263-6.07.313.367 4.437 5.818 4.437 5.818l2.632-3.1c.187.31.356.627.506.924.131.251.231.51.325.775l1.825-2.041 2.456 1.214c-.768-2.648-2.725-6.226-5.237-8.628a27.014 27.014 0 0 0-2.519 2.777c-1.225-1.738-2.75-3.507-4.462-5.154-4.413 4.23-7.544 9.74-7.544 13.065 0 .95.118 1.873.337 2.751l1.413-1.298 2.556-1.027.012-.006ZM23.413 23.174s1.375.278 2.937-.233l1.975 1.886-1.175 2.538s-2.75.724-5.106-.116l1.362-4.075h.007ZM3.706 23.833l1.894-.071 1.806 2.163s-.456.969-.462 1.453L4.7 26.901l-1.919.393s.125-1.679.925-3.455v-.006Z"
}))));

var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgStreakfreezeicon = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  width: 25,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React__namespace.createElement("g", {
  clipPath: "url(#streakfreezeicon_svg__a)"
}, /*#__PURE__*/React__namespace.createElement("path", {
  d: "M16.343 3.81a29.162 29.162 0 0 0-1.763 1.813 38.658 38.658 0 0 0-3.885-4.217 1.198 1.198 0 0 0-1.64 0c-2.333 2.19-4.329 4.701-5.747 7.108C1.908 10.889 1 13.28 1 15.209c0 6.493 5.118 11.8 11.5 11.8S24 21.702 24 15.209c0-1.47-.68-3.519-1.713-5.53-1.05-2.042-2.537-4.192-4.299-5.866a1.197 1.197 0 0 0-1.645-.002Zm-.66 15.75a5.315 5.315 0 0 1-3.047.949c-1.473 0-2.757-.486-3.662-1.311-.895-.816-1.474-2.011-1.474-3.558 0-1.212.651-2.375 2.4-4.545 1.133 1.43 3.15 4.005 3.711 4.722a1.197 1.197 0 0 0 1.845.048l1.642-1.873c.861 1.993.328 4.346-1.415 5.567Z",
  fill: "#719CF9",
  stroke: "#CEDDFF",
  strokeWidth: 2
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M16.343 3.81a29.162 29.162 0 0 0-1.763 1.813 38.658 38.658 0 0 0-3.885-4.217 1.198 1.198 0 0 0-1.64 0c-2.333 2.19-4.329 4.701-5.747 7.108C1.908 10.889 1 13.28 1 15.209c0 6.493 5.118 11.8 11.5 11.8S24 21.702 24 15.209c0-1.47-.68-3.519-1.713-5.53-1.05-2.042-2.537-4.192-4.299-5.866a1.197 1.197 0 0 0-1.645-.002Zm-.66 15.75a5.315 5.315 0 0 1-3.047.949c-1.473 0-2.757-.486-3.662-1.311-.895-.816-1.474-2.011-1.474-3.558 0-1.212.651-2.375 2.4-4.545 1.133 1.43 3.15 4.005 3.711 4.722a1.197 1.197 0 0 0 1.845.048l1.642-1.873c.861 1.993.328 4.346-1.415 5.567Z",
  fill: "#719CF9",
  stroke: "#C9DAFF",
  strokeWidth: 2
}), /*#__PURE__*/React__namespace.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.635 21.506a6.314 6.314 0 0 0 3.62-1.13c2.31-1.617 2.85-4.749 1.564-7.195-.119-.225-.248-.46-.387-.699a.197.197 0 0 0-.319-.029l-2.41 2.75a.197.197 0 0 1-.305-.006c-.69-.88-3.612-4.61-4.342-5.514a.19.19 0 0 0-.297.003c-2.173 2.617-3.26 4.18-3.26 5.95 0 3.632 2.755 5.87 6.136 5.87Z",
  fill: "#C9DAFF"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M9.707 3.438c1.178 1.11 4.4 4.554 4.4 4.554l-1.06 3.811c.135.135.025.19 0 0-3.31-3.45-2.78-2.902-3.31-3.45.079-.092-.085-.087 0 0l-6.084 6.001c-.133.063-.284-.032-.27-.178.242-2.434 3.386-8.023 6.324-10.739ZM15.022 24.904l-2.687-2.442 8.875-3.286c-.963 2.01-2.533 3.91-6.188 5.729.052.048-.068.021 0 0Z",
  fill: "#fff",
  fillOpacity: 0.2
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M1.804 29.414.178 17.074c-.028-.215.26-.315.37-.128l3.365 5.684a.2.2 0 0 1 .022.153l-1.739 6.656c-.055.212-.363.193-.392-.025ZM23.232 28.215l1.473-10.22c.029-.2-.221-.311-.351-.158l-3.557 4.226a.2.2 0 0 0-.035.195l2.083 5.994c.07.198.357.17.387-.037ZM5.925 28.91l-1.371-4.558a.2.2 0 0 1 .288-.233L7.1 25.37a.2.2 0 0 1 .096.227l-.887 3.307c-.052.195-.327.2-.385.006ZM19.212 29.132l1.371-4.557a.2.2 0 0 0-.288-.233l-2.26 1.25a.2.2 0 0 0-.096.226l.888 3.308c.052.194.327.199.385.006ZM9.737 31.434l-1.44-5.105a.2.2 0 0 1 .236-.25l2.986.65a.2.2 0 0 1 .146.26l-1.546 4.456a.2.2 0 0 1-.382-.011Z",
  fill: "#C9DAFF"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M7.387 6.878c.648-1.157 1.12-1.705 2.24-2.698l1.391 1.39v-.003l-3.63 1.31ZM19.096 21.59c-1.393 1.248-2.233 1.883-3.933 2.728l-1.686-1.447 5.62-1.281Z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
  id: "streakfreezeicon_svg__a"
}, /*#__PURE__*/React__namespace.createElement("path", {
  fill: "#fff",
  d: "M0 0h25v32H0z"
})))));

const StyledStreakTrigger = styled__default["default"].button `
  align-items: center;
  color: ${({ theme, $streakToRepair }) => ($streakToRepair ? '#ffbb45' : theme.colors.primary.main)};
  display: flex;
  gap: 0.5rem;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
`;
const StyledStreakTriggerText = styled__default["default"].p `
  font-size: 2.4rem;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  color: ${({ theme, $usingStreakFreeze, $streakToRepair }) => {
    if ($streakToRepair)
        return '#ffbb45';
    if ($usingStreakFreeze)
        return darkColors.info.main;
    return theme.colors.primary.main;
}};
  margin: 0;
`;
const StyledStreakTriggerIcon = styled__default["default"](FontAwesomeIcon) `
  && {
    color: ${({ theme }) => theme.colors.primary.main};
    height: 2.4rem;
    width: 2.1rem;
  }
`;
const StyledStreakFreezeIcon = styled__default["default"](SvgStreakfreezeicon) `
   height: 3.2rem;
   width: 2.5rem;
   object-fit: contain;
`;
const StyledStreakCrackedIcon = styled__default["default"](SvgStreakCracked) `
  height: 3rem;
  width: auto;
  margin-left: -0.2rem;
`;
const StyledStreakContent = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  gap: 1rem;
  
  background: ${({ theme }) => theme.colors.background.lighter};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  color: ${({ theme }) => theme.colors.text.main};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: 2.1rem;
  max-width: 80vw;
  padding: 2.4rem;
  z-index: 1;


`;
const StyledStreakRepair = styled__default["default"].div `
  display: flex;
  gap: 2rem;
  padding: 2rem;
  background: ${darkColors.placeholder.light};
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
`;
const StyledImage$1 = styled__default["default"].img `
  width: 3.2rem;
  height: 3.2rem;
  object-fit: contain;
`;
const StyledContent$8 = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 1;
`;
const StyledTitle$9 = styled__default["default"].p `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  color: ${darkColors.text.main};
  margin: 0;
`;
const StyledParagraph = styled__default["default"].p `
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  color: ${darkColors.text.lighter};
  margin: 0;
`;
const StyledStreakRepairButton = styled__default["default"](Button$1) `
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  padding: 0.6rem 1.6rem;
  margin-top: 0.4rem;
  width: fit-content;
`;
const StyledStreakTitle = styled__default["default"].p `
  font-size: 2rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  margin: 0;
`;
const StyledStreakSubTitle = styled__default["default"].p `
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  margin: 0;
`;
const StyledLargestStreak = styled__default["default"].p `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  margin: 0;
  svg {
    color: ${({ theme }) => theme.colors.primary.main};
    margin-right: 0.6rem;
  }
`;
const StyledTopBorderedContainer = styled__default["default"].div `
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
  padding-top: 1.6rem;
`;
const StyledStreakFreezeParagraph = styled__default["default"].p `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  margin: 0;
  svg {
    color: rgba(113, 156, 249, 1);
    margin-right: 0.6rem;
  }
`;
const StyledHelpPageLink = styled__default["default"](reactRouterDom.Link) `
  color: ${({ theme }) => theme.colors.text.main};
  background-color: ${({ $isDarkMode }) => $isDarkMode && '#151C2B'};
  border: 1px solid ${({ $isDarkMode }) => ($isDarkMode ? '#3E475A' : '#d4d8df')};
  text-decoration: none;
  border-radius: 0.4rem;
  padding: 1rem 1.6rem;
  text-align: center;
  &:hover {
    background-color: ${({ $isDarkMode }) => ($isDarkMode ? '#525a6a' : '#eeeff2')};
  }

  p {
    line-height: 1.6rem;
  }
  span {
    margin-left: 0.8rem;
  }
`;
const StyledStreakHeader = styled__default["default"].div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const StyledShareButton = styled__default["default"](Button$1) `
  width: 3.6rem;
  height: 3.6rem;

  svg {
    width: 1.6rem;
    height: 1.399rem;
  }
`;
const StyledStreakGrid = styled__default["default"].div `
  display: grid;
  grid-template-columns: repeat(7, 1fr);
`;
const StyledWeekdayIconWrapper = styled__default["default"].div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.6rem;
  height: 3.6rem;
  border-radius: 100%;
  border-width: 0.1rem;

   svg {
    width: 2.4rem;
    height: 2.4rem;

    ${({ $state }) => $state === 'frozen' &&
    styled.css `
        color: ${({ theme }) => theme.colors.info.main};
    `}

    ${({ $state }) => $state === 'complete' &&
    styled.css `
        color: ${({ theme }) => theme.colors.primary.main};
    `}

    ${({ $state }) => $state === 'pending' &&
    styled.css `
        color: ${({ theme }) => theme.colors.grey[600]};
    `}

    ${({ $state }) => $state === 'repair' &&
    styled.css `
        width: 1.8rem;
        height: 1.8rem; 
        color: ${accentColors.warning.dark};
    `}
   
     ${({ $state, $isDarkMode }) => $state === 'future' &&
    styled.css `
        color: ${({ theme }) => ($isDarkMode ? theme.colors.grey[900] : theme.colors.grey[600])};
      `}

     ${({ $state, theme, $isDarkMode }) => $state === 'missed' &&
    styled.css `
        width: 2.0rem;
        height: 2.3rem;
        & path {
          fill: ${$isDarkMode ? theme.colors.grey[800] : theme.colors.grey[400]};
          stroke: ${$isDarkMode ? theme.colors.grey[800] : theme.colors.grey[400]};
        }
    `}
  }
    
  ${({ $state }) => $state === 'frozen' &&
    styled.css `
      border-color: ${({ theme }) => theme.colors.info.main};
      background-color: rgba(113, 156, 249, 0.1);
  `}

  ${({ $state }) => $state === 'complete' &&
    styled.css `
      border-color: ${({ theme }) => theme.colors.primary.main};
      background-color: rgba(163, 234, 42, 0.1);
  `}
   ${({ $state, $isDarkMode }) => $state === 'missed' &&
    styled.css `
      border-color: ${({ theme }) => ($isDarkMode ? theme.colors.grey[800] : theme.colors.grey[400])};
  `}
   ${({ $state, $isDarkMode }) => $state === 'repair' &&
    styled.css `
        border-color: ${$isDarkMode ? accentColors.warning.dark : accentColors.warning.light};
        background-color: ${$isDarkMode ? lighterVariations.warning.dark : lighterVariations.warning.light};
    `}
  ${({ $state, $isDarkMode }) => $state === 'future' &&
    styled.css `
      border-color: ${$isDarkMode ? 'rgba(62, 71, 90, 1)' : 'rgba(212, 216, 223, 1)'};
      background-color: ${({ theme }) => ($isDarkMode ? theme.colors.grey[600] : theme.colors.grey[200])};
  `}
  ${({ $state, theme }) => $state === 'pending' &&
    styled.css `
      border-color: ${theme.colors.grey[600]};
    `}
  ${({ $isToday }) => `border-style: ${$isToday ? 'dashed' : 'solid'}`};
`;
const StyledWeekday = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.8rem;

  p {
    font-family: ${({ theme }) => theme.fonts.familyUbuntu};
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    line-height: 2.4rem;
    color: ${({ theme }) => theme.colors.grey[600]};
    ${({ $isToday, theme }) => $isToday && styled.css `color: ${theme.colors.text.main}; font-weight: ${theme.fonts.weight.semiBold}`};
  }
`;

var streakRepairSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle%20cx%3D%2216%22%20cy%3D%2216%22%20r%3D%2215.4861%22%20fill%3D%22%2349433B%22%20stroke%3D%22%23FFBB45%22%20stroke-width%3D%221.02778%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M23.8688%2011.8155C23.7778%2011.437%2023.2972%2011.3105%2023.0219%2011.5857L20.6245%2013.9826L18.0219%2013.9826V11.381L20.4193%208.98415C20.6947%208.70899%2020.5681%208.2284%2020.1896%208.13761C19.4477%207.95939%2018.6443%207.9463%2017.8119%208.14539C15.8874%208.6056%2014.3857%2010.2398%2014.0787%2012.1933C13.9157%2013.0051%2013.994%2013.816%2014.2383%2014.5485L8.66051%2020.1242C7.77983%2021.0046%207.77983%2022.4312%208.66051%2023.3113C9.07266%2023.7527%209.64892%2024%2010.1982%2024C10.7476%2024%2011.352%2023.7799%2011.7927%2023.3397L17.3705%2017.764C18.1052%2018.0062%2018.9148%2018.0846%2019.756%2017.952C21.7106%2017.6439%2023.3451%2016.1425%2023.8055%2014.2202C24.0598%2013.3589%2024.0473%2012.5574%2023.8688%2011.8155ZM10.477%2022.2468C10.062%2022.2468%209.72534%2021.9103%209.72534%2021.4955C9.72534%2021.0803%2010.062%2020.7441%2010.477%2020.7441C10.8919%2020.7441%2011.2286%2021.0803%2011.2286%2021.4955C11.2286%2021.9118%2010.8919%2022.2468%2010.477%2022.2468Z%22%20fill%3D%22%23FFBB45%22%2F%3E%3C%2Fsvg%3E";

const StreakRepair = ({ onStreakRepair, streakToRepair, isExtendedRepair = false }) => (jsxRuntime.exports.jsxs(StyledStreakRepair, { children: [jsxRuntime.exports.jsx(StyledImage$1, { src: streakRepairSVG, alt: "Streak Repair" }), jsxRuntime.exports.jsxs(StyledContent$8, { children: [jsxRuntime.exports.jsxs(StyledTitle$9, { children: ["Don't lose your ", streakToRepair, " day streak!"] }), jsxRuntime.exports.jsx(StyledParagraph, { children: isExtendedRepair
                        ? 'Complete 1 room within the next few days to save your streak!'
                        : 'Complete 1 room until the end of today to save your streak!' }), jsxRuntime.exports.jsx(StyledStreakRepairButton, { onClick: onStreakRepair, variant: "solid", color: "add", children: "Repair streak" })] })] }));
const StreakRepairCompleted = () => (jsxRuntime.exports.jsxs(StyledStreakRepair, { children: [jsxRuntime.exports.jsx(StyledImage$1, { src: streakRepairSVG, alt: "Streak Repair" }), jsxRuntime.exports.jsxs(StyledContent$8, { children: [jsxRuntime.exports.jsx(StyledTitle$9, { children: "You\u2019ve saved your streak!" }), jsxRuntime.exports.jsx(StyledParagraph, { children: "Great job! Keep completing rooms daily to keep your streak alive!" })] })] }));

const Streak = ({ streak, usingStreakFreeze, streakFreeze, streakToRepair, onStreakShare, extendedStreakToRepair, largestStreak, onStreakRepair, isStreakShareEnabled, weeklyBreakdown, hasCompletedRepairToday, onStreakOpenChange, }) => {
    const { theme } = React.useContext(SwitchThemeContext);
    const isDarkMode = theme === 'dark';
    const activeStreakToRepair = streakToRepair || extendedStreakToRepair;
    const isExtendedRepair = !!extendedStreakToRepair && !streakToRepair;
    const getStreakIcon = () => {
        if (activeStreakToRepair)
            return jsxRuntime.exports.jsx(StyledStreakCrackedIcon, {});
        if (usingStreakFreeze)
            return jsxRuntime.exports.jsx(StyledStreakFreezeIcon, {});
        return jsxRuntime.exports.jsx(StyledStreakTriggerIcon, { icon: faFire });
    };
    const dayLabelFor = (iso) => new Intl.DateTimeFormat('en-GB', { weekday: 'narrow', timeZone: 'UTC' }).format(new Date(iso));
    const renderWeekday = ({ date, state, isToday }) => (jsxRuntime.exports.jsxs(StyledWeekday, { "aria-label": state, "$isToday": isToday, "$isDarkMode": isDarkMode, children: [jsxRuntime.exports.jsxs(StyledWeekdayIconWrapper, { "$state": state, "$isToday": isToday, "$isDarkMode": isDarkMode, children: [state === 'complete' && jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faFire }), state === 'frozen' && jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faSnowflake }), state === 'future' && jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faFire }), state === 'repair' && jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faWrench }), state === 'missed' && jsxRuntime.exports.jsx(SvgStreakBroken, {}), state === 'pending' && jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faFire })] }), jsxRuntime.exports.jsx("p", { children: dayLabelFor(date) })] }, date));
    return (jsxRuntime.exports.jsx(DropdownMenu, { sideOffset: 8, alignContent: "end", type: "streak", onOpenChange: (open) => {
            onStreakOpenChange?.(open);
        }, triggerBtn: jsxRuntime.exports.jsxs(StyledStreakTrigger, { "data-testid": "streak-trigger", "$streakToRepair": activeStreakToRepair, "aria-label": `${streak ?? 0} day streak`, children: [jsxRuntime.exports.jsx(StyledStreakTriggerText, { "$streakToRepair": activeStreakToRepair, "$usingStreakFreeze": usingStreakFreeze, children: streak ?? 0 }), getStreakIcon()] }), children: jsxRuntime.exports.jsxs(StyledStreakContent, { children: [usingStreakFreeze && !weeklyBreakdown ? (jsxRuntime.exports.jsx("p", { children: "Your streak was saved by a streak freeze! Answer today to stop it resetting tomorrow." })) : (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsxs(StyledStreakHeader, { children: [jsxRuntime.exports.jsx(StyledStreakTitle, { children: `${streak ?? 0} day streak` }), isStreakShareEnabled && streak > 0 && (jsxRuntime.exports.jsx(StyledShareButton, { variant: "solid", color: "add", onClick: () => onStreakShare(streak), children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faShare, width: 1.6, height: 1.6 }) }))] }), jsxRuntime.exports.jsx(StyledStreakSubTitle, { children: "Answer a question every day to build your hacking streak, earn badges and prizes." }), Array.isArray(weeklyBreakdown) && weeklyBreakdown.length === 7 && (jsxRuntime.exports.jsx(StyledStreakGrid, { children: weeklyBreakdown.map(renderWeekday) })), largestStreak ? (jsxRuntime.exports.jsxs(StyledLargestStreak, { children: [' ', jsxRuntime.exports.jsx(FontAwesomeIcon, { fill: "rgba(163, 234, 42, 1)", icon: faFire }), "Your longest streak is ", largestStreak, " days"] })) : null, !usingStreakFreeze && Boolean(streakFreeze) ? (jsxRuntime.exports.jsxs(StyledStreakFreezeParagraph, { children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { fill: "rgba(113,156,249,1)", icon: faSnowflake }), "You have ", streakFreeze, " ", streakFreeze === 1 ? 'streak freeze' : 'streak freezes'] })) : null] })), jsxRuntime.exports.jsx(StyledHelpPageLink, { "$isDarkMode": isDarkMode, to: "https://help.tryhackme.com/en/articles/7843540-streak-freeze", target: "_blank", rel: "noopener noreferrer", children: jsxRuntime.exports.jsxs("p", { children: ["Learn more about streaks", jsxRuntime.exports.jsx("span", { children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faArrowUpRightFromSquare }) })] }) }), activeStreakToRepair && (jsxRuntime.exports.jsx(StyledTopBorderedContainer, { "data-testid": "streak-repair-container", children: jsxRuntime.exports.jsx(StreakRepair, { streakToRepair: activeStreakToRepair, onStreakRepair: onStreakRepair, isExtendedRepair: isExtendedRepair }) })), hasCompletedRepairToday && jsxRuntime.exports.jsx(StreakRepairCompleted, {})] }) }));
};

/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const faClock = {
  prefix: 'fal',
  iconName: 'clock',
  icon: [512, 512, [128339, "clock-four"], "f017", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112l0 144c0 5.3 2.7 10.3 7.1 13.3l96 64c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L272 247.4 272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
const faToolbox = {
  prefix: 'fal',
  iconName: 'toolbox',
  icon: [512, 512, [129520], "f552", "M176 64l160 0c8.8 0 16 7.2 16 16l0 48-192 0 0-48c0-8.8 7.2-16 16-16zM128 80l0 48-21.5 0c-17 0-33.3 6.7-45.3 18.7L18.7 189.3C6.7 201.3 0 217.5 0 234.5L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-181.5c0-17-6.7-33.3-18.7-45.3l-42.5-42.5c-12-12-28.3-18.7-45.3-18.7L384 128l0-48c0-26.5-21.5-48-48-48L176 32c-26.5 0-48 21.5-48 48zm16 80l224 0 37.5 0c8.5 0 16.6 3.4 22.6 9.4l42.5 42.5c6 6 9.4 14.1 9.4 22.6l0 85.5-128 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-128 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32L32 320l0-85.5c0-8.5 3.4-16.6 9.4-22.6l42.5-42.5c6-6 14.1-9.4 22.6-9.4l37.5 0zM32 352l128 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 128 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 128 0 0 64c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-64z"]
};
const faBell = {
  prefix: 'fal',
  iconName: 'bell',
  icon: [448, 512, [128276, 61602], "f0f3", "M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16.8c80.9 8 144 76.2 144 159.2l0 29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3L44.3 416C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1L64 192c0-83 63.1-151.2 144-159.2L208 16zm16 48C153.3 64 96 121.3 96 192l0 29.1c0 52.2-20.7 102.3-57.7 139.2L35.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3l359.4 0c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2l0-29.1c0-70.7-57.3-128-128-128zM193.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C275.6 494.2 251.9 512 224 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8z"]
};
const faMagnifyingGlass = {
  prefix: 'fal',
  iconName: 'magnifying-glass',
  icon: [512, 512, [128269, "search"], "f002", "M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"]
};
const faSearch = faMagnifyingGlass;

exports.AlertBannerStatus = void 0;
(function (AlertBannerStatus) {
    AlertBannerStatus["SUCCESS"] = "success";
    AlertBannerStatus["WARNING"] = "warning";
    AlertBannerStatus["ERROR"] = "error";
    AlertBannerStatus["INFO"] = "info";
})(exports.AlertBannerStatus || (exports.AlertBannerStatus = {}));
const alertBannerStatusToIconMap = {
    [exports.AlertBannerStatus.SUCCESS]: faCheckCircle$1,
    [exports.AlertBannerStatus.WARNING]: faExclamationTriangle,
    [exports.AlertBannerStatus.INFO]: faInfoCircle,
    [exports.AlertBannerStatus.ERROR]: faExclamationCircle,
};

const StyledAlertBanner = styled__default["default"].div `
  padding: 1.6rem 1.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.4rem;
  width: auto;
  border-radius: ${({ theme }) => theme.radius.small};
  background-color: ${({ theme, $status }) => {
    switch ($status) {
        case 'success': {
            return theme.colors.alertBanner.success;
        }
        case 'warning': {
            return theme.colors.alertBanner.warning;
        }
        case 'info': {
            return theme.colors.alertBanner.info;
        }
        case 'error': {
            return theme.colors.alertBanner.error;
        }
        default: {
            return theme.colors.alertBanner.success;
        }
    }
}};

  border: 1px solid;
  border-color: ${({ theme, $status }) => {
    switch ($status) {
        case 'success': {
            return theme.colors.success.main;
        }
        case 'warning': {
            return theme.colors.alertBanner.warningIcon;
        }
        case 'info': {
            return theme.colors.info.main;
        }
        case 'error': {
            return theme.colors.error.main;
        }
        default: {
            return theme.colors.success.main;
        }
    }
}};

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding: 1.6rem;
  }
`;
const StyledBannerContent = styled__default["default"].div `
  display: flex;
  align-items: flex-start;
  gap: 1.4rem;
`;
const StyledIcon$4 = styled__default["default"](FontAwesomeIcon) `
  width: 2rem;
  height: 2rem;
  color: ${({ theme, $status }) => {
    switch ($status) {
        case 'success': {
            return theme.colors.success.main;
        }
        case 'warning': {
            return theme.colors.alertBanner.warningIcon;
        }
        case 'info': {
            return theme.colors.info.main;
        }
        case 'error': {
            return theme.colors.error.main;
        }
        default: {
            return theme.colors.success.main;
        }
    }
}};
`;
const StyledMessage = styled__default["default"].p `
  color: ${({ theme }) => theme.colors.text.main};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 2rem;
`;
const StyledRemoveBannerIcon = styled__default["default"](FontAwesomeIcon) `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.main};
`;
const StyledButtonLink = styled__default["default"](Button$1) `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  white-space: nowrap;
`;
const StyledLink$3 = styled__default["default"].a `
  text-decoration: none;
  color: ${({ theme }) => theme.colors.info.main};
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 2rem;
  padding-left: 0;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding-left: 0.5rem;
  }
`;

const AlertBanner = ({ status, type, message, buttonText, handleButtonOnClick, handleBannerDismiss, href, dismissable, icon, children, ...nativeDivProps }) => (jsxRuntime.exports.jsxs(StyledAlertBanner, { role: "status", ...nativeDivProps, "$status": status, "data-testid": "mocked-alert-banner", children: [jsxRuntime.exports.jsxs(StyledFlex, { gap: "1.4rem", flexWrap: "no-wrap", children: [jsxRuntime.exports.jsxs(StyledBannerContent, { children: [jsxRuntime.exports.jsx(StyledIcon$4, { "$status": status, icon: icon ?? alertBannerStatusToIconMap[status], "data-testid": `${status}-icon` }), children || (message && jsxRuntime.exports.jsx(StyledMessage, { children: message }))] }), type === 'button' && (jsxRuntime.exports.jsx(StyledButtonLink, { color: status === 'error' ? 'error' : 'primary', variant: status === 'error' ? 'solid' : 'outlined', onClick: handleButtonOnClick, "data-testid": `${status}-button`, children: buttonText })), type === 'link' && (jsxRuntime.exports.jsx(StyledLink$3, { href: href, target: "_blank", rel: "noreferrer", "data-testid": `${status}-link`, children: "link" }))] }), dismissable && (jsxRuntime.exports.jsx("button", { type: "button", "aria-label": "dismiss", "data-testid": "dismiss-banner", onClick: handleBannerDismiss, children: jsxRuntime.exports.jsx(StyledRemoveBannerIcon, { icon: faXmarkLarge }) }))] }));

const StyledAvatarGroup = styled__default["default"].div `
  display: flex;
  align-items: center;

  & > * {
    border: 2px solid ${({ theme }) => theme.colors.black};
    margin-left: ${({ $isExpanded }) => ($isExpanded ? '-0.3rem' : '-1.3rem')};
    transition: margin-left 0.3s ease-in-out;

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }

    &:first-child {
      margin-left: 0;
    }
  }
`;

const AvatarGroup = ({ avatars = [], size = '4rem', hasHover = false, isExpanded = false, avatarsData = [], mobileSize, }) => (jsxRuntime.exports.jsxs(StyledAvatarGroup, { "data-testid": "avatar-group", "$isExpanded": isExpanded, children: [avatarsData?.length > 0 &&
            avatarsData.map(({ title, avatar, href }) => (jsxRuntime.exports.jsx(Avatar, { avatarSrc: avatar, size: size, isCursorPointer: hasHover, hasHover: hasHover, title: title, href: href, mobileSize: mobileSize ?? '5.2rem' }, avatar))), !avatarsData?.length &&
            avatars?.length > 0 &&
            avatars.map((src) => (jsxRuntime.exports.jsx(Avatar, { avatarSrc: src, size: size, isCursorPointer: hasHover, hasHover: hasHover, mobileSize: mobileSize ?? '5.2rem' }, src)))] }));

const StyledAvatarWrapper$2 = styled__default["default"](reactRouterDom.Link) `
  position: relative;
  height: ${({ size = '6.6rem' }) => size};
  width: ${({ size = '6.6rem' }) => size};
  color: transparent;
  display: inline-block;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    width: 4.6rem;
    height: 4.6rem;
  }
`;
const StyledTopIcon = styled__default["default"].span `
  border-radius: 100%;
  border: 2px solid ${({ theme }) => theme.colors.background.light};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.4rem;
  height: 2.4rem;
  background: ${({ theme }) => theme.colors.primary.main};
  position: absolute;
  bottom: 0;
  right: 0;

  svg {
    width: 1.3rem;
    height: auto;
    path {
      fill: ${({ theme }) => theme.colors.secondary.main};
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    width: 1.6rem;
    height: 1.6rem;

    svg {
      width: 0.8rem;
    }
  }
`;

const AvatarWithIcon = ({ userName, avatar, isTop3 = false, size }) => (jsxRuntime.exports.jsxs(StyledAvatarWrapper$2, { to: `/p/${userName}`, target: "_blank", size: size, children: [jsxRuntime.exports.jsx(Avatar, { avatarSrc: avatar, borderColor: isTop3 ? theme.colors.primary.main : '', size: size, mobileSize: size }), isTop3 && (jsxRuntime.exports.jsx(StyledTopIcon, { children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faTrophy }) }))] }));

const StyledAvatarWrapper$1 = styled__default["default"].div `
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-bottom: 1.6rem;
  }
`;
const StyledAvatar = styled__default["default"](Image) `
  width: 4rem;
  height: 4rem;
  border-radius: 3.2rem;
  object-fit: cover;
  border: 0.1rem solid ${({ theme }) => theme.colors.background.tableRowHover};
`;
const StyledLink$2 = styled__default["default"](reactRouterDom.Link) `
  text-decoration: none;
  display: flex;
  gap: 0.8rem;
  align-items: center;
`;
const StyledUsername = styled__default["default"].span `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-style: normal;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 1.6rem;
  color: ${({ theme }) => theme.colors.text.main};

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.small};
  }
`;
const StyledCompanyNameWrapper = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 0.8rem;
  align-self: stretch;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    gap: 0.4rem;
  }
`;

const AvatarWithUsername = ({ username, avatar, isManageUsers = false }) => (jsxRuntime.exports.jsx(StyledAvatarWrapper$1, { children: jsxRuntime.exports.jsxs(StyledLink$2, { to: isManageUsers ? '/admin/manage-users' : `/p/${username}`, children: [!!username && jsxRuntime.exports.jsx(StyledAvatar, { src: avatar, alt: "" }), jsxRuntime.exports.jsx(StyledCompanyNameWrapper, { children: jsxRuntime.exports.jsx(StyledUsername, { children: username }) })] }) }));

const StyledBadge = styled__default["default"].article `
  display: flex;
  align-items: center;
  padding: 1.6rem;
  gap: 1.6rem;
  background-color: ${({ theme }) => theme.colors.background.dark};
  cursor: ${({ $interactive }) => ($interactive ? 'pointer' : 'default')};
  transition: background-color 0.3s ease-in-out;
  border-radius: ${({ theme }) => theme.radius.small};

  &:hover {
    background-color: ${({ theme, $interactive }) => ($interactive ? theme.colors.background.secondaryLight : theme.colors.background.dark)};
  }
`;
const StyledImageWrapper$2 = styled__default["default"].figure `
  position: relative;
  width: 11.2rem;
  filter: ${({ $isEarned }) => ($isEarned ? 'none' : 'grayscale(100%)')};
  opacity: ${({ $isEarned }) => ($isEarned ? '1' : '0.4')};
  img {
    height: auto;
    max-height: 15rem;
    width: inherit;
    object-fit: contain;
  }
`;
const StyledBadgeContentWrapper = styled__default["default"].div `
  p {
    color: ${({ theme }) => theme.colors.paragraph};
    line-height: 2.24rem;

    &[data-content='title'] {
      font-size: 1.8rem;
      margin-bottom: 0.8rem;
      font-weight: ${({ theme }) => theme.fonts.weight.bolder};
      color: ${({ theme }) => theme.colors.text.main};
    }
  }

  span {
    display: inline-block;
    margin-top: 1rem;
    padding: 0.2rem 1rem;
    border-radius: 1rem;
    font-size: 1.2rem;
    text-transform: capitalize;

    ${({ theme, $rarityTier }) => {
    switch ($rarityTier) {
        case 'epic': {
            return styled.css `
            color: ${theme.colors.purple.main};
            background-color: ${theme.colors.statusTag.purple.background};
          `;
        }
        case 'common': {
            return styled.css `
            color: ${theme.colors.info.main};
            background-color: ${theme.colors.statusTag.blue.background};
          `;
        }
        case 'rare': {
            return styled.css `
            color: ${theme.colors.success.main};
            background-color: ${theme.colors.statusTag.green.background};
          `;
        }
        default: {
            return '';
        }
    }
}}
  }
`;
const StyledTickIcon = styled__default["default"](FontAwesomeIcon) `
  position: absolute;
  bottom: 0.6rem;
  right: 0.8rem;
  font-size: 3.4rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.success.main};

  path {
    fill: ${({ theme }) => theme.colors.background.dark};
  }
`;

const Badge = ({ title, name, image, description, isEarned, onClick, rarityPercent, rarityTier, isInteractive = true, }) => (jsxRuntime.exports.jsxs(StyledBadge, { "data-testid": "badge", onClick: onClick, "$interactive": isInteractive, children: [jsxRuntime.exports.jsxs(StyledImageWrapper$2, { "$isEarned": isEarned, children: [jsxRuntime.exports.jsx(Image, { src: image, alt: name, loading: "lazy" }), isEarned && jsxRuntime.exports.jsx(StyledTickIcon, { icon: faCircleCheck$2, "aria-label": "Earned badge" })] }), jsxRuntime.exports.jsxs(StyledBadgeContentWrapper, { "$rarityTier": rarityTier, children: [jsxRuntime.exports.jsx("p", { "data-content": "title", children: title }), jsxRuntime.exports.jsx("p", { children: description }), rarityTier && (jsxRuntime.exports.jsxs("span", { children: [rarityTier, ": ", rarityPercent, "%"] }))] })] }));

const StyledBanner$1 = styled__default["default"].div `
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.black};
  height: 30rem;
  isolation: isolate;
  overflow: hidden;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    height: 25rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    height: 20rem;
  }
`;
const StyledImageWrapper$1 = styled__default["default"].div `
  position: absolute;
  height: 100%;
  z-index: -1;
  top: ${(props) => props.top};
  right: ${(props) => props.right};
  left: ${(props) => props.left};
  bottom: ${(props) => props.bottom};

  svg {
    fill: ${({ theme }) => theme.colors.secondary.main};

    @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
      max-width: 50rem;
    }
  }
`;

const Banner = ({ children, Image, top = 'auto', bottom = 'auto', left = 'auto', right = 'auto', className, }) => (jsxRuntime.exports.jsx(StyledBanner$1, { className: className, "data-testid": "sc-banner", children: jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [Image && (jsxRuntime.exports.jsx(StyledImageWrapper$1, { top: top, bottom: bottom, left: left, right: right, children: jsxRuntime.exports.jsx(Image, {}) })), children] }) }));

const StyledLoadingCards = styled__default["default"].div `
  span {
    ${StyledLoadingPlaceholder};
    display: block;
    height: 3rem;
    margin-top: 1rem;
    width: 100%;

    &:nth-child(1) {
      height: 24rem;
    }

    &:nth-child(2) {
      animation-duration: 9s;
      width: 20%;
    }

    &:nth-child(5) {
      width: 90%;
    }
  }
`;

const Loading$4 = () => (jsxRuntime.exports.jsx(StyledLoadingCards, { "data-testid": "loading", children: jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsx("span", {})] }) }));

const StyledBlogPostLink = styled.css `
  border-radius: ${({ theme }) => theme.radius.small};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  text-decoration: none;
  transition: opacity 0.2s, border-color 0.2s;
  border: 1px solid transparent;
  padding: 0.5rem;

  :hover {
    opacity: 0.8;
  }
  :focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.info.main};
  }
`;
const StyledBlogPostCardWrapperLink = styled__default["default"](reactRouterDom.Link) `
  ${StyledBlogPostLink}
`;
const StyledBlogPostCardWrapperAnchor = styled__default["default"].a `
  ${StyledBlogPostLink}
`;
const StyledBlogPostCardImage = styled__default["default"](Image) `
  border-radius: 0.5rem;
  object-fit: cover;
  margin-bottom: 1.4rem;
  width: 100%;
  height: 25rem;
  transition: height 0.2s;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    height: 20rem;
  }
`;
const StyledBlogPostCardStats = styled__default["default"].span `
  color: ${({ theme }) => theme.colors.success.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 1.8rem;
`;
const StyledBlogPostCardTitle = styled__default["default"].h2 `
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: 1.8rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  line-height: 2.4rem;
  margin: 1.4rem 0;
`;
const StyledBlogPostCardExtract = styled__default["default"].p `
  ${StyledCardDescription};
  width: 100%;
  max-lines: 3;
  -webkit-line-clamp: 3;
`;

const BlogPostCard = ({ articleTitle, category, extract, imageProps, readingTime, isLoading = false, isPdf = false, href, ...anchorProps }) => {
    const BlogPostContainer = (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [imageProps && jsxRuntime.exports.jsx(StyledBlogPostCardImage, { ...imageProps }), jsxRuntime.exports.jsxs(StyledBlogPostCardStats, { children: [category, category && readingTime && ' • ', readingTime] }), jsxRuntime.exports.jsx(StyledBlogPostCardTitle, { children: articleTitle }), jsxRuntime.exports.jsx(StyledBlogPostCardExtract, { children: extract })] }));
    return isPdf ? (jsxRuntime.exports.jsx(StyledBlogPostCardWrapperAnchor, { ...anchorProps, href: href, children: isLoading ? jsxRuntime.exports.jsx(Loading$4, {}) : BlogPostContainer })) : (jsxRuntime.exports.jsx(StyledBlogPostCardWrapperLink, { ...anchorProps, to: href, children: isLoading ? jsxRuntime.exports.jsx(Loading$4, {}) : BlogPostContainer }));
};

const StyledBreadcrumb = styled__default["default"].ul `
  display: flex;
  gap: 0.5rem;
`;
const StyledBreadcrumbItem = styled__default["default"].li `
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  max-width: 15rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.4s ease-in-out;

  &:hover {
    max-width: fit-content;
    white-space: initial;
    overflow: initial;
  }

  span {
    color: ${({ theme, $isDarkVersion }) => $isDarkVersion ? darkColors.text.placeholderInvert : theme.colors.text.placeholderInvert};
  }

  a {
    color: ${({ theme, $isDarkVersion }) => $isDarkVersion ? darkColors.text.placeholder : theme.colors.text.placeholder};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    ${({ $isPrevItem }) => $isPrevItem &&
    ` &:before {
      content: '<'; 
      padding-right: 0.5rem;
    }
  `}
  }

  &:before {
    content: '>';
    color: ${({ theme }) => theme.colors.grey[300]};
    padding-right: 0.5rem;
  }

  &:first-of-type {
    &:before {
      content: '';
    }
  }
`;
styled__default["default"](reactRouterDom.Link) `
  align-items: center;
  display: flex;
  text-decoration: none;

  &:after {
    content: '<';
    color: ${({ theme }) => theme.colors.grey[300]};
    font-size: ${({ theme }) => theme.fonts.sizes.small};
    margin-right: 0.4rem;
  }
`;

const Breadcrumb = ({ breadcrumbItems, handleItemClick, isDarkVersion = false }) => {
    const { width } = useViewport();
    const prevItem = breadcrumbItems[breadcrumbItems.length - 2];
    return (jsxRuntime.exports.jsx("nav", { "aria-label": "breadcrumb", children: jsxRuntime.exports.jsx(StyledBreadcrumb, { children: width < BREAKPOINT_MOBILE && prevItem ? (jsxRuntime.exports.jsx(StyledBreadcrumbItem, { "$isPrevItem": true, children: jsxRuntime.exports.jsx(reactRouterDom.Link, { to: prevItem?.href, onClick: handleItemClick, children: `See ${prevItem?.label}` }) })) : (breadcrumbItems.map((item, index) => (jsxRuntime.exports.jsx(StyledBreadcrumbItem, { "$isDarkVersion": isDarkVersion, children: index === breadcrumbItems.length - 1 ? (jsxRuntime.exports.jsx("span", { children: item.label })) : (jsxRuntime.exports.jsx(reactRouterDom.Link, { to: item.href, onClick: handleItemClick, children: item.label })) }, item.id ?? item.href)))) }) }));
};

const StyledDropdownButton = styled__default["default"](Button$1) `
  padding: ${({ $hasLabel }) => ($hasLabel ? '0 1.6rem' : '0 1.0rem')};
  display: flex;
  gap: 1rem;
  color: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? theme.colors.grey[100] : theme.colors.text.main)};
  background-color: ${({ theme, $isDarkVersion }) => $isDarkVersion ? darkColors.background.secondary : theme.colors.background.secondary};
  border-color: ${({ theme, $isDarkVersion }) => $isDarkVersion ? theme.colors.secondary.lighter : theme.colors.border.light};

  &:hover:not(:disabled),
  &[data-state='open'] {
    background-color: ${({ theme }) => theme.colors.grey[200]};
  }

  &[data-state='open'] {
    color: ${({ theme }) => theme.colors.black};
  }

  svg {
    width: 1.6rem;
    height: 1.6rem;
  }
`;
const StyledLink$1 = styled__default["default"](reactRouterDom.Link) `
  color: ${({ theme, $isLightVersion }) => ($isLightVersion ? theme.colors.text.main : theme.colors.grey[100])};
  text-decoration: none;
`;

const ButtonDropdown = ({ options, onOptionSelect, onOpenChange, selectedOption, buttonLabel, icon, alignContent = 'start', isDarkVersion = false, hideDownArrow = false, }) => {
    const hasLabel = !!buttonLabel;
    return (jsxRuntime.exports.jsx(DropdownMenu, { sideOffset: 5, alignContent: alignContent, type: "button", onOpenChange: onOpenChange, triggerBtn: jsxRuntime.exports.jsxs(StyledDropdownButton, { variant: "outlined", color: "secondary", "aria-label": "dropdown", "$hasLabel": hasLabel, "$isDarkVersion": isDarkVersion, children: [icon && icon, buttonLabel && buttonLabel, hideDownArrow || jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCaretDown })] }), children: options.map((option) => (jsxRuntime.exports.jsx(StyledDropdownMenuItem, { onSelect: (e) => {
                if (option.toggle || option?.keepOpenOnSelect) {
                    e.preventDefault();
                }
                onOptionSelect(option.value);
                if (option?.handleClickSelectedOption) {
                    option?.handleClickSelectedOption();
                }
            }, "$isSelected": option.value === selectedOption, children: option.to ? (jsxRuntime.exports.jsx(StyledLink$1, { as: option.isTargetBlank ? 'a' : reactRouterDom.Link, href: option.to, to: option.to, target: option.isTargetBlank ? '_blank' : '_self', "$isLightVersion": true, children: jsxRuntime.exports.jsx(DropdownMenuItemContent, { title: option.title, type: "button", subTitle: option.subTitle, icon: option.icon ? jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: option.icon }) : null }) })) : (jsxRuntime.exports.jsx(DropdownMenuItemContent, { title: option.title, type: "button", subTitle: option.subTitle, icon: option.icon ? jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: option.icon }) : null, toggle: option.toggle })) }, option.id))) }));
};

const StyledButtonGroup = styled__default["default"].div `
  display: inline-flex;
  border-radius: 0.4rem;
  outline: 1px solid
    ${({ theme, $isDarkVersion }) => ($isDarkVersion ? theme.colors.secondary.lighter : theme.colors.border.light)};

  button {
    background-color: ${({ theme, $isDarkVersion }) => $isDarkVersion ? darkColors.background.secondary : theme.colors.background.secondary};
    border-radius: 0;
    border: none;
    border-right: 1px solid
      ${({ theme, $isDarkVersion }) => ($isDarkVersion ? theme.colors.secondary.lighter : theme.colors.border.light)};

    &:first-of-type {
      border-radius: 0.4rem 0 0 0.4rem;
    }
    &:last-of-type {
      border: none;
      border-radius: 0 0.4rem 0.4rem 0;
    }

    color: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? theme.colors.grey[100] : theme.colors.text.main)};

    svg {
      height: 1.6rem;
      width: 1.6rem;
    }
  }
`;

const ButtonGroup = ({ children, isDarkVersion = false }) => (jsxRuntime.exports.jsx(StyledButtonGroup, { "$isDarkVersion": isDarkVersion, role: "group", children: children }));

const StyledNewRoomCard$1 = styled__default["default"](reactRouterDom.Link) `
  ${StyledCardBoxShadowCommon};
  background-color: ${({ theme }) => theme.colors.background.lighter};
  border-radius: ${({ theme }) => theme.radius.small};
  display: flex;
  padding: 1.6rem;
  flex-direction: column-reverse;
  text-decoration: none;
  gap: 1rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: row;
    gap: unset;
  }
`;
const StyledTitle$8 = styled__default["default"].h2 `
  ${StyledCardTitle};
  margin: 0;
`;
const StyledImageContainer$4 = styled__default["default"].div `
  height: 7.8rem;
  width: 7.8rem;
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    display: flex;
  }
`;
const StyledCardImage$5 = styled__default["default"](Image) `
  height: inherit;
  object-fit: cover;
  width: inherit;
  border-radius: 0.5rem;
`;
const StyledContent$7 = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    margin-left: 2rem;
    gap: unset;
  }
`;
const StyledDescriptionText = styled__default["default"].p `
  color: ${({ theme }) => theme.colors.text.lighter};
  font-size: 1.6rem;
  line-height: 2rem;
  text-overflow: ellipsis;
`;
const StyledTagContainer = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: flex-start;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    align-items: flex-end;
  }
`;

const CareerLearningCard = ({ imageProps, title, description, difficulty, url, roomType, containerProps, }) => React.useMemo(() => {
    const renderTag = () => {
        let tagProps;
        switch (roomType) {
            case 'path': {
                tagProps = {
                    size: 'small',
                    color: 'info',
                    variation: 'lightest',
                    textColor: 'lighter',
                    children: 'Path',
                };
                break;
            }
            case 'module': {
                tagProps = {
                    size: 'small',
                    color: 'purple',
                    variation: 'lighter',
                    textColor: 'lighter',
                    children: 'Module',
                };
                break;
            }
            default: {
                tagProps = {
                    size: 'small',
                    color: 'success',
                    variation: 'lightest',
                    textColor: 'lighter',
                    children: 'Room',
                };
                break;
            }
        }
        return jsxRuntime.exports.jsx(Tag, { ...tagProps });
    };
    return (jsxRuntime.exports.jsxs(StyledNewRoomCard$1, { to: url, ...containerProps, children: [jsxRuntime.exports.jsx(StyledImageContainer$4, { children: imageProps && jsxRuntime.exports.jsx(StyledCardImage$5, { alt: "Room illustration", ...imageProps }) }), jsxRuntime.exports.jsxs(StyledContent$7, { children: [jsxRuntime.exports.jsx(StyledTitle$8, { children: title }), jsxRuntime.exports.jsx(StyledDescriptionText, { children: description }), jsxRuntime.exports.jsx(Difficulty, { difficulty: difficulty, hasIcon: true, isSmall: true })] }), jsxRuntime.exports.jsx(StyledTagContainer, { children: renderTag() })] }));
}, [containerProps, description, difficulty, imageProps, roomType, title, url]);

const StyledCommon = styled.css `
  border-radius: 100%;
  height: 100%;
  left: 0;
  position: absolute;
  transition: transform 0.3s ease-in-out;
  top: 0;
  width: 100%;
`;
const StyledCircularProgress = styled__default["default"].svg `
  transform: rotate(-90deg);
  shape-rendering: geometricPrecision;
  position: relative;
`;
const StyledCircleBackground = styled__default["default"].circle `
  fill: none;
  stroke: ${({ theme, $isDarkVersion }) => $isDarkVersion ? darkColors.background.darkest : theme.colors.background.darkest};
  stroke-width: strokeWidth;
`;
const StyledCircleProgress = styled__default["default"].circle `
  fill: none;
  stroke-width: strokeProgressWidth;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.5s linear;
`;
const StyledWrapperContent = styled__default["default"].div `
  position: absolute;
  width: ${({ $size }) => $size ?? '8'}px;
  height: ${({ $size }) => $size ?? '8'}px;
  border-radius: 100%;
`;
styled__default["default"].div `
  position: relative;
  perspective: 1000px;
  width: inherit;
  height: inherit;
`;
const StyledImage = styled__default["default"](Image) `
  ${StyledCommon};
  object-fit: cover;
  object-position: top center;
`;
const StyledCheckmarkWrapper = styled__default["default"].div `
  ${StyledCommon};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $isDarkMode }) => ($isDarkMode ? 'rgba(7, 77, 162, 0.70)' : 'rgba(105, 160, 229, 0.8)')};
`;
const StyledCheckmark = styled__default["default"](FontAwesomeIcon) `
  color: ${secondaryColors.white};
  font-size: 2rem;
`;
const StyledText = styled__default["default"].div `
  ${StyledCommon};
  background: ${({ theme, $isDarkVersion }) => $isDarkVersion ? darkColors.background.darker : theme.colors.background.darker};
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  display: ${({ $isHovered }) => ($isHovered ? 'flex' : 'none')};

  p,
  span {
    line-height: normal;
    color: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? darkColors.text.main : theme.colors.text.main)};
    font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  }

  p {
    font-size: ${({ $fontSize, $isBig }) => $fontSize ?? ($isBig ? '3.6rem' : '1.6rem')};
    font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  }

  span {
    font-size: ${({ $isBig }) => ($isBig ? '1.2rem' : '0.8rem')};
  }
`;
const StyledCircularProgressWrapper = styled__default["default"].div `
  align-items: center;
  display: flex;
  position: relative;
  justify-content: center;
  width: fit-content;

  &:hover ${StyledText} {
    display: flex;
  }
`;
const StyledIconOnTop = styled__default["default"].div `
  background-color: ${({ theme }) => theme.colors.background.main};
  border-radius: 100%;
  bottom: 0.5rem;
  position: absolute;
  right: 0.2rem;
  height: ${({ $size }) => ($size ? `${$size + 2}px` : '3rem')};
  width: ${({ $size }) => ($size ? `${$size + 2}px` : '3rem')};
  display: grid;
  place-items: center;
`;
const StyledProgressCheckIcon = styled__default["default"](FontAwesomeIcon) `
  height: ${({ $size }) => ($size ? `${$size}px` : '2.4rem')};
  width: ${({ $size }) => ($size ? `${$size}px` : '2.4rem')};
  color: ${({ theme }) => theme.colors.info.main};

  &[data-difficulty='easy'] {
    color: ${darkColors.success.main};
  }

  &[data-difficulty='medium'] {
    color: ${({ theme }) => theme.colors.warning.main};
  }

  &[data-difficulty='hard'],
  &[data-difficulty='insane'] {
    color: ${({ theme }) => theme.colors.error.main};
  }
  &[data-difficulty='info'] {
    color: ${({ theme }) => theme.colors.info.main};
  }
`;

const getGradientColors = (difficulty, isDarkMode, isDarkVersion) => {
    if (difficulty === 'easy') {
        return isDarkMode
            ? ['rgb(31, 94, 101)', 'rgb(42, 174, 16)', 'rgb(59, 200, 30)', 'rgb(163, 234, 42)', 'rgb(163, 234, 42)']
            : ['rgb(59, 200, 30)', 'rgb(59, 200, 30)', 'rgb(59, 200, 30)', 'rgb(163, 234, 42)', 'rgb(163, 234, 42)'];
    }
    if (difficulty === 'medium') {
        return isDarkMode
            ? ['rgb(143, 78, 32)', 'rgb(255, 141, 0)', 'rgb(200, 112, 30)', 'rgb(234, 192, 42)', 'rgb(234, 192, 42)']
            : ['rgb(255, 141, 0)', 'rgb(255, 141, 0)', 'rgb(255, 141, 0)', 'rgb(234, 192, 42)', 'rgb(234, 192, 42)'];
    }
    if (difficulty === 'hard' || difficulty === 'insane') {
        return isDarkMode
            ? ['rgb(159, 38, 38)', 'rgb(200, 30, 30)', 'rgb(200, 30, 30)', 'rgb(255, 79, 79)', 'rgb(255, 79, 79)']
            : ['rgb(235, 0, 55)', 'rgb(235, 0, 55)', 'rgb(235, 0, 55)', 'rgb(255, 97, 97)', 'rgb(255, 97, 97)'];
    }
    return isDarkMode || isDarkVersion
        ? ['rgb(75, 147, 244)', 'rgb(86, 164, 255)', 'rgb(53, 105, 239)', 'rgb(32, 43, 143)', 'rgb(75, 147, 244)']
        : ['rgb(86, 164, 255)', 'rgb(31, 78, 198)', 'rgb(32, 43, 143)', 'rgb(32, 43, 143)', 'rgb(86, 164, 255)'];
};

const CircularImageProgress = ({ isDarkVersion = false, progressValue = 0, fontSize, size = 64, strokeWidth = 3, strokeProgressWidth = strokeWidth + 2, contentSizeAdjustment = 12, isBig = false, image, isHovered = false, showCompletedCheckmarks = false, difficulty, isCheckOnTop = false, iconCheckSize, }) => {
    const { theme } = React.useContext(SwitchThemeContext);
    const gradientId = React.useId();
    const isDarkMode = theme === 'dark';
    const radius = size / 2 - strokeWidth;
    const circumference = 2 * Math.PI * radius;
    const offset = ((100 - progressValue) / 100) * circumference;
    const contentSize = size - strokeProgressWidth - contentSizeAdjustment;
    const [color1, color2, color3, color4, color5] = getGradientColors(difficulty, isDarkMode, isDarkVersion);
    return (jsxRuntime.exports.jsxs(StyledCircularProgressWrapper, { "data-testid": "circular-image-progress", children: [jsxRuntime.exports.jsxs(StyledCircularProgress, { width: size, viewBox: `0 0 ${size} ${size}`, "shape-rendering": "geometricPrecision", children: [jsxRuntime.exports.jsx("defs", { children: jsxRuntime.exports.jsxs("linearGradient", { id: gradientId, x1: "0%", y1: "0%", x2: "100%", y2: "0%", children: [jsxRuntime.exports.jsx("stop", { "data-testid": "stop-0", offset: "0%", style: { stopColor: color1, stopOpacity: 1 } }), jsxRuntime.exports.jsx("stop", { "data-testid": "stop-1", offset: "25%", style: { stopColor: color2, stopOpacity: 1 } }), jsxRuntime.exports.jsx("stop", { "data-testid": "stop-2", offset: "50%", style: { stopColor: color3, stopOpacity: 1 } }), jsxRuntime.exports.jsx("stop", { "data-testid": "stop-3", offset: "75%", style: { stopColor: color4, stopOpacity: 1 } }), jsxRuntime.exports.jsx("stop", { "data-testid": "stop-4", offset: "100%", style: { stopColor: color5, stopOpacity: 1 } })] }) }), jsxRuntime.exports.jsx(StyledCircleBackground, { "$isDarkVersion": isDarkVersion, cx: size / 2, cy: size / 2, r: radius, strokeWidth: strokeWidth, "shape-rendering": "geometricPrecision" }), jsxRuntime.exports.jsx(StyledCircleProgress, { cx: size / 2, cy: size / 2, r: radius, stroke: `url(#${gradientId})`, strokeWidth: strokeProgressWidth, strokeDasharray: circumference, strokeDashoffset: offset, "shape-rendering": "geometricPrecision" })] }), jsxRuntime.exports.jsxs(StyledWrapperContent, { "$size": contentSize, children: [jsxRuntime.exports.jsx(StyledImage, { src: image, alt: "image", loading: "lazy" }), showCompletedCheckmarks && progressValue === 100 ? (jsxRuntime.exports.jsx(StyledCheckmarkWrapper, { "$isDarkMode": isDarkMode, children: jsxRuntime.exports.jsx(StyledCheckmark, { icon: faCheck }) })) : (jsxRuntime.exports.jsx(StyledText, { "$fontSize": fontSize, "$isBig": isBig, "$isDarkVersion": isDarkVersion, "$isHovered": isHovered, children: jsxRuntime.exports.jsxs("p", { children: [progressValue, jsxRuntime.exports.jsx("span", { children: "%" })] }) }))] }), isCheckOnTop && progressValue === 100 && (jsxRuntime.exports.jsx(StyledIconOnTop, { "$size": iconCheckSize, "data-testid": "icon-on-top", children: jsxRuntime.exports.jsx(StyledProgressCheckIcon, { icon: faCheckCircle$1, "data-testid": "completed-icon", "$size": iconCheckSize, "data-difficulty": difficulty }) }))] }));
};

const StyledPoVTooltip$1 = styled__default["default"].div `
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  z-index: 1;
  text-align: center;
  display: none;
  top: -5rem;
  & > div[role='tooltip'] {
    background: ${({ $isDarkVersion }) => $isDarkVersion && darkColors.background.tertiary};
    color: ${({ $isDarkVersion }) => $isDarkVersion && darkColors.text.main};
    &::before {
      border-color: ${({ $isDarkVersion }) => $isDarkVersion && darkColors.background.tertiary};
      border-bottom-color: transparent;
      border-left-color: transparent;
      border-right-color: transparent;
    }
  }
`;
const StyledTooltipWrapper$2 = styled__default["default"].div `
  position: relative;
  text-transform: capitalize;
  &:hover {
    ${StyledPoVTooltip$1} {
      display: inline-block;
      animation: appear 0.3s ease-in-out;
    }
  }

  @keyframes appear {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
const StyledPoVTag = styled__default["default"](FontAwesomeIcon) `
  height: 1.4rem;
  width: 1.4rem;

  &[data-team='blue'] {
    color: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? darkColors.info.main : theme.colors.info.main)};
    fill: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? darkColors.info.main : theme.colors.info.main)};
  }

  &[data-team='red'] {
    color: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? darkColors.error.main : theme.colors.error.main)};
    fill: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? darkColors.error.main : theme.colors.error.main)};
  }

  &[data-team='purple'] {
    color: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? darkColors.purple.main : theme.colors.purple.main)};
    fill: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? darkColors.purple.main : theme.colors.purple.main)};
  }
`;

const PovTag = ({ povTag = 'purple', isDarkVersion }) => (jsxRuntime.exports.jsxs(StyledTooltipWrapper$2, { children: [jsxRuntime.exports.jsx(StyledPoVTooltip$1, { "$isDarkVersion": isDarkVersion, children: jsxRuntime.exports.jsxs(Tooltip, { arrowPosition: "bottom-center", children: [povTag, " team"] }) }), jsxRuntime.exports.jsx(StyledPoVTag, { icon: faShield, "data-team": povTag, "data-testid": "pov-tag", "$isDarkVersion": isDarkVersion })] }));

const StyledWrapperTag = styled__default["default"].span `
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.radius.huge};
  background-color: ${({ theme }) => theme.colors.alertBanner.info};
  color: ${({ theme }) => theme.colors.text.main};
  vertical-align: bottom;

  div[role='tooltip'] {
    text-transform: capitalize;
    opacity: 0;
    position: absolute;
    bottom: 160%;
    transition: all 0.3s ease-in-out;
    visibility: hidden;
    width: fit-content;
  }
  &:hover {
    div[role='tooltip'] {
      opacity: 1;
      visibility: visible;
    }
  }
`;
const TagIcon = styled__default["default"](FontAwesomeIcon) `
  color: ${({ theme }) => theme.colors.text.main};
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  padding: 0.4rem 0.75rem;
`;

const TagToolTip = ({ text, icon = faRoute, iconSrc }) => (jsxRuntime.exports.jsxs(StyledWrapperTag, { "data-testid": "tag-tooltip", onClick: (event) => event.preventDefault(), children: [jsxRuntime.exports.jsx(Tooltip, { arrowPosition: "bottom-center", children: text }), iconSrc ? (jsxRuntime.exports.jsx("img", { src: iconSrc, alt: text, style: { width: 32, height: 24, padding: '0.2rem  0.75rem' } })) : (jsxRuntime.exports.jsx(TagIcon, { icon: icon }))] }));

const StyledAditionalFooter = styled__default["default"].div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  opacity: 0;
  transition: 0.3s all ease-in-out;
  position: absolute;
  bottom: 1.6rem;
  left: 1.6rem;
  right: 1.6rem;
  z-index: 2;

  small[data-text='completed'] {
    color: ${({ theme }) => theme.colors.success.main};
    font-weight: ${({ theme }) => theme.fonts.weight.regular};
  }

  span[data-type='tag'] {
    border: 1px solid rgb(62, 71, 90);
  }
`;
const StyledTags$3 = styled__default["default"].div `
  display: flex;
  justify-content: flex-start;
  gap: 0.4rem;
  flex: 1;

  span {
    max-width: 10.8rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
const StyledFooter$1 = styled__default["default"].footer `
  background: ${({ theme }) => theme.colors.background.main};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 2rem;
  transition: height 0.2s linear;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;
const StyledDescription$2 = styled__default["default"].p `
  ${StyledCardDescription};
  line-height: 2.07rem;
  margin-bottom: 1.6rem;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ $isActiveContentDrop }) => ($isActiveContentDrop ? '3' : '4')};
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-bottom: 1.4rem;
  }
`;
const StyledCardContainer = styled__default["default"].div `
  
  padding: 1.6rem;
  height: ${({ $isActiveContentDrop }) => ($isActiveContentDrop ? '15.6rem' : '18.6rem')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  transition: all 0.4s ease-in-out 0.2s;

  &:hover {
    ${StyledFooter$1} {
      height: 100%;
    }
    ${StyledAditionalFooter}, ${StyledDescription$2} {
      opacity: 1;
    }
    overflow: visible;
  }
`;
const StyledClickableArea = styled__default["default"](reactRouterDom.Link) `
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  position: relative;
`;
const StyledCardMainWrapper = styled__default["default"].div `
  ${StyledCardCommon};
  ${StyledCardBoxShadowCommon};
  position: relative;
  border-radius: ${({ theme }) => theme.radius.small};
  height: 18.6rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    height: auto; 
    min-height: 18.6rem; 
  }

  ${({ $isActiveContentDrop }) => $isActiveContentDrop &&
    styled.css `
      border: 1px solid ${lightColors.info.main};
    `}
`;
styled__default["default"](reactRouterDom.Link) `
  ${StyledCardCommon};
  ${StyledCardBoxShadowCommon};
  padding: 1.6rem;
  text-decoration: none;
  height: inherit;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  transition: overflow 0.4s ease-in-out 0.4s;
`;
const StyledTitle$7 = styled__default["default"].h2 `
  ${StyledCardTitle};
  margin-bottom: 1rem;
`;
const StyledContentWrapper$1 = styled__default["default"].div `
  overflow: hidden;
  max-height: 11.95rem;

`;
const StyledProgressWrapper$1 = styled__default["default"].div `
  float: right;
  height: 6.7rem;
  margin: 0 0 1.3rem 1.3rem;
  position: relative;
  top: 0;
  width: 6.7rem;
  pointer-events: none;
`;
const StyledFooterContent = styled__default["default"].div `
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.text.main};
`;
styled__default["default"](FontAwesomeIcon) `
  height: 1.4rem;
  width: 1.4rem;

  &[data-team='blue'] {
    color: ${({ theme }) => theme.colors.info.main};
    fill: ${({ theme }) => theme.colors.info.main};
  }

  &[data-team='red'] {
    color: ${({ theme }) => theme.colors.error.main};
    fill: ${({ theme }) => theme.colors.error.main};
  }

  &[data-team='purple'] {
    color: ${({ theme }) => theme.colors.purple.main};
    fill: ${({ theme }) => theme.colors.purple.main};
  }
`;
const StyledAditionalContent = styled__default["default"].div `
  margin-top: 1.4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: inherit;

  span[data-type='tag'] {
    border: 1px solid ${({ theme }) => theme.colors.border.light};
  }
`;
styled__default["default"].small `
  color: ${({ theme }) => theme.colors.info.main};
`;
const StyledPoVTooltip = styled__default["default"].div `
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  z-index: 1;
  text-align: center;
  display: none;
  top: -5rem;
`;
styled__default["default"].div `
  position: relative;
  text-transform: capitalize;
  &:hover {
    ${StyledPoVTooltip} {
      display: inline-block;
      animation: appear 0.3s ease-in-out;
    }
  }

  @keyframes appear {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
const StyledSavedButton = styled__default["default"](Button$1) `
  padding: 0.5rem;
  svg {
    color: ${({ theme, $isRoomSaved }) => ($isRoomSaved ? theme.colors.success.main : theme.colors.grey[600])};
  }
`;
const StyledSpinner = styled__default["default"].span `
  width: 1.2rem;
  height: 1.2rem;
  border: 2px solid ${({ theme }) => theme.colors.border.light};
  border-top: 2px solid ${({ theme }) => theme.colors.border.main};
  border-radius: 50%;
  display: inline-block;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
const StyledBonusWrapper = styled__default["default"].section `
  align-items: center;
  background-color: ${lightColors.info.main};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  gap: 0.6rem;
  height: 2.8rem;
  padding: 0.4rem 0.8rem;
  svg {
    width: 1.4rem;
    height: 1.4rem;
  }
  p[data-text="bonus"] {
    font-size: ${({ theme }) => theme.fonts.sizes.small};
  }
`;
const StyledBonusHovered = styled__default["default"].div `
  display: flex;
  gap: 0.4rem;
  justify-content: space-between;
  transition: all 0.3s ease-in-out;
  width:100%;

 > div:first-child {
   align-items: center;
   display: flex;
   gap: 0.6rem;
   width: fit-content;
  }
`;

const adjustDifficulty = (difficulty) => {
    if (difficulty === 'insane')
        return 'hard';
    if (difficulty === 'info')
        return 'easy';
    return difficulty;
};

const ChallengesCard = ({ title, description, difficulty, url, image, progress, type, pageReferrer, duration, povTag, isRoomSaved = false, tagsDoc, handleSavedRoom, roomType, isLoading = false, isUserAuth = true, contentDropTimeRemaining, onClick, }) => {
    const contentWrapperRef = React.useRef(null);
    const icon = roomType === exports.RoomType.Challenge ? faFlag$1 : faRoute;
    const [isHovered, setIsHovered] = React.useState(false);
    const isActiveContentDropState = Boolean(contentDropTimeRemaining && contentDropTimeRemaining > 0);
    const countdownRef = useContentDropCountdown(contentDropTimeRemaining);
    return (jsxRuntime.exports.jsxs(StyledCardMainWrapper, { "$isActiveContentDrop": isActiveContentDropState, children: [jsxRuntime.exports.jsxs(StyledCardContainer, { onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), "$isActiveContentDrop": isActiveContentDropState, children: [jsxRuntime.exports.jsxs(StyledClickableArea, { to: url, state: { pageReferrer, type }, onClick: onClick, children: [jsxRuntime.exports.jsxs(StyledContentWrapper$1, { ref: contentWrapperRef, children: [jsxRuntime.exports.jsx(StyledProgressWrapper$1, { children: jsxRuntime.exports.jsx(CircularImageProgress, { progressValue: progress, image: image, difficulty: adjustDifficulty(difficulty), size: 68, contentSizeAdjustment: 11, isCheckOnTop: true, iconCheckSize: 16 }) }), jsxRuntime.exports.jsx(StyledTitle$7, { children: title })] }), jsxRuntime.exports.jsxs(StyledFooter$1, { children: [jsxRuntime.exports.jsxs(StyledFooterContent, { children: [jsxRuntime.exports.jsxs(StyledFlex, { gap: "1.2rem", justifyContent: "flex-start", children: [roomType && jsxRuntime.exports.jsx(TagToolTip, { icon: icon, text: roomType }), jsxRuntime.exports.jsx(Difficulty, { difficulty: adjustDifficulty(difficulty), hasIcon: true, isSmall: true }), duration && jsxRuntime.exports.jsx(Duration, { duration: duration })] }), povTag && jsxRuntime.exports.jsx(PovTag, { povTag: povTag ?? 'purple' })] }), jsxRuntime.exports.jsx(StyledAditionalContent, { children: jsxRuntime.exports.jsx(StyledDescription$2, { "data-testid": "description-new", "$isActiveContentDrop": isActiveContentDropState, children: description }) })] })] }), jsxRuntime.exports.jsxs(StyledAditionalFooter, { children: [tagsDoc && tagsDoc.length > 0 ? (jsxRuntime.exports.jsx(StyledTags$3, { children: tagsDoc.slice(0, 2).map((tag) => (jsxRuntime.exports.jsx(Tag, { size: "small", variation: "main", color: "secondary", "data-type": "tag", children: tag }, tag))) })) : (jsxRuntime.exports.jsx("div", {})), handleSavedRoom && isUserAuth && (jsxRuntime.exports.jsx(StyledSavedButton, { variant: "text", onClick: handleSavedRoom, "$isRoomSaved": isRoomSaved, "aria-label": isRoomSaved ? 'Unsave room' : 'Save room', disabled: isLoading, children: isLoading ? jsxRuntime.exports.jsx(StyledSpinner, {}) : jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: isRoomSaved ? faBookmark : faBookmark$1 }) }))] })] }), isActiveContentDropState && (jsxRuntime.exports.jsx(StyledBonusWrapper, { children: isHovered ? (jsxRuntime.exports.jsxs(StyledBonusHovered, { children: [jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faGift }), jsxRuntime.exports.jsx("p", { "data-text": "bonus", children: "Earn 50% more points" })] }), jsxRuntime.exports.jsxs("p", { "data-text": "bonus", children: ["Ends in ", jsxRuntime.exports.jsx("span", { ref: countdownRef })] })] })) : (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faGift }), jsxRuntime.exports.jsx("p", { "data-text": "bonus", children: "New release bonus" })] })) }))] }));
};

const StyledCharacterCard = styled__default["default"].div `
  border-radius: ${({ theme }) => theme.radius.small};
  min-height: 46.2rem;
  width: 37.6rem;
  overflow: hidden;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    height: 39.3rem;
    width: 35rem;
  }
`;
const StyledCardImage$4 = styled__default["default"](Image) `
  height: 50%;
  object-fit: cover;
  background-position: center;
  width: 100%;
`;
const StyledCardContent$2 = styled__default["default"].div `
  background-color: ${({ theme }) => theme.colors.secondary.main};
  color: white;
  min-height: 23.2rem;
  width: 100%;
  margin-top: -0.5rem;
`;
const StyledTopWrapper = styled__default["default"].div `
  position: relative;
  display: flex;
`;
const StyledImageLabel = styled__default["default"].label `
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 0.7rem 1.2rem;
  background-color: ${({ theme }) => theme.colors.grey[200]};
  border-top-right-radius: ${({ theme }) => theme.radius.big};
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-style: normal;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: normal;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin: 20.2rem 0 0 -35.6rem;
  }
`;
const CharacterTitle = styled__default["default"].span `
  font-family: ${({ theme }) => theme.fonts.familyBungee};
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-style: normal;
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  margin-right: 0.8rem;
  color: ${({ theme }) => theme.colors.text.main};
`;
const CharacteCategory = styled__default["default"].span `
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-style: normal;
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  line-height: 2.2rem;
  color: ${({ theme }) => theme.colors.primary.main};
`;
const CharacteMessage = styled__default["default"].div `
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-style: normal;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  color: ${({ theme }) => theme.colors.text.light};
  padding-top: 0.8rem;
`;
const StyledContent$6 = styled__default["default"].div `
  padding: 2.4rem 2.4rem 3.2rem 2.4rem;
`;

const CharacterCard = ({ characterTitle, characterImage, characterTag, characterMessage, characterCategory, }) => (jsxRuntime.exports.jsxs(StyledCharacterCard, { "data-testid": "character-card", children: [jsxRuntime.exports.jsxs(StyledTopWrapper, { children: [jsxRuntime.exports.jsx(StyledCardImage$4, { src: characterImage, alt: "characterImage" }), jsxRuntime.exports.jsx(StyledImageLabel, { children: characterTag })] }), jsxRuntime.exports.jsx(StyledCardContent$2, { children: jsxRuntime.exports.jsxs(StyledContent$6, { children: [jsxRuntime.exports.jsx(CharacterTitle, { children: characterTitle }), jsxRuntime.exports.jsx(CharacteCategory, { children: characterCategory }), jsxRuntime.exports.jsx(CharacteMessage, { children: characterMessage })] }) })] }));

const StyledCopyButtonTooltipContent = styled__default["default"].div `
  display: flex;
  gap: 0.3rem;
  align-items: center;
  min-width: 2.8rem;

  & > span {
    width: max-content;
  }
`;
const StyledCopyButtonWrapper = styled__default["default"].div `
  position: relative;
  width: 2.8rem;
  height: 2.8rem;
`;
const StyledCopyButtonTooltipWrapper = styled__default["default"].div `
  position: absolute;
  top: -4.75rem;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;

  & > div {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const CopyButtonWithTooltip = ({ value }) => {
    const [tooltipContent, setTooltipContent] = React.useState('Copy to clipboard');
    const [tooltipVisible, setTooltipVisible] = React.useState(false);
    const [isHover, setIsHover] = React.useState(false);
    const handleClick = React.useCallback(async () => {
        if (value) {
            setTooltipContent('Copied');
            setTooltipVisible(true);
            await navigator.clipboard.writeText(value.toString());
            window.dispatchEvent(new Event('copy'));
        }
    }, [value]);
    const handleMouseEnter = React.useCallback(() => setIsHover(true), []);
    const handleMouseLeave = React.useCallback(() => setIsHover(false), []);
    React.useEffect(() => {
        if (tooltipVisible) {
            setTimeout(() => {
                setTooltipVisible(false);
                setTooltipContent('Copy to clipboard');
            }, 1600);
        }
    }, [tooltipVisible]);
    return (jsxRuntime.exports.jsxs(StyledCopyButtonWrapper, { children: [jsxRuntime.exports.jsx(IconButton, { "data-testid": "copy-button", onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, variant: "copy", width: "2.8rem", height: "2.8rem", "aria-label": "copy", children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCopy$1 }) }), (isHover || tooltipVisible) && (jsxRuntime.exports.jsx(StyledCopyButtonTooltipWrapper, { children: jsxRuntime.exports.jsx(Tooltip, { arrowPosition: "bottom-center", children: jsxRuntime.exports.jsxs(StyledCopyButtonTooltipContent, { children: [tooltipContent === 'Copied' && jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCheck$1 }), jsxRuntime.exports.jsx("span", { children: tooltipContent })] }) }) }))] }));
};

exports.RoomDifficulty = void 0;
(function (RoomDifficulty) {
    RoomDifficulty["EASY"] = "easy";
    RoomDifficulty["MEDIUM"] = "medium";
    RoomDifficulty["HARD"] = "hard";
    RoomDifficulty["INSANE"] = "insane";
    RoomDifficulty["INFO"] = "info";
})(exports.RoomDifficulty || (exports.RoomDifficulty = {}));

const getDifficultyColor = (difficulty, theme) => {
    switch (difficulty) {
        case exports.RoomDifficulty.EASY: {
            return theme.colors.success.main;
        }
        case exports.RoomDifficulty.MEDIUM: {
            return theme.colors.warning.light;
        }
        case exports.RoomDifficulty.HARD: {
            return theme.colors.error.main;
        }
        case exports.RoomDifficulty.INSANE: {
            return theme.colors.purple.main;
        }
        default: {
            return theme.colors.purple.main;
        }
    }
};
const StyledDifficultyLabelWrapper = styled__default["default"].div `
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;
const StyledBarsIcon = styled__default["default"](FontAwesomeIcon) `
  width: 1.8rem;
  height: 1.4rem;
  color: ${({ theme, $difficulty }) => getDifficultyColor($difficulty, theme)};
`;
const StyledDifficultyLabel$1 = styled__default["default"].span `
  color: ${({ theme, $difficulty }) => getDifficultyColor($difficulty, theme)};
`;

const resolvedDifficultyProps = {
    [exports.RoomDifficulty.EASY]: { icon: faSignalBarsWeak, text: 'Easy' },
    [exports.RoomDifficulty.MEDIUM]: { icon: faSignalBarsFair, text: 'Medium' },
    [exports.RoomDifficulty.HARD]: { icon: faSignalBarsGood, text: 'Hard' },
    [exports.RoomDifficulty.INSANE]: { icon: faSignalBarsStrong, text: 'Insane' },
    [exports.RoomDifficulty.INFO]: { icon: faSignalBarsStrong, text: 'Info' },
};
const DifficultyLabel = ({ difficulty }) => {
    const { icon, text } = resolvedDifficultyProps[difficulty];
    return (jsxRuntime.exports.jsxs(StyledDifficultyLabelWrapper, { children: [jsxRuntime.exports.jsx(StyledBarsIcon, { icon: icon, "$difficulty": difficulty, "data-testid": "icon" }), jsxRuntime.exports.jsx(StyledDifficultyLabel$1, { "$difficulty": difficulty, children: text })] }));
};

const StyledDragDropContainer = styled__default["default"].div `
  position: relative;
  border: 2px dashed ${({ theme, $isDragOver, $hasError }) => {
    if ($hasError)
        return theme.colors.error.main;
    if ($isDragOver)
        return theme.colors.info.main;
    return theme.colors.statusTag.grey.background;
}};
  border-radius: ${({ theme }) => theme.radius.small};
  background-color: ${({ theme, $isDragOver, $disabled }) => {
    if ($disabled)
        return theme.colors.background.disabled;
    if ($isDragOver)
        return theme.colors.alertBanner.info;
    return theme.colors.background.tableOdd;
}};
  padding: 2.4rem;
  text-align: center;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease-in-out;
  min-height: 18.8rem;
  height: ${({ $height }) => $height ?? 'auto'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  margin-bottom: 2.4rem;

  &:hover {
    border-color: ${({ theme, $disabled, $hasError }) => {
    if ($disabled || $hasError)
        return 'inherit';
    return theme.colors.info.main;
}};
    background-color: ${({ theme, $disabled, $isDragOver }) => {
    if ($disabled)
        return 'inherit';
    if ($isDragOver)
        return theme.colors.alertBanner.info;
    return theme.colors.alertBanner.info;
}};
  }

  ${({ $isUploading }) => $isUploading &&
    styled.css `
      pointer-events: none;
      opacity: 0.7;
    `}

    small {
      color: ${({ theme }) => theme.colors.grey[600]};
    }
`;
const StyledUploadIcon = styled__default["default"](FontAwesomeIcon) `
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  color: ${({ theme }) => theme.colors.grey[800]};
`;
const StyledUploadText = styled__default["default"].div `
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
`;
const StyledFileInput = styled__default["default"].input `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
`;
const StyledErrorText = styled__default["default"].div `
  color: ${({ theme }) => theme.colors.error.main};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  margin-top: 1.6rem;
`;
const StyledButton$2 = styled__default["default"](Button$1) `
  background: ${({ theme }) => theme.colors.button.close.background};
`;
const StyledUploadedFiles = styled__default["default"].div `
  margin-top: 1.6rem;
`;
const StyledUploadedFile = styled__default["default"].div `
  display: flex;
  align-items: center;
  gap: 1.2rem;
  padding: 1.6rem;
  background-color: ${({ theme }) => theme.colors.background.main};
  border-radius: ${({ theme }) => theme.radius.small};
  border: 1px solid ${({ theme }) => theme.colors.statusTag.grey.background};
  position: relative;
  margin-bottom: 2.4rem;
`;
const StyledFileIcon = styled__default["default"].div `
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    color: ${({ theme }) => theme.colors.grey[600]};
    height: 3.8rem;
    width: auto;
  }
`;
const StyledFileInfo = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0.2rem;

`;
const StyledFileName = styled__default["default"].p `
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  margin-bottom: 0.6rem;  
  line-height: 2rem;
`;
const StyledFileSize = styled__default["default"].span `
  color: ${({ theme }) => theme.colors.grey[600]};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
`;
const StyledRemoveButton = styled__default["default"].button `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  background: none;
  color: ${({ theme }) => theme.colors.grey[500]};
  cursor: pointer;
  border-radius: ${({ theme }) => theme.radius.small};
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey[100]};
    color: ${({ theme }) => theme.colors.grey[700]};
  }

  &:active {
    transform: scale(0.95);
  }
`;

const formatFileSize = (bytes) => {
    if (bytes === 0)
        return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${Number.parseFloat((bytes / k ** i).toFixed(2))} ${sizes[i]}`;
};
const UploadedFile = ({ uploadedFiles, handleRemoveFile }) => {
    return (jsxRuntime.exports.jsx(StyledUploadedFiles, { "data-testid": "uploaded-files", children: uploadedFiles.map((file, index) => (jsxRuntime.exports.jsxs(StyledUploadedFile, { children: [jsxRuntime.exports.jsx(StyledFileIcon, { children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faFileSpreadsheet }) }), jsxRuntime.exports.jsxs(StyledFileInfo, { children: [jsxRuntime.exports.jsx(StyledFileName, { children: file.name }), jsxRuntime.exports.jsx(StyledFileSize, { children: formatFileSize(file.size) })] }), jsxRuntime.exports.jsx(StyledRemoveButton, { onClick: handleRemoveFile, type: "button", "data-testid": "remove-file-button", children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faXmark$2 }) })] }, `${file.name}-${index}`))) }));
};

const validateFileSize = (MAX_SIZE_MB = 10) => (file) => {
    const fileSizeMB = file.size / 1024 ** 2;
    const valid = fileSizeMB <= MAX_SIZE_MB;
    return {
        valid,
        error: valid ? null : `[${file.name}] - File too big (max ${MAX_SIZE_MB}MB)`,
    };
};
const validateFileFormat = (VALID_FORMATS = ['text/csv', 'application/vnd.ms-excel', 'text/plain']) => (file) => {
    const valid = VALID_FORMATS.includes(file.type) || file.name.toLowerCase().endsWith('.csv');
    return {
        valid,
        error: valid ? null : `[${file.name}] - Invalid file format. Only CSV files are allowed.`,
    };
};
const validateCsvFile = () => (file) => {
    const isCsv = file.type === 'text/csv' || file.type === 'application/vnd.ms-excel' || file.name.toLowerCase().endsWith('.csv');
    return {
        valid: isCsv,
        error: isCsv ? null : `[${file.name}] - Only CSV files are allowed.`,
    };
};
const validateCommonFiles = () => (file) => {
    const allowedExtensions = ['.jpg', '.jpeg', '.png', '.pdf', '.docx', '.pptx', '.txt', '.csv'];
    const allowedMimeTypes = [
        'text/csv',
        'application/vnd.ms-excel',
        'image/jpeg',
        'image/png',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'text/plain',
    ];
    const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
    const isValidExtension = allowedExtensions.includes(fileExtension);
    const isValidMimeType = allowedMimeTypes.includes(file.type);
    const isValid = isValidExtension || isValidMimeType;
    return {
        valid: isValid,
        error: isValid ? null : `[${file.name}] - Supported files: JPG, PNG, JPEG, PDF, DOCX, PPTX, TXT, CSV`,
    };
};

const SOMETHING_WENT_WRONG = 'Something went wrong. Please try again.';
const isErrorWithMessage = (error) => typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof error.message === 'string';
const isQueryErrorWithMessage = (error) => {
    if (typeof error !== 'object' || error === null || !('data' in error)) {
        return false;
    }
    const errorWithData = error;
    const data = errorWithData.data;
    return (typeof data === 'object' &&
        data !== null &&
        'message' in data &&
        typeof data.message === 'string');
};
const DragDropUploadReducer = (state, action) => {
    switch (action.type) {
        case 'idle':
            return { status: 'idle' };
        case 'uploading':
            return { status: 'uploading' };
        case 'error':
            return { status: 'error', error: action.payload };
        case 'drag-over':
            return { status: 'drag-over' };
        default:
            return state;
    }
};
const DragDropUpload = ({ handleFileUpload, onValidationError, hideError = false, fileValidators = [validateFileSize(10), validateCsvFile()], children, acceptedFileTypes = '.csv', disabled = false, placeholder = 'Drag & drop your CSV file here', showUploadedFiles = true, height, topIcon, buttonColorVariant = 'secondary', }) => {
    const inputRef = React.useRef(null);
    const [{ status, error }, setState] = React.useReducer(DragDropUploadReducer, { status: 'idle' });
    const [uploadedFiles, setUploadedFiles] = React.useState([]);
    const [internalProgress, setInternalProgress] = React.useState(0);
    const isDragOver = status === 'drag-over';
    const isUploading = status === 'uploading';
    const hasError = status === 'error';
    const validateFiles = React.useCallback((files) => {
        for (const validator of fileValidators) {
            const validations = [...files].map((file) => validator(file));
            if (!validations.every((v) => v.valid)) {
                const errors = validations
                    .filter((v) => !v.valid)
                    .map((v) => v.error)
                    .join(', ');
                setState({ type: 'error', payload: errors });
                onValidationError?.(errors);
                return false;
            }
        }
        return true;
    }, [fileValidators, onValidationError]);
    const processFiles = React.useCallback(async (files, event) => {
        if (!files.length || disabled)
            return;
        if (!validateFiles(files))
            return;
        setState({ type: 'uploading' });
        setInternalProgress(0);
        const progressTimer = setInterval(() => {
            setInternalProgress((prev) => Math.min(prev + 20, 80));
        }, 150);
        try {
            await handleFileUpload(files, event);
            clearInterval(progressTimer);
            setInternalProgress(100);
            if (showUploadedFiles && files[0]) {
                setUploadedFiles([files[0]]);
            }
            setState({ type: 'idle' });
            setInternalProgress(0);
            setTimeout(() => {
                if (inputRef.current) {
                    inputRef.current.value = '';
                }
            }, 100);
        }
        catch (uploadError) {
            clearInterval(progressTimer);
            setInternalProgress(0);
            setTimeout(() => {
                if (inputRef.current) {
                    inputRef.current.value = '';
                }
            }, 100);
            const errorMsg = isQueryErrorWithMessage(uploadError)
                ? uploadError.data.message
                : isErrorWithMessage(uploadError)
                    ? uploadError.message
                    : SOMETHING_WENT_WRONG;
            setState({ type: 'error', payload: errorMsg });
        }
    }, [handleFileUpload, validateFiles, disabled, showUploadedFiles]);
    const handleDragOver = React.useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!disabled) {
            setState({ type: 'drag-over' });
        }
    }, [disabled]);
    const handleDragLeave = React.useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!disabled) {
            setState({ type: 'idle' });
        }
    }, [disabled]);
    const handleDrop = React.useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        setState({ type: 'idle' });
        if (disabled)
            return;
        const files = event.dataTransfer.files;
        if (files.length) {
            processFiles(files, event);
        }
    }, [processFiles, disabled]);
    const handleFileInputChange = React.useCallback((event) => {
        const files = event.target.files;
        if (files?.length) {
            processFiles(files, event);
        }
    }, [processFiles]);
    const handleButtonClick = React.useCallback((event) => {
        event.stopPropagation();
        event.preventDefault();
        if (!disabled && inputRef.current && !isUploading) {
            inputRef.current.click();
        }
    }, [disabled, isUploading]);
    const handleRemoveFile = React.useCallback((event) => {
        event.stopPropagation();
        setUploadedFiles([]);
    }, []);
    const handleCancelClick = React.useCallback((event) => {
        event.stopPropagation();
        setState({ type: 'idle' });
        setUploadedFiles([]);
        setInternalProgress(0);
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    }, []);
    const defaultContent = (jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, { children: isUploading ? (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(CircularProgress, { size: 50, progressValue: internalProgress }), jsxRuntime.exports.jsx(StyledUploadText, { children: "Uploading file..." }), jsxRuntime.exports.jsx(StyledButton$2, { type: "button", onClick: handleCancelClick, color: "secondary", variant: "outlined", children: "Cancel" })] })) : (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [topIcon ?? jsxRuntime.exports.jsx(StyledUploadIcon, { icon: faArrowUpFromBracket }), jsxRuntime.exports.jsx(StyledUploadText, { children: placeholder }), jsxRuntime.exports.jsx(StyledButton$2, { type: "button", onClick: handleButtonClick, disabled: disabled || isUploading, color: buttonColorVariant, variant: "outlined", size: "small", children: "Choose file" }), jsxRuntime.exports.jsx("small", { children: "Maximum file size: 100 MB" })] })) }));
    return (jsxRuntime.exports.jsxs("section", { children: [(!showUploadedFiles || uploadedFiles.length === 0) && (jsxRuntime.exports.jsxs(StyledDragDropContainer, { "$isDragOver": isDragOver, "$isUploading": isUploading, "$hasError": hasError, "$disabled": disabled, onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop, style: { cursor: 'default' }, "data-testid": "drag-drop-upload", "$height": height ?? 'auto', children: [children || defaultContent, jsxRuntime.exports.jsx(StyledFileInput, { ref: inputRef, type: "file", accept: acceptedFileTypes, onChange: handleFileInputChange, disabled: disabled, "data-testid": "drag-drop-file-input" })] })), hasError && !hideError && (jsxRuntime.exports.jsx(FormErrorMessage, { children: jsxRuntime.exports.jsx(StyledErrorText, { children: error }) })), showUploadedFiles && uploadedFiles.length > 0 && (jsxRuntime.exports.jsx(UploadedFile, { uploadedFiles: uploadedFiles, handleRemoveFile: handleRemoveFile }))] }));
};

const StyledFieldAdornedWrapperHorizontal = styled__default["default"].div `
  display: flex;
  align-items: center;
  width: 100%;
  gap: 1rem;
`;
const StyledFieldAdornedWrapperVertical = styled__default["default"].div `
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const FieldAdorned = ({ leftOutsideAdornment, bottomAdornment, rightOutsideAdornment, children, }) => (jsxRuntime.exports.jsxs(StyledFieldAdornedWrapperVertical, { children: [jsxRuntime.exports.jsxs(StyledFieldAdornedWrapperHorizontal, { children: [leftOutsideAdornment, children, rightOutsideAdornment] }), bottomAdornment] }));

const StyledWrapperTooltipDefault = styled.css `
  position: absolute;
  left: -1rem;
  transform: translate(-100%, -50%);
  width: max-content;
  z-index: 1;
  text-align: center;
  display: none;
  top: 50%;
`;
const StyledUserName$3 = styled__default["default"].p `
  align-items: center;
  display: flex;
  gap: 0.4rem;

  a {
    color: ${({ theme }) => theme.colors.text.main};
    font-weight: ${({ $hasLevelRankTitle }) => ($hasLevelRankTitle ? 'bold' : 'normal')};
    text-decoration: none;
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 12.5rem;
    white-space: nowrap;
    :hover {
      text-decoration: underline;
    }

    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      max-width: 20.5rem;
    }
  }
  
  span {
    color: ${({ theme }) => theme.colors.paragraph};
  }
`;
const StyledFriendUserWrapper = styled__default["default"].div `
  display: grid;
  grid-template-columns:  3.8rem 1fr;
  gap: 0.8rem;
  flex: 1 1 auto;
`;
const StyledFriendItem = styled__default["default"].div `
  display: grid;
  align-items: center;
  gap: 1rem;
  padding: 0.8rem;
  transition: all 0.3s ease-in-out;
  grid-template-columns: 1fr 1fr;

  p {
    color: ${({ theme }) => theme.colors.paragraph};
    width: max-content;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-rows: 3.8rem 1fr;
    padding: 0;
    :not(:last-child) {
      margin-bottom: 0.8rem;
    }
  }
`;
const StyledTooltipWrapper$1 = styled__default["default"].div `
  ${StyledWrapperTooltipDefault};
  transform: ${({ $isFirstItem }) => ($isFirstItem ? 'translate(-50%, 100%)' : 'translate(-50%, -100%)')};
  left: 50%;
  top: ${({ $isFirstItem }) => ($isFirstItem ? '2px' : '-50%')};

  &[data-type='completed-rooms'] {
    transform: ${({ $isFirstItem }) => ($isFirstItem ? 'translate(-67%, 100%)' : 'translate(-67%, -100%)')};
    left: 0.6rem;
  }

  & > div[role='tooltip'] {
    max-width: 12rem;
    & > div {
      padding: 0.8rem;
    }
  }
`;
const StyledWrapperRecords = styled__default["default"].div `
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  gap: 0.4rem;
  position: relative;
  justify-self: ${({ $justifySelf }) => $justifySelf ?? 'end'};

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    ${({ $largeRecords }) => ($largeRecords ? 'grid-row: 2;' : '')}
    justify-self: start;
    gap: 0.65rem;
  }
`;
const StyledWrapperRecord = styled__default["default"].div `
  position: relative;

  &:hover {
    div[data-section='records-tooltip'] {
      display: inline-block;
      animation: appear 0.3s ease-in-out;
    }
  }
  ${StyledAppearAnimation$1};
`;
const StyledRecordItem = styled__default["default"].div `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  transition: all 0.3s ease-in-out;
  position: relative;
  padding: 0.4rem 0.8rem;
  cursor: pointer;
  border-radius: 10rem;


  svg {
    height: ${({ $largeRecords }) => ($largeRecords ? '1.6rem' : '1.2rem')};
    width: ${({ $largeRecords }) => ($largeRecords ? '1.6rem' : '1.2rem')};
  }

  p {
    font-size: ${({ theme, $largeRecords }) => ($largeRecords ? theme.fonts.sizes.default : theme.fonts.sizes.small)};
    line-height: 1.7rem;
    color: ${({ theme }) => theme.colors.paragraph};
  }

  &[data-type='points'] {
    min-width: ${({ $largeRecords }) => ($largeRecords ? '8.2rem' : '7.5rem')};
    svg path {
      fill: ${({ theme }) => theme.colors.warning.main};
    }

    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      background-color: ${({ theme }) => theme.colors.statusTag.orange.background};
    }
  }

  &[data-type='streak'] {
    min-width: ${({ $largeRecords }) => ($largeRecords ? '5.2rem' : '4.6rem')};
    svg path {
      fill: ${({ theme }) => theme.colors.primary.main};
    }


    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      background-color: ${({ theme }) => theme.colors.success.light};
      min-width: ${({ $largeRecords }) => ($largeRecords ? '6.2rem' : '4.6rem')};
    }
  }

  &[data-type='completed-rooms'] {
    min-width: ${({ $largeRecords }) => ($largeRecords ? '5.2rem' : '4.6rem')};
    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 3.5rem;
    }

    path {
      fill: ${({ theme }) => theme.colors.info.main};
    }

    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      background-color: ${({ theme }) => theme.colors.statusTag.blue.background};
      min-width: ${({ $largeRecords }) => ($largeRecords ? '6.2rem' : '4.6rem')};
      p {
        max-width: 11rem;
      }
    }
  }

  &:hover {
    &[data-type='points'] {
      background-color: ${({ theme }) => theme.colors.statusTag.orange.background};
    }

    &[data-type='streak'] {
      background-color: ${({ theme }) => theme.colors.success.light};
    }

   &[data-type='completed-rooms'] {
      background-color: ${({ theme }) => theme.colors.statusTag.blue.background};
    }
  }

  a {
    color: ${({ theme }) => theme.colors.paragraph};
    text-decoration: none;
    :hover {
      text-decoration: underline;
    }
  }
`;

const RecordTooltip = ({ content, tooltipText, arrowPosition, type, isFirstItem }) => {
    const dynamicArrowPosition = arrowPosition ?? (isFirstItem ? 'top-center' : 'bottom-center');
    return (jsxRuntime.exports.jsxs(StyledWrapperRecord, { "data-testid": type, "data-type": type, children: [content, jsxRuntime.exports.jsx(StyledTooltipWrapper$1, { "data-section": "records-tooltip", "data-type": type, "data-tooltip": "full-screen", "$isFirstItem": isFirstItem, children: jsxRuntime.exports.jsx(Tooltip, { arrowPosition: dynamicArrowPosition, children: tooltipText }) })] }));
};

const FriendItem = ({ friend, isMyUser, isFirstItem, hasRankTitle = false, justifySelf = 'end', largeRecords = false, }) => {
    return (jsxRuntime.exports.jsxs(StyledFriendItem, { "data-testid": "friend-item", children: [jsxRuntime.exports.jsxs(StyledFriendUserWrapper, { children: [jsxRuntime.exports.jsx(Avatar, { avatarSrc: friend.avatar, size: "38px", mobileSize: "38px", borderColor: isMyUser ? `${theme.colors.primary.main}` : undefined, borderWidth: "0.2rem" }), jsxRuntime.exports.jsxs(StyledUserName$3, { "$hasLevelRankTitle": hasRankTitle, children: [jsxRuntime.exports.jsxs(reactRouterDom.Link, { to: `/p/${friend.username}`, children: [" ", friend.username, " "] }), hasRankTitle && friend.rankTitle && jsxRuntime.exports.jsx("span", { children: friend.rankTitle })] })] }), jsxRuntime.exports.jsxs(StyledWrapperRecords, { "$largeRecords": largeRecords, "$justifySelf": justifySelf, children: [jsxRuntime.exports.jsx(RecordTooltip, { content: jsxRuntime.exports.jsxs(StyledRecordItem, { "data-type": "points", "$largeRecords": largeRecords, children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCrosshairs }), " ", jsxRuntime.exports.jsx("p", { children: friend.totalPoints })] }), tooltipText: "Points", type: "points", isFirstItem: isFirstItem }), jsxRuntime.exports.jsx(RecordTooltip, { content: jsxRuntime.exports.jsxs(StyledRecordItem, { "data-type": "streak", "$largeRecords": largeRecords, children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faFire$1 }), jsxRuntime.exports.jsx("p", { children: friend.streak })] }), tooltipText: "Streak", type: "streak", isFirstItem: isFirstItem }), jsxRuntime.exports.jsx(RecordTooltip, { content: jsxRuntime.exports.jsxs(StyledRecordItem, { "data-type": "completed-rooms", "$largeRecords": largeRecords, children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faDoorClosed }), jsxRuntime.exports.jsx("p", { children: friend?.completedRooms ?? 0 })] }), tooltipText: "Completed Rooms", type: "completed-rooms", isFirstItem: isFirstItem, arrowPosition: isFirstItem ? 'top-right' : 'bottom-right' })] })] }));
};

const StyledMultiCard = styled__default["default"](reactRouterDom.Link) `
  ${StyledCardBoxShadowCommon};
  background-color: ${({ theme }) => theme.colors.background.lighter};
  border-radius: ${({ theme }) => theme.radius.small};
  display: flex;
  gap: 16px;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  max-height: 33.3rem;
  min-height: ${({ $cardType, $hasCollaborator }) => $hasCollaborator && $cardType !== exports.CardTypeEnum.MODULE ? '29rem' : '25.6rem'};
  text-decoration: none;
  height: ${({ $cardHeight, $cardType }) => $cardHeight ??
    (($cardType === exports.CardTypeEnum.MODULE && '25.6rem') || ($cardType === exports.CardTypeEnum.NETWORK && '31.3') || '27.6rem')};
`;
const StyledWrapperCard = styled__default["default"].div `
  position: relative;
  &:hover ${StyledCardOverlay} {
    opacity: 1;
    visibility: visible;
    transition: 0.3s linear;
  }
`;
const StyledHeader = styled__default["default"].div `
  display: flex;
  justify-content: space-between;
  align-items: start;

  & > div {
    display: flex;
    gap: 1rem;
    align-items: center;
  }

  ${({ $cardType, theme }) => $cardType === exports.CardTypeEnum.MODULE
    ? `
    background:  ${theme.colors.gradientDarkFlip};
    border-radius: ${theme.radius.small} ${theme.radius.small} 0 0;
    height: 5rem;
    padding: 0 1.6rem 0;
    margin-bottom: 3.4rem;
    align-items: center;

    img {
      position: relative;
      top: 2rem;
    }
  `
    : 'padding: 1.6rem 1.6rem 0'}
`;
const StyledWrapper$3 = styled__default["default"].div `
  padding: 0 1.6rem 1.6rem;

  &[data-content='content'] {
    max-height: 15rem;
    padding: 0 1.6rem 0.6rem;
  }
`;
const StyledTitle$6 = styled__default["default"].h2 `
  ${StyledCardTitle};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  margin: 1rem 0;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;
const StyledDescription$1 = styled__default["default"].p `
  ${StyledCardDescription};
  color: ${({ theme }) => theme.colors.text.lighter};
  -webkit-line-clamp: ${({ $cardType }) => ($cardType === exports.CardTypeEnum.NETWORK ? '6' : '4')};
`;
const StyledImageContainer$3 = styled__default["default"].div `
  ${({ $cardType }) => {
    const imageSize = $cardType === exports.CardTypeEnum.MODULE ? '6.4rem' : '5rem';
    return `
      height: ${imageSize};
      width: ${imageSize};
    `;
}}
`;
const StyledCardImage$3 = styled__default["default"](Image) `
  height: inherit;
  object-fit: cover;
  width: inherit;
`;
const StyledMoreInfoWrapper = styled__default["default"].div `
  align-items: center;
  color: ${({ theme }) => theme.colors.text.lighter};
  display: flex;
  gap: 1rem;
  justify-content: ${({ $difficulty }) => ($difficulty ? 'space-between' : 'flex-end')};

  & > div {
    display: flex;
    align-items: center;
  }
`;
const StyledTags$2 = styled__default["default"].div `
  align-items: center;
  border-top: 0.1rem solid ${({ theme }) => theme.colors.border.light};
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  padding-top: 0.6rem;
  margin-top: 1rem;
`;
const StyledStreak = styled__default["default"].span `
  color: ${({ theme }) => theme.colors.primary.main};

  svg {
    font-size: 12px;
    fill: ${({ theme }) => theme.colors.primary.main};
  }
`;
const StyledFilterTag = styled__default["default"].span `
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  border-radius: ${({ theme }) => theme.radius.huge};
  background: ${({ theme }) => theme.colors.grey[300]};
  color: ${({ theme }) => theme.colors.secondary.main};
  padding: 0.2rem 1rem;
  text-transform: uppercase;
  height: 1.8rem;
  display: flex;
  align-items: center;
`;
const StyledCollaborator = styled__default["default"].div `
  align-items: center;
  display: flex;
  gap: 0.6rem;
  text-decoration: none;

  span {
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.text.lighter};
  }

  img {
    height: 2.4rem;
    width: auto;
  }
`;
const StyledCloseIcon$1 = styled__default["default"](FontAwesomeIcon) `
  color: ${({ theme }) => theme.colors.grey[600]};
  height: 2rem;
`;

const Collaborator = ({ collaboratorName, collaboratorImageLight, collaboratorImageDark, isDarkVersion, }) => {
    const { theme } = React.useContext(SwitchThemeContext);
    const isDarkMode = theme === 'dark' || isDarkVersion;
    const image = isDarkMode ? collaboratorImageDark : collaboratorImageLight;
    return (jsxRuntime.exports.jsxs(StyledCollaborator, { "data-testid": "collaborator", children: [jsxRuntime.exports.jsx("span", { children: "Created with" }), jsxRuntime.exports.jsx(Image, { src: image ?? '', alt: collaboratorName, height: "24" })] }));
};

const sharedCardImageStyles$1 = styled.css `
  border-radius: ${({ theme }) => theme.radius.small};
  height: 100%;
  object-fit: ${({ $hasChildren }) => ($hasChildren ? 'contain' : 'cover')};
  object-position: top center;
  width: 100%;
  transition: all 0.5s ease-in-out;
`;
const StyledCardImageNoSpinner$1 = styled__default["default"].img `
  ${sharedCardImageStyles$1}
`;
const StyledCardImage$2 = styled__default["default"](Image) `
  ${sharedCardImageStyles$1}
`;
const StyledPathCard$2 = styled__default["default"](reactRouterDom.Link) `
  border-radius: ${({ theme }) => theme.radius.small};
  height: ${({ $hasChildren }) => ($hasChildren ? '42.5rem' : '30rem')};
  display: flex;
  position: relative;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &:hover {
    ${StyledCardImage$2}, ${StyledCardImageNoSpinner$1} {
      transform: scale(1.1);
    }

    div[data-style='button'] {
      background-color: ${({ theme }) => theme.colors.primary.lighter};
      color: ${({ theme }) => theme.colors.white};
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    height: ${({ $hasChildren }) => ($hasChildren ? '39.3rem' : '24.4rem')};
  }
`;
const StyledImageWrapper = styled__default["default"].div `
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radius.small};
`;
const StyledCardContent$1 = styled__default["default"].div `
  color: ${({ theme }) => theme.colors.grey[200]};
  background: linear-gradient(
    to top,
    ${({ theme }) => theme.colors.secondary.main} ${({ $hasChildren }) => ($hasChildren ? '50.14%' : '36%')},
    transparent ${({ $hasChildren }) => ($hasChildren ? '80.88%' : '70%')}
  );
  bottom: 0;
  border-radius: ${({ theme }) => theme.radius.small};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: end;
  padding: 2.4rem;
  position: absolute;
  width: 100%;

  h3 {
    color: ${({ theme }) => theme.colors.grey[100]};
    font-weight: ${({ theme }) => theme.fonts.weight.regular};
    margin-bottom: ${({ $hasChildren }) => ($hasChildren ? '1.2rem' : '2.4rem')};
    word-wrap: break-word;
  }

  a {
    color: ${({ theme }) => theme.colors.grey[100]};
    width: fit-content;
  }

  p,
  li,
  span,
  & > div {
    font-weight: ${({ theme }) => theme.fonts.weight.regular};
    font-size: ${({ theme }) => theme.fonts.sizes.default};
  }

  p {
    text-align: left !important;
  }

  ul {
    list-style: disc;
    margin: 1.4rem 0 0 2.3rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: 1.8rem;
  }
`;
const StyledStatsWrapper = styled__default["default"].div `
  display: flex;
  align-items: center;
  margin-top: 2rem;
  margin-bottom: ${({ showProgressBar }) => (showProgressBar ? `1.6rem` : '0')};
`;
const StyledClock = styled__default["default"](FontAwesomeIcon) `
  margin-right: 0.6rem;
`;
const StyledPathButton = styled__default["default"].div `
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.radius.small};
  color: ${({ $buttomTheme, theme }) => ($buttomTheme === 'default' ? theme.colors.black : theme.colors.white)};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  display: inline-flex;
  width: fit-content;
  height: 3.6rem;
  transition: all 0.2s ease-in-out;
  padding: 0.9rem 1.6rem;
  background-color: ${({ $buttomTheme, theme }) => $buttomTheme === 'default' ? theme.colors.primary.main : theme.colors.secondary.main};
  border: 1px solid ${({ theme }) => theme.colors.primary.main};

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: 0.6rem 1rem;
  }
`;
const StyledRoomProgressbar = styled__default["default"].div `
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
`;
const StyledPaidTagWrapper$1 = styled__default["default"].div `
  position: absolute;
  top: 2.4rem;
  left: 2.4rem;
  z-index: 2;

  &:hover {
    div[role='tooltip'] {
      opacity: 1;
      visibility: visible;
    }
  }
`;
const StyledPaidTag = styled__default["default"](Tag) `
  background: ${lightColors.info.lighter};
  color: ${lightColors.info.main};
  height: 1.8rem;
`;
const StyledTooltipWrapper = styled__default["default"].div `
  display: flex;
  position: absolute;
  top: -80px;
  left: 50%;
  transform: translateX(-50%);

  div[role='tooltip'] {
    background-color: ${lightColors.background.tertiary};
    color: ${lightColors.text.main};
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    visibility: hidden;
    width: 22.5rem;

    &::before {
      border-color: ${lightColors.background.tertiary};
      border-bottom-color: transparent;
      border-left-color: transparent;
      border-right-color: transparent;
    }
  }
`;

const sharedCardImageStyles = styled.css `
  border-radius: ${({ theme }) => theme.radius.small} ${({ theme }) => theme.radius.small} 0 0;
  height: 100%;
  height: 18.4rem;
  object-fit: cover;
  object-position: top center;
  width: 100%;
`;
const StyledPathCard$1 = styled__default["default"](reactRouterDom.Link) `
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  background-color: ${({ theme }) => theme.colors.background.lighter};
  display: flex;
  flex-direction: column;
  height: ${({ $hasFooterComponent }) => ($hasFooterComponent ? '36.1rem' : '34.3rem')};
  justify-content: space-between;
  transition: box-shadow 0.3s ease-in-out, opacity 0.3s ease-in-out;
  opacity: 1;
  text-decoration: none;
  position: relative;
  overflow: ${({ $pathType }) => ($pathType === 'cloud' ? 'visible;' : 'hidden')};
  transform: translateY(0);

  cursor: ${({ $hasFooterComponent, $isComingSoon }) => ($hasFooterComponent || $isComingSoon ? 'default' : 'pointer')};

  ${({ $isDisabled }) => $isDisabled &&
    styled.css `
      cursor: not-allowed;

      > div:first-child {
        opacity: 0.2;
      }
      > div:not(:first-child) > div {
        opacity: 0.2;
      }
    `}

  ${({ $isComingSoon }) => !$isComingSoon &&
    styled.css `
      &:hover {
        box-shadow: ${({ theme }) => theme.colors.boxShadow.hover};
        width: 100%;

        div[data-content='position'] {
          bottom: 5.6rem;
          max-height: 30rem;
          overflow: visible;
          height: fit-content;
          width: 100%;
          transition: all 0.4s ease-in-out;
          transform: translateY(-54%);
        }

        ul {
          max-height: 30rem;
        }
      }
    `}

  ${({ $isHoverOn }) => !$isHoverOn &&
    styled.css `
      &:hover {
        box-shadow: ${({ theme }) => theme.boxShadow.light};
        width: auto;

        div[data-content='position'] {
          bottom: auto;
          max-height: auto;
          overflow: hidden;
          height: auto;
          width: auto;
          transition: none;
          transform: none;
        }

        ul {
          max-height: auto;
        }
      }
    `}
`;
const StyledPathHeaderBodyWrapper = styled__default["default"].div `
  position: relative;
`;
const StyledCardHeader = styled__default["default"].div `
  max-height: 18.4rem;
  position: relative;
`;
const StyledCardImageNoSpinner = styled__default["default"].img `
  ${sharedCardImageStyles};
`;
const StyledCardImage$1 = styled__default["default"](Image) `
  ${sharedCardImageStyles};
`;
const StyledWrapperItems = styled__default["default"].div `
  display: flex;
  gap: 1rem;
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;
`;
const StyledCardContentWrapper = styled__default["default"].div `
  position: absolute;
  width: 100%;
`;
const StyledCardContent = styled__default["default"].div `
  padding: 1.6rem 1.6rem 0;
  background-color: ${({ theme }) => theme.colors.background.lighter};
  height: auto;
  max-height: 14rem;
  transition: all 0.4s ease-in-out;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 1.8rem;

  h3 {
    color: ${({ theme }) => theme.colors.text.main};
    font-weight: ${({ theme }) => theme.fonts.weight.regular};
    font-size: 1.8rem;
    margin-bottom: 1rem;
    word-wrap: break-word;
  }

  p,
  li,
  div,
  span {
    color: ${({ theme }) => theme.colors.text.lighter};
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    line-height: 2rem;
  }
  p {
    text-align: left !important;
  }

  ul {
    max-height: 0;
    height: auto;
    padding-left: 2.4rem;
    list-style: disc;
    transition: max-height 0.3s ease-in-out;
    margin-top: 1rem;
    overflow: hidden;
    visibility: ${({ isHoverOn }) => (isHoverOn ? 'visible' : 'hidden')};
  }

  &:hover {
    ul {
      max-height: ${({ isHoverOn }) => (isHoverOn ? 'auto' : '0')};
      visibility: ${({ isHoverOn }) => (isHoverOn ? 'visible' : 'hidden')};
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: 1.8rem;
  }
`;
const ClampedDescription = styled__default["default"].div `
  display: -webkit-box;
  -webkit-line-clamp: ${({ $maxLinesCount }) => $maxLinesCount ?? 'unset'};
  line-height: 2rem;
  max-height: ${({ $maxLinesCount }) => ($maxLinesCount ? `calc(2rem * ${$maxLinesCount})` : 'auto')};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const StyledLearnMoreLink = styled__default["default"].a `
  && {
    color: ${({ theme }) => theme.colors.text.highlight};
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    cursor: pointer;
    display: block;
    visibility: hidden;
    margin-bottom: 1.9rem;
  }
  /* stylelint-disable selector-type-no-unknown */
  // This selector is legit, linter should not throw unknown selector "-styled-mixin0"
  ${StyledPathCard$1}:hover & {
    visibility: visible;
  }
  /* stylelint-enable selector-type-no-unknown */
`;
const StyledComingSoonTag = styled__default["default"].div `
  background-color: ${({ theme }) => theme.colors.primary.main};
  border-radius: ${({ theme }) => theme.radius.huge};
  color: ${({ theme }) => theme.colors.background.main};
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  line-height: 2.2rem;
  width: 9.1rem;
  text-align: center;
`;
const StyledCardFooter$1 = styled__default["default"].div `
  align-items: ${({ $hasFooterComponent }) => ($hasFooterComponent ? 'flex-end' : 'center')};
  background-color: ${({ theme }) => theme.colors.background.lighter};
  border-radius: ${({ theme }) => theme.radius.small};
  bottom: 0;
  color: ${({ theme }) => theme.colors.text.lighter};
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding: 1.8rem 1.6rem 1.6rem;
  position: fixed;
  width: 100%;

  & > div {
    display: flex;
    align-items: center;
  }
`;
const StyledPaidTagWrapper = styled__default["default"].div `
  position: relative;
  top: 0.2rem;

  &:hover {
    div[role='tooltip'] {
      opacity: 1;
      visibility: visible;
    }
  }
`;
const StyledDifficultyDurationGroup = styled__default["default"].div `
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
`;

const LearningPathCard = ({ title, image, code, difficulty = 'easy', duration, description, showCardType = false, showComingSoon = false, progressValue = 10, isCompleted = false, isNew = false, newBadgeText = 'New', pathType = 'regular', url, isHoverOn = true, hasCollaborator = false, collaboratorName, collaboratorImageLight, collaboratorImageDark, noImgSpinner = false, footerComponent, isDisabled, onLearnMore, isMyLearning = false, firstBtnText, secondBtnText, onFirstBtnClick, onSecondBtnClick, btnsWidth, descriptionMaxLinesCount, ...anchorProps }) => {
    const showProgress = !isCompleted && !isNew && progressValue !== 0 && progressValue <= 99;
    const showCompleted = isCompleted || progressValue === 100;
    const learnMoreClicked = (evt) => {
        evt.preventDefault();
        onLearnMore?.();
    };
    let clampLines;
    if (descriptionMaxLinesCount) {
        clampLines = descriptionMaxLinesCount;
    }
    else if (onLearnMore) {
        clampLines = 7;
    }
    else {
        clampLines = undefined;
    }
    return (jsxRuntime.exports.jsxs(StyledWrapperCard, { children: [isMyLearning && isCompleted && (jsxRuntime.exports.jsx(CardOverlay, { onFirstBtnClick: onFirstBtnClick, onSecondBtnClick: onSecondBtnClick, firstBtnText: firstBtnText, secondBtnText: secondBtnText, btnsWidth: btnsWidth })), jsxRuntime.exports.jsxs(StyledPathCard$1, { ...anchorProps, to: footerComponent ? '' : url, "$pathType": pathType, "$isHoverOn": isHoverOn && !isDisabled, "data-testid": "learning-path", "$hasFooterComponent": !!footerComponent, "$isComingSoon": showComingSoon, "$isDisabled": isDisabled, children: [jsxRuntime.exports.jsxs(StyledPathHeaderBodyWrapper, { children: [jsxRuntime.exports.jsxs(StyledCardHeader, { children: [jsxRuntime.exports.jsxs(StyledWrapperItems, { children: [showComingSoon && jsxRuntime.exports.jsx(StyledComingSoonTag, { children: "Coming soon" }), showCardType && jsxRuntime.exports.jsx(StyledFilterTag, { children: "Learning path" }), pathType === 'cloud' && (jsxRuntime.exports.jsxs(StyledPaidTagWrapper, { children: [jsxRuntime.exports.jsx(StyledTooltipWrapper, { children: jsxRuntime.exports.jsx(Tooltip, { arrowPosition: "bottom-center", children: "This training comes at an additional cost and requires a separate payment for access." }) }), jsxRuntime.exports.jsx(StyledPaidTag, { size: "small", children: "Paid add-on" })] })), showProgress && jsxRuntime.exports.jsx(CircularProgress, { progressValue: progressValue, isDarkVersion: true }), showCompleted && (jsxRuntime.exports.jsx(StyledCheckIcon$1, { "$cardType": exports.CardTypeEnum.PATH, icon: faCheckCircle$1, "data-testid": "completed-icon" })), isNew && jsxRuntime.exports.jsx(StyledNewTag, { children: newBadgeText })] }), noImgSpinner ? (jsxRuntime.exports.jsx(StyledCardImageNoSpinner, { src: image, alt: code })) : (jsxRuntime.exports.jsx(StyledCardImage$1, { src: image, alt: code }))] }), jsxRuntime.exports.jsx(StyledCardContentWrapper, { children: jsxRuntime.exports.jsxs(StyledCardContent, { "data-content": "position", isHoverOn: isHoverOn && !isDisabled, children: [jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx("h3", { children: title }), jsxRuntime.exports.jsx(ClampedDescription, { "$maxLinesCount": clampLines, children: description })] }), isHoverOn && !isDisabled && !showComingSoon && onLearnMore && (jsxRuntime.exports.jsx(StyledLearnMoreLink, { onClick: (e) => learnMoreClicked(e), children: "Learn more" }))] }) })] }), jsxRuntime.exports.jsxs(StyledCardFooter$1, { "$hasFooterComponent": !!footerComponent, children: [jsxRuntime.exports.jsxs(StyledDifficultyDurationGroup, { children: [duration && (jsxRuntime.exports.jsxs(StyledTime, { children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faClock$1 }), jsxRuntime.exports.jsx("p", { children: duration })] })), jsxRuntime.exports.jsx(Difficulty, { difficulty: difficulty, hasIcon: true, isSmall: true })] }), footerComponent ??
                                (hasCollaborator && (jsxRuntime.exports.jsx(Collaborator, { collaboratorName: collaboratorName, collaboratorImageLight: collaboratorImageLight, collaboratorImageDark: collaboratorImageDark })))] })] })] }));
};

const levelsAndPoints = {
    '0x1 [Neophyte]': '0',
    '0x2 [Apprentice]': '200',
    '0x3 [Pathfinder]': '500',
    '0x4 [Seeker]': '1,000',
    '0x5 [Visionary]': '1,500',
    '0x6 [Voyager]': '2,000',
    '0x7 [Adept]': '3,000',
    '0x8 [Hacker]': '4,000',
    '0x9 [Mage]': '8,000',
    '0xA [Wizard]': '12,000',
    '0xB [Master]': '15,000',
};
const levelsAndPointsWithTitle = {
    '0xC [Guru]': '17,000',
    '0xD [Legend]': '20,000',
    '0xE [Guardian]': '35,000',
    '0xF [TITAN]': '50,000',
    '0x10 [SAGE]': '65,000',
    '0x11 [VANGUARD]': '80,000',
    '0x12 [SHOGUN]': '95,000',
    '0x13 [ASCENDED]': '110,000',
    '0x14 [MYTHIC]': '130,000',
    '0x15 [ETERNAL]': '150,000',
};

const StyledTooltipContentContainer = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  max-width: ${({ isModal }) => (isModal ? '100%' : '100rem')};
  color: ${({ theme }) => theme.colors.text.main};
`;
const StyledTableWrapper$1 = styled__default["default"].div `
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 0.8rem;
  margin-top: 0.8rem;
  max-width: 100rem;

  @media screen and (max-width: 492px) {
    grid-template-columns: 1fr;
    gap: 0.2rem;
  }
`;
const StyledLeftColumnWrapper = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  border-right: 0.1rem solid ${({ theme }) => theme.colors.grey[300]};
  padding-right: 0.8rem;

  @media screen and (max-width: 490px) {
    border-right: none;
    padding-right: 0;
    border-bottom: 0.1rem solid ${({ theme }) => theme.colors.grey[300]};
  }
`;
const StyledRightColumnWrapper = styled__default["default"].div `
  @media screen and (max-width: 490px) {
    border-right: none;
  }
`;
const StyledGridItem = styled__default["default"].div `
  display: grid;
  grid-template-columns: ${({ withTitle }) => (withTitle ? '40% 60%' : '20% 80%')};
  color: ${({ theme }) => theme.colors.text.light};
  height: 2.7rem;
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.grey[300]};

  @media screen and (max-width: 490px) {
    grid-template-columns: auto 1fr;
  }

  &:last-child {
    border-bottom: none;
  }
`;
const StyledLevel = styled__default["default"].div `
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  color: ${({ theme }) => theme.colors.success.main};
  justify-content: flex-end;
  text-align: right;
  display: flex;
  align-items: center;

  @media screen and (max-width: 490px) {
    justify-content: flex-start;
  }
`;
const StyledPoints = styled__default["default"].p `
  align-items: center;
  color: ${({ theme }) => theme.colors.text.lighter};
  display: flex;
  font-size: ${({ theme }) => theme.fonts.sizes.small};
`;

const LevelsToolTipContent = ({ isModal }) => (jsxRuntime.exports.jsxs(StyledTooltipContentContainer, { "data-testid": "tooltip-content", isModal: isModal, children: ["Levels are obtained by playing rooms. You get a certain number of points for each question that you complete. ", jsxRuntime.exports.jsx("br", {}), ' ', jsxRuntime.exports.jsx("br", {}), "There are 21 obtainable levels:", jsxRuntime.exports.jsxs(StyledTableWrapper$1, { children: [jsxRuntime.exports.jsx(StyledLeftColumnWrapper, { children: Object.entries(levelsAndPoints).map(([level, points]) => (jsxRuntime.exports.jsxs(StyledGridItem, { withTitle: true, children: [jsxRuntime.exports.jsxs(StyledLevel, { children: [level, "\u00A0"] }), jsxRuntime.exports.jsxs(StyledPoints, { children: ["\u2265 ", points, " points"] })] }, level))) }), jsxRuntime.exports.jsx(StyledRightColumnWrapper, { children: Object.entries(levelsAndPointsWithTitle).map(([level, points]) => (jsxRuntime.exports.jsxs(StyledGridItem, { withTitle: true, children: [jsxRuntime.exports.jsxs(StyledLevel, { children: [level, "\u00A0"] }), jsxRuntime.exports.jsxs(StyledPoints, { children: ["\u2265 ", points, " points"] })] }, level))) })] })] }));

const StyledFontAwesomeIcon$1 = styled__default["default"](FontAwesomeIcon) `
  color: ${({ theme }) => theme.colors.primary.main};
  margin-right: 0.7rem;
  font-size: 1.7rem;
`;
const StyledBenefit = styled__default["default"].p `
  margin-top: 1.2rem;
  text-align: left;
  line-height: 2rem;
  &:first-child {
    margin-top: 0;
  }
`;

const Benefit = ({ text, icon = faCheck }) => (jsxRuntime.exports.jsxs(StyledBenefit, { children: [jsxRuntime.exports.jsx(StyledFontAwesomeIcon$1, { icon: icon }), " ", text] }));

const StyledManageAccountCardWrapper = styled__default["default"].div `
  background: ${({ theme }) => theme.colors.gradientDark};
  border-radius: ${({ theme }) => theme.radius.big};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  display: flex;
  flex-direction: column;
  position: relative;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  ${({ $size }) => {
    switch ($size) {
        case 'small': {
            return styled.css `
          width: 19.3rem;
          min-height: 23.5rem;
          padding-top: 1.6rem;
        `;
        }
        case 'medium': {
            return styled.css `
          min-width: 30.5rem;
          min-height: 39rem;
          padding-top: 2.5rem;
        `;
        }
        default: {
            return styled.css `
          width: 39.5rem;
          min-height: 25rem;
          padding-top: 3rem;
        `;
        }
    }
}}
`;
const StyledManageAccountCardImage = styled__default["default"](Image) `
  object-fit: cover;
  width: 100%;
  margin-top: auto;
  ${({ $size, theme }) => $size === 'large' &&
    styled.css `
      padding: 0 3rem 0 3rem;
      @media screen and (min-width: ${theme.sizes.sm}) {
        padding 0;
        position: absolute;
        right: 0;
        bottom: 0.3rem;
        width: 15.6rem;
      }
    `}
`;
const StyledManageAccountCardTitle = styled__default["default"].h2 `
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  line-height: 2.4rem;

  ${({ $size }) => {
    switch ($size) {
        case 'small': {
            return styled.css `
          font-size: 2rem;
          font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
          text-align: center;
          color: ${({ theme }) => theme.colors.primary.main};
          padding: 0 1rem;
          margin-bottom: 0.8rem;
        `;
        }
        case 'medium': {
            return styled.css `
          font-size: 2.5rem;
          text-align: center;
          color: ${({ theme }) => theme.colors.primary.main};
          padding: 0 1rem;
        `;
        }
        default: {
            return styled.css `
          font-size: 1.8rem;
          text-align: left;
          padding-left: 3rem;
          color: ${({ theme }) => theme.colors.grey[100]};
          margin-bottom: 1.4rem;
        `;
        }
    }
}}
`;
const StyledManageAccountCardDescription = styled__default["default"].span `
  color: ${({ theme }) => theme.colors.grey[100]};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 2.3rem;
  width: 100%;
  text-align: center;
  z-index: 1;
  ${({ $size }) => {
    switch ($size) {
        case 'small': {
            return styled.css `
          padding: 0 1rem 0.8rem;
          font-size: ${({ theme }) => theme.fonts.sizes.small};
        `;
        }
        case 'medium': {
            return styled.css `
          padding: 0 1rem 0.5rem;
          font-size: 1.8rem;
        `;
        }
        default: {
            return styled.css `
          padding: 0 3rem 3rem;
          font-size: ${({ theme }) => theme.fonts.sizes.default};
        `;
        }
    }
}}
`;

const ManageAccountCard = ({ size, image, title, description, content, ...nativeDivProps }) => (jsxRuntime.exports.jsxs(StyledManageAccountCardWrapper, { "$size": size, ...nativeDivProps, children: [title && jsxRuntime.exports.jsx(StyledManageAccountCardTitle, { "$size": size, children: title }), size === 'large' && content && (jsxRuntime.exports.jsx(StyledManageAccountCardDescription, { "$size": size, children: content })), size === 'medium' && description && (jsxRuntime.exports.jsx(StyledManageAccountCardDescription, { "$size": size, children: description })), size === 'small' && description && (jsxRuntime.exports.jsx(StyledManageAccountCardDescription, { "$size": size, children: description })), image && jsxRuntime.exports.jsx(StyledManageAccountCardImage, { "$size": size, ...image })] }));

const MitreCard = ({ isLoading = false, percentage = 0, tag, name, onClick, hasRoom }) => {
    const { theme } = React.useContext(SwitchThemeContext);
    const isDark = theme === 'dark';
    const isNotTagged = !hasRoom || tag === undefined || tag === null || tag === '';
    const { status, icon } = getMitreStatusDetails({ percentage, isNotTagged });
    const showProgressBar = status !== MitreStatusEnum.NOT_STARTED && status !== MitreStatusEnum.NOT_TAGGED && !isNotTagged && percentage > 0;
    if (isLoading)
        return jsxRuntime.exports.jsx(StyledMitreCardLoader, { "data-testid": "mitre-card-loader" });
    return (jsxRuntime.exports.jsxs(StyledMitreCard, { "$status": status, "$isDark": isDark, children: [showProgressBar && (jsxRuntime.exports.jsx(ProgressBar, { value: percentage, height: 5, progressColor: getMitreStatusItemColor(status, isDark), backgroundColor: isDark ? secondaryColors.secondary.lighter : secondaryColors.grey[300] })), jsxRuntime.exports.jsxs(StyledMitreContentContainer, { children: [jsxRuntime.exports.jsxs(StyledFlex, { alignItems: "flex-start", justifyContent: "flex-start", flexWrap: "no-wrap", gap: "0.6rem", children: [status === MitreStatusEnum.ALL_COMPLETED && (jsxRuntime.exports.jsx(StyledMitreStatusIcon, { "data-testid": "status-icon", "$status": status, "$isDark": isDark, icon: icon })), jsxRuntime.exports.jsx(StyledMitreName, { children: name }), tag && (jsxRuntime.exports.jsx(StyledMitreTag, { "$status": status, "$isDark": isDark, children: tag }))] }), jsxRuntime.exports.jsxs(StyledViewDetailsButton, { variant: "text", color: "info", onClick: onClick, "$isDark": isDark, children: ["View details", jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faChevronRight$1 })] })] })] }));
};

const StyledMitreRoomWrapper = styled__default["default"].div `
  border-radius: ${({ theme }) => theme.radius.small};
  background-color: ${({ theme }) => theme.colors.background.lighter};
  border: 0.1rem solid transparent;
  transition: border 0.3s ease-in-out;
  position: relative;
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  width: 100%;

  &:hover {
    box-shadow: ${({ theme }) => theme.colors.boxShadow.hover};
  }
`;
const StyledMitreRoom = styled__default["default"].div `
  display: flex;
  padding: 2.4rem;
  border-radius: ${({ theme }) => theme.radius.small};

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
  }
`;
const StyledImageContainer$2 = styled__default["default"].div `
  margin-right: 1.8rem;
  margin-top: 0.2rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: none;
  }
`;
const StyledMobileImageContainer = styled__default["default"](StyledImageContainer$2) `
  display: none;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: block;
    margin-right: 1rem;
  }
`;
const StyledTopRow = styled__default["default"].div `
  display: none;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 1rem;
  }
`;
const StyledRightColumn = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const StyledTitleRow = styled__default["default"].div `
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: none;
  }
`;
const StyledMobileTitleRow = styled__default["default"](StyledTitleRow) `
  display: none;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: flex;
    flex: 1;
    justify-content: flex-start;
  }
`;
const StyledRoomTitle = styled__default["default"].h2 `
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  margin: 0;
  margin-right: 1.2rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-right: 0;
  }
`;
const StyledDifficultyLabel = styled__default["default"].div `
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: none;
  }
`;
const StyledRoomDescription = styled__default["default"].div `
  color: ${({ theme }) => theme.colors.text.secondary};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  padding-right: 20rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    padding-right: 10rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    padding-right: 0;
    text-align: left;
  }
`;
const StyledTags$1 = styled__default["default"].div `
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  padding-top: 0.8rem;
  margin-top: 1rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: flex-start;
  }
`;
const StyledCheckbox = styled__default["default"](FormCheckbox) `
  position: absolute;
  top: 2.4rem;
  right: 2.4rem;
  width: 1.75rem;
  height: 1.75rem;
  cursor: pointer;
  z-index: 1;
  background-color: ${({ $isDark }) => ($isDark ? secondaryColors.secondary.light : 'rgb(255, 255, 255)')};
`;

const MitreRoom = ({ imageProps, title, description, difficulty = exports.RoomDifficulty.EASY, progress, isChecked = false, roomType, isFree = true, onCheck, ...restProps }) => {
    const { theme } = React.useContext(SwitchThemeContext);
    const isDark = theme === 'dark';
    const renderCircularImageProgress = () => (jsxRuntime.exports.jsx("div", { "data-testid": "circular-image-progress", "data-progress": progress || 0, children: jsxRuntime.exports.jsx(CircularImageProgress, { progressValue: progress ?? 0, image: imageProps?.src ?? '', size: 64, strokeWidth: 3, strokeProgressWidth: 7, difficulty: difficulty }) }));
    const renderTitleContent = () => (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(StyledRoomTitle, { "data-testid": "room-title", children: title }), jsxRuntime.exports.jsx(StyledDifficultyLabel, { "data-testid": "difficulty-label-desktop", children: jsxRuntime.exports.jsx(DifficultyLabel, { difficulty: difficulty }) })] }));
    const handleCheckboxChange = React__default["default"].useCallback(() => {
        if (onCheck) {
            onCheck();
        }
    }, [onCheck]);
    return (jsxRuntime.exports.jsxs(StyledMitreRoomWrapper, { ...restProps, children: [jsxRuntime.exports.jsx(StyledCheckbox, { "$isDark": isDark, "data-testid": "room-checkbox", checked: isChecked, onChange: handleCheckboxChange, onClick: handleCheckboxChange, "aria-label": "Mark room as completed" }), jsxRuntime.exports.jsxs(StyledMitreRoom, { children: [jsxRuntime.exports.jsx(StyledImageContainer$2, { children: renderCircularImageProgress() }), jsxRuntime.exports.jsxs(StyledTopRow, { children: [jsxRuntime.exports.jsx(StyledMobileImageContainer, { children: renderCircularImageProgress() }), jsxRuntime.exports.jsx(StyledMobileTitleRow, { "data-testid": "mobile-room-title", children: jsxRuntime.exports.jsx(StyledRoomTitle, { "data-testid": "room-title", children: title }) })] }), jsxRuntime.exports.jsxs(StyledRightColumn, { children: [jsxRuntime.exports.jsx(StyledTitleRow, { children: renderTitleContent() }), jsxRuntime.exports.jsx(StyledRoomDescription, { "data-testid": "room-description", children: description }), roomType && (jsxRuntime.exports.jsxs(StyledTags$1, { children: [jsxRuntime.exports.jsx(Tag, { size: "small", color: "grey", variation: 900, children: isFree ? 'Free' : 'Premium' }), jsxRuntime.exports.jsxs(Tag, { size: "small", color: "grey", variation: 900, children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { "data-testid": `font-awesome-icon-${roomType.toLowerCase().includes('challenge') ? 'flag' : 'route'}`, icon: roomType.toLowerCase().includes('challenge') ? faFlag$1 : faRoute }), ' ', roomType] })] }))] })] })] }));
};

function BellSvgDefs({ id, durS }) {
    return (jsxRuntime.exports.jsxs("defs", { children: [jsxRuntime.exports.jsxs("linearGradient", { id: `${id}-fill`, x1: "0%", y1: "0%", x2: "100%", y2: "0%", gradientUnits: "objectBoundingBox", gradientTransform: "rotate(137 .5 .5)", children: [jsxRuntime.exports.jsx("stop", { offset: "0%", stopColor: "#FFD36E", children: jsxRuntime.exports.jsx("animate", { attributeName: "stop-color", values: "#FFD36E;#A3EA2A;#A3EA2A", keyTimes: "0;0.55;1", dur: `${durS}s`, fill: "freeze" }) }), jsxRuntime.exports.jsx("stop", { offset: "100%", stopColor: "#E96A1D", children: jsxRuntime.exports.jsx("animate", { attributeName: "stop-color", values: "#E96A1D;#FBB026;#FBB026", keyTimes: "0;0.55;1", dur: `${durS}s`, fill: "freeze" }) })] }), jsxRuntime.exports.jsxs("radialGradient", { id: `${id}-stroke`, cx: "0.5", cy: "0.5", r: "0.8", fx: "0.5", fy: "0.5", children: [jsxRuntime.exports.jsx("stop", { offset: "0%", stopColor: "#FFFFFF", stopOpacity: "1" }), jsxRuntime.exports.jsx("stop", { offset: "30%", stopColor: "#FFFFFF", stopOpacity: "0" }), jsxRuntime.exports.jsx("stop", { offset: "100%", stopColor: "#FFFFFF", stopOpacity: "0" }), jsxRuntime.exports.jsx("animate", { attributeName: "fx", values: "0.5;0.75;0.35;0.75;0.75;0.5", keyTimes: "0;0.22;0.40;0.55;0.85;1", dur: `${durS}s`, fill: "freeze" }), jsxRuntime.exports.jsx("animate", { attributeName: "fy", values: "0.5;0.75;0.35;0.75;0.75;0.5", keyTimes: "0;0.22;0.40;0.55;0.85;1", dur: `${durS}s`, fill: "freeze" })] }), jsxRuntime.exports.jsxs("filter", { id: `${id}-glow`, x: "-50%", y: "-50%", width: "200%", height: "200%", children: [jsxRuntime.exports.jsx("feGaussianBlur", { in: "SourceGraphic", stdDeviation: "0.6", result: "b" }), jsxRuntime.exports.jsxs("feMerge", { children: [jsxRuntime.exports.jsx("feMergeNode", { in: "b" }), jsxRuntime.exports.jsx("feMergeNode", { in: "SourceGraphic" })] })] })] }));
}

var ExplodingHandsSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22147%22%20height%3D%22185%22%20viewBox%3D%220%200%20147%20185%22%20fill%3D%22none%22%3E%20%20%3Cpath%20d%3D%22M136.655%20152.564L134.801%20156.029C134.541%20156.516%20133.905%20156.664%20133.472%20156.432C132.985%20156.171%20132.808%20155.59%20133.069%20155.102L134.922%20151.638C135.154%20151.205%20135.765%20150.974%20136.252%20151.235C136.685%20151.467%20136.886%20152.131%20136.655%20152.564ZM131.064%20150.13L131.406%20153.656C131.474%20154.18%20131.076%20154.663%20130.498%20154.702C129.975%20154.77%20129.491%20154.372%20129.452%20153.794L129.11%20150.269C129.042%20149.745%20129.44%20149.262%20130.018%20149.223C130.541%20149.155%20131.025%20149.553%20131.064%20150.13ZM122.791%20152.32C123.539%20152.093%20124.351%20152.527%20124.577%20153.275L127.699%20163.579C127.951%20164.41%20129.128%20164.553%20129.533%20163.795L130.692%20161.629C131.184%20160.709%20132.376%20160.302%20133.351%20160.824C134.271%20161.316%20134.649%20162.562%20134.156%20163.483L129.697%20171.82C128.046%20174.905%20124.887%20176.906%20121.395%20177.057C116.801%20177.315%20112.651%20174.399%20111.317%20169.994L108.854%20161.714C108.573%20160.937%20109.007%20160.125%20109.809%20159.927C110.586%20159.646%20111.398%20160.081%20111.596%20160.883L112.93%20165.287C113.135%20165.815%20113.622%20166.075%20114.175%20165.953C114.703%20165.748%20114.963%20165.261%20114.841%20164.708L112.5%20156.98C112.219%20156.203%20112.654%20155.391%20113.455%20155.193C114.232%20154.913%20115.044%20155.347%20115.242%20156.149L117.583%20163.877C117.788%20164.405%20118.276%20164.665%20118.828%20164.543C119.356%20164.338%20119.616%20163.851%20119.494%20163.298L116.549%20153.576C116.268%20152.799%20116.703%20151.987%20117.505%20151.789C118.281%20151.508%20119.093%20151.943%20119.291%20152.745L122.236%20162.467C122.442%20162.995%20122.929%20163.255%20123.482%20163.133C124.009%20162.928%20124.27%20162.441%20124.148%20161.888L121.806%20154.16C121.526%20153.383%20121.96%20152.571%20122.762%20152.374L122.791%20152.32ZM128.324%20180.764C126.536%20180.852%20124.926%20180.478%20123.435%20179.75C127.163%20179.029%20130.471%20176.62%20132.295%20173.21L135.133%20167.904C135.566%20168.136%20136.173%20168.043%20136.463%20167.502L137.592%20165.39C138.113%20164.416%20139.277%20164.063%20140.251%20164.585C141.171%20165.077%20141.578%20166.269%20141.057%20167.244L136.626%20175.527C134.975%20178.612%20131.816%20180.613%20128.295%20180.818L128.324%20180.764ZM141.332%20155.275C141.62%20155.778%20141.439%20156.377%20140.965%20156.611L137.843%20158.283C137.341%20158.571%20136.741%20158.39%20136.507%20157.917C136.219%20157.414%20136.4%20156.815%20136.874%20156.581L139.996%20154.909C140.498%20154.621%20141.098%20154.802%20141.332%20155.275Z%22%20fill%3D%22%23A3EA2A%22%2F%3E%20%20%3Cpath%20d%3D%22M99.3088%2096.2558V100.185C99.3088%20100.738%2098.8177%20101.167%2098.3265%20101.167C97.774%20101.167%2097.3443%20100.738%2097.3443%20100.185V96.2558C97.3443%2095.7646%2097.774%2095.2734%2098.3265%2095.2734C98.8177%2095.2734%2099.3088%2095.7646%2099.3088%2096.2558ZM93.2309%2096.7469L95.1955%2099.694C95.5024%20100.124%2095.3797%20100.738%2094.8885%20101.045C94.4588%20101.352%2093.8448%20101.229%2093.5378%20100.738L91.5733%2097.7907C91.2663%2097.3609%2091.3891%2096.7469%2091.8802%2096.44C92.31%2096.133%2092.9239%2096.2558%2093.2309%2096.7469ZM86.9687%20102.58C87.5213%20102.027%2088.4422%20102.027%2088.9947%20102.58L96.6075%20110.193C97.2215%20110.807%2098.3265%20110.377%2098.3265%20109.517V107.061C98.3265%20106.018%2099.1861%20105.097%20100.291%20105.097C101.335%20105.097%20102.256%20106.018%20102.256%20107.061V116.516C102.256%20120.016%20100.414%20123.27%2097.4056%20125.051C93.4765%20127.445%2088.4422%20126.831%2085.1883%20123.577L79.1104%20117.437C78.4964%20116.885%2078.4964%20115.964%2079.1104%20115.411C79.6629%20114.797%2080.5838%20114.797%2081.1363%20115.411L84.3902%20118.665C84.82%20119.034%2085.3725%20119.034%2085.8023%20118.665C86.1706%20118.236%2086.1706%20117.683%2085.8023%20117.253L80.0927%20111.543C79.4787%20110.991%2079.4787%20110.07%2080.0927%20109.517C80.6452%20108.903%2081.5661%20108.903%2082.1186%20109.517L87.8282%20115.227C88.258%20115.596%2088.8105%20115.596%2089.2403%20115.227C89.6087%20114.797%2089.6087%20114.245%2089.2403%20113.815L82.0572%20106.632C81.4433%20106.079%2081.4433%20105.158%2082.0572%20104.606C82.6098%20103.992%2083.5307%20103.992%2084.0832%20104.606L91.2663%20111.789C91.696%20112.157%2092.2486%20112.157%2092.6783%20111.789C93.0467%20111.359%2093.0467%20110.807%2092.6783%20110.377L86.9687%20104.667C86.3548%20104.114%2086.3548%20103.194%2086.9687%20102.641V102.58ZM105.264%20125.051C103.729%20125.971%20102.133%20126.401%20100.475%20126.463C103.422%20124.068%20105.203%20120.384%20105.203%20116.516V110.5C105.694%20110.5%20106.185%20110.131%20106.185%20109.517V107.123C106.185%20106.018%20107.044%20105.158%20108.15%20105.158C109.193%20105.158%20110.114%20106.018%20110.114%20107.123V116.516C110.114%20120.016%20108.272%20123.27%20105.264%20125.112V125.051ZM104.711%2096.44C105.203%2096.7469%20105.325%2097.3609%20105.018%2097.7907L103.054%20100.738C102.747%20101.229%20102.133%20101.352%20101.703%20101.045C101.212%20100.738%20101.089%20100.124%20101.396%2099.694L103.361%2096.7469C103.668%2096.2558%20104.282%2096.133%20104.711%2096.44Z%22%20fill%3D%22%23A3EA2A%22%2F%3E%20%20%3Cpath%20d%3D%22M44.2971%20135.56V139.49C44.2971%20140.042%2043.806%20140.472%2043.3148%20140.472C42.7623%20140.472%2042.3325%20140.042%2042.3325%20139.49V135.56C42.3325%20135.069%2042.7623%20134.578%2043.3148%20134.578C43.806%20134.578%2044.2971%20135.069%2044.2971%20135.56ZM38.2192%20136.052L40.1838%20138.999C40.4907%20139.428%2040.3679%20140.042%2039.8768%20140.349C39.447%20140.656%2038.8331%20140.534%2038.5261%20140.042L36.5615%20137.095C36.2546%20136.666%2036.3774%20136.052%2036.8685%20135.745C37.2983%20135.438%2037.9122%20135.56%2038.2192%20136.052ZM31.957%20141.884C32.5096%20141.332%2033.4305%20141.332%2033.983%20141.884L41.5958%20149.497C42.2097%20150.111%2043.3148%20149.682%2043.3148%20148.822V146.366C43.3148%20145.322%2044.1743%20144.402%2045.2794%20144.402C46.3231%20144.402%2047.244%20145.322%2047.244%20146.366V155.821C47.244%20159.321%2045.4022%20162.575%2042.3939%20164.355C38.4647%20166.75%2033.4305%20166.136%2030.1766%20162.882L24.0986%20156.742C23.4847%20156.19%2023.4847%20155.269%2024.0986%20154.716C24.6512%20154.102%2025.5721%20154.102%2026.1246%20154.716L29.3785%20157.97C29.8082%20158.338%2030.3608%20158.338%2030.7905%20157.97C31.1589%20157.54%2031.1589%20156.988%2030.7905%20156.558L25.0809%20150.848C24.467%20150.296%2024.467%20149.375%2025.0809%20148.822C25.6335%20148.208%2026.5544%20148.208%2027.1069%20148.822L32.8165%20154.532C33.2463%20154.9%2033.7988%20154.9%2034.2286%20154.532C34.5969%20154.102%2034.5969%20153.55%2034.2286%20153.12L27.0455%20145.936C26.4316%20145.384%2026.4316%20144.463%2027.0455%20143.91C27.5981%20143.296%2028.519%20143.296%2029.0715%20143.91L36.2546%20151.094C36.6843%20151.462%2037.2369%20151.462%2037.6666%20151.094C38.035%20150.664%2038.035%20150.111%2037.6666%20149.682L31.957%20143.972C31.3431%20143.419%2031.3431%20142.498%2031.957%20141.946V141.884ZM50.2523%20164.355C48.7175%20165.276%2047.1212%20165.706%2045.4636%20165.767C48.4105%20163.373%2050.1909%20159.689%2050.1909%20155.821V149.804C50.6821%20149.804%2051.1732%20149.436%2051.1732%20148.822V146.428C51.1732%20145.322%2052.0327%20144.463%2053.1378%20144.463C54.1815%20144.463%2055.1024%20145.322%2055.1024%20146.428V155.821C55.1024%20159.321%2053.2606%20162.575%2050.2523%20164.417V164.355ZM49.6998%20135.745C50.1909%20136.052%2050.3137%20136.666%2050.0067%20137.095L48.0421%20140.042C47.7352%20140.534%2047.1212%20140.656%2046.6915%20140.349C46.2003%20140.042%2046.0775%20139.428%2046.3845%20138.999L48.3491%20136.052C48.6561%20135.56%2049.27%20135.438%2049.6998%20135.745Z%22%20fill%3D%22%23A3EA2A%22%2F%3E%20%20%3Cpath%20d%3D%22M117.722%200.736753V3.68377C117.722%204.09819%20117.354%204.42052%20116.986%204.42052C116.571%204.42052%20116.249%204.09819%20116.249%203.68377V0.736753C116.249%200.368377%20116.571%200%20116.986%200C117.354%200%20117.722%200.368377%20117.722%200.736753ZM113.164%201.10513L114.637%203.31539C114.867%203.63772%20114.775%204.09819%20114.407%204.32843C114.085%204.55866%20113.624%204.46657%20113.394%204.09819L111.921%201.88793C111.69%201.5656%20111.782%201.10513%20112.151%200.874895C112.473%200.644659%20112.934%200.736753%20113.164%201.10513ZM108.467%205.4796C108.882%205.06518%20109.572%205.06518%20109.987%205.4796L115.696%2011.1894C116.157%2011.6499%20116.986%2011.3276%20116.986%2010.6829V8.84104C116.986%208.05824%20117.63%207.36753%20118.459%207.36753C119.242%207.36753%20119.932%208.05824%20119.932%208.84104V15.9323C119.932%2018.557%20118.551%2020.9975%20116.295%2022.3328C113.348%2024.1287%20109.572%2023.6682%20107.132%2021.2277L102.573%2016.623C102.113%2016.2086%20102.113%2015.5179%20102.573%2015.1034C102.988%2014.643%20103.678%2014.643%20104.093%2015.1034L106.533%2017.5439C106.856%2017.8202%20107.27%2017.8202%20107.592%2017.5439C107.869%2017.2216%20107.869%2016.8072%20107.592%2016.4849L103.31%2012.2025C102.85%2011.7881%20102.85%2011.0973%20103.31%2010.6829C103.724%2010.2225%20104.415%2010.2225%20104.83%2010.6829L109.112%2014.9653C109.434%2015.2416%20109.849%2015.2416%20110.171%2014.9653C110.447%2014.643%20110.447%2014.2286%20110.171%2013.9062L104.784%208.51871C104.323%208.10429%20104.323%207.41358%20104.784%206.99916C105.198%206.53869%20105.889%206.53869%20106.303%206.99916L111.69%2012.3867C112.013%2012.663%20112.427%2012.663%20112.749%2012.3867C113.026%2012.0643%20113.026%2011.6499%20112.749%2011.3276L108.467%207.04521C108.007%206.63078%20108.007%205.94007%20108.467%205.52565V5.4796ZM122.189%2022.3328C121.037%2023.0235%20119.84%2023.3459%20118.597%2023.3919C120.807%2021.5961%20122.143%2018.8333%20122.143%2015.9323V11.4197C122.511%2011.4197%20122.879%2011.1434%20122.879%2010.6829V8.88709C122.879%208.05824%20123.524%207.41358%20124.353%207.41358C125.136%207.41358%20125.826%208.05824%20125.826%208.88709V15.9323C125.826%2018.557%20124.445%2020.9975%20122.189%2022.3789V22.3328ZM121.774%200.874895C122.143%201.10513%20122.235%201.5656%20122.004%201.88793L120.531%204.09819C120.301%204.46657%20119.84%204.55866%20119.518%204.32843C119.15%204.09819%20119.058%203.63772%20119.288%203.31539L120.761%201.10513C120.991%200.736753%20121.452%200.644659%20121.774%200.874895Z%22%20fill%3D%22%23A3EA2A%22%2F%3E%20%20%3Cpath%20d%3D%22M27.4303%2082.3779L24.9095%2083.9045C24.555%2084.1191%2024.0885%2083.971%2023.8977%2083.6559C23.6831%2083.3014%2023.7918%2082.8587%2024.1463%2082.644L26.667%2081.1175C26.9821%2080.9267%2027.4642%2081.0116%2027.6788%2081.3661C27.8696%2081.6812%2027.7453%2082.1871%2027.4303%2082.3779ZM24.7539%2078.6693L23.6266%2081.0746C23.4702%2081.4385%2023.0286%2081.5983%2022.6408%2081.4024C22.277%2081.246%2022.1172%2080.8044%2022.3131%2080.4166L23.4404%2078.0113C23.5968%2077.6474%2024.0384%2077.4877%2024.4262%2077.6835C24.79%2077.84%2024.9498%2078.2816%2024.7539%2078.6693ZM18.5794%2076.9176C19.1486%2077.0575%2019.5063%2077.6483%2019.3665%2078.2175L17.4401%2086.0592C17.2847%2086.6916%2017.9897%2087.2336%2018.5411%2086.8997L20.1166%2085.9456C20.7862%2085.5402%2021.7109%2085.7338%2022.1402%2086.4428C22.5457%2087.1124%2022.3126%2088.061%2021.643%2088.4665L15.5775%2092.1396C13.3325%2093.4992%2010.5295%2093.5817%208.21857%2092.3434C5.15605%2090.7527%203.59415%2087.2844%204.41755%2083.9327L5.99499%2077.6481C6.11096%2077.0395%206.70176%2076.6817%207.29475%2076.861C7.90327%2076.9769%208.26103%2077.5678%208.08182%2078.1608L7.25842%2081.5125C7.18906%2081.9313%207.40371%2082.2858%207.80699%2082.4184C8.2258%2082.4878%208.58028%2082.2731%208.71288%2081.8698L10.1577%2075.9885C10.2737%2075.38%2010.8645%2075.0222%2011.4575%2075.2014C12.066%2075.3174%2012.4238%2075.9082%2012.2445%2076.5012L10.7997%2082.3825C10.7303%2082.8014%2010.945%2083.1559%2011.3483%2083.2885C11.7671%2083.3578%2012.1216%2083.1432%2012.2542%2082.7399L14.0719%2075.3408C14.1878%2074.7323%2014.7786%2074.3745%2015.3716%2074.5537C15.9801%2074.6697%2016.3379%2075.2605%2016.1587%2075.8535L14.341%2083.2526C14.2716%2083.6714%2014.4863%2084.0259%2014.8896%2084.1585C15.3084%2084.2279%2015.6629%2084.0132%2015.7955%2083.6099L17.2403%2077.7286C17.3563%2077.1201%2017.9471%2076.7623%2018.5401%2076.9415L18.5794%2076.9176ZM11.2715%2097.3851C10.0844%2096.7581%209.18857%2095.901%208.50522%2094.8614C11.1861%2095.8218%2014.241%2095.5329%2016.7223%2094.0303L20.5822%2091.6928C20.773%2092.0079%2021.2002%2092.1799%2021.594%2091.9414L23.1301%2091.0112C23.8391%2090.5818%2024.7244%2090.7994%2025.1537%2091.5083C25.5592%2092.1779%2025.3655%2093.1027%2024.6566%2093.532L18.6304%2097.1813C16.3854%2098.5409%2013.5824%2098.6234%2011.2321%2097.4089L11.2715%2097.3851ZM29.411%2085.9157C29.4048%2086.35%2029.0587%2086.6673%2028.6637%2086.6373L26.0099%2086.5218C25.5756%2086.5157%2025.2583%2086.1695%2025.2883%2085.7745C25.2944%2085.3402%2025.6406%2085.0229%2026.0355%2085.0528L28.6893%2085.1684C29.1237%2085.1745%2029.4409%2085.5207%2029.411%2085.9157Z%22%20fill%3D%22%23A3EA2A%22%2F%3E%20%20%3Cpath%20d%3D%22M80.0857%2064.9302L78.4867%2068.5194C78.2618%2069.0242%2077.6383%2069.2168%2077.1896%2069.017C76.6849%2068.7921%2076.4673%2068.2246%2076.6921%2067.7199L78.2912%2064.1306C78.4911%2063.682%2079.0835%2063.4082%2079.5882%2063.6331C80.0369%2063.833%2080.2856%2064.4815%2080.0857%2064.9302ZM74.334%2062.9052L74.9292%2066.3967C75.0347%2066.9142%2074.6727%2067.425%2074.0992%2067.5056C73.5817%2067.6111%2073.0709%2067.249%2072.9903%2066.6754L72.3951%2063.184C72.2896%2062.6665%2072.6516%2062.1556%2073.2252%2062.0751C73.7426%2061.9696%2074.2535%2062.3316%2074.334%2062.9052ZM66.2403%2065.6844C66.9699%2065.4045%2067.8111%2065.7793%2068.0909%2066.5089L71.9466%2076.5614C72.2575%2077.372%2073.4419%2077.4292%2073.7917%2076.6441L74.7911%2074.4008C75.2158%2073.4474%2076.3757%2072.956%2077.3851%2073.4057C78.3385%2073.8305%2078.8049%2075.0465%2078.3802%2075.9999L74.5324%2084.6365C73.1083%2087.8332%2070.1017%2090.0559%2066.6292%2090.458C62.0657%2091.0461%2057.717%2088.4364%2056.069%2084.1398L53.0157%2076.0579C52.6797%2075.3033%2053.0545%2074.4621%2053.8402%2074.2072C54.5948%2073.8713%2055.4359%2074.2461%2055.6908%2075.0318L57.3388%2079.3284C57.5815%2079.8398%2058.0862%2080.0647%2058.6286%2079.9031C59.14%2079.6604%2059.3649%2079.1557%2059.2033%2078.6132L56.3115%2071.0739C55.9756%2070.3193%2056.3504%2069.478%2057.136%2069.2232C57.8906%2068.8872%2058.7318%2069.262%2058.9867%2070.0477L61.8784%2077.587C62.1211%2078.0984%2062.6258%2078.3233%2063.1683%2078.1617C63.6796%2077.9191%2063.9045%2077.4143%2063.7429%2076.8718L60.1049%2067.3869C59.769%2066.6323%2060.1437%2065.791%2060.9294%2065.5362C61.684%2065.2002%2062.5252%2065.575%2062.78%2066.3607L66.4181%2075.8457C66.6607%2076.3571%2067.1654%2076.582%2067.7079%2076.4204C68.2193%2076.1777%2068.4441%2075.673%2068.2825%2075.1305L65.3908%2067.5912C65.0549%2066.8366%2065.4296%2065.9953%2066.2153%2065.7405L66.2403%2065.6844ZM73.8074%2093.6562C72.0306%2093.8728%2070.3976%2093.6157%2068.8585%2092.9972C72.5248%2092.0093%2075.6502%2089.369%2077.2242%2085.8359L79.6728%2080.3398C80.1214%2080.5397%2080.72%2080.4031%2080.9698%2079.8423L81.9443%2077.6551C82.394%2076.6457%2083.5289%2076.2103%2084.5383%2076.6601C85.4917%2077.0848%2085.9831%2078.2448%2085.5333%2079.2542L81.7106%2087.8348C80.2864%2091.0314%2077.2798%2093.2542%2073.7824%2093.7123L73.8074%2093.6562ZM84.9458%2067.2972C85.2695%2067.7775%2085.1318%2068.3883%2084.6765%2068.656L81.6827%2070.5483C81.2024%2070.872%2080.5916%2070.7343%2080.324%2070.279C80.0003%2069.7987%2080.138%2069.1879%2080.5933%2068.9203L83.5871%2067.0279C84.0674%2066.7042%2084.6782%2066.8419%2084.9458%2067.2972Z%22%20fill%3D%22%23A3EA2A%22%2F%3E%3C%2Fsvg%3E";

const StyledIconWrapper$1 = styled__default["default"].div `
  position: relative;
  width: 2.2rem;
  height: 2.2rem;
`;
const BELL_ANIM_MS = 3000;
const OUTLINE_ANIM_MS = BELL_ANIM_MS;
const HANDS_ANIM_MS = 3500;
const BELL_EASE = 'ease-in-out';
const HANDS_EASE = 'ease-out';
const StyledNotificationIcon = styled__default["default"](FontAwesomeIcon) `
  && {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    transform-origin: top center;

    display: block;
    color: ${({ theme }) => theme.colors.alpha[50]};
  }
`;
const StyledGradientBellSvg = styled__default["default"].svg `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;

  display: block;
  z-index: 2;
  pointer-events: none;
  will-change: transform, opacity;
  transform-origin: top center;
  animation: thm-glyph-sequence ${BELL_ANIM_MS}ms ${BELL_EASE} 1 forwards;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
const StyledExplodingHands = styled__default["default"].img.attrs({ src: ExplodingHandsSvg }) `
  position: absolute;
  top: -10%;
  left: 24%;
  width: 10rem;
  height: auto;
  
  transform: translate(-50%, -100%) scale(0.3);
  transform-origin: bottom center;
  pointer-events: none;
  z-index: 1;
  opacity: 0;
  
  animation: thm-hands-explode ${HANDS_ANIM_MS}ms ${HANDS_EASE} 1 forwards;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    display: none;
  }
`;
const StyledUnreadNotificationsCount = styled__default["default"].span `
  align-items: center;
  background-color: ${darkColors.error.main};
  border-radius: 10rem;
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  font-size: 1.1rem;
  height: 1.6rem;
  justify-content: center;
  line-height: 1.1rem;
  position: absolute;
  right: 0.1rem;
  top: -0.2rem;
  width: 1.6rem;
  z-index: 3;
`;
const StyledNotificationsTrigger = styled__default["default"].button `
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  &:hover,
  &:focus {
    outline: none;
    ${StyledNotificationIcon} {
      color: ${({ theme }) => theme.colors.alpha[75]};
    }
  }
  &[data-state='open'] {
    ${StyledNotificationIcon} {
      color: ${({ theme }) => theme.colors.white};
    }
  }
  padding-right: ${({ isNotifications }) => (isNotifications ? '0.8rem' : '0')};

  &[data-animate='true'] ${StyledNotificationIcon} {
    opacity: 1;
    animation: thm-outline-crossfade ${OUTLINE_ANIM_MS}ms ${BELL_EASE} 1 forwards;
  }

  @media (prefers-reduced-motion: reduce) {
    &[data-animate='true'] ${StyledNotificationIcon} {
      animation: none;
    }
  }

  @keyframes thm-outline-crossfade {
    0% { opacity: 1; }
    12% { opacity: 0.6; }
    22% { opacity: 0; }
    85% { opacity: 0; }
    100% { opacity: 1; }
  }

  @keyframes thm-glyph-sequence {
    0% { transform: rotate(0deg) scale(1); opacity: 0; }
    12% { transform: rotate(0deg) scale(1.08); opacity: 0.5; }
    22% { transform: rotate(19.291deg) scale(1.12); opacity: 1; }
    40% { transform: rotate(-14.389deg) scale(1.12); opacity: 1; }
    55% { transform: rotate(19.291deg) scale(1.12); opacity: 1; }
    85% { transform: rotate(19.291deg) scale(1.12); opacity: 1; }
    100% { transform: rotate(0deg) scale(1); opacity: 0; }
  }

  @keyframes thm-hands-explode {
    0% {
      opacity: 0;
      transform: translate(-50%, -100%) scale(0.3);
    }
    55% {
      opacity: 0;
      transform: translate(-50%, -100%) scale(0.05);
    }
    60% {
      opacity: 1;
      transform: translate(-50%, -92%) scale(0.05);
    }
    85% {
      opacity: 0;
      transform: translate(-50%, -108%) scale(0.85);
    }
    100% {
      opacity: 0;
    }
  }
`;
const StyledNotificationItemContent = styled__default["default"].div `
  background-color: ${({ theme, isRead, $isDarkMode }) => isRead
    ? theme.colors.background.main
    : $isDarkMode
        ? theme.colors.background.lighter
        : theme.colors.background.dark};
  border-bottom: ${({ theme, isLast, $isDarkMode }) => (isLast ? '' : `0.1rem solid ${$isDarkMode ? 'rgba(62, 71, 90, 0.3)' : theme.colors.background.tableRowHover}`)}; 
  text-align: left;
  padding: 1.6rem 1.6rem 1.6rem 3.8rem;
  ${({ isNoNotifications }) => isNoNotifications &&
    `
    padding-bottom: 1.6rem;
  `}
  position: relative;
  outline: none;

  &::before {
    background-color: ${({ theme, isRead, $isDarkMode }) => (isRead ? ($isDarkMode ? theme.colors.background.lighter : theme.colors.background.darker) : 'rgba(59, 200, 30, 1)')};
    border-radius: 10rem;
    content: '';
    display: inline-block;
    height: 0.8rem;
    left: 2rem;
    position: absolute;
    top: 25px;
    width: 0.8rem;
  }

  small {
    display: block;
    color: ${secondaryColors.grey[500]};
    font-size: ${({ theme }) => theme.fonts.sizes.tiny};
    line-height: 1.5rem;
  }
`;
const StyledNotificationHeader = styled__default["default"].div `
  color: ${({ theme }) => theme.colors.text.main};
  background-color: ${({ theme }) => theme.colors.background.main};
  height: 5.6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.6rem;
`;
const StyledNotificationHeaderTitle = styled__default["default"].p `
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  line-height: 1.8rem;
  margin-bottom: 0;
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`;
const StyledNotificationItemsWrapper = styled__default["default"].div `
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 37rem;
`;
const StyledNotificationsContentLayer = styled__default["default"].div `
  position: relative;
`;
const StyledNotificationsPortalLayer = styled__default["default"].div `
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 3;
`;
const StyledClearNotificationsMenuItem = styled__default["default"]($d08ef79370b62062$export$ed97964d1871885d) `
  cursor: pointer;
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  color: ${({ theme }) => theme.colors.text.light};
  padding: 0.3rem;
  outline: none;
`;
styled__default["default"].div `
  margin-bottom: 0.6rem;
  span {
    display: inline;
    color: ${({ theme }) => theme.colors.text.main};
    font-size: ${({ theme }) => theme.fonts.sizes.small};
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    line-height: 1.8rem;
  }
  svg {
    display: inline-block;
    margin-left: 1rem;
    vertical-align: text-bottom;
    height: 1.6rem;
  }
`;
styled__default["default"](FontAwesomeIcon) `
  color: ${({ theme }) => theme.colors.info.main};
`;

function BellOverlay({ gradientId, durationS, onEnd }) {
    return (jsxRuntime.exports.jsxs(StyledGradientBellSvg, { "data-bell-gradient": "true", viewBox: "0 0 512 512", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": true, onAnimationEnd: onEnd, children: [jsxRuntime.exports.jsx(BellSvgDefs, { id: gradientId, durS: durationS }), jsxRuntime.exports.jsx("path", { d: "M256 512a64 64 0 0 0 64-64h-128a64 64 0 0 0 64 64zm215.38-149.44c-20.25-20.54-55.35-52.18-55.35-154.56 0-77.7-54.5-139.68-127.99-155.16v-20.84c0-17.67-14.33-32-31.99-32s-31.99 14.33-31.99 32v20.84c-73.49 15.48-127.99 77.46-127.99 155.16 0 102.38-35.1 134.02-55.35 154.56a31.94 31.94 0 0 0-8.65 22.05c.13 17.58 14.42 31.95 32 31.95h383.98c17.58 0 31.87-14.37 32-31.95a31.94 31.94 0 0 0-8.65-22.05z", fill: `url(#${gradientId}-fill)`, stroke: `url(#${gradientId}-stroke)`, strokeWidth: "28", strokeLinejoin: "round", strokeLinecap: "round" }), jsxRuntime.exports.jsxs("path", { d: "M256 512a64 64 0 0 0 64-64h-128a64 64 0 0 0 64 64zm215.38-149.44c-20.25-20.54-55.35-52.18-55.35-154.56 0-77.7-54.5-139.68-127.99-155.16v-20.84c0-17.67-14.33-32-31.99-32s-31.99 14.33-31.99 32v20.84c-73.49 15.48-127.99 77.46-127.99 155.16 0 102.38-35.1 134.02-55.35 154.56a31.94 31.94 0 0 0-8.65 22.05c.13 17.58 14.42 31.95 32 31.95h383.98c17.58 0 31.87-14.37 32-31.95a31.94 31.94 0 0 0-8.65-22.05z", fill: "none", stroke: "#FFFFFF", strokeWidth: "6", strokeLinecap: "round", pathLength: 100, strokeDasharray: "4 96", filter: `url(#${gradientId}-glow)`, children: [jsxRuntime.exports.jsx("animate", { attributeName: "stroke-dashoffset", values: "40;60;10;60;60;40", keyTimes: "0;0.22;0.40;0.55;0.85;1", dur: `${durationS}s`, fill: "freeze" }), jsxRuntime.exports.jsx("animate", { attributeName: "opacity", values: "1;1;0", keyTimes: "0;0.85;1", dur: `${durationS}s`, fill: "freeze" })] })] }));
}

const StyledActivityHeader = styled__default["default"].div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;
const StyledActivityDescription = styled__default["default"].div `
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  line-height: 1.8rem;
  color: ${({ theme }) => theme.colors.text.main};
`;
const StyledUsernameLink = styled__default["default"](reactRouterDom.Link) `
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  color: ${({ theme }) => theme.colors.text.main};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  &:focus-visible {
    text-decoration: underline;
 }
`;
const StyledActivityTimestamp = styled__default["default"].small `
  color: ${({ theme }) => theme.colors.grey[500]};
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  white-space: nowrap;
  line-height: 1.5rem;
`;
styled__default["default"].p `
  color: ${({ theme }) => theme.colors.text.main};
  strong {
    margin-right: 0.4rem;
  }
`;
const StyledLikeButton = styled__default["default"].button `
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.6rem 1.2rem;
  background: transparent;
  width: ${({ $hasCount }) => ($hasCount ? '5.5rem' : '4rem')};
  height: 3rem;
  cursor: pointer;
  border-radius: ${({ theme }) => theme.radius.huge};
  transition: all 0.2s ease;
  color: ${({ theme, $isLiked }) => ($isLiked ? theme.colors.notifications.likedColor : theme.colors.notifications.unlikedColor)};
  background-color: ${({ theme, $isLiked }) => ($isLiked ? theme.colors.notifications.likedBackground : theme.colors.notifications.unlikedBackground)};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  border: 0.1rem solid ${({ theme, $isLiked }) => ($isLiked ? theme.colors.notifications.likedBackground : theme.colors.notifications.unlikedBackground)};
  p {
    font-size: ${({ theme }) => theme.fonts.sizes.small};
    line-height: normal;
  }
  &:disabled {
    opacity: 0.5;
  }
  &:hover {
    color: ${({ theme, $isLiked }) => ($isLiked ? theme.colors.notifications.hoverColorLiked : theme.colors.notifications.hoverColor)};
    border: 0.1rem solid ${({ theme, $isLiked }) => ($isLiked ? theme.colors.notifications.hoverBorderLiked : theme.colors.notifications.hoverBorder)};
  }
`;
const confettiFly = styled.keyframes `
  0% { transform: translate(0, 0) rotate(0deg) scale(0.9); opacity: 0; }
  15% { opacity: 1; }
  100% { transform: var(--confetti-transform) rotate(var(--confetti-rot)) scale(1); opacity: 0; }
`;
const ConfettiOverlay = styled__default["default"].div `
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: visible;
  z-index: 5;
`;
const LikeButtonWrapper = styled__default["default"].div `
  position: relative;
  display: inline-block;
  z-index: 4;
`;
const ConfettiPiece = styled__default["default"].span `
  position: absolute;
  top: 50%;
  left: 50%;
  width: var(--confetti-w);
  height: var(--confetti-h);
  background: var(--confetti-color);
  border-radius: var(--confetti-radius);
  transform-origin: center;
  animation: ${confettiFly} var(--confetti-duration, 900ms) cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
`;
const PortalAnchor = styled__default["default"].div `
  position: ${({ $fixed }) => ($fixed ? 'fixed' : 'absolute')};
  left: ${({ left }) => `${left}px`};
  top: ${({ top }) => `${top}px`};
  width: 0;
  height: 0;
  z-index: 3;
  pointer-events: none;
`;

const DEFAULT_DELAY = 100;
const useHoverEvent = ({ onHover, delay = DEFAULT_DELAY }) => {
    const hasTriggeredOnHover = React.useRef(false);
    const hoverTimeoutRef = React.useRef(null);
    React.useEffect(() => {
        return () => {
            if (hoverTimeoutRef.current) {
                clearTimeout(hoverTimeoutRef.current);
            }
        };
    }, []);
    const handleMouseEnter = (groupId, activityType) => {
        if (onHover && !hasTriggeredOnHover.current && !hoverTimeoutRef.current) {
            hoverTimeoutRef.current = setTimeout(() => {
                hasTriggeredOnHover.current = true;
                onHover(groupId, activityType);
            }, delay);
        }
    };
    const handleMouseLeave = () => {
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
    };
    return {
        handleMouseEnter,
        handleMouseLeave,
    };
};

const ActivityNotificationItem = ({ notification, isLast, isFirst, requestingUser, onLike, onUnlike, onHover, onReactionHover, enableReactionsTooltip, renderSelfLikeEasterEgg, portalRoot, }) => {
    const EGG_SHOW_DELAY_MS = 220;
    const RESIZE_DEBOUNCE_MS = 100;
    const hasTriggeredOnView = React.useRef(false);
    const [isLiked, setIsLiked] = React.useState(notification.isLikedByUser || false);
    const [likesCount, setLikesCount] = React.useState(notification.activityData?.likesCount || 0);
    const [isLoading, setIsLoading] = React.useState(false);
    const [confettiBurstKey, setConfettiBurstKey] = React.useState(0);
    const [showEasterEgg, setShowEasterEgg] = React.useState(false);
    const { handleMouseEnter, handleMouseLeave } = useHoverEvent({ onHover });
    const hoverStartRef = React.useRef(null);
    const likeButtonRef = React.useRef(null);
    const [portalPosition, setPortalPosition] = React.useState(null);
    const easterEggTimeoutRef = React.useRef(null);
    const resizeDebounceRef = React.useRef(null);
    React.useEffect(() => {
        if (notification.onView && !hasTriggeredOnView.current) {
            hasTriggeredOnView.current = true;
            notification.onView();
        }
        setIsLiked(notification.isLikedByUser || false);
        setLikesCount(notification.activityData?.likesCount || 0);
    }, [notification.onView, notification.isLikedByUser, notification.activityData?.likesCount]);
    const { theme } = React.useContext(SwitchThemeContext);
    const isDark = theme === 'dark';
    const confettiPieces = React.useMemo(() => {
        const colors = ['#5A9B0F', '#7BC318', '#A3EA2A', '#8FD621', '#9CE534'];
        const getShape = (index) => {
            const mod = index % 3;
            switch (mod) {
                case 0:
                    return { radius: '50%', w: 6, h: 6 };
                case 1:
                    return { radius: '2px', w: 8, h: 5 };
                default:
                    return { radius: '1px', w: 5, h: 5 };
            }
        };
        const count = 16;
        const pieces = Array.from({ length: count }).map((_, i) => {
            const baseDeg = 0;
            const spreadDeg = 180;
            const t = (i + 0.5) / count;
            const angleDeg = baseDeg - spreadDeg + t * (2 * spreadDeg);
            const jitterDeg = (Math.random() - 0.5) * 4;
            const angle = ((angleDeg + jitterDeg) * Math.PI) / 180;
            const distance = 24 + Math.random() * 18;
            const rot = (Math.random() * 180 - 90).toFixed(2);
            const shape = getShape(i);
            const translateX = Math.cos(angle) * distance;
            const translateY = Math.sin(angle) * distance - 10;
            return {
                key: `${confettiBurstKey}-${i}`,
                color: colors[i % colors.length],
                width: `${shape.w}px`,
                height: `${shape.h}px`,
                radius: shape.radius,
                transform: `translate(${translateX}px, ${translateY}px)`,
                rot: `${rot}deg`,
            };
        });
        return pieces;
    }, [confettiBurstKey]);
    const computeTooltipText = React.useCallback(() => {
        if (!enableReactionsTooltip)
            return null;
        const activityTypeLabel = 'applauded this!';
        const total = notification.activityData?.likesCount ?? 0;
        const recent = notification.likedByUsers?.map((u) => u.username) ?? [];
        if (total === 0)
            return 'Add reaction...';
        const youReacted = Boolean(notification.isLikedByUser);
        const displayNames = [];
        if (youReacted)
            displayNames.push('You');
        for (const name of recent) {
            if (youReacted && name === requestingUser)
                continue;
            if (!displayNames.includes(name))
                displayNames.push(name);
            if (displayNames.length >= 3)
                break;
        }
        const shownNonYou = displayNames.filter((n) => n !== 'You').length;
        const remaining = Math.max(total - (youReacted ? 1 : 0) - shownNonYou, 0);
        if (total === 1) {
            return youReacted ? `You ${activityTypeLabel}` : `${displayNames[0]} ${activityTypeLabel}`;
        }
        if (remaining === 0 && displayNames.length <= 3) {
            if (displayNames.length === 2)
                return `${displayNames[0]}, ${displayNames[1]} ${activityTypeLabel}`;
            if (displayNames.length === 3)
                return `${displayNames[0]}, ${displayNames[1]} and ${displayNames[2]} ${activityTypeLabel}`;
        }
        const base = displayNames.slice(0, 3);
        const others = Math.max(total - (youReacted ? 1 : 0) - base.filter((n) => n !== 'You').length, 0);
        if (base.length === 1)
            return `${base[0]} and ${others} more ${activityTypeLabel}`;
        if (base.length === 2)
            return `${base[0]}, ${base[1]} and ${others} more ${activityTypeLabel}`;
        return `${base[0]}, ${base[1]}, ${base[2]} and ${others} more ${activityTypeLabel}`;
    }, [
        enableReactionsTooltip,
        notification.likedByUsers,
        notification.activityData?.likesCount,
        notification.isLikedByUser,
        requestingUser,
    ]);
    const tooltipText = computeTooltipText();
    const renderTooltipContent = React.useCallback(() => {
        if (!tooltipText)
            return null;
        const [namesPart, tail] = (() => {
            const idx = tooltipText.lastIndexOf(' applauded this!');
            if (idx !== -1)
                return [tooltipText.slice(0, idx), ' applauded this!'];
            return [tooltipText, ''];
        })();
        return (jsxRuntime.exports.jsxs("span", { children: [jsxRuntime.exports.jsx("span", { style: { color: '#F9F9FB' }, children: namesPart }), jsxRuntime.exports.jsx("span", { style: { color: '#B8BEC9' }, children: tail })] }));
    }, [tooltipText]);
    React.useEffect(() => {
        if (!showEasterEgg || !isFirst)
            return;
        const updatePosition = () => {
            if (!likeButtonRef.current)
                return;
            const rect = likeButtonRef.current.getBoundingClientRect();
            if (portalRoot) {
                const rootRect = portalRoot.getBoundingClientRect();
                setPortalPosition({ left: rect.left + rect.width / 2 - rootRect.left, top: rect.bottom - rootRect.top });
            }
            else {
                setPortalPosition({ left: rect.left + rect.width / 2, top: rect.bottom });
            }
        };
        updatePosition();
        const debounced = () => {
            if (resizeDebounceRef.current)
                clearTimeout(resizeDebounceRef.current);
            resizeDebounceRef.current = setTimeout(() => {
                updatePosition();
            }, RESIZE_DEBOUNCE_MS);
        };
        window.addEventListener('resize', debounced);
        return () => {
            window.removeEventListener('resize', debounced);
            if (resizeDebounceRef.current) {
                clearTimeout(resizeDebounceRef.current);
                resizeDebounceRef.current = null;
            }
        };
    }, [showEasterEgg, isFirst, portalRoot]);
    React.useEffect(() => {
        return () => {
            if (easterEggTimeoutRef.current) {
                clearTimeout(easterEggTimeoutRef.current);
                easterEggTimeoutRef.current = null;
            }
        };
    }, []);
    if (!notification.activityData || !notification.username || !notification.avatar) {
        return null;
    }
    const username = notification.username;
    const avatar = notification.avatar;
    const created = notification.created;
    const activityType = notification.activityData.activityType;
    const code = notification.activityData.code;
    const title = notification.activityData.title;
    const isUserNotificationAuthor = username === requestingUser;
    const isRead = notification.read;
    const formatActivityPrefix = (activityType, isUserNotificationAuthor) => {
        switch (activityType) {
            case 'module_completed':
                return `completed the module`;
            case 'path_completed':
                return `completed the path`;
            case 'path_enrolled':
                return `enrolled in the path`;
            case 'writeup_published':
                return `published a write-up`;
            case 'room_liked':
                return `recommend${isUserNotificationAuthor ? 'ed' : 's'} the room`;
            case 'badge_earned':
                return `earned the badge`;
            case 'league_won':
                return `won this week’s`;
            default:
                return '';
        }
    };
    const getActivityRedirectUrl = (activityType, code) => {
        switch (activityType) {
            case 'module_completed':
                return `/module/${code}`;
            case 'path_completed':
            case 'path_enrolled':
                return `/path/outline/${code}`;
            case 'room_liked':
                return `/room/${code}`;
            case 'writeup_published':
                return code;
            case 'badge_earned':
                return `/p/${username}?tab=badges`;
            case 'league_won':
                return '';
            default:
                return '';
        }
    };
    const renderEasterEgg = () => {
        if (!showEasterEgg || !renderSelfLikeEasterEgg)
            return null;
        const content = renderSelfLikeEasterEgg(() => setShowEasterEgg(false));
        if (isFirst && portalPosition) {
            return $7SXl2$reactdom.createPortal(jsxRuntime.exports.jsx(PortalAnchor, { left: portalPosition.left, top: portalPosition.top, "$fixed": !portalRoot, children: content }), portalRoot ?? document.body);
        }
        return content;
    };
    const handleLikeToggle = async (e) => {
        e.stopPropagation();
        if (isLoading)
            return;
        setIsLoading(true);
        try {
            if (isLiked) {
                const result = await onUnlike(notification._id, activityType);
                if (result?.success) {
                    setIsLiked(false);
                    setLikesCount(result.likesCount);
                }
            }
            else {
                setIsLiked(true);
                setConfettiBurstKey((k) => k + 1);
                if (isUserNotificationAuthor && renderSelfLikeEasterEgg) {
                    if (easterEggTimeoutRef.current) {
                        clearTimeout(easterEggTimeoutRef.current);
                    }
                    easterEggTimeoutRef.current = setTimeout(() => {
                        setShowEasterEgg(true);
                        easterEggTimeoutRef.current = null;
                    }, EGG_SHOW_DELAY_MS);
                }
                const result = await onLike(notification._id, activityType);
                if (result?.success) {
                    setLikesCount(result.likesCount);
                }
            }
        }
        catch (error) {
            NotificationDispatch('error', 'Failed to toggle like');
            setIsLiked((prev) => !prev);
            setLikesCount((prev) => (isLiked ? prev + 1 : Math.max(prev - 1, 0)));
        }
        finally {
            setIsLoading(false);
        }
    };
    return (jsxRuntime.exports.jsx(StyledNotificationItemContent, { "data-testid": "activity-notification-item", isRead: isRead, isLast: isLast, onClick: notification.onClick, onMouseEnter: () => handleMouseEnter(notification.groupId || '', activityType), onMouseLeave: handleMouseLeave, "$isDarkMode": isDark, children: jsxRuntime.exports.jsx(StyledActivityHeader, { children: jsxRuntime.exports.jsxs(StyledFlex, { gap: "0.8rem", justifyContent: "space-between", alignItems: "flex-start", children: [jsxRuntime.exports.jsxs(StyledFlex, { width: "80%", gap: "0.8rem", justifyContent: "flex-start", alignItems: "flex-start", children: [jsxRuntime.exports.jsx(StyledLink$2, { to: `/p/${username}`, children: jsxRuntime.exports.jsx(StyledAvatar, { src: avatar, alt: "" }) }), jsxRuntime.exports.jsxs(StyledFlex, { width: "85%", gap: "0", alignItems: "flex-start", flexDirection: "column", flexWrap: "no-wrap", children: [jsxRuntime.exports.jsxs(StyledActivityDescription, { children: [isUserNotificationAuthor ? ('You') : (jsxRuntime.exports.jsx(StyledUsernameLink, { to: `/p/${username}`, children: username })), ' ', formatActivityPrefix(activityType, isUserNotificationAuthor), ' ', activityType === 'writeup_published' ? (jsxRuntime.exports.jsx("a", { href: code, target: "_blank", rel: "noopener noreferrer", children: title })) : activityType === 'league_won' ? (jsxRuntime.exports.jsx("span", { children: title })) : (jsxRuntime.exports.jsx(reactRouterDom.Link, { to: getActivityRedirectUrl(activityType, code), state: { pageReferrer: '/notifications' }, children: title })), requestingUser === username && '  🎉'] }), jsxRuntime.exports.jsx(StyledActivityTimestamp, { children: dateFns.formatDistanceToNowStrict(new Date(created), { addSuffix: true }) })] })] }), jsxRuntime.exports.jsxs(LikeButtonWrapper, { children: [enableReactionsTooltip && tooltipText ? (jsxRuntime.exports.jsx(SmallTooltipWrapper, { id: `reaction-tooltip-${notification._id}`, tooltipText: tooltipText, tooltipContent: renderTooltipContent(), position: "top", contentStyles: { maxWidth: '19.2rem', textAlign: 'center' }, children: jsxRuntime.exports.jsxs(StyledLikeButton, { ref: likeButtonRef, onClick: handleLikeToggle, disabled: isLoading, "$isLiked": isLiked, "$isLoading": isLoading, "$hasCount": likesCount > 0, "aria-label": isLiked ? 'Unlike this activity' : 'Like this activity', onMouseEnter: () => {
                                        hoverStartRef.current = performance.now();
                                    }, onMouseLeave: () => {
                                        const start = hoverStartRef.current;
                                        hoverStartRef.current = null;
                                        if (!start || !onReactionHover)
                                            return;
                                        const duration = Math.max(0, Math.round(performance.now() - start));
                                        if (duration >= 100)
                                            onReactionHover(notification._id, activityType, duration);
                                    }, children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: isLiked ? faHandsClapping : faHandsClapping$1, style: {
                                                opacity: isLoading ? 0.6 : 1,
                                                transition: 'all 0.2s ease',
                                            } }), likesCount > 0 && jsxRuntime.exports.jsx("p", { children: formatNumberWithSuffix(likesCount) })] }) })) : (jsxRuntime.exports.jsxs(StyledLikeButton, { ref: likeButtonRef, onClick: handleLikeToggle, disabled: isLoading, "$isLiked": isLiked, "$isLoading": isLoading, "$hasCount": likesCount > 0, "aria-label": isLiked ? 'Unlike this activity' : 'Like this activity', children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: isLiked ? faHandsClapping : faHandsClapping$1, style: {
                                            opacity: isLoading ? 0.6 : 1,
                                            transition: 'all 0.2s ease',
                                        } }), likesCount > 0 && jsxRuntime.exports.jsx("p", { children: formatNumberWithSuffix(likesCount) })] })), isLiked && (jsxRuntime.exports.jsx(ConfettiOverlay, { "aria-hidden": "true", children: confettiPieces.map((p) => (jsxRuntime.exports.jsx(ConfettiPiece, { style: {
                                        '--confetti-color': p.color,
                                        '--confetti-w': p.width,
                                        '--confetti-h': p.height,
                                        '--confetti-radius': p.radius,
                                        '--confetti-transform': p.transform,
                                        '--confetti-rot': p.rot,
                                    } }, p.key))) })), renderEasterEgg()] })] }) }) }, notification._id));
};

const StyledFollowDescription = styled__default["default"](StyledActivityDescription) `
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`;
const StyledFollowUsernameLink = styled__default["default"](StyledUsernameLink) `
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
`;

const FollowNotificationItem = ({ notification, isLast, onHover, }) => {
    const hasTriggeredOnView = React.useRef(false);
    const { handleMouseEnter, handleMouseLeave } = useHoverEvent({ onHover });
    const { theme } = React.useContext(SwitchThemeContext);
    const isDark = theme === 'dark';
    React.useEffect(() => {
        if (notification.onView && !hasTriggeredOnView.current) {
            hasTriggeredOnView.current = true;
            notification.onView();
        }
    }, [notification.onView]);
    const followData = notification.followData;
    if (!followData) {
        return null;
    }
    const { created } = notification;
    const { followerUsername, followerAvatar } = followData;
    return (jsxRuntime.exports.jsx(StyledNotificationItemContent, { "data-testid": "follow-notification-item", isRead: notification.read, isLast: isLast, onClick: notification.onClick, onMouseEnter: () => handleMouseEnter(notification.groupId || ''), onMouseLeave: handleMouseLeave, "$isDarkMode": isDark, children: jsxRuntime.exports.jsx(StyledFlex, { children: jsxRuntime.exports.jsxs(StyledFlex, { gap: "1.2rem", justifyContent: "flex-start", alignItems: "center", children: [followerAvatar && (jsxRuntime.exports.jsx(StyledLink$2, { to: `/p/${followerUsername}`, children: jsxRuntime.exports.jsx(StyledAvatar, { src: followerAvatar, alt: "" }) })), jsxRuntime.exports.jsxs(StyledFlex, { flexDirection: "column", alignItems: "flex-start", gap: "0.6rem", width: "unset", children: [jsxRuntime.exports.jsxs(StyledFollowDescription, { children: [jsxRuntime.exports.jsx(StyledFollowUsernameLink, { to: `/p/${followerUsername}`, children: followerUsername }), ' ', "started following you."] }), jsxRuntime.exports.jsx(StyledActivityTimestamp, { children: dateFns.formatDistanceToNowStrict(new Date(created), { addSuffix: true }) })] })] }) }) }, notification._id));
};

var THMLogo = 'data:image/png;base64,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';

const NotificationItem = ({ notification, isLast, isFirst, requestingUser, onLike, onUnlike, onHover, onReactionHover, enableReactionsTooltip, renderSelfLikeEasterEgg, portalRoot, }) => {
    const hasTriggeredOnView = React.useRef(false);
    const { handleMouseEnter, handleMouseLeave } = useHoverEvent({ onHover });
    React.useEffect(() => {
        if (notification.onView && !hasTriggeredOnView.current) {
            hasTriggeredOnView.current = true;
            notification.onView();
        }
    }, []);
    const { theme } = React.useContext(SwitchThemeContext);
    const isDark = theme === 'dark';
    if (notification.groupId === 'user-activity' && onLike && onUnlike) {
        return (jsxRuntime.exports.jsx(ActivityNotificationItem, { notification: notification, isLast: isLast, isFirst: isFirst, requestingUser: requestingUser, onLike: onLike, onUnlike: onUnlike, onHover: onHover, onReactionHover: onReactionHover, enableReactionsTooltip: enableReactionsTooltip, renderSelfLikeEasterEgg: renderSelfLikeEasterEgg, portalRoot: portalRoot }));
    }
    if (notification.groupId === 'user-follow') {
        return jsxRuntime.exports.jsx(FollowNotificationItem, { notification: notification, isLast: isLast, onHover: onHover });
    }
    return (jsxRuntime.exports.jsx(StyledNotificationItemContent, { "data-testid": "notifications-list", isRead: notification.read, isLast: isLast, onClick: notification.onClick, onMouseEnter: () => handleMouseEnter(notification.groupId || ''), onMouseLeave: handleMouseLeave, "$isDarkMode": isDark, children: jsxRuntime.exports.jsx(StyledActivityHeader, { children: jsxRuntime.exports.jsxs(StyledFlex, { gap: "0.8rem", justifyContent: "flex-start", alignItems: "flex-start", children: [jsxRuntime.exports.jsx(StyledAvatar, { src: THMLogo, alt: "" }), jsxRuntime.exports.jsxs(StyledFlex, { width: "85%", gap: "0", alignItems: "flex-start", flexDirection: "column", flexWrap: "no-wrap", children: [jsxRuntime.exports.jsx(StyledActivityDescription, { dangerouslySetInnerHTML: { __html: notification.description } }), jsxRuntime.exports.jsx(StyledActivityTimestamp, { children: dateFns.formatDistanceToNowStrict(new Date(notification.created), { addSuffix: true }) })] })] }) }) }, notification._id));
};

const Notifications = ({ clearNotifications, notifications = [], unreadNotificationsCount, onNotificationsOpen, requestingUser, onLike, onUnlike, onHover, onReactionHover, enableReactionsTooltip, renderSelfLikeEasterEgg, animateBell = true, }) => {
    const [open, setOpen] = React.useState(false);
    const BELL_ANIM_DUR_S = BELL_ANIM_MS / 1000;
    const [animate, setAnimate] = React.useState(false);
    const unreadSocialCount = React.useMemo(() => notifications.filter((notification) => {
        const isFollow = !!notification.followData;
        const isLike = notification.activityData?.activityType === 'room_liked';
        const isSocial = isFollow || isLike;
        return isSocial && !notification.read;
    }).length, [notifications]);
    const prevUnreadSocialRef = React.useRef(unreadSocialCount);
    const reactId = React.useId().replace(/[:]/g, '-');
    const [gradientId] = React.useState(() => `thm-bell-${reactId}`);
    const handleOpenChange = (isOpen) => {
        if (isOpen)
            onNotificationsOpen?.();
        setOpen(isOpen);
        if (isOpen && animate)
            setAnimate(false);
    };
    const { theme } = React.useContext(SwitchThemeContext);
    const isDark = theme === 'dark';
    const [portalRoot, setPortalRoot] = React.useState(null);
    const handlePortalRootRef = React.useCallback((el) => {
        setPortalRoot(el);
    }, []);
    React.useEffect(() => {
        const prev = prevUnreadSocialRef.current;
        const next = unreadSocialCount;
        if (animateBell && prev === 0 && next > 0 && !animate) {
            setAnimate(true);
        }
        prevUnreadSocialRef.current = next;
    }, [unreadSocialCount, animate, animateBell]);
    React.useEffect(() => {
        if (!animate)
            return;
        const animationTimeoutId = setTimeout(() => setAnimate(false), BELL_ANIM_DUR_S * 1000 + 200);
        return () => clearTimeout(animationTimeoutId);
    }, [animate, BELL_ANIM_DUR_S]);
    return (jsxRuntime.exports.jsxs(DropdownMenu, { open: open, onOpenChange: handleOpenChange, type: "notification", alignContent: "end", triggerBtn: jsxRuntime.exports.jsxs(StyledNotificationsTrigger, { isNotifications: !!unreadNotificationsCount, "data-animate": animate && animateBell ? 'true' : 'false', "aria-label": "Open Notifications", children: [!!unreadNotificationsCount && (jsxRuntime.exports.jsx(StyledUnreadNotificationsCount, { children: unreadNotificationsCount })), jsxRuntime.exports.jsxs(StyledIconWrapper$1, { children: [jsxRuntime.exports.jsx(StyledNotificationIcon, { icon: faBell }), animate && animateBell && (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(StyledExplodingHands, { alt: "" }), jsxRuntime.exports.jsx(BellOverlay, { gradientId: gradientId, durationS: BELL_ANIM_DUR_S, onEnd: () => setAnimate(false) })] }))] })] }), children: [jsxRuntime.exports.jsxs(StyledNotificationHeader, { children: [jsxRuntime.exports.jsx(StyledNotificationHeaderTitle, { children: "Notifications" }), !!unreadNotificationsCount && (jsxRuntime.exports.jsx(StyledClearNotificationsMenuItem, { onSelect: () => clearNotifications && clearNotifications(), children: "Mark all as read" }))] }), notifications.length ? (jsxRuntime.exports.jsx($a093c7e1ec25a057$export$2881499e37b75b9a, { delayDuration: 100, skipDelayDuration: 200, children: jsxRuntime.exports.jsxs(StyledNotificationsContentLayer, { children: [jsxRuntime.exports.jsx(StyledNotificationsPortalLayer, { ref: handlePortalRootRef }), jsxRuntime.exports.jsx(StyledNotificationItemsWrapper, { children: React.Children.toArray(notifications.map((notification, index) => (jsxRuntime.exports.jsx(NotificationItem, { notification: notification, isLast: notifications.length - 1 === index, isFirst: index === 0, requestingUser: requestingUser, onLike: onLike, onUnlike: onUnlike, onHover: onHover, onReactionHover: onReactionHover, enableReactionsTooltip: enableReactionsTooltip, renderSelfLikeEasterEgg: renderSelfLikeEasterEgg, portalRoot: portalRoot }, notification._id)))) })] }) })) : (jsxRuntime.exports.jsx(StyledNotificationItemContent, { isNoNotifications: true, isLast: true, "$isDarkMode": isDark, "data-testid": "notifications-list", children: jsxRuntime.exports.jsx("p", { children: "You have no notifications" }) }))] }));
};

const StyledSearchPopUp = styled__default["default"](StyledBox) `
  background: ${({ theme }) => theme.colors.background.main};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  padding: 2.4rem;
  position: absolute;
  top: 4rem;
  right: 0;
  width: fit-content;
  z-index: 3;
  overflow-y: auto;
  max-height: calc(-80px + 100vh);

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) and (max-width: ${({ theme }) => theme.sizes.lg}) {
    right: -50%;
    transform: translateX(50%);
    overflow-y: auto;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    left: 1rem;
    top: 1rem;
    width: calc(100% - 1.8rem);
    height: calc(100vh - 3.2rem);
  }
`;
const StyledCloseIconButton$2 = styled__default["default"].button `
  display: none;
  position: absolute;
  top: 2.4rem;
  right: 2.4rem;

  svg {
    color: ${({ theme }) => theme.colors.text.lighter};
    height: 1.8rem;
    width: 1.8rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: inline-block;
  }
`;

const SearchPopUp = ({ children, setIsSearchResultsPopUpOpen, searchPopUpResultsRef, handleClick, }) => (jsxRuntime.exports.jsxs(StyledSearchPopUp, { "data-testid": "search-popup", onClick: handleClick, ref: searchPopUpResultsRef, children: [jsxRuntime.exports.jsx(StyledCloseIconButton$2, { "aria-label": "Close Modal", onClick: () => setIsSearchResultsPopUpOpen(false), "data-testid": "btn-close", children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faXmark$2 }) }), children] }));

const StyledAccordionTrigger = styled__default["default"]($1bf158f521e1b1b4$export$41fb9f06171c75f4) `
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  padding: 0 0 0 ${({ $isAvatar }) => ($isAvatar ? '0' : '3rem')};
  height: 5.3rem;
  flex: 1;
  display: flex;
  margin-bottom: ${({ $isAvatar }) => ($isAvatar ? '1.8rem' : '0')};
  align-items: center;
  justify-content: ${({ $isAvatar }) => ($isAvatar ? 'center' : 'space-between')};
  font-size: 1.8rem;
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  line-height: 2.068rem;
  color: ${({ theme }) => theme.colors.grey[100]};
  background-color: ${({ theme }) => theme.colors.black};

  & > div {
    display: flex;
  }

  & > div > svg {
    margin-right: 2rem;
    color: ${({ theme }) => theme.colors.grey[100]};
    height: 2rem;
    display: flex;
    align-self: end;
  }

  &[data-state='open'] {
    color: ${({ theme }) => theme.colors.primary.main};
    > div > svg {
      color: ${({ theme }) => theme.colors.primary.main};
    }
    > svg {
      transform: rotateX(180deg);
      transition: transform 300ms ease-in-out;
    }
  }

  &[data-state='closed'] {
    > svg {
      transition: transform 300ms ease-in-out;
    }
  }
`;
const StyledAccordionHeader = styled__default["default"].header `
  display: flex;
`;
const StyledChevronDownIcon = styled__default["default"](FontAwesomeIcon) `
  margin-right: 4.65rem;

  & > path {
    color: ${({ theme }) => theme.colors.grey[100]};
    width: 1.05rem;
    height: 0.6rem;
  }
`;

const AccordionTrigger = ({ trigger, item, avatar }) => {
    const result = trigger === 'avatar' ? (jsxRuntime.exports.jsx(StyledAccordionHeader, { children: jsxRuntime.exports.jsx(StyledAccordionTrigger, { "$isAvatar": true, children: jsxRuntime.exports.jsx(Avatar, { avatarSrc: avatar ?? '', size: "56px" }) }) })) : (jsxRuntime.exports.jsx(StyledAccordionHeader, { "aria-label": item?.name, children: jsxRuntime.exports.jsxs(StyledAccordionTrigger, { "$isAvatar": false, children: [jsxRuntime.exports.jsxs("div", { children: [item?.icon, jsxRuntime.exports.jsx("span", { children: trigger })] }), item?.subItems && item.subItems.length > 0 && jsxRuntime.exports.jsx(StyledChevronDownIcon, { icon: faChevronDown })] }) }));
    return result;
};

const StyledMobileNavLinkContent = styled__default["default"].div `
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
  font-size: 1.8rem;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 2.4rem;

  & > div {
    margin-top: ${({ first }) => (first ? '2.2rem' : '0')};
    margin-bottom: ${({ last }) => (last ? '2.2rem' : '0')};
  }

  color: ${({ theme }) => theme.colors.grey[100]};
  padding-left: 2.4rem;

  & > div {
    padding: 1.2rem 4rem;
    display: flex;
  }

  & > div > svg {
    margin-right: 2rem;
  }
`;
const StyledMobileNavLinkContentIcon = styled__default["default"].div `
  display: flex;
  align-items: center;
  padding-right: ${({ isNew }) => (isNew ? '0.5rem' : '1rem')};

  > svg {
    height: 2rem;
    color: ${({ theme }) => theme.colors.grey[100]};
    fill: ${({ theme }) => theme.colors.grey[100]};
  }
`;
const StyledMobileNavLinkContentText = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  & > span {
    &:nth-child(2) {
      font-size: ${({ theme }) => theme.fonts.sizes.small};
      font-weight: ${({ theme }) => theme.fonts.weight.regular};
      line-height: 1.76rem;
    }
  }
`;
const StyledNewTagWrapper = styled__default["default"].div `
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;
const StyledNewFeatureTag = styled__default["default"].span `
  display: flex;
  align-items: center;
  background-color: ${lighterVariations.error.light};
  color: ${accentColors.error.light};
  padding: 0 1rem;
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  border-radius: ${({ theme }) => theme.radius.huge};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  line-height: 1.379rem;
  height: 2rem;
`;
const StyledChevronIcon = styled__default["default"](FontAwesomeIcon) `
  height: 1.8rem;
  opacity: 0.7;
  margin-left: 3.6rem;
`;

const MobileNavLinkContent = ({ content, description, icon, first, last, isNew, hasSubItems, isOpen, }) => (jsxRuntime.exports.jsxs(StyledMobileNavLinkContent, { first: first ? 'true' : '', last: last ? 'true' : '', children: [jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx(StyledMobileNavLinkContentIcon, { isNew: isNew, children: icon }), jsxRuntime.exports.jsxs(StyledMobileNavLinkContentText, { children: [jsxRuntime.exports.jsxs(StyledNewTagWrapper, { children: [jsxRuntime.exports.jsx("span", { children: content }), isNew && jsxRuntime.exports.jsx(StyledNewFeatureTag, { children: "NEW" })] }), jsxRuntime.exports.jsx("span", { children: description })] })] }), hasSubItems && jsxRuntime.exports.jsx(StyledChevronIcon, { icon: isOpen ? faChevronUp : faChevronDown$2 })] }));

const StyledMobileNav = styled__default["default"].nav `
  display: none;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: flex;
    flex-direction: column;
    background-color: ${({ theme }) => theme.colors.black};
    height: calc(100% - env(safe-area-inset-bottom));
    width: 100vw;
    overflow: hidden;
    top: 0;
    left: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
    padding: 2.2rem 1.2rem;
    position: fixed;
    transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1100;
    opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  }
`;
const StyledMobileNavHeader = styled__default["default"].header `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;
const StyledCloseButton$1 = styled__default["default"].button `
  padding-right: 0.8rem;
`;
const StyledCloseButtonIcon = styled__default["default"](FontAwesomeIcon) `
  width: 2rem;
  color: ${({ theme }) => theme.colors.grey[100]};
`;
const StyledAccordion = styled__default["default"]($1bf158f521e1b1b4$export$be92b6f5f03c0fe9) `
  border-radius: 0.6rem;
  width: 100vw;
  margin-top: 4.6rem;
  min-width: 36rem;
  overflow-y: scroll;
`;
const StyledAccordionItem = styled__default["default"]($1bf158f521e1b1b4$export$6d08773d2e66f8f2) ``;
const StyledAccordionContent = styled__default["default"]($1bf158f521e1b1b4$export$7c6e2c02157bb7d2) `
  background-color: ${({ theme }) => theme.colors.secondary.light};
  margin-right: 1.2rem;
  border-radius: 0.5rem;
  overflow: hidden;
  &[data-state='open'] {
    animation: slideDown 300ms cubic-bezier(0.87, 0, 0.13, 1);

    @keyframes slideDown {
      from {
        height: 0;
      }
      to {
        height: var(--radix-accordion-content-height);
      }
    }
  }

  &[data-state='closed'] {
    animation: slideUp 300ms cubic-bezier(0.87, 0, 0.13, 1);

    @keyframes slideUp {
      from {
        height: var(--radix-accordion-content-height);
      }
      to {
        height: 0;
      }
    }
  }
`;
const StyledLink = styled__default["default"](reactRouterDom.Link) `
  text-decoration: none;
`;
const StyledButtonsWrapper = styled__default["default"].div `
  display: flex;
  gap: 1.6rem;
  justify-content: center;
  align-items: center;
  margin-top: auto;
  padding-top: 2rem;
  margin-bottom: 2.4rem;

  a:first-of-type,
  a:last-of-type:hover {
    color: ${({ theme }) => theme.colors.grey[100]};
  }

  & > a {
    width: 100%;
  }
`;
const StyledMobileNavMenu = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  margin-top: 4rem;
  margin-bottom: 4rem;
  gap: 4rem;

  & > div {
    display: flex;
    justify-content: center;
  }

  & > button {
    display: flex;
    justify-content: center;
    & > span {
      position: relative;
      left: 3rem;
    }
  }

  & div:nth-child(2) {
    left: 50%;
  }
`;
const StyledAdminAccordionTrigger = styled__default["default"]($1bf158f521e1b1b4$export$41fb9f06171c75f4) `
  display: block;
  width: 100%;
  text-align: center;
  margin-bottom: 2rem;

  svg {
    color: ${({ theme }) => theme.colors.alpha[50]};
    height: 2.2rem;
  }
`;
const StyledStreakWrapper = styled__default["default"].div `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
`;
const StyledMobileNavSubMenuTrigger = styled__default["default"].button `
  width: 100%;
  background: none;
  border: none;
  text-align: left;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  display: block;
`;
const StyledMobileNavSubMenuRow = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.secondary.light};
  border-radius: 0.5rem;
  margin: 0.5rem 0 1rem 0;
  padding: 1rem;
  gap: 2rem;
`;

const MobileNav = ({ isOpen, closeMobileNav, navItems, isAuth, avatar, avatarDropDownMenuItems, streak, onStreakRepair, onStreakShare, notifications, clearNotifications, unreadNotificationsCount, onNotificationsOpen, adminLinks, isChristmas, isStreakShareEnabled, username, }) => {
    const avatarItemsForAccordion = avatarDropDownMenuItems
        ?.flatMap((obj) => obj.items)
        ?.filter((item) => item.href);
    const tryHackmeLogo = 'https://assets.tryhackme.com/img/logo/tryhackme_logo_full.svg';
    const tryHackmeChristmasLogo = 'https://assets.tryhackme.com/img/logo/thm_christmas_logo.svg';
    const [openSubMenu, setOpenSubMenu] = React.useState(null);
    return (jsxRuntime.exports.jsxs(StyledMobileNav, { "aria-label": "Mobile", isOpen: isOpen, children: [jsxRuntime.exports.jsxs(StyledMobileNavHeader, { children: [jsxRuntime.exports.jsx(reactRouterDom.Link, { to: isAuth ? '/dashboard' : '/', state: { pageReferrer: 'navbar' }, children: jsxRuntime.exports.jsx("img", { width: 140, src: isChristmas ? tryHackmeChristmasLogo : tryHackmeLogo, alt: "TryHackMe" }) }), jsxRuntime.exports.jsx(StyledCloseButton$1, { onClick: closeMobileNav, "aria-label": "Close mobile nav", children: jsxRuntime.exports.jsx(StyledCloseButtonIcon, { icon: faXmark$2 }) })] }), jsxRuntime.exports.jsxs(StyledAccordion, { type: "single", collapsible: true, children: [navItems.map((item) => (jsxRuntime.exports.jsx(StyledAccordionItem, { value: item.name, children: item.subItems && item.subItems.length > 0 ? (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(AccordionTrigger, { trigger: item.name, item: item, avatar: avatar }), jsxRuntime.exports.jsx(StyledAccordionContent, { children: item.subItems.map((subItem, index) => {
                                        if (subItem.subMenuItems && subItem.subMenuItems.length > 0) {
                                            return (jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx(StyledMobileNavSubMenuTrigger, { onClick: () => setOpenSubMenu(openSubMenu === subItem.name ? null : subItem.name), children: jsxRuntime.exports.jsx(MobileNavLinkContent, { content: subItem.name, description: subItem.description, icon: subItem.icon, first: index === 0, last: item.subItems ? index === item.subItems.length - 1 : false, isNew: subItem.isNew, hasSubItems: !!subItem.subMenuItems?.length, isOpen: openSubMenu === subItem.name }) }), openSubMenu === subItem.name && (jsxRuntime.exports.jsx(StyledMobileNavSubMenuRow, { children: subItem.subMenuItems.map((subMenuItem) => (jsxRuntime.exports.jsxs(StyledLink, { to: subMenuItem.href ?? '#', onClick: closeMobileNav, style: { flex: 1 }, children: [jsxRuntime.exports.jsx(MobileNavLinkContent, { content: subMenuItem.name, description: subMenuItem.description, icon: subMenuItem.icon, isNew: subMenuItem.isNew, hasSubItems: !!subMenuItem.subMenuItems?.length, isOpen: openSubMenu === subMenuItem.name }), jsxRuntime.exports.jsx(StyledChevronIcon$1, { icon: openSubMenu === subMenuItem.name ? faChevronUp : faChevronDown$2 })] }, subMenuItem.name))) }))] }, subItem.name));
                                        }
                                        if (!subItem.href)
                                            return null;
                                        return (jsxRuntime.exports.jsx(StyledLink, { to: subItem.href ?? '#', onClick: closeMobileNav, children: jsxRuntime.exports.jsx(MobileNavLinkContent, { content: subItem.name, description: subItem.description, icon: subItem.icon, first: index === 0, last: item.subItems ? index === item.subItems.length - 1 : false, isNew: subItem.isNew, hasSubItems: !!subItem.subMenuItems?.length, isOpen: openSubMenu === subItem.name }) }, subItem.name));
                                    }) })] })) : (jsxRuntime.exports.jsx(StyledLink, { to: item.href ?? '#', "aria-label": item.href, onClick: closeMobileNav, children: jsxRuntime.exports.jsx(AccordionTrigger, { item: item, trigger: item.name, "aria-label": item.name }) })) }, item.name))), isAuth && (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(StyledMobileNavMenu, { children: jsxRuntime.exports.jsx("div", { children: jsxRuntime.exports.jsx(Notifications, { clearNotifications: clearNotifications, notifications: notifications, unreadNotificationsCount: unreadNotificationsCount, onNotificationsOpen: onNotificationsOpen, requestingUser: username }) }) }), adminLinks?.some((link) => link.visible) && (jsxRuntime.exports.jsxs(StyledAccordionItem, { "data-testid": "mobile-admin-links", value: "admin", children: [jsxRuntime.exports.jsx(StyledAdminAccordionTrigger, { children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faToolbox }) }), jsxRuntime.exports.jsx(StyledAccordionContent, { children: adminLinks.map((link, index) => (jsxRuntime.exports.jsx(StyledLink, { to: link.href, onClick: closeMobileNav, children: jsxRuntime.exports.jsx(MobileNavLinkContent, { content: link.title, icon: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: link.icon }), first: index === 0, last: index === adminLinks.length - 1 }) }, link.title))) })] })), streak && (jsxRuntime.exports.jsx(StyledStreakWrapper, { "aria-label": "streak", children: jsxRuntime.exports.jsx(Streak, { ...streak, onStreakRepair: onStreakRepair, onStreakShare: onStreakShare, isStreakShareEnabled: isStreakShareEnabled }) })), jsxRuntime.exports.jsxs(StyledAccordionItem, { value: "avatar", children: [jsxRuntime.exports.jsx(AccordionTrigger, { trigger: "avatar", avatar: avatar }), jsxRuntime.exports.jsx(StyledAccordionContent, { children: avatarItemsForAccordion?.map((subItem, index) => (jsxRuntime.exports.jsx(StyledLink, { to: subItem.href ?? '#', onClick: closeMobileNav, children: jsxRuntime.exports.jsx(MobileNavLinkContent, { content: subItem.name, description: subItem.description, icon: subItem.icon, first: index === 0, last: index === avatarItemsForAccordion.length - 1, hasSubItems: !!subItem.subMenuItems?.length, isOpen: openSubMenu === subItem.name }) }, subItem.name))) })] })] }))] }), !isAuth && (jsxRuntime.exports.jsxs(StyledButtonsWrapper, { children: [jsxRuntime.exports.jsx(LoginButton, { variant: "outlined", forceDarkMode: true, fillSpace: true, onNavigate: closeMobileNav }), jsxRuntime.exports.jsx(StyledButton$3, { as: reactRouterDom.Link, to: "/signup", color: "primary", variant: "solid", id: "cta-header-join-for-free", onClick: closeMobileNav, children: "Join for FREE" })] }))] }));
};

const StyledModuleCardWrapperLink = styled__default["default"](reactRouterDom.Link) `
  display: flex;
  flex-direction: column;
  text-decoration: none;
  padding: 1.6rem;
  position: relative;
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  border-radius: ${({ theme }) => theme.radius.small};
  background-color: ${({ theme }) => theme.colors.background.main};
  width: 100%;
  height: 21.5rem;

  &:hover {
    cursor: pointer;
    outline: 1px solid ${({ theme }) => theme.colors.border.hover};
  }
`;
const StyledTitle$5 = styled__default["default"].span `
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  color: ${({ theme }) => theme.colors.text.main};
  margin-top: 1rem;
`;
const StyledContent$5 = styled__default["default"].p `
  margin-top: 1.4rem;
  line-height: 2rem;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.lighter};
`;
const StyledIcon$3 = styled__default["default"].img `
  width: 6rem;
  height: 6rem;
`;
const StyledTitleAndContentWrapper = styled__default["default"].div `
  display: -webkit-box;
  height: 100%;
  overflow: hidden;
  max-height: 13rem;
  margin-top: 1rem;
  margin-bottom: auto;
  line-height: 2rem;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.lighter};
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
`;

const ModuleCard = ({ title, content, icon, code }) => {
    const moduleUrl = `/module/${code}`;
    return (jsxRuntime.exports.jsxs(StyledModuleCardWrapperLink, { to: moduleUrl, children: [jsxRuntime.exports.jsx(StyledIcon$3, { src: icon, alt: title }), jsxRuntime.exports.jsxs(StyledTitleAndContentWrapper, { children: [jsxRuntime.exports.jsx(StyledTitle$5, { children: title }), jsxRuntime.exports.jsx(StyledContent$5, { children: content })] })] }));
};

const TagContent = ({ cardType, roomType, requiredStreak }) => {
    switch (cardType) {
        case 'room': {
            const icon = roomType === exports.RoomType.Challenge ? faFlag$1 : faRoute;
            const text = roomType === exports.RoomType.Challenge ? 'Challenge' : 'Walkthrough';
            return (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: icon }), " ", text] }));
        }
        case 'network': {
            return (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: ["Streak required:", ' ', jsxRuntime.exports.jsxs(StyledStreak, { children: [requiredStreak, " ", jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faFire })] })] }));
        }
        default: {
            return null;
        }
    }
};

const MultiCard = ({ imageProps, title, description, difficulty, duration, isCompleted = false, isNew = false, freeToUse = true, cardType = exports.CardTypeEnum.ROOM, roomType, progressValue = 0, requiredStreak = 0, cardHeight, showCardType = false, url, hasCollaborator = false, collaboratorName, collaboratorImageLight, collaboratorImageDark, isClonedRoom = false, handleClose, isMyLearning = false, firstBtnText, secondBtnText, onFirstBtnClick, onSecondBtnClick, btnsWidth, cloudAddOn = false, }) => {
    const showProgress = !isCompleted && !isNew && progressValue !== 0 && progressValue <= 99;
    const showCompleted = isCompleted || progressValue === 100;
    const showWrapper = hasCollaborator || difficulty;
    const location = reactRouterDom.useLocation();
    return (jsxRuntime.exports.jsxs(StyledWrapperCard, { children: [isMyLearning && isCompleted && (jsxRuntime.exports.jsx(CardOverlay, { onFirstBtnClick: onFirstBtnClick, onSecondBtnClick: onSecondBtnClick, firstBtnText: firstBtnText, secondBtnText: secondBtnText, btnsWidth: btnsWidth })), jsxRuntime.exports.jsxs(StyledMultiCard, { to: url, state: { pageReferrer: cardType === exports.CardTypeEnum.ROOM && location.pathname }, "$cardHeight": cardHeight, "$cardType": cardType, "$hasCollaborator": hasCollaborator, children: [jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsxs(StyledHeader, { "$cardType": cardType, children: [jsxRuntime.exports.jsx(StyledImageContainer$3, { "$cardType": cardType, children: imageProps && jsxRuntime.exports.jsx(StyledCardImage$3, { ...imageProps }) }), jsxRuntime.exports.jsxs("div", { children: [showCardType && jsxRuntime.exports.jsx(StyledFilterTag, { "data-testid": "card-type-tag", children: cardType }), showProgress && (jsxRuntime.exports.jsx(CircularProgress, { progressValue: progressValue, isDarkVersion: Boolean(cardType === exports.CardTypeEnum.MODULE) })), showCompleted && (jsxRuntime.exports.jsx(StyledCheckIcon$1, { "$cardType": cardType, icon: faCheckCircle$1, "data-testid": "completed-icon" })), isNew && jsxRuntime.exports.jsx(StyledNewTag, { children: "New" }), Boolean(handleClose) && (jsxRuntime.exports.jsx("button", { onClick: handleClose, type: "button", "data-testid": "close-button", children: jsxRuntime.exports.jsx(StyledCloseIcon$1, { icon: faXmark$1 }) }))] })] }), jsxRuntime.exports.jsxs(StyledWrapper$3, { "data-content": "content", children: [jsxRuntime.exports.jsx(StyledTitle$6, { children: title }), jsxRuntime.exports.jsx(StyledDescription$1, { "$cardType": cardType, children: description })] })] }), jsxRuntime.exports.jsxs(StyledWrapper$3, { children: [showWrapper && (jsxRuntime.exports.jsxs(StyledMoreInfoWrapper, { "$difficulty": Boolean(difficulty), "data-testid": "info-wrapper", children: [difficulty && (jsxRuntime.exports.jsxs("div", { children: [duration && jsxRuntime.exports.jsx(Duration, { duration: duration }), jsxRuntime.exports.jsx(Difficulty, { difficulty: difficulty, hasIcon: true, isSmall: true })] })), hasCollaborator && (jsxRuntime.exports.jsx(Collaborator, { collaboratorName: collaboratorName, collaboratorImageLight: collaboratorImageLight, collaboratorImageDark: collaboratorImageDark }))] })), roomType && cardType !== exports.CardTypeEnum.MODULE && (jsxRuntime.exports.jsxs(StyledTags$2, { children: [isClonedRoom && (jsxRuntime.exports.jsx(Tag, { size: "small", color: "grey", variation: 900, children: "Cloned room" })), cloudAddOn ? (jsxRuntime.exports.jsx(Tag, { size: "small", color: "grey", variation: 900, children: "Cloud add-on" })) : (jsxRuntime.exports.jsx(Tag, { size: "small", color: "grey", variation: 900, children: freeToUse ? 'Free' : 'Premium' })), jsxRuntime.exports.jsx(Tag, { size: "small", color: "grey", variation: 900, children: jsxRuntime.exports.jsx(TagContent, { cardType: cardType, roomType: roomType, requiredStreak: requiredStreak }) })] }))] })] })] }));
};

const StyledNewRoomCard = styled__default["default"](reactRouterDom.Link) `
  background-color: ${({ $isDarkMode }) => ($isDarkMode ? '#212C42' : 'transparent')};
  border: 1px solid ${({ $isDarkMode }) => ($isDarkMode ? '#3E475A' : '#EEEFF2')};
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: none;
  display: flex;
  cursor: pointer;
  padding: 1.6rem;
  flex-direction: column;
  justify-content: space-between;
  text-decoration: none;
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
  height: 100%;
  &:hover {
    background-color: ${({ $isDarkMode }) => ($isDarkMode ? '#27344E' : '#EEEFF2')};
    border-color: ${({ $isDarkMode }) => ($isDarkMode ? '#454F64' : '#D4D8DF')};
    box-shadow: none;
  }
`;
const StyledTitle$4 = styled__default["default"].h2 `
  ${StyledCardTitle};
  margin: 1rem 0 1.6rem 0;
  > span {
    margin-left: 0.8rem;
  }
`;
const StyledImageContainer$1 = styled__default["default"].div `
  height: 5rem;
  width: 5rem;
`;
const StyledCardImage = styled__default["default"](Image) `
  height: inherit;
  object-fit: cover;
  width: inherit;
`;

const NewRoomCard = ({ imageProps, title, difficulty, url, roomType }) => {
    const icon = roomType === exports.RoomType.Challenge ? faFlag : faRoute;
    const location = reactRouterDom.useLocation();
    const { theme } = React.useContext(SwitchThemeContext);
    const isDarkMode = theme === 'dark';
    return (jsxRuntime.exports.jsxs(StyledNewRoomCard, { to: url, state: { pageReferrer: location.pathname }, "$isDarkMode": isDarkMode, children: [jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx(StyledImageContainer$1, { children: imageProps && jsxRuntime.exports.jsx(StyledCardImage, { alt: "Room illustration", ...imageProps }) }), jsxRuntime.exports.jsxs(StyledTitle$4, { children: [title, title && jsxRuntime.exports.jsx(TagToolTip, { icon: icon, text: roomType })] })] }), difficulty && jsxRuntime.exports.jsx(Difficulty, { difficulty: difficulty, hasIcon: true, isSmall: true })] }));
};

exports.PathType = void 0;
(function (PathType) {
    PathType["REGULAR"] = "regular";
    PathType["CLOUD"] = "cloud";
})(exports.PathType || (exports.PathType = {}));

const PathCard = ({ pathTitle, pathImage, pathCode, isAuth = false, difficulty = 'easy', children, progress = 0, showProgressBar, pathType, buttonTheme = 'default', noImgSpinner = false, hours, collaborators, ...anchorProps }) => {
    const logOutUrl = `/path/outline/${pathCode}`;
    const logInUrl = `/path-action/${pathCode}/join`;
    const hasChildren = !!children;
    return (jsxRuntime.exports.jsxs(StyledPathCard$2, { ...anchorProps, to: isAuth ? logInUrl : logOutUrl, "data-testid": "path-card", "$hasChildren": hasChildren, children: [pathType === exports.PathType.CLOUD && (jsxRuntime.exports.jsxs(StyledPaidTagWrapper$1, { children: [jsxRuntime.exports.jsx(StyledTooltipWrapper, { children: jsxRuntime.exports.jsx(Tooltip, { arrowPosition: "bottom-center", children: "This training comes at an additional cost and requires a separate payment for access." }) }), jsxRuntime.exports.jsx(StyledPaidTag, { size: "small", children: "Paid add-on" })] })), jsxRuntime.exports.jsx(StyledImageWrapper, { children: noImgSpinner ? (jsxRuntime.exports.jsx(StyledCardImageNoSpinner$1, { "$hasChildren": hasChildren, src: pathImage, alt: pathCode })) : (jsxRuntime.exports.jsx(StyledCardImage$2, { "$hasChildren": hasChildren, src: pathImage, alt: pathCode })) }), jsxRuntime.exports.jsxs(StyledCardContent$1, { "$hasChildren": hasChildren, children: [jsxRuntime.exports.jsx("h3", { children: pathTitle }), children, !hasChildren && (jsxRuntime.exports.jsx(StyledPathButton, { "$buttomTheme": buttonTheme, "data-style": "button", children: "Enroll in Path" })), (hours || difficulty) && hasChildren && (jsxRuntime.exports.jsxs(StyledStatsWrapper, { showProgressBar: showProgressBar, children: [jsxRuntime.exports.jsxs(StyledFlex, { gap: "1.6rem", justifyContent: "flex-start", children: [hours !== undefined && hours !== null && hours > 0 && (jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx(StyledClock, { icon: faClock }), jsxRuntime.exports.jsxs("span", { children: [hours, " hrs"] })] })), difficulty && jsxRuntime.exports.jsx(Difficulty, { difficulty: difficulty, hasIcon: true, isSmall: true, isDarkVersion: true })] }), collaborators && collaborators.length > 0 && (jsxRuntime.exports.jsx(CollaboratorWithTooltipGroup, { collaborators: collaborators, isDarkImg: true }))] })), showProgressBar && (jsxRuntime.exports.jsx(StyledRoomProgressbar, { children: jsxRuntime.exports.jsx(RoomProgressBar, { value: progress }) }))] })] }));
};

const StyledProgressIconWrapper = styled__default["default"].div `
  background-color: ${({ theme }) => theme.colors.background.dark};
  margin-left: auto;
  margin-right: auto;
  align-content: center;
  border-radius: 2.7rem;
  font-size: 1.2rem;
  height: 3.7rem;
  color: ${({ theme }) => theme.colors.text.main};
  z-index: 1;
`;
const StyledIconWrapper = styled__default["default"].div `
  background-color: ${({ theme, $isDarkMode }) => ($isDarkMode ? theme.colors.grey['600'] : theme.colors.grey['300'])};
  width: 3rem;
  height: 3rem;
  margin-left: auto;
  margin-right: auto;
  align-content: center;
  border-radius: 2.7rem;
  color: ${({ theme }) => theme.colors.text.main};
`;
const StyledSuccessIconWrapper = styled__default["default"](StyledIconWrapper) `
  ${({ theme }) => theme.colors.success.main};
`;
const StyledPositionIconWrapper = styled__default["default"].div `
  background-color: ${({ theme, $isDarkMode }) => ($isDarkMode ? theme.colors.grey['600'] : theme.colors.grey['300'])};
  width: 3rem;
  height: 3rem;
  margin-left: auto;
  margin-right: auto;
  align-content: center;
  border-radius: 2.7rem;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.text.main};
`;
const StyledSuccessIcon = styled__default["default"](FontAwesomeIcon) `
  width: 1.6rem;
  height: 1.6rem;
  color: ${({ theme }) => theme.colors.success.main};
  margin: auto;
`;

const ProgressIcon = ({ progress, position, isDarkMode }) => {
    const clampedProgress = Math.min(100, Math.max(0, progress || 0));
    if (clampedProgress === 100) {
        return (jsxRuntime.exports.jsx(StyledSuccessIconWrapper, { "$isDarkMode": isDarkMode, children: jsxRuntime.exports.jsx(StyledSuccessIcon, { "data-testid": "learning-guide-path-success-icon", icon: faCheck$1 }) }));
    }
    if (clampedProgress === 0) {
        return (jsxRuntime.exports.jsx(StyledPositionIconWrapper, { "$isDarkMode": isDarkMode, children: jsxRuntime.exports.jsx("span", { children: position }) }));
    }
    return (jsxRuntime.exports.jsx(StyledProgressIconWrapper, { "$isDarkMode": isDarkMode, children: jsxRuntime.exports.jsx(CircularProgress, { progressValue: Math.floor(clampedProgress), size: 37 }) }));
};

const StyledFieldSet = styled__default["default"].fieldset `
  border: none;
`;
const Horizontal = styled__default["default"].div `
  display: flex;
  gap: 1rem;
`;
const StyledLegend = styled__default["default"].legend `
  font-weight: 400;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
`;

const RadioGroup = ({ horizontal, children, errorMessage, legend }) => {
    const Wrapper = horizontal ? Horizontal : React.Fragment;
    return (jsxRuntime.exports.jsxs(StyledFieldSet, { children: [jsxRuntime.exports.jsx(StyledLegend, { children: legend }), jsxRuntime.exports.jsx(Wrapper, { children: children }), errorMessage && jsxRuntime.exports.jsx(FormErrorMessage, { children: errorMessage })] }));
};

const StyledRoomCardWrapper = styled__default["default"].div `
  border-radius: ${({ theme }) => theme.radius.small};
  background: ${({ theme }) => theme.colors.background.main};
  filter: drop-shadow(0 0.3rem 1.3rem rgba(21, 28, 43, 0.07));
  border: 0.1rem solid transparent;
  transition: border 0.3s ease-in-out;
  position: relative;

  :hover {
    border-color: ${({ theme }) => theme.colors.border.hover};
  }
`;
const StyledRoomCardWrapperAnchor = styled__default["default"](reactRouterDom.Link) `
  text-decoration: none;
`;
const StyledCheckIcon = styled__default["default"](FontAwesomeIcon) `
  color: ${({ theme }) => theme.colors.success.main};
  height: 2rem;
  align-self: flex-start;
`;
const StyledRoomCard = styled__default["default"].div `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 0.5rem;
  padding: 1.2rem;
  padding-right: 2.4rem;
`;
const StyledWrapperIcons = styled__default["default"].div `
  display: flex;
  gap: 1rem;
  position: absolute;
  right: 1.25rem;
  top: 1.25rem;
`;
const StyledCloseIcon = styled__default["default"](FontAwesomeIcon) `
  color: ${({ theme }) => theme.colors.grey[600]};
  height: 2rem;
`;
const StyledImageContainer = styled__default["default"].div `
  width: 10rem;
  height: 10rem;
`;
const StyledRoomCardImage = styled__default["default"](Image) `
  object-fit: cover;
  width: inherit;
  height: inherit;
`;
const StyledRoomDetails = styled__default["default"].div `
  margin-left: 3rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    margin-left: 1.8rem;
  }
`;
const StyledRoomCardTitle = styled__default["default"].h2 `
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: 1.8rem;
  line-height: 2.3rem;
  margin-bottom: 1rem;
`;
const StyledRoomCardDescription = styled__default["default"].div `
  color: ${({ theme }) => theme.colors.text.lighter};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: 2rem;
`;
const StyledRoomCardDescriptionTruncated = styled__default["default"](StyledRoomCardDescription) `
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    white-space: pre-wrap;
  }
`;
const StyledCardFooter = styled__default["default"].div `
  border-top: 0.1rem solid ${({ theme }) => theme.colors.border.light};
  margin: 0 1.2rem;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: baseline;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    > div:last-child {
      margin-left: auto;
    }
    flex-wrap: nowrap;
  }
`;
const StyledTags = styled__default["default"].div `
  align-items: center;
  margin: 0.6rem 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
`;
const StyledStreakNumber = styled__default["default"].span `
  color: ${({ theme }) => theme.colors.primary.main};
  margin-bottom: 1rem;
`;
const StyledStreakTagIcon = styled__default["default"](FontAwesomeIcon) `
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  color: ${({ theme }) => theme.colors.primary.main};
`;

const RoomCard = ({ additionalFooterContent, description, difficulty = 'easy', extendedDescription, handleSavedRoom, href, imageProps, isCompleted, isSavedRoom = false, tagDocs = [], title, streak, }) => (jsxRuntime.exports.jsxs(StyledRoomCardWrapper, { children: [jsxRuntime.exports.jsxs(StyledRoomCardWrapperAnchor, { ...(href ? { to: href } : { as: 'div' }), children: [jsxRuntime.exports.jsxs(StyledRoomCard, { children: [jsxRuntime.exports.jsx(StyledImageContainer, { children: imageProps && jsxRuntime.exports.jsx(StyledRoomCardImage, { ...imageProps }) }), jsxRuntime.exports.jsxs(StyledRoomDetails, { children: [jsxRuntime.exports.jsx(StyledRoomCardTitle, { children: title }), jsxRuntime.exports.jsx(StyledRoomCardDescriptionTruncated, { children: description }), jsxRuntime.exports.jsx(StyledRoomCardDescription, { children: extendedDescription })] })] }), jsxRuntime.exports.jsxs(StyledCardFooter, { children: [jsxRuntime.exports.jsxs(StyledTags, { children: [tagDocs.map((tag) => (jsxRuntime.exports.jsx(Tag, { size: "small", color: "grey", variation: 900, children: tag.label }, tag.label))), streak && (jsxRuntime.exports.jsx(Tag, { size: "small", color: "grey", variation: 900, children: jsxRuntime.exports.jsxs("span", { children: [streak.label, " ", jsxRuntime.exports.jsxs(StyledStreakNumber, { children: [" ", streak.number] }), " ", jsxRuntime.exports.jsx(StyledStreakTagIcon, { icon: faFire })] }) }, streak.label)), !!additionalFooterContent && jsxRuntime.exports.jsx(Difficulty, { difficulty: difficulty })] }), !additionalFooterContent && jsxRuntime.exports.jsx(Difficulty, { difficulty: difficulty }), additionalFooterContent] })] }), jsxRuntime.exports.jsxs(StyledWrapperIcons, { children: [isCompleted && jsxRuntime.exports.jsx(StyledCheckIcon, { icon: faCheckCircle$1 }), isSavedRoom && (jsxRuntime.exports.jsx("button", { onClick: handleSavedRoom, type: "button", children: jsxRuntime.exports.jsx(StyledCloseIcon, { icon: faXmark$1 }) }))] })] }));

const StyledRoomGridListItemLink = styled__default["default"](reactRouterDom.Link) `
  display: grid;
  grid-template-columns: 4% 10% 20%;
  align-items: center;
  width: 70rem;
  min-height: 2rem;
  background: transparent;
  text-decoration: none;
  padding: 1rem 1rem 1rem 1.3rem;
  border-radius: 0.5rem;
  transition: background-color 0.2s linear;

  :hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.background.tableRowHover};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    grid-template-columns: 4% 10% 28%;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.xs}) {
    grid-template-columns: 4% 10% 23%;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.sm}) {
    grid-template-columns: 4% 10% 45%;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 4% 10% 50%;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-template-columns: 4% 13% 1fr;
  }
`;
const StyledIcon$2 = styled__default["default"].img `
  width: 7.1rem;
  height: 7.1rem;
  margin-right: 0.5rem;
`;
const StyledContentWrapper = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  margin: 0;
`;
const StyledTitle$3 = styled__default["default"].div `
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  color: ${({ theme }) => theme.colors.text.main};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  line-height: 1.8rem;
`;
const StyledTextWrapper = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  gap: 0.6rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.sm}) {
    flex-direction: row;
  }
`;
const StyledContent$4 = styled__default["default"].div `
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.lighter};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  line-height: 2rem;
`;
const StyledTick = styled__default["default"].div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  border: 0.2rem solid;
  height: 1.5rem;
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.text.lightest};
  background: transparent;
`;
const StyledCompletion = styled__default["default"].div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primary.main};
`;
const StyledCompletionTick = styled__default["default"].span `
  width: 0.4rem;
  height: 0.6rem;
  border-bottom: 0.15rem solid ${({ theme }) => theme.colors.black};
  border-right: 0.15rem solid ${({ theme }) => theme.colors.black};
  transform: rotate(45deg);
  margin: 0.15rem 0.15rem 0.3rem 0.1rem;
`;
const StyledTagWrapper = styled__default["default"].div `
  gap: 0.6rem;
  margin: 0;

  @media screen and (min-width: ${({ theme }) => theme.sizes.xs}) {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    display: contents;
  }
`;
styled__default["default"].div `
  grid-template-columns: 6% 20% 15% 63%;
  margin-left: 26rem;
`;

const RoomGridListItem = ({ title, content, iconSrc, isFree = false, isCompleted = false, toPay = false, href, isAuth = false, }) => {
    const freeStatusIcon = isFree && !toPay;
    const paidStatusIcon = isFree && toPay;
    const vipStatusIcon = (!isFree && !toPay) || (!isFree && toPay);
    const location = reactRouterDom.useLocation();
    return (jsxRuntime.exports.jsxs(StyledRoomGridListItemLink, { to: href, state: { pageReferrer: isAuth && location.pathname }, children: [isCompleted ? (jsxRuntime.exports.jsx(StyledCompletion, { children: jsxRuntime.exports.jsx(StyledCompletionTick, { "data-testid": "completion-tick" }) })) : (jsxRuntime.exports.jsx(StyledTick, {})), jsxRuntime.exports.jsx(StyledTagWrapper, { children: jsxRuntime.exports.jsx(StyledIcon$2, { src: iconSrc, alt: title }) }), jsxRuntime.exports.jsxs(StyledContentWrapper, { children: [jsxRuntime.exports.jsxs(StyledTextWrapper, { children: [jsxRuntime.exports.jsx(StyledTitle$3, { children: title }), freeStatusIcon && (jsxRuntime.exports.jsx(Tag, { size: "small", color: "grey", variation: 900, textColor: "white", children: "Free" })), paidStatusIcon && (jsxRuntime.exports.jsx(Tag, { size: "small", color: "purple", variation: "main", textColor: "white", children: "Paid" })), vipStatusIcon && (jsxRuntime.exports.jsx(Tag, { size: "small", color: "primary", variation: "main", textColor: "white", children: "VIP" }))] }), jsxRuntime.exports.jsx(StyledContent$4, { children: content })] })] }));
};

const StyledRoomImage = styled__default["default"].figure `
  border-radius: ${({ theme }) => theme.radius.small};
  height: 2.4rem;
  width: 2.4rem;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
const StyledRoomItem$1 = styled__default["default"](reactRouterDom.Link) `
  align-items: center;
  background-color: transparent;
  border-radius: ${({ theme }) => theme.radius.small};
  display: flex;
  justify-content: space-between;
  padding: 1.2rem 0.8rem;
  text-decoration: none;
  width: 100%;
  svg {
    height: 1.6rem;
    margin-right: 0.8rem;
    width: 1.6rem;

    path {
      fill: ${({ theme }) => theme.colors.grey[700]};
    }
  }

  &:hover {
    background-color: ${({ theme, $isDarkVersion }) => $isDarkVersion ? theme.colors.secondary.lighter : theme.colors.background.greyLight};
  }

  p {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
  }

  p,
  span {
    color: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? theme.colors.white : theme.colors.text.main)};
  }

  span {
    font-size: 1.6rem;
  }

  &[data-progress='completed'] {
    svg path {
      fill: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? darkColors.success.main : theme.colors.success.main)};
    }
  }

  &[data-progress='to-complete'] {
    span {
      color: ${({ theme }) => theme.colors.grey[600]};
    }
  }
`;

const getProgressStatus = (progress) => {
    if (progress === 100)
        return 'completed';
    if (progress >= 1 && progress <= 99)
        return 'in-progress';
    return 'to-complete';
};
const progressIcons = {
    completed: faCircleCheck$1,
    'in-progress': faCircleEllipsis,
    'to-complete': faCircle$1,
};

const RoomItem = ({ progressValue, image, title, roomCode, isDarkVersion = false, pageReferrer, target, }) => {
    const progressStatus = getProgressStatus(progressValue);
    const icon = progressIcons[progressStatus];
    return (jsxRuntime.exports.jsxs(StyledRoomItem$1, { target: target, to: `/room/${roomCode}`, "data-progress": progressStatus, "data-testid": "room-item", "$isDarkVersion": isDarkVersion, state: { pageReferrer }, children: [jsxRuntime.exports.jsxs(StyledFlex, { justifyContent: "flex-start", alignItems: "center", gap: "0.8rem", children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: icon }), jsxRuntime.exports.jsx(StyledRoomImage, { children: jsxRuntime.exports.jsx(Image, { src: image, alt: "image", loading: "lazy", width: 100, height: 100 }) }), jsxRuntime.exports.jsx("p", { children: title })] }), jsxRuntime.exports.jsxs("span", { children: [progressValue, "%"] })] }));
};

const StyledRoomItem = styled__default["default"].details `
  background-color: transparent;
  border-radius: ${({ theme }) => theme.radius.small};
  text-align: start;
  padding: 1.2rem 0.8rem;
  width: 100%;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: ${({ theme, $isDarkVersion }) => $isDarkVersion ? theme.colors.secondary.lighter : theme.colors.background.greyLight};
  }

  summary {
    list-style: none;
    cursor: pointer;
    display: block;

    &::-webkit-details-marker {
      display: none;
    }

    &::marker {
      display: none;
    }
  }
`;
const MainContentWrapper = styled__default["default"].div `
  display: grid;
  gap: 1.6rem;
  grid-template-columns: 5rem 1fr auto;
  align-items: center;
`;
const StyledContent$3 = styled__default["default"].div `
  color: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? theme.colors.white : theme.colors.text.main)};

  p[data-text='title'] {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    margin-bottom: 0.5rem;
    color: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? theme.colors.white : theme.colors.text.main)};
  }
`;
const StyledArrowIcon$2 = styled__default["default"].span `
  transition: transform 0.3s ease-in-out;
  transform-origin: center;
  transform: ${({ $isItemOpen }) => ($isItemOpen ? 'rotate(-180deg)' : 'rotate(0) ')};
  padding: 0 0.8rem;
  svg {
    color: ${({ theme }) => theme.colors.grey[600]};
    width: 1.3rem;
    height: 1.9rem;
  }
`;
const StyledExtraContentWrapper = styled__default["default"].div `
  display: grid;
  grid-template-columns: 1fr 4.1rem;
  gap: 2.4rem;
  padding: 0 1.9rem 1rem;
  margin-top: 1.6rem;
  margin-left: 4.7rem;

  p {
    margin-bottom: 1rem;
    color: ${({ theme, $isDarkVersion }) => ($isDarkVersion ? theme.colors.white : theme.colors.text.main)};
  }

  span[data-type='tag'] {
    border: 1px solid
      ${({ theme, $isDarkVersion }) => ($isDarkVersion ? darkColors.border.light : theme.colors.border.light)};
  }
`;

const RoomItemV2 = ({ progressValue, image, title, roomCode, description, isDarkVersion = false, pageReferrer, difficulty, duration, techsTags, povTag, }) => {
    const [isItemOpen, setIsItemOpen] = React.useState(false);
    const handleToggle = () => {
        setIsItemOpen(!isItemOpen);
    };
    return (jsxRuntime.exports.jsxs(StyledRoomItem, { "$isDarkVersion": isDarkVersion, onToggle: handleToggle, "data-testid": "room-item", children: [jsxRuntime.exports.jsx("summary", { "data-testid": "item-main-content", children: jsxRuntime.exports.jsxs(MainContentWrapper, { children: [jsxRuntime.exports.jsx(CircularImageProgress, { progressValue: progressValue, image: image, difficulty: difficulty, size: 50, contentSizeAdjustment: 10, isDarkVersion: isDarkVersion, strokeWidth: 2, strokeProgressWidth: 2.8 }), jsxRuntime.exports.jsxs(StyledContent$3, { "$isDarkVersion": isDarkVersion, children: [jsxRuntime.exports.jsx("p", { "data-text": "title", children: title }), jsxRuntime.exports.jsxs(StyledFlex, { gap: "1.2rem", justifyContent: "flex-start", children: [difficulty && jsxRuntime.exports.jsx(Difficulty, { difficulty: difficulty, hasIcon: true, isDarkVersion: isDarkVersion }), duration && jsxRuntime.exports.jsx(Duration, { duration: duration })] })] }), jsxRuntime.exports.jsx(StyledArrowIcon$2, { "$isItemOpen": isItemOpen, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faAngleDown$1 }) })] }) }), jsxRuntime.exports.jsxs(StyledExtraContentWrapper, { "$isDarkVersion": isDarkVersion, "data-testid": "additional-content", children: [jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx("p", { children: description }), jsxRuntime.exports.jsxs(StyledFlex, { gap: "0.8rem", justifyContent: "flex-start", children: [jsxRuntime.exports.jsx(PovTag, { povTag: povTag ?? 'purple', isDarkVersion: isDarkVersion }), techsTags &&
                                        techsTags.map((tag) => (jsxRuntime.exports.jsx(Tag, { size: "small", variation: "main", color: "secondary", "data-type": "tag", children: tag }, tag)))] })] }), jsxRuntime.exports.jsx(StyledCircularLink, { to: `/room/${roomCode}`, state: { pageReferrer }, "data-testid": "room-item-link", children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCaretRight }) })] })] }));
};

const StyledSelectionBox = styled__default["default"].div `
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ gap }) => gap};

  
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 1fr;
  }
`;
const StyledSelectionBoxInput = styled__default["default"].input `
  border: 0;
  clip: rect(0, 0, 0, 0);
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  height: 0.1rem;
  margin: -0.1rem;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 0.1rem;
  &:checked {
    & + label {
      background-color: ${darkColors.background.active};
      border-color: ${({ theme, isDarkVersion }) => isDarkVersion ? darkColors.selectionBox.selectedBorder : theme.colors.selectionBox.selectedBorder};
    }
  }
`;
const StyledSelectionBoxLabel = styled__default["default"].label `
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  background: ${({ theme, isDarkVersion }) => isDarkVersion ? darkColors.background.light : theme.colors.background.light};
  color: ${({ theme, isDarkVersion }) => (isDarkVersion ? darkColors.text.main : theme.colors.text.main)};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 2rem;
  max-width: 63.6rem;
  border: solid 0.1rem ${({ theme }) => theme.colors.selectionBox.border};
  border-radius: 0.5rem;
  padding: 1rem;
  &:hover {
    border-color: ${({ theme, disabled, isDarkVersion }) => {
    if (isDarkVersion) {
        return darkColors.selectionBox.hoverBorder;
    }
    if (disabled) {
        return theme.colors.selectionBox.border;
    }
    return theme.colors.selectionBox.hoverBorder;
}};
  }
  &:focus {
    border-color: ${darkColors.info.main};
  }
`;
const StyledUserExperienceSelectionBoxLabel = styled__default["default"].label `
  position: relative;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  background: ${({ theme, disabled, isDarkVersion }) => {
    if (isDarkVersion) {
        return darkColors.background.light;
    }
    if (disabled) {
        return theme.colors.selectionBox.disabledContent;
    }
    return theme.colors.background.light;
}};
  display: flex;
  flex-direction: ${({ iconPosition }) => (iconPosition === 'left' ? 'row' : 'column')};
  gap: ${({ iconPosition }) => (iconPosition === 'left' ? '1rem' : '0')};
  align-items: center;
  color: ${({ theme, disabled, isDarkVersion }) => {
    if (isDarkVersion) {
        return darkColors.text.main;
    }
    if (disabled) {
        return theme.colors.selectionBox.disabledText;
    }
    return theme.colors.text.main;
}};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 2rem;
  width: 100%;
  height: auto;
  border: solid 0.1rem
    ${({ theme, isDarkVersion }) => (isDarkVersion ? darkColors.selectionBox.border : theme.colors.selectionBox.border)};
  border-radius: 0.5rem;
  padding: 1.8rem;
  &:hover {
    border-color: ${({ theme, disabled, isDarkVersion }) => {
    if (isDarkVersion) {
        return darkColors.text.main;
    }
    if (disabled) {
        return theme.colors.selectionBox.border;
    }
    return theme.colors.selectionBox.hoverBorder;
}};
  }
  &:focus {
    border-color: ${darkColors.info.main};
  }
  > span {
    margin-top: ${({ iconPosition }) => (iconPosition === 'left' ? '0' : '1rem')};
    text-align: ${({ iconPosition }) => (iconPosition === 'left' ? 'left' : 'center')};
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
const StyledSelectionBoxContent = styled__default["default"].span `
  color: ${({ theme, disabled, isDarkVersion }) => {
    if (isDarkVersion) {
        return darkColors.text.selectionBox;
    }
    if (disabled) {
        return theme.colors.selectionBox.disabledText;
    }
    return theme.colors.text.selectionBox;
}};
`;
const StyledFontAwesomeIcon = styled__default["default"](FontAwesomeIcon) `
  color: ${({ theme, disabled, isDarkVersion }) => {
    if (isDarkVersion) {
        return darkColors.success.toggle;
    }
    if (disabled) {
        return theme.colors.selectionBox.disabledIcon;
    }
    return theme.colors.success.toggle;
}};

  height: ${({ iconSize }) => iconSize || '2.4rem'};
`;
const StyledRadioButtonSelectionLabel = styled__default["default"](StyledSelectionBoxLabel) `
  ${({ checked }) => checked
    ? `
        background-color: ${darkColors.background.active};
        border-color: ${darkColors.success.main};
      `
    : ''};
`;
const StyledRadioSelectionBoxInput = styled__default["default"].input `
  border: 0;
  clip: rect(0, 0, 0, 0);
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  height: 0.1rem;
  margin: -0.1rem;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 0.1rem;
`;
const StyledCurrentSelectedTag = styled__default["default"].div `
  background-color: ${({ theme }) => theme.colors.primary.main};
  position: absolute;
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  text-align: center;
  top: 0;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  border-radius: 0.5rem 0.5rem 0 0;
  transform: translate(0%, -100%);
  width: 15rem;
  padding: 0.2rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  color: ${secondaryColors.black};
`;

const SelectionBox = ({ children, gap = '1.6rem', hasContent, labelledBy }) => (jsxRuntime.exports.jsx(StyledSelectionBox, { role: "group", gap: gap, hasContent: hasContent, "aria-labelledby": labelledBy, children: children }));

const SelectionBoxItem = ({ option, icon, hasContent, disabled, isDarkVersion = false, currentSelectionMessage, children, iconPosition = 'top', iconSize, ...nativeInputAttributes }) => (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(StyledSelectionBoxInput, { type: "radio", name: option.name, value: option.value, id: option.value, disabled: option.disabled, isDarkVersion: isDarkVersion, ...nativeInputAttributes }), hasContent ? (jsxRuntime.exports.jsxs(StyledUserExperienceSelectionBoxLabel, { "data-testid": `${option.value}-label`, disabled: option.disabled, htmlFor: option.value, isDarkVersion: isDarkVersion, iconPosition: iconPosition, children: [currentSelectionMessage && jsxRuntime.exports.jsx(StyledCurrentSelectedTag, { children: currentSelectionMessage }), icon && jsxRuntime.exports.jsx(StyledFontAwesomeIcon, { icon: icon, disabled: option.disabled, iconSize: iconSize }), jsxRuntime.exports.jsx("span", { children: option.label }), option.content && (jsxRuntime.exports.jsx(StyledSelectionBoxContent, { disabled: option.disabled, isDarkVersion: isDarkVersion, "data-testid": `${option.value}-content`, children: option.content }))] })) : (jsxRuntime.exports.jsx(StyledSelectionBoxLabel, { disabled: option.disabled, htmlFor: option.value, isDarkVersion: isDarkVersion, "data-testid": `${option.value}-box-label`, children: children }))] }));

const RadioButtonSelectionBoxItem = ({ option, icon, hasContent, disabled, placeholder, isFreeText = false, onChange, currentOption, onChangeInput, isError, checked, ...nativeInputAttributes }) => (jsxRuntime.exports.jsxs(StyledRadioButtonSelectionLabel, { disabled: option.disabled, htmlFor: option.value, "data-testid": `${option.label ?? ''}-box-label`, checked: option.value === currentOption, children: [jsxRuntime.exports.jsx(StyledRadioSelectionBoxInput, { type: "radio", name: option.name, value: option.value, id: option.value, disabled: option.disabled, checked: option.value === currentOption, onChange: onChange, ...nativeInputAttributes }), jsxRuntime.exports.jsx(FormRadio, { "data-testid": `${option.label ?? ''}-radio`, label: option.label ?? '', value: option.value, onChange: onChange, placeholder: placeholder, isFreeText: isFreeText, checked: option.value === currentOption, onChangeInput: onChangeInput, isError: isError }, option.label)] }));

const StyledSeriesGridListItemWrapper = styled__default["default"].div `
  display: flex;
  gap: 2.4rem;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  width: 100%;
  flex-direction: column;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: row;
  }
`;
const StyledSeriesGridListItemContent = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  padding-top: 0.5rem;

  > button {
    width: fit-content;
  }
`;
const StyledTitleAndDifficultyWrapper = styled__default["default"].div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
`;
const StyledTitle$2 = styled__default["default"].div `
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  color: ${({ theme }) => theme.colors.text.main};
`;
const StyledIcon$1 = styled__default["default"].img `
  width: 15rem;
  height: 15rem;
`;
const StyledContent$2 = styled__default["default"].div `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.lighter};
  margin-top: 1rem;
  flex: 1;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  max-height: 8rem;
  margin-bottom: 1.6rem;
`;
const StyledButton$1 = styled__default["default"](Button$1) `
  @media screen and (min-width: ${({ theme }) => theme.sizes.xs}) {
    && {
      width: auto;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    && {
      width: fit-content;
    }
  }
`;

const SeriesGridListItem = ({ title, content, difficulty, icon, onClick }) => (jsxRuntime.exports.jsxs(StyledSeriesGridListItemWrapper, { children: [jsxRuntime.exports.jsx(StyledIcon$1, { src: icon, alt: title }), jsxRuntime.exports.jsxs(StyledSeriesGridListItemContent, { children: [jsxRuntime.exports.jsxs(StyledTitleAndDifficultyWrapper, { children: [jsxRuntime.exports.jsx(StyledTitle$2, { children: title }), jsxRuntime.exports.jsx(Difficulty, { difficulty: difficulty, hasIcon: true, isSmall: true })] }), jsxRuntime.exports.jsx(StyledContent$2, { children: content }), jsxRuntime.exports.jsx(StyledButton$1, { onClick: onClick, variant: "solid", type: "submit", color: "add", children: "Enroll" })] })] }));

const StyledSlidingPane = styled__default["default"].div `
  ${StyledDialogOver};
  ${StyledDialogAnimation};
  align-items: stretch;
  justify-content: end;
  z-index: 9999;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    align-items: flex-end;
    justify-content: center;
  }
`;
const StyledContent$1 = styled__default["default"].div `
  background: ${({ theme }) => theme.colors.secondary.light};
  padding: 2.4rem;
  width: 50rem;
  overflow-y: auto;
  transition: all 0.3s ease;
  transform-origin: translateX(500px);
  animation: slideIn 0.4s linear;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    width: 40rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    animation: none;
    height: auto;
    max-height: calc(100vh - 4.6rem);
    padding: 0 1.5rem 1.5rem;
    transform-origin: translateX(0);
    width: 100%;
  }

  @keyframes slideIn {
    from {
      transform: translateX(500px);
    }
    to {
      transform: translateX(0);
    }
  }
`;
const StyledArrowButtonContainer = styled__default["default"].div `
  padding-top: 0.6rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    position: sticky;
    top: 0;
    width: 100%;
    background: ${({ theme }) => theme.colors.secondary.light};
    z-index: 2;
  }
`;
const StyledArrowButton = styled__default["default"].button `
  display: none;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.secondary.lighter};
    display: grid;
    margin-bottom: 4.6rem;
    padding: 0.6rem 0;
    place-items: center;
    width: 100%;
  }
`;
const StyledArrow = styled__default["default"](FontAwesomeIcon) `
  display: none;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: block;
    font-size: 2.4rem;

    path {
      fill: ${({ theme }) => theme.colors.grey[100]};
    }
  }
`;

const SlidingPane = ({ isSlidingPaneOpen, setIsSlidingPaneOpen, children, onClose }) => {
    const paneRef = React.useRef(null);
    const handleCloseSlidePane = React.useCallback(() => {
        if (onClose)
            onClose();
        setIsSlidingPaneOpen(false);
    }, [onClose, setIsSlidingPaneOpen]);
    useOnClickOutside({ ref: paneRef, handler: handleCloseSlidePane });
    React.useEffect(() => {
        const closeOnEscapeKey = (e) => (e.key === 'Escape' ? handleCloseSlidePane() : null);
        document.body.addEventListener('keydown', closeOnEscapeKey);
        return () => {
            document.body.removeEventListener('keydown', closeOnEscapeKey);
        };
    }, [handleCloseSlidePane]);
    React.useEffect(() => {
        if (isSlidingPaneOpen) {
            document.body.classList.add('no-scroll');
        }
        else {
            document.body.classList.remove('no-scroll');
        }
        return () => {
            document.body.classList.remove('no-scroll');
        };
    }, [isSlidingPaneOpen]);
    if (!isSlidingPaneOpen)
        return null;
    return (jsxRuntime.exports.jsx("div", { children: isSlidingPaneOpen &&
            $7SXl2$reactdom.createPortal(jsxRuntime.exports.jsx(StyledSlidingPane, { role: "dialog", children: jsxRuntime.exports.jsxs(StyledContent$1, { ref: paneRef, children: [jsxRuntime.exports.jsx(StyledArrowButtonContainer, { children: jsxRuntime.exports.jsx(StyledArrowButton, { onClick: handleCloseSlidePane, children: jsxRuntime.exports.jsx(StyledArrow, { icon: faAngleDown }) }) }), children] }) }), document.body) }));
};

const StyledStepHeader = styled__default["default"].span `
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  margin-bottom: 0.8rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 2.4rem;
  display: block;
`;

const StepHeader = ({ currentStep, totalSteps }) => {
    return (jsxRuntime.exports.jsxs(StyledStepHeader, { children: ["Step ", currentStep, " of ", totalSteps] }));
};

const StyledArrowIcon$1 = styled__default["default"](FontAwesomeIcon) `
  width: 2.1rem;
  height: auto;

  path {
    fill: ${({ theme, $isDisabled }) => ($isDisabled ? theme.colors.grey[800] : theme.colors.text.main)};
    transition: all 0.2s ease-in-out;
  }

  &:hover path {
    fill: ${({ theme, $isDisabled }) => ($isDisabled ? theme.colors.grey[800] : theme.colors.info.main)};
  }
`;
const StyledTimelineContainer = styled__default["default"].div `
  ${StyledTimelineContainerCommons}
  gap: 1.6rem;
  height: 68rem;
  margin-block: 1.2rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    height: 20.9rem;
  }
`;
const StyledTimelineItemWrapper = styled__default["default"].div `
  ${StyledFlexColumnCenter};
  gap: 2.2rem;
`;
const StyledTimelineItem = styled__default["default"].div `
  ${StyledFlexColumnCenter};
  cursor: pointer;
  position: relative;
  margin-top: 3rem;
  margin-bottom: ${({ isLastChild }) => (isLastChild ? '2rem' : '0')};
`;
const StyledItemImageWrapper = styled__default["default"](StyledImageWrapper$3) `
  border: none;
  background-color: ${({ theme }) => theme.colors.secondary.light};
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
const StyledItemTitle = styled__default["default"].div `
  border-radius: 100%;
  background-color: ${({ theme }) => theme.colors.secondary.light};
  color: ${({ theme }) => theme.colors.white};
  height: ${({ isSelected }) => (isSelected ? '5rem' : '3.8rem')};
  width: ${({ isSelected }) => (isSelected ? '5rem' : '3.8rem')};
  display: grid;
  place-items: center;
  position: absolute;
  top: ${({ isSelected }) => (isSelected ? '-2rem' : '-1.5rem')};

  box-shadow: ${({ isSelected, theme }) => `${isSelected ? '0 0 0 0.9rem' : '0 0 0 0.6rem'} ${theme.colors.background.secondary}`};
  p {
    font-size: ${({ isSelected, theme }) => (isSelected ? '2rem' : theme.fonts.sizes.default)};
    font-weight: ${({ theme }) => theme.fonts.weight.bolder};
    font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  }
`;
const StyledVerticalLine = styled__default["default"].div `
  width: 0.2rem;
  height: 7rem;
  background-color: ${({ theme }) => theme.colors.border.light};
`;

const TimelineV2 = ({ timelineData, onChange }) => {
    const containerRef = React.useRef(null);
    const { selectedItemIndex, handleOnElementClick, handleNavigationButtonClick } = useTimeline({
        timelineData,
        containerRef,
        onChange,
    });
    return (jsxRuntime.exports.jsxs(StyledWrapper$6, { children: [jsxRuntime.exports.jsx("button", { type: "button", onClick: () => handleNavigationButtonClick(-1), "aria-label": "Previous", disabled: selectedItemIndex === 0, children: jsxRuntime.exports.jsx(StyledArrowIcon$1, { icon: faArrowUp, "$isDisabled": selectedItemIndex === 0 }) }), jsxRuntime.exports.jsx(StyledTimelineContainer, { ref: containerRef, children: timelineData.map(({ image, title }, index) => (jsxRuntime.exports.jsxs(StyledTimelineItemWrapper, { children: [jsxRuntime.exports.jsxs(StyledTimelineItem, { onClick: () => handleOnElementClick(index), isLastChild: index === timelineData.length - 1, children: [jsxRuntime.exports.jsx(StyledItemTitle, { isSelected: index === selectedItemIndex, children: jsxRuntime.exports.jsx("p", { children: title }) }), jsxRuntime.exports.jsx(StyledItemImageWrapper, { isSelected: index === selectedItemIndex, children: jsxRuntime.exports.jsx(Image, { src: image, alt: title }) })] }), index !== timelineData.length - 1 && jsxRuntime.exports.jsx(StyledVerticalLine, {})] }, title))) }), jsxRuntime.exports.jsx("button", { type: "button", onClick: () => handleNavigationButtonClick(1), "aria-label": "Next", disabled: selectedItemIndex === timelineData.length - 1, children: jsxRuntime.exports.jsx(StyledArrowIcon$1, { icon: faArrowDown, "$isDisabled": selectedItemIndex === timelineData.length - 1 }) })] }));
};

const StyledLoadingTitle = styled__default["default"].div `
  width: 100%;
  display: flex;
  align-items: ${({ isLeftAlign }) => (isLeftAlign ? 'flex-start' : 'center')};
  flex-direction: column;
`;
const StyledLoadLine = styled__default["default"].span `
  ${StyledLoadingPlaceholder}
  height: 3.9rem;
  width: ${({ width }) => width ?? '50%'};
  margin-bottom: 1.7rem;
  display: block;

  &[data-title='title'] {
    &:after {
      content: '';
      display: block;
      margin: ${({ isLeftAlign }) => !isLeftAlign && '0 auto'};
      width: 15rem;
      padding-top: 5.8rem;
      border-bottom: ${({ theme }) => `0.4rem solid ${theme.colors.primary.main}`};
    }
  }

  &[data-title='subtitle'] {
    margin-bottom: 0;
    margin-top: 2rem;
  }
`;

const Loading$3 = ({ isLeftAlign, hasSubtitle }) => (jsxRuntime.exports.jsxs(StyledLoadingTitle, { isLeftAlign: isLeftAlign, children: [jsxRuntime.exports.jsx(StyledLoadLine, { width: "75%", isLeftAlign: isLeftAlign }), jsxRuntime.exports.jsx(StyledLoadLine, { width: "55%", isLeftAlign: isLeftAlign, "data-title": "title" }), hasSubtitle && jsxRuntime.exports.jsx(StyledLoadLine, { width: "70%", isLeftAlign: isLeftAlign, "data-title": "subtitle" })] }));

const StyledTitle$1 = styled__default["default"].div `
  text-align: ${({ isLeftAlign }) => (isLeftAlign ? 'left' : 'center')};
  color: ${({ theme, $isNewNavEnabled }) => ($isNewNavEnabled ? '#151C2B' : theme.colors.text.main)};
  font-size: ${({ theme }) => theme.fonts.sizes.dashboardTitle};

  h1,
  h2 {
    color: ${({ theme, isInBanner }) => (isInBanner ? theme.colors.grey['100'] : theme.colors.text.main)};

    &:after {
      content: '';
      display: ${({ $isNewNavEnabled }) => ($isNewNavEnabled ? 'none' : 'block')};
      margin: ${({ isLeftAlign }) => !isLeftAlign && '0 auto'};
      width: 15rem;
      padding-top: 2rem;
      border-bottom: ${({ theme }) => `0.4rem solid ${theme.colors.primary.main}`};
    }
  }

  h2 {
    &:after {
      padding-top: 1.6rem;
    }
  }

  p {
    color: ${({ theme, isInBanner }) => (isInBanner ? theme.colors.grey['200'] : theme.colors.paragraph)};
    margin: 0;
    font-size: 2rem;
    line-height: 3rem;

    @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
      font-size: 2.4rem;
      line-height: 3.5rem;
    }
  }

  span {
    display: block;
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.info.main};

    &:hover {
      text-decoration: underline;
    }
  }
`;
const StyledIcon = styled__default["default"](FontAwesomeIcon) `
  color: ${({ theme }) => theme.colors.success.main};
  font-size: 2rem;
  margin-right: 0.8rem;
`;

const Title = ({ titleText, subTitleText, titleTextSecondLine, subTitleTextSecondLine, isInBanner = false, isLeftAlign = false, isTitleSmall = false, isLoading = false, isNewNavEnabled = false, }) => {
    const [hasSubtitle] = React.useState(subTitleText !== undefined);
    return (jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, { children: isLoading ? (jsxRuntime.exports.jsx(Loading$3, { isLeftAlign: isLeftAlign, hasSubtitle: hasSubtitle })) : (jsxRuntime.exports.jsxs(StyledTitle$1, { "$isNewNavEnabled": isNewNavEnabled, isInBanner: isInBanner, isLeftAlign: isLeftAlign, children: [isTitleSmall ? (jsxRuntime.exports.jsxs("h2", { children: [isNewNavEnabled && jsxRuntime.exports.jsx(StyledIcon, { icon: faTerminal }), titleText, titleTextSecondLine && jsxRuntime.exports.jsx("span", { children: titleTextSecondLine })] })) : (jsxRuntime.exports.jsxs("h1", { children: [isNewNavEnabled && jsxRuntime.exports.jsx(StyledIcon, { icon: faTerminal }), titleText, titleTextSecondLine && jsxRuntime.exports.jsx("span", { children: titleTextSecondLine })] })), subTitleText && (jsxRuntime.exports.jsxs("p", { children: [subTitleText, subTitleTextSecondLine && jsxRuntime.exports.jsx("span", { children: subTitleTextSecondLine })] }))] })) }));
};

const StyledWrapper$2 = styled__default["default"].div `
  align-items: center;
  display: inline-flex;
  gap: 2.6rem;
`;
const StyledUploadInput$1 = styled__default["default"].div `
  border: 1px solid ${({ theme }) => theme.colors.primary.main};
  border-radius: ${({ theme }) => theme.radius.small};
  color: ${({ theme }) => theme.colors.text.main};
  cursor: pointer;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  height: 3.6rem;
  position: relative;
  width: 16rem;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.primary.lighter};
    color: ${({ theme }) => theme.colors.text.main};
  }

  input[type='file'] {
    appearance: none;
    background-color: transparent;
    color: transparent;
    cursor: pointer;
    height: inherit;
    opacity: 0;
    position: absolute;
    width: inherit;
    z-index: 1;
  }
`;
const StyledUploadContent$1 = styled__default["default"].span `
  align-items: center;
  display: flex;
  cursor: pointer;
  gap: 0.5rem;
  height: inherit;
  justify-content: center;
  padding: 0 1.6rem;

  svg {
    fill: ${({ theme }) => theme.colors.text.main};
    height: 1.2rem;
    width: auto;
  }
`;
const StyledInfoImage = styled__default["default"].small `
  color: ${({ theme }) => theme.colors.text.lightest};
  display: block;
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  margin-top: ${({ isError }) => (isError ? '0.5rem' : '1rem')};
`;

const UploadAvatar = ({ file, setFile, isError, inputId = 'upload-avatar', errorMessage = 'Your image size is too large, keep it under 2mb.', ...nativeInputAttributes }) => {
    const changeHandler = (e) => {
        const target = e.target;
        if (!target.files || !target.files[0])
            return;
        setFile(target.files[0]);
    };
    const isAFileObject = file instanceof File;
    return (jsxRuntime.exports.jsxs(StyledWrapper$2, { "data-testid": "upload-avatar-image", children: [jsxRuntime.exports.jsx("label", { htmlFor: inputId, children: jsxRuntime.exports.jsx(Avatar, { avatarSrc: isAFileObject ? URL.createObjectURL(file) : file, size: "9rem", mobileSize: "9rem" }) }), jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsxs(StyledUploadInput$1, { children: [jsxRuntime.exports.jsx("input", { "data-testid": "upload-input", type: "file", id: inputId, accept: ".png, .jpeg, .jpg, .gif", onChange: changeHandler, ...nativeInputAttributes }), jsxRuntime.exports.jsxs(StyledUploadContent$1, { children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faUpload }), "Upload Avatar"] })] }), isError && jsxRuntime.exports.jsx(FormErrorMessage, { children: errorMessage }), jsxRuntime.exports.jsx(StyledInfoImage, { isError: isError, children: "Max size 2MB. Formats: JPG, PNG." })] })] }));
};

const StyledWrapper$1 = styled__default["default"].div `
  align-items: center;
  display: inline-flex;
  gap: 2.6rem;
`;
const StyledImagePreview = styled__default["default"].div `
  width: ${({ $imagePreviewSize }) => $imagePreviewSize};
  height: ${({ $imagePreviewSize }) => $imagePreviewSize};
  border-radius: ${({ theme }) => theme.radius.small};
  overflow: hidden;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: ${({ $mobileImagePreviewSize }) => $mobileImagePreviewSize};
    height: ${({ $mobileImagePreviewSize }) => $mobileImagePreviewSize};
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
const StyledUploadInput = styled__default["default"].div `
  border: 1px solid ${({ theme }) => theme.colors.primary.main};
  border-radius: ${({ theme }) => theme.radius.small};
  color: ${({ theme }) => theme.colors.text.main};
  cursor: pointer;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  height: 3.6rem;
  position: relative;
  width: 16rem;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.primary.lighter};
    color: ${({ theme }) => theme.colors.text.main};
  }

  input[type='file'] {
    appearance: none;
    background-color: transparent;
    color: transparent;
    cursor: pointer;
    height: inherit;
    opacity: 0;
    position: absolute;
    width: inherit;
    z-index: 1;
  }
`;
const StyledUploadContent = styled__default["default"].span `
  align-items: center;
  display: flex;
  cursor: pointer;
  gap: 0.5rem;
  height: inherit;
  justify-content: center;
  padding: 0 1.6rem;

  svg {
    fill: ${({ theme }) => theme.colors.text.main};
    height: 1.2rem;
    width: auto;
  }
`;
const StyledInfoText = styled__default["default"].small `
  color: ${({ theme }) => theme.colors.text.lightest};
  display: block;
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  margin-top: ${({ isError }) => (isError ? '0.5rem' : '1rem')};
`;
const StyledContent = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const UploadImage = ({ file, setFile, isError, inputId = 'upload-image', errorMessage = 'Your image size is too large, keep it under 2mb.', label, infoText, buttonText = 'Upload Image', acceptedFormats = 'JPG, PNG', maxSizeMB = 2, imagePreviewSize = '9rem', mobileImagePreviewSize = '9rem', accept = '.png, .jpeg, .jpg', ...nativeInputAttributes }) => {
    const changeHandler = (e) => {
        const target = e.target;
        if (target.files && target.files.length > 0 && target.files[0]) {
            setFile(target.files[0]);
        }
    };
    const isAFileObject = file instanceof File;
    const imageUrl = isAFileObject ? URL.createObjectURL(file) : file;
    return (jsxRuntime.exports.jsxs("div", { "data-testid": "upload-image", children: [label && jsxRuntime.exports.jsx(FormLabel, { children: label }), jsxRuntime.exports.jsxs(StyledWrapper$1, { children: [imageUrl && (jsxRuntime.exports.jsx("label", { htmlFor: inputId, children: jsxRuntime.exports.jsx(StyledImagePreview, { "$imagePreviewSize": imagePreviewSize, "$mobileImagePreviewSize": mobileImagePreviewSize, children: jsxRuntime.exports.jsx("img", { src: imageUrl, alt: "Upload preview" }) }) })), jsxRuntime.exports.jsxs(StyledContent, { children: [jsxRuntime.exports.jsxs(StyledUploadInput, { children: [jsxRuntime.exports.jsx("input", { "data-testid": "upload-input", type: "file", id: inputId, accept: accept, onChange: changeHandler, ...nativeInputAttributes }), jsxRuntime.exports.jsxs(StyledUploadContent, { children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faUpload }), buttonText] })] }), isError && jsxRuntime.exports.jsx(FormErrorMessage, { children: errorMessage }), jsxRuntime.exports.jsx(StyledInfoText, { isError: isError, children: infoText || `Max size ${maxSizeMB}MB. Formats: ${acceptedFormats}.` })] })] })] }));
};

const StyledEmptySymbolContainer = styled__default["default"].span `
  height: ${({ theme }) => theme.fonts.sizes.tiny};
  width: ${({ theme }) => theme.fonts.sizes.tiny};
  text-align: center;
`;
const StyledValidationRow = styled__default["default"].p `
  display: flex;
  font-size: ${({ theme, isTiny }) => (isTiny ? theme.fonts.sizes.tiny : theme.fonts.sizes.small)};
  line-height: ${({ isTiny }) => (isTiny ? '1.2rem' : '1.5rem')};
  color: ${({ theme }) => theme.colors.text.lighter};

  & > :first-child {
    flex-shrink: 0;
    margin-top: 0.1rem;
    margin-right: 0.4rem;
  }

  & > svg {
    height: ${({ theme }) => theme.fonts.sizes.tiny};
    width: auto;
  }
`;

const ValidationRow = ({ message, isEmpty, isLoading, isValid, isTiny = false }) => {
    const theme = styled.useTheme();
    const renderIcon = () => {
        if (isEmpty) {
            return jsxRuntime.exports.jsx(StyledEmptySymbolContainer, { children: "\u2022" });
        }
        if (isLoading) {
            return jsxRuntime.exports.jsx(StyledSpinner$1, { color: theme.colors.text.lighter, size: theme.fonts.sizes.tiny, title: "Loading" });
        }
        if (isValid) {
            return jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCircleCheck$1, style: { color: theme.colors.success.main }, title: "Valid" });
        }
        return jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCircleExclamation, style: { color: theme.colors.error.main }, title: "Invalid" });
    };
    return (jsxRuntime.exports.jsxs(StyledValidationRow, { isTiny: isTiny, children: [renderIcon(), message] }));
};

const StyledValidationListWrapper = styled__default["default"].div `
  & > p {
    margin-bottom: 0.6rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const ValidationList = ({ validationStates, isTiny = false }) => (jsxRuntime.exports.jsx(StyledValidationListWrapper, { "data-testid": "validation-list", children: validationStates.map((validationState) => (jsxRuntime.exports.jsx(ValidationRow, { ...validationState, isTiny: isTiny }, validationState.message))) }));

styled__default["default"].div `
  ${StyledLoadingPlaceholder};
`;
const StyledCard = styled__default["default"](StyledBox) `
  align-items: start;
  align-content: space-between;
  display: grid;
  gap: 4rem;
  height: 23.4rem;
  grid-template-columns: 1fr auto;
  grid-template-rows: 1fr 1fr;
  justify-content: space-between;
  padding: 2.4rem;
  width: 100%;
  ${({ theme, isHighlighted }) => (isHighlighted ? `border: 1px solid ${theme.colors.success.toggle};` : '')}
  ${({ theme, isHighlighted }) => (isHighlighted ? `background-color: ${theme.colors.success.lighter};` : '')}
  p,
  span,
  small {
    color: ${({ theme }) => theme.colors.text.main};
  }
`;
const StyledPosition = styled__default["default"].p `
  justify-self: end;
  color: ${({ theme }) => theme.colors.text.main};
  font-size: 2.4rem;
`;
const StyledInfoWrapper = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  align-self: end;
  justify-self: start;
  gap: 0.4rem;

  small {
    font-size: 1.4rem;
  }

  span[data-text='rank'] {
    font-size: 1.8rem;
  }
   span[data-text='rank-inline'] {
    font-weight: ${({ theme }) => theme.fonts.weight.bolder};
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    color: #9CA4B4;
  }
  span[data-text='streak'] {
    display: inline-flex;
    align-items: center;
    gap: 0.2rem;
    color: #FF8D00;
    font-size: ${({ theme }) => theme.fonts.sizes.default};
  }
  p[data-text='points'] {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    margin-top: -0.2rem;
  }

  &:last-of-type {
    justify-self: end;
    text-align: right;

    small {
      display: block;
      text-align: right;
    }
  }
`;
const StyledUserName$2 = styled__default["default"](reactRouterDom.Link) `
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  line-height: unset;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  display: inline;
  margin-right: 0.4rem;
  font-size: 1.6rem;

  &:hover {
    text-decoration: underline;
  }
`;

const WeeklyLeaguesCard = ({ userName, avatar, rank, points, rankTitle, isHighlighted, streak, streakIcon, }) => {
    return (jsxRuntime.exports.jsxs(StyledCard, { isHighlighted: isHighlighted, children: [jsxRuntime.exports.jsx(AvatarWithIcon, { userName: userName, avatar: avatar, isTop3: true, size: "6.6rem" }), jsxRuntime.exports.jsx(StyledPosition, { children: rank }), jsxRuntime.exports.jsxs(StyledInfoWrapper, { children: [jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx(StyledUserName$2, { to: `/p/${userName}`, target: "_blank", children: userName }), jsxRuntime.exports.jsx("span", { "data-text": "rank-inline", children: rankTitle })] }), streak && streak >= 3 && (jsxRuntime.exports.jsxs("span", { "data-text": "streak", children: [streakIcon, " ", streak, "+ Day Streak"] }))] }), jsxRuntime.exports.jsxs(StyledInfoWrapper, { children: [jsxRuntime.exports.jsx("small", { children: "Points" }), jsxRuntime.exports.jsx("p", { "data-text": "points", children: points })] })] }));
};

const AdminDropdown = ({ adminLinks, onOpenChange, }) => (jsxRuntime.exports.jsx(DropdownMenu, { type: "main", sideOffset: 20, alignContent: "end", usePortal: false, onOpenChange: onOpenChange, triggerBtn: jsxRuntime.exports.jsx(StyledItemButton, { "aria-label": "Open Admin dropdown", children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faToolbox }) }), children: adminLinks.map((link) => link.visible && (jsxRuntime.exports.jsx(DropdownMenuItemAsLink, { href: link.href, children: jsxRuntime.exports.jsx(DropdownMenuItemContent, { icon: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: link.icon }), title: link.title }) }, link.title))) }));

const avatarDropdownMenuItemCategories = [
    {
        items: [
            {
                name: 'View Profile',
                href: '/p/[username]',
                icon: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCircleUser }),
            },
            {
                name: 'Manage Account',
                href: '/profile',
                icon: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faGear }),
            },
        ],
    },
    {
        items: [
            {
                name: 'Badges',
                href: '/badges',
                icon: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faAward }),
            },
            {
                name: 'My Rooms',
                href: '/rooms',
                icon: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faDoorClosed$1 }),
            },
            {
                name: 'Access',
                href: '/access',
                icon: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faKey }),
            },
            {
                name: 'Give Feedback',
                href: '/feedback',
                icon: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faMessageSmile }),
            },
        ],
    },
    {
        items: [
            {
                name: 'Log Out',
                href: '/logout',
                icon: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faArrowRightToBracket }),
            },
        ],
    },
];

styled__default["default"](StyledFlex) `
  display: inline-block;
  width: 100%;
`;
const StyledDropdownMenuToggleItem = styled__default["default"].div `
  display: flex;
  border-radius: ${({ theme }) => theme.radius.small};
  color: ${({ theme }) => theme.colors.text.main};
  text-decoration: none;
  align-items: center;
`;
const StyledFormToggle = styled__default["default"](FormToggle) `
    width: 3.2rem;
    height: 1.8rem;

    ${StyledSwitchThumb} {
      width: 1.2rem;
      height: 1.2rem;

      &[data-state='checked'] {
        transform: translateX(1.1rem);
      }
    }
`;

const shouldShowSeparator = (items, index) => {
    if (!items || !Array.isArray(items))
        return false;
    if (index < 0 || index >= items.length)
        return false;
    const currentSection = items[index];
    if (!currentSection?.items?.length)
        return false;
    const hasNextNonEmptySection = items.slice(index + 1).some((section) => section?.items && section.items.length > 0);
    return hasNextNonEmptySection;
};
const AvatarDropdown = ({ avatar, isPremium, avatarDropDownMenuItems, soundEffectsEnabled = true, onSoundEffectsChange, echoEnabled = true, onEchoChange, onOpenChange, }) => {
    const { theme, setTheme } = React.useContext(SwitchThemeContext);
    const [openSubMenu, setOpenSubMenu] = React.useState(null);
    const isDarkMode = theme === 'dark';
    return (jsxRuntime.exports.jsx(DropdownMenu, { sideOffset: 2, type: "avatar", alignContent: "end", onOpenChange: onOpenChange, triggerBtn: jsxRuntime.exports.jsx(StyledAvatarButtonWrapper, { "aria-label": "Toggle avatar dropdown", children: jsxRuntime.exports.jsx(Avatar, { avatarSrc: avatar, size: "56px" }) }), children: React.Children.toArray(avatarDropDownMenuItems?.map((category, itemIndex) => (jsxRuntime.exports.jsxs(React.Fragment, { children: [category.items.map((item) => {
                    let menuItemContent;
                    switch (item.id || item.name) {
                        case 'dark-mode':
                        case 'Dark Mode':
                            menuItemContent = (jsxRuntime.exports.jsxs(StyledDropdownMenuToggleItem, { children: [jsxRuntime.exports.jsx(DropdownMenuItemContent, { icon: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faMoon }), title: "Dark Mode", type: "avatar", isLinkOpenedInNewTab: item.isLinkOpenedInNewTab }), jsxRuntime.exports.jsx(StyledFormToggle, { "aria-label": "Toggle dark mode", checked: isDarkMode, onCheckedChange: (checked) => setTheme && setTheme(checked ? 'dark' : 'light') })] }, item.name));
                            break;
                        case 'sound-effects':
                            menuItemContent = (jsxRuntime.exports.jsxs(StyledDropdownMenuToggleItem, { children: [jsxRuntime.exports.jsx(DropdownMenuItemContent, { icon: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faVolumeHigh }), title: "Sound Effects", type: "avatar", isLinkOpenedInNewTab: item.isLinkOpenedInNewTab }), jsxRuntime.exports.jsx(StyledFormToggle, { "aria-label": "Toggle sound effects", checked: soundEffectsEnabled, onCheckedChange: (checked) => onSoundEffectsChange && onSoundEffectsChange(checked) })] }, item.name));
                            break;
                        case 'echo':
                            menuItemContent = (jsxRuntime.exports.jsxs(StyledDropdownMenuToggleItem, { children: [jsxRuntime.exports.jsx(DropdownMenuItemContent, { icon: item.icon, title: "Echo", type: "avatar", isLinkOpenedInNewTab: item.isLinkOpenedInNewTab }), jsxRuntime.exports.jsx(StyledFormToggle, { "aria-label": "Toggle echo", checked: echoEnabled, onCheckedChange: (checked) => {
                                            if (onEchoChange) {
                                                onEchoChange(checked, checked ? '' : undefined);
                                            }
                                        } })] }, item.name));
                            break;
                        default:
                            menuItemContent = (jsxRuntime.exports.jsx(DropdownMenuItemContent, { icon: item.icon, title: item.name, type: "avatar", urgencyIndicator: item.urgencyIndicator, isLinkOpenedInNewTab: item.isLinkOpenedInNewTab }, item.name));
                            break;
                    }
                    const isToggleItem = ['dark-mode', 'Dark Mode', 'sound-effects', 'echo'].includes(item.id || item.name);
                    if (isToggleItem) {
                        return menuItemContent;
                    }
                    if (item.subMenuItems && item.subMenuItems.length > 0) {
                        return (jsxRuntime.exports.jsx(DropdownSubMenuItemAsLink, { href: item.href || '#', openSubMenu: openSubMenu, onOpenChange: setOpenSubMenu, subMenuItems: item.subMenuItems, children: menuItemContent }, item.name));
                    }
                    return item.href ? (jsxRuntime.exports.jsx(DropdownMenuItemAsLink, { href: item.href, isLinkOpenedInNewTab: item.isLinkOpenedInNewTab, children: menuItemContent }, item.name)) : (jsxRuntime.exports.jsx(DropdownMenuItem, { onSelect: () => setTheme && setTheme(isDarkMode ? 'light' : 'dark'), shouldCloseOnSelect: item.id !== 'dark-mode' && item.id !== 'sound-effects' && item.id !== 'echo', children: menuItemContent }, item.name));
                }), !isPremium && itemIndex === avatarDropdownMenuItemCategories.length - 1 && (jsxRuntime.exports.jsx(DropdownMenuItemAsLinkGoPremiumCTA, { href: "/why-subscribe", children: jsxRuntime.exports.jsx(StyledButton$3, { "data-premium": true, size: "default", variant: "solid", color: "primary", as: "div", id: "cta-header-go-premium", children: "Go Premium" }) })), shouldShowSeparator(avatarDropDownMenuItems, itemIndex) && jsxRuntime.exports.jsx(DropdownMenuSeparator, {})] }, category.items[0]?.name || `category-${itemIndex}`)))) }));
};

const Header$1 = ({ isAuth, avatar, avatarDropDownMenuItems, streak, onStreakRepair, onStreakShare, notifications, navItems = [], isPremium = false, isPaused = false, clearNotifications, unreadNotificationsCount, onNotificationsOpen, adminLinks, accessMachineButton, handlerAccessMachine, isNavItemActive, onClickSignup, isExtendedSearchEnabled = false, searchLink, searchResults, isSearchResultsPopUpOpen, setIsSearchResultsPopUpOpen, splitScreenMode = false, isTransparent = false, isSticky = true, isChristmas = false, source, languageSelector, soundEffectsEnabled, onSoundEffectsChange, echoEnabled, onEchoChange, isFullWidth, isStreakShareEnabled, requestingUser, onLike, onUnlike, onHover, onReactionHover, enableReactionsTooltip, renderSelfLikeEasterEgg, handleBookDemo, isShowBookDemoCta, handleGoBusiness, onLogoHoverChange, }) => {
    const [isMobileNavOpen, setIsMobileNavOpen] = React.useState(false);
    const searchPopUpRef = React.useRef(null);
    const location = reactRouterDom.useLocation();
    const { width } = useViewport();
    const searchPopUpResultsRef = React.useRef(null);
    const isDecember = new Date().getMonth();
    const handleClick = (event) => {
        const target = event.target;
        if (target && target.tagName === 'A') {
            setIsSearchResultsPopUpOpen(false);
        }
    };
    const bySplitScreen = (item) => {
        if (!splitScreenMode)
            return true;
        if (item.visibleInSplitScreen)
            return true;
        return false;
    };
    const byPrivateOrPublicItems = (item) => isAuth ? item.visibleIn !== 'public' : item.visibleIn !== 'private';
    const bySubItems = (subItem) => isAuth ? subItem.visibleIn !== 'public' : subItem.visibleIn !== 'private';
    const getSubItems = (item) => ({
        ...item,
        subItems: item.subItems?.filter(bySubItems),
    });
    const navItemsFiltered = navItems
        .filter((item) => bySplitScreen(item))
        .filter((item) => byPrivateOrPublicItems(item))
        .map((item) => getSubItems(item));
    React.useEffect(() => {
        const closeOnEscapeKey = (e) => (e.key === 'Escape' ? setIsSearchResultsPopUpOpen(false) : null);
        document.body.addEventListener('keydown', closeOnEscapeKey);
        return () => {
            document.body.removeEventListener('keydown', closeOnEscapeKey);
        };
    }, [setIsSearchResultsPopUpOpen]);
    React.useEffect(() => {
        if (isSearchResultsPopUpOpen) {
            document.body.classList.add('mobile-no-scroll');
        }
        else {
            document.body.classList.remove('mobile-no-scroll');
        }
        return () => {
            document.body.classList.remove('mobile-no-scroll');
        };
    }, [isSearchResultsPopUpOpen]);
    const handlerSearchClick = () => {
        setIsSearchResultsPopUpOpen(!isSearchResultsPopUpOpen);
    };
    const handleCloseSearchPopUp = () => {
        setIsSearchResultsPopUpOpen(false);
    };
    useOnClickOutside({ ref: searchPopUpRef, handler: handleCloseSearchPopUp });
    return (jsxRuntime.exports.jsx(StyledHeader$1, { isTransparent: isTransparent, isSticky: isSticky, isSplitScreenOpen: splitScreenMode, children: jsxRuntime.exports.jsxs(FluidContainer, { isFullWidth: isFullWidth, children: [jsxRuntime.exports.jsxs(StyledFlex, { justifyContent: "flex-start", gap: "2rem", alignItems: "center", children: [jsxRuntime.exports.jsx(StyledNavButton, { "aria-label": "drawer-button", type: "button", onClick: () => setIsMobileNavOpen(true), children: jsxRuntime.exports.jsx("span", {}) }), jsxRuntime.exports.jsx(DesktopNav, { splitScreenMode: splitScreenMode, navItems: navItemsFiltered, isAuth: isAuth, isNavItemActive: isNavItemActive, isChristmas: isChristmas, onLogoHoverChange: onLogoHoverChange, onMenuOpenChange: (open) => {
                                if (open)
                                    setIsSearchResultsPopUpOpen(false);
                            } }), jsxRuntime.exports.jsx(MobileNav, { closeMobileNav: () => {
                                setIsMobileNavOpen(false);
                            }, navItems: navItemsFiltered, isAuth: isAuth, avatar: avatar, avatarDropDownMenuItems: avatarDropDownMenuItems, streak: streak, onStreakRepair: onStreakRepair, onStreakShare: onStreakShare, notifications: notifications, clearNotifications: clearNotifications, unreadNotificationsCount: unreadNotificationsCount, onNotificationsOpen: onNotificationsOpen, isOpen: isMobileNavOpen, isPremium: isPremium, adminLinks: adminLinks, isChristmas: isChristmas, isStreakShareEnabled: isStreakShareEnabled, username: requestingUser })] }), jsxRuntime.exports.jsx(StyledHeaderActions, { onMouseDown: (e) => {
                        if (!searchPopUpRef.current)
                            return;
                        const target = e.target;
                        if (!searchPopUpRef.current.contains(target)) {
                            setIsSearchResultsPopUpOpen(false);
                        }
                    }, children: isAuth ? (jsxRuntime.exports.jsxs(StyledAuthHeaderActionsWrapper, { children: [width > 960 && !splitScreenMode && accessMachineButton?.isVisible && (jsxRuntime.exports.jsx(StyledAccessMachine, { connected: !!accessMachineButton?.value, type: "button", onClick: handlerAccessMachine, children: accessMachineButton?.value ?? 'Access Machines' })), isExtendedSearchEnabled ? (jsxRuntime.exports.jsxs(StyledSearchWrapper, { ref: searchPopUpRef, children: [jsxRuntime.exports.jsx(StyledSearch, { onClick: handlerSearchClick, "data-testid": "search-btn", children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faSearch }) }), isSearchResultsPopUpOpen && (jsxRuntime.exports.jsx(SearchPopUp, { searchPopUpResultsRef: searchPopUpResultsRef, handleClick: handleClick, setIsSearchResultsPopUpOpen: setIsSearchResultsPopUpOpen, children: searchResults }))] })) : (jsxRuntime.exports.jsx(StyledSearch, { as: reactRouterDom.Link, to: searchLink ?? '/r/hacktivities/search', "data-testid": "search-btn", children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faSearch }) })), !splitScreenMode && (jsxRuntime.exports.jsx(Notifications, { clearNotifications: clearNotifications, notifications: notifications, unreadNotificationsCount: unreadNotificationsCount, onNotificationsOpen: () => {
                                    setIsSearchResultsPopUpOpen(false);
                                    onNotificationsOpen?.();
                                }, requestingUser: requestingUser, onLike: onLike, onUnlike: onUnlike, onHover: onHover, onReactionHover: onReactionHover, enableReactionsTooltip: enableReactionsTooltip, renderSelfLikeEasterEgg: renderSelfLikeEasterEgg })), !splitScreenMode && handleGoBusiness && (jsxRuntime.exports.jsx(StyledGoBusinessWrapper, { children: jsxRuntime.exports.jsx(StyledButton$3, { size: "default", variant: "solid", color: "primary", onClick: handleGoBusiness, "data-link": "go-business", id: "cta-header-go-business", children: "Go Business" }) })), !splitScreenMode && !isPremium && !isPaused && location.pathname !== '/business' && (jsxRuntime.exports.jsx(StyledGoPremiumWrapper, { children: jsxRuntime.exports.jsx(StyledButton$3, { "data-premium": true, as: reactRouterDom.Link, to: "/why-subscribe", size: "default", variant: "solid", color: "primary", id: "cta-header-go-premium", children: "Go Premium" }) })), !splitScreenMode && !isPaused && location.pathname === '/business' && isShowBookDemoCta && (jsxRuntime.exports.jsx(StyledGoPremiumWrapper, { children: jsxRuntime.exports.jsx(StyledButton$3, { "data-paused": true, onClick: handleBookDemo ?? (() => { }), size: "default", variant: "solid", color: "primary", children: "Try for FREE" }) })), !splitScreenMode && isPremium && isDecember === 11 && !isPaused && (jsxRuntime.exports.jsx(StyledGoPremiumWrapper, { children: jsxRuntime.exports.jsx(StyledButton$3, { "data-premium": true, as: reactRouterDom.Link, to: "/subscriptions", size: "default", variant: "solid", color: "primary", id: "cta-header-gift-subscription", children: "Gift Subscription" }) })), !splitScreenMode && isPaused && location.pathname !== '/manage-account/subscription' && (jsxRuntime.exports.jsx(StyledGoPremiumWrapper, { children: jsxRuntime.exports.jsx(StyledButton$3, { "data-paused": true, as: reactRouterDom.Link, to: "/manage-account/subscription", size: "default", variant: "solid", color: "primary", children: "Resume Subscription" }) })), !splitScreenMode && adminLinks?.some((link) => link.visible) && (jsxRuntime.exports.jsx(AdminDropdown, { adminLinks: adminLinks, onOpenChange: (open) => {
                                    if (open)
                                        setIsSearchResultsPopUpOpen(false);
                                } })), streak && (jsxRuntime.exports.jsx(Streak, { ...streak, onStreakRepair: onStreakRepair, onStreakShare: onStreakShare, isStreakShareEnabled: isStreakShareEnabled, onStreakOpenChange: (open) => {
                                    if (open)
                                        setIsSearchResultsPopUpOpen(false);
                                } })), languageSelector, jsxRuntime.exports.jsx(AvatarDropdown, { isPremium: isPremium, avatar: avatar, avatarDropDownMenuItems: avatarDropDownMenuItems, soundEffectsEnabled: soundEffectsEnabled, onSoundEffectsChange: onSoundEffectsChange, echoEnabled: echoEnabled, onEchoChange: onEchoChange, onOpenChange: (open) => {
                                    if (open)
                                        setIsSearchResultsPopUpOpen(false);
                                } })] })) : (jsxRuntime.exports.jsxs(StyledButtonsWrapper$1, { children: [isExtendedSearchEnabled ? (jsxRuntime.exports.jsxs(StyledSearchWrapper, { ref: searchPopUpRef, children: [jsxRuntime.exports.jsx(StyledSearch, { onClick: handlerSearchClick, "data-testid": "search-btn", children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faSearch }) }), isSearchResultsPopUpOpen && (jsxRuntime.exports.jsx(SearchPopUp, { searchPopUpResultsRef: searchPopUpResultsRef, handleClick: handleClick, setIsSearchResultsPopUpOpen: setIsSearchResultsPopUpOpen, children: searchResults }))] })) : (jsxRuntime.exports.jsx(StyledSearch, { as: reactRouterDom.Link, to: searchLink ?? '/r/hacktivities/search', "data-testid": "search-btn", children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faSearch }) })), languageSelector, jsxRuntime.exports.jsx(LoginButton, { variant: "outlined", forceDarkMode: true }), onClickSignup && (jsxRuntime.exports.jsx(StyledButton$3, { size: "default", variant: "solid", color: "primary", onClick: onClickSignup, "data-link": "join", id: "cta-header-join-for-free", children: "Join for FREE" })), !onClickSignup && (jsxRuntime.exports.jsx(StyledButton$3, { as: reactRouterDom.Link, to: source && source !== null ? `/signup?source=${source}` : '/signup', size: "default", variant: "solid", color: "primary", "data-link": "join", id: "cta-header-join-for-free", children: "Join for FREE" }))] })) })] }) }));
};

const StyledAppearAnimation = styled.css `
  @keyframes appear {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
const StyledCircularButton = styled__default["default"].button `
  align-items: center;
  background-color: ${({ theme }) => theme.colors.primary.main};
  border: none;
  border-radius: 100%;
  color: ${({ theme }) => theme.colors.secondary.main};
  cursor: pointer;
  justify-content: center;
  height: 3.2rem;
  width: 3.2rem;
  grid-area: button;
  display: none;
  opacity: 0;

  svg {
    font-size: 1.6rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    display: none;
  }
`;
const StyledLearningRoom = styled__default["default"](reactRouterDom.Link) `
  align-items: center;
  padding: 0.8rem 1.6rem 0.8rem 1.2rem;
  background-color: transparent;
  border-radius: 0.8rem;
  color: ${({ theme }) => theme.colors.text.main};
  display: grid;
  gap: 0.6rem 1.8rem;
  grid-template-columns: 6.4rem 1fr 3.2rem;
  grid-template-areas:
    'image title button'
    'image description button';
  text-decoration: none;
  transition: opacity 0.3s ease-in-out;
  ${StyledAppearAnimation};

  &:hover {
    background-color: ${({ theme }) => theme.colors.border.main};
    ${StyledCircularButton} {
      display: flex;
      opacity: 1;
      animation: appear 0.4s ease-in-out;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 6.4rem 1fr;
    gap: 1.6rem;
    grid-template-areas:
      'image title'
      'description description';
  }
`;
const StyledProgressWrapper = styled__default["default"].div `
  grid-area: image;
`;
const StyledTitle = styled__default["default"].div `
  grid-area: title;
  display: flex;
  justify-content: start;
  align-self: flex-end;
  gap: 0.8rem;

  img {
    padding: ${({ shouldScaleIcon }) => (shouldScaleIcon ? '0.1rem 0.7rem' : '0.1rem 0.5rem')};
    transform: ${({ shouldScaleIcon }) => (shouldScaleIcon ? 'scale(1.1)' : 'scale(1)')};
  }

  h3 {
    font-size: 2.1rem;
    font-family: ${({ theme }) => theme.fonts.familySansPro};
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    margin-bottom: 0;
    line-height: 2rem;
  }

  span[data-testid='tag-tooltip'] {
    margin-left: 0;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    align-self: center;
  }
`;
const StyledDescription = styled__default["default"].p `
  grid-area: description;
  align-self: flex-start;
  color: ${({ theme }) => theme.colors.paragraph};
  line-height: 2rem;
`;

const LearningRoom = ({ title, description, image, progressValue = 0, roomType, code, activeTab, showCompletedCheckmarks = false, isPublic = true, }) => {
    const icon = roomType === exports.RoomType.Challenge ? faFlag$1 : faRoute;
    const [isHovered, setIsHovered] = React.useState(false);
    const location = reactRouterDom.useLocation();
    const anchorId = `module-room-${code}`;
    const pagePathname = location.pathname;
    const pageReferrerPath = activeTab === 'saved' && pagePathname === '/dashboard' ? '/rooms' : pagePathname;
    return (jsxRuntime.exports.jsxs(StyledLearningRoom, { id: anchorId, to: isPublic ? `/room/${code}` : `/jr/${code}`, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), state: { pageReferrer: `${pageReferrerPath}#${anchorId}` }, children: [jsxRuntime.exports.jsx(StyledProgressWrapper, { children: activeTab === 'saved' ? (jsxRuntime.exports.jsx(Avatar, { avatarSrc: image })) : (jsxRuntime.exports.jsx(CircularImageProgress, { size: 64, strokeWidth: 3, contentSizeAdjustment: 12, fontSize: "1.6rem", progressValue: progressValue ?? 0, image: image, isBig: false, isHovered: isHovered, showCompletedCheckmarks: showCompletedCheckmarks })) }), jsxRuntime.exports.jsxs(StyledTitle, { children: [jsxRuntime.exports.jsx("h3", { children: title }), roomType && jsxRuntime.exports.jsx(TagToolTip, { icon: icon, text: roomType })] }), jsxRuntime.exports.jsx(StyledDescription, { children: description }), jsxRuntime.exports.jsx(StyledCircularButton, { children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCaretRight }) })] }));
};

const LearningScenario = ({ title, description, image, progressValue = 0, scenarioType, url, activeTab, showCompletedCheckmarks = false, icon, shouldScaleIcon = false, }) => {
    const [isHovered, setIsHovered] = React.useState(false);
    const location = reactRouterDom.useLocation();
    return (jsxRuntime.exports.jsxs(StyledLearningRoom, { to: url, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), state: { pageReferrer: location.pathname }, children: [jsxRuntime.exports.jsx(StyledProgressWrapper, { children: activeTab === 'saved' ? (jsxRuntime.exports.jsx(Avatar, { avatarSrc: image })) : (jsxRuntime.exports.jsx(CircularImageProgress, { size: 64, strokeWidth: 3, contentSizeAdjustment: 12, fontSize: "1.6rem", progressValue: progressValue ?? 0, image: image, isBig: false, isHovered: isHovered, showCompletedCheckmarks: showCompletedCheckmarks })) }), jsxRuntime.exports.jsxs(StyledTitle, { shouldScaleIcon: shouldScaleIcon, children: [jsxRuntime.exports.jsx("h3", { children: title }), scenarioType && jsxRuntime.exports.jsx(TagToolTip, { iconSrc: icon, text: scenarioType })] }), jsxRuntime.exports.jsx(StyledDescription, { children: description }), jsxRuntime.exports.jsx(StyledCircularButton, { children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faCaretRight }) })] }));
};

/* -------------------------------------------------------------------------------------------------
 * Dialog
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DIALOG_NAME = 'Dialog';
const [$5d3850c4d0b4e6c7$var$createDialogContext, $5d3850c4d0b4e6c7$export$cc702773b8ea3e41] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$5d3850c4d0b4e6c7$var$DialogProvider, $5d3850c4d0b4e6c7$var$useDialogContext] = $5d3850c4d0b4e6c7$var$createDialogContext($5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $5d3850c4d0b4e6c7$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const triggerRef = React.useRef(null);
    const contentRef = React.useRef(null);
    const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ React.createElement($5d3850c4d0b4e6c7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
        titleId: $1746a345f3d73bb7$export$f680877a34711e37(),
        descriptionId: $1746a345f3d73bb7$export$f680877a34711e37(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: React.useCallback(()=>setOpen((prevOpen)=>!prevOpen
            )
        , [
            setOpen
        ]),
        modal: modal
    }, children);
};
/* -------------------------------------------------------------------------------------------------
 * DialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$TRIGGER_NAME = 'DialogTrigger';
const $5d3850c4d0b4e6c7$export$2e1e1122cf0cba88 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...triggerProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.triggerRef);
    return /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$b({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onOpenToggle)
    }));
});
/* -------------------------------------------------------------------------------------------------
 * DialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$PORTAL_NAME = 'DialogPortal';
const [$5d3850c4d0b4e6c7$var$PortalProvider, $5d3850c4d0b4e6c7$var$usePortalContext] = $5d3850c4d0b4e6c7$var$createDialogContext($5d3850c4d0b4e6c7$var$PORTAL_NAME, {
    forceMount: undefined
});
const $5d3850c4d0b4e6c7$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog , forceMount: forceMount , children: children , container: container  } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
    return /*#__PURE__*/ React.createElement($5d3850c4d0b4e6c7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount
    }, React.Children.map(children, (child)=>/*#__PURE__*/ React.createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
            present: forceMount || context.open
        }, /*#__PURE__*/ React.createElement($f1701beae083dbae$export$602eac185826482c$1, {
            asChild: true,
            container: container
        }, child))
    ));
};
/* -------------------------------------------------------------------------------------------------
 * DialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$OVERLAY_NAME = 'DialogOverlay';
const $5d3850c4d0b4e6c7$export$bd1d06c79be19e17 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const portalContext = $5d3850c4d0b4e6c7$var$usePortalContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...overlayProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /*#__PURE__*/ React.createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, /*#__PURE__*/ React.createElement($5d3850c4d0b4e6c7$var$DialogOverlayImpl, _extends$b({}, overlayProps, {
        ref: forwardedRef
    }))) : null;
});
const $5d3850c4d0b4e6c7$var$DialogOverlayImpl = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...overlayProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
    return(/*#__PURE__*/ // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    React.createElement(ReactRemoveScroll, {
        as: $5e63c961fc1ce211$export$8c6ed5c666ac1360,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ]
    }, /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$b({
        "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
    }, overlayProps, {
        ref: forwardedRef // We re-enable pointer-events prevented by `Dialog.Content` to allow scrolling the overlay.
        ,
        style: {
            pointerEvents: 'auto',
            ...overlayProps.style
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * DialogContent
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$CONTENT_NAME = 'DialogContent';
const $5d3850c4d0b4e6c7$export$b6d9565de1e068cf = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const portalContext = $5d3850c4d0b4e6c7$var$usePortalContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    return /*#__PURE__*/ React.createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ React.createElement($5d3850c4d0b4e6c7$var$DialogContentModal, _extends$b({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ React.createElement($5d3850c4d0b4e6c7$var$DialogContentNonModal, _extends$b({}, contentProps, {
        ref: forwardedRef
    })));
});
/* -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DialogContentModal = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = React.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.contentRef, contentRef); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    React.useEffect(()=>{
        const content = contentRef.current;
        if (content) return hideOthers(content);
    }, []);
    return /*#__PURE__*/ React.createElement($5d3850c4d0b4e6c7$var$DialogContentImpl, _extends$b({}, props, {
        ref: composedRefs // we make sure focus isn't trapped once `DialogContent` has been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick; // If the event is a right-click, we shouldn't close because
            // it is effectively as if we right-clicked the `Overlay`.
            if (isRightClick) event.preventDefault();
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusOutside, (event)=>event.preventDefault()
        )
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DialogContentNonModal = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = React.useRef(false);
    return /*#__PURE__*/ React.createElement($5d3850c4d0b4e6c7$var$DialogContentImpl, _extends$b({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) hasInteractedOutsideRef.current = true; // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            //
            // We use `onInteractOutside` as some browsers also
            // focus on pointer down, creating the same issue.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DialogContentImpl = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , ...contentProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = React.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, contentRef); // Make sure the whole tree has focus guards as our `Dialog` will be
    // the last element in the DOM (beacuse of the `Portal`)
    $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement($d3863c46a17e8a28$export$20e40289641fbbb6, {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ React.createElement($5cb92bef7577960e$export$177fb62ff3ec1f22$1, _extends$b({
        role: "dialog",
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
    }, contentProps, {
        ref: composedRefs,
        onDismiss: ()=>context.onOpenChange(false)
    }))), false);
});
/* -------------------------------------------------------------------------------------------------
 * DialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$TITLE_NAME = 'DialogTitle';
const $5d3850c4d0b4e6c7$export$16f7638e4a34b909 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...titleProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
    return /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.h2, _extends$b({
        id: context.titleId
    }, titleProps, {
        ref: forwardedRef
    }));
});
/* -------------------------------------------------------------------------------------------------
 * DialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = 'DialogDescription';
const $5d3850c4d0b4e6c7$export$94e94c2ec2c954d5 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...descriptionProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
    return /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.p, _extends$b({
        id: context.descriptionId
    }, descriptionProps, {
        ref: forwardedRef
    }));
});
/* -------------------------------------------------------------------------------------------------
 * DialogClose
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$CLOSE_NAME = 'DialogClose';
const $5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...closeProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
    return /*#__PURE__*/ React.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$b({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, ()=>context.onOpenChange(false)
        )
    }));
});
/* -----------------------------------------------------------------------------------------------*/ function $5d3850c4d0b4e6c7$var$getState(open) {
    return open ? 'open' : 'closed';
}
const $5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9 = $5d3850c4d0b4e6c7$export$3ddf2d174ce01153;
const $5d3850c4d0b4e6c7$export$41fb9f06171c75f4 = $5d3850c4d0b4e6c7$export$2e1e1122cf0cba88;
const $5d3850c4d0b4e6c7$export$602eac185826482c = $5d3850c4d0b4e6c7$export$dad7c95542bacce0;
const $5d3850c4d0b4e6c7$export$c6fdb837b070b4ff = $5d3850c4d0b4e6c7$export$bd1d06c79be19e17;
const $5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2 = $5d3850c4d0b4e6c7$export$b6d9565de1e068cf;
const $5d3850c4d0b4e6c7$export$f99233281efd08a0 = $5d3850c4d0b4e6c7$export$16f7638e4a34b909;
const $5d3850c4d0b4e6c7$export$393edc798c47379d = $5d3850c4d0b4e6c7$export$94e94c2ec2c954d5;
const $5d3850c4d0b4e6c7$export$f39c2d165cd861fe = $5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac;

const StyledDialogOverlay = styled__default["default"]($5d3850c4d0b4e6c7$export$c6fdb837b070b4ff) `
  ${StyledDialogOver};
  ${StyledDialogAnimation};
  background-color: ${({ $isOverlayOpaque, theme }) => $isOverlayOpaque ? theme.colors.overlay : 'rgba(0, 0, 0, 0.4)'};
  overflow-y: auto;
  inset: 0;
  padding: 1rem 0;
  z-index: 10000;
`;
const StyledDialogFooter = styled__default["default"].footer `
  display: flex;
  flex-wrap: wrap-reverse;
  justify-content: flex-end;
  gap: 1.6rem;
  border-top: 0.1rem solid ${({ theme }) => theme.colors.border.dropdown};
  padding-top: 1.8rem;
  margin-top: ${({ $isSmall }) => ($isSmall ? '2.4rem' : '4.6rem')};

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-top: ${({ $isSmall }) => ($isSmall ? '2.4rem' : '3.2rem')};
  }

  button {
    // Display block is used here to show ellipsis when text is too long
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: auto;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    flex-direction: column-reverse;
  }
`;
const StyledDialogContent = styled__default["default"]($5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2) `
  background: ${({ theme }) => theme.colors.background.light};
  border-radius: ${({ theme, $borderRadius }) => $borderRadius ?? theme.radius.small};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  color: ${({ theme }) => theme.colors.text.main};
  width: 95vw;
  max-width: ${({ $isSmall, $maxWidth }) => $maxWidth ?? ($isSmall ? '54rem' : '76rem')};
  position: relative;
  margin: auto 0;
  overflow-x: hidden;
  max-height: ${({ $maxHeight }) => $maxHeight || '80vh'};
  padding: ${({ $padding, $isSmall }) => $padding ?? ($isSmall ? '3rem 3rem 2.4rem' : '4.6rem 4.6rem 3.0rem')};

  ${({ $overflowVisible }) => $overflowVisible &&
    styled.css `
      overflow: visible;
    `};

  ${({ $minHeight }) => $minHeight &&
    styled.css `
      min-height: ${$minHeight};
      display: flex;
      flex-direction: column;
      ${StyledDialogFooter} {
        margin-top: auto;
      }
    `};

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: ${({ $padding, $isSmall }) => $padding ?? ($isSmall ? '4.8rem 1.8rem 3rem' : '4.6rem 1.8rem 3rem')};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    max-height: 100%;
  }

  &:focus {
    outline: none;
  }

  &[data-state='open'] {
    animation: ${contentShow} 150ms ease-out;
  }

  &[data-state='closed'] {
    animation: ${fadeOut$1} 150ms ease-out;
  }

  /* Sometimes some designs require buttons to be hidden. Conditional rendering will break the tab focusing of the modal, so use the hidden attribute */
  button {
    &[hidden] {
      display: none;
    }
  }
`;
const StyledDialogHeader = styled__default["default"].header `
  display: flex;
  align-items: ${({ $isSmall }) => ($isSmall ? 'flex-start' : 'center')};
  gap: 1.4rem;
  margin-bottom: ${({ $isSmall }) => ($isSmall ? '2.4rem' : '4.6rem')};
  margin-right: ${({ $isSmall }) => $isSmall && '3rem'};

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    align-items: flex-start;
    margin-bottom: ${({ $isSmall }) => ($isSmall ? '2.4rem' : '3.2rem')};
  }
`;
const StyledDialogTitle = styled__default["default"]($5d3850c4d0b4e6c7$export$f99233281efd08a0) `
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: 2.4rem;
  font-weight: 400;
  margin-bottom: 0;
  margin-top: ${({ $isSmall }) => $isSmall && '-0.4rem'};

  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    font-size: 2rem;
  }
`;
const StyledDialogDescription = styled__default["default"]($5d3850c4d0b4e6c7$export$393edc798c47379d) `
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.paragraph};
  margin-bottom: 1.6rem;
`;
const StyledCloseIconButton$1 = styled__default["default"]($5d3850c4d0b4e6c7$export$f39c2d165cd861fe) `
  outline: none;
  position: absolute;
  padding: 0.9rem;
  border: 0.1rem solid transparent;
  border-radius: ${({ theme }) => theme.radius.small};
  top: ${({ $isSmall }) => ($isSmall ? '2rem' : '1.8rem')};
  right: ${({ $isSmall }) => ($isSmall ? '1.6rem' : '1.8rem')};

  svg {
    color: ${({ theme, $closeIconColor }) => $closeIconColor || theme.colors.text.lighter};
    height: ${({ $isSmall }) => ($isSmall ? '2.4rem' : '1.8rem')};
    width: ${({ $isSmall }) => ($isSmall ? '2.4rem' : '1.8rem')};
    display: block;
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.info.main};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    top: 0.8rem;
    right: 0.8rem;
  }
`;
const StyledCloseButton = styled__default["default"](Button$1) `
  background: ${({ theme }) => theme.colors.button.close.background};
`;

const Modal = ({ triggerElement, children, isOverlayOpaque = false, preventCloseOnOutsideClick, preventOnOpenAutoFocus, minHeight, maxHeight, maxWidth, isSmall = false, handleCloseButtonAction, overflowVisible = false, padding, borderRadius, hideCloseIcon = false, closeIconColor, ...args }) => {
    return (jsxRuntime.exports.jsxs($5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9, { ...args, children: [triggerElement && jsxRuntime.exports.jsx($5d3850c4d0b4e6c7$export$41fb9f06171c75f4, { asChild: true, children: triggerElement }), jsxRuntime.exports.jsx($5d3850c4d0b4e6c7$export$602eac185826482c, { children: jsxRuntime.exports.jsx(StyledDialogOverlay, { "data-testid": "rtl-overlay", "$isOverlayOpaque": isOverlayOpaque, children: jsxRuntime.exports.jsxs(StyledDialogContent, { "$minHeight": minHeight, "$maxHeight": maxHeight, "$maxWidth": maxWidth, "$isSmall": isSmall, "$overflowVisible": overflowVisible, "$padding": padding, "$borderRadius": borderRadius, onOpenAutoFocus: preventOnOpenAutoFocus ? (e) => e.preventDefault() : undefined, onPointerDownOutside: preventCloseOnOutsideClick ? (e) => e.preventDefault() : undefined, onInteractOutside: preventCloseOnOutsideClick ? (e) => e.preventDefault() : undefined, children: [children, !hideCloseIcon && (jsxRuntime.exports.jsx(StyledCloseIconButton$1, { "aria-label": "Close Modal", "$isSmall": isSmall, "$closeIconColor": closeIconColor, onClick: handleCloseButtonAction, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faXmark$2 }) }))] }) }) })] }));
};

const ModalDescription = ({ visuallyHidden, className, children }) => {
    const content = jsxRuntime.exports.jsx(StyledDialogDescription, { className: className, children: children });
    if (!visuallyHidden)
        return content;
    return jsxRuntime.exports.jsx($ea1ef594cf570d83$export$be92b6f5f03c0fe9, { asChild: true, children: content });
};

const ModalTitle = ({ visuallyHidden = false, isSmall = false, className, children, }) => {
    const content = (jsxRuntime.exports.jsx(StyledDialogTitle, { className: className, "$isSmall": isSmall, children: children }));
    if (!visuallyHidden)
        return content;
    return jsxRuntime.exports.jsx($ea1ef594cf570d83$export$be92b6f5f03c0fe9, { asChild: true, children: content });
};

const ModalCloseButton = ({ text, handleCloseButtonAction, color = 'secondary', variant = 'outlined', }) => (jsxRuntime.exports.jsx($5d3850c4d0b4e6c7$export$f39c2d165cd861fe, { asChild: true, children: jsxRuntime.exports.jsx(StyledCloseButton, { variant: variant, color: color, onClick: handleCloseButtonAction, children: text || 'Close' }) }));
const ModalClose = ({ ...args }) => jsxRuntime.exports.jsx($5d3850c4d0b4e6c7$export$f39c2d165cd861fe, { ...args });

const ModalFooter = ({ children, isSmall = false }) => (jsxRuntime.exports.jsx(StyledDialogFooter, { "$isSmall": isSmall, "data-testid": "modal-footer", children: children }));

const ModalHeader = ({ children, isSmall = false }) => (jsxRuntime.exports.jsx(StyledDialogHeader, { "$isSmall": isSmall, children: children }));

const StyledLoadingWrapper$2 = styled__default["default"].section `
  width: 100%;
  padding: 2rem;

  span {
    ${StyledLoadingPlaceholder};
    margin-bottom: 2rem;
    display: block;
    height: 4rem;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

const Loading$2 = () => (jsxRuntime.exports.jsxs(StyledLoadingWrapper$2, { "data-testid": "loading", children: [jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsx("span", {})] }));

exports.SortEnum = void 0;
(function (SortEnum) {
    SortEnum["ascending"] = "ascending";
    SortEnum["descending"] = "descending";
    SortEnum["unsorted"] = "unsorted";
})(exports.SortEnum || (exports.SortEnum = {}));
exports.CellBorderWidthEnum = void 0;
(function (CellBorderWidthEnum) {
    CellBorderWidthEnum["thin"] = "thin";
    CellBorderWidthEnum["thick"] = "thick";
})(exports.CellBorderWidthEnum || (exports.CellBorderWidthEnum = {}));
exports.TableColorThemeEnum = void 0;
(function (TableColorThemeEnum) {
    TableColorThemeEnum["grayWhite"] = "gray-white";
    TableColorThemeEnum["allWhite"] = "all-white";
})(exports.TableColorThemeEnum || (exports.TableColorThemeEnum = {}));

const getAccentColor = ({ theme, $colorTheme }) => {
    if ($colorTheme === exports.TableColorThemeEnum.grayWhite)
        return theme.colors.background.tableOdd;
    return theme.colors.background.light;
};
const StyledTable$1 = styled__default["default"].div `
  margin: 1.6rem 0 2.4rem;
  overflow: auto;
  background-color: ${({ theme }) => theme.colors.background.main};
  border-radius: ${({ $borderRadius = '0px' }) => $borderRadius};


  ${({ $isGlossaryPage, theme }) => $isGlossaryPage &&
    `
      box-shadow: ${theme.boxShadow.light};
    `};
`;
const StyledTableHeader$1 = styled__default["default"].div `
  display: flex;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: none;
  }
`;
const commonCellStyles = styled.css `
  display: flex;
  border: 1px solid ${getAccentColor};
  width: ${({ width = 'auto' }) => width};
  flex: ${({ flex = '1' }) => flex};
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.text.main};

  ${({ $cellBorderWidth }) => $cellBorderWidth === exports.CellBorderWidthEnum.thin &&
    `
      &:not(:last-child) {
        border-right: 0;
      }
    `};

  ${({ $hideColumnSeparator }) => $hideColumnSeparator &&
    `
      &:not(:first-child) {
        border-left: 0;
      }

      &:not(:last-child) {
        border-right: 0;
      }
  `}

  ${({ $isGlossaryPage }) => $isGlossaryPage &&
    `
      :first-child {
        border-left: 0;
      }

      :last-child {
        border-right: 0;
      }

    `}
`;
const StyledTableHeaderCell = styled__default["default"].div `
  ${commonCellStyles};
  padding: 1.6rem;
  line-height: 3.2rem;
  justify-content: ${({ justifyHeaderCellContents, justifyContent = 'flex-start' }) => justifyHeaderCellContents ? 'space-between' : justifyContent};

  ${({ $isGlossaryPage }) => $isGlossaryPage && `border-top: 0;`}
`;
const tableCellStyles = styled.css `
  ${commonCellStyles};
  align-items: ${({ alignItems = 'center' }) => alignItems};
  padding: ${({ padding = '1.6rem ' }) => padding};
  line-height: 1.6rem;
  overflow-wrap: anywhere;

  ${({ $cellBorderWidth }) => $cellBorderWidth === exports.CellBorderWidthEnum.thin && `border-top: 0;`};

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    border: none;
    display: flex;
    width: 100%;
    padding: 0.8rem 1.6rem;
    overflow-wrap: anywhere;
    text-align: left;
  }
`;
const StyledTableCell = styled__default["default"].div `
  ${tableCellStyles};
`;
const StyledTableExpansionTrigger = styled__default["default"]($1bf158f521e1b1b4$export$94e939b1f85bdd73) `
  ${tableCellStyles};
  position: relative;

  &[data-state='open'] {
    svg[data-icon='chevron-down'] {
      transform: rotate(180deg);
    }
  }
`;
const StyledTableRow = styled__default["default"]($1bf158f521e1b1b4$export$d99097c13d4dac9f) `
  display: flex;
  flex-direction: column;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    border: 1px solid ${getAccentColor};
    ${({ $cellBorderWidth }) => $cellBorderWidth === exports.CellBorderWidthEnum.thin && 'border-bottom: 0'};

    &:nth-child(even) {
      background-color: ${getAccentColor};
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    &:nth-child(odd) {
      background-color: ${getAccentColor};
    }
  }

  ${({ $isGlossaryPage }) => $isGlossaryPage &&
    `
      &:last-child {
        ${StyledTableCell} {
          border-bottom:0;
        }
      }
  `};

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.tableRowHover};
  }

  ${({ onClick }) => onClick
    ? styled.css `
          cursor: pointer;
        `
    : ''};
`;
const StyledRowInner = styled__default["default"].div `
  display: flex;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    ${({ rowHeight }) => rowHeight && `height: ${rowHeight};`}
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
    padding: 1.8rem 0;
  }
`;
const StyledSortIcon = styled__default["default"](FontAwesomeIcon) `
  color: ${({ theme, $iconColor }) => ($iconColor === 'unsorted' ? theme.colors.grey[400] : theme.colors.info.main)};

  &:hover {
    color: ${({ theme }) => theme.colors.text.main};
  }
`;
const StyledSortIconButton = styled__default["default"].div `
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: ${({ justifyHeaderCellContents = false }) => (justifyHeaderCellContents ? 'auto' : '3.2rem')};
  height: 3.2rem;
  margin-right: ${({ justifyHeaderCellContents = false }) => (justifyHeaderCellContents ? '0.8rem' : 0)};
`;
const StyledMobileColumnName = styled__default["default"].div `
  display: none;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: block;
    flex: 0 0 50%;
    color: ${({ theme }) => theme.colors.text.lighter};
  }

  @media screen and (max-width: 400px) {
    flex: 0 0 40%;
  }
`;
const StyledArrowIcon = styled__default["default"](FontAwesomeIcon).attrs({
    icon: faChevronDown$1,
}) `
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.text.main};
  transition: transform 0.2s ease-in-out;
`;
const slideDown = styled.keyframes `
  from {
    padding: 0 3.2rem;
    height: 0;
  }
  to {
    height: var(--radix-accordion-content-height);
  }
`;
const slideUp = styled.keyframes `
  from {
    padding: 3.2rem;
    height: var(--radix-accordion-content-height);
  }
  to {
    height: 0;
  }
`;
const StyledRowExpansion = styled__default["default"]($1bf158f521e1b1b4$export$985b9a77379b54a0) `
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.text.main};
  background-color: ${({ index, theme, $colorTheme }) => {
    if (index % 2 === 0) {
        return theme.colors.background.main;
    }
    return getAccentColor({ theme, $colorTheme });
}};

  border-bottom: 1px solid
    ${({ index, theme, $colorTheme }) => {
    if (index % 2) {
        return theme.colors.background.main;
    }
    return getAccentColor({ theme, $colorTheme });
}};
  overflow: hidden;
  &[data-state='open'] {
    padding: 3.2rem;
    animation: ${slideDown} 300ms ease-out;
  }

  &[data-state='closed'] {
    padding: 0 3.2rem;
    animation: ${slideUp} 300ms ease-out;
  }
`;
const StyledButton = styled__default["default"](Button$1) `
  padding: 1.2rem;
`;

const SortIcon = ({ sortFunction, sort, columnKey, activeSortColumn, }) => {
    if (activeSortColumn === columnKey) {
        return sort === exports.SortEnum.ascending ? (jsxRuntime.exports.jsx(StyledSortIcon, { "data-testid": "sort-icon arrow-up", icon: faArrowUp$1, "$iconColor": "ascending", onClick: () => sortFunction(columnKey) })) : (jsxRuntime.exports.jsx(StyledSortIcon, { "data-testid": "sort-icon arrow-down", icon: faArrowDown$1, "$iconColor": "descending", onClick: () => sortFunction(columnKey) }));
    }
    return (jsxRuntime.exports.jsx(StyledSortIcon, { "data-testid": "sort-icon", icon: faArrowDown$1, "$iconColor": "unsorted", onClick: () => sortFunction(columnKey) }));
};
const renderColumnHeader = (column) => {
    if (column.dropdownOptions) {
        return (jsxRuntime.exports.jsx(DropdownMenu, { sideOffset: 5, alignContent: "end", type: "button", triggerBtn: jsxRuntime.exports.jsxs(StyledButton, { variant: "outlined", color: "secondary", children: [column.title || 'Actions', " ", jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faChevronDown$2 })] }), children: column.dropdownOptions.map((option) => (jsxRuntime.exports.jsx(DropdownMenuItem, { onSelect: option.onClick, children: jsxRuntime.exports.jsx(DropdownMenuItemContent, { title: option.label, type: "other", isExtraPadding: false }) }, option.label))) }));
    }
    return column.title;
};
const ModularTable = ({ activeSortColumn, activeSortOrder, rows, columns, headerHeight, colorTheme, isLoading, hideColumnSeparator = false, cellBorderWidth, isGlossaryPage, rowHeight, justifyHeaderCellContents, rowExpansionTrigger, borderRadius, onRowClick, renderRowExpansion, }) => (jsxRuntime.exports.jsxs(StyledTable$1, { "$isGlossaryPage": isGlossaryPage, role: "table", "$borderRadius": borderRadius, children: [jsxRuntime.exports.jsx(StyledTableHeader$1, { headerHeight: headerHeight, role: "row", children: columns.map((column) => (jsxRuntime.exports.jsxs(StyledTableHeaderCell, { width: column.width, justifyContent: column.justifyContent, flex: column.flex, "$hideColumnSeparator": hideColumnSeparator, "$cellBorderWidth": cellBorderWidth, "$isGlossaryPage": isGlossaryPage, "$colorTheme": colorTheme, role: "columnheader", justifyHeaderCellContents: justifyHeaderCellContents, children: [justifyHeaderCellContents ? (jsxRuntime.exports.jsx("div", { children: renderColumnHeader(column) })) : (jsxRuntime.exports.jsxs("div", { children: [renderColumnHeader(column), " "] })), column.sortFunction ? (jsxRuntime.exports.jsx("div", { children: jsxRuntime.exports.jsx(StyledSortIconButton, { justifyHeaderCellContents: justifyHeaderCellContents, children: jsxRuntime.exports.jsx(SortIcon, { sortFunction: column.sortFunction, sort: activeSortOrder, columnKey: column.key, activeSortColumn: activeSortColumn }) }) })) : null, !!column.extraHeaderContent && column.extraHeaderContent] }, column.key))) }), isLoading ? (jsxRuntime.exports.jsx(Loading$2, {})) : (jsxRuntime.exports.jsx($1bf158f521e1b1b4$export$a766cd26d0d69044, { role: "rowgroup", type: "single", collapsible: true, children: rows.map((row, i) => (jsxRuntime.exports.jsxs(StyledTableRow, { value: String(row.id), "$colorTheme": colorTheme, role: "row", "$cellBorderWidth": cellBorderWidth, "$isGlossaryPage": isGlossaryPage, onClick: onRowClick ? onRowClick?.bind(null, row) : undefined, children: [jsxRuntime.exports.jsx(StyledRowInner, { rowHeight: rowHeight, children: columns.map((column) => {
                            let cell;
                            if (column.key in row) {
                                cell = row[column.key];
                            }
                            else if (column.key.startsWith('_')) {
                                const key = column.key.slice(1);
                                cell = row[key];
                            }
                            const isRowExpansionTrigger = rowExpansionTrigger === column.key;
                            const CellComponent = isRowExpansionTrigger
                                ? StyledTableExpansionTrigger
                                : StyledTableCell;
                            return (jsxRuntime.exports.jsxs(CellComponent, { "data-testid": `table-row-${row.id}-cell-${column.key}`, width: column.width, flex: column.flex, padding: column.padding, "$hideColumnSeparator": hideColumnSeparator, "$cellBorderWidth": cellBorderWidth, "$colorTheme": colorTheme, "$isGlossaryPage": isGlossaryPage, role: "cell", children: [jsxRuntime.exports.jsxs(StyledMobileColumnName, { children: [column.title, ":"] }), jsxRuntime.exports.jsxs(StyledFlex, { justifyContent: isRowExpansionTrigger ? 'space-between' : (column.justifyContent ?? 'flex-start'), children: [column.render ? column.render(cell, row, column) : cell, isRowExpansionTrigger && jsxRuntime.exports.jsx(StyledArrowIcon, {})] })] }, `table-row-${row.id}-cell-${column.key}`));
                        }) }), renderRowExpansion && (jsxRuntime.exports.jsx(StyledRowExpansion, { index: i, "$colorTheme": colorTheme, children: renderRowExpansion(row) }))] }, `table-row-${row.id}`))) }))] }));

const StyledCheckboxItem = styled__default["default"].div `
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
  padding-left: ${({ $indentLevel = 0 }) => `${$indentLevel * 2 + 0.4}rem`};
  > p {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    line-height: 2rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.text.main};
  }
  > button {
    flex-shrink: 0;
    background-color: transparent;
  }
`;
const StyledCheckboxItemTag = styled__default["default"](Tag) `
  margin-left: auto;
`;

const resolveTagProps = (tag) => {
    switch (tag) {
        case 'path': {
            return {
                size: 'small',
                color: 'info',
                variation: 'lightest',
                textColor: 'lighter',
                children: 'Path',
            };
        }
        case 'module': {
            return {
                size: 'small',
                color: 'purple',
                variation: 'lighter',
                textColor: 'lighter',
                children: 'Module',
            };
        }
        case 'public': {
            return {
                size: 'small',
                children: 'THM',
                color: 'background',
                variation: 'selectedHover',
                textColor: 'invert',
            };
        }
        case 'custom': {
            return {
                size: 'small',
                children: 'Custom',
                color: 'background',
                variation: 'grey',
                textColor: 'main',
            };
        }
        default: {
            return {
                size: 'small',
                color: 'success',
                variation: 'lightest',
                textColor: 'lighter',
                children: 'Room',
            };
        }
    }
};
const CheckboxItemWrapper = ({ ...props }) => {
    const { data: { indentLevel, tag, value, partial }, label, isSelected, innerProps: { onClick: nativeOnClick }, } = props;
    return (jsxRuntime.exports.jsx(components.Option, { ...props, children: jsxRuntime.exports.jsx(CheckboxItem, { checked: partial ? 'indeterminate' : isSelected, onClick: nativeOnClick, indentLevel, tag, value, label }) }));
};
const CheckboxItem = (props) => {
    const { indentLevel = 0, tag, label, checked, onClick } = props;
    const checkboxId = React.useId();
    return (jsxRuntime.exports.jsxs(StyledCheckboxItem, { "$indentLevel": indentLevel, onClick: (event) => {
            if (event.target instanceof HTMLInputElement) {
                event.stopPropagation();
            }
        }, children: [jsxRuntime.exports.jsx(FormCheckbox, { checked: checked, "aria-labelledby": checkboxId, onClick: onClick
                    ? (event) => {
                        event.stopPropagation();
                        onClick(event);
                    }
                    : undefined }), jsxRuntime.exports.jsx("p", { id: checkboxId, children: label }), tag && jsxRuntime.exports.jsx(StyledCheckboxItemTag, { ...resolveTagProps(tag) })] }));
};

const MultiValueRemoveWrapper = ({ ...props }) => (jsxRuntime.exports.jsx(components.MultiValueRemove, { ...props, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faXmark$1 }) }));

const StyledPlaceholderLabel = styled__default["default"].span `
  color: ${({ theme }) => theme.colors.text.placeholder};
`;

const SelectedLabel = ({ selectedOptions, placeholder, alwaysUsePlaceholderForButton }) => {
    let labelText = placeholder;
    if (alwaysUsePlaceholderForButton) {
        return jsxRuntime.exports.jsx(StyledPlaceholderLabel, { children: labelText });
    }
    const selectAllOption = selectedOptions.find((option) => option.value === SELECT_ALL_OPTION_VALUE);
    if (selectAllOption) {
        return jsxRuntime.exports.jsx("span", { children: selectAllOption.label });
    }
    const uniqueSelectedOptions = new Set(selectedOptions.map((selectedOption) => selectedOption.value));
    if (uniqueSelectedOptions.size === 1) {
        labelText = selectedOptions[0]?.label;
    }
    if (uniqueSelectedOptions.size === 2) {
        labelText = `${selectedOptions[0]?.label || ''}, ${selectedOptions[1]?.label || ''}`;
    }
    if (uniqueSelectedOptions.size > 2) {
        labelText = `${selectedOptions[0]?.label || ''} and ${uniqueSelectedOptions.size - 1} others`;
    }
    return jsxRuntime.exports.jsx("span", { children: labelText });
};

const resolveMultiSelectStyles = ({ theme, menuListMaxHeight, }) => {
    const customReactStyles = resolveCustomReactSelectStyles({
        theme,
        usesCheckboxItemWrapper: true,
    });
    return {
        ...customReactStyles,
        menuList: (baseStyles, props) => ({
            ...baseStyles,
            ...(customReactStyles.menuList ? customReactStyles.menuList(baseStyles, props) : {}),
            maxHeight: menuListMaxHeight ?? '30rem',
        }),
        indicatorsContainer: (baseStyles) => ({
            ...baseStyles,
            alignItems: 'start',
            marginTop: '0.7rem',
        }),
        multiValue: (baseStyles, { data }) => {
            let backgroundColor = theme.colors.grey[200];
            switch (data.tag) {
                case 'path': {
                    backgroundColor = theme.colors.info.lightest;
                    break;
                }
                case 'module': {
                    backgroundColor = theme.colors.purple.lighter;
                    break;
                }
                case 'room': {
                    backgroundColor = theme.colors.success.lightest;
                    break;
                }
            }
            return {
                ...baseStyles,
                backgroundColor,
                borderRadius: '1.2rem',
                padding: '0.1rem 0.8rem 0.1rem 0.6rem',
            };
        },
        multiValueRemove(baseStyles, { data }) {
            let color = secondaryColors.secondary.main;
            if (data.tag) {
                switch (data.tag) {
                    case 'path':
                    case 'module':
                    case 'room': {
                        color = theme.colors.text.lighter;
                        break;
                    }
                }
            }
            return {
                ...baseStyles,
                color,
                transition: 'color 0.2s',
                cursor: 'pointer',
                fontSize: '12px',
                ':hover': {
                    backgroundColor: 'transparent',
                    color: theme.colors.error.main,
                },
            };
        },
        multiValueLabel(baseStyles, { data }) {
            let color = secondaryColors.secondary.main;
            if (data.tag) {
                switch (data.tag) {
                    case 'path':
                    case 'module':
                    case 'room': {
                        color = theme.colors.text.lighter;
                        break;
                    }
                }
            }
            return { ...baseStyles, color };
        },
    };
};

const unNestOption = ({ children, ...option }, level = 0, parents) => [
    { ...option, indentLevel: level, parents: [...(parents ?? [])] },
    ...(children?.flatMap((child) => unNestOption(child, level + 1, [...(parents ?? []), option.value])) || []),
];
const unNestAllOptions = (optionsToUnNest) => optionsToUnNest.flatMap((option) => unNestOption(option, 0));
const MultiSelect = React.forwardRef(({ alwaysUsePlaceholderForButton = false, dropdownButtonAriaLabel, forceDarkMode = false, hideSelectedBadges = false, id, isDisabled = false, isError = false, isSearchable = true, menuListMaxHeight, menuWidth, options, placeholder = '', selectAllLabel, selected, selectSearchInputAriaLabel, setSelected, showSelectAllOption, }, ref) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const isMenuOpenAndForceDarkMode = isOpen && forceDarkMode;
    const [hasAllSelected, setHasAllSelected] = React.useState(false);
    const theme = styled.useTheme();
    const customStyles = React.useMemo(() => resolveMultiSelectStyles({
        theme: forceDarkMode ? { ...theme, colors: darkColors } : theme,
        menuListMaxHeight,
    }), [forceDarkMode, theme, menuListMaxHeight]);
    const unNestedOptions = React.useMemo(() => [
        ...(showSelectAllOption ? [{ value: SELECT_ALL_OPTION_VALUE, label: selectAllLabel ?? 'Select All' }] : []),
        ...unNestAllOptions(options),
    ], [options, showSelectAllOption, selectAllLabel]);
    const selectedOptions = React.useMemo(() => {
        if (hasAllSelected) {
            return unNestedOptions;
        }
        return unNestedOptions
            .filter(({ value }, _index, currentUnNestedOptions) => {
            if (selected.includes(value)) {
                return true;
            }
            const allPossibleChildren = currentUnNestedOptions.filter(({ parents, value: optionValue }) => parents?.includes(value) &&
                !currentUnNestedOptions.some(({ parents: currentOptionParents }) => currentOptionParents?.includes(optionValue)));
            if (allPossibleChildren.length === 0) {
                return false;
            }
            const selectedChildren = allPossibleChildren.filter(({ value: childValue }) => selected.includes(childValue));
            return selectedChildren.length === allPossibleChildren.length;
        })
            .filter(({ value: filteredOptionValue }, index, filteredOptions) => index === filteredOptions.findIndex((filteredOption) => filteredOption.value === filteredOptionValue));
    }, [selected, unNestedOptions, hasAllSelected]);
    React.useEffect(() => {
        if (selected.length === 0)
            setHasAllSelected(false);
    }, [selected]);
    const getSelectedValueAndSet = ({ actionMeta }) => {
        const { action } = actionMeta;
        switch (action) {
            case 'select-option': {
                const { option } = actionMeta;
                if (!option) {
                    break;
                }
                const { value } = option;
                if (value === SELECT_ALL_OPTION_VALUE) {
                    setHasAllSelected(true);
                    setSelected([
                        ...new Set(unNestedOptions
                            .filter((optionToFilter, _index, currentUnNestedOptions) => !currentUnNestedOptions.some((unNestedOption) => unNestedOption.parents?.includes(optionToFilter.value)))
                            .map((filteredOption) => filteredOption.value)
                            .filter((optionValue) => optionValue !== SELECT_ALL_OPTION_VALUE)),
                    ]);
                    break;
                }
                setHasAllSelected(false);
                const children = unNestedOptions
                    .filter((unNestedOption) => unNestedOption.parents?.includes(value))
                    .filter(({ value: filteredValue }, _index, filteredOptions) => !filteredOptions.some(({ parents: filteredParents }) => filteredParents?.includes(filteredValue)));
                setSelected([
                    ...new Set([
                        ...selected,
                        ...(children.length > 0 ? children.map(({ value: childValue }) => childValue) : [value]),
                    ]),
                ]);
                break;
            }
            case 'remove-value':
            case 'deselect-option': {
                const { option, removedValue } = actionMeta;
                const testValue = option || removedValue;
                if (!testValue) {
                    break;
                }
                const { value } = testValue;
                setHasAllSelected(false);
                if (value === SELECT_ALL_OPTION_VALUE) {
                    setSelected([]);
                    break;
                }
                const allSelectedChildrenValues = new Set(unNestedOptions
                    .filter(({ parents, value: optionValue }) => parents?.includes(value) && selected.includes(optionValue))
                    .map(({ value: optionValue }) => optionValue));
                setSelected(selected?.filter((selectedValue) => selectedValue !== value && !allSelectedChildrenValues.has(selectedValue)) || []);
                break;
            }
        }
    };
    return (jsxRuntime.exports.jsx(DropdownWrapper, { isOpen: isOpen, onClose: () => setIsOpen(false), menuWidth: menuWidth, target: jsxRuntime.exports.jsxs(StyledDropdownButton$1, { type: "button", name: id, isDisabled: isDisabled, disabled: isDisabled, isMenuOpen: isOpen, isError: isError, isSelected: !!selected, forceDarkMode: forceDarkMode, isMenuOpenAndForceDarkMode: isMenuOpenAndForceDarkMode, onClick: () => !isDisabled && setIsOpen((prev) => !prev), "aria-label": dropdownButtonAriaLabel, children: [jsxRuntime.exports.jsx(StyledSelected, { forceDarkMode: forceDarkMode, children: jsxRuntime.exports.jsx(SelectedLabel, { placeholder: placeholder, selectedOptions: selectedOptions, alwaysUsePlaceholderForButton: alwaysUsePlaceholderForButton }) }), jsxRuntime.exports.jsx(StyledArrowIcon$3, { icon: faChevronDown$1, "$isOpen": isOpen })] }), children: jsxRuntime.exports.jsx(StateManagedSelect, { forceDarkMode,
            isDisabled,
            isSearchable,
            placeholder,
            ref, "aria-label": selectSearchInputAriaLabel, backspaceRemovesValue: true, controlShouldRenderValue: true, hideSelectedOptions: false, isClearable: false, isMulti: true, menuIsOpen: true, name: id, options: unNestedOptions, styles: customStyles, tabSelectsValue: false, value: selectedOptions, components: {
                DropdownIndicator,
                Option: CheckboxItemWrapper,
                MultiValueRemove: MultiValueRemoveWrapper,
                IndicatorSeparator: null,
                ...(!isSearchable && { IndicatorsContainer: () => null }),
                ...(hideSelectedBadges && { MultiValue: () => null }),
            }, onChange: (newValue, actionMeta) => {
                if (newValue && !isDisabled)
                    getSelectedValueAndSet({ actionMeta });
            } }) }));
});

const StyledPathCardCarouselContainer = styled__default["default"](Container$1) `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
`;
const StyledCarousel = styled__default["default"].div `
  display: flex;
  overflow: hidden;
  margin: 4.6rem 0;
  border-radius: 0.5rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    max-width: unset;
    margin-right: -1.2rem;

    div > a {
      margin: 0 1.2rem 0 0;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    margin-right: -1.5rem;

    div > a {
      margin: 0 1.6rem 0 0;
    }
  }
`;
const StyledPathCardContainer = styled__default["default"].div `
  flex-shrink: 0;
  transition: transform 0.6s ease-in-out;
  width: calc(100% / ${({ itemsPerSlide }) => itemsPerSlide});
`;
const StyledPathCard = styled__default["default"](PathCard) `
  height: 24.2rem;

  > div:first-of-type {
    width: 100%;

    > img {
      height: unset;
      min-height: 19rem;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    height: 30rem;
  }
`;

const PathCardCarousel = ({ paths }) => {
    const itemsPerSlide = useItemsPerSlide();
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const handlers = useSwipeable({
        onSwipedLeft: () => {
            if (selectedIndex < paths.length - 1) {
                setSelectedIndex(selectedIndex + itemsPerSlide);
            }
        },
        onSwipedRight: () => {
            if (selectedIndex > 0) {
                setSelectedIndex(selectedIndex - itemsPerSlide);
            }
        },
        delta: 10,
        preventScrollOnSwipe: false,
        trackTouch: true,
        trackMouse: false,
        rotationAngle: 0,
        swipeDuration: Number.POSITIVE_INFINITY,
        touchEventOptions: { passive: true },
    });
    return (jsxRuntime.exports.jsxs(StyledPathCardCarouselContainer, { children: [jsxRuntime.exports.jsx(StyledCarousel, { ...handlers, "data-testid": "learn-and-practice-carousel", "aria-label": "Media carousel", children: paths.map(({ code, banner, title }, index) => (jsxRuntime.exports.jsx(StyledPathCardContainer, { "data-testid": `path-card-container-${index}`, itemsPerSlide: itemsPerSlide, style: {
                        transform: `translateX(${-100 * selectedIndex}%)`,
                    }, children: jsxRuntime.exports.jsx(StyledPathCard, { pathTitle: title, pathCode: code, pathImage: banner, buttonTheme: "primary", noImgSpinner: true }) }, code))) }), jsxRuntime.exports.jsx(CarouselDots, { itemsLength: paths.length, itemsPerSlide: itemsPerSlide, currentIndex: selectedIndex, onDotClick: (index) => {
                    setSelectedIndex(index);
                } })] }));
};

const slideIn = styled.keyframes `
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;
const slideInLeft = styled.keyframes `
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
`;
const slideOut = styled.keyframes `
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;
const slideOutLeft = styled.keyframes `
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
`;
const fadeIn = styled.keyframes `
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const fadeOut = styled.keyframes `
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
const StyledSideDrawerOverlay = styled__default["default"]($5d3850c4d0b4e6c7$export$c6fdb837b070b4ff) `
  position: fixed;
  inset: 0;
  background-color: ${darkColors.background.overlay};
  z-index: ${({ $zIndex }) => $zIndex ?? 50}; // fallback to 50

  &[data-state='open'] {
    animation: ${fadeIn} 200ms ease-out;
  }

  &[data-state='closed'] {
    animation: ${fadeOut} 200ms ease-out;
  }
`;
const StyledSideDrawer = styled__default["default"]($5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2) `
  position: fixed;
  top: 0;
  ${({ $position }) => ($position === 'right' ? 'right: 0;' : 'left: 0;')}
  bottom: 0;
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: ${({ $zIndex }) => $zIndex ?? 100}; // fallback to 100

  @media screen and (max-width: 468px) {
    max-width: 100%;
  }

  &:focus {
    outline: none;
  }

  &[data-state='open'] {
    animation: ${({ $position }) => ($position === 'right' ? slideIn : slideInLeft)} 300ms ease-out;
  }

  &[data-state='closed'] {
    animation: ${({ $position }) => ($position === 'right' ? slideOut : slideOutLeft)} 300ms ease-out;
  }
`;
const StyledSideDrawerHeader = styled__default["default"].header `
  padding: 4.6rem 4.6rem 1.4rem;
  border-bottom: ${({ theme, $hasBorder = true }) => $hasBorder ? `0.1rem solid ${theme.colors.border.dropdown}` : 'none'};
`;
const StyledSideDrawerTitle = styled__default["default"]($5d3850c4d0b4e6c7$export$f99233281efd08a0) `
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: 2.4rem;
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.main};
  margin: 0 0 0.8rem 0;
`;
const StyledSideDrawerSubtitle = styled__default["default"].h3 `
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  color: ${({ theme }) => theme.colors.text.lighter};
  margin: 1.5rem 0 0;
`;
const StyledSideDrawerDescription = styled__default["default"]($5d3850c4d0b4e6c7$export$393edc798c47379d) `
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.lighter};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  margin: 1.8rem 0 1.6rem;
`;
const StyledSideDrawerContent = styled__default["default"].div `
  flex: 1;
  padding: 3rem 4.6rem;
  overflow-y: auto;
`;
const StyledSideDrawerWrapper = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.colors.background.light};
  width: ${({ $width }) => $width ?? '50rem'};
  height: 100%;
`;
const StyledSideDrawerFooter = styled__default["default"].footer `
  padding: 1.8rem 2.4rem;
  border-top: 0.1rem solid ${({ theme }) => theme.colors.border.dropdown};
  display: flex;
  justify-content: flex-end;
  gap: 1.6rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    flex-direction: column-reverse;

    button {
      width: 100%;
    }
  }
`;
const StyledCloseIconButton = styled__default["default"]($5d3850c4d0b4e6c7$export$f39c2d165cd861fe) `
  display: none;

  @media screen and (max-width: 468px) {
    display: block;
    position: absolute;
    top: 1.8rem;
    right: 1.8rem;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0.5rem;
    color: ${({ theme }) => theme.colors.text.lighter};

    & svg {
      width: 2.5rem;
      height: 2.5rem;
    }

    &:hover {
      color: ${({ theme }) => theme.colors.text.main};
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.colors.primary.main};
      border-radius: ${({ theme }) => theme.radius.small};
    }
  }
`;

const SideDrawer = ({ triggerElement, isOpen, onOpenChange, defaultOpen, position = 'right', width = '50rem', children, hideCloseIcon = false, handleCloseButtonAction, preventCloseOnOutsideClick, zIndex, }) => (jsxRuntime.exports.jsxs($5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9, { open: isOpen, onOpenChange: onOpenChange, defaultOpen: defaultOpen, children: [triggerElement && jsxRuntime.exports.jsx($5d3850c4d0b4e6c7$export$41fb9f06171c75f4, { asChild: true, children: triggerElement }), jsxRuntime.exports.jsxs($5d3850c4d0b4e6c7$export$602eac185826482c, { children: [jsxRuntime.exports.jsx(StyledSideDrawerOverlay, { "data-testid": "rtl-overlay", onClick: (e) => preventCloseOnOutsideClick && e.stopPropagation(), "$zIndex": zIndex }), jsxRuntime.exports.jsx(StyledSideDrawer, { "$position": position, onInteractOutside: preventCloseOnOutsideClick ? (e) => e.preventDefault() : undefined, onPointerDownOutside: preventCloseOnOutsideClick ? (e) => e.preventDefault() : undefined, "$zIndex": zIndex, id: "side-drawer", children: jsxRuntime.exports.jsxs(StyledSideDrawerWrapper, { "$width": width, children: [children, !hideCloseIcon && (jsxRuntime.exports.jsx(StyledCloseIconButton, { "aria-label": "Close drawer", onClick: handleCloseButtonAction, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faXmark$2 }) }))] }) })] })] }));

const SideDrawerTitle = ({ visuallyHidden = false, className, children, }) => {
    const content = jsxRuntime.exports.jsx(StyledSideDrawerTitle, { className: className, children: children });
    if (!visuallyHidden)
        return content;
    return jsxRuntime.exports.jsx($ea1ef594cf570d83$export$be92b6f5f03c0fe9, { asChild: true, children: content });
};

const SideDrawerSubtitle = ({ visuallyHidden = false, className, children }) => {
    const content = jsxRuntime.exports.jsx(StyledSideDrawerSubtitle, { className: className, children: children });
    if (!visuallyHidden)
        return content;
    return jsxRuntime.exports.jsx($ea1ef594cf570d83$export$be92b6f5f03c0fe9, { asChild: true, children: content });
};

const SideDrawerDescription = ({ visuallyHidden = false, className, children, }) => {
    const content = jsxRuntime.exports.jsx(StyledSideDrawerDescription, { className: className, children: children });
    if (!visuallyHidden)
        return content;
    return jsxRuntime.exports.jsx($ea1ef594cf570d83$export$be92b6f5f03c0fe9, { asChild: true, children: content });
};

const SideDrawerContent = ({ children, className }) => (jsxRuntime.exports.jsx(StyledSideDrawerContent, { className: className, "data-testid": "side-drawer-content", children: children }));

const SideDrawerHeader = ({ children, className, hasBorder = true }) => (jsxRuntime.exports.jsx(StyledSideDrawerHeader, { className: className, "$hasBorder": hasBorder, "data-testid": "side-drawer-header", children: children }));

const SideDrawerFooter = ({ children, className }) => (jsxRuntime.exports.jsx(StyledSideDrawerFooter, { className: className, "data-testid": "side-drawer-footer", children: children }));

const StyledSideNav = styled__default["default"].nav `
  position: relative;
  border-left: ${({ theme }) => `3px solid ${theme.colors.primary.main}`};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  padding: 0.9rem 3rem 2.1rem 3rem;
  width: 30.6rem;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.colors.background.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  overflow: auto;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    width: 100%;
  }

  & > :not(div) {
    transition: 0.2s ease-in-out background-color;
    display: flex;
    align-items: center;
    min-height: 3.4rem;
    border-radius: 0.5rem;
    padding: 0.9rem 3rem;
    overflow: hidden;
    line-height: 1.6rem;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.sideNav.text};

    &.active {
      font-weight: ${({ theme }) => theme.fonts.weight.bolder};
      color: ${({ theme }) => theme.colors.sideNav.sectionHeader};

      ::before {
        content: '';
        border: 1rem solid transparent;
        border-right: 0;
        border-left: ${({ theme }) => `1.7rem solid ${theme.colors.primary.main}`};
        position: absolute;
        left: 0;
      }
    }

    :hover {
      background-color: ${({ theme }) => theme.colors.formSelect.optionHover};
    }
  }
`;

const SideNav = ({ children, ...nativeNavProps }) => (jsxRuntime.exports.jsx(StyledSideNav, { "aria-label": nativeNavProps['aria-label'] || 'Secondary', ...nativeNavProps, children: children }));

const StyledSideNavHeader = styled__default["default"].div `
  display: flex;
  align-items: center;
  padding-bottom: 1rem;
  margin: 2.1rem 0 1.5rem 0;
  border-bottom: ${({ theme }) => `0.1rem solid ${theme.colors.border.dropdown}`};
  color: ${({ theme }) => `${theme.colors.sideNav.sectionHeader}`};
`;
const StyledSideNavHeaderIcon = styled__default["default"](FontAwesomeIcon) `
  font-size: 2rem;
  margin-right: 1rem;
  color: ${({ theme }) => `${theme.colors.sideNav.sectionHeader}`};
`;

const SideNavHeader = ({ icon = faGear, text }) => (jsxRuntime.exports.jsxs(StyledSideNavHeader, { children: [jsxRuntime.exports.jsx(StyledSideNavHeaderIcon, { icon: icon }), text] }));

const StyledLoadingWrapper$1 = styled__default["default"].section `
  width: 100%;
  padding: 2rem;

  span {
    ${StyledLoadingPlaceholder};
    margin-bottom: 2rem;
    display: block;
    height: 4rem;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

const Loading$1 = () => (jsxRuntime.exports.jsxs(StyledLoadingWrapper$1, { "data-testid": "loading", children: [jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsx("span", {})] }));

const setAlignToLeftColumns = (alignToLeftColumns) => {
    const columns = alignToLeftColumns.map((col) => `
      & > div:nth-child(${col}) {
        justify-self: left;
      }
    `);
    return columns;
};
const StyledTableGrid = styled.css `
  color: ${({ theme }) => theme.colors.text.main};
  display: grid;
  font-size: 1.6rem;
  justify-content: space-between;
`;
const StyledTable = styled__default["default"].div `
  background: ${({ theme }) => theme.colors.background.light};
  border-radius: ${({ theme }) => theme.radius?.small};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
`;
const StyledTableHeader = styled__default["default"].div `
  ${StyledTableGrid};
  grid-template-columns: ${({ columns = 'repeat(auto-fit, minmax(70px, 1fr)' }) => columns};
  padding: 3.5rem;
  justify-items: center;
  ${({ alignToLeftColumns }) => (alignToLeftColumns ? setAlignToLeftColumns(alignToLeftColumns) : '')}

  & > div {
    text-align: center;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    padding: 2.4rem 2rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: none;
  }
`;
const StyledTableContent = styled__default["default"].div `
  & > div {
    ${StyledTableGrid};
    align-items: center;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.main};
    grid-template-columns: ${({ columns = 'repeat(auto-fit, minmax(70px, 1fr)' }) => columns};
    padding: 0.9rem 3.5rem;
    justify-items: center;
    transition: all 0.3s ease-in-out;
    ${({ alignToLeftColumns }) => (alignToLeftColumns ? setAlignToLeftColumns(alignToLeftColumns) : '')}

    &:last-of-type {
      border-bottom: none;
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.border.main};
    }

    @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
      padding: 1.5rem 2rem;
    }

    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      padding: 1.5rem 1.7rem;
      grid-template-columns: ${({ columnsMobile = '1fr' }) => columnsMobile};
      justify-items: left;
    }
  }
`;

const Table = ({ children, columns, dataHead, columnsMobile, alignToLeftColumns, isLoading }) => (jsxRuntime.exports.jsxs(StyledTable, { role: "table", children: [dataHead ? (jsxRuntime.exports.jsx(StyledTableHeader, { role: "row", columns: columns, columnsMobile: columnsMobile, alignToLeftColumns: alignToLeftColumns, children: dataHead.map((head) => (jsxRuntime.exports.jsx("div", { role: "columnheader", children: head }, head))) })) : null, isLoading ? (jsxRuntime.exports.jsx(Loading$1, {})) : (jsxRuntime.exports.jsx(StyledTableContent, { columns: columns, columnsMobile: columnsMobile, alignToLeftColumns: alignToLeftColumns, role: "rowgroup", children: children }))] }));

const StyledTagInputContainer = styled__default["default"].div `
  background-color: ${({ theme }) => theme.colors.background.secondary};
  padding: 0.625rem 0.75rem 0.625rem 1rem;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.border.dropdown};
  margin-top: 0.56rem;
`;
const StyledTagInput = styled__default["default"].input `
  background-color: ${({ theme }) => theme.colors.background.secondary};
  flex-grow: 1;
  outline: 0;
  border: none;
  color: ${({ theme }) => theme.colors.text.light};
  height: 2.45rem;
`;
const StyledSpan = styled__default["default"].span `
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  margin-top: 0.3rem;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  color: ${({ theme }) => theme.colors.text.lighter};
`;
const StyledTagText = styled__default["default"].span `
  font-size: 12px;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  color: ${({ theme }) => theme.colors.text.main};
`;

const TagsInput = ({ defaultValue, onTagsChange, labelText, id, infoText = '', isDisabled = false, onTagDismiss, ...nativeInputProps }) => {
    const [tags, setTags] = React.useState([]);
    const [inputText, setInputText] = React.useState('');
    React.useEffect(() => {
        const defaultTags = handleDefaultValue(defaultValue);
        setTags(defaultTags);
    }, [defaultValue]);
    const handleKeyDown = (event) => {
        const cleanedInputText = inputText.trim().replace(/\s+/g, ' ');
        if ((event.key === 'Enter' || event.key === ',') && cleanedInputText.length) {
            event.preventDefault();
            if (!tags.includes(cleanedInputText)) {
                const updatedTags = [...tags, cleanedInputText];
                handleonTagsChange(updatedTags);
                setTags(updatedTags);
            }
            setInputText('');
        }
        if (!cleanedInputText && tags.length && event.key === 'Backspace') {
            const tagsArray = tags.slice(0, -1);
            handleonTagsChange(tagsArray);
            onTagDismiss?.(tags.pop());
            setTags(tagsArray);
        }
    };
    const handleDismissTag = (tag) => {
        const tagsArray = tags.filter((tagItem) => tagItem !== tag);
        handleonTagsChange(tagsArray);
        setTags(tagsArray);
        onTagDismiss?.(tag);
    };
    const handleonTagsChange = (tagsToSend) => {
        onTagsChange?.({ commaSeparatedString: tagsToSend.join(','), tagsArray: [...tagsToSend] });
    };
    const handleInputOnChange = (e) => {
        if (e.currentTarget.value.at(-1) !== ',')
            setInputText(e.currentTarget.value);
    };
    return (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(FormLabel, { htmlFor: id ?? 'tags-input', children: labelText ?? 'Tags' }), jsxRuntime.exports.jsxs(StyledTagInputContainer, { children: [jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, { children: tags.map((tag) => (jsxRuntime.exports.jsx(Tag, { "data-testid": "tag", type: "dismissable", size: "small", color: "background", textColor: "main", variation: "grey", handleDismissTag: () => handleDismissTag(tag), children: jsxRuntime.exports.jsx(StyledTagText, { children: tag }) }, tag))) }), jsxRuntime.exports.jsx(StyledTagInput, { ...nativeInputProps, id: id ?? 'tags-input', "aria-label": "Tag text", "data-testid": "inputTagText", value: inputText, onChange: handleInputOnChange, onKeyDown: handleKeyDown, disabled: isDisabled })] }), jsxRuntime.exports.jsx(StyledSpan, { children: infoText })] }));
};
const handleDefaultValue = (defaultValue) => {
    if (typeof defaultValue === 'string') {
        const tags = defaultValue.trim().split(',');
        const tagsSet = new Set(tags);
        return [...tagsSet];
    }
    if (Array.isArray(defaultValue)) {
        const tagsSet = new Set(defaultValue);
        return [...tagsSet];
    }
    return [];
};

const resolveChild = (props) => {
    switch (props.variant) {
        case 'select': {
            return jsxRuntime.exports.jsx(FormSelect, { ...props });
        }
        case 'textarea': {
            const { innerRef } = props;
            return jsxRuntime.exports.jsx(FormTextArea, { ref: innerRef, ...props });
        }
        default: {
            const { innerRef } = props;
            return jsxRuntime.exports.jsx(FormInput, { ref: innerRef, ...props });
        }
    }
};
const TextField = ({ bottomAdornment, id, label, leftOutsideAdornment, rightOutsideAdornment, labelRightSideAdornment, labelPosition = 'top', errorMessage = '', isDisabled = false, customlabelMargin, isRequired = false, forceDarkMode = false, isOptionalLabel = false, ...otherTextFieldProps }) => {
    let leftAdornment;
    let rightAdornment;
    if (otherTextFieldProps.variant === 'input') {
        leftAdornment = otherTextFieldProps.leftAdornment;
        rightAdornment = otherTextFieldProps.rightAdornment;
    }
    const { isSuccess, isError } = otherTextFieldProps;
    const internalAdornments = React.useMemo(() => ({
        leftAdornment,
        rightAdornment: rightAdornment || isSuccess || isError ? (jsxRuntime.exports.jsxs(StyledIconGroupWrapper, { children: [rightAdornment, isSuccess && jsxRuntime.exports.jsx(StyledValidatedIcon, { icon: faCheckCircle$1, title: "Field is valid" }), isError && jsxRuntime.exports.jsx(StyledErrorIcon$1, { icon: faCircleExclamation, title: "Field is not valid" })] })) : undefined,
    }), [leftAdornment, rightAdornment, isSuccess, isError]);
    const labelComponent = (jsxRuntime.exports.jsx(FormLabel, { isDisabled, customlabelMargin, labelPosition, htmlFor: id, isRequired, isOptionalLabel, children: label }));
    return (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsxs(StyledTextFieldWithLabelWrapper, { labelPosition: labelPosition, children: [label && !labelRightSideAdornment && labelComponent, label && labelRightSideAdornment && (jsxRuntime.exports.jsxs(StyledLabelWrapper, { children: [labelComponent, labelRightSideAdornment] })), leftOutsideAdornment || rightOutsideAdornment || bottomAdornment ? (jsxRuntime.exports.jsx(FieldAdorned, { leftOutsideAdornment, rightOutsideAdornment, bottomAdornment, children: resolveChild({
                            id,
                            isDisabled,
                            forceDarkMode,
                            ...otherTextFieldProps,
                            ...internalAdornments,
                        }) })) : (jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, { children: resolveChild({
                            id,
                            isDisabled,
                            forceDarkMode,
                            ...otherTextFieldProps,
                            ...internalAdornments,
                        }) }))] }), errorMessage && jsxRuntime.exports.jsx(FormErrorMessage, { children: errorMessage })] }));
};

const getProgressColor = (characterCount, isOverLimit, defaultColor) => {
    if (isOverLimit || characterCount >= 900) {
        return 'rgba(255, 91, 103, 1)';
    }
    if (characterCount >= 700) {
        return 'rgba(255, 187, 69, 1)';
    }
    return defaultColor;
};
const StyledChatFooter = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  padding: 1.6rem;
  border-radius: 0 0 0.6rem 0.6rem;
  color: ${({ theme }) => theme.colors.text.invert};
  border-top: 0.1rem solid rgba(62, 71, 90, 1);

  ${({ $isEmbedded }) => !$isEmbedded &&
    styled.css `
      padding: 0;
      border-radius: 0;
      border-top: none;
    `}
`;
const StyledFormContainer = styled__default["default"].form `
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  width: 100%;

  ${({ $isEmbedded }) => !$isEmbedded &&
    styled.css `
      padding: 1rem 1.6rem;
      border-radius: 0 0 0.6rem 0.6rem;
      border-top: 0.1rem solid rgba(62, 71, 90, 1);
    `}
`;
const StyledInputContainer = styled__default["default"].div `
  display: flex;
  width: 100%;

  ${({ $isEmbedded }) => $isEmbedded &&
    styled.css `
      padding: 0.8rem 1.6rem;
      border: 0.1rem solid rgba(62, 71, 90, 1);
      border-radius: 0.6rem;
    `}
`;
const StyledInputText = styled__default["default"].textarea `
  width: 100%;
  padding: 1rem 0 1rem 0.6rem;
  border: none;
  background: none;
  resize: none;
  overflow-y: ${(props) => (props.$rows >= 4 ? 'auto' : 'hidden')};
  color: ${({ theme }) => theme.colors.grey[100]};
  line-height: 1.3;
  height: ${(props) => props.$rows * 1.7}rem;
  min-height: 3.9rem;
  transition: height 0.3s ease-in-out;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'auto')};
  white-space: pre-wrap;
  word-wrap: break-word;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.grey[400]};
    font-family: ${({ theme }) => theme.fonts.familySansPro};
  }

  &::-webkit-scrollbar {
    width: 0.6rem;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.grey[900]};
    border-radius: 0.3rem;
  }
`;
const StyledFooterContainer = styled__default["default"].div `
  display: flex;
  align-items: center;
  justify-content: ${({ $showProgress }) => ($showProgress ? 'space-between' : 'flex-end')};
  gap: 0.8rem;
  width: 100%;
`;
const StyledProgressBarContainer = styled__default["default"].div `
  flex: 1;
  height: 0.7rem;
  background-color: rgba(33, 44, 66, 1);
  border-radius: 0.2rem;
  overflow: hidden;
`;
const StyledProgressBar = styled__default["default"].div `
  height: 100%;
  border-radius: 0.2rem;
  transition: width 0.2s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.3s ease-in-out;
  width: ${(props) => Math.min(props.$percentage, 100)}%;
  
  background-color: ${({ $characterCount, $isOverLimit }) => getProgressColor($characterCount, $isOverLimit, 'rgba(17, 83, 228, 1)')};
`;
const StyledCharacterCount = styled__default["default"].span `
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  white-space: nowrap;
  transition: color 0.3s ease-in-out;
  
  color: ${({ $characterCount, $isOverLimit }) => getProgressColor($characterCount, $isOverLimit, 'rgba(113, 156, 249, 1)')};
`;
const StyledSendButton = styled__default["default"].button `
  flex-shrink: 0;
  height: 3.6rem;
  width: 3.6rem;
  color: rgba(113, 156, 249, 1);
  background-color: rgba(33, 44, 66, 1);
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  border: none;
  border-radius: 0.4rem;
  cursor: pointer;
  transition: transform 0.15s ease-out, opacity 0.15s ease-out, color 0.3s ease-out, background-color 0.3s ease-out;

  transform: ${(props) => (props.$visible ? 'scale(1)' : 'scale(0)')};
  opacity: ${(props) => (props.$visible ? 1 : 0)};
  pointer-events: ${(props) => (props.$visible ? 'auto' : 'none')};
  visibility: ${(props) => (props.$visible ? 'visible' : 'hidden')};

  &:hover {
    background-color: rgba(62, 71, 90, 1);
    color: rgba(163, 234, 42, 1);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

function useTextAreaRows(initialValue = '') {
    const [message, setMessage] = React.useState(initialValue);
    const [rows, setRows] = React.useState(1);
    const textareaRef = React.useRef(null);
    const updateRows = React.useCallback(() => {
        if (textareaRef.current) {
            const textarea = textareaRef.current;
            const computedStyle = window.getComputedStyle(textarea);
            const lineHeight = Number.parseInt(computedStyle.lineHeight, 10);
            if (message.trim() === '') {
                setRows(1);
            }
            else {
                const currentRows = Math.floor((textarea.scrollHeight -
                    Number.parseInt(computedStyle.paddingTop, 10) -
                    Number.parseInt(computedStyle.paddingBottom, 10)) /
                    lineHeight);
                const newRows = Math.min(Math.max(currentRows, 1), 6);
                if (newRows !== rows) {
                    setRows(newRows);
                }
            }
        }
    }, [message, rows]);
    React.useEffect(() => {
        updateRows();
    }, [updateRows, message]);
    const handleChange = (e) => {
        setMessage(e.target.value);
    };
    const resetTextArea = () => {
        setMessage('');
        setRows(1);
    };
    return { message, rows, textareaRef, handleChange, resetTextArea };
}
const ChatFooter = ({ onSubmit, isInputDisabled = false, isEmbedded = false, isTooltipDisabled = false, maxLength = 1000, showCharacterCount = true, }) => {
    const [isButtonVisible, setIsButtonVisible] = React.useState(false);
    const { message, rows, textareaRef, handleChange, resetTextArea } = useTextAreaRows();
    const characterCount = message.length;
    const isOverLimit = characterCount > maxLength;
    const canSubmit = message.trim() !== '' && !isOverLimit;
    const percentage = (characterCount / maxLength) * 100;
    React.useEffect(() => {
        if (message.trim() === '') {
            setIsButtonVisible(false);
        }
        else {
            setIsButtonVisible(true);
        }
    }, [message]);
    const focusTextarea = React.useCallback(() => {
        if (textareaRef.current && !isInputDisabled) {
            setTimeout(() => {
                textareaRef.current?.focus();
            }, 0);
        }
    }, [textareaRef, isInputDisabled]);
    React.useEffect(() => {
        focusTextarea();
    }, [focusTextarea, isInputDisabled]);
    const submitMessage = React.useCallback(() => {
        if (canSubmit) {
            onSubmit(message.trim());
            resetTextArea();
            focusTextarea();
        }
    }, [canSubmit, message, onSubmit, resetTextArea, focusTextarea]);
    const handleSubmit = (e) => {
        e.preventDefault();
        submitMessage();
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            submitMessage();
        }
    };
    return (jsxRuntime.exports.jsx(SmallTooltipWrapper, { id: "chat-window-footer-tooltip-wrapper", tooltipText: "Echo is unable to receive messages now.", position: "top", visible: isInputDisabled && !isTooltipDisabled, styles: { width: '100%' }, children: jsxRuntime.exports.jsx(StyledChatFooter, { id: "chat-window-footer-wrapper", "$isEmbedded": isEmbedded, children: jsxRuntime.exports.jsxs(StyledFormContainer, { onSubmit: handleSubmit, role: "form", "$isEmbedded": isEmbedded, children: [jsxRuntime.exports.jsx(StyledInputContainer, { "$isEmbedded": isEmbedded, children: jsxRuntime.exports.jsx(StyledInputText, { id: "chat-window-footer-textarea", ref: textareaRef, value: message, disabled: isInputDisabled, onChange: handleChange, onKeyDown: handleKeyDown, placeholder: "Type your message...", maxLength: maxLength + 100, "$rows": rows, "aria-describedby": showCharacterCount && characterCount > 0 ? 'chat-character-counter' : undefined, "aria-invalid": isOverLimit }) }), jsxRuntime.exports.jsxs(StyledFooterContainer, { "$isEmbedded": isEmbedded, "$showProgress": showCharacterCount && characterCount >= 350, children: [showCharacterCount && characterCount > 0 && (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(StyledProgressBarContainer, { children: jsxRuntime.exports.jsx(StyledProgressBar, { "$characterCount": characterCount, "$percentage": percentage, "$isOverLimit": isOverLimit, role: "progressbar", "aria-valuenow": characterCount, "aria-valuemin": 0, "aria-valuemax": maxLength }) }), jsxRuntime.exports.jsxs(StyledCharacterCount, { id: "chat-character-counter", "$characterCount": characterCount, "$maxLength": maxLength, "$isOverLimit": isOverLimit, "aria-live": "polite", "aria-atomic": "true", children: [characterCount, "/", maxLength] })] })), isButtonVisible && !isInputDisabled && (jsxRuntime.exports.jsx(SmallTooltipWrapper, { id: "chat-window-footer-send-tooltip", tooltipText: isOverLimit ? 'Message is too long' : 'Send message', position: "top", visible: isButtonVisible, children: jsxRuntime.exports.jsx(StyledSendButton, { type: "submit", "data-testid": "chat-footer-send-icon", disabled: isInputDisabled || isOverLimit, "$visible": isButtonVisible, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: faPaperPlaneTop }) }, "chat-footer-send-icon") }))] })] }) }) }));
};

const slideInFromLeft = styled.keyframes `
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;
const ChatIntroMessageContainer = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  background: linear-gradient(0deg, rgba(66, 34, 157, 1) 0%, rgba(0, 0, 0, 0) 100%);
  padding: 1.6rem;
  gap: 1.6rem;
  border-radius: 0.8rem;
  transition: all 0.5s ease-out;
  animation: ${slideInFromLeft} 0.5s ease-out;
  border: 1px solid rgba(102, 0, 202, 1);
`;
const Header = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  gap: 0.6rem;

  h4 {
    font-size: ${({ theme }) => theme.fonts.sizes.small};
    margin: 0;
    color: rgba(249, 249, 251, 1);
  }

  p {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    color: rgba(226, 232, 240, 1);
  }
`;
const Body = styled__default["default"].ul `
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.6rem;
  padding-left: 0.6rem;
`;
const Option = styled__default["default"].li `
  display: flex;
  align-items: start;
  gap: 0.8rem;

  span {
    color: rgba(249, 249, 251, 1);
    margin-top: -0.5rem;
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    font-weight: ${({ theme }) => theme.fonts.weight.regular};
    font-style: normal;
    line-height: 2.6rem;
  }
`;
const OptionIcon = styled__default["default"](FontAwesomeIcon) `
  color: rgba(215, 82, 255, 1);
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  width: 1.6rem;
  height: 1.4rem;
`;
const Footer = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  p {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    color: rgba(226, 232, 240, 1);
  }
`;
const Buttons = styled__default["default"].div `
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;
const Button = styled__default["default"].button `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.8rem;
  gap: 0.5rem;
  padding: 0.8rem 1rem;
  border-radius: 0.4rem;
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  color: ${({ $isPrimary }) => ($isPrimary ? 'rgba(21, 28, 43, 1)' : 'rgba(249, 249, 251, 1)')};
  background-color: ${({ $isPrimary }) => ($isPrimary ? 'rgba(249, 249, 251, 1)' : 'rgba(21, 28, 43, 1)')};
  border: 1px solid ${({ $isPrimary }) => ($isPrimary ? '#D4D8DF' : '#3E475A')};
  transition: all 0.2s ease-in-out;

  &:hover {
    opacity: 0.8;
  }
`;

const defaultChatIntroMessage = {
    header: `<h4>Hello there! </h4><p>I am Echo! Your AI tutor. With my help you will:</p>`,
    body: {
        options: [
            {
                icon: faSparkles,
                text: 'Get real-time insights and suggestions from your actions on virtual machines.',
                key: 'real-time-insights-option',
            },
            {
                icon: faGaugeCircleBolt,
                text: 'Boost your learning speed and efficiency.',
                key: 'boost-learning-speed-option',
            },
            {
                icon: faLightbulb,
                text: 'Get a better understanding of room concepts and tasks.',
                key: 'better-understanding-option',
            },
        ],
    },
    footer: {
        text: 'Stuck or want to chat? Let me know!',
        buttons: [
            {
                icon: faArrowRight$1,
                text: "I'm stuck",
                isPrimary: true,
                isVisible: true,
                key: 'stuck-button',
                onClick: () => { },
            },
            {
                icon: faQuestionCircle,
                text: 'Learn more about me',
                isPrimary: false,
                isVisible: true,
                key: 'learn-more-button',
                onClick: () => { },
            },
        ],
    },
    isVisible: false,
};
const ChatIntroMessage = ({ header, body, footer, onButtonClick, } = defaultChatIntroMessage) => {
    const handleButtonClick = (key, originalOnClick) => {
        if (onButtonClick) {
            onButtonClick(key);
        }
        originalOnClick();
    };
    return (jsxRuntime.exports.jsxs(ChatIntroMessageContainer, { children: [jsxRuntime.exports.jsx(Header, { dangerouslySetInnerHTML: { __html: header } }), jsxRuntime.exports.jsx(Body, { children: body.options.map((option) => (jsxRuntime.exports.jsxs(Option, { children: [jsxRuntime.exports.jsx(OptionIcon, { icon: option.icon }), jsxRuntime.exports.jsx("span", { children: option.text })] }, option.key))) }), jsxRuntime.exports.jsxs(Footer, { children: [jsxRuntime.exports.jsx("p", { children: footer.text }), jsxRuntime.exports.jsx(Buttons, { children: footer.buttons
                            .filter((button) => button.isVisible)
                            .map((button) => (jsxRuntime.exports.jsxs(Button, { "$isPrimary": button.isPrimary, onClick: () => handleButtonClick(button.key, button.onClick), children: [jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: button.icon }), button.text] }, button.key))) })] })] }));
};

const TRANSITION_DURATION = 1.5;
const StyledChat = styled__default["default"].div `
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  transition: width ${TRANSITION_DURATION}s ease-in-out;
  background-color: rgba(21, 28, 43, 1);
  box-shadow: rgba(0, 0, 0, 0.6);
  border-radius: 0.6rem;

  #chat-window-header {
    cursor: ${({ $draggingState }) => ($draggingState === 'dragging' ? 'grabbing' : 'grab')};
  }
`;
const StyledChatContentContainer = styled__default["default"].div `
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
`;
const StyledChatContent = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  max-height: 100%;
  padding: ${({ theme }) => theme.fonts.sizes.default};
  gap: ${({ theme }) => theme.fonts.sizes.default};
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  overflow-anchor: auto !important;
  overscroll-behavior: contain;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(33, 44, 66, 1);
    margin: 10px 0 10px 0;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.grey[700]};
    border-radius: 8px;
    width: 8px;

    :hover {
      background-color: ${({ theme }) => theme.colors.grey[500]};
    }
  }
`;
const StyledLargeLoader = styled__default["default"].div `
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
  height: 100%;
`;
const StyledChatMessages = styled__default["default"].div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.fonts.sizes.default};
  background-color: rgba(21, 28, 43, 1);
  transition: height ${TRANSITION_DURATION}s ease-in-out;
`;
const StyledJumpDownIconContainer = styled__default["default"].div `
  position: absolute;
  bottom: 2rem;
  right: 0.8rem;
  display: grid;
  place-items: center;
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  background-color: ${({ theme }) => theme.colors.secondary.light};
  border-radius: 0.6rem 0 0 0.6rem;
  padding: 0.6rem;
  cursor: pointer;
  height: 3.5rem;
  width: 3.5rem;

  transition: all 0.15s ease-out;
  transform: ${({ $isVisible }) => ($isVisible ? 'scale(1)' : 'scale(0)')};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondary.lighter};
  }
`;
const StyledJumpDownIcon = styled__default["default"](FontAwesomeIcon) `
  color: white;
  height: 2rem;
  width: 2rem;

  &:hover {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;
const StyledFooter = styled__default["default"].div `
  position: relative;
  display: grid;
`;
const StyledBanner = styled__default["default"].div `
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  height: 4.2rem;
  width: 100%;
  background-color: rgba(28, 37, 56, 1);
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  padding: 1rem;
`;
const StyledBannerText = styled__default["default"].p `
  flex-grow: 1;
  text-align: center;
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  color: ${({ theme }) => theme.colors.grey[200]};

  a {
    color: rgba(113, 156, 249, 1);
    text-decoration: none;
  }
`;
const StyledBannerCloseIcon = styled__default["default"](FontAwesomeIcon) `
  color: white;
  height: 1.2rem;
  width: 1.2rem;
  cursor: pointer;
  align-self: flex-start;
  transition: all 0.15s ease-out;
  &:hover {
    color: ${({ theme }) => theme.colors.grey[500]};
  }
`;
const StyledLastAction = styled__default["default"].div `
  justify-self: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  gap: 0.8rem;
  color: rgba(238, 239, 242, 1);
  background-color: ${({ $isLoading }) => ($isLoading ? 'rgba(44, 39, 39, 1)' : 'rgba(33, 44, 66, 1)')};
  border-radius: 2.6rem;
  padding: 0.4rem 1rem 0.4rem 0.8rem;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  transition: all 0.15s ease-out;

  span {
    border-left: 1px solid rgba(62, 71, 90, 1);
    padding-left: 0.8rem;
  }
`;
const StyledLastActionIcon = styled__default["default"].div `
  background-color: ${({ $isLoading }) => ($isLoading ? 'rgba(73, 67, 59, 1)' : 'rgba(51, 74, 9, 1)')};
  color: ${({ $isLoading }) => ($isLoading ? 'rgba(255, 187, 69, 1)' : 'rgba(163, 234, 42, 1)')};
  height: 2.2rem;
  width: 2.2rem;
  border-radius: 10rem;
  display: grid;
  place-items: center;

  * {
    width: 1.1rem;
    height: 1.1rem;
  }
`;

const ChatWindow = ({ messages, onVotingClick, onSuggestionClick, onSendMessageClick, onHeaderHover = () => { }, persona, isLoading, error, isInputDisabled, landingPageUrl = DEFAULT_TUTOR_LANDING_PAGE_URL, termsOfUseBanner, introMessage, headerOptions, isBeta = true, draggingState = 'idle', displayMode = 'floating', lastAction, suggestionsDisabled, askEchoPrompt, isVotingDisabled, isTooltipDisabled = false, isFooterVisible = true, maxMessageLength = 1000, showCharacterCount = true, }) => {
    const chatContentRef = React.useRef(null);
    const [showJumpDown, setShowJumpDown] = React.useState(false);
    const [isTermsOfUseBannerVisible, setIsTermsOfUseBannerVisible] = React.useState(termsOfUseBanner && termsOfUseBanner.isVisible);
    const scrollToBottom = React.useCallback(() => {
        if (chatContentRef.current) {
            chatContentRef.current.scrollTop = chatContentRef.current.scrollHeight;
        }
    }, []);
    React.useLayoutEffect(() => {
        scrollToBottom();
        setTimeout(scrollToBottom, 200);
    }, [scrollToBottom, isLoading, messages.length]);
    const handleScroll = React.useCallback(() => {
        if (chatContentRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = chatContentRef.current;
            const isScrolledUp = scrollHeight - scrollTop - clientHeight > 400;
            setShowJumpDown(isScrolledUp);
        }
    }, []);
    React.useEffect(() => {
        const chatContent = chatContentRef.current;
        if (chatContent) {
            chatContent.addEventListener('scroll', handleScroll);
            return () => chatContent.removeEventListener('scroll', handleScroll);
        }
        return () => { };
    }, [handleScroll]);
    const indexOfLastSystemMessage = messages.reduce((acc, message, index) => {
        if (message.sender !== exports.Sender.USER) {
            return index;
        }
        return acc;
    }, -1);
    const isLastMessageFromSystem = indexOfLastSystemMessage === messages.length - 1;
    const formatDate = (date) => {
        if (dateFns.isToday(date)) {
            return dateFns.format(date, 'hh:mm a');
        }
        if (dateFns.isThisWeek(date, {
            weekStartsOn: 1,
        })) {
            return dateFns.format(date, 'EEE hh:mm a');
        }
        return dateFns.format(date, 'MMM dd, yyyy');
    };
    return (jsxRuntime.exports.jsxs(StyledChat, { "data-testid": "chat-window", "$draggingState": draggingState, "$displayMode": displayMode, children: [jsxRuntime.exports.jsx(SmallTooltipWrapper, { id: "chat-window-header", tooltipText: "Click, hold & drag the window to reposition it anywhere on the screen.", position: "top", visible: displayMode === 'floating' && !isTooltipDisabled, children: jsxRuntime.exports.jsx(ChatHeader, { persona: persona, options: headerOptions, landingPageUrl: landingPageUrl, isBeta: isBeta, isEmbedded: displayMode === 'embedded', handleHover: onHeaderHover }) }), jsxRuntime.exports.jsx(StyledChatContentContainer, { children: jsxRuntime.exports.jsxs(StyledChatContent, { id: "chat-content-overlay", "data-testid": "chat-content-overlay", ref: chatContentRef, children: [introMessage && introMessage.isVisible && jsxRuntime.exports.jsx(ChatIntroMessage, { ...introMessage }), messages.length === 0 && isLoading && (jsxRuntime.exports.jsx(StyledLargeLoader, { children: jsxRuntime.exports.jsx(ChatLoader, { "$type": "wave" }) })), (messages.length > 0 || error) && (jsxRuntime.exports.jsxs(StyledChatMessages, { children: [messages.map((m, index) => {
                                    if (introMessage && introMessage.isVisible && index === 0 && m.sender !== exports.Sender.USER)
                                        return null;
                                    return (jsxRuntime.exports.jsx(ChatBubble, { chatMessage: m, persona: persona, shouldAnimate: index + 1 === messages.length && m.type !== 'hint', isMostRecentSystemMessage: index === indexOfLastSystemMessage && isLastMessageFromSystem, areActionsDisabled: suggestionsDisabled ?? isInputDisabled ?? isLoading, isVotingDisabled: isVotingDisabled, handleMessageVoting: onVotingClick, onSuggestionClick: onSuggestionClick, askEchoPrompt: askEchoPrompt }, m.id));
                                }), isLoading && jsxRuntime.exports.jsx(ChatLoader, { "$type": "wave" }), error && jsxRuntime.exports.jsx(ChatError, { ...error })] })), jsxRuntime.exports.jsx(StyledJumpDownIconContainer, { onClick: scrollToBottom, "$isVisible": showJumpDown, "data-testid": "jump-down-button", children: jsxRuntime.exports.jsx(StyledJumpDownIcon, { icon: faCircleArrowDown }) })] }) }), isFooterVisible && (jsxRuntime.exports.jsxs(StyledFooter, { children: [lastAction && lastAction.isVisible && (jsxRuntime.exports.jsxs(StyledLastAction, { "$isLoading": lastAction.isLoading, "data-testid": "tutor-last-action-container", "data-state": lastAction.isLoading ? 'loading' : 'visible', children: [jsxRuntime.exports.jsx(StyledLastActionIcon, { "$isLoading": lastAction.isLoading, children: jsxRuntime.exports.jsx(FontAwesomeIcon, { icon: lastAction.isLoading ? faSpinnerThird : faRadar, spin: lastAction.isLoading }) }), lastAction.isLoading ? lastAction.loadingMessage : `${lastAction.actionMessage} ${lastAction.action}`, !lastAction.isLoading && jsxRuntime.exports.jsx("span", { children: formatDate(new Date(lastAction.timestamp)) })] })), termsOfUseBanner && isTermsOfUseBannerVisible && (jsxRuntime.exports.jsxs(StyledBanner, { children: [jsxRuntime.exports.jsx(StyledBannerText, { children: termsOfUseBanner.content }), jsxRuntime.exports.jsx(StyledBannerCloseIcon, { icon: faClose, onClick: () => {
                                    setIsTermsOfUseBannerVisible(false);
                                    termsOfUseBanner.onClick?.();
                                }, "data-testid": "chat-terms-of-use-close-icon" })] })), jsxRuntime.exports.jsx(ChatFooter, { onSubmit: onSendMessageClick, isInputDisabled: isInputDisabled || isLoading, isEmbedded: displayMode === 'embedded', isTooltipDisabled: isTooltipDisabled, maxLength: maxMessageLength, showCharacterCount: showCharacterCount })] }))] }));
};

const StyledWrapperCountryFlag = styled__default["default"].div `
  position: relative;

  div[role='tooltip'] {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.black};
    left: 3.4rem;
    max-width: 20rem;
    opacity: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-54%);
    transition: all 0.3s ease-in-out;
    visibility: hidden;
    width: max-content;
    z-index: 1;

    &:before {
      border-right-color: ${({ theme }) => theme.colors.white};
    }

    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      left: 50%;
      transform: translateX(-50%);
      top: 2.8rem;

      &:before {
        border-right-color: transparent;
        border-bottom-color: ${({ theme }) => theme.colors.white};
      }
    }
  }

  &:hover {
    div[role='tooltip'] {
      opacity: 1;
      visibility: visible;
    }
  }
`;
const StyledCountryFlag = styled__default["default"].img `
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  height: auto;
  object-fit: contain;
  width: 2.3rem;
`;

const FlagTooltip = ({ countryName, SrcCountryFlag, arrowPositionTooltip = 'left' }) => (jsxRuntime.exports.jsxs(StyledWrapperCountryFlag, { children: [jsxRuntime.exports.jsx(StyledCountryFlag, { src: SrcCountryFlag, alt: countryName }), jsxRuntime.exports.jsx(Tooltip, { arrowPosition: arrowPositionTooltip, children: countryName })] }));

const StyledUserRank = styled__default["default"].div `
  &:hover {
    p {
      text-decoration: underline;
    }
  }
`;
const StyledUser$1 = styled__default["default"].div `
  align-items: center;
  display: flex;
  gap: 1.5rem;

  span {
    color: ${({ theme }) => theme.colors.text.light};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    grid-column: 2 / 4;
  }
`;
const StyledUserName$1 = styled__default["default"].div `
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0 1rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: block;
    text-align: left;
  }

  a {
    color: ${({ theme }) => theme.colors.success.main};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
      text-decoration: underline;
    }

    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      display: block;
    }
  }
`;
const StyledUserInfo$1 = styled__default["default"].div `
  display: flex;
  flex-wrap: wrap;
  font-weight: 600;
  grid-column: 1 / -1;
  justify-content: space-between;
  margin-top: 1.5rem;
  width: 100%;

  & > div {
    display: flex;
    align-items: center;
  }

  small {
    font-size: ${({ theme }) => theme.fonts.sizes.small};
    font-weight: 400;
    margin-right: 0.6rem;
  }
`;
const StyledAvatarWrapper = styled__default["default"](reactRouterDom.Link) `
  div {
    border: none;
    height: 4.6rem;
    min-width: 4.6rem;
    width: 4.6rem;

    @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
      height: 4.6rem;
      width: 4.6rem;
    }
  }
`;

const UserRank = ({ isKoth, user, isMonthly }) => {
    const { width } = useViewport();
    const breakpoint = 769;
    return (jsxRuntime.exports.jsxs(StyledUserRank, { "data-testid": "user-info", role: "row", "aria-busy": "true", children: [jsxRuntime.exports.jsx("div", { children: user.rankPosition }), jsxRuntime.exports.jsxs(StyledUser$1, { children: [jsxRuntime.exports.jsx(StyledAvatarWrapper, { to: `/p/${user.username}`, children: jsxRuntime.exports.jsx(Avatar, { avatarSrc: user.avatar }) }), jsxRuntime.exports.jsxs(StyledUserName$1, { children: [jsxRuntime.exports.jsx(reactRouterDom.Link, { to: `/p/${user.username}`, children: user.username }), jsxRuntime.exports.jsx("span", { children: user.rankTitle })] })] }), width < breakpoint ? (jsxRuntime.exports.jsxs(StyledUserInfo$1, { children: [isKoth ? (jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx("small", { children: "Games Won:" }), isMonthly ? user.monthlyGamesWon : user.gamesWon] })) : (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx("small", { children: "Points:" }), isMonthly ? user.monthlyPoints : user.points] }), jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx("small", { children: "Rooms in:" }), user.rooms] })] })), jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx("small", { children: "Country:" }), user.countryName ? (jsxRuntime.exports.jsx(FlagTooltip, { arrowPositionTooltip: "top-center", countryName: user.countryName, SrcCountryFlag: user.countryFlag })) : ('-')] })] })) : (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [user.countryName ? jsxRuntime.exports.jsx(FlagTooltip, { countryName: user.countryName, SrcCountryFlag: user.countryFlag }) : '-', isKoth ? (jsxRuntime.exports.jsxs("div", { children: [" ", isMonthly ? user.monthlyGamesWon : user.gamesWon] })) : (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx("div", { children: isMonthly ? user.monthlyPoints : user.points }), jsxRuntime.exports.jsx("div", { children: user.rooms })] }))] }))] }));
};

const animation = styled.css `
  @keyframes placeHolderShimmer {
    0% {
      background-position: -800px 0;
    }
    100% {
      background-position: 0 0;
    }
  }
`;
const background = styled.css `
  background: linear-gradient(
    to right,
    ${({ theme }) => theme.colors.loading.primary},
    ${({ theme }) => theme.colors.loading.secondary},
    ${({ theme }) => theme.colors.loading.primary}
  );
`;
const StyledLoadingWrapper = styled__default["default"].div `
  align-items: ${({ isFirstPlace }) => isFirstPlace && 'center'};
  grid-column: ${({ isFirstPlace }) => isFirstPlace && '1 / -1'};
  display: ${({ isFirstPlace }) => isFirstPlace && 'grid'};
  gap: ${({ isFirstPlace }) => isFirstPlace && '8rem'};
  grid-template-columns: ${({ isFirstPlace }) => isFirstPlace && '9rem  3fr'};
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    gap: ${({ isFirstPlace }) => isFirstPlace && '15rem'};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    ${({ isFirstPlace }) => !isFirstPlace &&
    `
        grid-column: 1 / -1;
        display: grid;
        grid-template-columns: 6rem 1fr 1fr;
        gap: 2rem;
        justify-content: space-between;
    `}
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: ${({ isFirstPlace }) => !isFirstPlace && '7.5rem 1fr'};
    gap: 1rem;
  }

  span {
    ${background}
    ${animation}
    animation: placeHolderShimmer 5s linear infinite;
    display: block;
    border-radius: ${({ theme }) => theme.radius.small};
    margin-bottom: 2rem;
    height: 4rem;
    width: ${({ isFirstPlace }) => (isFirstPlace ? '50%' : '80%')};

    @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
      ${({ isFirstPlace }) => !isFirstPlace && `margin-bottom: 0;`}
    }

    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      align-self: center;
    }
  }
`;
const StyledLoadingCircle = styled__default["default"].div `
  ${background}
  ${animation}
  animation: placeHolderShimmer 8s linear infinite;
  border-radius: 100%;
  margin-left: ${({ isFirstPlace }) => isFirstPlace && '6rem'};
  margin-bottom: ${({ isFirstPlace }) => (isFirstPlace ? '0' : '2rem')};
  height: ${({ isFirstPlace }) => (isFirstPlace ? '8.4rem' : '6.4rem')};
  width: ${({ isFirstPlace }) => (isFirstPlace ? '8.4rem' : '6.4rem')};
  display: inline-block;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    height: ${({ isFirstPlace }) => (isFirstPlace ? '8.4rem' : '4.6rem')};
    margin-bottom: 0;
    width: ${({ isFirstPlace }) => (isFirstPlace ? '8.4rem' : '4.6rem')};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    height: 7.4rem;
    margin-left: ${({ isFirstPlace }) => isFirstPlace && '0'};
    position: relative;
    top: ${({ isFirstPlace }) => !isFirstPlace && '3.3rem'};
    width: 7.4rem;
  }
`;
const StyledLoadingInfo = styled__default["default"].div `
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  width: ${({ isFirstPlace }) => isFirstPlace && '30%'};

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    width: ${({ isFirstPlace }) => isFirstPlace && '40%'};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: block;
    grid-column: 2;
    width: 50%;
  }

  span {
    animation: placeHolderShimmer 10s linear infinite;
    height: 4rem;
    width: 100%;
    margin-bottom: 0;

    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      height: 2rem;
      margin-bottom: 1rem;
    }
  }

  & > span:first-child {
    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      display: none;
    }
  }
`;

const Loading = ({ isFirstPlace = false }) => (jsxRuntime.exports.jsxs(StyledLoadingWrapper, { isFirstPlace: isFirstPlace, children: [jsxRuntime.exports.jsx(StyledLoadingCircle, { isFirstPlace: isFirstPlace }), isFirstPlace ? (jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsxs(StyledLoadingInfo, { isFirstPlace: isFirstPlace, children: [jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsx("span", {})] })] })) : (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsxs(StyledLoadingInfo, { isFirstPlace: isFirstPlace, children: [jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsx("span", {}), jsxRuntime.exports.jsx("span", {})] })] }))] }));

const StyledUserInfo = styled__default["default"].div `
  display: flex;
  flex-wrap: wrap;
  font-weight: 600;
  justify-content: ${({ isFirstPlace }) => (isFirstPlace ? 'start' : 'space-between')};
  gap: ${({ isFirstPlace }) => (isFirstPlace ? '1rem' : '1rem 0')};
  margin-top: 1.6rem;
  width: 100%;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    margin-top: ${({ isFirstPlace }) => (isFirstPlace ? '2rem' : '0')};
    width: auto;
    gap: 2rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-top: 1rem;
    grid-column: 2 / 4;
    display: block;
  }

  & > div {
    text-align: center;
    font-size: 1.6rem;
    display: ${({ isFirstPlace }) => isFirstPlace && 'flex'};
    align-items: ${({ isFirstPlace }) => isFirstPlace && 'center'};

    ${({ isFirstPlace }) => isFirstPlace &&
    `
      img {
        display: flex;
        align-items: center;
      }
    `}

    @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
      display: flex;
      align-items: center;

      img {
        display: flex;
        align-items: center;
      }
    }
  }

  small {
    font-weight: ${({ theme }) => theme.fonts.weight.regular};
    margin-bottom: ${({ isFirstPlace }) => (isFirstPlace ? '0' : '0.6rem')};
    margin-right: ${({ isFirstPlace }) => isFirstPlace && '0.6rem'};
    display: block;

    @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
      margin-bottom: 0;
      margin-right: 0.5rem;
    }
  }

  div[role='tooltip'] {
    left: 50%;
    transform: translateX(-50%);
    top: 2.8rem;

    &:before {
      border-right-color: transparent;
      border-bottom-color: ${({ theme }) => theme.colors.white};
    }
  }
`;

const UserInfo = ({ isKoth, isMonthly, isFirstPlace = false, user }) => (jsxRuntime.exports.jsxs(StyledUserInfo, { isFirstPlace: isFirstPlace, children: [isKoth ? (jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx("small", { children: "Games won:" }), jsxRuntime.exports.jsx("p", { children: isMonthly ? user.monthlyGamesWon : user.gamesWon })] })) : (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx("small", { children: "Points:" }), jsxRuntime.exports.jsx("p", { children: isMonthly ? user.monthlyPoints : user.points })] }), jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx("small", { children: "Rooms in:" }), jsxRuntime.exports.jsx("p", { children: user.rooms })] })] })), jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx("small", { children: "Country:" }), user.countryName ? (jsxRuntime.exports.jsx(FlagTooltip, { arrowPositionTooltip: "top-center", countryName: user.countryName, SrcCountryFlag: user.countryFlag })) : ('-')] })] }));

const StyledWrapper = styled__default["default"].div `
  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    display: ${({ isFirstPlace }) => !isFirstPlace && 'flex'};
    justify-content: ${({ isFirstPlace }) => !isFirstPlace && 'space-between'};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: block;
  }
`;
const StyledRankCard = styled__default["default"](StyledBox) `
  align-items: ${({ isFirstPlace }) => isFirstPlace && 'center'};
  display: ${({ isFirstPlace }) => isFirstPlace && 'grid'};
  gap: ${({ isFirstPlace }) => isFirstPlace && '4rem'};
  grid-column: ${({ isFirstPlace }) => isFirstPlace && '1 / -1'};
  grid-template-columns: ${({ isFirstPlace }) => isFirstPlace && '3rem 9rem 1fr'};
  padding: 2.4rem;
  position: relative;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    gap: ${({ isFirstPlace }) => isFirstPlace && '7rem'};
    grid-template-columns: ${({ isFirstPlace }) => isFirstPlace && '3rem 9rem 1fr'};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    align-items: center;
    padding: 1.2rem 2.4rem;
    display: grid;
    grid-template-columns: ${({ isFirstPlace }) => !isFirstPlace && '2.5rem 5rem 1fr'};
    gap: ${({ isFirstPlace }) => (isFirstPlace ? '2.4rem' : '1rem')};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: 1.4rem;
    grid-template-columns: 2.5rem 7.5rem 1fr;
    gap: 1rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    height: ${({ isFirstPlace }) => isFirstPlace && '14.5rem'};
  }

  p,
  span,
  small {
    color: ${({ theme }) => theme.colors.text.main};
  }

  & > a > div {
    border: ${({ isFirstPlace, theme }) => (isFirstPlace ? `4px solid ${theme.colors.primary.main}` : 'none')};
    height: ${({ isFirstPlace }) => (isFirstPlace ? '9rem' : '6.4rem')};
    margin-bottom: ${({ isFirstPlace }) => (isFirstPlace ? '0' : '1rem')};
    width: ${({ isFirstPlace }) => (isFirstPlace ? '9rem' : '6.4rem')};

    @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
      height: ${({ isFirstPlace }) => (isFirstPlace ? '9rem' : '6.4rem')};
      width: ${({ isFirstPlace }) => (isFirstPlace ? '9rem' : '6.4rem')};
    }

    @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
      height: ${({ isFirstPlace }) => (isFirstPlace ? '9rem' : '4.6rem')};
      margin-bottom: 0;
      width: ${({ isFirstPlace }) => (isFirstPlace ? '9rem' : '4.6rem')};
    }

    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      height: 7.4rem;
      width: 7.4rem;
    }
  }
`;
const StyledRankPosition = styled__default["default"].p `
  color: ${({ theme }) => theme.colors.text.main};
  font-size: 2.4rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    ${({ isFirstPlace }) => (isFirstPlace ? `position: initial` : `position: absolute; right: 2.4rem; top: 2.4rem;`)}
  }
`;
const StyledUser = styled__default["default"].div `
  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    grid-column: ${({ isFirstPlace }) => (isFirstPlace ? '3' : '2')};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    padding-left: ${({ isFirstPlace }) => isFirstPlace && '1rem'};
    display: block;
  }

  p,
  a,
  span {
    font-size: 1.8rem;

    @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
      font-size: ${({ isFirstPlace }) => (isFirstPlace ? '1.8rem' : '1.6rem')};
    }

    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      font-size: '1.6rem';
    }
  }
`;
const StyledUserName = styled__default["default"](reactRouterDom.Link) `
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  line-height: unset;
  max-width: 14rem;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  display: block;

  &:hover {
    text-decoration: underline;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    max-width: 16rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    max-width: 20rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) and (min-width: ${({ theme }) => theme.sizes.md}) {
    margin-right: 0.8rem;
    margin-bottom: 0;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    text-decoration: underline;
  }
`;
const StyledTriangle = styled__default["default"].span `
  background-color: ${({ theme }) => theme.colors.primary.main};
  border-radius: 0 0 0.5rem;
  bottom: 0;
  clip-path: polygon(0% 100%, 100% 0%, 100% 100%);
  display: block;
  height: 11.2rem;
  position: absolute;
  right: 0;
  width: 20rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    height: 10.1rem;
    width: 18.1rem;
  }
`;
const StyledCrownIcon = styled__default["default"](FontAwesomeIcon) `
  color: ${({ theme }) => theme.colors.secondary.main};
  position: inherit;
  right: 3.6rem;
  bottom: 1.5rem;
  font-size: 3.6rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    right: 3.2rem;
    bottom: 1.3rem;
    font-size: 3.2rem;
  }
`;

const UserRankCard = ({ user, isFirstPlace = false, isLoading = false, isKoth = false, isMonthly = false, }) => {
    const { width } = useViewport();
    return (jsxRuntime.exports.jsx(StyledRankCard, { isFirstPlace: isFirstPlace, "data-testid": "user-rank-card", children: isLoading ? (jsxRuntime.exports.jsx(Loading, { isFirstPlace: !!isFirstPlace })) : (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(StyledRankPosition, { isFirstPlace: isFirstPlace, children: user.rankPosition }), jsxRuntime.exports.jsx(reactRouterDom.Link, { to: `/p/${user.username}`, children: jsxRuntime.exports.jsx(Avatar, { avatarSrc: user.avatar }) }), width < BREAKPOINT_MOBILE && isFirstPlace ? (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsxs(StyledUser, { isFirstPlace: isFirstPlace, children: [jsxRuntime.exports.jsx(StyledUserName, { to: `/p/${user.username}`, children: user.username }), jsxRuntime.exports.jsx("span", { children: user.rankTitle })] }), jsxRuntime.exports.jsx(UserInfo, { isKoth: isKoth, isFirstPlace: isFirstPlace, user: user, isMonthly: isMonthly })] })) : (jsxRuntime.exports.jsxs(StyledWrapper, { isFirstPlace: isFirstPlace, children: [jsxRuntime.exports.jsxs(StyledUser, { isFirstPlace: isFirstPlace, children: [jsxRuntime.exports.jsx(StyledUserName, { to: `/p/${user.username}`, children: user.username }), jsxRuntime.exports.jsx("span", { children: user.rankTitle })] }), jsxRuntime.exports.jsx(UserInfo, { isKoth: isKoth, isFirstPlace: isFirstPlace, user: user, isMonthly: isMonthly })] })), isFirstPlace && (jsxRuntime.exports.jsx(StyledTriangle, { children: jsxRuntime.exports.jsx(StyledCrownIcon, { icon: faCrown }) }))] })) }));
};

const StyledTableWrapper = styled__default["default"].div `
  margin-top: 2.4rem;
`;
const StyledCardsWrapper = styled__default["default"].div `
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2.4rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;
const StyledInfo = styled__default["default"].div `
  text-align: center;
  padding: 6rem 2rem;
  max-width: 70%;
  margin: 0 auto;
`;

const UsersRanking = ({ dataRank, isLoading = false, isKoth = false, isMonthly = false, emptyDataMessage = "We don't currently have a top 50 in this location.", emptyDataMessageSecond = "Is this your country? You're probably the top legend. Have a browse through the other countries instead!", }) => {
    const leader = dataRank[0];
    const podium = dataRank.filter((_, index) => index > 0 && index <= 4);
    const leftover = dataRank.filter((_, index) => index >= 5);
    const tableHead = ['Rank', 'Username', 'Country', 'Points', 'Rooms'];
    const tableHeadKoth = ['Rank', 'Username', 'Country', 'Games won'];
    const columns = 'minMax(4rem, 10rem) 2fr minMax(5rem, 1fr) minMax(6rem, 1fr) minMax(6rem, 1fr)';
    const columnsKoth = 'minMax(4rem, 10rem) 2fr minMax(5rem, 1fr) minMax(6rem, 1fr)';
    const columnsMobile = '4rem 1fr 1fr';
    return dataRank.length === 0 ? (jsxRuntime.exports.jsxs(StyledInfo, { children: [jsxRuntime.exports.jsx("h3", { children: emptyDataMessage }), jsxRuntime.exports.jsx("h4", { children: emptyDataMessageSecond })] })) : (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsxs(StyledCardsWrapper, { children: [leader && (jsxRuntime.exports.jsx(UserRankCard, { isFirstPlace: true, user: leader, isLoading: isLoading, isKoth: isKoth, isMonthly: isMonthly })), podium.map((user) => (jsxRuntime.exports.jsx(UserRankCard, { user: user, isLoading: isLoading, isKoth: isKoth, isMonthly: isMonthly }, user.rankPosition)))] }), dataRank.length >= 6 && (jsxRuntime.exports.jsx(StyledTableWrapper, { children: jsxRuntime.exports.jsx(Table, { dataHead: isKoth ? tableHeadKoth : tableHead, columns: isKoth ? columnsKoth : columns, columnsMobile: columnsMobile, alignToLeftColumns: [2], isLoading: isLoading, children: leftover.map((user) => (jsxRuntime.exports.jsx(UserRank, { user: user, isKoth: isKoth, isMonthly: isMonthly }, user.rankPosition))) }) }))] }));
};

exports.Accordion = Accordion;
exports.AccordionGroup = AccordionGroup;
exports.AlertBanner = AlertBanner;
exports.AlertNotificationDispatch = AlertNotificationDispatch;
exports.Avatar = Avatar;
exports.AvatarGroup = AvatarGroup;
exports.AvatarWithIcon = AvatarWithIcon;
exports.AvatarWithUsername = AvatarWithUsername;
exports.BREAKPOINT_MOBILE = BREAKPOINT_MOBILE;
exports.Badge = Badge;
exports.Banner = Banner;
exports.Benefit = Benefit;
exports.BlogPostCard = BlogPostCard;
exports.Breadcrumb = Breadcrumb;
exports.Button = Button$1;
exports.ButtonDropdown = ButtonDropdown;
exports.ButtonGroup = ButtonGroup;
exports.Card = Card;
exports.CardOverlay = CardOverlay;
exports.CareerLearningCard = CareerLearningCard;
exports.Carousel = Carousel;
exports.CarouselDots = CarouselDots;
exports.CarouselFlex = CarouselFlex;
exports.ChallengesCard = ChallengesCard;
exports.CharacterCard = CharacterCard;
exports.ChatBubble = ChatBubble;
exports.ChatButton = ChatButton;
exports.ChatError = ChatError;
exports.ChatHeader = ChatHeader;
exports.ChatLoader = ChatLoader;
exports.ChatWindow = ChatWindow;
exports.CheckboxItem = CheckboxItem;
exports.CheckboxItemWrapper = CheckboxItemWrapper;
exports.CircularImageProgress = CircularImageProgress;
exports.CircularProgress = CircularProgress;
exports.CodeTag = CodeTag;
exports.Collaborator = Collaborator;
exports.CollaboratorWithTooltip = CollaboratorWithTooltip;
exports.CollaboratorWithTooltipGroup = CollaboratorWithTooltipGroup;
exports.Container = Container$1;
exports.CopyButtonWithTooltip = CopyButtonWithTooltip;
exports.DateTimePicker = DateTimePicker;
exports.DateTimeWheelPicker = DateTimeWheelPicker;
exports.DescriptionListItem = DescriptionListItem;
exports.DesktopNav = DesktopNav;
exports.Difficulty = Difficulty;
exports.DifficultyLabel = DifficultyLabel;
exports.DragDropUpload = DragDropUpload;
exports.DropdownIndicator = DropdownIndicator;
exports.DropdownMenu = DropdownMenu;
exports.DropdownMenuItem = DropdownMenuItem;
exports.DropdownMenuItemAsLink = DropdownMenuItemAsLink;
exports.DropdownMenuItemContent = DropdownMenuItemContent;
exports.DropdownMenuSeparator = DropdownMenuSeparator;
exports.DropdownSubMenuItemAsLink = DropdownSubMenuItemAsLink;
exports.DropdownWrapper = DropdownWrapper;
exports.Duration = Duration;
exports.EaseInSlideOut = EaseInSlideOut;
exports.FieldAdorned = FieldAdorned;
exports.FlagTooltip = FlagTooltip;
exports.FluidContainer = FluidContainer;
exports.Footer = Footer$1;
exports.FormCheckbox = FormCheckbox;
exports.FormErrorMessage = FormErrorMessage;
exports.FormInput = FormInput;
exports.FormLabel = FormLabel;
exports.FormRadio = FormRadio;
exports.FormSelect = FormSelect;
exports.FormSlider = FormSlider;
exports.FormTextArea = FormTextArea;
exports.FormToggle = FormToggle;
exports.FriendItem = FriendItem;
exports.GlobalStyles = GlobalStyles;
exports.GlossaryTooltip = GlossaryTooltip;
exports.Header = Header$1;
exports.IconButton = IconButton;
exports.IconTag = IconTag;
exports.Image = Image;
exports.InfoBox = InfoBox;
exports.LearningPathCard = LearningPathCard;
exports.LearningRoom = LearningRoom;
exports.LearningScenario = LearningScenario;
exports.LevelsToolTipContent = LevelsToolTipContent;
exports.LoginButton = LoginButton;
exports.ManageAccountCard = ManageAccountCard;
exports.MitreCard = MitreCard;
exports.MitreRoom = MitreRoom;
exports.MobileNav = MobileNav;
exports.Modal = Modal;
exports.ModalClose = ModalClose;
exports.ModalCloseButton = ModalCloseButton;
exports.ModalDescription = ModalDescription;
exports.ModalFooter = ModalFooter;
exports.ModalHeader = ModalHeader;
exports.ModalTitle = ModalTitle;
exports.ModularTable = ModularTable;
exports.ModuleCard = ModuleCard;
exports.MultiCard = MultiCard;
exports.MultiSelect = MultiSelect;
exports.MultiValueRemoveWrapper = MultiValueRemoveWrapper;
exports.NewRoomCard = NewRoomCard;
exports.NotificationContainer = NotificationContainer;
exports.NotificationDispatch = NotificationDispatch;
exports.Pagination = Pagination;
exports.PathCard = PathCard;
exports.PathCardCarousel = PathCardCarousel;
exports.PovTag = PovTag;
exports.PreCodeBlock = PreCodeBlock;
exports.ProgressBar = ProgressBar;
exports.ProgressBarSteps = ProgressBarSteps;
exports.ProgressIcon = ProgressIcon;
exports.RadioButtonSelectionBoxItem = RadioButtonSelectionBoxItem;
exports.RadioGroup = RadioGroup;
exports.Rating = Rating;
exports.RecommendButton = RecommendButton;
exports.RecordTooltip = RecordTooltip;
exports.RedeemTicketButton = RedeemTicketButton;
exports.RoomCard = RoomCard;
exports.RoomGridListItem = RoomGridListItem;
exports.RoomItem = RoomItem;
exports.RoomItemV2 = RoomItemV2;
exports.RoomProgressBar = RoomProgressBar;
exports.SOCSimScenarioCard = LearningPathCard;
exports.SelectedLabel = SelectedLabel;
exports.SelectionBox = SelectionBox;
exports.SelectionBoxItem = SelectionBoxItem;
exports.SeriesGridListItem = SeriesGridListItem;
exports.SideDrawer = SideDrawer;
exports.SideDrawerContent = SideDrawerContent;
exports.SideDrawerDescription = SideDrawerDescription;
exports.SideDrawerFooter = SideDrawerFooter;
exports.SideDrawerHeader = SideDrawerHeader;
exports.SideDrawerSubtitle = SideDrawerSubtitle;
exports.SideDrawerTitle = SideDrawerTitle;
exports.SideNav = SideNav;
exports.SideNavHeader = SideNavHeader;
exports.SimpleSelect = SimpleSelect;
exports.SlidingPane = SlidingPane;
exports.SortIcon = SortIcon;
exports.StatusTag = StatusTag;
exports.StepHeader = StepHeader;
exports.Streak = Streak;
exports.StreakNotificationComponent = StreakNotificationComponent;
exports.StreakNotificationDispatch = StreakNotificationDispatch;
exports.StyledAppearAnimation = StyledAppearAnimation$1;
exports.StyledArrowIcon = StyledArrowIcon$3;
exports.StyledBlanket = StyledBlanket;
exports.StyledBox = StyledBox;
exports.StyledBoxShadowedBox = StyledBoxShadowedBox;
exports.StyledButton = StyledButton$3;
exports.StyledCardBoxShadowCommon = StyledCardBoxShadowCommon;
exports.StyledCardCommon = StyledCardCommon;
exports.StyledCardDescription = StyledCardDescription;
exports.StyledCardTitle = StyledCardTitle;
exports.StyledCheckIcon = StyledCheckIcon$1;
exports.StyledChevronIcon = StyledChevronIcon$1;
exports.StyledCircularLink = StyledCircularLink;
exports.StyledCloseButton = StyledCloseButton$2;
exports.StyledDialogAnimation = StyledDialogAnimation;
exports.StyledDialogOver = StyledDialogOver;
exports.StyledDropdownButton = StyledDropdownButton$1;
exports.StyledDropdownMenuContent = StyledDropdownMenuContent;
exports.StyledDropdownMenuItem = StyledDropdownMenuItem;
exports.StyledDropdownMenuItemContent = StyledDropdownMenuItemContent;
exports.StyledDropdownMenuItemSubTitle = StyledDropdownMenuItemSubTitle;
exports.StyledDropdownMenuItemTitle = StyledDropdownMenuItemTitle;
exports.StyledDropdownMenuItemTitleWrapper = StyledDropdownMenuItemTitleWrapper;
exports.StyledDropdownMenuSeparator = StyledDropdownMenuSeparator;
exports.StyledDropdownMenuSubItemsIndicator = StyledDropdownMenuSubItemsIndicator;
exports.StyledDropdownMenuSubItemsWrapper = StyledDropdownMenuSubItemsWrapper;
exports.StyledDropdownMenuSubMenuContent = StyledDropdownMenuSubMenuContent;
exports.StyledDropdownMenuSubMenuDescription = StyledDropdownMenuSubMenuDescription;
exports.StyledDropdownMenuSubMenuList = StyledDropdownMenuSubMenuList;
exports.StyledDropdownMenuSubMenuListItem = StyledDropdownMenuSubMenuListItem;
exports.StyledDropdownMenuSubMenuTitle = StyledDropdownMenuSubMenuTitle;
exports.StyledDropdownWrapper = StyledDropdownWrapper;
exports.StyledFlex = StyledFlex;
exports.StyledFlexColumnCenter = StyledFlexColumnCenter;
exports.StyledFormInputBase = StyledFormInputBase;
exports.StyledFormInputBaseWrapper = StyledFormInputBaseWrapper;
exports.StyledGrid = StyledGrid;
exports.StyledHiddenParagraph = StyledHiddenParagraph;
exports.StyledIconButton = StyledIconButton;
exports.StyledImageWrapper = StyledImageWrapper$3;
exports.StyledLoadingPlaceholder = StyledLoadingPlaceholder;
exports.StyledMenu = StyledMenu;
exports.StyledNewFeatureTag = StyledNewFeatureTag$1;
exports.StyledNewTabLinkIcon = StyledNewTabLinkIcon;
exports.StyledNewTag = StyledNewTag;
exports.StyledNotificationContent = StyledNotificationContent;
exports.StyledRadixSubContent = StyledRadixSubContent;
exports.StyledSearchIcon = StyledSearchIcon;
exports.StyledSelected = StyledSelected;
exports.StyledSpinner = StyledSpinner$1;
exports.StyledStatusIcon = StyledStatusIcon$1;
exports.StyledSubMenuTriggerButton = StyledSubMenuTriggerButton;
exports.StyledTime = StyledTime;
exports.StyledTimelineContainerCommons = StyledTimelineContainerCommons;
exports.StyledTopToDown = StyledTopToDown;
exports.StyledVerticalContent = StyledVerticalContent;
exports.StyledWrapper = StyledWrapper$6;
exports.Switch = Switch;
exports.SwitchThemeContext = SwitchThemeContext;
exports.TICKETS = TICKETS;
exports.Tab = Tab;
exports.TabBadge = StyledTabBadge;
exports.TabList = TabList;
exports.TabPanel = TabPanel;
exports.Table = Table;
exports.Tabs = Tabs;
exports.Tag = Tag;
exports.TagToolTip = TagToolTip;
exports.TagsInput = TagsInput;
exports.TempCustomNotificationDispatch = TempCustomNotificationDispatch;
exports.TextField = TextField;
exports.ThNotificationIconCircles = ThNotificationIconCircles;
exports.ThreatHuntingNotificationComponent = ThreatHuntingNotificationComponent;
exports.ThreatHuntingNotificationDispatch = ThreatHuntingNotificationDispatch;
exports.Ticket = Ticket;
exports.Timeline = Timeline;
exports.TimelineV2 = TimelineV2;
exports.Title = Title;
exports.Tooltip = Tooltip;
exports.UploadAvatar = UploadAvatar;
exports.UploadImage = UploadImage;
exports.UploadedFile = UploadedFile;
exports.UsersRanking = UsersRanking;
exports.ValidationList = ValidationList;
exports.WeeklyLeaguesCard = WeeklyLeaguesCard;
exports.accentColors = accentColors;
exports.contentShow = contentShow;
exports.ctfCollectionVol2Data = ctfCollectionVol2Data;
exports.dailyBugleData = dailyBugleData;
exports.darkColors = darkColors;
exports.displayLinks = displayLinks;
exports.displayRoomContent = displayRoomContent;
exports.fadeIn = fadeIn$1;
exports.fadeOut = fadeOut$1;
exports.formatNumberWithSuffix = formatNumberWithSuffix;
exports.getProgressWidth = getProgressWidth;
exports.getVariant = getVariant;
exports.legacyColors = legacyColors;
exports.levelsAndPoints = levelsAndPoints;
exports.levelsAndPointsWithTitle = levelsAndPointsWithTitle;
exports.lightColors = lightColors;
exports.lighterVariations = lighterVariations;
exports.otherColors = otherColors;
exports.primaryColors = primaryColors;
exports.resolveCustomReactSelectStyles = resolveCustomReactSelectStyles;
exports.resourcesPageResponse = resourcesPageResponse;
exports.secondaryColors = secondaryColors;
exports.selectExampleOptions = selectExampleOptions;
exports.theme = theme;
exports.useContentDropCountdown = useContentDropCountdown;
exports.useItemsPerSlide = useItemsPerSlide;
exports.useOnClickOutside = useOnClickOutside;
exports.usePasswordVisibility = usePasswordVisibility;
exports.useSwitchTheme = useSwitchTheme;
exports.useTimeline = useTimeline;
exports.useViewport = useViewport;
exports.validateCommonFiles = validateCommonFiles;
exports.validateCsvFile = validateCsvFile;
exports.validateFileFormat = validateFileFormat;
exports.validateFileSize = validateFileSize;
